webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uniqid = __webpack_require__(97);

var _uniqid2 = _interopRequireDefault(_uniqid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        id: {
            type: String,
            'default': null
        }
    },
    data: function data() {
        return {
            localId_: null,
            uniqueId: (0, _uniqid2['default'])()
        };
    },
    mounted: function mounted() {
        if (!this.$isServer && !this.id && typeof this._uid !== 'undefined') {
            this.localId_ = '__BVID__' + this._uid + '_';
        }
    },

    methods: {
        safeId: function safeId() {
            var suffix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var id = this.id || this.localId_ || null;

            if (!id) {
                return null;
            }

            suffix = String(suffix).replace(/\s+/g, '_');
            return suffix ? id + '_' + suffix + '_' + this.uniqueId : id + ('_' + this.uniqueId);
        }
    }
};

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = new _vue2['default']();

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.debounce = debounce;
exports.browserDetails = browserDetails;
function debounce(func, wait, immediate) {
    var timeout;

    return function () {
        var context = this;
        var args = arguments;
        var callNow = immediate && !timeout;
        var later = function later() {
            timeout = null;

            if (!immediate) {
                func.apply(context, args);
            }
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) {
            func.apply(context, args);
        }
    };
}

function browserDetails() {
    var ua = navigator.userAgent;
    var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    var tem = void 0;
    var mobile = ua.match(/(Mobile|mobile)/);

    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {
            name: 'IE',
            version: tem[1] || ''
        };
    }

    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(?:OPR|Edge)\/(\d+)/);

        if (tem != null) {
            return {
                name: 'Opera',
                version: tem[1]
            };
        }
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }

    return {
        name: M[0],
        version: parseFloat(M[1], 10),
        mobile: mobile !== null
    };
}

var isString = exports.isString = function isString(value) {
    return typeof value === 'string';
};

var isBoolean = exports.isBoolean = function isBoolean(value) {
    return typeof value === 'boolean';
};

var isObject = exports.isObject = function isObject(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
};

var has = exports.has = function has(object, key) {
    return isObject(object) && object.hasOwnProperty(key);
};

var get = exports.get = function get(object, key, defaultValue) {
    return has(object, key) ? object[key] : defaultValue;
};

var px = exports.px = function px(value) {
    return value + 'px';
};

var translate = exports.translate = function translate(x, y) {
    return 'translate(' + x + ', ' + y + ')';
};

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_loading_spinner_vue__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_loading_spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_loading_spinner_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_loading_spinner_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_loading_spinner_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86f86d1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_loading_spinner_vue__ = __webpack_require__(799);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_loading_spinner_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86f86d1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_loading_spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlh+gD6APMIAEFAQkFBQkFBQ0JBQ4+Rk4+RlI+SlJCSlAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtJQ0NSR0JHMTAxMkgAAAxITGlubwIQAABtbnRyUkdCIFhZWiAHzgACAAkABgAxAABhY3NwTVNGVAAAAABJRUMgc1JHQgAAAAAAAAAAAAAAAQAA9tYAIf8LSUNDUkdCRzEwMTJIAAAMSExpbm8CEAAAbW50clJHQiBYWVogB84AAgAJAAYAMQAAYWNzcE1TRlQAAAAASUVDIHNSR0IAAAAAAAAAAAAAAAEAAPbWACH/C0lDQ1JHQkcxMDEySAAADEhMaW5vAhAAAG1udHJSR0IgWFlaIAfOAAIACQAGADEAAGFjc3BNU0ZUAAAAAElFQyBzUkdCAAAAAAAAAAAAAAABAAD21gAh/wtJQ0NSR0JHMTAxMkgAAAxITGlubwIQAABtbnRyUkdCIFhZWiAHzgACAAkABgAxAABhY3NwTVNGVAAAAABJRUMgc1JHQgAAAAAAAAAAAAAAAQAA9tYAIf8LSUNDUkdCRzEwMTJIAAAMSExpbm8CEAAAbW50clJHQiBYWVogB84AAgAJAAYAMQAAYWNzcE1TRlQAAAAASUVDIHNSR0IAAAAAAAAAAAAAAAEAAPbWACH/C0lDQ1JHQkcxMDEySAAADEhMaW5vAhAAAG1udHJSR0IgWFlaIAfOAAIACQAGADEAAGFjc3BNU0ZUAAAAAElFQyBzUkdCAAAAAAAAAAAAAAABAAD21gAh/wtJQ0NSR0JHMTAxMkgAAAxITGlubwIQAABtbnRyUkdCIFhZWiAHzgACAAkABgAxAABhY3NwTVNGVAAAAABJRUMgc1JHQgAAAAAAAAAAAAAAAQAA9tYAIf8LSUNDUkdCRzEwMTJIAAAMSExpbm8CEAAAbW50clJHQiBYWVogB84AAgAJAAYAMQAAYWNzcE1TRlQAAAAASUVDIHNSR0IAAAAAAAAAAAAAAAEAAPbWACH5BAkAAAgALAAAAAD6APoAAAT/EMlJq7046827/2AojmRpnmiqrmzrvnAsz3Rt33iu73zv/8CgcEgsGo/IpHLJbDqf0Kh0Sq1ar9isdsvter/gsHhMLpvP6LR6zW673/C4fE6v2+/4vH7P7/v/gIGCg4SFhm4FBwWLBQQFFAECAJMAAwOHd4uOjJycBJAAkpIBlpaklQGYaY2dBJuMr4sHkJIDkpQBuaW5upeqXosGna2uw4y0lQK3laampLq8qb9WrIwGBAexwomxm9iQ0bmh46EDocrovJTTUK2J1cWcwt6Kso8TkQC8pefmy+m8BNgSKI3dEU3GZNWDZczAtmMT/IUKMMmSsmQC0RHURcnSRIND/wo85FTP0bxX8a6JNEZLFKl/lZhpHBAQXalmIHsQq5bowLZrKGMtjHVPQqSL5MqpmyTKVkWm4cyNy3nDGLaV2XzyROhKmKJ4jOqBcopUGSmLTGuRBdiLkr6CVF+Efae10VWrX0VuyhaMJb6XGpXRPCWqrLlnNAeXFVgqbotGee1yTfjKQN2tdmNRGHzUZUBKhW8JOOuMYtLScB2T4Ak0M0PJdh920wuPJLh95ATfsqVO1LlzozEyfhtN9WrLPInam4t5mHKukDhfJEuOM0W0A9Mxc2udl3EQmoj69IZZttds3eIpWrgouq7Qv4mrM1X2bfZ/F8/q+76hkVdW2zhiEv9KkplEF0/jnQfLK5uddd04osnn4DMxoZIRU6DZdMpZ/F0Q1it5kcdXMHs1l5An6LUXUT/RjHYYNFKZtc9ibA1UDj/ndDjBXfYUYxkBKvElDHKwnfgOZEc6MiIyLoYjI2n+bERRU6ZNMqNLg3mESodaKSnga9WMOFJ48ZBH2ZEqSiCRi7nJ59REbQFHWDLmDJSYOMvsZxyJRWryVVDGsBcbZiXStg0yGAY2Wi55LhrQQIxWB9pTjKLDjC9UsfInmrIU44o2QAbqCVBAjkQkLKAUJmEkjLaoKp6J6sZiLwK5tU9OxQgK1knuaKLSSkTJJuKvy6WqqKtKRcoUfbVYSlP/YbtYClo0mP6yHEIjPkdbZJ6eqCRJhcYDij733QkhZ/EB5+hRjPL2UkzNQnpYtYcgZCIs1yzE3piRUVZmvtduVlFngqFVcGcQyllTo8oKB9wu9A5ijaafbjUSea29Mw8xrkSmyMXEbrbLUblp1JFvMtY4KZy/JTYRUuSkBkivriEkbCdDGViPSmChx6N/w4BzJ8nLHiWRwW8pnFi8zwJk5WgXFZaLxD0x14qgK03W0DtCOTdx0BGFM6VoJrvlGU0KN5xyOtY9pW4kgngNIphC+scvgPJw3esmNxeFQHdTuhUrdwQ1bSViA0Otkdhmn8Mo1bQZeWBffNXDl4A/a7sN/3vYbDJuhm7n6fjSi8PLcD7AtblbMzQVomkwGb++lYBZcTPPVwEyVLvkaSIQONkxnmzTmqNcFxhUb4oO4YXPyKyH3xIMc/Flg35IO4F8c+qtvX5Hct/yN45NkOCO2pgUR9JmiFQpAlgAPR0QUYBgx5uHdQ2Rp4r6c19WFTkLPmazlADR9huYkAswMEuaWWAWJSxFzCH/q4NmKkA5UcmDQFZRjqDGxL13CO1wypJSYL63rrQswxnrilbUQuG+atTBL/Kry17qN7sOzgVrJLHXl5DUO/0QJzTWAchwitcqkxGRWg6SVvsqIBQDzGGHqGIi3ubCs0RYhli/wmD//KS/7v+JjWDrqlSt1DI0akHqi2LTiAXAYg05lARsFDDTTtB0ORP95ESc68mXotMMMIYxH75hBhojhAo0Lsx93WIQHDxBlE9UgD0fg4euqvdG3sHwA/tADFoSJkCOwOuTxJHKsgSJSNrp8A2eyFv8JoDH5BhJNq/BHgvCAb5YQQM0BHyaOOrkG5mFamPuaEPWXDmSFl7lU8DMXpnABMVVwsB7DZxSlgyHCsMJsCK8aaFDJOfIVQyjklnrJiu/+R//HACHlZwgDjzCmD6eJWrSIRvKKIJII7FRDVbkUyuNeZWHcDCPI3LmDha4KKSIYxzteteTZAYZYhWIFR1LQ0nkqD2BVhH/OdP7GmaIwK6xDSYZSXvP8CL2RmLNRlxm0CIs0ulCCn7IITtspieQMEJqpQWERouY9DIHIpNEcAyWDNPOehc9nOEwSUQ9wsA4s5ZCBkRm5/xSSXziUEaWoTxQNJBKYJpUjcpUkU5Y2HRuMSMArHEyzcyKHLMBVEYuiH+/0tUa79hB2kmhJupKC4ekaLkwvTWgPBQnMJDKkAFpEHOCRUBzPsYXK4hxeQUzZkBz10hRheGY3zQTJJkjjBb2SRNYqFJFZnJWiloPsFWD6PuyoE80mZZbV4mkZ1nDBSTqop5myups+AcbYLwxVAnJ3ZkUsUbMicQLDmoMBSuLNV11JSFd/3iuxbJntdeg1n0BAoONlhhH8mCOpdVdaSe4sJ7IxbJEgA2ogbr6U+3qlK4keQgO/anR9lIjnEc1Z2RgCTJXyAFn3vqqtsq72in4qBP//OwF7ccJOIQImKptpQ6lZ18Dfwtv/SoPM9XTW2GiCMCp5B5iNyZHLMxOWyCSb4RxtkM2sPFLgOKtQlT5oShWQbyQGWptuHEtGCMItG1gY3K08WMOOmdn99WgxeBqQw6CtQ0Xu2F6Jry98VLBuC8NFYGxUt5fRZlMi+xgVIH0nAzbsEednYKMv4aNhYwEnLndYxyUo60tshlMSW1CFUM8pp6RCUlgefIiuyVi2VG5MjtxhP8UeMg/bwRIX1oRbsWAaQc8D7PQQ52o1Q4VBRI7WsEhntuaC4wIU74VdhVr9JhAlogo9CqZfVXIUMJzIjyEaFs0Y06K+BbTPCchnISdNf/Ku5fKdczX/9Ubhi19VOp64wkwFvKZ7dG3U1f4idfKYT+vtWsAIdpzTdBh13h8r/Na+Xm1qSOJIeOlb9W5EU6oTVwvfWpLppkPGqsYkRc8GWE3mAn2rOO9HLpfRffBGs9ZL5XrGmKANwcl/oypTPM2M+RoOdCprgYNjeRw6w4l4vncSjbeTOpMOPRTctTiT4bUF3ArwbhGVrbXNIzsPNB6yssB7oHJzMwlSLuyWlu1SCD/nFh83wV7eNE4hCdmmZfrEaJ01nHeTEuIHPpq2LXDLCw3ddxfrye/1J1xM39GiM6FmM/OJjocjXCictIFuCe3yzm32fW4CRdfppWqijd6BObyuJJRLpXurmIIcJ49xOP5qyzmgQTzOidYB84xrf9d9ZTkSqMVXRDX/XuELBIpVByGRzduZy9D2GuzZ0KwmB2ChD27cmJYi7ksMEHtEgl5SHObeM17oCTLJTzn+Z087V8H9rO7vkhshx3wCUVo125l+JveCYTV2ynKDyFICdlUoOk+eoFW/fFLb7Y1Tp78VgqlW5MsvSq2KG3tITo5bO8z+qfIjcqY2uX1OtJXLoPy/5Vu/LPl53tA0ynfYmZcZGP1Emizw3J4tjEKYnBEgFrUZkm7olrscHUPlUqX03yQRFxEYHWB0mtl4l0IiAm9FmrCxnPBUoI/kDeGZ2mgJmj5R2/uAFxuVRvH9IGVRVlfEiDiASYXiDPChVF9gmKs8IHWFRbNRYHeVwg2iC/jt0Pc4hrehYSMdnhPyDvXwA5GFna9NlV1ZoWqBHrx1QrzNlPToDXgUjMHmG2pRgQxVm8/pnqzc4FAEnz6whrSU38lpwPelYXf8h+75TGtloYad3pGeIPaoCOM2IiO+IiQGImSOIk6gGCRR4c0eF7XVnVRpmPLxE0MoYNGZW3E0G3s1v+E32dn1WUeSugaRMArE6NbhQIsU4R/0CduWWhPO1Z3QVBRxyZyJ3Uv7IBBJHg12OIfPYiKO0A9cud4jXZ40JGGXcJhkSQ5xHYxOogSOzNlu9Uj57Z+FvdZu0N0R3dJQKCCMmSGl6ZezxGEv/dL6XZ3K2aFF7ZiqrV5zcdpv6CAj3cms4iGIfGJpSgSfwIwvxeEqeeN73ZKRUBjoqeGVCZsv1ASAeIVv+RjQVWIYiiLo0aKr2EtryQ7AjlHW9iQIEZns/iPmVF0g2AS22SDTjZMEhhbfbgDZphxfHMSMZZbNekHKzhtWMYpb+SBEch1coh55TiGw8drzWVK3gAqyhH/f61oOW6Hcu52c7TBkoDwE9iwahnzHF7mHJ03cytxcqTCZ2A2gzyykN3yZQ/ReKmUEtwScwIXik6YSqRHWHmpdPsDl+qIIG5nDy9IZqYXl3jWSM2Xc7vHe/9Xl/2zOXcRMoVAPcVYWNwTawuilS1oM++3by/IWwLyfbr3bpNldq3wa9CYbUZSjbT2fTA1brBkmfPTmkmge+QmeV5yIE+JEGVHM0GZLRWDQzIYgdT1J3NDfbJXjYIARedUaFyhWYVFHj6XMzt2iRSlcHoRN7R4jDUkgbnWcROIJn1WhMtBYDPzbcc0D4GpaUGSEosJBEeWfdlGVb8FRYAwIuMhasIS/5T9Y4sHEXY3FHMYhyJtppnwo4vHxxDYh4lNYH8m5ZyvkUUE+J5zNn7PWYNc9I8EEm97OHmARg+692j4lnkvNmM71W+hwqELR51ZUz/1yJkUygaYGAx51FqegkE+8wRhYpvu4IONJJm2Nm5o1ZE21JzKWH4LKZyakhUjF5WZEB4X426QtjFcR3Lw1g4E4mQxpS9f1kF2kEiByDcGSFhUlBdSsHFCUjf2yG4pZ5d0MCA7s2U3OoD8+VtH6GpDYngrl0g0E5M9eQa6tpbDQhlTKF5qln2xqYjP2D/JxkiXyBztBnQ0eqSo2VC5JnKvF4eUSgYfZzNWZ5oEMnJrJhZUAP91pmVk9FVDZsd5btCNfSF7DfFcqXZvhxpLk5c9Z2ikTNZuiFB9uzl0kiogDLiGm/pyG0gmG5RDd6OEvRejXcA9TlZVp2abw+lqDyWFw3p/tgmka2BD35VRQkdObkoNuJOQ9minkbQXYQaRonaD4OJQrMdaS7eAFqSsQMOqbxCncphxwEYPevinDSquBJmak/OMLUQGXVWd+0qNejF9ABtuf5d6prlfUDd7UgRkg5WdLrWmPuit/mYSz9qRXKWg2pAipBpHkwEMs3pW+vRl53dmELgFqlVm67YvpzZb5MYFy/GWGwugEYqI1fkFJrKlx5hHtCoB8KhrWFCAhiZZZ6f/kl/1sK5GZ8CCWDzmpPJDRy9mBb43IPyjTQ9ZX3bTcGHgJ52zdBNXRRaAtlxhpFKgHFkknUxEjKxJgDLVVl6TXkVSDNgVXInaDpnqbXKWtVtks3t5VedUn/JgOQGFs3EpewAXdrF2gmsrn7zFQWagO9zZnNr4PioZgl0Dl8GCmcZpfdGTHpHHM0MBqBE2r2tXVPfDYvrnY3QntTOAFeW5nR+mfvLjYwaoTimFoQoqUPoVdbhrDZrmrDCAmDNXWfe0XA/3emoggpnnREwkf5pralkpD/p4A2yUIotKbkEhXJ7lZ/YXs4CaqEFZT3lIIizXfrfzMb9ooClgoTtWu7Cx/y+5iL4IILk6drRooIBz+j72s2VzQbU+a8B3qgLa41wSCqk8F7Ys6K7AuwaVoau8WFTDpL6/p8AVyHTFSgEUy2YXRg+xpnaJmSLFBSCzFgfxScCym4zCSX0JuVvh2DtkmV5s6XeewowaVVrElsFBVjP8e6k1yKcY/E1JbBlgR7iqtxdryUxkyXCHaC/WKz9ONgce6ri26m0VxZqmdS3ve4g/ZX9V1qOyyXzDhnnde7pvCD8868SdMlQwt3Xuhxxulj12ekniNrxqDKE16J3ESpTjpLEvBCS4FVUEKl0d9KAjiXmg1jtRC8JzdLXN8aClW7ETzL9ajLPY2TmfW04YBP9MWNN9a1d9sHh0XWbFRCybsbWQwGJf9Pumj+cTXTKz4zmACKYVappBvIWyWkOaT8in7pCCLddjoSma86t6+Hu8h7mzrOxmt/ls47RuR2xkwXdirtWJGNSSrQVinrpif4iX1cdgvNO7lhhcQsptfya+i5djgghOgpA/p7c1Xemr/Jpo6rl/vmpevZuYJTtheSRkVCVzaNyPEkPQ7XqbQGGzqoda/aVK+ZK1poZaJZWMhyYZ6vmg20N4VYceIO2qsDGLNapt4meDJ4sAFk2X0Gh4mGWNAGamaumtugizLumhmIid3WWYaVxXUieU/vZ2fNLGhrB3dxahUaxiJB2DuYn/w863b5Onv09ZkSP4WXRmEJRzO1ANe+yXqIZpmmHxz1R7JFTajEfpVxtWWEStCnsJg3gzQ+9stakVwWEsTgx3lQhXWCzqja5sR46BGcX3eYAcXkz8aADZv8Krx33Vpj5FZt92aUTxHcCXfln6xP5yobKR0nVLR2enyEoMkX85Fx3yOk3djfksgsJCzwwZPZdDWeIs0lc4XM3UiAsdmUBzrJm3i7vLN3IMmrSmpactVUm4IJDINekJXP4GFD4YuyyWtC1cyBgpxXGbGcmrq3ElKJMIigvWbKbdoX5Tbhh9mIttFbAYwt+Ry16DzZp8xKecaiQoiNPmzjQIFpRoTJaG/51qeExZdUfA1duxREOERmIj155IZ7s6Ato8idblXEPcA8w97NXovaZnVt8csLtdTCi6XTXAm3h06sUK0X7xbd71zWQtd5Xat+Cvx4u4B53HmHfHTIUGTuEGQmaTtFbgbZFyvD/vOHhk3VIUbgIZ2iNQTbHtF0O6a04xBkmzAcA/DuScLWP383483du5Y6SQuYTj2uQsIIQZB0s9iMcLjNizBiLgy88mysla7gJ4NmunMr8pDSBVFansl+Y6AK+9YrK2wUoveoI0Q+fw+aHZp2/ozGsracVo7ufniOdNlrX0xVg+juiudl07UoaQXumWfumYnumavumc3ume/umgHirqoj7qpF7qpn7qqJ7qqr7qrN7qrv7qsB7rsj7rtF7rtn7ruJ7ruv4FEQAAIfkEBQAACAAsGgAcAMYAwwAABP8QyUmrvTjrzbUhRRiCVHiIB0F0bOu+cCzPrqiKRiqGFHHqNpOORiwaj0gNqLAM7nakCfO2PFWZtlVyy+1usc2lYTR2inrP07M5Ihe88Lj8siR8fmJ2u1DmSfltB31QfCpsUXOJijQ7ViGDJoRtN28TY2N1km2YTzuLn6AZdp2UKDiRhiNiJYCXpJGtI2qFZ6G2igWzgHudnFiPYCNoTB9MeKWAQI1Waga3z1xhr5ilvpOydSXFuWt8B7q8v2Ju0OUznUGOwFC6h5taElRQhmp6uSfWu+uV5v0bTjl2GPgw7lW3PvVYoStjjwyIUqOwQDrgr2KFXAx9PCRGKR+1eZn/Gim8JpGbQXGnXiGyWE7Vr4EMNWUh6HKjuGLDMqkBN3CWPXdrUqxkGcrkvTU270nr9kiFKxMqKKhDZzIpoYcgynxTsRUK0aI4fDpNMwnZUZdTUAjyIwGpE0pWUWQli7XdmK+JIAo0GiTkoYEyqfaA9Cto4XCPmpl1ixcO4FRXZOlLNUaoGaqH2SK4jJjWNXdhfKja2BVe4yMYP9ZL1iSmqU4++8wF8YMfgrhPCEemOqoYvrSkTJ8+9+M3KlK1G5b0RZspoBKi0f30LQQLED02sz8Zfu7SXNam6O1L9wvIU85RpXxr9B0brFFWq4CbsrMbRe4uSFu3WY8wsI1s6JCR/zENpQDdaoH8JF0h9bFBU1lZCINfB/pscxI7/PESEFxOWRFGbcNgg5syyuTGC0Q6fXbChP+8pMd6tZWRgx1TkVRHHiceMtIea9XRB0KD0BbdYQ/JOEWAPrB4wVtIKfdaHYJEpBJmJe5I1XwI2hEGYZZpqIqM2SjZVi4h2ddZENY4OJkms2kmECTwwZJWKrsAZYNPsMzHjZh5LphZL9g9EtCcmOkzCxqtGXMmSrTVs9iNgIg2pGAT/odZoCWVKBeCYLRj0BKsWBiTPa7tgV1t5TEVUVJ34dccWrJdBqAJd/AWoZaZzRciVHLuVeg7Y0GFKUZGfcQiSeHowUmQ7MHGo/+i/2H1CCsKtoKnr7CtF8yn/jHDp5al4jAQV8hqUiM30nSEp2mSaAtLRouR5WedkkSX3mnCbXbZg4BZ2CmezL6Gbimr3UCtNMUomxZMRDJpEkJ/bleBACzVopByN+g5JWXYFoarx85MoNivU7pVjxWxRqLOq/kK4HJFqFgAXMN/isXQIDqQqIl/Vr53aVMNjQNORNdKTAEASANAsTmv3XdxslhNKm15jQ5iYZnEAGbbkXCts9F5vdpIplpUlDkUAi6nLQAALc2sWVsnn5WWefGOJ5qHyjGkRg8BRtpX3gExyxORarbsMtKHL23LaJ1Y4K4jGEsqUbrI3E2Gv+hS6+v/Usk0QiV5+lxpmwRqr434AIqDYh1fb98WkoecyoNuJOG2UwoM3+T+qnOiM3Xd7me7PADSA6AeQAACDLD42H6dDRyptOS8TpdvJZWEp71kgTX2WQaf9gABKH08AMWnnogq8wFoAZSBkVn5VfbMcWHsnAv64ugIKG066sIDgHzaiwBZ17xykVMMjWjUmBU6QjErXeggMj9JgU8soLakCU8AxyudIjjhof2gZH3z4JfGiEEIpv0scKYyRNQMpzSkBaB8plPa8JJ3PvdVT1n5ooXZyBQucVgEJVrRikBeZKCJIW5/GETcEcn3sji0A1UAgYvM6lSZwsTEX3jxlXdMlYZv/1BwbYdzof/+h8S0BQAOzqkWJKYYrNWR8Cz5IoobxkYvHNDmizFUYvIS1z/yge+MXRgSijxHKalcSC1MUBLJjNM6l2UwaeJDXguJl7ZIduF3IBmP11oHhkw4xRViEtkmSIIJChovfKZz5AvNiEr9YfCFXHBJDnL3pL4MqnUY60ModySgmHzxlN8TXyVfKUkXZnALRYMeZu7wAZmFZBu7pAOBUNAqChSPf8njH+JeiDoZvjJpx/sfEqhSqiYIZVkzA6Eto4mBjlmgmEp05dpOOcY9Ju90ADRCXwJDk/uls4AmcRo7nSklCzCxhZX0o9rAF8PyTVJt+nQj1ZBlGciZyv8CgxioBhSVL0r6D4zEfCE8wWdMMFpQf0Vw1iG5KBnJYBR/Gr1AMyeWytKF1H/D0184x+fIGeZzBoxsHyEGd5mYHkGJ4WQlNj86xkn6dKkgZQTouritbQGFEkYlQhhNx9MMatOP42thBoN5T6Wd406d+dh6nOSZ32RVBhVcYiT5mM2xqvJ/qxQpSmMgO9yYU05xqcys3vqCYeZRhuGz4AzD6dPj8S+x4dzrC7ohJU8yqFAP0RlMCbsBkPLUsGb0bFITN7yd2tV8HRjaS7wRjq74QrCl4mwMzBhP8on1pK+EoU5LOz4yovYfM7pR7DIjO4E1TraFdeQeEVo8VHbzhWP/1G1XoUvJtdXAEQ7sje2kJtTNIrez2Vwq+caXUwyujZv09GPxbBvPFgxxdv7Z3Rs16YnvzvZwvF2lKvmHuuYyVozg1K84KcQp1iFGTVzCgn1ncFi7Rhekp9Svef1X0nn+dkmbzN586XgYPK1owbPlrf76W0+Qjhih84QsBnNqVg7Iy20puVSROhhHELNgpyce7xEdytzDRfa8Nb1wTtYSiD1AIh9VKYyNaZC4VRozseDLLysfqT8L/rSdWisI1kBjq3F5d8kcaPL/xtvKSFb5m6Ol8BGbiAFPYSdgq1rDeQQKZhj4GHnQxeYMy/dZnaZZnkK+jVgWtTAz+OfLde4A/5kVq80kJq+VauPpGH0rZFvNzAfGSZg9tHW2RLvAnt7caem0KUnH+jbAyFMehgcYxD4VCnOI9jQHfLrHP/K00UzMLTbvKeoLz2IbnMhYw6p4IVkzudHZpLCpEytaCccwm2wGqIlW2iQf1CrWxgavK69JTFtL0tun7in/LmCcT/qNvrzjNLaznYHnenXE59VtU0dcvtLaE7XuEGLASPhr2TSB3Vrd6TVnONfhuZupDAUpRC/CVlWhaVjrBjgGHpvmXXfzmmE1JsEXWsByli2gRxKWUSYocbjWFZJrrvVdkUpG/o77D7uZRVcMLDChPKTkx75gc+ONam7atLZiNWSE3v9LMjAwJ+I4x6NJzTvWJ4v0go50JSQBOaYiwQleVNXeL5JOA4Inzb/PXrGo+Txm/FJdX+hgBksJXV+ux8CnTLQ1aG3d8zAi9g8SnYZxF4IDt5s80u5ueTe3+uhH2lQCH6ljaOp2FYv5/dPfS7gFHbtje3aTqfdemnZYe+gZdW4KPXH8413gSgcTvL+QRSV+y8pxffmTNz3sU41HvwH2qv6gLOZqWEE9+IU3Kxjb6NHm9QMq2if3ycKENmJtC8b1inWpcINNnNjTT+T82/iQt61jJxxkSZr08oUnYzxOESiLWjFZicR+YU/X29Md0avmVThX93gbVDwoLiXSCM3V/4L/8pL4nqpETP2DX6HWcr/WI6ujQkUXC0jHfwlVSfxFRsTDRGX3StDmMozTFCQUK6KyMODAf5DXXwvFSgmlbEn1R4CmYZQFDg50LiDYAnzEfihIV/1jWtSlNguSOyUSJZwxHi/IAnB3eTZISbs2aS2XRACgRX3jGUwyKqL3gxOXa2t2UinXfFIIbxjoCpCiPfdnIksBhbMWavAmdQsldWdWhm4hJdugQLxCSLMHhqQjhZRWhqCFhcoXaHCYh3q4h3zYh374h5+AEtKXST/Tdn8YKxrzRKGTXT24hgs4O80QMoCoGxDkNgXRJBvCK/oXMSXTSYA4Jpi1aYW4F7KjNQ4x/w+5IV8NqH4buA+jIkSyxCRxISmhQWxVVUh/KGNLCC3OcS3K0UFutDIb9oZwWBVuhogRc0Xz4oWy4S8p0zp8WCE5YCT0YSoI0SYHwUj5kAe0xIJPGI378D6jQT0e4xVFd1WXZgafWH87s2Gm0IzhMCaYQyfTZ43YaG2T+Cmf4iB9U3xS8itL8QGweFx+eBWPgyGG4G+UsiB2cEuB8xNZIQ2A2HgsoxHQI3OvMX7hKIjhkYpjsRGAKDnoUxtEFjWzQwqt8kAYUy+igQm3ZDR76Fe7MSnX4TBaoFKdcmh9lYCdBoaxeJK3SEgz0Xa3OC4r0zVWIT3px4fcaAOusVaqZf8oJsA3qGgmvCFBC9SHEYIywFNkC1IMOTASlwiUiZFZEbM3ezgJhxY6cMKL1iFQwnYiaVQSz+NDaUk7erIbo/EXdgmKUPJA+zAVkDEJq6GH2NhlcpkGWriUoCgWDaeWIhmRkuiTe0cafdVGdpQFU3QPUGRkXzINV7OKSaeQPZgSuJIuhqiRv3YcF6KAQVOMKxRCHHkpeAONOFMhLKUpwAeTL3hpkRM6sheR0Ih2nZc95CKSnucIUCgOOnEIq0k4iDScHHmY/rGWwLGcUACWnqEwhdIO7ZRhM2N+OLkLWtGbsvmTmjRzsJcBnKgXgJKQIPONo1ctdNIwwskXprhRkYL/NUMXNLgxnG5HHdjCOf6SAr6BI2+YnYlii41wZD9CnqJZZ0XSkh5xGGlSlanpOOESGjTnhU9CjBIXYyYyIOwDY57jYqR4oXThjlz0YY9HaNemFWNpBpRAZxgAcX/yj9mJSELyojkTl+jHITXhmXbAAmHjKBHzn8QiEC/qSQ/6GXyQZVlRHwQJXOmCD1WAZAB5olwnCejEFwJCl3T0Ey1QOUkxLOZkE/uWdJYmK8cBkS45le61T1NTRbcZnSMqn4kWQjVKXKN0GVCElnNKo5JhlmmXMUcnIQA3NWLqMIiBPdd3XRyUKpVJbXICcCrjRhAHIOSydj0RA/BDKFMFeuVo/1E4YWyU2hpa2klzOUQyAJwfV2gNIZAkg6m/1ylCWZeVypgvkAc+UoiC2ZZ6WmemuF2tBWeOyghCYj+YxYS11BxsWlyZyXeWQnMg+g/V0pnVEKUtuRZWMEU25jy8AiZ/anRmowdFMKUQQgXKsIW84UzG8F36AELaAic1+V7SApgRpZbZ2a4ekyL4k5WENZSbOXSERGSZIrBEEAzywaHt4XBTBI8DGygyI5D61x5sxTnjlCCgw4b7hD8IUh9ZBQSWUXwj8RsfqSruea01MHLxMQ6Miktk8RQ2qiRDggmrWbA6AWteSQ+xxF3P0wx/w0kylqET8pJO0ZImOwHOOT+buP910TAzHCh7ZLCZQYMWLOsPJ7IsyDCZbdEaZlo/iroF5uSI3FBgBlMBrOKWwGCx3LGsHEENl7BGBbRpzaGjKoRGUIIdghSpovRi0wMkAFoOEAmw+RewacCpwCcIgiAHpKpAlsWraGcuQ6oMvvFDghh6IYeST9i31QMcXusFtQIxH4s//qSkHQkMJrSlRQOcAcu3XXMoNeQQqviEZ0G6CSmeFCW5c2AWhQMQr2GKnCSQ1MgUAcRlVaqRk8M6f9UX52IDczBzQiG0NzAounG2dVJEUuFXLhWIQqAcOhsv2EMkiqGXgwsDnVGbWjeh0oektmt9fQcWPWJzuMShVLN5HDv/aKU7CegLWL5iHMFajtZmsNBbt+C7OHUzRfiQQG1YGAWmoO6SsRmFd4U4kO3olESFFpcqbVAhQc+wLsN7bomJo/w4Dw+MiwZLk1vBteiHWbqxVks7JhEcoeOUWeJqaUQUCDU5QotSEJP5iENUKnahgpZyvfBqtKGwhke8KvzpPpoyDp6XNWQSpmu3EsZ1nEWLoUJlttqRQ0i8PF5ML1y7GxUKF9OYlKthNUFAAbckLT/isRyZQJ26s9XrHJtZMS8VZx1zuLqoQtIQpkiWtl9LKBjrlcdAoBLUcAqSFevDHaHXPLDhZVUJuSbTxLwQKvHFC+PboVrnuksaPzZrR1Gp/4HL+JWkjIpCfC+b8bKcUxDeuqMPg6OFykUsIg8n3INbslo2zGG6CctWXEdjWi/V4ah+U2CAWZS8+xVLyGonoZMkpCZj4y7kZBvly5pYK8yJYaLP4pvSEbqNkQ4YKbaUyjjP6MCYtniXLAVfMyClXEsWgrAkQUsd9sV4sZiGMbS8GKuwGCBXI61L+4/1mRJCay6XSI6pWyi75Jmh87CCyZH6iyrV6QRPgz6iKKyimKPuQTTJyydu2Igu0i5l8TXAQT1CtL2psmUxOhe3rMHFgUORYFSj2J72Is4qcTK/ysbP7KZR2iRt+pkajKvnq0iMmjfY1arwMy6h2RclYLkbmv9G8yh891qaQc3RZPOoYcMXs6qXAe14AOmEGtG6bOiNTgmh8qpJzRHRmuyn1AonQhenXpMyUzNAKAtHXsMGIParbzlcROeUtds0HNYzlNEaULSqResgshuuBrZDywSkpBKzmuGYB6TTbgCzO81SWOFpPMKzgxhy6VOym8taS00rZ7mdiYdWMwbMSoyqBgGYVeCfDgdxw1DOWPEY80xZMV1ygig5QdU+K8lajkfYm0C9UQy3drpWG81uvmvbN2I2I9Q3g+Hbv3gcWqOS5UIoL/o5WM0mf+wkoSKXit0h5NemLjqfjrgW3kG9RgZsaXoY2jBtgjS36ROOkFJNrLiJmVCcoHl3i1+ozmwnNMYAz9hzqlDoF16mkzyYgOW4NUCso2+aGM2glVbxIB2Tdilh0hpIpe/thmIgqLl41dmdvgzYM+8oMDTiQWu8jlbix0Mds6nAxptnndvyayiun2awE0lrS4Z4tbF3yFM946BojJMKY0XKtKJzLtbj4zKAoIGlZHgHzRY6rEgOqkwIxY7nnviZtVG+r+k8yPOQaBEAACH5BAUAAAgALBoAHADGAMMAAAT/EMlJq7046821IUUYEgQ1hsfYrWzrvnAstyBhiPgtmiJxkIUabkYsGo9ITSEFZOJQoE+BV5CCgj7dc5rser/d4Kk3Lg8n4mtPp16KxeC4fH7xiW7R0S2FEh2kXBIkQGNAam1kgXSLjDJvbYgnfCNCIRRWlWRSTmIGkyCNoaIZKHxsTj9+PYchOhRXnkJXs3yTQZ9no7qLOZQ2iW9sbG65CLN3x1VLmW99xCW70V2Et5Sqt2q2ZCRsPJ6aW5laNuPBitLoLoSRW62/ypzEOQdUIH+skFV47QcpWj/Q0gncgKNGvkLs5GmRpMhOmmvZPuxpd+cDooADM0po9qgHkyup/7ZYUYaF3BUe+MwAi0RNWzGN0hK+IwnsCSSXtl59MhXMB8BSFJ/8udMDprQ3/pbNswUIUMeQ2ixSAbhwRDylVcNVPWR01LNWJ0BWq3RjWKlkBr7dMZGwGZ6kYjmG7AM1TddF1GgSBabFbBmAV4u1AvSrxg9cymwQKnvMUKU89O6C6ah0yTdqJPjkcaZ1Zi8q7fz2azYrSubGnQoSkxwGBxOmsNJ+Dbpl0r4PP01UTRoU1lzTJ4Sl8MeOtRGbMz1bDZrWaRDnKeGg+Rt2GWbaK0cHbmbc0SAsz2sajIRHMbV/Ntu9ohgyWUGX4VS76ctkT3d1PmjZYcbK9TbbP23D0f83OgnYmxmIxbfPfAVlZsl9HSwEHHs08aQfg5i9Y0t9GIUHHjfQ9aeSVQkKpZoUEG7Q2EdkMXPggsjAQwZPO0ynSj41OBdabZYZmNVDKV5A21B5EZNWaW5AgpovNA0Dio0N+ifPcCZapZyI4eCCUYqJVUbRZh+29Yg9I+ph2UlQyiflhWm059ZH4GSFSJAIqGlQUK+Nlg2YatLFEndoSNgOmcvZ9JtqhwCxCUcencNajzGW5JoaFjkTF0LWGJjIaDzY4mB1yDklS59/lhdaChC+18+PT1Qlm6V6fSnPKk9Q4WQTZcJiIiJOMWaNZo09ed+f6cVK22aOyZqGPWLVcyD/ocrF5yaelKkXZGcc4RMXK/v0s+eOD62Ghq5i8LbKQeukt497bcDnqFFbItDUXom4R69qJTqUAzeVgJYlpUV+ORSiVVyEmhoWvHuUsNMpyuiPP2aijb2zdvngRi7GlyMhqZQlF4UTKsTwRhenQ6gFh4KnGWf8gFNbWUceFIsi4fT3DqFmlFNITVEKYYEhBggUzs859/LcJPX1FvNsYiVIQVQ7Z3rjrjXD+J8QQVeQSbyiuERCwm2IBt5EUKgyF0L5GZleZCQvy3OZjFrZynZ96Ar2gNHMWI2jk4JVMa3ZpiZpu37vXTI7x2wIyGjNDVLqxskck7CBBwiwy0FFaX2N/8ZnIqlkwciBjsILUgt1p3jhveraaLFOzo4nuuxWrnRP4xua41YRVoWWcyLxVsXfYcfS1jXqtE7wI9MBkkOy9VuB4JFHDlYWzaxc8mT65CVOtAQnMnnLzjRSd1joXV8nJVZjsVU5kXiFFJatspyN+UqJ9Toje10aG99Tyl8GSzdIB3iMVqVRiY5/OJGPD3hxrKB8TyRpMIvHSKIRvRWJfanIzfPopRwJzQFW7qgXkCogKKRUqw13cdxj+tSJ5PGqF6xS2HFoU6lWUckC6Qtd7x5lp76R4XtIC2G98hCAyWztTvqK292I1aAg+SRs1tiDCxNFDvmcjQ9fwM6hMMe/Y/+lgmvGAVWj1rLB01FND4hgGxJW5qkktTFc8SoWQ+i0wVpUBk1swd0wxtGW5BEBc2pBBjce4hA1tk2MMuQSFqxnPlOxIXjlctdLZjBAc6mMPLMYxt0uYz465rEMCeMjuGDRlh8cQVAygZaYiOYHMHpyAnuKI8U4o7+ttGKGgGuT8IACnAcm8pWCcAjRpAc3UiYOYUTgESeoSK4vQpJvWQNmBxa4wUEFSyjjQOUvOVAi//CHM07woDSRICWhJJAh6TEPJSkixdpQCYSP+EE0x0lJsYxkSEcy0/j64IglcChgpaMYb5BJzxjM6iffKl9LOEYSLMKgE0FkyEXo0kA8FrT/BSBk059ocUdrqWMhOoDOrJCEAh3V6qIwSEg8DlbOA27hBQacTXyqY8ahoTQGr9qanIpVmit1UgnhoVS57EcjEa7hHtu8KQaWRb1zbe52fXLoCnwVpbJhxw/OkWdSlbrU+SFuDO+UyM2KxYKMhc6WupLJT7m6gne+8RkA5ZAZbGBIUoC1SpJo6pCekxa2JpMu1mOGzvbltyas4FPAY6R/PnEIwvh1nSbtGJhemCGhdGB3C7qQbGLYMi089o8t9OeSDBcYRRmiHxzY5/Qq5CF9lOGea/1sWTmbkpXVcIBl28A7uRgJPV1VBbKlJHxu81QDmTWRNvGYpwyhz9Y2yI/B/3XBgayKW3kQEwhAJVjGMNFKURYvuuv03OzGQNxCVQ+6xjAtITNFpGeuyR7gLQJzY0gmMZlXGUuNm3UJF1P0WDS+jmAVQMJGUnPYFGVzy2QlvVrOW20VwBpgndkGSLbk9uZrdXBPVjgpq8pC2AgAy4sO2nMrv0zyfFXahFBVIaHvEPTD/bSub+GWTmCg7HV2Yh6OdAljXBZYCC7xGDMC9MDjRUGxRbVZAHv8Vwk/C2l4CGmjtiRHwqlkt2XrBpNnIEk9vDWJf6DSLNYjP18BdBWoOPGWpVvVmz1yQsMrRinBtwbszHPNDzXUQpb7OaNZtEVp0y+7xONKPF92tUOy8v+g5By49f4vQF8yNBFEKiUYQXF33jvk/6bkmTAbS82SXsGk7Iis0CUpEa4whjWEmodMiqolail0qAny6MERJaZv20hI1iWM+d2VJoSYdXiVqY2fQNq5D5pLe/sAo+Wa+sHCZqXbXJTW+lphZRirGcsI6LXMRZt0zX1ZLjn4Q3nNFNNy1O8Yvp1nCBowkNt4JBQw1qsucdaqTqAmu0kHLDKdjYUtpYcuEammHN5iyftmM09xsywiMeispZMiQsNy5tIkHKb8qIUdltlrsv1YjC90tzlkfXGUDVTMOVJIYYUXxEoMzLmnlU/JMSoqzdDNQSQtcALdZVYazZwFlPnqGAP/NlYuqmSFRkX4z2mN2KLhOlwKnIgdLP22nnp76dndNPp2mW5uXcrEcXEJ1jnwzPpGzo6fpsTY1872trv97XCP+6Nq8Y0vmuMqKXuD3CcggL73HQACAEAABj+AAQggAAMAgOIF/3fBDz4AjG88AOKku/jJCk4kx7rfJe/4AUAeAIUPfOABH/jHB2DzpBeAxQbDKK9RDEV7R4DoN99300Pe8H8ffeALP/jcQ77v/FjeSqrK+u/GXfd+B7ztk097v3v+9KRPPODRyVxEaWg8aXlNFWKPAMMrXvSA9/zzcd98v59eAOTffNyohzPGEjA/pox94sEP/ud/n/aAT/3upZ9//9WrfJYNFSUbAm0lN3iMF36JR3iIl3qkd36bx3sO6H/IZhJ8ARTVRTty53n5J33PR3iFR36Oh3qHh3iPV3h1YnP2JULEwn21Z4Ckp3imN3/o53mzN3sKiHiHRFf5QytlFyOpdnwteHrQp3wu+IKEl3vmB3p/RzIXsR1eNVHBJndC+Hg1WIKg53gGWHrId4V9NwCa1m3VkinaE1tYN4UuuHm994Hjt3vn54DfZ4LnsxhSUxpJNiJ11Xa893wPqIfmR4VD2HwN2DaZlSssUhJoNwhxB4OIh36pt3xBSIXSh36i531FhGIv91rqRkPbB3cjCIiFt3i/N4KQh3iR+HmQCP8ADTNdwJZun8GJEQh6Cbh/0CeKIxiJnxiClSgB7gIsp7Y6PHJSbbeA5veA30d437d4/Xd/Gvh8oJEcUFcNpOZSeud2oTeJpHh4f/eJnIeMoHd7iuiFUDIcQAZBqDYW6oNeM+d7bWh/tdeB4Nd7xziDXQiObTNcEFRa+/RfSxeBDmh6s9eBxwiPoxd+sJiL2fZbGZMuztV2uneF8IiFy/iBDUiFyqd79JgmSZRElrcGCkmAoTaQb2iK8EiKj5d/CiiCpTc5K7Uuq5VEE5QkabN2jdeFwqh4HbiIpad/1ch7xSgklnZvp3BVmSds+Ld4uCd4SjiM6bd7x5iAqCgkZOL/X/6jaMuwW2U4kjFYfoCofyL4ePkVNSSlfdsWTn5wldDXe6eXfgdYkbPHgI5HhF9pMyWhkDU3IIbwc6ZnkiIIgx+Iksznj36XARuHL78gbx7SBE4CFj+ngfkXeV0ZiQwoiaXnj6eXdYtmX3JSGFK1b0PYjRqIjaG3eKIXg9X4iIFpV4P4LIsEPtqQcIyYjVRojS/4d3nZjSbJh09JCiSmPuTIHGk0Ovv2j7hXmyXZeHk4kMa4hpajW3+zaHthKmMjOB4JXs2Hlv7YjclnkwbImInHk7h3aD/mEN+0N4MFakwGiJPYmA0ofbYXisxHhMuZWm7yDfemN/viW0MJYKin/5Pn15jCGINuKHlUKGrd8hR6sSGXdlTGt2a5l3qG55S1Z5PzF3lLqY69B3RQ6CW1sR/kFheS9p79eXiRd4W2yZb395qKOHgYhVe2tAYzky0xZx8MaoQliYWfh41vCYtBqIYRiYMYxQrylKDVsWEfMo1bhnoe2I01moUeSIMjCItqOIMXKWo4p2HVpRgNhySucqQ0Soo2epbnJ364SIk8WpDtRhq2U2OFIoeA8mE1OJkJaIwOSpuKGHnbiX63Z5Ar+ml71jG9GD8xdaR9mIXzKIPz2Ig3CpvNF2NbVziOWjgJwix4NqjgJ3h82IIPGIrIGKDrRBJHVFLmdRq/pnSC6v+luTecAtmFo/d5jSmim5dMyTAwttFauIKmwMUDwWU+M9if3Rmnqdqqx/iGjVcEv/I2Gzk4zpNHGMZVzVIBnbeAIOh92UmKhlqMswdikrKD5AhnSeFL6PhKjGIBqyqEexl+hyd+NzmZp0msymI1RJcDoWQ6NxVRyYOEwVp63TmK7RmmrIoEGskrO6Y/voSs9NQP2rFDE+CWeHp7H5iWN9l7NRgG8XBsthYupKpqJQQS0tQ95UYB+Heu5ZeisXl+XjA3foB2uAVv9AOT2EFHLjdSkyR5aBiBOXmd8/cFCEoMLzeGyVMRU1cQC3EtO1hZulp7NAmxzFeLJwkGKxaAzVn/AzfmqVgyYkHQHV+SKJdUVzXYsNg4kJLIjvkJbrNjdwrhW/F6VSZWtV0xKR0Js/4krpWagKEprEg4B6jwqU5VZEPlTugynXHQKEkTUKmDiBXgfOvJhVrJQCLhjAuKt38AneriFAJUOkxhTTZWuA1JgolKkYxwOoahRBXASO5FQNIpKe4jaDu1kbgCt4NKkedqeOKjMeJUII8KEiW0KkGZBS/GtKg2aGfxm8oRfx47ky9YmvHJCN0SaPPxM9siRGiad25BGt+qDlUyF6xiWpgTOaw7m7F5vLELPD3bZ9lyvRqJbqdDNhjXE8kRUSqriaazoPQnfl27C+fGPy36Mfu0/2FSEJR/Gr0dcicGh5C1MGPEsQ7OprXO54932LkdcbEm62wCEritFFVWNWjYNQGm0lhQIDtONVf1Uym/KS4U4IERiA7TYnI95E9OCKQrFpUsM1yfFG4wSUUVe2qeQV82YQEn2XcCYRvf83XLgXRA+hxGR3w7q0ZuUx1kmYK4IyAU87LJ444ZAbXVpHKJwWCmsVJvxTolxEHOglUqXD2F4HqtIiL5BlaoVQFeWUEobH1/g0nPJRGpW79kpGl8cVxqOhZOdiojIq5WaxFNwA224RdY+ltucDYjcWYmMDG/EI2+C6MKtmgDNR5qq0hTE73WxHBhCIDb0mf+csnlaHbvYf8o2LBX1XJnPMRsbhwF6YNjzzjHz8gw/nAYaNZmXLe/FhaGm2MHEOJ+q0gSlaIjSrJRvohoONMpxbVtzAMqYlIk7hWrC7y2o9VlPUFeKthRrPhyi/zLffHLx+oYnsaKJpTDQvvGl0hRoSNmjoql4llwF2zHDwNHSoMZt2UdqzhIFkdHY0SOOjNBtkuO7XEIYDhPNJIXSGUkGillmMKKOINCwIRWzhtuffaigIoV7lQy1lwTW8HKW+TEJhQdUThOaPwQvKjFwXEuKzV8C4kGXDyYmvIPAfJP/Yszt2aedCLIDdUWsZbLWFs/D0ee+mZu1nMVDFVOQme5WJp9m4hSYMH/R/kRSCuTByDlNzyhI81jpHGog0DLJGCl1QpCKqbmV9QSz7t0T098HU/TLnDmqVSddroMgLI1JmXswUU6Lcu1m2LZKb1FXTdsKQNzKXy6mZ9lyPNR1H6CMxIENQ0h1zBUOuu3M3R4yRAmSMSnJB+BGGn1IXYEe7q2IMukMph4dHs2ZZPQY2IouDSVv1gbaHnhLxpirD1I0wBXyUx2bqK0YpaUrbn0zijWIFawLme80LCNX5ImYpQsSTfDEnjH2/TyD4UxD+cbb/eyoHiGPABXvnyNV7eKAOxL2GmnL+WTcAiC2fDDQi/3AWR2gXJTJv6cI3f7cxzlT1AlI5lCtf7WmiGBsVmyrXVsQtxYFzc6U2ytpFieZSNIRMTP0M2EDXf4qS8OvgwQ/VIYqU9ppCivZho2wH1X/Gx0/KeuvTZQID1Xwn11BDCjNmKZqXRixD6p/dGoTOKv8Bifgt32jNHQ82tNJzkwflhzfWYSTjKeIJbMXBalveMGtTP9huAZPgECzjnUbeRctgejDYy9rVo2DeWtMTEfTtvBFQEAIfkEBQAACAAsGgAcAMYAwwAABP8QyUmrvTjrzXUph/EVBEF9x0iaXeu+cCzPtEumpEioHyv1QBypYEjVjsikcqkRjUq85+pzAvF2QoJh52R6v+CvEOiM7nbWAgWNLqOf7Gd4Tq9fVO9zinCAYqNqEyN9QyiAeGdUdouMR0N5Q1mFNyBQOWsqWyVChFKGUY2hohmFcXk6Vk5vH6gGJ1xTZleHY6O2jSiolYdAhTirij8gB2OyboOqq663zF5Ze2gpxTydwFknqoCJ23iq0FwlzeI0kyNlnleEib0laFVPnLMqIZ59kCPj+R0rwFbReL3moSMyBBOUPXDYxBl05o+UdfoiVnhoqaIfLSDOferHA1sPPoP/0vDQde5eGlUS9SG8h1AWN4ABPwUSFikkuyJDDGgatEedTVYHUjaTCU9ej2L0MLayucmgOThPeanDOIul0FE715XjNWvMGZw/gwrCkaIMsU1cJaXx85PN1UXx8qh9RJZgzF0fYb15lxOgNY3rOMoNPPPtl0dEo7X7xW/rtLnEbryiOoWPTkDHjnIVCciwF09OtqQraxTvqshkWLXzgUCL6HmvgaxeRZkzNS3ANHlO8hNONkrzwJXj2NIM39IjA7Yr+tBXt0G7ya1FdKXfP6UxrTd+9Kp6qctbh4XWpRpvEMQ9osPImXvzoWQN7bZxXuw4Y2qpbPuDuhymJdXuqNeB/w5oAfOPXSOZUhlMsumylyDOrVANfspYNw1UsaCAg4AbCITedDGBNwk089CDjklrENYXZbixQlQUXg0UoRUc3qEQOxkR0d928pUUi0YEnaKjWBLggNMW5GX4XnGcOfQGKlA4QUiNgiBZWnwK9aOKlPIsJKMIazA5HGYMavgLLDya0SI+NSqXCWEGasMRgFP4NEkb3clSYpcyvhEjSDqas46UHMoTj4xRcKkhCk+6KIKRXB23WHGZWZSoi5X8l4uHlW2onkl3saWpdk0edeCMHUFoyJyy6dlSbCKaxalLhbKFGR9KYWTkcnO2CGp/WhWWQwi/sYpgVYkk6d6YVOqhZP+pd2Z46kubibBlYdZeBuWoEhKRjTKlxOcVS09FxxpN8b3JHjpCAOldgtYSRIxoVbTbaA7hHRJnho+ad1QRRVhQWD4BdifXXfpdAVhVm62Sp7PYzfJbq6Z+lO+Tv1mAa0S9CDxjQ8VoKluwFCKMaTAImPzkaV3JIxoh09yrgsaA5tPZRJeOeRpqN2rDnj1XVoGRdbZimiWINWXx1X81T8SHEOL0dm5r1kgRMmLEdCJTEZCAezNNDFtRVl1bxSGNHxMzVTCEUuLGTDl1CQwWQ/k2JjIXJp6M4KEkUKB1IcnUdKdWXCf84VPtCMzqLaE5ujbY+LqrL13sLmxJDCLNRyf/2n7GaZ0mmuygMYOeioJvbYV4nBQeLSWi9OF6Tl0D6/nxk24mnnCj9dRkamb6I6LFaQFSgtbTlp7p1UFm14gJ5t/ACORN+xS4BLlgsB4DFZVooSNv0yhExHjhbdJjmr0pFjICGyCdgImzwhmSVh7F42gagubRjliGxxbetQhsc8mD6N5XNn8NZID68EsPtoWfSSgOOKU4GRSUl5z8JUdgkIEF0I4lu3w8Ix0AIQsCJ+C8HeVmDoZimZ4eCKNoOWw3q8mdxawHvenIbBi06RsYnhXBi6EMco5RRo3+1rPYQM9PasIhoPKwwwM9RllsOd+QNpK8NrkrZjRD2n/cIL8q/y5hTJVQi4JgkT2udFBAPjrdCIWxkGi4Cy2Mgp4jcKen7iHPY5KTI5Uy5Rv3TaYrrIqMj76oQB5KiTRjMAIB8UClDjlGcX+bwsL2cwglsA85T5ibXPg3s0Y6UgpyO6B8cEWSFSJBgKEJVsRyCIoKvNCTG9AaBhHUq1MxyTU/lAEqxuUQ91CrhmeE5R2gl43xIdEMUnpNOGrANGN5aEcb7KQwCbmvhlimdYERmSJnUCYLiu0itIxFH6ZpyTB+5ybX01slucmcfcmkXfvpxzjJOTsCTUIj9wEOt0TGzsaMITOAq5MMZ0jPGaAJaOBYk+B6RyYZLNBsiDgNOOO5qtAUlP8cuDLKQdBkJe8JBHPce9HkjHmQcl0Uo+GKCWpuML7NwMBB4TEWiwAVMiKdNAa3zNk7M6GWPsjSBUpjA9kEVZGYfu2mDj0WD1uKJosBSocdmBNZlEUdHiIIqXM8VFH/0Ki5maOLucRAXkJixOWUbyuZwSoSVBM8AVKHNJSJpFs6wJiXMY8jypyQA9U6u/IYUVumMdmqdrGPwJ6HF14KVVj5uh6ttbR5D4kNpFjBAesRqGqoKlNG9cjY9VDSZwMBD5IuA4xPSkgnTJPGsrIDgs6eknDocV437blYYQQOtK2620KX4dojWOIcLTESQCPopy6Q4kR3uxp4NAe13iZhJYz/iVIbbiitVF0ghxdyK7vq5lzegNEmnDBmUR4HocS6c6GC01R3Lbm6XQVUTUPFp1hHcgxSKclWWFivdyNpVIbZFwNa6kXwzhSE/3hFv0pIo10clNhQlQ4TCwwe4tBqr2PRC8GnfG9GQBWvBeltm4KQrcgilK5vYbicIknlU4N0NjlJs7ys1A4XEfIoqgTzxDbIpMXI4lNwrUxvi7SayHxUG1XieK1Ii0pNeomgkowQfRu53QLlM7/8HnmtRYNgezrlVDlUCW8gIdkM5UWL2l7ZBhIWs51kmKw/HMdoj1UMa6F6Zm7KCq95DCEc/siqwMTIiGmoM5JxZ03FskJEEVSV/zmX+ItEVmtKgu6rh3w6Zo08CmZpUKRbY3TP1eYi0jXoV9b01Tip7C0QiCJt4djiZGeZGdR0ZVoROH1DpsXiB33eci/ySVpYM3NEmnE1lRsVXBaEbF8wUxA7HuRrGRhIqEqkTbzEpIhSDy3TzTHgT5ptUHk2taQFHhQjUxZHh0BpVbvrDWe5XVliDW7OI2PUTtRQwIZtbYZnYDc3qRIzRCm7wC4Kc6C00T42F0TfmJue/h7BBUV9og+ojcrVpBwkhRAI4QmPcQ8h6wZA1bdMIpTgUDOB8ZdiYSEQVyrD7pdnBlUzZ8wueWEtMnKpkXklxUOd8/q1I1rKPMe+6HO30P9BHr59ZRd4hVb41v3z7tD4RTynbcHnjToP5zBiSn5103Gt5LkAibZH3brYx072spv97GgXkI6ejcngCPvGYm+QbPrtUWdmW8/RdW9r065oZIyomdUZVSfmsqnCR7BSTI/7Q0H4IU2Ww8l7uOy7eSKcQ8+V7ykzOnHh+HIWmwRWDfQOV3nL98nJZBOFa+nCWhwbL1li1MDS+tb5e6WzgAVodcFfveNgFlt/AvMSEDNuHf6Xg7xszF0+fHNQC3xyByeJlLg6jlwh1Nz8A+ItdlSHE791RCH/9HVDNUC+1eWjuYz7MpeCJqSBk+ziCyaeirynnzINHRg37U1+Dhzuwzz/ixXp9fyhTReTMaX3Tx4lImIWPLalbkfnclSWSZinWcLnWN2Eak/FXJmkE/zFK9ZldlyRDJHxNHaXCJDTL5FAG9VwHd1CXmP3gFhQV1xCG6ASDCmkctnmewSBf8UVfVVFa+okNIvSetQhYWPVKmcXANQmcMi1Y2aVOCRUBqSVTraxRLixUnCHcB/BczYEbnBzJw92AyLIgT5IMbS1RmLHZPzgBsuFJejFJmykXRXoC5dRDMxHdkR3F7s0HyyShT9UIC4GWqsUL2b4c7lVFkkCTxcySO9jIMcgXtDmEGWHdCZBeB9Ce2UUUUCyYggjQC1YVQxxFpHlOnzoItdVNoZo/w691xcWdIW+pi6igh/XAjevVAFgpWQNBn8PiH6RplWIYS3XNF0ytVhl5ky/hT/9sXUJJSMpN1hsN1bzVW4UE358VCaEGDaAiErmoQvHFYcf8U+rAQ1rVo3F0UbnkEb/kIceMB+PhVswUWOseGX6whb5JDVQ5kc2MmGj4iXKAhgsCGoBlhkGCD/3MEEaUGiZIlo5IBgrZTxY6A+J+HoOd4LxpnXepH69Q4S8wG4BOVADR3/8URKFRTfb9Vj28FeS0YpCchHfVmlwVDYt0F8aKFJssDAm1oqdlmUBgU8MSGceYHo3FFLvJ2/sAGstZS/8xxkLmSg5Rhwq6YtbJTYyGf9pMkhoGPkL2aJuL8YB0hcZ6VYdxaR7BwePuWNPMihsf1NwWVlZs2IM4bNpiwIb78hY36Ai7Jd8l4Q0McBKqrWQvfIs3iB7cklwjuFiLXIoqKFLvtFCAkFx0OeGCIZyUKFatABub8STLsAqs6Z8GBIEo1YLR5YWGVgJ5BFDAQaYw9RzDXMfFwJXdeaKTBEeytQ/lvkCSgYwvLJiGFmBUsmN/rEQXAKSswOKzpGAd5GUpBd8cQlLAzAAo3MDqHVpOEIQl6WBluFmvnWB4ZN90SIrw5FFs1lQAyAAy8mcQVZI6ihbaelQXPVV1bWMt3iJpskhyykAAVCf5Jkn01hId0j/GyjWkZGEc/JhhdkDhbqoHssZAPSJoAMAAAM6h05FoBUSlIQEoMZjBtFVQ2niRbB0AAdan/UpAAAAAPf5hCEhZxPJEI3zGTS0CfN4i1MjfSQnTAEwnggaogJAnyI6osFnRjzqUyCmBL/0W6qlSrlEXJHSLOIpogCAoCC6pEs6n1IUjdlUXWDAgZOjBdBVpHXTMwU6Dglqo+FJn006ADNapiz0E4DWjY7JBICnmC7SXB4xP6xThfdnGGTKpB96oyAaAACgp3mqo+Smh4E3Yl1Km/zQlV2opQaUdDT2FmHapx66pEx6o2QaojmaoyxEMrGSKxSkTo81PNbwOkGpHBKR/6P1Cal3+qGnuqB8Wqb0uZzNaZ4MF5Z0QBkOAk+WyZEZenpMJA43WqZPmqc2KqmSCqILuqceqjqZ9GNAwAi8Z2hHNJwrej+aFXaLoKd7mqrH2qTISqzhGaYJ+qoWgJC4+GAU1EbUEasztH1kGTswYQesyqQiyqfHuqQ32qf4GqIeyqcg+qV9CquLtFnx8DuxYGNmGEIxWWYukQkwFZ8cMKPjGZ6qaqz9eq98iq8dSqbI2qQeuqCAun8NZAtEaCL2SBPidUgxA0XVIH8fEQMKWqn2KbF7irH8Kp79upwiaqw4a6MIap8XC7DvoJOFWk6Dl5beolRlsZW3d0mEils2Nf+eOYqzBxqv9tqnehqs4QqxkfqzFtuqvxqzHyt3axoKxZODOHOOWRciEXeX2Ha0KrU2B+qv9rmn4rmvXyqmxnqqVXuv4WmvVyuvwzqjnDRuzOBosYquHScJJvgamYiu/UUBd+qkXouvFnuv+HqxXnuv3MqxNWuvFyumVgux8JmcYdCBO4qrN6IpWZGTfjBZdJQpPQe5YlqmYXqqTLqt/dqzeGqflgqpdou5r+q7+0qms8QHHJOrxUEIxfIe0vZh+sEtoDQBfYujM+qnCcqv1UuxNmuswxqs9MqqfZu99Fq3EBu2Q0sHGGqD3qcNiGZH4Cdg0wC5ONutPUup/Wq1lsv/qr9KppGLrVmLozjqtxVrtRpjLtHoPfnUc0TKKSWFRdKrpBQ7vq+quf77pN8aoo+qteWLt616qtw6qYLbJnpAeOYlWHqzRTBCoTQivR7qr5yrrzpbqU56tRqbswLst5P6tT1brwrKoGp3S9wQkcdWdfr3kY+XOtK7vfqqsdcLwrYLrHprvfQKuDB8p/Z7ub0bwtFxJ201jAxTmVBmFDphRLKruTyroNkLunmbs3iLu/NJvp7rp8JLqR0LtFtcVHwIKn9CastiJUvkmG98vdQ7wffrv48avDUrvvqKxU8qnrWLs6JbI1FCgbeqYyZ8qEWWO6eCMqmKp/8quR7Mv/w6/786TL37ern2O6Oh27VP6klVRy5GUxE6UH+Wo4qvcT8jtKCSurXeuq09jKeai7k2/KczzMaQ+qv+Ok2K2WNedcAdKRDBVRJtdTkPPMA1SqOI7KSH/K9ge7va/K8cS766a6wFlcDIQjJFG4/6KRzULAEa26E4nMOWirt4O6+7HKk5iqyfu8j1CqjCtCUJCHZYajVFK4Zhka4sXL6P2r22K7UK+quWCqwXHLmqarURHbFIJQucVhrKhDyEyhGQa7uWi8xy67EZvL2UysaOrMrVK7G+G7V8dVjf5yYvuL5WQ2Y58rQzXKNyTKl9O69/+9M27NOkHK6SGrn+fFPftJkxtP+wmaMcZ7E6xyK7LRzO9fvBPH3UMVyz40m3EEuxuuzDvQWbtwFsclZiqhthC/S0lmvPSWqpXavGlPuq8urI2Cq8+qrF3cWjy/LK/NiOe+fOYvrTt/u5X8u/odvSH5rX+LvYU1yfOLaZCVMbLQc4whfSkXq1yHzMjh3M/qqkHkzSWt2amfEoYCEqx2R3uwBp7szYOVyxPlu1PZyvn0vPSeqzoHaN/oAxfNJgNSnYZdqzlyqzEZ3YeZqnlQvJS5zUV5a88KNZJHLazEirTLyxGJy7dX2zMGzM4Vq3AdyQ1DCHbqUVvkfEhRGvugvFAFyxiI3YsH3UUSvWGIdpNLUf7ULHoLNSHCGds6rs1ddr0RO8wV2ru3ZMiAI7lW2bZwh13otMud9MrLbrueA8xVDL3IT4Lee1ILCHDmX8tfq8sz283tVNr60MfDzCVcGyfSW6ApCrzR3Msb2r2YIMz3rdfM4XnZpROKrYgWHqsac8s3NbzBjLqjbek9oSg91jY8dQxio9yjd7oJB6qeJZ5Je5ZUh0boBM1Fs7qZ2spwVO5YaqUTSU5bs8phobs45s4WAuA+FVlzUR0oScyh275mTrbplSxl0NovoVAQAh+QQFAAAIACwaABwAxgDDAAAE/xDJSau9OOvNdSHFJxJUYYjh161s675wLLdpCqLETd0hXxwhYGFGLBqPSI8tdbrxTqHdMpfDmQ4nQ3LL7XJ/N2gNJPz4DqXaD/w5lGvunHdOr19ChjKIkM2rnTxpan8HBIV4g1F2i4xEcD1jkZAfTVCCBoYpbzWYZZtDjaGiGJhrmYmJPpxAgnuIqGZgPJujtY1UbUt/PUA+Ym+CQkJVu4OqQYq2ykmDWJqxIyginz0gO8SQvsePmr05J8vhMtTS1XBQ2MYoguXpP5tQmE5jIODi9xyJla6c5WLuNuxJCHJi2CRJ80zQwyEGn8MKat6ky9FLF6xDrqxNgLUtyLxhQP8qSiOT7GE4G3o4/gp50GPAZ2mcYIpnbspCcj50mFTGTeE2Ny17GMgCaZMrKRatkAvqkgeuFDtHceQEkCIqMUxFsFujq9Srelw53gA6KOqigGOjmUkpzWDNbT62GqLJh+uep7GGPhHK9VANs3MAVvNWqCAsJmoVKj7YSpJClmDbMeHXpm5SUICRoIxYzRC/jrmcOn5VkvMxrF3LUTKFSDSyH5mN5IyMx+/jVGTOXElMTKeEjqjX/LpMNZbrlrFlOFYlbHEYFH5xRV/M0q+WjYA8FoI32SIxr85snCraI7mL3VYeuRsvXm3dnNnKbhzzpknCjiyhaRq6MPh18xxQxI//H6jUhVE/xzglEhvTZLGVeAkaQxYy9eT2GhxW/QHgBqZd9o1b/TiHlX3FaDgfaIsZttkeUABB4BNk1Qffhnd4dgpth7224Gh7QYhFXPMNElxfWYiGGjZNOEcIZzROkBaKOa6XCjcJ3lUaJCMyiJiSuszCi2LBwYUZgM2M9dx+ljFRUUpJioBOQqQ5U4Ib3qSp2mokZeelXVRECJkpG7b1jG38fenamriZUSR76lyDZxwFxvfPM9nU09wuhUykUXK5mJBdNGmFVlMkYPkSaSJSeKOGXnzUh1qhPi3GV5+fOcYKmXv2tYYQXuUUEqJ8LkEOXWNW8Q1zC3W5C4mqmdoS/z9NTminhHb1tOokwH31ZQnbxINOUZB6JQ1Wtg26VBXJkQDRG6oymIelp167ZWIozcOtp5VKduGdU902SRMsCbSRSVBB1MlSJqiITilPqnJKQeyWeAmcq4YRqrwhOpGfp7z+BVFJ4QBJAVESkcrgdsW42C+2b8U0BcULUqZOr8vyBVQmFmRzj35jDtQcNrax2A5zx7boksmI3asOWGtW9OKslOYomQVgNXFSoxCZ+QOzrcHiRxni8tVGybg0xiiyKcF47r4jFZyGROrW8mwQOTPcL1m9UpYOuVGqEGSmbYs3JH31THoG3FzlDLVvorxjmWd+uxxR2CMU6odV2FCs3/8Lpq1J0tYlzotYSOkorpQlUnUaH8gIJDlsp2CbE1mbKPxnxFRpgsaf0NNUxrrDF8bNCOChRx6klkvKitgZBvbcxZGWXRqW6MeqYYHRQip2ywiuqqU4PwdCN33ldzHOCJX8Huas6fLG7rwXeNTKvcdzJvX5YKr0Ko5e0HhyNPi6oNqEbLKWTdEhE65BkeLa5TBqtOkhSFsaV1BjulKNoEeGqIM8KJOkSUGibm7KXgLLE5VcxY9n7RHgs0CzhznEq2T4Yl0zwgIaToHJWQ4T3m/MYCcxoANuXsDLH2AlxN/BqnbOMaAN0RMQmsDmYzLDEXcw0YX9oNBTuMiI+RAAu0P/kaFJXDzhe5DzsT4Y4x+/mMUXQKUYoEVNGlTjm3zAKAFVGQuLzsOXjVL0o4zR7wgMCdrFZnNCqrGMDXSsgFPEJTAJGMaEBCyFPHaDhBc9skxRPKLz4MO6RA7kXzL0Gveg1EZA4mEoMIxS7mSIwE56so6kqeCUwiMMOn0jG7dyxB8ONUH95Oc7davLKzXwOMV58E3KCxEqigCNsKHGKHASjSGH2YFQVix9c+GVYKg4g6Jk5CDfzFQfmwEUapoyaoYQSUdueZgZ3EhfQjGhW3rzRHMqB15VyZ/40lfPF3yiE8+YS/F2oQp7xoBC7wKnOWhnN8jxEGcw6NOd8ne5j/RE/5oGpcE7d5msonyLODpcATQiNJOL9QJEz3FCRjnHGfHUkkebGYNXXmAljzhUTJHw3xxX2oI+fdR9ZxJJlrriAjjRLkPNQhqSjMfTFXx0Cv9kTdfao5BS9NRWfumFfcZCE+j9saksCKFqbEONT+CEBfNoUa7CwL9oYi4WYD0oWxrknr7cbyorsCMKrYMprEzElXGt5rfiMMYNTkkW3GFqBhjEyYiMxyiUAFFgY0AShClLQTdjw1HyoaVfves0A8XRZJUDuKf0KCtByQlnqWqFtIKzIoQcbTd3RB8PjapmHNpNFvfFFhAdlYSyhYEcJ8klTtBkKWjIwDqjaL+jjS+47v+M4N12a6y5oGux0QDJN4WSKc+wq3CAha5IicMZ/oFBGF7a7B12QzKpSbQKfgiOeKMrnPZkklQbe4cQMKCmYQBsFszCWzSwMl9HACuybbtcCLWYtAvsRUB50mwuUPYv6RR4BmVdTTcSFqmU5vJjhKXqRwVz2Avr8h1CSmOHgbZFLtJOdAbRw7csdUcTd1NmzXonksYpNNt9crt4uiCQL/I+G2t0ooAY0sYytMXlyQt7wROWS4wcXRa5URP38wRlyvAxJWlsOS0ZHJVlUCre3fEglJuEiwqBFGPZDQdmelI7x0zmAoUYDj+6Tw5jEiHSIFExO2oxncdb277xi50fxov//0Sz6NFoYtAHVfFKqEOvTmz3QU95JvIsaj1IyxU+9LQWxzryt/H9mYABu4+nY6CHLDbQVkSxyA5JeQgGZoO4eFg1DBiy3RF9jsSB4CIfniqrGFuBQJ3S9UHpkbtzsXPBfgNeS41B4q8qW6QJLEgmxDXI15AhuXmuFjI8uFSOhvTanG1TTV/lliN5THVnW5W2e3McdJ+HbdKbFoHY0kJht5Q2CNRNs3xs7w6Ax7ZB+JF//RwFi7z4S6crxY4Kfm8nc6RcWFbHFCTuigEeA7JFpjh/EQFln5AtoZnomESI51djj6+7ZhB5WN9rbud6uxh+Up+rx1cPmTuV0YwSpbvD/xc4MPOQ5KjyOQcwro+hkMtOKU2qOoi+q3JlUen5uOuonFKrCn2msRY67FvegTqsYzegAInZpGSEzen9ww3cjrXbzH4Bv7aR6wVBtnE0HF66+/3vgA+84AdPePip2Ts8G/ZFPiz4Cq2OVNP6cjIzHk9lQrs4fce6E6V9dPV0xR35DSHCtsqgwofxM/PE2CkTMYyO29xTbXLdXRsZ+GnXxLfaitWSQk0hsu2BlsAd/Jei89tDcv0Jh8PWdFZDOfj2m/A5ahF6azM9V+Rd3TjnJ79NYPpCEyhMTjRIOnE4jb29JqFMmOTzBz9jrQsF11CXiL9VP66o+nDugpcQjiNsMf+BVu2TyMN6VaAyCzOANkB4MvZXSkZb/fBjlTMuHGV5VkB43wQxA+U+e+c3KAUhJeJ4pCZ8p1Qu8/RYS1CAirAqvFJyM8RR/AF9YbIarSZ5eBVGKEFE2pYXc0NVgncwbwFbhMRPuYYAvaU+JYgleEQJ+ccUdCJuEFg8TuIdzZFVVcVakZCE6CElWGKCbyQ8g1F0bfMe8MFtgCeFJ5NaocF2IzAyHXhrkqCCSzCGVxBrk3RE+hQGn/AgXpgV36EimWdvnMR0gyM4zSAXedAxu2FLNLQKO6V09FJbrWdF2bd+NKgm3jEPZzZ5fahsxWVcAqdJCOI8ZAFkuCZB2ed3gPb/es+ATPEBJwtkKsiGIjgGDFinLL2HKZRCgE5UI6AnbZpzJtZGcZSHX2/EbLV0XexDfTnWDxKXHr+IbhiCTf2XOeGxJSNnd8bnDO+yfYtYcIKCfuZgiLECGQW1XqQxWFjEMIjjhTLnhZgjUD7IaaqxWK4XEdtBY6YWdHywjqgkNYE2C7jALEogCUTnZis4Vkqkidw2L7R1CKrIehowYxmYiJC3HGNhb54XewOyhORxLcSQWyPxKUaIP4aCVCFHZ04GdziFIOKkIJk3PZmifi1RH70DC9f2Ch0EajMZTfpXTaZGIS/DKJn1LWUHaW+GiQQ1LyOUXKvFcD5ZYdygSfu1/2rOIT3FxQcbxXmEFkOR0UrlszWheCdROWijsTsb+ZG+0zUNsQLPNlHTuFvaYon4Z2O2d4PMCJVG2QJ8SHLVtR2tt02yoDNURgZEUV1tRISikTmZOAFhcimVMDMP54tjRkD65lKy43jCIYsaxTUq84hoESlsQXDiVV5WBzohaSjNpZQ0EICPATx3YRTTuI3BZVOep3EjxGxOsWx9Vmih0jzDmJhNhTFbpirAYmt0SWYVsgnIGYvstA2ReRW/R15wMY7LNiQkKROb+Di+GVg6Qn/e8hKXlZ3fMyVDtopwFpcDMACjJQdZI3bo93EwA545kxsWhSyn1mqsc54CkJ9g1f9g95KXtTMhzVc4FXE7FINKxxEvB3meAwAAAXCePOVnFvCVomKUbCNoLJUKVCk7OsV4CBAADeqhAxAADJpROhVKx6d3CKFxJXlvI2QxQjaMFsCgAhCiHgoADBoAAkBNRVlKimRfDAiXOpgEy/hgB2ZBcVmj+ZmfHzoAMwoAr1RtMVcBP3oqb9dPRwAiEkkeM1IBNGqjAuChIgoAC9qgCwpGEzUc1nQ/8AUuh4SamiFTc/V0icOlTEqj+QkAX8qkMgqiNLJXEgRCKFZthJKPXYB3SZUbE2IBZIqnX5qkYKqkCqqgS8SZyzMpcWRfhVlTAhUYxhF6y6eeFICfMyqiddr/oGIaogyKpzTqoFEhNRWTEBV0Nk/FZXRQYanXBxxKpjVKpueZqjN6nkjaqJLqEO0gd1SXdHKBCkZxFioaqFpRATcKonfKoEzqqLp6o/k5pg0qDlAyFsSDZUDBoTVFKQ7DCEmGmIthAb26pF7aqI2KoyKapPiJrQs6rKFgVnPlaB7EOp4IHI1ge9uInwqapF+Ko3cqAKpqsDbqpdXKqLyao3WQPFfBFNsmU9Zki8jQOEf5QVz6oQ/LqHiKow7LpGFarR6apHh6qiT7q8wQYZ26iekhd20UlhtBbr0jNx8XfBKwsDW6oAsbsgcbsjYKogp6oyE6rx5Lqj7roTQFgd+2/yez4YtR14Hx+YIr6kI2QbMScKfAirCMaq09W7Duaqrx6rApW6OnarC8GqnoeSIPhwifMC2JgiDjSgUcWmhx+a+xVQEI66hfuqe72qsIG69qa6MCi7ZKKqYF66sLO7hH+yDf6l5r8Z14ppwz1WWwugykoq6NCrghOrgi2qB9C6+kerKdO7juKqZD26UEW7rb+oSKkkoKdaCxOIzUmUfeIw4o5jz4WbinW7D1qqehS62K27fAKqYG27cE+7mqC6b26mJigy1rNWAqapVZuk7sc262AAaKSrZK+rfxCryCS6oJW7Z5Kq9KKronG7qmeqe8egnMiJTqAVpc0pC4EVJBSP+s6rqgxhumJ/u1hiuy1eq1XBu68rquS9u/pku4I1qzh3RbiXWDRPEmt9trHFsCyXG0pJq+w+ur4UutXiu62QqvXqugJYu6rPuhRuukx1MmMUUFa1eeLLNbIpGvoJkZxyvAyMuzCNuw7tuuiquqyluwumq6nau2A/y58EsIFNwZyXgOKEJEo7EhYBqmQyuyxIukWOyoCYyjA/y/Squ20pq6B9y2O4R5M0OZdqUfDUMtxEOQ2rsTXQui7AuyKbu4XMy4RPuo8gq0R4utztu8YOoonVma2SeATnSLrTRA2wIgilvEdnqw6Iuy0eqzIburyKuwQwvEBPuzN3ov7RJ9rPf/FQBKQ6GYZh3TJOsKpshrsmqrvMdLsARstOprwgeLxSS8q687ENY5irQIQBBiOG+LpbJARwTwxyFctGOavoY7ppz8rkLrriUMsqQ7pr1qxpPYpswIGuDIzRcDHQfAwokErGIcyYzqzB6rvF/byX98xyS8zqMbpuzQWN7JnUH3L+AIjldrHp/ruOtrrfybxyYry036t5BKzr/rxaqKFEqmUIRhsUdHfNkTFihjUF8cuqg6qs+My1zbpI+6p6oarZJMrc87Q5+zfHMDDyg9UHn7SgWQreR8qpAqyz/Lv0VbxOELvDPqvqjaytgcWvZJhS9sLILEQwaBzRllwrostn/r/87h26WqW7x3LMkf7ahieg3Wqw8xYgoT8S73l2XkGqVx5byoq9M0KrrCe8XT2r5e6s5nu9NevMsIIBhxG2RkeFjWd6D7bE7knLxBvMXQnLJeasWXvMN0vLJ5yrRPeFpihTGv6SbHIX7oMF8Brc4KO7DA67BE3Lu/Wq/Zmqoh/cmLnRM001F/6CqT9oYXhtlVrLAEvL6XDNOSPKqu/bckK9eqIyg1x4uIgY7zMmZ9Pdu3nLyzvKso68xfLKMlXWvgVaySSRBu52iQ5sWeXcKdjcXI67XKzb9C29a3zKo+kzEYOUB6cXDUcEcHCdyiSsS/+qHT2rpcu87kC7TOy2ctKvQZpPOcBtKak2BvrnvWfKy8IAqy1arUACyyOErI1FaEeSB3mAUIHSlySp3RenrJrNzD/DvGQWytEAtLh4xgpCgrvGl2vJrTsGy6CQvfKnzYTCoFx4cj0jV5vRB4Aa3Z2j2+7Rqv4zvgLQ67CEWLhoZFptfZGt2lwSrCoc3MoWvfT2MytbZowWZ6E4DEAD7AO+2wJGzkPz18PKNpfJe/Un4Bna2nGG7T8Hq2DIvbpHTP4xHmLOC9JF2voB2yAgveNNgmztAt2ODmMiCq1wzbqCrAW145eZ5wVcjnSTDhGky0IXova/qJiB4KBWDCKrvEHyDOshUBACH5BAUAAAgALBoAHADGAMMAAAT/EMlJq7046811+Z9xHAZlgAUBdmzrvnAsz+5pGOr5qQVeTjpUCjUq0I7IpHLp+RwIuZtQBzVOhFBoUCtker/g7yEkLZBuaOFORRmjCGnyyS0P2+/4i3k37PGGf308B21qU4F8RFZ5jI00QWuIZk+GiCaGIGWGRUKEjp+gGDqaN39bfYpzKYU9hjiHrbGZPKG1jj1zVbi6lCFYVFsmT5Ijkio8gaU9Y7bNX3spKmOBg7JEx05dV3/TyKg6Y5wgcCFZq87oMuMpr+Z04yeSkJkfFNBvVCiQxJk47+kAO2CiQ2IPtWiahsxDYy+HmWOvrmVbEw2Tvh8BM054l8hiRSdw/8gl8jYMI4JxlJ5ETPSOWjxUVUR60phO1rw3IHr56YgQyzFm23LwiGdO1x9JirAoJEDTGS4yuiC1RIWT4z0U9jwCsqa1ki4+TUOtsxGSj7c3R9eReffOpNWk3MyqObtOHNiweR7uIAEHB4FpPHUiVXvv6KU9bAe7QeSmJZ2yI8KZxOtl10ePX+dKtDgITkPNFSOCG4jt8t+d5upRZnImIaajw9IK4unxRlbZKRpTfD1xyGKRSlesRkLYK8WVVHtTPaNctQTawY3CDbfD7829gKUMn/FS0VEoHEezQxbxbV9V0Wae1HrwYzLZ0vo8XhNn+4tKvOUlIzJs4MVMt1GTHf9SpfkWE0FoRYINJUzZ10F8HRVYiQ3ZaJJacWqI1hBROIGEW4d7DfYNhos4iEEsrnXy1ilLLZMUHys6dxJEuGVmDXLJRRMXHSLgA5SJFeDiV1kVWQXcNd0cudtIVNFyBXRVSJWNThESmVk4kEkTiHomSnUeNvrBdJVuHfnj0JJPNXTaYlDV1hg1XzFoA3JxoQLkSbkYWecN2Y2DCC/kfPeEnGadYE8Q+XA15k0pBSodmrn15Z6JFdX5Rlv7VNNfH5qwudJXfvWQ1VZqACYShGghGsJvppkSpTcOkqgcMnH66QSPexEmBUdUFjIViE+5Rt5cnIwhnmmJGBqrH8ZIqMz/JFJIuNtbgiD144wgdZVjJ9p+QyBCk23HnEG+TZkTPkVepRaVFbKjxqjFcfJnb6V9CE2PnM7xm2fDhZttcMAyOU9MhHXTJFomgEcPpPDoIwtgDmPyUhXDXCtBuOi4YYEvOMXFRYZfHWPjY24kKl+J8Uw8FDQQo4VNO6f6YWyCcWkXpLIAvbFxd8xmAQmdoCU7lGzl0cfKuYrCVhq1FoFDHUTjWIAGzs6UQY7U3rFXaXWAtOWqjRRpMao4F/oiImf4KemuxXjq1WAzUBVU4sUdDtJyhH3a6y5M5FVxm61d1ZtetmULapM0Gy8sIyj6WBIkNCJ+LGZznfECV1/Xwsj1/7kceVxXNwmh+g3VdI/lZChnz71ePziW86g3r2BKxbiqc5DhkHCCTV6o9nKTeCSjYJwXIJ0plHjJfJ4GuHLz4SecEtHGtOB16wLLDRsVwBkx49ra9ng5KgeOjNfP27FHGbqt7HqpjWN1c2DgCw9GqIFzuTrul+k1URreZBGK1XWLRHFUVb7nACtJBbRDKQRkkcSJThFsoZfNnBKZsWjmZ5H5C9vkIjSOMCIk/miOIbCWHDgw7RcaYQfv1HIUEUSFdDPqkXkOggcKOcEfEHvLzsywEJONMCzo+dUmyLAxY53FFMeSHxJSlJp9TMECGvxO6mpHE4PMS4T2GwqH+Gahq/+BQUiV0pvyFocANBRhZpACEsdk9Qqp/ckujSvQ/FoxRi1YSm59cCOYzCGVO7UtQVNQHR1jcyTqEEZslVFSNbJwNu/Bi4UJBFLnCFNEP30nG8pzViKV5ES1eciR21DK6fw4AahJj4xBWAyfimEKQKpwCbmR1RqXt47EKWOCpJTa1Liws1QCLGR0oYMSnjJLTA6sEhp7HxFzmQGy4AKKqGES2NpCSeJwrBqZCg6PuOAvADGzCcmEl8juVY1YlgMqgVjiTbSQjymCJA1Y+yYLyIgSgLmsVOdJg/3uYxlYkEuUk8jR2+SJhLItphc/IVVAZ4U9GZypcFw4lQvRJQ+CqtP/heP8J5N+Rb+7xEBROXmUnh6zzn1adJ7n5BbaXFkYHajDk2RAmrrmwSuVnBQG2wScoI60Jp5kJgYhHE93ynkw0EjipjH4ywJ9wg2esS+ldnoB9drFJHUJ8IdIhcHHEDqezQUtpFid55wCpzgb9dScJs3qBtC4L2tQK3ILq4EzOzYhpvUQhmpFqfXYiQXksShQZWiBV9j1LHta0g84yOsMvuo8yLmTjCe6B8lSIyIylWmgioUBLenY2CFaJa0V4AtIczULD1lVDlTM7IOk1CbOgE2jJBCICqnHDd2gcS5aiK1qF6sWjJJ0b99KaEQ4sNTmbeKBmnvXbh8Bnr+c0lt7/3yInmywgadIS3EgaycmlvuIVrBrJMbYScdak9rVpeUnZSsVcjrH3SM0iS49+yVdgtCEpp2Wa/EJFEXaW1B9bPM0asvvVFOroluRr2MSklQk+VsDzSS0cy05W0NDmz90Wbe0AzsSg63JKoOxT2F+8mVBInu3ywDms3yAmbE2fITCAoMnyiCYU/d7AQA2MmCzSCeLWzyaEYQOuBAi2FF12b/37mJfRZbjjmngJx5N8hoxA5gbOwqbzsI3j0t2L45YxDCE7I6HldzKCasHyQVnuQVbUlETt0XOG37PXOwwlWHnEtgzc+c66atbZjQlKXucYYxmi87CEMEQOz8iWveIyP9g4rC8CUPFlwauSj2p4hdDM1m0SplhTB9TRz9TDGnz+rRHwmFp3r6KTf7lK7NmyU5Pv1ZOsWMiWjFb6hdsil5FhrTgqvOkTFL0uyx8T3lrXd3QvWeSjHEP9lgSpUmTWaV/ILY6nqUlma7DcJdSjbtoVcdyGbVD0l4sgYzkG1Qfwns5whedOWhOnYX7o/MRdT/MnS5w/aAfaSMQeiz87o8OUc1X7AiDDChUHgpCxM2uJ+b6DYMFWivFnCMcB58zDVUeEW2TFRXDNVsd2HWW3cYylJwxaQxGBWzjmjUusEXZST5ttsuiTDLK72OXnxjLuHsG0SgUuqSBMbGNMxcsfwr/xMicW/vVe1t1OZ5sFFwGvbrB8uEnV3h03GrO5UKBK8eePk++TBPAPmPg5ux2OxuUJBWvbQXXBWJjUIFKWERhFb4bRh+kpSima7cd2ROy1BsuzDrWmcKArXEm8aIx79XFY0zpcWD1XRjxkI+85CdP+cpbPiADGIAABACAznc+AKDv/AACAIDNe570ABgAAAKges2DnvUDuLwBmVO0uU/6hKwv/eY5//oACGD0q9e8AF4v/NH/PvO8X73s7zdjwK3EkJgQvul3r/vNZ974mye974e/feq3fvkhLoqckaPuXNBj95z3/PB/j/rVbz/4oB9+6Usv/NeDP2KSDtNuaJV5/9Gv//fpt3rul32/J4CrN330t3n3twZMM0Wn4QMfEH/sp3ukt3u9Z32m13kAmH7HN3z3l1Gv4UlGIgWsx3nch3rx93noh34COH3sB3vLZx7JlQyDdxqhV32jl4InOH8bSH3eB3qZt3zr1BcycUzW9g8laIKp93mqx4Khd4EYWH2lt4BQ9W+UkyAScH3Hd4D014SmR3o5eIDZB4TbB3qXRyV4Zl8LE3INUn8V2H+al4O8t32ZV4FLGHx1qHyWR3ioYEhE1Q7/onYIUIDBp4Ff6HulV4EF+HonmHvXFwCXlyLmISXwoQlZ6H4lmIC913/oJ3waSIdNqIeVxzraVDds8v9AP2B82pd6rNd7oSd9ijiHnId8cziKOYYl7vIp11ZM7CAB3VeA8keBqdd6LsiBuxeKwTeK11Mlg3U3jjOIxYh62ed/HMiD1fd/rBh7lAclBnEdqUEQEEMBtAiALSh91pd6yfd6AuiJJkhrawcx/EAsXvULMoJ96Pd+JmiCqqeO8+d+OeiJ2hh5E1Uc5EA2N7EFK0MB7qeBrreE2ud6vSeG2Yd8iph6kweIHZcT4CAFvjQyzzQBw6h7AviEKOh5I6l7ddh6mBiEkIcajFQXIlOQtFF0/kMB3Cd/ZZh7D8l9PJh8wweL8xd5DoYhEfQoymWTeYh8TLiPFjiMxad5rJj/iP0okJsQcv4hE5A0Yb6IjsGIgccHi+rIfVApjLMIiXlneBMRaoE0lJCVhOgoevOXg63IimOofi/Yema5dnSUW2PGGzSDARK4hMcYhZ83gKYHlXNpjgCwdgJCaPsDGoxmDhggh0q5gqq3hMCHgaqIgCKZl0FnITuHJkl2KlrENr64iRwIkd7nhTg5lr84hk+nHCJQMcB1bUQoU3V2AdoXi2UJhP+HgKFHgCvIfU8XLeSmUtREVy6VAXTIgyUJhff4i7t5mWU5c49ZLd5BQGC1C6WgAaBYlxQZlseofda3mwl4mYvJcGVmEcWwWS1jQsMWgDpJkqtIffBnkoVYlqMX/5DvNlqz4XcHdV3aoAHJJ5dyeYNKOJ93aID0t5ueSWwKJlC3QhvNoxID6p1wKZ8GmIEbyIjzR4ZQyZPpSWziZRa1tS0dlWmQpZvXJ3pguJAI2KGIeZLVmHvhZjVEBx/c6G0etQH8OI0FKH0UuI+Z6Ip0OJGsR6KgUhgdkkOmQiWcoEQV4Io46JbjKZ5EGpaImYOltp0z+SLKtm0PYUIu8I/TyJUZuJ/Ah33mSH0PWXyGNjg6YhQCapvGYQYvsJ9j2H79aKQ36XouCHxxaZF2Nk6cVjIucV04t6LeOYFh2X2uuKbqp4HoCJ02mmWLZ1ggRFTswScx8HlUWoFG6pt3uP+fXeihxMefDKZPl3VI56I3ISWlGXB92LeS4pmPwciFGWiko3dmv0E9rXNP9gJKeaqm+Uil1+imZKiE+GmGdsZoICJn2uMfGicD+5mCp9eKiBiNxGeYEymKzzqEJeeY3GKJNKCtEiiot5p+/CiHFtirj7NcqEQaLtFYNLKcNECrIzmjtOqE85muXEphH6lWS/E7lnGiEYQYAZcECOqh/ziO5RmGOsiSj4RX8hRj/PJIAzEVOURVSqCUwZemjYirQJqP8Kqx+GpR4tVcuvQaPzMafNcOS7CrlZqT0DmBuPqg6+E1KiAABDUKFCMCIgBFB8UpdDemIRVtTJCPH2qBkYr/nxnYeUTWNLK6GlvhKMuUMAl7QgjCqDPQk7MYteqIfbyps8QkU3IzopRyKWUADPaDb8GkUke5tMK5oZ9YmPvYhb+TTYglmWvrMItGa/wDai2iNmEwjL5Xh/YZgNmYuGZrhefDTharEWkILIWmJhi3NO4DBtv6hP2HknbJii3LoywkDilLubK0lkLiQGCybr2BB3kIoysomNm3MY6iG4imZ3OQQuiTdnslSOQANO22A4yAlxA7jejqQG/1koPSQhRTE5DiXNxCVNiwQ4GYX0qbB2DomzVKfDp7YI3lc0P2CWC0i7EANdamFiRULa/lCGS7jq9Yu28mL9/SITCDScuQ/wfq9p86MlTiNXgGixS52QjxF4eIO4w+WwFUkDoi04CjEzzDRnO4MCib9TFgE6yx8DtXkiahUJEMSrEbgU4BA1GpZCMp+hGa9SeF07X9dJA4EgV/oUsWwkNVCwYmya5A6ECINQlctQvwKRQBExuysKQD7I1WpQp7BhyOF72AFwLQFHFQ0Axm+pOPC2g8FDLPBgh0Ukf4sxvdCQS3tCbwVQTxmCGBSEv0I8NBhg7c64FBQhJfRZrL4Vx1Khp0RjXQyjdzNlp0el4a9CI7o2PocK1mWzKlFWjQ4bIQBz4gEiVUU8EW5ErI1UQQuCphAwmjG8GOMIwt6w7BRgycOhgBp/9fKiQjkNMx4ABgqiQrDHJxbDINndKyNPG90IE7b0EdRoRjtdG6m7s6IVhCYnTIM4gbXuc3Crwd5zuDhSUx50E8znN32/Uk01unZeG/L4MdViVEpXEnvoAeadY0vtbIqLUcWIJq6rFqG1knvWBjzTM0MkVZY7a2zRUpcMYuqgZqF/wst6Y/vVybfCMv4gow6hZdCWdPDrLMJ5No/Ju+ydHDjIVlBCcXhlxatMNU12ZDUdFxETbA/VIr0CGDbUXBkqaRe9F8JQJI4UWn3DLR5DRUbucKk4sXGHZE5wUaVPKAZEM4DhEPoKOxZSaDLrKeJSrMszEapBRTMWOhOvJVQP3/ymEDYLkASlLSl7/wVk70VJVDX8xUECtnolLnTkq8LdlbRvc0pgdRYq3zKUtccQmtshv8YdjJzyFRJ0G2UIuMMvgHpvvmPJ0jKeVUtGbmR1jcLbKCTfcbYoVyub7szIX3KmzmCmZ1QQN7UpJyRrpcYvSWPz2cnI9EI1uTyNNRFRm1IJJSw34kdy+JFrdsT9TLc6MkMUjrSormfIAjWsFrGbu1eOaXX1DqE/xxWAp1eNLcEyMNZaaTbaRidOcgr2OFIfhCFCziA8K2UqOSPO2zZ0HFGfswkOijyUiFEkt8WAQCYHk9CwdV3QdZZbyY3GfrYKbJXWggOVdxd+wCR3bq/y6Yq906Ed9DY8LknS9e215CO1XpFRwY/BDA4BZY4snnksoYFTCzfRmmvVyWchzhHHBmnGZuMaYlhr+PjWK0EthLNkS0ssC6jL8vqVTCwBXQ/M4Wlr7uWGsXgXXZXVmKllNODAQp9t9JRs+PJeIyLiRtG63irDiqlDA+kdNs5oxhVZwhZoTFfUB9cRgApVTOU9NWHuAzB0edY4Sn9CZ4/NRiPTnBRqzbCKa64he9MDNprOMpZd8e07YttHyPc1fEzUFQ/cjyCFcfowx0Dk63eRUGpUUlUpTDy74cA1p/HlpDMiFViaehJI9LHaHvveiyNd+HPR4DRRRYGT0uV62WrhkEyEMPEJFYQODO7WPmoX4HU+N3n5EQDBYBACH5BAUAAAgALBoAHADGAMMAAAT/EMlJq7046811+Z8RUmJRgl2qrmzrvvBaEOBH3MVBGwY127+c7UaIGY/IpNJTMzWFTwrtCQRNUcusdpt9EquGa43QmzQPTzRN16Rx3/D4xdkMV8dDoM96rqnJM2g1coSFR1eCXjgzgGJQe1QHglN2VFWGmJkZTol5iJYnJ0UTU46WIDydlViarYRBIXmnfFB4Uop1H5NApnquv11CO1Q0V6U1BomVaJC0jLCiIp28dAXA1zCozowHJ2fdBGjTTc3PY2pW4TMiizlkwzbY8h2RdsUhu8htVYAzPoLo7vXC04jYmHkIK7ijc6zdPjKC2KmbRWHctm3SiEgq5ohjmYTY/0SwY+Tth7Evzsbdo+NjYr8xHWGmw8UPJDAT/SYGAVjNoDhtK6dU1MWmlEtpnHZwnGkuHFJrNjPBXCrsok9YeGDdIjPyTBgc9gbi1OF0H6uocNTdsIgPCo5xFldpW9dSTImTQtiAYNttWdVOo9Bu0XXSIZBEEV1a8VYs4CAzfKagCVVLFyeZokCxFLwEz+S9JtCh8/LMUclF8MqdSgakxGmBd/BaznGAM5KIVhJ9+RnLGEy9WCuvVJ1mrlU/oIMHPGYbBuWSsxiZ0tuNWtfgbsws6ip37zTDgY4tnP0jmdDmMpy0w/GFMXJKvAmu85QcEvs8n0v9JBsE0F1ESMGnHv9r6KUgUHXRsaeDKDERVp1YJtUGmRj3OWTXJBoRNhdiCUJVYAbiGUPWV22IR01j7MBFhG8iDJXVeiaiFEgYFimT3F1CiPThHGYFwotuT5kU011/HJOZH/aFENQQBSUHCzz6aBjcSBDtSIoaZIkBmJRl1bLKlo5Bw9oz5VAyHnyGkfgkHTXWsgZMHxUoCz8ixULYdG1AB1oyI4lDiTr2dcePLKPpORoovp3y4Z2KedMVgjxAwd+bduYTwglsLCdFfNdFB8Uq7MHzjkkzySWGnE5Kp40kwQFlHG0lmtOjEC2Regpw+4xDJZTH7XDdh6x2FOxYxx1KITKSIXdRRSlOQ6L/UkSZJ5+Wc25YZ6UeotoqWFNhaINuyj6jCnk9ZVtiQ52ehtg0rKZkJy2RZouWABbMsl2rfOrVGFVCJtfgWVIyxdAa7H4bDlvlRSZWvSAJ4LAFIt6TjySOmqmsa6PqdEVXO0gowS4r3VltViSn0d1AgV2Z8jUOCwAAvQqRmiyU5oWpT5bpYKlPkGtI4ZJag/J0R4mJgfqEnvIiQA42ALzs8sv1HmaUUXUcG6utYkH0mATIfkKaWhvFNrVuuLaa9D4sP+20yxZ46wdwdh3d46SWxNRMyOS+ba+J6TAG7tmwCPJLAS037XLLUUfZyZa5LUbqd6GSnB3Xt67xbyxqkHik/9dDf5C4j1tnEkAADg/gsumn1ytQyHgdXO6TalVSzJgt9GemTm3dwQ6OL/oRzspKmyW4JgAE0HQAA7yMetMDfB4bU6ybhtWzwMdwmlvc5EgMuMuh0/b2VmRiOvKjC5A86i3DXKtZbybmiLFYySEJh8f8IWtrNph6di8cnUdI+gIYnfJetraHKcQ3ilmPmwZ1lkKsJiPhwRtOGpK0srHONYVInwDR1zTDlQ5io6nRdV5DBmxEaVZ1O1UFrAYQqlRPC6Vz2MtGRzq1mc90UKuA26pgP1JlJiHkopq7LJeDtunpPpLyHBxaNrrkmY+GHWTe0wy4B7z9TUN3QUvepkeRFf+CJ39x+8EbDMBE48kQih0cgADTp7qSWWoSzZkPrNqQqdBxjQccydyr8sEF852RhuUrnhORF8DDNa1eKnkJUTyGnrz1KQorHMNXkjWbL/hvCTEEYAdpmLziOcx4pAPAAJoXM7jdSweMLBD/xhMPhUCHekyBDgxHOcVOKi+QtOykDdVnBgQZxEoxg01knGcKoPVHjkpUgiijSDonps90ozSe0zyIuJg56ZLA5Fov2JC4L0bGMse6gRICiDppTvFpayye8tTYTDYecGjZ3ESy+qI6UZUAftPSChLY+UnmUXNtxathAMv3ycMlLlPx9ABlLNApWyWMTuF6IQvO+ETUne//ieoMKDpHeTxz8pJyrUwoiBIRtVceairUINcRZHi6aBKwdFAMoChbZtEoVrMlIk1BMklRmud94xTtaFEMMhlIjQaUnehzouECykmXBSCnSpAgNGJpKyphb6gsNeNApYk8ftLUfFFkag1pCNVDjKxkYtnFZIoBA46GdYahNGNAnbY8Tx5OjbqcaVlhEB9PLUZrD9lLCV4AxeXlkp1xbSLzytfVAuJwbXttQfT8oL+k/KAocEOFCwonU6cJsIZ0HagfoelMP3pQr5GVLFH0dtaeOuhWLSicIJHXUQGGlqBqW6wMB0jF1LKAJH4F6nFiMdHTzRCAn/WjHznpT3TSFH0f//WtTl/JO4MwZGhaSuUGSmfL06XPpmId5WMZS0CLRle6Om0Kh1Kag2utJLM9S0E0cYjDKaqTdIAcqzSPl0nTnhe96c0KBHOyMXPo61M4SAFGlQrW06KThsvdpXnBCuAYDE0l+AMdMmUmxg4MdJlI/XA5Z2pXM0LThuatcDZIo4/f2ctsDcTAJ413PoJu0KVufevTaJlJFVtYJuR5E4T6kR9WcSC3LP0uQZNH4602mL9f9bER9uLN/uwnNDlK1ORkrEnlmlaUanQqR+VaONzeUMoxQA2M6xZkOsaYAucEcxnzu0ZoKlaDYXYimo3Ak1I0VCJsptZOLbDU0c6ZzmCdsf9WZyze/+55BWAp5lusu5Y+jIDLYgWt4aBoW8Q+GLQAfPSUl4Nl6wgtuCW8QKKbyGPj1hCvy7QxhBftaFGr4Gs0Oleq1KNATAOwrmqkptqaGU1WF9DWfObKrqnylUqMhGfiVHWZc/ld5ZXOcEnlJEd7i+wXUOiKC+HXKtlqgbqqc3mghm6DuRpKlpqu21Mm2ZGeIShhwEOocJahVwvZTDC3+3Cyfql44X2EVVnICUgDBUAIrdz9LvW+gdSgVglISPMRPN7r8iHrvgktfU7gxP30rqI1+msTb1qgF7dwiEAzaeG6YyX4RsAzWUpxCIu2qbIVK7dTXjtLA4c/LpdZzJP/zERRAnKdoCykeTe5Rp6nOVG+HBH7rtuYnYK3oh015BpvyE80etDpMFiSTiwYqmJSbKcn9iAh54rD8pWT08tMNNifXpnOpQE3SprNBHZLcaUKUpNS/GMTd1zruW8ASMKJ0eyWtCoJEH2uG825bgdJY48a/gXlqa7VgoYLZsg8jU90OF07uFWByrarhb88E1B6TD4A3XU3kIbnnzvAh3O22Eum6VFTr3oMqLdHKKs7JRz/TAKCONaGhqltC2jx3vecyruJfQpXy2HiF86WNRe22tP5a+f3/Ii7CTTQl3bRpYYYkMV+JvZfynvvd1M050gOYlCSE5k787SDRz+Ov9pg/3e6Pz0ZkgtClhcsNgbP1UmlJWeexVXi1Xa49X8sIC3stTHewDijIhLbZkgANXpwpXVjNU1sA4G3RjUnY2/rIDvv8wEzBlAzd20V5YC2FWoiGGDypyEHtmvBIV4mVkuNtoJwlWnrtHMz6HsN0iQUFDCfkgP95WWc5V+JVm3dN4Qc4DuGgTuUkih3kFShxYSyJVoA9F3vJoUbECkJ1y4dUhA08F3J54L9ZVGPtYRiuAHOQGRU0CkFtgpxmId6uId82Id++IfzgEThdDUNISqD1od2pzAb8ydGAk4+hQq44ykWA4ggtXL3VHcINxmAgTB5gnd9gCeUiAAYIh6o9E2JyP8o35FwXoArlhKKRJQZCBQtrfcjAqgefdVeuRAlW+aHJrE5PEQuvLGIfJNhxWE1phCKrwJBBWgM11Fgh5I5JyUfkSBReZgVZZMudSIOwUhlmCI7gxKJK2ILlGgZjoE0q0QyCNBya4Yjp/Efh8iHDaIzTIKLc7JQSkMZvIIMOBN0gFgHk/ATECIMGEMrSqNApKZmV5NSgNhQJYMV7wAhEhA5whUvgjUQyQCIw4iJlwF1BgdSVOcvzjBCEZI0esg+eHMtc9ILZdAvsLMr16UqURInJWkrjFMZY6INdXIFEXl3LVQcXcMkJ8CLaYCQm3dwd8BTtrMt8yFpEvOOYqiRO3H/J/YjIlSwPqwRgJLoDgwSUtVIgPHnkDVJHsNTif7BZgNWhZCkh+YhLEE3iEujTXaHGs/CShZJkkPIB1e5JjsRMhRZSf8ggEL2H8oWLsTilBAYMjyRItiBE7O4Wta0ITQBL66jmIb5f35mYCjCQpB4mYcYMOsFDiYAaNczj3rYlOgyML1CNmeDKy/BBtWljMyoE3H4KpQCk+yFiUFZT8kIY37GLWl5l/UoPVziUziCART0RXiyQOolhZ+hLnfgS4uwEYjpec5jECgjdsghk/9HGu4oN9u0BpOknRFpKfkDHKMZHWQxg70YGfUWmYdBJhjQLkOymD7ZG2/We99CLIOZ/4v045JjeQFs8UopNTuspCZ2aXhfuUP1OY/52WHxGTjb8HqWwTs8IJgxp3o4yDdUwiHmGQsX+j1NuWy5Flhs4X610ENOMn4cYwnUuQkXkTkU4hrDGQSY4nxAh5KE8h4N+XKVCRmSlJJEdIPjAV+qF1TfWB752BFxo11E+JJQKYAZgXc6eXlzeJoHYwrVZSM9OiEsAmR7Ai9h4wUIejQgUx7j9y7v4ggjKCQmoppz5FB/YkcEJ1XCo2zueJznkB6R4Ym8Uxj9IRENwXPPyaCDconYVRAkBWnXtDOwaEyEqkIXF5Cu1Xp5iSyXwAJlgyy8kSJFeZv+QHDDMjScGiGUdP9WkCoDLyFBSAQ69ySjxECNKnZZcrmZgbMi6ihVsOqiqEA2gKAXCUeVyHRxMiMZOMpyt9I7K+YWZggbfoIwLjYSghoJKaSk7NUJaeYlqxiVZlM/kwF2oVlq0SEXQiMjWyqHYpmqF2MOJVEn3yNlJlCdyjIsVScrenIE17GsP3ovdbgDUYNNkfWWSJkphuoZGdYNqpCr9NAlQXcpwAc8xiFdD6WdNhh/V+gs1eCvmEcwwgNowhcfIGowB5pNE6pZjzlVKIQ/EyGemOeI+YCuBQg4AlOuthGVQgOvRCEjuBo+nZEmgXMX0BF73bRauyBShKl31qRlrJSmoKEFudMTEeP/tJ3ZExFREsB0YXennX6ireFqrVrAs8hkNFN6C9Lpk6WwI/rqkrXQNhaUd0FBKUyKBACwHn1ZihuWNFiZP7QRe6lhG3c6h8FRUq7irL4wGBqiSI5DJUbkI5xYEpKAFq7pKf+4GXsQF5sKBnHgpS+7P7c4EaNhIbt4DRehr9QaCAe1L3KER4MLBz65j3vRr9GgHqlSYDoLDJIxtT8VkuJYDmuVCrzwoVzQFAN6WYikMNl5QpZkVZrAuJDYl2zGFImjipIrBzt6qT7AOwhCf3UofjJLd47Da55qn0fzubpDrp9qCDdJfU4AMbBLLoK5r7mSN0sQewObkcJ3rADrkeAS/7aYkIifu5VLkalnoLBUiCgh63thepmYAjtLmXds25AMFVHh4AoAMBX+Oh3LcI7WxWuI8BnCcRYXUmVaQyHDMH/fOXUPXEk48QsZA5+bUpd2Ah2cmJB1Ww1bwWJhEZdTJUzdQYby+bnggbCqSx79Sgu12bMV8ouywD+lmsI8FaPZWbuyW8Tri0xFUUyA8xTyQBYtKgHeGE7edG+5qCVCpD1MQhwMNCl32LxClJFqWgF4GIjiqwruEUQn6hBF0qeYaDnQipSPk4JMkrW98gnMO4HaibG0q74mooxaCxhpVS7qEMPmksd4CxQW07x0uQ9BQioMM7MwyTnWiQrt6yq+KP9MulG9C5y9IIlCItw4XtE5VkIfxBud07sdjGEP4QFUE5EkCsSeItyIpZEPEogU6FCvchJU/yGgPpS/Z+qWVGbCKvMiVqSU0xuaK+cgfvO5WkSOHDcXiImLylaqSpET9xOvezDHWltpN7MabNum/HCMqpQwn8EhqBuNCtegwFddoZPB+QtY/mI5WGhVDvmc7/DKijGtTeuyD/U1Sxx+70oKKukXZjglzBhosbs69zmzDXKeo7IazNyYQfKfW/Q7o9qeb3LDscHI4FPAnLxmw1BpksG5EdrOZweW5LaTmet6WJPB9HGO3lBWMjoQ1QFuU6y3u1qtJeMir1rUAF2L3rH/MWECnlXxr9CcNwvtkGPnS94hN9myFMwoLQEiKe2peS+Xsm3rW4w3DHjcYrpCC6xJyQCjH/mJEi2ra896hW8KmqAMYCjkGr74OpHIEJMQKaPCSAPLwPFhpFStDmmtoT4Wyxy2DkZhgf+slXirv5S9R7Ycr0xiScoxK3v2nsA7vo3Zs46Y1tmyDK5KoKz3yTBX2QchasT610LGwfz7i8IkHZBwvuQ5bpDI1pWau7YGvQULmeJCrgg8WL0kQetyji7G2g4VrWg6lEgBaNdIqvMabTZtilZ9imh1s2Ggst02ulq9M0D53dLowRqm00NqvHILFEUKWEERIGhpMcwbFD4zwVygg9a2aWnUZ6I50ZOr2hPusctcWc3RvT0Ytr6+i5/53RcuHMANpWxV5Cp6GcYnBBOzKR0U2Q6Lk8O6MLBlAtrZ+xRFMc6ImFJ9ZYVx+Sbrg1KsAsldiox9isHZygctsaICU3Ysht2hSDkhUtDC9RNI3dwL1NIXq789rjpvtJln6XEFuXgwxh30luS3ZpP3dB+vdAt4IMzbdNFUzgEU+hZSvFO37EI98uXBgBU7VL2YsnFAjOZJACoJNgGAnL6PFgEAIfkEBQAACAAsGgAcAMYAwwAABP8QyUmrvTjrzXUJAggKAnUUBZEWRtG9cCzPdG3HICCSACnoJBMLdWoZji2C4cZsOp9QTQDQCw0C2GngOv2FhKjCSYVqlQ9HAiHKbrvbIe2AOuBRsaEqMAAehtUHZCcsaUhvh4iJFyR1cT1dPgKNdUB5fBOBYWGDKGRkYpphiqOkTVlAXD5UcZJVIa+wJmqgg2Z/K6GhR6W8vRk8rwB1W3nDVzquJFmOQp9jK0qfRM4p0WW+2KUic1jJOzk+dVfjP1evFAYqnLfrz7id1oRr2fRskl3Dd1Q6Wzrk+3iIVRl2ScIsAmiGJAEFCmGuWZ0IaapH0ca4KT3G7fsB7lUXOsj/rPzg92WCGWm0HqqwpUkQRHVLKsrk4GPKAHMjxPU7xkpVI2IjWmFBFzGX0aIqlNyS9mnXzKcUsojIkQNIFWIcR2A9JaymJQpqpKXLNShpO4csW56JCbWiFi+TJMXRCLKHMDzA9gSFNQAMxBS2mBJJGDHsH8OerrWlt6PcxWQckeHl12+kQFf7eshKnIksEc8o3RWtxnaxNi1TCf4UxpoRj2GqWrPeuKwEpjKhjaw1w3IdvJVGyZQ2fYgrI9apRuqjA1uqR5DmHukpiCBQ4qJpDwOPlxI3LusInRJ3022kI2U2t3CZYxcowfLl53hxNNSkw78sULKwXjbToFrqdCJa/1IojMcGVa14gQxkPfEACVZ0aNXNRyQFYdItZWxiQCYIXadJWr4xZBQawxlYA3rgyBcHXhiJJMwktM0h310AfVQTOkkR+JkfDSXVgmgZ6mfYOk2ZaIMBlgCkjCTR2RFMRlvYlEdkkjXiBTh3EPVJYsLp9k41IuJyH4YihoWEC0bGsGJN5SlHH2roLQjXK6mAs0175fShHX467ujnHyeJmaFaZaX5AhbyTYVoRsfd05ibqMWonF2QMlKfBCGGMZZK7Ax2lCeelFVYGSUaWsE3mDUCpVDG3GQVZZHkQZldOCHIj565pCPINEqZISqZnwlpGC7imUrBB+XZVUmsS7Yin/+VKmbEjzns/TTlTVZMQdRSEkVUxGiaZLJhSyHiJ2g6Rxxg7ARaKLsKelRKG8yDlmEUpTIk4RWnhLZJkN2v+i2l47gBg6tGdoehaaolrq347pJdOCcOaxLaa16UrkICzFuyLBQKQpkCu0KgxLYUzYZHjPqOqW1acVOLUD4S3cMtWpocCLB1Nacq81G3Kcmj9fZheNQMOlpTDwkoRqmmZQXLKjvoNSXMLq/Wil7sXZltTo76fFSGvI2MYY7ClekQNEECV9QBRbAckB6RtAtfXgo+Umkk3Dj4mrsRm3ASyUh3plTBCW8SpNFHI8H0eMwiOh/NW3UTEntVAfRuUHhIi5n/hZgSERiQoHgM5rno8hjwr7os/lSJPUWMyowsyl2OXJjjPLvFUNPKc8dDqP2OuZqqFSRLvvq2ZUsWqI6NIRWsifMdc0EnTjHz7c2kHDoH4+Ayj6BjXbhfi8ytwe+Ia7LnJaaxui0WdFOrgrBjK1cxq1As+T0gXTnVHZiDhXbIgNJQqDyljl35YSFsQ9w8jvUHmfipRK5Dj6q6IiGcRCZzjhmIPxCFD45M6Qf+g0fvfhM+8QlJUIIKUPo+RpGURaQF7bNghXBWlZe5QgSoIAYXFsWoEcyGFTogCtt+lY5AjOVsaEtBZ/YUIl/5aD/F8teHFIONbomNdbByz1Xw1x5K/7CIZ6/xISrgJiEcjYETBWRJgI4SCCAlEHjBI1Hy0gCYOmbDKLZQ16nWZIfpfINJHvQHMp6VmbtsDQAzQBeJlOK5OnLCV8EDmlqIVyI06OiR2PCQQtpWAXPoTzaVaJJrAjKZflSmDlFQQh4/phZQjS04gEGDBfLTkoVEURFnO4Eu16iE9jVIMup5jUcwUokXfRAEijDCWN7oDt0wJVNlK9GnlLg0hSXTlcGCxi1rkpG8LYhfSaJg5qhDChcCj3DhIowdKyC00XUiXaQ4iPHAZU0JSK5+crESpfB3ikhUBF1FDN3apiiWg83yO8Lb0gIRARhbhk8dvnzZB6tnh4iVI/+ITznYM8J2PO3kZ6FSRKEkG5KITZVwP0s7QfvkQEMc7iEfJCHOmRLGyB/54YzJu45SiJSrQ6QLTH16p9AgONEJKeMYbzOSGAbIEA79Rprm/BJCgZOyN0gSJShJiwWGmTU7rYicJkqDYPpEhln+7TvmG6go2nCmYX3skc+E4FSEEhKprAsBHoPJQ9KXELdSc4ojDA9bz9CQUKBOnYTYKlC6Ykxk3nUCZNVQOpKXQB794RkECpzyEjkmMhXwoUvz5V7sBda7wnIlZgWR4QRVriFAQVdiaAck13FEb62VAjLMwmMzMNP8pC9QwgoTPcMC0iMNDBACIq7wGJIEtlngEX3/220GOGTQCsgjiYZ9yTxjudkOuDAJvjvaYeCqoa1aSbobYIkFymXAgAkmksWdQWxHdzw0njA7G1opel9wyw1Joz9oaWc1D6dKJoTHhQ353EHY+Kn9QkFstmXkJjiRKYTdoI6+O4gnvASRsFXjbN11cHrDt0R3eAid8X0BUD+Gn0eKsL4brqqIawDekwxsxeO9T2RxUwMidVShKAyZ4Iww40QiGGgo3gTweDPZRFoyXGXDKokz25QQF9m6RYPyl4blm8ryyIjy9a0RTYchpyqthFa+Mpa5ZFMR/uczunpzhzSkRxiINXhJKxstsfrEd9ZTzfwdnGU9S1DLlm3MKYhB/8pqa0STKhltWTUgugBNYw+30juZxfNyOQEDxJLKcMpN50qeMSAVUNoG7RiRycqCzYRykgOFsy1v3utOhazxz6eOwUPk/BLgMsWmvgkxEsGX0FaiZUePrHOu5WuL7DwxUDxN2si8uyFR6cfRWf0RYbqU4mWruHzE0vCcvYQwTTFPA7VASjYJbbpm+8jbTCj1R6Oxq/6A7y+c1sBOkSYiOYNuy8LpNrypnbTADAGAhktLkzFAWNEN8L0FM0uBBn6DvG7ZnSG7by+nSyDyfg2a25kIxZkg1R8BV6qXHp36MICEgnnpT1Imi7JHTgNW/gaaQI32aFhOXCL1FdjYSWKOiP9A8yYYVrh4VNm4OKwGhtucsMJbonfQloSiM2FcH1c1HuHodAxT8yXEvriYnGv1q/fmhHpFnAITbQFV/pvdwz2YScseb2sfLnxYT/qr7VPmWks86HdPCt2bQLzzcaqjQNq4EBwtsnLvaGBpHvwFpkEodeiS8gdsddW3Nc3CfppbeVxJ5CVv3ReiHEDgLrRvSzNTdGrz9ErwDenjXRgq3/vkwfkEOmoM96H1jtWimf0N0CCaM9Lzr4e/LQL+rsZb2Pip3NmE8G0g6K8FSJNhb24I9QP8g6XkR/8lzPQv/HTBBArrNp2zHP3V0TL9DsFCCsz4jwS4oHIJyCMclEGOT8v/Hg0btKM3f/5iUt+DaZd1YgETE8+nadDwf+B1WREhgDZgc1JXQiZmbjHRKYOWRG9GgUslgTTmeYXxH6UDegPVZE8GOrSGdOFhbiBIAz+lRO21VP6FdLGGJqp0cTHHf8iVHy9oZAbHSh1oZiqjGJQUbN9DDTolVD9IA0RiBFwiPoYHGHhFMMDyX34mVUzRhInkKX6XaVrnfKtUTRrWeyITCFwoAzkoFmdWbGSTd08mYU1FOC2IUDuShopGb5n1dv0GMEhxNn8BItyhI32GEHhoZwAXbmR2g4UzUkFTbPemSgH4gznygGInbefjSqByVbrSYepWXofoXQ31Ttv1JT9z/3eEMAawZW5TV1P4EXqhSG1s418tl4WkooqzwGQrQCLf1XJnUoLpgjI1VW2hFYsbsBIahgS82CvmpIsth1rGGI3SOI3UWI3WeI3jkQaI9mVClxLfwkrYaBKQNCxpsWAodxTYhi4zKDCfEWzhiClJYHGwFHfLpQuicnmpQz6kMokv6Ay9Ai4A40QmF3bMJTr6CBwARoXvGGXghoUZEmwekkAkc1UPNXRN944L8RcIqVOt1VqfWGsf9nTswI8gaEAnJVAIeXSfV4QvFA9RqDTnho211X7AAkkeRVULVo4E4nifQpIS6FmWx333lTp49VnlM4Y9iGMrg5GMlnfwl2dKw/9IA/hXYwhY74VGiYWNH0VhQOV684gmRuCR5whpYsI+MhkYasQhRXBCueIUJ4VOxiMY4bhTwSZCwQFysyhFvVFuOtd/uTCXfUds+DdhwhMTYMdK5phLDPGKClmN3oEwDrWHfpmFCkhfSEST1VdfmnKNA2J6uiCE7icuE+BOQ/cOQZh7vuKTwkdHDZVlzbVdJah8m0JrcERPqYZroWhOGdeV7uQl37NwVYhj0aZnJ2YU1SiHl8glXqYSBTaaYGJwwQV1fLYC1bhKIZJ4MohEgVFWo6lnVwhpyIlVMRmL9AZhX0Ii4AJcKZNv3WkuPOV6SXiH0gg4IhkaICMm/3VQhVH/RP93HepUBN8zCNN4hSapcJHUljOHV5hlmsGzZH5FLKppdYjlfWoDhtUAkSy0XtkUcCNiLoNzeboSjQgGGMgIWM4mXsoHFidBhJ9Cky1JRXjIFAGCOoQYR0mDhhfQWyW6hC9WeGIYixSGOgEElDSlIzw3Gm2kj1p2fc6HmxKYMqWJNIfmlzlYZrfEd/1GYA+Ed5oicPNHS7p4UwZjfwnWnCzXpV1mlw2oZ+WSX1xoY2wDhgVol2RlkE5alL/DYujJkmM5Fk34EiuYnkOKjm6aAVEHiWoXJvyZIX+6irsYVEu1YSIZOgmqn+ZZMEMoh23kI1cqfNeFovlHYfzGivsh/4o2aHpIA4eeeXB3Sne1mKbhuVpHR4heeiE8CaokaDS01apl13K36aIo9FAhNqLBWkcjo3BlEVXQOH2iU4NheFLzVKsXcoHD1XfXZpqdanVixVSDei4mc2Mpml7vmXsJN2xjMFY4Knmsap5v9YChsZjZVKkaAFuXx4bKBJDkokT4GKH7ZXhcqWTfxaGRWntsp2go56JudXaasksy5qoIUy7bxVTD5nY0sGCkdppIio6PKK2UFnIyil8qyWIvlK4yIFZDplOng3LOOp5FBwjNRkLsRRYlymrZygEEU6dQCiTEapGkMnszRUTFBw9CtlokWW4eEqaeZi7AKXkkwqJ0+P+SbMgCBuZ4vkans9pA7MSvBlKwF3J0p5mLjPc73FlxCFOa0VaCMca1BkFcp/Y3s3Qw7RdxBzcWrFmzMJCU/Nek79WwmHBEdvtY/iWJbYdSuxiEs/ghuCe1TmBpQppCmlREyRNLjFpkszlns7REkKpE4LdrZukEH/l/xaoLl1ul7ehghdAjjemc/6VaIZmFnsAGmKerX5enWAsWoWINRaC1VRRNDVpJUCqrL1oytcBWTAqqx7Nhg3s0GxUWdzWbU4e4OWWJPEgWfwuDotNofgKG/WWnewaFuptMoGq1c9SGJ8ljbgAAR+Ry76q4KtpmFltl/mUksBW2H1kilRhYyKf/G2fiU7OZV+X4TnO0qSPiabXbFn7LgEujtMV1cOazinb6vW2nRprYU1k7UucEeRB8A6T7kUtVmIrnnAmDlbebwdGLr8ZZAaHGuhvbuiQcA3zyV2D4a/84vhlWj+VkZi5nv2hEYf9re+1WvWxwupqWVlKVtOwLWQ2Jn2OrCE+WYx8yvrxSSygJqRMqEeALEf92HQaJnL4VvZX7nLLECxIcdJHbXKMDscrVUWoUZ0CsYuqYfA2apbrgEi0XuQrVFBwLu34wbNIkq6B7vYPIRmgEpRepa4MWg8Z6TgqRt7nyZ9antqUAAL93C/rZftYZuoB1nuBKCIrDep1cCz1MvqNy/65n9o0mCaMSMEWzRg+wVYkHNaHYJ8U7MqLb2sHLFY8qJY5vxmqWt2Jt9pliqYQ3219wC0UtFFD9NSjFixts+ci596sNtXuxK6Px6hlCmpF3GS635H1ZecypO5U7uGteFsvlq837qCWeKMqBmohZp6ihEMFgNhMhWgFjJmEo5qHuBp4gc0IcQos48p1fmWUud3zHe86lx6u9YL//Mq7IaHtsuZaPZpvSsC3jmHIp/HTfom0+io+0VFltJ7/rOSphyS0RN6IlmlzM9UqdsH2RVTRY3Hnwep4tOigt/AY/Rowjs4SYiZi0u6JN9ULeY5OzDDR9lahgAypDiU2zYCpfSf9NZ3WhRrPOk2qKbVQsXolhnTlJuxlkjISF8QzSIfO/CCxcUopcBfh8ztoZ3pPSXmiKcnjVfcJ4EL2PhSy/L4ZCgepoGEvS+gpa1uREuziLb6SFoZdZBkrVxwsqJJsm2NYjPo3RHBh2CZhdTNi1tiWW+Mlag7aDcSrSi/ZYt5h/8wVzG5i3HeIQPidCKzeAnf3Wm2aU09S4vay3CYFecmhSNaWmXToqOeJjxlpC22ImY9NiQ/xO1LzbIng0IrbF7veoHHyrbchTw2vZ5pd6UsaQ/jlghFiOlIt17gUN55pHnY1d42Og1VYsVdufhpdlj5y5uRgNagYI6zuWnUdlQPf/lKTIes0NYuKGZxO8x0Kr27HHsjNWi/T1h1YkCBWomczJG5xHo81dzk0q4HDmbVAUj4lpc6N2wDJrbFuIpadqy4SrQG51ndHUIRQXfVI41TL3rLLJyLsS45msUGjJLWE8cuCVpkPo4u18139t1MA7hZ/5IXL2265KwC6JZjmN0nWUR/HbtVLNyKAmXCNtvpJHv4Pt3GQJ4KCWbfodLIyUEBCN1MqLmKm5tOrKi3McrP/hYhwcOJyHVTGrbqCbyd8sfIRhYxIMR5gVcLZkDawHIC8sEXXe4Zgbrl+q5ptSilzMvflJ3dhsNC9Xv+2oUQi9msmq4KJ8Uys4LusHj7lin1+WFsvo18XGyMnXl25vWY8x6TF7uuFb8jlbZuDWOGfZy5JXDZwoU85XberhaOBIp5OYB4tI7BIdR98HRDzvGMECBdMWt0beE8PsEIWGUYPLnl7KOOJLth+iF+gVqJJ8DFDXrmgZCZlxvNp4in1gRzYfPO6cJQ/CSCpbcuN4BXWteayp6O5sNWY11u/NQOh1iO76Pgqd7Ov1ro1mQHMRAAA7"

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e315e6a2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_vue__ = __webpack_require__(1039);
function injectStyle (ssrContext) {
  __webpack_require__(1037)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e315e6a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e315e6a2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_964e346a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_vue__ = __webpack_require__(1364);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_964e346a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initStore = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable no-console */
/* eslint-disable no-undef */


var _lodash = __webpack_require__(52);

var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(76);

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_vue2['default'].use(_vuex2['default']);

var sessionKey = '.card-selector-data';

var mutations = {
    setItems: function setItems(state, items) {
        state.items = items;
    },
    setState: function setState(state, initState) {
        state = initState;
    },
    updateFilter: function updateFilter(state, filter) {
        var name = filter.name,
            isSelected = filter.isSelected;

        if (isSelected) {
            if (!state.filters.includes(name)) {
                state.filters.push(name);
            }
        } else {
            state.filters = state.filters.filter(function (x) {
                return x !== name;
            });
        }
        state.selectedIds = getters.selectedItems(state).map(function (x) {
            return x.id;
        });
    },
    itemSelectionChanged: function itemSelectionChanged(state, selection) {
        var id = selection.id,
            isSelected = selection.isSelected;

        if (isSelected) {
            if (!state.selectedIds.includes(id)) {
                state.selectedIds.push(id);
            }
        } else {
            state.selectedIds = state.selectedIds.filter(function (x) {
                return x !== id;
            });
        }
        state.selectedIds = state.selectedIds.filter(function (id) {
            return state.items.some(function (x) {
                return x.id === id;
            });
        });
    },
    initialiseStore: function initialiseStore(state) {
        if (sessionStorage.getItem(sessionKey)) {
            this.replaceState(_extends(state, JSON.parse(sessionStorage.getItem(sessionKey))));
        }
    }
};

var getters = {
    availableItems: function availableItems(state) {
        if (state.filters.length === 0) {
            return (0, _lodash.filter)(state.items, function (x) {
                return !(0, _lodash.isEmpty)(x.flags) && x.flags.includes('adults');
            });
        }
        var items = (0, _lodash.filter)(state.items, function (x) {
            if ((0, _lodash.isEmpty)(state.filters) || (0, _lodash.isEmpty)(x.flags)) {
                return true;
            }
            return (0, _lodash.every)(state.filters, function (filter) {
                return x.flags.includes(filter);
            });
        });

        return items;
    },
    selectedItems: function selectedItems(state) {
        var items = getters.availableItems(state);
        return (0, _lodash.filter)(items, function (x) {
            return (0, _lodash.includes)(state.selectedIds, x.id);
        });
    }
};

var actions = {
    addItem: function addItem(context, item) {
        context.commit('setItem', item);
    },
    updateFilter: function updateFilter(context, filter) {
        context.commit('setFilter', filter);
    }
};

var CardSelectorModule = {
    state: {
        items: [],
        selectedIds: [],
        filters: []
    },
    mutations: mutations,
    getters: getters,
    actions: actions
};
var initStore = exports.initStore = function initStore() {
    var store = new _vuex2['default'].Store(CardSelectorModule);
    store.subscribe(function (mutation, state) {
        sessionStorage.setItem(sessionKey, JSON.stringify(state));
    });
    return store;
};
exports['default'] = CardSelectorModule;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

// const STORAGE_KEY = 'grocery-list';

var itemsStorageFunc = exports.itemsStorageFunc = {
    fetch: function fetch(key) {
        var items = JSON.parse(window.localStorage.getItem(key)) || [];
        items.forEach(function (item, index) {
            item.id = index;
        });
        itemsStorageFunc.uid = items.length;
        return items;
    },
    save: function save(key, items) {
        window.localStorage.setItem(key, JSON.stringify(items));
    }
};

var itemsStorageFilters = exports.itemsStorageFilters = {
    all: function all(items) {
        return items;
    },
    active: function active(items) {
        return items.filter(function (item) {
            return !item.completed;
        });
    },
    completed: function completed(items) {
        return items.filter(function (item) {
            return item.completed;
        });
    }
};

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = objectFitPolyfill;
function objectFitPolyfill() {
    // eslint-disable-next-line
    if (!Modernizr.objectfit) {
        var images = document.querySelectorAll('.h-placeholder-image, .h-video-play');

        for (var x = 0; x < images.length; x++) {
            var image = images[x].querySelector('img');

            if (image != null && !images[x].classList.contains('h-compat-object-fit')) {
                var lazyImgUrl = image.getAttribute('data-lazy-img-loading');
                var imgUrl = image.getAttribute('src');

                images[x].classList.add('h-compat-object-fit');

                if (lazyImgUrl) {
                    images[x].style.backgroundImage = 'url(' + lazyImgUrl + ')';
                } else {
                    images[x].style.backgroundImage = 'url(' + imgUrl + ')';
                }
            }
        }
    }
}

/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _popper = __webpack_require__(63);

var _popper2 = _interopRequireDefault(_popper);

var _clickout = __webpack_require__(145);

var _clickout2 = _interopRequireDefault(_clickout);

var _listenOnRoot = __webpack_require__(146);

var _listenOnRoot2 = _interopRequireDefault(_listenOnRoot);

var _array = __webpack_require__(32);

var _utils = __webpack_require__(22);

var _dom = __webpack_require__(44);

var _keyCodes = __webpack_require__(149);

var _keyCodes2 = _interopRequireDefault(_keyCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Dropdown item CSS selectors
var ITEM_SELECTOR = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]';

// eslint-disable-next-line
var VISIBLE_EVENT_TYPES = {
    MOUSE: 'mouse',
    KEYBOARD: 'keyboard'
};

// Popper attachment positions
var AttachmentMap = {
    BOTTOM: 'bottom',
    // Dropdown left Align
    BOTTOMSTART: 'bottom-start',
    // Dropdown Right Align
    BOTTOMEND: 'bottom-end'
};

exports['default'] = {
    mixins: [_clickout2['default'], _listenOnRoot2['default']],
    props: {
        text: {
            // Button label
            type: String,
            'default': ''
        },
        dropup: {
            // place on top if possible
            type: Boolean,
            'default': false
        },
        position: {
            // Right align menu (default is left align)
            type: String,
            'default': AttachmentMap.BOTTOMSTART
        },
        offset: {
            // Number of pixels to offset menu, or a CSS unit value (i.e. 1px, 1rem, etc)
            type: [Number, String],
            'default': 0
        },
        popperOpts: {
            type: Object,
            'default': function _default() {}
        },
        disableMenuEvents: {
            type: Boolean,
            'default': false
        }
    },
    data: function data() {
        return {
            visible: false,
            inNavbar: null,
            visibleEventType: null
        };
    },
    created: function created() {
        // Create non-reactive property
        this._popper = null;
    },
    mounted: function mounted() {
        // To keep one dropdown opened on page
        this.listenOnRoot('bv::dropdown::shown', this.rootCloseListener);
        // Hide when clicked on links
        this.listenOnRoot('clicked::link', this.rootCloseListener);
        // Use new namespaced events
        this.listenOnRoot('bv::link::clicked', this.rootCloseListener);
    },

    /* istanbul ignore next: not easy to test */
    deactivated: function deactivated() {
        // In case we are inside a `<keep-alive>`
        this.visible = false;
        this.setTouchStart(false);
        this.removePopper();
    },

    /* istanbul ignore next: not easy to test */
    beforeDestroy: function beforeDestroy() {
        this.visible = false;
        this.setTouchStart(false);
        this.removePopper();
    },

    watch: {
        visible: function visible(state, old) {
            var _this = this;

            if (state === old) {
                // Avoid duplicated emits
                return;
            }

            // IE11 loves to flicker so we need to actually show the menu after popperJS has calculated the position
            if (state) {
                this.$refs.menu.classList.add('is-shown');

                this.showMenu();

                this.$nextTick(function () {
                    _this.$refs.menu.classList.add('is-visible');
                });
            } else {
                this.hideMenu();
                this.$refs.menu.classList.remove('is-shown');
                this.$refs.menu.classList.remove('is-visible');
            }
        },
        disabled: function disabled(state, old) {
            if (state !== old && state && this.visible) {
                // Hide dropdown if disabled changes to true
                this.visible = false;
            }
        }
    },
    computed: {
        toggler: function toggler() {
            return this.$refs.toggle.$el || this.$refs.toggle;
        }
    },
    methods: {
        showMenu: function showMenu() {
            if (this.disabled) {
                return;
            }
            // TODO: move emit show to visible watcher, to allow cancelling of show
            this.$emit('show');

            // Ensure other menus are closed
            this.emitOnRoot('bv::dropdown::shown', this);

            if (this.position !== 'none') {
                /* istnbul ignore next: can't test popper in JSDOM */
                if (typeof _popper2['default'] === 'undefined') {
                    (0, _utils.warn)('b-dropdown: Popper.js not found. Falling back to CSS positioning.');
                } else {
                    // for dropup with alignment we use the parent element as popper container
                    var element = this.$refs.toggle;

                    // Make sure we have a reference to an element, not a component!
                    element = element.$el || element;

                    // Instantiate popper.js
                    this.createPopper(element);
                }
            } else {
                var arrow = this.$refs.arrow;
                var toggle = this.$refs.toggle;

                this.$nextTick(function () {
                    var arrowPosition = arrow.getBoundingClientRect();
                    var togglePosition = toggle.getBoundingClientRect();

                    arrow.style.left = toggle.offsetLeft + togglePosition.width / 2 - arrowPosition.width / 2 + 'px';
                });
            }

            this.setTouchStart(true);
            this.$emit('shown');
            this.showMenuFocus();
        },
        showMenuFocus: function showMenuFocus() {
            var _this2 = this;

            // Only Focus on the first item if it's a keyboard event
            if (this.visibleEventType === VISIBLE_EVENT_TYPES.KEYBOARD) {
                this.$nextTick(function () {
                    _this2.$nextTick(_this2.focusFirstItem);
                });
            }
        },
        hideMenu: function hideMenu() {
            // TODO: move emit hide to visible watcher, to allow cancelling of hide
            this.$emit('hide');
            this.setTouchStart(false);
            this.emitOnRoot('bv::dropdown::hidden', this);
            this.$emit('hidden');
            this.removePopper();
        },
        createPopper: function createPopper(element) {
            this.removePopper();

            this._popper = new _popper2['default'](element, this.$refs.menu, this.getPopperConfig());
        },
        removePopper: function removePopper() {
            if (this._popper) {
                // Ensure popper event listeners are removed cleanly
                this._popper.destroy();
            }
            this._popper = null;
        },
        getPopperConfig: function getPopperConfig() {
            var placement = AttachmentMap.BOTTOMSTART;

            if (this.position === 'right') {
                // dropdown + right
                placement = AttachmentMap.BOTTOMEND;
            }

            if (this.position === 'center') {
                placement = AttachmentMap.BOTTOM;
            }

            var popperConfig = {
                placement: placement,
                modifiers: {
                    computeStyle: {
                        gpuAcceleration: false
                    },
                    flip: {
                        enabled: false
                    },
                    preventOverflow: {
                        enabled: true,
                        escapeWithReference: true
                    }
                }
            };

            return popperConfig;
        },
        setTouchStart: function setTouchStart(on) {
            var _this3 = this;

            /*
             * If this is a touch-enabled device we add extra
             * empty mouseover listeners to the body's immediate children;
             * only needed because of broken event delegation on iOS
             * https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
             */
            if ('ontouchstart' in document.documentElement) {
                var children = (0, _array.from)(document.body.children);
                children.forEach(function (el) {
                    if (on) {
                        (0, _dom.eventOn)('mouseover', _this3._noop);
                    } else {
                        (0, _dom.eventOff)('mouseover', _this3._noop);
                    }
                });
            }
        },

        /* istanbul ignore next: not easy to test */
        _noop: function _noop() {
            // Do nothing event handler (used in touchstart event handler)
        },
        rootCloseListener: function rootCloseListener(vm) {
            if (vm !== this) {
                this.visible = false;
            }
        },
        clickOutListener: function clickOutListener() {
            this.visible = false;
        },
        show: function show() {
            // Public method to show dropdown
            if (this.disabled) {
                return;
            }
            this.visible = true;
        },
        hide: function hide() {
            // Public method to hide dropdown
            if (this.disabled) {
                return;
            }

            this.visible = false;
        },
        toggle: function toggle(evt) {
            // Called only by a button that toggles the menu
            evt = evt || {};
            var type = evt.type;
            var key = evt.keyCode;

            // make sure to close the dropdown if we're on the toggle button
            if (type === 'keydown' && key === _keyCodes2['default'].ESC) {
                this.visible = false;
                return;
            }

            if (type !== 'click' && !(type === 'keydown' && (key === _keyCodes2['default'].ENTER || key === _keyCodes2['default'].SPACE || key === _keyCodes2['default'].DOWN || key === _keyCodes2['default'].UP))) {
                // We only toggle on Click, Enter, Space, Arrow Down and Arrow Up
                return;
            }

            if (typeof evt.keyCode === 'undefined' && this.visible === false) {
                this.visibleEventType = VISIBLE_EVENT_TYPES.MOUSE;
            } else {
                this.visibleEventType = VISIBLE_EVENT_TYPES.KEYBOARD;
            }

            evt.preventDefault();
            evt.stopPropagation();

            if (this.disabled) {
                this.visible = false;
                return;
            }

            // Toggle visibility
            this.visible = !this.visible;
        },
        click: function click(evt) {
            // Calle only in split button mode, for the split button
            if (this.disabled) {
                this.visible = false;
                return;
            }
            this.$emit('click', evt);
        },

        /* istanbul ignore next: not easy to test */
        onKeydown: function onKeydown(evt) {
            // Called from dropdown menu context
            var key = evt.keyCode;
            var target = evt.target;

            if (key === _keyCodes2['default'].ESC || key === _keyCodes2['default'].SPACE) {
                // Close on ESC or space
                this.onEsc(evt);
            }

            if (!this.disableMenuEvents) {
                if (key === _keyCodes2['default'].TAB) {
                    // Close on tab out
                    this.onTab(evt);
                } else if (key === _keyCodes2['default'].DOWN) {
                    // Down Arrow
                    this.focusNext(evt, false);
                } else if (key === _keyCodes2['default'].UP) {
                    // Up Arrow
                    this.focusNext(evt, true);
                }
            }

            // If menu events are disabled, still close the dropdown when tabbing off
            if (this.disableMenuEvents) {
                var firstItem = this.getFirstItem();
                var lastItem = this.getLastItem();

                if (target === firstItem && key === _keyCodes2['default'].TAB && evt.shiftKey) {
                    this.visible = false;
                }

                if (target === lastItem && key === _keyCodes2['default'].TAB && !(key === _keyCodes2['default'].TAB && evt.shiftKey)) {
                    this.visible = false;
                }
            }
        },

        /* istanbul ignore next: not easy to test */
        onEsc: function onEsc(evt) {
            if (this.visible) {
                this.visible = false;
                evt.preventDefault();
                evt.stopPropagation();

                // Return focus to original trigger button
                this.$nextTick(this.focusToggler);
            }
        },

        /* istanbul ignore next: not easy to test */
        onTab: function onTab(evt) {
            if (this.visible) {
                // TODO: Need special handler for dealing with form inputs
                // Tab, if in a text-like input, we should just focus next item in the dropdown
                // Note: Inputs are in a special .dropdown-form container
                this.visible = false;
            }
        },
        onFocusOut: function onFocusOut(evt) {
            if (this.$refs.menu.contains(evt.relatedTarget)) {
                return;
            }

            this.visible = false;
        },
        focusNext: function focusNext(evt, up) {
            var _this4 = this;

            if (!this.visible) {
                return;
            }

            evt.preventDefault();
            evt.stopPropagation();

            this.$nextTick(function () {
                var items = _this4.getItems();
                if (items.length < 1) {
                    return;
                }

                var index = items.indexOf(evt.target);

                if (up && index > 0) {
                    index--;
                } else if (!up && index < items.length - 1) {
                    index++;
                }

                if (index < 0) {
                    index = 0;
                }

                _this4.focusItem(index, items);
            });
        },
        focusItem: function focusItem(idx, items) {
            var el = items.find(function (el, i) {
                return i === idx;
            });

            if (el && (0, _dom.getAttr)(el, 'tabindex') !== '-1') {
                el.focus();
            }
        },
        getItems: function getItems() {
            // Get all items
            return this.filterVisible((0, _dom.selectAll)(ITEM_SELECTOR, this.$refs.menu));
        },
        getFirstItem: function getFirstItem() {
            // Get the first non-disabled item
            var item = this.getItems()[0];
            return item || null;
        },
        getLastItem: function getLastItem() {
            var items = this.getItems();
            // Get the first non-disabled item
            var item = items[items.length - 1];
            return item || null;
        },
        focusFirstItem: function focusFirstItem() {
            var item = this.getFirstItem();

            if (item) {
                this.focusItem(0, [item]);
            }
        },
        focusToggler: function focusToggler() {
            var toggler = this.toggler;

            if (toggler && toggler.focus) {
                toggler.focus();
            }
        },
        filterVisible: function filterVisible(els) {
            return (els || []).filter(_dom.isVisible);
        }
    }
};

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * Key Codes (events)
 */

exports["default"] = {
    SPACE: 32,
    ENTER: 13,
    ESC: 27,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    PAGEUP: 33,
    PAGEDOWN: 34,
    HOME: 36,
    END: 35,
    TAB: 9
};

/***/ }),
/* 150 */,
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
var Cookie = {
    cookieExist: function cookieExist(cookieName) {
        var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
        if (match) {
            //console.log(match[2]);
            return true;
        } else {
            //console.log('-- cookie does\'t exist ---');
            //prompt to enter search
            return false;
        }
    },
    getCookieValue: function getCookieValue(cookieName) {
        var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
        if (match) {
            //console.log(match[2]);
            return match[2];
        } else {
            //console.log('-- cookie does\'t exist ---');
            //prompt to enter search
            return false;
        }
    },
    setCookie: function setCookie(cookieName, zipcode) {
        document.cookie = cookieName + '=' + zipcode;
    },
    setPageCookie: function setPageCookie(cName, cValue, expDays) {
        expDays = expDays || 30; // set to 30 days as default
        var date = new Date();
        date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + "; " + expires + ";";
    },
    deleteCookie: function deleteCookie(cookieName) {
        document.cookie = cookieName + '=; ' + 'expires = Thu, 01 Jan 1970 00:00:00 GMT';
    },
    getAllCookies: function getAllCookies() {
        console.log(document.cookie);
    }
};

exports.Cookie = Cookie;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _triggerPageGoals2 = __webpack_require__(860);

var _triggerPageGoals3 = _interopRequireDefault(_triggerPageGoals2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable */


exports['default'] = {
    methods: {
        triggerPageGoals: function triggerPageGoals(dataTrackingString) {
            // this.goalsObj = JSON.parse(this.goals.replace(/'/g, '"'));
            var data = JSON.parse(dataTrackingString.replace(/'/g, '"'));

            var goalId = data.goalId,
                pageEvent = _objectWithoutProperties(data, ['goalId']);

            var goalObj = { 'goalId': goalId };
            var pageEventObj = pageEvent;

            _triggerPageGoals3['default'].post('/aha-service/analytics/TriggerGoal', goalObj);
            _triggerPageGoals3['default'].post('/aha-service/analytics/trackevent', pageEventObj);
        }
    }
};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    post: function post(itemId, text, datasourceId) {
        var endpoint = '/aha-service/Promo/RegisterEvent';

        // Add analytics call
        return (0, _axios2['default'])({
            method: 'post',
            url: endpoint,
            responseType: 'text',
            data: {
                'itemID': itemId,
                'text': text,
                'datasourceId': datasourceId
            }
        })['catch'](function (error) {
            // eslint-disable-next-line
            console.log('RegisterEvent error: ' + error);
        });
    }
};

/***/ }),
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = setSpeedBumpClassLinks;
function setSpeedBumpClassLinks(speedBumpSelector, linkId) {
    var speedBumps = document.querySelectorAll(speedBumpSelector);
    var speedBumpLink = document.querySelector(linkId);

    window.activeSpeedBumpLink = null;

    Array.from(speedBumps).forEach(function (element, index) {
        if (!element.hasAttribute('speed-bump-set')) {
            element.addEventListener('click', function (event) {
                event.preventDefault();
                window.activeSpeedBumpLink = event.currentTarget;
                speedBumpLink.setAttribute('href', event.currentTarget.getAttribute('href'));

                // Call the hidden Vue speedbump
                speedBumpLink.click();
            });

            element.setAttribute('speed-bump-set', '');
        }
    });
}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = initSelectAll;
function initSelectAll() {
    var selectAllCheckbox = document.querySelectorAll('[select-all]');

    var _loop = function _loop(i) {
        var parent = selectAllCheckbox[i].getAttribute('select-all');
        var checkboxGroup = document.querySelectorAll(parent + ' input[type=checkbox]');

        selectAllCheckbox[i].addEventListener('change', function (evt) {
            if (parent) {
                for (var j = 0; j < checkboxGroup.length; j++) {
                    checkboxGroup[j].checked = selectAllCheckbox[i].checked;
                }
            }
        });

        var _loop2 = function _loop2(j) {
            checkboxGroup[j].addEventListener('change', function (evt) {
                if (evt.target.checked === false) {
                    selectAllCheckbox[i].checked = checkboxGroup[j].checked;
                } else {
                    var checkedBoxes = document.querySelectorAll(parent + ' input[type=checkbox]:checked');
                    if (checkedBoxes.length === checkboxGroup.length - 1) {
                        selectAllCheckbox[i].checked = checkboxGroup[j].checked;
                    }
                }
            });
        };

        for (var j = 0; j < checkboxGroup.length; j++) {
            _loop2(j);
        }
    };

    for (var i = 0; i < selectAllCheckbox.length; i++) {
        _loop(i);
    }
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = customEventPolyfill;
function customEventPolyfill() {
    if (typeof window.CustomEvent === 'function') return false;

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
}

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icons = __webpack_require__(756);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
  name: "AppIcon",
  props: {
    name: String,
    size: String,
    color: String,
    title: String,
    desc: String
  },
  methods: {
    getPath: function getPath(props) {
      return _icons2["default"][props.name];
    },
    getStyleClasses: function getStyleClasses(props) {
      return [props.size, props.color].map(function (val) {
        return val && "is-" + val;
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//

/*
    TODO: 
        Add responsive options
        Add support for custom font load testing

*/
exports['default'] = {
    props: {
        targetLineCount: {
            'default': 1,
            type: Number
        },
        unit: {
            'default': 'rem',
            type: String
        },
        min: {
            'default': 1,
            type: Number
        },
        max: {
            'default': 2,
            type: Number
        }
    },
    data: function data() {
        return {
            observer: null
        };
    },

    methods: {
        calculate: function calculate() {
            var element = this.$el;

            element.style.display = 'inline-block';
            element.style.lineHeight = '1px';

            // Keep trying until it fits
            var fontSize = this.max;
            var stepSize = this.unit === 'px' ? 1 : 0.05;

            // element.style.fontSize = fontSize + this.unit;

            while (element.offsetHeight > this.targetLineCount && fontSize > this.min) {
                fontSize -= stepSize;
                // element.style.fontSize = fontSize + this.unit;
            }

            element.style.display = null;
            element.style.lineHeight = null;
        }
    },
    mounted: function mounted() {
        this.calculate();

        if ('MutationObserver' in window && this.observer === null) {
            // Create the observer (and what to do on changes...)
            this.observer = new MutationObserver(this.calculate);

            // Setup the observer
            this.observer.observe(this.$el, {
                subtree: true,
                characterData: true
            });
        }
    },

    beforeDestroy: function beforeDestroy() {
        // Clean up
        this.observer.disconnect();
    }
};

/***/ }),
/* 244 */,
/* 245 */,
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    data: function data() {
        return {
            searchText: '',
            locations: [],
            isVisible: false
        };
    },

    props: {
        showDropdown: {
            type: Boolean,
            'default': true
        },
        showModal: {
            type: Boolean,
            'default': true
        },
        translations: {
            type: Object,
            required: true,
            'default': {
                "search": "Search",
                "or": "or",
                "searchResults": "Search results for",
                "clearResults": "Clear Results",
                "offices": "Offices",
                "address": "Address",
                "city": "City",
                "state": "State",
                "zipCode": "Zip Code"
            }
        },
        searchEndpoint: {
            type: String,
            required: true
        },
        states: {
            type: Array,
            'default': function _default() {
                return [];
            }
        }
    },
    methods: {
        clearResults: function clearResults() {
            this.locations = [];
            this.searchText = '';
        },
        handleSubmit: function handleSubmit(response) {
            this.searchText = response.searchText;
            this.locations = response.locations;

            this.$refs.locationSelectorModal.show();
        },
        hideModal: function hideModal() {
            this.$refs.locationSelectorModal.hide();
        },
        onShown: function onShown() {
            this.isVisible = true;
        },
        onHidden: function onHidden() {
            this.isVisible = false;
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    data: function data() {
        return {
            zipcode: '',
            state: '',
            isLoading: false,
            zipcodeId: null,
            stateId: null
        };
    },
    mounted: function mounted() {
        this.zipcodeId = "zipcode_" + this._uid;
        this.stateId = "state_" + this._uid;
    },

    props: {
        isVisible: {
            type: Boolean,
            'default': false
        },
        onSubmit: {
            type: Function
        },
        translations: {
            type: Object,
            required: true
        },
        endpoint: {
            type: String,
            required: true
        },
        states: {
            type: Array
        }
    },
    computed: {
        validInput: function validInput() {
            return this.state !== '' || this.zipcode !== '';
        }
    },
    watch: {
        isVisible: function isVisible(val) {
            if (val) {
                this.focusRef(this.$refs.input1);
            }
        }
    },
    methods: {
        handleSubmit: function handleSubmit() {
            var _this = this;

            this.isLoading = true;

            _axios2['default'].post(this.$props.endpoint, {
                search: this.state || this.zipcode
            }).then(function (response) {
                _this.isLoading = false;

                // Pass the data back to the parent component
                _this.onSubmit({
                    searchText: _this.state || _this.zipcode,
                    locations: response.data
                });

                _this.state = '';
                _this.zipcode = '';
            })['catch'](function (error) {
                _this.isLoading = false;
            });
        },
        focusRef: function focusRef(ref) {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$nextTick(function () {
                    (typeof ref.$el !== 'undefined' ? ref.$el : ref).focus();
                });
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    props: {
        locations: {
            type: Array,
            requires: true,
            'default': []
        },
        translations: {
            type: Object,
            required: true
        }
    },
    computed: {
        validLocations: function validLocations() {
            return this.locations.filter(function (location) {
                return location.url !== '';
            });
        }
    }
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ahaUtils = __webpack_require__(70);

var _ahaLoadingSpinner = __webpack_require__(78);

var _ahaLoadingSpinner2 = _interopRequireDefault(_ahaLoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = (0, _ahaUtils.browserDetails)();
exports["default"] = {
  components: {
    ahaLoadingSpinner: _ahaLoadingSpinner2["default"]
  },
  data: function data() {
    return {
      searchText: "",
      foundlocations: this.locations,
      isVisible: false,
      searchClicked: 0,
      previousParams: {},
      invalidZipCode: false,
      isLoading: false
    };
  },

  props: {
    showDropdown: {
      type: Boolean,
      "default": true
    },
    showModal: {
      type: Boolean,
      "default": true
    },
    translations: {
      type: Object,
      required: true,
      "default": {
        title: "Find a Stroke Support Group Nearby",
        search: "Search",
        searchResults: "Search results for",
        clearResults: "Clear Results",
        name: "Group Name",
        city: "City",
        state: "State",
        radius: "Radius",
        zipCode: "Zip Code",
        zipCodePlaceholder: "Enter zip code",
        increaseRadius: "If your initial search does not pull up any groups, try increasing your mile radius.",
        noResultsFound: "No results found.",
        requiredFields: "All fields are required."
      }
    },
    searchEndpoint: {
      type: String,
      required: true
    },
    radius: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    image: {
      type: String
    },
    locations: {
      type: Array,
      "default": []
    },
    previousSearchedParams: {
      type: Object,
      "default": {
        zipcode: "",
        radius: "",
        audience: []
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var data = localStorage.getItem("_aha.last-group-finder");

      if (data) {
        var psoptions = JSON.parse(data);

        if (psoptions.locations && psoptions.locations.length > 0) {
          _this.searchClicked = 1;
          _this.searchText = psoptions.searchText;
          _this.foundlocations = psoptions.locations;
          _this.previousParams = {
            radius: psoptions.radius,
            zipcode: psoptions.searchText,
            audience: psoptions.audience
          };
          _this.previousSearchedParams = _this.previousParams;
        }
      }
    });
    if (this.$props.locations.length > 0) {
      this.$refs.clearResultsLink.focus();
    } else {
      this.$refs.strokeForm1.focusRef(this.$refs.strokeForm1.$refs.input1);
    }
  },

  methods: {
    parse_query_string: function parse_query_string(query) {
      var vars = query.split("&");
      var query_string = {};
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        if (typeof query_string[key] === "undefined") {
          query_string[key] = decodeURIComponent(value);
        } else if (typeof query_string[key] === "string") {
          var arr = [query_string[key], decodeURIComponent(value)];
          query_string[key] = arr;
        } else {
          query_string[key].push(decodeURIComponent(value));
        }
      }
      return query_string;
    },
    displayPreviousSearchedParams: function displayPreviousSearchedParams(name) {
      var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(window.location.href);
      if (results == null) {
        return null;
      } else {
        return decodeURI(results[1]) || 0;
      }
    },
    clearResults: function clearResults(event) {
      this.foundlocations = [];
      this.previousParams = {};
      this.searchText = "";
      this.$refs.strokeForm1.resetForm();
      this.searchClicked = 0;
      this.$refs.results.clearFilters();
    },
    handleSubmit: function handleSubmit(response) {
      var _this2 = this;

      //this.previousParams = {};
      if (response.locations && response.locations.length > 0) {
        var data = JSON.stringify({
          searchText: response.searchText,
          locations: response.locations,
          radius: response.radius
        });

        localStorage.setItem("_aha.last-group-finder", data);
      } else {
        localStorage.removeItem("_aha.last-group-finder");
      }
      this.searchText = response.searchText;
      this.foundlocations = response.locations;
      this.invalidZipCode = response.invalidZipCode;
      this.searchClicked += 1;
      this.isLoading = response.isLoading;
      this.$nextTick(function () {
        if (document.querySelector("fieldset[name='filter']")) {
          var filters = document.querySelector("fieldset[name='filter']");
          var headerTop = document.querySelector('.l-header__top').getBoundingClientRect().height;
          var headerUtility = document.querySelector('.l-header__utility').getBoundingClientRect().height;
          var filtersParent = filters.closest('.container');
          if (browser.mobile) {
            var _mobileBuffer = 50;
            window.scrollTo({ top: filtersParent.offsetTop - Math.round(headerTop + headerUtility + _mobileBuffer) });
          } else {
            window.scrollTo({ top: filtersParent.offsetTop - Math.round(headerTop + headerUtility) });
          }
          filters.focus();
          _this2.$refs.results.clearFilters();
        }
      });
    },
    hideModal: function hideModal() {
      this.$refs.strokeGroupSelectorModal.hide();
    },
    onShown: function onShown() {
      this.isVisible = true;
    },
    onHidden: function onHidden() {
      this.isVisible = false;
    }
  }
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  mixins: [_ahaId2['default']],
  props: {
    isLoading: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      uuid: null
    };
  },
  mounted: function mounted() {
    this.uuid = this.safeId('_AHA_loading_spinner_');
  }
}; //
//
//
//
//

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
  data: function data() {
    return {
      zipcode: "",
      rad: "",
      isLoading: false,
      zipcodeId: null,
      radiusId: null
    };
  },
  mounted: function mounted() {
    this.zipcodeId = "zipcode_" + this._uid;
    this.radiusId = "radius_" + this._uid;

    var data = localStorage.getItem('_aha.last-group-finder');

    if (data) {
      var psoptions = JSON.parse(data);

      this.zipcode = psoptions.searchText;
      this.rad = psoptions.radius;
    }
    // this.$refs.input1.focus();
  },

  props: {
    isVisible: {
      type: Boolean,
      "default": false
    },
    onSubmit: {
      type: Function
    },
    translations: {
      type: Object,
      required: true
    },
    endpoint: {
      type: String,
      required: true
    },
    radius: {
      type: Array
    }
  },
  computed: {
    validInput: function validInput() {
      return this.rad !== "" && this.zipcode !== "";
    }
  },
  watch: {
    isVisible: function isVisible(val) {
      if (val) {
        this.focusRef(this.$refs.input1);
      }
    }
  },

  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      localStorage.removeItem('_aha.last-group-finder');
      this.isLoading = true;
      this.$parent.$data.isLoading = true;

      _axios2["default"].post(this.$props.endpoint, {
        zipcode: this.zipcode,
        radius: this.rad
      }).then(function (response) {
        _this.isLoading = false;
        // Pass the data back to the parent component
        _this.onSubmit({
          searchText: _this.zipcode,
          locations: response.data,
          radius: _this.rad,
          isLoading: false
        });

        _this.rad = "";
        _this.zipcode = "";
      })["catch"](function (error) {
        _this.isLoading = false;
        _this.onSubmit({
          invalidZipCode: true,
          isLoading: false
        });
      });
    },
    focusRef: function focusRef(ref) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$nextTick(function () {
          (typeof ref.$el !== "undefined" ? ref.$el : ref).focus();
        });
      });
    },
    resetForm: function resetForm() {
      this.$refs.strokeForm.reset();
      this.$refs.input1.focus();
      localStorage.removeItem('_aha.last-group-finder');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  data: function data() {
    return {
      status: "",
      selected: [],
      currentSort: "",
      currentSortDir: "ascending",
      options: [{ text: "Survivors", value: "Survivors" }, { text: "Caregivers", value: "Caregivers" }, { text: "Medical Professionals", value: "Medical Professionals" }],
      mylocations: [],
      captionMessage: "h"
    };
  },

  props: {
    locations: {
      type: Array,
      requires: true,
      "default": []
    },
    translations: {
      type: Object,
      required: true
    },
    previousSearchedParams: {
      type: Object,
      required: true
    }
  },
  computed: {
    validLocations: function validLocations() {
      return this.locations.filter(function (location) {
        return location.url !== "";
      });
    },
    sortedName: function sortedName() {
      var _this = this;

      if (this.selected.length >= 1) {
        this.updateTableCaption();
        this.mylocations = this.locations.filter(function (location) {
          for (var i = 0; i < _this.selected.length; i++) {
            if (location.audience.indexOf(_this.selected[i]) > -1) {
              return location;
            }
          }
        });
      } else {
        this.mylocations = this.locations;
      }
      return this.mylocations.sort(function (a, b) {
        var modifier = 1;
        if (_this.currentSortDir === "descending") modifier = -1;
        if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
        if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
        return 0;
      });
    },
    audienceUrlQuery: function audienceUrlQuery() {
      var query = "";
      if (this.selected.length > 0) {
        query = "";
        this.selected.forEach(function (item, i) {
          query += "&audience=" + item;
        });
      }
      return query;
    }
  },
  methods: {
    sort: function sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "ascending" ? "descending" : "ascending";
      }
      this.currentSort = s;
      this.updateTableCaption();
    },
    updateTableCaption: function updateTableCaption() {
      this.captionMessage = " (Sorted by " + this.$data.selected + ": " + this.$data.currentSortDir + ")";
    },
    handleLink: function handleLink(url) {
      window.location.href = url + '?' + this.audienceUrlQuery;
    },
    locationClicked: function locationClicked(url) {

      var baseUrl = window.location.href;
      var search = {
        id: url,
        baseURI: baseUrl
      };
      localStorage.setItem("_aha.last-search", JSON.stringify(search));

      var data = localStorage.getItem('_aha.last-group-finder');
      if (data) {
        var sgoptions = JSON.parse(data);
        sgoptions.audience = this.selected;
        localStorage.setItem('_aha.last-group-finder', JSON.stringify(sgoptions));
      }
    },

    clearFilters: function clearFilters() {
      this.selected = [];
    }
  },
  created: function created() {
    if (this.previousSearchedParams.audience) {
      this.selected = this.previousSearchedParams.audience;
    }
  }
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsCookie = __webpack_require__(98);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        notificationId: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            visible: false,
            cookieString: 'aha-alert-cookie-' + this.notificationId
        };
    },

    computed: {
        isVisible: function isVisible() {
            return this.visible;
        }
    },
    mounted: function mounted() {
        var _this = this;

        var alertCookie = _jsCookie2['default'].get(this.cookieString);

        if (typeof alertCookie == 'undefined') {

            var alertEl = window.document.querySelector('.c-alert');
            if (alertEl) {
                alertEl.classList.add('c-alert__active');
            }

            this.visible = true;

            this.$nextTick(function () {
                _this.$parent.$refs[_this.notificationId].addEventListener('click', function () {
                    _jsCookie2['default'].set(_this.cookieString, true);
                    _this.visible = false;
                });
            });
        } else {}
    }
}; //
//
//
//
//
//

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    // These props are optional.  By default, this component is designed for use in the main site navigation (header), which is what the default values here create.  If you need this component elsewhere, profile for instnace, you NEED to supply data for each of these props; they can be anything, as long as they are unique (except for the modalRole prop, which should be a valid role attribute value).
    // Example (profile version): 
    // <aha-mobile-nav nav-id="profile-navigation" nav-ref="profileNav" modal-title="Profile Navigation">
    props: {
        navId: {
            type: String,
            required: false,
            'default': 'mobile-navigation'
        },
        navRef: {
            type: String,
            required: false,
            'default': 'mobileNav'
        },
        modalTitle: {
            type: String,
            required: false,
            'default': 'Mobile Navigation'
        },
        modalRole: {
            type: String,
            required: false,
            'default': null
        },
        modalContentRole: {
            type: String,
            required: false,
            'default': null
        },
        modalTag: {
            type: String,
            required: false,
            'default': 'div'
        },
        showOnDesktop: {
            type: Boolean,
            required: false,
            'default': false
        }
    },
    methods: {
        hideNav: function hideNav(evt) {
            if (this.$refs[this.navRef].is_show) {
                evt.stopPropagation();
                evt.stopImmediatePropagation();

                document.body.classList.remove('modal-open--mobile-nav');

                this.$refs[this.navRef].hide();
            }
        },
        onShown: function onShown(evt) {
            var element = document.querySelector('.js-mobile-nav-positioning');
            var position = element.getBoundingClientRect();

            document.body.classList.add('modal-open--mobile-nav');

            evt.target.style.top = position.top + position.height + 'px';
            evt.target.style.bottom = 0;
        },
        onHidden: function onHidden(evt) {
            document.body.classList.remove('modal-open--mobile-nav');
        }
    }
};

/***/ }),
/* 260 */,
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GoogleMap = __webpack_require__(846);

var _GoogleMap2 = _interopRequireDefault(_GoogleMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    data: function data() {
        return {};
    },

    components: {
        GoogleMap: _GoogleMap2['default']
    },
    props: {
        address: {
            type: String
        },
        zoom: {
            type: Number
        }
    }
}; //
//
//
//
//
//

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
  name: "GoogleMap",
  data: function data() {
    return {
      // default to montreal to keep it simple
      // change this to whatever makes sense
      center: { lat: 0, lng: 0 },
      markers: [],
      places: [],
      currentPlace: null
    };
  },

  props: {
    zoom: {
      type: Number
    },
    address: {
      type: String
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$refs.gmap.$mapPromise.then(function (map) {
      _this.searchLocation();
    });
  },


  methods: {

    geolocate: function geolocate() {
      var _this2 = this;

      navigator.geolocation.getCurrentPosition(function (position) {
        _this2.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    searchLocation: function searchLocation() {
      var _this3 = this;

      this.currentPlace = {};
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': this.address }, function (results, status) {
        if (status === 'OK') {
          _this3.currentPlace.lat = Number(results[0].geometry.location.lat());
          _this3.currentPlace.lng = Number(results[0].geometry.location.lng());
          var marker = {
            lat: _this3.currentPlace.lat,
            lng: _this3.currentPlace.lng
          };

          _this3.markers.push({ position: marker });
          _this3.places.push(_this3.currentPlace);
          _this3.center = marker;
        }
      });
    }

  }
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
  data: function data() {
    return {
      isVisible: false,
      btnColor: true,
      btnColor2: false
    };
  },

  props: {
    showModal: {
      type: Boolean,
      "default": true
    },
    interval: {
      type: Number,
      "default": 0
    },
    translations: {
      type: Object,
      required: true,
      "default": {
        btn: "Donate",
        url: "",
        title: "",
        description: "",
        image: null,
        video: null
      }
    },
    endpoint: {
      type: String,
      required: true
    },
    dataTracking: {
      type: String
    }
  },
  mounted: function mounted() {
    if (this.interval !== 0) {
      this.timeTrigger();
    } else if (this.$refs.ahaDonationPromoModal == null) {
      return false;
    } else {
      this.$refs.ahaDonationPromoModal.show();
    }

    if (this.translations.btnTheme == 'red') {
      this.btnColor = false;
    } else {
      this.btnColor = true;
    }

    if (this.translations.btnTheme2 == 'white') {
      this.btnColor2 = true;
    } else {
      this.btnColor2 = false;
    }

    console.log("Data Tracking");
    console.log(this.dataTracking);
  },

  methods: {
    handleClose: function handleClose() {
      this.$root.$emit("bv::hide::modal", "ahaDonationPromoModal");
      //this.$refs.ahaDonationPromoModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.ahaDonationPromoModal.hide();
    },
    onShown: function onShown() {
      this.isVisible = true;
    },
    onHidden: function onHidden() {
      this.isVisible = false;
    },
    timeTrigger: function timeTrigger() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.ahaDonationPromoModal.show();
      }, this.interval * 1000);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ahaCookie = __webpack_require__(151);

exports["default"] = {
  data: function data() {
    return {
      zipcode: "",
      isVisible: false
    };
  },

  props: {
    translations: {
      type: Object,
      required: true,
      "default": {
        cookie: "",
        btn: "Search",
        heading: "",
        subheading: ""
      }
    },
    zipCodeSelector: {
      type: String,
      "default": ""
    }
  },
  mounted: function mounted() {
    _ahaCookie.Cookie.getAllCookies(); //Show all cookies
    if (_ahaCookie.Cookie.cookieExist(this.translations.cookie) === false) {
      this.showModal();
    }
  },

  methods: {
    handleClose: function handleClose() {
      this.$root.$emit("bv::hide::modal", "ahaZipCodeModal");
    },
    hideModal: function hideModal() {
      this.$refs.ahaZipCodeModal.hide();
    },
    onShown: function onShown() {
      this.isVisible = true;
    },
    onHidden: function onHidden() {
      this.isVisible = false;
    },
    onSubmit: function onSubmit() {
      _ahaCookie.Cookie.setCookie(this.translations.cookie, this.zipcode);
      this.handleClose();
      console.log(this.zipcode);
      document.getElementById(this.zipCodeSelector).value = _ahaCookie.Cookie.getCookieValue(this.translations.cookie);
      document.getElementById(this.zipCodeSelector).scrollIntoView();
      document.getElementById(this.zipCodeSelector).focus();
    },
    showModal: function showModal() {
      this.$refs.ahaZipCodeModal.show();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
  data: function data() {
    return {
      datasessionTime: null,
      idleDuration: 2,
      _st: null
    };
  },

  props: {
    redirect: {
      type: String
    },
    endpoint: {
      type: String
    },
    sessionTime: {
      type: Number,
      "default": 2
    },
    translations: {
      type: Object,
      required: true,
      "default": {
        btnyeslabel: "Yes",
        btnnolabel: "No",
        heading: "",
        subheading: ""
      }
    }
  },
  created: function created() {
    this.datasessionTime = this.sessionTime;
  },
  mounted: function mounted() {
    var _this = this;

    this.startTimer(this.datasessionTime);
    // Modal States - shown or hidden
    this.$root.$on('bv::modal::shown', function (bvEvent) {
      if (bvEvent.vueTarget.$options.propsData.id === 'ahaTimeoutModal') {
        _this.onIdle("active");
      }
    });
  },

  methods: {
    handleClose: function handleClose() {
      this.$root.$emit("bv::hide::modal", "ahaTimeoutModal");
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      _axios2["default"].get(this.$props.endpoint).then(function (response) {
        if (response.status === 200) {
          _this2.onIdle("reset");
          _this2.datasessionTime = _this2.sessionTime;
          _this2.startTimer(_this2.datasessionTime);
          _this2.handleClose();
        }
      });
    },
    onCancel: function onCancel() {
      this.datasessionTime = 0;
      if (this.$props.redirect) {
        window.location.href = this.$props.redirect;
      } else {
        this.logOut();
      }
      this.handleClose();
    },
    onIdle: function onIdle(state) {
      var _this3 = this;

      state = state || "active"; // 'active' or 'reset'

      var _duration = Number(this.idleDuration) * 60 * 1000;
      // var _st = null;

      if (state === "reset") {
        clearTimeout(this._st);
        this._st = null;
      } else {
        this._st = setTimeout(function () {
          _this3.onCancel();
        }, _duration);
      }
    },
    logOut: function logOut() {
      if (typeof window.GenerateLogoutRequest !== 'undefined') {
        window.GenerateLogoutRequest();
      } else {
        return;
      }
    },
    showModal: function showModal() {
      this.$root.$emit("bv::show::modal", "ahaTimeoutModal");
    },

    startTimer: function startTimer(duration) {
      if (duration !== 0) {
        var vm = this;
        var _duration = duration * 60;
        var timer = _duration,
            minutes = void 0,
            seconds = void 0;

        var countdown = setInterval(function () {
          minutes = Number(timer / 60, 10);
          seconds = Number(timer % 60, 10);

          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;

          if (timer == 0) {
            timer = 0;
            //clearTimer(countdown);
            clearInterval(countdown);
            vm.showModal();
          } else {
            --timer;
          }
        }, 1000);
      } else {
        return;
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//

exports['default'] = {
    mixins: [_ahaId2['default']],
    provide: function provide() {
        return {
            EventBus: this.EventBus
        };
    },
    mounted: function mounted() {
        var _this = this;

        var vm = this;

        this.EventBus.$on('stepTrigger', function (index) {
            // no index
            if (typeof index === 'undefined') {
                _this.goToNextStep();
                // this.currentInput = null;
            } else {
                _this.goToStep(index);
                // this.currentInput = null;
            }
        });

        // A different input can be registered per step
        this.EventBus.$on('registerInput', function (stepKey, element) {
            _this.inputs[stepKey] = element;
            _this.currentInput = _this.inputs[stepKey];
        });
    },
    data: function data() {
        return {
            EventBus: new _vue2['default'](),
            step: 1,
            inputs: {},
            currentInput: null
        };
    },

    methods: {
        goToNextStep: function goToNextStep() {
            var currentInput = this.inputs[this.step];

            this.step++;

            // window.scrollTo({ top: 200, behavior: 'smooth' });
            // console.log(this.step, 'go to next step', 'scroll to')

            // const el = document.querySelector('#main-content form[novalidate="novalidate"]');
            // const stickyHeight = window.document.querySelector('.l-header__top.sticky').getBoundingClientRect().height;
            // const headerUtilityHeight = window.document.querySelector('.l-header__utility').getBoundingClientRect().height;
            // const topPos = el.getBoundingClientRect().top + window.scrollY;
            // window.scrollTo(0, topPos - (stickyHeight + headerUtilityHeight));

            // console.log('test out scroll to section', 0, topPos - (stickyHeight + headerUtilityHeight))

            this.EventBus.$emit('stepChanged', this.step, currentInput);
        },
        goToStep: function goToStep(index) {
            var currentInput = this.inputs[this.step];

            this.step = index;

            this.EventBus.$emit('stepChanged', this.step, currentInput);
        }
    }
};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

var _inputEventbus = __webpack_require__(45);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

var _closest = __webpack_require__(268);

var _closest2 = _interopRequireDefault(_closest);

var _pageGoals = __webpack_require__(152);

var _pageGoals2 = _interopRequireDefault(_pageGoals);

var _ahaLoadingSpinner = __webpack_require__(78);

var _ahaLoadingSpinner2 = _interopRequireDefault(_ahaLoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_pageGoals2['default']],
    inject: ['EventBus'],
    components: {
        "aha-loading-spinner": _ahaLoadingSpinner2['default']
    },
    props: {
        errorStepKey: {
            type: Number,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        emailUrl: {
            type: String,
            required: false
        },
        quizId: {
            type: String,
            required: false
        },
        quizName: {
            type: String,
            required: false
        }
    },
    data: function data() {
        return {
            loading: false,
            formData: {
                symptoms: []
            },
            response: {},
            activeStep: 1,
            id: 'component_uid_' + this._uid,
            checkedItems: []
        };
    },

    computed: {
        redList: function redList() {
            if (this.formData.symptoms) {

                return this.formData.symptoms.filter(function (element) {
                    return element.category === 'red';
                });
            }
        },
        yellowList: function yellowList() {
            if (this.formData.symptoms) {
                return this.formData.symptoms.filter(function (element) {
                    return element.category === 'yellow';
                });
            }
        },
        greenList: function greenList() {
            if (this.formData.symptoms) {
                return this.formData.symptoms.filter(function (element) {
                    return element.category === 'green';
                });
            }
        }
    },

    methods: {
        submitForm: function submitForm(evt) {
            var _this = this;

            evt.preventDefault();
            this.loading = true;
            console.log('Submit form');
            (0, _axios2['default'])({
                method: 'POST',
                url: this.url,
                responseType: 'json',
                data: this.formData
            }).then(function (response) {
                console.log('response: ', response);
                if (_this.$attrs && _this.$attrs['data-quiz-type'] && _this.$attrs['data-quiz-type'] === 'symptom-checker' && response.status == 200) {
                    // bypass and go directly to last slide
                    _this.EventBus.$emit('stepTrigger');
                } else {
                    if (response.data === null) {
                        _this.EventBus.$emit('stepTrigger', _this.errorStepKey);
                    } else {
                        _this.response = response.data;
                        _this.EventBus.$emit('stepTrigger');
                    }
                }

                _this.loading = false;
            })['catch'](function (error) {
                console.log('Error: ', error);
                var step = _this.activeStep;
                _this.EventBus.$emit('stepTrigger', _this.errorStepKey);
                _this.activeStep = step;

                _this.loading = false;
            });
        },
        quizSubmitForm: function quizSubmitForm(evt) {
            var _this2 = this;

            evt.preventDefault();
            this.loading = true;
            (0, _axios2['default'])({
                method: 'POST',
                url: this.url,
                responseType: 'json',
                data: this.formData
            }).then(function (response) {
                if (response.data === null) {
                    _this2.EventBus.$emit('stepTrigger', _this2.errorStepKey);
                    // this.EventBus.$emit('stepTrigger');
                } else {
                    _this2.response = response.data;
                    _this2.formData = {};
                    _this2.formData.QuizData = _this2.response.QuizData;
                    _this2.response.QuizData = JSON.parse(response.data.QuizData);
                    _this2.formData.TotalScore = _this2.response.Summary.TotalScore;
                    _this2.formData.TotalScoreHash = _this2.response.Summary.TotalScoreHash;
                    if (_this2.response.ResponseTitle === null && _this2.response.ResponseText === null) {
                        _this2.EventBus.$emit('stepTrigger', _this2.activeStep + 2);
                    } else {
                        _this2.EventBus.$emit('stepTrigger');
                    }
                }
                _this2.loading = false;
            })['catch'](function (error) {
                console.log(error);
                var step = _this2.activeStep;
                _this2.EventBus.$emit('stepTrigger', _this2.errorStepKey);
                // this.EventBus.$emit('stepTrigger');
                _this2.activeStep = step;
                _this2.loading = false;
            });
        },
        resetForm: function resetForm(evt) {
            // this.formData = {};

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(this.formData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var k = _step.value;

                    console.log(k, Array.isArray(this.formData[k]));
                    if (Array.isArray(this.formData[k])) {
                        this.formData[k] = [];
                    } else {
                        this.formData[k] = '';
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator['return']) {
                        _iterator['return']();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.EventBus.$emit('stepTrigger', 1);
            _inputEventbus2['default'].$emit('inputCleared');
        },
        checkParent: function checkParent(el) {
            var root = '#' + this.id;
            var parent = (0, _closest2['default'])(el, root);
            if (this.$el === parent) {
                return true;
            } else {
                return false;
            }
        },
        clearCheckboxes: function clearCheckboxes() {
            var checkboxes = document.querySelectorAll('input[type=checkbox]:checked');
            for (var i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = false;
            }
        },
        clearAnswers: function clearAnswers() {
            this.clearCheckboxes();
            this.formData.AnswerId = null;
        },
        getCheckedItems: function getCheckedItems(id) {
            var checked = [];
            var checkboxes = document.querySelectorAll('input[type=checkbox]:checked');

            for (var i = 0; i < checkboxes.length; i++) {
                checked.push(checkboxes[i].value);
            }

            if (checked.length > 0) {
                this.formData[id] = checked;
            } else {
                this.formData[id] = false;
            }
        },
        sendEmail: function sendEmail(evt) {
            var _this3 = this;

            // prevent the form submission
            // don't need to submit the form
            // need to keep this modal open for the screen reader and not close with a timer
            evt.target.onsubmit = function (evt) {
                evt.preventDefault();
                // console.log('onsubmit from email modal');
            };

            // Goal Triggering
            var submitBtn = evt.target.querySelector('[type="submit"]');
            if (submitBtn && submitBtn.dataset.tracking) {
                var goalData = submitBtn.dataset.tracking;
                this.triggerPageGoals(goalData);
            }
            // End Goal Triggering

            var emailData = {};

            emailData['QuizId'] = this.response.QuizId;
            emailData['EmailTo'] = this.$el.querySelector('#email').value;
            emailData['EmailBody'] = this.$el.querySelector('#print-section').innerHTML;
            (0, _axios2['default'])({
                method: 'POST',
                url: this.emailUrl,
                data: emailData,
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                _this3.loading = false;
            })['catch'](function (error) {
                console.log(error);
            });

            // Close email modal
            setTimeout(function () {
                var slider = _this3.$el.querySelector('.discussion-email-modal .slide-inline');
                slider.classList.add('slide-left');
                // reset
                emailData = {};
                _this3.$el.querySelector('#email').value = '';
                // Close the modal with timeout
                /*setTimeout(() => {
                    this.$root.$emit('bv::hide::modal', 'email-results-modal');
                }, 900);*/
            }, 500);
        }
    }, mounted: function mounted() {
        if (this.quizId) {
            this.formData.quizId = this.quizId;
        }

        if (this.quizName) {
            this.formData.quizName = this.quizName;
        }

        if (this.$attrs && this.$attrs['data-quiz-type'] && this.$attrs['data-quiz-type'] === 'symptom-checker') {
            // if needed
        }
        document.body.onclick = function (e) {
            if (window.event) {
                e = event.srcElement;
            } else {
                e = e.target;
            }
            if (e.className && e.className.indexOf('buttondisable') != -1) {
                if (this.submitted = true) {
                    e.setAttribute('disabled', 'disabled');
                } else if (this.submitted = false) {
                    e.removeAttribute('disabled');
                }
            }
        };
    },
    created: function created() {
        var _this4 = this;

        _inputEventbus2['default'].$on('hiddenInputInit', function (value, id, el) {
            _this4.$nextTick(function () {
                var isParent = _this4.checkParent(el);
                if (isParent) {
                    _this4.formData[id] = value;
                }
            });
        });
        _inputEventbus2['default'].$on('inputInit', function (value, id, el) {
            _this4.$nextTick(function () {
                var isParent = _this4.checkParent(el);
                if (isParent) {
                    _this4.formData[id] = value;
                }
            });
        });
        _inputEventbus2['default'].$on('inputUpdated', function (value, id, el, category) {
            console.log('category: ', category);
            if (_this4.formData[id] !== value) {
                var isParent = _this4.checkParent(el);
                // console.log('Is Parent? ', isParent); true
                if (isParent) {
                    if (el.type === 'checkbox') {
                        _this4.getCheckedItems(id);
                    } else if (category != undefined) {
                        // For Quiz with category, icon, question, answer
                        var obj = {};
                        obj.id = id;
                        obj.value = value;
                        obj.icon = el.dataset.icon;
                        obj.question = el.dataset.question;
                        obj.category = category;

                        var arr = _this4.formData.symptoms;
                        if (_this4.formData.symptoms.length === 0) {
                            _this4.formData.symptoms.push(obj);
                        } else {
                            var elementExist = arr.find(function (element) {
                                return element['id'] === id;
                            });
                            if (elementExist !== undefined) {
                                var i = arr.indexOf(elementExist);
                                //arr[i] = obj;
                                _this4.$set(arr, i, obj);
                            } else {
                                arr.push(obj);
                            }
                        }
                    } else {
                        _this4.formData[id] = value;
                        // console.log('Form Data')
                        // console.log(this.formData);
                    }
                    _this4.$forceUpdate();
                }
            }
        });
        this.EventBus.$on('stepChanged', function (step) {
            _this4.activeStep = step;
            _this4.clearAnswers();
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Polyfill for window.Element.closest()
// get nearest parent element matching selector
var closest = function closest(el, selector) {
    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

    while (el) {
        if (matchesSelector.call(el, selector)) {
            break;
        }
        el = el.parentElement;
    }
    return el;
};

exports["default"] = closest;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectFit = __webpack_require__(115);

var _objectFit2 = _interopRequireDefault(_objectFit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    inject: ['EventBus'],
    data: function data() {
        return {
            step: 1
        };
    },
    mounted: function mounted() {
        var vm = this;

        window.scrollTo({ top: 0, behavior: 'smooth' });

        this.EventBus.$on('stepChanged', function (step, inputs) {
            var _this = this;

            if (vm.$el.nodeName !== '#comment' && step !== vm.stepKey) {
                vm.$el.classList.add('fade-leave-active', 'fade-leave-to');
            }

            setTimeout(function () {
                vm.step = step;
                _this.$nextTick(function () {
                    if (vm.$el.nodeName !== '#comment' && step === vm.stepKey) {
                        vm.$el.classList.add('fade-enter', 'fade-enter-active');
                        vm.$el.classList.remove('fade-enter');
                        vm.EventBus.$emit('stepShown', inputs);
                        setTimeout(function () {
                            (0, _objectFit2['default'])();
                        }, 150);
                    } else {
                        vm.$el.classList.remove('fade-leave-to');
                    }
                });
            }, 10);
        });
    },

    props: {
        stepKey: {
            type: Number,
            required: true
        }
    }
}; //
//
//
//
//
//

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default']],
    data: function data() {
        return {
            searchQuery: '',
            inputId: this.safeId() + '__search',
            modalId: this.safeId() + '__modal'
        };
    },

    props: {
        formAction: {
            type: String,
            required: true
        },
        searchLabel: {
            type: String,
            'default': 'Search'
        },
        placeholderText: {
            type: String,
            'default': 'ex: Heart Attack Symptoms'
        },
        inputName: {
            type: String,
            'default': 'query'
        },
        searchIcon: {
            type: String,
            'default': '/assets/glyphs/search.svg'
        },
        searchButton: {
            type: String,
            'default': 'Search'
        },
        queryDelimiter: {
            type: String,
            'default': '?'
        }
    },
    methods: {
        hideModal: function hideModal() {
            this.$refs.locationSelectorModal.hide();
        },
        onShown: function onShown() {
            var _this = this;

            this.$nextTick(function () {
                _this.$nextTick(function () {
                    _this.$refs.search.focus();
                });
            });
        },
        search: function search() {
            var url = this.formAction;
            if (this.searchQuery !== '') {
                url += this.queryDelimiter + this.inputName + '=' + this.searchQuery;
            }
            window.location.href = url;
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//


exports['default'] = {
    data: function data() {
        return {
            searchPageUri: null
        };
    },

    props: {
        linkText: {
            type: String,
            'default': 'Back to search'
        },
        storageKey: {
            type: String,
            'default': '_aha.last-search'
        },
        linkClass: {
            type: String,
            'default': ''
        },
        linkOnly: {
            type: Boolean,
            'default': false
        }
    },
    computed: {
        isVisible: function isVisible() {
            return !!this.searchPageUri;
        }
    },
    mounted: function mounted() {
        var store = localStorage.getItem(this.storageKey);
        if (!store) return;
        var lastSearch = JSON.parse(store);
        if (lastSearch && window.location.href.indexOf(lastSearch.id) >= 0) {
            this.searchPageUri = lastSearch.baseURI;
        }

        this.componentStyles = 'container container-fluid back-to-search-container';
        if (this.linkOnly) this.componentStyles = '';

        this.linkStyles = 'c-cta c-cta--icon h-theme--red c-cta--arrow-reverse c-cta--back-to-search';
        if (this.linkClass !== '' && this.linkClass !== undefined) this.linkStyles = this.linkStyles + " " + this.linkClass;
    }
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _registerEvent = __webpack_require__(153);

var _registerEvent2 = _interopRequireDefault(_registerEvent);

var _pageGoals = __webpack_require__(152);

var _pageGoals2 = _interopRequireDefault(_pageGoals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default'], _pageGoals2['default']],
    inject: ['EventBus'],
    props: {
        translations: {
            type: Object,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        eventText: {
            type: String,
            'default': ""
        },
        eventItemId: {
            type: String
        },
        goals: {
            type: String
        }
    },
    data: function data() {
        return {
            isInvalid: false,
            fieldValue: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.EventBus.$emit('registerInput', _this.config.currentKey, _this.$refs.singleFieldInput);
        });
    },

    methods: {
        submitForm: function submitForm(evt) {
            var value = parseInt(this.fieldValue, 10);

            evt.preventDefault();

            if (isNaN(value) || typeof value !== 'number' || value < this.config.minValue || value > this.config.maxValue) {
                this.isInvalid = true;
            } else {
                var lowerBound = this.config.targetValue.length ? this.config.targetValue[0] : this.config.targetValue;
                var upperBound = this.config.targetValue.length ? this.config.targetValue[1] : this.config.targetValue;

                this.isInvalid = false;

                // Trigger Page Goals (mixins - pageGoalsMixin)
                this.triggerPageGoals(this.goals);

                // Send the analytics request
                _registerEvent2['default'].post(this.$props.eventItemId, this.$props.eventText + ' $$Response$$ ' + value);

                // If we have an input saved for this step, use it's values to determine the step
                if (value > upperBound) {
                    this.EventBus.$emit('stepTrigger', this.config.greaterKey);
                } else if (value < lowerBound) {
                    this.EventBus.$emit('stepTrigger', this.config.lessKey);
                } else {
                    this.EventBus.$emit('stepTrigger', this.config.targetKey);
                }
            }
        }
    },
    computed: {
        inputId: function inputId() {
            return this.safeId('_AHA_field-prompt_');
        }

    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _registerEvent = __webpack_require__(153);

var _registerEvent2 = _interopRequireDefault(_registerEvent);

var _pageGoals = __webpack_require__(152);

var _pageGoals2 = _interopRequireDefault(_pageGoals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default'], _pageGoals2['default']],
    inject: ['EventBus'],
    props: {
        translations: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            'default': ""
        },
        label: {
            type: String,
            'default': ""
        },
        config: {
            type: Object,
            required: true
        },
        eventText: {
            type: String,
            'default': ""
        },
        eventItemId: {
            type: String
        },
        eventDatasourceId: {
            type: String
        },
        bypassCard: {
            type: Boolean,
            'default': false
        },
        goals: {
            type: String,
            required: false
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.$nextTick(function () {
                _this.EventBus.$emit('registerInput', _this.config.initialKey, _this.$el.querySelectorAll('[name="' + (_this.inputId + '_radio_') + '"]'));
            });
            //Remove p tag if empty
            var fLabel = _this.$refs.label;
            if (fLabel.innerHTML === '') {
                fLabel.parentNode.removeChild(fLabel);
            }
            //Remove role from fieldset
            // this.$el.querySelector('fieldset').removeAttribute('role');
            /*for(var child=this.$el.querySelector('fieldset').firstChild; child!==null; child=child.nextSibling) {
                if(child.hasAttribute('role')){
                    child.removeAttribute('role');
                    child.removeAttribute('aria-labelledby');
                }
            }*/
        });
        // Non IE
        /*this.$el.addEventListener('input', (evt) => {
            this.isFormValid = this.$el.checkValidity();
            console.log('Event input');
        });*/

        // IE
        var radios = this.$el.querySelectorAll('input[type="radio"]');
        var that = this;
        Array.prototype.slice.call(radios).forEach(function (item) {
            item.addEventListener('click', function (evt) {
                that.isFormValid = that.$el.checkValidity();
            });
        });
    },
    data: function data() {
        return {
            isInvalid: false,
            options: [],
            selected: null,
            isFormValid: false
        };
    },

    methods: {
        submitForm: function submitForm(evt) {
            var _this2 = this;

            var selected = this.config.options.find(function (option) {
                return option.text === _this2.selected;
            });
            var stepKey = void 0;

            evt.preventDefault();

            if (typeof selected === 'undefined') {
                this.isInvalid = true;
            } else {
                stepKey = parseInt(selected.stepKey, 10);

                if (this.$props.bypassCard) {
                    if (selected.linkTarget) {
                        window.open(selected.link, selected.linkTarget);
                    } else {
                        window.open(selected.link, "_self");
                    }
                } else {
                    this.EventBus.$emit('stepTrigger', stepKey);
                }

                // Trigger Page Goals (mixins - pageGoalsMixin)
                if (this.goals) {
                    this.triggerPageGoals(this.goals);
                }

                // Send the analytics request
                _registerEvent2['default'].post(this.$props.eventItemId, this.$props.eventText + ' $$Response$$ ' + selected.text, this.$props.eventDatasourceId);

                this.isInvalid = false;

                /* eslint-disable-next-line */
                // Reset form if retake 
                this.$el.reset();
                this.isFormValid = false;
            }
        }
    },
    computed: {
        inputId: function inputId() {
            return this.safeId('_AHA_field-prompt_');
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default']],
    props: {
        videoName: {
            required: true,
            type: String
        },
        loginId: {
            require: true,
            type: String
        },
        channelId: {
            required: true,
            type: String
        },
        apiBase: {
            required: true,
            type: String
        },
        scriptSrc: {
            required: true,
            type: String
        }
    },
    data: function data() {
        return {
            videoId: null
        };
    },

    methods: {
        loadScript: function loadScript() {
            if (document) {
                var script = document.createElement('script');
                script.setAttribute('src', this.scriptSrc);
                document.head.appendChild(script);
            }
        }
    },
    mounted: function mounted() {
        this.videoId = this.videoName + this.safeId('__TP_video_');
        window.__TVPage__ = window.__TVPage__ || {};
        window.__TVPage__.config = __TVPage__.config || {};
        window.__TVPage__.config[this.videoName] = {
            loginid: this.loginId,
            channel: {
                "id": this.channelId
            },
            targetEl: this.videoId,
            api_base_url: this.apiBase
        };
        this.$nextTick(this.loadScript);
    }
}; //
//
//
//

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

var _inputEventbus = __webpack_require__(45);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    inject: ['EventBus'],
    props: {
        errorStepKey: {
            type: Number,
            'default': 4
        }
    },
    data: function data() {
        return {
            formData: {
                commitment: [],
                firstName: '',
                lastName: '',
                email: '',
                zipCode: '',
                newsletters: false,
                URLReferral: ''
            },
            validation: {
                commitment: false,
                firstName: true,
                lastName: true,
                email: true,
                zipCode: true
            },
            loading: false,
            response: false
        };
    },

    methods: {
        submitForm: function submitForm(evt) {
            var _this = this;

            evt.preventDefault();
            var url = '/aha-service/grfw/MakeACommitment';
            this.loading = true;
            (0, _axios2['default'])({
                method: 'POST',
                url: url,
                responseType: 'json',
                data: this.formData
            }).then(function (response) {
                if (response.data === null) {
                    _this.EventBus.$emit('stepTrigger', _this.errorStepKey);
                    _this.loading = false;
                } else {
                    if (response.data.AlreadyRegistered) {
                        _this.response = true;
                    }
                    _this.EventBus.$emit('stepTrigger');
                    _this.loading = false;
                }
            })['catch'](function (error) {
                console.log(error);
                _this.EventBus.$emit('stepTrigger', _this.errorStepKey);
                _this.loading = false;
            });
        },
        checkInput: function checkInput(value, evt) {
            if (evt.target.hasAttribute('validation-prop')) {
                var validationProp = evt.target.getAttribute('validation-prop');
                this.validation[validationProp] = value !== '' ? true : false;
            }
            return value;
        }
    },
    watch: {
        formData: {
            handler: function handler(value) {
                for (var property in value) {
                    if (property === 'commitment') {
                        if (value[property].length > 0) {
                            this.validation[property] = true;
                        } else {
                            this.validation[property] = false;
                        }
                    }
                }
            },
            deep: true
        }
    },
    computed: {
        isComplete: function isComplete() {

            return this.validEmail;
        },
        validEmail: function validEmail() {
            if (this.formData.firstName === '' || this.formData.lastName === '' || this.formData.email === '' || this.formData.zipCode === '' || this.formData.newsletters === false) {
                console.log('Enter information in all fields');
            } else {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(this.formData.email);
            }
        }
    },
    created: function created() {
        var _this2 = this;

        _inputEventbus2['default'].$on('hiddenInputInit', function (value, id) {
            _this2.formData[id] = value;
        });
    }
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mounted: function mounted() {
        this.getForm();
    },

    props: {
        endpoint: {
            type: String,
            'default': '/aha-service/RecipeBox/GetRecipeBoxes'
        },
        recipeId: {
            type: String,
            required: true
        },
        errorMessage: {
            type: String,
            'default': 'Error loading Recipe Box Folder'
        }
    },
    data: function data() {
        return {
            recipeBoxForm: null
        };
    },

    methods: {
        getForm: function getForm() {
            var _this = this;

            (0, _axios2['default'])({
                method: 'post',
                url: this.$props.endpoint,
                responseType: 'text',
                data: {
                    recipeId: this.$props.recipeId
                }
            }).then(function (response) {
                _this.recipeBoxForm = response.data;
            })['catch'](function (error) {
                _this.recipeBoxForm = '\n                        <div class="alert alert-danger" role="alert">\n                            ' + _this.$props.errorMessage + '\n                        </div>\n                    ';

                // eslint-disable-next-link
                console.log(error);
            });
        }
    }
}; //
//
//
//

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        removeText: {
            type: String,
            'default': 'Remove from favorites'
        },
        addText: {
            type: String,
            'default': 'Add to favorites'
        },
        activeClass: {
            type: String,
            'default': 'icon-solid-heart h-color--red'
        },
        inactiveClass: {
            type: String,
            'default': 'icon-heart h-color--black'
        },
        endpoint: {
            type: String,
            'default': '/aha-service/RecipeBox/DeleteRecipe'
        },
        recipeId: {
            type: String,
            required: true
        },
        folderName: {
            type: String,
            required: true
        },
        savedDate: {
            type: String,
            required: true
        },
        errorMessage: {
            type: String,
            'default': 'Error loading Recipe Box Folder'
        },
        name: {
            type: String,
            required: true
        },
        modalId: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            isFavorite: true,
            isProcessing: false,
            recipeBoxForm: null
        };
    },

    computed: {
        getName: function getName() {
            return this.$props.name;
        },
        srText: function srText() {
            return this.isFavorite ? this.$props.removeText : this.$props.addText;
        },
        iconClasses: function iconClasses() {
            return [this.isFavorite ? this.$props.activeClass : this.$props.inactiveClass];
        }
    },
    methods: {
        click: function click(evt) {
            var _this = this;

            evt.preventDefault();

            if (!this.isProcessing) {
                // If it's currently a favorite, call the delete endpoint
                if (this.isFavorite) {
                    (0, _axios2['default'])({
                        method: 'post',
                        url: this.$props.endpoint,
                        responseType: 'text',
                        data: {
                            recipeId: this.$props.recipeId,
                            folderName: this.$props.folderName,
                            savedDate: this.$props.savedDate
                        }
                    }).then(function (response) {
                        if (response.data) {
                            _this.isFavorite = !_this.isFavorite;
                        }
                    })['catch'](function (error) {
                        // eslint-disable-next-line
                        console.log(error);
                    });
                } else {
                    // Show the add to folder modal
                    this.$root.$emit('bv::show::modal', this.$props.modalId, evt.target);
                }
            }
        }
    }
}; //
//
//
//
//
//
//

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
  filters: {
    underscore: function underscore(value) {
      if (!value) return "";
      value = value.toString();
      return "edit_" + value.split(" ").join("_");
    }
  },
  props: {
    translations: {
      type: Object,
      required: true
    },
    endpointDeleteRecipe: {
      type: String,
      "default": "/aha-service/RecipeBox/DeleteRecipeBox"
    },
    endpointRecipeListing: {
      type: String,
      "default": "/aha-service/RecipeBox/RecipeBoxListing"
    },
    endpointCreateFolder: {
      type: String,
      "default": "/aha-service/RecipeBox/CreateRecipeBoxFolder"
    },
    endpointUpdateFolders: {
      type: String,
      "default": "/aha-service/RecipeBox/SaveRecipe"
    },
    errorMessage: {
      type: String,
      "default": "Error loading Recipe Box Folder"
    },
    folderitems: {
      type: Array
    },
    items: {
      type: Array
    },
    message: {
      type: String,
      "default": " "
    }
  },
  data: function data() {
    return {
      recipeBoxUpdate: null,
      recipeBoxUpdateMessage: null,
      fieldValue: '',
      createFolderError: null,
      folderEditSection: null,
      isOpen: false,
      loadingImageShow: false,
      updateFolder: [],
      updateFolderError: null,
      recipeboxeditsection: null,
      isValid: true,
      wasSubmitted: false
    };
  },

  methods: {
    DeleteFolder: function DeleteFolder(folderName) {
      var _this = this;

      this.loadingImageShow = true;
      (0, _axios2["default"])({
        method: "post",
        url: this.$props.endpointDeleteRecipe,
        responseType: "json",
        data: {
          folderName: folderName
        }
      }).then(function (response) {
        console.log(response.data);
        _this.$props.items = response.data.JsonItemsDefaultFolders;
        _this.$refs.recipeBoxUpdateMessage.removeAttribute("hidden");
        _this.$refs.recipeBoxUpdateMessage.innerHTML = response.data.Message;
        _this.getRecipeListing();
        _this.loadingImageShow = false;
      })["catch"](function (error) {
        _this.loadingImageShow = false;
        _this.recipeBoxUpdate = "\n                        <div class=\"alert alert-danger\" role=\"alert\">\n                            " + _this.$props.errorMessage + "\n                        </div>\n                    ";

        // eslint-disable-next-link
        console.log(error);
      });
    },
    getRecipeListing: function getRecipeListing() {
      var _this2 = this;

      (0, _axios2["default"])({
        method: "post",
        url: this.$props.endpointRecipeListing,
        responseType: "json"
      }).then(function (response) {
        console.log(response.data);
        _this2.$props.folderitems = response.data.JsonItemsAllFolders;
        _this2.$props.items = response.data.JsonItemsDefaultFolders;
      })["catch"](function (error) {
        _this2.recipeBoxUpdate = "\n                        <div class=\"alert alert-danger\" role=\"alert\">\n                            " + _this2.$props.errorMessage + "\n                        </div>\n                    ";

        // eslint-disable-next-link
        console.log(error);
      });
    },
    createFolderFn: function createFolderFn() {
      var _this3 = this;

      if (this.fieldValue && this.fieldValue !== '') {
        this.isValid = true;
        this.loadingImageShow = true;
        (0, _axios2["default"])({
          method: "post",
          url: this.$props.endpointCreateFolder,
          responseType: "text",
          data: {
            folderName: this.fieldValue
          }
        }).then(function (response) {
          console.log(response.data);
          _this3.$refs.createFolderError.removeAttribute("hidden");
          _this3.$refs.createFolderError.innerHTML = response.data;
          _this3.getRecipeListing();
          _this3.loadingImageShow = false;
        })["catch"](function (error) {
          _this3.loadingImageShow = false;
          _this3.recipeBoxUpdate = "\n              <div class=\"alert alert-danger\" role=\"alert\">\n                  " + _this3.$props.errorMessage + "\n              </div>\n          ";
          // eslint-disable-next-link
          console.log(error);
        });
      } else {
        this.isValid = false;
        this.$refs.createFolderInput.focus();
      }
      this.wasSubmitted = true;
      this.fieldValue = '';
    },
    SumbitUpdateRecipeBox: function SumbitUpdateRecipeBox(evt) {
      var _this4 = this;

      this.updateFolder = evt.target.elements.updateFolder.value;
      var inputLists = evt.target.elements.updateFolder;
      var arra = {};
      if (evt.target.length > 2) {
        inputLists.forEach(function (element) {
          if (element.value != element._value) {
            arra[element._value] = element.value;
          }
        });
      } else {
        if (inputLists.value != inputLists._value) {
          arra[inputLists._value] = inputLists.value;
        }
      }

      this.loadingImageShow = true;
      (0, _axios2["default"])({
        method: "post",
        url: this.$props.endpointUpdateFolders,
        responseType: "text",
        data: {
          formData: arra
        }
      }).then(function (response) {
        console.log(response.data);
        _this4.$refs.updateFolderError.removeAttribute("hidden");
        _this4.$refs.updateFolderError.innerHTML = response.data;
        _this4.getRecipeListing();
        _this4.loadingImageShow = false;
      })["catch"](function (error) {
        _this4.loadingImageShow = false;
        _this4.recipeBoxUpdate = "\n                        <div class=\"alert alert-danger\" role=\"alert\">\n                            " + _this4.$props.errorMessage + "\n                        </div>\n                    ";

        // eslint-disable-next-link
        console.log(error);
      });
    },
    showEditSection: function showEditSection() {
      if (this.isOpen == true) {
        this.isOpen = false;
      } else {
        this.isOpen = true;
        this.focusRef(this.$refs.recipeboxeditsection);
      }
    },
    focusRef: function focusRef(ref) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$refs.recipeboxeditsection.focus();
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    data: function data() {
        return {
            url: window.location.href
        };
    },

    props: {
        ariaLabelProp: {
            type: String,
            'default': 'Copy site URL to your clipboard.'
        }
    }
};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _postscribe = __webpack_require__(897);

var _postscribe2 = _interopRequireDefault(_postscribe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        src: {
            type: String
        },
        id: {
            type: String,
            required: false,
            'default': 'jotform'
        }
    },
    computed: {
        idwrapper: function idwrapper() {
            return this.id + '-wrapper';
        }
    },
    created: function created() {},
    mounted: function mounted() {
        var _this = this;

        window.postscribe = _postscribe2['default'];

        window.postscribe(this.$el, '<script type="text/javascript" id="' + this.id + '" src="' + this.src + '" ><\/script>', {
            done: function done() {
                // console.log('Postsrcibe done for Jotform');
            },
            error: function error(e) {
                console.log('Postscribe Errors: ', e);
                _this.reloadScript();
            }
        });
    },

    methods: {
        reloadScript: function reloadScript() {
            window.postscribe2 = _postscribe2['default'];
            window.postscribe2(this.$el, '<script type="text/javascript" id="' + this.id + '" src="' + this.src + '" ><\/script>', {
                done: function done() {
                    // console.log('Postsrcibe done for Jotform');
                },
                error: function error(e) {
                    console.log('Postscribe Errors: ', e);
                }
            });
        }
    }
}; //
//
//
//
//
//

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uniqid = __webpack_require__(97);

var _uniqid2 = _interopRequireDefault(_uniqid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        name: ''
    },
    data: function data() {
        return {
            modalId: (0, _uniqid2['default'])() + '__footer_support_bar_'
        };
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uniqid = __webpack_require__(97);

var _uniqid2 = _interopRequireDefault(_uniqid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        title: { type: String },
        variant: {
            type: String,
            'default': 'btn--select'
        }

    },
    data: function data() {
        return {
            modalId: (0, _uniqid2['default'])() + '__phd_accordion_'

        };
    },

    computed: {
        icon: function icon() {
            if (this.variant === '' || this.variant === 'default') {
                return 'btn--select';
            }if (this.variant === 'phd-community') {
                return 'btn--select phd-community';
            } else {
                return this.variant;
            }
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    props: {
        dafdirect_settings: {
            type: String,
            'default': '135613797_1111_88885361-4ceb-423f-bde6-892d3785f35b'
        }
    },
    data: function data() {
        return {
            dafdirect_tin: '',
            dafdirect_token: 'hello',
            amount: '',
            data_dafdirect_settings: ''

        };
    },

    methods: {
        generateToken: function generateToken() {
            this.dafdirect_token = this.dafdirect_settings.substring(15);
        },
        generateTin: function generateTin() {
            this.dafdirect_tin = this.dafdirect_settings.substring(0, 9);
        },

        onSubmit: function onSubmit() {
            var _dsgtxt = "";
            var _amnt = "";
            var _dafurl = "";
            var _npoid = this.dafdirect_tin;
            var _tokenstr = "";
            var _querystring = "";

            // DAF url
            if (document.getElementById("dafprovider") != "undefined" && "FC" == document.getElementById("dafprovider").value) {
                _dafurl = "https://charitablegift.fidelity.com/cgfweb/CGFLogon.cgfdo";
            } else if ("SC" == document.getElementById("dafprovider").value) {
                _dafurl = "https://client.schwab.com/Login/SignOn/CustomerCenterLogin.aspx?SANC=recommendgrant&PARMS=|";
            } else if ("BNYM" == document.getElementById("dafprovider").value) {
                _dafurl = "https://bnym.iphiview.com/bnym/API/Grants.mvc.axd/DafDirect";
            } else {
                alert("Please select a donor advised fund.");
                return;
            }

            if (document.getElementById("dafdirect_dsgtxt")) {
                _dsgtxt = encodeURIComponent(document.getElementById("dafdirect_dsgtxt").value);
                document.getElementById("dafdirect_dsgtxt").value = "";
            }
            if (document.getElementById("dafdirect_amnt")) {
                _amnt = document.getElementById("dafdirect_amnt").value.replace(/[^0-9\.]+/g, '');
                document.getElementById("dafdirect_amnt").value = "";
            }
            if ("SC" == document.getElementById("dafprovider").value) {
                _tokenstr = "|ddtoken=" + this.dafdirect_token;
            } else {
                _tokenstr = "&ddtoken=" + this.dafdirect_token;
            }

            var action = "";
            if ("SC" == document.getElementById("dafprovider").value) {
                _querystring = "Npo_Id=" + _npoid + "|Grnt_Amnt=" + _amnt + "|Device_Type=Widget|App_Id=MDNR|source=widget" + "|Grnt_Dsg_Txt=" + _dsgtxt;
                action = _dafurl + _querystring + _tokenstr;
            } else {
                _querystring = "Npo_Id=" + _npoid + "&Grnt_Amnt=" + _amnt + "&Grnt_Dsg_Txt=" + _dsgtxt + "&Device_Type=Widget&App_Id=MDNR&source=widget";
                action = _dafurl + "?" + _querystring + _tokenstr;
            }
            document.getElementById("dafprovider").value = "";
            var popupWindow = window.open(action, '_blank');
            popupWindow.focus();
        }
    },
    created: function created() {
        if (this.dafdirect_settings === '' || this.dafdirect_settings === null) {
            this.data_dafdirect_settings = this.$options.props.dafdirect_settings['default'];
        } else {
            this.data_dafdirect_settings = this.dafdirect_settings;
        }
        this.generateToken();
    }
};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(52);

var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _inputEventbus = __webpack_require__(45);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
    data: function data() {
        return {
            isVisible: false,
            filters: []
        };
    },

    props: {
        show: { type: Boolean, "default": true },
        name: {
            type: String,
            required: true
        },
        ariaLive: {
            type: String
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.isVisible = this.show;
        if ((0, _lodash.isString)(this.name)) {
            _inputEventbus2["default"].$on("toggle-for:" + this.name, function (value, el) {
                _this.isVisible = value;
            });
        }
        if (this.ariaLive) {
            this.$refs['container'].setAttribute('aria-live', this.ariaLive);
        }
    }
}; //
//
//
//
//
//

/***/ }),
/* 285 */,
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  data: function data() {
    return {
      url: window.location.href,
      isSelected: false
    };
  },

  props: {
    id: {
      type: String,
      required: true
    },
    img: {
      type: String,
      "default": ""
    },
    imgAlt: {
      type: String,
      "default": ""
    },
    title: {
      type: String,
      "default": ""
    },
    description: {
      type: String,
      "default": ""
    },
    flags: {
      type: String,
      "default": ""
    },
    categoryTitle: {
      type: String,
      "default": ""
    },
    mediaTitle: {
      type: String,
      "default": ""
    },
    mediaText: {
      type: String,
      "default": ""
    },
    mediaLink: {
      type: String,
      "default": ""
    },
    mediaLinkClass: {
      type: String,
      "default": ""
    },
    mediaLinkTarget: {
      type: String,
      "default": ""
    },
    mediaLinkDescription: {
      type: String,
      "default": ""
    },
    downloadLink: {
      type: String,
      "default": ""
    },
    downloadLinkClass: {
      type: String,
      "default": ""
    },
    downloadLinkTarget: {
      type: String,
      "default": ""
    },
    downloadButtonText: {
      type: String,
      "default": "Download Your Tookit"
    },
    tabindex: {
      type: Number
    },
    active: {
      type: Boolean,
      "default": false
    },
    buttonText: {
      type: String,
      "default": "select"
    },
    removeButtonText: {
      type: String,
      "default": "deselect"
    },
    selected: {
      type: Boolean,
      "default": false
    },
    boxShadow: {
      type: Boolean,
      "default": false
    },
    rotate: {
      type: Number
    },
    skew: {
      type: Number
    },
    sortOrder: {
      type: String
    }
  },
  mounted: function mounted() {
    // if(this.active) {
    //     this.$refs.button.focus()
    // }
  },

  filters: {
    upper: function upper(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },
  computed: {
    styles: function styles() {
      return {
        "c-selection-card": true,
        selected: this.selected,
        hover: this.active,
        "box-shadow": this.boxShadow
      };
    },
    transformStyles: function transformStyles() {
      var transforms = [];
      if (this.rotate) {
        transforms.push("rotate(" + this.rotate + "deg)");
      }
      if (this.skew) {
        transforms.push("skew(" + this.skew + "deg)");
      }
      return transforms.length > 0 ? { transform: "" + transforms.join(" ") } : null;
    }
  }
};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inputEventbus = __webpack_require__(45);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

var _ahaUtils = __webpack_require__(70);

var _lodash = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  name: 'SwitchInput',
  props: {
    isChecked: {
      type: Boolean,
      'default': false
    },
    id: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    toggleFor: {
      type: String
    },
    disabled: {
      type: Boolean,
      'default': false
    },
    showLabels: {
      type: Boolean,
      'default': true
    },
    ariaLabel: {
      type: [String]
    },
    ariaLabelledby: {
      type: [String]
    },
    ariaDescribedby: {
      type: [String]
    },
    onText: {
      type: String,
      'default': 'on'
    },
    offText: {
      type: String,
      'default': 'off'
    }
  },
  data: function data() {
    return {
      checked: !!this.isChecked,
      lineHeight: 12,
      height: 22,
      width: 50,
      margin: 3,
      fontSize: 16,
      containerStyles: {},
      focused: false
    };
  },
  mounted: function mounted() {
    var s = this.$refs["wrapper"];
    var styles = window.getComputedStyle(s, null);
    var lineHeight = styles.getPropertyValue('line-height');
    this.containerStyles = styles;
    this.fontSize = parseInt(styles.getPropertyValue('line-height')) * .8;
    this.height = parseInt(styles.getPropertyValue('line-height')) + this.margin * 2;
    this.emitToggleFor();
  },

  methods: {
    toggle: function toggle(event) {
      var cbk = this.$refs["cbk"];
      cbk.value = this.checked;

      this.$emit('input', this.checked);
      this.$emit('change', {
        value: this.checked,
        name: this.name,
        srcEvent: event
      });
      this.emitToggleFor(event);
    },
    emitToggleFor: function emitToggleFor(event) {
      var cbk = this.$refs["cbk"];

      if (_.isString(this.toggleFor)) {
        var eventName = 'toggle-for:' + this.toggleFor;
        _inputEventbus2['default'].$emit('toggle-for:' + this.toggleFor, this.checked, cbk, event);
      }
    }
  },
  computed: {
    className: function className() {
      var checked = this.checked,
          disabled = this.disabled,
          focused = this.focused;


      return ['c-switch-input', {
        checked: checked,
        disabled: disabled,
        focused: focused
      }];
    },
    ariaChecked: function ariaChecked() {
      return this.checked;
    },
    getAriaLabel: function getAriaLabel() {
      return this.ariaLabelledby ? false : this.ariaLabel;
    },
    coreStyle: function coreStyle() {
      return {
        width: (0, _ahaUtils.px)(this.width),
        height: (0, _ahaUtils.px)(this.height),
        borderRadius: (0, _ahaUtils.px)(Math.round(this.height / 2))
      };
    },
    buttonRadius: function buttonRadius() {
      return this.height - this.margin * 2;
    },
    distance: function distance() {
      return (0, _ahaUtils.px)(this.width - this.height + this.margin);
    },
    buttonStyle: function buttonStyle() {
      var transition = 'transform 300ms';
      var margin = (0, _ahaUtils.px)(this.margin);

      var transform = this.checked ? (0, _ahaUtils.translate)(this.distance, margin) : (0, _ahaUtils.translate)(margin, margin);

      return {
        width: (0, _ahaUtils.px)(this.buttonRadius),
        height: (0, _ahaUtils.px)(this.buttonRadius),
        transition: transition,
        transform: transform
      };
    },
    labelStyle: function labelStyle() {
      return {
        lineHeight: (0, _ahaUtils.px)(this.height),
        fontSize: this.fontSize ? (0, _ahaUtils.px)(this.fontSize) : null
      };
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__(52);

var _cardSelector = __webpack_require__(99);

var _vuex = __webpack_require__(76);

var _utils = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
  provide: function provide() {
    return {
      EventBus: this.EventBus
    };
  },
  data: function data() {
    return _extends({
      EventBus: new _vue2["default"](),
      active: -1,
      isSubmitted: false,
      focusedItem: null,
      filters: []
    }, (0, _vuex.mapState)({
      selectedFilters: function selectedFilters(state) {
        return state.filters;
      }
    }));
  },

  props: {
    name: { type: String },
    data: { type: String },
    title: { type: String },
    description: { type: String }
  },
  beforeCreate: function beforeCreate() {
    this.$store = (0, _cardSelector.initStore)();
    this.$store.commit("initialiseStore");
  },
  init: function init() {
    this.isSubmitted = false;
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.$scopedSlots["default"] && this.$scopedSlots["default"]()) {
      var items = []; // Array
      _.forEach(this.$scopedSlots["default"](), function (element) {
        if (element.tag && element.tag.endsWith("aha-selection-card")) {
          var elData = element.componentOptions.propsData;
          items.push(elData); // Push item to array - items
        }
      });
      _.forEach(this.$scopedSlots.filters(), function (element) {
        if (element.tag && element.tag.endsWith("aha-card-selector-filter")) {
          var elData = element.componentOptions.propsData;
          _this2.filters.push(elData); // Push to array - filters
        }
      });

      // Converting sortOrder into array
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.sortOrder = item.sortOrder.split(",");
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"]) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$store.commit("setItems", items); // Add items to Vuex Store
    }

    this.EventBus.$on("filterChanged", function (name, isSelected) {
      _this2.$store.commit("updateFilter", { name: name, isSelected: isSelected });
      _this2.resize();
    });
    this.resize();
  },

  computed: _extends({}, (0, _vuex.mapGetters)({
    items: "availableItems",
    selectedItems: "selectedItems"
  }), {
    sortedItems: function sortedItems() {
      var _this = this;

      function compare(a, b) {
        var num1 = void 0,
            num2 = void 0;
        if (_this.selectedFilters().includes("youth") && a.flags.length > 1 && a.flags.includes("adults") && a.flags.includes("youth")) {
          num1 = Number(a.sortOrder[1]);
        } else {
          num1 = Number(a.sortOrder[0]);
        }
        if (_this.selectedFilters().includes("youth") && b.flags.length > 1 && b.flags.includes("adults") && b.flags.includes("youth")) {
          num2 = Number(b.sortOrder[1]);
        } else {
          num2 = Number(b.sortOrder[0]);
        }

        if (num1 < num2) return -1;
        if (num1 > num2) return 1;
        return 0;
      }
      return this.items.sort(compare);
    }
  }),
  methods: {
    resize: function resize() {
      var container = this.$refs["cardSelectorNode"];
      var items = container.getElementsByClassName("c-selection-card");
      var itemContainers = container.getElementsByClassName("c-card-selector-item");
      var height = 0;
      var padding = void 0;
      var getPadding = function getPadding(el) {
        if (padding) return padding;

        var styles = window.getComputedStyle(el, null);
        var px = styles["paddingTop"];
        var pt = parseInt(styles["paddingTop"]);
        var pb = parseInt(styles["paddingBottom"]);
        padding = pt + pb;
        return padding;
      };
      (0, _lodash.forEach)(items, function (card) {
        if (height < card.offsetHeight) {
          height = card.offsetHeight;

          console.log('inside selector');
          console.log('height', height);
          console.log('card.offsetHeight', card.offsetHeight);
        }

        if (height > 350) {
          height = 350;
        }
      });

      (0, _lodash.forEach)(itemContainers, function (cardContainer) {
        var styles = window.getComputedStyle(cardContainer, null);
        cardContainer.style["min-height"] = height + getPadding(cardContainer) + "px";
      });
    },
    isSelected: function isSelected(id) {
      return this.$store.state.selectedIds.includes(id);
    },
    onKeyPress: function onKeyPress(evt) {
      var _this3 = this;

      var key = evt.which || evt.keyCode;
      var previousItem = null,
          nextItem = null,
          currentItem = null;
      if (!this.focusedItem) {
        return;
      }
      this.items.forEach(function (item, i) {
        if (item.id === _this3.focusedItem) {
          currentItem = item;
          previousItem = i > 0 ? _this3.items[i - 1].id : null;
          nextItem = _this3.items.length - 1 > i ? _this3.items[i + 1].id : null;
        }
      });

      // console.log("navitems", currentItem, previousItem, nextItem);
      switch (key) {
        case _utils.KeyCodes.UP:
          evt.preventDefault();
          previousItem && this.focusItem(previousItem);
          break;
        case _utils.KeyCodes.DOWN:
          evt.preventDefault();
          nextItem && this.focusItem(nextItem);
          break;
        case _utils.KeyCodes.SPACE:
          evt.preventDefault();
          this.toggleItem(evt, currentItem);
          break;
      }
    },
    toggleItem: function toggleItem(evt, id) {
      var isSelected = !this.$store.state.selectedIds.includes(id);
      this.$store.commit("itemSelectionChanged", { id: id, isSelected: isSelected });
      evt.preventDefault();
    },
    isFiltered: function isFiltered(name) {
      return this.$store.state.filters.includes(name);
    },
    focusItem: function focusItem(itemId) {
      if (itemId) {
        this.focusedItem = itemId;
      } else {
        if (this.$store.state.selectedIds.length > 0) {
          this.focusedItem = this.$store.state.selectedIds[0];
        } else {
          this.focusedItem = this.$store.state.items[0].id;
        }
      }
    },
    submit: function submit(event) {
      this.$root.$emit("bv::show::modal", "loadingModal");
      this.isSubmitted = true;
      setTimeout(function () {
        var newUri = event.target.attributes.href.nodeValue;
        window.location.href = newUri;
      }, 250);
    }
  }
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    inject: ["EventBus"],
    data: function data() {
        return {
            url: window.location.href,
            enabled: !!this.checked
        };
    },

    props: {
        title: { type: String },
        description: { type: String },
        name: {
            type: String,
            required: true
        },
        checked: {
            type: Boolean,
            'default': false
        },
        onText: {
            type: String,
            'default': 'Yes'
        },
        offText: {
            type: String,
            'default': 'No'
        }
    },
    methods: {
        changed: function changed(_ref) {
            var value = _ref.value,
                name = _ref.name;

            this.EventBus.$emit("filterChanged", name, value, this);
        }
    }
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__(52);

var _cardSelector = __webpack_require__(99);

var _vuex = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports["default"] = {
    data: function data() {
        return {
            filters: [],
            maxHeight: 0
        };
    },

    props: {
        data: [],
        mode: {
            type: String,
            "default": 'stack',
            validator: function validator(value) {
                return typeof value === 'string' && (value === 'stack' || value === 'stacked' || value === 'list');
            }
        }
    },
    beforeCreate: function beforeCreate() {
        this.$store = (0, _cardSelector.initStore)();
        this.$store.commit('initialiseStore');
    },
    mounted: function mounted() {
        this.resize();
    },

    methods: {
        resize: function resize() {
            var container = this.$refs['wrapper'];
            var items = container.getElementsByClassName('c-selection-card');
            var itemContainers = container.getElementsByClassName('c-card-viewer__item');
            var height = 0;
            var width = 0;
            var padding = void 0;
            (0, _lodash.each)(items, function (card) {

                //height = (height < card.offsetHeight) ? card.offsetHeight : height;
                width = width < card.offsetWidth ? card.offsetWidth : width;

                if (height < card.offsetHeight) {
                    height = card.offsetHeight;

                    console.log('inside viewer');
                    console.log('height', height);
                    console.log('card.offsetHeight', card.offsetHeight);
                }

                if (height > 350) {
                    height = 350;
                }
            });

            if (this.isList) {
                var totalHeight = (0, _lodash.reduce)(itemContainers, function (th, item) {
                    return th + item.offsetHeight;
                }, 0);
                container.style.height = totalHeight + "px";
            } else {
                container.style.height = height + "px";
                container.style.width = width + "px";
            }

            (0, _lodash.each)(items, function (card) {
                card.style.height = height + "px";
            });
        }
    },
    computed: _extends({}, (0, _vuex.mapGetters)({
        selectedItems: 'selectedItems'
    }), {
        cardOptions: function cardOptions(index) {
            return {
                boxShadow: true
            };
        },
        contentStyle: function contentStyle() {
            return _defineProperty({
                'c-card-viewer__content': true
            }, "stack-of-" + (0, _lodash.size)(this.items), this.mode === 'stack');
        },
        className: function className() {
            return {
                'c-card-viewer': true,
                'c-card-viewer__stack': this.mode === 'stack',
                'c-card-viewer__list': this.mode === 'list'
            };
        },
        items: function items() {
            var mode = this.mode.toLowerCase();
            if (mode !== 'list') {
                var items = [];
                var len = (0, _lodash.size)(this.selectedItems) < 3 ? (0, _lodash.size)(this.selectedItems) : 3;
                return (0, _lodash.slice)((0, _lodash.shuffle)(this.selectedItems), 0, len);
            }
            return this.selectedItems;
        },
        count: function count() {
            return this.items.length;
        },
        isList: function isList() {
            return this.mode === 'list';
        }
    })
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//

var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__(52);

var _ = _interopRequireWildcard(_lodash);

var _cardSelector = __webpack_require__(99);

var _vuex = __webpack_require__(76);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
    props: {
        data: []
    },
    beforeCreate: function beforeCreate() {
        this.$store = (0, _cardSelector.initStore)();
        this.$store.commit('initialiseStore');
    },
    mounted: function mounted() {
        var text = this.$el.innerHTML;
        if (_.isString(text)) {
            text = text.replace(/{count}/gi, this.count);
            this.$el.innerHTML = text;
            // this.$slots.default.text = text;
        }
    },

    computed: _extends({}, (0, _vuex.mapGetters)({
        selectedItems: 'selectedItems'
    }), {
        count: function count() {
            return this.selectedItems.length;
        }
    })
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueTextMask = __webpack_require__(926);

var _vueTextMask2 = _interopRequireDefault(_vueTextMask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//
//
//
//
//


exports['default'] = {
    name: 'aha-masked-input',
    inheritAttrs: true,
    components: {
        MaskedInput: _vueTextMask2['default']
    },
    data: function data() {
        return {
            val: ''
        };
    },

    props: {
        name: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        styleClass: String
    },
    calulated: {
        mask: function mask() {
            var mask = '';
            switch (this.type) {
                case 'phone':
                    mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
                    break;
                case 'date':
                    mask = [/[0-1]/, /[0-9]/, '/', /[1-3]/, /[0-9]/, '/', /[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/];
                    break;
            }
            return mask;
        }
    }
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _inputEventbus = __webpack_require__(45);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        baseEndpointDomain: {
            type: String,
            'default': ''
        },
        dropdownController: {
            type: String,
            required: true
        },
        dropdownDynamic: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            coursetopic: null,
            coursetype: null,
            children: [],
            selectedTopic: '',
            errorMsg: 'No list found!',
            isError: false,
            showDynamicDropdown: false

        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$children.forEach(function (vNode) {
            vNode.$children.forEach(function (vNode) {
                // Course Type/Format - Dynamic
                if (vNode.$vnode.componentOptions.propsData.inputName === _this.dropdownDynamic) {
                    _this.coursetype = vNode;
                    _this.$nextTick(function () {
                        _this.resetCourseTypeList();
                    });
                }
                // Course Topic - Controller to fetch from API to generate Course Type dropdown list
                if (vNode.$vnode.componentOptions.propsData.inputName === _this.dropdownController) {
                    _this.coursetopic = vNode;
                    _this.$nextTick(function () {
                        // console.log('COURSETOPIC DROPDOWN: ', this.coursetopic);
                        _this.coursetopic.$on('selected', _this.listenToInput);
                    });
                }
            });
        });
    },

    methods: {
        listenToInput: function listenToInput(value, text, el) {
            if (value !== '') {
                if (this.selectedTopic !== text) {
                    var endpoint = el.getAttribute('data-endpoint');
                    this.fetchData(endpoint);
                    this.selectedTopic = text;
                }
            } else {
                this.resetCourseTypeList();
            }
        },
        fetchData: function fetchData(endpoint) {
            var _this2 = this;

            // test locally
            // let _endpoint = this.baseEndpointDomain + endpoint;
            // production
            var _endpoint = this.baseEndpointDomain + '?' + 'topicId=' + endpoint;
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var requestOptions = {
                method: "POST",
                headers: myHeaders
            };

            fetch(_endpoint, requestOptions).then(function (response) {
                if (response.ok) {
                    _this2.isError = false;
                    _this2.showDynamicDropdown = true;
                    response.json().then(function (data) {
                        _this2.children = data;
                    });
                } else {
                    throw Error(response.status + ' ' + response.statusText);
                }
            })['catch'](function (error) {
                _this2.resetCourseTypeList();
                _this2.isError = true;
            });
        },
        resetCourseTypeList: function resetCourseTypeList() {
            this.coursetype.resetList(0);
            this.children = [];
        }
    },
    render: function render() {
        return this.$scopedSlots['dynamicdropdowns']({
            children: this.children,
            error: this.errorMsg,
            isError: this.isError,
            showDynamicDropdown: this.showDynamicDropdown
        });
    }
}; //

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsCookie = __webpack_require__(98);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    data: function data() {
        return {
            cookieString: 'hide-science-volunteer-modal'
        };
    },

    props: {
        modalData: {
            type: Object,
            required: true
        }
    },
    mounted: function mounted() {
        var hideModalSessionCookie = _jsCookie2['default'].get(this.cookieString);

        if (this.modalData.isVolunteer && hideModalSessionCookie === undefined) {
            this.$refs.phdScienceVolunteerModal.show();
            _jsCookie2['default'].set(this.cookieString, true, { SameSite: 'Strict' });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

var _ahaLoadingSpinner = __webpack_require__(78);

var _ahaLoadingSpinner2 = _interopRequireDefault(_ahaLoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
exports['default'] = {
    name: 'NewsletterAjax',
    components: {
        "aha-loading-spinner": _ahaLoadingSpinner2['default']
    },
    props: {
        url: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            formData: {},
            response: {},
            toggleShow: false,
            loading: false,
            showError: false,
            errorMsg: ''
        };
    },

    methods: {
        submitForm: function submitForm(evt) {
            var _this = this;

            evt.preventDefault();
            this.loading = true;
            this.showLoadingModal();

            (0, _axios2['default'])({
                method: 'POST',
                url: this.url,
                responseType: 'json',
                data: this.formData
            }).then(function (response) {
                // console.log('RESPONSE', response.data);
                // on success slide in the thank you slide
                if (response.data === null) {
                    //
                } else {
                    //this.response = response.data;
                    //console.log('RESPONSE', response.data);
                    _this.response = response.data;
                    _this.toggleShow = response.data.success;
                    if (_this.showError === true) {
                        _this.resetError();
                    }
                    _this.hideLoadingModal(1000);
                    _this.loading = false;
                }
                //this.loading = false;
            })['catch'](function (error) {
                console.log('ERROR ERROR ERROR ERROR ');
                console.log(error);
                _this.hideLoadingModal(1000);
                // without timeout the error will show instantly, 
                // give some time for the modal to display
                setTimeout(function () {
                    _this.showError = true;
                    _this.errorMsg = error;
                    _this.loading = false;
                }, 1000);
            });
        },
        resetForm: function resetForm(evt) {
            this.formData = {};
            // this.EventBus.$emit('stepTrigger', 1);
            // inputEventBus.$emit('inputCleared');
            console.log('reset form is called');
        },
        showLoadingModal: function showLoadingModal() {
            this.$root.$emit("bv::show::modal", "loadingModal");
        },
        hideLoadingModal: function hideLoadingModal(val) {
            var _this2 = this;

            setTimeout(function () {
                _this2.$root.$emit("bv::hide::modal", "loadingModal");
            }, val);
        },
        resetError: function resetError() {
            this.showError = false;
            this.errorMsg = '';
        }
    },
    mounted: function mounted() {
        console.log('THIS: ', this);
        console.log('SCOPEDSLOTS', this.$scopedSlots);
        console.log('REFS', this.$refs);
    }
};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaUtils = __webpack_require__(70);

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _ahaLoadingSpinner = __webpack_require__(78);

var _ahaLoadingSpinner2 = _interopRequireDefault(_ahaLoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var browser = (0, _ahaUtils.browserDetails)(); //
//
//
//
//
//
//
//
//
//

exports['default'] = {
    components: {
        "aha-loading-spinner": _ahaLoadingSpinner2['default']
    },
    mixins: [_ahaId2['default']],
    data: function data() {
        return {
            isValid: false,
            submitButton: null,
            form: null,
            emailInput: null,
            emailFormat: RegExp(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,17}$/),
            isEmailFormatted: null,
            pagePosition: null,
            uuid: null,
            isLoading: false,
            spinnerEl: null
        };
    },

    methods: {
        a11yInjection: function a11yInjection() {
            var errorBoxes = this.$el.querySelectorAll('form .field-validation-error');
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = errorBoxes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var errorBox = _step.value;

                    errorBox.style.display = 'none';
                    errorBox.setAttribute('role', 'alert');
                    errorBox.setAttribute('aria-atomic', 'true');
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator['return']) {
                        _iterator['return']();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        isEmailFormatValid: function isEmailFormatValid() {
            return this.isEmailFormatted = this.emailFormat.test(this.emailInput.value);
        },
        isFormValid: function isFormValid() {
            if (this.form.checkValidity() === false) {
                return false;
            } else if (this.form.checkValidity() === true && this.isEmailFormatValid() === true) {
                return true;
            }
        },
        onSubmitClicked: function onSubmitClicked() {
            var _this = this;

            // this.pagePosition = window.scrollY;
            // window.__scrollY__ = this.pagePosition;
            setTimeout(function () {
                _this.submitButton.disabled = true;
            }, 250);
            this.isLoading = true;
            // console.log("Spinner El");
            // console.log(this.spinnerEl);
            // this.spinnerEl.classList.remove('d-none');
            // this.spinnerEl.classList.add('d-inline-block');
            this.submitButton.value = "Submitting";
        }
    },
    created: function created() {},
    mounted: function mounted() {
        var _this2 = this;

        this.uuid = this.safeId('_AHA_sc_form_wrapper_');
        this.a11yInjection();
        this.submitButton = this.$el.querySelector('[type="submit"]');
        this.submitButton.disabled = true;
        // let spinnerEl = document.createElement('div');
        // spinnerEl.classList.add('loader', 'd-none');
        // spinnerEl.innerText = "Loading...";
        // spinnerEl.innerHTML = `<div class="loader d-none ">Loading...</div>`;
        // this.spinnerEl = spinnerEl;
        // this.submitButton.after(spinnerEl);
        this.form = this.$el.querySelector('form[data-sc-fxb]');
        // this.$forceUpdate();

        this.emailInput = this.$el.querySelector('[type="email"]');
        var requiredInputs = this.$el.querySelectorAll('form [data-val-required]');
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            var _loop = function _loop() {
                var requiredInput = _step2.value;

                requiredInput.required = true;
                requiredInput.setAttribute('aria-required', 'true');
                requiredInput.setAttribute('aria-invalid', 'false');
                requiredInput.addEventListener('blur', function () {
                    if (requiredInput.validity.valid === false) {
                        if (requiredInput.nextElementSibling.classList.contains('field-validation-error')) {
                            requiredInput.nextElementSibling.style.display = 'block';
                        }
                        requiredInput.setAttribute('aria-invalid', 'true');
                    }
                });
            };

            for (var _iterator2 = requiredInputs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _loop();
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                    _iterator2['return']();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        this.form.addEventListener('input', function () {
            _this2.isValid = _this2.isFormValid();
            _this2.submitButton.disabled = !_this2.isValid;
        });
        this.submitButton.addEventListener('click', function (e) {
            //e.preventDefault(); // for testing

            _this2.onSubmitClicked();
        });

        document.addEventListener("sc-forms-submit-success", function (e) {

            /*setTimeout(function() {
                if(browser.mobile) {
                    // var _frm = document.getElementById(e.detail);
                    var _frm = document.querySelector('.c-aha-form');
                    var _parentFrm = _frm.closest('.container');
                    _parentFrm.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                    
                }
            }, 0);*/

        });
    }
};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _itemsStorage = __webpack_require__(100);

var STORAGE_KEY = '_aha-coveo-grocery-list'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// const STORAGE_KEY = "grocery-list";
// const itemsStorage = {
//     fetch: function() {
//         var items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
//         items.forEach((item,index) => {
//            item.id = index;
//         });
//         itemsStorage.uid = items.length;
//         return items;
//     },
//     save: function(items) {
//         localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
//     }
// };

// const filters = {
//     all: function(items) {
//         return items;
//     },
//     active: function(items) {
//         return items.filter(item => {
//             return !item.completed;
//         })
//     },
//     completed: function(items) {
//         return items.filter(item => {
//             return item.completed;
//         })
//     }
// };
exports['default'] = {
    props: {
        title: {
            type: String,
            required: false,
            'default': "My Grocery List"
        },
        count: {
            type: Number
        }
    },
    data: function data() {
        return {
            items: [],
            newItem: "",
            editedItem: null,
            visibility: "all",
            checked: ""
        };
    },

    // watch todos change for localStorage persistence
    watch: {
        items: {
            handler: function handler(items) {
                _itemsStorage.itemsStorageFunc.save(STORAGE_KEY, items);
                this.$eventHub.$emit('grocerylist::updated', this.remaining);

                var modal = document.querySelector('#GroceryListModal .modal-content'); // select the modal by it's id
                modal.addEventListener('keydown', function (e) {

                    // Focus trapp below: add all the elements inside modal which you want to make focusable
                    var focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

                    var firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
                    var focusableContent = modal.querySelectorAll(focusableElements);
                    var lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

                    var list = Array.from(focusableContent);
                    var index = list.findIndex(function (content) {
                        return content === document.activeElement;
                    });

                    //console.log(list[index], index, list[index + 1]); // 1
                    //console.log('i',index)

                    if (list[index]) {
                        list[index].addEventListener('click', function () {
                            list[index + 1].focus();
                        });
                    }

                    if (e.key !== 'Tab') {
                        return;
                    }

                    if (document.activeElement === firstFocusableElement && items.length === 0) {
                        firstFocusableElement.focus(); // add focus for the first focusable element
                        e.preventDefault();
                    }

                    if (e.shiftKey) {
                        // if shift key pressed for shift + tab combination
                        if (document.activeElement === firstFocusableElement) {
                            lastFocusableElement.focus(); // add focus for the last focusable element
                            e.preventDefault();
                        }
                    } else {
                        // if tab key is pressed
                        if (document.activeElement === lastFocusableElement) {
                            // if focused has reached to last focusable element then focus first focusable element after pressing tab
                            firstFocusableElement.focus(); // add focus for the first focusable element
                            e.preventDefault();
                        }
                    }

                    var closeBtn = document.querySelector('#GroceryListModal___BV_modal_header_ .close');
                    closeBtn.addEventListener('click', function () {
                        setTimeout(function () {
                            document.querySelector('.coveo-results-header button.coveo-results-add-to-list').focus();
                        }, 0);
                    });
                });

                // Lines below hide email section of grocery list modal where there are no items remaining

                var privacyPolicy = document.getElementsByClassName('message');
                var emailSelector = document.getElementById('grocery-list-email');

                if (this.remaining === 0) {
                    privacyPolicy[0].setAttribute("style", "visibility: hidden; height:0;");
                    emailSelector.setAttribute("style", "visibility: hidden; height:0;");
                } else {
                    privacyPolicy[0].setAttribute("style", "visibility: visible; height:auto;");
                    emailSelector.setAttribute("style", "visibility: visible; height:auto;");
                }
            },
            deep: true
        }

    },
    computed: {
        filteredItems: function filteredItems() {
            return _itemsStorage.itemsStorageFilters[this.visibility](this.items);
        },
        remaining: function remaining() {
            return _itemsStorage.itemsStorageFilters.active(this.items).length;
        },
        allDone: {
            get: function get() {
                return this.remaining === 0;
            },
            set: function set(value) {
                this.items.forEach(function (item) {
                    item.completed = value;
                });
            }
        }
    },
    created: function created() {},
    mounted: function mounted() {
        this.items = _itemsStorage.itemsStorageFunc.fetch(STORAGE_KEY);
        if (this.remaining === 0) {
            this.checked = "Uncheck All";
        } else {
            this.checked = "Check All";
        };

        var allFilterBtn = document.querySelector('.filters li:nth-child(2) .btn');
        allFilterBtn.classList.add('activeFilter');

        console.log(this.remaining);
    },

    filters: {
        pluralize: function pluralize(n) {
            return n === 1 ? "item" : "items";
        }
    },
    methods: {
        showFilterBtnStyle: function showFilterBtnStyle() {
            // show indication of what filter tab the user is actively on.
            var allFilterBtn = document.querySelector('.filters li:nth-child(2) .btn');
            var activeFilterBtn = document.querySelector('.filters li:nth-child(3) .btn');
            var completedFilterBtn = document.querySelector('.filters li:nth-child(4) .btn');

            if (this.visibility) {
                if (this.visibility === 'all') {
                    allFilterBtn.classList.add('activeFilter');
                    activeFilterBtn.classList.remove('activeFilter');
                    completedFilterBtn.classList.remove('activeFilter');
                }
                if (this.visibility === 'active') {
                    allFilterBtn.classList.remove('activeFilter');
                    activeFilterBtn.classList.add('activeFilter');
                    completedFilterBtn.classList.remove('activeFilter');
                }
                if (this.visibility === 'completed') {
                    allFilterBtn.classList.remove('activeFilter');
                    activeFilterBtn.classList.remove('activeFilter');
                    completedFilterBtn.classList.add('activeFilter');
                }
            }
        },
        addItem: function addItem(value) {
            // var value = this.newItem && this.newItem.trim();
            /*if (!value) {
                return
            };*/
            this.items.push({
                ProductName: value,
                completed: false,
                id: _itemsStorage.itemsStorageFunc.uid++
            });
            this.newItem = "";
        },
        removeItem: function removeItem(item) {
            this.items.splice(this.items.indexOf(item), 1);
        },
        editItem: function editItem(item) {
            this.beforeEditCache = item.title;
            this.editedItem = item;
        },
        doneEdit: function doneEdit(item) {
            if (!this.editedItem) {
                return;
            }
            this.editedItem = null;
            item.title = item.title.trim();
            if (!item.title) {
                this.removeItem(item);
            }
        },
        cancelEdit: function cancelEdit(item) {
            this.editedItem = null;
            item.title = this.beforeEditCache;
        },
        removeCompleted: function removeCompleted(item, value) {
            var checkedItems = document.querySelectorAll("ul.grocery-list li.completed");
            var checkedBoxItems = document.querySelectorAll("ul.grocery-list li input[type='checkbox']");

            //unchecks checkboxes, removes class, sets check All, sets item back
            checkedBoxItems.forEach(function (checkedBoxItem) {
                checkedBoxItem.checked = false;
            });
            checkedItems.forEach(function (checkedItem) {
                checkedItem.classList.remove("completed");
            });
            this.checked = "Check All";
            this.items.forEach(function (item) {
                item.completed = value;
            });

            // focus on the "completed" button once completed items are cleared with the "clear completed" btn
            // let clearCompleteBtn = document.querySelector('.clear-completed')
            // clearCompleteBtn.addEventListener('click', () => {
            //     let completedFilterBtn = document.querySelector('.filters li:nth-child(4) .btn')
            //     completedFilterBtn.focus();
            // })

            //removes all checked items
            //this.items = itemsStorageFilters.active(this.items)
        },
        checkAll: function checkAll(item) {
            if (this.remaining === 0) {
                this.checked = "Check All";
            } else {
                this.checked = "Uncheck All";
            }
        },
        checkAllItems: function checkAllItems() {
            var checkboxes = document.querySelectorAll("ul.grocery-list li input[type='checkbox']").length;
            var checkboxesChecked = document.querySelectorAll("ul.grocery-list li input[type='checkbox']:checked").length;

            if (checkboxesChecked === checkboxes) {
                this.checked = "Uncheck All";
            } else {
                this.checked = "Check All";
            }
        }
    }
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _itemsStorage = __webpack_require__(100);

var STORAGE_KEY = '_aha-coveo-grocery-list'; //
//
//
//
//
//
//

// const STORAGE_KEY = "grocery-list";
// const itemsStorage = {
//     fetch: function() {
//         var items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
//         items.forEach((item,index) => {
//            item.id = index;
//         });
//         itemsStorage.uid = items.length;
//         return items;
//     }
// };

// var filters = {
//     active: function(items) {
//         return items.filter(item => {
//             return !item.completed;
//         })
//     },
// };

exports['default'] = {
    data: function data() {
        return {
            count: _itemsStorage.itemsStorageFilters.active(_itemsStorage.itemsStorageFunc.fetch(STORAGE_KEY)).length
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$eventHub.$on('grocerylist::updated', function (data) {
            _this.count = data;
        });
    }
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable */
'use-strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dropdown = __webpack_require__(986);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _eventBus = __webpack_require__(300);

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _EVENT_BUS = new _eventBus2['default']();

var _SELECTOR = 'vjs-dropdown';

// ES6 Symbols to hide private Class functions from public scope
var _externalClick = Symbol('externalClick');
var _externalClickHandler = Symbol('externalClickHandler');

var VJSDropdown = function () {
    function VJSDropdown() {
        var _this = this;

        _classCallCheck(this, VJSDropdown);

        this.elements = null;
        this.store = [];
        this.initialized = false;

        this[_externalClickHandler] = function (evt) {
            return _this[_externalClick](evt);
        };
    }

    /* START: Public */

    _createClass(VJSDropdown, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            // Select all _SELECTOR elements
            this.elements = document.querySelectorAll('[' + _SELECTOR + ']');
            // If this hasn't been initialized....
            if (!this.initialized) {
                // Loop through plugin elements and create and initialize a dropdown instance
                Array.prototype.forEach.call(this.elements, function (el) {
                    var target = document.getElementById(el.getAttribute(_SELECTOR));
                    if (target && target.nodeType) {
                        var dropdown = new _dropdown2['default']({ el: el, target: target });
                        dropdown.init();
                        _this2.store.push(dropdown);
                    }
                });
                // Add event listener to window to close all dropdowns on click outside of dropdown
                window.addEventListener('click', this[_externalClickHandler]);
                this.initialized = true;
            }
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this.store.forEach(function (dropdown) {
                return dropdown.destroy();
            });
            this.store = [];
            window.removeEventListener('click', this[_externalClickHandler]);
            _EVENT_BUS.emit('vjs-dropdown:open', { id: '' });
            this.initialized = false;
        }

        /* END: Public */

        /* START: Private */

        // Check if window click is a dropdown item

    }, {
        key: _externalClick,
        value: function value(evt) {
            var src = evt.srcElement;
            var isDropdown = false;
            var i = 0;
            do {
                if (this.elements[i]) {
                    var target = document.getElementById(this.elements[i].getAttribute(_SELECTOR));
                    if (target) {
                        if (this.elements[i] === src || target === src) {
                            isDropdown = true;
                        }
                    }
                }
                i++;
            } while (!isDropdown && i < this.elements.length);
            if (!isDropdown) {
                _EVENT_BUS.emit('vjs-dropdown:open', { id: '' });
            }
        }

        /* END: Private */

    }]);

    return VJSDropdown;
}();

exports['default'] = VJSDropdown;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'use-strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DropdownEventBus = function () {
    function DropdownEventBus() {
        _classCallCheck(this, DropdownEventBus);

        this.bus = window;
    }

    _createClass(DropdownEventBus, [{
        key: 'on',
        value: function on(evt, callback) {
            this.bus.addEventListener(evt, callback);
        }
    }, {
        key: 'off',
        value: function off(evt, callback) {
            this.bus.removeEventListener(evt, callback);
        }
    }, {
        key: 'emit',
        value: function emit(evt) {
            var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            /* eslint-disable-next-line */
            this.bus.dispatchEvent(new CustomEvent(evt, { detail: detail }));
        }
    }]);

    return DropdownEventBus;
}();

exports['default'] = DropdownEventBus;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    props: {
        trialContent: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            tableData: {}
        };
    },
    beforeMount: function beforeMount() {
        this.tableData = this.trialContent;
    }
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    name: 'selector',
    mixins: [_ahaId2['default']],
    data: function data() {
        return {
            activeItem: 'journals',
            tierId: null,
            mobile: window.innerWidth <= 700

        };
    },
    created: function created() {
        if (this.mobile) {
            this.activeItem = ' ';
        }
    },

    methods: {
        isActive: function isActive(menuItem) {
            return this.activeItem === menuItem;
        },
        setActive: function setActive(menuItem) {
            this.activeItem = menuItem;
            if (this.activeItem === 'guidelines') {
                console.log('guidelines');
            }
        },
        onHidden: function onHidden() {
            console.log("closed");
            this.activeItem = '';
        }
    },
    mounted: function mounted() {
        this.tierId = this.safeId('__PHD_selector_');
        console.log(this.tierId);
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    props: {
        tables: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            theData: []
        };
    },
    beforeMount: function beforeMount() {
        this.theData = this.tables;
    }
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    props: {
        tableData: {
            // example data can be found:
            // demo\pages\components\phd-membership-rate-comparison.vue
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            theData: {}
        };
    },
    beforeMount: function beforeMount() {
        this.theData = this.tableData;
    },

    computed: {
        numberOfDataColumns: function numberOfDataColumns() {
            var count = this.theData.rateText.length;

            return count;
        },
        columnCountClass: function columnCountClass() {
            var className = '';

            switch (this.numberOfDataColumns) {
                case 1:
                    className = "data-column-count--one";
                    break;
                case 2:
                    className = "data-column-count--two";
                    break;
            }

            return className;
        }
    }
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    props: {
        scData: {
            // example data can be found:
            // demo\components\phd\phd-left-nav-demo.vue
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            menuData: {}
        };
    },
    beforeMount: function beforeMount() {
        this.menuData = this.scData;
    },

    methods: {
        findActiveItem: function findActiveItem() {
            var activeText = "Menu";

            for (var i = 0; i < this.menuData.length; i++) {
                var thisItem = this.menuData[i];
                if (thisItem.active) {
                    activeText = thisItem.text;
                    break;
                }
            }

            return activeText;
        }
    }
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    props: {
        navData: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            theData: []
        };
    },
    beforeMount: function beforeMount() {
        this.theData = this.navData;

        this.detectActiveItem();
    },

    directives: {
        'click-outside': {
            bind: function bind(el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                    // here I check that click was outside the el and his childrens
                    if (!(el == event.target || el.contains(event.target))) {
                        // and if it did, call method provided in attribute value
                        vnode.context[binding.expression](event);
                    }
                };
                document.body.addEventListener('click', el.clickOutsideEvent);
            },
            unbind: function unbind(el) {
                document.body.removeEventListener('click', el.clickOutsideEvent);
            } // click-outside
        } },
    methods: {
        detectActiveItem: function detectActiveItem() {
            // The purpose of this method is to check for the existance of ANY active item.  If any item in any sub-nav is active, we do nothing.  If nothing is active, we need to make the very first item active so that things will work properly on mobile.
            var somethingIsTrue = false;

            // Looping through all navigation items
            for (var i = 0; i < this.theData.navItems.length; i++) {
                // creating a variable for the current group of subNav items
                var childGroup = this.theData.navItems[i].subNav;

                if (childGroup !== "" && childGroup !== undefined && childGroup !== null) {
                    for (var ii = 0; ii < childGroup.length; ii++) {
                        if (childGroup[ii].active === true) {
                            // we found an active item
                            somethingIsTrue = true;
                            // we can stop looping now
                            break;
                        } // end if
                    } // end for

                    if (somethingIsTrue === true) {
                        break;
                    } // end if
                } // end if
            } // end for

            if (somethingIsTrue !== true) {
                // There aren't any active items, so let's make the first one active
                this.theData.navItems[0].subNav[0].active = true;
            }
        },
        showAll: function showAll() {
            this.theData.showAll = true;
        },
        hideAll: function hideAll() {
            this.theData.showAll = false;
            for (var i = 0; i < this.theData.navItems.length; i++) {
                this.theData.navItems[i].open = false;
            }
        },
        closeAllTertiary: function closeAllTertiary() {
            for (var i = 0; i < this.theData.navItems.length; i++) {
                this.theData.navItems[i].open = false;
            }
        },
        handleSecondaryNavClick: function handleSecondaryNavClick(itemIndex) {
            var _this = this;

            if (this.theData.showAll === false && window.innerWidth < 992) {
                this.showAll();
            } else {
                if (this.theData.navItems[itemIndex].open === true) {
                    this.theData.navItems[itemIndex].open = false;
                } else {
                    var strRef = 'secondary-dropdown-' + itemIndex + '_tertiary-item-0';
                    this.closeAllTertiary();
                    this.theData.navItems[itemIndex].open = true;

                    this.$nextTick(function () {
                        _this.$refs[strRef][0].focus();
                    });
                }
            }
        },
        findActiveChild: function findActiveChild(index) {
            // loop through parents children to figure out if this parent is active
            // this.navData.navItems[i].subNav
            var isActive = false;
            var subNav = this.navData.navItems[index].subNav;

            if (subNav !== "" && subNav !== undefined && subNav !== null) {
                for (var i = 0; i < subNav.length; i++) {
                    var subNavItem = subNav[i];

                    if (subNavItem.active === true) {
                        isActive = subNavItem.active;
                        break;
                    }
                } // end for loop

                return isActive;
            } // end if
        },
        // end findActiveChild(index)
        handleSecondaryUp: function handleSecondaryUp(index) {
            var thisItem = this.theData.navItems[index];
            if (thisItem.open) {
                // pressing up arrow on secondary nav level when tertiary is open shoud close it.
                this.theData.navItems[index].open = false;
                var strRef = 'secondary-dropdown-' + index;
                this.$refs[strRef][0].focus();
            }
        },
        handleSecondaryDown: function handleSecondaryDown(index) {
            var _this2 = this;

            var thisItem = this.theData.navItems[index];
            var strRef = 'secondary-dropdown-' + index + '_tertiary-item-0';
            if (thisItem.open) {
                // pressing down arrow on secondary nav level when tertiary is open should transfer focus to first link inside tertiary
                this.$refs[strRef][0].focus();
            } else {
                // Else it will open the tertiary nav and ensure the first subnav item is focused
                this.closeAllTertiary();
                this.theData.navItems[index].open = true;

                this.$nextTick(function () {
                    _this2.$refs[strRef][0].focus();
                });
            }
        },

        // todo here: handle left & right arrow keys for secondary, then handle all directions for tertiary.  excellent resource: https://www.youtube.com/watch?v=SGVSvi1OxE8
        handleEscape: function handleEscape(index) {
            var thisItem = this.theData.navItems[index];
            if (thisItem.open) {
                this.theData.navItems[index].open = false;
                var strRef = 'secondary-dropdown-' + index;
                this.$refs[strRef][0].focus();
            }
        },
        handleTab: function handleTab(subIndex, length) {
            if (subIndex + 1 === length) {
                this.closeAllTertiary();
            }
        },
        handleSecondaryPrevious: function handleSecondaryPrevious(index, length) {
            var thisItem = this.theData.navItems[index];
            var strRef = 'secondary-dropdown-' + (index - 1);

            if (index === 0) {
                return;
            }

            if (thisItem.open) {
                this.theData.navItems[index].open = false;
            }

            this.$refs[strRef][0].focus();
        },
        handleSecondaryNext: function handleSecondaryNext(index, length) {
            var thisItem = this.theData.navItems[index];
            var strRef = 'secondary-dropdown-' + (index + 1);

            if (index + 1 === length) {
                return;
            }

            if (thisItem.open) {
                this.theData.navItems[index].open = false;
            }

            this.$refs[strRef][0].focus();
        },
        handleTertiaryPrevious: function handleTertiaryPrevious(index, length, subIndex) {
            var strRef = 'secondary-dropdown-' + index + '_tertiary-item-' + (subIndex - 1);

            if (subIndex === 0) {
                this.handleSecondaryUp(index);
                return;
            }

            this.$refs[strRef][0].focus();
        },
        handleTertiaryNext: function handleTertiaryNext(index, length, subIndex) {
            var strRef = 'secondary-dropdown-' + index + '_tertiary-item-' + (subIndex + 1);

            if (subIndex + 1 === length) {
                return;
            }

            this.$refs[strRef][0].focus();
        }
    }
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    props: {
        heading: {
            type: String,
            required: true
        },
        headingLevel: {
            type: String,
            "default": "1"
        },
        description: {
            type: String,
            required: false
        },
        link: {
            type: Object,
            required: false
        }
    },
    data: function data() {
        return {};
    }
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _props;

var _memberTierSelectorTab = __webpack_require__(1012);

var _memberTierSelectorTab2 = _interopRequireDefault(_memberTierSelectorTab);

var _memberTierSelectorPanel = __webpack_require__(1014);

var _memberTierSelectorPanel2 = _interopRequireDefault(_memberTierSelectorPanel);

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _ahaLoadingSpinner = __webpack_require__(78);

var _ahaLoadingSpinner2 = _interopRequireDefault(_ahaLoadingSpinner);

var _keyCodes = __webpack_require__(149);

var _keyCodes2 = _interopRequireDefault(_keyCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  name: "member-tier-selector",
  mixins: [_ahaId2["default"]],
  components: {
    "selector-tab": _memberTierSelectorTab2["default"],
    "selector-panel": _memberTierSelectorPanel2["default"],
    "aha-loading-spinner": _ahaLoadingSpinner2["default"]
  },
  props: (_props = {
    uri: {
      type: String,
      "default": ""
    },
    flowType: {
      type: String,
      "default": "new"
    },
    promomsg: {
      type: String,
      "default": "Have a promo code?"
    }
  }, _defineProperty(_props, "promomsg", {
    type: String,
    "default": "Have a promo code?"
  }), _defineProperty(_props, "promoModalHeader", {
    type: String,
    "default": "Processing Request"
  }), _defineProperty(_props, "promoModalMessage", {
    type: String,
    "default": "Associating promo code to order."
  }), _defineProperty(_props, "promoCodeSession", {
    type: String,
    "default": ""
  }), _defineProperty(_props, "warningmessage", {
    type: String,
    "default": ""
  }), _defineProperty(_props, "loadingMessage", {
    type: String,
    "default": "Getting Member Levels"
  }), _defineProperty(_props, "icons", {
    type: Object,
    "default": function _default() {
      return {};
    }
  }), _defineProperty(_props, "componentTitle", {
    type: String,
    "default": "Professional Membership"
  }), _defineProperty(_props, "orderinprogress", {
    type: Boolean,
    "default": false
  }), _defineProperty(_props, "disableSignup", {
    type: Boolean,
    "default": false
  }), _props),
  data: function data() {
    return {
      componentId: null,
      activeItem: "1",
      tierId: null,
      tiercode: "",
      mobile: window.innerWidth <= 700,
      promoCode: null,
      isPromoCodeValid: false,
      tiers: [],
      tiersPromo: [],
      isLoading: true,
      isLoadingPromo: false,
      errorMsg: "",
      promoMsgFromApi: "",
      promoVisible: false,
      earlyCareerTerm: "0",
      termRemaining: null,
      signupUri: {
        base: "/phpapiproxy/signup",
        "default": "",
        upgrade: ""
      },
      referrer: "",
      timer: "",
      timerInterval: 10000,
      computedFlowType: this.flowType,
      tabs: [],
      currentTab: 0,
      tabsInitialized: false,
      signUpButtonText: 'Join or Renew'
    };
  },
  created: function created() {
    // Polyfill for nodelist foreach IE
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }

    if (this.mobile) {
      this.activeItem = " ";
    }
  },

  computed: {
    title: function title() {
      return this.componentTitle.trim() !== "" ? this.componentTitle : "Professional Membership";
    },
    loadingmsg: function loadingmsg() {
      return this.loadingMessage.trim() !== "" ? this.loadingMessage : "Getting Member Levels";
    }
  },
  methods: {
    fetchData: function fetchData() {
      var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/PhpApiProxy/GetMemberTierAsync";

      var _this = this;

      var flowType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "new";
      var promoCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = void 0;

      if (promoCode !== null) {
        raw = JSON.stringify({
          flowType: flowType,
          promoCode: promoCode
        });
        // console.log("RAW BODY: ", raw);
      } else {
        raw = JSON.stringify({
          flowType: flowType
        });
      }

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      fetch(uri, requestOptions).then(function (response) {
        if (response.ok) {
          response.json().then(function (data) {
            _this.tiers = data.result.tiers;
            _this.setActive(String(_this.tiers[0].id), String(_this.tiers[0].code));
            _this.promoMsgFromApi = data.result.promoCodeMessage;
            _this.isPromoCodeValid = data.result.isPromoValid;
            _this.promoCode = data.result.promoCode;
            _this.isLoading = false;
            _this.cancelTimer(); //clear interval on success
            if (_this.isLoadingPromo === true) {
              _this.isLoadingPromo = false;
              _this.completePromoCodeDataFetch();
            }

            // Tabs keyboard accessibility
            // Initialize tabs - create an array of tabs when data is loaded
            _this.$nextTick(function () {
              if (_this.tabsInitialized === false) {
                _this.initalizeTabsKeyboarding();
                _this.tabsInitialized = true;
              }
            });
          });
        } else {
          throw Error(response.status + " " + response.statusText);
        }
      })
      // uncomment for prod
      ["catch"](function (error) {
        _this.errorMsg = error;
        console.log(error);
      });
      //testing only
      // ANCHOR: LOCAL DATA
      //.catch((error) => this.fetchLocalMembershipData());
    },
    fetchLocalMembershipData: function fetchLocalMembershipData() {
      var _this2 = this;

      fetch("./data/upgrade.json").then(function (response) {
        if (response.ok) {
          response.json().then(function (data) {
            _this2.tiers = data.result.tiers;
            _this2.setActive(String(_this2.tiers[0].id), String(_this2.tiers[0].code));
            _this2.promoMsgFromApi = data.result.promoCodeMessage;
            _this2.isPromoCodeValid = data.result.isPromoValid;
            _this2.promoCode = data.result.promoCode;
            _this2.isLoading = false;
            _this2.cancelTimer(); //clear interval on success
            if (_this2.isLoadingPromo === true) {
              _this2.isLoadingPromo = false;
              _this2.completePromoCodeDataFetch();
            }

            // Tabs keyboard accessibility
            // Initialize tabs - create an array of tabs when data is loaded
            _this2.$nextTick(function () {
              if (_this2.tabsInitialized === false) {
                _this2.initalizeTabsKeyboarding();
                _this2.tabsInitialized = true;
              }
            });
          });
        } else {
          throw Error(response.statusText);
        }
      })["catch"](function (error) {
        console.log("Error:", error);
      });
    },
    isActive: function isActive(tierid) {
      return this.activeItem === tierid;
    },
    setActive: function setActive(tierid, tiercode) {
      var _this3 = this;

      this.activeItem = tierid;
      this.tiercode = tiercode;

      this.tabs.forEach(function (t, index) {
        if (t.dataset.tierId == _this3.activeItem) {
          _this3.currentTab = index;
        }
      });
    },
    onHidden: function onHidden() {
      this.activeItem = "";
    },
    onPromoCodeSubmit: function onPromoCodeSubmit() {
      // ANCHOR: Promo Submit
      this.$root.$emit("bv::show::modal", "loadingModal");

      this.$root.$emit("bv::toggle::collapse", "collapse-promo-code");
      var promoBtn = document.querySelector(".c-promo-code .c-promo-code__btn");
      var enteredPromoCode = document.getElementById("inputPromoCode").value;

      this.fetchData(this.uri, this.computedFlowType, enteredPromoCode);
      this.isLoadingPromo = true;
    },
    completePromoCodeDataFetch: function completePromoCodeDataFetch() {
      var _this4 = this;

      setTimeout(function () {
        _this4.$root.$emit("bv::hide::modal", "loadingModal");
        _this4.$refs.formpromo.reset();
        if (_this4.promoCode !== null) {
          _this4.showHidePromoAppliedDisplay("show");
        }
      }, 1500);
    },
    onDataReset: function onDataReset() {
      this.$root.$emit("bv::show::modal", "loadingModal");
      this.promoCode = null;
      this.isLoadingPromo = true;
      this.fetchData(this.uri, this.computedFlowType, this.promoCode);
    },
    onSignUp: function onSignUp(evt) {
      // ANCHOR: Signup
      evt.preventDefault();
      if (this.orderinprogress) return;
      var _code = evt.target.dataset["tierCode"];
      var _tierid = evt.target.dataset["tierId"];
      var _termRemaining = evt.target.dataset["termRemaining"];

      // EC
      if (_termRemaining && _code !== "ST") {
        this.termRemaining = evt.target.dataset["termRemaining"];
      } else {
        this.termRemaining = null;
      }

      // console.log(evt.target.dataset);
      this.setSignupUriDefault(_tierid, encodeURIComponent(this.promoCode), this.earlyCareerTerm, this.referrer, this.computedFlowType || "new");

      // Is institutional by the tiers return from api
      if (this.tiers.length === 1) {
        window.location.href = this.signupUri["default"];
      } else {
        if (_code === "EC") {
          this.$root.$emit("bv::show::modal", "ec-membership-modal");
        } else if (_code === "GM") {
          this.$root.$emit("bv::show::modal", "gp-upgrade-modal");
          this.signupUri.upgrade = this.signupUri.base + "?tierId=2&promoCode=" + this.promoCode + "&earlyCareerTerm=" + this.earlyCareerTerm + "&ru=" + this.referrer + "&flowType=" + this.computedFlowType;
        } else if (_code === "ST") {
          this.$root.$emit("bv::show::modal", "st-membership-modal");
        } else {
          //go to new location
          window.location.href = this.signupUri["default"];
        }
      }

      if (_code === "EC") {
        this.earlyCareerTerm = 1;
      } else {
        this.earlyCareerTerm = 0;
      }
    },
    setEarlyCareerTerm: function setEarlyCareerTerm(num) {
      this.earlyCareerTerm = num;
    },
    setSignupUriDefault: function setSignupUriDefault(_activeItem, _promocode, _ec, _referrer, flowType) {
      this.signupUri["default"] = this.signupUri.base + "?tierId=" + _activeItem + "&promoCode=" + _promocode + "&earlyCareerTerm=" + _ec + "&ru=" + _referrer + "&flowType=" + flowType;
    },
    getTierIcon: function getTierIcon(_tiercode) {
      var code = _tiercode;
      var icons = this.icons.membershipicons;
      var icon_path = "";
      if (icons) {
        icons.forEach(function (icon) {
          if (icon.code === code) {
            icon_path = icon.path;
          }
        });
      }

      return icon_path;
    },
    getReferrer: function getReferrer() {
      function getUrlParameter(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
        var results = regex.exec(location.search);
        // return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        return results === null ? "" : results[1];
      }

      this.referrer = getUrlParameter("ru");
      //this.computedFlowType = getUrlParameter('flowType') || this.computedFlowType; //this is changing the flowType prop
      if (getUrlParameter("c")) {
        this.computedFlowType = getUrlParameter("flowType");
      }
      if (this.promoCodeSession === '') {
        this.promoCode = getUrlParameter("promoCode") || null;
      } else {
        this.promoCode = this.promoCodeSession;
      }
    },
    closePromoCodeAppliedDisplay: function closePromoCodeAppliedDisplay($evt) {
      this.showHidePromoAppliedDisplay("hide");
      if (this.isPromoCodeValid === true) {
        this.onDataReset();
      }
    },
    showHidePromoAppliedDisplay: function showHidePromoAppliedDisplay(state) {
      // state = 'show', 'hide'
      var _state = state;
      var _el = document.querySelector(".c-promo-code__display-wrapper");
      var _className = "d-none";

      if (_state === "hide") {
        _el.classList.add(_className);
      } else {
        if (_el.classList.contains(_className)) {
          _el.classList.remove(_className);
        }
      }
    },
    cancelTimer: function cancelTimer() {
      clearInterval(this.timer);
    },
    onPromoCodeKeydown: function onPromoCodeKeydown(event) {
      // esc to close
      // if (event.keyCode === KeyCodes.ESC || event.key === "Escape") {
      //   this.promoVisible = false;
      // }
      // Down arrow to expand
      if (event.keyCode === _keyCodes2["default"].DOWN || event.key === "ArrowDown") {
        event.preventDefault();
        this.promoVisible = true;
      }
    },
    onKeynav: function onKeynav(evt) {
      // ANCHOR: Keyboard Nav
      // Tab item keyboarding
      var key = evt.keyCode;
      var shift = evt.shiftKey;

      function stop() {
        evt.preventDefault();
        evt.stopPropagation();
      }

      if (key === _keyCodes2["default"].UP || key === _keyCodes2["default"].LEFT) {
        stop();
        this.previousTab();
      } else if (key === _keyCodes2["default"].DOWN || key === _keyCodes2["default"].RIGHT) {
        stop();
        this.nextTab();
      }
    },
    setTab: function setTab(index) {
      var _this5 = this;

      // ANCHOR: SET TAB
      index = index || 0;
      // Prevent setting same tab
      if (index === this.currentTab) {
        return;
      }

      var tab = this.tabs[index];

      // Don't go beyond indexes!
      if (!tab) {
        console.log("Outside index");
        return;
      }

      // Activate requested current tab, and deactivate any old tabs
      this.tabs.forEach(function (t) {
        if (t === tab) {
          // Set new tab as active
          _this5.setActive(tab.dataset.tierId, tab.dataset.tier);
          setTimeout(function () {
            tab.focus();
          }, 0);
        } else {
          // Ensure non current tabs are not active
        }
      });
      // Update currentTab
      this.currentTab = index;
    },
    previousTab: function previousTab() {
      this.setTab(this.currentTab - 1);
    },
    nextTab: function nextTab() {
      this.setTab(this.currentTab + 1);
    },
    initalizeTabsKeyboarding: function initalizeTabsKeyboarding() {
      // ANCHOR: INITIALIZE TABS FOR KEYBOARDING
      // Initialize when content is loaded
      var tabs = this.$el.querySelectorAll('a[role="tab"]');
      this.tabs = tabs;
    }
  },
  watch: {
    earlyCareerTerm: {
      handler: function handler(newValue, oldValue) {
        this.setSignupUriDefault(this.activeItem, this.promoCode, this.earlyCareerTerm, this.referrer, this.computedFlowType);
      },
      deep: false
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    // console.log("prop flow-type: ", this.computedFlowType);
    this.componentId = this.safeId("__PHD_selector_");
    this.getReferrer(); // Get values from the query string
    this.fetchData(this.uri, this.computedFlowType || "new", this.promoCode);
    // Call fertchData again after 20 seconds, to solve api being idle
    this.timer = setInterval(function () {
      _this6.fetchData(_this6.uri, _this6.computedFlowType || "new", _this6.promoCode);
    }, this.timerInterval);

    if (this.flowType === 'upgrade') {
      this.signUpButtonText = "Upgrade Now";
    }

    // Close promo box on keypress - escape key
    document.addEventListener("keydown", function (evt) {
      if (evt.keyCode === _keyCodes2["default"].ESCAPE || evt.key === "Escape" && _this6.promoVisible === true) {
        console.log("esc");
        _this6.promoVisible = false;
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  }
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  name: "selector-tab",
  props: {
    tierid: "",
    tiercode: ""
  },
  methods: {
    setParentActive: function setParentActive() {
      this.$parent.setActive(String(this.tierid), String(this.tiercode));
    }
  }
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keyCodes = __webpack_require__(149);

var _keyCodes2 = _interopRequireDefault(_keyCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    name: 'selector-panel',
    props: {
        tierid: '',
        displayname: '',
        price: '',
        discountPrice: '',
        tiercode: ''
    },
    data: function data() {
        return {
            visible: false
        };
    },

    computed: {
        collapseid: function collapseid() {
            return 'collapse-panel-' + this.tierid;
        }
    },
    methods: {
        setParentActive: function setParentActive() {
            this.$parent.setActive(String(this.tierid));
        },
        openOnKeyDown: function openOnKeyDown() {
            // Down arrow to expand
            if (event.keyCode === _keyCodes2['default'].DOWN || event.key === "ArrowDown") {
                event.preventDefault();
                this.visible = true;
            }

            if (event.keyCode === _keyCodes2['default'].ESCAPE || event.key === "Escape") {
                event.preventDefault();
                this.visible = false;
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        var tabbables = this.$el.querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
        var lastTabbable = tabbables[tabbables.length - 1];
        if (window.getComputedStyle(lastTabbable).display === 'none') {
            lastTabbable = tabbables[tabbables.length - 2];
        }
        lastTabbable.addEventListener('keydown', function (evt) {
            _this.$parent.nextTab();
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _utils = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    mixins: [_ahaId2['default']],
    data: function data() {
        return {
            isChecked: false,
            checkboxId: null
        };
    },
    props: {
        checkClass: {
            type: String
        }
    },
    computed: {
        containerClasses: function containerClasses() {
            return [this.isChecked ? 'is-checked' : '', this['class']];
        },
        containerAttributes: function containerAttributes() {
            return {
                'role': 'checkbox',
                'aria-checked': this.isChecked.toString(),
                'tabindex': 0,
                'aria-labelledby': this.checkboxId
            };
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.checkboxId = this.safeId('_PHD_checkbox_');
        // on hidden
        this.$root.$on('bv::modal::hidden', function (bvEvent, modalId) {
            if (bvEvent.vueTarget.$options.propsData.id === _this.$parent.$options.propsData.id) {
                _this.isChecked = false;
                var elm = _this.$parent.$el.querySelector('.checked-continue');
                _this.resetClass(elm, 'disabled');
                // toggleClass(this.$parent.$el.querySelector('.ec-continue'))
            }
        });
    },

    methods: {
        toggleChecked: function toggleChecked(evt) {
            if (evt.type === 'click' || evt.keyCode === _utils.KeyCodes.SPACE) {
                evt.preventDefault();
                this.isChecked = !this.isChecked;
                var elm = this.$parent.$el.querySelector('.checked-continue');
                console.log('element ', elm);
                this.toggleClass(elm, 'disabled');
            }
        },
        toggleClass: function toggleClass(elm, classname) {
            console.log('toggle', elm, classname);
            elm.classList.toggle(classname);
        },
        resetClass: function resetClass(elm, classname) {
            if (!elm.classList.contains(classname)) {
                elm.classList.add(classname);
            }
        }
    }
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        uri: {
            type: String,
            'default': ""
        },
        community: {
            type: Number,
            'default': 2
        },
        numbertoshow: {
            type: Number,
            'default': 5
        }
    },
    data: function data() {
        return {
            apiData: []
            // demoResponse is for testing data only
            // demoResponse: {
            //     "statusCode": 200,
            //     "status": "OK",
            //     "errors": null,
            //     "result": [
            //         {
            //             "eventId": null,
            //             "eventCode": "6598455",
            //             "eventName": "Giantbomb Gaming News",
            //             "eventLink": 'http://giantbomb.com',
            //             "eventDescription": "This is a fake description for Giantbomb.com's gaming news event thingy for testing purposes.",
            //             "startDate": null,
            //             "startTime": "",
            //             "endDate": null,
            //             "endTime": "",
            //             "creditHours": "0.25",
            //             "facility": null,
            //             "facilityCity": "",
            //             "facilityState": "",
            //             "releaseDate": null,
            //             "expirationDate": null,
            //             "lmsActivityKeyword": []
            //         },
            //         {
            //             "eventId": null,
            //             "eventCode": "6598706",
            //             "eventName": "Google-a-thon",
            //             "eventLink": "https://google.com",
            //             "eventDescription": "This is a story all about how my life got flipped turned upside down, let me take a minute you just sit right there and I'll tell you how I became the prince of a town called Bel-Air.",
            //             "startDate": null,
            //             "startTime": "",
            //             "endDate": null,
            //             "endTime": "",
            //             "creditHours": "0.25",
            //             "facility": null,
            //             "facilityCity": "",
            //             "facilityState": "",
            //             "releaseDate": null,
            //             "expirationDate": null,
            //             "lmsActivityKeyword": []
            //         },
            //         {
            //             "eventId": null,
            //             "eventCode": "6598565",
            //             "eventName": "Test Event 3",
            //             "eventLink": "https://arstechnica.com",
            //             "eventDescription": "This webinar series covers evaluation of patients with cryptogenic stroke, cardiac monitoring and the role of atrial cardiopathy; and the management Strategies for patients with cryptogenic stroke. Descriptions and accreditations are shown under Activity Information. Accreditation is claimed separately on each activity. Click the Register button to purchase the bundle.",
            //             "startDate": null,
            //             "startTime": "",
            //             "endDate": null,
            //             "endTime": "",
            //             "creditHours": "0.25",
            //             "facility": null,
            //             "facilityCity": "",
            //             "facilityState": "",
            //             "releaseDate": null,
            //             "expirationDate": null,
            //             "lmsActivityKeyword": []
            //         },
            //         {
            //             "eventId": null,
            //             "eventCode": "6598565",
            //             "eventName": "Test Event 4",
            //             "eventLink": "https://polygon.com",
            //             "eventDescription": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi quis iste, nemo corporis iusto ipsam fugiat voluptate unde, neque temporibus perferendis blanditiis atque ea distinctio dolorum, dolor sed ducimus nihil!",
            //             "startDate": null,
            //             "startTime": "",
            //             "endDate": null,
            //             "endTime": "",
            //             "creditHours": "0.25",
            //             "facility": null,
            //             "facilityCity": "",
            //             "facilityState": "",
            //             "releaseDate": null,
            //             "expirationDate": null,
            //             "lmsActivityKeyword": []
            //         }
            //     ]
            // }
        };
    },
    beforeMount: function beforeMount() {
        this.getApiData();
    },

    methods: {
        getApiData: function getApiData() {
            var _this = this;

            _axios2['default'].get(this.uri, {
                params: {
                    communityId: this.community
                }
            }).then(function (response) {
                _this.apiData = response.data.result;
                // console.log('***Data successfully retrieved***');
                // console.log('apiData: ', this.apiData);
            })['catch'](function (error) {
                console.log('getApiData Error: ', error);
            });

            // Example Response - uncomment this line if you need to see this thing actually work
            // this.apiData = this.demoResponse.result;
        } // getApiData

    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  data: function data() {
    return {
      isAgeValidate: false,
      isMlvwtValidate: false,
      isLasizeValidate: false,
      isMaxlovtValidate: false,
      isAgeRequired: false,
      isMlvwtRequired: false,
      isLasizeRequired: false,
      isMaxlvotRequired: false,
      ageToolTip: true,
      mlvwtToolTip: true,
      lasizeToolTip: true,
      maxlvotToolTip: true,
      fhscdToolTip: true,
      nsvtToolTip: true,
      unexSyToolTip: true,
      ef50ToolTip: true,
      apAnToolTip: true,
      elgeToolTip: true,
      age_range: {
        value: "",
        ageRange: {
          min: 16,
          max: 80
        },
        requiredMessage: "Please enter your age",
        errorMessage: "Age input should be between 16 to 80 years."
      },
      mlvwt_range: {
        value: "",
        wallThickness: {
          min: 10,
          max: 35
        },
        requiredMessage: "Please enter the wall thickness",
        errorMessage: "Maximal wall thickness input should be between 10mm and 35mm."
      },
      lasize_range: {
        value: "",
        laDiameter: {
          min: 28,
          max: 67
        },
        requiredMessage: "Please enter the LA Diameter",
        errorMessage: "LA Diameter input should be between 28mm and 67mm."
      },
      maxlvot_range: {
        value: "",
        lvotGradient: {
          min: 2,
          max: 154
        },
        requiredMessage: "Please enter the LVOT Gradient",
        errorMessage: "LVOT Gradient input should be between 2mmHg and 154mmHg."
      },
      fhscd_pick: 0,
      nsvt_pick: 0,
      unexSy_pick: 0,
      ef50_pick: 0,
      apAn_pick: 0,
      elge_pick: 0,
      recommendation: "",
      risk: {
        value: ""
      }
    };
  },

  methods: {
    hcmCalculatorFormula: function hcmCalculatorFormula() {
      var age = this.age_range;
      var mlvwt = this.mlvwt_range;
      var lasize = this.lasize_range;
      var maxlvot = this.maxlvot_range;
      var fhscd = this.fhscd_pick;
      var nsvt = this.nsvt_pick;
      var unexSyncope = this.unexSy_pick;
      var ef50 = this.ef50_pick;
      var aa = this.apAn_pick;
      var elge = this.elge_pick;

      var a = 0.01799934 * age.value;
      var b = 0.15939858 * mlvwt.value - 0.00294271 * mlvwt.value * mlvwt.value;
      var c = 0.0259082 * lasize.value;
      var d = 0.00446131 * maxlvot.value;
      var e = fhscd === 0 ? 0 : 0.4583082;
      var f = nsvt === 0 ? 0 : 0.82639195;
      var g = unexSyncope === 0 ? 0 : 0.71650361;
      var h = mlvwt.value <= 29 ? 0 : 1;
      var i = ef50 === 0 ? 0 : 1;
      var j = null;
      var k = b + c + d + e + f + g - a;
      var l = Math.pow(2.71828183, k);
      var m = Math.pow(0.998, l);
      var risk = 100 * (1 - m);

      var elgeYes = elge == 1;
      var aaYes = aa == 1;
      var efYes = i == 1;
      var nsvtYes = f == 0.82639195;
      var fhscdYes = e == 0.4583082;
      var usYes = g == 0.71650361;
      var mlvwtYes = h == 1;

      switch (true) {
        //Class 2A: When one parameter AND NSVT AND Extensive LGE = YES
        case elgeYes && nsvtYes && aaYes && efYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%, Apical Aneurysm, and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge, aa, ef & nsvt are yes");
          break;
        case efYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge & nsvt");
          break;
        case aaYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge & nsvt");
          break;
        case fhscdYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("fhscd, elge, nsvt are yes");
          break;
        case usYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("US, elge, nsvt are yes");
          break;
        case mlvwtYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("mlvwt, elge, nsvt are yes");
          break;
        case elgeYes && efYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm, EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge,ef,aa are yes");
          break;
        case nsvtYes && efYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Apical Aneursym)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge,ef,aa are yes");
          break;

        //Class 2B(a): When all parameters = NO except for NVST AND Extensive LGE
        case elgeYes && nsvtYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "This patient has 2 risk factors that while individually carry Class 2B indications, having both of these likely represents more risk than having either risk factor in isolation";
          console.log("elge & nsvt");
          break;

        //Class 2A: When any parameter AND EXTENSIVE LGE = YES
        case elgeYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("switch elge & aa");
          break;
        case elgeYes && efYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge & ef are yes");
          break;
        case elgeYes && fhscdYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("FHSCD and ELGE are yes");
          break;
        case elgeYes && usYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("Unexplained Syncope and ELGE are yes");
          break;
        case elgeYes && mlvwtYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("MLVWT and ELGE are yes");
          break;

        //Class 2A: When any parameter AND NVST = YES
        case nsvtYes && efYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("EF and NSVT are yes");
          break;
        case nsvtYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("EF and NSVT are yes");
          break;
        case nsvtYes && fhscdYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("FHSCD and NSVT are yes");
          break;
        case nsvtYes && usYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("Unexplained Syncope and NSVT are yes");
          break;
        case nsvtYes && mlvwtYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("MLVWT and NSVT are yes");
          break;

        //Class 2A: When any parameter except for NSVT and Extensive LGE = YES
        case efYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("EF and AA are yes");
          break;

        //Class 2B: When all parameters = NO except for NVST OR Extensive LGE
        case nsvtYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD risk factors present, this patient has a Class 2B indication for an ICD (may be considered)";
          console.log("nsvtYes");
          break;
        case elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD risk factors present, this patient has a Class 2B indication for an ICD (may be considered)";
          console.log("elge catch all");
          break;

        //Class 2A: When any parameter except for NSVT and Extensive LGE = YES
        case efYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("EF is Yes");
          break;
        case aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("Apical aneurysm is yes");
          break;
        case fhscdYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("fhscd is yes");
          break;
        case usYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("Unexplained Syncope is Yes");
          break;
        case mlvwtYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("mlvwt is yes");
          break;
        default:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the absence of risk factors, this patient does not have an indication for an  <span class='abbr' title='Implantable Cardioverter Defibrillator'><abbr title='Implantable Cardioverter Defibrillator'>ICD</abbr></span>  (Class 3 – No Benefit)";
          console.log("all no");
          break;
      }
    },
    validateAge: function validateAge() {
      if (this.age_range.value >= this.age_range.ageRange.min && this.age_range.value <= this.age_range.ageRange.max) {
        console.log("within range");
        this.isAgeValidate = false;
      } else {
        console.log("outside range");
        this.isAgeValidate = true;
      }
    },
    validateMlvwt: function validateMlvwt() {
      if (this.mlvwt_range.value >= this.mlvwt_range.wallThickness.min && this.mlvwt_range.value <= this.mlvwt_range.wallThickness.max) {
        console.log("within range");
        this.isMlvwtValidate = false;
      } else {
        console.log("outside range");
        this.isMlvwtValidate = true;
      }
    },
    validateLasize: function validateLasize() {
      if (this.lasize_range.value >= this.lasize_range.laDiameter.min && this.lasize_range.value <= this.lasize_range.laDiameter.max) {
        console.log("within range");
        this.isLasizeValidate = false;
      } else {
        console.log("outside range");
        this.isLasizeValidate = true;
      }
    },
    validateMaxlovt: function validateMaxlovt() {
      if (this.maxlvot_range.value >= this.maxlvot_range.lvotGradient.min && this.maxlvot_range.value <= this.maxlvot_range.lvotGradient.max) {
        console.log("within range");
        this.isMaxlovtValidate = false;
      } else {
        console.log("outside range");
        this.isMaxlovtValidate = true;
      }
    },
    formValidate: function formValidate(e) {
      if (this.age_range.value == "") {
        this.isAgeRequired = true;
        console.log("number not entered");
        e.preventDefault();
      } else {
        this.isAgeRequired = false;
        console.log("number entered");
      }

      if (this.mlvwt_range.value == "") {
        this.isMlvwtRequired = true;
        console.log("number not entered");
        e.preventDefault();
      } else {
        this.isMlvwtRequired = false;
        console.log("number entered");
      }

      if (this.lasize_range.value == "") {
        this.isLasizeRequired = true;
        console.log("number not entered");
        e.preventDefault();
      } else {
        this.isLasizeRequired = false;
        console.log("number  entered");
      }

      if (this.maxlvot_range.value == "") {
        this.isMaxlvotRequired = true;
        console.log("number not entered");
        e.preventDefault();
      } else {
        this.isMaxlvotRequired = false;
        console.log("number entered");
      }
    },
    resetForm: function resetForm() {
      this.age_range.value = "";
      this.mlvwt_range.value = "";
      this.lasize_range.value = "";
      this.maxlvot_range.value = "";
      this.fhscd_pick = 0;
      this.nsvt_pick = 0;
      this.unexSy_pick = 0;
      this.ef50_pick = 0;
      this.apAn_pick = 0;
      this.elge_pick = 0;
      this.risk.value = "";
      this.recommendation = "";
      this.isAgeValidate = false;
      this.isMlvwtValidate = false;
      this.isLasizeValidate = false;
      this.isMaxlovtValidate = false;
      this.isAgeRequired = false;
      this.isMlvwtRequired = false;
      this.isLasizeRequired = false;
      this.isMaxlvotRequired = false;
      this.ageToolTip = true;
      this.mlvwtToolTip = true;
      this.lasizeToolTip = true;
      this.maxlvotToolTip = true;
      this.fhscdToolTip = true;
      this.nsvtToolTip = true;
      this.unexSyToolTip = true;
      this.ef50ToolTip = true;
      this.apAnToolTip = true;
      this.elgeToolTip = true;
    }
  }
};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    props: {
        references: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            activeId: null,
            sourceAnchor: null
        };
    },
    computed: {
        allIds: function allIds() {
            return this.references.map(function (contentObject) {
                return contentObject.id;
            });
        }
    },
    mounted: function mounted() {
        var _this = this;

        var parentCollapseButtons = [];
        var parentCollapse = this.$refs.eccReferences.closest('.nested-accordion__collapse');

        while (parentCollapse) {
            var previousElementSibling = parentCollapse.previousElementSibling;
            if (parentCollapse && previousElementSibling && previousElementSibling.classList && previousElementSibling.classList.contains('nested-accordion__toggle-button')) {
                parentCollapseButtons.push(previousElementSibling);
                parentCollapse = previousElementSibling.closest('.nested-accordion__collapse');
            } else {
                parentCollapse = null;
            }
        }

        document.body.addEventListener('click', function (e) {
            var forceScroll = false;
            var hashId = e.target.hash ? e.target.hash.substr(1) : false;
            if (hashId) {
                _this.sourceAnchor = e.target;
            }

            var activeIdIndex = _this.allIds.indexOf(hashId) > -1 ? _this.allIds.indexOf(hashId) : -1;
            if (activeIdIndex > -1) {
                _this.activeId = _this.allIds[activeIdIndex];

                if (parentCollapseButtons.length > 0) {
                    parentCollapseButtons.forEach(function (collapseButton) {
                        var collapseId = collapseButton.getAttribute('aria-controls');
                        if (collapseButton.getAttribute('aria-expanded') === 'false' && collapseId) {
                            e.preventDefault();
                            _this.$root.$emit('bv::toggle::collapse', collapseId);
                            forceScroll = true;
                        }
                    });

                    if (forceScroll) {
                        setTimeout(function () {
                            _this.$refs[hashId][0].scrollIntoView();
                        }, 500);
                    }
                }
            }
        });
    },

    methods: {
        returnToText: function returnToText() {
            var _this2 = this;

            if (this.sourceAnchor) {
                this.$nextTick(function () {
                    _this2.sourceAnchor.scrollIntoView();
                    _this2.sourceAnchor = null;
                });
            }
            this.activeId = null;
        }
    }
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    props: {
        mapData: {
            type: Array,
            required: false
        },
        mapSettings: {
            type: Object,
            required: false,
            'default': function _default() {
                return {
                    mapHeight: '500px',
                    activeStateColor: '#ce2a23',
                    inactiveStateColor: '#6f859a',
                    hiddenStateAbbrev: ['MD', 'RI', 'CT', 'MA', 'NH', 'DC', 'DE', 'NJ', 'VT'],
                    showAccessibleStateSelector: true,
                    screenReaderMapTitle: 'CPR In Schools Legislation Map',
                    selectorButtonLabel: 'Select',
                    blankSelectorOptionLabel: 'Select A State'
                };
            }
        }
    },
    data: function data() {
        return {
            chart: null,
            statesList: []
        };
    },
    computed: {
        amchartsPresent: function amchartsPresent() {
            return window.am4core ? true : false;
        },
        mapDataPresent: function mapDataPresent() {
            return Array.isArray(this.mapData) ? this.mapData.length > 0 ? true : false : false;
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (this.amchartsPresent) {
            am4core.ready(function () {
                _this.initMap();
            });
        }
    },
    beforeDestroy: function beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
        }
    },

    methods: {
        initMap: function initMap() {
            var _this2 = this;

            // Themes begin
            am4core.useTheme(am4themes_animated);
            // Themes end

            // Create map instance
            var chart = am4core.create(this.$refs.chartdiv, am4maps.MapChart);
            chart.readerTitle = this.mapSettings.screenReaderMapTitle;
            chart.role = null;
            chart.svgContainer.hideOverflow = true;

            // Set map definition
            chart.geodata = am4geodata_usaLow;

            // Set projection
            chart.projection = new am4maps.projections.AlbersUsa();
            // chart.projection.role = '';

            // Set focus styles
            chart.focusFilter.strokeWidth = 0;

            // Create map polygon series
            var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
            polygonSeries.readerTitle = '';
            polygonSeries.role = '';
            polygonSeries.dataFields.line1 = 'line1';
            polygonSeries.dataFields.line2 = 'line2';
            polygonSeries.dataFields.line3 = 'line3';
            polygonSeries.dataFields.url = 'url';
            polygonSeries.sortPolygonsBy = 'name';

            polygonSeries.heatRules.push({
                property: "fill",
                target: polygonSeries.mapPolygons.template,
                min: am4core.color(this.mapSettings.inactiveStateColor),
                max: am4core.color(this.mapSettings.activeStateColor)
            });

            // Make map load polygon data (state shapes and names) from GeoJSON
            polygonSeries.useGeodata = true;
            polygonSeries.calculateVisualCenter = true;

            // Set heatmap values for each state
            polygonSeries.data = this.mapData;

            // Create series tooltip
            polygonSeries.tooltip.getFillFromObject = false;
            polygonSeries.tooltip.background.fill = am4core.color("#fff");
            polygonSeries.tooltip.background.fillOpacity = 1;
            polygonSeries.tooltip.background.cornerRadius = 4;
            polygonSeries.tooltip.background.strokeWidth = 0;
            polygonSeries.tooltip.label.fill = am4core.color("#000");
            polygonSeries.tooltip.fillOpacity = 1;
            polygonSeries.tooltip.label.interactionsEnabled = true;

            if (window.innerWidth >= 1024) {
                polygonSeries.tooltip.fontSize = '0.8rem';
            } else {
                polygonSeries.tooltip.fontSize = '0.7rem';
                polygonSeries.tooltip.keepTargetHover = true;
                chart.homeZoomLevel = 1.1;
                polygonSeries.tooltip.label.maxWidth = 250;
                polygonSeries.tooltip.label.wrap = true;
            }

            // Configure series tooltip
            var polygonTemplate = polygonSeries.mapPolygons.template;
            polygonTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer;
            polygonTemplate.tooltipPosition = 'fixed';
            polygonTemplate.hoverOnFocus = true;

            if (window.innerWidth >= 1024) {
                polygonTemplate.tooltipText = "[bold]{name}\n[/]{line1}\n{line2}\n{line3}";
            } else {
                // Caution, setting custom tooltip HTML breaks IE support, use for mobile only
                polygonTemplate.tooltipHTML = '\n                    <p class="c-svg-map__tooltip-header">{name} <a href=\'{url}\' target=\'_blank\'>(Link)</a></p>\n                    <span class="c-svg-map__tooltip-content-line">{line1}</span>\n                    <span class="c-svg-map__tooltip-content-line">{line2}</span>\n                    <span class="c-svg-map__tooltip-content-line">{line3}</span>\n                ';
                polygonTemplate.userClassName = 'c-svg-map__disable-clicks';
            }

            polygonTemplate.nonScalingStroke = true;
            polygonTemplate.strokeWidth = 1.5;

            // Create series labels
            var labelSeries = chart.series.push(new am4maps.MapImageSeries());
            labelSeries.readerTitle = '';
            labelSeries.role = '';
            var labelTemplate = labelSeries.mapImages.template.createChild(am4core.Label);
            labelTemplate.horizontalCenter = "middle";
            labelTemplate.verticalCenter = "middle";
            labelTemplate.fill = am4core.color("#fff");
            labelTemplate.fontWeight = "bold";
            labelTemplate.interactionsEnabled = false;

            if (window.innerWidth >= 1024) {
                labelTemplate.fontSize = ".9rem";
            } else {
                labelTemplate.fontSize = ".7rem";
            }

            polygonSeries.events.on("inited", function () {
                polygonSeries.mapPolygons.each(function (polygon) {
                    if (polygon.dataItem.dataContext.id === undefined) {
                        return;
                    }

                    _this2.statesList.unshift({
                        id: polygon.dataItem.dataContext.id,
                        name: polygon.dataItem.dataContext.name
                    });

                    var label = labelSeries.mapImages.create();
                    label.tabindex = -1;
                    var stateAbbrev = polygon.dataItem.dataContext.id.split("-").pop();
                    var value = polygon.dataItem.dataContext.value;
                    var hiddenStateIndex = _this2.mapSettings.hiddenStateAbbrev.indexOf(stateAbbrev);
                    polygon.readerTitle = polygon.dataItem.dataContext.name + ': ';

                    if (polygon.dataItem.dataContext.line1) {
                        polygon.readerTitle += polygon.dataItem.dataContext.line1;
                    }

                    if (polygon.dataItem.dataContext.line2) {
                        polygon.readerTitle += polygon.dataItem.dataContext.line2;
                    }

                    if (polygon.dataItem.dataContext.line3) {
                        polygon.readerTitle += polygon.dataItem.dataContext.line3;
                    }

                    if (hiddenStateIndex > -1) {
                        label.background = new am4core.RoundedRectangle();
                        label.background.cornerRadius(4, 4, 4, 4);
                        label.ignoreBounds = true;

                        if (value === '1') {
                            label.background.fill = am4core.color(_this2.mapSettings.activeStateColor);
                        } else if (value === '0') {
                            label.background.fill = am4core.color(_this2.mapSettings.inactiveStateColor);
                        }

                        label.fontWeight = 'bold';
                        label.textAlign = 'middle';
                        label.textValign = 'middle';
                        label.contentAlign = 'middle';
                        label.contentValign = 'middle';
                        label.children.getIndex(0).text = stateAbbrev;
                        label.cursorOverStyle = am4core.MouseCursorStyle.pointer;

                        if (window.innerWidth < 576) {
                            label.fontSize = '.7rem';
                            label.width = 25;
                            label.height = 13;
                            label.paddingTop = 7;
                            label.paddingLeft = 13;

                            if (hiddenStateIndex < 5) {
                                var lat = 35.00 + hiddenStateIndex * 2;
                                var lng = -70.71 + hiddenStateIndex * .7;
                                label.latitude = lat;
                                label.longitude = lng;
                            } else {
                                var _lat = 23.93 + hiddenStateIndex * 2;
                                var _lng = -78.71 + hiddenStateIndex * .6;
                                label.latitude = _lat;
                                label.longitude = _lng;
                            }
                        } else if (window.innerWidth < 768) {
                            label.fontSize = '.7rem';
                            label.width = 32;
                            label.height = 19;
                            label.paddingTop = 11;
                            label.paddingLeft = 16;

                            if (hiddenStateIndex < 5) {
                                var _lat2 = 35.80 + hiddenStateIndex * 1.6;
                                var _lng2 = -71.10 + hiddenStateIndex * .6;
                                label.latitude = _lat2;
                                label.longitude = _lng2;
                            } else {
                                var _lat3 = 26.93 + hiddenStateIndex * 1.6;
                                var _lng3 = -77.71 + hiddenStateIndex * .45;
                                label.latitude = _lat3;
                                label.longitude = _lng3;
                            }
                        } else if (window.innerWidth < 992) {
                            label.fontSize = '.7rem';
                            label.width = 32;
                            label.height = 19;
                            label.paddingTop = 11;
                            label.paddingLeft = 16;

                            if (hiddenStateIndex < 5) {
                                var _lat4 = 36.93 + hiddenStateIndex * 1.1;
                                var _lng4 = -70.51 + hiddenStateIndex * .4;
                                label.latitude = _lat4;
                                label.longitude = _lng4;
                            } else {
                                var _lat5 = 30.93 + hiddenStateIndex * 1.1;
                                var _lng5 = -75.71 + hiddenStateIndex * .35;
                                label.latitude = _lat5;
                                label.longitude = _lng5;
                            }
                        } else if (window.innerWidth >= 992) {
                            label.fontSize = '.9rem';
                            label.width = 32;
                            label.height = 19;
                            label.paddingTop = 11;
                            label.paddingLeft = 16;

                            if (hiddenStateIndex < 5) {
                                var _lat6 = 36.93 + hiddenStateIndex * 1.1;
                                var _lng6 = -70.51 + hiddenStateIndex * .4;
                                label.latitude = _lat6;
                                label.longitude = _lng6;
                            } else {
                                var _lat7 = 30.93 + hiddenStateIndex * 1.1;
                                var _lng7 = -75.71 + hiddenStateIndex * .35;
                                label.latitude = _lat7;
                                label.longitude = _lng7;
                            }
                        }

                        label.events.on("over", function (e) {
                            polygon.isHover = true;
                            // This is needed so that "unhovering" previous polygon does not hide tooltip
                            e.target.isHover = false;
                            e.target.isHover = true;
                        });

                        label.events.on("out", function (e) {
                            polygon.isHover = false;
                        });

                        if (window.innerWidth >= 1024) {
                            label.events.on("over", function (e) {
                                label.url = polygon.dataItem.dataContext.url;
                                label.urlTarget = 'blank';
                            });

                            label.events.on("out", function (e) {
                                label.url = null;
                                label.urlTarget = null;
                            });
                        } else {
                            label.userClassName = 'c-svg-map__disable-clicks';
                        }
                    } else {
                        label.latitude = polygon.visualLatitude;
                        label.longitude = polygon.visualLongitude;
                        label.children.getIndex(0).text = stateAbbrev;
                    }

                    if (window.innerWidth >= 1024) {
                        polygon.events.on('over', function () {
                            polygon.url = polygon.dataItem.dataContext.url;
                            polygon.urlTarget = 'blank';
                        });

                        polygon.events.on('out', function () {
                            polygon.url = null;
                            polygon.urlTarget = null;
                        });
                    }

                    var hoverState = polygon.states.create("hover");
                    hoverState.properties.fill = am4core.color(polygon.fill).lighten(-0.35);

                    polygon.events.on("focus", function (e) {
                        polygon.url = polygon.dataItem.dataContext.url;
                        polygon.urlTarget = 'blank';
                    }, _this2);

                    polygon.events.on("blur", function (e) {
                        polygon.url = null;
                        polygon.urlTarget = null;
                    }, _this2);
                });
            });

            this.$nextTick(function () {
                // Clean up extraneous WAI-ARIA attributes for accessibility & Hide AMCharts Logo
                var svgContainer = _this2.$refs.chartdiv.querySelector('.c-svg-map svg');
                var toolTips = _this2.$refs.chartdiv.querySelectorAll('[role="tooltip"]');
                var amChartsLogo = _this2.$refs.chartdiv.querySelector('g[aria-labelledby^="id-"');

                if (svgContainer) {
                    svgContainer.removeAttribute('role');
                }

                if (toolTips.length > 0) {
                    toolTips.forEach(function (el) {
                        if (!el.getAttribute('font-size')) {
                            el.parentNode.removeChild(el);
                        }
                    });
                }

                if (amChartsLogo) {
                    amChartsLogo.setAttribute('visibility', 'hidden');
                }
            });

            this.chart = chart;
        },
        selectState: function selectState() {
            var statePolylgon = this.chart.series.getIndex(0).getPolygonById(this.$refs.stateselector.value);

            if (statePolylgon) {
                statePolylgon.isFocused = true;
                var stateDOMElement = this.$refs.chartdiv.querySelector('#' + statePolylgon.uid);

                if (stateDOMElement) {
                    window.setTimeout(function () {
                        // SVG element focus hack for IE
                        if (window.document.documentMode) {
                            var foreignObjectEl = document.createElement('foreignObject');
                            var inputEl = document.createElement('input');
                            foreignObjectEl.appendChild(inputEl);
                            stateDOMElement.appendChild(foreignObjectEl);
                            inputEl.focus();
                            inputEl.disabled = true;
                            foreignObjectEl.parentNode.removeChild(foreignObjectEl);
                        } else {
                            stateDOMElement.focus();
                        }
                    }, 500);
                }
            }
        }
    }
};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    name: 'app'
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//

exports['default'] = {
    props: ['title']
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaDropdownButton = __webpack_require__(1049);

var _ahaDropdownButton2 = _interopRequireDefault(_ahaDropdownButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    data: function data() {
        return {
            selected: null,
            options: [{
                value: null,
                text: 'Select Option'
            }, {
                value: 'a',
                text: 'Option 1'
            }, {
                value: 'b',
                text: 'Option 2'
            }, {
                value: 'C',
                text: 'Option 3'
            }, {
                value: 'd',
                text: 'Option 4'
            }]
        };
    },

    props: {
        size: {
            type: String,
            'default': ''
        }
    },
    computed: {
        currentDropdown: function currentDropdown() {
            var _this = this;

            return this.options.find(function (option) {
                return option.value === _this.selected;
            });
        }
    },
    methods: {
        onHidden: function onHidden() {
            var button = this.$el.querySelector('[aria-haspopup]');

            this.$nextTick(function () {
                button.focus();
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    methods: {
        onShown: function onShown() {
            this.focusRef(this.$refs.input1);
        },
        onHide: function onHide() {
            this.focusRef(this.$refs.button);
        },
        closeToolTip: function closeToolTip() {
            this.focusRef(this.$refs.button);
        },
        focusRef: function focusRef(ref) {
            this.$nextTick(function () {
                (ref.$el || ref).focus();
            });
        }
    }
};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    data: function data() {
        return {
            isFetching: true,
            users: [],
            tu: [{ 'name': 'Tu' }, { 'name': 'Leon' }, { 'name': 'Clinton' }, { 'name': 'Tu' }, { 'name': 'Leon' }, { 'name': 'Clinton' }, { 'name': 'Tu' }, { 'name': 'Leon' }, { 'name': 'Clinton' }, { 'name': 'Tu' }, { 'name': 'Leon' }, { 'name': 'Clinton' }, { 'name': 'Tu' }, { 'name': 'Leon' }, { 'name': 'Clinton' }, { 'name': 'Tu' }, { 'name': 'Leon' }, { 'name': 'Clinton' }],
            colors: ['red', 'red-alt', 'black', 'black-alt', 'gray-mid', 'gray-dark', 'blue-alt', 'lime-alt', 'seafoam-alt'],
            cardsamplecolors: ['red-alt', 'black-alt', 'gray-dark', 'blue-alt'],
            headlines: ["What To Expect From This Year's Event", "Professional Partnership", "Compassion Amid Crisis", "What To Expect From This Year's Event", "Compassion Amid Crisis"]
        };
    },

    methods: {
        fetchUsers: function fetchUsers() {
            var _this = this;

            _axios2['default'].get('https://tinyfac.es/api/users').then(function (response) {
                _this.users = response.data;
                // window.__users__ = this.users;
                _this.isFetching = false;
            })['catch'](function (error) {
                return console.log(error);
            });
        }
    },
    created: function created() {
        this.fetchUsers();
        // console.log(this.users)
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e83fc7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_nav_vue__ = __webpack_require__(1147);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e83fc7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d4e388f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_signup_vue__ = __webpack_require__(1148);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d4e388f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb15a412_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_nav_vue__ = __webpack_require__(1149);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb15a412_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    data: function data() {
        return {};
    }
};

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f83d10e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_utility_bar_vue__ = __webpack_require__(1152);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f83d10e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_utility_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    data: function data() {
        return {
            searchLabelPlaceholder: '',
            hospital: '',
            distance: '',
            address: '',
            distancePlaceholder: '',
            isLoading: false,
            inputLabel: null,
            inputAddressLabel: null,
            distanceId: null
        };
    },
    mounted: function mounted() {
        this.inputLabel = "hospital_" + this._uid;
        this.inputAddressLabel = "address_" + this._uid;
        this.distanceId = "distance_" + this._uid;
    },

    props: {
        isVisible: {
            type: Boolean,
            'default': false
        },
        onSubmit: {
            type: Function
        },
        translations: {
            type: Object,
            required: true
        },
        endpoint: {
            type: String,
            required: true
        },
        distances: {
            type: Array
        }
    },
    computed: {
        validInput: function validInput() {
            return this.address !== '' || this.hospital !== '';
        }
    },
    watch: {
        isVisible: function isVisible(val) {
            if (val) {
                this.focusRef(this.$refs.input1);
            }
        }
    },
    methods: {
        handleSubmit: function handleSubmit() {
            var _this = this;

            this.isLoading = true;

            _axios2['default'].post(this.$props.endpoint, {
                search: this.address || this.hospital
            }).then(function (response) {
                _this.isLoading = false;

                // Pass the data back to the parent component
                _this.onSubmit({
                    searchText: _this.address || _this.hospital,
                    locations: response.data
                });

                _this.address = '';
                _this.hospital = '';

                // Scroll on submit
                var target = document.getElementsByClassName('l-article__col')[0];
                var scrollContainer = target;
                console.log("this is target", target);

                if (target) {
                    do {
                        //find scroll container
                        scrollContainer = scrollContainer.parentNode;
                        if (!scrollContainer) return;
                        scrollContainer.scrollTop += 1;
                    } while (scrollContainer.scrollTop == 0);

                    var targetY = 0;
                    do {
                        //find the top of target relatively to the container
                        if (target == scrollContainer) break;
                        targetY += target.offsetTop;
                    } while (target = target.offsetParent);

                    scroll = function (_scroll) {
                        function scroll(_x, _x2, _x3, _x4) {
                            return _scroll.apply(this, arguments);
                        }

                        scroll.toString = function () {
                            return _scroll.toString();
                        };

                        return scroll;
                    }(function (c, a, b, i) {
                        i++;if (i > 30) return;
                        c.scrollTop = a + (b - a) / 30 * i;
                        setTimeout(function () {
                            scroll(c, a, b, i);
                        }, 20);
                    });
                    // start scrolling
                    scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
                }
            })['catch'](function (error) {
                _this.isLoading = false;
            });
        },
        focusRef: function focusRef(ref) {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$nextTick(function () {
                    (typeof ref.$el !== 'undefined' ? ref.$el : ref).focus();
                });
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// export default {
//     data() {
//         return {
//             submitted: false,
//         };
//     },
//     mounted() {

//        document.body.onclick = function(e) {   
//             if (window.event) {
//                 e = event.srcElement;
//             }
//             else {
//                 e = e.target;
//             }
//             if (e.className && e.className.indexOf('buttondisable') != -1) {
//                 if (this.submitted = true) {
//                     e.setAttribute('disabled', 'disabled');
//                     // eslint-disable-next-line
//                     console.log('disabled two');
//                 }
//                 else if (this.submitted = false) {
//                     e.removeAttribute('disabled');
//                 }
//             }
//         }
//     },
//     methods: {
//         disablebtn() {
//             this.submitted = true;
//             console.log('disabled oz');
//         },
//         enablebtn() {
//             this.submitted = false;
//         },
//     }
// }
// 


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a794f11_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_listbox_vue__ = __webpack_require__(1293);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a794f11_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_listbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58d13568_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_list_component_vue__ = __webpack_require__(1294);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58d13568_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_list_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb0ef87_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ad_horizontal_vue__ = __webpack_require__(1295);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb0ef87_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ad_horizontal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    name: 'selector',
    mixins: [_ahaId2['default']],
    data: function data() {
        return {
            activeItem: 'premier',
            tierId: null,
            mobile: window.innerWidth <= 700

        };
    },
    created: function created() {
        if (this.mobile) {
            this.activeItem = ' ';
        }
    },

    methods: {
        isActive: function isActive(menuItem) {
            return this.activeItem === menuItem;
        },
        setActive: function setActive(menuItem) {
            this.activeItem = menuItem;
            if (this.activeItem === 'limited') {
                console.log('limited');
            }
        },
        onHidden: function onHidden() {
            console.log("closed");
            this.activeItem = '';
        }
    },
    mounted: function mounted() {
        this.tierId = this.safeId('__PHD_selector_');
        console.log(this.tierId);
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66888dd1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linkbox_vue__ = __webpack_require__(1308);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66888dd1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56721220_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linkbox_50_50_vue__ = __webpack_require__(1309);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56721220_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linkbox_50_50_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec56a46_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_links_to_details_vue__ = __webpack_require__(1312);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec56a46_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_links_to_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fc04857_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_link_vue__ = __webpack_require__(1315);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fc04857_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d9601e3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_citations_vue__ = __webpack_require__(1326);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d9601e3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_citations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_media_block_vue__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_media_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_media_block_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_media_block_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_media_block_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d65715e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_media_block_vue__ = __webpack_require__(1327);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_media_block_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d65715e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_media_block_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    data: function data() {
        return {};
    }
};

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae795fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_references_vue__ = __webpack_require__(1330);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae795fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_references_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd7f5d4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_video_vue__ = __webpack_require__(1331);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd7f5d4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_video_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a795866c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rich_text_vue__ = __webpack_require__(1336);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a795866c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rich_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    data: function data() {
        return {
            // This should be the name of your variable (make it unique), and can be anything.  This is what goes in the :nav-data="" attrubite of the component.
            demoData: {
                // showAll should default to false
                showAll: false,
                // This is the array of navigation objects for the secondary nav (first level).
                navItems: [
                // each object here has 4 required and 1 optional key:value pair.
                {
                    // this example shows the REQUIRED items
                    // 'open' should always be false
                    open: false,
                    text: 'Submit Science',
                    // this key:value pair is where the tertiary (sub-nav) links are stored, in an array of objects
                    subNav: [
                    // each object here should simply have a URL and a text value.  These are the required items.
                    {
                        text: '1 subMenuItem',
                        url: '#'
                    }, {
                        text: '1 subMenuItem 2',
                        url: '#'
                    }]
                }, {
                    // this example show all 4 REQUIRED items, and the 1 OPTIONAL item.
                    // 'active' is the OPTIONAL item... technically, one item should be active, and it relates to which page is being displayed.  This makes that items show up 'bold' to indicate the current category of the page the user is on
                    open: false,
                    text: 'Programming',
                    // this is a more robust example of what you can put in here.  While there are 2 required items (text & url), there are also 2 optional items.

                    subNav: [{
                        text: 'Programming by Community',
                        url: '#',
                        // 'target' is the first OPTIONAL key:value pair, and it does exactly what you think it does.  In the event, for some reason, that the client wants to change the target attribute of one of these links, this will take care of that
                        target: '_blank'
                    }, {
                        // 'active' is the other OPTIONAL key:value pair here.  Technically, ONE tartiary item in the data set should be active to represent the current page.  This will be represented on mobile as 'bold' to let the user know that's the current page.  Note that the parent item (category) should also have an "active: true" if there is one in this list.
                        // active: true,
                        text: 'CV Nursing Symposium',
                        url: '#'
                    }, {
                        text: 'Late-Breaking Science (Scientific Sessions)',
                        url: '#'
                    }, {
                        text: 'Health Tech & Innovation Summit',
                        url: '#'
                    }, {
                        text: 'Science & Technology Hall Highlights and some other stuff to make this longer',
                        url: '#'
                    }, {
                        text: 'Live STreaming',
                        url: '#'
                    }, {
                        text: 'Maintenance of Certification',
                        url: '#'
                    }, {
                        text: 'CME/CE Credit',
                        url: '#'
                    }, {
                        text: 'For Presenters and Moderators',
                        url: '#'
                    }]
                }, {
                    open: false,
                    text: 'Awards',
                    subNav: [{
                        text: 'google plz',
                        url: 'https://google.com',
                        target: '_blank'
                    }, {
                        text: 'subMenuItem 2',
                        url: '#'
                    }, {
                        text: 'subMenuItem 3',
                        url: '#'
                    }, {
                        text: 'subMenuItem 4',
                        url: '#'
                    }, {
                        text: 'subMenuItem 5',
                        url: '#'
                    }, {
                        text: 'subMenuItem six',
                        url: '#'
                    }, {
                        text: 'subMenuItem 7',
                        url: '#'
                    }, {
                        text: 'subMenuItem 8',
                        url: '#'
                    }]
                }, {
                    open: false,
                    text: 'Science & Technology Hall',
                    subNav: [{
                        text: 'subMenuItem',
                        url: '#'
                    }, {
                        active: true,
                        text: 'subMenuItem 2',
                        url: '#'
                    }]
                }, {
                    text: 'Science News',
                    url: '#',
                    target: '_blank' // link target, leave off if none is desired.
                }, {
                    open: false,
                    text: 'Live Streaming',
                    subNav: [{
                        text: 'subMenuItem',
                        url: '#'
                    }, {
                        text: 'subMenuItem 2',
                        url: '#'
                    }]
                }, {
                    open: false,
                    text: 'Archive',
                    subNav: [{
                        text: 'subMenuItem',
                        url: '#'
                    }, {
                        text: 'subMenuItem 2',
                        url: '#'
                    }]
                }]
            }
        };
    }
};

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_671ec3e3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_heading_vue__ = __webpack_require__(1339);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_671ec3e3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_heading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bce238f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_science_news_recent_list_vue__ = __webpack_require__(1340);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bce238f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_science_news_recent_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e725d4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_science_news_heading_vue__ = __webpack_require__(1341);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e725d4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_science_news_heading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4af05931_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_science_news_promo_vue__ = __webpack_require__(1342);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4af05931_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_science_news_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db43b7de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sign_up_promo_vue__ = __webpack_require__(1343);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db43b7de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sign_up_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
//
//
//
//
//
//
//
!function (d, s, id) {
  var js,
      fjs = d.getElementsByTagName(s)[0],
      p = /^http:/.test(d.location) ? 'http' : 'https';if (!d.getElementById(id)) {
    js = d.createElement(s);js.id = id;js.src = p + "://platform.twitter.com/widgets.js";fjs.parentNode.insertBefore(js, fjs);
  }
}(document, "script", "twitter-wjs");

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24009906_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_promo_vue__ = __webpack_require__(1346);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24009906_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75e6dabf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upcoming_meetings_vue__ = __webpack_require__(1351);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75e6dabf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upcoming_meetings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e47f4752_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_cta_component_vue__ = __webpack_require__(1354);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e47f4752_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_cta_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a7f810_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linked_list_vue__ = __webpack_require__(1355);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a7f810_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linked_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9baaf9b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_hero_vue__ = __webpack_require__(1356);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9baaf9b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_hero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f08c83e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_member_dashboard_account_summary_vue__ = __webpack_require__(1359);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f08c83e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_member_dashboard_account_summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0300241e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_linked_list_demo_vue__ = __webpack_require__(1360);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0300241e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_linked_list_demo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15167969_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linked_list_view_all_page_vue__ = __webpack_require__(1361);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15167969_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linked_list_view_all_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsCookie = __webpack_require__(98);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    methods: {
        click: function click(evt) {
            _jsCookie2['default'].remove('aha-alert-cookie-test');
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue';
exports['default'] = {
    provide: function provide() {
        return {
            // EventBus: this.EventBus
        };
    },
    data: function data() {
        return {
            // EventBus: new Vue(),
        };
    },
    mounted: function mounted() {

        //this.EventBus.$emit('stepTrigger', '3');
        //console.log('children', this.$root.$children);// dont work, app as a child

        //console.log('child ',this.$children.find(child => { return child.$options.name === "aha-modal"; }))
        //console.log('Quiz',this.$refs['Quiz']);
        //console.log('Quiz Modal',this.$root);
        //this.$refs['Quiz'].EventBus.$emit('stepTrigger', 3); // Works
        this.$root.$on('bv::modal::hidden', function ($event) {
            //console.log('evt', $event);
            //this.$root.EventBus.$emit('stepTrigger', '1');
            //this.$refs['Quiz'].EventBus.$emit('stepTrigger', 1);

        });
    }
};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _component = __webpack_require__(80);

var _component2 = _interopRequireDefault(_component);

var _mainNav = __webpack_require__(323);

var _mainNav2 = _interopRequireDefault(_mainNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//
//

exports['default'] = {
    components: {
        ahaComponent: _component2['default'],
        ahaMainNav: _mainNav2['default']
    }
};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _component = __webpack_require__(80);

var _component2 = _interopRequireDefault(_component);

var _utilityBar = __webpack_require__(325);

var _utilityBar2 = _interopRequireDefault(_utilityBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//

exports['default'] = {
    components: {
        ahaComponent: _component2['default'],
        ahaUtilityBar: _utilityBar2['default']
    }
};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _component = __webpack_require__(80);

var _component2 = _interopRequireDefault(_component);

var _topNav = __webpack_require__(321);

var _topNav2 = _interopRequireDefault(_topNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    components: {
        ahaComponent: _component2['default'],
        ahaTopNav: _topNav2['default']
    }
};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _component = __webpack_require__(80);

var _component2 = _interopRequireDefault(_component);

var _loginSignup = __webpack_require__(322);

var _loginSignup2 = _interopRequireDefault(_loginSignup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    components: {
        ahaComponent: _component2['default'],
        ahaLoginSignup: _loginSignup2['default']
    }
};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _itemsStorage = __webpack_require__(100);

var STORAGE_KEY = '_aha-coveo-grocery-list'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var presetValues = [{ "title": "Rancho Pecana Natural Pecan Halves", "completed": false }, { "title": "WestSoy Organic Original Soymilk", "completed": false }, { "title": "Kirkland Signature Boneless Skinless Chicken Breast 99% Fat Free", "completed": false }, { "title": "Mother Earth Fresh Premium Idaho/Russet Potatoes", "completed": false }, { "title": "Garcia de la Cruz Organic Extra Virgin Olive Oil", "completed": false }, { "title": "Food Lion 96% Lean 4% Fat Ground Beefs", "completed": false }, { "title": "Health Valley Organic Low Sodium Chicken and Rice Soup", "completed": false }];
exports['default'] = {
    created: function created() {
        var items = JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || presetValues;
        _itemsStorage.itemsStorageFunc.save(STORAGE_KEY, items);
    }
};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _courseInformation = __webpack_require__(1433);

var _courseInformation2 = _interopRequireDefault(_courseInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//
//
//
//
//

_vue2['default'].component('aha-course-information', _courseInformation2['default']);

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _video = __webpack_require__(1439);

var _video2 = _interopRequireDefault(_video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//
//
//
//

_vue2['default'].component('aha-video', _video2['default']);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08fd95e4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_things_to_know_vue__ = __webpack_require__(1444);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08fd95e4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_things_to_know_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  data: function data() {
    return {
      timeSet: 1,
      value: "00:00"
    };
  },
  created: function created() {},
  mounted: function mounted() {
    //this.showModal();
    // this.$nextTick(function() {
    // });
    // let minutes = 60 * this.timeSet;
    // const display = document.querySelector('#time');
    // this.startTimer(minutes, display);
  },

  methods: {

    showModal: function showModal() {}
    //this.$refs["zipcode-modal"].showModal();

    /*,startTimer: function(duration, display) {
    let timer = duration, minutes, seconds;
      var countdown = setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);
         minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
         display.textContent = minutes + ":" + seconds;
         if (--timer < 0) {
            timer = duration;
            //clearInterval(countdown);
        }
      }, 1000);
    }*/
    , timerUpdate: function timerUpdate(newValue) {
      this.value = newValue;
    }
  }
};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bootstrapVue = __webpack_require__(116);

exports['default'] = {
    components: {
        BFormDatepicker: _bootstrapVue.BFormDatepicker
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    data: function data() {
        return {
            clinicalTrialDemoData1: {
                active: false, // needs to be false by default
                table: {
                    sidebarContent: [{
                        title: "<strong>Purpose</strong>",
                        content: "<p>To study the primary prevention role daily supplements of vitamin D3 or omega-3 fatty acids in reducing the risk of developing cancer, heart disease, and stroke in people with no history of cancer, heart disease or stroke.</p>"
                    }, {
                        title: "<strong>Trail Design</strong>",
                        content: "<p>25,871 U.S. adults (men \u226550; women \u226555); median treatment 5.3 years. Double-blinded, placebo-controlled, randomized, 2x2 factorial: (1) vitamin D3 (cholecalciferol; 2000 IU daily) and marine omega-3 fatty acids (Omacor&reg; fish oil, (eicosapentaenoic acid [EPA] and docosahexaenoic acid [DHA]], 1 g daily); (2) vitamin D and omega-3 placebo; (3) vitamin D placebo and omega-3 fatty acids; (4) both placebo.</p>"
                    }, {
                        title: "<strong>Primary Endpoints</strong>",
                        content: "<p>Primary Endpoints: (a) MACE (composite MI, stroke, CVD mortality); (b) total invasive cancer.</p>"
                    }],
                    rows: [{
                        name: "MACE composite",
                        active: false,
                        colData: [{
                            titles: ["event", "event"],
                            names: ["Vit D3", "placebo"],
                            values: ["396", "409"],
                            resultsLabel: "events",
                            result: "HR=0.97"
                        }, {
                            titles: ["event", "event"],
                            names: ["O3FA", "placebo"],
                            values: ["386", "419"],
                            resultsLabel: "events",
                            result: "8% reduction (HR-0.92); p=0.24"
                        }]
                    }, {
                        name: "Total Invasive Cancer",
                        active: false,
                        colData: [{
                            titles: ["event", "event"],
                            names: ["Vit D3", "placebo"],
                            values: ["793", "824"],
                            resultsLabel: "events",
                            result: "HR=0.96"
                        }, {
                            titles: ["event", "event"],
                            names: ["O3FA", "placebo"],
                            values: ["820", "797"],
                            resultsLabel: "events",
                            result: "No reduction (HR-1.03)"
                        }]
                    }, {
                        name: "Total MI",
                        active: false,
                        colData: [{
                            titles: ["event", "event"],
                            names: ["Vit D3", "placebo"],
                            values: ["169", "176"],
                            resultsLabel: "events",
                            result: "HR=0.96"
                        }, {
                            titles: ["event", "event"],
                            names: ["O3FA", "placebo"],
                            values: ["145", "200"],
                            resultsLabel: "events",
                            result: "28% reduction (HR-0.72, p=0.003)"
                        }]
                    }, {
                        name: "MI African Americans",
                        active: false,
                        colData: [{
                            titles: [],
                            names: [],
                            values: [],
                            resultsLabel: "",
                            result: ""
                        }, {
                            titles: ["", "event"],
                            names: ["O3FA", "placebo"],
                            values: ["9", "39"],
                            resultsLabel: "events",
                            result: "77% reduction (HR-0.23, p=0.001)"
                        }]
                    }]
                }
            }
        };
    }
};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsCookie = __webpack_require__(98);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    data: function data() {
        return {
            // Dev Note:
            //      Each "table" needs 1 set of data.  This example
            //      shows two "tables", each with their own set.
            //      This has been built to take as many tables as
            //      the user wants to throw at it, although most use
            //      cases is 2.
            demoData: [
            // Demo Data Set 1
            {
                active: false, // this needs to be false by default
                tableName: {
                    preTitle: 'MEMBERS',
                    title: '1-Day Member',
                    day: 'Wednesday & Thursday'
                },
                rates: [{
                    title: 'Early Rate',
                    date: 'Oct. 9 - Dec. 31',
                    rate: '$275'
                }, {
                    title: 'Advanced Rate',
                    date: 'Jan. 1 - Jan. 28',
                    rate: '$375'
                }, {
                    title: 'Standard Rate',
                    date: 'Jan. 29 - Feb. 19',
                    rate: '$475'
                }]
            },
            // Demo Data Set 2
            {
                active: false, // this needs to be false by default
                tableName: {
                    preTitle: 'MEMBERS',
                    title: '1-Day Member',
                    day: 'Friday'
                },
                rates: [{
                    title: 'Early Rate',
                    date: 'Oct. 9 - Dec. 31',
                    rate: '$200'
                }, {
                    title: 'Advanced Rate',
                    date: 'Jan. 1 - Jan. 28',
                    rate: '$300'
                }, {
                    title: 'Standard Rate',
                    date: 'Jan. 29 - Feb. 19',
                    rate: '$400'
                }]
            }]
        };
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    data: function data() {
        return {
            // note that 'target' and 'active' are the optional items here.  'target' can be left off completely, or left as an empty string.  While 'active' is technically optional, ONE item should have it (and only one) in order to render appropriately.  That item should corrospod to which ever page they are on.
            demoData: [{
                target: '_blank',
                text: 'I <3 Kittens',
                url: 'https://www.eyebleach.me/kittens/'
            }, {
                target: '_blank',
                text: 'Cats!',
                url: 'https://www.eyebleach.me/cats/'
            }, {
                target: '_blank',
                text: 'I like dogs Dogs',
                url: 'https://www.eyebleach.me/dogs/'
            }, {
                target: '_blank',
                text: 'Show me some nature',
                url: 'https://www.eyebleach.me/nature/'
            }, {
                active: true,
                target: '_blank',
                text: 'I wanna go fast!',
                url: 'https://www.eyebleach.me/faster/'
            }, {
                text: 'No target on this one',
                url: 'https://giantbomb.com'
            }]
        };
    }
};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    data: function data() {
        return {
            demoData: {
                active: false, // needs to be false by default
                tableName: {
                    preTitle: 'MEMBERS',
                    title: 'General Membership'
                },
                rateText: [{
                    title: 'Early Rate',
                    date: 'Oct. 9 - Dec. 31'
                }, {
                    title: 'Advanced Rate',
                    date: 'Jan. 1 - Jan. 28'
                }, {
                    title: 'Standard Rate',
                    date: 'Jan. 29 - Feb. 19'
                }],
                rowData: [{
                    active: false,
                    rowTitle: 'Premium Professional Member',
                    rowDescription: 'Stroke in the real world: A star is Born: Thrombolysis &amp; Thrombectomy',
                    rates: [{
                        normal: '$500',
                        gold: '$850'
                    }, {
                        normal: '$600',
                        gold: '$950'
                    }, {
                        normal: '$700',
                        gold: '$1,050'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Premium Professional Plus Member',
                    rates: [{
                        normal: '$400',
                        gold: '$750'
                    }, {
                        normal: '$500',
                        gold: '$850'
                    }, {
                        normal: '$600',
                        gold: '$950'
                    }]
                }, {
                    active: false,
                    rowTitle: 'General Professional Member',
                    rates: [{
                        normal: '$900',
                        gold: '$1,400'
                    }, {
                        normal: '$1,000',
                        gold: '$1,500'
                    }, {
                        normal: '$1,200',
                        gold: '$1,700'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Premium Emeritus Member',
                    rates: [{
                        normal: '$75',
                        gold: '$375'
                    }, {
                        normal: '$1750',
                        gold: '$475'
                    }, {
                        normal: '$275',
                        gold: '$575'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Early Career Member',
                    rates: [{
                        normal: '$300',
                        gold: '$600'
                    }, {
                        normal: '$400',
                        gold: '$700'
                    }, {
                        normal: '$500',
                        gold: '$800'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Student/Trainee Member*',
                    rates: [{
                        normal: '$200',
                        gold: '$500'
                    }, {
                        normal: '$300',
                        gold: '$600'
                    }, {
                        normal: '$400',
                        gold: '$700'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Professional Associate Member',
                    rates: [{
                        normal: '$900',
                        gold: '$1,400'
                    }, {
                        normal: '$1,000',
                        gold: '$1,500'
                    }, {
                        normal: '$1,200',
                        gold: '$1,700'
                    }]
                }]
            },
            demoDataWithoutGoldPricing: {
                active: false, // needs to be false by default
                tableName: {
                    preTitle: 'MEMBERS',
                    title: 'General Membership (no gold)'
                },
                rateText: [{
                    title: 'Early Rate'
                }, {
                    title: 'Advanced Rate'
                }, {
                    title: 'Standard Rate'
                }],
                rowData: [{
                    active: false,
                    rowTitle: 'Premium Professional Member',
                    rowDescription: 'Stroke in the real world: A star is Born: Thrombolysis & Thrombectomy',
                    rates: [{
                        normal: '$500'
                    }, {
                        normal: '$600'
                    }, {
                        normal: '$700'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Premium Professional Plus Member',
                    rates: [{
                        normal: '$400'
                    }, {
                        normal: '$500'
                    }, {
                        normal: '$600'
                    }]
                }, {
                    active: false,
                    rowTitle: 'General Professional Member',
                    rates: [{
                        normal: '$900'
                    }, {
                        normal: '$1,000'
                    }, {
                        normal: '$1,200'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Premium Emeritus Member',
                    rates: [{
                        normal: '$75'
                    }, {
                        normal: '$1750'
                    }, {
                        normal: '$275'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Early Career Member',
                    rates: [{
                        normal: '$300'
                    }, {
                        normal: '$400'
                    }, {
                        normal: '$500'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Student/Trainee Member*',
                    rates: [{
                        normal: '$200'
                    }, {
                        normal: '$300'
                    }, {
                        normal: '$400'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Professional Associate Member',
                    rates: [{
                        normal: '$900' }, {
                        normal: '$1,000' }, {
                        normal: '$1,200' }]
                }]
            }
        };
    }
};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    data: function data() {
        return {
            // example data default
            demoHeading: 'Required Title',
            demoDescription: 'Optional Description',
            demoLink: {
                text: 'Optional Link',
                url: 'https://google.com'
            },
            // example data 'Science News'
            demoHeading2: 'Science News',
            demoDescription2: 'Top experts from around the world coming together to discuss and debate the latest cardiovascular science and clinical information',
            demoLink2: {
                text: 'VIEW ALL NEWS',
                url: 'https://heart.org'
            }
        };
    }
};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  data: function data() {
    return {
      modalShow: true
    };
  }
};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ahaCookie = __webpack_require__(151);

exports["default"] = {
  data: function data() {
    return {};
  },
  created: function created() {
    document.addEventListener("DOMContentLoaded", function () {
      // Coveo.SearchEndpoint.configureSampleEndpointV2();
      var root = document.getElementById("search");
      //alert("hello");
      Coveo.SearchEndpoint.endpoints["default"] = new Coveo.SearchEndpoint({
        restUri: "https://platform.cloud.coveo.com/rest/search",
        accessToken: "xx09c92f34-189d-4f13-85af-6e3a207f2f13"
      });
      Coveo.$$(root).on("buildingQuery", function (e, args) {
        args.queryBuilder.expression.add("heart attack");
      });
      Coveo.init(root);
    });
  },
  mounted: function mounted() {
    //this.showModal();
    // this.$nextTick(function() {
    // });
  },

  methods: {
    clearCookie: function clearCookie() {
      _ahaCookie.Cookie.deleteCookie("EventManualZipcodeEntry");
      window.location.reload();
      _ahaCookie.Cookie.getAllCookies();
    },
    showModal: function showModal() {
      //this.$refs["zipcode-modal"].showModal();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    data: function data() {
        return {
            demoDataMembershipRateComparison: {
                active: false, // needs to be false by default
                tableName: {
                    preTitle: 'MEMBERS',
                    title: 'General Membership'
                },
                rateText: [{
                    title: 'Early Rate',
                    date: 'Oct. 9 - Dec. 31'
                }, {
                    title: 'Advanced Rate',
                    date: 'Jan. 1 - Jan. 28'
                }, {
                    title: 'Standard Rate',
                    date: 'Jan. 29 - Feb. 19'
                }],
                rowData: [{
                    active: false,
                    rowTitle: 'Premium Professional Member',
                    rates: [{
                        normal: '$500',
                        gold: '$850'
                    }, {
                        normal: '$600',
                        gold: '$950'
                    }, {
                        normal: '$700',
                        gold: '$1,050'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Premium Professional Plus Member',
                    rates: [{
                        normal: '$400',
                        gold: '$750'
                    }, {
                        normal: '$500',
                        gold: '$850'
                    }, {
                        normal: '$600',
                        gold: '$950'
                    }]
                }, {
                    active: false,
                    rowTitle: 'General Professional Member',
                    rates: [{
                        normal: '$900',
                        gold: '$1,400'
                    }, {
                        normal: '$1,000',
                        gold: '$1,500'
                    }, {
                        normal: '$1,200',
                        gold: '$1,700'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Premium Emeritus Member',
                    rates: [{
                        normal: '$75',
                        gold: '$375'
                    }, {
                        normal: '$1750',
                        gold: '$475'
                    }, {
                        normal: '$275',
                        gold: '$575'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Early Career Member',
                    rates: [{
                        normal: '$300',
                        gold: '$600'
                    }, {
                        normal: '$400',
                        gold: '$700'
                    }, {
                        normal: '$500',
                        gold: '$800'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Student/Trainee Member*',
                    rowDescription: 'Stroke in the real world: A star is Born: Thrombolysis &amp; Thrombectomy',
                    rates: [{
                        normal: '$200',
                        gold: '$500'
                    }, {
                        normal: '$300',
                        gold: '$600'
                    }, {
                        normal: '$400',
                        gold: '$700'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Professional Associate Member',
                    rates: [{
                        normal: '$900',
                        gold: '$1,400'
                    }, {
                        normal: '$1,000',
                        gold: '$1,500'
                    }, {
                        normal: '$1,200',
                        gold: '$1,700'
                    }]
                }]
            },
            // 2 data column here
            demoDataMembershipRateComparison2datacolumns: {
                active: false, // needs to be false by default
                tableName: {
                    preTitle: 'MEMBERS',
                    title: 'General Membership'
                },
                rateText: [{
                    title: 'Early Rate',
                    date: 'Oct. 9 - Dec. 31'
                }, {
                    title: 'Advanced Rate',
                    date: 'Jan. 1 - Jan. 28'
                }],
                rowData: [{
                    active: false,
                    rowTitle: 'Premium Professional Member',
                    rates: [{
                        normal: '$500',
                        gold: '$850'
                    }, {
                        normal: '$600',
                        gold: '$950'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Premium Professional Plus Member',
                    rates: [{
                        normal: '$400',
                        gold: '$750'
                    }, {
                        normal: '$500',
                        gold: '$850'
                    }]
                }, {
                    active: false,
                    rowTitle: 'General Professional Member',
                    rates: [{
                        normal: '$900',
                        gold: '$1,400'
                    }, {
                        normal: '$1,000',
                        gold: '$1,500'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Premium Emeritus Member',
                    rates: [{
                        normal: '$75',
                        gold: '$375'
                    }, {
                        normal: '$1750',
                        gold: '$475'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Early Career Member',
                    rates: [{
                        normal: '$300',
                        gold: '$600'
                    }, {
                        normal: '$400',
                        gold: '$700'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Student/Trainee Member*',
                    rowDescription: 'Stroke in the real world: A star is Born: Thrombolysis &amp; Thrombectomy',
                    rates: [{
                        normal: '$200',
                        gold: '$500'
                    }, {
                        normal: '$300',
                        gold: '$600'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Professional Associate Member',
                    rates: [{
                        normal: '$900',
                        gold: '$1,400'
                    }, {
                        normal: '$1,000',
                        gold: '$1,500'
                    }]
                }]
            },
            // 1 data column here
            demoDataMembershipRateComparison1datacolumn: {
                active: false, // needs to be false by default
                tableName: {
                    preTitle: 'MEMBERS',
                    title: 'General Membership'
                },
                rateText: [{
                    title: 'Early Rate',
                    date: 'Oct. 9 - Dec. 31'
                }],
                rowData: [{
                    active: false,
                    rowTitle: 'Premium Professional Member',
                    rates: [{
                        normal: '$500',
                        gold: '$850'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Premium Professional Plus Member',
                    rates: [{
                        normal: '$400',
                        gold: '$750'
                    }]
                }, {
                    active: false,
                    rowTitle: 'General Professional Member',
                    rates: [{
                        normal: '$900',
                        gold: '$1,400'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Premium Emeritus Member',
                    rates: [{
                        normal: '$75',
                        gold: '$375'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Early Career Member',
                    rates: [{
                        normal: '$300',
                        gold: '$600'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Student/Trainee Member*',
                    rowDescription: 'Stroke in the real world: A star is Born: Thrombolysis &amp; Thrombectomy',
                    rates: [{
                        normal: '$200',
                        gold: '$500'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Professional Associate Member',
                    rates: [{
                        normal: '$900',
                        gold: '$1,400'
                    }]
                }]
            },
            // 1 data column here - No Gold
            demoDataMembershipRateComparison1datacolumnNoGold: {
                active: false, // needs to be false by default
                tableName: {
                    preTitle: 'MEMBERS',
                    title: 'General Membership'
                },
                rateText: [{
                    title: 'Early Rate',
                    date: 'Oct. 9 - Dec. 31'
                }],
                rowData: [{
                    active: false,
                    rowTitle: 'Premium Professional Member',
                    rates: [{
                        normal: '$500'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Premium Professional Plus Member and a bunch of other text to make it really long and ensure it\'s going to wrap in order to test out the way the words flow',
                    rates: [{
                        normal: '$400'
                    }]
                }, {
                    active: false,
                    rowTitle: 'General Professional Member',
                    rates: [{
                        normal: '$900,000'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Premium Emeritus Member',
                    rates: [{
                        normal: '$75,000'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Early Career Member',
                    rates: [{
                        normal: '$300'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Student/Trainee Member*',
                    rowDescription: 'Stroke in the real world: A star is Born: Thrombolysis &amp; Thrombectomy',
                    rates: [{
                        normal: '$2,000,000'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Professional Associate Member',
                    rates: [{
                        normal: '$900'
                    }]
                }]
            },
            demoDataWithoutGoldPricing: {
                active: false, // needs to be false by default
                tableName: {
                    preTitle: 'MEMBERS',
                    title: 'General Membership (no gold)'
                },
                rateText: [{
                    title: 'Early Rate'
                }, {
                    title: 'Advanced Rate'
                }, {
                    title: 'Standard Rate'
                }],
                rowData: [{
                    active: false,
                    rowTitle: 'Premium Professional Member',
                    rowDescription: 'Stroke in the real world: A star is Born: Thrombolysis & Thrombectomy',
                    rates: [{
                        normal: '$500'
                    }, {
                        normal: '$600'
                    }, {
                        normal: '$700'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Premium Professional Plus Member',
                    rates: [{
                        normal: '$400'
                    }, {
                        normal: '$500'
                    }, {
                        normal: '$600'
                    }]
                }, {
                    active: false,
                    rowTitle: 'General Professional Member',
                    rates: [{
                        normal: '$900'
                    }, {
                        normal: '$1,000'
                    }, {
                        normal: '$1,200'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Premium Emeritus Member',
                    rates: [{
                        normal: '$75'
                    }, {
                        normal: '$1750'
                    }, {
                        normal: '$275'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Early Career Member',
                    rates: [{
                        normal: '$300'
                    }, {
                        normal: '$400'
                    }, {
                        normal: '$500'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Student/Trainee Member*',
                    rates: [{
                        normal: '$200'
                    }, {
                        normal: '$300'
                    }, {
                        normal: '$400'
                    }]
                }, {
                    active: false,
                    rowTitle: 'Professional Associate Member',
                    rates: [{
                        normal: '$900' }, {
                        normal: '$1,000' }, {
                        normal: '$1,200' }]
                }]
            },
            demoDataDailyRateComparison: [
            // Demo Data Set 1
            {
                active: false, // this needs to be false by default
                tableName: {
                    preTitle: 'MEMBERS',
                    title: '1-Day Member',
                    day: 'Wednesday & Thursday'
                },
                rates: [{
                    title: 'Early Rate',
                    date: 'Oct. 9 - Dec. 31',
                    rate: '$275'
                }, {
                    title: 'Advanced Rate',
                    date: 'Jan. 1 - Jan. 28',
                    rate: '$375'
                }, {
                    title: 'Standard Rate',
                    date: 'Jan. 29 - Feb. 19',
                    rate: '$475'
                }]
            },
            // Demo Data Set 2
            {
                active: false, // this needs to be false by default
                tableName: {
                    preTitle: 'MEMBERS',
                    title: '1-Day Member',
                    day: 'Friday'
                },
                rates: [{
                    title: 'Early Rate',
                    date: 'Oct. 9 - Dec. 31',
                    rate: '$200'
                }, {
                    title: 'Advanced Rate',
                    date: 'Jan. 1 - Jan. 28',
                    rate: '$300'
                }, {
                    title: 'Standard Rate',
                    date: 'Jan. 29 - Feb. 19',
                    rate: '$400'
                }]
            },
            // Demo Data Set 3
            {
                active: false, // this needs to be false by default
                tableName: {
                    preTitle: 'MEMBERS',
                    title: '1-Day Member',
                    day: 'Friday'
                },
                rates: [{
                    title: 'Early Rate',
                    date: 'Oct. 9 - Dec. 31',
                    rate: '$200'
                }, {
                    title: 'Advanced Rate',
                    date: 'Jan. 1 - Jan. 28',
                    rate: '$300'
                }, {
                    title: 'Standard Rate',
                    date: 'Jan. 29 - Feb. 19',
                    rate: '$400'
                }]
            },
            // Demo Data Set 4
            {
                active: false, // this needs to be false by default
                tableName: {
                    preTitle: 'MEMBERS',
                    title: '1-Day Member',
                    day: 'Friday'
                },
                rates: [{
                    title: 'Early Rate',
                    date: 'Oct. 9 - Dec. 31',
                    rate: '$200'
                }, {
                    title: 'Advanced Rate',
                    date: 'Jan. 1 - Jan. 28',
                    rate: '$300'
                }, {
                    title: 'Standard Rate',
                    date: 'Jan. 29 - Feb. 19',
                    rate: '$400'
                }]
            },
            // Demo Data Set 5
            {
                active: false, // this needs to be false by default
                tableName: {
                    preTitle: 'MEMBERS',
                    title: '1-Day Member',
                    day: 'Friday'
                },
                rates: [{
                    title: 'Early Rate',
                    date: 'Oct. 9 - Dec. 31',
                    rate: '$200'
                }, {
                    title: 'Advanced Rate',
                    date: 'Jan. 1 - Jan. 28',
                    rate: '$300'
                }, {
                    title: 'Standard Rate',
                    date: 'Jan. 29 - Feb. 19',
                    rate: '$400'
                }]
            }]
        };
    }
};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  data: function data() {
    return {};
  }
};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    name: 'selector',
    mixins: [_ahaId2['default']],
    data: function data() {
        return {
            activeItem: 'premier',
            tierId: null,
            mobile: window.innerWidth <= 700

        };
    },
    created: function created() {
        if (this.mobile) {
            this.activeItem = ' ';
        }
    },

    methods: {
        isActive: function isActive(menuItem) {
            return this.activeItem === menuItem;
        },
        setActive: function setActive(menuItem) {
            this.activeItem = menuItem;
            if (this.activeItem === 'student') {
                console.log('student');
            }
        },
        onHidden: function onHidden() {
            console.log("closed");
            this.activeItem = '';
        }
    },
    mounted: function mounted() {
        this.tierId = this.safeId('__PHD_selector_');
        console.log(this.tierId);
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports["default"] = {
    data: function data() {
        return {
            membershipIcons: {
                'membershipicons': [{ "name": "Premium Professional Plus", "code": "PS", "path": "https://sitecoretestphd.heart.org//-/media/feature/phd/membershipbriefcaseblack.svg?h=24&amp;w=27&amp;hash=A11AADA7C43F77E34BB5F2814189C976490CCF2C" }, { "name": "Premium Professional", "code": "PP", "path": "https://sitecoretestphd.heart.org//-/media/feature/phd/membershiphandcardblack.svg?h=30&amp;w=31&amp;hash=BAB1D2A11B434241306F4CFD8B390890DA8BE6F7" }, { "name": "General Professional", "code": "GM", "path": "https://sitecoretestphd.heart.org//-/media/feature/phd/membershipbriefcaseblack.svg?h=24&amp;w=27&amp;hash=A11AADA7C43F77E34BB5F2814189C976490CCF2C" }, { "name": "Early Career", "code": "EC", "path": "https://sitecoretestphd.heart.org//-/media/feature/phd/membershipbriefcaseblack.svg?h=24&amp;w=27&amp;hash=A11AADA7C43F77E34BB5F2814189C976490CCF2C" }, { "name": "Student/Trainee", "code": "ST", "path": "https://sitecoretestphd.heart.org//-/media/feature/phd/membershipbriefcaseblack.svg?h=24&amp;w=27&amp;hash=A11AADA7C43F77E34BB5F2814189C976490CCF2C" }]
            }
        };
    }
};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(381);


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(382);

__webpack_require__(385);

__webpack_require__(386);

var _speedBumpLinks = __webpack_require__(172);

var _speedBumpLinks2 = _interopRequireDefault(_speedBumpLinks);

var _selectAll = __webpack_require__(173);

var _selectAll2 = _interopRequireDefault(_selectAll);

var _customEvent = __webpack_require__(174);

var _customEvent2 = _interopRequireDefault(_customEvent);

var _objectFit = __webpack_require__(115);

var _objectFit2 = _interopRequireDefault(_objectFit);

var _focusWithin = __webpack_require__(387);

var _focusWithin2 = _interopRequireDefault(_focusWithin);

var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(390);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _bootstrapVue = __webpack_require__(116);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _veeValidate = __webpack_require__(207);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _vueScrollto = __webpack_require__(532);

var _vueScrollto2 = _interopRequireDefault(_vueScrollto);

__webpack_require__(533);

var _app = __webpack_require__(1030);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(1034);

__webpack_require__(1035);

__webpack_require__(1036);

var _component = __webpack_require__(80);

var _component2 = _interopRequireDefault(_component);

var _buttons = __webpack_require__(1040);

var _buttons2 = _interopRequireDefault(_buttons);

var _colorPalette = __webpack_require__(1044);

var _colorPalette2 = _interopRequireDefault(_colorPalette);

var _dropdown = __webpack_require__(1048);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _facets = __webpack_require__(1051);

var _facets2 = _interopRequireDefault(_facets);

var _inputsFeedback = __webpack_require__(1055);

var _inputsFeedback2 = _interopRequireDefault(_inputsFeedback);

var _inputs = __webpack_require__(1059);

var _inputs2 = _interopRequireDefault(_inputs);

var _largeInputsFeedback = __webpack_require__(1061);

var _largeInputsFeedback2 = _interopRequireDefault(_largeInputsFeedback);

var _largeInputs = __webpack_require__(1063);

var _largeInputs2 = _interopRequireDefault(_largeInputs);

var _pagination = __webpack_require__(1065);

var _pagination2 = _interopRequireDefault(_pagination);

var _radioButtons = __webpack_require__(1067);

var _radioButtons2 = _interopRequireDefault(_radioButtons);

var _tabs = __webpack_require__(1069);

var _tabs2 = _interopRequireDefault(_tabs);

var _tags = __webpack_require__(1071);

var _tags2 = _interopRequireDefault(_tags);

var _textboxes = __webpack_require__(1073);

var _textboxes2 = _interopRequireDefault(_textboxes);

var _tooltip = __webpack_require__(1077);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _typography = __webpack_require__(1079);

var _typography2 = _interopRequireDefault(_typography);

var _glyphs = __webpack_require__(1083);

var _glyphs2 = _interopRequireDefault(_glyphs);

var _socialIcons = __webpack_require__(1085);

var _socialIcons2 = _interopRequireDefault(_socialIcons);

var _icons = __webpack_require__(1087);

var _icons2 = _interopRequireDefault(_icons);

var _labels = __webpack_require__(1089);

var _labels2 = _interopRequireDefault(_labels);

var _phdTypography = __webpack_require__(1091);

var _phdTypography2 = _interopRequireDefault(_phdTypography);

var _phdColorPalette = __webpack_require__(1095);

var _phdColorPalette2 = _interopRequireDefault(_phdColorPalette);

var _phdColorPaletteMembership = __webpack_require__(1099);

var _phdColorPaletteMembership2 = _interopRequireDefault(_phdColorPaletteMembership);

var _phdButtons = __webpack_require__(1103);

var _phdButtons2 = _interopRequireDefault(_phdButtons);

var _phdLinks = __webpack_require__(1107);

var _phdLinks2 = _interopRequireDefault(_phdLinks);

var _phdDropdowns = __webpack_require__(1111);

var _phdDropdowns2 = _interopRequireDefault(_phdDropdowns);

var _phdInputs = __webpack_require__(1115);

var _phdInputs2 = _interopRequireDefault(_phdInputs);

var _phdInputsFeedback = __webpack_require__(1119);

var _phdInputsFeedback2 = _interopRequireDefault(_phdInputsFeedback);

var _phdRadios = __webpack_require__(1123);

var _phdRadios2 = _interopRequireDefault(_phdRadios);

var _phdIcons = __webpack_require__(1125);

var _phdIcons2 = _interopRequireDefault(_phdIcons);

var _phdSkeletonComponent = __webpack_require__(1129);

var _phdSkeletonComponent2 = _interopRequireDefault(_phdSkeletonComponent);

var _phdDefaultTables = __webpack_require__(1133);

var _phdDefaultTables2 = _interopRequireDefault(_phdDefaultTables);

var _breadcrumb = __webpack_require__(1135);

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

var _breadcrumbWithLink = __webpack_require__(1137);

var _breadcrumbWithLink2 = _interopRequireDefault(_breadcrumbWithLink);

var _listingHeader = __webpack_require__(1139);

var _listingHeader2 = _interopRequireDefault(_listingHeader);

var _listingHeaderMedium = __webpack_require__(1141);

var _listingHeaderMedium2 = _interopRequireDefault(_listingHeaderMedium);

var _listingHeaderSmall = __webpack_require__(1143);

var _listingHeaderSmall2 = _interopRequireDefault(_listingHeaderSmall);

var _alert = __webpack_require__(1145);

var _alert2 = _interopRequireDefault(_alert);

var _topNav = __webpack_require__(321);

var _topNav2 = _interopRequireDefault(_topNav);

var _loginSignup = __webpack_require__(322);

var _loginSignup2 = _interopRequireDefault(_loginSignup);

var _mainNav = __webpack_require__(323);

var _mainNav2 = _interopRequireDefault(_mainNav);

var _mainNav3 = __webpack_require__(1150);

var _mainNav4 = _interopRequireDefault(_mainNav3);

var _utilityBar = __webpack_require__(325);

var _utilityBar2 = _interopRequireDefault(_utilityBar);

var _articleLarge = __webpack_require__(1153);

var _articleLarge2 = _interopRequireDefault(_articleLarge);

var _articleMedium = __webpack_require__(1155);

var _articleMedium2 = _interopRequireDefault(_articleMedium);

var _articleSmall = __webpack_require__(1157);

var _articleSmall2 = _interopRequireDefault(_articleSmall);

var _articleXSmall = __webpack_require__(1159);

var _articleXSmall2 = _interopRequireDefault(_articleXSmall);

var _articleListing = __webpack_require__(1161);

var _articleListing2 = _interopRequireDefault(_articleListing);

var _articleListWithIcons = __webpack_require__(1163);

var _articleListWithIcons2 = _interopRequireDefault(_articleListWithIcons);

var _articleToc = __webpack_require__(1165);

var _articleToc2 = _interopRequireDefault(_articleToc);

var _aroundAhaNews = __webpack_require__(1167);

var _aroundAhaNews2 = _interopRequireDefault(_aroundAhaNews);

var _inquiriesSupport = __webpack_require__(1169);

var _inquiriesSupport2 = _interopRequireDefault(_inquiriesSupport);

var _fullWidthTestimonial = __webpack_require__(1171);

var _fullWidthTestimonial2 = _interopRequireDefault(_fullWidthTestimonial);

var _fullWidthHighlightCopy = __webpack_require__(1173);

var _fullWidthHighlightCopy2 = _interopRequireDefault(_fullWidthHighlightCopy);

var _videoGallery = __webpack_require__(1175);

var _videoGallery2 = _interopRequireDefault(_videoGallery);

var _affiliateNav = __webpack_require__(1177);

var _affiliateNav2 = _interopRequireDefault(_affiliateNav);

var _sitecoreForms = __webpack_require__(1179);

var _sitecoreForms2 = _interopRequireDefault(_sitecoreForms);

var _inlineSearch = __webpack_require__(1181);

var _inlineSearch2 = _interopRequireDefault(_inlineSearch);

var _ceSearch = __webpack_require__(1183);

var _ceSearch2 = _interopRequireDefault(_ceSearch);

var _courseSearch = __webpack_require__(1185);

var _courseSearch2 = _interopRequireDefault(_courseSearch);

var _cprCourseSearch = __webpack_require__(1187);

var _cprCourseSearch2 = _interopRequireDefault(_cprCourseSearch);

var _qualityResearchPublications = __webpack_require__(1189);

var _qualityResearchPublications2 = _interopRequireDefault(_qualityResearchPublications);

var _mapSearch = __webpack_require__(1191);

var _mapSearch2 = _interopRequireDefault(_mapSearch);

var _printButton = __webpack_require__(1193);

var _printButton2 = _interopRequireDefault(_printButton);

var _ratingWidget = __webpack_require__(1195);

var _ratingWidget2 = _interopRequireDefault(_ratingWidget);

var _inlineSearchDropdown = __webpack_require__(1197);

var _inlineSearchDropdown2 = _interopRequireDefault(_inlineSearchDropdown);

var _inlineSearchIcon = __webpack_require__(1199);

var _inlineSearchIcon2 = _interopRequireDefault(_inlineSearchIcon);

var _inlineSearchRedirect = __webpack_require__(1201);

var _inlineSearchRedirect2 = _interopRequireDefault(_inlineSearchRedirect);

var _inlineSearchSimple = __webpack_require__(1203);

var _inlineSearchSimple2 = _interopRequireDefault(_inlineSearchSimple);

var _twoColumnContentWidthPromo = __webpack_require__(1205);

var _twoColumnContentWidthPromo2 = _interopRequireDefault(_twoColumnContentWidthPromo);

var _twoColumnFullWidthPromo = __webpack_require__(1207);

var _twoColumnFullWidthPromo2 = _interopRequireDefault(_twoColumnFullWidthPromo);

var _twoColumnFullBleedPromo = __webpack_require__(1209);

var _twoColumnFullBleedPromo2 = _interopRequireDefault(_twoColumnFullBleedPromo);

var _threeColumnContentWidthPromo = __webpack_require__(1211);

var _threeColumnContentWidthPromo2 = _interopRequireDefault(_threeColumnContentWidthPromo);

var _fourColumnContentWidthIconPromo = __webpack_require__(1213);

var _fourColumnContentWidthIconPromo2 = _interopRequireDefault(_fourColumnContentWidthIconPromo);

var _fourColumnContentWidthImagePromo = __webpack_require__(1215);

var _fourColumnContentWidthImagePromo2 = _interopRequireDefault(_fourColumnContentWidthImagePromo);

var _fourColumnFullWidthImagePromo = __webpack_require__(1217);

var _fourColumnFullWidthImagePromo2 = _interopRequireDefault(_fourColumnFullWidthImagePromo);

var _threeColumnFullWidthPromo = __webpack_require__(1219);

var _threeColumnFullWidthPromo2 = _interopRequireDefault(_threeColumnFullWidthPromo);

var _fullWidthEmailPromo = __webpack_require__(1221);

var _fullWidthEmailPromo2 = _interopRequireDefault(_fullWidthEmailPromo);

var _halfImageHalfCopyPromo = __webpack_require__(1223);

var _halfImageHalfCopyPromo2 = _interopRequireDefault(_halfImageHalfCopyPromo);

var _oneColumnContentWidthPromo = __webpack_require__(1225);

var _oneColumnContentWidthPromo2 = _interopRequireDefault(_oneColumnContentWidthPromo);

var _eventPromo = __webpack_require__(1227);

var _eventPromo2 = _interopRequireDefault(_eventPromo);

var _twoThirdLinkComponent = __webpack_require__(1229);

var _twoThirdLinkComponent2 = _interopRequireDefault(_twoThirdLinkComponent);

var _heroCard = __webpack_require__(1231);

var _heroCard2 = _interopRequireDefault(_heroCard);

var _eventList = __webpack_require__(1233);

var _eventList2 = _interopRequireDefault(_eventList);

var _heroFullWidth = __webpack_require__(1235);

var _heroFullWidth2 = _interopRequireDefault(_heroFullWidth);

var _heroFullWidthVideoImage = __webpack_require__(1237);

var _heroFullWidthVideoImage2 = _interopRequireDefault(_heroFullWidthVideoImage);

var _fullWidthEventPromo = __webpack_require__(1239);

var _fullWidthEventPromo2 = _interopRequireDefault(_fullWidthEventPromo);

var _tvPages = __webpack_require__(1241);

var _tvPages2 = _interopRequireDefault(_tvPages);

var _nutritionalFacts = __webpack_require__(1243);

var _nutritionalFacts2 = _interopRequireDefault(_nutritionalFacts);

var _instructions = __webpack_require__(1245);

var _instructions2 = _interopRequireDefault(_instructions);

var _quickTips = __webpack_require__(1247);

var _quickTips2 = _interopRequireDefault(_quickTips);

var _social = __webpack_require__(1249);

var _social2 = _interopRequireDefault(_social);

var _speedBump = __webpack_require__(1251);

var _speedBump2 = _interopRequireDefault(_speedBump);

var _ssoInterceptor = __webpack_require__(1253);

var _ssoInterceptor2 = _interopRequireDefault(_ssoInterceptor);

var _studentCode = __webpack_require__(1255);

var _studentCode2 = _interopRequireDefault(_studentCode);

var _studentCodeInvalid = __webpack_require__(1257);

var _studentCodeInvalid2 = _interopRequireDefault(_studentCodeInvalid);

var _dailyJourney = __webpack_require__(1259);

var _dailyJourney2 = _interopRequireDefault(_dailyJourney);

var _yesNoQuestion = __webpack_require__(1261);

var _yesNoQuestion2 = _interopRequireDefault(_yesNoQuestion);

var _singleFieldPrompt = __webpack_require__(1263);

var _singleFieldPrompt2 = _interopRequireDefault(_singleFieldPrompt);

var _makeCommitment = __webpack_require__(1265);

var _makeCommitment2 = _interopRequireDefault(_makeCommitment);

var _quiz = __webpack_require__(1267);

var _quiz2 = _interopRequireDefault(_quiz);

var _quizScoring = __webpack_require__(1269);

var _quizScoring2 = _interopRequireDefault(_quizScoring);

var _poll = __webpack_require__(1271);

var _poll2 = _interopRequireDefault(_poll);

var _quizPersonalised = __webpack_require__(1273);

var _quizPersonalised2 = _interopRequireDefault(_quizPersonalised);

var _listicle = __webpack_require__(1275);

var _listicle2 = _interopRequireDefault(_listicle);

var _introBanner = __webpack_require__(1277);

var _introBanner2 = _interopRequireDefault(_introBanner);

var _counterComponent = __webpack_require__(1279);

var _counterComponent2 = _interopRequireDefault(_counterComponent);

var _multiLogoComponent = __webpack_require__(1281);

var _multiLogoComponent2 = _interopRequireDefault(_multiLogoComponent);

var _flipCardComponent = __webpack_require__(1283);

var _flipCardComponent2 = _interopRequireDefault(_flipCardComponent);

var _colorCodedTable = __webpack_require__(1285);

var _colorCodedTable2 = _interopRequireDefault(_colorCodedTable);

var _eccSearch = __webpack_require__(1287);

var _eccSearch2 = _interopRequireDefault(_eccSearch);

var _nestedAccordion = __webpack_require__(1289);

var _nestedAccordion2 = _interopRequireDefault(_nestedAccordion);

var _strokeSymptoms = __webpack_require__(1291);

var _strokeSymptoms2 = _interopRequireDefault(_strokeSymptoms);

var _articleListbox = __webpack_require__(328);

var _articleListbox2 = _interopRequireDefault(_articleListbox);

var _articleListComponent = __webpack_require__(329);

var _articleListComponent2 = _interopRequireDefault(_articleListComponent);

var _adHorizontal = __webpack_require__(330);

var _adHorizontal2 = _interopRequireDefault(_adHorizontal);

var _communityScienceNews = __webpack_require__(1296);

var _communityScienceNews2 = _interopRequireDefault(_communityScienceNews);

var _ctaBar = __webpack_require__(1298);

var _ctaBar2 = _interopRequireDefault(_ctaBar);

var _ctaBarFlexible = __webpack_require__(1300);

var _ctaBarFlexible2 = _interopRequireDefault(_ctaBarFlexible);

var _council = __webpack_require__(1302);

var _council2 = _interopRequireDefault(_council);

var _imagePdfAccessibleLinks = __webpack_require__(1304);

var _imagePdfAccessibleLinks2 = _interopRequireDefault(_imagePdfAccessibleLinks);

var _institutionalTier = __webpack_require__(1306);

var _institutionalTier2 = _interopRequireDefault(_institutionalTier);

var _linkbox = __webpack_require__(332);

var _linkbox2 = _interopRequireDefault(_linkbox);

var _linkbox3 = __webpack_require__(333);

var _linkbox4 = _interopRequireDefault(_linkbox3);

var _phdMainNav = __webpack_require__(1310);

var _phdMainNav2 = _interopRequireDefault(_phdMainNav);

var _linksToDetails = __webpack_require__(334);

var _linksToDetails2 = _interopRequireDefault(_linksToDetails);

var _needToKnow = __webpack_require__(1313);

var _needToKnow2 = _interopRequireDefault(_needToKnow);

var _newsLink = __webpack_require__(335);

var _newsLink2 = _interopRequireDefault(_newsLink);

var _newWindowHyperlink = __webpack_require__(1316);

var _newWindowHyperlink2 = _interopRequireDefault(_newWindowHyperlink);

var _nonPartnerConnections = __webpack_require__(1318);

var _nonPartnerConnections2 = _interopRequireDefault(_nonPartnerConnections);

var _partnerBenefits = __webpack_require__(1320);

var _partnerBenefits2 = _interopRequireDefault(_partnerBenefits);

var _phdArticleLink = __webpack_require__(1322);

var _phdArticleLink2 = _interopRequireDefault(_phdArticleLink);

var _phdCard = __webpack_require__(1324);

var _phdCard2 = _interopRequireDefault(_phdCard);

var _phdCitations = __webpack_require__(336);

var _phdCitations2 = _interopRequireDefault(_phdCitations);

var _phdMediaBlock = __webpack_require__(337);

var _phdMediaBlock2 = _interopRequireDefault(_phdMediaBlock);

var _phdMeeting = __webpack_require__(1328);

var _phdMeeting2 = _interopRequireDefault(_phdMeeting);

var _phdReferences = __webpack_require__(339);

var _phdReferences2 = _interopRequireDefault(_phdReferences);

var _phdVideo = __webpack_require__(340);

var _phdVideo2 = _interopRequireDefault(_phdVideo);

var _volunteerSearch = __webpack_require__(1332);

var _volunteerSearch2 = _interopRequireDefault(_volunteerSearch);

var _profile = __webpack_require__(1334);

var _profile2 = _interopRequireDefault(_profile);

var _richText = __webpack_require__(341);

var _richText2 = _interopRequireDefault(_richText);

var _phdSecondaryTertiaryNav = __webpack_require__(1337);

var _phdSecondaryTertiaryNav2 = _interopRequireDefault(_phdSecondaryTertiaryNav);

var _sectionHeading = __webpack_require__(343);

var _sectionHeading2 = _interopRequireDefault(_sectionHeading);

var _scienceNewsRecentList = __webpack_require__(344);

var _scienceNewsRecentList2 = _interopRequireDefault(_scienceNewsRecentList);

var _scienceNewsHeading = __webpack_require__(345);

var _scienceNewsHeading2 = _interopRequireDefault(_scienceNewsHeading);

var _scienceNewsPromo = __webpack_require__(346);

var _scienceNewsPromo2 = _interopRequireDefault(_scienceNewsPromo);

var _signUpPromo = __webpack_require__(347);

var _signUpPromo2 = _interopRequireDefault(_signUpPromo);

var _twitterFeed = __webpack_require__(1344);

var _twitterFeed2 = _interopRequireDefault(_twitterFeed);

var _videoPromo = __webpack_require__(349);

var _videoPromo2 = _interopRequireDefault(_videoPromo);

var _phdTopNav = __webpack_require__(1347);

var _phdTopNav2 = _interopRequireDefault(_phdTopNav);

var _phdTopUtilityNav = __webpack_require__(1349);

var _phdTopUtilityNav2 = _interopRequireDefault(_phdTopUtilityNav);

var _upcomingMeetings = __webpack_require__(350);

var _upcomingMeetings2 = _interopRequireDefault(_upcomingMeetings);

var _sessionsMeetings = __webpack_require__(1352);

var _sessionsMeetings2 = _interopRequireDefault(_sessionsMeetings);

var _twoCtaComponent = __webpack_require__(351);

var _twoCtaComponent2 = _interopRequireDefault(_twoCtaComponent);

var _linkedList = __webpack_require__(352);

var _linkedList2 = _interopRequireDefault(_linkedList);

var _phdHero = __webpack_require__(353);

var _phdHero2 = _interopRequireDefault(_phdHero);

var _thingsToKnow = __webpack_require__(1357);

var _thingsToKnow2 = _interopRequireDefault(_thingsToKnow);

var _phdMemberDashboardAccountSummary = __webpack_require__(354);

var _phdMemberDashboardAccountSummary2 = _interopRequireDefault(_phdMemberDashboardAccountSummary);

var _phdLinkedListDemo = __webpack_require__(355);

var _phdLinkedListDemo2 = _interopRequireDefault(_phdLinkedListDemo);

var _linkedListViewAllPage = __webpack_require__(356);

var _linkedListViewAllPage2 = _interopRequireDefault(_linkedListViewAllPage);

var _routes = __webpack_require__(1362);

var _routes2 = _interopRequireDefault(_routes);

var _authoring = __webpack_require__(299);

var _authoring2 = _interopRequireDefault(_authoring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Expose VanillaJS Dropdown plugin to Global scope


// PHD Pages


// Stroke


// Snackable


// Student Code


// Demo components


// PHD UI Kit


// Demo-only components


// import postscribe from 'postscribe';

// import setSsoInterceptLinks from '@/utils/sso-intercept-links'; // removed by C.Castle
window.VJSDropdown = new _authoring2['default']();

// Plugins


// PHD Components


// ECC


// LIW


// UI Kit


_vue2['default'].use(_bootstrapVue2['default']);
_vue2['default'].use(_vueRouter2['default']);
_vue2['default'].use(_veeValidate2['default']);
_vue2['default'].use(_vueScrollto2['default']);

// UI Kit
_vue2['default'].component('aha-ui-buttons', _buttons2['default']);
_vue2['default'].component('aha-ui-color-palette', _colorPalette2['default']);
_vue2['default'].component('aha-ui-dropdown', _dropdown2['default']);
_vue2['default'].component('aha-ui-facets', _facets2['default']);
_vue2['default'].component('aha-ui-inputs-feedback', _inputsFeedback2['default']);
_vue2['default'].component('aha-ui-inputs', _inputs2['default']);
_vue2['default'].component('aha-ui-large-inputs-feedback', _largeInputsFeedback2['default']);
_vue2['default'].component('aha-ui-large-inputs', _largeInputs2['default']);
_vue2['default'].component('aha-ui-pagination', _pagination2['default']);
_vue2['default'].component('aha-ui-radio-buttons', _radioButtons2['default']);
_vue2['default'].component('aha-ui-tabs', _tabs2['default']);
_vue2['default'].component('aha-ui-tags', _tags2['default']);
_vue2['default'].component('aha-ui-textboxes', _textboxes2['default']);
_vue2['default'].component('aha-ui-tooltip', _tooltip2['default']);
_vue2['default'].component('aha-ui-typography', _typography2['default']);
_vue2['default'].component('aha-ui-glyphs', _glyphs2['default']);
_vue2['default'].component('aha-ui-social-icons', _socialIcons2['default']);
_vue2['default'].component('aha-ui-icons', _icons2['default']);
_vue2['default'].component('aha-ui-labels', _labels2['default']);

// PHD UI Kit
_vue2['default'].component('phd-typography', _phdTypography2['default']);
_vue2['default'].component('phd-ui-color-palette', _phdColorPalette2['default']);
_vue2['default'].component('phd-ui-color-palette-membership', _phdColorPaletteMembership2['default']);
_vue2['default'].component('phd-buttons', _phdButtons2['default']);
_vue2['default'].component('phd-links', _phdLinks2['default']);
_vue2['default'].component('phd-dropdowns', _phdDropdowns2['default']);
_vue2['default'].component('phd-inputs', _phdInputs2['default']);
_vue2['default'].component('phd-inputs-feedback', _phdInputsFeedback2['default']);
_vue2['default'].component('phd-radios', _phdRadios2['default']);
_vue2['default'].component('phd-icons', _phdIcons2['default']);
_vue2['default'].component('phd-skeleton-component', _phdSkeletonComponent2['default']);
_vue2['default'].component('phd-default-tables', _phdDefaultTables2['default']);

// Demo components
_vue2['default'].component('aha-component', _component2['default']);
_vue2['default'].component('aha-breadcrumb', _breadcrumb2['default']);
_vue2['default'].component('aha-breadcrumb-with-link', _breadcrumbWithLink2['default']);
_vue2['default'].component('aha-listing-header', _listingHeader2['default']);
_vue2['default'].component('aha-listing-header-medium', _listingHeaderMedium2['default']);
_vue2['default'].component('aha-listing-header-small', _listingHeaderSmall2['default']);
_vue2['default'].component('aha-alert', _alert2['default']);
_vue2['default'].component('aha-top-nav', _topNav2['default']);
_vue2['default'].component('aha-login-signup', _loginSignup2['default']);
_vue2['default'].component('aha-main-nav', _mainNav2['default']);
_vue2['default'].component('aha-main-nav-2023', _mainNav4['default']);
_vue2['default'].component('aha-utility-bar', _utilityBar2['default']);
_vue2['default'].component('aha-article-large', _articleLarge2['default']);
_vue2['default'].component('aha-article-medium', _articleMedium2['default']);
_vue2['default'].component('aha-article-small', _articleSmall2['default']);
_vue2['default'].component('aha-article-xsmall', _articleXSmall2['default']);
_vue2['default'].component('aha-article-listing', _articleListing2['default']);
_vue2['default'].component('aha-article-list-with-icons', _articleListWithIcons2['default']);
_vue2['default'].component('aha-article-toc', _articleToc2['default']);
_vue2['default'].component('around-aha-news', _aroundAhaNews2['default']);
_vue2['default'].component('aha-inquiries-support', _inquiriesSupport2['default']);
_vue2['default'].component('aha-testimonial', _fullWidthTestimonial2['default']);
_vue2['default'].component('aha-full-width-highlight-copy', _fullWidthHighlightCopy2['default']);
_vue2['default'].component('aha-video-gallery', _videoGallery2['default']);
_vue2['default'].component('aha-affiliate-nav', _affiliateNav2['default']);
_vue2['default'].component('aha-sitecore-forms', _sitecoreForms2['default']);

_vue2['default'].component('aha-inline-search', _inlineSearch2['default']);
_vue2['default'].component('aha-ce-search', _ceSearch2['default']);
_vue2['default'].component('aha-course-search', _courseSearch2['default']);
_vue2['default'].component('aha-cpr-course-search', _cprCourseSearch2['default']);
_vue2['default'].component('aha-quality-research-publications', _qualityResearchPublications2['default']);
_vue2['default'].component('aha-map-search', _mapSearch2['default']);
_vue2['default'].component('aha-print-button', _printButton2['default']);
_vue2['default'].component('aha-rating-widget', _ratingWidget2['default']);
_vue2['default'].component('aha-inline-search-dropdown', _inlineSearchDropdown2['default']);
_vue2['default'].component('aha-inline-search-icon', _inlineSearchIcon2['default']);
_vue2['default'].component('aha-inline-search-redirect', _inlineSearchRedirect2['default']);
_vue2['default'].component('aha-inline-search-simple', _inlineSearchSimple2['default']);

_vue2['default'].component('aha-two-column-content-width-promo', _twoColumnContentWidthPromo2['default']);
_vue2['default'].component('aha-two-column-full-width-promo', _twoColumnFullWidthPromo2['default']);
_vue2['default'].component('aha-two-column-full-bleed-promo', _twoColumnFullBleedPromo2['default']);
_vue2['default'].component('aha-three-column-content-width-promo', _threeColumnContentWidthPromo2['default']);
_vue2['default'].component('aha-four-column-content-width-icon-promo', _fourColumnContentWidthIconPromo2['default']);
_vue2['default'].component('aha-four-column-content-width-image-promo', _fourColumnContentWidthImagePromo2['default']);
_vue2['default'].component('aha-four-column-full-width-image-promo', _fourColumnFullWidthImagePromo2['default']);
_vue2['default'].component('aha-three-column-full-width-promo', _threeColumnFullWidthPromo2['default']);
_vue2['default'].component('aha-two-third-link-component', _twoThirdLinkComponent2['default']);
_vue2['default'].component('aha-full-width-email-promo', _fullWidthEmailPromo2['default']);
_vue2['default'].component('aha-half-image-half-copy-promo', _halfImageHalfCopyPromo2['default']);
_vue2['default'].component('aha-one-column-content-width-promo', _oneColumnContentWidthPromo2['default']);
_vue2['default'].component('aha-event-promo', _eventPromo2['default']);

_vue2['default'].component('aha-hero-card', _heroCard2['default']);
_vue2['default'].component('aha-hero-full-width', _heroFullWidth2['default']);
_vue2['default'].component('aha-event-list', _eventList2['default']);
_vue2['default'].component('aha-full-width-video-image', _heroFullWidthVideoImage2['default']);
_vue2['default'].component('aha-full-width-event', _fullWidthEventPromo2['default']);
_vue2['default'].component('aha-rating-widget', _ratingWidget2['default']);

_vue2['default'].component('aha-tv-pages', _tvPages2['default']);

// LIW Components
_vue2['default'].component('liw-intro-banner', _introBanner2['default']);
_vue2['default'].component('liw-counter-component', _counterComponent2['default']);
_vue2['default'].component('liw-multi-logo-component', _multiLogoComponent2['default']);
_vue2['default'].component('liw-flip-card-component', _flipCardComponent2['default']);

// ECC components
_vue2['default'].component('color-coded-table', _colorCodedTable2['default']);
_vue2['default'].component('ecc-search', _eccSearch2['default']);
_vue2['default'].component('nested-accordion', _nestedAccordion2['default']);

// PHD components
_vue2['default'].component('article-listbox', _articleListbox2['default']);
_vue2['default'].component('article-list-component', _articleListComponent2['default']);
_vue2['default'].component('ad-horizontal', _adHorizontal2['default']);
_vue2['default'].component('community-science-news', _communityScienceNews2['default']);
_vue2['default'].component('cta-bar', _ctaBar2['default']);
_vue2['default'].component('cta-bar-flexible', _ctaBarFlexible2['default']);
_vue2['default'].component('phd-council', _council2['default']);
_vue2['default'].component('image-pdf-accessible-links', _imagePdfAccessibleLinks2['default']);
_vue2['default'].component('institutional-tier', _institutionalTier2['default']);
_vue2['default'].component('link-box', _linkbox2['default']);
_vue2['default'].component('link-box-50-50', _linkbox4['default']);
_vue2['default'].component('phd-main-nav', _phdMainNav2['default']);
_vue2['default'].component('links-to-details', _linksToDetails2['default']);
_vue2['default'].component('need-to-know', _needToKnow2['default']);
_vue2['default'].component('news-link', _newsLink2['default']);
_vue2['default'].component('new-window-hyperlink', _newWindowHyperlink2['default']);
_vue2['default'].component('non-partner-connections', _nonPartnerConnections2['default']);
_vue2['default'].component('partner-benefits', _partnerBenefits2['default']);
_vue2['default'].component('phd-card', _phdCard2['default']);
_vue2['default'].component('phd-article-link', _phdArticleLink2['default']);
_vue2['default'].component('phd-citations', _phdCitations2['default']);

_vue2['default'].component('phd-media-block', _phdMediaBlock2['default']);
_vue2['default'].component('phd-meeting', _phdMeeting2['default']);
_vue2['default'].component('phd-references', _phdReferences2['default']);
_vue2['default'].component('phd-video', _phdVideo2['default']);
_vue2['default'].component('rich-text', _richText2['default']);
_vue2['default'].component('science-news-heading', _scienceNewsHeading2['default']);
_vue2['default'].component('science-news-promo', _scienceNewsPromo2['default']);
_vue2['default'].component('secondary-tertiary-nav', _phdSecondaryTertiaryNav2['default']);
_vue2['default'].component('section-heading', _sectionHeading2['default']);
_vue2['default'].component('sign-up-promo', _signUpPromo2['default']);
_vue2['default'].component('video-promo', _videoPromo2['default']);
_vue2['default'].component('phd-volunteer-search', _volunteerSearch2['default']);
_vue2['default'].component('phd-profile', _profile2['default']);
_vue2['default'].component('science-news-recent-list', _scienceNewsRecentList2['default']);
_vue2['default'].component('phd-top-nav', _phdTopNav2['default']);
_vue2['default'].component('phd-top-utility-nav', _phdTopUtilityNav2['default']);
_vue2['default'].component('phd-upcoming-meetings', _upcomingMeetings2['default']);
_vue2['default'].component('sessions-meetings', _sessionsMeetings2['default']);
_vue2['default'].component('twitter-feed', _twitterFeed2['default']);
_vue2['default'].component('two-cta-component', _twoCtaComponent2['default']);
_vue2['default'].component('linked-list', _linkedList2['default']);
_vue2['default'].component('phd-hero', _phdHero2['default']);

// PHD Pages
_vue2['default'].component('aha-things-to-know', _thingsToKnow2['default']);
_vue2['default'].component('phd-member-dashboard-account-summary', _phdMemberDashboardAccountSummary2['default']);
_vue2['default'].component('aha-nutritional-facts', _nutritionalFacts2['default']);
_vue2['default'].component('aha-recipe-instructions', _instructions2['default']);
_vue2['default'].component('aha-quick-tips', _quickTips2['default']);
_vue2['default'].component('aha-recipe-gigya-addthis', _social2['default']);
_vue2['default'].component('aha-listicle-component', _listicle2['default']);
_vue2['default'].component('aha-quiz-scoring-component', _quizScoring2['default']);
_vue2['default'].component('aha-quiz-personalised-component', _quizPersonalised2['default']);
_vue2['default'].component('aha-quiz-component', _quiz2['default']);
_vue2['default'].component('aha-poll-component', _poll2['default']);
_vue2['default'].component('aha-daily-journey-component', _dailyJourney2['default']);
_vue2['default'].component('aha-yes-no-question-component', _yesNoQuestion2['default']);
_vue2['default'].component('aha-single-field-prompt-component', _singleFieldPrompt2['default']);
_vue2['default'].component('aha-make-commitment-component', _makeCommitment2['default']);
_vue2['default'].component('aha-student-code', _studentCode2['default']);
_vue2['default'].component('aha-student-code-invalid', _studentCodeInvalid2['default']);
_vue2['default'].component('aha-speed-bump', _speedBump2['default']);
_vue2['default'].component('aha-sso-interceptor', _ssoInterceptor2['default']);
_vue2['default'].component('asa-stroke-symptoms', _strokeSymptoms2['default']);
_vue2['default'].component('phd-linked-list-demo', _phdLinkedListDemo2['default']);
_vue2['default'].component('phd-linked-list-view-all-page', _linkedListViewAllPage2['default']);

var router = new _vueRouter2['default']({
    routes: _routes2['default']
});

new _vue2['default']({
    el: '#app',
    render: function render(h) {
        return h(_app2['default']);
    },
    router: router
});

/* eslint-disable */
router.afterEach(function (to, from) {
    setTimeout(function () {
        (0, _speedBumpLinks2['default'])('.twoClick, .twoclick', '#speed-bump-link');
        // setSsoInterceptLinks('#sso-intercept-link'); // removed by C.Castle
        (0, _selectAll2['default'])();

        // Globally exposed plugins
        window.VJSDropdown.destroy();
        window.VJSDropdown.init();

        (0, _customEvent2['default'])();
        (0, _objectFit2['default'])();
    }, 150);
});

(0, _speedBumpLinks2['default'])('.twoClick, .twoclick', '#speed-bump-link');
// setSsoInterceptLinks('#sso-intercept-link'); // removed by C.Castle
(0, _selectAll2['default'])();

// Globally exposed plugins
window.VJSDropdown.init();

// Polyfills
(0, _customEvent2['default'])();
(0, _objectFit2['default'])();
(0, _focusWithin2['default'])();

/***/ }),
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable */
/* ! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-objectfit-setclasses !*/

!function (e, n, t) {
  function r(e, n) {
    return (typeof e === "undefined" ? "undefined" : _typeof(e)) === n;
  }function o() {
    var e, n, t, o, i, s, a;for (var l in C) {
      if (C.hasOwnProperty(l)) {
        if (e = [], n = C[l], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (t = 0; t < n.options.aliases.length; t++) {
          e.push(n.options.aliases[t].toLowerCase());
        }for (o = r(n.fn, "function") ? n.fn() : n.fn, i = 0; i < e.length; i++) {
          s = e[i], a = s.split("."), 1 === a.length ? Modernizr[a[0]] = o : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = o), h.push((o ? "" : "no-") + a.join("-"));
        }
      }
    }
  }function i(e) {
    var n = _.className,
        t = Modernizr._config.classPrefix || "";if (w && (n = n.baseVal), Modernizr._config.enableJSClass) {
      var r = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");n = n.replace(r, "$1" + t + "js$2");
    }Modernizr._config.enableClasses && (n += " " + t + e.join(" " + t), w ? _.className.baseVal = n : _.className = n);
  }function s(e) {
    return e.replace(/([a-z])-([a-z])/g, function (e, n, t) {
      return n + t.toUpperCase();
    }).replace(/^-/, "");
  }function a(e, n) {
    return !!~("" + e).indexOf(n);
  }function l() {
    return "function" != typeof n.createElement ? n.createElement(arguments[0]) : w ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0]) : n.createElement.apply(n, arguments);
  }function f(e, n) {
    return function () {
      return e.apply(n, arguments);
    };
  }function u(e, n, t) {
    var o;for (var i in e) {
      if (e[i] in n) return t === !1 ? e[i] : (o = n[e[i]], r(o, "function") ? f(o, t || n) : o);
    }return !1;
  }function p(e) {
    return e.replace(/([A-Z])/g, function (e, n) {
      return "-" + n.toLowerCase();
    }).replace(/^ms-/, "-ms-");
  }function c(n, t, r) {
    var o;if ("getComputedStyle" in e) {
      o = getComputedStyle.call(e, n, t);var i = e.console;if (null !== o) r && (o = o.getPropertyValue(r));else if (i) {
        var s = i.error ? "error" : "log";i[s].call(i, "getComputedStyle returning null, its possible modernizr test results are inaccurate");
      }
    } else o = !t && n.currentStyle && n.currentStyle[r];return o;
  }function d() {
    var e = n.body;return e || (e = l(w ? "svg" : "body"), e.fake = !0), e;
  }function m(e, t, r, o) {
    var i,
        s,
        a,
        f,
        u = "modernizr",
        p = l("div"),
        c = d();if (parseInt(r, 10)) for (; r--;) {
      a = l("div"), a.id = o ? o[r] : u + (r + 1), p.appendChild(a);
    }return i = l("style"), i.type = "text/css", i.id = "s" + u, (c.fake ? c : p).appendChild(i), c.appendChild(p), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(n.createTextNode(e)), p.id = u, c.fake && (c.style.background = "", c.style.overflow = "hidden", f = _.style.overflow, _.style.overflow = "hidden", _.appendChild(c)), s = t(p, e), c.fake ? (c.parentNode.removeChild(c), _.style.overflow = f, _.offsetHeight) : p.parentNode.removeChild(p), !!s;
  }function v(n, r) {
    var o = n.length;if ("CSS" in e && "supports" in e.CSS) {
      for (; o--;) {
        if (e.CSS.supports(p(n[o]), r)) return !0;
      }return !1;
    }if ("CSSSupportsRule" in e) {
      for (var i = []; o--;) {
        i.push("(" + p(n[o]) + ":" + r + ")");
      }return i = i.join(" or "), m("@supports (" + i + ") { #modernizr { position: absolute; } }", function (e) {
        return "absolute" == c(e, null, "position");
      });
    }return t;
  }function y(e, n, o, i) {
    function f() {
      p && (delete P.style, delete P.modElem);
    }if (i = r(i, "undefined") ? !1 : i, !r(o, "undefined")) {
      var u = v(e, o);if (!r(u, "undefined")) return u;
    }for (var p, c, d, m, y, g = ["modernizr", "tspan", "samp"]; !P.style && g.length;) {
      p = !0, P.modElem = l(g.shift()), P.style = P.modElem.style;
    }for (d = e.length, c = 0; d > c; c++) {
      if (m = e[c], y = P.style[m], a(m, "-") && (m = s(m)), P.style[m] !== t) {
        if (i || r(o, "undefined")) return f(), "pfx" == n ? m : !0;try {
          P.style[m] = o;
        } catch (h) {}if (P.style[m] != y) return f(), "pfx" == n ? m : !0;
      }
    }return f(), !1;
  }function g(e, n, t, o, i) {
    var s = e.charAt(0).toUpperCase() + e.slice(1),
        a = (e + " " + b.join(s + " ") + s).split(" ");return r(n, "string") || r(n, "undefined") ? y(a, n, o, i) : (a = (e + " " + j.join(s + " ") + s).split(" "), u(a, n, t));
  }var h = [],
      C = [],
      S = { _version: "3.6.0", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, n) {
      var t = this;setTimeout(function () {
        n(t[e]);
      }, 0);
    }, addTest: function addTest(e, n, t) {
      C.push({ name: e, fn: n, options: t });
    }, addAsyncTest: function addAsyncTest(e) {
      C.push({ name: null, fn: e });
    } },
      Modernizr = function Modernizr() {};Modernizr.prototype = S, Modernizr = new Modernizr();var _ = n.documentElement,
      w = "svg" === _.nodeName.toLowerCase(),
      x = "Moz O ms Webkit",
      b = S._config.usePrefixes ? x.split(" ") : [];S._cssomPrefixes = b;var E = function E(n) {
    var r,
        o = prefixes.length,
        i = e.CSSRule;if ("undefined" == typeof i) return t;if (!n) return !1;if (n = n.replace(/^@/, ""), r = n.replace(/-/g, "_").toUpperCase() + "_RULE", r in i) return "@" + n;for (var s = 0; o > s; s++) {
      var a = prefixes[s],
          l = a.toUpperCase() + "_" + r;if (l in i) return "@-" + a.toLowerCase() + "-" + n;
    }return !1;
  };S.atRule = E;var j = S._config.usePrefixes ? x.toLowerCase().split(" ") : [];S._domPrefixes = j;var z = { elem: l("modernizr") };Modernizr._q.push(function () {
    delete z.elem;
  });var P = { style: z.elem.style };Modernizr._q.unshift(function () {
    delete P.style;
  }), S.testAllProps = g;var N = S.prefixed = function (e, n, t) {
    return 0 === e.indexOf("@") ? E(e) : (-1 != e.indexOf("-") && (e = s(e)), n ? g(e, n, t) : g(e, "pfx"));
  };Modernizr.addTest("objectfit", !!N("objectFit"), { aliases: ["object-fit"] }), o(), i(h), delete S.addTest, delete S.addAsyncTest;for (var T = 0; T < Modernizr._q.length; T++) {
    Modernizr._q[T]();
  }e.Modernizr = Modernizr;
}(window, document);

/* eslint-enable */

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = focusWithinPolyfill;
/* eslint-disable */
function focusWithinPolyfill() {
    function addListeners(parentClass) {
        var focusableItems = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', '[tabindex="0"]'];
        for (var i = 0, leni = focusableItems.length; i < leni; i++) {
            var focusableElements = document.querySelectorAll("." + parentClass + " " + focusableItems[i]);
            for (var j = 0, lenj = focusableElements.length; j < lenj; j++) {
                focusableElements[j].addEventListener("focus", function () {
                    this.parentNode.parentNode.parentNode.classList.add("focus-within");
                });
                focusableElements[j].addEventListener("blur", function () {
                    this.parentNode.parentNode.parentNode.classList.remove("focus-within");
                });
            }
        }
    }
    addListeners("c-flip-cards__card");
}

/***/ }),
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(534);

var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapVue = __webpack_require__(116);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _veeValidate = __webpack_require__(207);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _vueClipboard = __webpack_require__(725);

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

var _vuex = __webpack_require__(76);

var _vuex2 = _interopRequireDefault(_vuex);

var _vue2GoogleMaps = __webpack_require__(727);

var VueGoogleMaps = _interopRequireWildcard(_vue2GoogleMaps);

var _appIcon = __webpack_require__(753);

var _appIcon2 = _interopRequireDefault(_appIcon);

var _fitText = __webpack_require__(758);

var _fitText2 = _interopRequireDefault(_fitText);

var _ahaNavDropdown = __webpack_require__(760);

var _ahaNavDropdown2 = _interopRequireDefault(_ahaNavDropdown);

var _ahaSelectDropdown = __webpack_require__(773);

var _ahaSelectDropdown2 = _interopRequireDefault(_ahaSelectDropdown);

var _ahaSelectDropdownItem = __webpack_require__(774);

var _ahaSelectDropdownItem2 = _interopRequireDefault(_ahaSelectDropdownItem);

var _locationSelector = __webpack_require__(775);

var _locationSelector2 = _interopRequireDefault(_locationSelector);

var _locationSelectorForm = __webpack_require__(794);

var _locationSelectorForm2 = _interopRequireDefault(_locationSelectorForm);

var _locationSelectorTable = __webpack_require__(796);

var _locationSelectorTable2 = _interopRequireDefault(_locationSelectorTable);

var _strokeGroupSelector = __webpack_require__(798);

var _strokeGroupSelector2 = _interopRequireDefault(_strokeGroupSelector);

var _strokeGroupSelectorForm = __webpack_require__(801);

var _strokeGroupSelectorForm2 = _interopRequireDefault(_strokeGroupSelectorForm);

var _strokeGroupSelectorTable = __webpack_require__(803);

var _strokeGroupSelectorTable2 = _interopRequireDefault(_strokeGroupSelectorTable);

var _ahaYoutube = __webpack_require__(805);

var _ahaYoutube2 = _interopRequireDefault(_ahaYoutube);

var _ahaNotification = __webpack_require__(818);

var _ahaNotification2 = _interopRequireDefault(_ahaNotification);

var _ahaMobileNav = __webpack_require__(820);

var _ahaMobileNav2 = _interopRequireDefault(_ahaMobileNav);

var _ahaRecipeCheckbox = __webpack_require__(822);

var _ahaRecipeCheckbox2 = _interopRequireDefault(_ahaRecipeCheckbox);

var _ahaRecipeSocial = __webpack_require__(823);

var _ahaRecipeSocial2 = _interopRequireDefault(_ahaRecipeSocial);

var _ahaModal = __webpack_require__(824);

var _ahaModal2 = _interopRequireDefault(_ahaModal);

var _ahaListbox = __webpack_require__(842);

var _ahaListbox2 = _interopRequireDefault(_ahaListbox);

var _ahaGoogleMap = __webpack_require__(843);

var _ahaGoogleMap2 = _interopRequireDefault(_ahaGoogleMap);

var _ahaHalfImageHalfCopyCollapse = __webpack_require__(849);

var _ahaHalfImageHalfCopyCollapse2 = _interopRequireDefault(_ahaHalfImageHalfCopyCollapse);

var _ahaDonationModal = __webpack_require__(851);

var _ahaDonationModal2 = _interopRequireDefault(_ahaDonationModal);

var _ahaHospitalZipcodeModal = __webpack_require__(853);

var _ahaHospitalZipcodeModal2 = _interopRequireDefault(_ahaHospitalZipcodeModal);

var _ahaSessionTimeoutModal = __webpack_require__(855);

var _ahaSessionTimeoutModal2 = _interopRequireDefault(_ahaSessionTimeoutModal);

var _ahaTransitionGroup = __webpack_require__(857);

var _ahaTransitionGroup2 = _interopRequireDefault(_ahaTransitionGroup);

var _ahaTransitionGroupForm = __webpack_require__(859);

var _ahaTransitionGroupForm2 = _interopRequireDefault(_ahaTransitionGroupForm);

var _ahaTransitionStep = __webpack_require__(862);

var _ahaTransitionStep2 = _interopRequireDefault(_ahaTransitionStep);

var _ahaTransitionTrigger = __webpack_require__(864);

var _ahaTransitionTrigger2 = _interopRequireDefault(_ahaTransitionTrigger);

var _ahaTransitionInputValue = __webpack_require__(865);

var _ahaTransitionInputValue2 = _interopRequireDefault(_ahaTransitionInputValue);

var _ahaInlineSiteSearch = __webpack_require__(866);

var _ahaInlineSiteSearch2 = _interopRequireDefault(_ahaInlineSiteSearch);

var _impactedData = __webpack_require__(868);

var _impactedData2 = _interopRequireDefault(_impactedData);

var _ahaSearchResultsForm = __webpack_require__(870);

var _ahaSearchResultsForm2 = _interopRequireDefault(_ahaSearchResultsForm);

var _ahaBackToSearch = __webpack_require__(872);

var _ahaBackToSearch2 = _interopRequireDefault(_ahaBackToSearch);

var _ahaShare = __webpack_require__(878);

var _ahaShare2 = _interopRequireDefault(_ahaShare);

var _ahaShareGigya = __webpack_require__(879);

var _ahaShareGigya2 = _interopRequireDefault(_ahaShareGigya);

var _ahaSingleFieldPromptForm = __webpack_require__(880);

var _ahaSingleFieldPromptForm2 = _interopRequireDefault(_ahaSingleFieldPromptForm);

var _ahaSingleFieldPromptRadioForm = __webpack_require__(882);

var _ahaSingleFieldPromptRadioForm2 = _interopRequireDefault(_ahaSingleFieldPromptRadioForm);

var _ahaTvPageModal = __webpack_require__(884);

var _ahaTvPageModal2 = _interopRequireDefault(_ahaTvPageModal);

var _ahaMakeCommitmentForm = __webpack_require__(886);

var _ahaMakeCommitmentForm2 = _interopRequireDefault(_ahaMakeCommitmentForm);

var _ahaAddToRecipeBox = __webpack_require__(888);

var _ahaAddToRecipeBox2 = _interopRequireDefault(_ahaAddToRecipeBox);

var _ahaRecipeBoxFavorite = __webpack_require__(890);

var _ahaRecipeBoxFavorite2 = _interopRequireDefault(_ahaRecipeBoxFavorite);

var _ahaModifyRecipeBox = __webpack_require__(892);

var _ahaModifyRecipeBox2 = _interopRequireDefault(_ahaModifyRecipeBox);

var _ahaCopyUrlToClipboard = __webpack_require__(894);

var _ahaCopyUrlToClipboard2 = _interopRequireDefault(_ahaCopyUrlToClipboard);

var _ahaExternalScript = __webpack_require__(896);

var _ahaExternalScript2 = _interopRequireDefault(_ahaExternalScript);

var _footerSupportBarSection = __webpack_require__(899);

var _footerSupportBarSection2 = _interopRequireDefault(_footerSupportBarSection);

var _simpleAccordion = __webpack_require__(901);

var _simpleAccordion2 = _interopRequireDefault(_simpleAccordion);

var _ahaDafWidget = __webpack_require__(903);

var _ahaDafWidget2 = _interopRequireDefault(_ahaDafWidget);

var _ahaCollapsableView = __webpack_require__(907);

var _ahaCollapsableView2 = _interopRequireDefault(_ahaCollapsableView);

var _ahaSelectionCard = __webpack_require__(909);

var _ahaSelectionCard2 = _interopRequireDefault(_ahaSelectionCard);

var _ahaSwitchInput = __webpack_require__(911);

var _ahaSwitchInput2 = _interopRequireDefault(_ahaSwitchInput);

var _ahaCardSelector = __webpack_require__(915);

var _ahaCardSelector2 = _interopRequireDefault(_ahaCardSelector);

var _ahaCardSelectorFilter = __webpack_require__(917);

var _ahaCardSelectorFilter2 = _interopRequireDefault(_ahaCardSelectorFilter);

var _ahaCardViewer = __webpack_require__(919);

var _ahaCardViewer2 = _interopRequireDefault(_ahaCardViewer);

var _ahaCardViewerText = __webpack_require__(921);

var _ahaCardViewerText2 = _interopRequireDefault(_ahaCardViewerText);

var _ahaMaskedInput = __webpack_require__(923);

var _ahaMaskedInput2 = _interopRequireDefault(_ahaMaskedInput);

var _ahaCprSearchCourseWrapper = __webpack_require__(928);

var _ahaCprSearchCourseWrapper2 = _interopRequireDefault(_ahaCprSearchCourseWrapper);

var _phdScienceVolunteerModal = __webpack_require__(929);

var _phdScienceVolunteerModal2 = _interopRequireDefault(_phdScienceVolunteerModal);

var _ahaNewsletterAjaxThankYou = __webpack_require__(931);

var _ahaNewsletterAjaxThankYou2 = _interopRequireDefault(_ahaNewsletterAjaxThankYou);

var _ahaSitecoreFormWrapper = __webpack_require__(935);

var _ahaSitecoreFormWrapper2 = _interopRequireDefault(_ahaSitecoreFormWrapper);

var _ahaCarousel = __webpack_require__(939);

var _ahaCarousel2 = _interopRequireDefault(_ahaCarousel);

var _ahaGroceryList = __webpack_require__(941);

var _ahaGroceryList2 = _interopRequireDefault(_ahaGroceryList);

var _ahaGroceryCount = __webpack_require__(943);

var _ahaGroceryCount2 = _interopRequireDefault(_ahaGroceryCount);

var _pluralize = __webpack_require__(945);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _verticalAlign = __webpack_require__(947);

var _verticalAlign2 = _interopRequireDefault(_verticalAlign);

var _lazyImg = __webpack_require__(948);

var _lazyImg2 = _interopRequireDefault(_lazyImg);

var _toggleChecked = __webpack_require__(949);

var _toggleChecked2 = _interopRequireDefault(_toggleChecked);

var _toggleCreditImage = __webpack_require__(950);

var _toggleCreditImage2 = _interopRequireDefault(_toggleCreditImage);

var _perfectScrollbar = __webpack_require__(951);

var _perfectScrollbar2 = _interopRequireDefault(_perfectScrollbar);

var _shareButton = __webpack_require__(953);

var _shareButton2 = _interopRequireDefault(_shareButton);

var _speedBump = __webpack_require__(954);

var _speedBump2 = _interopRequireDefault(_speedBump);

var _ssoIntercept = __webpack_require__(955);

var _ssoIntercept2 = _interopRequireDefault(_ssoIntercept);

var _printElement = __webpack_require__(957);

var _printElement2 = _interopRequireDefault(_printElement);

var _registerEvent = __webpack_require__(959);

var _registerEvent2 = _interopRequireDefault(_registerEvent);

var _formSubmit = __webpack_require__(960);

var _formSubmit2 = _interopRequireDefault(_formSubmit);

var _formValidate = __webpack_require__(961);

var _formValidate2 = _interopRequireDefault(_formValidate);

var _formSubmitCheckbox = __webpack_require__(962);

var _formSubmitCheckbox2 = _interopRequireDefault(_formSubmitCheckbox);

var _buttonCollapseContent = __webpack_require__(963);

var _buttonCollapseContent2 = _interopRequireDefault(_buttonCollapseContent);

var _imageVideoCarousel = __webpack_require__(964);

var _imageVideoCarousel2 = _interopRequireDefault(_imageVideoCarousel);

var _luminateDonateForm = __webpack_require__(965);

var _luminateDonateForm2 = _interopRequireDefault(_luminateDonateForm);

var _maxChildrenHeight = __webpack_require__(966);

var _maxChildrenHeight2 = _interopRequireDefault(_maxChildrenHeight);

var _nestedAccordion = __webpack_require__(967);

var _nestedAccordion2 = _interopRequireDefault(_nestedAccordion);

var _tabs = __webpack_require__(968);

var _tabs2 = _interopRequireDefault(_tabs);

var _tabsCustomTabbing = __webpack_require__(969);

var _tabsCustomTabbing2 = _interopRequireDefault(_tabsCustomTabbing);

var _hiddenInput = __webpack_require__(970);

var _hiddenInput2 = _interopRequireDefault(_hiddenInput);

var _input = __webpack_require__(971);

var _input2 = _interopRequireDefault(_input);

var _youtubeModal = __webpack_require__(972);

var _youtubeModal2 = _interopRequireDefault(_youtubeModal);

var _closeCoveoModal = __webpack_require__(974);

var _closeCoveoModal2 = _interopRequireDefault(_closeCoveoModal);

var _formSubmitGroceryEmail = __webpack_require__(975);

var _formSubmitGroceryEmail2 = _interopRequireDefault(_formSubmitGroceryEmail);

var _speedBumpLinks = __webpack_require__(172);

var _speedBumpLinks2 = _interopRequireDefault(_speedBumpLinks);

var _skipTo = __webpack_require__(976);

var _skipTo2 = _interopRequireDefault(_skipTo);

var _selectAll = __webpack_require__(173);

var _selectAll2 = _interopRequireDefault(_selectAll);

var _speedBumpModalTabbing = __webpack_require__(977);

var _speedBumpModalTabbing2 = _interopRequireDefault(_speedBumpModalTabbing);

var _customEvent = __webpack_require__(174);

var _customEvent2 = _interopRequireDefault(_customEvent);

var _objectFit = __webpack_require__(115);

var _objectFit2 = _interopRequireDefault(_objectFit);

var _localstorage = __webpack_require__(978);

var _localstorage2 = _interopRequireDefault(_localstorage);

var _fromStore = __webpack_require__(979);

var _fromStore2 = _interopRequireDefault(_fromStore);

var _inputMask = __webpack_require__(981);

var _inputMask2 = _interopRequireDefault(_inputMask);

var _stickyHeader = __webpack_require__(982);

var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

var _analyticsCampaignTracker = __webpack_require__(983);

var _analyticsCampaignTracker2 = _interopRequireDefault(_analyticsCampaignTracker);

var _courseSearchForm = __webpack_require__(984);

var _courseSearchForm2 = _interopRequireDefault(_courseSearchForm);

var _phdProVolSearch = __webpack_require__(985);

var _phdProVolSearch2 = _interopRequireDefault(_phdProVolSearch);

var _authoring = __webpack_require__(299);

var _authoring2 = _interopRequireDefault(_authoring);

var _vjsDropdownCoveo = __webpack_require__(987);

var _vjsDropdownCoveo2 = _interopRequireDefault(_vjsDropdownCoveo);

var _coveoEvents = __webpack_require__(988);

var _coveoEvents2 = _interopRequireDefault(_coveoEvents);

var _fundraiseUp = __webpack_require__(989);

var _fundraiseUp2 = _interopRequireDefault(_fundraiseUp);

var _detectIos = __webpack_require__(990);

var _detectIos2 = _interopRequireDefault(_detectIos);

var _revealElementBehindSticky = __webpack_require__(991);

var _revealElementBehindSticky2 = _interopRequireDefault(_revealElementBehindSticky);

var _ahaCookie = __webpack_require__(151);

var _itemsStorage = __webpack_require__(100);

__webpack_require__(992);

__webpack_require__(1025);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Expose VanillaJS Dropdown plugin to Global scope


// Phd Components

// Plugins

// import setMainNavActive from '@/utils/main-nav-active';

// import setSsoInterceptLinks from '@/utils/sso-intercept-links'; // removed by C.Castle


// Global directives


// Reusuable Generic components
window.VJSDropdown = new _authoring2['default']();

// Global Filter


_vue2['default'].use(_bootstrapVue2['default']);
_vue2['default'].use(_veeValidate2['default']);
_vue2['default'].use(_vueClipboard2['default']);
_vue2['default'].use(_vuex2['default']);
_vue2['default'].use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAfoI8CjSCPhRd7IYXmgAbArVRkEdGvMyU',
        libraries: 'places'
    }
});

_vue2['default'].filter('pluralize', _pluralize2['default']);

_vue2['default'].directive('vertical-align', _verticalAlign2['default']);
_vue2['default'].directive('lazy-img', _lazyImg2['default']);
_vue2['default'].directive('toggle-checked', _toggleChecked2['default']);
_vue2['default'].directive('toggle-credit-image', _toggleCreditImage2['default']);
_vue2['default'].directive('share-button', _shareButton2['default']);
_vue2['default'].directive('perfect-scrollbar', _perfectScrollbar2['default']);
_vue2['default'].directive('speed-bump', _speedBump2['default']);
_vue2['default'].directive('sso-intercept', _ssoIntercept2['default']);
_vue2['default'].directive('print-element', _printElement2['default']);
_vue2['default'].directive('register-event', _registerEvent2['default']);
_vue2['default'].directive('form-submit', _formSubmit2['default']);
_vue2['default'].directive('form-validate', _formValidate2['default']);
_vue2['default'].directive('form-submit-checkbox', _formSubmitCheckbox2['default']);
_vue2['default'].directive('button-collapse-content', _buttonCollapseContent2['default']);
_vue2['default'].directive('image-video-carousel', _imageVideoCarousel2['default']);
_vue2['default'].directive('luminate-donate-form', _luminateDonateForm2['default']);
_vue2['default'].directive('max-children-height', _maxChildrenHeight2['default']);
_vue2['default'].directive('nestedAccordion', _nestedAccordion2['default']);
_vue2['default'].directive('tabs', _tabs2['default']);
_vue2['default'].directive('tabs-custom-tabbing', _tabsCustomTabbing2['default']);
_vue2['default'].directive('hidden-input', _hiddenInput2['default']);
_vue2['default'].directive('input', _input2['default']);
_vue2['default'].directive('youtube-modal', _youtubeModal2['default']);
_vue2['default'].directive('close-coveo-modal', _closeCoveoModal2['default']);
_vue2['default'].directive('from-store', _fromStore2['default']);
_vue2['default'].directive('aha-mask', _inputMask2['default']);
_vue2['default'].directive('sticky-header', _stickyHeader2['default']);
_vue2['default'].directive('course-search-form', _courseSearchForm2['default']);
_vue2['default'].directive('phd-pro-vol-search', _phdProVolSearch2['default']);
_vue2['default'].directive('form-submit-grocery-email', _formSubmitGroceryEmail2['default']);

// Non-visual required components
_vue2['default'].component('app-icon', _appIcon2['default']);
_vue2['default'].component('fit-text', _fitText2['default']);
_vue2['default'].component('aha-nav-dropdown', _ahaNavDropdown2['default']);
_vue2['default'].component('aha-select-dropdown', _ahaSelectDropdown2['default']);
_vue2['default'].component('aha-select-dropdown-item', _ahaSelectDropdownItem2['default']);
_vue2['default'].component('aha-location-selector', _locationSelector2['default']);
_vue2['default'].component('aha-location-selector-form', _locationSelectorForm2['default']);
_vue2['default'].component('aha-location-selector-table', _locationSelectorTable2['default']);
_vue2['default'].component('aha-stroke-group-selector', _strokeGroupSelector2['default']);
_vue2['default'].component('aha-stroke-group-selector-form', _strokeGroupSelectorForm2['default']);
_vue2['default'].component('aha-stroke-group-selector-table', _strokeGroupSelectorTable2['default']);
_vue2['default'].component('aha-youtube', _ahaYoutube2['default']);
_vue2['default'].component('aha-notification', _ahaNotification2['default']);
_vue2['default'].component('aha-mobile-nav', _ahaMobileNav2['default']);
_vue2['default'].component('aha-recipe-checkbox', _ahaRecipeCheckbox2['default']);
_vue2['default'].component('aha-recipe-social', _ahaRecipeSocial2['default']);
_vue2['default'].component('aha-modal', _ahaModal2['default']);
_vue2['default'].component('aha-listbox', _ahaListbox2['default']);
_vue2['default'].component('aha-donation-modal', _ahaDonationModal2['default']);
_vue2['default'].component('aha-hospital-zipcode-modal', _ahaHospitalZipcodeModal2['default']);
_vue2['default'].component('aha-session-timeout-modal', _ahaSessionTimeoutModal2['default']);
_vue2['default'].component('aha-inline-site-search', _ahaInlineSiteSearch2['default']);
_vue2['default'].component('impacted-data', _impactedData2['default']);
_vue2['default'].component('aha-back-to-search-link', _ahaBackToSearch2['default']);
_vue2['default'].component('aha-share', _ahaShare2['default']);
_vue2['default'].component('aha-share-gigya', _ahaShareGigya2['default']);
_vue2['default'].component('aha-transition-group', _ahaTransitionGroup2['default']);
_vue2['default'].component('aha-transition-group-form', _ahaTransitionGroupForm2['default']);
_vue2['default'].component('aha-transition-step', _ahaTransitionStep2['default']);
_vue2['default'].component('aha-transition-trigger', _ahaTransitionTrigger2['default']);
_vue2['default'].component('aha-transition-input-value', _ahaTransitionInputValue2['default']);
_vue2['default'].component('aha-search-results-form', _ahaSearchResultsForm2['default']);
_vue2['default'].component('aha-single-field-prompt-form', _ahaSingleFieldPromptForm2['default']);
_vue2['default'].component('aha-single-field-prompt-radio-form', _ahaSingleFieldPromptRadioForm2['default']);
_vue2['default'].component('aha-tv-page-modal', _ahaTvPageModal2['default']);
_vue2['default'].component('aha-make-commitment-form', _ahaMakeCommitmentForm2['default']);
_vue2['default'].component('aha-add-to-recipe-box', _ahaAddToRecipeBox2['default']);
_vue2['default'].component('aha-recipe-box-favorite', _ahaRecipeBoxFavorite2['default']);
_vue2['default'].component('aha-modify-recipe-box', _ahaModifyRecipeBox2['default']);
_vue2['default'].component('aha-google-map', _ahaGoogleMap2['default']);
_vue2['default'].component('aha-half-image-half-copy-collapse', _ahaHalfImageHalfCopyCollapse2['default']);
_vue2['default'].component('aha-copy-url-to-clipboard', _ahaCopyUrlToClipboard2['default']);
_vue2['default'].component('aha-external-script', _ahaExternalScript2['default']);
_vue2['default'].component('support-bar-section', _footerSupportBarSection2['default']);
_vue2['default'].component('simple-accordion', _simpleAccordion2['default']);
_vue2['default'].component('aha-daf-widget', _ahaDafWidget2['default']);
_vue2['default'].component('aha-selection-card', _ahaSelectionCard2['default']);
_vue2['default'].component('aha-card-selector', _ahaCardSelector2['default']);
_vue2['default'].component('aha-card-selector-filter', _ahaCardSelectorFilter2['default']);
_vue2['default'].component('aha-card-viewer', _ahaCardViewer2['default']);
_vue2['default'].component('aha-card-viewer-text', _ahaCardViewerText2['default']);
_vue2['default'].component('aha-switch-input', _ahaSwitchInput2['default']);
_vue2['default'].component('aha-collapsable-view', _ahaCollapsableView2['default']);
_vue2['default'].component('aha-masked-input', _ahaMaskedInput2['default']);
_vue2['default'].component('aha-cpr-search-course-wrapper', _ahaCprSearchCourseWrapper2['default']);
_vue2['default'].component('phd-science-volunteer-modal', _phdScienceVolunteerModal2['default']);
_vue2['default'].component('aha-newsletter-ajax-thank-you', _ahaNewsletterAjaxThankYou2['default']);
_vue2['default'].component('aha-sitecore-form-wrapper', _ahaSitecoreFormWrapper2['default']);
_vue2['default'].component('aha-carousel', _ahaCarousel2['default']);
_vue2['default'].component('aha-grocery-list', _ahaGroceryList2['default']);
_vue2['default'].component('aha-grocery-count', _ahaGroceryCount2['default']);

_vue2['default'].prototype.$eventHub = new _vue2['default']();

/* eslint-disable */
window.ahavm = new _vue2['default']({
    el: '#app'
});

// Set up the speed-bump hack to bridge between vanilla JS and Vue
(0, _speedBumpLinks2['default'])('.twoClick, .twoclick', '#speed-bump-link');
// setSsoInterceptLinks('#sso-intercept-link'); // removed by C.Castle
(0, _skipTo2['default'])('.c-skip-to');
(0, _selectAll2['default'])();
// setMainNavActive();
(0, _speedBumpModalTabbing2['default'])();
(0, _vjsDropdownCoveo2['default'])();
(0, _coveoEvents2['default'])();
(0, _customEvent2['default'])();
(0, _objectFit2['default'])();
(0, _localstorage2['default'])();
(0, _analyticsCampaignTracker2['default'])();
(0, _fundraiseUp2['default'])();
(0, _detectIos2['default'])();
(0, _revealElementBehindSticky2['default'])();
window.AHACookieAPI = _ahaCookie.Cookie;
window.AHAItemsStorageAPI = { itemsStorage: _itemsStorage.itemsStorageFunc, filters: _itemsStorage.itemsStorageFilters };

/***/ }),
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_icon_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_icon_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_icon_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_icon_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df8fc834_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_app_icon_vue__ = __webpack_require__(757);
function injectStyle (ssrContext) {
  __webpack_require__(754)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = true
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_icon_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df8fc834_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_app_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(755);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("d7d8ca5e", content, true, {});

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".icon{width:1.2em;height:1.2em;fill:currentColor}.icon.is-large{width:2em;height:2em}.icon.is-medium{width:1.6em;height:1.6em}.icon.is-normal{width:1.2em;height:1.2em}.icon.is-small{width:1em;height:1em}.icon.is-tiny{width:.8em;height:.8em}.icon.is-blue,.icon.is-primary{fill:#2196f3}.icon.is-green,.icon.is-success{fill:#4caf50}.icon.is-danger,.icon.is-red{fill:#f44336}.icon.is-orange,.icon.is-warning{fill:#ff9800}", ""]);

// exports


/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports = {"heart":"M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z","housing":"M4.21875,0 C1.8984375,0 0,1.8984375 0,4.21875 C0,4.9359375 0.5484375,5.484375 1.265625,5.484375 C1.9828125,5.484375 2.53125,4.9359375 2.53125,4.21875 C2.53125,3.290625 3.290625,2.53125 4.21875,2.53125 C5.146875,2.53125 5.90625,3.290625 5.90625,4.21875 C5.90625,5.146875 5.146875,5.90625 4.21875,5.90625 C1.8984375,5.90625 0,7.8046875 0,10.125 L0,18.984375 C0,19.321875 0.1265625,19.659375 0.3796875,19.8703125 C0.6328125,20.08125 0.928125,20.25 1.265625,20.25 L7.171875,20.25 C7.509375,20.25 7.846875,20.1234375 8.0578125,19.8703125 C8.26875,19.6171875 8.4375,19.321875 8.4375,18.984375 L8.4375,4.21875 C8.4375,1.8984375 6.5390625,0 4.21875,0 Z M7.59375,18.984375 C7.59375,19.1109375 7.5515625,19.1953125 7.4671875,19.2796875 C7.3828125,19.3640625 7.2984375,19.40625 7.171875,19.40625 L1.265625,19.40625 C1.1390625,19.40625 1.0546875,19.3640625 0.9703125,19.2796875 C0.8859375,19.1953125 0.84375,19.1109375 0.84375,18.984375 L0.84375,10.125 C0.84375,8.26875 2.3625,6.75 4.21875,6.75 C5.6109375,6.75 6.75,5.6109375 6.75,4.21875 C6.75,2.8265625 5.6109375,1.6875 4.21875,1.6875 C2.8265625,1.6875 1.6875,2.8265625 1.6875,4.21875 C1.6875,4.471875 1.51875,4.640625 1.265625,4.640625 C1.0125,4.640625 0.84375,4.471875 0.84375,4.21875 C0.84375,2.3625 2.3625,0.84375 4.21875,0.84375 C6.075,0.84375 7.59375,2.3625 7.59375,4.21875 L7.59375,18.984375 Z M3.335512,13.5288024 L5.81587685,11.0484375 L6.6234375,11.8559981 L3.73929232,14.7401433 C3.62392652,14.8555091 3.50856071,14.913192 3.335512,14.913192 C3.16246329,14.913192 3.04709748,14.8555091 2.93173167,14.7401433 L1.7780736,13.5864853 L2.58563425,12.7789246 L3.335512,13.5288024 Z M17.71875,4.21875 C17.71875,1.8984375 15.8203125,0 13.5,0 C11.1796875,0 9.28125,1.8984375 9.28125,4.21875 C9.28125,6.5390625 11.1796875,8.4375 13.5,8.4375 C13.7953125,8.4375 14.090625,8.3953125 14.34375,8.353125 L14.34375,18.39375 L13.5,19.2375 L11.390625,17.128125 L11.390625,17.04375 L12.5296875,15.9046875 C12.6140625,15.8203125 12.65625,15.7359375 12.65625,15.609375 C12.65625,15.4828125 12.6140625,15.3984375 12.5296875,15.3140625 L11.390625,14.175 L11.390625,14.090625 L12.5296875,12.9515625 C12.6140625,12.8671875 12.65625,12.7828125 12.65625,12.65625 C12.65625,12.5296875 12.6140625,12.4453125 12.5296875,12.3609375 L11.390625,11.221875 L11.390625,11.1375 L12.1078125,10.4203125 C12.1921875,10.3359375 12.234375,10.2515625 12.234375,10.125 L12.234375,8.859375 L11.390625,8.859375 L11.390625,9.95625 L10.6734375,10.6734375 C10.5890625,10.7578125 10.546875,10.8421875 10.546875,10.96875 L10.546875,11.390625 C10.546875,11.5171875 10.5890625,11.6015625 10.6734375,11.6859375 L11.64375,12.65625 L10.6734375,13.6265625 C10.5890625,13.7109375 10.546875,13.7953125 10.546875,13.921875 L10.546875,14.34375 C10.546875,14.4703125 10.5890625,14.5546875 10.6734375,14.6390625 L11.64375,15.609375 L10.6734375,16.5796875 C10.5890625,16.6640625 10.546875,16.7484375 10.546875,16.875 L10.546875,17.296875 C10.546875,17.4234375 10.5890625,17.5078125 10.6734375,17.5921875 L13.2046875,20.1234375 C13.2890625,20.2078125 13.415625,20.25 13.5,20.25 C13.584375,20.25 13.7109375,20.2078125 13.7953125,20.1234375 L15.0609375,18.8578125 C15.1453125,18.7734375 15.1875,18.6890625 15.1875,18.5625 L15.1875,8.1 C16.6640625,7.425 17.71875,5.9484375 17.71875,4.21875 Z M13.5,7.59375 C11.64375,7.59375 10.125,6.075 10.125,4.21875 C10.125,2.3625 11.64375,0.84375 13.5,0.84375 C15.35625,0.84375 16.875,2.3625 16.875,4.21875 C16.875,6.075 15.35625,7.59375 13.5,7.59375 Z","program":"M77.53455,4271 L77.53455,4275.5 L72,4275.5 L72,4307 L112.5,4307 L112.5,4282.241 L105.75405,4275.5 L92.25,4275.5 L77.53455,4271 Z M79.78455,4300.48805 L79.78455,4274.042 L91.12455,4277.75 L91.12455,4304.75 L79.78455,4300.48805 Z M93.375,4277.75 L103.5,4277.75 L103.5,4284.49595 L110.24955,4284.49595 L110.24955,4304.75 L93.375,4304.75 L93.375,4277.75 Z M74.25,4277.75 L77.53455,4277.75 L77.53455,4302.15395 L84.897,4304.75 L74.25,4304.75 L74.25,4277.75 Z M105.74955,4278.677 L109.32255,4282.2455 L105.74955,4282.2455 L105.74955,4278.677 Z"}

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',_vm._g(_vm._b({staticClass:"icon",class:_vm.$options.methods.getStyleClasses(_vm.props),attrs:{"viewBox":"0 0 24 24","role":"img"}},'svg',_vm.data.attrs,false),_vm.listeners),[_c('title',[_vm._v(_vm._s(_vm.props.title || _vm.props.name))]),_vm._v(" "),(_vm.props.desc)?_c('desc',[_vm._v(_vm._s(_vm.props.desc))]):_vm._e(),_vm._v(" "),_c('path',{attrs:{"d":_vm.$options.methods.getPath(_vm.props)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fit_text_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fit_text_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fit_text_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fit_text_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fit_text_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5247a7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fit_text_vue__ = __webpack_require__(759);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fit_text_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5247a7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fit_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _ahaDropdown = __webpack_require__(144);

var _ahaDropdown2 = _interopRequireDefault(_ahaDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default'], _ahaDropdown2['default']],
    render: function render(h) {
        var toggle = h('button', {
            ref: 'toggle',
            attrs: {
                id: this.safeId('_BV_toggle_'),
                'aria-haspopup': this.hasPopup,
                'aria-expanded': this.visible ? 'true' : 'false'
            },
            'class': this.extraClasses,
            on: {
                click: this.toggle,
                keydown: this.toggle
            }
        }, [this.$slots['default']]);

        var arrow = h('span', {
            ref: 'arrow',
            attrs: {
                'x-arrow': ''
            },
            'class': this.arrowClass
        });

        var menu = h('div', {
            ref: 'menu',
            'class': this.menuClasses,
            attrs: this.menuAttributes,
            on: {
                keydown: this.onKeydown // tab, up, down, esc
            }
        }, [this.$slots.dropdown, arrow]);

        return h('div', {
            ref: 'dropdown',
            attrs: {
                id: this.safeId()
            },
            'class': this.dropdownClasses
        }, [toggle, menu]);
    },

    props: {
        target: {
            // String ID of element, or element/component reference
            type: [String, Object]
        },
        size: {
            type: String,
            'default': null
        },
        extraClasses: {
            type: String,
            'default': ''
        },
        arrowClass: {
            type: String,
            'default': 'c-nav-dropdown__arrow'
        },
        role: {
            type: String,
            'default': null
        },
        hasPopup: {
            type: String,
            'default': 'true'
        },
        arrow: {
            type: Boolean,
            'default': true
        },
        boundary: {
            // String: `scrollParent`, `window` or `viewport`
            // Object: HTML Element reference
            type: [String, Object],
            'default': 'scrollParent'
        }
    },
    computed: {
        dropdownClasses: function dropdownClasses() {
            var position = '';
            // Position `static` is needed to allow menu to "breakout" of the scrollParent boundaries
            // when boundary is anything other than `scrollParent`
            // See https://github.com/twbs/bootstrap/issues/24251#issuecomment-341413786
            if (this.boundary !== 'scrollParent' || !this.boundary) {
                position = 'position-static';
            }

            return ['c-nav-dropdown__container', this.visible ? 'show' : '', position];
        },
        menuClasses: function menuClasses() {
            return ['c-nav-dropdown', 'dropdown-menu', this.right ? 'dropdown-menu-right' : ''];
        },
        menuAttributes: function menuAttributes() {
            var attributes = {
                'aria-labelledby': this.safeId('_BV_toggle_')
            };

            if (this.role) {
                attributes.role = this.role;
            }

            return attributes;
        },
        toggleClasses: function toggleClasses() {
            return [{
                'dropdown-toggle': !this.noCaret || this.split,
                'dropdown-toggle-split': this.split
            }, this.toggleClass];
        }
    }
};

/***/ }),
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _ahaDropdown = __webpack_require__(144);

var _ahaDropdown2 = _interopRequireDefault(_ahaDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default'], _ahaDropdown2['default']],
    render: function render(h) {
        var toggle = h('button', {
            ref: 'toggle',
            attrs: {
                id: this.safeId('_BV_toggle_'),
                'aria-haspopup': 'true',
                'aria-expanded': this.visible ? 'true' : 'false',
                type: 'button'
            },
            'class': this.toggleClasses,
            on: {
                click: this.toggle,
                keydown: this.toggle
            }
        }, [this.buttonText]);

        var arrow = h('span', {
            ref: 'arrow',
            attrs: {
                'x-arrow': ''
            },
            'class': 'c-nav-dropdown__arrow'
        });

        var menu = h('div', {
            ref: 'menu',
            'class': this.menuClasses,
            attrs: {
                role: this.role,
                'aria-labelledby': this.safeId('_BV_toggle_')
            },
            on: {
                keydown: this.onKeydown // tab, up, down, esc
            }
        }, [this.$slots.dropdown, this.arrow ? arrow : null]);

        var hiddenInput = h('input', {
            attrs: {
                type: 'hidden',
                value: this.hiddenValue,
                name: this.inputName
            }
        });

        return h('div', {
            ref: 'dropdown',
            attrs: {
                id: this.safeId()
            },
            'class': this.dropdownClasses
        }, [toggle, hiddenInput, menu]);
    },
    data: function data() {
        return {
            hiddenValue: null,
            displayText: null,
            dropdownItems: {}
        };
    },

    props: {
        value: {
            required: false
        },
        defaultValue: {
            type: String,
            required: true
        },
        toggleClass: {
            type: String,
            'default': ''
        },
        role: {
            type: String,
            'default': 'menu'
        },
        arrow: {
            type: Boolean,
            'default': false
        },
        inputName: {
            type: String,
            'default': 'searchCategory'
        },
        boundary: {
            // String: `scrollParent`, `window` or `viewport`
            // Object: HTML Element reference
            type: [String, Object],
            'default': 'scrollParent'
        }
    },
    mounted: function mounted() {
        this.$on('selected', this.clickListener);
        this.$on('register', this.registerDropdownItem);

        // Set the default dropdown value if specified
        if (this.defaultValue) {
            this.hiddenValue = this.defaultValue;
        }
    },

    methods: {
        clickListener: function clickListener(value, text) {
            if (typeof value !== 'undefined') {
                this.hiddenValue = value;
                this.displayText = text;

                this.$emit('input', this.hiddenValue);
            }
        },
        registerDropdownItem: function registerDropdownItem(value, text) {
            this.dropdownItems[value] = text;
        }
    },
    watch: {
        // Value comes from v-model
        value: function value(val) {
            // If the value is trying to be set programmatically, check the registered dropdown items
            if (typeof this.dropdownItems[val] !== 'undefined') {
                this.hiddenValue = val;
                this.displayText = this.dropdownItems[val];
            }
        }
    },
    computed: {
        buttonText: function buttonText() {
            return this.displayText || this.defaultValue;
        },
        dropdownClasses: function dropdownClasses() {
            var position = '';
            // Position `static` is needed to allow menu to "breakout" of the scrollParent boundaries
            // when boundary is anything other than `scrollParent`
            // See https://github.com/twbs/bootstrap/issues/24251#issuecomment-341413786
            if (this.boundary !== 'scrollParent' || !this.boundary) {
                position = 'position-static';
            }

            return ['c-select-dropdown__container', this.visible ? 'show' : '', position];
        },
        menuClasses: function menuClasses() {
            return ['c-select-dropdown', 'dropdown-menu', this.right ? 'dropdown-menu-right' : ''];
        },
        toggleClasses: function toggleClasses() {
            return [this.toggleClass];
        }
    }
};

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(22);

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default']],
    render: function render(h) {
        var vm = this;

        return h(this.tag, {
            on: {
                keydown: function keydown(e) {
                    if (e.keyCode === _utils.KeyCodes.ENTER || e.keyCode === _utils.KeyCodes.SPACE) {
                        vm.emitEvents(e, vm.inputValue, vm.text);
                    }

                    // If we're trying to tab inside of the dropdown, close it
                    if (e.keyCode === 9 || e.keyCode === 16 && e.keyCode === 9) {
                        vm.$root.$emit('clicked::link', e);
                    }
                },
                click: function click(e) {
                    vm.emitEvents(e, vm.inputValue, vm.text);
                }
            },
            attrs: this.attributes,
            'class': this.itemClass
        }, [this.$slots['default']]);
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.$parent.$emit('register', _this.inputValue, _this.text, _this.$el);
        });

        if (this.selected) {
            this.$nextTick(function () {
                _this.$parent.$emit('selected', _this.inputValue, _this.text, _this.$el, true);
            });
        }
    },

    props: {
        value: {
            type: String
        },
        text: {
            type: String,
            required: true
        },
        itemClass: {
            type: String
        },
        selected: {
            type: Boolean,
            'default': false
        },
        tag: {
            type: String,
            'default': 'button'
        },
        role: {
            type: String,
            'default': 'menuitem'
        }
    },
    computed: {
        attributes: function attributes() {
            var attributes = {
                // type: 'button',
                role: this.role,
                id: this.safeId('_dropdown-item_')
            };

            if (this.tag !== 'a') {
                attributes['aria-selected'] = 'false';
            }

            return attributes;
        },
        inputValue: function inputValue() {
            return this.value;
        }
    },
    methods: {
        emitEvents: function emitEvents(e, value, text) {
            this.$parent.$emit('selected', value, text, this.$el);
        }
    }
};

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10462188_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_location_selector_vue__ = __webpack_require__(793);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10462188_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_location_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showDropdown)?_c('div',[_c('aha-nav-dropdown',{attrs:{"role":"dialog","has-popup":"dialog","position":"right","extra-classes":"c-top-nav__link c-cta dropdown-toggle","disable-menu-events":true},on:{"shown":_vm.onShown,"hidden":_vm.onHidden}},[_vm._t("default"),_vm._v(" "),_c('template',{slot:"dropdown"},[_vm._t("content"),_vm._v(" "),_c('aha-location-selector-form',{attrs:{"endpoint":_vm.searchEndpoint,"states":_vm.states,"translations":_vm.translations,"is-visible":_vm.isVisible,"on-submit":_vm.handleSubmit}})],2)],2)],1):_c('div',[_vm._t("content"),_vm._v(" "),_c('aha-location-selector-form',{attrs:{"endpoint":_vm.searchEndpoint,"states":_vm.states,"translations":_vm.translations,"is-visible":_vm.isVisible,"on-submit":_vm.handleSubmit}})],2),_vm._v(" "),(_vm.showModal)?_c('div',[_c('aha-modal',{ref:"locationSelectorModal",staticClass:"c-location-modal",attrs:{"id":"locationSelectorModal","hide-footer":"","centered":"","lazy":""}},[_c('template',{slot:"modal-header"},[_c('h2',{staticClass:"c-location-modal__heading h4"},[_vm._v(_vm._s(_vm.translations.searchResults)+" "),_c('i',[_vm._v("\""+_vm._s(_vm.searchText)+"\"")])])]),_vm._v(" "),_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'locationSelectorModal', $event.target)}}},[_vm._v("×")]),_vm._v(" "),_c('aha-location-selector-table',{attrs:{"translations":_vm.translations,"locations":_vm.locations}})],2)],1):_c('div',{staticClass:"c-location-selector__mobile-table"},[(_vm.locations.length)?_c('div',[_c('div',{staticClass:"c-location-selector__mobile-header"},[_c('h2',{staticClass:"c-location-modal__heading h4"},[_vm._v(_vm._s(_vm.translations.searchResults)+" "),_c('i',[_vm._v("\""+_vm._s(_vm.searchText)+"\"")])]),_vm._v(" "),_c('span',{staticClass:"c-cta h-theme--red",on:{"click":_vm.clearResults}},[_vm._v(_vm._s(_vm.translations.clearResults))])]),_vm._v(" "),_c('aha-location-selector-table',{attrs:{"translations":_vm.translations,"locations":_vm.locations}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_form_vue__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed1a210_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_location_selector_form_vue__ = __webpack_require__(795);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed1a210_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_location_selector_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"location-selector-form",staticClass:"location-search",class:{ 'is-loading': _vm.isLoading },attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"location-search__fields"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.zipcodeId}},[_vm._v(_vm._s(_vm.translations.zipCode))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zipcode),expression:"zipcode"}],ref:"input1",staticClass:"form-control",attrs:{"id":_vm.zipcodeId,"name":"zipcode","type":"text","pattern":"^\\d{5}(?:[-\\s]\\d{4})?$","placeholder":_vm.translations.zipCode},domProps:{"value":(_vm.zipcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.zipcode=$event.target.value}}})]),_vm._v(" "),_c('span',{staticClass:"location-search__or"},[_vm._v(_vm._s(_vm.translations.or))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.stateId}},[_vm._v(_vm._s(_vm.translations.state))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.state),expression:"state"}],staticClass:"custom-select btn--select",attrs:{"id":_vm.stateId,"name":"state"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.state=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.translations.state))]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('option',{key:state.code,domProps:{"value":state.code}},[_vm._v(_vm._s(state.title))])})],2)])]),_vm._v(" "),_c('button',{ref:"submit",staticClass:"location-search__search btn btn-tertiary btn-round",attrs:{"disabled":!_vm.validInput,"type":"submit"}},[_vm._v(_vm._s(_vm.translations.search))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_table_vue__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_table_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_table_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_table_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5f14e12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_location_selector_table_vue__ = __webpack_require__(797);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_table_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5f14e12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_location_selector_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.validLocations.length)?_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.translations.noResults))]):_vm._e(),_vm._v(" "),(_vm.validLocations.length)?_c('table',{staticClass:"c-location-modal__table table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.translations.offices))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.translations.address))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.validLocations),function(location){return _c('tr',{key:location.id},[_c('td',[_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":location.url}},[_vm._v(_vm._s(location.name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(location.address1)+" "+_vm._s(location.address2))])])}),0)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_vue__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf5f125_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_selector_vue__ = __webpack_require__(800);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf5f125_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-container",class:{ show: _vm.isLoading },attrs:{"role":"alert","aria-live":"assertive","id":_vm.uuid}},[_c('div',{staticClass:"loader"},[_vm._v("Loading...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo row"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo--full-width c-promo--bg-triangle c-promo--border c-promo--shadow h-theme--red"},[_c('aha-loading-spinner',{attrs:{"is-loading":_vm.isLoading}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 c-promo--last-sm"},[_c('div',{staticClass:"c-promo c-promo--match-height"},[_c('div',{staticClass:"c-promo__content"},[_c('h2',{staticClass:"h2"},[_vm._v(_vm._s(_vm.translations.title))]),_vm._v(" "),_c('div',[_c('p',[_c('span',{staticClass:"small form-text text-danger"},[_vm._v(_vm._s(_vm.translations.requiredFields))])]),_vm._v(" "),_c('aha-stroke-group-selector-form',{ref:"strokeForm1",attrs:{"endpoint":_vm.searchEndpoint,"radius":_vm.radius,"translations":_vm.translations,"is-visible":_vm.isVisible,"on-submit":_vm.handleSubmit}})],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.translations.increaseRadius))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:(_vm.image),expression:"image"}],attrs:{"src":_vm.image,"alt":""}})])])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"c-location-selector__mobile-table",attrs:{"aria-live":"polite","aria-atomic":"true"}},[(_vm.invalidZipCode)?_c('div',[_c('div',[_c('p',[_vm._v(_vm._s(_vm.translations.zipCodeNotFound))])])]):(_vm.foundlocations.length)?_c('div',[_c('div',{staticClass:"c-location-selector__mobile-header"},[_c('h2',{staticClass:"c-location-modal__heading h4"},[_vm._v("\n            "+_vm._s(_vm.translations.searchResults)+"\n            "),_c('i',[_vm._v("\""+_vm._s(_vm.searchText)+"\"")])]),_vm._v(" "),_c('button',{ref:"clearResultsLink",staticClass:"c-cta btn btn-link h-theme--red",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.clearResults.apply(null, arguments)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.clearResults.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.clearResults.apply(null, arguments)}]}},[_vm._v(_vm._s(_vm.translations.clearResults))])]),_vm._v(" "),_c('aha-stroke-group-selector-table',{ref:"results",attrs:{"previousSearchedParams":_vm.previousParams,"translations":_vm.translations,"locations":_vm.foundlocations}})],1):_c('div',[(_vm.searchClicked > 0 && _vm.foundlocations.length === 0)?_c('div',[_c('h3',[_vm._v(_vm._s(_vm.translations.noResultsFound))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.translations.increaseRadius))])]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_form_vue__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdcf8814_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_selector_form_vue__ = __webpack_require__(802);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdcf8814_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_selector_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"strokeForm",staticClass:"stroke-group-search my-4",class:{ 'is-loading': _vm.isLoading },attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"location-search__fields"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.zipcodeId}},[_vm._v(_vm._s(_vm.translations.zipCode))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zipcode),expression:"zipcode"}],ref:"input1",staticClass:"form-control",attrs:{"id":_vm.zipcodeId,"name":"zipcode","type":"text","pattern":"^\\d{5}(?:[-\\s]\\d{4})?$","placeholder":_vm.translations.zipCodePlaceholder},domProps:{"value":(_vm.zipcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.zipcode=$event.target.value}}})]),_vm._v(" "),_c('span',{staticClass:"ml-5 d-xs-none"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.radiusId}},[_vm._v(_vm._s(_vm.translations.radius))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.rad),expression:"rad"}],staticClass:"custom-select btn--select",attrs:{"id":_vm.radiusId,"name":"radius"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.rad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select radius")]),_vm._v(" "),_vm._l((_vm.radius),function(rad){return _c('option',{key:rad.code,domProps:{"value":rad.code}},[_vm._v(_vm._s(rad.title))])})],2)])]),_vm._v(" "),_c('button',{ref:"submit",staticClass:"location-search__search btn btn-tertiary btn-round",attrs:{"disabled":!_vm.validInput,"type":"submit"}},[_vm._v(_vm._s(_vm.translations.search))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_table_vue__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_table_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_table_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_table_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4bbfd58_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_selector_table_vue__ = __webpack_require__(804);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_table_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4bbfd58_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_selector_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md"},[_c('b-form-group',{attrs:{"name":"filter","label":"Filter by Audience:"}},[_c('b-form-checkbox-group',{attrs:{"plain":"","options":_vm.options},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1),_vm._v(" "),_c('table',{staticClass:"c-location-modal__table table mb-6",attrs:{"id":"results-table"}},[_c('caption',{staticClass:"sr-only",attrs:{"id":"stroke-groups-caption","aria-live":"polite"}},[_vm._v("\n      Stroke Group Results\n      "),_c('span',{ref:"captionUpdate",attrs:{"id":"captionUpdated"}},[_vm._v(_vm._s(_vm.captionMessage))])]),_vm._v(" "),_c('thead',[_c('tr',[_c('th',{attrs:{"tabindex":"0","aria-sort":_vm.currentSortDir},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sort('name')},"click":function($event){return _vm.sort('name')}}},[_c('span',{attrs:{"role":"button"}},[_vm._v(_vm._s(_vm.translations.name))])]),_vm._v(" "),_c('th',{attrs:{"tabindex":"0","aria-sort":_vm.currentSortDir},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sort('city')},"click":function($event){return _vm.sort('city')}}},[_c('span',{attrs:{"role":"button"}},[_vm._v(_vm._s(_vm.translations.city))])]),_vm._v(" "),_c('th',{attrs:{"tabindex":"0","aria-sort":_vm.currentSortDir},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sort('state')},"click":function($event){return _vm.sort('state')}}},[_c('span',{attrs:{"role":"button"}},[_vm._v(_vm._s(_vm.translations.state))])]),_vm._v(" "),_c('th',{attrs:{"tabindex":"0","aria-sort":_vm.currentSortDir},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sort('zip')},"click":function($event){return _vm.sort('zip')}}},[_c('span',{attrs:{"role":"button"}},[_vm._v(_vm._s(_vm.translations.zipCode))])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.sortedName),function(location){return _c('tr',{key:location.id},[_c('td',[_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":location.url},on:{"click":function($event){return _vm.locationClicked(location.url)}}},[_vm._v(_vm._s(location.name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(location.city))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(location.state))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(location.zip))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _youtubePlayer = __webpack_require__(806);

var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default']],
    render: function render(h) {
        var _this = this;

        var youtubeContainerId = this.safeId('_AHA_youtube_');

        var youtube = h('div', {
            'class': 'youtube-player',
            attrs: {
                id: youtubeContainerId
            }
        });

        var embed = h('div', {
            'class': 'embed-responsive embed-responsive-16by9'
        }, [youtube]);

        var closeButton = h('b-btn-close', {
            on: {
                click: function click(event) {
                    _this.$root.$emit('bv::hide::modal', _this.trigger, event.target);
                }
            }
        });

        var modal = h('aha-modal', {
            'class': 'c-modal--youtube',
            attrs: {
                id: this.trigger,
                centered: true,
                lazy: true,
                hideFooter: true,
                hideHeader: true,
                noFade: true,
                title: this.title
            },
            on: {
                shown: function shown(event) {
                    var arg = event.arg;
                    var player = (0, _youtubePlayer2['default'])(youtubeContainerId, {
                        playerVars: {
                            rel: 0
                        }
                    });

                    // eslint-disable-next-line
                    if (arg === 'queue') {
                        player.cueVideoById(_this.videoId);
                    } else {
                        player.loadVideoById(_this.videoId);
                        player.playVideo();
                    }
                }
            }
        }, [closeButton, embed]);

        return modal;
    },

    props: {
        trigger: {
            type: String,
            required: true
        },
        title: {
            type: String,
            'default': 'Video'
        },
        videoId: {
            type: String,
            required: true
        }
    }
};

/***/ }),
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_notification_vue__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_notification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_notification_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_notification_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_notification_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efd4aaf2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_notification_vue__ = __webpack_require__(819);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_notification_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efd4aaf2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}]},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_vue__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a50e1ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_mobile_nav_vue__ = __webpack_require__(821);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a50e1ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_mobile_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.navId),expression:"navId"}],staticClass:"c-top-nav__menu-trigger",on:{"click":_vm.hideNav}},[_vm._m(0)]),_vm._v(" "),_c('aha-modal',{ref:_vm.navRef,staticClass:"c-mobile-nav",attrs:{"id":_vm.navId,"title":_vm.modalTitle,"modalRole":_vm.modalRole,"modalContentRole":_vm.modalContentRole,"modalTag":_vm.modalTag,"showOnDesktop":_vm.showOnDesktop,"hide-backdrop":"","hide-header":"","hide-footer":""},on:{"shown":_vm.onShown,"hidden":_vm.onHidden}},[_vm._t("default")],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-top-nav__hamburger"},[_c('span',{staticClass:"sr-only"},[_vm._v("Menu")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _utils = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default']],
    mounted: function mounted() {
        this.checkboxId = this.safeId('_AHA_checkbox_');
    },
    render: function render(h) {
        var _this = this;

        var iconCheck = h('i', {
            'class': 'icon-check'
        });

        var check = h('span', {
            'class': this.checkClass,
            attrs: this.containerAttributes
        }, [iconCheck]);

        var empty = h('div', {
            attrs: {
                id: this.checkboxId
            }
        }, [this.$slots['default']]);

        var container = h('div', {
            'class': this.containerClasses,
            on: {
                click: function click(evt) {
                    toggleChecked(evt);
                },
                keypress: function keypress(evt) {
                    toggleChecked(evt);
                }
            }
        }, [check, empty]);

        var toggleChecked = function toggleChecked(evt) {
            if (evt.type === 'click' || evt.keyCode === _utils.KeyCodes.SPACE) {
                evt.preventDefault();
                _this.isChecked = !_this.isChecked;
            }
        };

        return container;
    },

    data: function data() {
        return {
            isChecked: false,
            checkboxId: null
        };
    },
    props: {
        checkClass: {
            type: String
        }
    },
    computed: {
        containerClasses: function containerClasses() {
            return [this.isChecked ? 'is-checked' : '', this['class']];
        },
        containerAttributes: function containerAttributes() {
            return {
                'role': 'checkbox',
                'aria-checked': this.isChecked.toString(),
                'tabindex': 0,
                'aria-labelledby': this.checkboxId
            };
        }
    }
};

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* global gigya */

exports['default'] = {
    render: function render(h) {
        var ratings = h('div', {
            'class': 'c-recipe__ratings',
            attrs: {
                id: 'ratingsDiv'
            }
        });

        var comments = h('div', {
            'class': 'c-recipe__comments',
            attrs: {
                id: 'commentsDiv'
            }
        });

        var container = h('div', {
            'class': 'c-recipe__social'
        }, [ratings, comments]);

        return container;
    },

    props: {
        ratingsCategoryId: {
            type: String,
            required: true
        },
        ratingsStreamId: {
            type: String,
            required: true
        },
        commentsCategoryId: {
            type: String,
            required: true
        },
        commentsStreamId: {
            type: String,
            required: true
        },
        commentsStreamTags: {
            type: String,
            required: true
        },
        hideShareButtons: {
            type: Boolean,
            'default': false
        },
        showReadReviewsLink: {
            type: Boolean,
            'default': false
        },
        showCommentButton: {
            type: Boolean,
            'default': true
        },
        writeReviewLabel: {
            type: String,
            'default': 'Write Review'
        },
        hideRatingToolLabel: {
            type: String,
            'default': 'Hide Rating'
        }
    },
    mounted: function mounted() {
        var _this = this;

        var ratingsParams = {
            categoryID: this.ratingsCategoryId,
            streamID: this.ratingsStreamId,
            containerID: 'ratingsDiv',
            showReadReviewsLink: this.showReadReviewsLink,
            showCommentButton: this.showCommentButton,
            onAddReviewClicked: function onAddReviewClicked() {
                var commentsElement = document.querySelector('#commentsDiv');
                var reviewButton = document.querySelector('.gig-rating-writeYourReview');

                commentsElement.classList.toggle('is-visible');

                reviewButton.text = commentsElement.classList.contains('is-visible') ? _this.hideRatingToolLabel : _this.writeReviewLabel;
            },
            onReadReviewsClicked: function onReadReviewsClicked() {
                var commentsElement = document.querySelector('#commentsDiv');
                var reviewButton = document.querySelector('.gig-rating-writeYourReview');

                commentsElement.classList.toggle('is-visible');

                reviewButton.text = commentsElement.classList.contains('is-visible') ? _this.hideRatingToolLabel : _this.writeReviewLabel;
            },
            onLoad: function onLoad() {
                var reviewButton = document.querySelector('.gig-rating-writeYourReview');

                reviewButton.innerHTML = _this.writeReviewLabel;
            }
        };

        var ratingsElement = document.querySelector('#ratingsDiv');

        ratingsElement.classList.toggle('is-visible', this.showCommentButton || this.showReadReviewsLink);

        gigya.comments.showRatingUI(ratingsParams);

        var commentsParams = {
            categoryID: this.commentsCategoryId,
            streamID: this.commentsStreamId,
            containerID: 'commentsDiv',
            hideShareButtons: this.hideShareButtons,
            version: 2,
            disabledShareProviders: '*',
            streamTags: this.commentsStreamTags
        };

        gigya.comments.showCommentsUI(commentsParams);
    }
};

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _button = __webpack_require__(825);

var _button2 = _interopRequireDefault(_button);

var _buttonClose = __webpack_require__(826);

var _buttonClose2 = _interopRequireDefault(_buttonClose);

var _mixins = __webpack_require__(827);

var _utils = __webpack_require__(22);

var _bvEvent = __webpack_require__(840);

var _bvEvent2 = _interopRequireDefault(_bvEvent);

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _extendAhaModal = __webpack_require__(841);

var _extendAhaModal2 = _interopRequireDefault(_extendAhaModal);

var _dom = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

// Selectors for padding/margin adjustments
var Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'

    // ObserveDom config
};

var OBSERVER_CONFIG = {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class']
};

exports['default'] = {
    mixins: [_ahaId2['default'], _mixins.listenOnRootMixin, _extendAhaModal2['default']],
    components: {
        bBtn: _button2['default'],
        bBtnClose: _buttonClose2['default']
    },
    render: function render(h) {
        var t = this;
        var $slots = t.$slots;
        // Modal Header
        var header = h(false);

        if (!t.hideHeader) {
            var modalHeader = $slots['modal-header'];
            if (!modalHeader) {
                var closeButton = h(false);
                if (!t.hideHeaderClose) {
                    closeButton = h('b-btn-close', {
                        props: {
                            disabled: t.is_transitioning,
                            ariaLabel: t.headerCloseLabel,
                            textVariant: t.headerTextVariant
                        },
                        on: {
                            click: function click(evt) {
                                t.hide('header-close');
                            }
                        }
                    }, [$slots['modal-header-close']]);
                }
                modalHeader = [h(t.titleTag, {
                    'class': ['modal-title']
                }, [$slots['modal-title'] || t.title]), closeButton];
            }
            header = h('div', {
                ref: 'header',
                'class': t.headerClasses,
                attrs: {
                    id: t.safeId('__BV_modal_header_')
                }
            }, [modalHeader]);
        }
        // Modal Body
        var body = h('div', {
            ref: 'body',
            'class': t.bodyClasses,
            attrs: {
                id: t.safeId('__BV_modal_body_')
            }
        }, [$slots['default']]);
        // Modal Footer
        var footer = h(false);
        if (!t.hideFooter) {
            var modalFooter = $slots['modal-footer'];
            if (!modalFooter) {
                var okButton = h(false);
                if (!t.okOnly) {
                    okButton = h('b-btn', {
                        props: {
                            variant: t.cancelVariant,
                            size: t.buttonSize,
                            disabled: t.cancelDisabled || t.busy || t.is_transitioning
                        },
                        on: {
                            click: function click(evt) {
                                t.hide('cancel');
                            }
                        }
                    }, [$slots['modal-cancel'] || t.cancelTitle]);
                }
                var cancelButton = h('b-btn', {
                    props: {
                        variant: t.okVariant,
                        size: t.buttonSize,
                        disabled: t.okDisabled || t.busy || t.is_transitioning
                    },
                    on: {
                        click: function click(evt) {
                            t.hide('ok');
                        }
                    }
                }, [$slots['modal-ok'] || t.okTitle]);
                modalFooter = [cancelButton, okButton];
            }
            footer = h('footer', {
                ref: 'footer',
                'class': t.footerClasses,
                attrs: {
                    id: t.safeId('__BV_modal_footer_')
                }
            }, [modalFooter]);
        }
        // Assemble Modal Content
        var modalContent = h('div', {
            ref: 'content',
            'class': ['modal-content'],
            attrs: this.modalContentAttributes,
            on: {
                focusout: t.onFocusout,
                click: function click(evt) {
                    evt.stopPropagation();
                }
            }
        }, [header, body, footer]);

        // Modal Dialog wrapper
        var modalDialog = h('div', {
            'class': t.dialogClasses
        }, [modalContent]);

        var modalTag = this.modalTag;

        // Modal
        var modal = h(modalTag, {
            ref: 'modal',
            'class': t.modalClasses,
            directives: [{
                name: 'show',
                rawName: 'v-show',
                value: t.is_visible,
                expression: 'is_visible'
            }],
            attrs: t.dialogAttributes,
            on: {
                click: t.onClickOut,
                keydown: t.onEsc
            }
        }, [modalDialog]);
        // Wrap modal in transition
        modal = h('transition', {
            props: {
                enterClass: '',
                enterToClass: '',
                enterActiveClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: ''
            },
            on: {
                'before-enter': t.onBeforeEnter,
                'enter': t.onEnter,
                'after-enter': t.onAfterEnter,
                'before-leave': t.onBeforeLeave,
                'leave': t.onLeave,
                'after-leave': t.onAfterLeave
            }
        }, [modal]);
        // Modal Backdrop
        var backdrop = h(false);
        if (!t.hideBackdrop && (t.is_visible || t.is_transitioning)) {
            backdrop = h('div', {
                'class': t.backdropClasses,
                attrs: {
                    id: t.safeId('__BV_modal_backdrop_')
                }
            });
        }
        // Assemble modal and backdrop
        var outer = h(false);
        if (!t.is_hidden) {
            outer = h('div', {
                attrs: {
                    id: t.safeId('__BV_modal_outer_')
                }
            }, [modal, backdrop]);
        }
        // Wrap in DIV to maintain thi.$el reference for hide/show method aceess
        return h('div', {}, [outer]);
    },
    data: function data() {
        return {
            is_hidden: this.lazy || false,
            is_visible: false,
            is_transitioning: false,
            is_show: false,
            is_shown_for_desktop: false,
            is_block: false,
            scrollbarWidth: 0,
            isBodyOverflowing: false,
            return_focus: this.returnFocus || null,
            arg: null
        };
    },

    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        ariaLabelledby: {
            type: String,
            'default': ''
        },
        title: {
            type: String,
            'default': ''
        },
        titleTag: {
            type: String,
            'default': 'h5'
        },
        modalTag: {
            type: String,
            'default': 'div'
        },
        size: {
            type: String,
            'default': 'md'
        },
        centered: {
            type: Boolean,
            'default': false
        },
        buttonSize: {
            type: String,
            'default': ''
        },
        noFade: {
            type: Boolean,
            'default': false
        },
        noCloseOnBackdrop: {
            type: Boolean,
            'default': false
        },
        noCloseOnEsc: {
            type: Boolean,
            'default': false
        },
        noEnforceFocus: {
            type: Boolean,
            'default': false
        },
        headerBgVariant: {
            type: String,
            'default': null
        },
        headerBorderVariant: {
            type: String,
            'default': null
        },
        headerTextVariant: {
            type: String,
            'default': null
        },
        headerClass: {
            type: [String, Array],
            'default': null
        },
        bodyBgVariant: {
            type: String,
            'default': null
        },
        bodyTextVariant: {
            type: String,
            'default': null
        },
        bodyClass: {
            type: [String, Array],
            'default': null
        },
        footerBgVariant: {
            type: String,
            'default': null
        },
        footerBorderVariant: {
            type: String,
            'default': null
        },
        footerTextVariant: {
            type: String,
            'default': null
        },
        footerClass: {
            type: [String, Array],
            'default': null
        },
        hideHeader: {
            type: Boolean,
            'default': false
        },
        hideFooter: {
            type: Boolean,
            'default': false
        },
        hideHeaderClose: {
            type: Boolean,
            'default': false
        },
        hideBackdrop: {
            type: Boolean,
            'default': false
        },
        okOnly: {
            type: Boolean,
            'default': false
        },
        okDisabled: {
            type: Boolean,
            'default': false
        },
        cancelDisabled: {
            type: Boolean,
            'default': false
        },
        visible: {
            type: Boolean,
            'default': false
        },
        returnFocus: {
            'default': null
        },
        headerCloseLabel: {
            type: String,
            'default': 'Close'
        },
        cancelTitle: {
            type: String,
            'default': 'Cancel'
        },
        okTitle: {
            type: String,
            'default': 'OK'
        },
        cancelVariant: {
            type: String,
            'default': 'secondary'
        },
        okVariant: {
            type: String,
            'default': 'primary'
        },
        lazy: {
            type: Boolean,
            'default': false
        },
        busy: {
            type: Boolean,
            'default': false
        },
        modalRole: {
            type: String,
            'default': null
        },
        modalContentRole: {
            type: String,
            'default': null
        },
        showOnDesktop: {
            type: Boolean,
            'default': false
        }
    },
    computed: {
        dialogAttributes: function dialogAttributes() {
            var attributes = {
                id: this.safeId(),
                // 'aria-describedby': this.safeId('__BV_modal_body_'),
                'aria-hidden': this.is_shown_for_desktop ? false : this.is_visible ? null : 'true'
            };

            if (this.modalRole) {
                attributes.role = this.modalRole;
            }

            if (this.hideHeader) {
                // Allow aria-labelledby to be set manually
                if (this.ariaLabelledby !== '') {
                    attributes['aria-labelledby'] = this.ariaLabelledby;
                } else {
                    attributes['aria-label'] = this.$slots['modal-title'] || this.title;
                }
            }

            return attributes;
        },
        modalClasses: function modalClasses() {
            return ['modal', {
                fade: !this.noFade,
                show: this.is_show,
                'd-block': this.is_block
            }];
        },
        modalContentAttributes: function modalContentAttributes() {
            var attributes = {
                tabindex: '-1'
            };

            if (this.modalContentRole) {
                attributes.role = this.modalContentRole;
            }

            return attributes;
        },
        dialogClasses: function dialogClasses() {
            var _ref = {};

            return ['modal-dialog', (_ref, _defineProperty(_ref, 'modal-' + this.size, Boolean(this.size)), _defineProperty(_ref, 'modal-dialog-centered', this.centered), _ref)];
        },
        backdropClasses: function backdropClasses() {
            return ['modal-backdrop', {
                fade: !this.noFade,
                show: this.is_show || this.noFade
            }];
        },
        headerClasses: function headerClasses() {
            var _ref2 = {};

            return ['modal-header', (_ref2, _defineProperty(_ref2, 'bg-' + this.headerBgVariant, Boolean(this.headerBgVariant)), _defineProperty(_ref2, 'text-' + this.headerTextVariant, Boolean(this.headerTextVariant)), _defineProperty(_ref2, 'border-' + this.headerBorderVariant, Boolean(this.headerBorderVariant)), _ref2), this.headerClass];
        },
        bodyClasses: function bodyClasses() {
            var _ref3 = {};

            return ['modal-body', (_ref3, _defineProperty(_ref3, 'bg-' + this.bodyBgVariant, Boolean(this.bodyBgVariant)), _defineProperty(_ref3, 'text-' + this.bodyTextVariant, Boolean(this.bodyTextVariant)), _ref3), this.bodyClass];
        },
        footerClasses: function footerClasses() {
            var _ref4 = {};

            return ['modal-footer', (_ref4, _defineProperty(_ref4, 'bg-' + this.footerBgVariant, Boolean(this.footerBgVariant)), _defineProperty(_ref4, 'text-' + this.footerTextVariant, Boolean(this.footerTextVariant)), _defineProperty(_ref4, 'border-' + this.footerBorderVariant, Boolean(this.footerBorderVariant)), _ref4), this.footerClass];
        }
    },
    watch: {
        visible: function visible(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            this[newVal ? 'show' : 'hide']();
        }
    },
    methods: {
        // Public Methods
        show: function show() {
            if (this.is_visible) {
                return;
            }
            var showEvt = new _bvEvent2['default']('show', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                relatedTarget: null
            });
            this.emitEvent(showEvt);
            if (showEvt.defaultPrevented || this.is_visible) {
                // Don't show if canceled
                return;
            }
            if ((0, _dom.hasClass)(document.body, 'modal-open')) {
                // If another modal is already open, wait for it to close
                this.$root.$once('bv::modal::hidden', this.doShow);
            } else {
                // Show the modal
                this.doShow();
            }
        },
        hide: function hide(trigger) {
            if (!this.is_visible) {
                return;
            }
            var hideEvt = new _bvEvent2['default']('hide', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                // this could be the trigger element/component reference
                relatedTarget: null,
                isOK: trigger || null,
                trigger: trigger || null,
                cancel: function cancel() {
                    // Backwards compatibility
                    (0, _utils.warn)('b-modal: evt.cancel() is deprecated. Please use evt.preventDefault().');
                    this.preventDefault();
                }
            });
            if (trigger === 'ok') {
                this.$emit('ok', hideEvt);
            } else if (trigger === 'cancel') {
                this.$emit('cancel', hideEvt);
            }
            this.emitEvent(hideEvt);
            // Hide if not canceled
            if (hideEvt.defaultPrevented || !this.is_visible) {
                return;
            }
            // stop observing for content changes
            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }
            this.is_visible = false;
            this.$emit('change', false);
        },

        // Private method to finish showing modal
        doShow: function doShow() {
            var _this = this;

            // Plce modal in DOM if lazy
            this.is_hidden = false;
            this.$nextTick(function () {
                // We do this in nextTick to ensure the modal is in DOM first before we show it
                _this.is_visible = true;
                _this.$emit('change', true);
                // Observe changes in modal content and adjust if necessary
                _this._observer = (0, _utils.observeDom)(_this.$refs.content, _this.adjustDialog.bind(_this), OBSERVER_CONFIG);
            });
        },

        // Transition Handlers
        onBeforeEnter: function onBeforeEnter() {
            this.is_transitioning = true;
            this.checkScrollbar();
            this.setScrollbar();
            this.adjustDialog();
            (0, _dom.addClass)(document.body, 'modal-open');
            this.setResizeEvent(true);
        },
        onEnter: function onEnter() {
            this.is_block = true;
            this.$refs.modal.scrollTop = 0;
        },
        onAfterEnter: function onAfterEnter() {
            var _this2 = this;

            this.is_show = true;
            this.is_transitioning = false;
            this.$nextTick(function () {
                _this2.focusFirst();
                var shownEvt = new _bvEvent2['default']('shown', {
                    cancelable: false,
                    vueTarget: _this2,
                    target: _this2.$refs.modal,
                    relatedTarget: null,
                    arg: this.arg
                });
                _this2.emitEvent(shownEvt);
            });
        },
        onBeforeLeave: function onBeforeLeave() {
            this.is_transitioning = true;
            this.setResizeEvent(false);
        },
        onLeave: function onLeave() {
            // Remove the 'show' class
            this.is_show = false;
        },
        onAfterLeave: function onAfterLeave() {
            var _this3 = this;

            this.is_block = false;
            this.resetAdjustments();
            this.resetScrollbar();
            this.is_transitioning = false;
            (0, _dom.removeClass)(document.body, 'modal-open');
            this.$nextTick(function () {
                _this3.is_hidden = _this3.lazy || false;
                _this3.returnFocusTo();
                var hiddenEvt = new _bvEvent2['default']('hidden', {
                    cancelable: false,
                    vueTarget: _this3,
                    target: _this3.lazy ? null : _this3.$refs.modal,
                    relatedTarget: null
                });
                _this3.emitEvent(hiddenEvt);
            });
        },

        // Event emitter
        emitEvent: function emitEvent(bvEvt) {
            var type = bvEvt.type;
            this.$emit(type, bvEvt);
            this.$root.$emit('bv::modal::' + type, bvEvt);
        },

        // UI Event Handlers
        onClickOut: function onClickOut(evt) {
            // If backdrop clicked, hide modal
            if (this.is_visible && !this.noCloseOnBackdrop) {
                this.hide('backdrop');
            }
        },
        onEsc: function onEsc(evt) {
            // If ESC pressed, hide modal
            if (evt.keyCode === _utils.KeyCodes.ESC && this.is_visible && !this.noCloseOnEsc) {
                this.hide('esc');
            }
        },
        onFocusout: function onFocusout(evt) {
            // If focus leaves modal, bring it back
            // 'focusout' Event Listener bound on content
            var content = this.$refs.content;
            if (!this.noEnforceFocus && this.is_visible && content && !content.contains(evt.relatedTarget)) {
                content.focus();
            }
        },

        // Resize Listener
        setResizeEvent: function setResizeEvent(on) {
            var _this4 = this;

            ['resize', 'orientationchange'].forEach(function (evtName) {
                if (on) {
                    (0, _dom.eventOn)(window, evtName, _this4.adjustDialog);
                } else {
                    (0, _dom.eventOff)(window, evtName, _this4.adjustDialog);
                }
            });
        },

        // Root Listener handlers
        showHandler: function showHandler(id, triggerEl, arg) {
            this.arg = null;
            if (arg) {
                this.arg = arg;
            }
            if (id === this.id) {
                this.return_focus = triggerEl || null;
                this.show();
            }
        },
        hideHandler: function hideHandler(id) {
            if (id === this.id) {
                this.hide();
            }
        },
        modalListener: function modalListener(bvEvt) {
            // If another modal opens, close this one
            if (bvEvt.vueTarget !== this) {
                this.hide();
            }
        },

        // Focus control handlers
        focusFirst: function focusFirst() {
            // Don't try and focus if we are SSR
            if (typeof document === 'undefined') {
                return;
            }
            var content = this.$refs.content;
            var modal = this.$refs.modal;
            var activeElement = document.activeElement;
            if (activeElement && content && content.contains(activeElement)) {
                // If activeElement is child of content, no need to change focus
            } else if (content) {
                if (modal) {
                    modal.scrollTop = 0;
                }
                // Focus the modal content wrapper
                content.focus();
            }
        },
        returnFocusTo: function returnFocusTo() {
            // Prefer returnFocus prop over event specified return_focus value
            var el = this.returnFocus || this.return_focus || null;
            if (typeof el === 'string') {
                // CSS Selector
                el = (0, _dom.select)(el);
            }
            if (el) {
                el = el.$el || el;
                if ((0, _dom.isVisible)(el)) {
                    el.focus();
                }
            }
        },

        // Utility methods
        getScrollbarWidth: function getScrollbarWidth() {
            var scrollDiv = document.createElement('div');
            scrollDiv.className = 'modal-scrollbar-measure';
            document.body.appendChild(scrollDiv);
            this.scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        },
        adjustDialog: function adjustDialog() {
            if (!this.is_visible) {
                return;
            }
            var modal = this.$refs.modal;
            var isModalOverflowing = modal.scrollHeight > document.documentElement.clientHeight;
            if (!this.isBodyOverflowing && isModalOverflowing) {
                modal.style.paddingLeft = this.scrollbarWidth + 'px';
            }
            if (this.isBodyOverflowing && !isModalOverflowing) {
                modal.style.paddingRight = this.scrollbarWidth + 'px';
            }
        },
        resetAdjustments: function resetAdjustments() {
            var modal = this.$refs.modal;
            if (modal) {
                modal.style.paddingLeft = '';
                modal.style.paddingRight = '';
            }
        },
        checkScrollbar: function checkScrollbar() {
            var rect = (0, _dom.getBCR)(document.body);
            this.isBodyOverflowing = rect.left + rect.right < window.innerWidth;
        },
        setScrollbar: function setScrollbar() {
            if (this.isBodyOverflowing) {
                // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                var computedStyle = window.getComputedStyle;
                var body = document.body;
                var scrollbarWidth = this.scrollbarWidth;
                // Adjust fixed content padding
                (0, _dom.selectAll)(Selector.FIXED_CONTENT).forEach(function (el) {
                    var actualPadding = el.style.paddingRight;
                    var calculatedPadding = computedStyle(el).paddingRight || 0;
                    (0, _dom.setAttr)(el, 'data-padding-right', actualPadding);
                    el.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
                });
                // Adjust sticky content margin
                (0, _dom.selectAll)(Selector.STICKY_CONTENT).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    (0, _dom.setAttr)(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) - scrollbarWidth + 'px';
                });
                // Adjust navbar-toggler margin
                (0, _dom.selectAll)(Selector.NAVBAR_TOGGLER).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    (0, _dom.setAttr)(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) + scrollbarWidth + 'px';
                });
                // Adjust body padding
                var actualPadding = body.style.paddingRight;
                var calculatedPadding = computedStyle(body).paddingRight;
                (0, _dom.setAttr)(body, 'data-padding-right', actualPadding);
                body.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
            }
        },
        resetScrollbar: function resetScrollbar() {
            // Restore fixed content padding
            (0, _dom.selectAll)(Selector.FIXED_CONTENT).forEach(function (el) {
                if ((0, _dom.hasAttr)(el, 'data-padding-right')) {
                    el.style.paddingRight = (0, _dom.getAttr)(el, 'data-padding-right') || '';
                    (0, _dom.removeAttr)(el, 'data-padding-right');
                }
            });
            // Restore sticky content and navbar-toggler margin
            (0, _dom.selectAll)(Selector.STICKY_CONTENT + ', ' + Selector.NAVBAR_TOGGLER).forEach(function (el) {
                if ((0, _dom.hasAttr)(el, 'data-margin-right')) {
                    el.style.marginRight = (0, _dom.getAttr)(el, 'data-margin-right') || '';
                    (0, _dom.removeAttr)(el, 'data-margin-right');
                }
            });
            // Restore body padding
            var body = document.body;
            if ((0, _dom.hasAttr)(body, 'data-padding-right')) {
                body.style.paddingRight = (0, _dom.getAttr)(body, 'data-padding-right') || '';
                (0, _dom.removeAttr)(body, 'data-padding-right');
            }
        }
    },
    created: function created() {
        // create non-reactive property
        this._observer = null;
    },
    mounted: function mounted() {
        var _this5 = this;

        // Update dialogAttributes() computed property to remove aria-hidden=true if shownOnDesktop prop is set to true and screen is desktop size
        if (this.showOnDesktop) {
            var timeout = false;
            var delay = 1000;

            if (window.innerWidth > 991) {
                this.is_shown_for_desktop = true;
            }

            // Handle window resize events to remove aria-hidden=true on desktop size with a delay
            window.addEventListener('resize', function () {
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    if (window.innerWidth > 991) {
                        _this5.is_shown_for_desktop = true;
                    } else {
                        _this5.is_shown_for_desktop = false;
                    }
                }, delay);
            });
        }
        // Measure scrollbar
        this.getScrollbarWidth();
        // Listen for events from others to either open or close ourselves
        this.listenOnRoot('bv::show::modal', this.showHandler);
        this.listenOnRoot('bv::hide::modal', this.hideHandler);
        // Listen for bv:modal::show events, and close ourselves if the opening modal not us
        this.listenOnRoot('bv::modal::show', this.modalListener);
        // Initially show modal?
        if (this.visible === true) {
            this.show();
        }
    },
    beforeDestroy: function beforeDestroy() {
        // Ensure everything is back to normal
        if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
        }
        this.setResizeEvent(false);
        // Re-adjust body/navbar/fixed padding/margins (if needed)
        (0, _dom.removeClass)(document.body, 'modal-open');
        this.resetAdjustments();
        this.resetScrollbar();
    }
};

/***/ }),
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
exports['default'] = {
    props: {
        interval: {
            type: Number,
            'default': 0
        }
    },
    data: function data() {
        return {
            test: '',
            Quiz: null
        };
    },
    mounted: function mounted() {
        this.openAtTimeout();

        this.Quiz = this.$children.find(function (child) {
            return child.$options.name === "aha-transition-group";
        });
        if (this.Quiz !== undefined) {
            console.log('Quiz component', this.Quiz);
            this.$root.$on('bv::modal::hidden', this.resetQuiz);
        }
    },

    methods: {
        openAtTimeout: function openAtTimeout() {
            var _this = this;

            if (this.interval === 0 || this.interval === '') {
                return;
            }
            setTimeout(function () {
                _this.show();
            }, this.interval * 1000);
        },
        resetQuiz: function resetQuiz(evt) {
            // Reset quiz back to first step
            this.Quiz.EventBus.$emit('stepTrigger', 1);
        }
    }
};

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _ahaDropdown = __webpack_require__(144);

var _ahaDropdown2 = _interopRequireDefault(_ahaDropdown);

var _dom = __webpack_require__(44);

var _keyCodes = __webpack_require__(244);

var _keyCodes2 = _interopRequireDefault(_keyCodes);

var _inputEventbus = __webpack_require__(45);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default'], _ahaDropdown2['default']],
    render: function render(h) {
        var toggle = h('button', {
            ref: 'toggle',
            attrs: {
                type: 'button',
                id: this.safeId('_AHA_toggle_'),
                'aria-haspopup': this.role,
                'aria-expanded': this.visible ? 'true' : 'false'
            },
            'class': this.toggleClasses,
            on: {
                click: this.toggle,
                keydown: this.toggle
            }
        }, [this.buttonText]);

        var arrow = h('span', {
            ref: 'arrow',
            attrs: {
                'x-arrow': ''
            },
            'class': 'c-nav-dropdown__arrow'
        });

        var menu = h(this.dropdownTag, {
            ref: 'menu',
            'class': this.menuClasses,
            attrs: {
                tabindex: -1,
                role: this.role,
                'aria-activedescendant': this.activeItemId,
                'aria-labelledby': this.safeId('_AHA_toggle_')
            },
            on: {
                keydown: this.onListboxKeydown
            }
        }, [this.$slots.dropdown, this.arrow ? arrow : null]);

        var hiddenInput = h('input', {
            ref: 'input',
            attrs: {
                type: 'hidden',
                value: this.hiddenValue,
                name: this.inputName
            },
            directives: [this.directiveOptions]
        });

        return h('div', {
            ref: 'dropdown',
            attrs: {
                id: this.safeId()
            },
            'class': this.dropdownClasses
        }, [toggle, hiddenInput, menu]);
    },
    data: function data() {
        return {
            hiddenValue: null,
            displayText: null,
            activeItemId: null,
            dropdownItems: [],
            directiveOptions: {}
        };
    },

    props: {
        value: {
            required: false
        },
        defaultValue: {
            type: String,
            required: true
        },
        labelledby: {
            type: String,
            'default': ''
        },
        toggleClass: {
            type: String,
            'default': ''
        },
        menuClass: {
            type: String,
            'default': ''
        },
        role: {
            type: String,
            'default': 'menu'
        },
        arrow: {
            type: Boolean,
            'default': false
        },
        inputName: {
            type: String,
            'default': 'searchCategory'
        },
        dropdownTag: {
            type: String,
            'default': 'div'
        },
        dropdownItemActiveClass: {
            type: String,
            'default': 'selected'
        },
        inputDirective: {
            type: Boolean,
            'default': false
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$on('selected', this.selectedListener);
        this.$on('register', this.registerDropdownItem);

        if (this.inputDirective) {
            this.directiveOptions = {
                name: 'input',
                value: this.inputName
            };
        }

        this.$nextTick(function () {
            if (_this.defaultValue) {
                _this.hiddenValue = _this.defaultValue;

                // If we have a default value, set the item to be selected on first menu opening
                var item = _this.dropdownItems.find(function (item) {
                    return item.value === _this.defaultValue || item.text === _this.defaultValue;
                });

                if (typeof item !== 'undefined') {
                    item.selected = true;
                    // This next line actually sets the item as selected
                    _this.selectedListener(item.value, item.text, item.element);
                }
            }
        });
    },

    methods: {
        onListboxKeydown: function onListboxKeydown(evt) {
            this.onKeydown(evt);

            // Select the currently selected dropdown item
            if (!this.disableMenuEvents && (evt.keyCode === _keyCodes2['default'].ENTER || evt.keyCode === _keyCodes2['default'].SPACE)) {
                var item = this.currentSelectedDropdown();
                this.selectedListener(item.value, item.text, item.element);
            }
        },
        selectedListener: function selectedListener(value, text, element, isInitial) {
            if (typeof value !== 'undefined') {
                this.hiddenValue = value;
                this.displayText = text;

                this.setSelectedDropdownItem(value);

                this.$emit('input', this.hiddenValue);
                _inputEventbus2['default'].$emit('inputUpdated', this.hiddenValue, this.inputName, this.$el);
                this.focusItemByElement(element);

                // Disable focus on initial page load
                if (!isInitial) {
                    this.focusToggler();
                }
            }
        },
        getItems: function getItems() {
            return this.filterVisible((0, _dom.selectAll)('[role]', this.$refs.menu));
        },
        registerDropdownItem: function registerDropdownItem(value, text, element) {
            this.dropdownItems.push({
                value: value,
                text: text,
                element: element,
                selected: false
            });
        },
        showMenuFocus: function showMenuFocus() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$nextTick(function () {
                    var item = _this2.dropdownItems.find(function (item) {
                        return item.selected;
                    });

                    if (typeof item !== 'undefined') {
                        _this2.setSelectedDropdownItem(item.value);
                        _this2.focusItemByElement(item.element);
                    }

                    _this2.$refs.menu.focus();
                });
            });
        },
        setSelectedDropdownItem: function setSelectedDropdownItem(value) {
            this.dropdownItems.forEach(function (item) {
                item.selected = false;

                if (item.value === value) {
                    item.selected = true;
                }
            });
        },
        focusItem: function focusItem(index, items) {
            var element = items.find(function (element, i) {
                return i === index;
            });

            this.setSelectedDropdownClasses(element, items);
        },
        focusItemByElement: function focusItemByElement(element) {
            var items = this.getItems();

            var index = items.indexOf(items.find(function (item) {
                return item === element;
            }));

            this.focusItem(index, items);
        },
        focusNext: function focusNext(evt, up) {
            var _this3 = this;

            if (!this.visible) {
                return;
            }

            evt.preventDefault();
            evt.stopPropagation();

            this.$nextTick(function () {
                var items = _this3.getItems();

                if (items.length < 1) {
                    return;
                }

                var index = items.indexOf(items.find(function (el) {
                    return el.classList.contains(_this3.dropdownItemActiveClass);
                }));

                if (up && index > 0) {
                    index--;
                } else if (!up && index < items.length - 1) {
                    index++;
                }

                if (index < 0) {
                    index = 0;
                }

                _this3.focusItem(index, items);
            });
        },
        setSelectedDropdownClasses: function setSelectedDropdownClasses(selectedElement, elements) {
            var _this4 = this;

            elements.forEach(function (el) {
                el.classList.remove(_this4.dropdownItemActiveClass);
                if (selectedElement.tagName !== 'A') {
                    el.setAttribute('aria-selected', false);
                }
            });

            if (selectedElement && (0, _dom.getAttr)(selectedElement, 'tabindex') !== '-1') {
                selectedElement.classList.add(this.dropdownItemActiveClass);
                if (selectedElement.tagName !== 'A') {
                    selectedElement.setAttribute('aria-selected', true);
                }
                this.activeItemId = selectedElement.getAttribute('id');
            }
        },
        currentSelectedDropdown: function currentSelectedDropdown() {
            var _this5 = this;

            return this.dropdownItems.find(function (item) {
                return item.element.classList.contains(_this5.dropdownItemActiveClass);
            });
        },
        resetList: function resetList() {
            var item = this.dropdownItems[0];
            this.selectedListener(item.value, item.text, item.element);
        }
    },
    watch: {
        value: function value(val) {
            var dropdown = this.dropdownItems.find(function (item) {
                return item.value === val;
            });

            // If the value is trying to be set programmatically, check the registered dropdown items
            if (typeof dropdown !== 'undefined') {
                this.hiddenValue = val;
                this.displayText = dropdown.text;

                this.setSelectedDropdownItem(dropdown.value);
            }
        }
    },
    computed: {
        buttonText: function buttonText() {
            return this.displayText || this.getDefaultValue;
        },
        getDefaultValue: function getDefaultValue() {
            var _this6 = this;

            var item = this.dropdownItems.find(function (item) {
                return item.value === _this6.defaultValue;
            });

            if (typeof item !== 'undefined') {
                return item.text;
            } else {
                return this.defaultValue;
            }
        },
        dropdownClasses: function dropdownClasses() {
            return ['c-select-dropdown__container', 'position-static', this.visible ? 'show' : ''];
        },
        menuClasses: function menuClasses() {
            return ['c-select-dropdown', 'dropdown-menu', this.right ? 'dropdown-menu-right' : '', this.menuClass];
        },
        toggleClasses: function toggleClasses() {
            return [this.toggleClass];
        }
    }
};

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_google_map_vue__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_google_map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_google_map_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_google_map_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_google_map_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04bd2a8c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_google_map_vue__ = __webpack_require__(848);
function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_google_map_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04bd2a8c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_google_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(845);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("54b3e017", content, true, {});

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32713dd3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__ = __webpack_require__(847);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32713dd3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gmap-map',{ref:"gmap",staticStyle:{"width":"100%","height":"276px"},attrs:{"center":_vm.center,"zoom":_vm.zoom}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.center=m.position}}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('google-map',{attrs:{"address":_vm.address,"zoom":_vm.zoom}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36358446_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_half_image_half_copy_collapse_vue__ = __webpack_require__(850);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36358446_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_half_image_half_copy_collapse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo text-collapse"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo__media h-placeholder-image image-fixed h-placeholder-image--bg h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://via.placeholder.com/425'),expression:"'https://via.placeholder.com/425'"}],attrs:{"src":"https://via.placeholder.com/425"}})])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-promo c-promo--half c-promo--bg h-text-contrast"},[_c('div',{staticClass:"c-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Veggie Migas")]),_vm._v(" "),_c('p',[_vm._v("A Tex-Mex dish, migas are corn tortilla strips gently fried and incorporated into scrambled eggs. This spin on the classic uses very little oil while also adding an array of veggies into the mix.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{directives:[{name:"button-collapse-content",rawName:"v-button-collapse-content"}],staticClass:"btn btn-primary",attrs:{"type":"button","data-toggle":"collapse","data-target":"#collapseExample","aria-expanded":"false","aria-controls":"collapseExample"}},[_vm._v("\n                            Expand to see more\n                        ")])]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"l-promo text-collapse"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo c-promo--half c-promo--bg h-text-contrast"},[_c('div',{staticClass:"c-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Veggie Migas")]),_vm._v(" "),_c('p',[_vm._v("A Tex-Mex dish, migas are corn tortilla strips gently fried and incorporated into scrambled eggs. This spin on the classic uses very little oil while also adding an array of veggies into the mix.")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"button-collapse-content",rawName:"v-button-collapse-content"}],staticClass:"btn btn-primary",attrs:{"data-text-id":"collapseExample1","type":"button","data-toggle":"collapse","data-target":"#collapseExample1","aria-expanded":"false","aria-controls":"collapseExample1"}},[_vm._v("\n                            Expand to see more\n                        ")])]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-promo__media h-placeholder-image image-fixed h-placeholder-image--bg h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://via.placeholder.com/425'),expression:"'https://via.placeholder.com/425'"}],attrs:{"src":"https://via.placeholder.com/425"}})])])])]),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo text-collapse"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo__media h-placeholder-image image-fixed h-placeholder-image--bg h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://via.placeholder.com/425'),expression:"'https://via.placeholder.com/425'"}],attrs:{"src":"https://via.placeholder.com/425"}})])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-promo c-promo--half c-promo--bg h-text-contrast"},[_c('div',{staticClass:"c-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Veggie Migas")]),_vm._v(" "),_c('p',[_vm._v("A Tex-Mex dish, migas are corn tortilla strips gently fried and incorporated into scrambled eggs. This spin on the classic uses very little oil while also adding an array of veggies into the mix.")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('button',{directives:[{name:"button-collapse-content",rawName:"v-button-collapse-content"}],staticClass:"btn btn-primary",attrs:{"data-text-id":"collapseExample3","type":"button","data-toggle":"collapse","data-target":"#collapseExample3","aria-expanded":"false","aria-controls":"collapseExample3"}},[_vm._v("\n                            Expand to see more\n                        ")])]),_vm._v(" "),_vm._m(5)])])]),_vm._v(" "),_c('div',{staticClass:"l-promo text-collapse"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo c-promo--half c-promo--bg h-text-contrast"},[_c('div',{staticClass:"c-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Veggie Migas")]),_vm._v(" "),_c('p',[_vm._v("A Tex-Mex dish, migas are corn tortilla strips gently fried and incorporated into scrambled eggs. This spin on the classic uses very little oil while also adding an array of veggies into the mix.")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('button',{directives:[{name:"button-collapse-content",rawName:"v-button-collapse-content"}],staticClass:"btn btn-primary",attrs:{"data-text-id":"collapseExample4","type":"button","data-toggle":"collapse","data-target":"#collapseExample4","aria-expanded":"false","aria-controls":"collapseExample4"}},[_vm._v("\n                            Expand to see more\n                        ")])]),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-promo__media h-placeholder-image image-fixed h-placeholder-image--bg h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://via.placeholder.com/425'),expression:"'https://via.placeholder.com/425'"}],attrs:{"src":"https://via.placeholder.com/425"}})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse",attrs:{"id":"collapseExample"}},[_c('div',{staticClass:"card card-body c-promo--bg"},[_vm._v("\n                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. \n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--icon h-theme--green-lime",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg"}}),_vm._v("View Recipe\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse",attrs:{"id":"collapseExample1"}},[_c('div',{staticClass:"card card-body c-promo--bg"},[_vm._v("\n                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. \n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--icon h-theme--green-lime",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg"}}),_vm._v("View Recipe\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse",attrs:{"id":"collapseExample3"}},[_c('div',{staticClass:"card card-body c-promo--bg"},[_vm._v("\n                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. \n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--icon h-theme--green-lime",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg"}}),_vm._v("View Recipe\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse",attrs:{"id":"collapseExample4"}},[_c('div',{staticClass:"card card-body c-promo--bg"},[_vm._v("\n                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     \n                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. \n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--icon h-theme--green-lime",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg"}}),_vm._v("View Recipe\n                        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_donation_modal_vue__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_donation_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_donation_modal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_donation_modal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_donation_modal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60035216_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_donation_modal_vue__ = __webpack_require__(852);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_donation_modal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60035216_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_donation_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showModal)?_c('div',[_c('aha-modal',{ref:"ahaDonationPromoModal",attrs:{"id":"ahaDonationPromoModal","aria-labelledby":"dialog-title","aria-describedby":"dialog-description","size":"lg","hide-footer":"","hide-header":"","centered":"","lazy":""}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"l-generic__col col-md-12 p-0"},[_c('div',{staticClass:"c-promotion__card h-theme--black h-text-contrast mb-0"},[_c('div',{staticClass:"c-article-card__background h-placeholder-image",class:{
                  'h-placeholder-image--16-9': _vm.translations.image,
                }},[(_vm.translations.image)?_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:(_vm.translations.image),expression:"translations.image"}],attrs:{"src":_vm.translations.image,"alt":""}}):_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":_vm.translations.video,"allowfullscreen":""}}),_vm._v(" "),_c('b-btn-close',{staticClass:"c-modal--promotion__close btn btn-dark",on:{"click":_vm.handleClose}},[_vm._v("×")])],1)])])]),_vm._v(" "),_c('b-row',{attrs:{"align-v":"center"}},[_c('div',{staticClass:"col-lg-12 c-promotion__title__wrapper w-100 px-0"},[_c('div',{staticClass:"c-promotion__title w-100 text-center mb-3",attrs:{"id":"dialog-title"},domProps:{"innerHTML":_vm._s(_vm.translations.title)}})]),_vm._v(" "),_c('div',{staticClass:"d-flex c-promotion__modal",class:{ 'flex-wrap': _vm.translations.btn2 }},[_c('div',{},[_c('div',{staticClass:"h4 text-lg-left text-center",attrs:{"id":"dialog-description"},domProps:{"innerHTML":_vm._s(_vm.translations.description)}})]),_vm._v(" "),_c('div',{staticClass:"mx-auto mt-3 c-promotion__modal-buttons"},[_c('a',{staticClass:"mb-lg-0 mb-3 mr-lg-5 mr-0 btn btn-lg btn-round btn-danger",class:{ 'btn-outline-primary' : _vm.btnColor },attrs:{"href":_vm.translations.url,"data-tracking":_vm.dataTracking}},[_vm._v(_vm._s(_vm.translations.btn))]),_vm._v(" "),(_vm.translations.btn2)?_c('a',{staticClass:"btn btn-lg ml-lg-5 ml-0 btn-round btn-danger",class:{ 'btn-outline-primary': _vm.btnColor2 },attrs:{"href":_vm.translations.url2,"data-tracking":_vm.dataTracking}},[_vm._v(_vm._s(_vm.translations.btn2))]):_vm._e()])])])],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_hospital_zipcode_modal_vue__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_hospital_zipcode_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_hospital_zipcode_modal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_hospital_zipcode_modal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_hospital_zipcode_modal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe7c30b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_hospital_zipcode_modal_vue__ = __webpack_require__(854);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_hospital_zipcode_modal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe7c30b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_hospital_zipcode_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"c-location-modal"},[_c('aha-modal',{ref:"ahaZipCodeModal",attrs:{"id":"ahaZipCodeModal","aria-labelledby":"dialog-title","aria-describedby":"dialog-description","size":"lg","hide-footer":"","centered":"","lazy":""}},[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"c-listing-header c-listing-header--medium pt-0"},[_c('div',{staticClass:"c-listing-header__cta-container d-block"},[_c('h2',{staticClass:"c-listing-header__heading"},[_vm._v(_vm._s(_vm.translations.heading))])])]),_vm._v(" "),_c('p',{staticClass:"c-listing-header__subheading"},[_vm._v(_vm._s(_vm.translations.subheading))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('form',{attrs:{"action":"#","method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"text-left",attrs:{"for":"event_manual_zipcode"}},[_vm._v("\n                Zip code (required)\n                "),_c('p',{staticClass:"invalid-feedback"},[_vm._v("Please provide a valid zipcode.")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zipcode),expression:"zipcode"}],staticClass:"form-control",attrs:{"id":"event_manual_zipcode","type":"text","pattern":"^\\d{5}(?:[-\\s]\\d{4})?$","name":"manualZipcodeEntry","placeholder":"Please enter your zip code","aria-required":"true","required":"","aria-invalid":"false"},domProps:{"value":(_vm.zipcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.zipcode=$event.target.value}}})]),_vm._v(" "),_c('input',{staticClass:"btn btn-primary btn-round",attrs:{"type":"submit"},domProps:{"value":_vm.translations.btn}})])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_session_timeout_modal_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_session_timeout_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_session_timeout_modal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_session_timeout_modal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_session_timeout_modal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466565a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_session_timeout_modal_vue__ = __webpack_require__(856);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_session_timeout_modal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466565a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_session_timeout_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"c-location-modal"},[_c('aha-modal',{ref:"ahaTimeoutModal",attrs:{"id":"ahaTimeoutModal","aria-labelledby":"dialog-title","aria-describedby":"dialog-description","no-close-on-esc":true,"no-close-on-backdrop":true,"hide-header-close":"","hide-footer":"","centered":"","lazy":""}},[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"c-listing-header c-listing-header--medium pt-0"},[_c('div',{staticClass:"c-listing-header__cta-container d-block"},[_c('h2',{staticClass:"c-listing-header__heading"},[_vm._v(_vm._s(_vm.translations.heading))])])]),_vm._v(" "),_c('p',{staticClass:"c-listing-header__subheading"},[_vm._v(_vm._s(_vm.translations.subheading))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('form',{attrs:{"action":"#","method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('input',{staticClass:"btn btn-primary btn-round",attrs:{"type":"submit"},domProps:{"value":_vm.translations.btnyeslabel}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-round",on:{"click":function($event){$event.preventDefault();return _vm.onCancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.translations.btnnolabel))])])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ec52b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_transition_group_vue__ = __webpack_require__(858);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ec52b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_transition_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_form_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29dc6ade_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_transition_group_form_vue__ = __webpack_require__(861);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29dc6ade_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_transition_group_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(19);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports['default'] = {
    post: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(endpoint, obj) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', (0, _axios2['default'])({
                                method: 'post',
                                url: endpoint,
                                responseType: 'json',
                                data: obj
                            })['catch'](function (error) {
                                // eslint-disable-next-line
                                console.log('Trigger Page Goals error: ' + error);
                            }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function post(_x, _x2) {
            return _ref.apply(this, arguments);
        }

        return post;
    }()
};

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transition-group-form",attrs:{"id":_vm.id}},[_vm._t("default",null,{"formData":_vm.formData,"loading":_vm.loading,"activeStep":_vm.activeStep,"response":_vm.response,"submitForm":_vm.submitForm,"quizSubmitForm":_vm.quizSubmitForm,"resetForm":_vm.resetForm,"sendEmail":_vm.sendEmail,"redList":_vm.redList,"yellowList":_vm.yellowList,"greenList":_vm.greenList})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_step_vue__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_step_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_step_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_step_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_step_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fad4aa1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_transition_step_vue__ = __webpack_require__(863);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_step_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fad4aa1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_transition_step_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step == _vm.stepKey),expression:"step == stepKey"}],key:_vm.stepKey},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    inject: ['EventBus'],
    props: {
        ariaLabel: {
            type: String,
            required: false
        }
    },
    render: function render(h) {
        var _this = this;

        var container = h('button', {
            attrs: {
                'aria-label': this.ariaLabel
            },
            on: {
                click: function click(evt) {
                    if (evt.target.hasAttribute('step-index')) {
                        _this.EventBus.$emit('stepTrigger', evt.target.getAttribute('step-index'));
                    } else {
                        _this.EventBus.$emit('stepTrigger');
                        // evt.target.setAttribute('disabled', 'disabled');
                    }
                }
            }
        }, [this.$slots['default']]);

        return container;
    }
};

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    inject: ['EventBus'],
    render: function render(h) {
        var container = h('span', {});

        return container;
    },

    props: {},
    mounted: function mounted() {
        var _this = this;

        this.EventBus.$on('stepShown', function (inputs) {
            _this.$nextTick(function () {
                if (inputs.length) {
                    for (var i = 0; i < inputs.length; i++) {
                        if (inputs[i].checked) {
                            _this.$el.innerHTML = inputs[i].value;
                            break;
                        }
                    }
                } else {
                    _this.$el.innerHTML = inputs.value;
                }
            });
        });
    }
};

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_inline_site_search_vue__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_inline_site_search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_inline_site_search_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_inline_site_search_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_inline_site_search_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03487e0d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_inline_site_search_vue__ = __webpack_require__(867);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_inline_site_search_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03487e0d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_inline_site_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.modalId),expression:"modalId"}],staticClass:"c-top-nav__link btn btn-link-plain"},[_c('img',{attrs:{"src":_vm.searchIcon,"alt":""}}),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.searchLabel))])]),_vm._v(" "),_c('aha-modal',{staticClass:"c-site-search-modal global-search-section",attrs:{"id":_vm.modalId,"hide-footer":"","hide-header":"","lazy":""},on:{"shown":_vm.onShown}},[_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', _vm.modalId, $event.target)}}},[_vm._v("×")]),_vm._v(" "),_c('form',{staticClass:"c-inline-search__form",attrs:{"action":_vm.formAction,"role":"search"}},[_c('div',{staticClass:"c-inline-search__search form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label-lg",attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.searchLabel))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],ref:"search",staticClass:"c-inline-search__input form-control form-control-lg",attrs:{"type":"text","id":_vm.inputId,"name":_vm.inputName,"placeholder":_vm.placeholderText},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})]),_vm._v(" "),_c('input',{staticClass:"c-inline-search__submit btn btn-lg btn-danger btn-round",attrs:{"type":"submit"},domProps:{"value":_vm.searchButton},on:{"click":function($event){$event.preventDefault();return _vm.search.apply(null, arguments)}}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bacae1dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_impacted_data_vue__ = __webpack_require__(869);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bacae1dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_impacted_data_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-impact-map-data"},[_c('div',{staticClass:"c-impact-map-data__container container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-impact-map-data col-md-10 offset-md-1"},[_c('h1',[_vm._v("Our Impact")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("For nearly 100 years")]),_vm._v(", we've been fighting heart disease and stroke, helping communities live longer, healthier lives."),_c('br'),_vm._v("\n          When you support the American Heart Association, it's evident in communities like yours."),_c('br'),_vm._v(" "),_c('i',[_vm._v("Explore the map below to see how your support has made an impact.")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-impact-map-data col-md-4 float-left"},[_c('div',{staticClass:"c-impact-map-data__sub-headings"},[_c('span',{staticClass:"c-impact-map-data__sub-heading"},[_c('strong',[_vm._v("13.6%")])])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-impact-map-data__text"},[_c('strong',[_vm._v("Reduction in deaths from Stroke")]),_c('br'),_vm._v("\n              Since February 2018\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"c-impact-map-data col-md-4 float-left"},[_c('div',{staticClass:"c-impact-map-data__sub-headings"},[_c('span',{staticClass:"c-impact-map-data__sub-heading"},[_c('strong',[_vm._v("$200"),_c('br'),_c('label',[_vm._v("MILLION")])])])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-impact-map-data__text"},[_c('strong',[_vm._v("Invested annually in inovative research funding")]),_c('br'),_vm._v("\n              More than any private not-for-profit organization except the federal government.\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"c-impact-map-data col-md-4 float-left"},[_c('div',{staticClass:"c-impact-map-data__sub-headings"},[_c('span',{staticClass:"c-impact-map-data__sub-heading"},[_c('strong',[_vm._v("15.1%")])])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-impact-map-data__text"},[_c('strong',[_vm._v("Reduction in deaths from Heart Disease")]),_c('br'),_vm._v("\n              Since February 2018\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-impact-map-data col-md-4 float-left"},[_c('div',{staticClass:"c-impact-map-data__sub-headings"},[_c('span',{staticClass:"c-impact-map-data__sub-heading"},[_c('strong',[_vm._v("30"),_c('br'),_c('label',[_vm._v("MILLION")])])])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-impact-map-data__text"},[_c('strong',[_vm._v("Nutritious school lunches provided")])])])]),_vm._v(" "),_c('div',{staticClass:"c-impact-map-data col-md-4 float-left"},[_c('div',{staticClass:"c-impact-map-data__sub-headings"},[_c('span',{staticClass:"c-impact-map-data__sub-heading"},[_c('strong',[_vm._v("14"),_c('br'),_c('label',[_vm._v("MILLION")])])])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-impact-map-data__text"},[_c('strong',[_vm._v("Nutritious school breakfasts provided")])])])]),_vm._v(" "),_c('div',{staticClass:"c-impact-map-data col-md-4 float-left"},[_c('div',{staticClass:"c-impact-map-data__sub-headings"},[_c('span',{staticClass:"c-impact-map-data__sub-heading"},[_c('strong',[_vm._v("22"),_c('br'),_c('label',[_vm._v("MILLION")])])])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-impact-map-data__text"},[_c('strong',[_vm._v("Peaople trained in CPR each year")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _queryParams = __webpack_require__(871);

var _queryParams2 = _interopRequireDefault(_queryParams);

var _inputEventbus = __webpack_require__(45);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

var _closest = __webpack_require__(268);

var _closest2 = _interopRequireDefault(_closest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    render: function render(h) {
        var template = h('div', [this.$scopedSlots['default']({
            isInitialized: this.isInitialized,
            currentQuery: this.currentQuery,
            sortBy: this.sortBy,
            numResults: this.numResults,
            formData: this.formData,
            flaggedData: this.flaggedData,
            id: this.id,
            isValid: this.isValid,
            submitSearch: this.submitSearch,
            manualSubmitSearch: this.manualSubmitSearch,
            checkFormData: this.checkFormData,
            checkParent: this.checkParent
        })]);

        var form = h('form', {
            ref: 'searchForm',
            attrs: {
                id: this.id,
                action: this.action
            }
        }, [template]);

        return form;
    },
    data: function data() {
        return {
            isInitialized: false,
            currentQuery: {
                type: String
            },
            sortBy: {
                type: String
            },
            numResults: {
                type: String
            },
            formData: {},
            flaggedData: [],
            id: 'component_uid_' + this._uid
        };
    },

    props: {
        action: {
            type: String,
            'default': ''
        },
        queryString: {
            type: String,
            'default': null
        },
        queryDelimeter: {
            type: String,
            'default': '?'
        },
        sortByName: {
            type: String,
            'default': 'sort-by'
        },
        numResultsName: {
            type: String,
            'default': 'num-results'
        }
    },
    computed: {
        isValid: function isValid() {
            return this.checkFormData;
        }
    },
    watch: {
        sortBy: function sortBy(val) {
            this.submitSearch();
        },
        numResults: function numResults(val) {
            this.submitSearch();
        }
    },
    methods: {
        submitSearch: function submitSearch() {
            var _this = this;

            // Don't submit search until default values are set
            if (this.isInitialized) {
                this.$nextTick(function () {
                    _this.$refs.searchForm.submit();
                });
            }
        },
        manualSubmitSearch: function manualSubmitSearch() {
            var _this2 = this;

            if (this.isInitialized) {
                this.$nextTick(function () {
                    var validQuery = _this2.checkFormData();
                    var url = _this2.action;
                    if (validQuery) {
                        var i = 0;
                        url += _this2.queryDelimeter;
                        for (var prop in _this2.formData) {
                            if (_this2.formData[prop] !== '') {
                                var flagged = false;
                                var z = 0;
                                do {
                                    if (_this2.flaggedData[z] === prop) {
                                        flagged = true;
                                    }
                                    z++;
                                } while (z < _this2.flaggedData.length && !flagged);
                                if (i > 0) {
                                    url += '&';
                                }
                                if (flagged) {
                                    url += prop + '=' + _this2.formData[prop];
                                } else {
                                    url += prop + '=[' + _this2.formData[prop] + ']';
                                }
                                i++;
                            }
                        }
                    }
                    window.location.href = url;
                });
            }
        },
        checkFormData: function checkFormData() {
            for (var prop in this.formData) {
                if (this.formData[prop] !== '') {
                    return true;
                }
            }
            return false;
        },
        checkParent: function checkParent(el) {
            var root = '#' + this.id;
            var parent = (0, _closest2['default'])(el, root);
            if (this.$el === parent) {
                return true;
            } else {
                return false;
            }
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        var params = (0, _queryParams2['default'])();

        // Save the current query
        if (this.queryString && typeof params[this.queryString] !== 'undefined') {
            this.currentQuery = params[this.queryString];
        }

        this.$nextTick(function () {
            if (typeof params[_this3.sortByName] !== 'undefined') {
                _this3.sortBy = params[_this3.sortByName];
            }

            if (typeof params[_this3.numResultsName] !== 'undefined') {
                _this3.numResults = params[_this3.numResultsName];
            }

            _this3.$nextTick(function () {
                _this3.isInitialized = true;
            });
        });
    },
    created: function created() {
        var _this4 = this;

        _inputEventbus2['default'].$on('inputInit', function (value, id, el) {
            _this4.$nextTick(function () {
                var isParent = _this4.checkParent(el);
                if (isParent && !_this4.formData[id]) {
                    _this4.formData[id] = value;
                }
            });
        });

        _inputEventbus2['default'].$on('inputInitFlagged', function (value, id, el) {
            _this4.$nextTick(function () {
                var isParent = _this4.checkParent(el);
                if (isParent) {
                    _this4.formData[id] = value;
                    _this4.flaggedData.push(id);
                }
            });
        });

        _inputEventbus2['default'].$on('inputUpdated', function (value, id, el) {
            if (_this4.formData[id] !== value) {
                var isParent = _this4.checkParent(el);
                if (isParent) {
                    _this4.formData[id] = value;
                    _this4.$forceUpdate();
                }
            }
        });
    }
};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports['default'] = queryParams;
function queryParams() {
    var query = window.location.search;

    return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
        var _param$split = param.split('='),
            _param$split2 = _slicedToArray(_param$split, 2),
            key = _param$split2[0],
            value = _param$split2[1];

        params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
        return params;
    }, {});
}

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_back_to_search_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_back_to_search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_back_to_search_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_back_to_search_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_back_to_search_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3b496f6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_back_to_search_vue__ = __webpack_require__(877);
function injectStyle (ssrContext) {
  __webpack_require__(873)
  __webpack_require__(875)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b3b496f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_back_to_search_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3b496f6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_back_to_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(874);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("f3585c10", content, true, {});

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".c-cta--arrow-reverse[data-v-b3b496f6]:before{content:\"<\";width:15px}.c-cta--arrow-reverse[data-v-b3b496f6]{padding:1.875rem 0}.c-cta--arrow-reverse[data-v-b3b496f6]:hover:before{text-decoration:none}", ""]);

// exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(876);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("c836ed04", content, true, {});

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".back-to-search-container+.c-hero-full{margin-top:18px}", ""]);

// exports


/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{class:_vm.componentStyles},[(_vm.linkOnly)?_c('a',{class:_vm.linkStyles,attrs:{"href":_vm.searchPageUri}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.linkText))]})],2):_c('b-row',[_c('b-col',[_c('a',{class:_vm.linkStyles,attrs:{"href":_vm.searchPageUri}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.linkText))]})],2)])],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* global addthis */

exports['default'] = {
    render: function render(h) {
        var addThis = h('div', {
            'class': 'c-share addthis_inline_share_toolbox'
        });

        var shareSpan = h('span', {
            'class': 'c-social__text'
        }, [this.shareText]);

        var container = h('div', {
            'class': 'c-social'
        }, [this.showText ? shareSpan : null, addThis]);

        return container;
    },

    props: {
        shareText: {
            type: String,
            'default': 'Share:'
        },
        showText: {
            type: Boolean,
            'default': false
        }
    },
    mounted: function mounted() {
        // Force AddThis to refresh
        if (typeof addthis.layers.refresh !== 'undefined') {
            addthis.layers.refresh();
        }
    }
};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(17);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default']],
    render: function render(h) {
        var gigya = h('div', {
            'class': 'c-share c-share--gigya',
            attrs: {
                id: this.shareId
            }
        });

        var container = h('div', {
            'class': 'c-social'
        }, [gigya, this.hasDefaultSlot && this.$slots['default']]);

        return container;
    },

    props: {
        shareButtons: {
            type: Array
        },
        description: {
            type: String,
            'default': ''
        },
        title: {
            type: String,
            'default': ''
        },
        imageUrl: {
            type: String,
            'default': ''
        },
        tags: {
            type: String,
            'default': ''
        }
    },
    computed: {
        shareId: function shareId() {
            return this.safeId('_AHA-gigya-social');
        },
        hasDefaultSlot: function hasDefaultSlot() {
            return !!this.$slots['default'];
        }
    },
    mounted: function mounted() {
        var act = new gigya.socialize.UserAction();

        act.setDescription(this.description);
        act.setTitle(this.title);
        act.addMediaItem({
            type: 'image',
            src: this.imageUrl
        });

        var showShareBarUiParams = {
            containerID: this.shareId,
            tags: this.tags,
            wrap: 'true',
            iconsOnly: 'true',
            showTooltips: 'true',
            layout: 'horizontal',
            shortURLs: 'never',
            showCounts: 'none',
            shareButtons: this.shareButtons || [{
                provider: 'facebook',
                tooltip: 'Share on Facebook',
                iconImgUp: '/dist/common/assets/share/facebook.svg'
            }, {
                provider: 'twitter',
                tooltip: 'Share on Twitter',
                iconImgUp: '/dist/common/assets/share/twitter.svg'
            }, {
                provider: 'pinterest',
                tooltip: 'Pin It!',
                iconImgUp: '/dist/common/assets/share/pinterest.svg'
            }, {
                provider: 'print',
                tooltip: 'Print',
                iconImgUp: '/dist/common/assets/share/print.svg'
            }],
            userAction: act,
            onLoad: function onLoad(event) {
                var container = document.querySelector('#' + event.containerID);
                var shareButtons = container.querySelectorAll('.gig-share-button');

                for (var x = 0; x < shareButtons.length; x++) {
                    shareButtons[x].setAttribute('tabindex', 0);
                    shareButtons[x].setAttribute('role', 'button');

                    shareButtons[x].addEventListener('keypress', function (keyEvent) {
                        if (keyEvent.charCode === 13) {
                            this.onclick();
                        }
                    });
                }
            }
        };

        this.$nextTick(function () {
            gigya.socialize.showShareBarUI(showShareBarUiParams);
        });
    }
}; /* global gigya */

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_form_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_081b5c1a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_single_field_prompt_form_vue__ = __webpack_require__(881);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_081b5c1a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_single_field_prompt_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"c-single-field-prompt-form",attrs:{"novalidate":""},on:{"submit":_vm.submitForm}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label col-form-label-lg",attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.translations.label))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"}],ref:"singleFieldInput",staticClass:"form-control form-control-lg",class:{ 'is-invalid': _vm.isInvalid },attrs:{"id":_vm.inputId,"placeholder":_vm.translations.placeholder,"min":_vm.config.minValue,"max":_vm.config.maxValue,"required":""},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group",attrs:{"aria-hidden":!_vm.isInvalid,"aria-describedby":_vm.inputId,"role":"alert"}},[_c('div',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.translations.validation))])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-round btn-lg btn-danger",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.translations.submit))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_radio_form_vue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_radio_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_radio_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_radio_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_radio_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66a5f12a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_single_field_prompt_radio_form_vue__ = __webpack_require__(883);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_radio_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66a5f12a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_single_field_prompt_radio_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"c-single-field-prompt-form",attrs:{"novalidate":""},on:{"submit":_vm.submitForm}},[_c('b-form-group',{attrs:{"label":_vm.title}},[_c('p',{ref:"label",domProps:{"innerHTML":_vm._s(_vm.label)}}),_vm._v(" "),_c('div',{staticClass:"input-group",class:{ 'is-invalid': _vm.isInvalid },attrs:{"aria-hidden":!_vm.isInvalid,"role":"alert","aria-atomic":"true"}},[_c('div',{staticClass:"invalid-feedback",attrs:{"id":"invalid_feedback"}},[_c('p',[_vm._v(_vm._s(_vm.translations.validation))])])]),_vm._v(" "),_vm._l((this.config.options),function(option){return _c('div',{key:option.stepKey,staticClass:"custom-control custom-radio",class:{ 'is-invalid': _vm.isInvalid }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"custom-control-input",class:{ 'is-invalid': _vm.isInvalid },attrs:{"type":"radio","required":"","id":_vm.inputId + '_radio_' + option.stepKey,"name":_vm.inputId + '_radio_'},domProps:{"value":option.text,"checked":_vm._q(_vm.selected,option.text)},on:{"change":function($event){_vm.selected=option.text}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":_vm.inputId + '_radio_' + option.stepKey},domProps:{"innerHTML":_vm._s(option.text)}})])})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-round btn-lg btn-danger",attrs:{"type":"submit","disabled":!_vm.isFormValid}},[_vm._v(_vm._s(_vm.translations.submit))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_tv_page_modal_vue__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_tv_page_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_tv_page_modal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_tv_page_modal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_tv_page_modal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_847dc004_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_tv_page_modal_vue__ = __webpack_require__(885);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_tv_page_modal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_847dc004_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_tv_page_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.videoId}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_make_commitment_form_vue__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_make_commitment_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_make_commitment_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_make_commitment_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_make_commitment_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5730c0c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_make_commitment_form_vue__ = __webpack_require__(887);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_make_commitment_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5730c0c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_make_commitment_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"novalidate":""},on:{"submit":_vm.submitForm}},[_c('div',{staticClass:"c-promo c-promo--events c-promo--shadow c-promo--row",attrs:{"aria-live":"polite"}},[_vm._t("default",null,{"formData":_vm.formData,"response":_vm.response,"validation":_vm.validation,"loading":_vm.loading,"isComplete":_vm.isComplete,"checkInput":_vm.checkInput,"validEmail":_vm.validEmail})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_add_to_recipe_box_vue__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_add_to_recipe_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_add_to_recipe_box_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_add_to_recipe_box_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_add_to_recipe_box_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05b62330_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_add_to_recipe_box_vue__ = __webpack_require__(889);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_add_to_recipe_box_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05b62330_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_add_to_recipe_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{domProps:{"innerHTML":_vm._s(_vm.recipeBoxForm)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_recipe_box_favorite_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_recipe_box_favorite_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_recipe_box_favorite_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_recipe_box_favorite_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_recipe_box_favorite_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_679f442a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_recipe_box_favorite_vue__ = __webpack_require__(891);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_recipe_box_favorite_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_679f442a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_recipe_box_favorite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-reset",attrs:{"type":"button"},on:{"click":_vm.click}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.srText))]),_vm._v(" "),_c('span',{class:_vm.iconClasses})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_modify_recipe_box_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_modify_recipe_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_modify_recipe_box_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_modify_recipe_box_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_modify_recipe_box_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_047f9664_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_modify_recipe_box_vue__ = __webpack_require__(893);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_modify_recipe_box_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_047f9664_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_modify_recipe_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"c-recipe-box-widget"},[_c('div',{staticClass:"c-recipe-box-widget__header c-label c-label--red c-label--wide"},[_c('h3',{staticClass:"c-recipe-box-widget__heading h6"},[_vm._v(_vm._s(_vm.translations.firstSectionTitle))]),_vm._v(" "),_c('a',{staticClass:"c-recipe-box-widget__edit c-cta h-color--white",attrs:{"href":"#","role":"button","aria-label":"Edit Folder","title":"Edit Folder"},on:{"click":_vm.showEditSection}},[_vm._v(_vm._s(_vm.translations.editText))])]),_vm._v(" "),_c('nav',{staticClass:"c-recipe-box-widget__content"},[_c('ul',{staticClass:"c-recipe-box-categories"},[_c('li',[_c('a',{staticClass:"c-recipe-box-categories__link",attrs:{"href":_vm.translations.currentItemLink}},[_vm._v(_vm._s(_vm.translations.label))])]),_vm._v(" "),_vm._l((_vm.folderitems),function(option){return _c('li',{key:option.text},[(option.count!=null)?_c('a',{staticClass:"c-recipe-box-categories__link",attrs:{"href":_vm.translations.currentItemLink + '?recipeFolder=' + option.text}},[_vm._v(_vm._s(option.text)+" ("+_vm._s(option.count)+")")]):_vm._e(),_vm._v(" "),(option.count==null)?_c('a',{staticClass:"c-recipe-box-categories__link",attrs:{"href":_vm.translations.currentItemLink + '?recipeFolder=' + option.text}},[_vm._v(_vm._s(option.text))]):_vm._e()])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],ref:"recipeboxeditsection",staticClass:"c-recipe-box-widget",attrs:{"id":"recipeboxeditsection","role":"document","tabindex":"-1"}},[_c('div',{staticClass:"c-recipe-box-widget__header c-label c-label--red c-label--wide"},[_c('h3',{staticClass:"c-recipe-box-widget__heading h6"},[_vm._v(_vm._s(_vm.translations.firstSectionTitle))])]),_vm._v(" "),_c('div',{ref:"folderEditSection",staticClass:"c-recipe-box-widget__content clearfix"},[_c('form',{attrs:{"id":"updateRecipeboxFormData","action":"#"},on:{"submit":function($event){$event.preventDefault();return _vm.SumbitUpdateRecipeBox.apply(null, arguments)}}},[_c('ul',{ref:"recipeBoxUpdate",staticClass:"c-recipe-box-categories update-recipe-section",attrs:{"id":"recipeBoxUpdate"}},[_c('li',{ref:"recipeBoxUpdateMessage",staticClass:"sr-only",attrs:{"id":"recipeBoxUpdateMessage","hidden":true,"aria-live":"polite","role":"alert"}}),_vm._v(" "),_c('li',{staticClass:"form-group"},[_vm._v(_vm._s(_vm.translations.label))]),_vm._v(" "),_vm._l((_vm.items),function(option){return _c('li',{key:option.text,staticClass:"form-group"},[_c('label',{staticClass:"sr-only",attrs:{"for":_vm._f("underscore")(option.text)}},[_vm._v(_vm._s(option.text))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control has-invalid-icon",attrs:{"id":_vm._f("underscore")(option.text),"type":"text","name":"updateFolder","title":option.text},domProps:{"value":option.text}}),_vm._v(" "),_c('a',{staticClass:"input-validation-icon input-validation-icon--invalid",attrs:{"href":"#","aria-label":"Delete Folder","title":"Delete Folder","role":"button"},on:{"click":function($event){return _vm.DeleteFolder(option.text)}}},[_c('i',{staticClass:"icon-times"})])])])})],2),_vm._v(" "),_c('input',{staticClass:"c-recipe-box-widget__submit btn btn-danger btn-round",attrs:{"type":"submit"},domProps:{"value":_vm.translations.saveButtonText}})])])]),_vm._v(" "),_c('div',{staticClass:"c-recipe-box-widget"},[_c('div',{staticClass:"c-recipe-box-widget__header c-label c-label--red c-label--wide"},[_c('h3',{staticClass:"c-recipe-box-widget__heading h6"},[_vm._v(_vm._s(_vm.translations.createNewFolder))])]),_vm._v(" "),_c('div',{staticClass:"c-recipe-box-widget__content clearfix"},[_c('p',{ref:"createFolderError",staticClass:"sr-only",attrs:{"hidden":true,"role":"alert"}}),_vm._v(" "),_c('form',{class:[_vm.wasSubmitted ? 'was-validated' : 'needs-validation'],attrs:{"action":"#","novalidate":""}},[_c('ul',{staticClass:"c-recipe-box-categories"},[_c('li',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.fieldValue),expression:"fieldValue",modifiers:{"trim":true}}],ref:"createFolderInput",staticClass:"form-control",class:_vm.isValid ? ' ' : 'is-invalid',attrs:{"aria-atomic":_vm.isValid,"aria-invalid":!_vm.isValid,"required":"","id":"create-new-folder","type":"text","placeholder":_vm.translations.newFolderName,"name":""},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(!_vm.isValid)?_c('div',{staticClass:"form-text text-danger is-invalid h4",attrs:{"role":"alert","aria-atomic":"true","id":"new-folder-help"}},[_c('small',[_vm._v("A folder name is required.")])]):_vm._e()])]),_vm._v(" "),_c('input',{staticClass:"c-recipe-box-widget__submit btn btn-danger btn-round",attrs:{"type":"submit","disabled":_vm.fieldValue === ''},domProps:{"value":_vm.translations.createButtonText},on:{"click":function($event){$event.preventDefault();return _vm.createFolderFn.apply(null, arguments)}}})])])]),_vm._v(" "),(_vm.loadingImageShow)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingImageShow),expression:"loadingImageShow"}],class:{ 'loading-image modal fade show d-block': _vm.loadingImageShow }},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-backdrop fade show",attrs:{"id":"recipe-add-to-box___BV_modal_backdrop__jlf62in2"}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"create-new-folder"}},[_vm._v("\n              New Folder Name "),_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-centered"},[_c('img',{attrs:{"src":__webpack_require__(79),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_copy_url_to_clipboard_vue__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_copy_url_to_clipboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_copy_url_to_clipboard_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_copy_url_to_clipboard_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_copy_url_to_clipboard_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58b895a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_copy_url_to_clipboard_vue__ = __webpack_require__(895);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_copy_url_to_clipboard_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58b895a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_copy_url_to_clipboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.url),expression:"url",arg:"copy"}],ref:"button",staticClass:"btn btn-link m-0 p-0 bg-white border-0",attrs:{"type":"button","aria-label":_vm.ariaLabelProp}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_external_script_vue__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_external_script_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_external_script_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_external_script_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_external_script_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf8a66d2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_external_script_vue__ = __webpack_require__(898);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_external_script_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf8a66d2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_external_script_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 897 */,
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ext_script",staticClass:"ext-script-container",attrs:{"id":_vm.idwrapper}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_support_bar_section_vue__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_support_bar_section_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_support_bar_section_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_support_bar_section_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_support_bar_section_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_847f4c64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_support_bar_section_vue__ = __webpack_require__(900);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_support_bar_section_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_847f4c64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_support_bar_section_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col c-support-bar__section"},[_c('div',{staticClass:"c-support-bar__content"},[_c('h2',{staticClass:"h6 c-support-bar__content-title"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(_vm.modalId),expression:"modalId"}],staticClass:"btn btn-link-plain btn--select"},[_c('span',{staticClass:"h6"},[_vm._v(_vm._s(_vm.name))])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":_vm.modalId,"visible":false}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simple_accordion_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simple_accordion_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simple_accordion_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simple_accordion_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simple_accordion_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37dd9156_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simple_accordion_vue__ = __webpack_require__(902);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simple_accordion_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37dd9156_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simple_accordion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-simple-accordion",attrs:{"id":[_vm.modalId + '_simple-accordion_']}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(_vm.modalId),expression:"modalId"}],staticClass:"btn btn-link-plain",class:[_vm.icon]},[_c('div',{},[_vm._v(_vm._s(_vm.title)+" ")])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":_vm.modalId,"visible":false}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_daf_widget_vue__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_daf_widget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_daf_widget_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_daf_widget_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_daf_widget_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88b9032e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_daf_widget_vue__ = __webpack_require__(906);
function injectStyle (ssrContext) {
  __webpack_require__(904)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88b9032e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_daf_widget_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88b9032e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_daf_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(905);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("b7d3f108", content, true, {});

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "form label[data-v-88b9032e]{font-weight:500}p[data-v-88b9032e]{font-size:.85rem;font-weight:500}", ""]);

// exports


/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo c-promo--full-width c-promo--border c-promo--shadow h-theme--red"},[_c('form',{directives:[{name:"form-submit",rawName:"v-form-submit"}],attrs:{"action":"","method":"post","name":"dafdirect","id":"dafdirect"}},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 form__content"},[_c('p',[_vm._v("\n                If you have a donor advised fund, DAF Direct enables you to recommend grants to this nonprofit directly from your DAF (as long as your DAF's sponsoring organization is participating).\n            ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.amount),expression:"amount",modifiers:{"number":true}}],staticClass:"text-iput dafdirectInput form-control",attrs:{"name":"dafdirect_amnt","id":"dafdirect_amnt","type":"number","required":""},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-round btn-primary btn-block",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_vm._v("Submit")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 form__image mb-3 d-flex justify-content-center align-items-center"},[_c('img',{attrs:{"src":"https://www.dafdirect.org/ddirect/images/logo-DAF-direct2.jpg","alt":"Logo DAF Direct"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"dafprovider"}},[_vm._v("Donate now from: "),_c('span',{staticClass:"small text-danger"},[_vm._v("(required)")])]),_vm._v(" "),_c('select',{staticClass:"form-control custom-select btn--select py-0",attrs:{"id":"dafprovider","required":""}},[_c('option',{attrs:{"value":""}},[_vm._v("--Please select--")]),_vm._v(" "),_c('option',{attrs:{"value":"FC"}},[_vm._v("Fidelity Charitable")]),_vm._v(" "),_c('option',{attrs:{"value":"SC"}},[_vm._v("Schwab Charitable")]),_vm._v(" "),_c('option',{attrs:{"value":"BNYM"}},[_vm._v("BNY Mellon")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"dafdirect_dsgtxt"}},[_vm._v("Designation:")]),_vm._v(" "),_c('input',{staticClass:"dafdirectInputFull dafdirectInpu form-control",attrs:{"type":"text","name":"dafdirect_dsgtxt","id":"dafdirect_dsgtxt","size":"8","value":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"dafdirect_amnt"}},[_vm._v("Amount: $ "),_c('span',{staticClass:"small text-danger"},[_vm._v("(required)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_collapsable_view_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_collapsable_view_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_collapsable_view_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_collapsable_view_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_collapsable_view_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3258467a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_collapsable_view_vue__ = __webpack_require__(908);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_collapsable_view_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3258467a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_collapsable_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"c-collapsible-view"},[(_vm.isVisible)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_selection_card_vue__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_selection_card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_selection_card_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_selection_card_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_selection_card_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_540e10f5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_selection_card_vue__ = __webpack_require__(910);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_selection_card_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_540e10f5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_selection_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.styles,style:(_vm.transformStyles)},[_c('div',{staticClass:"c-selection-card__content"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.img,"alt":_vm.imgAlt}})]),_vm._v(" "),_c('div',{staticClass:"title-container"},[_c('h2',{staticClass:"title h4",attrs:{"id":("selectionCard-" + _vm.id + "_title")}},[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('transition',{attrs:{"name":"selection-card-hover"}},[_c('div',{class:{'c-selection-card__overlay': true}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('button',{staticClass:"btn btn-round btn-danger"},[_vm._v(_vm._s(_vm._f("upper")(_vm.selected ? _vm.removeButtonText : _vm.buttonText)))])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_switch_input_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_switch_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_switch_input_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_switch_input_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_switch_input_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86a2d8f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_switch_input_vue__ = __webpack_require__(914);
function injectStyle (ssrContext) {
  __webpack_require__(912)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-86a2d8f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_switch_input_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86a2d8f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_switch_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(913);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("faac1574", content, true, {});

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".phd-bg--red[data-v-86a2d8f8]{background-color:#d22338}.phd-bg--red-alt[data-v-86a2d8f8]{background-color:#c0161d}.phd-bg--gray-light[data-v-86a2d8f8]{background-color:#f1f1f1}.phd-bg--gray[data-v-86a2d8f8]{background-color:#979797}.phd-bg--gray-mid[data-v-86a2d8f8]{background-color:#6d6e71}.phd-bg--gray-dark[data-v-86a2d8f8]{background-color:#373737}.phd-bg--black[data-v-86a2d8f8]{background-color:#000}.phd-bg--black-alt[data-v-86a2d8f8]{background-color:#050606}.phd-bg--blue[data-v-86a2d8f8]{background-color:#65baf5}.phd-bg--blue-alt[data-v-86a2d8f8]{background-color:#034a80}.phd-bg--mustard[data-v-86a2d8f8]{background-color:#f9b146}.phd-bg--mustard-alt[data-v-86a2d8f8]{background-color:#a7762d}.phd-bg--lime[data-v-86a2d8f8]{background-color:#abd02e}.phd-bg--lime-alt[data-v-86a2d8f8]{background-color:#6b831c}.phd-bg--seafoam[data-v-86a2d8f8]{background-color:#30b6a1}.phd-bg--seafoam-alt[data-v-86a2d8f8]{background-color:#1d7164}.phd-font-color--red[data-v-86a2d8f8]{color:#d22338}.phd-font-color--red-alt[data-v-86a2d8f8]{color:#c0161d}.phd-font-color--gray-light[data-v-86a2d8f8]{color:#f1f1f1}.phd-font-color--gray[data-v-86a2d8f8]{color:#979797}.phd-font-color--gray-mid[data-v-86a2d8f8]{color:#6d6e71}.phd-font-color--gray-dark[data-v-86a2d8f8]{color:#373737}.phd-font-color--black[data-v-86a2d8f8]{color:#000}.phd-font-color--black-alt[data-v-86a2d8f8]{color:#050606}.phd-font-color--blue[data-v-86a2d8f8]{color:#65baf5}.phd-font-color--blue-alt[data-v-86a2d8f8]{color:#034a80}.phd-font-color--mustard[data-v-86a2d8f8]{color:#f9b146}.phd-font-color--mustard-alt[data-v-86a2d8f8]{color:#a7762d}.phd-font-color--lime[data-v-86a2d8f8]{color:#abd02e}.phd-font-color--lime-alt[data-v-86a2d8f8]{color:#6b831c}.phd-font-color--seafoam[data-v-86a2d8f8]{color:#30b6a1}.phd-font-color--seafoam-alt[data-v-86a2d8f8]{color:#1d7164}.phd-link-color--red[data-v-86a2d8f8],.phd-link-color--red[data-v-86a2d8f8]:hover{color:#d22338}.phd-link-color--red-alt[data-v-86a2d8f8],.phd-link-color--red-alt[data-v-86a2d8f8]:hover{color:#c0161d}.phd-link-color--gray-light[data-v-86a2d8f8],.phd-link-color--gray-light[data-v-86a2d8f8]:hover{color:#f1f1f1}.phd-link-color--gray[data-v-86a2d8f8],.phd-link-color--gray[data-v-86a2d8f8]:hover{color:#979797}.phd-link-color--gray-mid[data-v-86a2d8f8],.phd-link-color--gray-mid[data-v-86a2d8f8]:hover{color:#6d6e71}.phd-link-color--gray-dark[data-v-86a2d8f8],.phd-link-color--gray-dark[data-v-86a2d8f8]:hover{color:#373737}.phd-link-color--black[data-v-86a2d8f8],.phd-link-color--black[data-v-86a2d8f8]:hover{color:#000}.phd-link-color--black-alt[data-v-86a2d8f8],.phd-link-color--black-alt[data-v-86a2d8f8]:hover{color:#050606}.phd-link-color--blue[data-v-86a2d8f8],.phd-link-color--blue[data-v-86a2d8f8]:hover{color:#65baf5}.phd-link-color--blue-alt[data-v-86a2d8f8],.phd-link-color--blue-alt[data-v-86a2d8f8]:hover{color:#034a80}.phd-link-color--mustard[data-v-86a2d8f8],.phd-link-color--mustard[data-v-86a2d8f8]:hover{color:#f9b146}.phd-link-color--mustard-alt[data-v-86a2d8f8],.phd-link-color--mustard-alt[data-v-86a2d8f8]:hover{color:#a7762d}.phd-link-color--lime[data-v-86a2d8f8],.phd-link-color--lime[data-v-86a2d8f8]:hover{color:#abd02e}.phd-link-color--lime-alt[data-v-86a2d8f8],.phd-link-color--lime-alt[data-v-86a2d8f8]:hover{color:#6b831c}.phd-link-color--seafoam[data-v-86a2d8f8],.phd-link-color--seafoam[data-v-86a2d8f8]:hover{color:#30b6a1}.phd-link-color--seafoam-alt[data-v-86a2d8f8],.phd-link-color--seafoam-alt[data-v-86a2d8f8]:hover{color:#1d7164}.ecc-bg--cor-1[data-v-86a2d8f8]{background-color:#67bf80}.ecc-bg--cor-2a[data-v-86a2d8f8]{background-color:#ffd643}.ecc-bg--cor-2b[data-v-86a2d8f8]{background-color:#f1a63e}.ecc-bg--cor-3nobenefit[data-v-86a2d8f8]{background-color:#ef6e5d}.ecc-bg--cor-3harm[data-v-86a2d8f8]{background-color:#e71e26}.ecc-bg--loe-br[data-v-86a2d8f8]{background-color:#5c99cf}.ecc-bg--loe-cld[data-v-86a2d8f8]{background-color:#9cbfe2}.ecc-bg--loe-a[data-v-86a2d8f8]{background-color:#3776c8}.ecc-bg--loe-bnr[data-v-86a2d8f8]{background-color:#5b99d1}.ecc-bg--loe-ceo[data-v-86a2d8f8]{background-color:#bdd3ea}.ecc-bg--gray[data-v-86a2d8f8]{background-color:#ebebeb}.ecc-bg--white[data-v-86a2d8f8]{background-color:#fff}.ecc-bg--black[data-v-86a2d8f8]{background-color:#000}.ecc-font-color--cor-1[data-v-86a2d8f8]{color:#67bf80}.ecc-font-color--cor-2a[data-v-86a2d8f8]{color:#ffd643}.ecc-font-color--cor-2b[data-v-86a2d8f8]{color:#f1a63e}.ecc-font-color--cor-3nobenefit[data-v-86a2d8f8]{color:#ef6e5d}.ecc-font-color--cor-3harm[data-v-86a2d8f8]{color:#e71e26}.ecc-font-color--loe-br[data-v-86a2d8f8]{color:#5c99cf}.ecc-font-color--loe-cld[data-v-86a2d8f8]{color:#9cbfe2}.ecc-font-color--loe-a[data-v-86a2d8f8]{color:#3776c8}.ecc-font-color--loe-bnr[data-v-86a2d8f8]{color:#5b99d1}.ecc-font-color--loe-ceo[data-v-86a2d8f8]{color:#bdd3ea}.ecc-font-color--gray[data-v-86a2d8f8]{color:#ebebeb}.ecc-font-color--white[data-v-86a2d8f8]{color:#fff}.ecc-font-color--black[data-v-86a2d8f8]{color:#000}.c-switch-input[data-v-86a2d8f8]{display:inline-block;position:relative;vertical-align:middle;font-size:10px;cursor:pointer}.c-switch-input.focused[data-v-86a2d8f8]{outline:5px auto -webkit-focus-ring-color;outline-color:-webkit-focus-ring-color;outline-style:auto;outline-width:5px}.c-switch-input input[data-v-86a2d8f8]{opacity:0;position:absolute;width:1px;height:1px}.c-switch-input--label[data-v-86a2d8f8]{position:absolute;top:0;font-weight:600;color:#fff;z-index:1}.c-switch-input--label.v-left[data-v-86a2d8f8]{left:10px}.c-switch-input--label.v-right[data-v-86a2d8f8]{right:10px}.c-switch-input--core[data-v-86a2d8f8]{display:block;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;outline:0;margin:0;-webkit-transition:border-color .3s,background-color .3s;transition:border-color .3s,background-color .3s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#343a40}.checked .c-switch-input--core[data-v-86a2d8f8]{background-color:#c10e21}.c-switch-input--button[data-v-86a2d8f8]{display:block;position:absolute;overflow:hidden;top:0;left:0;border-radius:100%;background-color:#fff;z-index:2}.c-switch-input.disabled[data-v-86a2d8f8]{pointer-events:none;opacity:.6}legend.c-switch-input-legend[data-v-86a2d8f8]{display:inline;margin-right:10px}", ""]);

// exports


/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{ref:"wrapper",class:_vm.className,attrs:{"tabindex":"-1","aria-live":"polite"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],ref:"cbk",attrs:{"type":"checkbox","id":_vm.id,"name":_vm.name,"disabled":_vm.disabled,"role":"switch","aria-checked":_vm.checked,"aria-label":_vm.getAriaLabel,"aria-labelledby":_vm.ariaLabelledby,"aria-describedby":_vm.ariaDescribedby},domProps:{"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,null)>-1:(_vm.checked)},on:{"change":[function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}},_vm.toggle],"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false}}}),_vm._v(" "),_c('span',{staticClass:"c-switch-input--core",style:(_vm.coreStyle)},[_c('span',{staticClass:"c-switch-input--button",style:(_vm.buttonStyle)})]),_vm._v(" "),(_vm.showLabels)?[(_vm.checked)?_c('span',{staticClass:"c-switch-input--label v-left",style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.onText)+"\n      ")]):_c('span',{staticClass:"c-switch-input--label v-right",style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.offText))])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_vue__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a70eb20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_selector_vue__ = __webpack_require__(916);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a70eb20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-card-selector"},[_c('div',{staticClass:"c-card-selector__header"},[_c('h1',{attrs:{"id":"c-card-selector__header-label"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}})]),_vm._v(" "),_c('div',{staticClass:"c-card-selector__filters"},[(!_vm.filters)?_c('div',[_vm._t("filters")],2):_vm._l((_vm.filters),function(item,i){return _c('aha-card-selector-filter',{key:("filter_" + i),attrs:{"title":item.title,"description":item.description,"name":item.name,"checked":_vm.isFiltered(item.name)}})})],2),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"c-card-selector__message"},[_vm._v(_vm._s(_vm.errors[0]))]):_vm._e(),_vm._v(" "),_c('ul',{ref:"cardSelectorNode",staticClass:"c-card-selector__content",attrs:{"role":"listbox","aria-labelledby":"c-card-selector__header-label","aria-multiselectable":"true","tabindex":"-1"}},[_vm._l((_vm.sortedItems),function(item,i){return _c('li',{key:("selector-item_" + i),ref:("selectorItem_" + i),refInFor:true,staticClass:"c-card-selector-item",attrs:{"aria-selected":_vm.isSelected(item.id) ? 'true' : 'false',"id":("selector-item_" + i),"role":"option","active":_vm.focusedItem === item.id,"tabindex":"0"},on:{"mouseover":function($event){_vm.focusedItem = item.id},"mouseleave":function($event){_vm.focusedItem = null},"click":function (evt) { return _vm.toggleItem(evt, item.id); },"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return (function (evt) { return _vm.toggleItem(evt, item.id); }).apply(null, arguments)},"blur":function($event){_vm.focusedItem = null},"focus":function($event){_vm.focusedItem = item.id}}},[_c('aha-selection-card',{attrs:{"id":item.id,"title":item.title,"img":item.img,"imgAlt":item.imgAlt,"description":item.description,"button":item.button,"removeButtonText":item.removeButtonText,"flags":item.flags,"categoryTitle":item.categoryTitle,"mediaTitle":item.mediaTitle,"mediaText":item.mediaText,"mediaLink":item.mediaLink,"mediaLinkTarget":item.mediaLinkTarget,"mediaLinkClass":item.mediaLinkClass,"mediaLinkDescription":item.mediaLinkDescription,"downloadLink":item.downloadLink,"downloadLinkTarget":item.downloadLinkTarget,"downloadLinkClass":item.downloadLinkClass,"downloadButtonText":item.downloadButtonText,"selected":_vm.isSelected(item.id),"active":_vm.focusedItem === item.id,"sortOrder":item.sortOrder}})],1)}),_vm._v(" "),(!_vm.items)?_c('div',[_vm._t("default")],2):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"c-card-selector__actions"},[_vm._t("actions",null,{"valid":_vm.$store.state.selectedIds.length > 0,"submit":_vm.submit,"isFiltered":_vm.isFiltered,"selectedItems":_vm.$store.state.selectedIds})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_filter_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_filter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_filter_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_filter_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_filter_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78ad1a60_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_selector_filter_vue__ = __webpack_require__(918);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_filter_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78ad1a60_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_selector_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-selector-filter row"},[_c('div',{staticClass:"c-selector-filter__wrapper col-md-6 offset-md-3 col-12"},[_c('div',{staticClass:"c-selector-filter__content",attrs:{"id":"tempone"}},[_c('h2',{staticClass:"h4"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('div',{staticClass:"c-selector-filter__input"},[_c('fieldset',[_c('legend',{staticClass:"sr-only",attrs:{"aria-labelledby":"tempone","id":"YouthOpportunities"}},[_vm._v("\n            Switch for youth opportunities.\n            ")]),_vm._v(" "),_c('aha-switch-input',{attrs:{"value":_vm.enabled,"on-text":_vm.onText,"off-text":_vm.offText,"name":_vm.name,"isChecked":_vm.checked,"aria-describedby":"YouthOpportunities"},on:{"change":_vm.changed}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df00de10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_viewer_vue__ = __webpack_require__(920);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df00de10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_viewer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_c('div',{ref:"wrapper",class:_vm.contentStyle},[_vm._l((_vm.items),function(item,i){return _c('div',{key:("selectionCard-" + i),staticClass:"c-card-viewer__item"},[_c('aha-selection-card',_vm._b({},'aha-selection-card',Object.assign({}, _vm.cardOptions, item),false)),_vm._v(" "),(_vm.isList)?_c('div',{staticClass:"c-selection-card-details"},[_c('div',{staticClass:"h3"},[_vm._v(_vm._s(item.mediaTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.mediaText))]),_vm._v(" "),_c('div',{staticClass:"card-media-container"},[(item.mediaLink)?_c('div',{staticClass:"card-media",class:item.downloadLink  ? 'card-media--border' : ''},[_c('a',{staticClass:"btn--vol-media-play",class:item.mediaLinkClass,attrs:{"href":item.mediaLink,"target":item.mediaLinkTarget,"tabindex":"0"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Play "),_c('span',{domProps:{"innerHTML":_vm._s(item.mediaLinkDescription)}})])]),_vm._v(" "),_c('div',[(item.mediaLinkDescription)?_c('div',{staticClass:"info small",domProps:{"innerHTML":_vm._s(item.mediaLinkDescription)}}):_vm._e()])]):_vm._e(),_vm._v(" "),(item.downloadLink)?_c('div',{staticClass:"card-action"},[_c('a',{staticClass:"btn btn-round btn-outline-primary",class:item.downloadLinkClass,attrs:{"href":item.downloadLink,"target":item.downloadLinkTarget}},[_vm._v(_vm._s(item.downloadButtonText))])]):_vm._e()])]):_vm._e()],1)}),_vm._v(" "),(!_vm.items)?_c('div',[_vm._t("default",null,{"items":_vm.items,"count":_vm.count})],2):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_text_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_text_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_text_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_text_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_text_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c60b71aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_viewer_text_vue__ = __webpack_require__(922);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_text_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c60b71aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_viewer_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"content"},[_vm._t("default",null,{"count":_vm.count,"items":_vm.selectedItems})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_masked_input_vue__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_masked_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_masked_input_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_masked_input_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_masked_input_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d0cb2c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_masked_input_vue__ = __webpack_require__(927);
function injectStyle (ssrContext) {
  __webpack_require__(924)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_masked_input_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d0cb2c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_masked_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(925);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("a1213f08", content, true, {});

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 926 */,
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('masked-input',{class:_vm.styleClass,attrs:{"type":"text","name":_vm.name,"mask":['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],"guide":true},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_cpr_search_course_wrapper_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_cpr_search_course_wrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_cpr_search_course_wrapper_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_cpr_search_course_wrapper_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_cpr_search_course_wrapper_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_cpr_search_course_wrapper_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_science_volunteer_modal_vue__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_science_volunteer_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_science_volunteer_modal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_science_volunteer_modal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_science_volunteer_modal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7004132e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_science_volunteer_modal_vue__ = __webpack_require__(930);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_science_volunteer_modal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7004132e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_science_volunteer_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-science-volunteer-modal"},[(_vm.modalData.isVolunteer)?_c('div',[_c('aha-modal',{ref:"phdScienceVolunteerModal",attrs:{"id":"phdScienceVolunteerModal","size":"md","hide-footer":"","hide-header":"","centered":"","lazy":""}},[(_vm.modalData.title)?_c('h2',{staticClass:"mb-4",domProps:{"innerHTML":_vm._s(_vm.modalData.title)}}):_vm._e(),_vm._v(" "),_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'phdScienceVolunteerModal', $event.target)}}},[_vm._v("×")]),_vm._v(" "),(_vm.modalData.message)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.modalData.message)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-around mt-4"},[(_vm.modalData.yesRedirect)?_c('a',{staticClass:"btn btn-round btn-primary",attrs:{"href":_vm.modalData.yesRedirect},domProps:{"innerHTML":_vm._s(_vm.modalData.yesLabel)}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-round btn-dark",domProps:{"innerHTML":_vm._s(_vm.modalData.noLabel)},on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'phdScienceVolunteerModal', $event.target)}}})])],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_newsletter_ajax_thank_you_vue__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_newsletter_ajax_thank_you_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_newsletter_ajax_thank_you_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_newsletter_ajax_thank_you_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_newsletter_ajax_thank_you_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36e3d14c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_newsletter_ajax_thank_you_vue__ = __webpack_require__(934);
function injectStyle (ssrContext) {
  __webpack_require__(932)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36e3d14c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_newsletter_ajax_thank_you_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36e3d14c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_newsletter_ajax_thank_you_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(933);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("00037ce1", content, true, {});

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".fade-enter-active[data-v-36e3d14c],.fade-leave-active[data-v-36e3d14c]{-webkit-transition:opacity .5s;transition:opacity .5s}.fade-enter[data-v-36e3d14c],.fade-leave-to[data-v-36e3d14c]{opacity:.5}", ""]);

// exports


/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-newsletter-ajax"},[_c('aha-modal',{ref:"loadingModal",staticClass:"c-loadingModal",attrs:{"size":"md","id":"loadingModal","hide-footer":"","hide-header-close":"","no-close-on-esc":"","no-close-on-backdrop":"","centered":"","lazy":""}},[_c('template',{slot:"modal-header"},[_c('div',{staticClass:"c-loadingModal__heading"},[_vm._v("Submitting")])]),_vm._v(" "),_c('aha-loading-spinner',{attrs:{"is-loading":true}})],2),_vm._v(" "),(_vm.showError)?_c('div',{staticClass:"alert alert-danger"},[_vm._v("\n        "+_vm._s(_vm.errorMsg)+"\n    ")]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.toggleShow)?_vm._t("newsletter",null,{"resetForm":_vm.resetForm,"formData":_vm.formData,"submitForm":_vm.submitForm,"response":_vm.response,"toggleShow":_vm.toggleShow}):_vm._t("thankyou",null,{"toggleShow":_vm.toggleShow})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_sitecore_form_wrapper_vue__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_sitecore_form_wrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_sitecore_form_wrapper_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_sitecore_form_wrapper_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_sitecore_form_wrapper_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aa2e352_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_sitecore_form_wrapper_vue__ = __webpack_require__(938);
function injectStyle (ssrContext) {
  __webpack_require__(936)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_sitecore_form_wrapper_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aa2e352_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_sitecore_form_wrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(937);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("65955afc", content, true, {});

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".loader{font-size:8px;position:relative;text-indent:-9999em;border-top:.75em solid pink;border-right:.75em solid pink;border-bottom:.75em solid pink;border-left:.75em solid #c10e21;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation:load8 1.1s infinite linear;animation:load8 1.1s infinite linear}.loader,.loader:after{border-radius:50%;width:5em;height:5em}", ""]);

// exports


/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aha-sc-form-container",attrs:{"id":_vm.uuid}},[_vm._m(0),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d07ce87_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_carousel_vue__ = __webpack_require__(940);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d07ce87_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_carousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"carousel",attrs:{"id":"myCarousel","aria-roledescription":"carousel","aria-label":"Highlighted television shows"}},[_c('div',{staticClass:"carousel-inner"},[_c('div',{staticClass:"controls"},[_c('button',{staticClass:"rotation pause",attrs:{"type":"button","aria-label":"Stop automatic slide show"}},[_c('svg',{attrs:{"width":"42","height":"34","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{staticClass:"background",attrs:{"x":"2","y":"2","rx":"5","ry":"5","width":"38","height":"24"}}),_vm._v(" "),_c('rect',{staticClass:"border",attrs:{"x":"4","y":"4","rx":"5","ry":"5","width":"34","height":"20"}}),_vm._v(" "),_c('polygon',{staticClass:"pause",attrs:{"points":"17 8 17 20"}}),_vm._v(" "),_c('polygon',{staticClass:"pause",attrs:{"points":"24 8 24 20"}}),_vm._v(" "),_c('polygon',{staticClass:"play",attrs:{"points":"15 8 15 20 27 14"}})])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"previous",attrs:{"type":"button","aria-controls":"myCarousel-items","aria-label":"Previous Slide"}},[_c('i',{staticClass:"icon-left-arrow"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"next",attrs:{"type":"button","aria-controls":"myCarousel-items","aria-label":"Next Slide"}},[_c('i',{staticClass:"icon-right-arrow"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-items",attrs:{"id":"myCarousel-items","aria-live":"off"}},[_c('div',{staticClass:"carousel-item active",attrs:{"role":"group","aria-roledescription":"slide","aria-label":"1 of 6"}},[_c('div',{staticClass:"col-md-5 mb-3 mb-md-0"},[_c('div',{staticClass:"carousel-image"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"//placeimg.com/360/240/any","alt":"","data-lazy-img-loading":"//placeimg.com/360/240/any"}})])]),_vm._v(" "),_c('div',{staticClass:"c-modal--youtube"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('h2',{staticClass:"h3"},[_vm._v("Nancy Williams")]),_vm._v(" "),_c('p',[_vm._v("\"Fusce pulvinar facilisis nisi, id imperdiet ipsum volutpat dapibus. Donec at felis a arcu ultricies dignissim. Sed tincidunt libero ac eleifend consequat. Mauris massa lectus, euismod at rutrum sed, pellentesque eget lectus. Etiam faucibus dui ut nibh dapibus suscipit. Nullam lacus tellus, varius vitae sapien sagittis, sodales blandit risus. Praesent dignissim sit amet sem eu efficitur. Curabitur eu arcu aliquet, ultricies libero nec, elementum justo.\"")]),_vm._v(" "),_c('a',{staticClass:"c-cta c-cta--arrow h-theme--aqua-alt",attrs:{"href":"#"}},[_vm._v("Read Her Story")])])]),_vm._v(" "),_c('div',{staticClass:"carousel-item",attrs:{"role":"group","aria-roledescription":"slide","aria-label":"2 of 6"}},[_c('div',{staticClass:"col-md-5 mb-3 mb-md-0"},[_c('div',{staticClass:"carousel-image"},[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"https://via.placeholder.com/150","alt":"Land's End in Cornwall"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('h2',{staticClass:"h3"},[_vm._v("Frank Williams")]),_vm._v(" "),_c('p',[_vm._v("\"Fusce pulvinar facilisis nisi, id imperdiet ipsum volutpat dapibus. Donec at felis a arcu ultricies dignissim. Sed tincidunt libero ac eleifend consequat. Mauris massa lectus, euismod at rutrum sed, pellentesque eget lectus. Etiam faucibus dui ut nibh dapibus suscipit. Nullam lacus tellus, varius vitae sapien sagittis, sodales blandit risus. Praesent dignissim sit amet sem eu efficitur. Curabitur eu arcu aliquet, ultricies libero nec, elementum justo.\"")]),_vm._v(" "),_c('a',{staticClass:"c-cta c-cta--arrow h-theme--aqua-alt",attrs:{"href":"#"}},[_vm._v("Read Her Story")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_list_vue__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_list_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_list_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_list_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70640b93_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_grocery_list_vue__ = __webpack_require__(942);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_list_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70640b93_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_grocery_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-grocery-list"},[_c('div',{staticClass:"d-flex flex-column flex-md-row justify-content-between"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length),expression:"items.length"}],staticClass:"view__container order-1 d-print-none"},[_c('ul',{staticClass:"filters list-unstyled list-inline"},[_vm._m(0),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('button',{staticClass:"btn",on:{"click":function($event){_vm.visibility = 'all'; _vm.showFilterBtnStyle()}}},[_vm._v("All")])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('button',{staticClass:"btn",on:{"click":function($event){_vm.visibility = 'active'; _vm.showFilterBtnStyle()}}},[_vm._v("Active")])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('button',{staticClass:"btn",on:{"click":function($event){_vm.visibility = 'completed'; _vm.showFilterBtnStyle()}}},[_vm._v("Completed")])])])]),_vm._v(" "),_c('div',{staticClass:"h3 mt-3"},[_vm._v("Items:"),_c('aha-grocery-count')],1)]),_vm._v(" "),_vm._t("header"),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length === 0),expression:"items.length === 0"}]},[_vm._t("error",function(){return [_c('h2',{staticClass:"text-primary"},[_vm._v("No items found.")])]})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length),expression:"items.length"}],staticClass:"c-grocery-list__container"},[_c('div',{staticClass:"completed__container d-flex justify-content-between d-print-none"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allDone),expression:"allDone"}],staticClass:"toggle-all",attrs:{"type":"checkbox","id":"toggle-all"},domProps:{"checked":Array.isArray(_vm.allDone)?_vm._i(_vm.allDone,null)>-1:(_vm.allDone)},on:{"change":function($event){var $$a=_vm.allDone,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.allDone=$$a.concat([$$v]))}else{$$i>-1&&(_vm.allDone=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.allDone=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"toggle-all"},on:{"click":_vm.checkAll}},[_vm._v(_vm._s(_vm.checked))]),_vm._v(" "),_c('button',{staticClass:"btn clear-completed",on:{"click":function($event){$event.preventDefault();return _vm.removeCompleted.apply(null, arguments)}}},[_vm._v("Clear Completed")])]),_vm._v(" "),_c('ul',{staticClass:"grocery-list list-unstyled"},_vm._l((_vm.filteredItems),function(item){return _c('li',{key:item.id,class:{completed: item.completed}},[_c('div',{staticClass:"view"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.completed),expression:"item.completed"}],staticClass:"toggle",attrs:{"id":item.id,"type":"checkbox"},domProps:{"checked":Array.isArray(item.completed)?_vm._i(item.completed,null)>-1:(item.completed)},on:{"click":_vm.checkAllItems,"change":function($event){var $$a=item.completed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "completed", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "completed", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "completed", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":item.id}},[_vm._v(_vm._s(item.ProductName))]),_vm._v(" "),_c('button',{staticClass:"destroy d-print-none",on:{"click":function($event){return _vm.removeItem(item)}}})])])}),0)])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-inline-item"},[_c('span',[_vm._v("View:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_count_vue__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_count_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_count_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_count_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_count_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdfbb23c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_grocery_count_vue__ = __webpack_require__(944);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_count_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdfbb23c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_grocery_count_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n    "+_vm._s(_vm.count)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filter = undefined;

var _pluralize = __webpack_require__(946);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var filter = exports.filter = function filter(value, number) {
    return (0, _pluralize2['default'])(value, number);
};
exports['default'] = filter;

/***/ }),
/* 946 */,
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaUtils = __webpack_require__(70);

var state = new WeakMap();
var resizeEvent = 'resize';

exports['default'] = {
    bind: function bind(el) {
        state.set(el, {
            resizeEventListener: null
        });
    },
    inserted: function inserted(el, directive, vnode) {
        var data = state.get(el);
        var resizeEventHandler = (0, _ahaUtils.debounce)(function () {
            // hardcoding for now unless we find another use-case
            if (window.innerWidth < 992) {
                el.style.top = 'auto';
                el.style.marginTop = 'auto';
            } else {
                el.style.top = '50%';
                el.style.marginTop = '-' + el.clientHeight / 2 + 'px';
            }
        }, 50);

        data.resizeEventListener = resizeEventHandler;
        window.addEventListener(resizeEvent, resizeEventHandler);
        resizeEventHandler();

        vnode.context.$on('v-vertical-align-reset', function () {
            resizeEventHandler();
        });
    },
    unbind: function unbind(el) {
        var data = state.get(el);

        window.removeEventListener(resizeEvent, data.resizeEventListener);
    }
};

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LazyImgInitial = 'is-loading';
var LazyImgLoaded = 'is-loaded';

exports['default'] = {
    inserted: function inserted(el, binding) {
        var img = new Image();

        el.setAttribute('data-lazy-img-loading', binding.value);
        el.classList.add(LazyImgInitial);

        img.src = binding.value;

        img.onload = function () {
            el.src = binding.value;

            el.classList.remove(LazyImgInitial);
            el.classList.add(LazyImgLoaded);
        };
    }
};

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _inputEventbus = __webpack_require__(45);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    inserted: function inserted(el, binding) {
        var isChecked = false;

        el.setAttribute('role', 'checkbox');
        el.setAttribute('aria-checked', 'false');
        el.setAttribute('tabindex', 0);

        el.addEventListener('click', function () {
            toggleChecked();
        });

        el.addEventListener('keypress', function (evt) {
            if (evt.keyCode === 13) {
                toggleChecked();
            }
        });

        function toggleChecked() {
            isChecked = !isChecked;
            el.classList.toggle('is-checked');

            el.setAttribute('aria-checked', isChecked.toString());
            if (binding.modifiers.event) {
                _inputEventbus2['default'].$emit('toggle-checked', el.value, el.id, el);
            }
        }
    }
};

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    inserted: function inserted(el) {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            this.classList.toggle('active');
        });
    }
};

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaUtils = __webpack_require__(70);

var _perfectScrollbar = __webpack_require__(952);

var _perfectScrollbar2 = _interopRequireDefault(_perfectScrollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var state = new WeakMap();
var resizeEvent = 'resize';

exports['default'] = {
    bind: function bind(el) {
        state.set(el, {
            resizeEventListener: null,
            scrollbar: null
        });
    },
    inserted: function inserted(el, directive, vnode) {
        var data = state.get(el);

        var resizeEventHandler = (0, _ahaUtils.debounce)(function () {
            if (window.outerWidth >= 576 && data.scrollbar === null) {
                data.scrollbar = new _perfectScrollbar2['default'](el, {
                    suppressScrollY: true,
                    wheelPropagation: true,
                    wheelSpeed: 0.4
                });
            }

            if (window.outerWidth < 576 && data.scrollbar !== null) {
                data.scrollbar.destroy();
            }
        }, 100);

        data.resizeEventListener = resizeEventHandler;

        window.addEventListener(resizeEvent, resizeEventHandler);
        resizeEventHandler();
    },
    unbind: function unbind(el) {
        var data = state.get(el);

        window.removeEventListener(resizeEvent, data.resizeEventListener);

        if (data.scrollbar !== null) {
            data.scrollbar.destroy();
            data.scrollbar = null; // to make sure garbages are collected
        }
    }
};

/***/ }),
/* 952 */,
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    inserted: function inserted(el, binding) {
        var url = el.getAttribute('href');

        el.addEventListener('click', function (event) {
            event.preventDefault();
            window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=585,height=511');
        });
    }
};

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(22);

exports['default'] = {
    bind: function bind(el, binding, vnode) {
        var targetHref = void 0;
        var isModalShowing = false;

        if (el.tagName === 'A') {
            targetHref = el.getAttribute('href');
        } else {
            targetHref = el.getAttribute('target-href');
            el.setAttribute('tabindex', '0');
        }

        el.addEventListener('click', function (evt) {
            evt.preventDefault();

            isModalShowing = true;
            vnode.context.$root.$emit('bv::show::modal', binding.value, vnode.elm);
        });

        el.addEventListener('keypress', function (evt) {
            evt.preventDefault();

            if (evt.keyCode === _utils.KeyCodes.ENTER) {
                isModalShowing = true;
                vnode.context.$root.$emit('bv::show::modal', binding.value, vnode.elm);
            }
        });

        vnode.context.$root.$on('bv::modal::show', function (evt) {
            if (isModalShowing) {
                if (window.activeSpeedBumpLink) {
                    var speedBumpLink = document.querySelector('#speed-bump-link');

                    setModalContent(evt.vueTarget.$vnode.context.$refs, speedBumpLink.getAttribute('href'));
                } else {
                    setModalContent(evt.vueTarget.$vnode.context.$refs, targetHref);
                }
            }
        });

        vnode.context.$root.$on('bv::modal::hide', function (evt) {
            if (isModalShowing) {
                isModalShowing = false;
                setModalContent(evt.vueTarget.$vnode.context.$refs, '');
            }
        });

        vnode.context.$root.$on('bv::modal::hidden', function (evt) {
            if (window.activeSpeedBumpLink) {
                window.activeSpeedBumpLink.focus();
                window.activeSpeedBumpLink = null;
            }
        });

        if (el.tagName !== 'BUTTON') {
            // If element is not a button, we add `role="button"` for accessibility
            el.setAttribute('role', 'button');
        }

        function setModalContent(refs, value) {
            var text = refs['speed-bump-text'];
            var href = refs['speed-bump-link'];

            if (text) {
                if (value.length > 120) {
                    text.innerHTML = value.substring(0, 120) + '...';
                } else {
                    text.innerHTML = value;
                }
            }

            if (href) {
                href.setAttribute('href', value);

                href.addEventListener('click', function () {
                    setTimeout(function () {
                        vnode.context.$root.$emit('bv::hide::modal', 'speed-bump-modal');
                    }, 250);
                });
            }
        }
    }
};

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(22);

var _tlsAvailable = __webpack_require__(956);

exports['default'] = {
    bind: function bind(el, binding, vnode) {
        var targetHref = void 0;
        var isModalShowing = false;

        el.addEventListener('click', function (evt) {
            targetHref = el.getAttribute('href');

            if (!(0, _tlsAvailable.isTlsAvailable)() && targetHref.match(/sso\.heart\.org/)) {
                evt.preventDefault();

                isModalShowing = true;
                vnode.context.$root.$emit('bv::show::modal', binding.value, vnode.elm);
            }
        });

        el.addEventListener('keypress', function (evt) {
            evt.preventDefault();

            if (evt.keyCode === _utils.KeyCodes.ENTER) {
                isModalShowing = true;
                vnode.context.$root.$emit('bv::show::modal', binding.value, vnode.elm);
            }
        });

        vnode.context.$root.$on('bv::modal::hide', function (evt) {
            if (isModalShowing) {
                isModalShowing = false;
            }
        });

        vnode.context.$root.$on('bv::modal::hidden', function (evt) {
            if (window.activeSssoIntercept) {
                window.activeSssoIntercept.focus();
                window.activeSssoIntercept = null;
            }
        });

        if (el.tagName !== 'BUTTON') {
            // If element is not a button, we add `role="button"` for accessibility
            el.setAttribute('role', 'button');
        }
    }
};

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isTlsAvailable = isTlsAvailable;

var _ahaUtils = __webpack_require__(70);

function isTlsAvailable() {
    var browser = (0, _ahaUtils.browserDetails)();
    var isSecure = true;

    switch (browser.name) {
        case 'Chrome':
            if (browser.mobile) {
                if (browser.version < 4.1) {
                    isSecure = false;
                }
            } else {
                if (browser.version < 31) {
                    isSecure = false;
                }
            }

            break;

        case 'Safari':
            if (browser.mobile) {
                if (browser.version < 5) {
                    isSecure = false;
                }
            } else {
                if (browser.version < 7) {
                    isSecure = false;
                }
            }

            break;

        case 'MSIE':
            if (browser.mobile) {
                if (browser.version < 10) {
                    isSecure = false;
                }
            } else {
                if (browser.version < 10) {
                    isSecure = false;
                }
            }

            break;

        case 'Opera':
            if (browser.version < 10) {
                isSecure = false;
            }

            break;

        case 'Firefox':
            if (browser.version < 24) {
                isSecure = false;
            }

            break;
    }

    return isSecure;
}

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _printd = __webpack_require__(958);

exports['default'] = {
    inserted: function inserted(el, binding) {
        el.addEventListener('click', function (evt) {
            evt.preventDefault();

            var printElement = document.getElementById(binding.value);
            var d = new _printd.Printd();

            // Styling to enable background graphics on printed grocery list so that user can see checkboxes
            var cssText = '\n                #grocery-list-print-section {\n                    -webkit-print-color-adjust: exact !important;   /* Chrome, Safari */\n                    color-adjust: exact !important;                 /*Firefox*/\n                }\n            ';

            var styles = ['https://www.heart.org/dist/common/app.css', 'https://www.heart.org/dist/common/vendor.css', cssText];
            d.print(printElement, styles);
        });
    }
};

/***/ }),
/* 958 */,
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _registerEvent = __webpack_require__(153);

var _registerEvent2 = _interopRequireDefault(_registerEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    inserted: function inserted(el, binding) {
        var itemId = el.getAttribute('event-item-id');
        var text = el.getAttribute('event-text');
        var datasourceId = el.getAttribute('event-datasource-id');

        el.addEventListener('click', function (evt) {
            _registerEvent2['default'].post(itemId, text, datasourceId);
        });
    }
};

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
/** Date: 4/7/2019*/
/*RQI form with 1 required checkboxes checked*/
exports['default'] = {
    inserted: function inserted(el, binding, vnode) {

        var forms = el;
        var button = forms.querySelector('[type=submit]');
        var required = forms.querySelectorAll('input[required="required"]');
        var telephone = forms.querySelectorAll('input[type="tel"]:required, [id^=phone]:required');
        var phoneFormat = RegExp(/^(\d{3})-(\d{3})-(\d{4})$/);
        var zipFormat = RegExp(/^\d{5}$|^\d{5}-\d{4}$/);
        button.disabled = true;

        forms.onsubmit = function (event) {
            // Safari fix
            event.preventDefault();
            if (vnode.context.$root.$el.querySelector('.c-loadingModal')) {
                vnode.context.$root.$emit('bv::show::modal', 'loadingModal');
            }
            // Safari fix
            setTimeout(function () {
                HTMLFormElement.prototype.submit.call(event.target);
                // forms.submit();
            }, 500);
        };

        var validateForm = function validateForm(el) {
            if (el && el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el && el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }

            if (forms.checkValidity() === false) {
                button.disabled = true;
            } else {
                button.disabled = false;
            }
        };

        // Email validation message
        var validateEmail = function validateEmail(el) {
            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && el.nextElementSibling.classList.contains('invalid-feedback')) {
                    el.nextElementSibling.classList.toggle('d-block');
                }
            }
            // email validation for doctor quiz 
        };

        // Telephone validation message
        var validatePhone = function validatePhone(el) {
            if (el.value.length === 0) {
                el.setCustomValidity('');
            }

            var isFormatted = phoneFormat.test(el.value);

            if (isFormatted) {
                el.setCustomValidity('');
            } else if (el.value.length > 0) {
                el.setCustomValidity('Please provide a valid Phone.');
            }

            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }
        };

        var validateZip = function validateZip(el) {
            var isFormatted = zipFormat.test(el.value);

            if (isFormatted) {
                el.setCustomValidity('');
            } else {
                el.setCustomValidity('Zipcode Required.');
            }

            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }
        };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            var _loop = function _loop() {
                var req = _step.value;

                req.addEventListener('change', function (evt) {
                    if (req.required === true) {
                        validateEmail(req);
                    }
                    validateForm();
                });
            };

            for (var _iterator = required[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _loop();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator['return']) {
                    _iterator['return']();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            var _loop2 = function _loop2() {
                var form = _step2.value;

                form.addEventListener('input', function (evt) {
                    if (form.required === true && form.value === '') {
                        form.setCustomValidity('Please provide a valid response.');
                    } else {
                        form.setCustomValidity('');
                    }
                    if (form.required === true && form.id.startsWith('zipcode')) {
                        validateZip(form);
                    }
                    // For non-required zip code in course search component
                    if (form.id === 'zipcode' && form.value.length > 0) {
                        validateZip(form);
                    }
                    validateForm(form);
                });

                form.addEventListener('blur', function (evt) {
                    if (form.required === true && form.value === '') {
                        form.setCustomValidity('Please provide a valid response.');
                    } else {
                        form.setCustomValidity('');
                    }
                    if (form.required === true && form.id.startsWith('zipcode')) {
                        validateZip(form);
                    }
                    // For non-required zip code in course search component
                    if (form.id === 'zipcode' && form.value.length > 0) {
                        validateZip(form);
                    }
                    validateForm(form);
                });

                form.addEventListener('change', function (evt) {
                    if (form.required === true && form.value === '') {
                        form.setCustomValidity('Please provide a valid response.');
                    } else if (form.required === true && form.value.length > 0) {
                        form.setCustomValidity('');
                    }
                    validateForm(form);
                });
            };

            for (var _iterator2 = forms[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _loop2();
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                    _iterator2['return']();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = telephone[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var tel = _step3.value;

                tel.addEventListener('blur', function (evt) {
                    validatePhone(evt.target);
                    validateForm();
                });
            }

            // Check form on load
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3['return']) {
                    _iterator3['return']();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        validateForm();
    }
};

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
/* Vue directive to validate all required fields with error messages */
exports['default'] = {
    inserted: function inserted(el, binding, vnode) {

        var forms = el;
        var button = forms.querySelector('[type=submit]');
        var required = forms.querySelectorAll('input[required="required"]');
        var telephone = forms.querySelectorAll('input[type="tel"], [id^=phone]');
        var phoneFormat = RegExp(/^(\d{3})-(\d{3})-(\d{4})$/);
        var zipFormat = RegExp(/^\d{5}$|^\d{5}-\d{4}$/);
        button.disabled = true;

        var validateForm = function validateForm(el) {
            if (el && el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el && el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }

            if (forms.checkValidity() === false) {
                button.disabled = true;
            } else {
                button.disabled = false;
            }
        };

        // Email validation message
        var validateEmail = function validateEmail(el) {
            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && el.nextElementSibling.classList.contains('invalid-feedback')) {
                    el.nextElementSibling.classList.toggle('d-block');
                }
            }
            // email validation for doctor quiz 
        };

        // Telephone validation message
        var validatePhone = function validatePhone(el) {
            if (el.value.length === 0) {
                el.setCustomValidity('');
            }

            var isFormatted = phoneFormat.test(el.value);

            if (isFormatted) {
                el.setCustomValidity('');
            } else if (el.value.length > 0) {
                el.setCustomValidity('Please provide a valid Phone.');
            }

            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }
        };

        var validateZip = function validateZip(el) {
            var isFormatted = zipFormat.test(el.value);

            if (isFormatted) {
                el.setCustomValidity('');
            } else {
                el.setCustomValidity('Zipcode Required.');
            }

            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }
        };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            var _loop = function _loop() {
                var req = _step.value;

                req.addEventListener('change', function (evt) {
                    if (req.required === true) {
                        validateEmail(req);
                    }
                    validateForm();
                });
            };

            for (var _iterator = required[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _loop();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator['return']) {
                    _iterator['return']();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            var _loop2 = function _loop2() {
                var form = _step2.value;

                form.addEventListener('input', function (evt) {
                    if (form.required === true && form.value === '') {
                        form.setCustomValidity('Please provide a valid response.');
                    } else {
                        form.setCustomValidity('');
                    }
                    if (form.required === true && form.id.startsWith('zipcode')) {
                        validateZip(form);
                    }
                    // For non-required zip code in course search component
                    if (form.id === 'zipcode' && form.value.length > 0) {
                        validateZip(form);
                    }
                    validateForm(form);
                });

                form.addEventListener('blur', function (evt) {
                    if (form.required === true && form.value === '') {
                        form.setCustomValidity('Please provide a valid response.');
                    } else {
                        form.setCustomValidity('');
                    }
                    if (form.required === true && form.id.startsWith('zipcode')) {
                        validateZip(form);
                    }
                    // For non-required zip code in course search component
                    if (form.id === 'zipcode' && form.value.length > 0) {
                        validateZip(form);
                    }
                    validateForm(form);
                });

                form.addEventListener('change', function (evt) {
                    if (form.required === true && form.value === '') {
                        form.setCustomValidity('Please provide a valid response.');
                    } else if (form.required === true && form.value.length > 0) {
                        form.setCustomValidity('');
                    }
                    validateForm(form);
                });
            };

            for (var _iterator2 = forms[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _loop2();
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                    _iterator2['return']();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = telephone[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var tel = _step3.value;

                tel.addEventListener('blur', function (evt) {
                    validatePhone(evt.target);
                    validateForm();
                });
            }

            // Check form on load
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3['return']) {
                    _iterator3['return']();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        validateForm();
    }
};

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
/** Date: 4/7/2019*/
/*RQI form with 1 required checkboxes checked*/
exports['default'] = {
    inserted: function inserted(el) {
        var button = el.querySelector('[type=submit]');
        var requiredEls = el.querySelectorAll('input:required,select:required');
        var requiredCheckboxes = el.querySelectorAll('input[type="checkbox"]');

        button.disabled = true;

        if (requiredEls.length > 0) {
            (function () {

                var checkFormValidity = function checkFormValidity() {

                    var isFormValid = false;

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = requiredEls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var requiredEl = _step.value;

                            if (requiredEl.validity.valid === true && checkBoxesValidation() !== false) {
                                isFormValid = true;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator['return']) {
                                _iterator['return']();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    button.disabled = !isFormValid;
                };

                // ---

                var checkBoxesValidation = function checkBoxesValidation() {
                    var checkedOne = Array.prototype.slice.call(requiredCheckboxes).some(function (x) {
                        return x.checked;
                    });
                    return checkedOne;
                };

                // ---

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = requiredEls[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var requiredEl = _step2.value;

                        requiredEl.addEventListener('input', function (evt) {
                            checkFormValidity();
                        });
                    }

                    // ---
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                            _iterator2['return']();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = requiredCheckboxes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var cb = _step3.value;

                        cb.addEventListener('change', function (evt) {
                            checkFormValidity();
                        });
                    }

                    // Check form on load
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
                            _iterator3['return']();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                checkFormValidity();
            })();
        }
    }
};

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
exports['default'] = {
    bind: function bind(el) {
        el.addEventListener('click', function (e) {
            var buttonClicked = e.target;
            // get the value of the data attribute of the button clicked and store it in a variable for later use
            var buttonClickedValue = buttonClicked.getAttribute('aria-expanded');
            // get the value of the data attribute of the button collapse text
            var buttonCollapseTextValue = buttonClicked.getAttribute('data-collapse-text');
            // get the value of the data attribute of the button expand text
            var buttonExpandTextValue = buttonClicked.getAttribute('data-expand-text');
            // get the content element that is related to the button clicked and has the class fixed-image and store it in a variable for later use
            var contentElementFixedImage = e.target.parentElement;
            // // get the parent element of contentElementFixedImage and store it in a variable for later use
            var contentElement = contentElementFixedImage.parentElement;
            // //get the parent element of contentElement and store it in a variable for later use
            var contentElementParent = contentElement.parentElement;
            // // get the sibling element of contentElementParent and store it in a variable for later use
            var contentElementSibling = contentElementParent.parentElement;
            // get the content element that has the class fixed-image and store it in a variable for later use
            var contentElementFixedImageSibling = contentElementSibling.querySelector('.image-fixed');
            // console.log(contentElementSibling)

            //if the value of the data attribute is false, change it to true and vice versa
            if (buttonClickedValue === 'false') {
                //the set attribute has been removed per the request of the accessibility team
                buttonClicked.setAttribute('aria-expanded', 'true');
                //get the content element that is related to the button clicked and change the class to show it
                var _contentElement = buttonClicked.previousElementSibling;
                _contentElement.classList.add('show');
                //add class 'expanded-text' to c-promo
                contentElementParent.classList.add('expanded-text');
                //change the text of the button to 'Expand to see more'
                buttonClicked.innerHTML = buttonCollapseTextValue || 'Collapse to see less';

                //if the window is greater than 992px wide add styling to the contentElementFixedImageSibling position of sticky and top of 50px
                if (window.innerWidth > 425 && buttonClickedValue === 'false') {
                    // contentElementFixedImageSibling.style.position = 'sticky';
                    // contentElementFixedImageSibling.style.top = '70px';
                    contentElementFixedImageSibling.classList.add('img-expanded-pos');
                }
            } else {
                //the set attribute has been removed per the request of the accessibility team
                buttonClicked.setAttribute('aria-expanded', 'false');
                //get the content element that is related to the button clicked and change the class to hide it
                var _contentElement2 = buttonClicked.previousElementSibling;
                _contentElement2.classList.remove('show');
                //remove class 'expanded-text' from .c-promo
                contentElementParent.classList.remove('expanded-text');
                buttonClicked.innerHTML = buttonExpandTextValue || 'Expand to see more';

                //if the window is greater than 992px wide add styling to the contentElementFixedImageSibling position of sticky and top of 50px
                if (window.innerWidth > 425 && buttonClickedValue === 'true') {
                    // contentElementFixedImageSibling.style.position = 'relative';
                    // contentElementFixedImageSibling.style.top = '0px';
                    contentElementFixedImageSibling.classList.remove('img-expanded-pos');
                }

                contentElementSibling.scrollIntoView({ block: "start", behavior: "smooth" });
            }
        });
    }
};

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
 *   File:   carousel-prev-next.js
 *
 *   Desc:   Carousel widget with Previous and Next Buttons that implements ARIA Authoring Practices
 *
 */

var CarouselPreviousNext = function CarouselPreviousNext(node, options) {
    // merge passed options with defaults
    options = _extends({ moreaccessible: false, paused: false, norotate: true }, options || {});

    // a prefers-reduced-motion user setting must always override autoplay
    var hasReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (hasReducedMotion.matches) {
        options.paused = true;
    }

    /* DOM properties */
    this.domNode = node;

    this.carouselItemNodes = node.querySelectorAll('.carousel-item');

    this.containerNode = node.querySelector('.carousel-items');
    this.liveRegionNode = node.querySelector('.carousel-items');
    this.pausePlayButtonNode = null;
    this.previousButtonNode = null;
    this.nextButtonNode = null;

    this.playLabel = 'Start automatic slide show';
    this.pauseLabel = 'Stop automatic slide show';

    /* State properties */
    this.hasUserActivatedPlay = false; // set when the user activates the play/pause button
    this.isAutoRotationDisabled = options.norotate; // This property for disabling auto rotation
    this.isPlayingEnabled = !options.paused; // This property is also set in updatePlaying method
    this.timeInterval = 5000; // length of slide rotation in ms
    this.currentIndex = 0; // index of current slide
    this.slideTimeout = null; // save reference to setTimeout

    // Pause Button

    var elem = document.querySelector('.controls button.rotation');
    if (elem) {
        this.pausePlayButtonNode = elem;
        this.pausePlayButtonNode.addEventListener('click', this.handlePausePlayButtonClick.bind(this));
    }

    // Previous Button

    elem = document.querySelector('.controls button.previous');
    if (elem) {
        this.previousButtonNode = elem;
        this.previousButtonNode.addEventListener('click', this.handlePreviousButtonClick.bind(this));
        this.previousButtonNode.addEventListener('focus', this.handleFocusIn.bind(this));
        this.previousButtonNode.addEventListener('blur', this.handleFocusOut.bind(this));
    }

    // Next Button

    elem = document.querySelector('.controls button.next');
    if (elem) {
        this.nextButtonNode = elem;
        this.nextButtonNode.addEventListener('click', this.handleNextButtonClick.bind(this));
        this.nextButtonNode.addEventListener('focus', this.handleFocusIn.bind(this));
        this.nextButtonNode.addEventListener('blur', this.handleFocusOut.bind(this));
    }

    // Carousel item events

    for (var i = 0; i < this.carouselItemNodes.length; i++) {
        var carouselItemNode = this.carouselItemNodes[i];

        // support stopping rotation when any element receives focus in the tabpanel
        carouselItemNode.addEventListener('focusin', this.handleFocusIn.bind(this));
        carouselItemNode.addEventListener('focusout', this.handleFocusOut.bind(this));

        var imageLinkNode = carouselItemNode.querySelector('.carousel-image a');

        if (imageLinkNode) {
            imageLinkNode.addEventListener('focus', this.handleImageLinkFocus.bind(this));
            imageLinkNode.addEventListener('blur', this.handleImageLinkBlur.bind(this));
        }
    }

    // Handle hover events
    this.domNode.addEventListener('mouseover', this.handleMouseOver.bind(this));
    this.domNode.addEventListener('mouseout', this.handleMouseOut.bind(this));

    // initialize behavior based on options

    this.enableOrDisableAutoRotation(options.norotate);
    this.updatePlaying(!options.paused && !options.norotate);
    this.setAccessibleStyling(options.moreaccessible);
    this.rotateSlides();
};

/* Public function to disable/enable rotation and if false, hide pause/play button */
CarouselPreviousNext.prototype.enableOrDisableAutoRotation = function (disable) {
    this.isAutoRotationDisabled = disable;
    this.pausePlayButtonNode.hidden = disable;
};

/* Public function to update controls/caption styling */
CarouselPreviousNext.prototype.setAccessibleStyling = function (accessible) {
    if (accessible) {
        this.domNode.classList.add('carousel-moreaccessible');
    } else {
        this.domNode.classList.remove('carousel-moreaccessible');
    }
};

CarouselPreviousNext.prototype.showCarouselItem = function (index) {
    this.currentIndex = index;

    for (var i = 0; i < this.carouselItemNodes.length; i++) {
        var carouselItemNode = this.carouselItemNodes[i];
        if (index === i) {
            carouselItemNode.classList.add('active');
        } else {
            carouselItemNode.classList.remove('active');
        }
    }
};

CarouselPreviousNext.prototype.previousCarouselItem = function () {
    var nextIndex = this.currentIndex - 1;
    if (nextIndex < 0) {
        nextIndex = this.carouselItemNodes.length - 1;
    }
    this.showCarouselItem(nextIndex);
};

CarouselPreviousNext.prototype.nextCarouselItem = function () {
    var nextIndex = this.currentIndex + 1;
    if (nextIndex >= this.carouselItemNodes.length) {
        nextIndex = 0;
    }
    this.showCarouselItem(nextIndex);
};

CarouselPreviousNext.prototype.rotateSlides = function () {
    if (!this.isAutoRotationDisabled) {
        if (!this.hasFocus && !this.hasHover && this.isPlayingEnabled || this.hasUserActivatedPlay) {
            this.nextCarouselItem();
        }
    }

    this.slideTimeout = setTimeout(this.rotateSlides.bind(this), this.timeInterval);
};

CarouselPreviousNext.prototype.updatePlaying = function (play) {
    this.isPlayingEnabled = play;

    if (play) {
        this.pausePlayButtonNode.setAttribute('aria-label', this.pauseLabel);
        this.pausePlayButtonNode.classList.remove('play');
        this.pausePlayButtonNode.classList.add('pause');
        this.liveRegionNode.setAttribute('aria-live', 'off');
    } else {
        this.pausePlayButtonNode.setAttribute('aria-label', this.playLabel);
        this.pausePlayButtonNode.classList.remove('pause');
        this.pausePlayButtonNode.classList.add('play');
        this.liveRegionNode.setAttribute('aria-live', 'polite');
    }
};

/* Event Handlers */

CarouselPreviousNext.prototype.handleImageLinkFocus = function () {
    this.liveRegionNode.classList.add('focus');
};

CarouselPreviousNext.prototype.handleImageLinkBlur = function () {
    this.liveRegionNode.classList.remove('focus');
};

CarouselPreviousNext.prototype.handleMouseOver = function (event) {
    if (!this.pausePlayButtonNode.contains(event.target)) {
        this.hasHover = true;
    }
};

CarouselPreviousNext.prototype.handleMouseOut = function () {
    this.hasHover = false;
};

/* EVENT HANDLERS */

CarouselPreviousNext.prototype.handlePausePlayButtonClick = function () {
    this.hasUserActivatedPlay = !this.isPlayingEnabled;
    this.updatePlaying(!this.isPlayingEnabled);
};

CarouselPreviousNext.prototype.handlePreviousButtonClick = function () {
    this.previousCarouselItem();
};

CarouselPreviousNext.prototype.handleNextButtonClick = function () {
    this.nextCarouselItem();
};

/* Event Handlers for carousel items */

CarouselPreviousNext.prototype.handleFocusIn = function () {
    this.liveRegionNode.setAttribute('aria-live', 'polite');
    this.hasFocus = true;
};

CarouselPreviousNext.prototype.handleFocusOut = function () {
    if (this.isPlayingEnabled) {
        this.liveRegionNode.setAttribute('aria-live', 'off');
    }
    this.hasFocus = false;
};

/* Initialize Carousel and options */

window.addEventListener('load', function () {
    var carouselEls = document.querySelectorAll('.carousel');
    var carousels = [];

    // set example behavior based on
    // default setting of the checkboxes and the parameters in the URL
    // update checkboxes based on any corresponding URL parameters
    var checkboxes = document.querySelectorAll('.carousel-options input[type=checkbox]');
    var urlParams = new URLSearchParams(this.location.search);
    var carouselOptions = {};

    // initialize example features based on
    // default setting of the checkboxes and the parameters in the URL
    // update checkboxes based on any corresponding URL parameters
    checkboxes.forEach(function (checkbox) {
        var checked = checkbox.checked;

        if (urlParams.has(checkbox.value)) {
            var urlParam = urlParams.get(checkbox.value);
            if (typeof urlParam === 'string') {
                checked = urlParam === 'true';
                checkbox.checked = checked;
            }
        }

        carouselOptions[checkbox.value] = checkbox.checked;
    });

    carouselEls.forEach(function (node) {
        carousels.push(new CarouselPreviousNext(node, carouselOptions));
    });

    // add change event to checkboxes
    checkboxes.forEach(function (checkbox) {
        var updateEvent;
        switch (checkbox.value) {
            case 'moreaccessible':
                updateEvent = 'setAccessibleStyling';
                break;
            case 'norotate':
                updateEvent = 'enableOrDisableAutoRotation';
                break;
        }

        // update the carousel behavior and URL when a checkbox state changes
        checkbox.addEventListener('change', function (event) {
            urlParams.set(event.target.value, event.target.checked + '');
            window.history.replaceState(null, '', window.location.pathname + '?' + urlParams);

            if (updateEvent) {
                carousels.forEach(function (carousel) {
                    carousel[updateEvent](event.target.checked);
                });
            }
        });
    });
}, false);

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
/** Date: 10/2/2020*/

// import { valueOf } from "core-js/fn/_";

/* luminate donation form  */
exports['default'] = {
    inserted: function inserted(el) {
        var button = el.querySelector("[type=submit]");
        var amountRadios = el.querySelectorAll('input[name="amount_select"]');
        var otherAmount = el.querySelector('input[name="amount_other"]');
        var amount = el.querySelector('input[name="amount"]');
        var donationDiv = el.querySelector("#donation");
        var errorMessage = document.querySelector(".error-message");
        var spinner = document.createElement('span');
        spinner.classList.add('spinner-border', 'spinner-border-sm');
        spinner.setAttribute('role', 'status');
        spinner.setAttribute('aria-hidden', 'true');
        button.classList.add('has-spinner');

        // ON SUBMIT - APPEND FREQUENCY AND AMOUNT TO FORM ACTION 
        el.onsubmit = function (e) {
            var frequencyValue = el.querySelector('input[name="frequency"]:checked').value;
            var amountValue = el.querySelector('input[name="amount"]').value;
            var action_src = el.action;
            action_src += "&amount=" + amountValue + "&frequency=" + frequencyValue;
            el.action = action_src;
            button.append(spinner);
            button.disabled = true; // only submit one time
        };

        function unselectAllAmountRadios() {
            Array.prototype.slice.call(amountRadios).forEach(function (radio) {
                radio.checked = false;
            });
        }

        function clearAmountOther() {
            otherAmount.value = "";
        }

        function setAmountHidden(val) {
            //for backend to get value amount either from radio or input text field
            if (val != "undefined") {
                amount.value = val;
            }
        }

        donationDiv.addEventListener("input", function (e) {
            // listens for input change
            switch (e.target.name) {
                case "amount_other":
                    unselectAllAmountRadios();
                    break;
                case "amount_select":
                    clearAmountOther();
                    break;
            }
            validateDonation();
        });

        function validateDonation() {
            var selected = document.querySelector('input[name="amount_select"]:checked');
            var selectedValue = selected ? selected.value : "";

            if (selectedValue.length >= 2 && otherAmount.value.length === 0) {
                button.disabled = false;
                errorMessage.style.display = "none";
                setAmountHidden(selectedValue);
            } else if (otherAmount.value > 9 && otherAmount.value < 50001) {
                button.disabled = false;
                errorMessage.style.display = "none";
                setAmountHidden(otherAmount.value);
            } else {
                button.disabled = true;
                errorMessage.style.display = "block";
                setAmountHidden("");
            }
        }

        // Run on page load
        validateDonation();
    }
};

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
exports['default'] = {
    inserted: function inserted(el) {

        var winWidth = window.innerWidth;
        var mobileWidth = 500;

        var getMaxHeight = function getMaxHeight() {
            var maxHeight = 0;
            var tabPanels = document.querySelectorAll('[role="tabpanel"]');
            console.log("panels: ", tabPanels.length);
            for (var i = 0; i < tabPanels.length; i++) {
                var elHeight = tabPanels[i].offsetHeight;
                console.log(i + ': ' + elHeight);
                if (elHeight > maxHeight) {
                    maxHeight = elHeight;
                }
            }
            return maxHeight;
        };

        var setMaxHeight = function setMaxHeight(height) {
            var tabPanels = document.querySelectorAll('[role="tabpanel"]');
            for (var i = 0; i < tabPanels.length; i++) {
                tabPanels[i].style.height = height + "px";
            }
        };

        var reportWindowSize = function reportWindowSize() {
            if (winWidth > mobileWidth) {
                setMaxHeight(getMaxHeight());
            }
        };

        console.log("width: ", winWidth);

        setTimeout(function () {
            if (winWidth > mobileWidth) {
                setMaxHeight(getMaxHeight());
            }
            window.addEventListener('resize', reportWindowSize);
        }, 500);
    }
};

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    bind: function bind(el, binding, vnode) {
        var nestedAccordionEl = el.querySelector('.js-nested-accordion');
        var expandAllBoolean = true;
        var accordionObserver = new window.MutationObserver(observerCallback);
        var toggleAllButton = el.querySelector('.nested-accordion__toggle-all');
        var hashId = window.location.href.split('#')[1] || '';
        var searchResultLinkedHeading = el.querySelector('button[aria-controls="' + hashId + '"]');
        var parentContainersArray = [];

        if (nestedAccordionEl) {
            accordionObserver.observe(nestedAccordionEl, {
                attributeFilter: ['aria-expanded'],
                attributes: true,
                subtree: true
            });
        }

        if (searchResultLinkedHeading) {
            var parentContainer = getClosest(searchResultLinkedHeading, '.nested-accordion__collapse');

            if (parentContainer) {
                while (parentContainer) {
                    if (parentContainer.previousElementSibling && parentContainer.previousElementSibling.classList && parentContainer.previousElementSibling.classList.contains('nested-accordion__toggle-button')) {
                        parentContainersArray.push(parentContainer.previousElementSibling);
                        parentContainer = getClosest(parentContainer.previousElementSibling, '.nested-accordion__collapse');
                    } else {
                        break;
                    }
                }

                if (parentContainersArray.length) {
                    var _loop = function _loop(i) {
                        setTimeout(function () {
                            parentContainersArray[i].click();
                        }, 10);
                    };

                    for (var i = 0; i < parentContainersArray.length; i++) {
                        _loop(i);
                    }
                }
            }

            searchResultLinkedHeading.click();
            searchResultLinkedHeading.scrollIntoView();
        }

        window.toggleNestedAccordions = function toggleNestedAccordions() {
            if (expandAllBoolean) {
                expandAll();

                if (toggleAllButton) {
                    toggleAllButton.innerHTML = 'Collapse All <span aria-hidden="true">&minus;</span>';
                }

                expandAllBoolean = false;
            } else {
                collapseAll();

                if (toggleAllButton) {
                    toggleAllButton.innerHTML = 'Expand All <span aria-hidden="true">&plus;</span>';
                }

                expandAllBoolean = true;
            }
        };

        function expandAll() {
            var buttonList = el.querySelectorAll('.js-nested-accordion button.nested-accordion__toggle-button');

            for (var i = 0; i < buttonList.length; i++) {
                if (buttonList[i].attributes.getNamedItem('aria-expanded').value === 'false') {
                    buttonList[i].click();
                }
            }
        }

        function collapseAll() {
            var buttonList = el.querySelectorAll('.js-nested-accordion button.nested-accordion__toggle-button');

            for (var i = 0; i < buttonList.length; i++) {
                if (buttonList[i].attributes.getNamedItem('aria-expanded').value === 'true') {
                    buttonList[i].click();
                }
            }
        }

        function getClosest(elem, selector) {
            for (; elem && elem !== document; elem = elem.parentNode) {
                if (elem.matches(selector)) return elem;
            }

            return null;
        }

        function observerCallback(mutationsList) {
            mutationsList.forEach(function (node) {
                var target = node.target;
                var parentElement = target.parentElement;
                var lastButtonElement = void 0;
                var targetIsLastButtonElement = false;
                var targetIsContainerElement = false;
                var parentCollapseElement = getClosest(target, '.nested-accordion__collapse');
                var lastChildButtonElement = void 0;
                var childCardBody = void 0;
                var nextParentButtonElement = void 0;
                var nextSiblingButton = void 0;
                var targetIsExpanded = target.attributes.getNamedItem('aria-expanded').value === 'true';

                if (target.classList.contains('js-transparent-border') && targetIsExpanded) {
                    target.classList.remove('js-transparent-border');
                    target.classList.add('js-transparent-border-off');

                    if (target.nextElementSibling && target.nextElementSibling.classList && target.nextElementSibling.classList.contains('nested-accordion__collapse--content')) {
                        target.nextElementSibling.setAttribute('data-content', '');
                    }
                } else if (target.classList.contains('js-transparent-border-off') && !targetIsExpanded) {
                    target.classList.remove('js-transparent-border-off');

                    if (target.nextElementSibling && target.nextElementSibling.classList && target.nextElementSibling.classList.contains('nested-accordion__collapse--content')) {
                        target.nextElementSibling.removeAttribute('data-content');
                    }
                }

                if (parentElement) {
                    for (var i = parentElement.childNodes.length; i--;) {
                        if (parentElement.childNodes[i].classList && parentElement.childNodes[i].classList.contains('nested-accordion__toggle-button')) {
                            lastButtonElement = parentElement.childNodes[i];
                            break;
                        }
                    }
                }

                if (lastButtonElement) {
                    targetIsLastButtonElement = target.isSameNode(lastButtonElement);
                }

                if (target.nextElementSibling.classList && (target.nextElementSibling.classList.contains('nested-accordion__collapse--container-container') || target.nextElementSibling.classList.contains('nested-accordion__collapse--container'))) {
                    targetIsContainerElement = true;
                }

                if (lastButtonElement && targetIsExpanded && target.nextElementSibling.classList && target.nextElementSibling.classList.contains('nested-accordion__collapse--content')) {
                    if (parentCollapseElement) {
                        nextParentButtonElement = parentCollapseElement.nextElementSibling;

                        if (!nextParentButtonElement && targetIsLastButtonElement) {
                            target.nextElementSibling.setAttribute('data-content', '');
                        }
                    }
                }

                if (target.attributes.getNamedItem('aria-expanded').value === 'true') {
                    targetIsExpanded = true;
                } else {
                    targetIsExpanded = false;
                }

                if (targetIsLastButtonElement && targetIsContainerElement) {
                    childCardBody = target.nextElementSibling.querySelector('.card-body');

                    if (parentCollapseElement) {
                        nextParentButtonElement = parentCollapseElement.nextElementSibling;
                    }

                    if (childCardBody) {
                        for (var _i = childCardBody.childNodes.length; _i--;) {
                            if (childCardBody.childNodes[_i].classList && childCardBody.childNodes[_i].classList.contains('nested-accordion__toggle-button')) {
                                lastChildButtonElement = childCardBody.childNodes[_i];
                                break;
                            }
                        }

                        if (lastChildButtonElement && lastChildButtonElement.attributes.getNamedItem('aria-expanded').value === 'false') {
                            lastChildButtonElement.classList.add('js-transparent-border');
                        }
                    }
                }

                if (targetIsLastButtonElement && nextParentButtonElement && nextParentButtonElement.classList && nextParentButtonElement.classList.contains('nested-accordion__toggle-button')) {
                    if (targetIsExpanded) {
                        nextParentButtonElement.classList.add('js-hide-after');
                    } else {
                        nextParentButtonElement.classList.remove('js-hide-after');
                    }

                    for (var _i2 = parentCollapseElement.parentNode.children.length; _i2--;) {
                        if (parentCollapseElement.parentNode.children[_i2].classList && parentCollapseElement.parentNode.children[_i2].classList.contains('nested-accordion__toggle-button')) {
                            if (!parentCollapseElement.previousElementSibling.isSameNode(parentCollapseElement.parentNode.children[_i2]) && !parentCollapseElement.previousElementSibling.parentNode.classList.contains('js-nested-accordion')) {
                                nextParentButtonElement.classList.remove('js-hide-after');
                                break;
                            }
                        }
                    }
                } else if (parentElement.classList && parentElement.classList.contains('js-nested-accordion')) {
                    if (targetIsLastButtonElement && targetIsExpanded) {
                        target.nextElementSibling.setAttribute('data-content', '');
                    } else if (targetIsLastButtonElement && !targetIsExpanded) {
                        target.nextElementSibling.removeAttribute('data-content');
                    }

                    if (target.nextElementSibling && target.nextElementSibling.nextElementSibling) {
                        if (target.nextElementSibling.nextElementSibling.classList && target.nextElementSibling.nextElementSibling.classList.contains('nested-accordion__toggle-button')) {
                            nextSiblingButton = target.nextElementSibling.nextElementSibling;

                            if (targetIsExpanded && nextSiblingButton.isSameNode(lastButtonElement) && nextSiblingButton.attributes.getNamedItem('aria-expanded').value === 'false') {
                                nextSiblingButton.classList.add('js-transparent-border');
                            } else if (!targetIsExpanded && nextSiblingButton.isSameNode(lastButtonElement) && nextSiblingButton.attributes.getNamedItem('aria-expanded').value === 'false') {
                                nextSiblingButton.classList.remove('js-transparent-border');
                            }
                        }
                    }
                }
            });
        }
    }
};

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// removes the href
setTimeout(function () {
    var links = document.querySelectorAll('div.tabs ul[role="tablist"] li.nav-item');

    for (var i = 0; i < links.length; i++) {
        links[i].setAttribute('role', 'none');
    }
}, 1000);

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
exports['default'] = {
    inserted: function inserted(el) {
        var allTabPanels = el.querySelectorAll('[role="tabpanel"]');
        var tabList = el.querySelector('[role="tablist"]');

        // The current version of bootstrap-vue being used (1.51.1) looks to have a misspelling when adding the 'aria-labelledby' attribute on the tabpanels causing an accessibility risk flag.  Removing the misspelled attribute and adding the correct spelling with the appropriate value here.
        allTabPanels.forEach(function (tabPanel) {
            window.setTimeout(function () {
                tabPanel.setAttribute('aria-labelledby', tabPanel.attributes.getNamedItem('aria-lablelledby').value);
                tabPanel.removeAttribute('aria-lablelledby');
            }, 0);
        });

        // Move focus to the next tab in the tab list when tabbing from the last tabbable element within a tab panel on desktop with screen reader announcement.  Do not do this if it is the last tab panel.

        var _loop = function _loop(i) {
            var allTabbableElements = allTabPanels[i].querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
            var lastTabbableElement = allTabbableElements[allTabbableElements.length - 1];

            lastTabbableElement.addEventListener('keydown', function (e) {
                var allTabs = void 0;

                if (tabList) {
                    allTabs = tabList.querySelectorAll('.nav-item');
                }

                if (e.keyCode === 9 && !e.shiftKey && allTabs && window.innerWidth > 575) {
                    e.preventDefault();
                    allTabs[i + 1].querySelector('[role="tab"]').setAttribute('tabindex', '0');
                    allTabs[i + 1].querySelector('[role="tab"]').click();
                    allTabs[i + 1].querySelector('[role="tab"]').focus();
                    allTabs[i].querySelector('[role="tab"]').setAttribute('tabindex', '-1');
                }
            });
        };

        for (var i = 0; i < allTabPanels.length - 1; i++) {
            _loop(i);
        }

        // // Enable screen readers to announce the tabs while navigating them via arrow keys.  The current version of bootstrap-vue being used (1.51.1) does support this.  Navigating with the down arrow key is also broken because of a misspelling in file Project\Heart-FrontEnd\node_modules\bootstrap-vue\es\components\tabs\tabs.js on line 245 (KeyCodes.DWON).
        setTimeout(function () {
            if (tabList) {
                var initialActiveTab = tabList.querySelector('.active');
                var allListItems = tabList.querySelectorAll('li');

                allListItems.forEach(function (listItem) {
                    listItem.removeAttribute('role');
                });

                // Remove tabindex=0 on tab list
                if (tabList) {
                    tabList.removeAttribute('tabindex');
                }
                // Set tabindex=0 on the active tab when loaded
                if (initialActiveTab) {
                    initialActiveTab.setAttribute('tabindex', '0');
                }

                tabList.addEventListener('keydown', function (e) {
                    var currentTab = void 0;

                    if (e.target.classList.contains('nav-link') && (e.keyCode === 39 || e.keyCode === 40)) {
                        currentTab = e.target;
                        var nextTab = currentTab.parentNode.nextElementSibling ? currentTab.parentNode.nextElementSibling.querySelector('.nav-link') : null;

                        if (nextTab) {
                            currentTab.setAttribute('tabindex', '-1');
                            nextTab.setAttribute('tabindex', '0');
                            nextTab.click();
                            nextTab.focus();
                        }
                    } else if (e.target.classList.contains('nav-link') && (e.keyCode === 37 || e.keyCode === 38)) {
                        currentTab = e.target;
                        var previousTab = currentTab.parentNode.previousElementSibling ? currentTab.parentNode.previousElementSibling.querySelector('.nav-link') : null;

                        if (previousTab) {
                            currentTab.setAttribute('tabindex', '-1');
                            previousTab.setAttribute('tabindex', '0');
                            previousTab.click();
                            previousTab.focus();
                        }
                    }
                });
                // Set tabindex=0 on a tab when it is clicked and set tabindex=-1 on the currently active tab.  Listening to 'mouseup' as bootstrap-vue is preventing propagation of 'click' event in their Tab component.
                tabList.addEventListener('mouseup', function (e) {
                    var currentActiveTab = tabList.querySelector('.active');

                    if (currentActiveTab) {
                        currentActiveTab.setAttribute('tabindex', '-1');
                    }

                    if (e.target.classList.contains('nav-link')) {
                        e.target.setAttribute('tabindex', '0');
                    }
                });
            }
        }, 0);
    }
};

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _inputEventbus = __webpack_require__(45);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    inserted: function inserted(el) {
        _inputEventbus2['default'].$emit('hiddenInputInit', el.value, el.id, el);
    }
};

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _inputEventbus = __webpack_require__(45);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    bind: function bind(el, binding) {
        var type = el.type;
        var value = el.value;
        var id = el.id;
        var category = el.dataset.category;

        if (binding.modifiers.radio || binding.modifiers.checkbox) {
            id = binding.value;
            value = '';
        } else if (binding.value !== undefined) {
            id = binding.value;
        }

        if (type === 'checkbox') {
            value = el.checked;
        }

        if (type === 'text' || type === 'textarea') {
            el.addEventListener('input', function () {
                value = this.value;
                _inputEventbus2['default'].$emit('inputUpdated', value, id, el);
            });
        } else {
            el.addEventListener('change', function () {
                if (type === 'checkbox') {
                    value = el.checked;
                } else {
                    value = this.value;
                }
                _inputEventbus2['default'].$emit('inputUpdated', value, id, el, category);
            });
        }

        if (!binding.modifiers.flagged) {
            _inputEventbus2['default'].$emit('inputInit', value, id, el);
        } else {
            _inputEventbus2['default'].$emit('inputInitFlagged', value, id, el);
        }

        _inputEventbus2['default'].$on('inputCleared', function () {
            if (type === 'radio' || type === 'checkbox') {
                el.checked = false;
            } else {
                el.value = '';
            }
        });
    }
}; /* eslint-disable */

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _target = __webpack_require__(973);

var _target2 = _interopRequireDefault(_target);

var _dom = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var listenTypes = { click: true };

exports['default'] = {
    // eslint-disable-next-line no-shadow-restricted-names
    bind: function bind(el, binding, vnode) {
        (0, _target2['default'])(vnode, binding, listenTypes, function (_ref) {
            var targets = _ref.targets,
                vnode = _ref.vnode;

            targets.forEach(function (target) {
                vnode.context.$root.$emit('bv::show::modal', target, vnode.elm, binding.arg);
            });
        });
        if (el.tagName !== 'BUTTON') {
            // If element is not a button, we add `role="button"` for accessibility
            (0, _dom.setAttr)(el, 'role', 'button');
        }
    }
};

/***/ }),
/* 973 */,
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
exports['default'] = {
    bind: function bind(el, binding, vnode) {
        vnode.context.$root.$on('bv::modal::shown', function (evt) {
            setTimeout(function () {
                var searchInterface = document.querySelector('.CoveoSearchInterface');
                if (searchInterface && window.Coveo && typeof window.Coveo !== 'undefined') {
                    window.Coveo.$$(searchInterface).on('newQuery', function (e) {
                        vnode.context.$root.$emit('bv::hide::modal', 'coveomodal1');
                    });
                }
            }, 0);
        });
    }
};

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable */
/** Date: 7/20/2022 */
// Submit to email endpoint
exports['default'] = {
    inserted: function inserted(el, binding, vnode) {
        var _this = this;

        console.log('el: ', el);
        console.log('binding: ', binding.value);
        console.log('node: ', vnode);

        // const url = binding.value;
        // const url = 'https://run.mocky.io/v3/a4720da8-ae94-470e-bfb5-0aeb5c970f6d?mocky-delay=500ms';
        var url = window.location.origin + '/aha-service/HeartCheckGroceryList/Email';
        console.log("endpoint: ", url);

        var loader = vnode.context.$el.querySelector('#GroceryListSpinner');

        var emailBtn = document.querySelector('.btn.btn-round.btn-primary.d-print-none');

        var sendToEmail = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var emailData, res, message, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                emailData = {};

                                emailData['recipients'] = el.querySelector('#email').value;
                                // emailData['EmailBody'] = vnode.context.$el.querySelector('#grocery-list-print-section').innerHTML;

                                //products
                                emailData['products'] = window.AHAItemsStorageAPI.itemsStorage.fetch('_aha-coveo-grocery-list');

                                console.log("Email Data Obj: ", emailData);

                                _context.prev = 4;
                                _context.next = 7;
                                return fetch(url, {
                                    method: "post",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": "token-value"
                                    },
                                    body: JSON.stringify(emailData, null, 2)
                                });

                            case 7:
                                res = _context.sent;

                                if (res.ok) {
                                    _context.next = 11;
                                    break;
                                }

                                message = 'An error has occurred: ' + res.status + ' - ' + res.statusText;
                                throw new Error(message);

                            case 11:
                                _context.next = 13;
                                return res.json();

                            case 13:
                                data = _context.sent;

                                console.log("Response from server: ", data);
                                loader.classList.remove('show');
                                _this.loader.classList.remove('show');
                                console.log(loader + " no this list");
                                console.log(_this.loader + " this list");
                                console.log('loader removed');
                                _context.next = 25;
                                break;

                            case 22:
                                _context.prev = 22;
                                _context.t0 = _context['catch'](4);

                                console.error(_context.t0 + ' this error');

                            case 25:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[4, 22]]);
            }));

            return function sendToEmail() {
                return _ref.apply(this, arguments);
            };
        }();

        // Submit button for email form
        var submitBtn = el.querySelector('button[type="submit"]');
        submitBtn.addEventListener('click', function (e) {
            console.log('Button clicked');
            e.preventDefault();

            console.log(e);
            loader.classList.add('show');
            sendToEmail().then(function () {
                console.log("Resolved", 'binding', binding);
                emailBtn.disabled = true;
                el.reset();
            })['catch'](function (error) {
                console.log("Error");
                console.log(error);
            });
        });
    }
};

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = skipToLink;
function skipToLink(selector) {
    var skipLink = document.querySelector(selector);

    if (skipLink) {
        skipLink.addEventListener('click', function (evt) {
            evt.preventDefault();

            var target = document.querySelector(evt.target.getAttribute('href'));
            target.focus();
        });
    }
}

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = speedBumpTabbing;
function speedBumpTabbing() {
    var twoClickClass = document.getElementsByClassName('twoClick');
    var speedBumpTrapFocus = function speedBumpTrapFocus() {
        var el = document.getElementById('speed-bump');
        var focusableEls = el.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select');
        var firstFocusableEl = focusableEls[1];
        var lastFocusableEl = focusableEls[focusableEls.length - 1];
        var KEYCODE_TAB = 9;

        el.addEventListener('keydown', function (e) {
            var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
            if (!isTabPressed) {
                return;
            }
            if (e.shiftKey) {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        });
    };

    for (var i = 0; i < twoClickClass.length; i++) {
        twoClickClass[i].addEventListener('click', function () {
            speedBumpTrapFocus();
        }, false);
    }
}

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function () {
    var isStorage = false;
    try {
        isStorage = 'localStorage' in window && window.localStorage != null;
    } catch (e) {
        // console.log('no storage');
    }
    init(isStorage);
};

function init(isStorage) {
    if (!isStorage) {
        var Storage = function Storage() {};
        Storage.prototype.setItem = function (id, val) {
            this[id] = JSON.stringify(val);
        };
        Storage.prototype.getItem = function (id) {
            return this.hasOwnProperty(id) ? this[id] : null;
        };
        Storage.prototype.removeItem = function (id) {
            return delete this[id];
        };

        Storage.prototype.clear = function () {
            var self = this;
            Object.keys(this).map(function (key) {
                self.removeItem(key);
            });
        };

        window.localStorage = new Storage();
    }
}

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _modules = __webpack_require__(980);

var stores = _interopRequireWildcard(_modules);

var _lodash = __webpack_require__(52);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/* eslint-disable no-console */
exports['default'] = {
    inserted: function inserted(el, binding) {
        var redirectOnEmptyUrl = el.getAttribute('redirect-on-empty');

        if (!binding.arg || !(0, _lodash.isString)(binding.value)) {
            el.remove();
            return;
        }

        var storeName = (0, _lodash.startCase)(binding.arg).replace(' ', '') + 'Module';
        var store = (0, _lodash.isEmpty)(stores[storeName]) ? null : stores[storeName];

        if (!store || (0, _lodash.isEmpty)(store.state)) {
            return;
        }

        if ((0, _lodash.isFunction)(store.mutations.initializeStore)) {
            store.mutations.initializeStore();
        }

        var value = store.state[binding.value];

        if ((0, _lodash.isString)(value)) {
            el.value = value;
        }

        if ((0, _lodash.isArray)(value)) {
            value.forEach(function (v, i) {
                if (i === 0) {
                    el.value = v;
                } else {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = el.name;
                    input.value = v;
                    el.insertAdjacentElement('afterend', input);
                }
            });
        }

        if (redirectOnEmptyUrl && (0, _lodash.isEmpty)(value)) {
            window.location.href = redirectOnEmptyUrl;
        }
    }
};

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardSelectorModule = undefined;

var _cardSelector = __webpack_require__(99);

var _cardSelector2 = _interopRequireDefault(_cardSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.CardSelectorModule = _cardSelector2['default'];

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(52);

var DEFAULT_PLACE_HOLDER = '_'; /* eslint-disable no-unused-vars */


var MaskTypes = {
    phone: {
        mask: [/[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
        validation: function validation(val) {
            return true;
        }
    },
    date: {
        mask: [/[0-1]/, /[0-9]/, '/', /[0-3]/, /[0-9]/, '/', /[12]/, /[0-9]/, /[0-9]/, /[0-9]/]
    }
};
var convertMask = function convertMask() {
    var mask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var placeholderChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_PLACE_HOLDER;

    if (!(0, _lodash.isArray)(mask)) {
        throw new Error('Text-mask:convertMaskToPlaceholder; The mask property must be an array.');
    }

    if (mask.indexOf(placeholderChar) !== -1) {
        throw new Error('Placeholder character must not be used as part of the mask. Please specify a character ' + 'that is not present in your mask as your placeholder character.\n\n' + ('The placeholder character that was received is: ' + JSON.stringify(placeholderChar) + '\n\n') + ('The mask that was received is: ' + JSON.stringify(mask)));
    }

    return mask.map(function (char) {
        return char instanceof RegExp ? placeholderChar : char;
    }).join('');
};

exports['default'] = {
    bind: function bind(el, binding, vnode) {
        if (MaskTypes[binding.value]) {
            var mask = MaskTypes[binding.value].mask;

            el.addEventListener('keydown', function (evt) {
                var key = evt.key;
                var pos = el.value.length;
                var oldValue = el.value;
                var keyCode = evt.which;

                if (keyCode === 9 || keyCode === 37 || keyCode === 39) {
                    return;
                }

                if (key === 'Backspace') {
                    el.value = el.value.substr(0, el.value.length - 1);
                    if (!(mask[el.value.length] instanceof RegExp)) {
                        el.value = el.value.substr(0, el.value.length - 1);
                    }
                    return evt.preventDefault();
                }

                if (pos >= mask.length) {
                    return evt.preventDefault();
                }

                var cancel = false;

                var val = mask.map(function (char, maskIndex) {
                    var isRexEx = char instanceof RegExp;

                    if (isRexEx) {
                        if (maskIndex < pos) {
                            var oldChar = oldValue.charAt(maskIndex);
                            if (char.test(oldChar)) {
                                return oldChar;
                            } else {
                                cancel = true;
                            }
                        }
                        if (maskIndex === pos) {
                            return (/\w/.test(key) ? key : ''
                            );
                        }
                    } else {
                        return char;
                    }

                    return DEFAULT_PLACE_HOLDER;
                });

                if (!mask[pos].test(evt.key)) {
                    evt.preventDefault();
                }
            });
            el.addEventListener('keyup', function (evt) {
                var pos = el.value.length;
                var key = evt.key;

                if (key === 'Backspace') {
                    if (pos > 1) {
                        var mapChar = mask[pos];
                        var isRexEx = mapChar instanceof RegExp;
                    }
                }

                if (pos < mask.length) {
                    var _mapChar = mask[pos];
                    var _isRexEx = _mapChar instanceof RegExp;
                    if (!_isRexEx) {
                        el.value += _mapChar;
                    }
                }
            });
            el.addEventListener('change', function (evt) {
                var phoneFormat = RegExp(/^(\d{3})-(\d{3})-(\d{4})$/);

                if (binding.value === 'phone') {
                    var isFormatted = phoneFormat.test(evt.target.value);

                    if (evt.target.value.length > 0 && !isFormatted) {
                        evt.target.value = evt.target.value.replace(/[^0-9]/g, '').replace(/^(\d{3})?(\d{3})?(\d{4})?/g, '$1-$2-$3');
                    }
                }
            });
        }
    }
};

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    inserted: function inserted(el, binding, vnode) {
        // const stickyPos = el.offsetTop;
        var stickyPos = 0;

        var Scroll = function Scroll() {
            if (window.pageYOffset > stickyPos) {
                el.classList.add('sticky');
                document.body.classList.add('has-sticky');
            } else {
                if (el.classList.contains('sticky')) {
                    el.classList.remove('sticky');
                    if (document.body.classList.contains('has-sticky')) {
                        document.body.classList.remove('has-sticky');
                    }
                }
            }
        };

        // detect if have child - sticky logo
        if (el.querySelector('.sticky__logo')) {
            var stickyParent = el.querySelector('.c-top-nav__logo');
            stickyParent.classList.add('does-fade-out');
            var stickylogo = el.querySelector('.sticky__logo img');
            stickylogo.style.cssText = 'display: block; opacity: 0;';
        }

        window.onscroll = Scroll;
    }
};

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function () {
    document.addEventListener('DOMContentLoaded', function () {
        var API_TRIGGER_GOAL = window.location.origin + '/aha-service/analytics/TriggerGoal';
        var API_TRACK_EVENT = window.location.origin + '/aha-service/analytics/trackevent';

        // D A T A  T R A C K I N G  A T T R I B U T E
        var trackingEls = document.querySelectorAll('[data-tracking]');
        // L O O P
        Array.prototype.forEach.call(trackingEls, function (el) {
            // CLICK HANDLER
            el.addEventListener('click', function (e) {
                if (e.currentTarget.getAttribute('data-tracking') === '') {
                    return;
                }
                if (e.currentTarget.tagName === 'A') {
                    e.preventDefault();
                    var _link = e.currentTarget.getAttribute('href');
                    var _target = e.currentTarget.getAttribute('target');
                    // get current target that has class twoClick and set it to a variable to use later
                    var _twoClick = e.currentTarget.classList.contains('twoClick');
                    // get the link in the modal that has the text that says "proceed" and set it to a variable to use later
                    var _proceedLink = document.querySelector('.proceed');
                }
                var data = el.getAttribute('data-tracking');
                // Convert single quote to double quote, JSON format specific
                data = data.replace(/'/g, '"');
                var obj = JSON.parse(data);

                // Destructuring assignments

                var goalId = obj.goalId,
                    pageEvent = _objectWithoutProperties(obj, ['goalId']);

                var goalObj = { 'goalId': goalId };
                var trackEventObj = pageEvent;
                if (Object.keys(goalObj).length !== 0 && goalObj.constructor === Object) {
                    postData(API_TRIGGER_GOAL, goalObj);
                }

                if (Object.keys(trackEventObj).length !== 0 && trackEventObj.constructor === Object) {
                    postData(API_TRACK_EVENT, trackEventObj);
                }
                /* eslint-disable-next-line */
                // if the current target has class twoClick, then wait till proceed is clicked to open the link
                if (_twoClick) {
                    _proceedLink.addEventListener('click', function () {
                        if (_link !== '#') {
                            setTimeout(function () {
                                window.open(_link, _target);
                            }, 250);
                        }
                    });
                }
                // commenting out to stop opening new tab and letting the link work as normal
                if (e.currentTarget.tagName === 'A') {
                    if (e.currentTarget.getAttribute('href') !== '#') {
                        setTimeout(function () {
                            // if target is null, open in same window else open in _target
                            if (_target === null) {
                                window.location.href = _link;
                            } else {
                                window.open(_link, _target);
                            }
                        }, 250);
                    }
                }
            });
        });
        // E N D  L O O P

        // P O S T
        function postData(api, dataObj) {
            /* eslint-disable-next-line */
            fetch(api, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataObj)
            }).then(function (response) {
                // if there is a response from the server
                if (response) {
                    return response.json();
                }
            }).then(function (result) {
                if (result) {
                    // log response
                    // console.log('RESPONSE', result);
                }
            })['catch'](function (error) {
                if (error.constructor === Object) {
                    /* eslint-disable-next-line */
                    console.error('ERROR:', error);
                }
            })['finally'](function () {
                // console.log('Promise done');
            });
        }
    });
};

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
exports['default'] = {
    inserted: function inserted(el) {
        // Append course id and zip code to provided form action
        el.onsubmit = function (e) {
            var courseIdEl = el.querySelector('#courseid');
            var courseZipCodeEl = el.querySelector('#zipcode');
            var originalFormAction = el.getAttribute('action');
            var newFormAction = originalFormAction;

            if (courseIdEl && courseIdEl.value) {
                newFormAction += '&courseid=' + courseIdEl.value;
                if (courseZipCodeEl && courseZipCodeEl.value) {
                    newFormAction += '&zipcode=' + courseZipCodeEl.value;
                }
            }

            el.action = encodeURI(newFormAction);
        };
    }
};

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
/** Date: 4/16/2021*/
/*PHD Pro Volunteer Search Form*/
exports['default'] = {
    inserted: function inserted(el) {
        var regionInput1 = document.getElementById('ahaRegionSelected'); // dropdown 1
        var regionInput2 = document.getElementById('domesticRegionSelected'); // dropdown 2
        var regionInput3 = document.getElementById('internationalRegionSelected'); // dropdown 3

        regionInput1.style.display = "block";
        regionInput2.style.display = "none";
        regionInput3.style.display = "none";

        document.addEventListener('click', function (event) {
            if (event.target.matches('input[name="region"]')) {
                var region = document.getElementsByName('region');

                var i;
                for (i = 0; i < region.length; i++) {
                    if (region[i].checked) {
                        if (region[i].value == 1) {
                            console.log("AHA Region");
                            regionInput1.style.display = "block";
                            regionInput2.style.display = "none";
                            regionInput3.style.display = "none";
                            break;
                        }
                        if (region[i].value == 2) {
                            console.log("Domestic");
                            regionInput1.style.display = "none";
                            regionInput2.style.display = "block";
                            regionInput3.style.display = "none";
                            break;
                        }
                        if (region[i].value == 3) {
                            console.log("International");
                            regionInput1.style.display = "none";
                            regionInput2.style.display = "none";
                            regionInput3.style.display = "block";
                            break;
                        }
                        region[i].addEventListener('click', function (event) {
                            console.log('clicked');
                        }, false);
                    }
                }
            }
        }, false);
    }
};

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'use-strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uniqid = __webpack_require__(97);

var _uniqid2 = _interopRequireDefault(_uniqid);

var _popper = __webpack_require__(63);

var _popper2 = _interopRequireDefault(_popper);

var _eventBus = __webpack_require__(300);

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _EVENT_BUS = new _eventBus2['default']();

var _POPPER_CONFIG = {
    placement: 'bottom',
    modifiers: {
        computeStyle: {
            gpuAcceleration: false
        },
        flip: {
            enabled: false
        },
        preventOverflow: {
            enabled: true,
            escapeWithReference: true
        }
    }
};

var _DROPDOWN_ROLE = 'listbox';
var _DROPDOWN_CHILD_ROLE = 'menuitem';
var _ITEM_SELECTOR = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]';
var _DOWN_ARROW = 40;
var _UP_ARROW = 38;

// ES6 Symbols to hide private Class functions from public scope
var _openMenu = Symbol('openMenu');
var _closeMenu = Symbol('closeMenu');
var _toggleAriaExpanded = Symbol('toggleAriaExpanded');
var _checkRoles = Symbol('checkRoles');
var _focusInit = Symbol('focusInit');
var _focusCtrl = Symbol('focusCtrl');
var _focusCtrlHandler = Symbol('focusCtrlHandler');
var _nextFocusable = Symbol('nextFocusable');
var _closeOnEvent = Symbol('closeOnEvent');
var _closeOnEventHandler = Symbol('closeOnEventHandler');
var _createPopper = Symbol('createPopper');
var _removePopper = Symbol('removePopper');

var Dropdown = function () {
    function Dropdown(_ref) {
        var _this2 = this;

        var el = _ref.el,
            target = _ref.target,
            _ref$toggleClass = _ref.toggleClass,
            toggleClass = _ref$toggleClass === undefined ? 'show' : _ref$toggleClass;

        _classCallCheck(this, Dropdown);

        var _this = this;

        this.uniqueId = (0, _uniqid2['default'])();
        this.el = el;
        this.target = target;
        this.focusable = target.querySelectorAll(_ITEM_SELECTOR);
        this.toggleClass = toggleClass;

        this.popper = null;

        this.open = false;
        this.initialized = false;

        this.toggleHandler = function () {
            return _this2.toggle();
        };

        this[_closeOnEventHandler] = function (evt) {
            return _this2[_closeOnEvent](evt);
        };
        this[_focusCtrlHandler] = function (evt) {
            _this[_focusCtrl](evt, this);
        };
    }

    /* START: Public */

    _createClass(Dropdown, [{
        key: 'init',
        value: function init() {
            this.el.addEventListener('click', this.toggleHandler);
            this.el.setAttribute('aria-haspopup', true);
            this[_toggleAriaExpanded]();
            this[_checkRoles]();
            this.initialized = true;
        }

        // Toggle dropdown visibility

    }, {
        key: 'toggle',
        value: function toggle() {
            this.target.classList.toggle(this.toggleClass);
            this.open = !this.open;
            this[_toggleAriaExpanded]();
            if (this.open) this[_openMenu]();else this[_closeMenu]();
        }

        // Destroy VanillaJS dropdown instance

    }, {
        key: 'destroy',
        value: function destroy() {
            this.el.removeEventListener('click', this.toggleHandler);
        }

        /* END: Public */

        /* START: Private */

        // Open/Close controls

    }, {
        key: _openMenu,
        value: function value() {
            this[_focusInit]();
            this[_createPopper]();
            _EVENT_BUS.emit('vjs-dropdown:open', { id: this.uniqueId });
            _EVENT_BUS.on('vjs-dropdown:open', this[_closeOnEventHandler]);
        }
    }, {
        key: _closeMenu,
        value: function value() {
            this[_removePopper]();
            _EVENT_BUS.off('vjs-dropdown:open', this[_closeOnEventHandler]);
        }

        // Toggle Aria controls

    }, {
        key: _toggleAriaExpanded,
        value: function value() {
            this.el.setAttribute('aria-expanded', this.open);
        }

        // Check role attribute on dropdown & children for accessibilty

    }, {
        key: _checkRoles,
        value: function value() {
            var children = this.target.children;
            this.target.setAttribute('role', _DROPDOWN_ROLE);
            Array.prototype.filter.call(children, function (child) {
                return child.setAttribute('role', _DROPDOWN_CHILD_ROLE);
            });
        }

        // Focus on first focusable item and initialize focus controls

    }, {
        key: _focusInit,
        value: function value() {
            var _this3 = this;

            this.focusable[0].focus();
            Array.prototype.forEach.call(this.focusable, function (item) {
                item.addEventListener('keydown', _this3[_focusCtrlHandler]);
            });
        }

        // Control focus in menu via arrow keys

    }, {
        key: _focusCtrl,
        value: function value(evt, el) {
            if (evt.keyCode === _DOWN_ARROW || evt.keyCode === _UP_ARROW) {
                evt.preventDefault();
                var next = this[_nextFocusable](el, evt.keyCode);
                if (next) {
                    next.focus();
                }
            }
        }

        // Select next focusable element

    }, {
        key: _nextFocusable,
        value: function value(el, keyCode) {
            return keyCode === _DOWN_ARROW ? el.nextElementSibling : el.previousElementSibling;
        }

        // Close when another Vanilla JS dropdown is opened

    }, {
        key: _closeOnEvent,
        value: function value(evt) {
            if (evt.detail.id !== this.uniqueId) {
                this.toggle();
            }
        }

        // Popper controls

    }, {
        key: _createPopper,
        value: function value() {
            if (typeof _popper2['default'] === 'undefined') {
                /* eslint-disable-next-line */
                console.log('vjs-dropdown: Popper.js not found. Falling back to CSS positioning.');
            } else {
                this[_removePopper]();
                this.popper = new _popper2['default'](this.el, this.target, { _POPPER_CONFIG: _POPPER_CONFIG });
            }
        }
    }, {
        key: _removePopper,
        value: function value() {
            if (this.popper) this.popper.destroy();
            this.popper = null;
        }

        /* END: Private */

    }]);

    return Dropdown;
}();

exports['default'] = Dropdown;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function () {
    document.addEventListener('DOMContentLoaded', function () {
        var cprSearchInterface = document.querySelectorAll('.CoveoSearchInterface');
        var cSearch = cprSearchInterface[cprSearchInterface.length - 1];
        if (window.Coveo && cSearch && typeof window.Coveo !== 'undefined') {
            setTimeout(function () {
                // Coveo dropdown
                window.VJSDropdown.destroy();
                window.VJSDropdown.init();
                window.Coveo.$$(cSearch).on('newResultsDisplayed', function (e, args) {
                    window.VJSDropdown.destroy();
                    window.VJSDropdown.init();
                });
            }, 1000);
        }
    });
};

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function () {
    document.addEventListener('DOMContentLoaded', function () {
        var SearchInterfaceID = '_185F67BF-1D73-4AEE-9564-FDE5B0EB24D9';
        var SearchInterface = document.querySelectorAll('#' + SearchInterfaceID);
        var cSearch = SearchInterface[SearchInterface.length - 1];
        var phdArchiveSearchInterface = document.querySelector('.c-expand-search--archive .coveo-search-section div');
        var impactMapSearchInterface = document.querySelector('.impact-map .CoveoSearchInterface');
        var coveoMainSection = document.querySelector('.coveo-main-section');
        var observerStarted = false;
        var observer = new window.MutationObserver(filtersButtonAddedObserver);

        if (window.Coveo && cSearch && typeof window.Coveo !== 'undefined') {
            window.Coveo.$$(cSearch).on('beforeInitialization', function (e, args) {
                // Add alert popup to notify user when showing archived content
                var phdArchiveTab = window.document.querySelector('.CoveoTab[data-caption="Archives"]');

                if (phdArchiveTab) {
                    phdArchiveTab.addEventListener('click', archiveTabListener);
                    phdArchiveTab.addEventListener('keyup', archiveTabListener);
                }

                function archiveTabListener(e) {
                    if (e.type === 'keyup' && e.keyCode !== 13) {
                        return;
                    }

                    if (!e.currentTarget.classList.contains('coveo-selected')) {
                        window.alert('By applying this filter, only archived content will be presented. This content is preserved for historical reasons only.');
                    }
                }
            });

            window.Coveo.$$(cSearch).on('afterInitialization', function (e, args) {
                // Set Publish Date Facet Slider to today's date if it exists
                var coveoFacetSlider = document.querySelector('.CoveoFacetSlider');
                var currentDate = new Date();

                if (coveoFacetSlider) {
                    var facetSliderInstance = window.Coveo.get(coveoFacetSlider);
                    currentDate.setHours(0);
                    currentDate.setMinutes(0);
                    currentDate.setSeconds(0);
                    currentDate.setMilliseconds(0);
                    facetSliderInstance.initialEndOfSlider = currentDate.getTime();
                }
            });

            window.Coveo.$$(cSearch).on('noResults', function (e, args) {
                // Make Filters button visible after noResults event fired
                setFiltersButtonVisible();

                setTimeout(function () {
                    setFiltersButtonVisible();
                }, 1000);

                if (!observerStarted && coveoMainSection) {
                    observer.observe(coveoMainSection, { childList: true, subtree: true });
                    observerStarted = true;
                }
            });

            setTimeout(function () {
                // No results found event
                window.Coveo.$$(cSearch).on('deferredQuerySuccess', function (e, args) {
                    if (args.results.totalCount === 0) {
                        var coveoQuerySummaryCancelLastElement = cSearch.querySelector('.coveo-query-summary-cancel-last');
                        if (coveoQuerySummaryCancelLastElement) {
                            coveoQuerySummaryCancelLastElement.setAttribute('tabindex', '0');
                            coveoQuerySummaryCancelLastElement.setAttribute('role', 'button');
                            window.Coveo.$$(coveoQuerySummaryCancelLastElement).on('keypress', function (e) {
                                var keycode = e.keyCode ? e.keyCode : e.which;
                                if (keycode === 13 || keycode === 32) {
                                    window.Coveo.$$(coveoQuerySummaryCancelLastElement).trigger('click');
                                }
                            });
                        }
                    }
                });
            }, 1000);
        }

        // For archive search pages, get the search input box and set the searchPageUri to point to the archive tab
        if (window.Coveo && phdArchiveSearchInterface && typeof window.Coveo !== 'undefined') {
            window.Coveo.$$(phdArchiveSearchInterface).on('afterInitialization', function () {
                var archivePageSearchBox = document.querySelectorAll('.c-expand-search--archive .CoveoSearchInterface');
                if (archivePageSearchBox.length > 0) {
                    var archivePageSearchBoxComponent = window.Coveo.get(archivePageSearchBox[0], window.Coveo.SearchInterface);
                    // Set custom searchPageUri, 'coveo5514054d' is the hard coded archive tab ID/data-id
                    archivePageSearchBoxComponent.options.searchPageUri = '/search#t=coveo5514054d&sort=relevancy';
                }
            });
        }

        // For Impact Map, add Filters button when it is not rendered by Coveo
        if (window.Coveo && impactMapSearchInterface && typeof window.Coveo !== 'undefined') {
            window.Coveo.$$(impactMapSearchInterface).on('afterInitialization', function () {
                var timeout = false;

                // Coveo does not add the Filters button on tablet sizes, so manually add it
                if (window.innerWidth > 847 && window.innerWidth < 992) {
                    appendCustomFiltersButton();
                }

                // Apply or remove the custom filters button based on screen size as needed
                window.addEventListener('resize', function () {
                    clearTimeout(timeout);
                    timeout = setTimeout(function () {
                        if (window.innerWidth > 847 && window.innerWidth < 992) {
                            appendCustomFiltersButton();
                        } else {
                            removeCustomFiltersButton();
                        }
                    }, 500);
                });
            });

            window.Coveo.$$(impactMapSearchInterface).on('deferredQuerySuccess', function () {
                var facetColumnElement = impactMapSearchInterface.querySelector('.coveo-facet-column');
                var customFiltersButtonElement = impactMapSearchInterface.querySelector('button.coveo-facet-dropdown-header.coveo-dropdown-header.coveo-accessible-button.impact-map__custom-filters-button');

                if (facetColumnElement && customFiltersButtonElement && facetColumnElement.className.indexOf('coveo-no-results') === -1) {
                    facetColumnElement.className = 'coveo-facet-column coveo-facet-dropdown-content coveo-dropdown-content';
                    customFiltersButtonElement.className += ' coveo-dropdown-header-active';
                }
            });
        }

        // Append custom filters button and container to DOM
        function appendCustomFiltersButton() {
            var coveoStateSearchElement = impactMapSearchInterface.querySelector('.coveo-search-section');
            var previouslyAppendedCustomFiltersButton = impactMapSearchInterface.querySelector('.impact-map__custom-filters-button-container');

            if (coveoStateSearchElement && previouslyAppendedCustomFiltersButton === null) {
                var newFiltersButtonContainer = createCustomFiltersButtonContainer();
                var newFiltersButton = createCustomFiltersButton();
                newFiltersButtonContainer.appendChild(newFiltersButton);
                coveoStateSearchElement.parentNode.insertBefore(newFiltersButtonContainer, coveoStateSearchElement.nextSibling);
            }
        }

        // Remove appended custom filters button and container from DOM
        function removeCustomFiltersButton() {
            var customFiltersButtonContainer = impactMapSearchInterface.querySelector('.impact-map__custom-filters-button-container');

            if (customFiltersButtonContainer) {
                customFiltersButtonContainer.parentNode.removeChild(customFiltersButtonContainer);
            }
        }

        // Create Filters button container for Impact Map
        function createCustomFiltersButtonContainer() {
            var newDropdownHeaderWrapper = document.createElement('DIV');
            newDropdownHeaderWrapper.className = 'coveo-dropdown-header-wrapper impact-map__custom-filters-button-container';
            return newDropdownHeaderWrapper;
        }

        // Create Filters button link for Impact Map
        function createCustomFiltersButton() {
            var newFiltersButton = document.createElement('BUTTON');
            var newFiltersButtonText = document.createElement('P');
            newFiltersButton.className = 'coveo-facet-dropdown-header coveo-dropdown-header coveo-accessible-button coveo-dropdown-header-active impact-map__custom-filters-button';
            newFiltersButton.setAttribute('role', 'button');
            newFiltersButton.setAttribute('aria-label', 'Filters');
            newFiltersButton.setAttribute('tabindex', '0');
            newFiltersButtonText.innerHTML = 'Filters';

            newFiltersButton.addEventListener('click', function (e) {
                var facetColumnElement = impactMapSearchInterface.querySelector('.coveo-facet-column');

                if (facetColumnElement) {
                    if (e.currentTarget.className.indexOf('coveo-dropdown-header-active') === -1) {
                        e.currentTarget.className += ' coveo-dropdown-header-active';
                        facetColumnElement.className = 'coveo-facet-column coveo-facet-dropdown-content coveo-dropdown-content';
                        facetColumnElement.style.display = 'block';
                    } else if (e.currentTarget.className.indexOf('coveo-dropdown-header-active') > -1) {
                        e.currentTarget.className = 'coveo-facet-dropdown-header coveo-dropdown-header coveo-accessible-button impact-map__custom-filters-button';
                        facetColumnElement.className = 'coveo-facet-column';
                        facetColumnElement.style.display = 'none';
                    }
                }
            });

            newFiltersButton.appendChild(newFiltersButtonText);
            return newFiltersButton;
        }
    });

    // Observer callback when Filters button markup is added, removes the 'coveo-hidden' class
    function filtersButtonAddedObserver(mutationList) {
        mutationList.forEach(function (mutationRecord) {
            if (mutationRecord.target.classList.contains('coveo-dropdown-header-wrapper')) {
                mutationRecord.addedNodes.forEach(function (node) {
                    if (node.classList.contains('coveo-hidden') && node.ariaLabel === 'Filters') {
                        node.classList.remove('coveo-hidden');
                    }
                });
            }
        });
    }

    // Remove coveo-hidden class for Filters button
    function setFiltersButtonVisible(event) {
        var filtersButton = window.document.querySelector('a[aria-label="Filters"]');
        if (filtersButton) {
            filtersButton.classList.remove('coveo-hidden');
        }
    }
};

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function () {
    if (typeof FundraiseUp !== 'undefined' && typeof FundraiseUp === 'function') {
        /* eslint-disable-next-line */
        // console.log('::::::::::::::::FUNDRAISE UP::::::::::::::::::::::::::::::::');
        // Object
        var FRUSitecore = {};
        // Endpoints
        FRUSitecore.donationEndpoint = window.location.origin + '/aha-service/fundraise/track';
        FRUSitecore.goalEndpoint = window.location.origin + '/aha-service/analytics/TriggerGoal';
        FRUSitecore.eventEndpoint = window.location.origin + '/aha-service/analytics/trackevent';

        FRUSitecore.mapData = function (vendorDataObj) {
            /* eslint-disable */
            // Destructuring assignments
            var campaign = vendorDataObj.campaign,
                supporter = vendorDataObj.supporter,
                donation = vendorDataObj.donation,
                tribute = vendorDataObj.tribute,
                customFields = vendorDataObj.customFields;
            var id = campaign.id;


            if (supporter === null && donation === null) {
                return;
            };

            var firstName = supporter.firstName,
                lastName = supporter.lastName,
                email = supporter.email,
                mailingListSubscribed = supporter.mailingListSubscribed,
                employer = supporter.employer,
                onBehalfOn = supporter.onBehalfOn;
            var amount = donation.amount,
                recurring = donation.recurring;


            var data = {
                FirstName: firstName,
                LastName: lastName,
                Email: email,
                Amount: amount,
                GiftType: tribute ? 2 : 1,
                ContributionType: recurring ? 2 : 1,
                CustomFields: JSON.stringify(customFields),
                Employer: employer || '',
                Corporate: onBehalfOn || '',
                Newsletter: mailingListSubscribed
            };

            // console.log('Mapped data: ');
            // console.log(data);

            return data;
        };

        FRUSitecore.sendData = function (endpoint, dataObj) {
            // P O S T
            /* eslint-disable-next-line */
            console.log("Data Obj: ", dataObj);
            fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataObj)
            }).then(function (response) {
                /* eslint-disable-next-line */
                // console.log(response.status + ' - ' + response.statusText);
                /*if(response) {
                    // return response.json();
                }*/
            }).then(function (result) {
                /*if(result) {
                    console.log('RESPONSE:', result);
                }*/
            })['catch'](function (error) {
                /* eslint-disable-next-line */
                console.log('ERROR:', error);
                if (error.constructor === Object) {
                    /* eslint-disable-next-line */
                    console.error('ERROR:', error);
                }
            });
        };

        FRUSitecore.triggerGoal = function (data) {
            /* eslint-disable-next-line */
            var _dataObj = data;
            _dataObj = _dataObj.replace(/'/g, '"');
            var obj = JSON.parse(_dataObj);

            var goalId = obj.goalId,
                pageEvent = _objectWithoutProperties(obj, ['goalId']);

            var goalObj = { 'goalId': goalId };
            // let pageEventObj = pageEvent;

            if (Object.keys(goalObj).length !== 0 && goalObj.constructor === Object) {
                FRUSitecore.sendData(FRUSitecore.goalEndpoint, goalObj);
            }

            // if(Object.keys(pageEventObj).length !== 0 && pageEventObj.constructor === Object) {
            //     FRUSitecore.sendData(FRUSitecore.eventEndpoint, pageEventObj);
            // }
        };

        // FRU Events
        FundraiseUp.on('checkoutOpen', function (details) {
            /* eslint-disable-next-line */
            console.log('CHECKOUT OPEN ::::::::::::::::::::');
            /* eslint-disable-next-line */
            console.log('Details: ', details);

            // Determine if its fru widget or button
            var _data = "";

            if (window.dataTrackingOpen == undefined) {
                return;
            }
            _data = window.dataTrackingOpen;

            // If is widget
            // FRUSitecore.triggerGoal('data-tracking-open');
            FRUSitecore.triggerGoal(_data);
            // else use the global data object
            // console.log('OPEN: Data tracking String: ', dataTrackingOpen);
        });

        FundraiseUp.on('checkoutClose', function (details) {
            /* eslint-disable-next-line */
            console.log('CHECKOUT CLOSE :::::::::::::::::::');
            /* eslint-disable-next-line */
            console.log("Close Details: ", details);
            var _data = "";

            _data = window.dataTrackingClose;
            // FRUSitecore.triggerGoal('data-tracking-close');
            FRUSitecore.triggerGoal(_data);
        });

        FundraiseUp.on('donationComplete', function (details) {
            /* eslint-disable-next-line */
            //console.log('DONATION COMPLETE ::::::::::::::::::'); // Donation complete
            /* eslint-disable-next-line */

            console.log('DONATION COMPLETE ::::::::::::::::::');
            console.log("Donation Details:", details);
            var _goalData = "";
            if (window.dataTrackingComplete == undefined) {
                return;
            }
            _goalData = window.dataTrackingComplete;
            FRUSitecore.triggerGoal(_goalData);
            FRUSitecore.sendData(FRUSitecore.donationEndpoint, FRUSitecore.mapData(details));
        });
    }
};

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function () {
    if (detectIOS() === true) {
        document.body.classList.add('iOS');
    }
    function detectIOS() {
        var _ua = window.navigator.userAgent;
        if (_ua.indexOf('iPhone') !== -1 || _ua.indexOf('iPad') !== -1 || _ua.indexOf('iPod') !== -1) {
            return true;
        } else {
            return false;
        }
    }
};

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function () {
    window.addEventListener('DOMContentLoaded', function (e) {
        setTimeout(function () {
            if (window.document.body.classList.contains('has-sticky') && window.location.hash !== '') {
                var el = document.querySelector('' + window.location.hash);
                var stickyHeight = window.document.querySelector('.l-header__top.sticky').getBoundingClientRect().height;
                var headerUtilityHeight = window.document.querySelector('.l-header__utility').getBoundingClientRect().height;
                var topPos = el.getBoundingClientRect().top + window.scrollY;
                window.scrollTo(0, topPos - (stickyHeight + headerUtilityHeight));

                // console.log('onload')
                // console.log('el', el)
                // console.log('stickyHeight', stickyHeight)
                // console.log('headerUtilityHeight', headerUtilityHeight)
                // console.log('topPos', topPos)
                // console.log('window-scrollTo', topPos - (stickyHeight + headerUtilityHeight))
            }
        }, 1500);
    });

    window.addEventListener('click', function (e) {
        setTimeout(function () {
            if (window.document.body.classList.contains('has-sticky') && window.location.hash !== '') {
                var el = document.querySelector('' + window.location.hash);
                var stickyHeight = window.document.querySelector('.l-header__top.sticky').getBoundingClientRect().height;
                var headerUtilityHeight = window.document.querySelector('.l-header__utility').getBoundingClientRect().height;
                var topPos = el.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo(0, topPos - (stickyHeight + headerUtilityHeight));
                // console.log('onclick')
                // console.log('el', el)
                // console.log('stickyHeight', stickyHeight)
                // console.log('headerUtilityHeight', headerUtilityHeight)
                // console.log('topPos', topPos)
                // console.log('window-scrollTo', topPos - (stickyHeight + headerUtilityHeight))
            }
        }, 100);
    });
};

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _clinicalTrialComponent = __webpack_require__(993);

var _clinicalTrialComponent2 = _interopRequireDefault(_clinicalTrialComponent);

var _communitiesEducation = __webpack_require__(995);

var _communitiesEducation2 = _interopRequireDefault(_communitiesEducation);

var _deviceDrugAlerts = __webpack_require__(997);

var _deviceDrugAlerts2 = _interopRequireDefault(_deviceDrugAlerts);

var _dailyRateComparison = __webpack_require__(999);

var _dailyRateComparison2 = _interopRequireDefault(_dailyRateComparison);

var _membershipRateComparison = __webpack_require__(1001);

var _membershipRateComparison2 = _interopRequireDefault(_membershipRateComparison);

var _overallJournal = __webpack_require__(1003);

var _overallJournal2 = _interopRequireDefault(_overallJournal);

var _leftNav = __webpack_require__(1005);

var _leftNav2 = _interopRequireDefault(_leftNav);

var _navSecondaryTertiary = __webpack_require__(1007);

var _navSecondaryTertiary2 = _interopRequireDefault(_navSecondaryTertiary);

var _scienceNewsBox = __webpack_require__(1009);

var _scienceNewsBox2 = _interopRequireDefault(_scienceNewsBox);

var _memberTierSelector = __webpack_require__(1011);

var _memberTierSelector2 = _interopRequireDefault(_memberTierSelector);

var _phdDisplayCheckbox = __webpack_require__(1017);

var _phdDisplayCheckbox2 = _interopRequireDefault(_phdDisplayCheckbox);

var _educationActivitiesList = __webpack_require__(1019);

var _educationActivitiesList2 = _interopRequireDefault(_educationActivitiesList);

var _riskCalculator = __webpack_require__(1021);

var _riskCalculator2 = _interopRequireDefault(_riskCalculator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// PHD Components
_vue2['default'].component('clinical-trial-component', _clinicalTrialComponent2['default']);
_vue2['default'].component('communities-education', _communitiesEducation2['default']);
_vue2['default'].component('device-drug-alerts', _deviceDrugAlerts2['default']);
_vue2['default'].component('daily-rate-comparison', _dailyRateComparison2['default']);
_vue2['default'].component('phd-left-nav', _leftNav2['default']);
_vue2['default'].component('phd-nav-secondary-tertiary', _navSecondaryTertiary2['default']);
_vue2['default'].component('science-news-box', _scienceNewsBox2['default']);
_vue2['default'].component('membership-rate-comparison', _membershipRateComparison2['default']);
_vue2['default'].component('member-tier-selector', _memberTierSelector2['default']);
_vue2['default'].component('overall-journal', _overallJournal2['default']);
_vue2['default'].component('phd-display-checkbox', _phdDisplayCheckbox2['default']);
_vue2['default'].component('phd-education-activities-list', _educationActivitiesList2['default']);
_vue2['default'].component('risk-calculator', _riskCalculator2['default']);

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clinical_trial_component_vue__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clinical_trial_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clinical_trial_component_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clinical_trial_component_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clinical_trial_component_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7faabc44_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_clinical_trial_component_vue__ = __webpack_require__(994);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clinical_trial_component_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7faabc44_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_clinical_trial_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clinical-trial mb-5"},[_c('div',{staticClass:"container clinical-trial__container"},[_c('div',{staticClass:"clinical-trial__wrapper phd--shadow-border"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-4 clinical-trial__description"},_vm._l((_vm.tableData.table.sidebarContent),function(row,rowIndex){return _c('div',{key:rowIndex,staticClass:"clinical-trial__text-block"},[(row.title)?_c('div',{staticClass:"row-description",domProps:{"innerHTML":_vm._s(row.title)}}):_vm._e(),_vm._v(" "),(row.content)?_c('div',{staticClass:"row-description",domProps:{"innerHTML":_vm._s(row.content)}}):_vm._e()])}),0),_vm._v(" "),_c('div',{staticClass:"col-12 clinical-table__content-group d-md-none"},_vm._l((_vm.tableData.table.rows),function(row,rowIndex){return _c('div',{key:rowIndex,staticClass:"clinical-table general-endpoints",class:{'collapsed': !row.active}},[_c('div',{staticClass:"clinical-table__cell clinical-table__cell--head",on:{"click":function($event){row.active = !row.active}}},[_c('span',{staticClass:"row-title",domProps:{"innerHTML":_vm._s(row.name)}}),_vm._v(" "),(row.name)?_c('span',{staticClass:"row-description d-none d-md-block",domProps:{"innerHTML":_vm._s(row.name)}}):_vm._e()]),_vm._v(" "),_vm._l((row.colData),function(col,colIndex){return _c('span',{key:colIndex,staticClass:"clinical-table__cell"},[(col.values[colIndex])?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 md-d-none general-endpoints__mobile-label"},[(col.values[0])?[_c('span',{staticClass:"general-endpoints__mobile-label-top",domProps:{"innerHTML":_vm._s(col.titles[0])}}),_vm._v(" "),(col.names[0])?_c('span',{staticClass:"general-endpoints__mobile-label-bottom",domProps:{"innerHTML":_vm._s(col.names[0])}}):_vm._e()]:_vm._e(),_vm._v(" "),(col.values[1])?[_c('span',{staticClass:"general-endpoints__mobile-label-top",domProps:{"innerHTML":_vm._s(col.titles[1])}}),_vm._v(" "),(col.names[1])?_c('span',{staticClass:"general-endpoints__mobile-label-bottom",domProps:{"innerHTML":_vm._s(col.names[1])}}):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-6 general-endpoints__value text-right"},[_c('div',{staticClass:"row"},[(col.values[0])?_c('span',{staticClass:"col-12 general-endpoints__value",domProps:{"innerHTML":_vm._s(col.values[0])}}):_vm._e(),_vm._v(" "),(col.values[1])?_c('span',{staticClass:"col-12 general-endpoints__value-bottom",domProps:{"innerHTML":_vm._s(col.values[1])}}):_vm._e()])]),_vm._v(" "),(col.result)?_c('div',{staticClass:"col-12 general-endpoints__mobile-label-results",domProps:{"innerHTML":_vm._s(col.result)}}):_vm._e()]):_vm._e()])})],2)}),0),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-8"},[_c('div',{staticClass:"clinical-trial__table d-none d-md-block"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.tableData.table.rows),function(row,rowIndex){return _c('div',{key:rowIndex,staticClass:"row clinical-trial__table-colrows"},[_c('div',{staticClass:"col-12 col-md-4 collapse-trigger clinical-trial__table-name",domProps:{"innerHTML":_vm._s(row.name)}}),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row clinical-trial__table-datarow"},[_c('span',{staticClass:"col-6"},[_c('div',{staticClass:"row"},[_c('span',{staticClass:"col-md-5"},[_vm._v(_vm._s(row.colData[0].values[0]))]),_vm._v(" "),_c('span',{staticClass:"col-md-5"},[_vm._v(_vm._s(row.colData[0].values[1]))]),_vm._v(" "),_c('span',{staticClass:"d-none d-md-block col-md-2"})])]),_vm._v(" "),_c('span',{staticClass:"col-6"},[_c('div',{staticClass:"row"},[_c('span',{staticClass:"col-md-5"},[_vm._v(_vm._s(row.colData[1].values[0]))]),_vm._v(" "),_c('span',{staticClass:"col-md-5"},[_vm._v(_vm._s(row.colData[1].values[1]))]),_vm._v(" "),_c('span',{staticClass:"d-none d-md-block col-md-2"})])]),_vm._v(" "),_vm._l((row.colData),function(col,colIndex){return _c('span',{key:colIndex,staticClass:"col-12 col-md-6 clinical-trial__table-resultLabel text-right",class:{'clinical-trial__table-empty-trial': !col.resultsLabel[colIndex]}},[_vm._v("\n                                                    "+_vm._s(col.resultsLabel)+"\n                                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row clinical-trial__table-resultrow"},_vm._l((row.colData),function(col,colIndex){return _c('span',{key:colIndex,staticClass:"col-6 col-md-6"},[_vm._v("\n                                                    "+_vm._s(col.result)+"\n                                            ")])}),0)])])])])})],2),_vm._v(" "),_c('hr',{staticClass:"clinical-trial__results-divider mx-md-4 d-none d-md-block"}),_vm._v(" "),_vm._t("results")],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row d-none d-md-flex clinical-trial__table-colheaders"},[_c('div',{staticClass:"col-4"}),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-5"},[_vm._v("\n                                        Vit D3\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_vm._v("\n                                        placebo\n                                    ")]),_vm._v(" "),_c('span',{staticClass:"d-none d-md-block col-md-2"})])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-5"},[_vm._v("\n                                        O3FA\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_vm._v("\n                                        placebo\n                                    ")]),_vm._v(" "),_c('span',{staticClass:"d-none d-md-block col-md-2"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_communities_education_vue__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_communities_education_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_communities_education_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_communities_education_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_communities_education_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a22561d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_communities_education_vue__ = __webpack_require__(996);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_communities_education_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a22561d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_communities_education_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD communities-education"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container container-fluid communities-education__wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row l-tier-selector"},[_c('div',{staticClass:"col-3 c-tier-selector__tabs communities-education__tabs"},[_c('div',{staticClass:"nav flex-column nav-pills",attrs:{"id":"v-pills-tab","role":"tablist","aria-orientation":"vertical"}},[_c('a',{staticClass:"nav-link communities-education__nav-link",class:{ active: _vm.isActive('journals') },attrs:{"id":"v-pills-journals-tab","data-toggle":"pill","href":"#v-pills-journals","role":"tab","aria-controls":"v-pills-journals","aria-selected":[_vm.isActive('journals') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('journals')}}},[_vm._m(1)]),_vm._v(" "),_c('a',{staticClass:"nav-link communities-education__nav-link",class:{ active: _vm.isActive('science-news') },attrs:{"id":"v-pills-science-news-tab","data-toggle":"pill","href":"#v-pills-science-news","role":"tab","aria-controls":"v-pills-science-news","aria-selected":[_vm.isActive('science-news') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('science-news')}}},[_vm._m(2)]),_vm._v(" "),_c('a',{staticClass:"nav-link communities-education__nav-link",class:{ active: _vm.isActive('guidelines') },attrs:{"id":"v-pills-guidelines-tab","data-toggle":"pill","href":"#v-pills-guidelines","role":"tab","aria-controls":"v-pills-guidelines","aria-selected":[_vm.isActive('guidelines') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('guidelines')}}},[_vm._m(3)]),_vm._v(" "),_c('a',{staticClass:"nav-link communities-education__nav-link",class:{ active: _vm.isActive('meetings') },attrs:{"id":"v-pills-meetings-tab","data-toggle":"pill","href":"#v-pills-meetings","role":"tab","aria-controls":"v-pills-meetings","aria-selected":[_vm.isActive('meetings') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('meetings')}}},[_vm._m(4)]),_vm._v(" "),_c('a',{staticClass:"nav-link communities-education__nav-link",class:{ active: _vm.isActive('education') },attrs:{"id":"v-pills-education-tab","data-toggle":"pill","href":"#v-pills-education","role":"tab","aria-controls":"v-pills-education","aria-selected":[_vm.isActive('education') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('education')}}},[_vm._m(5)]),_vm._v(" "),_c('a',{staticClass:"nav-link communities-education__nav-link",class:{ active: _vm.isActive('council') },attrs:{"id":"v-pills-council-tab","data-toggle":"pill","href":"#v-pills-council","role":"tab","aria-controls":"v-pills-council","aria-selected":[_vm.isActive('council') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('council')}}},[_vm._m(6)])])]),_vm._v(" "),_c('div',{staticClass:"col-9 c-tier-selector__tab-panels"},[_c('div',{staticClass:"tab-content communities-education__tab-content",attrs:{"id":"v-pills-tabContent"}},[_c('div',{staticClass:"tab-pane p-0",class:{ 'active show': _vm.isActive('journals') },attrs:{"id":"v-pills-journals","role":"tabpanel","aria-labelledby":"v-pills-journals-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-journals'),expression:"'panel-collapse-journals'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('journals') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('journals')}}},[_vm._m(7)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-journals","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4 mb-4"},[_vm._v("Related Journal Content")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider communities-education__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--gray-dark",attrs:{"href":"#"}},[_vm._v("View All Related Journal Content")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane p-0",class:{ 'show active': _vm.isActive('science-news') },attrs:{"id":"v-pills-science-news","role":"tabpanel","aria-labelledby":"v-pills-science-news-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-science-news'),expression:"'panel-collapse-science-news'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('science-news') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('science-news')}}},[_vm._m(8)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-science-news","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4 mb-4"},[_vm._v("Related Science News")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider communities-education__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--gray-dark",attrs:{"href":"#"}},[_vm._v("View More Science News")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane p-0",class:{ 'show active': _vm.isActive('guidelines') },attrs:{"id":"v-pills-guidelines","role":"tabpanel","aria-labelledby":"v-pills-guidelines-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-guidelines'),expression:"'panel-collapse-guidelines'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('guidelines') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('guidelines')}}},[_vm._m(9)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-guidelines","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4 mb-4"},[_vm._v("Related Guidelines & Statements")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("Published Nov 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("Published Nov 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("Published Nov 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("Published Nov 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("Published Nov 2019")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider communities-education__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--gray-dark",attrs:{"href":"#"}},[_vm._v("View All Guidelines & Statements")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane p-0",class:{ 'show active': _vm.isActive('meetings') },attrs:{"id":"v-pills-meetings","role":"tabpanel","aria-labelledby":"v-pills-meetings-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-meetings'),expression:"'panel-collapse-meetings'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('meetings') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('meetings')}}},[_vm._m(10)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-meetings","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4 mb-4"},[_vm._v("Related Meetings")]),_vm._v(" "),_c('div',{staticClass:"c-phd-meeting"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6 c-phd-meeting__image-container"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('img',{attrs:{"src":"assets/images/placeholder.gif","alt":"alt text"}}),_vm._v(" "),_c('span',{staticClass:"c-phd-meeting__image-title"},[_vm._v("Featured Session")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 c-phd-meeting__metadata-container"},[_c('h3',[_vm._v("International Stroke Conference")]),_vm._v(" "),_c('p',{staticClass:"date"},[_vm._v("Precon & Nursing: Feb. 18 | Sessions: Feb. 19–21, 2020")]),_vm._v(" "),_c('p',{staticClass:"location"},[_vm._v("Los Angeles, Calif.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"c-phd-meeting__registration c-phd-meeting__registration--status"},[_vm._v("Registration now open")]),_vm._v(" "),_c('p',{staticClass:"c-phd-meeting__registration c-phd-meeting__registration--message"},[_vm._v("Get EARLY pricing through Dec. 31!")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 order-2 order-md-1 c-phd-meeting__content-container"},[_c('p',[_vm._v("Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nemo eveniet exercitationem esse architecto consequatur consequuntur sapiente, modi accusamus amet porro deserunt perferendis soluta sunt quisquam autem dolorem dolore! Vitae, natus.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ad ut nisi quia assumenda, voluptas incidunt quasi dolor. Neque, corporis a dolorum facilis facere qui quidem expedita ex id, aliquid exercitationem?")]),_vm._v(" "),_c('li',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus laboriosam culpa vitae! Optio possimus perspiciatis accusamus laborum odio quisquam reprehenderit vitae maiores quas est. Beatae incidunt blanditiis sit ut distinctio.")])]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga, labore aperiam. Minus hic ipsa ullam, consequatur doloribus rem distinctio aut adipisci facere! Fugiat, consequatur accusantium necessitatibus fuga sit consequuntur iste.")])]),_vm._v(" "),_c('ul',{staticClass:"col-12 order-1 order-lg-2 c-phd-meeting__buttons-list"},[_c('li',{staticClass:"c-phd-meeting__buttons-list-item"},[_c('a',{staticClass:"btn btn-outline",attrs:{"href":"#"}},[_vm._v("Housing & Transportation")])]),_vm._v(" "),_c('li',{staticClass:"c-phd-meeting__buttons-list-item"},[_c('a',{staticClass:"btn btn-outline",attrs:{"href":"#"}},[_vm._v("Submit Abstract")])]),_vm._v(" "),_c('li',{staticClass:"c-phd-meeting__buttons-list-item"},[_c('a',{staticClass:"btn btn-outline",attrs:{"href":"#"}},[_vm._v("View Programming")])]),_vm._v(" "),_c('li',{staticClass:"c-phd-meeting__buttons-list-item"},[_c('a',{staticClass:"btn",attrs:{"href":"#"}},[_vm._v("Register Now")])])])])])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider communities-education__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--gray-dark",attrs:{"href":"#"}},[_vm._v("View All Meetings")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane p-0",class:{ 'show active': _vm.isActive('education') },attrs:{"id":"v-pills-education","role":"tabpanel","aria-labelledby":"v-pills-education-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-education'),expression:"'panel-collapse-education'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('education') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('education')}}},[_vm._m(11)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-education","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4 mb-4"},[_vm._v("Continuing Education")]),_vm._v(" "),_c('phd-education-activities-list',{attrs:{"numbertoshow":3}}),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider communities-education__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--gray-dark",attrs:{"href":"#"}},[_vm._v("View More Education on Life Long Learning")])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane p-0",class:{ 'show active': _vm.isActive('council') },attrs:{"id":"v-pills-council","role":"tabpanel","aria-labelledby":"v-pills-council-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-council'),expression:"'panel-collapse-council'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('council') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('council')}}},[_vm._m(12)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-council","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4 mb-4"},[_vm._v("Related Scientific Councils")]),_vm._v(" "),_c('div',{staticClass:"c-phd-card"},[_c('div',{staticClass:"c-phd-card__background h-placeholder-image h-placeholder-image--4-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"//placehold.it/750x563/ddd/ccc?text=FPO","alt":"alt text"}})]),_vm._v(" "),_c('div',{staticClass:"c-phd-card__content"},[_c('h3',{staticClass:"c-phd-card__heading"},[_vm._v("Cardiovascular and Stroke Nursing (CVSN)")]),_vm._v(" "),_c('p',{attrs:{"slot":"content"},slot:"content"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam interdum maximus turpis, nec malesuada augue interdum at. Ut sed elit mollis, sollicitudin nisi sed, congue diam. ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"c-phd-card__actions"},[_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("Scientific Sessions")])]),_vm._v(" "),_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("Resuscitation Science Symposium")])]),_vm._v(" "),_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("CVRI Council Awards")])])])])]),_vm._v(" "),_c('div',{staticClass:"c-phd-card"},[_c('div',{staticClass:"c-phd-card__background h-placeholder-image h-placeholder-image--4-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"//placehold.it/750x563/ddd/ccc?text=FPO","alt":"alt text"}})]),_vm._v(" "),_c('div',{staticClass:"c-phd-card__content"},[_c('h3',{staticClass:"c-phd-card__heading"},[_vm._v("Cardiovascular and Stroke Nursing (CVSN)")]),_vm._v(" "),_c('p',{attrs:{"slot":"content"},slot:"content"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam interdum maximus turpis, nec malesuada augue interdum at. Ut sed elit mollis, sollicitudin nisi sed, congue diam. ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"c-phd-card__actions"},[_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("Scientific Sessions")])]),_vm._v(" "),_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("Resuscitation Science Symposium")])]),_vm._v(" "),_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("CVRI Council Awards")])])])])])])],1)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Communities Component - Education Tab")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v("General Cardiology")]),_vm._v(" "),_c('p',{staticClass:"mb-5"},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur cumque sequi, veritatis animi aspernatur, nobis perferendis, necessitatibus corporis adipisci maxime ut. Deleniti voluptatum non quisquam doloremque nemo consectetur eaque! Pariatur.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading communities-education__heading"},[_vm._v("Journals")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading communities-education__heading"},[_vm._v("Science News")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading communities-education__heading"},[_vm._v("Guidelines & Statements")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading communities-education__heading"},[_vm._v("Meetings")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading communities-education__heading"},[_vm._v("Education")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading communities-education__heading"},[_vm._v("Council")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Journals")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Science News")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Guidelines & Statements")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Meetings")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Education")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Council")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb93efca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_device_drug_alerts_vue__ = __webpack_require__(998);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb93efca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_device_drug_alerts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-drug-alert"},[_c('div',{staticClass:"container device-drug-alert__container"},[_c('div',{staticClass:"device-drug-alert__wrapper phd--shadow-border"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-9 order-1"},[_c('h2',{staticClass:"device-drug-alert__heading"},[_vm._v("Drug & Device Alerts")])]),_vm._v(" "),_c('div',{staticClass:"col-12 order-2 order-md-3 device-drug-alert__content"},[_c('div',{staticClass:"device-drug-alert__text-block"},[_c('div',{staticClass:"device-drug-alert-container"},[_c('a',{staticClass:"device-drug-alert__alert-link",attrs:{"href":"#"}},[_vm._v("FDA approval: once a week semaglutide injection - indication to reduce risk of major adverse CV events in adults with CVD and T2DM")])]),_vm._v(" "),_c('div',{staticClass:"device-drug-alert-container"},[_c('a',{staticClass:"device-drug-alert__alert-link",attrs:{"href":"#"}},[_vm._v("FDA: Stryker Launches Voluntary Field Action for Specific Units of The LIFEPAK® 15 Monitor/Defibrillator")])]),_vm._v(" "),_c('div',{staticClass:"device-drug-alert-container"},[_c('a',{staticClass:"device-drug-alert__alert-link",attrs:{"href":"#"}},[_vm._v("FDA: Voluntary worldwide recall of Mavidon manufactured products, including Cardio Prep Single Use Cups Due to Burkholderia Cepacia Contamination")])]),_vm._v(" "),_c('div',{staticClass:"device-drug-alert-container"},[_c('a',{staticClass:"device-drug-alert__alert-link",attrs:{"href":"#"}},[_vm._v("FDA approves first generics of Eliquis (apixaban)")])]),_vm._v(" "),_c('div',{staticClass:"device-drug-alert-container"},[_c('a',{staticClass:"device-drug-alert__alert-link",attrs:{"href":"#"}},[_vm._v("FDA Safety Alert: Mavidon Issues Voluntary Worldwide Recall of all Manufactured Products Due to Burkholderia cepacia Contamination")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 col-lg-3 order-3 order-md-2 device-drug-alert__link-container"},[_c('a',{staticClass:"c-cta c-cta--arrow view-all-link device-drug-alert__link",attrs:{"href":"link.url"}},[_vm._v("View All Alerts")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_rate_comparison_vue__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_rate_comparison_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_rate_comparison_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_rate_comparison_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_rate_comparison_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d834d3a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_rate_comparison_vue__ = __webpack_require__(1000);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_rate_comparison_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d834d3a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_rate_comparison_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daily-comparison"},[_c('div',{staticClass:"container daily-comparison__container"},[_c('div',{staticClass:"row"},_vm._l((_vm.theData),function(table,index){return _c('div',{key:index,staticClass:"col-12 col-md-6 daily-comparison__grid",class:{'is-active': table.active != false},on:{"click":function($event){table.active = !table.active}}},[_c('div',{staticClass:"daily-comparison__grid-titles"},[_c('span',{staticClass:"daily-comparison__grid-category",domProps:{"innerHTML":_vm._s(table.tableName.preTitle)}}),_vm._v(" "),_c('h2',{staticClass:"daily-comparison__grid-title",domProps:{"innerHTML":_vm._s(table.tableName.title)}}),_vm._v(" "),_c('h6',{staticClass:"daily-comparison__grid-day",domProps:{"innerHTML":_vm._s(table.tableName.day)}})]),_vm._v(" "),_c('div',{staticClass:"row daily-comparison__grid-data"},_vm._l((table.rates),function(item,rateIndex){return _c('div',{key:rateIndex,staticClass:"col-12 col-lg-4 daily-comparison__grid-data-item"},[_c('span',{staticClass:"daily-comparison__grid-rate-label",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('span',{staticClass:"daily-comparison__grid-rate-date",domProps:{"innerHTML":_vm._s(item.date)}}),_vm._v(" "),_c('span',{staticClass:"daily-comparison__grid-rate",domProps:{"innerHTML":_vm._s(item.rate)}})])}),0)])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_membership_rate_comparison_vue__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_membership_rate_comparison_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_membership_rate_comparison_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_membership_rate_comparison_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_membership_rate_comparison_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43456de1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_membership_rate_comparison_vue__ = __webpack_require__(1002);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_membership_rate_comparison_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43456de1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_membership_rate_comparison_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rate-comparison",class:{'is-active': _vm.theData.active}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"rate-comparison__wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"flex-table general-membership"},[_c('span',{staticClass:"flex-table__cell flex-table__heading-cell",class:_vm.columnCountClass,on:{"click":function($event){_vm.theData.active = !_vm.theData.active}}},[(_vm.theData.tableName.preTitle)?_c('span',{staticClass:"flex-table__category-label",domProps:{"innerHTML":_vm._s(_vm.theData.tableName.preTitle)}}):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"flex-table__table-title",domProps:{"innerHTML":_vm._s(_vm.theData.tableName.title)}})]),_vm._v(" "),_vm._l((_vm.theData.rateText),function(item,index){return _c('span',{key:index,staticClass:"flex-table__cell flex-table__labels-cell"},[_c('span',{staticClass:"general-membership__rate-label",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('span',{staticClass:"general-membership__date-label",domProps:{"innerHTML":_vm._s(item.date)}})])})],2),_vm._v(" "),_c('div',{staticClass:"flex-table__content-group"},_vm._l((_vm.theData.rowData),function(tableRow,index){return _c('div',{key:index,staticClass:"flex-table general-membership",class:{'collapsed': !tableRow.active}},[_c('div',{staticClass:"flex-table__cell flex-table__cell--head",class:_vm.columnCountClass,on:{"click":function($event){tableRow.active = !tableRow.active}}},[_c('span',{staticClass:"row-title",domProps:{"innerHTML":_vm._s(tableRow.rowTitle)}}),_vm._v(" "),(tableRow.rowDescription)?_c('span',{staticClass:"row-description d-none d-md-block",domProps:{"innerHTML":_vm._s(tableRow.rowDescription)}}):_vm._e()]),_vm._v(" "),_vm._l((tableRow.rates),function(rate,rateIndex){return _c('span',{key:rateIndex,staticClass:"flex-table__cell"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 md-d-none general-membership__mobile-label"},[_c('span',{staticClass:"general-membership__mobile-label-top",domProps:{"innerHTML":_vm._s(_vm.theData.rateText[rateIndex].title)}}),_vm._v(" "),_c('span',{staticClass:"general-membership__mobile-label-bottom",domProps:{"innerHTML":_vm._s(_vm.theData.rateText[rateIndex].date)}})]),_vm._v(" "),_c('div',{staticClass:"general-membership__value",class:rate.gold ? 'col-3 col-md-6' : 'col-6 col-md-12'},[_vm._v("\n                                        "+_vm._s(rate.normal)+"\n                                    ")]),_vm._v(" "),(rate.gold)?_c('div',{staticClass:"col-3 col-md-6 general-membership__value general-membership__value--gold",class:{
                                            'show-label': index === 0 && rate.gold, 'm-show-label': rate.gold
                                            }},[_vm._v("\n                                        "+_vm._s(rate.gold)+"\n                                    ")]):_vm._e()])])})],2)}),0),_vm._v(" "),_vm._t("postTableContent")],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2209d1e4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overall_journal_vue__ = __webpack_require__(1004);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2209d1e4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overall_journal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"PHD"},[_c('div',{staticClass:"l-main"},[_c('div',{staticClass:"container container-fluid overall-journal__wrapper"},[_c('div',{staticClass:"l-promo--shadow"},[_c('div',{staticClass:"l-promo row"},[_c('div',{staticClass:"l-promo__col col-sm-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"c-text-promo d-block overall-journal__container"},[_c('div',{staticClass:"c-text-promo__content"},[_c('div',{staticClass:"c-promo-enhanced__image overall-journal__image"},[_c('img',{staticClass:"is-loaded img-fluid",attrs:{"src":"//placehold.it/170x300/333333/666666?text=FPO"}})]),_vm._v(" "),_c('h2',{staticClass:"overall-journal__title"},[_vm._v("ATVB")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__image-cta"},[_c('a',{attrs:{"href":"#"}},[_vm._v("March 2020 - Vol 75, Issue 3")])])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions overall-journal__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Explore ATVB")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-sm-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"c-text-promo d-block overall-journal__container"},[_c('div',{staticClass:"c-text-promo__content"},[_c('div',{staticClass:"c-promo-enhanced__image overall-journal__image"},[_c('img',{staticClass:"is-loaded img-fluid",attrs:{"src":"//placehold.it/140x310/333333/666666?text=FPO"}})]),_vm._v(" "),_c('h2',{staticClass:"overall-journal__title"},[_vm._v("Circulation")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__image-cta"},[_c('a',{attrs:{"href":"#"}},[_vm._v("March 3, 2020 - Vol 9, Issue 5")])])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions overall-journal__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Explore Circulation")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-sm-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"c-text-promo d-block overall-journal__container"},[_c('div',{staticClass:"c-text-promo__content"},[_c('div',{staticClass:"c-promo-enhanced__image overall-journal__image"},[_c('img',{staticClass:"is-loaded img-fluid",attrs:{"src":"//placehold.it/200x280/333333/666666?text=FPO"}})]),_vm._v(" "),_c('h2',{staticClass:"overall-journal__title"},[_vm._v("Circulation Research")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__image-cta"},[_c('a',{attrs:{"href":"#"}},[_vm._v("February 2020 - Vol 51, Issue Suppl_1")])])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions overall-journal__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Explore Cardiovascular Research")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-sm-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"c-text-promo d-block overall-journal__container"},[_c('div',{staticClass:"c-text-promo__content"},[_c('div',{staticClass:"c-promo-enhanced__image overall-journal__image"},[_c('img',{staticClass:"is-loaded img-fluid",attrs:{"src":"//placehold.it/700x700/333333/666666?text=FPO"}})]),_vm._v(" "),_c('h2',{staticClass:"overall-journal__title"},[_vm._v("Hypertension")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__image-cta"},[_c('a',{attrs:{"href":"#"}},[_vm._v("March 2020 - Vol 75, Issue 3")])])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions overall-journal__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Explore Hypertension")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-sm-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"c-text-promo d-block overall-journal__container"},[_c('div',{staticClass:"c-text-promo__content"},[_c('div',{staticClass:"c-promo-enhanced__image overall-journal__image"},[_c('img',{staticClass:"is-loaded img-fluid",attrs:{"src":"//placehold.it/140x330/333333/666666?text=FPO"}})]),_vm._v(" "),_c('h2',{staticClass:"overall-journal__title"},[_vm._v("Stroke")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__image-cta"},[_c('a',{attrs:{"href":"#"}},[_vm._v("March 3, 2020 - Vol 9, Issue 5")])])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions overall-journal__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Explore Stroke")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-sm-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"c-text-promo d-block overall-journal__container"},[_c('div',{staticClass:"c-text-promo__content"},[_c('div',{staticClass:"c-promo-enhanced__image overall-journal__image"},[_c('img',{staticClass:"is-loaded img-fluid",attrs:{"src":"//placehold.it/240x250/333333/666666?text=FPO"}})]),_vm._v(" "),_c('h2',{staticClass:"overall-journal__title"},[_vm._v("Circulation: Cardiovascular Imaging")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__image-cta"},[_c('a',{attrs:{"href":"#"}},[_vm._v("March 9 2020 - Vol 75, Issue 3")])])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions overall-journal__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("More on Circ: Cardiovascular Imaging")])])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_nav_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_nav_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_nav_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_nav_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7137c097_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_left_nav_vue__ = __webpack_require__(1006);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_nav_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7137c097_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_left_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"left-nav",attrs:{"aria-label":"Side Navigation"}},[_c('div',{staticClass:"d-md-none"},[_c('aha-listbox',{attrs:{"dropdown-tag":"div","role":"navigation","default-value":_vm.findActiveItem(),"toggle-class":"btn btn-outline btn--select w-100"}},[_vm._l((_vm.menuData),function(mLink,mIndex){return _c('template',{slot:"dropdown"},[(!mLink.active)?[_c('aha-select-dropdown-item',{key:mIndex,attrs:{"href":mLink.url,"tag":"a","role":"","text":mLink.text,"target":mLink.target,"item-class":"c-select-dropdown__item"}},[_vm._v(_vm._s(mLink.text))])]:[_c('aha-select-dropdown-item',{key:mIndex,attrs:{"tag":"span","text":mLink.text,"item-class":"c-select-dropdown__item selected","selected":""}},[_vm._v(_vm._s(mLink.text))])]],2)})],2)],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block"},[_vm._l((_vm.menuData),function(link,index){return [(!link.active)?[_c('a',{key:index,staticClass:"left-nav__item",attrs:{"href":link.url,"target":link.target},domProps:{"innerHTML":_vm._s(link.text)}})]:[_c('span',{key:index,staticClass:"left-nav__item is-active",domProps:{"innerHTML":_vm._s(link.text)}})]]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_secondary_tertiary_vue__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_secondary_tertiary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_secondary_tertiary_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_secondary_tertiary_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_secondary_tertiary_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d38855_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_secondary_tertiary_vue__ = __webpack_require__(1008);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_secondary_tertiary_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d38855_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_secondary_tertiary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('nav',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideAll),expression:"hideAll"}],staticClass:"nav-secondary",class:{'all-open': _vm.theData.showAll},attrs:{"role":"navigation","aria-label":"Secondary Navigation"}},_vm._l((_vm.theData.navItems),function(item,index){return _c('div',{key:index,staticClass:"nav-secondary__item",class:{'is-open': item.open, 'is-active': _vm.findActiveChild(index)}},[(item.subNav)?[_c('button',{ref:'secondary-dropdown-' + index,refInFor:true,staticClass:"nav-secondary__link",class:{'is-active': _vm.findActiveChild(index)},attrs:{"id":'secondary-nav-button-' + index,"aria-haspopup":"true","aria-expanded":item.open ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();return _vm.handleSecondaryNavClick(index)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.closeAllTertiary.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }if(!$event.shiftKey){ return null; }return _vm.closeAllTertiary.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleSecondaryUp(index)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleSecondaryDown(index)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleSecondaryPrevious(index, _vm.theData.navItems.length)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleSecondaryNext(index, _vm.theData.navItems.length)}]}},[_vm._v(_vm._s(item.text))])]:[_c('a',{ref:'secondary-dropdown-' + index,refInFor:true,staticClass:"nav-secondary__link",attrs:{"href":item.url,"target":item.target},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleSecondaryPrevious(index, _vm.theData.navItems.length)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleSecondaryNext(index, _vm.theData.navItems.length)}]}},[_vm._v(_vm._s(item.text))])],_vm._v(" "),(item.subNav)?[_c('transition',{attrs:{"name":"slide"}},[(item.open)?_c('div',{staticClass:"nav-tertiary",class:{'is-open': item.open},attrs:{"role":"menu","aria-label":"Tertiary Navigation","aria-labelledby":'secondary-nav-button-' + index}},_vm._l((item.subNav),function(link,subIndex){return _c('a',{key:subIndex,ref:'secondary-dropdown-' + index + '_tertiary-item-' + subIndex,refInFor:true,staticClass:"nav-tertiary__link",class:{'is-active': link.active},attrs:{"href":link.url,"target":link.target,"role":"menuitem"},domProps:{"innerHTML":_vm._s(link.text)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.handleEscape(index)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.handleTab(subIndex, item.subNav.length)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleTertiaryPrevious(index, item.subNav.length, subIndex)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleTertiaryNext(index, item.subNav.length, subIndex)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleTertiaryPrevious(index, item.subNav.length, subIndex)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleTertiaryNext(index, item.subNav.length, subIndex)}]}})}),0):_vm._e()])]:_vm._e()],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_science_news_box_vue__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_science_news_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_science_news_box_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_science_news_box_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_science_news_box_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_792430f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_science_news_box_vue__ = __webpack_require__(1010);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_science_news_box_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_792430f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_science_news_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"science-news-box"},[(_vm.heading)?_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"science-news-box__container phd--shadow-border"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-9 order-1"},[_c('div',{staticClass:"h2 science-news-box__heading",attrs:{"role":"heading","aria-level":_vm.headingLevel},domProps:{"innerHTML":_vm._s(_vm.heading)}},[_vm._v("Heading Goes Here")]),_vm._v(" "),(_vm.description)?_c('p',{staticClass:"title-description science-news-box__description",domProps:{"innerHTML":_vm._s(_vm.description)}},[_vm._v("Description Goes Here")]):_vm._e()]),_vm._v(" "),(_vm.link.url && _vm.link.text)?_c('div',{staticClass:"col-12 col-md-4 col-lg-3 order-2 d-none d-md-block science-news-box__link-container"},[_c('a',{staticClass:"c-cta c-cta--arrow view-all-link science-news-box__link",attrs:{"href":_vm.link.url},domProps:{"innerHTML":_vm._s(_vm.link.text)}},[_vm._v("link text here")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 order-2 order-md-3 science-news-box__content"},[_vm._t("default",function(){return [_c('p',[_vm._v("If you're seeing this message, you need to slot something into this component.")])]})],2),_vm._v(" "),(_vm.link.url && _vm.link.text)?_c('div',{staticClass:"col-12 col-md-4 col-lg-3 order-3 d-md-none science-news-box__link-container"},[_c('a',{staticClass:"c-cta c-cta--arrow view-all-link science-news-box__link",attrs:{"href":_vm.link.url},domProps:{"innerHTML":_vm._s(_vm.link.text)}},[_vm._v("link text here")])]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_vue__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63f9b2e2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_tier_selector_vue__ = __webpack_require__(1016);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63f9b2e2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_tier_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_tab_vue__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_tab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_tab_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_tab_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_tab_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab2e260c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_tier_selector_tab_vue__ = __webpack_require__(1013);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_tab_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab2e260c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_tier_selector_tab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-item nav-link h-100",class:{ active: _vm.$parent.isActive(String(_vm.tierid)) },attrs:{"id":("panel-" + _vm.tierid + "-tab"),"data-toggle":"pill","data-tier":("" + _vm.tiercode),"href":("panel-" + _vm.tierid),"role":"tab","aria-controls":("panel-" + _vm.tierid),"aria-selected":[_vm.$parent.isActive(String(_vm.tierid)) ? true : false],"tabindex":[_vm.$parent.isActive(String(_vm.tierid)) ? 0 : -1],"data-tier-id":("" + _vm.tierid)},on:{"click":function($event){$event.preventDefault();return _vm.setParentActive.apply(null, arguments)}}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_panel_vue__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_panel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_panel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_panel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_panel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4937c74a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_tier_selector_panel_vue__ = __webpack_require__(1015);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_panel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4937c74a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_tier_selector_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-pane",class:{ 'active show': _vm.$parent.isActive(String(_vm.tierid)) },attrs:{"id":("panel-" + _vm.tierid),"role":"tabpanel","aria-labelledby":("panel-" + _vm.tierid + "-tab")}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(_vm.collapseid),expression:"collapseid"}],staticClass:"btn btn--select",class:{ active: _vm.$parent.isActive(String(_vm.tierid)) },on:{"click":function($event){$event.preventDefault();return _vm.setParentActive.apply(null, arguments)},"keydown":_vm.openOnKeyDown}},[_c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v(_vm._s(_vm.displayname))]),_vm._v(" "),(_vm.discountPrice !== null)?_c('div',{staticClass:"tier-price"},[_c('span',{staticClass:"full-price strikethrough"},[_vm._v("$"+_vm._s(_vm.price)+"/YR")]),_vm._v(" "),_c('span',{staticClass:"discounted-price"},[_vm._v("$"+_vm._s(_vm.discountPrice)+"/YR")])]):_c('div',[_c('span',{staticClass:"full-price"},[_vm._v("$"+_vm._s(_vm.price)+"/YR")])])])])]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":_vm.collapseid},on:{"hidden":_vm.$parent.onHidden},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-member-tier-selector"},[(_vm.isLoading)?_c('div',[_c('b-alert',{attrs:{"show":"","variant":"danger text-center mt-4"}},[(_vm.errorMsg)?_c('div',[_c('p',[_vm._v("Sorry, something went wrong.")]),_vm._v(" "),_c('h4',{staticClass:"alert-heading mt-0"},[_vm._v(_vm._s(_vm.errorMsg))])]):_c('div',[_c('p',[_vm._v(_vm._s(_vm.loadingmsg))]),_vm._v(" "),_c('aha-loading-spinner',{staticClass:"small",attrs:{"is-loading":true}})],1)])],1):_c('div',[_c('aha-modal',{ref:"loadingModal",staticClass:"c-loadingModal",attrs:{"size":"md","id":"loadingModal","hide-footer":"","hide-header-close":"","no-close-on-esc":"","no-close-on-backdrop":"","centered":"","lazy":""}},[_c('template',{slot:"modal-header"},[_c('div',{staticClass:"c-loadingModal__heading"},[_vm._v(_vm._s(_vm.promoModalHeader))])]),_vm._v(" "),_c('aha-loading-spinner',{attrs:{"is-loading":true}}),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.promoModalMessage))])],2),_vm._v(" "),(_vm.warningmessage)?_c('div',{staticClass:"w-100 warning",domProps:{"innerHTML":_vm._s(_vm.warningmessage)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"promo-code-wrapper d-flex flex-column flex-lg-row justify-content-between"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"pc-wrapper"},[(_vm.promoCode)?_c('div',{staticClass:"c-promo-code c-promo-code__display-wrapper"},[_c('div',{staticClass:"h-color--white c-promo-code__display px-3 w-100"},[(_vm.isPromoCodeValid === false && _vm.promoMsgFromApi !== null)?_c('span',[_vm._v(_vm._s(_vm.promoMsgFromApi))]):_c('div',[_vm._v("Promo applied: "),_c('strong',[_vm._v(_vm._s(_vm.promoCode))])]),_vm._v(" "),_c('span',{staticClass:"c-promo-code__close",attrs:{"role":"button"},on:{"click":_vm.closePromoCodeAppliedDisplay}},[_vm._v("×")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"c-promo-code"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-promo-code",modifiers:{"collapse-promo-code":true}}],staticClass:"c-promo-code__btn btn--select w-100",on:{"keydown":function($event){return _vm.onPromoCodeKeydown($event)}}},[_vm._v(_vm._s(_vm.promomsg))]),_vm._v(" "),_c('b-collapse',{staticClass:"c-promo-code__content",attrs:{"id":"collapse-promo-code"},model:{value:(_vm.promoVisible),callback:function ($$v) {_vm.promoVisible=$$v},expression:"promoVisible"}},[_c('form',{ref:"formpromo",staticClass:"form-inline",attrs:{"name":"form-promo-code","action":"","autocomplete":"off","aria-autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.onPromoCodeSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"sr-only",attrs:{"for":"inputPromoCode"}},[_vm._v("Promo Code")]),_vm._v(" "),_c('input',{staticClass:"form-control input--small",attrs:{"type":"text","id":"inputPromoCode","placeholder":"Enter promo code","autocomplete":"off","required":""}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("Add")])])])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row l-tier-selector"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"c-tier-selector__tabs"},[_c('div',{staticClass:"nav nav-pills nav-justified align-items-stretch justify-content-center",attrs:{"id":"pills-tab","role":"tablist"},on:{"keydown":_vm.onKeynav}},_vm._l((_vm.tiers),function(tier){return _c('selector-tab',{key:tier.id,class:((tier.code) + " flex-even"),attrs:{"tierid":tier.id,"tiercode":("" + (tier.code))}},[_c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v(_vm._s(tier.displayName))]),_vm._v(" "),(tier.discountPrice !== null)?_c('div',{staticClass:"tier-price"},[_c('span',{staticClass:"font-italic strikethrough d-sm-block"},[_vm._v("$"+_vm._s(tier.price)+" / YEAR")]),_vm._v(" "),_c('span',{staticClass:"discounted-price font-italic"},[_vm._v("$"+_vm._s(tier.discountPrice)+" / YEAR")])]):_c('div',{staticClass:"tier-price"},[_c('span',{staticClass:"font-italic"},[_vm._v("$"+_vm._s(tier.price)+" / YEAR")])])])])])}),1)]),_vm._v(" "),_c('div',{staticClass:"c-tier-selector__tab-panels"},[_c('div',{staticClass:"tab-content",attrs:{"id":"v-pills-tabContent"}},_vm._l((_vm.tiers),function(tier){return _c('selector-panel',{key:tier.id,attrs:{"tiercode":tier.code,"tierid":tier.id,"displayname":tier.displayName,"price":tier.price,"discountPrice":tier.discountPrice}},[_c('h2',{staticClass:"my-4 col-8 px-0"},[_vm._v(_vm._s(tier.displayName))]),_vm._v(" "),_c('div',{staticClass:"btn-wrapper"},[_c('a',{staticClass:"btn btn-primary btn-round btn-block btn--signup",class:{ disabled: _vm.orderinprogress || _vm.disableSignup },attrs:{"data-promo-code":("" + _vm.promoCode),"data-tier-id":("" + (tier.id)),"data-tier-code":("" + (tier.code)),"data-term-remaining":("" + (tier.termRemaining)),"href":((_vm.signupUri.base) + "?tierId=" + (tier.id) + "&promoCode=" + (_vm.isPromoCodeValid ? _vm.promoCode : null) + "&earlyCareerTerm=" + _vm.earlyCareerTerm + "&ru=" + _vm.referrer + "&flowType=" + _vm.flowType),"aria-disabled":_vm.orderinprogress},on:{"click":function($event){$event.preventDefault();return _vm.onSignUp.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.signUpButtonText))])]),_vm._v(" "),_c('div',{staticClass:"mem-benefits-wrapper",domProps:{"innerHTML":_vm._s(tier.benefitDescription)}}),_vm._v(" "),_c('div',{staticClass:"btn-wrapper"},[_c('a',{staticClass:"btn btn-primary btn-round btn-block btn--signup-mobile",class:{ disabled: _vm.orderinprogress || _vm.disableSignup },attrs:{"data-promo-code":("" + _vm.promoCode),"data-tier-id":("" + (tier.id)),"data-tier-code":("" + (tier.code)),"data-term-remaining":("" + (tier.termRemaining)),"href":((_vm.signupUri.base) + "?tierId=" + (tier.id) + "&promoCode=" + (_vm.isPromoCodeValid ? _vm.promoCode : null) + "&earlyCareerTerm=" + _vm.earlyCareerTerm + "&ru=" + _vm.referrer + "&flowType=" + _vm.flowType),"aria-disabled":_vm.orderinprogress},on:{"click":function($event){$event.preventDefault();return _vm.onSignUp.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.signUpButtonText))])])])}),1)])],2)]),_vm._v(" "),_c('aha-modal',{staticClass:"st-membership-modal",attrs:{"id":"st-membership-modal","hide-footer":"","centered":"","title":"Student Trainee Modal"}},[_c('h2',{staticClass:"text-center"},[_vm._v("Student/Trainee")]),_vm._v(" "),_c('phd-display-checkbox',{staticClass:"c-phd-display-checkbox__item",attrs:{"check-class":"c-phd-display-checkbox__check"}},[_c('p',{},[_vm._v("\n          I certify I am eligible for this category because I am still in\n          training as an undergraduate, graduate, or postdoctoral/clinical\n          fellow.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mt-4"},[_c('button',{staticClass:"btn btn-outline mr-2 w-100",on:{"click":function($event){return _vm.$root.$emit(
              'bv::hide::modal',
              'st-membership-modal',
              $event.target
            )}}},[_vm._v("\n          Go Back\n        ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary w-100 checked-continue disabled",attrs:{"href":_vm.signupUri.default}},[_vm._v("Continue")])])],1),_vm._v(" "),_c('aha-modal',{ref:"ec-modal",staticClass:"ec-membership-modal",attrs:{"id":"ec-membership-modal","hide-footer":"","centered":"","title":"Early Career Modal"}},[_c('h2',{staticClass:"text-center"},[_vm._v("Early Career")]),_vm._v(" "),_c('fieldset',[_c('legend',{staticClass:"h6"},[_vm._v("\n          Please indicate number of years since completion of training:\n        ")]),_vm._v(" "),_vm._l((4),function(i){return _c('div',{key:i,staticClass:"custom-control custom-radio"},[_c('div',[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":("term" + i),"name":"earlyCareerTerm1"},domProps:{"value":i},on:{"change":function($event){return _vm.setEarlyCareerTerm(i)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":("term" + i)}},[_vm._v(_vm._s(i))])])])})],2),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mt-4"},[_c('button',{staticClass:"btn btn-outline mr-2 w-100",on:{"click":function($event){return _vm.$root.$emit(
              'bv::hide::modal',
              'ec-membership-modal',
              $event.target
            )}}},[_vm._v("\n          Go Back\n        ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary w-100 ec-continue",attrs:{"href":_vm.signupUri.default}},[_vm._v("Continue")])])]),_vm._v(" "),_c('aha-modal',{staticClass:"gp-upgrade-modal",attrs:{"id":"gp-upgrade-modal","hide-footer":"","centered":"","title":"General Professional Upgrade Modal"}},[_c('h2',{staticClass:"text-center"},[_vm._v("Did You Know?")]),_vm._v(" "),_c('p',{},[_vm._v("\n        Select Premium Professional and receive even more benefits including 11 free online journals and an additional council.\n      ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mt-4"},[_c('a',{staticClass:"btn btn-outline mr-2 w-100",attrs:{"href":_vm.signupUri.default}},[_vm._v("No Thanks")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary w-100",attrs:{"href":_vm.signupUri.upgrade}},[_vm._v("Accept")])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_display_checkbox_vue__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_display_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_display_checkbox_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_display_checkbox_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_display_checkbox_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0555de03_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_display_checkbox_vue__ = __webpack_require__(1018);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_display_checkbox_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0555de03_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_display_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClasses,on:{"click":_vm.toggleChecked,"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.toggleChecked.apply(null, arguments)}}},[_c('span',_vm._b({class:_vm.checkClass},'span',_vm.containerAttributes,false),[_c('i',{staticClass:"icon-check"})]),_vm._v(" "),_c('div',{attrs:{"id":_vm.checkboxId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_education_activities_list_vue__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_education_activities_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_education_activities_list_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_education_activities_list_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_education_activities_list_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50eef808_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_education_activities_list_vue__ = __webpack_require__(1020);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_education_activities_list_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50eef808_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_education_activities_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD__article-link-container"},_vm._l((_vm.apiData.slice(0, _vm.numbertoshow)),function(item,index){return _c('div',{key:index,staticClass:"article-link__item"},[_c('a',{staticClass:"PHD__article-link PHD__article-link--large",attrs:{"href":item.eventLink},domProps:{"innerHTML":_vm._s(item.eventName)}},[_vm._v("linkText")]),_vm._v(" "),(item.eventName)?_c('p',{staticClass:"PHD__article-summary",domProps:{"innerHTML":_vm._s(item.eventDescription)}},[_vm._v("Description")]):_vm._e()])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_calculator_vue__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_calculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_calculator_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_calculator_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_calculator_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95de1370_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_risk_calculator_vue__ = __webpack_require__(1024);
function injectStyle (ssrContext) {
  __webpack_require__(1022)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-95de1370"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_calculator_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95de1370_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_risk_calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1023);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("acd88880", content, true, {});

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".phd-bg--red[data-v-95de1370]{background-color:#d22338}.phd-bg--red-alt[data-v-95de1370]{background-color:#c0161d}.phd-bg--gray-light[data-v-95de1370]{background-color:#f1f1f1}.phd-bg--gray[data-v-95de1370]{background-color:#979797}.phd-bg--gray-mid[data-v-95de1370]{background-color:#6d6e71}.phd-bg--gray-dark[data-v-95de1370]{background-color:#373737}.phd-bg--black[data-v-95de1370]{background-color:#000}.phd-bg--black-alt[data-v-95de1370]{background-color:#050606}.phd-bg--blue[data-v-95de1370]{background-color:#65baf5}.phd-bg--blue-alt[data-v-95de1370]{background-color:#034a80}.phd-bg--mustard[data-v-95de1370]{background-color:#f9b146}.phd-bg--mustard-alt[data-v-95de1370]{background-color:#a7762d}.phd-bg--lime[data-v-95de1370]{background-color:#abd02e}.phd-bg--lime-alt[data-v-95de1370]{background-color:#6b831c}.phd-bg--seafoam[data-v-95de1370]{background-color:#30b6a1}.phd-bg--seafoam-alt[data-v-95de1370]{background-color:#1d7164}.phd-font-color--red[data-v-95de1370]{color:#d22338}.phd-font-color--red-alt[data-v-95de1370]{color:#c0161d}.phd-font-color--gray-light[data-v-95de1370]{color:#f1f1f1}.phd-font-color--gray[data-v-95de1370]{color:#979797}.phd-font-color--gray-mid[data-v-95de1370]{color:#6d6e71}.phd-font-color--gray-dark[data-v-95de1370]{color:#373737}.phd-font-color--black[data-v-95de1370]{color:#000}.phd-font-color--black-alt[data-v-95de1370]{color:#050606}.phd-font-color--blue[data-v-95de1370]{color:#65baf5}.phd-font-color--blue-alt[data-v-95de1370]{color:#034a80}.phd-font-color--mustard[data-v-95de1370]{color:#f9b146}.phd-font-color--mustard-alt[data-v-95de1370]{color:#a7762d}.phd-font-color--lime[data-v-95de1370]{color:#abd02e}.phd-font-color--lime-alt[data-v-95de1370]{color:#6b831c}.phd-font-color--seafoam[data-v-95de1370]{color:#30b6a1}.phd-font-color--seafoam-alt[data-v-95de1370]{color:#1d7164}.phd-link-color--red[data-v-95de1370],.phd-link-color--red[data-v-95de1370]:hover{color:#d22338}.phd-link-color--red-alt[data-v-95de1370],.phd-link-color--red-alt[data-v-95de1370]:hover{color:#c0161d}.phd-link-color--gray-light[data-v-95de1370],.phd-link-color--gray-light[data-v-95de1370]:hover{color:#f1f1f1}.phd-link-color--gray[data-v-95de1370],.phd-link-color--gray[data-v-95de1370]:hover{color:#979797}.phd-link-color--gray-mid[data-v-95de1370],.phd-link-color--gray-mid[data-v-95de1370]:hover{color:#6d6e71}.phd-link-color--gray-dark[data-v-95de1370],.phd-link-color--gray-dark[data-v-95de1370]:hover{color:#373737}.phd-link-color--black[data-v-95de1370],.phd-link-color--black[data-v-95de1370]:hover{color:#000}.phd-link-color--black-alt[data-v-95de1370],.phd-link-color--black-alt[data-v-95de1370]:hover{color:#050606}.phd-link-color--blue[data-v-95de1370],.phd-link-color--blue[data-v-95de1370]:hover{color:#65baf5}.phd-link-color--blue-alt[data-v-95de1370],.phd-link-color--blue-alt[data-v-95de1370]:hover{color:#034a80}.phd-link-color--mustard[data-v-95de1370],.phd-link-color--mustard[data-v-95de1370]:hover{color:#f9b146}.phd-link-color--mustard-alt[data-v-95de1370],.phd-link-color--mustard-alt[data-v-95de1370]:hover{color:#a7762d}.phd-link-color--lime[data-v-95de1370],.phd-link-color--lime[data-v-95de1370]:hover{color:#abd02e}.phd-link-color--lime-alt[data-v-95de1370],.phd-link-color--lime-alt[data-v-95de1370]:hover{color:#6b831c}.phd-link-color--seafoam[data-v-95de1370],.phd-link-color--seafoam[data-v-95de1370]:hover{color:#30b6a1}.phd-link-color--seafoam-alt[data-v-95de1370],.phd-link-color--seafoam-alt[data-v-95de1370]:hover{color:#1d7164}.ecc-bg--cor-1[data-v-95de1370]{background-color:#67bf80}.ecc-bg--cor-2a[data-v-95de1370]{background-color:#ffd643}.ecc-bg--cor-2b[data-v-95de1370]{background-color:#f1a63e}.ecc-bg--cor-3nobenefit[data-v-95de1370]{background-color:#ef6e5d}.ecc-bg--cor-3harm[data-v-95de1370]{background-color:#e71e26}.ecc-bg--loe-br[data-v-95de1370]{background-color:#5c99cf}.ecc-bg--loe-cld[data-v-95de1370]{background-color:#9cbfe2}.ecc-bg--loe-a[data-v-95de1370]{background-color:#3776c8}.ecc-bg--loe-bnr[data-v-95de1370]{background-color:#5b99d1}.ecc-bg--loe-ceo[data-v-95de1370]{background-color:#bdd3ea}.ecc-bg--gray[data-v-95de1370]{background-color:#ebebeb}.ecc-bg--white[data-v-95de1370]{background-color:#fff}.ecc-bg--black[data-v-95de1370]{background-color:#000}.ecc-font-color--cor-1[data-v-95de1370]{color:#67bf80}.ecc-font-color--cor-2a[data-v-95de1370]{color:#ffd643}.ecc-font-color--cor-2b[data-v-95de1370]{color:#f1a63e}.ecc-font-color--cor-3nobenefit[data-v-95de1370]{color:#ef6e5d}.ecc-font-color--cor-3harm[data-v-95de1370]{color:#e71e26}.ecc-font-color--loe-br[data-v-95de1370]{color:#5c99cf}.ecc-font-color--loe-cld[data-v-95de1370]{color:#9cbfe2}.ecc-font-color--loe-a[data-v-95de1370]{color:#3776c8}.ecc-font-color--loe-bnr[data-v-95de1370]{color:#5b99d1}.ecc-font-color--loe-ceo[data-v-95de1370]{color:#bdd3ea}.ecc-font-color--gray[data-v-95de1370]{color:#ebebeb}.ecc-font-color--white[data-v-95de1370]{color:#fff}.ecc-font-color--black[data-v-95de1370]{color:#000}.c-aha-form textarea[data-v-95de1370],textarea.form-control[data-v-95de1370]{padding:10px;min-height:100px}.lower[data-v-95de1370]{margin-top:45px}@media (min-width:576px){.lower[data-v-95de1370]{margin-top:50px}}a.icon[data-v-95de1370]{width:30px;height:30px;background:#c10e21;border-radius:50%;border:thin solid #c10e21;color:#fff;font-weight:700;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}a.icon[data-v-95de1370]:hover{color:#fff}#recommendation[data-v-95de1370],#risk[data-v-95de1370],.toolTip[data-v-95de1370]{background-color:#e9ecef;opacity:1;padding:1rem .75rem;font-size:1rem;line-height:1.5;color:#495057;background-clip:padding-box;border:1px solid #c4cacf;border-radius:2px;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}", ""]);

// exports


/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phd-risk-calculator"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 h-100"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.hcmCalculatorFormula.apply(null, arguments)}}},[_c('h2',[_vm._v(" Hypertrophic Cardiomyopathy - Sudden Cardiac Death Risk Calculator")]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"age"}},[_vm._v("Age ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model:value.number",value:(_vm.age_range.value),expression:"age_range.value",arg:"value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","id":"age","placeholder":"16-80","aria-describedby":"ageyears"},domProps:{"value":(_vm.age_range.value)},on:{"blur":[_vm.validateAge,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.age_range, "value", _vm._n($event.target.value))}}}),_vm._v(" "),(_vm.isAgeValidate)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.age_range.errorMessage))]):_vm._e(),_vm._v(" "),(_vm.isAgeRequired)?_c('p',{staticClass:"text-danger requiredMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.age_range.requiredMessage))]):_vm._e(),_vm._v(" "),(!_vm.ageToolTip)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Age at evaluation in years (≥ 16 years of age).")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_c('p',{staticClass:"float-left",attrs:{"id":"ageyears"}},[_vm._v("years")]),_vm._v(" "),_c('a',{key:"age-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for age"},on:{"click":function($event){_vm.ageToolTip = !_vm.ageToolTip}}},[_vm._v("i")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model:value.number",value:(_vm.mlvwt_range.value),expression:"mlvwt_range.value",arg:"value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","id":"mlvwt","placeholder":"10-35","aria-describedby":"mm-value"},domProps:{"value":(_vm.mlvwt_range.value)},on:{"blur":[_vm.validateMlvwt,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mlvwt_range, "value", _vm._n($event.target.value))}}}),_vm._v(" "),(_vm.isMlvwtValidate)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.mlvwt_range.errorMessage))]):_vm._e(),_vm._v(" "),(_vm.isMlvwtRequired)?_c('p',{staticClass:"text-danger requiredMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.mlvwt_range.requiredMessage))]):_vm._e(),_vm._v(" "),(!_vm.mlvwtToolTip)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Wall thickness ≥ 30 millimeter in\n                                    any segment within the chamber by echocardiography or "),_vm._m(1),_vm._v(" imaging is\n                                    Massive "),_vm._m(2),_vm._v("; consideration\n                                    for this morphologic marker is also given to borderline values of ≥ 28 millimeter\n                                    in individual patients at the discretion of the treating cardiologist.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_vm._m(3),_vm._v(" "),_c('a',{key:"mlvwt-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Maximal left ventricular wall thickness"},on:{"click":function($event){_vm.mlvwtToolTip = !_vm.mlvwtToolTip}}},[_vm._v("i")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model:value.number",value:(_vm.lasize_range.value),expression:"lasize_range.value",arg:"value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","id":"la-size","placeholder":"28-67","aria-describedby":"mm-value"},domProps:{"value":(_vm.lasize_range.value)},on:{"blur":[_vm.validateLasize,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lasize_range, "value", _vm._n($event.target.value))}}}),_vm._v(" "),(_vm.isLasizeValidate)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.lasize_range.errorMessage))]):_vm._e(),_vm._v(" "),(_vm.isLasizeRequired)?_c('p',{staticClass:"text-danger requiredMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.lasize_range.requiredMessage))]):_vm._e(),_vm._v(" "),(!_vm.lasizeToolTip)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Echocardiographic continuous-wave\n                                  Doppler technique for left atrial diameter size in millimeters.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_c('span',{staticClass:"float-left"},[_vm._v("mm")]),_vm._v(" "),_c('a',{key:"lasize-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Left atrium diameter size"},on:{"click":function($event){_vm.lasizeToolTip = !_vm.lasizeToolTip}}},[_vm._v("i")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model:value.number",value:(_vm.maxlvot_range.value),expression:"maxlvot_range.value",arg:"value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","id":"max-lvot","placeholder":"2-154","aria-describedby":"mmHg-value"},domProps:{"value":(_vm.maxlvot_range.value)},on:{"blur":[_vm.validateMaxlovt,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.maxlvot_range, "value", _vm._n($event.target.value))}}}),_vm._v(" "),(_vm.isMaxlovtValidate)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.maxlvot_range.errorMessage))]):_vm._e(),_vm._v(" "),(_vm.isMaxlvotRequired)?_c('p',{staticClass:"text-danger requiredMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.maxlvot_range.requiredMessage))]):_vm._e(),_vm._v(" "),(!_vm.maxlvotToolTip)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Provocative maneuvers may be\n                                  necessary in patients with low or absent peak resting gradients (i.e., < 30 mm\n                                      Hg) to elicit the presence of "),_vm._m(6),_vm._v(",\n                                      particularly in patients with symptoms. Such maneuvers include standing,\n                                      Valsalva strain, amyl nitrite inhalation, or exercise (fasted or\n                                      postprandial), with simultaneous echocardiography performed using\n                                      continuous-wave Doppler technique to document the relation of the gradient\n                                      to occurrence of systolic anterior motion of the mitral valve.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_vm._m(7),_vm._v(" "),_c('a',{key:"maxlvot-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Left ventricular outflow tract obstruction"},on:{"click":function($event){_vm.maxlvotToolTip = !_vm.maxlvotToolTip}}},[_vm._v("i")])])])]),_vm._v(" "),_c('fieldset',{staticClass:"mt-5"},[_c('legend',{staticClass:"sr-only"},[_vm._v("Risk Factors for Sudden Cardiac Death")]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"fhscd_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.fhscd_pick),expression:"fhscd_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"fhscd","id":"fhscd_no","autocomplete":"off","value":"0","checked":"","aria-describedby":"abbrfhscd"},domProps:{"checked":_vm._q(_vm.fhscd_pick,_vm._n("0"))},on:{"change":function($event){_vm.fhscd_pick=_vm._n("0")}}}),_vm._v(" No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"fhscd_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.fhscd_pick),expression:"fhscd_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"fhscd","id":"fhscd_yes","autocomplete":"off","value":"1","aria-describedby":"abbrfhscd"},domProps:{"checked":_vm._q(_vm.fhscd_pick,_vm._n("1"))},on:{"change":function($event){_vm.fhscd_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"fhscd-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Family History of Sudden Cardiac Death"},on:{"click":function($event){_vm.fhscdToolTip = !_vm.fhscdToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(!_vm.fhscdToolTip)?_c('p',{staticClass:"toolTip",attrs:{"role":"alert"}},[_vm._v("Sudden death judged definitively or likely\n                                      attributable to "),_vm._m(9),_vm._v(" in ≥ 1\n                                      first-degree or close relatives who are ≤ 50 years of age. Close relatives\n                                          would generally be second-degree relatives; however, multiple SCDs in\n                                          tertiary relatives should also be considered relevant.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"nsvt_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.nsvt_pick),expression:"nsvt_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"nsvt","id":"nsvt_no","autocomplete":"off","value":"0","checked":"","aria-describedby":"abbrnsvt"},domProps:{"checked":_vm._q(_vm.nsvt_pick,_vm._n("0"))},on:{"change":function($event){_vm.nsvt_pick=_vm._n("0")}}}),_vm._v(" No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"nsvt_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.nsvt_pick),expression:"nsvt_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"nsvt","id":"nsvt_yes","autocomplete":"off","value":"1","aria-describedby":"abbrnsvt"},domProps:{"checked":_vm._q(_vm.nsvt_pick,_vm._n("1"))},on:{"change":function($event){_vm.nsvt_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"nsvt-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Non-sustained ventricular tachycardia"},on:{"click":function($event){_vm.nsvtToolTip = !_vm.nsvtToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(!_vm.nsvtToolTip)?_c('p',{staticClass:"toolTip",attrs:{"role":"alert"}},[_vm._v("It would seem most appropriate to place\n                                      greater weight on NSVT as a risk marker when runs are frequent (≥ 3), longer\n                                      (≥ 10 beats), and faster (≥ 200 bpm) occurring usually over 24 to 48 hours of\n                                      monitoring.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-4 col-form-label"},[_vm._v(" Unexplained Syncope")]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"unexSy_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.unexSy_pick),expression:"unexSy_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"unexSy","id":"unexSy_no","autocomplete":"off","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.unexSy_pick,_vm._n("0"))},on:{"change":function($event){_vm.unexSy_pick=_vm._n("0")}}}),_vm._v("\n                                          No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"unexSy_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.unexSy_pick),expression:"unexSy_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"unexSy","id":"unexSy_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.unexSy_pick,_vm._n("1"))},on:{"change":function($event){_vm.unexSy_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"unexsy-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Unexplained Syncope"},on:{"click":function($event){_vm.unexSyToolTip = !_vm.unexSyToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(!_vm.unexSyToolTip)?_c('p',{staticClass:"toolTip",attrs:{"role":"alert"}},[_vm._v("Greater than or equal to 1 unexplained\n                                      episodes involving acute transient loss of consciousness, judged by history\n                                      unlikely to be of neurocardiogenic (vasovagal) etiology, nor attributable to\n                                      LVOTO, and especially when occurring within 6 months of evaluation (events\n                                      beyond 5 years in the past do not appear to have relevance).")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"ef50_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.ef50_pick),expression:"ef50_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"ef50","id":"ef50_no","autocomplete":"off","value":"0","checked":"","aria-describedby":"abbref"},domProps:{"checked":_vm._q(_vm.ef50_pick,_vm._n("0"))},on:{"change":function($event){_vm.ef50_pick=_vm._n("0")}}}),_vm._v(" No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"ef50_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.ef50_pick),expression:"ef50_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"ef50","id":"ef50_yes","autocomplete":"off","value":"1","aria-describedby":"abbref"},domProps:{"checked":_vm._q(_vm.ef50_pick,_vm._n("1"))},on:{"change":function($event){_vm.ef50_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"ef50-iput",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Ejection fraction"},on:{"click":function($event){_vm.ef50ToolTip = !_vm.ef50ToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(!_vm.ef50ToolTip)?_c('p',{staticClass:"toolTip",attrs:{"role":"alert"}},[_vm._v("Systolic dysfunction with EF ≤ 50% by\n                                          echocardiography or CMR.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-4 col-form-label"},[_vm._v("Apical Aneurysm")]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"apAn_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.apAn_pick),expression:"apAn_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"apAn","id":"apAn_no","autocomplete":"off","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.apAn_pick,_vm._n("0"))},on:{"change":function($event){_vm.apAn_pick=_vm._n("0")}}}),_vm._v("\n                                          No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"apAn_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.apAn_pick),expression:"apAn_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"apAn","id":"apAn_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.apAn_pick,_vm._n("1"))},on:{"change":function($event){_vm.apAn_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"apan-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Apical Aneurysm"},on:{"click":function($event){_vm.apAnToolTip = !_vm.apAnToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(!_vm.apAnToolTip)?_c('p',{staticClass:"toolTip",attrs:{"role":"alert"}},[_vm._v("Discrete thin-walled dyskinetic or akinetic\n                                      segment of the most distal portion of the LV chamber; independent of size.\n                                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"elge_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.elge_pick),expression:"elge_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"elge","id":"elge_no","autocomplete":"off","value":"0","checked":"","aria-describedby":"abbr-elge"},domProps:{"checked":_vm._q(_vm.elge_pick,_vm._n("0"))},on:{"change":function($event){_vm.elge_pick=_vm._n("0")}}}),_vm._v(" No \n                                       ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"elge_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.elge_pick),expression:"elge_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"elge","id":"elge_yes","autocomplete":"off","value":"1","aria-describedby":"abbr-elge"},domProps:{"checked":_vm._q(_vm.elge_pick,_vm._n("1"))},on:{"change":function($event){_vm.elge_pick=_vm._n("1")}}}),_vm._v(" Yes \n                                    ")]),_vm._v(" "),_c('a',{key:"elge-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Extensive Late gadolinium enhancement"},on:{"click":function($event){_vm.elgeToolTip = !_vm.elgeToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(!_vm.elgeToolTip)?_c('p',{staticClass:"toolTip",attrs:{"role":"alert"}},[_vm._v("Diffuse and extensive LGE, representing\n                                      fibrosis, either quantified or estimated by visual inspection, comprising ≥\n                                      15% of LV mass.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(13),_vm._v(" "),_c('div',[_c('div',{attrs:{"id":"risk","aria-describedby":"abbr-scd"},domProps:{"innerHTML":_vm._s(_vm.risk.value)}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"recommendation"}},[_vm._v("Recommendation")]),_vm._v(" "),_c('div',{attrs:{"id":"recommendation"},domProps:{"innerHTML":_vm._s(_vm.recommendation)}})]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col col-md-12 text-center text-lg-left"},[_c('input',{key:"submit",staticClass:"btn btn-primary",attrs:{"type":"submit","value":"Submit"},on:{"click":_vm.formValidate}}),_vm._v(" "),_c('input',{key:"reset",staticClass:"btn btn-outline ml-3",attrs:{"type":"reset","value":"Reset"},on:{"click":_vm.resetForm}})])])])]),_vm._v(" "),_vm._m(14)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label text-uppercase",attrs:{"for":"mlvwt"}},[_c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"aria-label":"Maximal left ventricular wall thickness","title":"Maximal left ventricular wall thickness"}},[_vm._v("mlvwt\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"aria-label":"Cardiovascular magnetic resonance","title":"Cardiovascular magnetic resonance"}},[_vm._v("CMR")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"aria-label":"Left ventricular hypertrophy","title":"Left ventricular hypertrophy"}},[_vm._v("LVH")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"float-left"},[_c('abbr',{attrs:{"id":"mm-value","aria-label":"millimetre","title":"millimetre"}},[_vm._v("mm")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label",attrs:{"for":"la-size"}},[_c('span',{staticClass:"abbr",attrs:{"aria-label":"Left atrium"}},[_c('abbr',{attrs:{"title":"Left atrium"}},[_vm._v("LA")])]),_vm._v("\n                              Size\n                              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label",attrs:{"for":"max-lvot"}},[_c('span',{staticClass:"abbr",attrs:{"aria-label":"Maximal left ventricular outflow tract gradient"}},[_c('abbr',{attrs:{"title":"Maximal left ventricular outflow tract gradient"}},[_vm._v("Max LVOT\n                                          Gradient")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"aria-label":"Left ventricular outflow tract obstruction","title":"Left ventricular outflow tract obstruction"}},[_vm._v("LVOTO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr float-left"},[_c('abbr',{attrs:{"id":"mmHg-value","aria-label":"millimetre of mercury ","title":"millimetre of mercury "}},[_vm._v("mmHg")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-form-label text-uppercase"},[_c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"id":"abbrfhscd","aria-label":"Family History of Sudden Cardiac Death","title":"Family History of Sudden Cardiac Death"}},[_vm._v("fh scd")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"aria-label":"Hypertrophic cardiomyopathy","title":"Hypertrophic cardiomyopathy"}},[_vm._v("HCM")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-form-label text-uppercase"},[_c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"id":"abbrnsvt","aria-label":"Non-sustained ventricular tachycardia","title":"Non-sustained ventricular tachycardia"}},[_vm._v("nsvt")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-form-label"},[_c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"id":"abbref","aria-label":"Ejection fraction","title":"Ejection fraction"}},[_vm._v("EF")])]),_vm._v("\n                                  ≤ 50% \n                              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-form-label"},[_vm._v("Extensive "),_c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"aria-label":"Late gadolinium enhancement","id":"abbr-elge","title":"Late gadolinium enhancement"}},[_vm._v("LGE")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label",attrs:{"for":"risk"}},[_vm._v("Risk of "),_c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"id":"abbr-scd","aria-label":"Sudden Cardiac Death","title":"Sudden Cardiac Death"}},[_vm._v("SCD")])]),_vm._v(" at 5 years(%)")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('p',[_vm._v("This calculator is for use in patients with hypertrophic cardiomyopathy (HCM) who are ≥ 16 years of age with > 1 major SCD risk factors, estimating 5-year SCD risk may aid patients in understanding the magnitude of their individual risk for SCD to further assist in ICD decision-making.")]),_vm._v(" "),_c('p',[_vm._v("ICD decisions in pediatric patients with HCM are based on ≥ 1 of these major risk factors: family history of HCM SCD, NSVT on ambulatory monitor, massive left ventricular hypertrophy, and unexplained syncope.")]),_vm._v(" "),_c('p',[_vm._v("Children who are 16 to 18 years of age accounted for 2% of the cohort used for the adult-based risk calculator. The low representation of this age group should be considered if calculating risk estimates for patients in this age range.")]),_vm._v(" "),_c('p',[_vm._v("The HCM-SCD Calculator should not be used in:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Pediatric patients (< 16 years)")]),_vm._v(" "),_c('li',[_vm._v("Elite/competitive athletes")]),_vm._v(" "),_c('li',[_vm._v("HCM associated with metabolic diseases (e.g., Anderson-Fabry disease), and syndromes (e.g., Noonan syndrome).")]),_vm._v(" "),_c('li',[_vm._v("Patients with a previous history of aborted SCD or sustained ventricular arrhythmia who should be treated with an ICD for secondary prevention.")])]),_vm._v(" "),_c('p',[_vm._v("Caution should be exercised when assessing the SCD in patients following invasive reduction in left ventricular outflow tract obstruction with myectomy or alcohol septal ablation.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _eccReferences = __webpack_require__(1026);

var _eccReferences2 = _interopRequireDefault(_eccReferences);

var _svgMap = __webpack_require__(1028);

var _svgMap2 = _interopRequireDefault(_svgMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_vue2['default'].component('ecc-references', _eccReferences2['default']); // ECC Components

_vue2['default'].component('svg-map', _svgMap2['default']);

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ecc_references_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ecc_references_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ecc_references_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ecc_references_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ecc_references_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cf7d04e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ecc_references_vue__ = __webpack_require__(1027);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ecc_references_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cf7d04e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ecc_references_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"eccReferences",staticClass:"ecc-references"},[_c('div',{staticClass:"container ecc-references__container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',[_vm._v("References")]),_vm._v(" "),(_vm.references.length)?_c('ol',{staticClass:"ecc-references__list"},_vm._l((_vm.references),function(item){return _c('li',{key:item.id,ref:item.id,refInFor:true,staticClass:"ecc-references__list-item",class:{ active: _vm.activeId === item.id },attrs:{"id":item.id}},[_c('button',{staticClass:"ecc-references__list-item-button",attrs:{"aria-label":"Return to text."},on:{"click":_vm.returnToText}},[_c('img',{attrs:{"src":"/assets/icons/up-arrow.svg","aria-hidden":"true"}})]),_vm._v(" "),_c('div',[_c('span',{staticClass:"ecc-references__list-item-number"},[_vm._v(_vm._s(item.refnum)+".")]),_vm._v(" "),_c('div',{staticClass:"ecc-references__list-item-content",domProps:{"innerHTML":_vm._s(item.content)}})])])}),0):_c('p',[_vm._v("Empty data was passed to the 'references' property for this component.")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_svg_map_vue__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_svg_map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_svg_map_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_svg_map_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_svg_map_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4dab5d2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_svg_map_vue__ = __webpack_require__(1029);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_svg_map_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4dab5d2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_svg_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.amchartsPresent && _vm.mapDataPresent)?_c('div',{staticClass:"c-svg-map"},[(_vm.mapSettings.showAccessibleStateSelector)?_c('div',{staticClass:"d-flex pb-2"},[_c('select',{ref:"stateselector",staticClass:"c-svg-map__state-selector mr-3",attrs:{"id":"svg-map-state-selector","aria-label":"Select a state to display details."}},[_c('option',{attrs:{"value":""},domProps:{"innerHTML":_vm._s(_vm.mapSettings.blankSelectorOptionLabel)}}),_vm._v(" "),_vm._l((_vm.statesList),function(state){return _c('option',{key:state.id,domProps:{"value":state.id,"innerHTML":_vm._s(state.name)}})})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-primary c-svg-map__state-selector-button",on:{"click":_vm.selectState}},[_vm._v(_vm._s(_vm.mapSettings.selectorButtonLabel))])]):_vm._e(),_vm._v(" "),_c('div',{ref:"chartdiv",style:({ height: this.mapSettings.mapHeight })})]):(!_vm.amchartsPresent && _vm.mapDataPresent)?_c('div',{staticClass:"c-svg-map__error"},[_c('p',[_vm._v("JavaScript Mapping Code Not Present. Could not draw the map.")])]):(_vm.amchartsPresent && !_vm.mapDataPresent)?_c('div',{staticClass:"c-svg-map__error"},[_c('p',[_vm._v("Mapping data not present. Could not draw the map.")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6819b360_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__(1033);
function injectStyle (ssrContext) {
  __webpack_require__(1031)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6819b360_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1032);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("7387061e", content, true, {});

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".phd-bg--red{background-color:#d22338}.phd-bg--red-alt{background-color:#c0161d}.phd-bg--gray-light{background-color:#f1f1f1}.phd-bg--gray{background-color:#979797}.phd-bg--gray-mid{background-color:#6d6e71}.phd-bg--gray-dark{background-color:#373737}.phd-bg--black{background-color:#000}.phd-bg--black-alt{background-color:#050606}.phd-bg--blue{background-color:#65baf5}.phd-bg--blue-alt{background-color:#034a80}.phd-bg--mustard{background-color:#f9b146}.phd-bg--mustard-alt{background-color:#a7762d}.phd-bg--lime{background-color:#abd02e}.phd-bg--lime-alt{background-color:#6b831c}.phd-bg--seafoam{background-color:#30b6a1}.phd-bg--seafoam-alt{background-color:#1d7164}.phd-font-color--red{color:#d22338}.phd-font-color--red-alt{color:#c0161d}.phd-font-color--gray-light{color:#f1f1f1}.phd-font-color--gray{color:#979797}.phd-font-color--gray-mid{color:#6d6e71}.phd-font-color--gray-dark{color:#373737}.phd-font-color--black{color:#000}.phd-font-color--black-alt{color:#050606}.phd-font-color--blue{color:#65baf5}.phd-font-color--blue-alt{color:#034a80}.phd-font-color--mustard{color:#f9b146}.phd-font-color--mustard-alt{color:#a7762d}.phd-font-color--lime{color:#abd02e}.phd-font-color--lime-alt{color:#6b831c}.phd-font-color--seafoam{color:#30b6a1}.phd-font-color--seafoam-alt{color:#1d7164}.phd-link-color--red,.phd-link-color--red:hover{color:#d22338}.phd-link-color--red-alt,.phd-link-color--red-alt:hover{color:#c0161d}.phd-link-color--gray-light,.phd-link-color--gray-light:hover{color:#f1f1f1}.phd-link-color--gray,.phd-link-color--gray:hover{color:#979797}.phd-link-color--gray-mid,.phd-link-color--gray-mid:hover{color:#6d6e71}.phd-link-color--gray-dark,.phd-link-color--gray-dark:hover{color:#373737}.phd-link-color--black,.phd-link-color--black:hover{color:#000}.phd-link-color--black-alt,.phd-link-color--black-alt:hover{color:#050606}.phd-link-color--blue,.phd-link-color--blue:hover{color:#65baf5}.phd-link-color--blue-alt,.phd-link-color--blue-alt:hover{color:#034a80}.phd-link-color--mustard,.phd-link-color--mustard:hover{color:#f9b146}.phd-link-color--mustard-alt,.phd-link-color--mustard-alt:hover{color:#a7762d}.phd-link-color--lime,.phd-link-color--lime:hover{color:#abd02e}.phd-link-color--lime-alt,.phd-link-color--lime-alt:hover{color:#6b831c}.phd-link-color--seafoam,.phd-link-color--seafoam:hover{color:#30b6a1}.phd-link-color--seafoam-alt,.phd-link-color--seafoam-alt:hover{color:#1d7164}.ecc-bg--cor-1{background-color:#67bf80}.ecc-bg--cor-2a{background-color:#ffd643}.ecc-bg--cor-2b{background-color:#f1a63e}.ecc-bg--cor-3nobenefit{background-color:#ef6e5d}.ecc-bg--cor-3harm{background-color:#e71e26}.ecc-bg--loe-br{background-color:#5c99cf}.ecc-bg--loe-cld{background-color:#9cbfe2}.ecc-bg--loe-a{background-color:#3776c8}.ecc-bg--loe-bnr{background-color:#5b99d1}.ecc-bg--loe-ceo{background-color:#bdd3ea}.ecc-bg--gray{background-color:#ebebeb}.ecc-bg--white{background-color:#fff}.ecc-bg--black{background-color:#000}.ecc-font-color--cor-1{color:#67bf80}.ecc-font-color--cor-2a{color:#ffd643}.ecc-font-color--cor-2b{color:#f1a63e}.ecc-font-color--cor-3nobenefit{color:#ef6e5d}.ecc-font-color--cor-3harm{color:#e71e26}.ecc-font-color--loe-br{color:#5c99cf}.ecc-font-color--loe-cld{color:#9cbfe2}.ecc-font-color--loe-a{color:#3776c8}.ecc-font-color--loe-bnr{color:#5b99d1}.ecc-font-color--loe-ceo{color:#bdd3ea}.ecc-font-color--gray{color:#ebebeb}.ecc-font-color--white{color:#fff}.ecc-font-color--black{color:#000}body>iframe{display:none}.app__sidebar{background:#f8f9fa;padding:10px}.app__content{padding:0}.anchor{display:block;position:relative;top:-60px;visibility:hidden}.c-sidebar-nav__header{display:block;font-weight:600;text-transform:uppercase;margin-bottom:10px;padding-top:8px}.c-sidebar-nav__links{list-style-type:none;margin:0 0 20px;padding:0 0 20px;font-size:14px;border-bottom:1px solid #ccc}.c-sidebar-nav__link{display:block;padding:4px 0;color:#495057;cursor:pointer}.c-sidebar-nav__link.router-link-exact-active{font-weight:600;color:#000}.c-sidebar-nav>:last-child{border:none;margin:0;padding:0}.hljs{font-family:Inconsolata,Monaco,Andale Mono,Lucida Console,Bitstream Vera Sans Mono,Courier New,Courier,monospace!important;font-size:17px;overflow-x:auto;position:relative;background-color:#f9f9f9;-webkit-box-shadow:0 1px 1px rgba(0,0,0,.125);box-shadow:0 1px 1px rgba(0,0,0,.125);padding:1em;margin-bottom:1em}@media (min-width:768px){.app__sidebar{position:sticky;top:58.5px;z-index:1000;height:calc(100vh - 58.5px);overflow-y:auto;overflow-x:hidden;padding:20px}}@media (-ms-high-contrast:none){.app__sidebar{position:static;top:auto;height:auto;overflow:visible}}.nav-demo .c-nav-dropdown{margin-top:1.25rem}.nav-demo .dropdown-item{padding:4px 0}.nav-demo .dropdown-item.active,.nav-demo .dropdown-item:active,.nav-demo .dropdown-item:hover{color:#495057;background:transparent}.page-heading{color:#565656;font-family:Montserrat,Arial,sans-serif;font-size:34px;font-weight:400;text-transform:uppercase;margin:60px 0}.has-focus{color:#495057;background-color:#fff;border-color:#4d90fe;outline:0;-webkit-box-shadow:0 0 0 1px #4d90fe;box-shadow:0 0 0 1px #4d90fe}@media (max-width:1199.98px){.page-heading{margin:30px 0}}@media print{.app__sidebar,.page-heading{display:none}}", ""]);

// exports


/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('b-navbar',{staticClass:"sticky-top nav-demo",attrs:{"toggleable":"md","type":"dark","variant":"dark"}},[_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-navbar-brand',{attrs:{"to":'/'}},[_vm._v("AHA Component Library")]),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('li',{staticClass:"c-main-nav__item"},[_c('router-link',{staticClass:"c-top-nav__link c-cta h-color--white",attrs:{"to":'/ui-kit'}},[_vm._v("UI Kit")])],1),_vm._v(" "),_c('li',{staticClass:"c-main-nav__item"},[_c('router-link',{staticClass:"c-top-nav__link c-cta h-color--white",attrs:{"to":'/pages'}},[_vm._v("Layouts")])],1),_vm._v(" "),_c('li',{staticClass:"c-main-nav__item c-mega-nav"},[_c('router-link',{staticClass:"c-top-nav__link c-cta h-color--white",attrs:{"to":'/snackable'}},[_vm._v("Snackables")])],1),_vm._v(" "),_c('li',{staticClass:"c-main-nav__item c-mega-nav"},[_c('router-link',{staticClass:"c-top-nav__link c-cta h-color--white",attrs:{"to":'/components'}},[_vm._v("Components")])],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"app__sidebar col-md-3 col-xl-2 col-12"},[_c('router-view',{attrs:{"name":"sidebar-nav"}})],1),_vm._v(" "),_c('main',{staticClass:"app__content col-md-9 col-xl-10 col-12",attrs:{"id":"main-content","tabindex":"-1"}},[_c('router-view')],1)])]),_vm._v(" "),_c('aha-speed-bump'),_vm._v(" "),_c('aha-sso-interceptor'),_vm._v(" "),_c('span',{attrs:{"tabindex":"0"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */,
/* 1036 */,
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1038);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("5edb3576", content, true, {});

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".phd-bg--red[data-v-e315e6a2]{background-color:#d22338}.phd-bg--red-alt[data-v-e315e6a2]{background-color:#c0161d}.phd-bg--gray-light[data-v-e315e6a2]{background-color:#f1f1f1}.phd-bg--gray[data-v-e315e6a2]{background-color:#979797}.phd-bg--gray-mid[data-v-e315e6a2]{background-color:#6d6e71}.phd-bg--gray-dark[data-v-e315e6a2]{background-color:#373737}.phd-bg--black[data-v-e315e6a2]{background-color:#000}.phd-bg--black-alt[data-v-e315e6a2]{background-color:#050606}.phd-bg--blue[data-v-e315e6a2]{background-color:#65baf5}.phd-bg--blue-alt[data-v-e315e6a2]{background-color:#034a80}.phd-bg--mustard[data-v-e315e6a2]{background-color:#f9b146}.phd-bg--mustard-alt[data-v-e315e6a2]{background-color:#a7762d}.phd-bg--lime[data-v-e315e6a2]{background-color:#abd02e}.phd-bg--lime-alt[data-v-e315e6a2]{background-color:#6b831c}.phd-bg--seafoam[data-v-e315e6a2]{background-color:#30b6a1}.phd-bg--seafoam-alt[data-v-e315e6a2]{background-color:#1d7164}.phd-font-color--red[data-v-e315e6a2]{color:#d22338}.phd-font-color--red-alt[data-v-e315e6a2]{color:#c0161d}.phd-font-color--gray-light[data-v-e315e6a2]{color:#f1f1f1}.phd-font-color--gray[data-v-e315e6a2]{color:#979797}.phd-font-color--gray-mid[data-v-e315e6a2]{color:#6d6e71}.phd-font-color--gray-dark[data-v-e315e6a2]{color:#373737}.phd-font-color--black[data-v-e315e6a2]{color:#000}.phd-font-color--black-alt[data-v-e315e6a2]{color:#050606}.phd-font-color--blue[data-v-e315e6a2]{color:#65baf5}.phd-font-color--blue-alt[data-v-e315e6a2]{color:#034a80}.phd-font-color--mustard[data-v-e315e6a2]{color:#f9b146}.phd-font-color--mustard-alt[data-v-e315e6a2]{color:#a7762d}.phd-font-color--lime[data-v-e315e6a2]{color:#abd02e}.phd-font-color--lime-alt[data-v-e315e6a2]{color:#6b831c}.phd-font-color--seafoam[data-v-e315e6a2]{color:#30b6a1}.phd-font-color--seafoam-alt[data-v-e315e6a2]{color:#1d7164}.phd-link-color--red[data-v-e315e6a2],.phd-link-color--red[data-v-e315e6a2]:hover{color:#d22338}.phd-link-color--red-alt[data-v-e315e6a2],.phd-link-color--red-alt[data-v-e315e6a2]:hover{color:#c0161d}.phd-link-color--gray-light[data-v-e315e6a2],.phd-link-color--gray-light[data-v-e315e6a2]:hover{color:#f1f1f1}.phd-link-color--gray[data-v-e315e6a2],.phd-link-color--gray[data-v-e315e6a2]:hover{color:#979797}.phd-link-color--gray-mid[data-v-e315e6a2],.phd-link-color--gray-mid[data-v-e315e6a2]:hover{color:#6d6e71}.phd-link-color--gray-dark[data-v-e315e6a2],.phd-link-color--gray-dark[data-v-e315e6a2]:hover{color:#373737}.phd-link-color--black[data-v-e315e6a2],.phd-link-color--black[data-v-e315e6a2]:hover{color:#000}.phd-link-color--black-alt[data-v-e315e6a2],.phd-link-color--black-alt[data-v-e315e6a2]:hover{color:#050606}.phd-link-color--blue[data-v-e315e6a2],.phd-link-color--blue[data-v-e315e6a2]:hover{color:#65baf5}.phd-link-color--blue-alt[data-v-e315e6a2],.phd-link-color--blue-alt[data-v-e315e6a2]:hover{color:#034a80}.phd-link-color--mustard[data-v-e315e6a2],.phd-link-color--mustard[data-v-e315e6a2]:hover{color:#f9b146}.phd-link-color--mustard-alt[data-v-e315e6a2],.phd-link-color--mustard-alt[data-v-e315e6a2]:hover{color:#a7762d}.phd-link-color--lime[data-v-e315e6a2],.phd-link-color--lime[data-v-e315e6a2]:hover{color:#abd02e}.phd-link-color--lime-alt[data-v-e315e6a2],.phd-link-color--lime-alt[data-v-e315e6a2]:hover{color:#6b831c}.phd-link-color--seafoam[data-v-e315e6a2],.phd-link-color--seafoam[data-v-e315e6a2]:hover{color:#30b6a1}.phd-link-color--seafoam-alt[data-v-e315e6a2],.phd-link-color--seafoam-alt[data-v-e315e6a2]:hover{color:#1d7164}.ecc-bg--cor-1[data-v-e315e6a2]{background-color:#67bf80}.ecc-bg--cor-2a[data-v-e315e6a2]{background-color:#ffd643}.ecc-bg--cor-2b[data-v-e315e6a2]{background-color:#f1a63e}.ecc-bg--cor-3nobenefit[data-v-e315e6a2]{background-color:#ef6e5d}.ecc-bg--cor-3harm[data-v-e315e6a2]{background-color:#e71e26}.ecc-bg--loe-br[data-v-e315e6a2]{background-color:#5c99cf}.ecc-bg--loe-cld[data-v-e315e6a2]{background-color:#9cbfe2}.ecc-bg--loe-a[data-v-e315e6a2]{background-color:#3776c8}.ecc-bg--loe-bnr[data-v-e315e6a2]{background-color:#5b99d1}.ecc-bg--loe-ceo[data-v-e315e6a2]{background-color:#bdd3ea}.ecc-bg--gray[data-v-e315e6a2]{background-color:#ebebeb}.ecc-bg--white[data-v-e315e6a2]{background-color:#fff}.ecc-bg--black[data-v-e315e6a2]{background-color:#000}.ecc-font-color--cor-1[data-v-e315e6a2]{color:#67bf80}.ecc-font-color--cor-2a[data-v-e315e6a2]{color:#ffd643}.ecc-font-color--cor-2b[data-v-e315e6a2]{color:#f1a63e}.ecc-font-color--cor-3nobenefit[data-v-e315e6a2]{color:#ef6e5d}.ecc-font-color--cor-3harm[data-v-e315e6a2]{color:#e71e26}.ecc-font-color--loe-br[data-v-e315e6a2]{color:#5c99cf}.ecc-font-color--loe-cld[data-v-e315e6a2]{color:#9cbfe2}.ecc-font-color--loe-a[data-v-e315e6a2]{color:#3776c8}.ecc-font-color--loe-bnr[data-v-e315e6a2]{color:#5b99d1}.ecc-font-color--loe-ceo[data-v-e315e6a2]{color:#bdd3ea}.ecc-font-color--gray[data-v-e315e6a2]{color:#ebebeb}.ecc-font-color--white[data-v-e315e6a2]{color:#fff}.ecc-font-color--black[data-v-e315e6a2]{color:#000}.component[data-v-e315e6a2]{margin:80px 0}.component__heading[data-v-e315e6a2]{color:#898989;font-family:Montserrat,Arial,sans-serif;font-size:20px;font-weight:600;margin-bottom:30px;letter-spacing:-.1px;text-transform:uppercase}@media (max-width:1199.98px){.component[data-v-e315e6a2]{margin:40px 0}}", ""]);

// exports


/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"component"},[_c('h2',{staticClass:"component__heading"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac9564c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_buttons_vue__ = __webpack_require__(1043);
function injectStyle (ssrContext) {
  __webpack_require__(1041)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac9564c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_buttons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1042);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("0ddc0dab", content, true, {});

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "th{color:#6d6e71}", ""]);

// exports


/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table button-table"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Primary")]),_vm._v(" "),_c('th',[_vm._v("Secondary")]),_vm._v(" "),_c('th',[_vm._v("Tertiary")]),_vm._v(" "),_c('th',[_vm._v("Primary Link")]),_vm._v(" "),_c('th',[_vm._v("Secondary Link")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',[_vm._v("Default")]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-primary"},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-outline-primary"},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-tertiary"},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-link btn-link--cta"},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-secondary-link"},[_vm._v("Button")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Hover")]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-primary active"},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-outline-primary active"},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-tertiary active"},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-link btn-link--cta active"},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-secondary-link"},[_vm._v("Button")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Disabled")]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-primary",attrs:{"disabled":""}},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-outline-secondary",attrs:{"disabled":""}},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-tertiary",attrs:{"disabled":""}},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-link btn-link--cta",attrs:{"disabled":""}},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-link",attrs:{"disabled":""}},[_vm._v("Button")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Active")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-link btn-link--cta"},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-secondary-link"},[_vm._v("Button")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d70747e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_color_palette_vue__ = __webpack_require__(1047);
function injectStyle (ssrContext) {
  __webpack_require__(1045)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d70747e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d70747e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_color_palette_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1046);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("d5261b06", content, true, {});

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".phd-bg--red[data-v-d70747e4]{background-color:#d22338}.phd-bg--red-alt[data-v-d70747e4]{background-color:#c0161d}.phd-bg--gray-light[data-v-d70747e4]{background-color:#f1f1f1}.phd-bg--gray[data-v-d70747e4]{background-color:#979797}.phd-bg--gray-mid[data-v-d70747e4]{background-color:#6d6e71}.phd-bg--gray-dark[data-v-d70747e4]{background-color:#373737}.phd-bg--black[data-v-d70747e4]{background-color:#000}.phd-bg--black-alt[data-v-d70747e4]{background-color:#050606}.phd-bg--blue[data-v-d70747e4]{background-color:#65baf5}.phd-bg--blue-alt[data-v-d70747e4]{background-color:#034a80}.phd-bg--mustard[data-v-d70747e4]{background-color:#f9b146}.phd-bg--mustard-alt[data-v-d70747e4]{background-color:#a7762d}.phd-bg--lime[data-v-d70747e4]{background-color:#abd02e}.phd-bg--lime-alt[data-v-d70747e4]{background-color:#6b831c}.phd-bg--seafoam[data-v-d70747e4]{background-color:#30b6a1}.phd-bg--seafoam-alt[data-v-d70747e4]{background-color:#1d7164}.phd-font-color--red[data-v-d70747e4]{color:#d22338}.phd-font-color--red-alt[data-v-d70747e4]{color:#c0161d}.phd-font-color--gray-light[data-v-d70747e4]{color:#f1f1f1}.phd-font-color--gray[data-v-d70747e4]{color:#979797}.phd-font-color--gray-mid[data-v-d70747e4]{color:#6d6e71}.phd-font-color--gray-dark[data-v-d70747e4]{color:#373737}.phd-font-color--black[data-v-d70747e4]{color:#000}.phd-font-color--black-alt[data-v-d70747e4]{color:#050606}.phd-font-color--blue[data-v-d70747e4]{color:#65baf5}.phd-font-color--blue-alt[data-v-d70747e4]{color:#034a80}.phd-font-color--mustard[data-v-d70747e4]{color:#f9b146}.phd-font-color--mustard-alt[data-v-d70747e4]{color:#a7762d}.phd-font-color--lime[data-v-d70747e4]{color:#abd02e}.phd-font-color--lime-alt[data-v-d70747e4]{color:#6b831c}.phd-font-color--seafoam[data-v-d70747e4]{color:#30b6a1}.phd-font-color--seafoam-alt[data-v-d70747e4]{color:#1d7164}.phd-link-color--red[data-v-d70747e4],.phd-link-color--red[data-v-d70747e4]:hover{color:#d22338}.phd-link-color--red-alt[data-v-d70747e4],.phd-link-color--red-alt[data-v-d70747e4]:hover{color:#c0161d}.phd-link-color--gray-light[data-v-d70747e4],.phd-link-color--gray-light[data-v-d70747e4]:hover{color:#f1f1f1}.phd-link-color--gray[data-v-d70747e4],.phd-link-color--gray[data-v-d70747e4]:hover{color:#979797}.phd-link-color--gray-mid[data-v-d70747e4],.phd-link-color--gray-mid[data-v-d70747e4]:hover{color:#6d6e71}.phd-link-color--gray-dark[data-v-d70747e4],.phd-link-color--gray-dark[data-v-d70747e4]:hover{color:#373737}.phd-link-color--black[data-v-d70747e4],.phd-link-color--black[data-v-d70747e4]:hover{color:#000}.phd-link-color--black-alt[data-v-d70747e4],.phd-link-color--black-alt[data-v-d70747e4]:hover{color:#050606}.phd-link-color--blue[data-v-d70747e4],.phd-link-color--blue[data-v-d70747e4]:hover{color:#65baf5}.phd-link-color--blue-alt[data-v-d70747e4],.phd-link-color--blue-alt[data-v-d70747e4]:hover{color:#034a80}.phd-link-color--mustard[data-v-d70747e4],.phd-link-color--mustard[data-v-d70747e4]:hover{color:#f9b146}.phd-link-color--mustard-alt[data-v-d70747e4],.phd-link-color--mustard-alt[data-v-d70747e4]:hover{color:#a7762d}.phd-link-color--lime[data-v-d70747e4],.phd-link-color--lime[data-v-d70747e4]:hover{color:#abd02e}.phd-link-color--lime-alt[data-v-d70747e4],.phd-link-color--lime-alt[data-v-d70747e4]:hover{color:#6b831c}.phd-link-color--seafoam[data-v-d70747e4],.phd-link-color--seafoam[data-v-d70747e4]:hover{color:#30b6a1}.phd-link-color--seafoam-alt[data-v-d70747e4],.phd-link-color--seafoam-alt[data-v-d70747e4]:hover{color:#1d7164}.ecc-bg--cor-1[data-v-d70747e4]{background-color:#67bf80}.ecc-bg--cor-2a[data-v-d70747e4]{background-color:#ffd643}.ecc-bg--cor-2b[data-v-d70747e4]{background-color:#f1a63e}.ecc-bg--cor-3nobenefit[data-v-d70747e4]{background-color:#ef6e5d}.ecc-bg--cor-3harm[data-v-d70747e4]{background-color:#e71e26}.ecc-bg--loe-br[data-v-d70747e4]{background-color:#5c99cf}.ecc-bg--loe-cld[data-v-d70747e4]{background-color:#9cbfe2}.ecc-bg--loe-a[data-v-d70747e4]{background-color:#3776c8}.ecc-bg--loe-bnr[data-v-d70747e4]{background-color:#5b99d1}.ecc-bg--loe-ceo[data-v-d70747e4]{background-color:#bdd3ea}.ecc-bg--gray[data-v-d70747e4]{background-color:#ebebeb}.ecc-bg--white[data-v-d70747e4]{background-color:#fff}.ecc-bg--black[data-v-d70747e4]{background-color:#000}.ecc-font-color--cor-1[data-v-d70747e4]{color:#67bf80}.ecc-font-color--cor-2a[data-v-d70747e4]{color:#ffd643}.ecc-font-color--cor-2b[data-v-d70747e4]{color:#f1a63e}.ecc-font-color--cor-3nobenefit[data-v-d70747e4]{color:#ef6e5d}.ecc-font-color--cor-3harm[data-v-d70747e4]{color:#e71e26}.ecc-font-color--loe-br[data-v-d70747e4]{color:#5c99cf}.ecc-font-color--loe-cld[data-v-d70747e4]{color:#9cbfe2}.ecc-font-color--loe-a[data-v-d70747e4]{color:#3776c8}.ecc-font-color--loe-bnr[data-v-d70747e4]{color:#5b99d1}.ecc-font-color--loe-ceo[data-v-d70747e4]{color:#bdd3ea}.ecc-font-color--gray[data-v-d70747e4]{color:#ebebeb}.ecc-font-color--white[data-v-d70747e4]{color:#fff}.ecc-font-color--black[data-v-d70747e4]{color:#000}.color-palette__header[data-v-d70747e4]{padding:5px}.color-palette__colors[data-v-d70747e4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:3px;overflow:hidden;font-size:14px}.color-palette__colors>[data-v-d70747e4]{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center;color:#fff;padding:20px 0}.color-palette__color--red[data-v-d70747e4]{background:#c10e21}.color-palette__color--red-alt[data-v-d70747e4]{background:#e11127}.color-palette__color--dark-gray[data-v-d70747e4]{background:#6d6e71}.color-palette__color--dark-gray-alt[data-v-d70747e4]{background:#979797}.color-palette__color--black[data-v-d70747e4]{background:#000}.color-palette__color--black-alt[data-v-d70747e4]{background:#222328}.color-palette__color--blue[data-v-d70747e4]{background:#334cd5}.color-palette__color--blue-alt[data-v-d70747e4]{background:#3b55e6}.color-palette__color--aqua[data-v-d70747e4]{background:#51dde9}.color-palette__color--aqua-alt[data-v-d70747e4]{background:#32cdda}.color-palette__color--green[data-v-d70747e4]{background:#468438}.color-palette__color--green-alt[data-v-d70747e4]{background:#426a3a}.color-palette__color--orange[data-v-d70747e4]{background:#fe5339}.color-palette__color--orange-alt[data-v-d70747e4]{background:#eb4e36}.color-palette__color--yellow-orange[data-v-d70747e4]{background:#f8b416}.color-palette__color--yellow-orange-alt[data-v-d70747e4]{background:#e28413}", ""]);

// exports


/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card color-palette"},[_c('div',{staticClass:"card-header color-palette__header"},[_c('div',{staticClass:"color-palette__colors"},[_c('div',{staticClass:"color-palette__color--red"},[_vm._v("#C10E21")]),_vm._v(" "),_c('div',{staticClass:"color-palette__color--red-alt"},[_vm._v("#E11127")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n                    Primary\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card color-palette"},[_c('div',{staticClass:"card-header color-palette__header"},[_c('div',{staticClass:"color-palette__colors"},[_c('div',{staticClass:"color-palette__color--dark-gray"},[_vm._v("#6D6E71")]),_vm._v(" "),_c('div',{staticClass:"color-palette__color--dark-gray-alt"},[_vm._v("#979797")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n                    Light\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card color-palette"},[_c('div',{staticClass:"card-header color-palette__header"},[_c('div',{staticClass:"color-palette__colors"},[_c('div',{staticClass:"color-palette__color--black"},[_vm._v("#000000")]),_vm._v(" "),_c('div',{staticClass:"color-palette__color--black-alt"},[_vm._v("#222328")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n                    Dark\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card color-palette"},[_c('div',{staticClass:"card-header color-palette__header"},[_c('div',{staticClass:"color-palette__colors"},[_c('div',{staticClass:"color-palette__color--blue"},[_vm._v("#334CD5")]),_vm._v(" "),_c('div',{staticClass:"color-palette__color--blue-alt"},[_vm._v("#3B55E6")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n                    Alt\n                ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_vue__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69cf78e4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dropdown_vue__ = __webpack_require__(1050);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69cf78e4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _vueFunctionalDataMerge = __webpack_require__(119);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_vue2['default'].component('aha-dropdown-button', {
    functional: true,
    render: function render(h, _ref) {
        var props = _ref.props,
            data = _ref.data,
            parent = _ref.parent,
            children = _ref.children;

        return h('button', (0, _vueFunctionalDataMerge.mergeData)(data, {
            props: props,
            staticClass: 'dropdown-item',
            attrs: {
                type: 'button',
                role: props.role,
                disabled: props.disabled
            },
            on: {
                keydown: function keydown(e) {
                    // If we're trying to tab inside of the dropdown, close it
                    if (e.keyCode === 9 || e.keyCode === 16 && e.keyCode === 9) {
                        parent.$root.$emit('clicked::link', e);
                    }
                },
                click: function click(e) {
                    parent.$root.$emit('clicked::link', e);
                }
            }
        }), children);
    },
    props: {
        disabled: {
            type: Boolean,
            'default': false
        },
        role: {
            type: String,
            'default': 'option'
        }
    }
});

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("\n        "+_vm._s(_vm.currentDropdown)+"\n        "),_c('input',{ref:"button",attrs:{"id":"ddown1-value","type":"hidden"},domProps:{"value":_vm.selected}}),_vm._v(" "),_c('b-dropdown',{staticClass:"dropdown button--select",attrs:{"size":_vm.size,"id":"ddown1","text":_vm.currentDropdown.text,"variant":"btn","role":"listbox"},on:{"hidden":_vm.onHidden}},_vm._l((_vm.options),function(option){return _c('aha-dropdown-button',{key:option.value,on:{"click":function($event){_vm.selected = option.value}}},[_vm._v(_vm._s(option.text))])}),1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3bac930_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_facets_vue__ = __webpack_require__(1054);
function injectStyle (ssrContext) {
  __webpack_require__(1052)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e3bac930"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3bac930_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_facets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1053);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("ee418622", content, true, {});

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".phd-bg--red[data-v-e3bac930]{background-color:#d22338}.phd-bg--red-alt[data-v-e3bac930]{background-color:#c0161d}.phd-bg--gray-light[data-v-e3bac930]{background-color:#f1f1f1}.phd-bg--gray[data-v-e3bac930]{background-color:#979797}.phd-bg--gray-mid[data-v-e3bac930]{background-color:#6d6e71}.phd-bg--gray-dark[data-v-e3bac930]{background-color:#373737}.phd-bg--black[data-v-e3bac930]{background-color:#000}.phd-bg--black-alt[data-v-e3bac930]{background-color:#050606}.phd-bg--blue[data-v-e3bac930]{background-color:#65baf5}.phd-bg--blue-alt[data-v-e3bac930]{background-color:#034a80}.phd-bg--mustard[data-v-e3bac930]{background-color:#f9b146}.phd-bg--mustard-alt[data-v-e3bac930]{background-color:#a7762d}.phd-bg--lime[data-v-e3bac930]{background-color:#abd02e}.phd-bg--lime-alt[data-v-e3bac930]{background-color:#6b831c}.phd-bg--seafoam[data-v-e3bac930]{background-color:#30b6a1}.phd-bg--seafoam-alt[data-v-e3bac930]{background-color:#1d7164}.phd-font-color--red[data-v-e3bac930]{color:#d22338}.phd-font-color--red-alt[data-v-e3bac930]{color:#c0161d}.phd-font-color--gray-light[data-v-e3bac930]{color:#f1f1f1}.phd-font-color--gray[data-v-e3bac930]{color:#979797}.phd-font-color--gray-mid[data-v-e3bac930]{color:#6d6e71}.phd-font-color--gray-dark[data-v-e3bac930]{color:#373737}.phd-font-color--black[data-v-e3bac930]{color:#000}.phd-font-color--black-alt[data-v-e3bac930]{color:#050606}.phd-font-color--blue[data-v-e3bac930]{color:#65baf5}.phd-font-color--blue-alt[data-v-e3bac930]{color:#034a80}.phd-font-color--mustard[data-v-e3bac930]{color:#f9b146}.phd-font-color--mustard-alt[data-v-e3bac930]{color:#a7762d}.phd-font-color--lime[data-v-e3bac930]{color:#abd02e}.phd-font-color--lime-alt[data-v-e3bac930]{color:#6b831c}.phd-font-color--seafoam[data-v-e3bac930]{color:#30b6a1}.phd-font-color--seafoam-alt[data-v-e3bac930]{color:#1d7164}.phd-link-color--red[data-v-e3bac930],.phd-link-color--red[data-v-e3bac930]:hover{color:#d22338}.phd-link-color--red-alt[data-v-e3bac930],.phd-link-color--red-alt[data-v-e3bac930]:hover{color:#c0161d}.phd-link-color--gray-light[data-v-e3bac930],.phd-link-color--gray-light[data-v-e3bac930]:hover{color:#f1f1f1}.phd-link-color--gray[data-v-e3bac930],.phd-link-color--gray[data-v-e3bac930]:hover{color:#979797}.phd-link-color--gray-mid[data-v-e3bac930],.phd-link-color--gray-mid[data-v-e3bac930]:hover{color:#6d6e71}.phd-link-color--gray-dark[data-v-e3bac930],.phd-link-color--gray-dark[data-v-e3bac930]:hover{color:#373737}.phd-link-color--black[data-v-e3bac930],.phd-link-color--black[data-v-e3bac930]:hover{color:#000}.phd-link-color--black-alt[data-v-e3bac930],.phd-link-color--black-alt[data-v-e3bac930]:hover{color:#050606}.phd-link-color--blue[data-v-e3bac930],.phd-link-color--blue[data-v-e3bac930]:hover{color:#65baf5}.phd-link-color--blue-alt[data-v-e3bac930],.phd-link-color--blue-alt[data-v-e3bac930]:hover{color:#034a80}.phd-link-color--mustard[data-v-e3bac930],.phd-link-color--mustard[data-v-e3bac930]:hover{color:#f9b146}.phd-link-color--mustard-alt[data-v-e3bac930],.phd-link-color--mustard-alt[data-v-e3bac930]:hover{color:#a7762d}.phd-link-color--lime[data-v-e3bac930],.phd-link-color--lime[data-v-e3bac930]:hover{color:#abd02e}.phd-link-color--lime-alt[data-v-e3bac930],.phd-link-color--lime-alt[data-v-e3bac930]:hover{color:#6b831c}.phd-link-color--seafoam[data-v-e3bac930],.phd-link-color--seafoam[data-v-e3bac930]:hover{color:#30b6a1}.phd-link-color--seafoam-alt[data-v-e3bac930],.phd-link-color--seafoam-alt[data-v-e3bac930]:hover{color:#1d7164}.ecc-bg--cor-1[data-v-e3bac930]{background-color:#67bf80}.ecc-bg--cor-2a[data-v-e3bac930]{background-color:#ffd643}.ecc-bg--cor-2b[data-v-e3bac930]{background-color:#f1a63e}.ecc-bg--cor-3nobenefit[data-v-e3bac930]{background-color:#ef6e5d}.ecc-bg--cor-3harm[data-v-e3bac930]{background-color:#e71e26}.ecc-bg--loe-br[data-v-e3bac930]{background-color:#5c99cf}.ecc-bg--loe-cld[data-v-e3bac930]{background-color:#9cbfe2}.ecc-bg--loe-a[data-v-e3bac930]{background-color:#3776c8}.ecc-bg--loe-bnr[data-v-e3bac930]{background-color:#5b99d1}.ecc-bg--loe-ceo[data-v-e3bac930]{background-color:#bdd3ea}.ecc-bg--gray[data-v-e3bac930]{background-color:#ebebeb}.ecc-bg--white[data-v-e3bac930]{background-color:#fff}.ecc-bg--black[data-v-e3bac930]{background-color:#000}.ecc-font-color--cor-1[data-v-e3bac930]{color:#67bf80}.ecc-font-color--cor-2a[data-v-e3bac930]{color:#ffd643}.ecc-font-color--cor-2b[data-v-e3bac930]{color:#f1a63e}.ecc-font-color--cor-3nobenefit[data-v-e3bac930]{color:#ef6e5d}.ecc-font-color--cor-3harm[data-v-e3bac930]{color:#e71e26}.ecc-font-color--loe-br[data-v-e3bac930]{color:#5c99cf}.ecc-font-color--loe-cld[data-v-e3bac930]{color:#9cbfe2}.ecc-font-color--loe-a[data-v-e3bac930]{color:#3776c8}.ecc-font-color--loe-bnr[data-v-e3bac930]{color:#5b99d1}.ecc-font-color--loe-ceo[data-v-e3bac930]{color:#bdd3ea}.ecc-font-color--gray[data-v-e3bac930]{color:#ebebeb}.ecc-font-color--white[data-v-e3bac930]{color:#fff}.ecc-font-color--black[data-v-e3bac930]{color:#000}.facets[data-v-e3bac930]{max-width:300px}.facets__button[data-v-e3bac930]{width:100%;text-align:left}.facets__button[data-v-e3bac930]:after{content:\"\\E909\"}.facets__button[aria-expanded=true][data-v-e3bac930]:after{content:\"\\E901\"}.facets__options[data-v-e3bac930]{width:100%;padding-top:.625rem}.facets__options>[data-v-e3bac930]{padding:.75rem 1.25rem}.facets .custom-control-label[data-v-e3bac930]:before{background:#fff;border:1.5px solid #979797}.facets .custom-checkbox .custom-control-input:checked~.custom-control-label[data-v-e3bac930]:after{background:#6d6e71}", ""]);

// exports


/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"facets"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse1",modifiers:{"collapse1":true}}],staticClass:"facets__button",attrs:{"variant":"btn btn--select"}},[_vm._v("Toggle Collapse")]),_vm._v(" "),_c('b-collapse',{staticClass:"facets__options",attrs:{"id":"collapse1"}},[_c('div',{staticClass:"facets__option"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck1"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck1"}},[_vm._v("Option 1")])])]),_vm._v(" "),_c('div',{staticClass:"facets__option"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck2"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck2"}},[_vm._v("Option 2")])])]),_vm._v(" "),_c('div',{staticClass:"facets__option"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck3"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck3"}},[_vm._v("Option 3")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e31bce1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputs_feedback_vue__ = __webpack_require__(1058);
function injectStyle (ssrContext) {
  __webpack_require__(1056)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e31bce1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e31bce1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputs_feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1057);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("08cc2a0c", content, true, {});

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"first-name-feedback"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{staticClass:"form-control has-focus",attrs:{"type":"text","id":"first-name-feedback","placeholder":"First Name"}})])])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"first-name-feedback-active"}},[_vm._v("First Name")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control has-invalid-icon",attrs:{"id":"first-name-feedback-active","type":"text","placeholder":"Username","aria-label":"Username","aria-describedby":"basic-addon1"}}),_vm._v(" "),_c('div',{staticClass:"input-validation-icon input-validation-icon--valid"},[_c('i',{staticClass:"icon-check"})])])])])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"first-name-feedback-error"}},[_vm._v("First Name")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control is-invalid has-invalid-icon",attrs:{"type":"text","id":"first-name-feedback-error","placeholder":"First Name","required":""}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please provide a valid city.")]),_vm._v(" "),_c('div',{staticClass:"input-validation-icon input-validation-icon--invalid"},[_c('i',{staticClass:"icon-times"})])])])])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"first-name-feedback-copy"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"first-name-feedback-copy","aria-describedby":"","placeholder":"First Name"}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted",attrs:{"id":""}},[_vm._v("Some Info Copy Here")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36ed6c69_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputs_vue__ = __webpack_require__(1060);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36ed6c69_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inputs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Default")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"first-name"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"first-name","placeholder":"First Name"}})])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Active")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"first-name-active"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{staticClass:"form-control has-focus",attrs:{"type":"text","id":"first-name-active","placeholder":"First Name"}})])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Disabled")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"first-name-disabled"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"first-name-disabled","placeholder":"First Name","disabled":""}})])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Info Copy")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"first-name-copy"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"first-name-copy","aria-describedby":"","placeholder":"First Name"}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted",attrs:{"id":""}},[_vm._v("Some Info Copy Here")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1142e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_large_inputs_feedback_vue__ = __webpack_require__(1062);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1142e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_large_inputs_feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('td',[_c('div',{staticClass:"form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label col-form-label-lg",attrs:{"for":"input-large-feedback"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{staticClass:"form-control form-control-lg has-focus",attrs:{"type":"text","id":"input-large-feedback","placeholder":"First Name"}})])])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label col-form-label-lg",attrs:{"for":"input-large-success"}},[_vm._v("First Name")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control form-control-lg is-valid has-valid-icon",attrs:{"id":"input-large-success","type":"text","placeholder":"Username","aria-label":"Username","aria-describedby":"basic-addon1"}}),_vm._v(" "),_c('div',{staticClass:"input-validation-icon input-validation-icon--valid"},[_c('i',{staticClass:"icon-check"})])])])])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label col-form-label-lg",attrs:{"for":"input-large-error"}},[_vm._v("First Name")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control form-control-lg is-invalid has-invalid-icon",attrs:{"type":"text","id":"input-large-error","placeholder":"First Name","required":""}}),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please provide a valid city.")])]),_vm._v(" "),_c('div',{staticClass:"input-validation-icon input-validation-icon--invalid"},[_c('i',{staticClass:"icon-times"})])])])])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label col-form-label-lg",attrs:{"for":"input-large-feedback-copy"}},[_vm._v("First Name")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"input-large-feedback-copy","aria-describedby":"","placeholder":"First Name"}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted",attrs:{"id":""}},[_vm._v("Some Info Copy Here. "),_c('a',{attrs:{"href":"#"}},[_vm._v("Learn More")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fff7734_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_large_inputs_vue__ = __webpack_require__(1064);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fff7734_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_large_inputs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Default")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label-lg",attrs:{"for":"input-large"}},[_vm._v("Diastolic")]),_vm._v(" "),_c('input',{staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"input-large","placeholder":"i.e. 124"}})])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Active")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label-lg",attrs:{"for":"input-large-active"}},[_vm._v("Diastolic")]),_vm._v(" "),_c('input',{staticClass:"form-control form-control-lg has-focus",attrs:{"type":"text","id":"input-large-active","placeholder":"i.e. 124"}})])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Disabled")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label-lg",attrs:{"for":"input-large-disabled"}},[_vm._v("Diastolic")]),_vm._v(" "),_c('input',{staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"input-large-disabled","placeholder":"i.e. 124","disabled":""}})])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Info Copy")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label col-form-label-lg",attrs:{"for":"input-large-copy"}},[_vm._v("Diastolic")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"input-large-copy","placeholder":"i.e. 124"}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted",attrs:{"id":""}},[_vm._v("Some Info Copy Here")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e683929_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pagination_vue__ = __webpack_require__(1066);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e683929_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"Pagination"}},[_c('ul',{staticClass:"pagination pagination-lg pagination--page-count"},[_c('li',{staticClass:"page-item disabled"},[_c('a',{staticClass:"page-link",attrs:{"href":"","rel":"prev","aria-disabled":"true"}},[_c('i',{staticClass:"icon-left-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous Page")])])]),_vm._v(" "),_c('li',{staticClass:"page-item page-item--page-count"},[_c('span',{staticClass:"sr-only"},[_vm._v("Current Page ")]),_vm._v("1 of 10\n        ")]),_vm._v(" "),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#","rel":"next"}},[_c('i',{staticClass:"icon-right-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next Page")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_715dc3fb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radio_buttons_vue__ = __webpack_require__(1068);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_715dc3fb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radio_buttons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio1","name":"customRadioGroup","checked":""}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio1"}},[_vm._v("Radio is on")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio2","name":"customRadioGroup"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio2"}},[_vm._v("Radio is off")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio3","disabled":"","checked":"","name":"customRadioGroup2"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio3"}},[_vm._v("Disabled Radio is off")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio4","disabled":"","name":"customRadioGroup2"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio4"}},[_vm._v("Disabled Radio is off")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6ba24ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabs_vue__ = __webpack_require__(1070);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6ba24ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav nav-tabs nav-tabs--centered"},[_c('li',{staticClass:"nav-item"},[_c('button',{staticClass:"nav-link active"},[_vm._v("Active")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('button',{staticClass:"nav-link"},[_vm._v("Link")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('button',{staticClass:"nav-link"},[_vm._v("Link")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('button',{staticClass:"nav-link disabled"},[_vm._v("Disabled")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44840c2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tags_vue__ = __webpack_require__(1072);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44840c2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"alert alert-warning"},[_c('h3',{staticClass:"h5"},[_vm._v("TODO:")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},[_c('li',[_vm._v("Create custom badge class with close button support")])])]),_vm._v(" "),_c('span',{staticClass:"c-tag",attrs:{"tabindex":"0"}},[_vm._v("heart attack\n        "),_c('button',{staticClass:"c-tag__close",attrs:{"type":"button","aria-label":"Close","tabindex":"-1"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Close")])])]),_vm._v(" "),_c('span',{staticClass:"c-tag",attrs:{"tabindex":"0"}},[_vm._v("symptoms\n        "),_c('button',{staticClass:"c-tag__close",attrs:{"type":"button","aria-label":"Close","tabindex":"-1"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Close")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_368a312e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_textboxes_vue__ = __webpack_require__(1076);
function injectStyle (ssrContext) {
  __webpack_require__(1074)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-368a312e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_368a312e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_textboxes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1075);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("752737f8", content, true, {});

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "textarea[data-v-368a312e]{min-height:200px;resize:none}", ""]);

// exports


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"text-area"}},[_vm._v("Default")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"id":"text-area","placeholder":"First Name"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"text-area-focus"}},[_vm._v("Active (Focus State)")]),_vm._v(" "),_c('textarea',{staticClass:"form-control has-focus",attrs:{"id":"text-area-focus","placeholder":"First Name"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tooltip_vue__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tooltip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tooltip_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tooltip_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tooltip_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c63de42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tooltip_vue__ = __webpack_require__(1078);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tooltip_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c63de42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('b-btn',{ref:"button",attrs:{"id":"exPopover3","variant":"primary"}},[_vm._v("Tooltip")]),_vm._v(" "),_c('b-popover',{attrs:{"target":"exPopover3","placement":"bottomleft","triggers":"click blur"},on:{"shown":_vm.onShown,"hide":_vm.onHide}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h4"},[_vm._v("Title of Tooltip")])]),_vm._v(" "),_c('form',{staticClass:"location-search"},[_c('div',{staticClass:"location-search__fields"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Zip Code")]),_vm._v(" "),_c('input',{ref:"input1",staticClass:"form-control",attrs:{"type":"text","id":"","placeholder":"Zip Code"}})]),_vm._v(" "),_c('span',{staticClass:"location-search__or"},[_vm._v("or")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("State")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"","placeholder":"State"}})])]),_vm._v(" "),_c('button',{staticClass:"location-search__search btn btn-tertiary btn-round",attrs:{"type":"submit"},on:{"keyup":function($event){return _vm.closeToolTip()}}},[_vm._v("Search")])])],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning"},[_c('h3',{staticClass:"h5"},[_vm._v("TODO:")]),_vm._v(" "),_c('ul',{staticClass:"mb-0"},[_c('li',[_vm._v("On blur, let focus go to other tabindexed elements if clicked")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfae9ef4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_typography_vue__ = __webpack_require__(1082);
function injectStyle (ssrContext) {
  __webpack_require__(1080)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bfae9ef4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfae9ef4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_typography_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1081);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("5b35ef51", content, true, {});

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".phd-bg--red[data-v-bfae9ef4]{background-color:#d22338}.phd-bg--red-alt[data-v-bfae9ef4]{background-color:#c0161d}.phd-bg--gray-light[data-v-bfae9ef4]{background-color:#f1f1f1}.phd-bg--gray[data-v-bfae9ef4]{background-color:#979797}.phd-bg--gray-mid[data-v-bfae9ef4]{background-color:#6d6e71}.phd-bg--gray-dark[data-v-bfae9ef4]{background-color:#373737}.phd-bg--black[data-v-bfae9ef4]{background-color:#000}.phd-bg--black-alt[data-v-bfae9ef4]{background-color:#050606}.phd-bg--blue[data-v-bfae9ef4]{background-color:#65baf5}.phd-bg--blue-alt[data-v-bfae9ef4]{background-color:#034a80}.phd-bg--mustard[data-v-bfae9ef4]{background-color:#f9b146}.phd-bg--mustard-alt[data-v-bfae9ef4]{background-color:#a7762d}.phd-bg--lime[data-v-bfae9ef4]{background-color:#abd02e}.phd-bg--lime-alt[data-v-bfae9ef4]{background-color:#6b831c}.phd-bg--seafoam[data-v-bfae9ef4]{background-color:#30b6a1}.phd-bg--seafoam-alt[data-v-bfae9ef4]{background-color:#1d7164}.phd-font-color--red[data-v-bfae9ef4]{color:#d22338}.phd-font-color--red-alt[data-v-bfae9ef4]{color:#c0161d}.phd-font-color--gray-light[data-v-bfae9ef4]{color:#f1f1f1}.phd-font-color--gray[data-v-bfae9ef4]{color:#979797}.phd-font-color--gray-mid[data-v-bfae9ef4]{color:#6d6e71}.phd-font-color--gray-dark[data-v-bfae9ef4]{color:#373737}.phd-font-color--black[data-v-bfae9ef4]{color:#000}.phd-font-color--black-alt[data-v-bfae9ef4]{color:#050606}.phd-font-color--blue[data-v-bfae9ef4]{color:#65baf5}.phd-font-color--blue-alt[data-v-bfae9ef4]{color:#034a80}.phd-font-color--mustard[data-v-bfae9ef4]{color:#f9b146}.phd-font-color--mustard-alt[data-v-bfae9ef4]{color:#a7762d}.phd-font-color--lime[data-v-bfae9ef4]{color:#abd02e}.phd-font-color--lime-alt[data-v-bfae9ef4]{color:#6b831c}.phd-font-color--seafoam[data-v-bfae9ef4]{color:#30b6a1}.phd-font-color--seafoam-alt[data-v-bfae9ef4]{color:#1d7164}.phd-link-color--red[data-v-bfae9ef4],.phd-link-color--red[data-v-bfae9ef4]:hover{color:#d22338}.phd-link-color--red-alt[data-v-bfae9ef4],.phd-link-color--red-alt[data-v-bfae9ef4]:hover{color:#c0161d}.phd-link-color--gray-light[data-v-bfae9ef4],.phd-link-color--gray-light[data-v-bfae9ef4]:hover{color:#f1f1f1}.phd-link-color--gray[data-v-bfae9ef4],.phd-link-color--gray[data-v-bfae9ef4]:hover{color:#979797}.phd-link-color--gray-mid[data-v-bfae9ef4],.phd-link-color--gray-mid[data-v-bfae9ef4]:hover{color:#6d6e71}.phd-link-color--gray-dark[data-v-bfae9ef4],.phd-link-color--gray-dark[data-v-bfae9ef4]:hover{color:#373737}.phd-link-color--black[data-v-bfae9ef4],.phd-link-color--black[data-v-bfae9ef4]:hover{color:#000}.phd-link-color--black-alt[data-v-bfae9ef4],.phd-link-color--black-alt[data-v-bfae9ef4]:hover{color:#050606}.phd-link-color--blue[data-v-bfae9ef4],.phd-link-color--blue[data-v-bfae9ef4]:hover{color:#65baf5}.phd-link-color--blue-alt[data-v-bfae9ef4],.phd-link-color--blue-alt[data-v-bfae9ef4]:hover{color:#034a80}.phd-link-color--mustard[data-v-bfae9ef4],.phd-link-color--mustard[data-v-bfae9ef4]:hover{color:#f9b146}.phd-link-color--mustard-alt[data-v-bfae9ef4],.phd-link-color--mustard-alt[data-v-bfae9ef4]:hover{color:#a7762d}.phd-link-color--lime[data-v-bfae9ef4],.phd-link-color--lime[data-v-bfae9ef4]:hover{color:#abd02e}.phd-link-color--lime-alt[data-v-bfae9ef4],.phd-link-color--lime-alt[data-v-bfae9ef4]:hover{color:#6b831c}.phd-link-color--seafoam[data-v-bfae9ef4],.phd-link-color--seafoam[data-v-bfae9ef4]:hover{color:#30b6a1}.phd-link-color--seafoam-alt[data-v-bfae9ef4],.phd-link-color--seafoam-alt[data-v-bfae9ef4]:hover{color:#1d7164}.ecc-bg--cor-1[data-v-bfae9ef4]{background-color:#67bf80}.ecc-bg--cor-2a[data-v-bfae9ef4]{background-color:#ffd643}.ecc-bg--cor-2b[data-v-bfae9ef4]{background-color:#f1a63e}.ecc-bg--cor-3nobenefit[data-v-bfae9ef4]{background-color:#ef6e5d}.ecc-bg--cor-3harm[data-v-bfae9ef4]{background-color:#e71e26}.ecc-bg--loe-br[data-v-bfae9ef4]{background-color:#5c99cf}.ecc-bg--loe-cld[data-v-bfae9ef4]{background-color:#9cbfe2}.ecc-bg--loe-a[data-v-bfae9ef4]{background-color:#3776c8}.ecc-bg--loe-bnr[data-v-bfae9ef4]{background-color:#5b99d1}.ecc-bg--loe-ceo[data-v-bfae9ef4]{background-color:#bdd3ea}.ecc-bg--gray[data-v-bfae9ef4]{background-color:#ebebeb}.ecc-bg--white[data-v-bfae9ef4]{background-color:#fff}.ecc-bg--black[data-v-bfae9ef4]{background-color:#000}.ecc-font-color--cor-1[data-v-bfae9ef4]{color:#67bf80}.ecc-font-color--cor-2a[data-v-bfae9ef4]{color:#ffd643}.ecc-font-color--cor-2b[data-v-bfae9ef4]{color:#f1a63e}.ecc-font-color--cor-3nobenefit[data-v-bfae9ef4]{color:#ef6e5d}.ecc-font-color--cor-3harm[data-v-bfae9ef4]{color:#e71e26}.ecc-font-color--loe-br[data-v-bfae9ef4]{color:#5c99cf}.ecc-font-color--loe-cld[data-v-bfae9ef4]{color:#9cbfe2}.ecc-font-color--loe-a[data-v-bfae9ef4]{color:#3776c8}.ecc-font-color--loe-bnr[data-v-bfae9ef4]{color:#5b99d1}.ecc-font-color--loe-ceo[data-v-bfae9ef4]{color:#bdd3ea}.ecc-font-color--gray[data-v-bfae9ef4]{color:#ebebeb}.ecc-font-color--white[data-v-bfae9ef4]{color:#fff}.ecc-font-color--black[data-v-bfae9ef4]{color:#000}.table[data-v-bfae9ef4]{width:auto}.table th[data-v-bfae9ef4]{vertical-align:middle;font-weight:400;color:#6d6e71}.table p[data-v-bfae9ef4]{margin-bottom:0}.small-text[data-v-bfae9ef4]{font-size:.875rem}", ""]);

// exports


/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table mb-5"},[_c('tr',[_c('th',[_vm._v("Heading 1, 80pt")]),_vm._v(" "),_c('td',[_c('h1',{staticClass:"heading-1"},[_vm._v("Life Is Why")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Heading 2, 54pt")]),_vm._v(" "),_c('td',[_c('h2',{staticClass:"heading-2"},[_vm._v("Life Is Why")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Heading 3, 36pt")]),_vm._v(" "),_c('td',[_c('h3',{staticClass:"heading-3"},[_vm._v("Life Is Why")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Heading 4, 24pt")]),_vm._v(" "),_c('td',[_c('h4',{staticClass:"heading-4"},[_vm._v("Life Is Why")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Body, 16pt")]),_vm._v(" "),_c('td',[_c('p',[_vm._v("Life Is Why")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Footer, 14pt")]),_vm._v(" "),_c('td',[_c('p',{staticClass:"small-text"},[_vm._v("Life Is Why")])])])]),_vm._v(" "),_c('div',{staticClass:"mb-5"},[_c('h3',{staticClass:"h4"},[_vm._v("Paragraph")]),_vm._v(" "),_c('p',[_vm._v("Fusce pulvinar facilisis nisi, id imperdiet ipsum volutpat dapibus. Donec at felis a arcu ultricies dignissim. Sed tincidunt libero ac eleifend consequat. Mauris massa lectus, euismod at rutrum sed, pellentesque eget lectus. Etiam faucibus dui ut nibh dapibus suscipit. Nullam lacus tellus, varius vitae sapien sagittis, sodales blandit risus. Praesent dignissim sit amet sem eu efficitur. Curabitur eu arcu aliquet, ultricies libero nec, elementum justo.")])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"h4"},[_vm._v("Quote")]),_vm._v(" "),_c('blockquote',{staticClass:"blockquote"},[_c('h3',{staticClass:"h3"},[_vm._v("Nancy Williams")]),_vm._v(" "),_c('p',[_vm._v("\"Fusce pulvinar facilisis nisi, id imperdiet ipsum volutpat dapibus. Donec at felis a arcu ultricies dignissim. Sed tincidunt libero ac eleifend consequat. Mauris massa lectus, euismod at rutrum sed, pellentesque eget lectus. Etiam faucibus dui ut nibh dapibus suscipit. Nullam lacus tellus, varius vitae sapien sagittis, sodales blandit risus. Praesent dignissim sit amet sem eu efficitur. Curabitur eu arcu aliquet, ultricies libero nec, elementum justo.\"")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19fcb506_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_glyphs_vue__ = __webpack_require__(1084);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19fcb506_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_glyphs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_c('img',{attrs:{"width":"32","src":"assets/icons/hospital_map_icons/location.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/cross.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/circle-check.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/check.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/paper.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/search.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/cursor.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/volunteer.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/plate.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/graph.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/strong.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/circle-star.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/star.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/login-signup.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/heart.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/solid-heart.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/play.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/play-circle.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/print.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/glyphs/megaphone.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/large-white-play-button.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/close-button.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/play-button.svg"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b767004_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_social_icons_vue__ = __webpack_require__(1086);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b767004_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_social_icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/google-plus.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/mail.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/copy-link.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/linkedin.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/print.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/instagram.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/youtube.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/pinterest.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/more.svg"}})])]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/twitter-gray.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/facebook-gray.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/google-plus-gray.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/mail-gray.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/copy-link-gray.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/linkedin-gray.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/print-gray.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/instagram-gray.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/youtube-gray.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/pinterest-gray.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/more-gray.svg"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6a5c364_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_icons_vue__ = __webpack_require__(1088);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6a5c364_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_c('img',{attrs:{"src":"assets/icons/people-and-hearts-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/hands-and-cross-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/laugh-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/envelope-and-heart-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/heart-beat-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/infographic-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/book-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/sprout-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/male-female-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/brain-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/main-dishes-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/side-dishes-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/salad-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/slow-cooker-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/poultry-icon.svg"}})]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/beef-icon.svg"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48f2232_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_labels_vue__ = __webpack_require__(1090);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48f2232_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_labels_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"c-label c-label--green"},[_vm._v("New Label")]),_vm._v(" "),_c('span',{staticClass:"c-label c-label--purple"},[_vm._v("Shop Label")]),_vm._v(" "),_c('span',{staticClass:"c-label c-label--orange"},[_vm._v("Recipes")]),_vm._v(" "),_c('span',{staticClass:"c-label c-label--grey"},[_vm._v("Inactive")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59f22383_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_typography_vue__ = __webpack_require__(1094);
function injectStyle (ssrContext) {
  __webpack_require__(1092)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59f22383"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59f22383_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_typography_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1093);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("82a3455c", content, true, {});

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".phd-bg--red[data-v-59f22383]{background-color:#d22338}.phd-bg--red-alt[data-v-59f22383]{background-color:#c0161d}.phd-bg--gray-light[data-v-59f22383]{background-color:#f1f1f1}.phd-bg--gray[data-v-59f22383]{background-color:#979797}.phd-bg--gray-mid[data-v-59f22383]{background-color:#6d6e71}.phd-bg--gray-dark[data-v-59f22383]{background-color:#373737}.phd-bg--black[data-v-59f22383]{background-color:#000}.phd-bg--black-alt[data-v-59f22383]{background-color:#050606}.phd-bg--blue[data-v-59f22383]{background-color:#65baf5}.phd-bg--blue-alt[data-v-59f22383]{background-color:#034a80}.phd-bg--mustard[data-v-59f22383]{background-color:#f9b146}.phd-bg--mustard-alt[data-v-59f22383]{background-color:#a7762d}.phd-bg--lime[data-v-59f22383]{background-color:#abd02e}.phd-bg--lime-alt[data-v-59f22383]{background-color:#6b831c}.phd-bg--seafoam[data-v-59f22383]{background-color:#30b6a1}.phd-bg--seafoam-alt[data-v-59f22383]{background-color:#1d7164}.phd-font-color--red[data-v-59f22383]{color:#d22338}.phd-font-color--red-alt[data-v-59f22383]{color:#c0161d}.phd-font-color--gray-light[data-v-59f22383]{color:#f1f1f1}.phd-font-color--gray[data-v-59f22383]{color:#979797}.phd-font-color--gray-mid[data-v-59f22383]{color:#6d6e71}.phd-font-color--gray-dark[data-v-59f22383]{color:#373737}.phd-font-color--black[data-v-59f22383]{color:#000}.phd-font-color--black-alt[data-v-59f22383]{color:#050606}.phd-font-color--blue[data-v-59f22383]{color:#65baf5}.phd-font-color--blue-alt[data-v-59f22383]{color:#034a80}.phd-font-color--mustard[data-v-59f22383]{color:#f9b146}.phd-font-color--mustard-alt[data-v-59f22383]{color:#a7762d}.phd-font-color--lime[data-v-59f22383]{color:#abd02e}.phd-font-color--lime-alt[data-v-59f22383]{color:#6b831c}.phd-font-color--seafoam[data-v-59f22383]{color:#30b6a1}.phd-font-color--seafoam-alt[data-v-59f22383]{color:#1d7164}.phd-link-color--red[data-v-59f22383],.phd-link-color--red[data-v-59f22383]:hover{color:#d22338}.phd-link-color--red-alt[data-v-59f22383],.phd-link-color--red-alt[data-v-59f22383]:hover{color:#c0161d}.phd-link-color--gray-light[data-v-59f22383],.phd-link-color--gray-light[data-v-59f22383]:hover{color:#f1f1f1}.phd-link-color--gray[data-v-59f22383],.phd-link-color--gray[data-v-59f22383]:hover{color:#979797}.phd-link-color--gray-mid[data-v-59f22383],.phd-link-color--gray-mid[data-v-59f22383]:hover{color:#6d6e71}.phd-link-color--gray-dark[data-v-59f22383],.phd-link-color--gray-dark[data-v-59f22383]:hover{color:#373737}.phd-link-color--black[data-v-59f22383],.phd-link-color--black[data-v-59f22383]:hover{color:#000}.phd-link-color--black-alt[data-v-59f22383],.phd-link-color--black-alt[data-v-59f22383]:hover{color:#050606}.phd-link-color--blue[data-v-59f22383],.phd-link-color--blue[data-v-59f22383]:hover{color:#65baf5}.phd-link-color--blue-alt[data-v-59f22383],.phd-link-color--blue-alt[data-v-59f22383]:hover{color:#034a80}.phd-link-color--mustard[data-v-59f22383],.phd-link-color--mustard[data-v-59f22383]:hover{color:#f9b146}.phd-link-color--mustard-alt[data-v-59f22383],.phd-link-color--mustard-alt[data-v-59f22383]:hover{color:#a7762d}.phd-link-color--lime[data-v-59f22383],.phd-link-color--lime[data-v-59f22383]:hover{color:#abd02e}.phd-link-color--lime-alt[data-v-59f22383],.phd-link-color--lime-alt[data-v-59f22383]:hover{color:#6b831c}.phd-link-color--seafoam[data-v-59f22383],.phd-link-color--seafoam[data-v-59f22383]:hover{color:#30b6a1}.phd-link-color--seafoam-alt[data-v-59f22383],.phd-link-color--seafoam-alt[data-v-59f22383]:hover{color:#1d7164}.ecc-bg--cor-1[data-v-59f22383]{background-color:#67bf80}.ecc-bg--cor-2a[data-v-59f22383]{background-color:#ffd643}.ecc-bg--cor-2b[data-v-59f22383]{background-color:#f1a63e}.ecc-bg--cor-3nobenefit[data-v-59f22383]{background-color:#ef6e5d}.ecc-bg--cor-3harm[data-v-59f22383]{background-color:#e71e26}.ecc-bg--loe-br[data-v-59f22383]{background-color:#5c99cf}.ecc-bg--loe-cld[data-v-59f22383]{background-color:#9cbfe2}.ecc-bg--loe-a[data-v-59f22383]{background-color:#3776c8}.ecc-bg--loe-bnr[data-v-59f22383]{background-color:#5b99d1}.ecc-bg--loe-ceo[data-v-59f22383]{background-color:#bdd3ea}.ecc-bg--gray[data-v-59f22383]{background-color:#ebebeb}.ecc-bg--white[data-v-59f22383]{background-color:#fff}.ecc-bg--black[data-v-59f22383]{background-color:#000}.ecc-font-color--cor-1[data-v-59f22383]{color:#67bf80}.ecc-font-color--cor-2a[data-v-59f22383]{color:#ffd643}.ecc-font-color--cor-2b[data-v-59f22383]{color:#f1a63e}.ecc-font-color--cor-3nobenefit[data-v-59f22383]{color:#ef6e5d}.ecc-font-color--cor-3harm[data-v-59f22383]{color:#e71e26}.ecc-font-color--loe-br[data-v-59f22383]{color:#5c99cf}.ecc-font-color--loe-cld[data-v-59f22383]{color:#9cbfe2}.ecc-font-color--loe-a[data-v-59f22383]{color:#3776c8}.ecc-font-color--loe-bnr[data-v-59f22383]{color:#5b99d1}.ecc-font-color--loe-ceo[data-v-59f22383]{color:#bdd3ea}.ecc-font-color--gray[data-v-59f22383]{color:#ebebeb}.ecc-font-color--white[data-v-59f22383]{color:#fff}.ecc-font-color--black[data-v-59f22383]{color:#000}.text-blue[data-v-59f22383]{color:#2e44c9}.c-typo[data-v-59f22383]{margin-bottom:3rem}.c-typo .typo__desc[data-v-59f22383]{color:#2e44c9;letter-spacing:1px}code[data-v-59f22383]{margin-bottom:1em;display:block}", ""]);

// exports


/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-uppercase mt-5"},[_vm._v("Typopgraphy")]),_vm._v(" "),_c('hr',{staticClass:"mb-5"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('h2',{staticClass:"component__heading mb-3"},[_vm._v("Elements")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('h5',{},[_vm._v("Example of component using the section title and heading classes")]),_vm._v(" "),_c('div',{staticClass:"l-promo l-promo--phd-generic l-promo--shadow"},[_vm._m(21),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg'),expression:"'https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg'"}],attrs:{"src":"assets/images/placeholder.gif","alt":"Quit vaping"}})])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg'),expression:"'https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg'"}],attrs:{"src":"assets/images/placeholder.gif","alt":"Quit vaping"}})])])])]),_vm._v(" "),_vm._m(22)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold"}),_vm._v("* font-size / line-height / letter spacing / font-weight")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold"},[_vm._v("H1 (Desktop)")]),_vm._v(" 32/46/.5 letter spacing")]),_vm._v(" "),_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold"},[_vm._v("H1 (Mobile)")]),_vm._v(" 28/36/.25 letter spacing")]),_vm._v(" "),_c('h1',[_vm._v("Meetings & Conferences")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold"},[_vm._v("H2 (Desktop)")]),_vm._v(" 30/36/.5 letter spacing")]),_vm._v(" "),_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold"},[_vm._v("H2 (Mobile)")]),_vm._v(" 26/30/.25 letter spacing")]),_vm._v(" "),_c('h2',[_vm._v("Science News")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold"},[_vm._v("H3 (Desktop)")]),_vm._v(" 28/32")]),_vm._v(" "),_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold"},[_vm._v("H3 (Mobile)")]),_vm._v(" 24/28")]),_vm._v(" "),_c('h3',[_vm._v("Science News from Hypertension")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold"},[_vm._v("H4 (Desktop + Mobile)")]),_vm._v(" 20/24")]),_vm._v(" "),_c('h4',[_vm._v("Science News from Hypertension")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold"},[_vm._v("H5 (Desktop + Mobile)")]),_vm._v(" 18/24/medium")]),_vm._v(" "),_c('h5',[_vm._v("Science News from Hypertension")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold"},[_vm._v("H6 (Desktop + Mobile)")]),_vm._v(" 16/24/semibold")]),_vm._v(" "),_c('h6',[_vm._v("Science News from Hypertension")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold"},[_vm._v("BODY")]),_vm._v(" 16/26")]),_vm._v(" "),_c('p',[_vm._v("\n            In a study of American Indians from the Strong Heart Family Study, high-resolution lipidomics identified novel plasma lipids significantly predictive for T2DM onset in this high-risk population.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n            Adding a guideline-based treatment protocol in clinical decision support systems to team-based decisions reduced diabetic patient CVD risk factors more than team-based care alone.\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold text-uppercase"},[_vm._v("News General Title")]),_vm._v(" 18/24")]),_vm._v(" "),_c('code',{staticClass:"small text-danger"},[_vm._v(".news__title")]),_vm._v(" "),_c('div',{staticClass:"news__title"},[_vm._v("Tackling the AHA 2030 Impact Goal at EPI Lifestyle 2020")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold text-uppercase"},[_vm._v("News General Title Description")]),_vm._v(" 16/24")]),_vm._v(" "),_c('code',{staticClass:"small text-danger"},[_vm._v(".news__desc / maybe section description?")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"news__desc"},[_vm._v("In a study of American Indians from the Strong Heart Family Study, high-resolution lipidomics identified novel plasma lipids significantly predictive for T2DM onset in this high-risk population.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"news__desc"},[_vm._v("This article reports that waterpipe exposure to mice modulates hemostasis and increases the risk of thrombosis.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold text-uppercase"},[_vm._v("News List Title")]),_vm._v(" 16/24/semibold")]),_vm._v(" "),_c('code',{staticClass:"small text-danger"},[_vm._v(".news-list__title")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"news-list__title"},[_vm._v("Microvascular Disease Increases Amputation in Patients With Peripheral Artery Disease")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"news-list__title"},[_vm._v("Lifestyle and Risk Factor Modification for Reduction of Atrial Fibrillation")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"news-list__title"},[_vm._v("Microvascular Disease Increases Amputation in Patients With Peripheral Artery Disease")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold text-uppercase"},[_vm._v("News List Byline")]),_vm._v(" 13/16")]),_vm._v(" "),_c('code',{staticClass:"small text-danger"},[_vm._v(".news-list__byline")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"news-list__byline"},[_vm._v("\n                    Bruce R. Stevens | University of Florida "),_c('br'),_vm._v("\n                    Gainesville, FL | AHA News Release\n                ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold text-uppercase"},[_vm._v("News List Description")]),_vm._v(" 14/20")]),_vm._v(" "),_c('code',{staticClass:"small text-danger"},[_vm._v(".news-list__desc")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"news-list__desc"},[_vm._v("Atrial fibrillation (AF) is the most common cardiac arrhythmia and is associated with high morbidity, mortality and healthcare usage. Aug. 31-Sept. 4, 2019 | Oct. 28, 2019")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"news-list__desc"},[_vm._v("Hypertension Trending Topics for January 2020 Level of Physical Activity, Left Ventricular Mass, Hypertension, and Prognosis In Utero Antihypertensive Medication Exposure and Neonatal Outcomes: A Data Linkage Cohort Study. May 6, 2020")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold text-uppercase"},[_vm._v("Date")]),_vm._v(" 16/24")]),_vm._v(" "),_c('code',{staticClass:"small text-danger"},[_vm._v(".date")]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("March 3 - 6, 2020")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold text-uppercase"},[_vm._v("Location")]),_vm._v(" 13/24")]),_vm._v(" "),_c('code',{staticClass:"small text-danger"},[_vm._v(".location")]),_vm._v(" "),_c('div',{staticClass:"location"},[_vm._v("Dallas, Texas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold text-uppercase"},[_vm._v("Journal With Date")]),_vm._v(" 14/20/.5 letter spacing")]),_vm._v(" "),_c('code',{staticClass:"small text-danger"},[_vm._v(".journal__date")]),_vm._v(" "),_c('div',{staticClass:"journal__date"},[_vm._v("Hypertension | Oct. 28, 2019")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold text-uppercase"},[_vm._v("View All Links")]),_vm._v(" 14/20/.5 letter spacing")]),_vm._v(" "),_c('code',{staticClass:"small text-danger"},[_vm._v(".c-cta.c-cta--secondary.c-cta--type-view-all.text-uppercase")]),_vm._v(" "),_c('a',{staticClass:"c-cta c-cta--secondary c-cta--arrow c-cta--type-view-all text-uppercase",attrs:{"href":"#"}},[_vm._v("View All Meetings")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold text-uppercase"},[_vm._v("Section Label")]),_vm._v(" 12/18/.75 letter spacing")]),_vm._v(" "),_c('code',{staticClass:"small text-danger"},[_vm._v(".section__label")]),_vm._v(" "),_c('div',{staticClass:"section__label"},[_vm._v("Recent News")]),_vm._v(" "),_c('code',{staticClass:"small text-danger"},[_vm._v(".section__label.section__label--gray")]),_vm._v(" "),_c('div',{staticClass:"section__label section__label--gray"},[_vm._v("Recent News")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold text-uppercase"},[_vm._v("Additional Section Label")]),_vm._v(" 12/24")]),_vm._v(" "),_c('code',{staticClass:"small text-danger"},[_vm._v(".section__label--thin / no letter spacing here?")]),_vm._v(" "),_c('div',{staticClass:"section__label--thin"},[_vm._v("Featured Article")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold text-uppercase"},[_vm._v("Breadcrumb")]),_vm._v(" 12/24/.25 letter spacing")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('ol',{staticClass:"c-breadcrumb"},[_c('li',[_vm._v("\n                Home\n            ")]),_vm._v(" "),_c('li',[_vm._v("\n                Guidelines and Statements\n            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-typo"},[_c('div',{staticClass:"typo__desc"},[_c('span',{staticClass:"text-bold text-uppercase"},[_vm._v("Featured Tag Title White")]),_vm._v(" 12/14/.75 letter spacing/caps")]),_vm._v(" "),_c('code',{staticClass:"small text-danger"},[_vm._v(".c-label.c-label-phd.c-label-phd--gray")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"c-label c-label-phd c-label-phd--gray"},[_vm._v("Featured News")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"section__label mb-1"},[_vm._v("Programming ")]),_vm._v(" "),_c('div',{staticClass:"h3 mb-3"},[_vm._v("What To Expect From This Year's Event")]),_vm._v(" "),_c('div',{staticClass:"h6 mb-0"},[_vm._v("New 3-Day Meeting. New Experience. New Sessions.")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis eum quia accusamus harum accusantium?")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo l-promo--phd-generic l-promo--shadow l-promo--border-top"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"section__label mb-1"},[_vm._v("Programming ")]),_vm._v(" "),_c('div',{staticClass:"h3 mb-3"},[_vm._v("What To Expect From This Year's Event")]),_vm._v(" "),_c('div',{staticClass:"h6 mb-0"},[_vm._v("New 3-Day Meeting. New Experience. New Sessions.")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis eum quia accusamus harum accusantium?")])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('div',{staticClass:"c-card__label"},[_c('span',{staticClass:"c-label c-label-phd c-label-phd--gray"},[_vm._v("Featured")])]),_vm._v(" "),_c('img',{staticClass:"is-loaded",attrs:{"src":"https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg","alt":"Quit vaping"}})])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg","alt":"Quit vaping"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ac5865e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_color_palette_vue__ = __webpack_require__(1098);
function injectStyle (ssrContext) {
  __webpack_require__(1096)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ac5865e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ac5865e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_color_palette_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1097);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("61d462b1", content, true, {});

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".phd-bg--red[data-v-0ac5865e]{background-color:#d22338}.phd-bg--red-alt[data-v-0ac5865e]{background-color:#c0161d}.phd-bg--gray-light[data-v-0ac5865e]{background-color:#f1f1f1}.phd-bg--gray[data-v-0ac5865e]{background-color:#979797}.phd-bg--gray-mid[data-v-0ac5865e]{background-color:#6d6e71}.phd-bg--gray-dark[data-v-0ac5865e]{background-color:#373737}.phd-bg--black[data-v-0ac5865e]{background-color:#000}.phd-bg--black-alt[data-v-0ac5865e]{background-color:#050606}.phd-bg--blue[data-v-0ac5865e]{background-color:#65baf5}.phd-bg--blue-alt[data-v-0ac5865e]{background-color:#034a80}.phd-bg--mustard[data-v-0ac5865e]{background-color:#f9b146}.phd-bg--mustard-alt[data-v-0ac5865e]{background-color:#a7762d}.phd-bg--lime[data-v-0ac5865e]{background-color:#abd02e}.phd-bg--lime-alt[data-v-0ac5865e]{background-color:#6b831c}.phd-bg--seafoam[data-v-0ac5865e]{background-color:#30b6a1}.phd-bg--seafoam-alt[data-v-0ac5865e]{background-color:#1d7164}.phd-font-color--red[data-v-0ac5865e]{color:#d22338}.phd-font-color--red-alt[data-v-0ac5865e]{color:#c0161d}.phd-font-color--gray-light[data-v-0ac5865e]{color:#f1f1f1}.phd-font-color--gray[data-v-0ac5865e]{color:#979797}.phd-font-color--gray-mid[data-v-0ac5865e]{color:#6d6e71}.phd-font-color--gray-dark[data-v-0ac5865e]{color:#373737}.phd-font-color--black[data-v-0ac5865e]{color:#000}.phd-font-color--black-alt[data-v-0ac5865e]{color:#050606}.phd-font-color--blue[data-v-0ac5865e]{color:#65baf5}.phd-font-color--blue-alt[data-v-0ac5865e]{color:#034a80}.phd-font-color--mustard[data-v-0ac5865e]{color:#f9b146}.phd-font-color--mustard-alt[data-v-0ac5865e]{color:#a7762d}.phd-font-color--lime[data-v-0ac5865e]{color:#abd02e}.phd-font-color--lime-alt[data-v-0ac5865e]{color:#6b831c}.phd-font-color--seafoam[data-v-0ac5865e]{color:#30b6a1}.phd-font-color--seafoam-alt[data-v-0ac5865e]{color:#1d7164}.phd-link-color--red[data-v-0ac5865e],.phd-link-color--red[data-v-0ac5865e]:hover{color:#d22338}.phd-link-color--red-alt[data-v-0ac5865e],.phd-link-color--red-alt[data-v-0ac5865e]:hover{color:#c0161d}.phd-link-color--gray-light[data-v-0ac5865e],.phd-link-color--gray-light[data-v-0ac5865e]:hover{color:#f1f1f1}.phd-link-color--gray[data-v-0ac5865e],.phd-link-color--gray[data-v-0ac5865e]:hover{color:#979797}.phd-link-color--gray-mid[data-v-0ac5865e],.phd-link-color--gray-mid[data-v-0ac5865e]:hover{color:#6d6e71}.phd-link-color--gray-dark[data-v-0ac5865e],.phd-link-color--gray-dark[data-v-0ac5865e]:hover{color:#373737}.phd-link-color--black[data-v-0ac5865e],.phd-link-color--black[data-v-0ac5865e]:hover{color:#000}.phd-link-color--black-alt[data-v-0ac5865e],.phd-link-color--black-alt[data-v-0ac5865e]:hover{color:#050606}.phd-link-color--blue[data-v-0ac5865e],.phd-link-color--blue[data-v-0ac5865e]:hover{color:#65baf5}.phd-link-color--blue-alt[data-v-0ac5865e],.phd-link-color--blue-alt[data-v-0ac5865e]:hover{color:#034a80}.phd-link-color--mustard[data-v-0ac5865e],.phd-link-color--mustard[data-v-0ac5865e]:hover{color:#f9b146}.phd-link-color--mustard-alt[data-v-0ac5865e],.phd-link-color--mustard-alt[data-v-0ac5865e]:hover{color:#a7762d}.phd-link-color--lime[data-v-0ac5865e],.phd-link-color--lime[data-v-0ac5865e]:hover{color:#abd02e}.phd-link-color--lime-alt[data-v-0ac5865e],.phd-link-color--lime-alt[data-v-0ac5865e]:hover{color:#6b831c}.phd-link-color--seafoam[data-v-0ac5865e],.phd-link-color--seafoam[data-v-0ac5865e]:hover{color:#30b6a1}.phd-link-color--seafoam-alt[data-v-0ac5865e],.phd-link-color--seafoam-alt[data-v-0ac5865e]:hover{color:#1d7164}.ecc-bg--cor-1[data-v-0ac5865e]{background-color:#67bf80}.ecc-bg--cor-2a[data-v-0ac5865e]{background-color:#ffd643}.ecc-bg--cor-2b[data-v-0ac5865e]{background-color:#f1a63e}.ecc-bg--cor-3nobenefit[data-v-0ac5865e]{background-color:#ef6e5d}.ecc-bg--cor-3harm[data-v-0ac5865e]{background-color:#e71e26}.ecc-bg--loe-br[data-v-0ac5865e]{background-color:#5c99cf}.ecc-bg--loe-cld[data-v-0ac5865e]{background-color:#9cbfe2}.ecc-bg--loe-a[data-v-0ac5865e]{background-color:#3776c8}.ecc-bg--loe-bnr[data-v-0ac5865e]{background-color:#5b99d1}.ecc-bg--loe-ceo[data-v-0ac5865e]{background-color:#bdd3ea}.ecc-bg--gray[data-v-0ac5865e]{background-color:#ebebeb}.ecc-bg--white[data-v-0ac5865e]{background-color:#fff}.ecc-bg--black[data-v-0ac5865e]{background-color:#000}.ecc-font-color--cor-1[data-v-0ac5865e]{color:#67bf80}.ecc-font-color--cor-2a[data-v-0ac5865e]{color:#ffd643}.ecc-font-color--cor-2b[data-v-0ac5865e]{color:#f1a63e}.ecc-font-color--cor-3nobenefit[data-v-0ac5865e]{color:#ef6e5d}.ecc-font-color--cor-3harm[data-v-0ac5865e]{color:#e71e26}.ecc-font-color--loe-br[data-v-0ac5865e]{color:#5c99cf}.ecc-font-color--loe-cld[data-v-0ac5865e]{color:#9cbfe2}.ecc-font-color--loe-a[data-v-0ac5865e]{color:#3776c8}.ecc-font-color--loe-bnr[data-v-0ac5865e]{color:#5b99d1}.ecc-font-color--loe-ceo[data-v-0ac5865e]{color:#bdd3ea}.ecc-font-color--gray[data-v-0ac5865e]{color:#ebebeb}.ecc-font-color--white[data-v-0ac5865e]{color:#fff}.ecc-font-color--black[data-v-0ac5865e]{color:#000}.card[data-v-0ac5865e]{border-radius:6px;border:0}.card .card-body[data-v-0ac5865e]{color:#979797;padding-top:4px;text-transform:uppercase;font-size:.85rem}.color-palette[data-v-0ac5865e]{-webkit-box-shadow:0 15px 30px 0 rgba(0,0,0,.2);box-shadow:0 15px 30px 0 rgba(0,0,0,.2);letter-spacing:1px}.color-palette__header[data-v-0ac5865e]{border:0;background-color:transparent}.color-palette__colors[data-v-0ac5865e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:4px;overflow:hidden;font-size:14px}.color-palette__colors>[data-v-0ac5865e]{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center;color:#fff;padding:34px 0}.color-palette__color--red[data-v-0ac5865e]{background:#d22338}.color-palette__color--red-alt[data-v-0ac5865e]{background:#c0161d}.color-palette__color--light-gray[data-v-0ac5865e]{background:#f1f1f1;color:#979797}.color-palette__color--gray[data-v-0ac5865e]{background:#979797}.color-palette__color--gray-mid[data-v-0ac5865e]{background:#6d6e71}.color-palette__color--gray-dark[data-v-0ac5865e]{background:#373737}.color-palette__color--black[data-v-0ac5865e]{background:#000}.color-palette__color--black-alt[data-v-0ac5865e]{background:#050606}", ""]);

// exports


/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-uppercase mt-5"},[_vm._v("Color Palette")]),_vm._v(" "),_c('hr',{staticClass:"mb-3"}),_vm._v(" "),_c('p',{staticClass:"h-color--gray-mid"},[_vm._v("When using the colors below make sure the contrast ratio should be at least 4.5:1 for normal text and 3:1 for large text.")]),_vm._v(" "),_c('h3',{staticClass:"component__heading mb-3"},[_vm._v("Primary")]),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card color-palette mb-4"},[_c('div',{staticClass:"card-header color-palette__header"},[_c('div',{staticClass:"color-palette__colors"},[_c('div',{staticClass:"color-palette__color--red"},[_vm._v("D22338")]),_vm._v(" "),_c('div',{staticClass:"color-palette__color--red-alt"},[_vm._v("C0161D")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n                    Brand Red\n                    "),_c('div',{staticClass:"small text-danger d-flex justify-content-between align-items-center"},[_c('code',[_vm._v("$phd-red")]),_vm._v(" "),_c('code',[_vm._v("$phd-red-alt")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card color-palette mb-4"},[_c('div',{staticClass:"card-header color-palette__header"},[_c('div',{staticClass:"color-palette__colors"},[_c('div',{staticClass:"color-palette__color--light-gray"},[_vm._v("F1F1F1")]),_vm._v(" "),_c('div',{staticClass:"color-palette__color--gray h-color--black"},[_vm._v("979797")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n                    Light Gray\n                    "),_c('div',{staticClass:"small text-danger d-flex justify-content-between align-items-center"},[_c('code',[_vm._v("$phd-gray--light")]),_vm._v(" "),_c('code',[_vm._v("$phd-gray")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card color-palette mb-4"},[_c('div',{staticClass:"card-header color-palette__header"},[_c('div',{staticClass:"color-palette__colors"},[_c('div',{staticClass:"color-palette__color--gray-mid"},[_vm._v("6D6E71")]),_vm._v(" "),_c('div',{staticClass:"color-palette__color--gray-dark"},[_vm._v("373737")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n                    Mid/Dark Gray\n                    "),_c('div',{staticClass:"small text-danger d-flex justify-content-between align-items-center"},[_c('code',[_vm._v("$phd-gray--mid")]),_vm._v(" "),_c('code',[_vm._v("$phd-gray--dark")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card color-palette"},[_c('div',{staticClass:"card-header color-palette__header"},[_c('div',{staticClass:"color-palette__colors"},[_c('div',{staticClass:"color-palette__color--black-alt"},[_vm._v("050606")]),_vm._v(" "),_c('div',{staticClass:"color-palette__color--black"},[_vm._v("000000")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n                    Midnight\n                    "),_c('div',{staticClass:"small text-danger d-flex justify-content-between align-items-center"},[_c('code',[_vm._v("$phd-black-alt")]),_vm._v(" "),_c('code',[_vm._v("$phd-black")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_color_palette_membership_vue__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_color_palette_membership_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_color_palette_membership_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_color_palette_membership_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_color_palette_membership_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58212be8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_color_palette_membership_vue__ = __webpack_require__(1102);
function injectStyle (ssrContext) {
  __webpack_require__(1100)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58212be8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_color_palette_membership_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58212be8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_color_palette_membership_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1101);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("3f3e578b", content, true, {});

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".phd-bg--red[data-v-58212be8]{background-color:#d22338}.phd-bg--red-alt[data-v-58212be8]{background-color:#c0161d}.phd-bg--gray-light[data-v-58212be8]{background-color:#f1f1f1}.phd-bg--gray[data-v-58212be8]{background-color:#979797}.phd-bg--gray-mid[data-v-58212be8]{background-color:#6d6e71}.phd-bg--gray-dark[data-v-58212be8]{background-color:#373737}.phd-bg--black[data-v-58212be8]{background-color:#000}.phd-bg--black-alt[data-v-58212be8]{background-color:#050606}.phd-bg--blue[data-v-58212be8]{background-color:#65baf5}.phd-bg--blue-alt[data-v-58212be8]{background-color:#034a80}.phd-bg--mustard[data-v-58212be8]{background-color:#f9b146}.phd-bg--mustard-alt[data-v-58212be8]{background-color:#a7762d}.phd-bg--lime[data-v-58212be8]{background-color:#abd02e}.phd-bg--lime-alt[data-v-58212be8]{background-color:#6b831c}.phd-bg--seafoam[data-v-58212be8]{background-color:#30b6a1}.phd-bg--seafoam-alt[data-v-58212be8]{background-color:#1d7164}.phd-font-color--red[data-v-58212be8]{color:#d22338}.phd-font-color--red-alt[data-v-58212be8]{color:#c0161d}.phd-font-color--gray-light[data-v-58212be8]{color:#f1f1f1}.phd-font-color--gray[data-v-58212be8]{color:#979797}.phd-font-color--gray-mid[data-v-58212be8]{color:#6d6e71}.phd-font-color--gray-dark[data-v-58212be8]{color:#373737}.phd-font-color--black[data-v-58212be8]{color:#000}.phd-font-color--black-alt[data-v-58212be8]{color:#050606}.phd-font-color--blue[data-v-58212be8]{color:#65baf5}.phd-font-color--blue-alt[data-v-58212be8]{color:#034a80}.phd-font-color--mustard[data-v-58212be8]{color:#f9b146}.phd-font-color--mustard-alt[data-v-58212be8]{color:#a7762d}.phd-font-color--lime[data-v-58212be8]{color:#abd02e}.phd-font-color--lime-alt[data-v-58212be8]{color:#6b831c}.phd-font-color--seafoam[data-v-58212be8]{color:#30b6a1}.phd-font-color--seafoam-alt[data-v-58212be8]{color:#1d7164}.phd-link-color--red[data-v-58212be8],.phd-link-color--red[data-v-58212be8]:hover{color:#d22338}.phd-link-color--red-alt[data-v-58212be8],.phd-link-color--red-alt[data-v-58212be8]:hover{color:#c0161d}.phd-link-color--gray-light[data-v-58212be8],.phd-link-color--gray-light[data-v-58212be8]:hover{color:#f1f1f1}.phd-link-color--gray[data-v-58212be8],.phd-link-color--gray[data-v-58212be8]:hover{color:#979797}.phd-link-color--gray-mid[data-v-58212be8],.phd-link-color--gray-mid[data-v-58212be8]:hover{color:#6d6e71}.phd-link-color--gray-dark[data-v-58212be8],.phd-link-color--gray-dark[data-v-58212be8]:hover{color:#373737}.phd-link-color--black[data-v-58212be8],.phd-link-color--black[data-v-58212be8]:hover{color:#000}.phd-link-color--black-alt[data-v-58212be8],.phd-link-color--black-alt[data-v-58212be8]:hover{color:#050606}.phd-link-color--blue[data-v-58212be8],.phd-link-color--blue[data-v-58212be8]:hover{color:#65baf5}.phd-link-color--blue-alt[data-v-58212be8],.phd-link-color--blue-alt[data-v-58212be8]:hover{color:#034a80}.phd-link-color--mustard[data-v-58212be8],.phd-link-color--mustard[data-v-58212be8]:hover{color:#f9b146}.phd-link-color--mustard-alt[data-v-58212be8],.phd-link-color--mustard-alt[data-v-58212be8]:hover{color:#a7762d}.phd-link-color--lime[data-v-58212be8],.phd-link-color--lime[data-v-58212be8]:hover{color:#abd02e}.phd-link-color--lime-alt[data-v-58212be8],.phd-link-color--lime-alt[data-v-58212be8]:hover{color:#6b831c}.phd-link-color--seafoam[data-v-58212be8],.phd-link-color--seafoam[data-v-58212be8]:hover{color:#30b6a1}.phd-link-color--seafoam-alt[data-v-58212be8],.phd-link-color--seafoam-alt[data-v-58212be8]:hover{color:#1d7164}.ecc-bg--cor-1[data-v-58212be8]{background-color:#67bf80}.ecc-bg--cor-2a[data-v-58212be8]{background-color:#ffd643}.ecc-bg--cor-2b[data-v-58212be8]{background-color:#f1a63e}.ecc-bg--cor-3nobenefit[data-v-58212be8]{background-color:#ef6e5d}.ecc-bg--cor-3harm[data-v-58212be8]{background-color:#e71e26}.ecc-bg--loe-br[data-v-58212be8]{background-color:#5c99cf}.ecc-bg--loe-cld[data-v-58212be8]{background-color:#9cbfe2}.ecc-bg--loe-a[data-v-58212be8]{background-color:#3776c8}.ecc-bg--loe-bnr[data-v-58212be8]{background-color:#5b99d1}.ecc-bg--loe-ceo[data-v-58212be8]{background-color:#bdd3ea}.ecc-bg--gray[data-v-58212be8]{background-color:#ebebeb}.ecc-bg--white[data-v-58212be8]{background-color:#fff}.ecc-bg--black[data-v-58212be8]{background-color:#000}.ecc-font-color--cor-1[data-v-58212be8]{color:#67bf80}.ecc-font-color--cor-2a[data-v-58212be8]{color:#ffd643}.ecc-font-color--cor-2b[data-v-58212be8]{color:#f1a63e}.ecc-font-color--cor-3nobenefit[data-v-58212be8]{color:#ef6e5d}.ecc-font-color--cor-3harm[data-v-58212be8]{color:#e71e26}.ecc-font-color--loe-br[data-v-58212be8]{color:#5c99cf}.ecc-font-color--loe-cld[data-v-58212be8]{color:#9cbfe2}.ecc-font-color--loe-a[data-v-58212be8]{color:#3776c8}.ecc-font-color--loe-bnr[data-v-58212be8]{color:#5b99d1}.ecc-font-color--loe-ceo[data-v-58212be8]{color:#bdd3ea}.ecc-font-color--gray[data-v-58212be8]{color:#ebebeb}.ecc-font-color--white[data-v-58212be8]{color:#fff}.ecc-font-color--black[data-v-58212be8]{color:#000}.thumbnail[data-v-58212be8]{width:64px;height:64px;-o-object-fit:cover;object-fit:cover}.card[data-v-58212be8]{border-radius:6px;border:0}.card .card-body[data-v-58212be8]{color:#979797;padding-top:4px;text-transform:uppercase;font-size:.85rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.color-palette[data-v-58212be8]{-webkit-box-shadow:0 15px 30px 0 rgba(0,0,0,.2);box-shadow:0 15px 30px 0 rgba(0,0,0,.2);letter-spacing:1px}.color-palette__header[data-v-58212be8]{border:0;background-color:transparent}.color-palette__colors[data-v-58212be8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:4px;overflow:hidden;font-size:14px}.color-palette__colors>[data-v-58212be8]{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center;color:#fff;padding:34px 0}.color-palette__color--gray-border[data-v-58212be8]{background-color:#dee2e6;color:#050606}.color-palette__color--red-border[data-v-58212be8]{background-color:#d22338;color:#fff}.color-palette__color--blue[data-v-58212be8]{background:#65baf5}.color-palette__color--blue-dark[data-v-58212be8]{background:#034a80}.color-palette__color--mustard[data-v-58212be8]{background:#f9b146;color:#2e2a2b}.color-palette__color--mustard-dark[data-v-58212be8]{background:#a7762d}.color-palette__color--lime[data-v-58212be8]{background:#abd02e;color:#2e2a2b}.color-palette__color--lime-dark[data-v-58212be8]{background:#6b831c}.color-palette__color--seafoam[data-v-58212be8]{background:#30b6a1;color:#2e2a2b}.color-palette__color--seafoam-dark[data-v-58212be8]{background:#1d7164}.c-text-color-card .card[data-v-58212be8]{height:340px}.news-list__byline[data-v-58212be8],.news-list__desc[data-v-58212be8]{font-weight:500}", ""]);

// exports


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mb-3"},[_vm._v("Membership")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"component__heading mb-3"},[_vm._v("Borders")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h3',{staticClass:"component__heading mb-3"},[_vm._v("Text Colors (Passed Color Contrast Ratio)")]),_vm._v(" "),(!_vm.isFetching)?_c('div',{staticClass:"row mb-4"},_vm._l((_vm.colors),function(color,index){return _c('div',{key:index,staticClass:"col-md-3"},[_c('div',{staticClass:"c-text-color-card"},[_c('div',{staticClass:"card phd-box-shadow my-3"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"small text-danger d-flex justify-content-between align-items-center text-lowercase"},[_c('code',[_vm._v(_vm._s('.h-color--'+color))])]),_vm._v(" "),_c('div',{staticClass:"section__label"},[_vm._v("Recent News")]),_vm._v(" "),_c('h4',{class:"mb-4 h-color--"+color},[_vm._v(_vm._s(_vm.headlines[Math.floor(Math.random() * _vm.headlines.length)]))]),_vm._v(" "),_c('p',{staticClass:"news-list__desc small h-color--gray-dark text-capitalize"},[_vm._v("Atrial fibrillation (AF) is the most common cardiac arrhythmia...")]),_vm._v(" "),_c('hr',{staticClass:"w-100 mt-auto"}),_vm._v(" "),_c('a',{staticClass:"text-left c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("View More")])])])])])}),0):_vm._e(),_vm._v(" "),(!_vm.isFetching)?_c('div',{staticClass:"row mb-4"},_vm._l((_vm.cardsamplecolors),function(color,index){return _c('div',{key:index,staticClass:"col-md-3"},[_c('div',{staticClass:"c-text-color-card"},[_c('div',{staticClass:"card phd-box-shadow my-3"},[_c('div',{staticClass:"card-body pt-3"},[_c('div',{staticClass:"small text-danger d-flex justify-content-between align-items-center text-lowercase"},[_c('code',[_vm._v(_vm._s('.h-color--'+color))])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('img',{staticClass:"p-1 mr-2 thumbnail rounded-circle",attrs:{"src":_vm.users[index].avatars[0].url}}),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"mb-0 news-list__title text-capitalize",class:"h-color--"+color},[_c('span',[_vm._v(_vm._s(_vm.users[index].first_name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.users[index].last_name))])]),_vm._v(" "),_c('p',{staticClass:"news-list__byline h-color--black text-capitalize"},[_vm._v("Lorem ipsum, dolor.")])])]),_vm._v(" "),_c('h4',{class:"mt-auto mb-1 h-color--"+color},[_vm._v(_vm._s(_vm.headlines[Math.floor(Math.random() * _vm.headlines.length)]))]),_vm._v(" "),_c('p',{staticClass:"news-list__desc small h-color--gray-dark text-capitalize"},[_vm._v("Atrial fibrillation (AF) is the most common cardiac arrhythmia...")]),_vm._v(" "),_c('hr',{staticClass:"w-100 mt-auto"}),_vm._v(" "),_c('a',{staticClass:"text-left c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("View More")])])])])])}),0):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card color-palette mb-4"},[_c('div',{staticClass:"card-header color-palette__header"},[_c('div',{staticClass:"color-palette__colors"},[_c('div',{staticClass:"color-palette__color--blue h-color--black"},[_vm._v("65BAF5")]),_vm._v(" "),_c('div',{staticClass:"color-palette__color--blue-dark"},[_vm._v("034A80")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n                    Blue\n                    "),_c('div',{staticClass:"small text-danger d-flex justify-content-between align-items-center"},[_c('code',[_vm._v("$phd-blue")]),_vm._v(" "),_c('code',[_vm._v("$phd-blue-alt")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card color-palette mb-4"},[_c('div',{staticClass:"card-header color-palette__header"},[_c('div',{staticClass:"color-palette__colors"},[_c('div',{staticClass:"color-palette__color--mustard"},[_vm._v("F9B146")]),_vm._v(" "),_c('div',{staticClass:"color-palette__color--mustard-dark h-color--black"},[_vm._v("A7762D")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n                    Mustard\n                    "),_c('div',{staticClass:"small text-danger d-flex justify-content-between align-items-center"},[_c('code',[_vm._v("$phd-mustard")]),_vm._v(" "),_c('code',[_vm._v("$phd-mustard-alt")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card color-palette mb-4"},[_c('div',{staticClass:"card-header color-palette__header"},[_c('div',{staticClass:"color-palette__colors"},[_c('div',{staticClass:"color-palette__color--lime"},[_vm._v("ABD02E")]),_vm._v(" "),_c('div',{staticClass:"color-palette__color--lime-dark"},[_vm._v("687F1A")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n                    Lime\n                    "),_c('div',{staticClass:"small text-danger d-flex justify-content-between align-items-center"},[_c('code',[_vm._v("$phd-lime")]),_vm._v(" "),_c('code',[_vm._v("$phd-lime-alt")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card color-palette mb-4"},[_c('div',{staticClass:"card-header color-palette__header"},[_c('div',{staticClass:"color-palette__colors"},[_c('div',{staticClass:"color-palette__color--seafoam"},[_vm._v("55D2BF")]),_vm._v(" "),_c('div',{staticClass:"color-palette__color--seafoam-dark"},[_vm._v("1D7164")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n                    Seafoam\n                    "),_c('div',{staticClass:"small text-danger d-flex justify-content-between align-items-center"},[_c('code',[_vm._v("$phd-seafoam")]),_vm._v(" "),_c('code',[_vm._v("$phd-seafoam-alt")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card color-palette mb-4"},[_c('div',{staticClass:"card-header color-palette__header"},[_c('div',{staticClass:"color-palette__colors"},[_c('div',{staticClass:"color-palette__color--gray-border text-uppercase"},[_vm._v("dee2e6")]),_vm._v(" "),_c('div',{staticClass:"color-palette__color--red-border"},[_vm._v("034A80")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n                    Border\n                    "),_c('div',{staticClass:"small text-danger d-flex justify-content-between align-items-center"},[_c('code',[_vm._v("$gray-300")]),_vm._v(" "),_c('code',[_vm._v("$phd-red")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa0f03c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_buttons_vue__ = __webpack_require__(1106);
function injectStyle (ssrContext) {
  __webpack_require__(1104)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fa0f03c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa0f03c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_buttons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1105);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("4cfe8ad9", content, true, {});

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".button-table[data-v-6fa0f03c]{table-layout:inherit}th[data-v-6fa0f03c]{font-weight:400;color:#6d6e71}", ""]);

// exports


/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-uppercase mt-5 mb-3"},[_vm._v("Buttons")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table button-table"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Outline")]),_vm._v(" "),_c('th',[_vm._v("Strong CTA")]),_vm._v(" "),_c('th',[_vm._v("Round CTA")]),_vm._v(" "),_c('th',[_vm._v("Outline Round")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',[_vm._v("Default")]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-outline"},[_vm._v("View Programming")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn w-100 text-uppercase"},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round w-100"},[_vm._v("Button")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-outline btn-round"},[_vm._v("Renew Your Membership")])])])])])]),_vm._v(" "),_c('code',{staticClass:"small"},[_c('p',{staticStyle:{"line-height":"16px"}},[_c('sup',[_vm._v("*")]),_vm._v("Removed the linear gradient for hover and active from t he comp. No CSS transition for linear gradients. Matched color for hover and active from comp instead.\n    ")])]),_vm._v(" "),_c('h2',{staticClass:"component__heading mt-5 mb-3"},[_vm._v("Membership")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table button-table"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Premier")]),_vm._v(" "),_c('th',[_vm._v("Professional")]),_vm._v(" "),_c('th',[_vm._v("Signature")]),_vm._v(" "),_c('th',[_vm._v("Subscriber")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',[_vm._v("Default")]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-membership btn-membership--premier w-100"},[_vm._v("Sign Up")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round w-100 btn-membership btn-membership--pro"},[_vm._v("Sign Up")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-membership btn-membership--sig w-100"},[_vm._v("Sign Up")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-membership btn-membership--sub w-100"},[_vm._v("Sign Up")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Hover")]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-membership btn-membership--premier w-100 active"},[_vm._v("Sign Up")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-membership btn-membership--pro w-100 active"},[_vm._v("Sign Up")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-membership btn-membership--sig w-100 active"},[_vm._v("Sign Up")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-membership btn-membership--sub w-100 active"},[_vm._v("Sign Up")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Disabled")]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-membership btn-membership--premier w-100",attrs:{"disabled":""}},[_vm._v("Sign Up")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-membership btn-membership--pro w-100",attrs:{"disabled":""}},[_vm._v("Sign Up")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-membership btn-membership--sig w-100",attrs:{"disabled":""}},[_vm._v("Sign Up")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-round btn-membership btn-membership--sub w-100",attrs:{"disabled":""}},[_vm._v("Sign Up")])])])])])]),_vm._v(" "),_c('h5',{staticClass:"mt-5"},[_vm._v("Example of Buttons")]),_vm._v(" "),_c('div',{staticClass:"l-promo l-promo--shadow"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"d-flex justify-content-between mb-3"},[_c('h2',[_vm._v("Professional Partnership")]),_vm._v(" "),_c('div',{staticClass:"c-cta__action d-flex align-items-center"},[_c('a',{staticClass:"btn btn-round btn-membership btn-membership--premier",attrs:{"href":"#"}},[_vm._v("Sign Up")])])]),_vm._v(" "),_c('p',[_vm._v("\n          Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur cumque sequi, veritatis animi aspernatur, nobis perferendis, necessitatibus corporis adipisci maxime ut. Deleniti voluptatum non quisquam doloremque nemo consectetur eaque! Pariatur.\n          "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_vm._v("Click here to Compare Partnership")])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters"},[_c('a',{staticClass:"btn btn-outline col-md m-2",attrs:{"href":"#","role":"button"}},[_vm._v("Housing & Transportation")]),_vm._v(" "),_c('a',{staticClass:"btn btn-outline col-md m-2",attrs:{"href":"#","role":"button"}},[_vm._v("Submit Abstract")]),_vm._v(" "),_c('a',{staticClass:"btn btn-outline col-md m-2",attrs:{"href":"#","role":"button"}},[_vm._v("View Programming")]),_vm._v(" "),_c('a',{staticClass:"btn col-md m-2",attrs:{"href":"#","role":"button"}},[_vm._v("Register Now")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_223c380c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_links_vue__ = __webpack_require__(1110);
function injectStyle (ssrContext) {
  __webpack_require__(1108)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-223c380c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_223c380c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_links_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1109);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("0f91b6f8", content, true, {});

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".button-table[data-v-223c380c]{table-layout:inherit}.c-code__heading[data-v-223c380c],th[data-v-223c380c]{font-weight:400;color:#6d6e71}", ""]);

// exports


/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-uppercase mt-5 mb-3"},[_vm._v("Links")]),_vm._v(" "),_c('p',[_vm._v("\n        Updated: 3/27/2020 Links are now consistent with Heart.org.\n    ")]),_vm._v(" "),_c('table',{staticClass:"table button-table"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("CTA Links")]),_vm._v(" "),_c('th',[_vm._v("CTA Links Alt")]),_vm._v(" "),_c('th',[_vm._v("Basic Text Link")]),_vm._v(" "),_c('th',[_vm._v("Mobile Menu Nav Item")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',[_vm._v("Default")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("View All Meetings")])]),_vm._v(" "),_c('td',[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--black text-uppercase",attrs:{"href":"#"}},[_vm._v("Learn more")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"#"}},[_vm._v("Read the full article in circulation")])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"c-mobile-nav"},[_c('ul',{staticClass:"list-unstyled"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"",attrs:{"href":"/en/health-topics"}},[_vm._v("Nav Item")])])])])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Active")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"c-cta h-theme--red c-cta--arrow active",attrs:{"href":"#"}},[_vm._v("View All Meetings")])]),_vm._v(" "),_c('td',[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--black text-uppercase active",attrs:{"href":"#"}},[_vm._v("Learn more")])]),_vm._v(" "),_c('td',[_c('a',{staticClass:"active",attrs:{"href":"#"}},[_vm._v("Read the full article in circulation")])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"c-mobile-nav"},[_c('ul',{staticClass:"list-unstyled"},[_c('li',{staticClass:"nav-item active"},[_c('a',{staticClass:"",attrs:{"href":"/en/health-topics"}},[_vm._v("Nav Item Active")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 c-code mb-4"},[_c('div',{staticClass:"c-code__heading"},[_vm._v("\n            CTA Links\n        ")]),_vm._v(" "),_c('div',[_c('code',{staticClass:"small text-danger"},[_vm._v("\n                a.c-cta.c-cta--arrow.h-theme--red\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 c-code mb-4"},[_c('div',{staticClass:"c-code__heading"},[_vm._v("\n            CTA Links Alt\n        ")]),_vm._v(" "),_c('div',[_c('code',{staticClass:"small text-danger"},[_vm._v("\n                a.c-cta.c-cta--arrow.h-theme--black.text-uppercase\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 c-code mb-4"},[_c('div',{staticClass:"c-code__heading"},[_vm._v("\n            Basic Text Link\n        ")]),_vm._v(" "),_c('div',[_c('code',{staticClass:"small text-danger"},[_vm._v("\n                <a href=\"#\">Read the full article in circulation »</a>\n            ")])])]),_vm._v(" "),_c('h5',{},[_vm._v("Example of component using links")]),_vm._v(" "),_c('div',{staticClass:"l-promo l-promo--shadow l-promo--border-top"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h2',[_vm._v("Professional Partnership")]),_vm._v(" "),_c('div',{staticClass:"c-cta__action d-flex align-items-center"},[_c('a',{staticClass:"c-cta c-cta--secondary c-cta--arrow h-theme--black text-uppercase",attrs:{"href":"#"}},[_vm._v("View All Meetings")])])]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur cumque sequi, veritatis animi aspernatur, nobis perferendis, necessitatibus corporis adipisci maxime ut. Deleniti voluptatum non quisquam doloremque nemo consectetur eaque! Pariatur. "),_c('br'),_c('a',{attrs:{"href":"#"}},[_vm._v("Click here to Compare Partnership")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider"},[_c('a',{staticClass:"c-promo__cta c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("View Meetings")]),_vm._v(" "),_c('span',{staticClass:"c-promo__cta-divider"}),_vm._v(" "),_c('a',{staticClass:"c-promo__cta c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("View Journals")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_394f3d26_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_dropdowns_vue__ = __webpack_require__(1114);
function injectStyle (ssrContext) {
  __webpack_require__(1112)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-394f3d26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_394f3d26_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_dropdowns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1113);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("be321962", content, true, {});

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".c-code__heading[data-v-394f3d26]{font-weight:400;color:#979797}", ""]);

// exports


/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-uppercase mt-5 mb-5"},[_vm._v("Dropdowns")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',{},[_c('div',{staticClass:"pb-2",attrs:{"id":"socialDeterminantHeading"}},[_vm._v("\n                    Dropdown with label\n                ")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"socialDeterminantHeading","input-name":"socialDeterminant","input-directive":true,"default-value":"","toggle-class":"btn btn-outline btn--select"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-outline btn--select"},[_vm._v("Select Social Determinant")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Select Social Determinant","value":"","item-class":"c-select-dropdown__item","selected":""}},[_vm._v("Select Social\n                            Determinant")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 1","value":"option-1","item-class":"c-select-dropdown__item"}},[_vm._v("Option 1")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 2","value":"option-2","item-class":"c-select-dropdown__item"}},[_vm._v("Option 2")])],1)],2)],1)]),_vm._v(" "),_c('code',{staticClass:"small text-danger col-sm-12",staticStyle:{"margin-top":"-25px"}},[_vm._v("\n            Use the aha-listbox component. Change the toggle-class attribute\n            value to \"btn btn-outline btn--select\".\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b14b298c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_inputs_vue__ = __webpack_require__(1118);
function injectStyle (ssrContext) {
  __webpack_require__(1116)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b14b298c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_inputs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1117);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("4860a514", content, true, {});

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "th{font-weight:400;color:#979797}", ""]);

// exports


/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Default")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"phd-first-name"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"phd-first-name","placeholder":"First Name"}})])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Active")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"phd-first-name-active"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{staticClass:"form-control has-focus",attrs:{"type":"text","id":"phd-first-name-active","placeholder":"First Name"}})])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Disabled")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"phd-first-name-disabled"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"phd-first-name-disabled","placeholder":"First Name","disabled":""}})])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Info Copy")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"phd-first-name-copy"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"phd-first-name-copy","aria-describedby":"","placeholder":"First Name"}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted",attrs:{"id":""}},[_vm._v("Some Info Copy Here")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81a98ba8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_inputs_feedback_vue__ = __webpack_require__(1122);
function injectStyle (ssrContext) {
  __webpack_require__(1120)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-81a98ba8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81a98ba8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_inputs_feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1121);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("55245a42", content, true, {});

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"phd-first-name-feedback"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{staticClass:"form-control has-focus",attrs:{"type":"text","id":"phd-first-name-feedback","placeholder":"First Name"}})])])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"phd-first-name-feedback-active"}},[_vm._v("First Name")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control has-invalid-icon",attrs:{"id":"phd-first-name-feedback-active","type":"text","placeholder":"Username","aria-label":"Username","aria-describedby":"basic-addon1"}}),_vm._v(" "),_c('div',{staticClass:"input-validation-icon input-validation-icon--valid"},[_c('i',{staticClass:"icon-check"})])])])])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"phd-first-name-feedback-error"}},[_vm._v("First Name")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control is-invalid has-invalid-icon",attrs:{"type":"text","id":"phd-first-name-feedback-error","placeholder":"First Name","required":""}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please provide a valid first name.")])])])])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"phd-first-name-feedback-copy"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"phd-first-name-feedback-copy","aria-describedby":"","placeholder":"First Name"}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted",attrs:{"id":""}},[_vm._v("Your data is private. "),_c('a',{staticClass:"text-primary",attrs:{"href":"#","title":"Learn more about privacy."}},[_vm._v("Learn more.")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4182b78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_radios_vue__ = __webpack_require__(1124);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4182b78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_radios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-md"},[_c('h3',{staticClass:"mb-3"},[_vm._v("Radios")]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio1phd","name":"customRadioGroup1","checked":""}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio1phd"}},[_vm._v("Radio is on")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio2phd","name":"customRadioGroup1"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio2phd"}},[_vm._v("Radio is off")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio3phd","disabled":"","checked":"","name":"customRadioGroup21"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio3phd"}},[_vm._v("Disabled Radio is on")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio4phd","disabled":"","name":"customRadioGroup21"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio4phd"}},[_vm._v("Disabled Radio is off")])])]),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('h3',{staticClass:"mb-3"},[_vm._v("Checkboxes")]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customControlAutosizing"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customControlAutosizing"}},[_vm._v("Remember my preference")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf462b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_icons_vue__ = __webpack_require__(1128);
function injectStyle (ssrContext) {
  __webpack_require__(1126)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf462b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1127);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("6ccded26", content, true, {});

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".icon__heading{font-weight:400;color:#6d6e71}.icons-wrapper{-ms-flex-wrap:wrap;flex-wrap:wrap}.icons-wrapper,.icons-wrapper>div{display:-webkit-box;display:-ms-flexbox;display:flex}.icons-wrapper>div{margin:15px;text-align:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-width:200px}", ""]);

// exports


/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"icons-wrapper"},[_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Housing")]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/housing.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Housing Active")]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/housing-active.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Registration")]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/registration.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Registration Active")]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/registration-active.svg"}})])])]),_vm._v(" "),_c('div',{staticClass:"icons-wrapper"},[_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Program")]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/icon-program.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Renew Membership")]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/renew-membership.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Schedule")]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/schedule.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Tool Kit")]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/toolkit.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Guest")]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/guest.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Institution")]),_vm._v(" "),_c('span',[_c('img',{attrs:{"src":"assets/icons/institution-black.svg"}})])])]),_vm._v(" "),_c('h3',{staticClass:"mt-5 mb-3"},[_vm._v("Membership")]),_vm._v(" "),_c('div',{staticClass:"icons-wrapper"},[_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Premier")]),_vm._v(" "),_c('div',{staticClass:"icon-membership icon-membership__premier"},[_c('img',{attrs:{"src":"assets/icons/membership-ribbon-black.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Premier Active")]),_vm._v(" "),_c('div',{staticClass:"icon-membership icon-membership__premier active"},[_c('img',{attrs:{"src":"assets/icons/membership-ribbon-white.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Limited")]),_vm._v(" "),_c('div',{staticClass:"icon-membership icon-membership__limited"},[_c('img',{attrs:{"src":"assets/icons/membership-pencil-black.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Limited Active")]),_vm._v(" "),_c('div',{staticClass:"icon-membership icon-membership__limited active"},[_c('img',{attrs:{"src":"assets/icons/membership-pencil-white.svg"}})])])]),_vm._v(" "),_c('div',{staticClass:"icons-wrapper"},[_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Professional")]),_vm._v(" "),_c('div',{staticClass:"icon-membership icon-membership__pro"},[_c('img',{attrs:{"src":"assets/icons/membership-briefcase-black.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Professional Active")]),_vm._v(" "),_c('div',{staticClass:"icon-membership icon-membership__pro active"},[_c('img',{attrs:{"src":"assets/icons/membership-briefcase-white.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Signature")]),_vm._v(" "),_c('div',{staticClass:"icon-membership icon-membership__signature"},[_c('img',{attrs:{"src":"assets/icons/membership-hand-card-black.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Signature Active")]),_vm._v(" "),_c('div',{staticClass:"icon-membership icon-membership__signature active"},[_c('img',{attrs:{"src":"assets/icons/membership-hand-card-white.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Institution")]),_vm._v(" "),_c('div',{staticClass:"icon-membership icon-membership__institution"},[_c('img',{attrs:{"src":"assets/icons/institution-black.svg"}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"icon__heading"},[_vm._v("Institution Active")]),_vm._v(" "),_c('div',{staticClass:"icon-membership icon-membership--bg-gray-dark active"},[_c('img',{attrs:{"src":"assets/icons/institution-white.svg"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da4e1f48_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_skeleton_component_vue__ = __webpack_require__(1132);
function injectStyle (ssrContext) {
  __webpack_require__(1130)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-da4e1f48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da4e1f48_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_skeleton_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1131);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("92f30d26", content, true, {});

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".c-promo[data-v-da4e1f48]{background-color:#dee2e6;width:100%;height:300px}.alert-columns[data-v-da4e1f48]{-webkit-columns:auto 2;-moz-columns:auto 2;columns:auto 2}.alert p[data-v-da4e1f48]{font-weight:500;line-height:1rem}.alert button[data-v-da4e1f48]{color:currentColor}", ""]);

// exports


/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{},[_vm._v("Skeleton")]),_vm._v(" "),_c('div',{staticClass:"alert alert-warning"},[_c('h6',[_vm._v("Note:")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('hr',{staticClass:"mb-0"}),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('collapse1'),expression:"'collapse1'"}],staticClass:"btn btn-link-plain btn--select w-100 text-left"},[_c('h3',{staticClass:"h3"},[_vm._v("Code")])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1"}},[_c('code',{staticClass:"small text-gray p-3"},[_c('pre',[_vm._v(" <div class=\"PHD\">\n     <div class=\"l-main\">\n\n        <!-- YOUR COMPONENT -->\n        <div class=\"l-promo l-promo--name-of-your-component l-promo--shadow l-promo--border-top l-promo--border-bottom\">\n            <!-- Col -->\n            <div class=\"l-promo__col col-md\">\n                <div class=\"c-promo\">\n                //...        \n                </div>\n            </div>\n            <!-- End Col -->\n        </div>\n        <!-- END COMPONENT -->\n    <div>\n</<div>\n")])])])],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-columns"},[_c('p',{staticClass:"small"},[_vm._v("The skeleton is a good starting point to create your component. You don't have to follow in your component creation. Make sure the component's paddings and margins are consistent with the site.")]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v(" To inherit all the PHD styling make sure to wrap the component inside .PHD for testing in demo. Don't need to have for the dev, test, prod environment because it already exist. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo l-promo--name-of-your-component l-promo--shadow"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"})]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"})]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo l-promo--name-of-your-component l-promo--shadow l-promo--border-top"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"})]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo l-promo--name-of-your-component l-promo--shadow l-promo--border-bottom"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2caa2d8d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_default_tables_vue__ = __webpack_require__(1134);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2caa2d8d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_default_tables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("Table(s)")]),_vm._v(" "),_c('div',{staticClass:"alert alert-warning"},[_c('h6',[_vm._v("Note(s):")]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("Here is a basic example of a table that a user might drop into the rich text editor to use on the sight.  No extra classes, just base table HTML.")]),_vm._v(" "),_c('hr',{staticClass:"mb-0"}),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('collapse1'),expression:"'collapse1'"}],staticClass:"btn btn-link-plain btn--select w-100 text-left"},[_c('h3',{staticClass:"h3"},[_vm._v("Code")])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1"}},[_c('code',{staticClass:"small text-gray p-3"},[_c('pre',[_vm._v("                    <table>\n                        <thead>\n                            <tr>\n                                <th></th>\n                                <th>Column Title</th>\n                                <th>Column Title 2</th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr>\n                                <th>Row Title</th>\n                                <td>Quisquam, fuga pariatur!</td>\n                                <td>Eaque, hic libero?</td>\n                            </tr>\n                            <tr>\n                                <th>Row Title 2</th>\n                                <td>Expedita, ex magni.</td>\n                                <td>Recusandae, ad fuga.</td>\n                            </tr>\n                            <tr>\n                                <th>Row Title 3</th>\n                                <td>Hic, libero atque?</td>\n                                <td>Placeat, quis est.</td>\n                            </tr>\n                            <tr>\n                                <th>Row Title four</th>\n                                <td>Eos, obcaecati corporis!</td>\n                                <td>Eaque, veritatis natus!</td>\n                            </tr>\n                            <tr>\n                                <th>Row Title fivesies</th>\n                                <td>Alias, iste eaque.</td>\n                                <td>Atque, provident eius.</td>\n                            </tr>   \n                        </tbody>\n                    </table>\n                ")])])])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_vm._m(2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('tbody',[_c('tr',[_c('th',[_vm._v("Row Title")]),_vm._v(" "),_c('td',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolores, numquam.")]),_vm._v(" "),_c('td',[_vm._v("Eaque, hic libero?")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Row Title 2")]),_vm._v(" "),_c('td',[_vm._v("Expedita, ex magni.")]),_vm._v(" "),_c('td',[_vm._v("Recusandae, ad fuga.")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Lorem ipsum dolor sit amet consectetur")]),_vm._v(" "),_c('td',[_vm._v("Eos, obcaecati corporis!")]),_vm._v(" "),_c('td',[_vm._v("Eaque, veritatis natus!")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('tr',[_c('th',[_vm._v("Column Title")]),_vm._v(" "),_c('th',[_vm._v("Column Title 2")]),_vm._v(" "),_c('th',[_vm._v("Column Title Three")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Explicabo blanditiis vero perferendis laboriosam ad")]),_vm._v(" "),_c('td',[_vm._v("Lorem ipsum dolor sit")]),_vm._v(" "),_c('td',[_vm._v("Perspiciatis veniam ex excepturi")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Lorem ipsum dolor sit amet consectetur")]),_vm._v(" "),_c('td',[_vm._v("Ab in blanditiis porro")]),_vm._v(" "),_c('td',[_vm._v("Numquam, at")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Lorem, ipsum")]),_vm._v(" "),_c('td',[_vm._v("Ut, eligendi")]),_vm._v(" "),_c('td',[_vm._v("Corrupti doloremque deserunt in facere aut")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Column Title")]),_vm._v(" "),_c('th',[_vm._v("Column Title 2")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',[_vm._v("Row Title")]),_vm._v(" "),_c('td',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolores, numquam.")]),_vm._v(" "),_c('td',[_vm._v("Eaque, hic libero?")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Row Title 2")]),_vm._v(" "),_c('td',[_vm._v("Expedita, ex magni.")]),_vm._v(" "),_c('td',[_vm._v("Recusandae, ad fuga.")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Lorem ipsum dolor sit amet consectetur")]),_vm._v(" "),_c('td',[_vm._v("Eos, obcaecati corporis!")]),_vm._v(" "),_c('td',[_vm._v("Eaque, veritatis natus!")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12e1f4b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__ = __webpack_require__(1136);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12e1f4b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"Breadcrumb Navigation"}},[_c('ol',{staticClass:"c-breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("A long page title")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Another very long page title")])]),_vm._v(" "),_c('li',[_vm._v("Current")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41f239e4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_with_link_vue__ = __webpack_require__(1138);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41f239e4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_with_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('b-row',[_c('b-col',{attrs:{"sm":"8"}},[_c('b-row',[_c('nav',{attrs:{"aria-label":"Breadcrumb Navigation"}},[_c('ol',{staticClass:"c-breadcrumb mt-0"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("A long page title")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Another very long page title")])]),_vm._v(" "),_c('li',[_vm._v("Current")])])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-row',{staticClass:"justify-content-sm-end"},[_c('a',{staticClass:"c-listing-header__cta c-cta c-cta--arrow mt-0 mb-4 mb-sm-0",attrs:{"href":"https://www.strokeassociation.org/Stroke%20Support%20Group%20Finder?zipcode=78748&radius=20"}},[_vm._v("Back to Search")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_affda64e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listing_header_vue__ = __webpack_require__(1140);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_affda64e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listing_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-listing-header"},[_c('p',{staticClass:"c-listing-header__kicker"},[_c('img',{staticClass:"c-listing-header__kicker-icon",attrs:{"src":"assets/aha_heart.svg","alt":""}}),_vm._v("American Heart Association\n    ")]),_vm._v(" "),_c('h2',{staticClass:"c-listing-header__heading"},[_vm._v("Health Topics")]),_vm._v(" "),_c('div',{staticClass:"c-listing-header__cta-container"},[_c('p',{staticClass:"c-listing-header__subheading"},[_vm._v("Lorem Ipsum dolor sit amet, consectetur adipiscing elit.")]),_vm._v(" "),_c('a',{staticClass:"c-listing-header__cta c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Read All News Stories")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73db843d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listing_header_medium_vue__ = __webpack_require__(1142);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73db843d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listing_header_medium_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-listing-header c-listing-header--medium"},[_c('div',{staticClass:"c-listing-header__cta-container"},[_c('h2',{staticClass:"c-listing-header__heading"},[_vm._v("Health Topics")]),_vm._v(" "),_c('span',{staticClass:"h-flex"}),_vm._v(" "),_c('a',{staticClass:"c-listing-header__cta c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("View More Info Sheets")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74954fa2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listing_header_small_vue__ = __webpack_require__(1144);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74954fa2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listing_header_small_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-listing-header c-listing-header--small"},[_c('div',{staticClass:"c-listing-header__cta-container"},[_c('h2',{staticClass:"c-listing-header__heading"},[_vm._v("Health Topics")]),_vm._v(" "),_c('span',{staticClass:"h-flex"}),_vm._v(" "),_c('a',{staticClass:"c-listing-header__cta c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("View More Info Sheets")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d05102_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_vue__ = __webpack_require__(1146);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d05102_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-notification',{attrs:{"notification-id":"test"}},[_c('div',{staticClass:"c-alert",attrs:{"role":"alert","aria-atomic":"true"}},[_c('div',{staticClass:"container c-alert__container"},[_c('div',{staticClass:"c-alert__message"},[_c('span',{staticClass:"c-alert__kicker"},[_vm._v("Take Action")]),_vm._v(" "),_c('a',{staticClass:"c-alert__content",attrs:{"href":"#"}},[_vm._v("Help those affected by recent catastrophic storms")])]),_vm._v(" "),_c('div',{staticClass:"c-alert__actions"},[_c('a',{staticClass:"c-alert__cta btn btn-round btn-light",attrs:{"href":"#"}},[_vm._v("Get Involved")]),_vm._v(" "),_c('button',{ref:"test",staticClass:"c-alert__close btn btn-dark",attrs:{"type":"button","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"c-top-nav js-mobile-nav-positioning",attrs:{"aria-label":"Top Navigation"}},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"c-top-nav__nav nav"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('li',{staticClass:"c-top-nav__item c-top-nav__button"},[_c('aha-nav-dropdown',{attrs:{"role":"menu","position":"center","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle h-theme--red"}},[_c('span',{staticClass:"c-underline-link"},[_c('img',{attrs:{"src":"assets/glyphs/donate-heart.svg","alt":""}}),_vm._v("Donate")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('ul',{staticClass:"c-nav-dropdown__list"},[_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link c-nav-dropdown__header",attrs:{"href":"#"}},[_vm._v("Donate")])]),_vm._v(" "),_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Link 1")])]),_vm._v(" "),_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Link 2")])]),_vm._v(" "),_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Link 3")])])])])],2)],1),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('li',{staticClass:"c-top-nav__item c-top-nav__search"}),_vm._v(" "),_c('li',{staticClass:"c-top-nav__item"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.coveomodal1",modifiers:{"coveomodal1":true}}],staticClass:"c-top-nav__link btn btn-link-plain"},[_c('img',{attrs:{"src":"assets/glyphs/search.svg","alt":""}}),_c('span',{staticClass:"sr-only"},[_vm._v("Search")])]),_vm._v(" "),_c('b-modal',{staticClass:"c-site-search-modal global-search-section",attrs:{"id":"coveomodal1","hide-footer":"","lazy":""}},[_c('div',{staticClass:"global-search-section__search-text"},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"global-search-section__coveo-block"},[_c('div',[_c('div',{attrs:{"id":"_C0D532FD-12E5-4585-AF03-F0B25CA425E8","data-search-interface-id":"coveoC606340E"}},[_c('div',{staticClass:"coveo-search-section"},[_c('div',{staticClass:"CoveoSearchInterface Coveostate CoveoComponentState CoveoComponentOptions CoveoQueryController CoveoDebug coveo-after-initialization",staticStyle:{"display":"block"},attrs:{"id":"_185F67BF-1D73-4AEE-9564-FDE5B0EB24D9_container","data-prebind-maximum-age":"currentMaximumAge","data-pipeline":"heart.org","data-applied-prebind":"true","data-maximum-age":"900000","data-coveo-for-sitecore-event-registered":"true"}},[_c('div',{staticClass:"CoveoSearchbox",attrs:{"id":"_185F67BF-1D73-4AEE-9564-FDE5B0EB24D9","data-enable-omnibox":"true","data-prebind-maximum-age":"currentMaximumAge","data-pipeline":"heart.org","data-placeholder":"ex: Heart Attack Symptoms","data-applied-prebind":"true","data-maximum-age":"900000"}},[_c('div',{staticClass:"CoveoForSitecoreExpressions"}),_vm._v(" "),_c('div',{staticClass:"CoveoForSitecoreConfigureSearchHub",attrs:{"data-sc-search-hub":"Search"}}),_c('a',{staticClass:"CoveoSearchButton",attrs:{"aria-label":"Search"}},[_c('span',{staticClass:"coveo-search-button"},[_c('svg',{staticClass:"coveo-search-button-svg",attrs:{"enable-background":"new 0 0 20 20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{staticClass:"coveo-magnifier-circle-svg",attrs:{"d":"m8.368 16.736c-4.614 0-8.368-3.754-8.368-8.368s3.754-8.368 8.368-8.368 8.368 3.754 8.368 8.368-3.754 8.368-8.368 8.368m0-14.161c-3.195 0-5.793 2.599-5.793 5.793s2.599 5.793 5.793 5.793 5.793-2.599 5.793-5.793-2.599-5.793-5.793-5.793"}}),_c('path',{attrs:{"d":"m18.713 20c-.329 0-.659-.126-.91-.377l-4.552-4.551c-.503-.503-.503-1.318 0-1.82.503-.503 1.318-.503 1.82 0l4.552 4.551c.503.503.503 1.318 0 1.82-.252.251-.581.377-.91.377"}})])])]),_c('span',{staticClass:"coveo-search-button-loading"},[_c('svg',{staticClass:"coveo-search-button-loading-svg",attrs:{"enable-background":"new 0 0 18 18","viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m16.76 8.051c-.448 0-.855-.303-.969-.757-.78-3.117-3.573-5.294-6.791-5.294s-6.01 2.177-6.79 5.294c-.134.537-.679.861-1.213.727-.536-.134-.861-.677-.728-1.212 1.004-4.009 4.594-6.809 8.731-6.809 4.138 0 7.728 2.8 8.73 6.809.135.536-.191 1.079-.727 1.213-.081.02-.162.029-.243.029z"}}),_c('path',{attrs:{"d":"m9 18c-4.238 0-7.943-3.007-8.809-7.149-.113-.541.234-1.071.774-1.184.541-.112 1.071.232 1.184.773.674 3.222 3.555 5.56 6.851 5.56s6.178-2.338 6.852-5.56c.113-.539.634-.892 1.184-.773.54.112.887.643.773 1.184-.866 4.142-4.57 7.149-8.809 7.149z"}})])])])]),_c('div',{staticClass:"CoveoOmnibox coveo-query-syntax-disabled magic-box"},[_c('div',{staticClass:"magic-box-clear"},[_c('div',{staticClass:"magic-box-icon"},[_c('svg',{staticClass:"magic-box-clear-svg",attrs:{"enable-background":"new 0 0 13 13","viewBox":"0 0 13 13","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m7.881 6.501 4.834-4.834c.38-.38.38-1.001 0-1.381s-1.001-.38-1.381 0l-4.834 4.834-4.834-4.835c-.38-.38-1.001-.38-1.381 0s-.38 1.001 0 1.381l4.834 4.834-4.834 4.834c-.38.38-.38 1.001 0 1.381s1.001.38 1.381 0l4.834-4.834 4.834 4.834c.38.38 1.001.38 1.381 0s .38-1.001 0-1.381z"}})])])])]),_c('div',{staticClass:"magic-box-input"},[_c('div',{staticClass:"magic-box-underlay"},[_c('span',{staticClass:"magic-box-highlight-container"},[_c('span',{attrs:{"data-id":"start","data-success":"true"}},[_c('span',{attrs:{"data-id":"Any","data-success":"true","data-value":""}})])]),_c('span',{staticClass:"magic-box-ghost-text"})]),_c('input',{attrs:{"spellcheck":"false","form":"coveo-dummy-form","autocomplete":"off","placeholder":"ex: Heart Attack Symptoms"}})]),_c('div',{staticClass:"magic-box-suggestions"})])]),_c('div',{staticClass:"CoveoForSitecoreContext",attrs:{"data-sc-should-have-analytics-component":"true","data-sc-analytics-enabled":"true","data-sc-current-language":"en","data-prebind-sc-language-field-name":"fieldTranslator","data-sc-language-field-name":"z95xlanguage","data-sc-labels":"{\"Created\" : \"Created\" , \"Created by\" : \"Created by\" , \"Creation time.\" : \"Creation time.\" , \"Language\" : \"Language\" , \"Last time modified.\" : \"Last time modified.\" , \"Template\" : \"Template\" , \"Uniform resource identifier\" : \"URI\" , \"Updated by\" : \"Updated by\" , \"If the problem persists contact the administrator.\" : \"If the problem persists contact the administrator.\" , \"Search is currently unavailable\" : \"Oops! Something went wrong on the server.\"}","data-sc-maximum-age":"900000","data-sc-page-name":"Home","data-sc-page-name-full-path":"/sitecore/content/Heart/Home","data-sc-index-source-name":"Coveo_web_index - azre1vsitecmpw1-sitecoreprodcm.heart.org","data-sc-is-in-experience-editor":"false","data-sc-is-user-anonymous":"true","data-sc-item-uri":"sitecore://web/{06543030-2367-46B0-A2D2-0ECC48DA526F}?lang=en&ver=63","data-sc-item-id":"06543030-2367-46b0-a2d2-0ecc48da526f","data-prebind-sc-latest-version-field-name":"fieldTranslator","data-sc-latest-version-field-name":"z95xlatestversion","data-sc-rest-endpoint-uri":"/coveo/rest","data-sc-site-name":"heart","data-sc-field-prefix":"f","data-sc-field-suffix":"12787","data-sc-prefer-source-specific-fields":"false","data-sc-external-fields":"[{\"fieldName\":\"sysauthor\",\"shouldEscape\":false},{\"fieldName\":\"syscollection\",\"shouldEscape\":false},{\"fieldName\":\"sysconcepts\",\"shouldEscape\":false},{\"fieldName\":\"sysdate\",\"shouldEscape\":false},{\"fieldName\":\"sysfiletype\",\"shouldEscape\":false},{\"fieldName\":\"syssource\",\"shouldEscape\":false},{\"fieldName\":\"sysrowid\",\"shouldEscape\":false},{\"fieldName\":\"sysattachmentparentid\",\"shouldEscape\":false},{\"fieldName\":\"sysclickableuri\",\"shouldEscape\":false},{\"fieldName\":\"sysindexeddate\",\"shouldEscape\":false},{\"fieldName\":\"sysisattachment\",\"shouldEscape\":false},{\"fieldName\":\"syslanguage\",\"shouldEscape\":false},{\"fieldName\":\"sysprintableuri\",\"shouldEscape\":false},{\"fieldName\":\"syssize\",\"shouldEscape\":false},{\"fieldName\":\"systitle\",\"shouldEscape\":false},{\"fieldName\":\"systopparent\",\"shouldEscape\":false},{\"fieldName\":\"systopparentid\",\"shouldEscape\":false},{\"fieldName\":\"systransactionid\",\"shouldEscape\":false},{\"fieldName\":\"sysuri\",\"shouldEscape\":false},{\"fieldName\":\"sysurihash\",\"shouldEscape\":false},{\"fieldName\":\"permanentid\",\"shouldEscape\":false}]","data-applied-prebind":"true"}})]),_vm._v(" "),_c('div',{staticClass:"coveo-hide-until-settings-added"})])])])])])],1)]),_vm._v(" "),_c('aha-mobile-nav',{attrs:{"modal-role":"dialog","modal-content-role":"document"}},[[_c('ul',{staticClass:"c-mobile-nav__list"},[_c('li',[_c('form',{staticClass:"c-mobile-nav__search c-mobile-nav__list-item",attrs:{"action":""}},[_c('label',{attrs:{"for":"mobile-search"}},[_c('input',{staticClass:"c-mobile-nav__search-input",attrs:{"id":"mobile-search","type":"text","placeholder":"Search American Heart Association"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Search American Heart Association")])]),_vm._v(" "),_c('button',{staticClass:"c-mobile-nav__search-submit btn btn-link-plain",attrs:{"type":"submit"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Search")]),_vm._v(" "),_c('img',{attrs:{"src":"assets/glyphs/search.svg","alt":""}})])])]),_vm._v(" "),_c('li',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.mobileNavCollapse6",modifiers:{"mobileNavCollapse6":true}}],staticClass:"c-mobile-nav__list-item btn btn-link-plain btn--select"},[_vm._v("\n                           Find Your Local Office\n                        ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"mobileNavCollapse6","visible":false}},[_c('ul',{staticClass:"c-mobile-nav__sub-list nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 1")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 2")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 3")])])])])],1),_vm._v(" "),_c('li',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.mobileNavCollapse3",modifiers:{"mobileNavCollapse3":true}}],staticClass:"c-mobile-nav__list-item btn btn-link-plain btn--select c-cta--icon"},[_c('img',{attrs:{"src":"assets/glyphs/flag.svg","alt":""}}),_vm._v("English\n                        ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"mobileNavCollapse3","visible":false}},[_c('ul',{staticClass:"c-mobile-nav__sub-list nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 1")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 2")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 3")])])])])],1),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mobile-nav__list-item c-cta c-cta--icon h-theme--red",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/cross.svg","alt":""}}),_vm._v("Heart Attack And Stroke Symptoms\n                        ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mobile-nav__list-item c-cta c-cta--icon h-theme--red",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/volunteer.svg","alt":""}}),_vm._v("Volunteer\n                        ")])]),_vm._v(" "),_c('li',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.mobileNavCollapse1",modifiers:{"mobileNavCollapse1":true}}],staticClass:"c-mobile-nav__list-item btn btn-link-plain btn--select c-cta--icon"},[_c('img',{attrs:{"src":"assets/glyphs/donate-heart.svg","alt":""}}),_c('span',{staticClass:"h-color--red"},[_vm._v("Donate")])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"mobileNavCollapse1","visible":false}},[_c('ul',{staticClass:"c-mobile-nav__sub-list nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 1")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 2")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 3")])])])])],1),_vm._v(" "),_c('li',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.mobileNavCollapse2",modifiers:{"mobileNavCollapse2":true}}],staticClass:"c-mobile-nav__list-item btn btn-link-plain btn--select"},[_vm._v("\n                            Healthy Living\n                        ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"mobileNavCollapse2","visible":false}},[_c('ul',{staticClass:"c-mobile-nav__sub-list nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 1")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 2")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 3")])])])])],1),_vm._v(" "),_c('li',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.mobileNavCollapse4",modifiers:{"mobileNavCollapse4":true}}],staticClass:"c-mobile-nav__list-item btn btn-link-plain btn--select"},[_vm._v("\n                            Location Selector\n                        ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"mobileNavCollapse4","visible":false}},[_c('div',{staticClass:"c-mobile-nav__sub-list"},[_c('aha-location-selector',{attrs:{"name":"location-selector","show-dropdown":false,"show-modal":false,"search-endpoint":"//jsonplaceholder.typicode.com/posts","translations":{ "search": "Search", "or": "or", "searchResults": "Search results for", "clearResults": "Clear Results", "offices": "Offices", "address": "Address", "city": "City", "state": "State", "zipCode": "Zip Code" },"states":[{ "code": "TX", "title": "Texas" }, { "code": "NY", "title": "New York" }, { "code": "AK", "title": "Alaska" }]}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Location")]),_vm._v(" "),_c('template',{slot:"content"},[_vm._v("\n                                        Extra Location Selector Content\n                                    ")])],2)],1)])],1),_vm._v(" "),_c('li',{staticClass:"c-mobile-nav__footer"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse3",modifiers:{"collapse3":true}}],staticClass:"c-mobile-nav__list-item btn btn-link-plain btn--select"},[_vm._v("\n                            Our Causes\n                        ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse3","visible":false}},[_c('ul',{staticClass:"c-mobile-nav__sub-list nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Go Red For Women")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("2Ro Red Por Tu Curazon")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Healthy Living")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("EmPOWERED to Serve")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("The Warning Signs")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Online Communities")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Heart & Stroke Encyclopedia")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Volunteer")])])])])],1),_vm._v(" "),_c('li',{staticClass:"c-mobile-nav__social"},[_c('ul',{staticClass:"c-mobile-nav__sub-list nav l-icon-nav"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/twitter-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/facebook-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/google-plus-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/instagram-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/youtube-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/linkedin-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/pinterest-gray.svg"}})])])])])])]],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"c-top-nav__logo",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/aha_heart.svg","alt":""}}),_c('span',{staticClass:"sr-only"},[_vm._v("Logo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-top-nav__item"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon",attrs:{"href":"#"}},[_c('span',{staticClass:"c-underline-link"},[_c('img',{attrs:{"src":"assets/glyphs/cross.svg","alt":""}}),_vm._v("Heart Attack And Stroke Symptoms")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-top-nav__item"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon h-theme--red",attrs:{"href":"#"}},[_c('span',{staticClass:"c-underline-link"},[_c('img',{attrs:{"src":"assets/glyphs/volunteer.svg","alt":""}}),_vm._v("Volunteer")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"d-block d-lg-none d-xl-none donate-btn--mobile"},[_c('a',{staticClass:"c-mobile-nav__list-item c-cta h-color--red",attrs:{"href":"#","rel":"noopener noreferrer","disablewebedit":"True","target":"_blank"}},[_vm._v("\n                    Donate\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"d-block d-lg-none d-xl-none donate-btn--mobile"},[_c('a',{staticClass:"btn btn-primary btn-round c-cta--icon",attrs:{"href":"#","rel":"noopener noreferrer","disablewebedit":"True","target":"_blank"}},[_c('img',{attrs:{"src":"assets/glyphs/donate-heart.svg","alt":""}}),_vm._v(" \n                        Donate\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('button',{staticClass:"btn c-top-nav__link btn btn-link-plain btn-secondary",attrs:{"type":"button"}},[_c('img',{attrs:{"src":"assets/glyphs/search.svg","alt":"","width":"24","height":"24","disablewebedit":"False"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Search")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-login-signup"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon",attrs:{"href":"#"}},[_c('span',[_c('img',{attrs:{"src":"assets/glyphs/login-signup.svg","alt":""}}),_vm._v("Login")])]),_vm._v(" | "),_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon",attrs:{"href":"#"}},[_c('span',[_vm._v("Signup")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"c-main-nav",attrs:{"aria-label":"Site Navigation"}},[_c('ul',{staticClass:"mr-auto"},[_c('li',{staticClass:"c-main-nav__item c-mega-nav",attrs:{"data-aha-nav":"healthy-living"}},[_c('aha-nav-dropdown',{attrs:{"role":"menu","position":"none","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Healthy Living")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('div',{staticClass:"container container-fluid container-wide"},[_c('ul',{staticClass:"c-mega-nav__container"},[_c('li',[_c('a',{staticClass:"c-mega-nav__header",attrs:{"href":"#","id":"menu-group-1"}},[_vm._v("Health Topics")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav__links c-mega-nav__links--columns"},[_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Arrythmia")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Atrial Fibrilation")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Cardiac Arrest")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Cardiac Rehab")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Cardiomyopathy")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Cholesterol")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Congenital Heart Defects")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Cardiovascular Conditions of Childhood")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Heart Attack")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Heart Failure")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Heart Valve & Disease")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("High Blood Pressure")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Metabolic Syndrome")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Peripheral Artery Disease")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Stroke")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Vascular Health")])])])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__header",attrs:{"href":"#","id":"menu-group-1"}},[_vm._v("Conditions")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav__links"},[_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Link 1")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Link 2")])])])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__header",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__header",attrs:{"href":"#"}},[_vm._v("Encyclopedia")])])])])])],2)],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"c-main-nav__item"},[_c('aha-nav-dropdown',{attrs:{"role":"menu","position":"right","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle"}},[_c('span',{staticClass:"c-underline-link"},[_c('img',{attrs:{"src":"assets/glyphs/flag.svg","alt":""}}),_vm._v("English")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('ul',{staticClass:"c-nav-dropdown__list"},[_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Option 1")])]),_vm._v(" "),_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Option 2")])])])])],2)],1),_vm._v(" "),_c('li',{staticClass:"c-main-nav__item"},[_c('aha-location-selector',{attrs:{"name":"location-selector","search-endpoint":"//jsonplaceholder.typicode.com/posts","translations":{ "search": "Search", "or": "or", "searchResults": "Search results for", "clearResults": "Clear Results", "offices": "Offices", "address": "Address", "city": "City", "state": "State", "zipCode": "Zip Code" },"states":[{ "code": "TX", "title": "Texas" }, { "code": "NY", "title": "New York" }, { "code": "AK", "title": "Alaska" }]}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Location")]),_vm._v(" "),_c('template',{slot:"content"},[_vm._v("\n                    Extra Location Selector Content\n                ")])],2)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-main-nav__item"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon dropdown-toggle",attrs:{"href":"#"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Health Topics")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-main-nav__item"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon dropdown-toggle",attrs:{"href":"#"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Professional")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-main-nav__item"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon dropdown-toggle",attrs:{"href":"#"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("About Us")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-main-nav__item"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon dropdown-toggle",attrs:{"href":"#"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Get Involved")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_nav_2023_vue__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_nav_2023_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_nav_2023_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_nav_2023_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_nav_2023_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd5e0d0c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_nav_2023_vue__ = __webpack_require__(1151);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_nav_2023_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd5e0d0c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_nav_2023_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"new c-main-nav-2023",attrs:{"aria-label":"Site Navigation"}},[_c('ul',{staticClass:"mr-auto"},[_c('li',{staticClass:"c-main-nav-2023__item c-mega-nav-2023",attrs:{"data-aha-nav":"healthy-living"}},[_c('aha-nav-dropdown',{attrs:{"role":"menu","position":"none","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Healthy Living")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('div',{staticClass:"container container-fluid container-wide"},[_c('a',{staticClass:"c-mega-nav-2023__dropdown-header mb-2",attrs:{"href":"#"}},[_vm._v("Healthly Living")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav-2023__container layout-1"},[_c('li',[_c('a',{staticClass:"c-mega-nav-2023__header",attrs:{"href":"#","id":"menu-group-1"}},[_vm._v("Health Eating")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav-2023__links c-mega-nav-2023__links--columns mb-4"},[_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Add Color")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Losing Weight")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Cooking Skills")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Eat Smart")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Heart-Check Foods")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Losing Weight")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Recipes")])])]),_vm._v(" "),_c('a',{staticClass:"c-mega-nav-2023__header",attrs:{"href":"#","id":"menu-group-2"}},[_vm._v("Pets and Your Health / Healthy Bond for Life")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav-2023__links c-mega-nav-2023__links--columns mb-4"},[_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Best Friend Fridays")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Horses Have Heart")])])])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__header",attrs:{"href":"#","id":"menu-group-1"}},[_vm._v("Healthy Lifestyle")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav-2023__links c-mega-nav-2023__links--columns mb-4"},[_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Mental Health and Well-being")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Sleep")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Stress Management")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Quit Smoking/Tobacco/Vaping")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Healthy Habits")])])])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__header",attrs:{"href":"#","id":"menu-group-1"}},[_vm._v("Fitness")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav-2023__links c-mega-nav-2023__links--columns mb-4"},[_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Fitness Basics")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Getting Active")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Staying Motivated")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Walking")])])])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__header",attrs:{"href":"#","id":"menu-group-1"}},[_vm._v("Company Collaboration")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav-2023__links c-mega-nav-2023__links--columns mb-4"},[_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Well-being Works Better")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Heart-Check Certification")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Food System Strategy")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Healthly for Life")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Health Equity in the Workforce")])])])])])])])],2)],1),_vm._v(" "),_c('li',{staticClass:"c-main-nav-2023__item c-mega-nav-2023",attrs:{"data-aha-nav":"healthy-topics"}},[_c('aha-nav-dropdown',{attrs:{"role":"menu","position":"none","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Healthy Topics")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('div',{staticClass:"container container-fluid container-wide layout-2"},[_c('a',{staticClass:"c-mega-nav-2023__dropdown-header mb-2",attrs:{"href":"#"}},[_vm._v("Health Topics")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav-2023__container"},[_c('li',{staticClass:"column_w_3"},[_c('a',{staticClass:"c-mega-nav-2023__header",attrs:{"href":"#","id":"menu-group-1"}},[_vm._v("Health Topics")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav-2023__links c-mega-nav-2023__links--columns mb-4"},[_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Arrythmia")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Atrial Fibrilation")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Cardiac Arrest")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Cardiac Rehab")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Cardiomyopathy")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Cholesterol")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Congenital Heart Defects")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Cardiovascular Conditions of Childhood")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Heart Attack")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Heart Failure")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Heart Valve & Disease")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("High Blood Pressure")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Metabolic Syndrome")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Peripheral Artery Disease")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Stroke")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__link",attrs:{"href":"#"}},[_vm._v("Vascular Health")])])])]),_vm._v(" "),_c('li',{staticClass:"border-l"},[_c('ul',{staticClass:"c-mega-nav-2023__links c-mega-nav-2023__links--columns mb-4"},[_c('li',[_c('a',{staticClass:"c-mega-nav-2023__header",attrs:{"href":"#"}},[_vm._v("Caregiver Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__header",attrs:{"href":"#"}},[_vm._v("Caregiver Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__header",attrs:{"href":"#"}},[_vm._v("Consumer Health Care")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__header",attrs:{"href":"#"}},[_vm._v("Support Network")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav-2023__header",attrs:{"href":"#"}},[_vm._v("Coronavirus (COVID-19)")])])])])])])])],2)],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"c-main-nav-2023__item"},[_c('aha-nav-dropdown',{attrs:{"role":"menu","position":"right","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle"}},[_c('span',{staticClass:"c-underline-link"},[_c('img',{attrs:{"src":"assets/glyphs/flag.svg","alt":""}}),_vm._v("English")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('ul',{staticClass:"c-nav-dropdown__list"},[_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Option 1")])]),_vm._v(" "),_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Option 2")])])])])],2)],1),_vm._v(" "),_c('li',{staticClass:"c-main-nav-2023__item"},[_c('aha-location-selector',{attrs:{"name":"location-selector","search-endpoint":"//jsonplaceholder.typicode.com/posts","translations":{ "search": "Search", "or": "or", "searchResults": "Search results for", "clearResults": "Clear Results", "offices": "Offices", "address": "Address", "city": "City", "state": "State", "zipCode": "Zip Code" },"states":[{ "code": "TX", "title": "Texas" }, { "code": "NY", "title": "New York" }, { "code": "AK", "title": "Alaska" }]}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Location")]),_vm._v(" "),_c('template',{slot:"content"},[_vm._v("\n                    Extra Location Selector Content\n                ")])],2)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-main-nav-2023__item"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon dropdown-toggle",attrs:{"href":"#"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Professional")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-main-nav-2023__item"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon dropdown-toggle",attrs:{"href":"#"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("About Us")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-main-nav-2023__item"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon dropdown-toggle",attrs:{"href":"#"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Get Involved")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"c-utility-bar",attrs:{"aria-label":"Site Navigation"}},[_c('ul',{staticClass:"c-utility-bar__main-ul"},[_c('li',{staticClass:"c-utility-bar__item"},[_c('aha-nav-dropdown',{attrs:{"role":"menu","position":"right","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle"}},[_c('span',{staticClass:"c-underline-link"},[_c('img',{attrs:{"src":"assets/glyphs/megaphone.svg","alt":""}}),_vm._v("New Link Area")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('ul',{staticClass:"c-nav-dropdown__list"},[_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("New Link 1")])]),_vm._v(" "),_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("New Link 2")])])])])],2)],1),_vm._v(" "),_c('li',{staticClass:"c-utility-bar__item"},[_c('aha-location-selector',{attrs:{"name":"location-selector","search-endpoint":"//jsonplaceholder.typicode.com/posts","translations":{ "search": "Search", "or": "or", "searchResults": "Search results for", "clearResults": "Clear Results", "offices": "Offices", "address": "Address", "city": "City", "state": "State", "zipCode": "Zip Code" },"states":[{ "code": "TX", "title": "Texas" }, { "code": "NY", "title": "New York" }, { "code": "AK", "title": "Alaska" }]}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Find Your Local Office")]),_vm._v(" "),_c('template',{slot:"content"},[_vm._v("\n                    Extra Location Selector Content\n                ")])],2)],1),_vm._v(" "),_c('li',{staticClass:"c-utility-bar__item"},[_c('aha-nav-dropdown',{attrs:{"role":"menu","position":"right","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle"}},[_c('span',{staticClass:"c-underline-link"},[_c('img',{attrs:{"src":"assets/glyphs/flag.svg","alt":""}}),_vm._v("English")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('ul',{staticClass:"c-nav-dropdown__list"},[_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Option 1")])]),_vm._v(" "),_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Option 2")])])])])],2)],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('li',{staticClass:"c-utility-bar__item"},[_c('aha-nav-dropdown',{attrs:{"role":"menu","position":"right","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle ml-0"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Signup")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('ul',{staticClass:"c-nav-dropdown__list"},[_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Option 1")])]),_vm._v(" "),_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Option 2")])])])])],2)],1),_vm._v(" "),_c('li',{staticClass:"c-top-nav__item c-top-nav__search"},[_c('aha-inline-site-search',{attrs:{"form-action":"#","placeholder-text":"ex: Heart Attack Symptoms","input-name":"query","searchButton":"Search","searchLabel":"Search","search-icon":"assets/glyphs/search.svg"}},[_c('button',{staticClass:"c-top-nav__link btn btn-link-plain"},[_c('img',{attrs:{"src":"assets/glyphs/search.svg","alt":"Search"}})])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-utility-bar__item"},[_c('div',{staticClass:"c-top-nav__account"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon",attrs:{"href":"#"}},[_c('span',{staticClass:"c-underline-link"},[_c('img',{attrs:{"src":"assets/glyphs/login-signup.svg","alt":""}}),_vm._v("Login")])]),_vm._v(" |\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31839636_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_large_vue__ = __webpack_require__(1154);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31839636_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_large_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"c-article-card c-article-card--large"},[_vm._m(0),_vm._v(" "),_c('a',{staticClass:"c-article-card__link",attrs:{"href":"#"}},[_c('div',{staticClass:"c-article-card__background h-placeholder-image h-placeholder-image--4-3",attrs:{"href":"#"}},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/750x563/ddd/ccc?text=FPO'),expression:"'//placehold.it/750x563/ddd/ccc?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"c-article-card__label"},[_c('span',{staticClass:"c-label c-label--green"},[_vm._v("In The News")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-article-card__content"},[_c('p',{staticClass:"c-article-card__metadata"},[_c('time',{attrs:{"datetime":"2017-10-03"}},[_vm._v("Oct. 3, 2017")]),_vm._v("  /  By American Heart Association News")]),_vm._v(" "),_c('h2',{staticClass:"c-article-card__title h3"},[_vm._v("Meditation May Decrease The Risk Of Heart Disease")]),_vm._v(" "),_c('p',{staticClass:"c-article-card__subtitle"},[_vm._v("Live a long and healthy life, The American Heart Association has your back.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb87c65c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_medium_vue__ = __webpack_require__(1156);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb87c65c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_medium_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"c-article-card c-article-card--small"},[_c('div',{staticClass:"c-article-card__content"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"#"}},[_c('div',{staticClass:"c-article-card__background h-placeholder-image h-placeholder-image--3-2",attrs:{"href":"#"}},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/750x563/ddd/ccc?text=FPO'),expression:"'//placehold.it/750x563/ddd/ccc?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_c('h2',{staticClass:"c-article-card__title h4"},[_vm._v("Meditation May Decrease The Risk Of Heart Disease")])]),_vm._v(" "),_c('p',{staticClass:"c-article-card__metadata"},[_vm._v("Oct. 3, 2017")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fdaf0ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_small_vue__ = __webpack_require__(1158);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fdaf0ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_small_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"c-article-card c-article-card--small"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"c-article-card__content"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"#"}},[_c('div',{staticClass:"c-article-card__background h-placeholder-image h-placeholder-image--3-2",attrs:{"href":"#"}},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/360x240/ddd/ccc?text=FPO'),expression:"'//placehold.it/360x240/ddd/ccc?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_c('h3',{staticClass:"c-article-card__title h4"},[_vm._v("\n                A Type Of Hypertension During Pregnancy More Dangerous Than Thought\n            ")])]),_vm._v(" "),_c('p',{staticClass:"c-article-card__metadata"},[_vm._v("Oct. 3, 2017")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"c-article-card__label"},[_c('span',{staticClass:"c-label c-label--green"},[_vm._v("In The News")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb5def9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_x_small_vue__ = __webpack_require__(1160);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb5def9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_x_small_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"c-article-card c-article-card--x-small"},[_c('div',{staticClass:"c-article-card__content"},[_c('p',{staticClass:"c-article-card__title h4"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"#"}},[_vm._v("Appalachian Poor Seek Free Care")])]),_vm._v(" "),_c('p',{staticClass:"c-article-card__metadata"},[_vm._v("Oct. 3, 2017")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d2ab62_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_listing_vue__ = __webpack_require__(1162);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d2ab62_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_listing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"c-article-card c-article-card--listing"},[_c('div',{staticClass:"c-article-card__content"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"#"}},[_c('div',{staticClass:"c-article-card__background h-placeholder-image h-placeholder-image--3-2",attrs:{"href":"#"}},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/750x563/ddd/ccc?text=FPO'),expression:"'//placehold.it/750x563/ddd/ccc?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_c('h2',{staticClass:"c-article-card__title h4"},[_vm._v("Appalachian Poor Seek Free Care")])]),_vm._v(" "),_c('p',{staticClass:"c-article-card__date"},[_vm._v("Oct. 3, 2017")]),_vm._v(" "),_c('p',{staticClass:"c-article-card__excerpt"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris facilisis ornare enim ac posuere. Nam porta lacus nec leo vehicula rhoncus. In ut nibh cursus, viverra risus non, finibus nibh.")]),_vm._v(" "),_c('p',{staticClass:"c-article-card__metadata"},[_vm._v("\n            Categories: Blog, Heart Attack, Heart Disease, Patients, Stories from the Heart, Stroke | Tags: alteplase, atrial fibrillation, Brain Saver award, Heart Attack, mechanical thrombectomy, Stroke, Terry Summers | 0 Comments\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54bf121c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_list_with_icons_vue__ = __webpack_require__(1164);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54bf121c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_list_with_icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"c-article-card c-article-card--small h-theme--red"},[_c('div',{staticClass:"c-article-card__content"},[_c('p',{staticClass:"h3 text-center c-list-icons__title"},[_vm._v("Support Our Legacy "),_c('br'),_vm._v("of Discovery")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',{staticClass:"media my-4"},[_c('img',{staticClass:"align-self-center mr-3",attrs:{"src":"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2264%22%20height%3D%2264%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2064%2064%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_173bf68586b%20text%20%7B%20fill%3Argba(255%2C255%2C255%2C.75)%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A10pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_173bf68586b%22%3E%3Crect%20width%3D%2264%22%20height%3D%2264%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%2213.8359375%22%20y%3D%2236.5%22%3E64x64%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E","alt":"Generic placeholder image"}}),_vm._v(" "),_c('div',{staticClass:"media-body align-self-center"},[_c('p',{staticClass:"h5 mt-0 mb-0"},[_vm._v("Created CPR Techniques & Standard")])])]),_vm._v(" "),_c('li',{staticClass:"media my-4"},[_c('img',{staticClass:"align-self-center mr-3",attrs:{"src":"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2264%22%20height%3D%2264%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2064%2064%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_173bf68586b%20text%20%7B%20fill%3Argba(255%2C255%2C255%2C.75)%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A10pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_173bf68586b%22%3E%3Crect%20width%3D%2264%22%20height%3D%2264%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%2213.8359375%22%20y%3D%2236.5%22%3E64x64%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E","alt":"Generic placeholder image"}}),_vm._v(" "),_c('div',{staticClass:"media-body align-self-center"},[_c('p',{staticClass:"h5 mt-0 mb-0"},[_vm._v("Invented the artifical heart valve")])])]),_vm._v(" "),_c('li',{staticClass:"media my-4"},[_c('img',{staticClass:"align-self-center mr-3",attrs:{"src":"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2264%22%20height%3D%2264%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2064%2064%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_173bf68586b%20text%20%7B%20fill%3Argba(255%2C255%2C255%2C.75)%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A10pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_173bf68586b%22%3E%3Crect%20width%3D%2264%22%20height%3D%2264%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%2213.8359375%22%20y%3D%2236.5%22%3E64x64%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E","alt":"Generic placeholder image"}}),_vm._v(" "),_c('div',{staticClass:"media-body align-self-center"},[_c('p',{staticClass:"h5 mt-0 mb-0"},[_vm._v("Developed cholesterol-inhibiting drugs")])])]),_vm._v(" "),_c('li',{staticClass:"media my-4"},[_c('img',{staticClass:"align-self-center mr-3",attrs:{"src":"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2264%22%20height%3D%2264%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2064%2064%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_173bf68586b%20text%20%7B%20fill%3Argba(255%2C255%2C255%2C.75)%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A10pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_173bf68586b%22%3E%3Crect%20width%3D%2264%22%20height%3D%2264%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%2213.8359375%22%20y%3D%2236.5%22%3E64x64%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E","alt":"Generic placeholder image"}}),_vm._v(" "),_c('div',{staticClass:"media-body align-self-center"},[_c('p',{staticClass:"h5 mt-0 mb-0"},[_vm._v("Expanded heart transplant capabilities")])])])]),_vm._v(" "),_c('p',{staticClass:"h4 text-center"},[_c('i',[_vm._v("The next breakthrough"),_c('br'),_vm._v(" depends on you!")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afe3a830_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_toc_vue__ = __webpack_require__(1166);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afe3a830_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_toc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-article-card c-article-card--x-small"},[_c('ul',{staticClass:"l-article-list"},[_c('li',{staticClass:"l-article-list__item"},[_c('div',{staticClass:"c-article-card c-article-card--x-small"},[_c('div',{staticClass:"c-article-card__content"},[_c('p',{staticClass:"c-article-card__title h4"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/arrhythmia","target":""}},[_vm._v("Arrhythmia")])])])])]),_vm._v(" "),_c('li',{staticClass:"l-article-list__item"},[_c('div',{staticClass:"c-article-card c-article-card--x-small"},[_c('div',{staticClass:"c-article-card__content is-active"},[_c('p',{staticClass:"c-article-card__title h4 is-active"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/arrhythmia/about-arrhythmia","target":""}},[_vm._v("About Arrhythmia")])])]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"c-article-card__sub-heading"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/arrhythmia/about-arrhythmia/bradycardia--slow-heart-rate","target":""}},[_vm._v("Bradycardia: Slow Heart Rate")])]),_vm._v(" "),_c('li',{staticClass:"c-article-card__sub-heading"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/arrhythmia/about-arrhythmia/conduction-disorders","target":""}},[_vm._v("Conduction Disorders")])]),_vm._v(" "),_c('li',{staticClass:"c-article-card__sub-heading"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/arrhythmia/about-arrhythmia/premature-contractions-pacs-and-pvcs","target":""}},[_vm._v("Premature Contractions: PACs and PVCs")])]),_vm._v(" "),_c('li',{staticClass:"c-article-card__sub-heading"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/arrhythmia/about-arrhythmia/tachycardia--fast-heart-rate","target":""}},[_vm._v("Tachycardia: Fast Heart Rate")])]),_vm._v(" "),_c('li',{staticClass:"c-article-card__sub-heading"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/arrhythmia/about-arrhythmia/ventricular-fibrillation","target":""}},[_vm._v("Ventricular Fibrillation")])]),_vm._v(" "),_c('li',{staticClass:"c-article-card__sub-heading"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/arrhythmia/about-arrhythmia/other-heart-rhythm-disorders","target":""}},[_vm._v("Other Heart Rhythm Disorders")])]),_vm._v(" "),_c('li',{staticClass:"c-article-card__sub-heading"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/arrhythmia/about-arrhythmia/types-of-arrhythmia-in-children","target":""}},[_vm._v("Types of Arrhythmia in Children")])])])])]),_vm._v(" "),_c('li',{staticClass:"l-article-list__item"},[_c('div',{staticClass:"c-article-card c-article-card--x-small"},[_c('div',{staticClass:"c-article-card__content"},[_c('p',{staticClass:"c-article-card__title h4"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/arrhythmia/why-arrhythmia-matters","target":""}},[_vm._v("Why Arrhythmia Matters")])])])])]),_vm._v(" "),_c('li',{staticClass:"l-article-list__item"},[_c('div',{staticClass:"c-article-card c-article-card--x-small"},[_c('div',{staticClass:"c-article-card__content"},[_c('p',{staticClass:"c-article-card__title h4"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/arrhythmia/understand-your-risk-for-arrhythmia","target":""}},[_vm._v("Understand Your Risk for Arrhythmia")])])])])]),_vm._v(" "),_c('li',{staticClass:"l-article-list__item"},[_c('div',{staticClass:"c-article-card c-article-card--x-small"},[_c('div',{staticClass:"c-article-card__content"},[_c('p',{staticClass:"c-article-card__title h4"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/arrhythmia/symptoms-diagnosis--monitoring-of-arrhythmia","target":""}},[_vm._v("Symptoms, Diagnosis and Monitoring of Arrhythmia")])])])])]),_vm._v(" "),_c('li',{staticClass:"l-article-list__item"},[_c('div',{staticClass:"c-article-card c-article-card--x-small"},[_c('div',{staticClass:"c-article-card__content"},[_c('p',{staticClass:"c-article-card__title h4"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/arrhythmia/prevention--treatment-of-arrhythmia","target":""}},[_vm._v("Prevention and Treatment")])])])])]),_vm._v(" "),_c('li',{staticClass:"l-article-list__item"},[_c('div',{staticClass:"c-article-card c-article-card--x-small"},[_c('div',{staticClass:"c-article-card__content"},[_c('p',{staticClass:"c-article-card__title h4"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/arrhythmia/arrhythmia-tools--resources","target":""}},[_vm._v("Arrhythmia Tools and Resources")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa1571a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_around_aha_news_vue__ = __webpack_require__(1168);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa1571a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_around_aha_news_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid around-aha__container"},[_c('div',{staticClass:"c-article-card c-article-card--listing c-article-card--around-aha"},[_c('div',{staticClass:"c-article-card__content"},[_c('h2',{staticClass:"c-article-card__title h2"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"#"}},[_vm._v("Harvest Moon")])]),_vm._v(" "),_c('p',{staticClass:"c-article-card__excerpt"},[_vm._v("\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n                Mauris facilisis ornare enim ac posuere. Nam porta lacus nec\n                leo vehicula rhoncus. In ut nibh cursus, viverra risus non,\n                finibus nibh.\n            ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fffb4058_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inquiries_support_vue__ = __webpack_require__(1170);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fffb4058_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inquiries_support_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-inquiries-support"},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"c-inquiries-support__container col-md-9"},[_c('div',{staticClass:"c-inquiries-support__content"},[_c('p',[_vm._v("CPR-Related Inquiries: "),_c('br'),_vm._v("1-877-AHA-4CPR Or 1-877-242-4277")])]),_vm._v(" "),_c('div',{staticClass:"c-inquiries-support__actions"},[_c('div',{staticClass:"c-inquiries-support__cta"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--black",attrs:{"href":"#"}},[_vm._v("International Inquiries")])]),_vm._v(" "),_c('div',{staticClass:"c-inquiries-support__cta"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--black",attrs:{"href":"#"}},[_vm._v("Global Web Support")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71a35481_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_testimonial_vue__ = __webpack_require__(1172);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71a35481_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_testimonial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-testimonial"},[_c('div',{staticClass:"c-testimonial__container container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"c-testimonial__image"},[_c('div',{staticClass:"c-testimonial__image-placeholder h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x300/ddd/ccc?text=FPO'),expression:"'//placehold.it/300x300/ddd/ccc?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])])]),_vm._v(" "),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-7 d-flex"},[_c('div',{staticClass:"c-testimonial__content"},[_c('blockquote',{staticClass:"blockquote"},[_c('h2',{staticClass:"h3"},[_vm._v("Nancy Williams")]),_vm._v(" "),_c('p',[_vm._v("\"Fusce pulvinar facilisis nisi, id imperdiet ipsum volutpat dapibus. Donec at felis a arcu ultricies dignissim. Sed tincidunt libero ac eleifend consequat. Mauris massa lectus, euismod at rutrum sed, pellentesque eget lectus. Etiam faucibus dui ut nibh dapibus suscipit. Nullam lacus tellus, varius vitae sapien sagittis, sodales blandit risus. Praesent dignissim sit amet sem eu efficitur. Curabitur eu arcu aliquet, ultricies libero nec, elementum justo.\"")])]),_vm._v(" "),_c('a',{staticClass:"c-cta c-cta--arrow h-theme--aqua-alt",attrs:{"href":"#"}},[_vm._v("Read Her Story")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_928c7ba2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_highlight_copy_vue__ = __webpack_require__(1174);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_928c7ba2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_highlight_copy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-highlight-copy"},[_c('div',{staticClass:"c-highlight-copy__container container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"c-highlight-copy__header"},[_c('h2',{staticClass:"c-highlight-copy__heading h4"},[_c('span',{staticClass:"h-color--red"},[_vm._v("American Heart Association")]),_vm._v(" "),_c('br'),_vm._v("News Stories")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7 d-flex"},[_c('div',{staticClass:"c-highlight-copy__content"},[_c('p',[_vm._v("American Heart Association News covers heart disease, stroke and related health issues. Not all views expressed in American Heart Association News stories reflect the official position of the American Heart Association.")]),_vm._v(" "),_c('p',[_vm._v("Copyright is owned or held by the American Heart Association, Inc., and all rights are reserved. Permission is granted, at no cost and without need for further request, to link to, quote, excerpt or reprint from these stories in any medium as long as no text is altered an proper attribution is made to the American Heart Association News. See full terms of use.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_043db6b9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_gallery_vue__ = __webpack_require__(1176);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_043db6b9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-section l-section--videos h-theme--black"},[_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"perfect-scrollbar",rawName:"v-perfect-scrollbar"}],staticClass:"l-video-gallery"},[_c('ul',{staticClass:"l-video-gallery__list"},[_c('li',[_c('div',{staticClass:"c-article-card c-article-card--small c-article-card--video"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId2'),expression:"'uniqueModalId2'"}],staticClass:"c-article-card__background"},[_c('span',{staticClass:"h-placeholder-image h-placeholder-image--3-2"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/360/240/any'),expression:"'//placeimg.com/360/240/any'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId2","video-id":"M7lc1UVf-VE"}})],1),_vm._v(" "),_c('li',[_c('div',{staticClass:"c-article-card c-article-card--small c-article-card--video"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId3'),expression:"'uniqueModalId3'"}],staticClass:"c-article-card__background"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--3-2"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/360/240/any?2'),expression:"'//placeimg.com/360/240/any?2'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId3","video-id":"M7lc1UVf-VE"}})],1),_vm._v(" "),_c('li',[_c('div',{staticClass:"c-article-card c-article-card--small c-article-card--video"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId4'),expression:"'uniqueModalId4'"}],staticClass:"c-article-card__background"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--3-2"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/360/240/any?3'),expression:"'//placeimg.com/360/240/any?3'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId4","video-id":"M7lc1UVf-VE"}})],1),_vm._v(" "),_c('li',[_c('div',{staticClass:"c-article-card c-article-card--small c-article-card--video"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId5'),expression:"'uniqueModalId5'"}],staticClass:"c-article-card__background"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--3-2"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/360/240/any?4'),expression:"'//placeimg.com/360/240/any?4'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})]),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)]),_vm._v(" "),_vm._m(12)]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId5","video-id":"M7lc1UVf-VE"}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"c-listing-header c-listing-header--no-border"},[_c('h2',{staticClass:"c-listing-header__heading"},[_vm._v("Videos")]),_vm._v(" "),_c('div',{staticClass:"c-listing-header__cta-container"},[_c('p',{staticClass:"c-listing-header__subheading h-secondary-font-color"},[_vm._v("Lorem Ipsum dolor sit amet, consectetur adipiscing elit.")]),_vm._v(" "),_c('a',{staticClass:"c-listing-header__cta c-cta c-cta--arrow h-color--green-light",attrs:{"href":"#"}},[_vm._v("Read All News Stories")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-article-card__video-meta"},[_c('span',{staticClass:"c-article-card__vide-time"},[_vm._v("0:15")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-article-card__video-overlay"},[_c('span',{staticClass:"c-article-card__play"},[_c('img',{attrs:{"src":"assets/glyphs/play.svg","alt":""}}),_vm._v("Watch Video")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-arctile-card__content"},[_c('h3',{staticClass:"c-article-card__title h6"},[_vm._v("A Type Of Hypertension During Pregnancy More Dangerous Than Thought")]),_vm._v(" "),_c('div',{staticClass:"c-article-card__metadata h-secondary-font-color"},[_vm._v("Oct. 3, 2017")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-article-card__video-meta"},[_c('span',{staticClass:"c-article-card__vide-time"},[_vm._v("0:15")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-article-card__video-overlay"},[_c('span',{staticClass:"c-article-card__play"},[_c('img',{attrs:{"src":"assets/glyphs/play.svg","alt":""}}),_vm._v("Watch Video")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-arctile-card__content"},[_c('h3',{staticClass:"c-article-card__title h6"},[_vm._v("A Type Of Hypertension During Pregnancy More Dangerous Than Thought")]),_vm._v(" "),_c('div',{staticClass:"c-article-card__metadata h-secondary-font-color"},[_vm._v("Oct. 3, 2017")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-article-card__video-meta"},[_c('span',{staticClass:"c-article-card__vide-time"},[_vm._v("0:15")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-article-card__video-overlay"},[_c('span',{staticClass:"c-article-card__play"},[_c('img',{attrs:{"src":"assets/glyphs/play.svg","alt":""}}),_vm._v("Watch Video")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-arctile-card__content"},[_c('h3',{staticClass:"c-article-card__title h6"},[_vm._v("A Type Of Hypertension During Pregnancy More Dangerous Than Thought")]),_vm._v(" "),_c('div',{staticClass:"c-article-card__metadata h-secondary-font-color"},[_vm._v("Oct. 3, 2017")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-article-card__video-meta"},[_c('span',{staticClass:"c-article-card__vide-time"},[_vm._v("0:15")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-article-card__video-overlay"},[_c('span',{staticClass:"c-article-card__play"},[_c('img',{attrs:{"src":"assets/glyphs/play.svg","alt":""}}),_vm._v("Watch Video")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-arctile-card__content"},[_c('h3',{staticClass:"c-article-card__title h6"},[_vm._v("A Type Of Hypertension During Pregnancy More Dangerous Than Thought")]),_vm._v(" "),_c('div',{staticClass:"c-article-card__metadata h-secondary-font-color"},[_vm._v("Oct. 3, 2017")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cd992b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_affiliate_nav_vue__ = __webpack_require__(1178);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cd992b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_affiliate_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"c-affiliate-nav",attrs:{"aria-label":"Affilate Nav"}},[_c('ul',{staticClass:"c-affiliate-nav__list"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Training CPR")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Funding Research")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Improving Workplaces")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Protecting Newborns")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Advocating For Health")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48ca034c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sitecore_forms_vue__ = __webpack_require__(1180);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48ca034c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sitecore_forms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-aha-form"},[_c('form',{attrs:{"action":"/formbuilder?fxb.FormItemId=3dba4155-3624-4977-5c32-677a239d712a&fxb.HtmlPrefix=fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b","data-ajax":"true","data-ajax-method":"Post","data-ajax-mode":"replace-with","data-ajax-success":"$.validator.unobtrusive.parse('#fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_3dba4155-3624-4977-5c32-677a239d712a');$.fxbFormTracker.parse('#fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_3dba4155-3624-4977-5c32-677a239d712a');","data-ajax-update":"#fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_3dba4155-3624-4977-5c32-677a239d712a","data-sc-fxb":"3dba4155-3624-4977-5c32-677a239d712a","enctype":"multipart/form-data","id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_3dba4155-3624-4977-5c32-677a239d712a","method":"post"}},[_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_FormSessionId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.FormSessionId","type":"hidden","value":"d08d7c48-2b3a-498d-961e-9e30851741bb"}}),_vm._v(" "),_c('input',{attrs:{"name":"__RequestVerificationToken","type":"hidden","value":"p3XQTnHwjvxd_HoCR97WmxtkiD9HTsoYucR7rXB8ht6bfQ4w0aqWu00SWQfVhyh-vV97ohciyKHQ19GT8lYQkbwlsf32ymBRrvukGhu3iI81"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_FormItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.FormItemId","type":"hidden","value":"3dba4155-3624-4977-5c32-677a239d712a"}}),_vm._v(" "),_c('div',{staticClass:"validation-summary-errors"},[_c('ul',[_c('li',{staticStyle:{"display":"none"}})])]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_PageItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.PageItemId","type":"hidden","value":"041c4b16-ad42-4d79-b56b-8b16529b4158"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_bd3163cc-44e7-487b-a44d-db5f9cc60987","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"bd3163cc-44e7-487b-a44d-db5f9cc60987"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_bd3163cc-44e7-487b-a44d-db5f9cc60987__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[bd3163cc-44e7-487b-a44d-db5f9cc60987].ItemId","type":"hidden","value":"bd3163cc-44e7-487b-a44d-db5f9cc60987"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_bd3163cc-44e7-487b-a44d-db5f9cc60987__Value"}},[_vm._v("American Stroke Association Tedy’s Team")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_bd3163cc-44e7-487b-a44d-db5f9cc60987__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[bd3163cc-44e7-487b-a44d-db5f9cc60987].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"americanStroke"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[bd3163cc-44e7-487b-a44d-db5f9cc60987].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_911a6bee-2697-1b88-9ccd-be68cd8ed07c","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"911a6bee-2697-1b88-9ccd-be68cd8ed07c"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_911a6bee-2697-1b88-9ccd-be68cd8ed07c__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[911a6bee-2697-1b88-9ccd-be68cd8ed07c].ItemId","type":"hidden","value":"911a6bee-2697-1b88-9ccd-be68cd8ed07c"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_911a6bee-2697-1b88-9ccd-be68cd8ed07c__Value"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_911a6bee-2697-1b88-9ccd-be68cd8ed07c__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[911a6bee-2697-1b88-9ccd-be68cd8ed07c].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"firstName","data-val-required":"First Name is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[911a6bee-2697-1b88-9ccd-be68cd8ed07c].Value","data-valmsg-replace":"true"}},[_vm._v("First Name is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_05ef8956-6476-caf2-7bc3-18ff28ab334b","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"05ef8956-6476-caf2-7bc3-18ff28ab334b"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_05ef8956-6476-caf2-7bc3-18ff28ab334b__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[05ef8956-6476-caf2-7bc3-18ff28ab334b].ItemId","type":"hidden","value":"05ef8956-6476-caf2-7bc3-18ff28ab334b"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_05ef8956-6476-caf2-7bc3-18ff28ab334b__Value"}},[_vm._v("Last Name (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_05ef8956-6476-caf2-7bc3-18ff28ab334b__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[05ef8956-6476-caf2-7bc3-18ff28ab334b].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"lastName","data-val-required":"Last Name (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[05ef8956-6476-caf2-7bc3-18ff28ab334b].Value","data-valmsg-replace":"true"}},[_vm._v("Last Name (required) is required.")]),_vm._v(" "),_c('div',{},[_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_b94ea597-dd81-28b0-0de6-80c5d287c7c9","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"b94ea597-dd81-28b0-0de6-80c5d287c7c9"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_b94ea597-dd81-28b0-0de6-80c5d287c7c9__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[b94ea597-dd81-28b0-0de6-80c5d287c7c9].ItemId","type":"hidden","value":"b94ea597-dd81-28b0-0de6-80c5d287c7c9"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_b94ea597-dd81-28b0-0de6-80c5d287c7c9__Value"}},[_vm._v("Street Address")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_b94ea597-dd81-28b0-0de6-80c5d287c7c9__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[b94ea597-dd81-28b0-0de6-80c5d287c7c9].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"Street Address","data-val-required":"Street Address is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[b94ea597-dd81-28b0-0de6-80c5d287c7c9].Value","data-valmsg-replace":"true"}},[_vm._v("Street Address is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_303b28a1-6298-ff06-4abe-20e56c574f3d","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"303b28a1-6298-ff06-4abe-20e56c574f3d"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_303b28a1-6298-ff06-4abe-20e56c574f3d__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[303b28a1-6298-ff06-4abe-20e56c574f3d].ItemId","type":"hidden","value":"303b28a1-6298-ff06-4abe-20e56c574f3d"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_303b28a1-6298-ff06-4abe-20e56c574f3d__Value"}},[_vm._v("Street Address Line 2")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_303b28a1-6298-ff06-4abe-20e56c574f3d__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[303b28a1-6298-ff06-4abe-20e56c574f3d].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"Street Address Line 2","data-val-required":"Street Address Line 2 is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[303b28a1-6298-ff06-4abe-20e56c574f3d].Value","data-valmsg-replace":"true"}},[_vm._v("Street Address Line 2 is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_2be9683b-c29b-e5ad-615a-d21bb8dddf9b","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"2be9683b-c29b-e5ad-615a-d21bb8dddf9b"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_2be9683b-c29b-e5ad-615a-d21bb8dddf9b__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[2be9683b-c29b-e5ad-615a-d21bb8dddf9b].ItemId","type":"hidden","value":"2be9683b-c29b-e5ad-615a-d21bb8dddf9b"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_2be9683b-c29b-e5ad-615a-d21bb8dddf9b__Value"}},[_vm._v("City")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_2be9683b-c29b-e5ad-615a-d21bb8dddf9b__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[2be9683b-c29b-e5ad-615a-d21bb8dddf9b].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"City","data-val-required":"City is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[2be9683b-c29b-e5ad-615a-d21bb8dddf9b].Value","data-valmsg-replace":"true"}},[_vm._v("City is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_76bee699-ad1f-68a7-2b18-61a70323e52c","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"76bee699-ad1f-68a7-2b18-61a70323e52c"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_76bee699-ad1f-68a7-2b18-61a70323e52c__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[76bee699-ad1f-68a7-2b18-61a70323e52c].ItemId","type":"hidden","value":"76bee699-ad1f-68a7-2b18-61a70323e52c"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_76bee699-ad1f-68a7-2b18-61a70323e52c__Value"}},[_vm._v("State / Province")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_76bee699-ad1f-68a7-2b18-61a70323e52c__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[76bee699-ad1f-68a7-2b18-61a70323e52c].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"State  Province","data-val-required":"State / Province is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[76bee699-ad1f-68a7-2b18-61a70323e52c].Value","data-valmsg-replace":"true"}},[_vm._v("State / Province is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_74444848-8df0-cde5-e233-97a2d6eaff42","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"74444848-8df0-cde5-e233-97a2d6eaff42"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_74444848-8df0-cde5-e233-97a2d6eaff42__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[74444848-8df0-cde5-e233-97a2d6eaff42].ItemId","type":"hidden","value":"74444848-8df0-cde5-e233-97a2d6eaff42"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_74444848-8df0-cde5-e233-97a2d6eaff42__Value"}},[_vm._v("Zip / Postal")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_74444848-8df0-cde5-e233-97a2d6eaff42__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[74444848-8df0-cde5-e233-97a2d6eaff42].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"Zip  Postal","data-val-required":"Zip / Postal is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[74444848-8df0-cde5-e233-97a2d6eaff42].Value","data-valmsg-replace":"true"}},[_vm._v("Zip / Postal is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_ecca1133-c02a-3787-de47-c99ed4428c1f","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"ecca1133-c02a-3787-de47-c99ed4428c1f"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_ecca1133-c02a-3787-de47-c99ed4428c1f__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[ecca1133-c02a-3787-de47-c99ed4428c1f].ItemId","type":"hidden","value":"ecca1133-c02a-3787-de47-c99ed4428c1f"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_ecca1133-c02a-3787-de47-c99ed4428c1f__Value"}},[_vm._v("Country")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_ecca1133-c02a-3787-de47-c99ed4428c1f__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[ecca1133-c02a-3787-de47-c99ed4428c1f].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"Country","data-val-required":"Country is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[ecca1133-c02a-3787-de47-c99ed4428c1f].Value","data-valmsg-replace":"true"}},[_vm._v("Country is required.")])]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_a6d5b012-aa14-522d-2271-02eea7cf9a87","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"a6d5b012-aa14-522d-2271-02eea7cf9a87"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_a6d5b012-aa14-522d-2271-02eea7cf9a87__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[a6d5b012-aa14-522d-2271-02eea7cf9a87].ItemId","type":"hidden","value":"a6d5b012-aa14-522d-2271-02eea7cf9a87"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_a6d5b012-aa14-522d-2271-02eea7cf9a87__Value"}},[_vm._v("Please provide your Home Phone Number, Cell Phone Number, or Both (required)")]),_vm._v(" "),_c('select',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_a6d5b012-aa14-522d-2271-02eea7cf9a87__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[a6d5b012-aa14-522d-2271-02eea7cf9a87].Value","data-sc-tracking":"True","data-sc-field-name":"pleaseProvide41","data-val-required":"Please provide your Home Phone Number,  Cell Phone Number, or Both (required) is required.","data-val":"true"}},[_c('option',{attrs:{"value":"Both","selected":"selected"}},[_vm._v("Both")]),_vm._v(" "),_c('option',{attrs:{"value":"Cell"}},[_vm._v("Cell")]),_vm._v(" "),_c('option',{attrs:{"value":"Home"}},[_vm._v("Home")])]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[a6d5b012-aa14-522d-2271-02eea7cf9a87].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_f32b236e-b84d-fef9-e149-6edfdc0e649e","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"f32b236e-b84d-fef9-e149-6edfdc0e649e"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_f32b236e-b84d-fef9-e149-6edfdc0e649e__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[f32b236e-b84d-fef9-e149-6edfdc0e649e].ItemId","type":"hidden","value":"f32b236e-b84d-fef9-e149-6edfdc0e649e"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_f32b236e-b84d-fef9-e149-6edfdc0e649e__Value"}},[_vm._v("Home Phone (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_f32b236e-b84d-fef9-e149-6edfdc0e649e__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[f32b236e-b84d-fef9-e149-6edfdc0e649e].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"homePhone12","data-val-required":"Home Phone (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[f32b236e-b84d-fef9-e149-6edfdc0e649e].Value","data-valmsg-replace":"true"}},[_vm._v("Home Phone (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_c7aeafb7-be9c-1eec-cdf8-b98d838b3583","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"c7aeafb7-be9c-1eec-cdf8-b98d838b3583"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_c7aeafb7-be9c-1eec-cdf8-b98d838b3583__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[c7aeafb7-be9c-1eec-cdf8-b98d838b3583].ItemId","type":"hidden","value":"c7aeafb7-be9c-1eec-cdf8-b98d838b3583"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_c7aeafb7-be9c-1eec-cdf8-b98d838b3583__Value"}},[_vm._v("Cell Phone (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_c7aeafb7-be9c-1eec-cdf8-b98d838b3583__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[c7aeafb7-be9c-1eec-cdf8-b98d838b3583].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"cellPhone","data-val-required":"Cell Phone (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[c7aeafb7-be9c-1eec-cdf8-b98d838b3583].Value","data-valmsg-replace":"true"}},[_vm._v("Cell Phone (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_281ade3a-7744-6c71-04e1-61c1e876df55","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"281ade3a-7744-6c71-04e1-61c1e876df55"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_281ade3a-7744-6c71-04e1-61c1e876df55__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[281ade3a-7744-6c71-04e1-61c1e876df55].ItemId","type":"hidden","value":"281ade3a-7744-6c71-04e1-61c1e876df55"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_281ade3a-7744-6c71-04e1-61c1e876df55__Value"}},[_vm._v("E-mail (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_281ade3a-7744-6c71-04e1-61c1e876df55__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[281ade3a-7744-6c71-04e1-61c1e876df55].Value","type":"email","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"emailrequired","data-val-required":"E-mail (required) is required.","data-val-regex":"E-mail (required) contains an invalid email address.","data-val-regex-pattern":"^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,17}$","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[281ade3a-7744-6c71-04e1-61c1e876df55].Value","data-valmsg-replace":"true"}},[_vm._v("E-mail (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_9f9930a2-4434-6509-d7a0-5d45a416d3e9","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"9f9930a2-4434-6509-d7a0-5d45a416d3e9"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_9f9930a2-4434-6509-d7a0-5d45a416d3e9__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[9f9930a2-4434-6509-d7a0-5d45a416d3e9].ItemId","type":"hidden","value":"9f9930a2-4434-6509-d7a0-5d45a416d3e9"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_9f9930a2-4434-6509-d7a0-5d45a416d3e9__Value"}},[_vm._v("Place of Business (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_9f9930a2-4434-6509-d7a0-5d45a416d3e9__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[9f9930a2-4434-6509-d7a0-5d45a416d3e9].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"placeOf","data-val-required":"Place of  Business (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[9f9930a2-4434-6509-d7a0-5d45a416d3e9].Value","data-valmsg-replace":"true"}},[_vm._v("Place of Business (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_23cc7a64-2bd8-bfce-7371-479446660c13","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"23cc7a64-2bd8-bfce-7371-479446660c13"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_23cc7a64-2bd8-bfce-7371-479446660c13__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[23cc7a64-2bd8-bfce-7371-479446660c13].ItemId","type":"hidden","value":"23cc7a64-2bd8-bfce-7371-479446660c13"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_23cc7a64-2bd8-bfce-7371-479446660c13__Value"}},[_vm._v("Job Title (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_23cc7a64-2bd8-bfce-7371-479446660c13__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[23cc7a64-2bd8-bfce-7371-479446660c13].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"jobTitle","data-val-required":"Job Title (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[23cc7a64-2bd8-bfce-7371-479446660c13].Value","data-valmsg-replace":"true"}},[_vm._v("Job Title (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_fe6df62e-7066-6a94-c120-f2a79fb5c951","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"fe6df62e-7066-6a94-c120-f2a79fb5c951"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_fe6df62e-7066-6a94-c120-f2a79fb5c951__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[fe6df62e-7066-6a94-c120-f2a79fb5c951].ItemId","type":"hidden","value":"fe6df62e-7066-6a94-c120-f2a79fb5c951"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_fe6df62e-7066-6a94-c120-f2a79fb5c951__Value"}},[_vm._v("Does your company have a matching gift program? (required)")]),_vm._v(" "),_c('select',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_fe6df62e-7066-6a94-c120-f2a79fb5c951__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[fe6df62e-7066-6a94-c120-f2a79fb5c951].Value","data-sc-tracking":"True","data-sc-field-name":"doesYour19","data-val-required":"Does your company have a matching gift program? (required) is required.","data-val":"true"}},[_c('option',{attrs:{"value":"No","selected":"selected"}},[_vm._v("No")]),_vm._v(" "),_c('option',{attrs:{"value":"Yes"}},[_vm._v("Yes")])]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[fe6df62e-7066-6a94-c120-f2a79fb5c951].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_61b34f63-0e0f-f84c-a81f-64d0815319f8","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"61b34f63-0e0f-f84c-a81f-64d0815319f8"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_61b34f63-0e0f-f84c-a81f-64d0815319f8__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[61b34f63-0e0f-f84c-a81f-64d0815319f8].ItemId","type":"hidden","value":"61b34f63-0e0f-f84c-a81f-64d0815319f8"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_61b34f63-0e0f-f84c-a81f-64d0815319f8__Value"}},[_vm._v("I would like to be contacted at:")]),_vm._v(" "),_c('select',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_61b34f63-0e0f-f84c-a81f-64d0815319f8__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[61b34f63-0e0f-f84c-a81f-64d0815319f8].Value","data-sc-tracking":"True","data-sc-field-name":"iWould20"}},[_c('option',{attrs:{"value":"Cell","selected":"selected"}},[_vm._v("Cell")]),_vm._v(" "),_c('option',{attrs:{"value":"Home"}},[_vm._v("Home")])]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[61b34f63-0e0f-f84c-a81f-64d0815319f8].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_557734a5-3e9b-1ec9-506a-4a090f4215fb","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"557734a5-3e9b-1ec9-506a-4a090f4215fb"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_557734a5-3e9b-1ec9-506a-4a090f4215fb__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[557734a5-3e9b-1ec9-506a-4a090f4215fb].ItemId","type":"hidden","value":"557734a5-3e9b-1ec9-506a-4a090f4215fb"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_557734a5-3e9b-1ec9-506a-4a090f4215fb__Value"}},[_vm._v("Fundraising Experience")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_557734a5-3e9b-1ec9-506a-4a090f4215fb__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[557734a5-3e9b-1ec9-506a-4a090f4215fb].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"heading"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[557734a5-3e9b-1ec9-506a-4a090f4215fb].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_5ee2066c-193f-243b-1e1a-f4a5ed6037ec","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"5ee2066c-193f-243b-1e1a-f4a5ed6037ec"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_5ee2066c-193f-243b-1e1a-f4a5ed6037ec__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[5ee2066c-193f-243b-1e1a-f4a5ed6037ec].ItemId","type":"hidden","value":"5ee2066c-193f-243b-1e1a-f4a5ed6037ec"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_5ee2066c-193f-243b-1e1a-f4a5ed6037ec__Value"}},[_vm._v("Have you participated in a marathon/road race charity program before? (required)")]),_vm._v(" "),_c('select',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_5ee2066c-193f-243b-1e1a-f4a5ed6037ec__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[5ee2066c-193f-243b-1e1a-f4a5ed6037ec].Value","data-sc-tracking":"True","data-sc-field-name":"haveYou22","data-val-required":"Have you participated in a marathon/road race charity program before? (required) is required.","data-val":"true"}},[_c('option',{attrs:{"value":"No","selected":"selected"}},[_vm._v("No")]),_vm._v(" "),_c('option',{attrs:{"value":"Yes"}},[_vm._v("Yes")])]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[5ee2066c-193f-243b-1e1a-f4a5ed6037ec].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('p',{},[_vm._v("If yes, please list which charity, which race and how much was fundraised for each one.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_c1a3946e-591b-32f7-f6c4-2d2af56c1ead","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"c1a3946e-591b-32f7-f6c4-2d2af56c1ead"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_c1a3946e-591b-32f7-f6c4-2d2af56c1ead__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[c1a3946e-591b-32f7-f6c4-2d2af56c1ead].ItemId","type":"hidden","value":"c1a3946e-591b-32f7-f6c4-2d2af56c1ead"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_c1a3946e-591b-32f7-f6c4-2d2af56c1ead__Value"}},[_vm._v("Charity Name (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_c1a3946e-591b-32f7-f6c4-2d2af56c1ead__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[c1a3946e-591b-32f7-f6c4-2d2af56c1ead].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"charityName23","data-val-required":"Charity Name (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[c1a3946e-591b-32f7-f6c4-2d2af56c1ead].Value","data-valmsg-replace":"true"}},[_vm._v("Charity Name (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_c56189a8-9b9f-2c19-5b83-9f6130325f3f","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"c56189a8-9b9f-2c19-5b83-9f6130325f3f"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_c56189a8-9b9f-2c19-5b83-9f6130325f3f__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[c56189a8-9b9f-2c19-5b83-9f6130325f3f].ItemId","type":"hidden","value":"c56189a8-9b9f-2c19-5b83-9f6130325f3f"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_c56189a8-9b9f-2c19-5b83-9f6130325f3f__Value"}},[_vm._v("Amount Raised: $ (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_c56189a8-9b9f-2c19-5b83-9f6130325f3f__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[c56189a8-9b9f-2c19-5b83-9f6130325f3f].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"amountRaised24","data-val-required":"Amount Raised: $ (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[c56189a8-9b9f-2c19-5b83-9f6130325f3f].Value","data-valmsg-replace":"true"}},[_vm._v("Amount Raised: $ (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_3dd70182-94d2-ab65-c438-9f18259b24a8","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"3dd70182-94d2-ab65-c438-9f18259b24a8"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_3dd70182-94d2-ab65-c438-9f18259b24a8__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[3dd70182-94d2-ab65-c438-9f18259b24a8].ItemId","type":"hidden","value":"3dd70182-94d2-ab65-c438-9f18259b24a8"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_3dd70182-94d2-ab65-c438-9f18259b24a8__Value"}},[_vm._v("Do you have another charity to add?")]),_vm._v(" "),_c('select',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_3dd70182-94d2-ab65-c438-9f18259b24a8__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[3dd70182-94d2-ab65-c438-9f18259b24a8].Value","data-sc-tracking":"True","data-sc-field-name":"doYou49"}},[_c('option',{attrs:{"value":"No","selected":"selected"}},[_vm._v("No")]),_vm._v(" "),_c('option',{attrs:{"value":"Yes"}},[_vm._v("Yes")])]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[3dd70182-94d2-ab65-c438-9f18259b24a8].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_e738d072-529b-1041-2f0e-ae8b7917b8d1","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"e738d072-529b-1041-2f0e-ae8b7917b8d1"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_e738d072-529b-1041-2f0e-ae8b7917b8d1__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[e738d072-529b-1041-2f0e-ae8b7917b8d1].ItemId","type":"hidden","value":"e738d072-529b-1041-2f0e-ae8b7917b8d1"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_e738d072-529b-1041-2f0e-ae8b7917b8d1__Value"}},[_vm._v("Charity Name (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_e738d072-529b-1041-2f0e-ae8b7917b8d1__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[e738d072-529b-1041-2f0e-ae8b7917b8d1].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"charityName43","data-val-required":"Charity Name (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[e738d072-529b-1041-2f0e-ae8b7917b8d1].Value","data-valmsg-replace":"true"}},[_vm._v("Charity Name (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_1f4706e8-258f-82ac-f366-8493ab26fd7b","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"1f4706e8-258f-82ac-f366-8493ab26fd7b"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_1f4706e8-258f-82ac-f366-8493ab26fd7b__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[1f4706e8-258f-82ac-f366-8493ab26fd7b].ItemId","type":"hidden","value":"1f4706e8-258f-82ac-f366-8493ab26fd7b"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_1f4706e8-258f-82ac-f366-8493ab26fd7b__Value"}},[_vm._v("Amount Raised: $ (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_1f4706e8-258f-82ac-f366-8493ab26fd7b__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[1f4706e8-258f-82ac-f366-8493ab26fd7b].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"amountRaised44","data-val-required":"Amount Raised: $ (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[1f4706e8-258f-82ac-f366-8493ab26fd7b].Value","data-valmsg-replace":"true"}},[_vm._v("Amount Raised: $ (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_34e2ca80-cbbd-b2cf-4f2c-3c1f0595590c","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"34e2ca80-cbbd-b2cf-4f2c-3c1f0595590c"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_34e2ca80-cbbd-b2cf-4f2c-3c1f0595590c__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[34e2ca80-cbbd-b2cf-4f2c-3c1f0595590c].ItemId","type":"hidden","value":"34e2ca80-cbbd-b2cf-4f2c-3c1f0595590c"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_34e2ca80-cbbd-b2cf-4f2c-3c1f0595590c__Value"}},[_vm._v("Do you have another charity to add?")]),_vm._v(" "),_c('select',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_34e2ca80-cbbd-b2cf-4f2c-3c1f0595590c__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[34e2ca80-cbbd-b2cf-4f2c-3c1f0595590c].Value","data-sc-tracking":"True","data-sc-field-name":"doYou50"}},[_c('option',{attrs:{"value":"No","selected":"selected"}},[_vm._v("No")]),_vm._v(" "),_c('option',{attrs:{"value":"Yes"}},[_vm._v("Yes")])]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[34e2ca80-cbbd-b2cf-4f2c-3c1f0595590c].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_02ad328c-60c1-8df9-5e58-95c4e7cec798","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"02ad328c-60c1-8df9-5e58-95c4e7cec798"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_02ad328c-60c1-8df9-5e58-95c4e7cec798__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[02ad328c-60c1-8df9-5e58-95c4e7cec798].ItemId","type":"hidden","value":"02ad328c-60c1-8df9-5e58-95c4e7cec798"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_02ad328c-60c1-8df9-5e58-95c4e7cec798__Value"}},[_vm._v("Charity Name (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_02ad328c-60c1-8df9-5e58-95c4e7cec798__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[02ad328c-60c1-8df9-5e58-95c4e7cec798].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"charityName45","data-val-required":"Charity Name (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[02ad328c-60c1-8df9-5e58-95c4e7cec798].Value","data-valmsg-replace":"true"}},[_vm._v("Charity Name (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_61df24be-c50e-548b-b511-e659346fd620","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"61df24be-c50e-548b-b511-e659346fd620"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_61df24be-c50e-548b-b511-e659346fd620__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[61df24be-c50e-548b-b511-e659346fd620].ItemId","type":"hidden","value":"61df24be-c50e-548b-b511-e659346fd620"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_61df24be-c50e-548b-b511-e659346fd620__Value"}},[_vm._v("Amount Raised: $ (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_61df24be-c50e-548b-b511-e659346fd620__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[61df24be-c50e-548b-b511-e659346fd620].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"amountRaised46","data-val-required":"Amount Raised: $ (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[61df24be-c50e-548b-b511-e659346fd620].Value","data-valmsg-replace":"true"}},[_vm._v("Amount Raised: $ (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_937935d3-43e6-d95e-49c4-edb0d619173e","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"937935d3-43e6-d95e-49c4-edb0d619173e"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_937935d3-43e6-d95e-49c4-edb0d619173e__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[937935d3-43e6-d95e-49c4-edb0d619173e].ItemId","type":"hidden","value":"937935d3-43e6-d95e-49c4-edb0d619173e"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_937935d3-43e6-d95e-49c4-edb0d619173e__Value"}},[_vm._v("What will your fundraising goal be for Tedy’s Team? $ (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_937935d3-43e6-d95e-49c4-edb0d619173e__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[937935d3-43e6-d95e-49c4-edb0d619173e].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"whatWill25","data-val-required":"What will your fundraising goal be for Tedy’s Team? $ (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[937935d3-43e6-d95e-49c4-edb0d619173e].Value","data-valmsg-replace":"true"}},[_vm._v("What will your fundraising goal be for Tedy’s Team? $ (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_330e1455-cf54-2c9f-e6fd-1451f9219d17","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"330e1455-cf54-2c9f-e6fd-1451f9219d17"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_330e1455-cf54-2c9f-e6fd-1451f9219d17__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[330e1455-cf54-2c9f-e6fd-1451f9219d17].ItemId","type":"hidden","value":"330e1455-cf54-2c9f-e6fd-1451f9219d17"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_330e1455-cf54-2c9f-e6fd-1451f9219d17__Value"}},[_vm._v("What are your ideas for raising these funds? (please use attachment option below if necessary) (required)")]),_vm._v(" "),_c('textarea',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_330e1455-cf54-2c9f-e6fd-1451f9219d17__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[330e1455-cf54-2c9f-e6fd-1451f9219d17].Value","rows":"10","maxlength":"512","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"whatAre26","data-val-required":"What are your ideas for raising these funds? (please use attachment option below if necessary)  (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[330e1455-cf54-2c9f-e6fd-1451f9219d17].Value","data-valmsg-replace":"true"}},[_vm._v("What are your ideas for raising these funds? (please use attachment option below if necessary) (required) is\n            required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_f5d05525-5fe7-4503-9da6-e7e9c667669c","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"f5d05525-5fe7-4503-9da6-e7e9c667669c"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_f5d05525-5fe7-4503-9da6-e7e9c667669c__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[f5d05525-5fe7-4503-9da6-e7e9c667669c].ItemId","type":"hidden","value":"f5d05525-5fe7-4503-9da6-e7e9c667669c"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_f5d05525-5fe7-4503-9da6-e7e9c667669c__Value"}},[_vm._v("Use this option to submit an attachment if necessary:")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_f5d05525-5fe7-4503-9da6-e7e9c667669c__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[f5d05525-5fe7-4503-9da6-e7e9c667669c].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"useThis"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[f5d05525-5fe7-4503-9da6-e7e9c667669c].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_5717998b-7429-f8b4-9409-a66961513bcc","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"5717998b-7429-f8b4-9409-a66961513bcc"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_5717998b-7429-f8b4-9409-a66961513bcc__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[5717998b-7429-f8b4-9409-a66961513bcc].ItemId","type":"hidden","value":"5717998b-7429-f8b4-9409-a66961513bcc"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_5717998b-7429-f8b4-9409-a66961513bcc__Value"}},[_vm._v("Do you have other fundraising experience? (required)")]),_vm._v(" "),_c('select',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_5717998b-7429-f8b4-9409-a66961513bcc__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[5717998b-7429-f8b4-9409-a66961513bcc].Value","data-sc-tracking":"True","data-sc-field-name":"typeA61","data-val-required":"Do you have other fundraising experience? (required) is required.","data-val":"true"}},[_c('option',{attrs:{"value":"No","selected":"selected"}},[_vm._v("No")]),_vm._v(" "),_c('option',{attrs:{"value":"Yes"}},[_vm._v("Yes")])]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[5717998b-7429-f8b4-9409-a66961513bcc].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_ec5638d7-4849-4c80-8348-09a949c2f431","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"ec5638d7-4849-4c80-8348-09a949c2f431"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_ec5638d7-4849-4c80-8348-09a949c2f431__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[ec5638d7-4849-4c80-8348-09a949c2f431].ItemId","type":"hidden","value":"ec5638d7-4849-4c80-8348-09a949c2f431"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_ec5638d7-4849-4c80-8348-09a949c2f431__Value"}},[_vm._v("Please list the non-profit/s you have fundraised for. (required)")]),_vm._v(" "),_c('textarea',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_ec5638d7-4849-4c80-8348-09a949c2f431__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[ec5638d7-4849-4c80-8348-09a949c2f431].Value","rows":"10","maxlength":"512","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"pleaseList62","data-val-required":"Please list the non-profit/s you have fundraised for. (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[ec5638d7-4849-4c80-8348-09a949c2f431].Value","data-valmsg-replace":"true"}},[_vm._v("Please list the non-profit/s you have fundraised for. (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_09a1d1a7-d4ce-66d5-98ae-dcd73243f612","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"09a1d1a7-d4ce-66d5-98ae-dcd73243f612"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_09a1d1a7-d4ce-66d5-98ae-dcd73243f612__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[09a1d1a7-d4ce-66d5-98ae-dcd73243f612].ItemId","type":"hidden","value":"09a1d1a7-d4ce-66d5-98ae-dcd73243f612"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_09a1d1a7-d4ce-66d5-98ae-dcd73243f612__Value"}},[_vm._v("Please list fundraising amount raised. (required)")]),_vm._v(" "),_c('textarea',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_09a1d1a7-d4ce-66d5-98ae-dcd73243f612__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[09a1d1a7-d4ce-66d5-98ae-dcd73243f612].Value","rows":"10","maxlength":"512","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"pleaseList63","data-val-required":"Please list fundraising amount raised. (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[09a1d1a7-d4ce-66d5-98ae-dcd73243f612].Value","data-valmsg-replace":"true"}},[_vm._v("Please list fundraising amount raised. (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_78985e05-9a40-6108-5fc8-3d440f4a3c81","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"78985e05-9a40-6108-5fc8-3d440f4a3c81"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_78985e05-9a40-6108-5fc8-3d440f4a3c81__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[78985e05-9a40-6108-5fc8-3d440f4a3c81].ItemId","type":"hidden","value":"78985e05-9a40-6108-5fc8-3d440f4a3c81"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_78985e05-9a40-6108-5fc8-3d440f4a3c81__Value"}},[_vm._v("Running Experience")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_78985e05-9a40-6108-5fc8-3d440f4a3c81__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[78985e05-9a40-6108-5fc8-3d440f4a3c81].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"heading28"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[78985e05-9a40-6108-5fc8-3d440f4a3c81].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_e20f8315-24e5-ef9d-cfc8-85638be2cb99","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"e20f8315-24e5-ef9d-cfc8-85638be2cb99"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_e20f8315-24e5-ef9d-cfc8-85638be2cb99__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[e20f8315-24e5-ef9d-cfc8-85638be2cb99].ItemId","type":"hidden","value":"e20f8315-24e5-ef9d-cfc8-85638be2cb99"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_e20f8315-24e5-ef9d-cfc8-85638be2cb99__Value"}},[_vm._v("Have you ever run the Boston Marathon®? (required)")]),_vm._v(" "),_c('select',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_e20f8315-24e5-ef9d-cfc8-85638be2cb99__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[e20f8315-24e5-ef9d-cfc8-85638be2cb99].Value","data-sc-tracking":"True","data-sc-field-name":"haveYou51","data-val-required":"Have you ever run the Boston Marathon®? (required) is required.","data-val":"true"}},[_c('option',{attrs:{"value":"No","selected":"selected"}},[_vm._v("No")]),_vm._v(" "),_c('option',{attrs:{"value":"Yes"}},[_vm._v("Yes")])]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[e20f8315-24e5-ef9d-cfc8-85638be2cb99].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_711a23f8-ce68-349e-e2c6-5ac4a03ad50f","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"711a23f8-ce68-349e-e2c6-5ac4a03ad50f"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_711a23f8-ce68-349e-e2c6-5ac4a03ad50f__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[711a23f8-ce68-349e-e2c6-5ac4a03ad50f].ItemId","type":"hidden","value":"711a23f8-ce68-349e-e2c6-5ac4a03ad50f"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_711a23f8-ce68-349e-e2c6-5ac4a03ad50f__Value"}},[_vm._v("If yes, in what year and what was your finishing time? If no, have you completed any full or half marathon previously\n            – please list race, year and time. (This is not a requirement for inclusion on the team) (required)")]),_vm._v(" "),_c('textarea',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_711a23f8-ce68-349e-e2c6-5ac4a03ad50f__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[711a23f8-ce68-349e-e2c6-5ac4a03ad50f].Value","rows":"10","maxlength":"512","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"ifYes29","data-val-required":"If yes, in what year and what was your finishing time? If no, have you completed any full or half marathon previously – please list race, year and time. (This is not a requirement for inclusion on the team) (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[711a23f8-ce68-349e-e2c6-5ac4a03ad50f].Value","data-valmsg-replace":"true"}},[_vm._v("If yes, in what year and what was your finishing time? If no, have you completed any full or half marathon previously\n            – please list race, year and time. (This is not a requirement for inclusion on the team) (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_aa0e8a05-998d-b202-d09d-48b4640a01e3","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"aa0e8a05-998d-b202-d09d-48b4640a01e3"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_aa0e8a05-998d-b202-d09d-48b4640a01e3__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[aa0e8a05-998d-b202-d09d-48b4640a01e3].ItemId","type":"hidden","value":"aa0e8a05-998d-b202-d09d-48b4640a01e3"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_aa0e8a05-998d-b202-d09d-48b4640a01e3__Value"}},[_vm._v("Please list finishing times in your last 3 road races of at least 5K in duration (please distinguish race\n                length) (required)")]),_vm._v(" "),_c('textarea',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_aa0e8a05-998d-b202-d09d-48b4640a01e3__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[aa0e8a05-998d-b202-d09d-48b4640a01e3].Value","rows":"10","maxlength":"512","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"pleaseList","data-val-required":"Please list finishing times in your last 3 road races of at least 5K in duration (please distinguish race length) (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[aa0e8a05-998d-b202-d09d-48b4640a01e3].Value","data-valmsg-replace":"true"}},[_vm._v("Please list finishing times in your last 3 road races of at least 5K in duration (please distinguish race\n                length) (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_ef425aa4-ec0e-d87a-0fc7-9bdae0717dcf","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"ef425aa4-ec0e-d87a-0fc7-9bdae0717dcf"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_ef425aa4-ec0e-d87a-0fc7-9bdae0717dcf__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[ef425aa4-ec0e-d87a-0fc7-9bdae0717dcf].ItemId","type":"hidden","value":"ef425aa4-ec0e-d87a-0fc7-9bdae0717dcf"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_ef425aa4-ec0e-d87a-0fc7-9bdae0717dcf__Value"}},[_vm._v("Briefly describe your current running program/fitness program, including days per week, type of exercise\n                and duration of exercise. (required)")]),_vm._v(" "),_c('textarea',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_ef425aa4-ec0e-d87a-0fc7-9bdae0717dcf__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[ef425aa4-ec0e-d87a-0fc7-9bdae0717dcf].Value","rows":"10","maxlength":"512","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"brieflyDescribe31","data-val-required":"Briefly describe your current running program/fitness program, including days per week, type of exercise and duration of exercise. (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[ef425aa4-ec0e-d87a-0fc7-9bdae0717dcf].Value","data-valmsg-replace":"true"}},[_vm._v("Briefly describe your current running program/fitness program, including days per week, type of exercise\n                and duration of exercise. (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_a077a0f9-6c4d-ed9b-108c-cc289bb7093c","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"a077a0f9-6c4d-ed9b-108c-cc289bb7093c"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_a077a0f9-6c4d-ed9b-108c-cc289bb7093c__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[a077a0f9-6c4d-ed9b-108c-cc289bb7093c].ItemId","type":"hidden","value":"a077a0f9-6c4d-ed9b-108c-cc289bb7093c"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_a077a0f9-6c4d-ed9b-108c-cc289bb7093c__Value"}},[_vm._v("Please answer the following questions so that we can get to know you a little better.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_a077a0f9-6c4d-ed9b-108c-cc289bb7093c__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[a077a0f9-6c4d-ed9b-108c-cc289bb7093c].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"heading32"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[a077a0f9-6c4d-ed9b-108c-cc289bb7093c].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_ba27b62c-e905-cdb8-eb4e-a3cd5d65a423","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"ba27b62c-e905-cdb8-eb4e-a3cd5d65a423"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_ba27b62c-e905-cdb8-eb4e-a3cd5d65a423__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[ba27b62c-e905-cdb8-eb4e-a3cd5d65a423].ItemId","type":"hidden","value":"ba27b62c-e905-cdb8-eb4e-a3cd5d65a423"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_ba27b62c-e905-cdb8-eb4e-a3cd5d65a423__Value"}},[_vm._v("How did you learn about Tedy’s Team? (required)")]),_vm._v(" "),_c('textarea',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_ba27b62c-e905-cdb8-eb4e-a3cd5d65a423__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[ba27b62c-e905-cdb8-eb4e-a3cd5d65a423].Value","rows":"10","maxlength":"512","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"howDid","data-val-required":"How did you learn about Tedy’s Team? (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[ba27b62c-e905-cdb8-eb4e-a3cd5d65a423].Value","data-valmsg-replace":"true"}},[_vm._v("How did you learn about Tedy’s Team? (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_c42a39de-c474-5af4-fd2c-4feafa7f5794","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"c42a39de-c474-5af4-fd2c-4feafa7f5794"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_c42a39de-c474-5af4-fd2c-4feafa7f5794__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[c42a39de-c474-5af4-fd2c-4feafa7f5794].ItemId","type":"hidden","value":"c42a39de-c474-5af4-fd2c-4feafa7f5794"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_c42a39de-c474-5af4-fd2c-4feafa7f5794__Value"}},[_vm._v("Have you had any experience with other American Stroke Association programs? (required)")]),_vm._v(" "),_c('select',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_c42a39de-c474-5af4-fd2c-4feafa7f5794__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[c42a39de-c474-5af4-fd2c-4feafa7f5794].Value","data-sc-tracking":"True","data-sc-field-name":"haveYou","data-val-required":"Have you had any experience with other American Stroke Association programs? (required) is required.","data-val":"true"}},[_c('option',{attrs:{"value":"No","selected":"selected"}},[_vm._v("No")]),_vm._v(" "),_c('option',{attrs:{"value":"Yes"}},[_vm._v("Yes")])]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[c42a39de-c474-5af4-fd2c-4feafa7f5794].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_4a3fe05c-bb05-1e92-510f-8fa722e43fb7","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"4a3fe05c-bb05-1e92-510f-8fa722e43fb7"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_4a3fe05c-bb05-1e92-510f-8fa722e43fb7__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[4a3fe05c-bb05-1e92-510f-8fa722e43fb7].ItemId","type":"hidden","value":"4a3fe05c-bb05-1e92-510f-8fa722e43fb7"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_4a3fe05c-bb05-1e92-510f-8fa722e43fb7__Value"}},[_vm._v("If yes, how and which program? (required)")]),_vm._v(" "),_c('textarea',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_4a3fe05c-bb05-1e92-510f-8fa722e43fb7__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[4a3fe05c-bb05-1e92-510f-8fa722e43fb7].Value","rows":"10","maxlength":"512","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"ifYes35","data-val-required":"If yes, how and which program?  (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[4a3fe05c-bb05-1e92-510f-8fa722e43fb7].Value","data-valmsg-replace":"true"}},[_vm._v("If yes, how and which program? (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_4d7aeda7-0ec2-63fb-3805-f4bc9df9c341","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"4d7aeda7-0ec2-63fb-3805-f4bc9df9c341"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_4d7aeda7-0ec2-63fb-3805-f4bc9df9c341__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[4d7aeda7-0ec2-63fb-3805-f4bc9df9c341].ItemId","type":"hidden","value":"4d7aeda7-0ec2-63fb-3805-f4bc9df9c341"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_4d7aeda7-0ec2-63fb-3805-f4bc9df9c341__Value"}},[_vm._v("Do you have a personal connection to stroke? (required)")]),_vm._v(" "),_c('select',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_4d7aeda7-0ec2-63fb-3805-f4bc9df9c341__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[4d7aeda7-0ec2-63fb-3805-f4bc9df9c341].Value","data-sc-tracking":"True","data-sc-field-name":"doYou","data-val-required":"Do you have a personal connection to stroke?  (required) is required.","data-val":"true"}},[_c('option',{attrs:{"value":"No","selected":"selected"}},[_vm._v("No")]),_vm._v(" "),_c('option',{attrs:{"value":"Yes"}},[_vm._v("Yes")])]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[4d7aeda7-0ec2-63fb-3805-f4bc9df9c341].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_dd3dd4ad-f75a-b3e2-f97c-9a8062be167f","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"dd3dd4ad-f75a-b3e2-f97c-9a8062be167f"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_dd3dd4ad-f75a-b3e2-f97c-9a8062be167f__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[dd3dd4ad-f75a-b3e2-f97c-9a8062be167f].ItemId","type":"hidden","value":"dd3dd4ad-f75a-b3e2-f97c-9a8062be167f"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_dd3dd4ad-f75a-b3e2-f97c-9a8062be167f__Value"}},[_vm._v("If yes, please state connection. (required)")]),_vm._v(" "),_c('textarea',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_dd3dd4ad-f75a-b3e2-f97c-9a8062be167f__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[dd3dd4ad-f75a-b3e2-f97c-9a8062be167f].Value","rows":"10","maxlength":"512","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"ifYes","data-val-required":"If yes, please state connection. (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[dd3dd4ad-f75a-b3e2-f97c-9a8062be167f].Value","data-valmsg-replace":"true"}},[_vm._v("If yes, please state connection. (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_83e10d00-7aca-639f-9db8-85e1eb022b44","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"83e10d00-7aca-639f-9db8-85e1eb022b44"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_83e10d00-7aca-639f-9db8-85e1eb022b44__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[83e10d00-7aca-639f-9db8-85e1eb022b44].ItemId","type":"hidden","value":"83e10d00-7aca-639f-9db8-85e1eb022b44"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_83e10d00-7aca-639f-9db8-85e1eb022b44__Value"}},[_vm._v("Please describe why you would like to run the marathon for Tedy’s Team? Please feel free to include any additional\n                pages, photos, etc that may help to elaborate your connection to the cause and interest in our team.\n                (please use attachment option below if necessary) (required)")]),_vm._v(" "),_c('textarea',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_83e10d00-7aca-639f-9db8-85e1eb022b44__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[83e10d00-7aca-639f-9db8-85e1eb022b44].Value","rows":"10","maxlength":"512","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"pleaseDescribe37","data-val-required":"Please describe why you would like to run the marathon for Tedy’s Team?  Please feel free to include any additional pages, photos, etc that may help to elaborate your connection to the cause and interest in our team. (please use attachment option below if necessary)  (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[83e10d00-7aca-639f-9db8-85e1eb022b44].Value","data-valmsg-replace":"true"}},[_vm._v("Please describe why you would like to run the marathon for Tedy’s Team? Please feel free to include any additional\n                pages, photos, etc that may help to elaborate your connection to the cause and interest in our team.\n                (please use attachment option below if necessary) (required) is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_0eeb7f22-62c0-0f89-136b-2f7803b147ad","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"0eeb7f22-62c0-0f89-136b-2f7803b147ad"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_0eeb7f22-62c0-0f89-136b-2f7803b147ad__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[0eeb7f22-62c0-0f89-136b-2f7803b147ad].ItemId","type":"hidden","value":"0eeb7f22-62c0-0f89-136b-2f7803b147ad"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_0eeb7f22-62c0-0f89-136b-2f7803b147ad__Value"}},[_vm._v("Use this option to submit an attachment if necessary:")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_0eeb7f22-62c0-0f89-136b-2f7803b147ad__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[0eeb7f22-62c0-0f89-136b-2f7803b147ad].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"useThis38"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[0eeb7f22-62c0-0f89-136b-2f7803b147ad].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_86f7abcc-aa90-3f77-990e-25c6af5e5476","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"86f7abcc-aa90-3f77-990e-25c6af5e5476"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_86f7abcc-aa90-3f77-990e-25c6af5e5476__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[86f7abcc-aa90-3f77-990e-25c6af5e5476].ItemId","type":"hidden","value":"86f7abcc-aa90-3f77-990e-25c6af5e5476"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_86f7abcc-aa90-3f77-990e-25c6af5e5476__Value"}},[_vm._v("Label")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_86f7abcc-aa90-3f77-990e-25c6af5e5476__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[86f7abcc-aa90-3f77-990e-25c6af5e5476].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"clickTo","data-val-required":"Label is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[86f7abcc-aa90-3f77-990e-25c6af5e5476].Value","data-valmsg-replace":"true"}},[_vm._v("Label is required.")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_5a3b5af7-81ef-4fc3-82d9-4cf67f0d8152","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"5a3b5af7-81ef-4fc3-82d9-4cf67f0d8152"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_5a3b5af7-81ef-4fc3-82d9-4cf67f0d8152__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[5a3b5af7-81ef-4fc3-82d9-4cf67f0d8152].ItemId","type":"hidden","value":"5a3b5af7-81ef-4fc3-82d9-4cf67f0d8152"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_5a3b5af7-81ef-4fc3-82d9-4cf67f0d8152__Value"}},[_vm._v("Label")]),_vm._v(" "),_c('input',{attrs:{"type":"date","id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_5a3b5af7-81ef-4fc3-82d9-4cf67f0d8152__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[5a3b5af7-81ef-4fc3-82d9-4cf67f0d8152].Value","data-sc-tracking":"True","data-sc-field-name":"Date","data-val-date":"The field Value must be a date.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[5a3b5af7-81ef-4fc3-82d9-4cf67f0d8152].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_bc187d56-0f3d-48a4-a4cf-c4e59e65360d","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"bc187d56-0f3d-48a4-a4cf-c4e59e65360d"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_bc187d56-0f3d-48a4-a4cf-c4e59e65360d__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[bc187d56-0f3d-48a4-a4cf-c4e59e65360d].ItemId","type":"hidden","value":"bc187d56-0f3d-48a4-a4cf-c4e59e65360d"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_bc187d56-0f3d-48a4-a4cf-c4e59e65360d__Value"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_bc187d56-0f3d-48a4-a4cf-c4e59e65360d__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[bc187d56-0f3d-48a4-a4cf-c4e59e65360d].Value","type":"password","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"Password Confirmation","data-val-required":"Password is required.","data-val-length":"Password must have at least 6 and no more than 255 characters.","data-val-length-min":"6","data-val-length-max":"255","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[bc187d56-0f3d-48a4-a4cf-c4e59e65360d].Value","data-valmsg-replace":"true"}},[_vm._v("Password is required.")]),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_bc187d56-0f3d-48a4-a4cf-c4e59e65360d__ConfirmPassword"}},[_vm._v("Confirm password")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_bc187d56-0f3d-48a4-a4cf-c4e59e65360d__ConfirmPassword","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[bc187d56-0f3d-48a4-a4cf-c4e59e65360d].ConfirmPassword","type":"password","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"Password Confirmation","data-val-equalto":"The Confirm password and Password do not match.","data-val-equalto-other":"*.Value","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[bc187d56-0f3d-48a4-a4cf-c4e59e65360d].ConfirmPassword","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_Index_3da04f80-e96a-4f66-9a8d-9be1e1670ac7","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields.Index","type":"hidden","value":"3da04f80-e96a-4f66-9a8d-9be1e1670ac7"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_3da04f80-e96a-4f66-9a8d-9be1e1670ac7__ItemId","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[3da04f80-e96a-4f66-9a8d-9be1e1670ac7].ItemId","type":"hidden","value":"3da04f80-e96a-4f66-9a8d-9be1e1670ac7"}}),_vm._v(" "),_c('label',{},[_c('input',{attrs:{"type":"checkbox","id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_3da04f80-e96a-4f66-9a8d-9be1e1670ac7__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[3da04f80-e96a-4f66-9a8d-9be1e1670ac7].Value","value":"true","data-sc-tracking":"True","data-sc-field-name":"Checkbox","data-val-required":"The Value field is required.","data-val":"true"}}),_vm._v("Label\n                "),_c('input',{attrs:{"type":"hidden","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[3da04f80-e96a-4f66-9a8d-9be1e1670ac7].Value","value":"false"}})]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[3da04f80-e96a-4f66-9a8d-9be1e1670ac7].Value","data-valmsg-replace":"true"}}),_vm._v(" "),_c('input',{attrs:{"value":"Submit","type":"submit","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.199ed37d-20b0-e58a-28d3-4186af220554"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_NavigationButtons","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.NavigationButtons","type":"hidden","value":"199ed37d-20b0-e58a-28d3-4186af220554"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_199ed37d-20b0-e58a-28d3-4186af220554","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.199ed37d-20b0-e58a-28d3-4186af220554","type":"hidden","value":"0"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4bc741e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inline_search_vue__ = __webpack_require__(1182);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4bc741e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inline_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-search-results-form',{attrs:{"action":"en/search","query-delimeter":"?#","role":"search"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"c-inline-search"},[_c('div',{staticClass:"c-inline-search__form"},[_c('div',{staticClass:"c-inline-search__search form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label-lg",attrs:{"for":""}},[_vm._v("Search")]),_vm._v(" "),_c('input',{directives:[{name:"input",rawName:"v-input.flagged",value:('q'),expression:"'q'",modifiers:{"flagged":true}}],staticClass:"c-inline-search__input form-control form-control-lg",attrs:{"type":"text","id":"","placeholder":"ex: avocado","name":"q"}})]),_vm._v(" "),_c('button',{staticClass:"c-inline-search__submit btn btn-lg btn-danger btn-round",attrs:{"disabled":!slotProps.isValid()},on:{"click":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}},[_vm._v("Search")])])])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_293d404e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ce_search_vue__ = __webpack_require__(1184);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_293d404e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ce_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-ce-search"},[_c('div',{staticClass:"c-ce-search__top"},[_c('div',{staticClass:"col-md-10 offset-md-1"},[_vm._m(0),_vm._v(" "),_c('aha-search-results-form',{attrs:{"action":"search","query-delimeter":"#","role":"search"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg"},[_c('label',{staticClass:"c-ce-search__top-label"},[_c('div',{staticClass:"pb-2",attrs:{"id":"socialDeterminantHeading"}},[_vm._v("What Problems Are You Trying to Solve?")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"socialDeterminantHeading","input-name":"socialDeterminant","input-directive":true,"default-value":"","toggle-class":"c-search-group__dropdown btn btn-white btn--select"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Select Problem Area")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Select Problem Area","value":"","item-class":"c-select-dropdown__item","selected":""}},[_vm._v("Select Problem Area")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 1","value":"option-1","item-class":"c-select-dropdown__item"}},[_vm._v("Option 1")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 2","value":"option-2","item-class":"c-select-dropdown__item"}},[_vm._v("Option 2")])],1)],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg"},[_c('label',{staticClass:"c-ce-search__top-label"},[_c('div',{staticClass:"pb-2",attrs:{"id":"sizeOfPopulationHeading"}},[_vm._v("Urban or Rural?")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"sizeOfPopulationHeading","input-name":"sizeOfPopulation","input-directive":true,"default-value":"","toggle-class":"c-search-group__dropdown btn btn-white btn--select"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Select Urban or Rural")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Urban or Rural","value":"","item-class":"c-select-dropdown__item","selected":""}},[_vm._v("Select Urban or Rural")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 1","value":"option-1","item-class":"c-select-dropdown__item"}},[_vm._v("Option 1")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 2","value":"option-2","item-class":"c-select-dropdown__item"}},[_vm._v("Option 2")])],1)],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-4"},[_c('button',{staticClass:"btn btn-round btn-primary c-ce-search__search-btn",attrs:{"disabled":!slotProps.isValid()},on:{"click":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}},[_vm._v("Search")])])])]}}])}),_vm._v(" "),_c('span',{staticClass:"c-ce-search__orlabel"},[_vm._v("or")])],1)]),_vm._v(" "),_c('div',{staticClass:"c-ce-search__bottom"},[_vm._m(1),_vm._v(" "),_c('aha-search-results-form',{attrs:{"action":"search","query-delimeter":"#","role":"search"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8"},[_c('label',{staticClass:"c-ce-search__top-label",attrs:{"id":"keywordSearchHeading"}},[_c('div',{staticClass:"pb-2"},[_vm._v("Keyword")]),_vm._v(" "),_c('input',{directives:[{name:"input",rawName:"v-input.flagged",value:('q'),expression:"'q'",modifiers:{"flagged":true}}],staticClass:"form-control",attrs:{"type":"text","id":"keywordSearch","aria-describedby":"keywordSearchHeading","placeholder":"i.e health care","name":"q"}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('button',{staticClass:"btn btn-round btn-primary c-ce-search__search-btn",attrs:{"disabled":!slotProps.isValid()},on:{"click":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}},[_vm._v("Search")])])])]}}])})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-ce-search__top-title"},[_c('h3',{staticClass:"c-ce-search__top-header"},[_vm._v("Community Innovation Exchange Search")]),_vm._v(" "),_c('p',{staticClass:"c-ce-search__top-subheader pb-3"},[_vm._v("\n          No problem is to big to solve if we work together.\n          "),_c('br'),_vm._v("Search and be inspired by innovative programs designed to solve big problems in communities across the country.\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-ce-search__bottom-title"},[_c('h4',{staticClass:"c-ce-search__bottom-header"},[_vm._v("Search By Keyword")]),_vm._v(" "),_c('p',{staticClass:"c-ce-search__bottom-subheader pb-3"},[_vm._v("Use terms and phrases to search our Community Innovation Exchange solutions.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000af91c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_course_search_vue__ = __webpack_require__(1186);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000af91c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_course_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{directives:[{name:"form-submit",rawName:"v-form-submit"},{name:"course-search-form",rawName:"v-course-search-form"}],staticClass:"container c-course-search",attrs:{"action":"https://ahainstructornetworkqa.americanheart.org/AHAECC/classConnector.jsp?pid=ahaecc.classconnector.home&_ga=2.175320930.1307746969.1574643604-685754032.1573072366%27","target":"_blank","method":"post","novalidate":""}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-3 d-flex align-items-center"},[_c('img',{staticClass:"c-course-search__icon",attrs:{"src":"assets/icons/institution-black.svg","aria-hidden":"true"}}),_vm._v(" "),_c('h2',{staticClass:"d-inline ml-4 my-0 h3"},[_vm._v("Find A Course")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-lg-6"},[_c('label',{attrs:{"for":"courseid"}},[_vm._v("Course List")]),_vm._v(" "),_c('select',{staticClass:"custom-select btn--select form-control",attrs:{"id":"courseid","name":"courseid","aria-required":"true","required":""}},[_c('option',{attrs:{"value":""}},[_vm._v("Select A Course")]),_vm._v(" "),_c('option',{attrs:{"value":"courseId1"}},[_vm._v("BLS Course Options")]),_vm._v(" "),_c('option',{attrs:{"value":"courseId2"}},[_vm._v("ACLS Course Options")]),_vm._v(" "),_c('option',{attrs:{"value":"courseId3"}},[_vm._v("ACLS EP Classroom Course")]),_vm._v(" "),_c('option',{attrs:{"value":"courseId4"}},[_vm._v("PALS Course Options")]),_vm._v(" "),_c('option',{attrs:{"value":"courseId5"}},[_vm._v("PEARS Classroom Course")]),_vm._v(" "),_c('option',{attrs:{"value":"courseId6"}},[_vm._v("Heartsaver First Aid Course Options")]),_vm._v(" "),_c('option',{attrs:{"value":"courseId7"}},[_vm._v("Heartsaver CPR AED Course Options")]),_vm._v(" "),_c('option',{attrs:{"value":"courseId8"}},[_vm._v("Heartsaver® First Aid CPR AED Course Options")]),_vm._v(" "),_c('option',{attrs:{"value":"courseId9"}},[_vm._v("Heartsaver® Pediatric First Aid CPR AED Course Options")]),_vm._v(" "),_c('option',{attrs:{"value":"courseId10"}},[_vm._v("Heartsaver® Bloodborne Pathogens Classroom Course")]),_vm._v(" "),_c('option',{attrs:{"value":"courseId11"}},[_vm._v("Family & Friends CPR Classroom Course")])]),_vm._v(" "),_c('p',{staticClass:"invalid-feedback",attrs:{"role":"alert"}},[_vm._v("Course Selection Required")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-lg-6"},[_c('label',{attrs:{"for":"zipcode"}},[_vm._v("Zip Code")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"zipcode","value":"12345","name":"zipcode","type":"text","placeholder":"Zip Code"}}),_vm._v(" "),_c('p',{staticClass:"invalid-feedback",attrs:{"role":"alert"}},[_vm._v("Invalid Zip Code Format")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-4"},[_c('button',{staticClass:"c-course-search__search-btn btn btn-danger btn-round",attrs:{"type":"submit","data-analytics-campaign":"{\"id\":123, \"name\":\"search button\"}"}},[_vm._v("Search")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c658f16_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cpr_course_search_vue__ = __webpack_require__(1188);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c658f16_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cpr_course_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-cpr-course-search"},[_c('div',{staticClass:"c-ce-search__top"},[_vm._m(0),_vm._v(" "),_c('aha-cpr-search-course-wrapper',{attrs:{"base-endpoint-domain":"http://www.mocky.io/v2/","dropdown-controller":'f:@coursetopic',"dropdown-dynamic":'f:@coursetype'},scopedSlots:_vm._u([{key:"dynamicdropdowns",fn:function(props){return _c('div',{},[_c('aha-search-results-form',{ref:"searchForm",attrs:{"action":"search","query-delimeter":"#","role":"search"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('label',{staticClass:"c-ce-search__top-label",attrs:{"id":"Audience4b3f7fb56c3b4393989c50f9f31717a9lbl"}},[_c('span',{staticClass:"pb-2 d-block",attrs:{"id":"Audience4b3f7fb56c3b4393989c50f9f31717a9"}},[_vm._v("Audience")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"Audience4b3f7fb56c3b4393989c50f9f31717a9","input-name":"f:@courseaudience","toggle-class":"c-search-group__dropdown btn btn-white btn--select","input-directive":true,"default-value":""}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Select Audience")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Select Audience","value":"","item-class":"c-select-dropdown__item","selected":""}},[_vm._v("Select Audience")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"General Community","value":"General%20Community","item-class":"c-select-dropdown__item"}},[_vm._v("General Community")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Healthcare Professionals","value":"Healthcare%20Professionals","item-class":"c-select-dropdown__item"}},[_vm._v("Healthcare Professionals")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Instructors","value":"Instructors","item-class":"c-select-dropdown__item"}},[_vm._v("Instructors")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Schools","value":"Schools","item-class":"c-select-dropdown__item"}},[_vm._v("Schools")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Non-Healthcare professionals","value":"Non-Healthcare%20professionals","item-class":"c-select-dropdown__item"}},[_vm._v("Non-Healthcare professionals")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Non-Clinical","value":"Non-Clinical","item-class":"c-select-dropdown__item"}},[_vm._v("Non-Clinical")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"General Public","value":"General%20Public","item-class":"c-select-dropdown__item"}},[_vm._v("General Public")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"First Responders","value":"First%20Responders","item-class":"c-select-dropdown__item"}},[_vm._v("First Responders")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Other","value":"Other","item-class":"c-select-dropdown__item"}},[_vm._v("Other")])],1)],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{staticClass:"c-ce-search__top-label",attrs:{"id":"Topic32c80ae17b454fc1a3f9b7ae28ac30f7lbl"}},[_c('span',{staticClass:"pb-2 d-block",attrs:{"id":"Topic32c80ae17b454fc1a3f9b7ae28ac30f7"}},[_vm._v("Topic")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"Topic32c80ae17b454fc1a3f9b7ae28ac30f7","input-name":"f:@coursetopic","toggle-class":"c-search-group__dropdown btn btn-white btn--select","input-directive":true,"default-value":""}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Select Topic")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Select Topic","value":"","item-class":"c-select-dropdown__item","selected":""}},[_vm._v("Select Topic")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","data-endpoint":"5ed7fa7a32000005f6274de7","role":"option","text":"Adult CPR","value":"Adult%20CPR","item-class":"c-select-dropdown__item"}},[_vm._v("Adult CPR")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","data-endpoint":"5ed7fa7a32000005f6274de7","role":"option","text":"Advanced Cardiovascular Life Support (ACLS)","value":"Advanced%20Cardiovascular%20Life%20Support%20%28ACLS%29","item-class":"c-select-dropdown__item"}},[_vm._v("Advanced Cardiovascular Life Support (ACLS)")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","data-endpoint":"5ed7fa7a32000005f6274de7","role":"option","text":"Basic Life Support (BLS)","value":"Basic%20Life%20Support%20%28BLS%29","item-class":"c-select-dropdown__item"}},[_vm._v("Basic Life Support (BLS)")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","data-endpoint":"5ed7fa7a32000005f6274de7","role":"option","text":"Bloodborne Pathogens","value":"Bloodborne%20Pathogens","item-class":"c-select-dropdown__item"}},[_vm._v("Bloodborne Pathogens")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","data-endpoint":"5ed7fa7a32000005f6274de7","role":"option","text":"Infant & Child CPR","value":"Infant%20%26%20Child%20CPR","item-class":"c-select-dropdown__item"}},[_vm._v("Infant & Child CPR")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","data-endpoint":"5ed7fa7a32000005f6274de7","role":"option","text":"Blood Pressure","value":"Blood%20Pressure","item-class":"c-select-dropdown__item"}},[_vm._v("Blood Pressure")])],1)],2)],1)]),_vm._v(" "),(props.showDynamicDropdown)?_c('div',{staticClass:"col-lg-4"},[_c('label',{staticClass:"c-ce-search__top-label",attrs:{"id":"Course-Format9df3212677a741c49ccf1002bf86254flbl"}},[_c('span',{staticClass:"pb-2 d-block",attrs:{"id":"Course-Format9df3212677a741c49ccf1002bf86254f"}},[_vm._v("Course Format "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(props.isError),expression:"props.isError"}],staticClass:"h-color--white small"},[_vm._v("( "+_vm._s(props.error)+" )")])]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"Course-Format9df3212677a741c49ccf1002bf86254f","input-name":"f:@coursetype","toggle-class":"c-search-group__dropdown btn btn-white btn--select","input-directive":true,"default-value":""}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Select Course Format ")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Select Course Format","value":"","item-class":"c-select-dropdown__item","selected":""}},[_vm._v("Select Course Format")]),_vm._v(" "),_vm._l((props.children),function(child,index){return _c('aha-select-dropdown-item',{key:index,attrs:{"tag":"li","role":"option","text":child.text,"value":child.value,"item-class":"c-select-dropdown__item"}},[_c('span',{domProps:{"innerHTML":_vm._s(child.text)}})])})],2)],2)],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-4"},[_c('button',{staticClass:"btn btn-round btn-primary c-ce-search__search-btn",attrs:{"disabled":!slotProps.isValid()},on:{"click":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}},[_vm._v("Search")])])])]}}],null,true)})],1)}}])}),_vm._v(" "),_c('span',{staticClass:"c-ce-search__orlabel"},[_vm._v("or")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-ce-search__top-title"},[_c('h2',{staticClass:"c-ce-search__top-header"},[_vm._v("I need help finding the right course")]),_vm._v(" "),_c('p',{staticClass:"c-ce-search__top-subheader pb-3"},[_vm._v("Use the categories in the dropdowns below to tell us more about you, so we can help you find the correct course. If a course is required for work, always make sure to check with your employer to ensure you are selecting the correct course.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d22880_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quality_research_publications_vue__ = __webpack_require__(1190);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d22880_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quality_research_publications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-ce-search"},[_c('div',{staticClass:"c-ce-search__top"},[_vm._m(0),_vm._v(" "),_c('aha-search-results-form',{attrs:{"action":"search","query-delimeter":"#","role":"search"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('label',{staticClass:"c-ce-search__top-label"},[_c('div',{staticClass:"pb-2",attrs:{"id":"moduleHeading"}},[_vm._v("GWTG Condition Module")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"moduleHeading","input-name":"module","input-directive":true,"default-value":"","toggle-class":"c-search-group__dropdown btn btn-white btn--select"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Select Module")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Select Module","value":"","item-class":"c-select-dropdown__item","selected":""}},[_vm._v("Select Module")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Atrial Fibrillation","value":"atrial-fibrillation","item-class":"c-select-dropdown__item"}},[_vm._v("Atrial Fibrillation")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Coronary Artery","value":"coronary-artery","item-class":"c-select-dropdown__item"}},[_vm._v("Coronary Artery")])],1)],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{staticClass:"c-ce-search__top-label"},[_c('div',{staticClass:"pb-2",attrs:{"id":"publicationYearHeading"}},[_vm._v("Publication Year")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"publicationYearHeading","input-name":"publicationYear","input-directive":true,"default-value":"","toggle-class":"c-search-group__dropdown btn btn-white btn--select"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Select Year")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Select Year","value":"","item-class":"c-select-dropdown__item","selected":""}},[_vm._v("Select Year")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"2000","value":"2000","item-class":"c-select-dropdown__item"}},[_vm._v("2000")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"2001","value":"2001","item-class":"c-select-dropdown__item"}},[_vm._v("2001")])],1)],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{staticClass:"c-ce-search__top-label",attrs:{"id":"searchTermHeading"}},[_c('div',{staticClass:"pb-2"},[_vm._v("Enter Search Term")]),_vm._v(" "),_c('input',{directives:[{name:"input",rawName:"v-input.flagged",value:('q'),expression:"'q'",modifiers:{"flagged":true}}],staticClass:"c-ce-search__input form-control",attrs:{"type":"text","id":"searchTerm","aria-describedby":"searchTermHeading","placeholder":"Example: Jones or Diabetes","name":"q"}})])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-4"},[_c('button',{staticClass:"btn btn-round btn-primary c-ce-search__search-btn c-ce-search__search-btn--spacer",attrs:{"disabled":!slotProps.isValid()},on:{"click":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}},[_vm._v("Search")])])])]}}])})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-ce-search__top-title"},[_c('h3',{staticClass:"c-ce-search__top-header h2"},[_vm._v("Search for Quality Research Publications")]),_vm._v(" "),_c('p',{staticClass:"c-ce-search__top-subheader pb-3"},[_vm._v("Search for "),_c('strong',[_vm._v("Publications by Condition Module, Year, or Search Term.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_search_vue__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_search_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_search_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_search_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308c4076_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_map_search_vue__ = __webpack_require__(1192);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_search_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308c4076_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_map_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"location-selector-form",class:{ 'is-loading': _vm.isLoading },attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-lg-4"},[_c('label',{attrs:{"for":_vm.inputLabel}},[_vm._v(_vm._s(_vm.translations.searchLabel))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hospital),expression:"hospital"}],ref:"input1",staticClass:"form-control",attrs:{"id":_vm.inputLabel,"name":"hospital","type":"text","placeholder":_vm.translations.searchLabelPlaceholder},domProps:{"value":(_vm.hospital)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hospital=$event.target.value}}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"form-group col-lg-4"},[_c('label',{attrs:{"for":_vm.inputAddressLabel}},[_vm._v(_vm._s(_vm.translations.searchAddressLabel))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],ref:"input2",staticClass:"form-control",attrs:{"id":_vm.inputAddressLabel,"name":"address","type":"text","autocomplete":"off","placeholder":_vm.translations.addressLabelPlaceholder},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-lg-3"},[_c('label',{attrs:{"for":_vm.distanceId}},[_vm._v(_vm._s(_vm.translations.distance))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.distance),expression:"distance"}],staticClass:"custom-select btn--select form-control",attrs:{"id":_vm.distanceId,"name":"distance"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.distance=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.translations.distancePlaceholder))]),_vm._v(" "),_vm._l((_vm.distances),function(distance){return _c('option',{key:distance.code,domProps:{"value":distance.code}},[_vm._v(_vm._s(distance.title))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-4"},[_c('button',{ref:"submit",staticClass:"c-map-search__search-btn btn btn-danger btn-round",attrs:{"disabled":!_vm.validInput,"type":"submit"}},[_vm._v(_vm._s(_vm.translations.search))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n            Form error message\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-lg-1 p-0"},[_c('span',{staticClass:"c-ce-search__orlabel"},[_vm._v("or")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59a040a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_print_button_vue__ = __webpack_require__(1194);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59a040a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_print_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('recipe-print'),expression:"'recipe-print'"}],staticClass:"c-print-btn"},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"c-print-btn__link c-cta h-theme--red"},[_vm._v("\n        Print this recipe\n    ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-print-btn__icon"},[_c('img',{attrs:{"src":"assets/glyphs/print.svg","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e482744_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rating_widget_vue__ = __webpack_require__(1196);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e482744_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rating_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid container-wide"},[_c('div',{staticClass:"c-hero-card h-theme--yellow-orange-alt"},[_c('div',{staticClass:"c-hero-card__container rating-widget"},[_c('div',{directives:[{name:"vertical-align",rawName:"v-vertical-align"}],staticClass:"c-hero-card__content-container"},[_c('h1',{staticClass:"c-hero-card__heading h2"},[_vm._v("Veggie Pizza With Cauliflower Crust")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"c-hero-card__media h-placeholder-image h-placeholder-image--43-20"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/1200x600?text=loaded'),expression:"'//placehold.it/1200x600?text=loaded'"}],attrs:{"src":"//placehold.it/1200x600?text=loading","alt":""}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-card__action"},[_c('div',{},[_c('i',{staticClass:"icon-circle-star h-color--green"}),_vm._v(" "),_c('div',{staticClass:"rw-ui-container"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5abadce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inline_search_dropdown_vue__ = __webpack_require__(1198);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5abadce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inline_search_dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-search-results-form',{attrs:{"action":"en/search","query-delimeter":"?#","role":"search"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"c-inline-search"},[_c('div',{staticClass:"c-inline-search__form",attrs:{"action":"#"}},[_c('div',{staticClass:"form-group"},[_c('span',{staticClass:"sr-only",attrs:{"id":"browse"}},[_vm._v("Browse")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"browse","input-name":"searchCategory","input-directive":true,"default-value":"","toggle-class":"c-inline-search__dropdown btn btn-lg btn-white btn--select"}},[_c('span',{staticClass:"c-inline-search__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Browse")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Browse","value":"","item-class":"c-select-dropdown__item","selected":""}},[_vm._v("Browse")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 1","value":"option-1","item-class":"c-select-dropdown__item"}},[_vm._v("Option 1")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 2","value":"option-2","item-class":"c-select-dropdown__item"}},[_vm._v("Option 2")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 3","value":"option-3","item-class":"c-select-dropdown__item"}},[_vm._v("Option 3")])],1)],2)],1),_vm._v(" "),_c('div',{staticClass:"c-inline-search__search form-group"},[_c('label',{staticClass:"sr-only",attrs:{"for":"inline-search-dropdown-input"}},[_vm._v("Search Recipes")]),_vm._v(" "),_c('input',{directives:[{name:"input",rawName:"v-input.flagged",value:('q'),expression:"'q'",modifiers:{"flagged":true}}],staticClass:"c-inline-search__input form-control form-control-lg",attrs:{"type":"text","id":"inline-search-dropdown-input","placeholder":"ex: avocado","name":"q"}})]),_vm._v(" "),_c('button',{staticClass:"c-inline-search__submit btn btn-lg btn-danger btn-round",attrs:{"disabled":!slotProps.isValid(),"type":"submit"},on:{"click":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}},[_vm._v("Search")])])])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c5044f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inline_search_icon_vue__ = __webpack_require__(1200);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c5044f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inline_search_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-search-results-form',{attrs:{"action":"en/search","query-delimeter":"?#","role":"search"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"c-inline-search"},[_c('form',{staticClass:"c-inline-search__form",attrs:{"action":"#"}},[_c('div',{staticClass:"form-group"},[_c('span',{staticClass:"sr-only",attrs:{"id":"browse"}},[_vm._v("Browse")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","input-name":"customInputName","input-directive":true,"default-value":"Browse","toggle-class":"c-inline-search__dropdown btn btn-lg btn-white btn--select","menu-class":"l-promo l-promo--icon-search"}},[_c('span',{staticClass:"c-inline-search__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Browse")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Main Dishes","value":"main-dishes","item-class":"l-promo__col"}},[_c('div',{staticClass:"c-select-dropdown__icon"},[_c('div',{staticClass:"c-icon-promo"},[_c('div',{staticClass:"c-icon-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/main-dishes-icon.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Main Dishes")])])])])]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Side Dishes","value":"side-dishes","item-class":"l-promo__col"}},[_c('div',{staticClass:"c-select-dropdown__icon"},[_c('div',{staticClass:"c-icon-promo"},[_c('div',{staticClass:"c-icon-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/side-dishes-icon.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Side Dishes")])])])])]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Salads","value":"salads","item-class":"l-promo__col"}},[_c('div',{staticClass:"c-select-dropdown__icon"},[_c('div',{staticClass:"c-icon-promo"},[_c('div',{staticClass:"c-icon-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/salad-icon.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Salads")])])])])]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Slow Cooker","value":"slow-cooker","item-class":"l-promo__col"}},[_c('div',{staticClass:"c-select-dropdown__icon"},[_c('div',{staticClass:"c-icon-promo"},[_c('div',{staticClass:"c-icon-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/slow-cooker-icon.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Slow Cooker")])])])])]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Poultry","value":"poultry","item-class":"l-promo__col"}},[_c('div',{staticClass:"c-select-dropdown__icon"},[_c('div',{staticClass:"c-icon-promo"},[_c('div',{staticClass:"c-icon-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/slow-cooker-icon.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Poultry")])])])])]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Beef","value":"beef","item-class":"l-promo__col"}},[_c('div',{staticClass:"c-select-dropdown__icon"},[_c('div',{staticClass:"c-icon-promo"},[_c('div',{staticClass:"c-icon-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/beef-icon.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Beef")])])])])]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Vegetarian","value":"vegetarian","item-class":"l-promo__col"}},[_c('div',{staticClass:"c-select-dropdown__icon"},[_c('div',{staticClass:"c-icon-promo"},[_c('div',{staticClass:"c-icon-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/veggie-icon.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Vegetarian")])])])])]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Budget Friendly","value":"budget-friendly","item-class":"l-promo__col"}},[_c('div',{staticClass:"c-select-dropdown__icon"},[_c('div',{staticClass:"c-icon-promo"},[_c('div',{staticClass:"c-icon-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/budget-icon.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Budget Friendly")])])])])]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"AHA Cookbooks","value":"aha-cookbooks","item-class":"l-promo__col"}},[_c('div',{staticClass:"c-select-dropdown__icon"},[_c('div',{staticClass:"c-select-dropdown__icon"},[_c('div',{staticClass:"c-icon-promo"},[_c('div',{staticClass:"c-icon-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/recipe-book-icon.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("AHA Cookbooks")])])])])])])],1)],2)],1),_vm._v(" "),_c('div',{staticClass:"c-inline-search__search form-group"},[_c('label',{staticClass:"sr-only",attrs:{"for":""}},[_vm._v("Search Recipes")]),_vm._v(" "),_c('input',{directives:[{name:"input",rawName:"v-input.flagged",value:('q'),expression:"'q'",modifiers:{"flagged":true}}],staticClass:"c-inline-search__input form-control form-control-lg",attrs:{"type":"text","id":"","placeholder":"ex: avocado","name":"q"}})]),_vm._v(" "),_c('button',{staticClass:"c-inline-search__submit btn btn-lg btn-danger btn-round",attrs:{"disabled":!slotProps.isValid(),"type":"submit"},on:{"click":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}},[_vm._v("Search")])])])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73765a48_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inline_search_redirect_vue__ = __webpack_require__(1202);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73765a48_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inline_search_redirect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-search-results-form',{attrs:{"action":"en/search","query-delimeter":"?#","role":"search"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"c-inline-search"},[_c('div',{staticClass:"c-inline-search__form"},[_c('aha-select-dropdown',{attrs:{"position":"left","default-value":"Recipes Categories","toggle-class":"c-inline-search__dropdown btn btn-lg btn-white btn--select"}},[_vm._v("\n                    Recipes Categories\n        \n                    "),_c('template',{slot:"dropdown"},[_c('ul',{staticClass:"c-select-dropdown__list"},[_c('li',{staticClass:"c-select-dropdown__item"},[_c('a',{staticClass:"c-select-dropdown__link h-color--black",attrs:{"href":"http://google.com"}},[_vm._v("Option 1")])]),_vm._v(" "),_c('li',{staticClass:"c-select-dropdown__item"},[_c('a',{staticClass:"c-select-dropdown__link h-color--black",attrs:{"href":"#"}},[_vm._v("Option 2")])])])])],2),_vm._v(" "),_c('span',{staticClass:"c-inline-search__or"},[_vm._v("or")]),_vm._v(" "),_c('div',{staticClass:"c-inline-search__search form-group"},[_c('label',{staticClass:"sr-only",attrs:{"for":""}},[_vm._v("Search Something")]),_vm._v(" "),_c('input',{directives:[{name:"input",rawName:"v-input.flagged",value:('q'),expression:"'q'",modifiers:{"flagged":true}}],staticClass:"c-inline-search__input form-control form-control-lg",attrs:{"type":"text","id":"","placeholder":"ex. Search Something","name":"q"}})]),_vm._v(" "),_c('button',{staticClass:"c-inline-search__submit btn btn-lg btn-danger btn-round",attrs:{"disabled":!slotProps.isValid(),"type":"submit","value":"Search"},on:{"click":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}},[_vm._v("Search")])],1)])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_138b50a3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inline_search_simple_vue__ = __webpack_require__(1204);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_138b50a3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inline_search_simple_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-search-results-form',{attrs:{"action":"/en/search","query-delimeter":"#","role":"search"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"c-inline-search"},[_c('div',{staticClass:"c-inline-search__form"},[_c('div',{staticClass:"c-inline-search__search form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label-lg sr-only",attrs:{"for":"firstAidGuidelinesSearch"}},[_vm._v("Search")]),_vm._v(" "),_c('input',{directives:[{name:"input",rawName:"v-input.flagged",value:('q'),expression:"'q'",modifiers:{"flagged":true}}],staticClass:"c-inline-search__input form-control form-control-lg",attrs:{"type":"text","id":"firstAidGuidelinesSearch","placeholder":"Search First Aid...","name":"q","title":"Insert a query. Press enter to send","aria-label":"Insert a query. Press enter to send"},on:{"enter":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}})]),_vm._v(" "),_c('button',{staticClass:"c-inline-search__submit btn btn-lg btn-danger btn-round",on:{"click":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}},[_vm._v("Search")])])])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e72a97e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_column_content_width_promo_vue__ = __webpack_require__(1206);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e72a97e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_column_content_width_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo--match-height c-promo--bg c-promo--shadow h-text-contrast h-theme--gray-dark"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/600/600/any?2'),expression:"'//placeimg.com/600/600/any?2'"}],attrs:{"src":"assets/images/placeholder.gif","width":"1200","height":"600","alt":""}})]),_vm._v(" "),_c('span',{staticClass:"h-mask-dark"}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo row"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('aha-poll-component')],1),_vm._v(" "),_vm._m(4)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo--match-height c-promo--border c-promo--shadow c-promo--bg-triangle h-theme--red"},[_c('div',{staticClass:"c-promo__content"},[_c('div',{staticClass:"c-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/laugh-icon.svg"}})]),_vm._v(" "),_c('h2',{staticClass:"h3"},[_vm._v("Donate Today")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin lobortis felis et purus mollis, in consequat elit gravida. Cras eu lorem lectus. Nulla lacinia nulla id quam luctus rhoncus.")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("View All Articles")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo__content"},[_c('div',{staticClass:"c-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/laugh-icon.svg"}})]),_vm._v(" "),_c('h2',{staticClass:"h3"},[_vm._v("Join Us For a Heart Walk In Your Area")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin lobortis felis et purus mollis, in consequat elit gravida. Cras eu lorem lectus. Nulla lacinia nulla id quam luctus rhoncus.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo__actions c-promo__actions--divider"},[_c('a',{staticClass:"c-promo__cta c-cta c-cta--arrow h-theme--green",attrs:{"href":"#"}},[_vm._v("View Cartoons")]),_vm._v(" "),_c('span',{staticClass:"c-promo__cta-divider"}),_vm._v(" "),_c('a',{staticClass:"c-promo__cta c-cta c-cta--arrow h-theme--white",attrs:{"href":"#"}},[_vm._v("Second Link")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo row"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo--bg-triangle c-promo--match-height c-promo--shadow h-theme--gray-dark"},[_c('div',{staticClass:"c-promo__content"},[_c('div',{staticClass:"c-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/laugh-icon.svg"}})]),_vm._v(" "),_c('h2',{staticClass:"h3"},[_vm._v("Articles")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin lobortis felis.")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--orange-alt",attrs:{"href":"#"}},[_vm._v("View All Articles")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo--match-height c-promo--bg-triangle c-promo--shadow h-theme--gray-dark"},[_c('div',{staticClass:"c-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Sponsor")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__icon"},[_c('p',{staticClass:"h-color--gray"},[_vm._v("National Recipe Host")]),_vm._v(" "),_c('img',{attrs:{"src":"//placehold.it/300x150"}})]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--green",attrs:{"href":"#"}},[_vm._v("Explore Our Sponsor")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo--match-height c-promo--bg-triangle c-promo--shadow h-theme--gray-dark"},[_c('div',{staticClass:"c-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Sponsor")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__icon"},[_c('p',{staticClass:"h-color--gray"},[_vm._v("National Recipe Host")]),_vm._v(" "),_c('img',{attrs:{"src":"//placehold.it/300x150"}})]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--green",attrs:{"href":"#"}},[_vm._v("Explore Our Sponsor")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3edb117a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_column_full_width_promo_vue__ = __webpack_require__(1208);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3edb117a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_column_full_width_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo row"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo--full-width c-promo--bg-triangle c-promo--border c-promo--shadow h-theme--green-light"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/600x600/333333/666666?text=FPO'),expression:"'//placehold.it/600x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo row"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo--full-width c-promo--bg-triangle c-promo--border c-promo--shadow h-theme--green-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/600x600/333333/666666?text=FPO'),expression:"'//placehold.it/600x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])]),_vm._v(" "),_vm._m(1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 c-promo--last-sm"},[_c('div',{staticClass:"c-promo c-promo--match-height"},[_c('div',{staticClass:"c-promo__content"},[_c('div',{staticClass:"c-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/laugh-icon.svg"}})]),_vm._v(" "),_c('h2',{staticClass:"h3"},[_vm._v("Join Us For a Heart Walk In Your Area")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin lobortis felis.")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Register Today")]),_vm._v(" "),_c('span',{staticClass:"c-promo__cta-divider"}),_vm._v(" "),_c('a',{staticClass:"c-cta pl-5 c-cta--arrow h-theme--gray",attrs:{"href":"#"}},[_vm._v("More Info")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 c-promo--last-sm"},[_c('div',{staticClass:"c-promo c-promo--match-height"},[_c('div',{staticClass:"c-promo__content"},[_c('div',{staticClass:"c-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/laugh-icon.svg"}})]),_vm._v(" "),_c('h2',{staticClass:"h3"},[_vm._v("Join Us For a Heart Walk In Your Area")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin lobortis felis.")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Register Today")]),_vm._v(" "),_c('span',{staticClass:"c-promo__cta-divider"}),_vm._v(" "),_c('a',{staticClass:"c-cta c-cta--arrow h-theme--gray",attrs:{"href":"#"}},[_vm._v("More Info")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51ed728e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_column_full_bleed_promo_vue__ = __webpack_require__(1210);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51ed728e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_column_full_bleed_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"l-promo__container"},[_c('div',{staticClass:"l-promo l-promo--bg d-none d-md-flex"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo c-promo--bg h-theme--white"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/600/600/any?1'),expression:"'//placeimg.com/600/600/any?1'"}],attrs:{"src":"assets/images/placeholder.gif"}})])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo c-promo--bg h-theme--gray-dark"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/600/600/any?2'),expression:"'//placeimg.com/600/600/any?2'"}],attrs:{"src":"assets/images/placeholder.gif"}})])])])]),_vm._v(" "),_c('div',{staticClass:"container-wide"},[_c('div',{staticClass:"l-promo"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo c-promo--match-height h-text-contrast h-theme--white"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg d-md-none"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/600/600/any?1'),expression:"'//placeimg.com/600/600/any?1'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_c('span',{staticClass:"h-mask-light"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo c-promo--match-height h-text-contrast h-theme--gray-dark"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg d-md-none"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/600/600/any?2'),expression:"'//placeimg.com/600/600/any?2'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_c('span',{staticClass:"h-mask-dark"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo__content"},[_c('div',{staticClass:"c-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/laugh-icon.svg"}})]),_vm._v(" "),_c('h2',{staticClass:"h2"},[_vm._v("Recent Articles")]),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin lobortis felis et purus mollis, in consequat elit gravida. Cras eu lorem lectus.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("View All Articles")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo__content"},[_c('div',{staticClass:"c-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/laugh-icon.svg"}})]),_vm._v(" "),_c('h2',{staticClass:"h2"},[_vm._v("Heart Humor By Jonny Hawkins")]),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin lobortis felis et purus mollis, in consequat elit gravida. Cras eu lorem lectus.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo__actions"},[_c('a',{staticClass:"c-promo__cta c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("View Cartoons")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24aed7a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_column_content_width_promo_vue__ = __webpack_require__(1212);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24aed7a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_column_content_width_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo row no-gutters"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-text-promo"},[_c('div',{staticClass:"c-text-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Warning Signs")]),_vm._v(" "),_c('p',[_vm._v("Learn about the warning signs of heart attack, stroke, and cardiac arrest.")])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Learn Warning Signs")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-text-promo"},[_c('div',{staticClass:"c-text-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Hands-Only CPR")]),_vm._v(" "),_c('p',[_vm._v("Hands-only CPR can save lives. Your actions can only help.")])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Learn About CPR")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-text-promo"},[_c('div',{staticClass:"c-text-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Patients Matter")]),_vm._v(" "),_c('p',[_vm._v("The best revenge against stroke is recovery - and we've got the tools.")])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Learn More")])])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo row no-gutters"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-text-promo"},[_c('div',{staticClass:"c-text-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Warning Signs")]),_vm._v(" "),_c('p',[_vm._v("Learn about the warning signs of heart attack, stroke, and cardiac arrest.")])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Learn Warning Signs")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-text-promo"},[_c('div',{staticClass:"c-text-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Hands-Only CPR")]),_vm._v(" "),_c('p',[_vm._v("Hands-only CPR can save lives. Your actions can only help.")])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Learn About CPR")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-text-promo"},[_c('div',{staticClass:"c-text-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Patients Matter")]),_vm._v(" "),_c('p',[_vm._v("The best revenge against stroke is recovery - and we've got the tools.")])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Learn More")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-text-promo"},[_c('div',{staticClass:"c-text-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Patients Matter")]),_vm._v(" "),_c('p',[_vm._v("The best revenge against stroke is recovery - and we've got the tools.")])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Learn More")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1da527c5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_four_column_content_width_icon_promo_vue__ = __webpack_require__(1214);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1da527c5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_four_column_content_width_icon_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo l-promo--icon"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-icon-promo"},[_c('div',{staticClass:"c-icon-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/main-dishes-icon.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Main Dishes")])]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#","aria-label":"View Main Dishes Recipes"}},[_vm._v("View Recipes")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-icon-promo"},[_c('div',{staticClass:"c-icon-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/side-dishes-icon.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Side Dishes")])]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#","aria-label":"View Side Dishes Recipes"}},[_vm._v("View Recipes")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-icon-promo"},[_c('div',{staticClass:"c-icon-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/salad-icon.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Salads")])]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#","aria-label":"View Salad Recipes"}},[_vm._v("View Recipes")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-icon-promo"},[_c('div',{staticClass:"c-icon-promo__icon"},[_c('img',{attrs:{"src":"assets/icons/slow-cooker-icon.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Slow Cooker")])]),_vm._v(" "),_c('div',{staticClass:"c-icon-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#","aria-label":"View Slow Cooker Recipes"}},[_vm._v("View Recipes")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a562b49_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_four_column_content_width_image_promo_vue__ = __webpack_require__(1216);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a562b49_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_four_column_content_width_image_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo l-promo--image row"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('a',{staticClass:"c-image-promo",attrs:{"href":"#"}},[_c('div',{staticClass:"c-image-promo__media h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('a',{staticClass:"c-image-promo",attrs:{"href":"#"}},[_c('div',{staticClass:"c-image-promo__media h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('a',{staticClass:"c-image-promo",attrs:{"href":"#"}},[_c('div',{staticClass:"c-image-promo__media h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('a',{staticClass:"c-image-promo",attrs:{"href":"#"}},[_c('div',{staticClass:"c-image-promo__media h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_vm._m(3)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-image-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Recipes for Lowering Cholesterol")]),_vm._v(" "),_c('p',{staticClass:"c-image-promo__meta"},[_vm._v("45 Recipes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-image-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Top 30 Seafood Recipes")]),_vm._v(" "),_c('p',{staticClass:"c-image-promo__meta"},[_vm._v("30 Recipes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-image-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Best of Vegetarian Meals")]),_vm._v(" "),_c('p',{staticClass:"c-image-promo__meta"},[_vm._v("25 Recipes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-image-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Healthy Holiday Recipes")]),_vm._v(" "),_c('p',{staticClass:"c-image-promo__meta"},[_vm._v("37 Recipes")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a0d65d3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_four_column_full_width_image_promo_vue__ = __webpack_require__(1218);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a0d65d3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_four_column_full_width_image_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid container-wide"},[_c('div',{staticClass:"l-promo l-promo--image"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-image-promo c-image-promo--full"},[_c('div',{staticClass:"c-image-promo__media h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-image-promo c-image-promo--full"},[_c('div',{staticClass:"c-image-promo__media h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-image-promo c-image-promo--full"},[_c('div',{staticClass:"c-image-promo__media h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-image-promo c-image-promo--full"},[_c('div',{staticClass:"c-image-promo__media h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_vm._m(3)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-image-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Healthy Summer Salad")]),_vm._v(" "),_c('a',{staticClass:"c-image-promo__meta c-cta h-theme--red",attrs:{"href":"#","aria-label":"Download Image"}},[_vm._v("Download Image")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-image-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("BP Cuff on Woman's Arm")]),_vm._v(" "),_c('a',{staticClass:"c-image-promo__meta c-cta h-theme--red",attrs:{"href":"#","aria-label":"Download Image"}},[_vm._v("Download Image")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-image-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Fall Time Veggie Pizza")]),_vm._v(" "),_c('a',{staticClass:"c-image-promo__meta c-cta h-theme--red",attrs:{"href":"#","aria-label":"Download Image"}},[_vm._v("Download Image")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-image-promo__content"},[_c('h2',{staticClass:"h4"},[_vm._v("Checking Blood Pressure")]),_vm._v(" "),_c('a',{staticClass:"c-image-promo__meta c-cta h-theme--red",attrs:{"href":"#","aria-label":"Download Image"}},[_vm._v("Download Image")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52968dd4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_column_full_width_promo_vue__ = __webpack_require__(1220);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52968dd4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_column_full_width_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-extra-wide"},[_c('div',{staticClass:"l-promo l-promo--survivor-grid"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"container-extra-wide"},[_c('div',{staticClass:"l-promo l-promo--survivor-grid"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])])])]),_vm._v(" "),_c('div',{staticClass:"container-extra-wide"},[_c('div',{staticClass:"l-promo l-promo--survivor-grid"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"container-extra-wide"},[_c('div',{staticClass:"l-promo l-promo--survivor-grid"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-survivor-promo"},[_c('p',[_vm._v("Jeremy Woodward with his wife, Brook, and older daughter, Elliana, after he completed his first Ironman triathlon in 2010. (Photo courtesy of Jeremy Woodward)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-survivor-promo c-survivor-promo--first"},[_c('p',[_vm._v("Jeremy Woodward with his wife, Brook, and older daughter, Elliana, after he completed his first Ironman triathlon in 2010. (Photo courtesy of Jeremy Woodward)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-survivor-promo c-survivor-promo--alt-first"},[_c('h4',{staticClass:"h4"},[_vm._v("…Participated in "),_c('span',{staticClass:"h-color--red"},[_vm._v("his fourth")]),_vm._v(" Boston Marathon")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-survivor-promo c-survivor-promo--alt"},[_c('h4',{staticClass:"h4"},[_vm._v("…Participated in "),_c('span',{staticClass:"h-color--red"},[_vm._v("his fourth")]),_vm._v(" Boston Marathon")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f2fa16e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_email_promo_vue__ = __webpack_require__(1222);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f2fa16e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_email_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"c-email-promo c-email-promo--bg c-email-promo--center h-text-contrast h-theme--gray-dark"},[_c('div',{staticClass:"c-email-promo__media h-placeholder-image h-placeholder-image--bg"}),_vm._v(" "),_c('span',{}),_vm._v(" "),_c('div',{staticClass:"c-email-promo__container container container-fluid"},[_c('div',{staticClass:"c-email-promo__content h-text-contrast h-theme--black"},[_c('h1',{staticClass:"c-email-promo__heading h2"},[_vm._v("Sign up for more RQI Content")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{directives:[{name:"form-submit",rawName:"v-form-submit"}],staticClass:"text-left",attrs:{"action":""}},[_vm._m(1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"c-email-promo__subheading h4"},[_vm._v("\n          Are you interested in learning more about the specifics of the RQI® program including what is included with a subscription?\n          "),_c('br'),_vm._v(" "),_c('br'),_vm._v("Complete the form below to recive more details about RQI, and to learn more about events and program developments.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"aria-atomic":"true","aria-live":"polite"}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"firstname"}},[_vm._v("First Name (optional)")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"firstname","name":"firstname"}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"lastname"}},[_vm._v("Last Name (optional)")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"lastname","name":"lastname"}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"title"}},[_vm._v("Title (optional)")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"title","name":"title"}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"organization"}},[_vm._v("Organization (optional)")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"organization","name":"organization"}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"d-block",attrs:{"for":"city"}},[_vm._v("City (optional)")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"city","name":"city"}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"d-block",attrs:{"for":"SelectedState"}},[_vm._v("State (optional)")]),_vm._v(" "),_c('select',{staticClass:"custom-select btn--select",attrs:{"id":"state","name":"SelectedState"}},[_c('option',{attrs:{"value":"","selected":"selected"}},[_vm._v("Select State")]),_vm._v(" "),_c('option',{attrs:{"value":"Alabama"}},[_vm._v("Alabama")]),_vm._v(" "),_c('option',{attrs:{"value":"Alaska"}},[_vm._v("Alaska")]),_vm._v(" "),_c('option',{attrs:{"value":"Arizona"}},[_vm._v("Arizona")]),_vm._v(" "),_c('option',{attrs:{"value":"Arkansas"}},[_vm._v("Arkansas")]),_vm._v(" "),_c('option',{attrs:{"value":"California"}},[_vm._v("California")]),_vm._v(" "),_c('option',{attrs:{"value":"Colorado"}},[_vm._v("Colorado")]),_vm._v(" "),_c('option',{attrs:{"value":"Connecticut"}},[_vm._v("Connecticut")]),_vm._v(" "),_c('option',{attrs:{"value":"Delaware"}},[_vm._v("Delaware")]),_vm._v(" "),_c('option',{attrs:{"value":"Florida"}},[_vm._v("Florida")]),_vm._v(" "),_c('option',{attrs:{"value":"Georgia"}},[_vm._v("Georgia")]),_vm._v(" "),_c('option',{attrs:{"value":"Hawaii"}},[_vm._v("Hawaii")]),_vm._v(" "),_c('option',{attrs:{"value":"Idaho"}},[_vm._v("Idaho")]),_vm._v(" "),_c('option',{attrs:{"value":"Illinois"}},[_vm._v("Illinois")]),_vm._v(" "),_c('option',{attrs:{"value":"Indiana"}},[_vm._v("Indiana")]),_vm._v(" "),_c('option',{attrs:{"value":"Iowa"}},[_vm._v("Iowa")]),_vm._v(" "),_c('option',{attrs:{"value":"Kansas"}},[_vm._v("Kansas")]),_vm._v(" "),_c('option',{attrs:{"value":"Kentucky"}},[_vm._v("Kentucky")]),_vm._v(" "),_c('option',{attrs:{"value":"Louisiana"}},[_vm._v("Louisiana")]),_vm._v(" "),_c('option',{attrs:{"value":"Maine"}},[_vm._v("Maine")]),_vm._v(" "),_c('option',{attrs:{"value":"Maryland"}},[_vm._v("Maryland")]),_vm._v(" "),_c('option',{attrs:{"value":"Massachusetts"}},[_vm._v("Massachusetts")]),_vm._v(" "),_c('option',{attrs:{"value":"Michigan"}},[_vm._v("Michigan")]),_vm._v(" "),_c('option',{attrs:{"value":"Minnesota"}},[_vm._v("Minnesota")]),_vm._v(" "),_c('option',{attrs:{"value":"Mississippi"}},[_vm._v("Mississippi")]),_vm._v(" "),_c('option',{attrs:{"value":"Missouri"}},[_vm._v("Missouri")]),_vm._v(" "),_c('option',{attrs:{"value":"Montana"}},[_vm._v("Montana")]),_vm._v(" "),_c('option',{attrs:{"value":"Nebraska"}},[_vm._v("Nebraska")]),_vm._v(" "),_c('option',{attrs:{"value":"Nevada"}},[_vm._v("Nevada")]),_vm._v(" "),_c('option',{attrs:{"value":"New Hampshire"}},[_vm._v("New Hampshire")]),_vm._v(" "),_c('option',{attrs:{"value":"New Jersey"}},[_vm._v("New Jersey")]),_vm._v(" "),_c('option',{attrs:{"value":"New Mexico"}},[_vm._v("New Mexico")]),_vm._v(" "),_c('option',{attrs:{"value":"New York"}},[_vm._v("New York")]),_vm._v(" "),_c('option',{attrs:{"value":"North Carolina"}},[_vm._v("North Carolina")]),_vm._v(" "),_c('option',{attrs:{"value":"North Dakota"}},[_vm._v("North Dakota")]),_vm._v(" "),_c('option',{attrs:{"value":"Ohio"}},[_vm._v("Ohio")]),_vm._v(" "),_c('option',{attrs:{"value":"Oklahoma"}},[_vm._v("Oklahoma")]),_vm._v(" "),_c('option',{attrs:{"value":"Oregon"}},[_vm._v("Oregon")]),_vm._v(" "),_c('option',{attrs:{"value":"Pennsylvania"}},[_vm._v("Pennsylvania")]),_vm._v(" "),_c('option',{attrs:{"value":"Rhode Island"}},[_vm._v("Rhode Island")]),_vm._v(" "),_c('option',{attrs:{"value":"South Carolina"}},[_vm._v("South Carolina")]),_vm._v(" "),_c('option',{attrs:{"value":"South Dakota"}},[_vm._v("South Dakota")]),_vm._v(" "),_c('option',{attrs:{"value":"Tennessee"}},[_vm._v("Tennessee")]),_vm._v(" "),_c('option',{attrs:{"value":"Texas"}},[_vm._v("Texas")]),_vm._v(" "),_c('option',{attrs:{"value":"Utah"}},[_vm._v("Utah")]),_vm._v(" "),_c('option',{attrs:{"value":"Vermont"}},[_vm._v("Vermont")]),_vm._v(" "),_c('option',{attrs:{"value":"Virginia"}},[_vm._v("Virginia")]),_vm._v(" "),_c('option',{attrs:{"value":"Washington"}},[_vm._v("Washington")]),_vm._v(" "),_c('option',{attrs:{"value":"West Virginia"}},[_vm._v("West Virginia")]),_vm._v(" "),_c('option',{attrs:{"value":"Wisconsin"}},[_vm._v("Wisconsin")]),_vm._v(" "),_c('option',{attrs:{"value":"Wyoming"}},[_vm._v("Wyoming")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"d-block",attrs:{"for":"email1"}},[_vm._v("\n                  Email Address (required)\n                  "),_c('p',{staticClass:"invalid-feedback"},[_vm._v("Please provide a valid email.")])]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"email","id":"email1","name":"email1","placeholder":"youremail@domain.com","required":"","aria-required":"true"}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please provide a valid email.")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"d-block",attrs:{"for":"phone"}},[_vm._v("Phone (optional)")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"phone","name":"phone"}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('fieldset',{staticClass:"col-md-12"},[_c('legend',{attrs:{"id":"legend01"}},[_vm._v("Choose at least one (required)")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('ul',{staticClass:"list-unstyled"},[_c('li',{staticClass:"pt-1"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck1","aria-describedby":"legend01"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck1"}},[_vm._v("I want someone to contact me about getting RQI for my institution")])])]),_vm._v(" "),_c('li',{staticClass:"pt-1"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck2","aria-describedby":"legend01"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck2"}},[_vm._v("I have questions about the RQI program")])])]),_vm._v(" "),_c('li',{staticClass:"pt-1"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck3","aria-describedby":"legend01"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck3"}},[_vm._v("I want to be contacted about webinars, events, and other new content related to RQI")])])])])])])]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("\n              By clicking the sign up button you agree to the\n              "),_c('a',{attrs:{"href":"http://www.heart.org/HEARTORG/HealthyLiving/Healthy-For-Good-Sign-Up_UCM_428192_Article.jsp"}},[_vm._v("Terms and Conditions")]),_vm._v(" and\n              "),_c('a',{attrs:{"href":"http://www.heart.org/privacy"}},[_vm._v("Privacy Policy")]),_vm._v(".\n            ")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-danger btn-round col-md-6",attrs:{"type":"submit"}},[_vm._v("Submit")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acc455e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_half_image_half_copy_promo_vue__ = __webpack_require__(1224);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acc455e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_half_image_half_copy_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/600x600/333333/666666?text=FPO'),expression:"'//placehold.it/600x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])])])]),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/600x600/666666/333333?text=FPO'),expression:"'//placehold.it/600x600/666666/333333?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h2',[_vm._v("Dark Gray / Centered Content / Image on Right")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h2',[_vm._v("White / Left Content / Image on Left")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h2',[_vm._v("Gray / Right Content / Image on Right")]),_vm._v(" "),_vm._m(5)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-promo c-promo--half"},[_c('div',{staticClass:"c-promo__content"},[_c('span',{staticClass:"c-promo__label c-label c-label--orange"},[_vm._v("Featured")]),_vm._v(" "),_c('h2',{staticClass:"h3"},[_vm._v("Veggie Migas")]),_vm._v(" "),_c('p',[_vm._v("A Tex-Mex dish, migas are corn tortilla strips gently fried and incorporated into scrambled eggs. This spin on the classic uses very little oil while also adding an array of veggies into the mix.")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--icon h-theme--yellow-orange-alt",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg"}}),_vm._v("View Recipe\n                        ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-promo c-promo--half c-promo--bg h-theme--black h-text-contrast"},[_c('div',{staticClass:"c-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Veggie Migas")]),_vm._v(" "),_c('p',[_vm._v("A Tex-Mex dish, migas are corn tortilla strips gently fried and incorporated into scrambled eggs. This spin on the classic uses very little oil while also adding an array of veggies into the mix.")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--icon h-theme--green-lime",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg"}}),_vm._v("View Recipe\n                        ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h2',[_vm._v("Full Width")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-section"},[_c('div',{staticClass:"l-promo l-promo--full-width"},[_c('div',{staticClass:"l-promo__col c-promo--last-md"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg h-placeholder-image--bg-sm"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"//placeimg.com/1200/600/arch","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-promo c-promo--half c-promo--bg h-theme--black h-text-contrast"},[_c('div',{staticClass:"row no-gutters w-100 justify-content-md-center"},[_c('div',{staticClass:"col-md-12 col-lg-8"},[_c('div',{staticClass:"c-promo__content"},[_c('div',{staticClass:"c-promo__content-label"},[_vm._v("\n                                        American Heart Association\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"c-promo__content-heading h2"},[_vm._v("\n                                        COVID-19 Vaccines and Getting Back to Life\n                                    ")]),_vm._v(" "),_c('p',{staticClass:"c-promo__content-subheading"},[_vm._v("\n                                        Every vaccination brings us closer to a future free of COVD-19. Based on the best science, vaccines are safe, effective and protect you, your loved ones and community.\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions--full-width"},[_c('div',{staticClass:"d-md-inline-flex c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Default\n                                        ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            NOT the same Width\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"d-md-flex c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Equal Width\n                                        ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Be Same Width\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"flex-column c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Stacked\n                                        ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Should be a column\n                                        ")])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"c-hero-card__action d-inline-flex flex-column"},[_c('a',{staticClass:"c-hero-card__cta c-cta c-cta--icon h-theme--white c-cta--arrow",attrs:{"href":"#first","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v(" First CTA Link Only Stack")]),_vm._v(" "),_c('a',{staticClass:"c-hero-card__cta c-cta c-cta--icon h-theme--white c-cta--arrow",attrs:{"href":"#Second","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v(" Second CTA Link No Side by Side")])])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-section"},[_c('div',{staticClass:"l-promo l-promo--full-width"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg h-placeholder-image--bg-sm"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"//placeimg.com/1200/600/arch","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col c-promo--last-sm c-promo--last-md"},[_c('div',{staticClass:"c-promo c-promo--half c-promo--bg h-theme--white h-text-contrast"},[_c('div',{staticClass:"row no-gutters w-100"},[_c('div',{staticClass:"col-md-12 col-lg-12"},[_c('div',{staticClass:"c-promo__content"},[_c('div',{staticClass:"c-promo__content-label"},[_vm._v("\n                                        American Heart Association\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"c-promo__content-heading h2 mb-4"},[_vm._v("\n                                        COVID-19 Vaccines and Getting Back to Life\n                                    ")]),_vm._v(" "),_c('p',{staticClass:"c-promo__content-subheading"},[_vm._v("\n                                        Every vaccination brings us closer to a future free of COVD-19. Based on the best science, vaccines are safe, effective and protect you, your loved ones and community.\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions--full-width"},[_c('div',{staticClass:"d-md-inline-flex c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Default\n                                        ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            NOT the same Width\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"d-md-flex c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Equal Width\n                                        ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Be Same Width\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"flex-column c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Stacked\n                                        ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Should be a column\n                                        ")])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"c-hero-card__action d-inline-flex flex-column"},[_c('a',{staticClass:"c-hero-card__cta c-cta c-cta--icon h-theme--white c-cta--arrow",attrs:{"href":"#first","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v(" First CTA Link Only Stack")]),_vm._v(" "),_c('a',{staticClass:"c-hero-card__cta c-cta c-cta--icon h-theme--white c-cta--arrow",attrs:{"href":"#Second","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v(" Second CTA Link No Side by Side")])])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-section"},[_c('div',{staticClass:"l-promo l-promo--full-width"},[_c('div',{staticClass:"l-promo__col c-promo--last-md"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg h-placeholder-image--bg-sm"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"//placeimg.com/1200/600/arch","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-promo c-promo--half c-promo--bg h-theme--gray h-text-contrast"},[_c('div',{staticClass:"row no-gutters w-100 justify-content-md-end"},[_c('div',{staticClass:"col-md-12 col-lg-12"},[_c('div',{staticClass:"c-promo__content"},[_c('div',{staticClass:"c-promo__content-label"},[_vm._v("\n                                        American Heart Association\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"c-promo__content-heading h2 mb-4"},[_vm._v("\n                                        COVID-19 Vaccines and Getting Back to Life\n                                    ")]),_vm._v(" "),_c('p',{staticClass:"c-promo__content-subheading"},[_vm._v("\n                                        Every vaccination brings us closer to a future free of COVD-19. Based on the best science, vaccines are safe, effective and protect you, your loved ones and community.\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions--full-width"},[_c('div',{staticClass:"d-md-inline-flex c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Default\n                                        ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            NOT the same Width\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"d-md-flex c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Equal Width\n                                        ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Be Same Width\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"flex-column c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Stacked\n                                        ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v("\n                                            Should be a column\n                                        ")])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"c-hero-card__action d-inline-flex flex-column"},[_c('a',{staticClass:"c-hero-card__cta c-cta c-cta--icon h-theme--white c-cta--arrow",attrs:{"href":"#first","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v(" First CTA Link Only Stack")]),_vm._v(" "),_c('a',{staticClass:"c-hero-card__cta c-cta c-cta--icon h-theme--white c-cta--arrow",attrs:{"href":"#Second","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v(" Second CTA Link No Side by Side")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68d540f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_one_column_content_width_promo_vue__ = __webpack_require__(1226);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68d540f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_one_column_content_width_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo c-promo--post-preview c-promo--bg-triangle c-promo--shadow"},[_c('div',{staticClass:"c-promo__content-container"},[_c('div',{staticClass:"c-promo__content"},[_c('span',{staticClass:"c-promo__meta"},[_c('strong',[_vm._v("Madison85")]),_vm._v(", October 12, 2017 11:56am EST\n            ")]),_vm._v(" "),_c('h2',{staticClass:"h3"},[_vm._v("Life After Stroke For My Mom")]),_vm._v(" "),_c('p',[_vm._v("I've been the primary care giver for my mother since her stroke in Feb 2014. I work full time and unfortunately, my mother is able to care for herself for the most part. However, she's no longer able to drive since having her stroke and is therefore…")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Read More")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ddabdad_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_event_promo_vue__ = __webpack_require__(1228);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ddabdad_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_event_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aha-listing-header'),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo c-promo--events"},[_c('div',{staticClass:"c-promo__content-container"},[_c('ul',{staticClass:"c-promo__events"},[_c('li',[_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Harvest Moon, Location: Barnes Park, Date: MON Feb 19, 2018")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Harvest Moon, Location: Barnes Park, Date: MON Feb 19, 2018")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Harvest Moon, Location: Barnes Park, Date: MON Feb 19, 2018")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Harvest Moon, Location: Barnes Park, Date: MON Feb 19, 2018")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0232d90d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_third_link_component_vue__ = __webpack_require__(1230);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0232d90d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_third_link_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-two-third-link"},[_c('h2',{staticClass:"h4"},[_vm._v("Types of Arrythmia")]),_vm._v(" "),_c('div',{staticClass:"c-two-third-link__content"},[_c('ul',{staticClass:"c-two-third-link--links"},[_c('li',[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Atrial Fibrillation")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Bradycardia")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Conduction Disorders")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Premature Contractions")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Tachycardia")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Ventricular Fibrillation")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Other Rhythm Disorders")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Types of Arrythmia in Children")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d38c541_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_card_vue__ = __webpack_require__(1232);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d38c541_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"c-hero-card h-theme--red"},[_c('div',{staticClass:"c-hero-card__container"},[_c('div',{directives:[{name:"vertical-align",rawName:"v-vertical-align"}],staticClass:"c-hero-card__content-container"},[_vm._m(0),_vm._v(" "),_c('h1',{staticClass:"c-hero-card__heading h1"},[_vm._v("Life is Why")]),_vm._v(" "),_c('p',{staticClass:"c-hero-card__subheading h4"},[_vm._v("Live a long and healthy life, The American Heart Association has your back.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId'),expression:"'uniqueModalId'"}],staticClass:"c-hero-card__media h-placeholder-image h-placeholder-image--43-20 h-video-play"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any'),expression:"'//placeimg.com/1200/600/any'"}],attrs:{"src":"assets/images/placeholder.gif","width":"1200","height":"600","alt":""}}),_vm._v(" "),_c('span',{staticClass:"h-mask-dark"})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId","video-id":"M7lc1UVf-VE"}})],1),_vm._v(" "),_c('h2',[_vm._v("New 2 Buttons")]),_vm._v(" "),_c('div',{staticClass:"c-hero-card h-theme--red"},[_c('div',{staticClass:"c-hero-card__container"},[_c('div',{directives:[{name:"vertical-align",rawName:"v-vertical-align"}],staticClass:"c-hero-card__content-container"},[_vm._m(5),_vm._v(" "),_c('h1',{staticClass:"c-hero-card__heading h1"},[_vm._v("Life is Why")]),_vm._v(" "),_c('p',{staticClass:"c-hero-card__subheading h4"},[_vm._v("Below are some test on btn. There are 3 options to select from: Default, Equal Width, and Stacked ")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div'),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('div'),_vm._v(" "),_vm._m(12)]),_vm._v(" "),_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId'),expression:"'uniqueModalId'"}],staticClass:"c-hero-card__media h-placeholder-image h-placeholder-image--43-20 h-video-play"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any'),expression:"'//placeimg.com/1200/600/any'"}],attrs:{"src":"assets/images/placeholder.gif","width":"1200","height":"600","alt":""}}),_vm._v(" "),_c('span',{staticClass:"h-mask-dark"})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId","video-id":"M7lc1UVf-VE"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"c-hero-card__kicker"},[_c('img',{staticClass:"c-hero-card__kicker-icon",attrs:{"src":"assets/aha_heart.svg","alt":""}}),_vm._v("American Heart Association\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-card__social"},[_c('a',{attrs:{"href":"//twitter.com"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"//facebook.com"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"//google.com"}},[_c('img',{attrs:{"src":"assets/share/google-plus.svg"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-card__action"},[_c('a',{staticClass:"btn btn-md btn-danger btn-round h-theme--red",attrs:{"href":"http://www.heart.org","title":"Go to Heart Home","target":"testCustom"}},[_vm._v(" Go to Heart Home")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-card__action"},[_c('a',{staticClass:"c-hero-card__cta c-cta c-cta--arrow c-cta--icon",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg","alt":""}}),_vm._v("Read the Video Transcript\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-card__action"},[_c('a',{staticClass:"c-hero-card__cta c-cta c-cta--icon h-theme--red c-cta--arrow",attrs:{"href":"https://sitecoretest.goredforwomen.org:443/en","title":"Go to GRFW Home"}},[_vm._v(" Go to GRFW Home")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"c-hero-card__kicker"},[_c('img',{staticClass:"c-hero-card__kicker-icon",attrs:{"src":"assets/aha_heart.svg","alt":""}}),_vm._v("American Heart Association\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-md-inline-flex c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","target":"DonateNow"}},[_vm._v("\n                        Default\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#","target":"DonateMonhtly"}},[_vm._v("\n                        NOT the same Width\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-md-flex c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","target":"DonateNow"}},[_vm._v("\n                        Equal Width\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#","target":"DonateMonhtly"}},[_vm._v("\n                        Be Same Width\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-column c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","target":"DonateNow"}},[_vm._v("\n                        Stacked\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#","target":"DonateMonhtly"}},[_vm._v("\n                        Should be a column\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-card__action"},[_c('a',{staticClass:"c-hero-card__cta c-cta c-cta--icon h-theme--red c-cta--arrow",attrs:{"href":"#first"}},[_vm._v(" First CTA Link Only Stack")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-card__action"},[_c('a',{staticClass:"c-hero-card__cta c-cta c-cta--icon h-theme--red c-cta--arrow",attrs:{"href":"#Second"}},[_vm._v(" Second CTA Link No Side by Side")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-md-inline-flex c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","target":"DonateNow"}},[_vm._v("\n                        Default\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-card__social clearfix"},[_c('a',{attrs:{"href":"//twitter.com"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"//facebook.com"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"//google.com"}},[_c('img',{attrs:{"src":"assets/share/google-plus.svg"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2caeb4bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_event_list_vue__ = __webpack_require__(1234);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2caeb4bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_event_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v("There are no upcoming events in your area at this time.  Please participate in a Virtual Heart Walk.")])])])]),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"c-event-list c-promo--shadow"},[_c('h2',{staticClass:"c-event-list__heading h-theme--red"},[_vm._v("2021 Denver Heart and Stroke Walk Digital Experience")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__location mb-0"},[_vm._v("Location: The Lawn at Reunion Tower")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__date"},[_vm._v("Date: Saturday, June 5, 2021")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-danger",attrs:{"href":"#","aria-label":"Register for 2021 Denver Heart and Stroke Walk Digital Experience"}},[_vm._v("Register")])])]),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"c-event-list c-promo--shadow"},[_c('h2',{staticClass:"c-event-list__heading"},[_vm._v("2021 Denver Heart and Stroke Walk Digital Experience")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__location mb-0"},[_vm._v("Location: The Lawn at Reunion Tower")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__date"},[_vm._v("Date: Saturday, June 5, 2021")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-danger",attrs:{"href":"#","aria-label":"Register for 2021 Denver Heart and Stroke Walk Digital Experience"}},[_vm._v("Register")])])]),_vm._v(" "),_c('div',{staticClass:"w-100 d-md-block"}),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"c-event-list c-promo--shadow"},[_c('h2',{staticClass:"c-event-list__heading"},[_vm._v("2021 Denver Heart and Stroke Walk Digital Experience")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__location mb-0"},[_vm._v("Location: The Lawn at Reunion Tower")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__date"},[_vm._v("Date: Saturday, June 5, 2021")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-danger",attrs:{"href":"#","aria-label":"Register for 2021 Denver Heart and Stroke Walk Digital Experience"}},[_vm._v("Register")])])]),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"c-event-list c-promo--shadow"},[_c('h2',{staticClass:"c-event-list__heading"},[_vm._v("2021 Denver Heart and Stroke Walk Digital Experience")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__location mb-0"},[_vm._v("Location: The Lawn at Reunion Tower")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__date"},[_vm._v("Date: Saturday, June 5, 2021")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-danger",attrs:{"href":"#","aria-label":"Register for 2021 Denver Heart and Stroke Walk Digital Experience"}},[_vm._v("Register")])])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"c-event-list"},[_c('h2',{staticClass:"c-event-list__heading"},[_vm._v("2021 Denver Heart and Stroke Walk Digital Experience")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__location mb-0"},[_vm._v("Location: The Lawn at Reunion Tower")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__date"},[_vm._v("Date: Saturday, June 5, 2021")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-danger",attrs:{"href":"#","aria-label":"Register for 2021 Denver Heart and Stroke Walk Digital Experience"}},[_vm._v("Register")])])]),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"c-event-list"},[_c('h2',{staticClass:"c-event-list__heading"},[_vm._v("2021 Denver Heart and Stroke Walk Digital Experience")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__location mb-0"},[_vm._v("Location: The Lawn at Reunion Tower")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__date"},[_vm._v("Date: Saturday, June 5, 2021")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-danger",attrs:{"href":"#","aria-label":"Register for 2021 Denver Heart and Stroke Walk Digital Experience"}},[_vm._v("Register")])])]),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"c-event-list"},[_c('h2',{staticClass:"c-event-list__heading"},[_vm._v("2021 Denver Heart and Stroke Walk Digital Experience")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__location mb-0"},[_vm._v("Location: The Lawn at Reunion Tower")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__date"},[_vm._v("Date: Saturday, June 5, 2021")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-danger",attrs:{"href":"#","aria-label":"Register for 2021 Denver Heart and Stroke Walk Digital Experience"}},[_vm._v("Register")])])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"c-event-list c-promo--shadow"},[_c('h2',{staticClass:"c-event-list__heading"},[_vm._v("2021 Denver Heart and Stroke Walk Digital Experience")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__location mb-0"},[_vm._v("Location: The Lawn at Reunion Tower")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__date"},[_vm._v("Date: Saturday, June 5, 2021")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-danger",attrs:{"href":"#","aria-label":"Register for 2021 Denver Heart and Stroke Walk Digital Experience"}},[_vm._v("Register")])])]),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"c-event-list"},[_c('h2',{staticClass:"c-event-list__heading"},[_vm._v("2021 Denver Heart and Stroke Walk Digital Experience")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__location mb-0"},[_vm._v("Location: The Lawn at Reunion Tower")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__date"},[_vm._v("Date: Saturday, June 5, 2021")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-danger",attrs:{"href":"#","aria-label":"Register for 2021 Denver Heart and Stroke Walk Digital Experience"}},[_vm._v("Register")])])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"c-event-list"},[_c('h2',{staticClass:"c-event-list__heading"},[_vm._v("2021 Denver Heart and Stroke Walk Digital Experience")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__location mb-0"},[_vm._v("Location: The Lawn at Reunion Tower")]),_vm._v(" "),_c('p',{staticClass:"c-event-list__subheading c-event-list__date"},[_vm._v("Date: Saturday, June 5, 2021")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-danger",attrs:{"href":"#","aria-label":"Register for 2021 Denver Heart and Stroke Walk Digital Experience"}},[_vm._v("Register")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06876254_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_full_width_vue__ = __webpack_require__(1236);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06876254_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_full_width_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"l-section"},[_c('div',{staticClass:"c-hero-full"},[_c('div',{staticClass:"c-hero-full__media h-placeholder-image h-placeholder-image--bg"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/1200x600?text=FPO'),expression:"'//placehold.it/1200x600?text=FPO'"}],attrs:{"src":"//placehold.it/1200x600?text=loading","alt":""}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"l-section"},[_c('div',{staticClass:"c-hero-full h-text-contrast h-theme--black"},[_c('div',{staticClass:"c-hero-full__media h-placeholder-image h-placeholder-image--bg"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any'),expression:"'//placeimg.com/1200/600/any'"}],attrs:{"src":"//placehold.it/1200x600?text=loading","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"c-hero-full__content-container container container-fluid"},[_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId'),expression:"'uniqueModalId'"}],staticClass:"c-hero-full__link h-video-play"},[_c('span',{staticClass:"sr-only"},[_vm._v("Link Text")])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId","video-id":"M7lc1UVf-VE"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"l-section"},[_c('div',{staticClass:"c-hero-full c-hero-full--no-label"},[_c('div',{staticClass:"c-hero-full__media h-placeholder-image h-placeholder-image--bg"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/1200x600?text=FPO'),expression:"'//placehold.it/1200x600?text=FPO'"}],attrs:{"src":"//placehold.it/1200x600?text=loading","alt":""}})]),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-full__content-container container container-fluid"},[_c('p',{staticClass:"c-hero-full__kicker"},[_c('img',{staticClass:"c-hero-card__kicker-icon",attrs:{"src":"assets/aha_heart.svg","alt":""}}),_vm._v("American Heart Association\n                ")]),_vm._v(" "),_c('div',{staticClass:"c-hero-full__content"},[_c('h2',{staticClass:"c-hero-full__heading h2"},[_vm._v("American heart Association presents")]),_vm._v(" "),_c('p',{staticClass:"c-hero-full__subheading"},[_vm._v("Join the #NashvilleAtHeart Conversation! "),_c('br'),_vm._v("Follow Us On:")]),_vm._v(" "),_c('div',{staticClass:"c-hero-full__social"},[_c('a',{attrs:{"href":"//twitter.com"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"//facebook.com"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"//google.com"}},[_c('img',{attrs:{"src":"assets/share/google-plus.svg"}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"c-hero-full__link",attrs:{"href":"#"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Link Text")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h2',[_vm._v("Design Refresh 2022")]),_vm._v(" "),_c('p',[_vm._v("\n                    Width content is 50% of the container per mockup. To center add class \"offset-3\" to col.\n                ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-section"},[_c('div',{staticClass:"c-hero-full h-text-contrast h-theme--black"},[_c('div',{staticClass:"c-hero-full__media h-placeholder-image h-placeholder-image--bg"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"//placeimg.com/1200/600/arch","loading":"lazy","alt":""}})]),_vm._v(" "),_c('span',{staticClass:"h-mask-dark"}),_vm._v(" "),_c('div',{staticClass:"c-hero-full__content-container container container-fluid"},[_c('div',{staticClass:"row no-gutters w-100"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"c-hero-full__logo"},[_c('img',{staticClass:"c-hero-full__logo-icon",attrs:{"src":"assets/aha_heart.svg","alt":""}}),_vm._v("American Heart Association\n                        ")]),_vm._v(" "),_c('div',{staticClass:"c-hero-full__content"},[_c('div',{staticClass:"c-hero-full__heading h2"},[_vm._v("COVID-19 Vaccines and Getting Back to Life")])]),_vm._v(" "),_c('div',{staticClass:"c-hero-card__action d-inline-flex flex-column"},[_c('a',{staticClass:"c-hero-card__cta c-cta c-cta--icon h-theme--white c-cta--arrow",attrs:{"href":"#first","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v(" First CTA Link Only Stack")]),_vm._v(" "),_c('a',{staticClass:"c-hero-card__cta c-cta c-cta--icon h-theme--white c-cta--arrow",attrs:{"href":"#Second","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}"}},[_vm._v(" Second CTA Link No Side by Side")])]),_vm._v(" "),_c('div',{staticClass:"p-2"}),_vm._v(" "),_c('div',{staticClass:"d-md-flex c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#"}},[_vm._v("\n                        DONATE ONCE\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#"}},[_vm._v("\n                        DONATE MONTHLY\n                    ")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-section"},[_c('div',{staticClass:"c-hero-full h-text-contrast h-theme--black"},[_c('div',{staticClass:"c-hero-full__media h-placeholder-image h-placeholder-image--bg"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"//placeimg.com/1200/600/arch","loading":"lazy","alt":""}})]),_vm._v(" "),_c('span',{staticClass:"h-mask-dark"}),_vm._v(" "),_c('div',{staticClass:"c-hero-full__content-container container container-fluid"},[_c('div',{staticClass:"row no-gutters w-100"},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"c-hero-full__logo"},[_c('img',{staticClass:"c-hero-full__logo-icon",attrs:{"src":"assets/aha_heart.svg","alt":""}}),_vm._v("American Heart Association\n                    \n                ")]),_vm._v(" "),_c('div',{staticClass:"c-hero-full__content"},[_c('div',{staticClass:"c-hero-full__heading h2"},[_vm._v("\n                        COVID-19 Vaccines and Getting Back to Life\n                    ")]),_vm._v(" "),_c('p',{staticClass:"c-hero-full__subheading"},[_vm._v("\n                        Every vaccination brings us closer to a future free of COVD-19. Based on the best science, vaccines are safe, effective and protect you, your loved ones and community.\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"d-md-inline-flex c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","target":"DonateNow"}},[_vm._v("\n                        Default\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#","target":"DonateMonhtly"}},[_vm._v("\n                        NOT the same Width\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"flex-column c-hero-card__btn-side-by-side"},[_c('a',{staticClass:"btn btn-round btn-primary col",attrs:{"href":"#","target":"DonateNow"}},[_vm._v("\n                        Stacked\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-outline-primary col",attrs:{"href":"#","target":"DonateMonhtly"}},[_vm._v("\n                        Should be a column\n                    ")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-full__kicker"},[_c('img',{staticClass:"c-hero-card__kicker-icon",attrs:{"src":"assets/aha_heart.svg","alt":""}}),_vm._v("American Heart Association")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-full__content"},[_c('h2',{staticClass:"c-hero-full__heading h2"},[_vm._v("American heart Association presents")]),_vm._v(" "),_c('p',{staticClass:"c-hero-full__subheading"},[_vm._v("Join the #NashvilleAtHeart Conversation! "),_c('br'),_vm._v("Follow Us On:")]),_vm._v(" "),_c('div',{staticClass:"c-hero-full__social"},[_c('a',{attrs:{"href":"//twitter.com"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"//facebook.com"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"//google.com"}},[_c('img',{attrs:{"src":"assets/share/google-plus.svg"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-full__content-container container container-fluid"},[_c('div',{staticClass:"c-hero-full__content"},[_c('h2',{staticClass:"c-hero-full__heading h2"},[_vm._v("American heart Association presents")]),_vm._v(" "),_c('p',{staticClass:"c-hero-full__subheading"},[_vm._v("Join the #NashvilleAtHeart Conversation! "),_c('br'),_vm._v("Follow Us On:")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-section"},[_c('div',{staticClass:"c-hero-full c-hero-full--no-label c-hero-full--scaled h-text-contrast h-theme--yellow-orange c-promo--bg"},[_c('div',{staticClass:"c-hero-full__content-container container container-fluid"},[_c('div',{staticClass:"c-hero-full__content"},[_c('h2',{staticClass:"c-hero-full__heading h2"},[_vm._v("American heart Association presents")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-section"},[_c('div',{staticClass:"c-hero-full c-hero-full--scaled h-text-contrast h-theme--gray-dark c-promo--bg"},[_c('div',{staticClass:"c-hero-full__content-container container container-fluid"},[_c('div',{staticClass:"c-hero-full__kicker"},[_c('img',{staticClass:"c-hero-card__kicker-icon",attrs:{"src":"assets/aha_heart.svg","alt":""}}),_vm._v("American Heart Association")]),_vm._v(" "),_c('div',{staticClass:"c-hero-full__content"},[_c('h2',{staticClass:"c-hero-full__heading h2"},[_vm._v("American heart Association presents")]),_vm._v(" "),_c('p',{staticClass:"c-hero-full__subheading"},[_vm._v("Join the #NashvilleAtHeart Conversation! "),_c('br'),_vm._v("Follow Us On:")]),_vm._v(" "),_c('div',{staticClass:"c-hero-full__social"},[_c('a',{attrs:{"href":"//twitter.com"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"//facebook.com"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"//google.com"}},[_c('img',{attrs:{"src":"assets/share/google-plus.svg"}})])])]),_vm._v(" "),_c('a',{staticClass:"c-hero-full__link",attrs:{"href":"#"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Link Text")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a598b6fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_full_width_video_image_vue__ = __webpack_require__(1238);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a598b6fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_full_width_video_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"l-section"},[_c('div',{staticClass:"c-hero-full"},[_c('a',{staticClass:"c-hero-full__media h-placeholder-image h-placeholder-image--bg",attrs:{"href":"#"}},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/1200x600?text=FPO'),expression:"'//placehold.it/1200x600?text=FPO'"}],attrs:{"src":"//placehold.it/1200x600?text=loading","alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"l-section"},[_c('div',{staticClass:"c-hero-full"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId2'),expression:"'uniqueModalId2'"}],staticClass:"c-hero-full__media h-placeholder-image h-placeholder-image--bg h-video-play"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/1200x600?text=FPO'),expression:"'//placehold.it/1200x600?text=FPO'"}],attrs:{"src":"//placehold.it/1200x600?text=loading","alt":""}})]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId2","video-id":"M7lc1UVf-VE"}})],1)]),_vm._v(" "),_c('div',{staticClass:"l-section"},[_c('div',{staticClass:"c-hero-full"},[_c('button',{directives:[{name:"youtube-modal",rawName:"v-youtube-modal:queue",value:('uniqueModalId'),expression:"'uniqueModalId'",arg:"queue"}],staticClass:"c-hero-full__media h-placeholder-image h-placeholder-image--bg h-video-play"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/1200x600?text=FPO'),expression:"'//placehold.it/1200x600?text=FPO'"}],attrs:{"src":"//placehold.it/1200x600?text=loading","alt":""}})]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId","video-id":"M7lc1UVf-VE"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71ddee54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_event_promo_vue__ = __webpack_require__(1240);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71ddee54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_event_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-full-width-event"},[_c('div',{staticClass:"container container-fluid"},[_c('aha-listing-header'),_vm._v(" "),_vm._m(0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo c-promo--events c-promo--shadow"},[_c('div',{staticClass:"c-promo__content-container"},[_c('ul',{staticClass:"c-promo__events"},[_c('li',[_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Harvest Moon, Location: Barnes Park, Date: MON Feb 19, 2018")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Harvest Moon, Location: Barnes Park, Date: MON Feb 19, 2018")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Harvest Moon, Location: Barnes Park, Date: MON Feb 19, 2018")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Harvest Moon, Location: Barnes Park, Date: MON Feb 19, 2018")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_613d6895_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tv_pages_vue__ = __webpack_require__(1242);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_613d6895_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tv_pages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"c-hero-card h-theme--red"},[_c('div',{staticClass:"c-hero-card__container"},[_c('div',{directives:[{name:"vertical-align",rawName:"v-vertical-align"}],staticClass:"c-hero-card__content-container"},[_vm._m(0),_vm._v(" "),_c('h1',{staticClass:"c-hero-card__heading h1"},[_vm._v("TV PAGES")]),_vm._v(" "),_c('p',{staticClass:"c-hero-card__subheading h4"},[_vm._v("I'm a really good description of this video or something. Please buy something idk.")]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"c-hero-card__media c-hero-card__media--tv"},[_c('div',{staticClass:"c-hero-card__media-bg h-placeholder-image h-placeholder-image--16-9"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any'),expression:"'//placeimg.com/1200/600/any'"}],attrs:{"src":"assets/images/placeholder.gif","width":"1200","height":"600","alt":""}})]),_vm._v(" "),_c('aha-tv-page-modal',{attrs:{"video-name":"home-page-hero","login-id":"1758930","channel-id":"87698931","api-base":"//api.tvpage.com/v1","script-src":"https://s56361-aha-ada-implementation--tvpwidgets-heart-org.netlify.com/tvpwidget/home-page-hero/index.js"}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"c-hero-card__kicker"},[_c('img',{staticClass:"c-hero-card__kicker-icon",attrs:{"src":"assets/aha_heart.svg","alt":""}}),_vm._v("American Heart Association\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-card__action"},[_c('a',{staticClass:"c-hero-card__cta c-cta c-cta--arrow c-cta--icon",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg","alt":""}}),_vm._v("Read the Video Transcript\n                    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd3c4462_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nutritional_facts_vue__ = __webpack_require__(1244);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd3c4462_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nutritional_facts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-quick-nutrition"},[_c('h2',{staticClass:"sr-only"},[_vm._v("Nutrition Facts")]),_vm._v(" "),_c('p',{staticClass:"c-quick-nutrition__heading h4"},[_vm._v("Summer Veggie Pizza With Cauliflower Crust")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"c-quick-nutrition__cta"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('nutrition-facts'),expression:"'nutrition-facts'"}],staticClass:"c-cta h-theme--green"},[_vm._v("View Full Nutritional Info")])]),_vm._v(" "),_c('aha-modal',{staticClass:"nutrition-facts__modal",attrs:{"id":"nutrition-facts","hide-footer":"","centered":""}},[_c('template',{staticClass:"nutrition-facts__header",slot:"modal-header"},[_c('h2',{staticClass:"nutrition-facts__heading"},[_vm._v("Nutrition Facts")])]),_vm._v(" "),_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'nutrition-facts', $event.target)}}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticClass:"nutrition-facts"},[_c('table',{staticClass:"nutrition-facts__table"},[_c('tbody',[_c('tr',[_c('th',{staticClass:"nutrition-facts__category",attrs:{"colspan":"2"}},[_vm._v("Calories")]),_vm._v(" "),_c('td',[_vm._v("218")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"nutrition-facts__category",attrs:{"colspan":"2"}},[_vm._v("Total Fat")]),_vm._v(" "),_c('td',[_vm._v("12.0 g")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"blank-cell"}),_vm._v(" "),_c('th',[_vm._v("Saturated Fat")]),_vm._v(" "),_c('td',[_vm._v("2.0 g")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"blank-cell"}),_vm._v(" "),_c('th',[_vm._v("Trans Fat")]),_vm._v(" "),_c('td',[_vm._v("0.0 g")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"blank-cell"}),_vm._v(" "),_c('th',[_vm._v("Polyunsaturated Fat")]),_vm._v(" "),_c('td',[_vm._v("1.5 g")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"blank-cell"}),_vm._v(" "),_c('th',[_vm._v("Monounsaturated Fat")]),_vm._v(" "),_c('td',[_vm._v("8.0 g")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"nutrition-facts__category",attrs:{"colspan":"2"}},[_vm._v("Cholesterol")]),_vm._v(" "),_c('td',[_vm._v("0 mg")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"nutrition-facts__category",attrs:{"colspan":"2"}},[_vm._v("Sodium")]),_vm._v(" "),_c('td',[_vm._v("154 mg")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"nutrition-facts__category",attrs:{"colspan":"2"}},[_vm._v("Total Carbohydrate")]),_vm._v(" "),_c('td',[_vm._v("25 g")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"blank-cell"}),_vm._v(" "),_c('th',[_vm._v("Dietary Fiber")]),_vm._v(" "),_c('td',[_vm._v("8 g")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"blank-cell"}),_vm._v(" "),_c('th',[_vm._v("Sugars")]),_vm._v(" "),_c('td',[_vm._v("8 g")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"nutrition-facts__category",attrs:{"colspan":"2"}},[_vm._v("Protein")]),_vm._v(" "),_c('td',[_vm._v("6 g")])])])])]),_vm._v(" "),_c('p',{staticClass:"nutrition-facts__exchange"},[_c('strong',[_vm._v("Dietary Exchanges")]),_c('br'),_vm._v("\n            1 starch, 1/2 fruit, 1 vegetable, 2 fat\n        ")])],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-quick-nutrition__content"},[_c('div',{staticClass:"c-quick-nutrition__col"},[_c('p',{staticClass:"c-quick-nutrition__category h4"},[_c('img',{attrs:{"src":"assets/glyphs/graph.svg","alt":""}}),_vm._v("Calories")]),_vm._v(" "),_c('span',{staticClass:"c-quick-nutrition__value h4"},[_vm._v("190 Per Serving")])]),_vm._v(" "),_c('div',{staticClass:"c-quick-nutrition__col"},[_c('p',{staticClass:"c-quick-nutrition__category h4"},[_c('img',{attrs:{"src":"assets/glyphs/strong.svg","alt":""}}),_vm._v("Protein")]),_vm._v(" "),_c('span',{staticClass:"c-quick-nutrition__value h4"},[_vm._v("15g Per Serving")])]),_vm._v(" "),_c('div',{staticClass:"c-quick-nutrition__col"},[_c('p',{staticClass:"c-quick-nutrition__category h4"},[_c('img',{attrs:{"src":"assets/glyphs/leaf.svg","alt":""}}),_vm._v("Fiber")]),_vm._v(" "),_c('span',{staticClass:"c-quick-nutrition__value h4"},[_vm._v("17g Per Serving")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87dac02c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_instructions_vue__ = __webpack_require__(1246);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87dac02c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_instructions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"c-recipe-instructions"},[_c('h2',{staticClass:"c-recipe-instructions__heading h3"},[_vm._v("Ingredients")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"c-recipe-instructions__section"},[_c('h3',{staticClass:"c-recipe-instructions__subheading h4"},[_vm._v("For The Cauliflower Crust:")]),_vm._v(" "),_c('ul',{staticClass:"c-recipe-instructions__list"},[_c('li',{staticClass:"c-recipe-instructions__list-item"},[_c('aha-recipe-checkbox',{staticClass:"c-recipe-instructions__item",attrs:{"check-class":"c-recipe-instructions__check"}},[_vm._v("\n                        1 large head "),_c('strong',[_vm._v("cauliflower")]),_vm._v(" (roughly chopped)\n                    ")])],1),_vm._v(" "),_c('li',{staticClass:"c-recipe-instructions__list-item"},[_c('aha-recipe-checkbox',{staticClass:"c-recipe-instructions__item",attrs:{"check-class":"c-recipe-instructions__check"}},[_vm._v("\n                        4 egg whites\n                    ")])],1),_vm._v(" "),_c('li',{staticClass:"c-recipe-instructions__list-item"},[_c('aha-recipe-checkbox',{staticClass:"c-recipe-instructions__item",attrs:{"check-class":"c-recipe-instructions__check"}},[_vm._v("\n                        1/4 cup shredded, fat-free "),_c('strong',[_vm._v("mozzarella cheese")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"c-recipe-instructions__section"},[_c('h3',{staticClass:"c-recipe-instructions__subheading h4"},[_vm._v("For The Sauce And Toppings:")]),_vm._v(" "),_c('ul',{staticClass:"c-recipe-instructions__list"},[_c('li',{staticClass:"c-recipe-instructions__list-item"},[_c('aha-recipe-checkbox',{staticClass:"c-recipe-instructions__item",attrs:{"check-class":"c-recipe-instructions__check"}},[_vm._v("\n                        1/2 cup canned, no-salt-added "),_c('strong',[_vm._v("tomato puree")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"c-recipe-instructions"},[_c('h2',{staticClass:"c-recipe-instructions__heading h3"},[_vm._v("Directions")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"c-recipe-instructions__section"},[_c('h3',{staticClass:"c-recipe-instructions__subheading h4"},[_vm._v("For The Cauliflower Crust:")]),_vm._v(" "),_c('ol',{staticClass:"c-recipe-instructions__list"},[_c('li',{staticClass:"c-recipe-instructions__list-item c-recipe-instructions__list-item--directions"},[_c('aha-recipe-checkbox',{staticClass:"c-recipe-instructions__item",attrs:{"check-class":"c-recipe-instructions__check"}},[_vm._v("\n                        Preheat the oven to 450°F. Line 2 baking sheets with parchment paper and coat them with cooking spray.\n                    ")])],1),_vm._v(" "),_c('li',{staticClass:"c-recipe-instructions__list-item c-recipe-instructions__list-item--directions"},[_c('aha-recipe-checkbox',{staticClass:"c-recipe-instructions__item",attrs:{"check-class":"c-recipe-instructions__check"}},[_vm._v("\n                        Trim and discard the leaves from the cauliflower. Roughly chop the cauliflower florets. Add to the bowl of a food processor in batches, pulsing until the mixture resembles couscous. (The key to getting the correct consistency is to not overload the food processor.) Measure out 4 cups of the caulifflower and transfer to a medium bowl. (See tip for ways to use the extra cauliflower.) Into the bowl, add egg whites, mozzarella cheese, Parmesan, garlic powder, and black ppepper. Stir to combine.\n                    ")])],1),_vm._v(" "),_c('li',{staticClass:"c-recipe-instructions__list-item c-recipe-instructions__list-item--directions"},[_c('aha-recipe-checkbox',{staticClass:"c-recipe-instructions__item",attrs:{"check-class":"c-recipe-instructions__check"}},[_vm._v("\n                        Divide the cauliflower mixture over the 2 prepared baking sheets—aim for each \"pizza\" to be a 7- to 8-inch oval or cicle, using a knife or spatula to spread the mixture into the pizza.\n                    ")])],1),_vm._v(" "),_c('li',{staticClass:"c-recipe-instructions__list-item c-recipe-instructions__list-item--directions"},[_c('aha-recipe-checkbox',{staticClass:"c-recipe-instructions__item",attrs:{"check-class":"c-recipe-instructions__check"}},[_vm._v("\n                        Bake cauliflower crusts in the oven until edges are totally golden, around 30 minutes. Remove from oven.\n                    ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"c-recipe__copyright"},[_vm._v("Recipe copyright © American Heart Association. This recipe is brought to you by the American Heart Association's Simple Cooking with Heart ® Program. For more simple, quick and affordable recipes, visit heart.org/simplecooking.")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"c-recipe-instructions__meta"},[_c('img',{attrs:{"src":"assets/glyphs/plate.svg"}}),_vm._v("4 Servings\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"c-recipe-instructions__meta"},[_c('img',{attrs:{"src":"assets/glyphs/cursor.svg"}}),_vm._v("Tip: Click on step to mark as complete.\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299b23b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_tips_vue__ = __webpack_require__(1248);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299b23b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_tips_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-quick-tips"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse1",modifiers:{"collapse1":true}}],staticClass:"c-quick-tips__trigger"},[_c('h2',{staticClass:"c-quick-tips__heading h4"},[_vm._v("Quick Tips")])]),_vm._v(" "),_c('b-collapse',{staticClass:"c-quick-tips__content",attrs:{"visible":"","id":"collapse1"}},[_c('div',{staticClass:"c-quick-tips__content-container"},[_c('p',[_c('strong',[_vm._v("Cooking Tip")]),_vm._v(": For a whole-wheat pizza, use 1(20-ounce) whole wheat pizza dough ball. Preheat oven to 500°F. Stretch the dough to fit a greased large baking sheet and cooked until golden brown, about 15 minutes. Cover with toppings, again cooking in the oven briefly until cheese melts.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Keep it Healthy")]),_vm._v(": Another way to get a healthy pizza dinner on the table even quicker than with the cauliflower crust is to use whole-wheat pita bread. Place pitas onto a foiled and greased baking sheet, topping with the tomato sauce—use more tomato sauce than with the cauliflower pizza, around 3/4 cup to 1 cup—pile high with cooked vegetables and cheese. Bake in a 425°F oven until pita is crispy, about 15 to 20 minutes.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Tip")]),_vm._v(": Use any remaining cauliflower puree to toss in with a grain for a future night's dinner or to sprinkle into salads.")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a56da6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_social_vue__ = __webpack_require__(1250);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a56da6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_social_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-share-gigya',[[_c('aha-recipe-social',{attrs:{"write-review-label":"Rate This Recipe","ratings-category-id":"Recipe","ratings-stream-id":"2163","comments-category-id":"Recipe","comments-stream-id":"2074","comments-stream-tags":"globalRecipe, 1002/4021, 1003/4031, 1004/4033, 1002/4023, 1001/4017, 1001/4018, 1002/4025, 1002/4024, 1002/4028, 1000/4011"}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_284e820c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_speed_bump_vue__ = __webpack_require__(1252);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_284e820c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_speed_bump_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"speed-bump"}},[_c('a',{directives:[{name:"speed-bump",rawName:"v-speed-bump",value:('speed-bump-modal'),expression:"'speed-bump-modal'"}],staticStyle:{"display":"none"},attrs:{"href":"","id":"speed-bump-link"}}),_vm._v(" "),_c('aha-modal',{staticClass:"c-speed-bump__modal text-center",attrs:{"id":"speed-bump-modal","hide-footer":"","centered":""}},[_c('template',{slot:"modal-header"},[_c('h2',{staticClass:"sr-only"},[_vm._v("Speed Bump")])]),_vm._v(" "),_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'speed-bump-modal')}}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticClass:"c-speed-bump__media"},[_c('img',{attrs:{"src":"//placehold.it/300x100","alt":""}})]),_vm._v(" "),_c('p',[_vm._v("The link provided below is for convenience only, and is not an endorsement of either the linked-to entity or any product or service.")]),_vm._v(" "),_c('p',[_c('span',{ref:"speed-bump-text",staticClass:"c-speed-bump__link"})]),_vm._v(" "),_c('a',{ref:"speed-bump-link",staticClass:"btn btn-danger btn-round",attrs:{"target":"_blank"}},[_vm._v("Proceed")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5391b0c9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sso_interceptor_vue__ = __webpack_require__(1254);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5391b0c9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sso_interceptor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sso-intercept"}},[_c('a',{directives:[{name:"sso-intercept",rawName:"v-sso-intercept",value:('sso-intercept-modal'),expression:"'sso-intercept-modal'"}],staticStyle:{"display":"none"},attrs:{"href":"","id":"sso-intercept-link"}}),_vm._v(" "),_c('aha-modal',{staticClass:"c-speed-bump__modal c-speed-bump--title",attrs:{"id":"sso-intercept-modal","hide-footer":"","centered":""}},[_c('template',{slot:"modal-header"},[_c('h2',{staticClass:"sr-only"},[_vm._v("Please Upgrade Your Browser")])]),_vm._v(" "),_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'sso-intercept-modal', $event.target)}}},[_vm._v("×")]),_vm._v(" "),_c('p',[_vm._v("Effective "),_c('strong',[_vm._v("June 1, 2018")]),_vm._v(" the Payment Card Industry is requiring web servers to support TLS 1.2 or higher encryption protocol as a security enhancement. If your browser is not current, you will be unable to access our secure web sites beginning June 1, 2018. Please "),_c('a',{attrs:{"href":"#"}},[_vm._v("Upgrade your browser now")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("*Note: Many of our 3rd party partners have updated, or are updating, their systems prior to June 1, 2018. If you are using an older browser version, you may experience issues when accessing specific functionality on our website.")]),_vm._v(" "),_c('p',[_vm._v("For more information, access our "),_c('a',{attrs:{"href":"#"}},[_vm._v("browser upgrade help resource")]),_vm._v(".")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68aca6a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_student_code_vue__ = __webpack_require__(1256);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68aca6a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_student_code_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-inline-search l-section"},[_c('form',{attrs:{"action":"/aha-service/StudentCode/Validate","method":"post","role":"form"}},[_c('input',{attrs:{"id":"scController","name":"scController","type":"hidden","value":"StudenCode"}}),_vm._v(" "),_c('input',{attrs:{"id":"scAction","name":"scAction","type":"hidden","value":"Validate"}}),_vm._v(" "),_c('div',{staticClass:"c-inline-search__form"},[_c('div',{staticClass:"c-inline-search__search form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label-lg",attrs:{"for":"AccessCode"}},[_vm._v("Enter Code")]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('input',{staticClass:"c-inline-search__input form-control form-control-lg student-code__input",attrs:{"id":"AccessCode","name":"AccessCode","type":"text"}})]),_vm._v(" "),_c('div',{staticClass:"c-inline-search__submit-wrap"},[_c('input',{staticClass:"c-inline-search__submit btn btn-lg btn-danger btn-round student-code__btn",attrs:{"type":"submit","value":"Submit","disabled":""}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8116cec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_student_code_invalid_vue__ = __webpack_require__(1258);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8116cec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_student_code_invalid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-inline-search l-section"},[_c('form',{attrs:{"action":"/aha-service/StudentCode/Validate","method":"post","role":"form"}},[_c('input',{attrs:{"id":"scController","name":"scController","type":"hidden","value":"StudentCode"}}),_vm._v(" "),_c('input',{attrs:{"id":"scAction","name":"scAction","type":"hidden","value":"Validate"}}),_vm._v(" "),_c('div',{staticClass:"c-inline-search__form"},[_c('div',{staticClass:"c-inline-search__search form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label-lg",attrs:{"for":"AccessCode"}},[_vm._v("Enter Code")]),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('input',{staticClass:"c-inline-search__input form-control form-control-lg student-code__input is-invalid",attrs:{"id":"AccessCode","name":"AccessCode","type":"text","aria-invalid":"true","aria-describedby":"AccessCodeError"}}),_vm._v(" "),_c('div',{staticClass:"input-group is-invalid",attrs:{"role":"alert"}},[_c('div',{staticClass:"invalid-feedback"},[_c('p',{attrs:{"id":"AccessCodeError"}},[_vm._v("The code you have entered is invalid")])]),_vm._v("​\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"c-inline-search__submit-wrap"},[_c('input',{staticClass:"c-inline-search__submit btn btn-lg btn-danger btn-round student-code__btn",attrs:{"type":"submit","value":"Submit","disabled":""}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d1a508_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_journey_vue__ = __webpack_require__(1260);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d1a508_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_journey_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-transition-group',{staticClass:"c-hero-card-snackable"},[_c('div',{staticClass:"c-hero-card-snackable__container"},[_c('div',{staticClass:"c-hero-card-snackable__content",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"c-daily-journey"},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Daily Journey")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate. ")])]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                        Next\n                    ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('div',{staticClass:"c-daily-journey"},[_c('div',[_vm._v("December 15, 2017")]),_vm._v(" "),_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Walking")]),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Come see us again when you've walked "),_c('strong',[_vm._v("5,000")]),_vm._v(" steps.")])]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","event-item-id":"12345","event-text":"eventText"}},[_vm._v("\n                        I Accept The Challenge\n                    ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"c-daily-journey"},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("I accepted the 5,000 Step Challenge!")]),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Share Your Daily Journey")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share"},[_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('img',{attrs:{"src":"assets/share/mail.svg"}})])])])])],1),_vm._v(" "),_c('div',{staticClass:"c-hero-card-snackable__media"},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"c-hero-card-snackable__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?1'),expression:"'//placeimg.com/1200/600/any?1'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('div',{staticClass:"c-hero-card-snackable__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?2'),expression:"'//placeimg.com/1200/600/any?2'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"c-hero-card-snackable__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?3'),expression:"'//placeimg.com/1200/600/any?3'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b48fbdc8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_yes_no_question_vue__ = __webpack_require__(1262);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b48fbdc8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_yes_no_question_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-transition-group',{staticClass:"c-yes-no-question"},[_c('div',{staticClass:"c-yes-no-question__container container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-lg-6"},[_c('div',{staticClass:"c-yes-no-question__media h-placeholder-image h-placeholder-image--1-1 h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any'),expression:"'//placeimg.com/1200/600/any'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-lg-6 d-flex",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-yes-no-question__content",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-yes-no-question__heading h3"},[_vm._v("Did Your Mother Or Grandmother Have Heart Disease?")]),_vm._v(" "),_c('div',{staticClass:"c-yes-no-question__actions"},[_c('aha-transition-trigger',{staticClass:"c-yes-no-question__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","step-index":"2"}},[_vm._v("Yes")]),_vm._v(" "),_c('aha-transition-trigger',{staticClass:"c-yes-no-question__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","step-index":"3"}},[_vm._v("No")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-yes-no-question__content",attrs:{"step-key":2}},[_c('h2',{staticClass:"c-yes-no-question__heading h3"},[_vm._v("Family History")]),_vm._v(" "),_c('p',[_vm._v("Your family history provides a picture of the environment and genetics in place when these diseases occurred. \"You can't counteract your generics,\" Dr. Kraus said, and so if you have a history you must do what you can to change your environment.")]),_vm._v(" "),_c('p',[_vm._v("Check out these articles to see how you can be proactive!")]),_vm._v(" "),_c('div',{staticClass:"c-yes-no-question__actions"},[_c('a',{staticClass:"c-yes-no-question__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Heart Disease And Family")]),_vm._v(" "),_c('a',{staticClass:"c-yes-no-question__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Healthy Meals For Heart Disease")]),_vm._v(" "),_c('a',{staticClass:"c-yes-no-question__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Latest News On Heart Disease")])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-yes-no-question__content",attrs:{"step-key":3}},[_c('h2',{staticClass:"c-yes-no-question__heading h3"},[_vm._v("No Answer")]),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("The text if the user answers \"No\"")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa55c3a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_single_field_prompt_vue__ = __webpack_require__(1264);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa55c3a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_single_field_prompt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aha-transition-group',{staticClass:"c-hero-card-snackable"},[_c('div',{staticClass:"c-hero-card-snackable__container"},[_c('div',{staticClass:"c-hero-card-snackable__content",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-single-field-prompt__heading h3"},[_vm._v("What's your resting heart rate")]),_vm._v(" "),_c('aha-single-field-prompt-form',{attrs:{"translations":{ label: 'Enter Your Resting Heart Rate', placeholder: 'ex: 78 bpm', submit: 'Submit', validation: 'Please enter a valid resting heart rate' },"config":{ targetValue: [50, 80], currentKey: 1, lessKey: 2, targetKey: 3, greaterKey: 4, minValue: 40, maxValue: 100 },"goals":"{'name':'content promo image event name','data':'content promo image event data','text':'content promo image event text',  'goalId':'{E020A002-55A2-4495-9D06-EF6B0B1F2E71}'}","event-text":"test","event-item-id":"12345"}})],1),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":3}},[_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--green"},[_c('aha-transition-input-value'),_vm._v(" bpm")],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Looking Good")]),_vm._v(" "),_c('p',[_vm._v("Here are some local events to keep you healthy and active!")]),_vm._v(" "),_c('div',{staticClass:"c-single-field-prompt__actions"},[_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Heart Disease And Family")]),_vm._v(" "),_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Healthy Meals For Heart Disease")]),_vm._v(" "),_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Latest News On Heart Disease")])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":2}},[_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--orange"},[_c('aha-transition-input-value'),_vm._v(" bpm")],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Too Low")])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":4}},[_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--red"},[_c('aha-transition-input-value'),_vm._v(" bpm")],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Too High")])])],1),_vm._v(" "),_c('div',{staticClass:"c-hero-card-snackable__media h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any'),expression:"'//placeimg.com/1200/600/any'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])])]),_vm._v(" "),_c('aha-transition-group',{staticClass:"c-hero-card-snackable"},[_c('div',{staticClass:"c-hero-card-snackable__container"},[_c('div',{staticClass:"c-hero-card-snackable__content",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":1}},[_c('aha-single-field-prompt-radio-form',{attrs:{"translations":{ title:'What\'s your resting heart rate?', label: '', submit: 'Submit', validation: 'Please select a value' },"config":{ initialKey: '1', options: [ { text: 'Option 1', stepKey: '2' }, { text: 'Option 2', stepKey: '3' }, { text: 'Option 3', stepKey: 4 } ]},"goals":"{'name':'content promo image event name','data':'content promo image event data','text':'content promo image event text',  'goalId':'{E020A002-55A2-4495-9D06-EF6B0B1F2E71}'}","event-text":"test","event-item-id":"12345"}})],1),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":3}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('aha-transition-trigger',{staticClass:"p-0 m-0 bg-white border-0",attrs:{"type":"button","step-index":"1"}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake\n                        ")])],1),_vm._v(" "),_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--green"},[_c('aha-transition-input-value')],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Option 2 Result")]),_vm._v(" "),_c('p',[_vm._v("Here are some local events to keep you healthy and active!")]),_vm._v(" "),_c('div',{staticClass:"c-single-field-prompt__actions"},[_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Heart Disease And Family")]),_vm._v(" "),_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Healthy Meals For Heart Disease")]),_vm._v(" "),_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Latest News On Heart Disease")])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":2}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('aha-transition-trigger',{staticClass:"p-0 m-0 bg-white border-0",attrs:{"type":"button","step-index":"1"}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake\n                        ")])],1),_vm._v(" "),_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--orange"},[_c('aha-transition-input-value')],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Option 1 Result")])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":4}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('aha-transition-trigger',{staticClass:"p-0 m-0 bg-white border-0",attrs:{"type":"button","step-index":"1"}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake\n                        ")])],1),_vm._v(" "),_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--red"},[_c('aha-transition-input-value')],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Option 3 Result")])])],1),_vm._v(" "),_c('div',{staticClass:"c-hero-card-snackable__media h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any'),expression:"'//placeimg.com/1200/600/any'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"p-5"}),_vm._v(" "),_c('h2',[_vm._v("No Background")]),_vm._v(" "),_c('aha-transition-group',{staticClass:"c-hero-card-snackable"},[_c('div',{staticClass:"c-hero-card-snackable__container no-img"},[_c('div',{staticClass:"c-hero-card-snackable__content",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-single-field-prompt__heading h3"},[_vm._v("What's your resting heart rate")]),_vm._v(" "),_c('aha-single-field-prompt-form',{attrs:{"translations":{ label: 'Enter Your Resting Heart Rate', placeholder: 'ex: 78 bpm', submit: 'Submit', validation: 'Please enter a valid resting heart rate' },"config":{ targetValue: [50, 80], currentKey: 1, lessKey: 2, targetKey: 3, greaterKey: 4, minValue: 40, maxValue: 100 },"goals":"{'name':'content promo image event name','data':'content promo image event data','text':'content promo image event text',  'goalId':'{E020A002-55A2-4495-9D06-EF6B0B1F2E71}'}","event-text":"test","event-item-id":"12345"}})],1),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":3}},[_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--green"},[_c('aha-transition-input-value'),_vm._v(" bpm")],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Looking Good")]),_vm._v(" "),_c('p',[_vm._v("Here are some local events to keep you healthy and active!")]),_vm._v(" "),_c('div',{staticClass:"c-single-field-prompt__actions"},[_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Heart Disease And Family")]),_vm._v(" "),_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Healthy Meals For Heart Disease")]),_vm._v(" "),_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Latest News On Heart Disease")])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":2}},[_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--orange"},[_c('aha-transition-input-value'),_vm._v(" bpm")],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Too Low")])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":4}},[_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--red"},[_c('aha-transition-input-value'),_vm._v(" bpm")],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Too High")])])],1)])]),_vm._v(" "),_c('aha-transition-group',{staticClass:"c-hero-card-snackable"},[_c('div',{staticClass:"c-hero-card-snackable__container no-img"},[_c('div',{staticClass:"c-hero-card-snackable__content",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":1}},[_c('aha-single-field-prompt-radio-form',{attrs:{"translations":{ title:'What\'s your resting heart rate?', label: '', submit: 'Submit', validation: 'Please select a value' },"config":{ initialKey: '1', options: [ { text: 'Option 1', stepKey: '2' }, { text: 'Option 2', stepKey: '3' }, { text: 'Option 3', stepKey: 4 } ]},"goals":"{'name':'content promo image event name','data':'content promo image event data','text':'content promo image event text',  'goalId':'{E020A002-55A2-4495-9D06-EF6B0B1F2E71}'}","event-text":"test","event-item-id":"12345"}})],1),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":3}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('aha-transition-trigger',{staticClass:"p-0 m-0 bg-white border-0",attrs:{"type":"button","step-index":"1"}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake\n                        ")])],1),_vm._v(" "),_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--green"},[_c('aha-transition-input-value')],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Option 2 Result")]),_vm._v(" "),_c('p',[_vm._v("Here are some local events to keep you healthy and active!")]),_vm._v(" "),_c('div',{staticClass:"c-single-field-prompt__actions"},[_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Heart Disease And Family")]),_vm._v(" "),_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Healthy Meals For Heart Disease")]),_vm._v(" "),_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Latest News On Heart Disease")])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":2}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('aha-transition-trigger',{staticClass:"p-0 m-0 bg-white border-0",attrs:{"type":"button","step-index":"1"}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake\n                        ")])],1),_vm._v(" "),_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--orange"},[_c('aha-transition-input-value')],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Option 1 Result")])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":4}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('aha-transition-trigger',{staticClass:"p-0 m-0 bg-white border-0",attrs:{"type":"button","step-index":"1"}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake\n                        ")])],1),_vm._v(" "),_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--red"},[_c('aha-transition-input-value')],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Option 3 Result")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"p-5"}),_vm._v(" "),_c('h2',[_vm._v("Strip Down for Widgets and Modal")]),_vm._v(" "),_c('aha-transition-group',{staticClass:"c-hero-card-snackable"},[_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-single-field-prompt__heading h3"},[_vm._v("What's your resting heart rate")]),_vm._v(" "),_c('aha-single-field-prompt-form',{attrs:{"translations":{ label: 'Enter Your Resting Heart Rate', placeholder: 'ex: 78 bpm', submit: 'Submit', validation: 'Please enter a valid resting heart rate' },"config":{ targetValue: [50, 80], currentKey: 1, lessKey: 2, targetKey: 3, greaterKey: 4, minValue: 40, maxValue: 100 },"goals":"{'name':'content promo image event name','data':'content promo image event data','text':'content promo image event text',  'goalId':'{E020A002-55A2-4495-9D06-EF6B0B1F2E71}'}","event-text":"test","event-item-id":"12345"}})],1),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":3}},[_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--green"},[_c('aha-transition-input-value'),_vm._v(" bpm")],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Looking Good")]),_vm._v(" "),_c('p',[_vm._v("Here are some local events to keep you healthy and active!")]),_vm._v(" "),_c('div',{staticClass:"c-single-field-prompt__actions"},[_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Heart Disease And Family")]),_vm._v(" "),_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Healthy Meals For Heart Disease")]),_vm._v(" "),_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Latest News On Heart Disease")])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":2}},[_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--orange"},[_c('aha-transition-input-value'),_vm._v(" bpm")],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Too Low")])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":4}},[_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--red"},[_c('aha-transition-input-value'),_vm._v(" bpm")],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Too High")])])],1),_vm._v(" "),_c('aha-transition-group',{staticClass:"c-hero-card-snackable"},[_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":1}},[_c('aha-single-field-prompt-radio-form',{attrs:{"translations":{ title:'What\'s your resting heart rate?', label: '', submit: 'Submit', validation: 'Please select a value' },"config":{ initialKey: '1', options: [ { text: 'Option 1', stepKey: '2' }, { text: 'Option 2', stepKey: '3' }, { text: 'Option 3', stepKey: 4 } ]},"goals":"{'name':'content promo image event name','data':'content promo image event data','text':'content promo image event text',  'goalId':'{E020A002-55A2-4495-9D06-EF6B0B1F2E71}'}","event-text":"test","event-item-id":"12345"}})],1),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":3}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('aha-transition-trigger',{staticClass:"p-0 m-0 bg-white border-0",attrs:{"type":"button","step-index":"1"}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake\n                ")])],1),_vm._v(" "),_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--green"},[_c('aha-transition-input-value')],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Option 2 Result")]),_vm._v(" "),_c('p',[_vm._v("Here are some local events to keep you healthy and active!")]),_vm._v(" "),_c('div',{staticClass:"c-single-field-prompt__actions"},[_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Heart Disease And Family")]),_vm._v(" "),_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Healthy Meals For Heart Disease")]),_vm._v(" "),_c('a',{staticClass:"c-single-field-prompt__link c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Latest News On Heart Disease")])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":2}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('aha-transition-trigger',{staticClass:"p-0 m-0 bg-white border-0",attrs:{"type":"button","step-index":"1"}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake\n                ")])],1),_vm._v(" "),_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--orange"},[_c('aha-transition-input-value')],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Option 1 Result")])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-single-field-prompt",attrs:{"step-key":4}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('aha-transition-trigger',{staticClass:"p-0 m-0 bg-white border-0",attrs:{"type":"button","step-index":"1"}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake\n                ")])],1),_vm._v(" "),_c('p',{staticClass:"c-single-field-prompt__heading h3 h-color--red"},[_c('aha-transition-input-value')],1),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v("Option 3 Result")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ecc9448_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_make_commitment_vue__ = __webpack_require__(1266);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ecc9448_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_make_commitment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-transition-group',{staticClass:"container"},[_c('aha-make-commitment-form',{attrs:{"error-step-key":4},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('aha-transition-step',{staticClass:"c-hero-card-snackable-full-width__transition step-one",attrs:{"step-key":1}},[_c('div',{staticClass:"c-make-commitment"},[_c('div',{staticClass:"col-md-8 text-center m-auto"},[_c('h2',{staticClass:"c-make-commitment__heading mb-2"},[_vm._v("Make a Commitment")]),_vm._v(" "),_c('p',{staticClass:"h4 mb-5"},[_vm._v("\n                            Join a friend or family member and make a Go Red Commitment to take action in the fight against heart disease.\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('fieldset',{staticClass:"b-form-group form-group",attrs:{"role":"group","id":"__BVID__1","aria-labelledby":"__BVID__1___BV_label_"}},[_c('legend',{staticClass:"col-form-legend pt-0 mb-2",attrs:{"id":"__BVID__1___BV_label_"}},[_c('h3',{staticClass:"h4"},[_vm._v("Step 1: Select up to two commitment")])]),_vm._v(" "),_c('div',{attrs:{"role":"group","aria-labelledby":"__BVID__1___BV_label_"}},[_c('div',{staticClass:"c-make-commitment__wrap",attrs:{"id":"__BVID__1_"}},[_c('div',{staticClass:"col c-make-commitment__item c-make-commitment__bg c-make-commitment__border align-items-center h-theme--red",staticStyle:{"background-image":"url('https://picsum.photos/300/600?image=674')"}},[_c('div',{staticClass:"h-100"},[_c('div',{staticClass:"new-check-box h-100 w-100"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(formCtrl.formData.commitment),expression:"formCtrl.formData.commitment"}],attrs:{"id":"id1","type":"radio","value":"id1","name":"make-commitment-radio-btn"},domProps:{"checked":_vm._q(formCtrl.formData.commitment,"id1")},on:{"change":function($event){return _vm.$set(formCtrl.formData, "commitment", "id1")}}}),_vm._v(" "),_c('label',{staticClass:"h-100 w-100",attrs:{"for":"id1"}},[_c('div',{staticClass:"position-relative w-100 h-100"},[_c('div',{staticClass:"c-make-commitment__text position-absolute w-100 p-2"},[_c('div',{staticClass:"p-1 m-2 text-center"},[_vm._v("Healthy Living")])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-end mask h-100"},[_c('div',{staticClass:"hover-msg"},[_vm._v("Join a friend or family member and make a Go Red Commitment to take action in the fight against heart disease.")])])]),_vm._v(" "),_c('span',{staticClass:"check-box"})])])])]),_vm._v(" "),_c('div',{staticClass:"col c-make-commitment__item c-make-commitment__bg c-make-commitment__border align-items-center",staticStyle:{"background-image":"url('https://picsum.photos/300/600?image=694')"}},[_c('div',{staticClass:"d-flex align-items-center h-100"},[_c('div',{staticClass:"new-check-box h-100 w-100"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(formCtrl.formData.commitment),expression:"formCtrl.formData.commitment"}],attrs:{"id":"id2","type":"radio","value":"id2","name":"make-commitment-radio-btn"},domProps:{"checked":_vm._q(formCtrl.formData.commitment,"id2")},on:{"change":function($event){return _vm.$set(formCtrl.formData, "commitment", "id2")}}}),_vm._v(" "),_c('label',{staticClass:"h-100 w-100",attrs:{"for":"id2"}},[_c('div',{staticClass:"position-relative w-100 h-100"},[_c('div',{staticClass:"c-make-commitment__text position-absolute w-100 p-2"},[_c('div',{staticClass:"p-1 m-2 text-center"},[_vm._v("Monitor Blood Pressure")])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-end mask h-100"},[_c('div',{staticClass:"hover-msg"},[_vm._v("A cool description of some sort between these tags. I am so cool and awesomely awesome.")])])]),_vm._v(" "),_c('span',{staticClass:"check-box"})])])])]),_vm._v(" "),_c('div',{staticClass:"col c-make-commitment__item c-make-commitment__bg c-make-commitment__border align-items-center",staticStyle:{"background-image":"url('https://picsum.photos/300/600?image=784')"}},[_c('div',{staticClass:"d-flex align-items-center h-100"},[_c('div',{staticClass:"new-check-box h-100 w-100"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(formCtrl.formData.commitment),expression:"formCtrl.formData.commitment"}],attrs:{"id":"id3","type":"radio","value":"id3","name":"make-commitment-radio-btn"},domProps:{"checked":_vm._q(formCtrl.formData.commitment,"id3")},on:{"change":function($event){return _vm.$set(formCtrl.formData, "commitment", "id3")}}}),_vm._v(" "),_c('label',{staticClass:"h-100 w-100",attrs:{"for":"id3"}},[_c('div',{staticClass:"position-relative w-100 h-100"},[_c('div',{staticClass:"c-make-commitment__text position-absolute w-100 p-2"},[_c('div',{staticClass:"p-1 m-2 text-center"},[_vm._v("Get Active")])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-end mask h-100"},[_c('div',{staticClass:"hover-msg"},[_vm._v("A cool description of some sort between these tags. I am so cool and awesomely awesome.")])])]),_vm._v(" "),_c('span',{staticClass:"check-box"})])])])]),_vm._v(" "),_c('div',{staticClass:"col c-make-commitment__item c-make-commitment__bg c-make-commitment__border align-items-center",staticStyle:{"background-image":"url('https://picsum.photos/300/600?image=677')"}},[_c('div',{staticClass:"d-flex align-items-center h-100"},[_c('div',{staticClass:"new-check-box h-100 w-100"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(formCtrl.formData.commitment),expression:"formCtrl.formData.commitment"}],attrs:{"id":"id4","type":"radio","value":"id4","name":"make-commitment-radio-btn"},domProps:{"checked":_vm._q(formCtrl.formData.commitment,"id4")},on:{"change":function($event){return _vm.$set(formCtrl.formData, "commitment", "id4")}}}),_vm._v(" "),_c('label',{staticClass:"h-100 w-100",attrs:{"for":"id4"}},[_c('div',{staticClass:"position-relative w-100 h-100"},[_c('div',{staticClass:"c-make-commitment__text position-absolute w-100 p-2"},[_c('div',{staticClass:"p-1 m-2 text-center"},[_vm._v("Donate")])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-end mask h-100"},[_c('div',{staticClass:"hover-msg"},[_vm._v("A cool description of some sort between these tags. I am so cool and awesomely awesome.")])])]),_vm._v(" "),_c('span',{staticClass:"check-box"})])])])]),_vm._v(" "),_c('div',{staticClass:"col c-make-commitment__item c-make-commitment__bg c-make-commitment__border align-items-center",staticStyle:{"background-image":"url('https://picsum.photos/300/600?image=874')"}},[_c('div',{staticClass:"d-flex align-items-center h-100"},[_c('div',{staticClass:"new-check-box h-100 w-100"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(formCtrl.formData.commitment),expression:"formCtrl.formData.commitment"}],attrs:{"id":"id5","type":"radio","value":"id5","name":"make-commitment-radio-btn"},domProps:{"checked":_vm._q(formCtrl.formData.commitment,"id5")},on:{"change":function($event){return _vm.$set(formCtrl.formData, "commitment", "id5")}}}),_vm._v(" "),_c('label',{staticClass:"h-100 w-100",attrs:{"for":"id5"}},[_c('div',{staticClass:"position-relative w-100 h-100"},[_c('div',{staticClass:"c-make-commitment__text position-absolute w-100 p-2"},[_c('div',{staticClass:"p-1 m-2 text-center"},[_vm._v("Research")])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-end mask h-100"},[_c('div',{staticClass:"hover-msg"},[_vm._v("A cool description of some sort between these tags. I am so cool and awesomely awesome.")])])]),_vm._v(" "),_c('span',{staticClass:"check-box"})])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"c-make-commitment__actions"},[_c('aha-transition-trigger',{staticClass:"c-make-commitment__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.validation.commitment}},[_vm._v("\n                        Next\n                    ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable-full-width__transition step-two",attrs:{"step-key":2}},[_c('div',{staticClass:"c-make-commitment"},[_c('div',{staticClass:"col-md-8 text-center m-auto"},[_c('h2',{staticClass:"c-make-commitment__heading mb-2"},[_vm._v("Make a Commitment")]),_vm._v(" "),_c('p',{staticClass:"h4 mb-5"},[_vm._v("\n                            Join a friend or family member and make a Go Red Commitment to take action in the fight against heart disease.\n                        ")])]),_vm._v(" "),_c('fieldset',{staticClass:"b-form-group form-group",attrs:{"role":"group","id":"__BVID__2","aria-labelledby":"__BVID__2___BV_label_"}},[_c('legend',{staticClass:"col-form-legend pt-0 mb-5 text-center",attrs:{"id":"__BVID__1___BV_label_"}},[_c('h3',{staticClass:"h4 mb-3"},[_vm._v("Step 2: Enter your information to complete your commitment")]),_vm._v(" "),_c('p',{staticClass:"h4"},[_c('i',[_vm._v("All fields required unless indicated as optional.")])])]),_vm._v(" "),_c('b-row',{staticClass:"c-make-commitment__form form-group",attrs:{"id":"__BVID__2___BV_label_"}},[_c('b-col',{attrs:{"sm":"6"}},[_c('div',{staticClass:"input-group"},[_c('label',{attrs:{"for":"FirstName"}},[_vm._v("First Name")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"FirstName","name":"FirstName","formatter":formCtrl.checkInput,"lazy-formatter":"","aria-required":"true","validation-prop":"firstname","required":""},model:{value:(formCtrl.formData.firstName),callback:function ($$v) {_vm.$set(formCtrl.formData, "firstName", $$v)},expression:"formCtrl.formData.firstName"}})],1)]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('div',{staticClass:"input-group"},[_c('label',{attrs:{"for":"LastName"}},[_vm._v("Last Name")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"LastName","name":"LastName","aria-required":"true","validation-prop":"lastname","required":""},model:{value:(formCtrl.formData.lastName),callback:function ($$v) {_vm.$set(formCtrl.formData, "lastName", $$v)},expression:"formCtrl.formData.lastName"}})],1)]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('div',{staticClass:"input-group"},[_c('label',{attrs:{"for":"Email"}},[_vm._v("Email")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid has-invalid-icon': !formCtrl.validEmail},attrs:{"id":"Email","name":"Email","validation-prop":"email","formatter":formCtrl.checkInput,"lazy-formatter":"","type":"email","aria-required":"true","required":""},model:{value:(formCtrl.formData.email),callback:function ($$v) {_vm.$set(formCtrl.formData, "email", $$v)},expression:"formCtrl.formData.email"}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback",attrs:{"ng-if":"!formCtrl.validEmail"}},[_vm._v("Please provide a valid email.")])],1)]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('div',{staticClass:"input-group"},[_c('label',{attrs:{"for":"ZipCode"}},[_vm._v("Zipcode")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"ZipCode","name":"ZipCode","formatter":formCtrl.checkInput,"lazy-formatter":"","aria-required":"true","validation-prop":"lastname","required":"","pattern":"^\\d{5}(?:[-\\s]\\d{4})?$"},model:{value:(formCtrl.formData.zipCode),callback:function ($$v) {_vm.$set(formCtrl.formData, "zipCode", $$v)},expression:"formCtrl.formData.zipCode"}})],1)]),_vm._v(" "),_c('input',{directives:[{name:"hidden-input",rawName:"v-hidden-input"}],attrs:{"type":"hidden","id":"datasourceItemId","name":"datasourceItemId","value":"{AB7909E9-F9EA-45D9-BAE4-D397E9B496CD}"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-8 m-auto"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(formCtrl.formData.newsletters),expression:"formCtrl.formData.newsletters"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox1","name":"customRadioGroup"},domProps:{"checked":Array.isArray(formCtrl.formData.newsletters)?_vm._i(formCtrl.formData.newsletters,null)>-1:(formCtrl.formData.newsletters)},on:{"change":function($event){var $$a=formCtrl.formData.newsletters,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(formCtrl.formData, "newsletters", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(formCtrl.formData, "newsletters", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(formCtrl.formData, "newsletters", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheckbox1"}},[_c('strong',[_vm._v(" Up for our newsletters!")])])]),_vm._v(" "),_c('p',[_vm._v("By clicking the sign up button you agree recieve communication regarding your specified commitment and communication from Go Red For Women® according to the  "),_c('a',{attrs:{"href":"http://www.heart.org/HEARTORG/HealthyLiving/Healthy-For-Good-Sign-Up_UCM_428192_Article.jsp"}},[_vm._v("Terms and Conditions")]),_vm._v(" and "),_c('a',{attrs:{"href":"http://www.heart.org/privacy"}},[_vm._v("Privacy Policy")]),_vm._v(".")])])],1)]),_vm._v(" "),_c('div',{staticClass:"c-make-commitment__actions text-center"},[_c('button',{staticClass:"c-make-commitment__button btn btn-round btn-lg btn-primary",attrs:{"type":"submit","disabled":!formCtrl.isComplete}},[_vm._v("\n                        Make My Commitment\n                    ")])]),_vm._v(" "),(formCtrl.loading)?_c('div',{staticClass:"loading-image modal fade show d-block"},[_c('div',{staticClass:"loader-centered"},[_c('img',{attrs:{"src":__webpack_require__(79),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop fade show",attrs:{"id":"recipe-add-to-box___BV_modal_backdrop__jlf62in2"}})]):_vm._e()]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable-full-width__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"c-make-commitment text-center"},[(formCtrl.response)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                       Already have data\n                     ")]):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"c-make-commitment__heading"},[_vm._v("Thank you for your commitment!")]),_vm._v(" "),_c('div',{staticClass:"col-md-8 mb-3 mx-auto"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus ornare nibh egestas mi tincidunt sagittis. ")]),_vm._v(" "),_c('img',{attrs:{"src":"https://via.placeholder.com/200x228"}}),_vm._v(" "),_c('h2',{staticClass:"c-make-commitment__heading mt-3"},[_vm._v("Next Step: "),_c('br'),_vm._v(" Find your Heart Score")]),_vm._v(" "),_c('p',{staticClass:"col-md-8 mb-3 mx-auto"},[_vm._v("\n                        Take the test and follow up with your physician to discuess the results.\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-lg btn-primary",attrs:{"href":"#"}},[_vm._v("Find Out My Heart Score")])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable-full-width__transition",attrs:{"step-key":4}},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                    Uh oh, it appears that there was a network issue.\n                ")]),_vm._v(" "),_c('div',{staticClass:"c-make-commitment__actions"},[_c('aha-transition-trigger',{staticClass:"c-make-commitment__button btn btn-round btn-lg btn-primary",attrs:{"type":"button","step-index":"2"}},[_vm._v("\n                        Back\n                    ")])],1)])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quiz_vue__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quiz_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quiz_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quiz_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quiz_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_393087e2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_vue__ = __webpack_require__(1268);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quiz_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_393087e2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-transition-group',{staticClass:"c-hero-card-snackable-full-quiz"},[_c('aha-transition-group-form',{attrs:{"error-step-key":7,"url":"/aha-service/grfw/Quiz","name":"With Background"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable-full-quiz__container"},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__content",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Which Breakfast Item Are You?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate. ")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("1 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                                    Next  \n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"whichBreakfastHeading"}},[_vm._v("Which One Would You Choose")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"whichBreakfastHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"bisquit","name":"whichBreakfast","value":"Bisquit"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"bisquit"}},[_vm._v("Bisquit")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"toast","name":"whichBreakfast","value":"Toast"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"toast"}},[_vm._v("Toast")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"waffle","name":"whichBreakfast","value":"Waffle"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"waffle"}},[_vm._v("Waffle")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("2 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"1","type":"button"}},[_vm._v("\n                                    Back  \n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v(_vm._s(formCtrl.ResponseTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.ResponseText))]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("3 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"2","type":"button"}},[_vm._v("\n                                    Back  \n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":4}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"healthyDietHeading"}},[_vm._v("The simplest way to enjoy a healthy diet is with:")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"healthyDietHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"candy","name":"healthyDiet","value":"Candy"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"candy"}},[_vm._v("Candy")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"butter","name":"healthyDiet","value":"Butter"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"butter"}},[_vm._v("Butter")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"burger","name":"healthyDiet","value":"Burger"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"burger"}},[_vm._v("Burger")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("4 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"3","type":"button"}},[_vm._v("\n                                    Back  \n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":5}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v(_vm._s(formCtrl.ResponseTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.ResponseText))]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("5 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"4"}},[_vm._v("\n                                Back\n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":6}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('button',{staticClass:"p-0 m-0 bg-white border-0",attrs:{"type":"button","step-index":"1"},on:{"click":formCtrl.resetForm}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake Quiz\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey"},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("You Got: Avocado Toast")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut.")]),_vm._v(" "),_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Get the Recipe Here!")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number mt-3"},[_vm._v("6 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share--quiz"},[_c('p',{staticClass:"h3 mr-3"},[_vm._v("Share:")]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('img',{attrs:{"src":"assets/share/mail.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#0"}},[_c('img',{attrs:{"src":"assets/share/copy-link.svg"}})])])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable-full-width__transition",attrs:{"step-key":7}},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                            Uh oh, it appears that there was a network issue.\n                        ")]),_vm._v(" "),_c('div',{staticClass:"c-make-commitment__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"2","type":"button"}},[_vm._v("\n                                    Back  \n                            ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media"},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?1'),expression:"'//placeimg.com/1200/400/any?1'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?2'),expression:"'//placeimg.com/1200/400/any?2'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?3'),expression:"'//placeimg.com/1200/400/any?3'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])])],1)])]}}])}),_vm._v(" "),_c('div',{staticClass:"p-5"}),_vm._v(" "),_c('h2',[_vm._v("No Background")]),_vm._v(" "),_c('aha-transition-group-form',{attrs:{"error-step-key":7,"url":"/aha-service/grfw/Quiz","name":"No Background"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable-full-quiz_container no-img"},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__content m-auto",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Which Breakfast Item Are You?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate. ")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("1 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                                    Next  \n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"whichBreakfastHeading"}},[_vm._v("Which One Would You Choose")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"whichBreakfastHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"bisquit","name":"whichBreakfast","value":"Bisquit"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"bisquit"}},[_vm._v("Bisquit")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"toast","name":"whichBreakfast","value":"Toast"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"toast"}},[_vm._v("Toast")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"waffle","name":"whichBreakfast","value":"Waffle"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"waffle"}},[_vm._v("Waffle")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("2 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"1","type":"button"}},[_vm._v("\n                                    Back  \n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v(_vm._s(formCtrl.ResponseTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.ResponseText))]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("3 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"2","type":"button"}},[_vm._v("\n                                    Back  \n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":4}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"healthyDietHeading"}},[_vm._v("The simplest way to enjoy a healthy diet is with:")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"healthyDietHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"candy","name":"healthyDiet","value":"Candy"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"candy"}},[_vm._v("Candy")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"butter","name":"healthyDiet","value":"Butter"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"butter"}},[_vm._v("Butter")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"burger","name":"healthyDiet","value":"Burger"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"burger"}},[_vm._v("Burger")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("4 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"3","type":"button"}},[_vm._v("\n                                    Back  \n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":5}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v(_vm._s(formCtrl.ResponseTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.ResponseText))]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("5 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"4"}},[_vm._v("\n                                Back\n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":6}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('button',{staticClass:"c-cta btn btn-link h-theme--red",attrs:{"type":"button","step-index":"1"},on:{"click":formCtrl.resetForm}},[_c('img',{staticClass:"mr-2",attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake Quiz\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey"},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("You Got: Avocado Toast")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut.")]),_vm._v(" "),_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Get the Recipe Here!")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number mt-3"},[_vm._v("6 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share--quiz"},[_c('p',{staticClass:"h3 mr-3"},[_vm._v("Share:")]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('img',{attrs:{"src":"assets/share/mail.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#0"}},[_c('img',{attrs:{"src":"assets/share/copy-link.svg"}})])])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable-full-width__transition",attrs:{"step-key":7}},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                            Uh oh, it appears that there was a network issue.\n                        ")]),_vm._v(" "),_c('div',{staticClass:"c-make-commitment__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"2","type":"button"}},[_vm._v("\n                                    Back  \n                            ")])],1)])],1)])]}}])}),_vm._v(" "),_c('div',{staticClass:"p-5"}),_vm._v(" "),_c('h2',[_vm._v("Strip Down for Widgets and Modal")]),_vm._v(" "),_c('aha-transition-group-form',{attrs:{"error-step-key":7,"url":"/aha-service/grfw/Quiz","name":"Strip Down"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable-full-quiz"},[_c('div',{attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Which Breakfast Item Are You?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate. ")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("1 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                                    Next  \n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"whichBreakfastHeading"}},[_vm._v("Which One Would You Choose")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"whichBreakfastHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"bisquit","name":"whichBreakfast","value":"Bisquit"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"bisquit"}},[_vm._v("Bisquit")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"toast","name":"whichBreakfast","value":"Toast"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"toast"}},[_vm._v("Toast")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"waffle","name":"whichBreakfast","value":"Waffle"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"waffle"}},[_vm._v("Waffle")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("2 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"1","type":"button"}},[_vm._v("\n                                    Back  \n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v(_vm._s(formCtrl.ResponseTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.ResponseText))]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("3 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"2","type":"button"}},[_vm._v("\n                                    Back  \n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":4}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"healthyDietHeading"}},[_vm._v("The simplest way to enjoy a healthy diet is with:")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"healthyDietHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"candy","name":"healthyDiet","value":"Candy"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"candy"}},[_vm._v("Candy")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"butter","name":"healthyDiet","value":"Butter"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"butter"}},[_vm._v("Butter")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"burger","name":"healthyDiet","value":"Burger"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"burger"}},[_vm._v("Burger")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("4 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"3","type":"button"}},[_vm._v("\n                                    Back  \n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":5}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v(_vm._s(formCtrl.ResponseTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.ResponseText))]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("5 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"4"}},[_vm._v("\n                                Back\n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":6}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('button',{staticClass:"c-cta btn btn-link h-theme--red",attrs:{"type":"button","step-index":"1"},on:{"click":formCtrl.resetForm}},[_c('img',{staticClass:"mr-2",attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake Quiz\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey"},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("You Got: Avocado Toast")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut.")]),_vm._v(" "),_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Get the Recipe Here!")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number mt-3"},[_vm._v("6 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share--quiz"},[_c('p',{staticClass:"h3 mr-3"},[_vm._v("Share:")]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('img',{attrs:{"src":"assets/share/mail.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#0"}},[_c('img',{attrs:{"src":"assets/share/copy-link.svg"}})])])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable-full-width__transition",attrs:{"step-key":7}},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                            Uh oh, it appears that there was a network issue.\n                        ")]),_vm._v(" "),_c('div',{staticClass:"c-make-commitment__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"2","type":"button"}},[_vm._v("\n                                    Back  \n                            ")])],1)])],1)])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12b11654_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_scoring_vue__ = __webpack_require__(1270);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12b11654_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_scoring_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-transition-group',{staticClass:"c-hero-card-snackable-full-quiz"},[_c('aha-transition-group-form',{attrs:{"error-step-key":7,"url":"/aha-service/grfw/Quiz"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable__container"},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__content",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Which Breakfast Item Are You?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate. ")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("1 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"whichBreakfastHeading"}},[_vm._v("Which One Would You Choose")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"whichBreakfastHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"bisquit","name":"whichBreakfast","value":"Bisquit"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"bisquit"}},[_vm._v("Bisquit")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"toast","name":"whichBreakfast","value":"Toast"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"toast"}},[_vm._v("Toast")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"waffle","name":"whichBreakfast","value":"Waffle"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"waffle"}},[_vm._v("Waffle")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("2 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"1"}},[_vm._v("\n                                Back\n                            ")]),_vm._v(" "),_c('button',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v(_vm._s(formCtrl.ResponseTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.ResponseText))]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("3 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"2"}},[_vm._v("\n                                Back\n                            ")]),_vm._v(" "),_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":4}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"healthyDietHeading"}},[_vm._v("The simplest way to enjoy a healthy diet is with:")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"healthyDietHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"candy","name":"healthyDiet","value":"Candy"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"candy"}},[_vm._v("Candy")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"butter","name":"healthyDiet","value":"Butter"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"butter"}},[_vm._v("Butter")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"burger","name":"healthyDiet","value":"Burger"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"burger"}},[_vm._v("Burger")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("4 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"3"}},[_vm._v("\n                                Back\n                            ")]),_vm._v(" "),_c('button',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.healthyDiet},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":5}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v(_vm._s(formCtrl.ResponseTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.ResponseText))]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("5 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"4"}},[_vm._v("\n                                Back\n                            ")]),_vm._v(" "),_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":6}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('button',{staticClass:"p-0 m-0 bg-white border-0",attrs:{"type":"button","step-index":"1"},on:{"click":formCtrl.resetForm}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake Quiz\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey"},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("C.H.A.D.S. Factors Risk Level")]),_vm._v(" "),_c('p',{staticClass:"c-score"},[_vm._v("Your score: "),_c('span',{staticClass:"c-score__score c-cta h-theme--red"},[_vm._v("10")])]),_vm._v(" "),_c('p',[_vm._v("Always check with yopur doctor to verify your risk score. The guidelines recommend \"blood thinning\" medications for people who have added risks")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_c('strong',[_vm._v("Risk Level: (low to high)")])]),_vm._v(" "),_c('img',{staticClass:"mb-3",attrs:{"src":"//placehold.it/350x100"}}),_vm._v(" "),_c('p',[_c('strong',[_vm._v("NOTE:")]),_vm._v(" Although the risk level self-assessment is not intended to replace the essential risk assessment you need with your healthcare provider, it can help you visualize the risks for stroke you may be facing. The higher your levels, the higher you are at risk for stroke.")]),_vm._v(" "),_c('p',[_vm._v("*\"Blood thinner\" is a common term for anticoagulant medication that reduces the blood's ability to form a clot that can cause a stroke.")]),_vm._v(" "),_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Learn more")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share--quiz"},[_c('p',{staticClass:"h3 mr-3"},[_vm._v("Share:")]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('img',{attrs:{"src":"assets/share/mail.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#0"}},[_c('img',{attrs:{"src":"assets/share/copy-link.svg"}})])])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable-full-width__transition",attrs:{"step-key":7}},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                            Uh oh, it appears that there was a network issue.\n                        ")]),_vm._v(" "),_c('div',{staticClass:"c-make-commitment__actions"},[_c('aha-transition-trigger',{staticClass:"c-make-commitment__button btn btn-round btn-lg btn-primary",attrs:{"type":"button","step-index":formCtrl.activeStep}},[_vm._v("\n                                Back\n                            ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media"},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?1'),expression:"'//placeimg.com/1200/400/any?1'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?2'),expression:"'//placeimg.com/1200/400/any?2'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?3'),expression:"'//placeimg.com/1200/400/any?3'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])])],1)])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25c95122_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_poll_vue__ = __webpack_require__(1272);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25c95122_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_poll_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aha-transition-group',{staticClass:"c-hero-card-snackable-poll"},[_c('aha-transition-group-form',{attrs:{"error-step-key":3,"url":"/aha-service/grfw/Poll"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable__container"},[_c('div',{staticClass:"c-hero-card-snackable-poll__content",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"preferredTrainingHeading"}},[_vm._v("Do You Prefer Cardio or Strength Training?")]),_vm._v(" "),_c('form',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"role":"radiogroup","aria-required":"true","aria-labelledby":"preferredTrainingHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('preferredTraining'),expression:"'preferredTraining'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"cardioRadio","name":"preferredTraining","value":"Cardio"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"cardioRadio"}},[_vm._v("Cardio: my favorite type of excersise gets my heart rate going.")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('preferredTraining'),expression:"'preferredTraining'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"strengthRadio","name":"preferredTraining","value":"Strength"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"strengthRadio"}},[_vm._v("Strength Training: focusing on muscle building is the most satisfying.")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('preferredTraining'),expression:"'preferredTraining'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"bothRadio","name":"preferredTraining","value":"Both"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"bothRadio"}},[_vm._v("Both: my workouts wouldn't be complete without either.")])])])])]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('button',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.preferredTraining},on:{"click":formCtrl.submitForm}},[_vm._v("\n                                    Submit\n                                ")])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Do You Prefer Cardio or Strength Training?")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__user-count"},[_c('p',{staticClass:"h-color--gray"},[_vm._v(_vm._s(formCtrl.response.Total)+" users have taken this poll")])]),_vm._v(" "),_c('div',{staticClass:"c-progress-bars"},[_c('div',{staticClass:"c-progress-bars__single"},[_c('label',{staticClass:"c-progress-bars__label"},[_vm._v("Cardio: my favorite type of excersise gets my heart rate going.")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar h-bg-color--yellow-orange",style:({width: formCtrl.response.Cardio + '%'}),attrs:{"role":"progressbar","aria-valuenow":formCtrl.response.Cardio,"aria-valuetext":formCtrl.response.Cardio,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"c-progress-bars__result yellow-orange-alt"},[_vm._v(_vm._s(formCtrl.response.Cardio)+"%")])])])]),_vm._v(" "),_c('div',{staticClass:"c-progress-bars__single"},[_c('label',{staticClass:"c-progress-bars__label"},[_vm._v("Strength Training: focusing on muscle building is the most satisfying.")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar h-bg-color--yellow-orange-alt",style:({width: formCtrl.response.Strength + '%'}),attrs:{"role":"progressbar","aria-valuenow":formCtrl.response.Strength,"aria-valuetext":formCtrl.response.Strength,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"c-progress-bars__result h-color--yellow-orange-alt"},[_vm._v(_vm._s(formCtrl.response.Strength)+"%")])])])]),_vm._v(" "),_c('div',{staticClass:"c-progress-bars__single"},[_c('label',{staticClass:"c-progress-bars__label"},[_vm._v("Both: my workouts wouldn't be complete without either.")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar h-bg-color--yellow-orange",style:({width: formCtrl.response.Both + '%'}),attrs:{"role":"progressbar","aria-valuenow":formCtrl.response.Both,"aria-valuetext":formCtrl.response.Both,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"c-progress-bars__result"},[_vm._v(_vm._s(formCtrl.response.Both)+"%")])])])])]),_vm._v(" "),_c('a',{staticClass:"c-cta h-theme--red c-cta--fit-content twoClick c-cta--arrow",attrs:{"href":"#"}},[_vm._v("Learn About Staying Active!")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share--quiz"},[_c('p',{staticClass:"h3 mr-3"},[_vm._v("Share:")]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"/assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"/assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('p',{staticClass:"sr-only"},[_vm._v("Email Us")]),_vm._v(" "),_c('img',{attrs:{"src":"/assets/share/mail.svg"}})]),_vm._v(" "),_c('aha-copy-url-to-clipboard',{attrs:{"aria-label-prop":"Copy site URL to your clipboard."}},[[_c('img',{attrs:{"src":"/assets/share/copy-link.svg"}})]],2)],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable-full-width__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                                Uh oh, it appears that there was a network issue.\n                            ")]),_vm._v(" "),_c('div',{staticClass:"c-make-commitment__actions"},[_c('aha-transition-trigger',{staticClass:"c-make-commitment__button btn btn-round btn-lg btn-primary",attrs:{"type":"button","step-index":"1"}},[_vm._v("\n                                    Back\n                                ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"c-hero-card-snackable-poll__media"},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"c-hero-card-snackable-poll__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?1'),expression:"'//placeimg.com/1200/400/any?1'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('div',{staticClass:"c-hero-card-snackable-poll__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?2'),expression:"'//placeimg.com/1200/400/any?2'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])])],1),_vm._v(" "),(formCtrl.loading)?_c('div',{staticClass:"loading-image modal fade show d-block"},[_c('div',{staticClass:"loader-centered"},[_c('img',{attrs:{"src":__webpack_require__(79),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop fade show",attrs:{"id":"recipe-add-to-box___BV_modal_backdrop__jlf62in2"}})]):_vm._e()])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"p-5"}),_vm._v(" "),_c('h2',[_vm._v("No Background")]),_vm._v(" "),_c('aha-transition-group',{staticClass:"c-hero-card-snackable-poll"},[_c('aha-transition-group-form',{attrs:{"error-step-key":3,"url":"/aha-service/grfw/Poll"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable__container no-img"},[_c('div',{staticClass:"c-hero-card-snackable-poll__content",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"preferredTrainingHeading"}},[_vm._v("Do You Prefer Cardio or Strength Training?")]),_vm._v(" "),_c('form',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"role":"radiogroup","aria-required":"true","aria-labelledby":"preferredTrainingHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('preferredTraining'),expression:"'preferredTraining'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"cardioRadio","name":"preferredTraining","value":"Cardio"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"cardioRadio"}},[_vm._v("Cardio: my favorite type of excersise gets my heart rate going.")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('preferredTraining'),expression:"'preferredTraining'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"strengthRadio","name":"preferredTraining","value":"Strength"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"strengthRadio"}},[_vm._v("Strength Training: focusing on muscle building is the most satisfying.")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('preferredTraining'),expression:"'preferredTraining'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"bothRadio","name":"preferredTraining","value":"Both"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"bothRadio"}},[_vm._v("Both: my workouts wouldn't be complete without either.")])])])])]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('button',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.preferredTraining},on:{"click":formCtrl.submitForm}},[_vm._v("\n                                    Submit\n                                ")])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Do You Prefer Cardio or Strength Training?")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__user-count"},[_c('p',{staticClass:"h-color--gray"},[_vm._v(_vm._s(formCtrl.response.Total)+" users have taken this poll")])]),_vm._v(" "),_c('div',{staticClass:"c-progress-bars"},[_c('div',{staticClass:"c-progress-bars__single"},[_c('label',{staticClass:"c-progress-bars__label"},[_vm._v("Cardio: my favorite type of excersise gets my heart rate going.")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar h-bg-color--yellow-orange",style:({width: formCtrl.response.Cardio + '%'}),attrs:{"role":"progressbar","aria-valuenow":formCtrl.response.Cardio,"aria-valuetext":formCtrl.response.Cardio,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"c-progress-bars__result yellow-orange-alt"},[_vm._v(_vm._s(formCtrl.response.Cardio)+"%")])])])]),_vm._v(" "),_c('div',{staticClass:"c-progress-bars__single"},[_c('label',{staticClass:"c-progress-bars__label"},[_vm._v("Strength Training: focusing on muscle building is the most satisfying.")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar h-bg-color--yellow-orange-alt",style:({width: formCtrl.response.Strength + '%'}),attrs:{"role":"progressbar","aria-valuenow":formCtrl.response.Strength,"aria-valuetext":formCtrl.response.Strength,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"c-progress-bars__result h-color--yellow-orange-alt"},[_vm._v(_vm._s(formCtrl.response.Strength)+"%")])])])]),_vm._v(" "),_c('div',{staticClass:"c-progress-bars__single"},[_c('label',{staticClass:"c-progress-bars__label"},[_vm._v("Both: my workouts wouldn't be complete without either.")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar h-bg-color--yellow-orange",style:({width: formCtrl.response.Both + '%'}),attrs:{"role":"progressbar","aria-valuenow":formCtrl.response.Both,"aria-valuetext":formCtrl.response.Both,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"c-progress-bars__result"},[_vm._v(_vm._s(formCtrl.response.Both)+"%")])])])])]),_vm._v(" "),_c('a',{staticClass:"c-cta h-theme--red c-cta--fit-content twoClick c-cta--arrow",attrs:{"href":"#"}},[_vm._v("Learn About Staying Active!")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share--quiz"},[_c('p',{staticClass:"h3 mr-3"},[_vm._v("Share:")]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"/assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"/assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('p',{staticClass:"sr-only"},[_vm._v("Email Us")]),_vm._v(" "),_c('img',{attrs:{"src":"/assets/share/mail.svg"}})]),_vm._v(" "),_c('aha-copy-url-to-clipboard',{attrs:{"aria-label-prop":"Copy site URL to your clipboard."}},[[_c('img',{attrs:{"src":"/assets/share/copy-link.svg"}})]],2)],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable-full-width__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                                Uh oh, it appears that there was a network issue.\n                            ")]),_vm._v(" "),_c('div',{staticClass:"c-make-commitment__actions"},[_c('aha-transition-trigger',{staticClass:"c-make-commitment__button btn btn-round btn-lg btn-primary",attrs:{"type":"button","step-index":"1"}},[_vm._v("\n                                    Back\n                                ")])],1)])],1),_vm._v(" "),(formCtrl.loading)?_c('div',{staticClass:"loading-image modal fade show d-block"},[_c('div',{staticClass:"loader-centered"},[_c('img',{attrs:{"src":__webpack_require__(79),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop fade show",attrs:{"id":"recipe-add-to-box___BV_modal_backdrop__jlf62in2"}})]):_vm._e()])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"p-5"}),_vm._v(" "),_c('h2',[_vm._v("Strip Down for Widgets and Modal")]),_vm._v(" "),_c('aha-transition-group',{staticClass:"c-hero-card-snackable-poll"},[_c('aha-transition-group-form',{attrs:{"error-step-key":3,"url":"/aha-service/grfw/Poll"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"preferredTrainingHeading"}},[_vm._v("Do You Prefer Cardio or Strength Training?")]),_vm._v(" "),_c('form',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"role":"radiogroup","aria-required":"true","aria-labelledby":"preferredTrainingHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('preferredTraining'),expression:"'preferredTraining'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"cardioRadio","name":"preferredTraining","value":"Cardio"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"cardioRadio"}},[_vm._v("Cardio: my favorite type of excersise gets my heart rate going.")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('preferredTraining'),expression:"'preferredTraining'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"strengthRadio","name":"preferredTraining","value":"Strength"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"strengthRadio"}},[_vm._v("Strength Training: focusing on muscle building is the most satisfying.")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('preferredTraining'),expression:"'preferredTraining'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"bothRadio","name":"preferredTraining","value":"Both"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"bothRadio"}},[_vm._v("Both: my workouts wouldn't be complete without either.")])])])])]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('button',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.preferredTraining},on:{"click":formCtrl.submitForm}},[_vm._v("\n                            Submit\n                        ")])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Do You Prefer Cardio or Strength Training?")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__user-count"},[_c('p',{staticClass:"h-color--gray"},[_vm._v(_vm._s(formCtrl.response.Total)+" users have taken this poll")])]),_vm._v(" "),_c('div',{staticClass:"c-progress-bars"},[_c('div',{staticClass:"c-progress-bars__single"},[_c('label',{staticClass:"c-progress-bars__label"},[_vm._v("Cardio: my favorite type of excersise gets my heart rate going.")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar h-bg-color--yellow-orange",style:({width: formCtrl.response.Cardio + '%'}),attrs:{"role":"progressbar","aria-valuenow":formCtrl.response.Cardio,"aria-valuetext":formCtrl.response.Cardio,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"c-progress-bars__result yellow-orange-alt"},[_vm._v(_vm._s(formCtrl.response.Cardio)+"%")])])])]),_vm._v(" "),_c('div',{staticClass:"c-progress-bars__single"},[_c('label',{staticClass:"c-progress-bars__label"},[_vm._v("Strength Training: focusing on muscle building is the most satisfying.")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar h-bg-color--yellow-orange-alt",style:({width: formCtrl.response.Strength + '%'}),attrs:{"role":"progressbar","aria-valuenow":formCtrl.response.Strength,"aria-valuetext":formCtrl.response.Strength,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"c-progress-bars__result h-color--yellow-orange-alt"},[_vm._v(_vm._s(formCtrl.response.Strength)+"%")])])])]),_vm._v(" "),_c('div',{staticClass:"c-progress-bars__single"},[_c('label',{staticClass:"c-progress-bars__label"},[_vm._v("Both: my workouts wouldn't be complete without either.")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar h-bg-color--yellow-orange",style:({width: formCtrl.response.Both + '%'}),attrs:{"role":"progressbar","aria-valuenow":formCtrl.response.Both,"aria-valuetext":formCtrl.response.Both,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"c-progress-bars__result"},[_vm._v(_vm._s(formCtrl.response.Both)+"%")])])])])]),_vm._v(" "),_c('a',{staticClass:"c-cta h-theme--red c-cta--fit-content twoClick c-cta--arrow",attrs:{"href":"#"}},[_vm._v("Learn About Staying Active!")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share--quiz"},[_c('p',{staticClass:"h3 mr-3"},[_vm._v("Share:")]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"/assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"/assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('p',{staticClass:"sr-only"},[_vm._v("Email Us")]),_vm._v(" "),_c('img',{attrs:{"src":"/assets/share/mail.svg"}})]),_vm._v(" "),_c('aha-copy-url-to-clipboard',{attrs:{"aria-label-prop":"Copy site URL to your clipboard."}},[[_c('img',{attrs:{"src":"/assets/share/copy-link.svg"}})]],2)],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable-full-width__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                        Uh oh, it appears that there was a network issue.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"c-make-commitment__actions"},[_c('aha-transition-trigger',{staticClass:"c-make-commitment__button btn btn-round btn-lg btn-primary",attrs:{"type":"button","step-index":"1"}},[_vm._v("\n                            Back\n                        ")])],1)]),_vm._v(" "),(formCtrl.loading)?_c('div',{staticClass:"loading-image modal fade show d-block"},[_c('div',{staticClass:"loader-centered"},[_c('img',{attrs:{"src":__webpack_require__(79),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop fade show",attrs:{"id":"recipe-add-to-box___BV_modal_backdrop__jlf62in2"}})]):_vm._e()]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735d8eed_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_personalised_vue__ = __webpack_require__(1274);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735d8eed_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_personalised_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-transition-group',{staticClass:"c-hero-card-snackable"},[_c('div',{staticClass:"c-hero-card-snackable__container"},[_c('div',{staticClass:"c-hero-card-snackable__content",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Cholesterol high? Let Us Help You Find The Perfect Meal. ")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. ")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number mt-3"},[_vm._v("1 of 3")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                        Next\n                    ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Choose a Protein")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2 mb-0"},[_c('fieldset',[_c('div',{attrs:{"data-v-546c2c52":""}},[_c('div',{staticClass:"c-quiz-personalized__selects"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio1","name":"customRadioGroup","checked":""}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio1"}},[_vm._v("Bisquit")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio2","name":"customRadioGroup"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio2"}},[_vm._v("Toast")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio3","name":"customRadioGroup"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio3"}},[_vm._v("Waffle")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio4","name":"customRadioGroup","checked":""}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio4"}},[_vm._v("Turkey")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio5","name":"customRadioGroup"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio5"}},[_vm._v("Salmon")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio6","name":"customRadioGroup"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio6"}},[_vm._v("Lean Beef")])])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number mt-3"},[_vm._v("2 of 3")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"1","event-item-id":"12345","event-text":"eventText"}},[_vm._v("\n                        Back\n                    ")]),_vm._v(" "),_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","event-item-id":"123456","event-text":"eventText"}},[_vm._v("\n                        Next\n                    ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"p-0 m-0 bg-white border-0",attrs:{"type":"button","step-index":"1","event-item-id":"123456","event-text":"eventText"}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake Quiz\n                    ")])],1),_vm._v(" "),_c('div',{staticClass:"c-daily-journey"},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Try This: Salmon With Sauted Greens And Veggies")]),_vm._v(" "),_c('a',{staticClass:"btn btn-secondary-link ml-0 pl-0",attrs:{"href":"/en"}},[_vm._v("Get the Recipe Here!")]),_vm._v(" "),_c('a',{staticClass:"btn btn-secondary-link ml-0 pl-0",attrs:{"href":"/en"}},[_vm._v("Show Me Something Else!")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number mt-3"},[_vm._v("3 of 3")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share--quiz"},[_c('p',{staticClass:"h3 mr-3"},[_vm._v("Share:")]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"/assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"/assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('img',{attrs:{"src":"/assets/share/mail.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#0"}},[_c('img',{attrs:{"src":"/assets/share/copy-link.svg"}})])])])])],1),_vm._v(" "),_c('div',{staticClass:"c-hero-card-snackable__media"},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"c-hero-card-snackable__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?1'),expression:"'//placeimg.com/1200/600/any?1'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('div',{staticClass:"c-hero-card-snackable__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?2'),expression:"'//placeimg.com/1200/600/any?2'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"c-hero-card-snackable__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?3'),expression:"'//placeimg.com/1200/600/any?3'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7e7c492_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listicle_vue__ = __webpack_require__(1276);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7e7c492_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listicle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aha-transition-group',{staticClass:"c-hero-card-snackable"},[_c('div',{staticClass:"c-hero-card-snackable__container"},[_c('div',{staticClass:"c-hero-card-snackable__content",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"c-daily-journey"},[_c('p',{staticClass:"c-daily-journey__slide-number mb-1"},[_vm._v("1 of 3")]),_vm._v(" "),_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("5 Great Excercises For You")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate. ")])]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                            Next\n                        ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('p',{staticClass:"c-daily-journey__slide-number mb-1"},[_vm._v("2 of 3")]),_vm._v(" "),_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("#1: Yoga")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate. ")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"1","event-item-id":"12345","event-text":"eventText"}},[_vm._v("\n                            Back\n                        ")]),_vm._v(" "),_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","event-item-id":"12345","event-text":"eventText"}},[_vm._v("\n                            Next\n                        ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"c-daily-journey"},[_c('div',{staticClass:"c-daily-journey__slide-number mb-1"},[_vm._v("3 of 3")]),_vm._v(" "),_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Share 5 Great Excercises For You")]),_vm._v(" "),_c('p',[_vm._v("\n                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate.\n                        ")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share c-daily-journey__button c-daily-journey__button--float-none pt-3"},[_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('img',{attrs:{"src":"assets/share/mail.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#0"}},[_c('img',{attrs:{"src":"assets/share/copy-link.svg"}})])]),_vm._v(" "),_c('a',{staticClass:"mt-3 c-cta--arrow c-cta",attrs:{"href":"/en"}},[_vm._v("Learn More About Health & Wellness")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"2","event-item-id":"12345","event-text":"eventText"}},[_vm._v("\n                                    Back\n                                ")])],1)])])])],1),_vm._v(" "),_c('div',{staticClass:"c-hero-card-snackable__media"},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"c-hero-card-snackable__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?1'),expression:"'//placeimg.com/1200/600/any?1'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('div',{staticClass:"c-hero-card-snackable__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?2'),expression:"'//placeimg.com/1200/600/any?2'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"c-hero-card-snackable__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?3'),expression:"'//placeimg.com/1200/600/any?3'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])])],1)])]),_vm._v(" "),_c('div',{staticClass:"p-5"}),_vm._v(" "),_c('h2',[_vm._v("No Background")]),_vm._v(" "),_c('aha-transition-group',{staticClass:"c-hero-card-snackable no-img"},[_c('div',{staticClass:"c-hero-card-snackable__container"},[_c('div',{staticClass:"c-hero-card-snackable__content",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"c-daily-journey"},[_c('p',{staticClass:"c-daily-journey__slide-number mb-1"},[_vm._v("1 of 3")]),_vm._v(" "),_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("5 Great Excercises For You")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate. ")])]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                            Next\n                        ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('p',{staticClass:"c-daily-journey__slide-number mb-1"},[_vm._v("2 of 3")]),_vm._v(" "),_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("#1: Yoga")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate. ")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"1","event-item-id":"12345","event-text":"eventText"}},[_vm._v("\n                            Back\n                        ")]),_vm._v(" "),_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","event-item-id":"12345","event-text":"eventText"}},[_vm._v("\n                            Next\n                        ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"c-daily-journey"},[_c('div',{staticClass:"c-daily-journey__slide-number mb-1"},[_vm._v("3 of 3")]),_vm._v(" "),_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Share 5 Great Excercises For You")]),_vm._v(" "),_c('p',[_vm._v("\n                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate.\n                        ")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share c-daily-journey__button c-daily-journey__button--float-none pt-3"},[_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('img',{attrs:{"src":"assets/share/mail.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#0"}},[_c('img',{attrs:{"src":"assets/share/copy-link.svg"}})])]),_vm._v(" "),_c('a',{staticClass:"mt-3 c-cta--arrow c-cta",attrs:{"href":"/en"}},[_vm._v("Learn More About Health & Wellness")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"2","event-item-id":"12345","event-text":"eventText"}},[_vm._v("\n                                    Back\n                                ")])],1)])])])],1)])]),_vm._v(" "),_c('div',{staticClass:"p-5"}),_vm._v(" "),_c('h2',[_vm._v("Strip Down for Widgets and Modal")]),_vm._v(" "),_c('aha-transition-group',{staticClass:"c-hero-card-snackable"},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"c-daily-journey"},[_c('p',{staticClass:"c-daily-journey__slide-number mb-1"},[_vm._v("1 of 3")]),_vm._v(" "),_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("5 Great Excercises For You")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate. ")])]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                    Next\n                ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('p',{staticClass:"c-daily-journey__slide-number mb-1"},[_vm._v("2 of 3")]),_vm._v(" "),_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("#1: Yoga")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate. ")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"1","event-item-id":"12345","event-text":"eventText"}},[_vm._v("\n                    Back\n                ")]),_vm._v(" "),_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","event-item-id":"12345","event-text":"eventText"}},[_vm._v("\n                    Next\n                ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"c-daily-journey"},[_c('div',{staticClass:"c-daily-journey__slide-number mb-1"},[_vm._v("3 of 3")]),_vm._v(" "),_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Share 5 Great Excercises For You")]),_vm._v(" "),_c('p',[_vm._v("\n                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate.\n                ")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share c-daily-journey__button c-daily-journey__button--float-none pt-3"},[_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('img',{attrs:{"src":"assets/share/mail.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#0"}},[_c('img',{attrs:{"src":"assets/share/copy-link.svg"}})])]),_vm._v(" "),_c('a',{staticClass:"mt-3 c-cta--arrow c-cta",attrs:{"href":"/en"}},[_vm._v("Learn More About Health & Wellness")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"2","event-item-id":"12345","event-text":"eventText"}},[_vm._v("\n                            Back\n                        ")])],1)])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07c6385f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_intro_banner_vue__ = __webpack_require__(1278);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07c6385f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_intro_banner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"c-intro-banner"},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-intro-banner__media-wrapper col-md-6"},[_c('img',{attrs:{"src":"assets\\images\\life-is-why.png","alt":"Life is Why Logo"}})]),_vm._v(" "),_c('span',{staticClass:"c-intro-banner__slash"}),_vm._v(" "),_c('div',{staticClass:"c-intro-banner__content-wrapper col-md-6"},[_c('p',{staticClass:"c-intro-banner__content"},[_vm._v("\n            Lorem ipsum dolor sit amet consectetur adipisicing elit.\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"c-sponsor"},[_c('div',{staticClass:"media"},[_c('a',{staticClass:"align-self-center",attrs:{"href":""}},[_c('img',{attrs:{"src":"http://via.placeholder.com/64x200","width":"64","height":"200","alt":"Best Nonprofits to Work for 2010 to 2017 logo"}})]),_vm._v(" "),_c('div',{staticClass:"c-sponsor__link mx-3"}),_vm._v(" "),_c('div',{staticClass:"c-sponsor__logo align-self-center media-body"},[_c('p',[_vm._v("\n            Pellentesque habitant morbi tristique senectus et netus et\n            malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat\n            vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit\n            amet quam egestas semper. Aenean ultricies mi vitae est. Mauris\n            placerat eleifend leo. Pellentesque habitant morbi tristique\n            senectus et netus et malesuada fames ac turpis egestas. Vestibulum\n            tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante.\n            Donec eu libero sit amet quam egestas semper. Aenean ultricies mi\n            vitae est. Mauris placerat eleifend leo.\n          ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ea399ab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_counter_component_vue__ = __webpack_require__(1280);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ea399ab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_counter_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-counter-component"},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"d-flex col-xl-5"},[_c('p',{staticClass:"c-counter-component__content"},[_c('strong',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit.")]),_vm._v("\n                    Nulla dui quam, iaculis at orci vitae.\n                    "),_c('a',{staticClass:"c-counter-component__link",attrs:{"href":"#"}},[_vm._v("Dolor Sit")]),_vm._v(" | "),_c('a',{staticClass:"c-counter-component__link",attrs:{"href":"#"}},[_vm._v("Amet Elit")])])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-xl-3"},[_c('div',{staticClass:"c-counter-component__wrapper"},[_c('p',{staticClass:"c-counter-component__supertext"}),_vm._v(" "),_c('p',{staticClass:"c-counter-component__feature"},[_vm._v("60%")])]),_vm._v(" "),_c('p',{staticClass:"c-counter-component__subtext"},[_vm._v("in January")])]),_vm._v(" "),_c('div',{staticClass:"col-6 d-flex flex-column col-xl-4"},[_c('div',{staticClass:"c-counter-component__wrapper"},[_c('p',{staticClass:"c-counter-component__supertext"},[_vm._v("$")]),_vm._v(" "),_c('p',{staticClass:"c-counter-component__feature"},[_vm._v("800k")])]),_vm._v(" "),_c('p',{staticClass:"c-counter-component__subtext"},[_vm._v("Raised in 2020")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27ed9030_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multi_logo_component_vue__ = __webpack_require__(1282);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27ed9030_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multi_logo_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-multi-logo-component"},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-2 col-6 col-xl-6"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-250\\charge-running.png","alt":"Orange Theory"}})]),_vm._v(" "),_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-2 col-6 col-xl-6"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-250\\white-and-warren.png","alt":"Orange Theory"}})]),_vm._v(" "),_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-2 col-6 col-xl-6"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-250\\charge-running.png","alt":"Orange Theory"}})])]),_vm._v(" "),_c('div',{staticClass:"row row--desaturate"},[_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-4 col-6 col-xl-3"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-250\\big-lots.png","alt":"Orange Theory"}})]),_vm._v(" "),_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-4 col-6 col-xl-3"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-250\\aimbridge.png","alt":"Orange Theory"}})]),_vm._v(" "),_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-4 col-6 col-xl-3"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-250\\white-and-warren.png","alt":"Orange Theory"}})]),_vm._v(" "),_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-4 col-6 col-xl-3"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-250\\amazing-cosmetics.png","alt":"Orange Theory"}})]),_vm._v(" "),_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-4 col-6 col-xl-3"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-250\\k-g.png","alt":"Orange Theory"}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-6 col-6 col-xl-2"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-150\\k-g.png","alt":"Orange Theory"}})]),_vm._v(" "),_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-6 col-6 col-xl-2"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-150\\bam_books.png","alt":"Orange Theory"}})]),_vm._v(" "),_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-6 col-6 col-xl-2"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-150\\brahmin.png","alt":"Orange Theory"}})]),_vm._v(" "),_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-6 col-6 col-xl-2"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-150\\k-g.png","alt":"Orange Theory"}})]),_vm._v(" "),_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-6 col-6 col-xl-2"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-150\\k-g.png","alt":"Orange Theory"}})]),_vm._v(" "),_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-6 col-6 col-xl-2"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-150\\k-g.png","alt":"Orange Theory"}})]),_vm._v(" "),_c('div',{staticClass:"c-multi-logo-component__brand-logos c-multi-logo-component__brand-logos--only-6 col-6 col-xl-2"},[_c('img',{staticClass:"c-multi-logo-component__image",attrs:{"src":"assets\\images\\brand-logos-150\\k-g.png","alt":"Orange Theory"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36ccf90d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_flip_card_component_vue__ = __webpack_require__(1284);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36ccf90d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_flip_card_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"c-flip-cards"},[_c('div',{staticClass:"c-flip-cards__card"},[_c('div',{staticClass:"c-flip-cards__inner"},[_c('div',{staticClass:"c-flip-cards__front",attrs:{"tabindex":"0"}},[_c('img',{staticClass:"c-flip-cards__image",attrs:{"src":"assets\\images\\brand-logos-250\\advance-auto-parts.png","alt":"Brand Logo"}})]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__back"},[_c('a',{staticClass:"c-flip-cards__link",attrs:{"href":"https://www.google.com","target":"_blank"}},[_vm._v("In February, Amazing Cosmetics will support the American Heart Association by inviting customers to donate in support of the AHA.")])])])]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__card"},[_c('div',{staticClass:"c-flip-cards__inner"},[_c('div',{staticClass:"c-flip-cards__front",attrs:{"tabindex":"0"}},[_c('img',{staticClass:"c-flip-cards__image",attrs:{"src":"assets\\images\\brand-logos-250\\aimbridge.png","alt":"Brand Logo"}})]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__back"},[_c('a',{staticClass:"c-flip-cards__link",attrs:{"href":"https://www.google.com","target":"_blank"}},[_vm._v("\n                        During the month of February and throughout the year, Orangetheory Fitness will engage their members and their communities by offering donation-only classes in support of the American Heart Association.\n                       ")])])])]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__card"},[_c('div',{staticClass:"c-flip-cards__inner"},[_c('div',{staticClass:"c-flip-cards__front",attrs:{"tabindex":"0"}},[_c('img',{staticClass:"c-flip-cards__image",attrs:{"src":"assets\\images\\brand-logos-250\\amazing-cosmetics.png","alt":"Brand Logo"}})]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__back"},[_c('a',{staticClass:"c-flip-cards__link",attrs:{"href":"https://www.google.com","target":"_blank"}},[_vm._v("In February, Amazing Cosmetics will support the American Heart Association by inviting customers to donate in support of the AHA.")])])])]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__card"},[_c('div',{staticClass:"c-flip-cards__inner"},[_c('div',{staticClass:"c-flip-cards__front",attrs:{"tabindex":"0"}},[_c('img',{staticClass:"c-flip-cards__image",attrs:{"src":"assets\\images\\brand-logos-250\\americanqueen.png","alt":"Brand Logo"}})]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__back"},[_c('a',{staticClass:"c-flip-cards__link",attrs:{"href":"https://www.google.com","target":"_blank"}},[_vm._v("In February, Amazing Cosmetics will support the American Heart Association by inviting customers to donate in support of the AHA.")])])])]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__card"},[_c('div',{staticClass:"c-flip-cards__inner"},[_c('div',{staticClass:"c-flip-cards__front",attrs:{"tabindex":"0"}},[_c('img',{staticClass:"c-flip-cards__image",attrs:{"src":"assets\\images\\brand-logos-250\\bam_books.png","alt":"Brand Logo"}})]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__back"},[_c('a',{staticClass:"c-flip-cards__link",attrs:{"href":"https://www.google.com","target":"_blank"}},[_vm._v("In February, Amazing Cosmetics will support the American Heart Association by inviting customers to donate in support of the AHA.")])])])]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__card"},[_c('div',{staticClass:"c-flip-cards__inner"},[_c('div',{staticClass:"c-flip-cards__front",attrs:{"tabindex":"0"}},[_c('img',{staticClass:"c-flip-cards__image",attrs:{"src":"assets\\images\\brand-logos-250\\belk.png","alt":"Brand Logo"}})]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__back"},[_c('a',{staticClass:"c-flip-cards__link",attrs:{"href":"https://www.google.com","target":"_blank"}},[_vm._v("In February, Amazing Cosmetics will support the American Heart Association by inviting customers to donate in support of the AHA.")])])])]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__card"},[_c('div',{staticClass:"c-flip-cards__inner"},[_c('div',{staticClass:"c-flip-cards__front",attrs:{"tabindex":"0"}},[_c('img',{staticClass:"c-flip-cards__image",attrs:{"src":"assets\\images\\brand-logos-250\\big-lots.png","alt":"Brand Logo"}})]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__back"},[_c('a',{staticClass:"c-flip-cards__link",attrs:{"href":"https://www.google.com","target":"_blank"}},[_vm._v("In February, Amazing Cosmetics will support the American Heart Association by inviting customers to donate in support of the AHA.")])])])]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__card"},[_c('div',{staticClass:"c-flip-cards__inner"},[_c('div',{staticClass:"c-flip-cards__front"},[_c('img',{staticClass:"c-flip-cards__image",attrs:{"src":"assets\\images\\brand-logos-250\\brahmin.png","alt":"Brand Logo"}})]),_vm._v(" "),_c('div',{staticClass:"c-flip-cards__back"},[_c('a',{staticClass:"c-flip-cards__link",attrs:{"href":"https://www.google.com","target":"_blank"}},[_vm._v("In February, Amazing Cosmetics will support the American Heart Association by inviting customers to donate in support of the AHA.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b260ff1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_color_coded_table_vue__ = __webpack_require__(1286);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b260ff1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_color_coded_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-coded-table",attrs:{"id":"id123"}},[_c('div',{staticClass:"container color-coded-table__container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"color-coded-table__table"},[_c('caption',[_vm._v("Recommendations for anticipating resuscitation needs")]),_vm._v(" "),_c('thead',[_c('tr',[_c('th',{staticClass:"ecc-bg--gray",attrs:{"scope":"col","id":"hdr-cor"}},[_vm._v("COR")]),_vm._v(" "),_c('th',{staticClass:"ecc-bg--gray",attrs:{"scope":"col","id":"hdr-loe"}},[_vm._v("LOE")]),_vm._v(" "),_c('th',{staticClass:"ecc-bg--gray",attrs:{"scope":"col","id":"hdr-rec"}},[_vm._v("Recommendations")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',{staticClass:"ecc-bg--cor-1",attrs:{"id":"hdr-cor-1","scope":"row"}},[_vm._v("1")]),_vm._v(" "),_c('th',{staticClass:"ecc-bg--loe-br",attrs:{"id":"hdr-loe-br","scope":"row"}},[_vm._v("B-R")]),_vm._v(" "),_c('td',{attrs:{"headers":"hdr-cor hdr-cor-1 hdr-loe hdr-loe-br hdr-rec"}},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed dolorum ullam ab perferendis quos alias cupiditate! Suscipit eius nemo cupiditate sunt tempora quod, veritatis, impedit excepturi quaerat incidunt ullam necessitatibus.")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"ecc-bg--cor-1",attrs:{"id":"hdr-cor-1-1","scope":"row"}},[_vm._v("1")]),_vm._v(" "),_c('th',{staticClass:"ecc-bg--loe-cld",attrs:{"id":"hdr-cld","scope":"row"}},[_vm._v("C-LD")]),_vm._v(" "),_c('td',{attrs:{"headers":"hdr-cor hdr-loe hdr-cor-1-1 hdr-cld hdr-rec"}},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed dolorum ullam ab perferendis quos alias cupiditate! Suscipit eius nemo cupiditate sunt tempora quod, veritatis, impedit excepturi quaerat incidunt ullam necessitatibus.")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"ecc-bg--cor-2a",attrs:{"id":"hdr-2a","scope":"row"}},[_vm._v("2a")]),_vm._v(" "),_c('th',{staticClass:"ecc-bg--loe-a",attrs:{"id":"hdr-a","scope":"row"}},[_vm._v("A")]),_vm._v(" "),_c('td',{attrs:{"headers":"hdr-cor hdr-2a hdr-loe hdr-a hdr-rec"}},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed dolorum ullam ab perferendis quos alias cupiditate! Suscipit eius nemo cupiditate sunt tempora quod, veritatis, impedit excepturi quaerat incidunt ullam necessitatibus.")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"ecc-bg--cor-2b",attrs:{"id":"hdr-2b","scope":"row"}},[_vm._v("2b")]),_vm._v(" "),_c('th',{staticClass:"ecc-bg--loe-bnr",attrs:{"id":"hdr-bnr","scope":"row"}},[_vm._v("B-NR")]),_vm._v(" "),_c('td',{attrs:{"headers":"hdr-cor hdr-2b hdr-loe hdr-bnr hdr-rec"}},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed dolorum ullam ab perferendis quos alias cupiditate! Suscipit eius nemo cupiditate sunt tempora quod, veritatis, impedit excepturi quaerat incidunt ullam necessitatibus.")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"ecc-bg--cor-3harm",attrs:{"id":"hdr-3harm","scope":"row"}},[_vm._v("3:Harm")]),_vm._v(" "),_c('th',{staticClass:"ecc-bg--loe-ceo",attrs:{"id":"hdr-ceo","scope":"row"}},[_vm._v("C-EO")]),_vm._v(" "),_c('td',{attrs:{"headers":"hdr-cor hdr-3harm hdr-loe hdr-ceo hdr-rec"}},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed dolorum ullam ab perferendis quos alias cupiditate! Suscipit eius nemo cupiditate sunt tempora quod, veritatis, impedit excepturi quaerat incidunt ullam necessitatibus.")])])]),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"3"}},[_c('div',{staticClass:"color-coded-legend"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('h2',{staticClass:"h4 ecc-bg--gray color-coded-legend__header"},[_vm._v("\n                                                CLASS (STRENGTH) OF RECOMMENDATION")]),_vm._v(" "),_c('div',{staticClass:"ecc-bg--cor-1 color-coded-legend__box"},[_c('h3',{staticClass:"h5 color-coded-legend__box-header"},[_vm._v("\n                                                    CLASS 1 (STRONG) "),_c('span',[_vm._v("Benefit >>> Risk")])]),_vm._v(" "),_c('div',{staticClass:"color-coded-legend__box-content"},[_c('p',[_vm._v("Suggested phases for writing recommendations:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("High-quality evidence from more than 1 RCT")]),_vm._v(" "),_c('li',[_vm._v("Meta-analyses of high-quality RCTs\n                                                            "),_c('ul',[_c('li',[_vm._v("Meta-analyses of high-quality RCTs")]),_vm._v(" "),_c('li',[_vm._v("One or more RCTs corroborated by high-quality registry studies")])])]),_vm._v(" "),_c('li',[_vm._v("Meta-analyses of high-quality RCTs")]),_vm._v(" "),_c('li',[_vm._v("One or more RCTs corroborated by high-quality registry studies")])])])]),_vm._v(" "),_c('div',{staticClass:"ecc-bg--cor-2a color-coded-legend__box"},[_c('h3',{staticClass:"h5 color-coded-legend__box-header"},[_vm._v("\n                                                    CLASS 2a (MODERATE) "),_c('span',[_vm._v("Benefit >> Risk")])]),_vm._v(" "),_c('div',{staticClass:"color-coded-legend__box-content"},[_c('p',[_vm._v("Suggested phases for writing recommendations:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("High-quality evidence from more than 1 RCT")]),_vm._v(" "),_c('li',[_vm._v("Meta-analyses of high-quality RCTs")]),_vm._v(" "),_c('li',[_vm._v("One or more RCTs corroborated by high-quality registry studies")])])])]),_vm._v(" "),_c('div',{staticClass:"ecc-bg--cor-2b color-coded-legend__box"},[_c('h3',{staticClass:"h5 color-coded-legend__box-header"},[_vm._v("\n                                                    CLASS 2b (WEAK) "),_c('span',[_vm._v("Benefit > Risk")])]),_vm._v(" "),_c('div',{staticClass:"color-coded-legend__box-content"},[_c('p',[_vm._v("Suggested phases for writing recommendations:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("High-quality evidence from more than 1 RCT")]),_vm._v(" "),_c('li',[_vm._v("Meta-analyses of high-quality RCTs")]),_vm._v(" "),_c('li',[_vm._v("One or more RCTs corroborated by high-quality registry studies")])])])]),_vm._v(" "),_c('div',{staticClass:"ecc-bg--cor-3nobenefit color-coded-legend__box"},[_c('h3',{staticClass:"h5 color-coded-legend__box-header"},[_vm._v("\n                                                    CLASS 3: No Benefit (WEAK) "),_c('span',[_vm._v("Benefit = Risk")])]),_vm._v(" "),_c('p',[_vm._v("Decidedly LOE A or B user web")]),_vm._v(" "),_c('div',{staticClass:"color-coded-legend__box-content"},[_c('p',[_vm._v("Suggested phases for writing recommendations:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("High-quality evidence from more than 1 RCT")]),_vm._v(" "),_c('li',[_vm._v("Meta-analyses of high-quality RCTs")]),_vm._v(" "),_c('li',[_vm._v("One or more RCTs corroborated by high-quality registry studies")])])])]),_vm._v(" "),_c('div',{staticClass:"ecc-bg--cor-3harm color-coded-legend__box"},[_c('h3',{staticClass:"h5 color-coded-legend__box-header"},[_vm._v("\n                                                    CLASS III: Harm (STRONG) "),_c('span',[_vm._v("Risk > Benefit")])]),_vm._v(" "),_c('div',{staticClass:"color-coded-legend__box-content"},[_c('p',[_vm._v("Suggested phases for writing recommendations:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("High-quality evidence from more than 1 RCT")]),_vm._v(" "),_c('li',[_vm._v("Meta-analyses of high-quality RCTs")]),_vm._v(" "),_c('li',[_vm._v("One or more RCTs corroborated by high-quality registry studies")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('h2',{staticClass:"h4 ecc-bg--gray color-coded-legend__header"},[_vm._v("\n                                                LEVEL (QUALITY) OF EVIDENCE")]),_vm._v(" "),_c('div',{staticClass:"ecc-bg--loe-a color-coded-legend__box"},[_c('h3',{staticClass:"h5 color-coded-legend__box-header"},[_vm._v("\n                                                    LEVEL A")]),_vm._v(" "),_c('div',{staticClass:"color-coded-legend__box-content"},[_c('ul',[_c('li',[_vm._v("High-quality evidence from more than 1 RCT")]),_vm._v(" "),_c('li',[_vm._v("Meta-analyses of high-quality RCTs")]),_vm._v(" "),_c('li',[_vm._v("One or more RCTs corroborated by high-quality registry studies")])])])]),_vm._v(" "),_c('div',{staticClass:"ecc-bg--loe-br color-coded-legend__box"},[_c('h3',{staticClass:"h5 color-coded-legend__box-header"},[_vm._v("\n                                                    LEVEL B-R "),_c('span',[_vm._v("(Randomized)")])]),_vm._v(" "),_c('div',{staticClass:"color-coded-legend__box-content"},[_c('ul',[_c('li',[_vm._v("High-quality evidence from more than 1 RCT")]),_vm._v(" "),_c('li',[_vm._v("Meta-analyses of high-quality RCTs")]),_vm._v(" "),_c('li',[_vm._v("One or more RCTs corroborated by high-quality registry studies")])])])]),_vm._v(" "),_c('div',{staticClass:"ecc-bg--loe-bnr color-coded-legend__box"},[_c('h3',{staticClass:"h5 color-coded-legend__box-header"},[_vm._v("\n                                                    LEVEL B-NR "),_c('span',[_vm._v("(Nonrandomized)")])]),_vm._v(" "),_c('div',{staticClass:"color-coded-legend__box-content"},[_c('ul',[_c('li',[_vm._v("High-quality evidence from more than 1 RCT")]),_vm._v(" "),_c('li',[_vm._v("Meta-analyses of high-quality RCTs")]),_vm._v(" "),_c('li',[_vm._v("One or more RCTs corroborated by high-quality registry studies")])])])]),_vm._v(" "),_c('div',{staticClass:"ecc-bg--loe-cld color-coded-legend__box"},[_c('h3',{staticClass:"h5 color-coded-legend__box-header"},[_vm._v("\n                                                    LEVEL C-LD "),_c('span',[_vm._v("(Limited Data)")])]),_vm._v(" "),_c('div',{staticClass:"color-coded-legend__box-content"},[_c('ul',[_c('li',[_vm._v("High-quality evidence from more than 1 RCT")]),_vm._v(" "),_c('li',[_vm._v("Meta-analyses of high-quality RCTs")]),_vm._v(" "),_c('li',[_vm._v("One or more RCTs corroborated by high-quality registry studies")])])])]),_vm._v(" "),_c('div',{staticClass:"ecc-bg--loe-ceo color-coded-legend__box"},[_c('h3',{staticClass:"h5 color-coded-legend__box-header"},[_vm._v("\n                                                    LEVEL C-EO "),_c('span',[_vm._v("(Expert Opinion)")])]),_vm._v(" "),_c('div',{staticClass:"color-coded-legend__box-content"},[_c('p',[_vm._v("Consensus of expert opinion based on clinical experience")])])]),_vm._v(" "),_c('div',{staticClass:"color-coded-legend__content"},[_c('p',[_vm._v("Consensus of expert opinion based on clinical experience")])])])])])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_516e7b7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ecc_search_vue__ = __webpack_require__(1288);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_516e7b7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ecc_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"l-article__widget ecc-search",attrs:{"aria-label":"Search Guidelines"}},[_c('aha-search-results-form',{staticClass:"c-side-search c-side-search--ecc-side",attrs:{"action":"/en/search","query-delimeter":"#","role":"search"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('input',{directives:[{name:"input",rawName:"v-input.flagged",value:('q'),expression:"'q'",modifiers:{"flagged":true}}],staticClass:"c-side-search__input",attrs:{"type":"text","id":"eccGuidelinesSearch","placeholder":"Search Guidelines...","title":"Insert a query. Press enter to send","aria-label":"Insert a query. Press enter to send","name":"q"},on:{"enter":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}}),_vm._v(" "),_c('label',{staticClass:"c-side-search__label mr-0",attrs:{"for":"eccGuidelinesSearch"}},[_vm._v("\n                        Search\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-round btn-primary c-side-search__btn",attrs:{"label":"Search button."},on:{"click":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24px","height":"24px","viewBox":"0 0 23.414101 23.414062"}},[_c('g',{attrs:{"transform":"translate(-1358,-18)"}},[_c('path',{attrs:{"d":"m 1374.4004,32.986328 -1.4141,1.414063 0.7071,0.707031 5.5996,5.599609 0.707,0.707031 1.4141,-1.414062 -0.7071,-0.707031 -5.5996,-5.59961 z"}}),_vm._v(" "),_c('path',{attrs:{"d":"m 1368,18 c -5.511,0 -10,4.488997 -10,10 0,5.511003 4.489,10 10,10 5.511,0 10,-4.488997 10,-10 0,-5.511003 -4.489,-10 -10,-10 z m 0,2 c 4.4301,0 8,3.569877 8,8 0,4.430123 -3.5699,8 -8,8 -4.4301,0 -8,-3.569877 -8,-8 0,-4.430123 3.5699,-8 8,-8 z"}})])])])])])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06fb24c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nested_accordion_vue__ = __webpack_require__(1290);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06fb24c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nested_accordion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"nested-accordion",rawName:"v-nested-accordion"}],staticClass:"nested-accordion"},[_c('div',{staticClass:"container nested-accordion__container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 pl-0 nested-accordion__toggle-all-container"},[_c('b-button',{staticClass:"nested-accordion__toggle-all",attrs:{"onclick":"toggleNestedAccordions()"}},[_vm._v("Expand All "),_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("+")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 nested-accordion__accordion-container js-nested-accordion"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.heading-1",modifiers:{"heading-1":true}}],staticClass:"nested-accordion__toggle-button"},[_c('span',{staticClass:"nested-accordion__heading-number"},[_vm._v("1")]),_vm._v("Heading 1: Very Long Heading Text Here To Show What Can Happen When A Heading Title Is Really Really Long")]),_vm._v(" "),_c('b-collapse',{staticClass:"nested-accordion__collapse nested-accordion__collapse--container",attrs:{"id":"heading-1"}},[_c('b-card',{staticClass:"nested-accordion__card"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.heading-1-1",modifiers:{"heading-1-1":true}}],staticClass:"nested-accordion__toggle-button"},[_c('span',{staticClass:"nested-accordion__heading-number"},[_vm._v("1.1")]),_vm._v("Heading 1-1: Very Long Heading Text Here To Show What Can Happen When A Heading Title Is Really Really Long Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptatum beatae ab optio, necessitatibus aut deserunt impedit fugiat reiciendis nulla adipisci! Voluptates deleniti ab debitis natus saepe, suscipit odit facilis obcaecati.")]),_vm._v(" "),_c('b-collapse',{staticClass:"nested-accordion__collapse nested-accordion__collapse--container",attrs:{"id":"heading-1-1"}},[_c('b-card',{staticClass:"nested-accordion__card"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.heading-1-1-1",modifiers:{"heading-1-1-1":true}}],staticClass:"nested-accordion__toggle-button"},[_c('span',{staticClass:"nested-accordion__heading-number"},[_vm._v("1.1.1")]),_vm._v("Heading 1-1-1")]),_vm._v(" "),_c('b-collapse',{staticClass:"nested-accordion__collapse nested-accordion__collapse--content",attrs:{"id":"heading-1-1-1"}},[_c('p',{staticClass:"mt-3"},[_vm._v("1-1-1 Content Lorem ipsum dolor sit, amet consectetur adipisicing elit. Inventore doloribus odio tenetur ad laborum maxime ab ex placeat nesciunt ducimus enim natus recusandae velit accusantium, magni fuga reiciendis, provident vero?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iste corrupti reprehenderit velit sequi est ea aut id similique dicta earum veniam, impedit a magni numquam possimus maiores doloribus fugiat incidunt.")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Est non, consectetur sunt eligendi quia obcaecati dolore excepturi omnis veritatis ab quod rem iusto repudiandae aliquid. Minima ducimus voluptas magnam eveniet?")]),_vm._v(" "),_c('button',[_vm._v("Content Button")]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Est non, consectetur sunt eligendi quia obcaecati dolore excepturi omnis veritatis ab quod rem iusto repudiandae aliquid. Minima ducimus voluptas magnam eveniet?")])])],1)],1),_vm._v(" "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.heading-1-2",modifiers:{"heading-1-2":true}}],staticClass:"nested-accordion__toggle-button"},[_c('span',{staticClass:"nested-accordion__heading-number"},[_vm._v("1.2")]),_vm._v("Heading 1-2: Very Long Heading Text Here To Show What Can Happen When")]),_vm._v(" "),_c('b-collapse',{staticClass:"nested-accordion__collapse nested-accordion__collapse--container",attrs:{"id":"heading-1-2"}},[_c('b-card',{staticClass:"nested-accordion__card"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.heading-1-2-1",modifiers:{"heading-1-2-1":true}}],staticClass:"nested-accordion__toggle-button"},[_c('span',{staticClass:"nested-accordion__heading-number"},[_vm._v("1.2.1")]),_vm._v("Heading 1-2-1")]),_vm._v(" "),_c('b-collapse',{staticClass:"nested-accordion__collapse nested-accordion__collapse--container",attrs:{"id":"heading-1-2-1"}},[_c('b-card',{staticClass:"nested-accordion__card"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.heading-1-2-1-1",modifiers:{"heading-1-2-1-1":true}}],staticClass:"nested-accordion__toggle-button"},[_c('span',{staticClass:"nested-accordion__heading-number"},[_vm._v("1.2.1-1")]),_vm._v("Heading 1-2-1-1")]),_vm._v(" "),_c('b-collapse',{staticClass:"nested-accordion__collapse nested-accordion__collapse--container",attrs:{"id":"heading-1-2-1-1"}},[_c('b-card',{staticClass:"nested-accordion__card"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.heading-1-2-1-1-1",modifiers:{"heading-1-2-1-1-1":true}}],staticClass:"nested-accordion__toggle-button"},[_c('span',{staticClass:"nested-accordion__heading-number"},[_vm._v("1.2.1-1-1")]),_vm._v("Heading 1-2-1-1-1")]),_vm._v(" "),_c('b-collapse',{staticClass:"nested-accordion__collapse nested-accordion__collapse--content",attrs:{"id":"heading-1-2-1-1-1"}},[_c('p',[_vm._v("1-2-1-1-1 Content")])])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.heading-2",modifiers:{"heading-2":true}}],staticClass:"nested-accordion__toggle-button"},[_c('span',{staticClass:"nested-accordion__heading-number"},[_vm._v("2")]),_vm._v("Heading 2: Color Coded Table")]),_vm._v(" "),_c('b-collapse',{staticClass:"nested-accordion__collapse nested-accordion__collapse--container",attrs:{"id":"heading-2"}},[_c('b-card',{staticClass:"nested-accordion__card"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.heading-2-1",modifiers:{"heading-2-1":true}}],staticClass:"nested-accordion__toggle-button"},[_c('span',{staticClass:"nested-accordion__heading-number"},[_vm._v("2-1")]),_vm._v("Heading 2-1: Color Coded Table")]),_vm._v(" "),_c('b-collapse',{staticClass:"nested-accordion__collapse nested-accordion__collapse--content",attrs:{"id":"heading-2-1"}},[_c('color-coded-table')],1),_vm._v(" "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.heading-2-2",modifiers:{"heading-2-2":true}}],staticClass:"nested-accordion__toggle-button"},[_c('span',{staticClass:"nested-accordion__heading-number"},[_vm._v("2-2")]),_vm._v("Heading 2-2")]),_vm._v(" "),_c('b-collapse',{staticClass:"nested-accordion__collapse nested-accordion__collapse--container",attrs:{"id":"heading-2-2"}},[_c('b-card',{staticClass:"nested-accordion__card"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.heading-2-2-1",modifiers:{"heading-2-2-1":true}}],staticClass:"nested-accordion__toggle-button"},[_c('span',{staticClass:"nested-accordion__heading-number"},[_vm._v("2.2.1")]),_vm._v("Heading 2-2-1")]),_vm._v(" "),_c('b-collapse',{staticClass:"nested-accordion__collapse nested-accordion__collapse--content",attrs:{"id":"heading-2-2-1"}},[_c('p',[_vm._v("2-2-1 Content")])])],1)],1)],1)],1),_vm._v(" "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.heading-3",modifiers:{"heading-3":true}}],staticClass:"nested-accordion__toggle-button"},[_c('span',{staticClass:"nested-accordion__heading-number"},[_vm._v("3")]),_vm._v("3 References Component")]),_vm._v(" "),_c('b-collapse',{staticClass:"nested-accordion__collapse nested-accordion__collapse--content",attrs:{"id":"heading-3"}},[_c('p',[_vm._v("References Component Shown Below")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? "),_c('a',{staticClass:"text-bold",attrs:{"href":"#uniqueID1"}},[_vm._v("Reference 1")]),_vm._v(" quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! "),_c('a',{staticClass:"text-bold",attrs:{"href":"#uniqueID2"}},[_vm._v("Reference 2")]),_vm._v(" dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? "),_c('a',{staticClass:"text-bold",attrs:{"href":"#uniqueID1"}},[_vm._v("Reference 1")]),_vm._v(" quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit "),_c('a',{staticClass:"text-bold",attrs:{"href":"#uniqueID3"}},[_vm._v("Reference 3")]),_vm._v("?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('ecc-references',{attrs:{"references":[
                        {
                            id: 'uniqueID1',
                            content: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est voluptatibus nobis nulla? Est, architecto quidem modi voluptatem magnam vitae perferendis expedita corrupti accusantium numquam nostrum illo quisquam perspiciatis, tempore provident!',
                            refnum: '1'
                        },
                        {
                            id: 'uniqueID2',
                            content: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est voluptatibus nobis nulla? Est, architecto quidem modi voluptatem magnam vitae perferendis expedita corrupti accusantium numquam nostrum illo quisquam perspiciatis, tempore provident!',
                            refnum: '2'
                        },
                        {
                            id: 'uniqueID3',
                            content: "<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. <a href='#'>quam nostrum</a> illo quisquam perspiciatis",
                            refnum: '2a'
                        },
                        {
                            id: 'uniqueID4',
                            content: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est voluptatibus nobis nulla? Est, architecto quidem modi voluptatem magnam vitae perferendis expedita corrupti accusantium numquam nostrum illo quisquam perspiciatis, tempore provident!',
                            refnum: '3'
                        },
                        {
                            id: 'uniqueID5',
                            content: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est voluptatibus nobis nulla? Est, architecto quidem modi voluptatem magnam vitae perferendis expedita corrupti accusantium numquam nostrum illo quisquam perspiciatis, tempore provident!',
                            refnum: '4'
                        },
                        {
                            id: 'uniqueID6',
                            content: "<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. <a href='#'>quam nostrum</a> illo quisquam perspiciatis",
                            refnum: '33a'
                        } ]}})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f9ee1c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_symptoms_vue__ = __webpack_require__(1292);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f9ee1c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_symptoms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"c-stroke-symptoms c-stroke-symptoms__items"},[_c('b-row',{staticClass:"d-flex c-stroke-symptoms__item justify-content-center",attrs:{"align-v":"center"}},[_c('b-container',{staticClass:"col-md-12 c-promo--shadow rounded py-4 px-5"},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"py-2",attrs:{"lg":"auto"}},[_c('img',{attrs:{"src":"assets/icons/laugh-icon.svg","width":"60","height":"60"}})]),_vm._v(" "),_c('b-col',{staticClass:"justify-content-center",attrs:{"md":"auto"}},[_c('h2',{staticClass:"m-0"},[_vm._v("Confusion")])]),_vm._v(" "),_c('b-col',[_vm._v("Sudden trouble walking, dizziness, loss of balance or coordination or anything in between that you can think of because this is where we can see and not see what the problem is! Sudden trouble walking, dizziness, loss of balance or coordination or anything in between that you can think of because this is where we can see and not see what the problem is! Sudden trouble walking, dizziness, loss of balance or coordination or anything in between that you can think of because this is where we can see and not see what the problem is!")])],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"d-flex c-stroke-symptoms__item justify-content-center",attrs:{"align-v":"center"}},[_c('b-container',{staticClass:"col-md-12 c-promo--shadow rounded py-4 px-5"},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"py-2",attrs:{"lg":"auto"}},[_c('img',{attrs:{"src":"assets/icons/laugh-icon.svg","width":"60","height":"60"}})]),_vm._v(" "),_c('b-col',{staticClass:"justify-content-center",attrs:{"md":"auto"}},[_c('h2',{staticClass:"m-0"},[_vm._v("Confusion")])]),_vm._v(" "),_c('b-col',[_vm._v("dmbshjfhdskjfhsdfhjksdfhkjdshfskjhhjk, consectetur adipiscing elit.")])],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"d-flex c-stroke-symptoms__item justify-content-center",attrs:{"align-v":"center"}},[_c('b-container',{staticClass:"col-md-12 c-promo--shadow rounded py-4 px-5"},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"py-2",attrs:{"lg":"auto"}},[_c('img',{attrs:{"src":"assets/icons/laugh-icon.svg","width":"60","height":"60"}})]),_vm._v(" "),_c('b-col',{staticClass:"justify-content-center",attrs:{"md":"auto"}},[_c('h2',{staticClass:"m-0"},[_vm._v("Confusion")])]),_vm._v(" "),_c('b-col',[_vm._v("dmbshjfhdskjfhsdfhjksdfhkjdshfskjhhjk, consectetur adipiscing elit.")])],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"d-flex c-stroke-symptoms__item justify-content-center arrow",attrs:{"align-v":"center"}},[_c('b-container',{staticClass:"col-md-12 c-promo--shadow rounded justify-content-center py-4 px-5 c-promo--bg h-theme--gray-light h-text-contrast"},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"py-2",attrs:{"lg":"auto"}},[_c('img',{attrs:{"src":"assets/icons/laugh-icon.svg","width":"60","height":"60"}})]),_vm._v(" "),_c('b-col',{staticClass:"justify-content-center",attrs:{"md":"auto"}},[_c('h2',{staticClass:"m-0"},[_vm._v("Confusion")])]),_vm._v(" "),_c('b-col',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit.")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-listbox"},[_c('div',{staticClass:"container article-listbox__container"},[_c('div',{staticClass:"article-listbox__wrapper phd-shadow-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-8 article-listbox__title"},[_c('h2',[_vm._v("Article Listbox Title")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 article-listbox__view-all"},[_c('a',{attrs:{"href":"#"}},[_vm._v("View All Article Listbox Title")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 article-listbox__content"},[_c('p',{staticClass:"article-listbox__item"},[_c('a',{staticClass:"article-listbox__item-link",attrs:{"href":"#"}},[_c('span',{staticClass:"article-listbox__item-title"},[_vm._v("Article Listbox List Item Link Title")]),_vm._v(" "),_c('span',{staticClass:"article-listbox__item-info"},[_vm._v("\n                                Date | Author: Name | brief description\n                            ")])])]),_vm._v(" "),_c('p',{staticClass:"article-listbox__item"},[_c('a',{staticClass:"article-listbox__item-link",attrs:{"href":"#"}},[_c('span',{staticClass:"article-listbox__item-title"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('span',{staticClass:"article-listbox__item-info"},[_vm._v("\n                                01/23/2020 | Author: Harry Copperfield Blackstone Dresden, Wizard | As Warden of Chicago, Wizard Dresden protects...\n                            ")])])]),_vm._v(" "),_c('p',{staticClass:"article-listbox__item"},[_c('a',{staticClass:"article-listbox__item-link",attrs:{"href":"#"}},[_c('span',{staticClass:"article-listbox__item-title"},[_vm._v("Pulmonary Embolism Management – The New Frontier for Interventional Therapies?")]),_vm._v(" "),_c('span',{staticClass:"article-listbox__item-info"},[_vm._v("\n                                11/08/2019 | Author: Sanjum S. Sethi, MD, MPH, and Sahil A. Parikh, MD | Pulmonary embolism (PE) remains the 3rd ...\n                            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('nav',{attrs:{"aria-label":"Pagination"}},[_c('ul',{staticClass:"pagination pagination-lg pagination--page-count pagination--right"},[_c('li',{staticClass:"page-item disabled"},[_c('a',{staticClass:"page-link",attrs:{"href":"","rel":"prev","aria-disabled":"true"}},[_c('i',{staticClass:"icon-left-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous Page")])])]),_vm._v(" "),_c('li',{staticClass:"page-item page-item--page-count"},[_c('span',{staticClass:"sr-only"},[_vm._v("Current Page ")]),_vm._v("1 of 10\n                            ")]),_vm._v(" "),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#","rel":"next"}},[_c('i',{staticClass:"icon-right-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next Page")])])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"phd-shadow-box"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('h6',[_vm._v("Find More")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"nav","role":"navigation","default-value":"Browse Journals","toggle-class":"btn btn-outline btn--select w-100"}},[_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"href":"#","tag":"a","role":"","text":"Journal 1","value":"Journal 1","item-class":"c-select-dropdown__item"}},[_vm._v("Journal 1")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"href":"#","tag":"a","role":"","text":"Journal 2 has a longer name for testing","value":"Journal 2 has a longer name for testing","item-class":"c-select-dropdown__item"}},[_vm._v("Journal 2 has a longer name for testing")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"href":"#","tag":"a","role":"","text":"Journal 3","value":"Journal 3","item-class":"c-select-dropdown__item"}},[_vm._v("Journal 3")])],1)],2)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-8"},[_c('h2',[_vm._v("Featured Journal Articles")]),_vm._v(" "),_c('ul',{staticClass:"article-list"},[_c('li',{staticClass:"article-list__item"},[_c('a',{staticClass:"news-list-title article-list__link",attrs:{"href":"#"}},[_vm._v("Endothelin: 30 Years From Discovery to Therapy")]),_vm._v(" "),_c('div',{staticClass:"journal-with-date article-list__item-info"},[_c('span',{staticClass:"article-list__item-category"},[_vm._v("Hypertension")]),_vm._v(" "),_c('span',{staticClass:"article-list__item-category"},[_vm._v("Example")]),_vm._v(" "),_c('span',{staticClass:"article-list__item-category"},[_vm._v("Another Ex")]),_vm._v(" "),_c('span',{staticClass:"article-list__item-date"},[_vm._v("12/01/2019")])])]),_vm._v(" "),_c('li',{staticClass:"article-list__item"},[_c('a',{staticClass:"news-list-title article-list__link",attrs:{"href":"#"}},[_vm._v("Opposing Age-Related Trends in Absolute and Relative Risk of Adverse Health Outcomes Associated With Out-of-Office Blood Pressure")]),_vm._v(" "),_c('div',{staticClass:"journal-with-date article-list__item-info"},[_c('span',{staticClass:"article-list__item-category"},[_vm._v("Hypertension")]),_vm._v(" "),_c('span',{staticClass:"article-list__item-date"},[_vm._v("12/01/2019")])])]),_vm._v(" "),_c('li',{staticClass:"article-list__item"},[_c('a',{staticClass:"news-list-title article-list__link",attrs:{"href":"#"}},[_vm._v("A Common Tag Nucleotide Variant in MMP7 Promoter Increases Risk for Hypertension via Enhanced Interactions With CREB (Cyclic AMP Response Element-Binding Protein) Transcription Factor")]),_vm._v(" "),_c('div',{staticClass:"journal-with-date article-list__item-info"},[_c('span',{staticClass:"article-list__item-category"},[_vm._v("Hypertension")]),_vm._v(" "),_c('span',{staticClass:"article-list__item-date"},[_vm._v("12/01/2019")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-horizontal"},[_c('div',{staticClass:"container ad-horizontal__container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('div',{staticClass:"ad-horizontal__wrapper"},[_c('div',{staticClass:"ad-horizontal__disclaimer"},[_c('a',{attrs:{"href":"/professional/General/UCM_490457_PHD-Ad-Disclaimer.jsp"}},[_vm._v("ADVERTISMENT")])]),_vm._v(" "),_c('div',{staticClass:"ad-horizontal__js-ad"},[_c('a',{staticClass:"twoclick",attrs:{"target":"_blank","href":"//www5.smartadserver.com/ac?jump=1&nwid=1541&siteid=264961&pgname=ros&fmtid=72402&visit=m&tmstp=[timestamp]&out=nonrich","speed-bump-set":""}},[_c('img',{attrs:{"alt":"advertisement","src":"//www5.smartadserver.com/ac?out=nonrich&nwid=1541&siteid=264961&pgname=ros&fmtid=72402&visit=m&tmstp=[timestamp]"}})])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cd14671_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_community_science_news_vue__ = __webpack_require__(1297);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cd14671_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_community_science_news_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"community-science-news"},[_c('div',{staticClass:"container community-science-news__container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 community-science-news__heading"},[_c('h2',[_vm._v("Science News")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"community-science-news__council-name h-color--red"},[_vm._v("ATVB")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("CIRCULATION RESEARCH | Featured Articles | November 2019")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("11/11/2019 | "),_c('span',{staticClass:"font-italic"},[_vm._v("CIRCULATION RESEARCH Featured articles for November 2019")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"community-science-news__council-name h-color--red"},[_vm._v("ATVB")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("CIRCULATION RESEARCH | Featured Articles | November 2019")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("11/11/2019 | "),_c('span',{staticClass:"font-italic"},[_vm._v("CIRCULATION RESEARCH Featured articles for November 2019")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"community-science-news__council-name h-color--red"},[_vm._v("ITAPE")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Interventional Therapies for Acute Pulmonary Embolism")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("11/11/2019 | "),_c('span',{staticClass:"font-italic"},[_vm._v("CIRCULATION RESEARCH Featured articles for November 2019")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"community-science-news__council-name h-color--red"},[_vm._v("ATVB")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("CIRCULATION RESEARCH | Featured Articles | November 2019")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("11/11/2019 | "),_c('span',{staticClass:"font-italic"},[_vm._v("CIRCULATION RESEARCH Featured articles for November 2019")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"community-science-news__council-name h-color--red"},[_vm._v("Electrophysiology and Arrhythmias")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Interventional Therapies for Acute Pulmonary Embolism")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("10/04/2019 | "),_c('span',{staticClass:"font-italic"},[_vm._v("Pulmonary embolism (PE) represents the third leading cause of cardiovascular mortality in the U.S.")])])])])]),_vm._v(" "),_c('div',{staticClass:"row community-science-news__view-all-row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red d-block community-science-news__view-all-link",attrs:{"href":""}},[_vm._v("View ATVB News")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red d-block community-science-news__view-all-link",attrs:{"href":""}},[_vm._v("View Electrophsiology & Arrythmias News")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red d-block community-science-news__view-all-link",attrs:{"href":""}},[_vm._v("View All Science News")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red d-block community-science-news__view-all-link",attrs:{"href":""}},[_vm._v("View All Science News")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fef510b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cta_bar_vue__ = __webpack_require__(1299);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fef510b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cta_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cta-bar d-flex justify-content-center flex-column flex-lg-row"},[_c('div',{staticClass:"cta-bar__content d-flex align-items-center text-center text-xl-left"},[_c('p',[_c('span',{staticClass:"text-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(", consectetur adipisicing elit. Corrupti nesciunt quas ea.")])]),_vm._v(" "),_c('a',{staticClass:"cta-bar__link l-main btn active text-uppercase align-self-center",attrs:{"href":"#"}},[_vm._v("REGISTER NOW")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_905fa784_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cta_bar_flexible_vue__ = __webpack_require__(1301);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_905fa784_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cta_bar_flexible_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"l-promo cta-bar-flexible l-promo--shadow l-promo--border-top"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"row section__label my-3 mx-0"},[_vm._v("\n                Alert\n            ")]),_vm._v(" "),_c('div',{staticClass:"row mb-3 three-col"},[_c('div',{staticClass:"col col-md"},[_c('a',{attrs:{"href":"#"}},[_vm._v("\n                        Statins: Drug Safety Communication - FDA Requests Removal of Strongest Warning Against Using Cholesterol-lowering Statins During Pregnancy\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col col-md"},[_c('a',{attrs:{"href":"#"}},[_vm._v("\n                        FDA: Medtronic Vascular Recalls Angiographic Guidewire Component Due to Being Non-sterile\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col col-md"},[_c('a',{attrs:{"href":"#"}},[_vm._v("\n                        FDA: Magellan Diagnostics Recalls LeadCare II, LeadCare Plus, and LeadCare Ultra Blood Lead Tests Due to Risk of Falsely Low Results\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo cta-bar-flexible l-promo--shadow l-promo--border-top"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"row section__label my-3 mx-0"},[_vm._v("\n                Alert - 2 Col\n            ")]),_vm._v(" "),_c('div',{staticClass:"row mb-3 two-col"},[_c('div',{staticClass:"col col-md"},[_c('a',{attrs:{"href":"#"}},[_vm._v("\n                        Statins: Drug Safety Communication - FDA Requests Removal of Strongest Warning Against Using Cholesterol-lowering Statins During Pregnancy\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col col-md"},[_c('a',{attrs:{"href":"#"}},[_vm._v("\n                        FDA: Medtronic Vascular Recalls Angiographic Guidewire Component Due to Being Non-sterile\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo cta-bar-flexible l-promo--shadow l-promo--border-top"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"row section__label my-3 mx-0"},[_vm._v("\n                Alert - 1 Col\n            ")]),_vm._v(" "),_c('div',{staticClass:"row mb-3 one-col"},[_c('div',{staticClass:"col col-md"},[_c('a',{attrs:{"href":"#"}},[_vm._v("\n                        Statins: Drug Safety Communication - FDA Requests Removal of Strongest Warning Against Using Cholesterol-lowering Statins During Pregnancy\n                    ")])])])])]),_vm._v(" "),_c('h2',[_vm._v("\n        Style Variations\n    ")]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"h4"},[_vm._v("Box Shadow")]),_vm._v(" "),_c('p',[_vm._v("Remove "),_c('code',[_vm._v("l-promo--shadow")])])]),_vm._v(" "),_c('div',{staticClass:"l-promo cta-bar-flexible l-promo--border-top"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"row section__label my-3 mx-0"},[_vm._v("\n                Alert - 1 Col without drop shadow\n            ")]),_vm._v(" "),_c('div',{staticClass:"row mb-3 one-col"},[_c('div',{staticClass:"col col-md"},[_c('a',{attrs:{"href":"#"}},[_vm._v("\n                        Statins: Drug Safety Communication - FDA Requests Removal of Strongest Warning Against Using Cholesterol-lowering Statins During Pregnancy\n                    ")])])])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"h4"},[_vm._v("Top Red bar")]),_vm._v(" "),_c('p',[_vm._v("Remove "),_c('code',[_vm._v("l-promo--border-top")])])]),_vm._v(" "),_c('div',{staticClass:"l-promo cta-bar-flexible"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"row section__label my-3 mx-0"},[_vm._v("\n                Alert - 1 Col without top red bar\n            ")]),_vm._v(" "),_c('div',{staticClass:"row mb-3 one-col"},[_c('div',{staticClass:"col col-md"},[_c('a',{attrs:{"href":"#"}},[_vm._v("\n                        Statins: Drug Safety Communication - FDA Requests Removal of Strongest Warning Against Using Cholesterol-lowering Statins During Pregnancy\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo cta-bar-flexible l-promo--shadow"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"row section__label my-3 mx-0"},[_vm._v("\n                Alert - 1 Col with drop shadow and without top red bar\n            ")]),_vm._v(" "),_c('div',{staticClass:"row mb-3 one-col"},[_c('div',{staticClass:"col col-md"},[_c('a',{attrs:{"href":"#"}},[_vm._v("\n                        Statins: Drug Safety Communication - FDA Requests Removal of Strongest Warning Against Using Cholesterol-lowering Statins During Pregnancy\n                    ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4acb984e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_council_vue__ = __webpack_require__(1303);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4acb984e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_council_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-phd-profile js-mobile-nav-positioning"},[_c('div',{staticClass:"c-phd-profile__container d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"c-phd-profile__councils-container col-12"},[_c('span',{staticClass:"section__label d-block"},[_vm._v("My Scientific Councils")]),_vm._v(" "),_c('div',{staticClass:"c-phd-profile__councils-container--content"},[_c('div',{staticClass:"c-phd-profile__councils-container--text-block"},[_c('div',{staticClass:"c-phd-profile__councils-container--text-item"},[_c('a',{staticClass:"c-phd-profile__councils-container--text-link",attrs:{"href":"#"}},[_vm._v("ATVB")])]),_vm._v(" "),_c('div',{staticClass:"c-phd-profile__councils-container--text-item"},[_c('a',{staticClass:"c-phd-profile__councils-container--text-link",attrs:{"href":"#"}},[_vm._v("Electrophysiology and Arrhythmias")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fede470_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_pdf_accessible_links_vue__ = __webpack_require__(1305);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fede470_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_pdf_accessible_links_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-pdf-accessible-links",attrs:{"id":"UniqueID123"}},[_c('div',{staticClass:"d-flex flex-column l-promo--shadow image-pdf-accessible-links__container"},[_c('figure',{staticClass:"image-pdf-accessible-links__figure"},[_c('img',{attrs:{"src":"//placehold.it/800x500/ddd/ccc?text=FPO"}}),_vm._v(" "),_c('a',{staticClass:"image-pdf-accessible-links__figure-link",attrs:{"href":"#","target":"_blank","aria-label":"View image at full size."}},[_c('img',{attrs:{"src":"assets/icons/icon-material-open-in-new.svg"}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('figcaption',[_vm._v("Figure 1: Structure of questions for evidence evaluation")])]),_vm._v(" "),_c('div',{staticClass:"image-pdf-accessible-links__links"},[_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#","target":"_blank"}},[_c('img',{attrs:{"src":"assets/icons/icon-awesome-file-pdf.svg"}}),_vm._v("PDF Version")]),_vm._v(" "),_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#","target":"_blank"}},[_c('img',{attrs:{"src":"assets/icons/icon-material-accessible.svg"}}),_vm._v("Accessible Version")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_institutional_tier_vue__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_institutional_tier_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_institutional_tier_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_institutional_tier_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_institutional_tier_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f1f3a5b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_institutional_tier_vue__ = __webpack_require__(1307);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_institutional_tier_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f1f3a5b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_institutional_tier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD tier-selector"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container container-fluid institutional-tier__wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row l-tier-selector"},[_c('div',{staticClass:"col-12 d-block"},[_c('div',{staticClass:"l-promo l-promo--image institutional-tier--image"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-image-promo c-image-promo--full institutional-tier--image-promo"},[_c('div',{staticClass:"c-image-promo__media h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col d-none d-md-block"},[_c('div',{staticClass:"c-image-promo c-image-promo--full institutional-tier--image-promo"},[_c('div',{staticClass:"c-image-promo__media h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col d-none d-md-block"},[_c('div',{staticClass:"c-image-promo c-image-promo--full institutional-tier--image-promo"},[_c('div',{staticClass:"c-image-promo__media h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-3 c-tier-selector__tabs institutional-tier__tabs"},[_c('div',{staticClass:"nav flex-column nav-pills",attrs:{"id":"v-pills-tab","role":"tablist","aria-orientation":"vertical"}},[_c('a',{staticClass:"nav-link",class:{ active: _vm.isActive('premier') },attrs:{"id":"v-pills-premier-tab","data-toggle":"pill","href":"#v-pills-premier","role":"tab","aria-controls":"v-pills-premier","aria-selected":[_vm.isActive('premier') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('premier')}}},[_vm._m(1)]),_vm._v(" "),_c('a',{staticClass:"nav-link",class:{ active: _vm.isActive('professional') },attrs:{"id":"v-pills-professional-tab","data-toggle":"pill","href":"#v-pills-professional","role":"tab","aria-controls":"v-pills-professional","aria-selected":[_vm.isActive('professional') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('professional')}}},[_vm._m(2)]),_vm._v(" "),_c('a',{staticClass:"nav-link",class:{ active: _vm.isActive('limited') },attrs:{"id":"v-pills-limited-tab","data-toggle":"pill","href":"#v-pills-limited","role":"tab","aria-controls":"v-pills-limited","aria-selected":[_vm.isActive('limited') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('limited')}}},[_vm._m(3)]),_vm._v(" "),_c('a',{staticClass:"nav-link",class:{ active: _vm.isActive('early') },attrs:{"id":"v-pills-early-tab","data-toggle":"pill","href":"#v-pills-early","role":"tab","aria-controls":"v-pills-early","aria-selected":[_vm.isActive('early') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('early')}}},[_vm._m(4)]),_vm._v(" "),_vm._m(5)])]),_vm._v(" "),_c('div',{staticClass:"col-9 c-tier-selector__tab-panels"},[_c('div',{staticClass:"tab-content",attrs:{"id":"v-pills-tabContent"}},[_c('div',{staticClass:"tab-pane",class:{ 'active show': _vm.isActive('premier') },attrs:{"id":"v-pills-premier","role":"tabpanel","aria-labelledby":"v-pills-premier-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-premier'),expression:"'panel-collapse-premier'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('premier') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('premier')}}},[_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-premier","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4"},[_vm._v("Premier")]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Council Affiliations")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Affiliate with up to two of our "),_c('strong',[_c('a',{attrs:{"href":"/professional/MembershipCouncils/ScientificCouncils/UCM_475327_Scientific-Councils.jsp","target":"_blank"}},[_vm._v("16 Scientific Councils")])]),_vm._v(".")]),_vm._v(" "),_c('li',[_vm._v("(Optional) Affiliate with a third council for an additional $65/year.")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("AHA Scientific Journals")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Access to all "),_c('strong',[_vm._v("11 online")]),_vm._v(" "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/","target":"_blank"}},[_vm._v("AHA scientific journals")])]),_vm._v(" (full text)")]),_vm._v(" "),_c('li',[_vm._v("Yearly print subscriptions only $225 per journal ("),_c('em',[_vm._v("ATVB, Circulation, Circulation Research, Hypertension, Stroke")]),_vm._v(")")]),_vm._v(" "),_c('li',[_vm._v("Access to CME credits through the "),_c('strong',[_c('a',{attrs:{"href":"https://cme.ahajournals.org/s/catalog","target":"_blank"}},[_vm._v("AHA Journals CME")]),_vm._v(" ")]),_vm._v("program")]),_vm._v(" "),_c('li',[_c('strong',[_c('a',{attrs:{"href":"/professional/Journals/UCM_491607_JAHA-Discount-for-AHA-Professional-Members.jsp","target":"_blank"}},[_vm._v("Discounted article publication charges")])]),_vm._v(" for accepted articles in "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/journal/jaha","target":"_blank"}},[_c('em',[_vm._v("JAHA")])])]),_vm._v(" (the AHA/ASA’s Open Access journal that’s freely accessible). Members save $700 with discount code")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Conferences and Education")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Save on AHA/ASA "),_c('strong',[_c('a',{attrs:{"href":"/professional/EducationMeetings/MeetingsLiveCME/UCM_475321_Meetings.jsp","target":"_blank"}},[_vm._v("Scientific Conferences")]),_vm._v(" ")]),_vm._v("registration")]),_vm._v(" "),_c('li',[_vm._v("Savings on Science OnDemand® products,")]),_vm._v(" "),_c('li',[_vm._v("Priority Registration and Housing for Scientific Sessions and the International Stroke Conference")]),_vm._v(" "),_c('li',[_vm._v("Complimentary and/or discounted courses through the "),_c('strong',[_c('a',{attrs:{"href":"https://learn.heart.org/","target":"_blank"}},[_vm._v("Lifelong Learning Center")])])])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Opportunities")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Funding opportunities for members only")]),_vm._v(" "),_c('li',[_vm._v("Become a "),_c('strong',[_c('a',{attrs:{"href":"/professional/ProfessionalMembership/FellowofAHAFAHA/UCM_475326_Fellow-of-AHA-FAHA.jsp","target":"_blank"}},[_vm._v("Fellow of the American Heart Association (FAHA)")])])]),_vm._v(" "),_c('li',[_vm._v("Leadership Opportunities")]),_vm._v(" "),_c('li',[_vm._v("Networking with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and to mentor others")]),_vm._v(" "),_c('li',[_vm._v("Access to Science News")]),_vm._v(" "),_c('li',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('li',[_vm._v("Quarterly AHA Connections Newsletter")]),_vm._v(" "),_c('li',[_vm._v("Inclusion/ access to the online AHA/ASA Professional Membership Directory")]),_vm._v(" "),_c('li',[_vm._v("Achieve Golden and Silver Heart Membership")]),_vm._v(" "),_c('li',[_vm._v("Be a part of the Emeritus Membership program")])]),_vm._v(" "),_c('div',{staticClass:"btn-wrapper"},[_c('a',{staticClass:"btn btn-primary btn-round btn-block btn--signup",attrs:{"href":"#"}},[_vm._v("Sign Up")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane",class:{ 'show active': _vm.isActive('professional') },attrs:{"id":"v-pills-professional","role":"tabpanel","aria-labelledby":"v-pills-professional-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-professional'),expression:"'panel-collapse-professional'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('professional') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('professional')}}},[_vm._m(7)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-professional","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4"},[_vm._v("Professional")]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Council Affiliations")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("2 Affiliate with up to two of our "),_c('strong',[_c('a',{attrs:{"href":"/professional/MembershipCouncils/ScientificCouncils/UCM_475327_Scientific-Councils.jsp","target":"_blank"}},[_vm._v("16 Scientific Councils")])]),_vm._v(".")]),_vm._v(" "),_c('li',[_vm._v("(Optional) Affiliate with a third council for an additional $65/year.")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("AHA Scientific Journals")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Access to all "),_c('strong',[_vm._v("11 online")]),_vm._v(" "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/","target":"_blank"}},[_vm._v("AHA scientific journals")])]),_vm._v(" (full text)")]),_vm._v(" "),_c('li',[_vm._v("Yearly print subscriptions only $225 per journal ("),_c('em',[_vm._v("ATVB, Circulation, Circulation Research, Hypertension, Stroke")]),_vm._v(")")]),_vm._v(" "),_c('li',[_vm._v("Access to CME credits through the "),_c('strong',[_c('a',{attrs:{"href":"https://cme.ahajournals.org/s/catalog","target":"_blank"}},[_vm._v("AHA Journals CME")]),_vm._v(" ")]),_vm._v("program")]),_vm._v(" "),_c('li',[_c('strong',[_c('a',{attrs:{"href":"/professional/Journals/UCM_491607_JAHA-Discount-for-AHA-Professional-Members.jsp","target":"_blank"}},[_vm._v("Discounted article publication charges")])]),_vm._v(" for accepted articles in "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/journal/jaha","target":"_blank"}},[_c('em',[_vm._v("JAHA")])])]),_vm._v(" (the AHA/ASA’s Open Access journal that’s freely accessible). Members save $700 with discount code")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Conferences and Education")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Save on AHA/ASA "),_c('strong',[_c('a',{attrs:{"href":"/professional/EducationMeetings/MeetingsLiveCME/UCM_475321_Meetings.jsp","target":"_blank"}},[_vm._v("Scientific Conferences")]),_vm._v(" ")]),_vm._v("registration")]),_vm._v(" "),_c('li',[_vm._v("Savings on Science OnDemand® products,")]),_vm._v(" "),_c('li',[_vm._v("Priority Registration and Housing for Scientific Sessions and the International Stroke Conference")]),_vm._v(" "),_c('li',[_vm._v("Complimentary and/or discounted courses through the "),_c('strong',[_c('a',{attrs:{"href":"https://learn.heart.org/","target":"_blank"}},[_vm._v("Lifelong Learning Center")])])])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Opportunities")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Funding opportunities for members only")]),_vm._v(" "),_c('li',[_vm._v("Become a "),_c('strong',[_c('a',{attrs:{"href":"/professional/ProfessionalMembership/FellowofAHAFAHA/UCM_475326_Fellow-of-AHA-FAHA.jsp","target":"_blank"}},[_vm._v("Fellow of the American Heart Association (FAHA)")])])]),_vm._v(" "),_c('li',[_vm._v("Leadership Opportunities")]),_vm._v(" "),_c('li',[_vm._v("Networking with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and to mentor others")]),_vm._v(" "),_c('li',[_vm._v("Access to Science News")]),_vm._v(" "),_c('li',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('li',[_vm._v("Quarterly AHA Connections Newsletter")]),_vm._v(" "),_c('li',[_vm._v("Inclusion/ access to the online AHA/ASA Professional Membership Directory")]),_vm._v(" "),_c('li',[_vm._v("Achieve Golden and Silver Heart Membership")]),_vm._v(" "),_c('li',[_vm._v("Be a part of the Emeritus Membership program")])]),_vm._v(" "),_c('div',{staticClass:"btn-wrapper"},[_c('a',{staticClass:"btn btn-primary btn-round btn-block btn--signup",attrs:{"href":"#"}},[_vm._v("Sign Up")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane",class:{ 'show active': _vm.isActive('limited') },attrs:{"id":"v-pills-professional","role":"tabpanel","aria-labelledby":"v-pills-limited-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-limited'),expression:"'panel-collapse-limited'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('limited') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('limited')}}},[_vm._m(8)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-limited","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4"},[_vm._v("Limited")]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Council Afiliations")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("3 Affiliate with up to two of our "),_c('strong',[_c('a',{attrs:{"href":"/professional/MembershipCouncils/ScientificCouncils/UCM_475327_Scientific-Councils.jsp","target":"_blank"}},[_vm._v("16 Scientific Councils")])]),_vm._v(".")]),_vm._v(" "),_c('li',[_vm._v("(Optional) Affiliate with a third council for an additional $65/year.")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("AHA Scientific Journals")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Access to all "),_c('strong',[_vm._v("11 online")]),_vm._v(" "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/","target":"_blank"}},[_vm._v("AHA scientific journals")])]),_vm._v(" (full text)")]),_vm._v(" "),_c('li',[_vm._v("Yearly print subscriptions only $225 per journal ("),_c('em',[_vm._v("ATVB, Circulation, Circulation Research, Hypertension, Stroke")]),_vm._v(")")]),_vm._v(" "),_c('li',[_vm._v("Access to CME credits through the "),_c('strong',[_c('a',{attrs:{"href":"https://cme.ahajournals.org/s/catalog","target":"_blank"}},[_vm._v("AHA Journals CME")]),_vm._v(" ")]),_vm._v("program")]),_vm._v(" "),_c('li',[_c('strong',[_c('a',{attrs:{"href":"/professional/Journals/UCM_491607_JAHA-Discount-for-AHA-Professional-Members.jsp","target":"_blank"}},[_vm._v("Discounted article publication charges")])]),_vm._v(" for accepted articles in "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/journal/jaha","target":"_blank"}},[_c('em',[_vm._v("JAHA")])])]),_vm._v(" (the AHA/ASA’s Open Access journal that’s freely accessible). Members save $700 with discount code")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Conferences and Education")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Save on AHA/ASA "),_c('strong',[_c('a',{attrs:{"href":"/professional/EducationMeetings/MeetingsLiveCME/UCM_475321_Meetings.jsp","target":"_blank"}},[_vm._v("Scientific Conferences")]),_vm._v(" ")]),_vm._v("registration")]),_vm._v(" "),_c('li',[_vm._v("Savings on Science OnDemand® products,")]),_vm._v(" "),_c('li',[_vm._v("Priority Registration and Housing for Scientific Sessions and the International Stroke Conference")]),_vm._v(" "),_c('li',[_vm._v("Complimentary and/or discounted courses through the "),_c('strong',[_c('a',{attrs:{"href":"https://learn.heart.org/","target":"_blank"}},[_vm._v("Lifelong Learning Center")])])])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Opportunities")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Funding opportunities for members only")]),_vm._v(" "),_c('li',[_vm._v("Become a "),_c('strong',[_c('a',{attrs:{"href":"/professional/ProfessionalMembership/FellowofAHAFAHA/UCM_475326_Fellow-of-AHA-FAHA.jsp","target":"_blank"}},[_vm._v("Fellow of the American Heart Association (FAHA)")])])]),_vm._v(" "),_c('li',[_vm._v("Leadership Opportunities")]),_vm._v(" "),_c('li',[_vm._v("Networking with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and to mentor others")]),_vm._v(" "),_c('li',[_vm._v("Access to Science News")]),_vm._v(" "),_c('li',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('li',[_vm._v("Quarterly AHA Connections Newsletter")]),_vm._v(" "),_c('li',[_vm._v("Inclusion/ access to the online AHA/ASA Professional Membership Directory")]),_vm._v(" "),_c('li',[_vm._v("Achieve Golden and Silver Heart Membership")]),_vm._v(" "),_c('li',[_vm._v("Be a part of the Emeritus Membership program")])]),_vm._v(" "),_c('div',{staticClass:"btn-wrapper"},[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('limited-membership-modal'),expression:"'limited-membership-modal'"}],staticClass:"btn btn-primary btn-round btn-block btn--signup",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Sign Up")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane",class:{ 'show active': _vm.isActive('early') },attrs:{"id":"v-pills-professional","role":"tabpanel","aria-labelledby":"v-pills-early-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-early'),expression:"'panel-collapse-early'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('early') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('early')}}},[_vm._m(9)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-early","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4"},[_vm._v("Early Career")]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Council Affiliations")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("4 Affiliate with up to two of our "),_c('strong',[_c('a',{attrs:{"href":"/professional/MembershipCouncils/ScientificCouncils/UCM_475327_Scientific-Councils.jsp","target":"_blank"}},[_vm._v("16 Scientific Councils")])]),_vm._v(".")]),_vm._v(" "),_c('li',[_vm._v("(Optional) Affiliate with a third council for an additional $65/year.")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("AHA Scientific Journals")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Access to all "),_c('strong',[_vm._v("11 online")]),_vm._v(" "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/","target":"_blank"}},[_vm._v("AHA scientific journals")])]),_vm._v(" (full text)")]),_vm._v(" "),_c('li',[_vm._v("Yearly print subscriptions only $225 per journal ("),_c('em',[_vm._v("ATVB, Circulation, Circulation Research, Hypertension, Stroke")]),_vm._v(")")]),_vm._v(" "),_c('li',[_vm._v("Access to CME credits through the "),_c('strong',[_c('a',{attrs:{"href":"https://cme.ahajournals.org/s/catalog","target":"_blank"}},[_vm._v("AHA Journals CME")]),_vm._v(" ")]),_vm._v("program")]),_vm._v(" "),_c('li',[_c('strong',[_c('a',{attrs:{"href":"/professional/Journals/UCM_491607_JAHA-Discount-for-AHA-Professional-Members.jsp","target":"_blank"}},[_vm._v("Discounted article publication charges")])]),_vm._v(" for accepted articles in "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/journal/jaha","target":"_blank"}},[_c('em',[_vm._v("JAHA")])])]),_vm._v(" (the AHA/ASA’s Open Access journal that’s freely accessible). Members save $700 with discount code")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Opportunities")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Funding opportunities for members only")]),_vm._v(" "),_c('li',[_vm._v("Become a "),_c('strong',[_c('a',{attrs:{"href":"/professional/ProfessionalMembership/FellowofAHAFAHA/UCM_475326_Fellow-of-AHA-FAHA.jsp","target":"_blank"}},[_vm._v("Fellow of the American Heart Association (FAHA)")])])]),_vm._v(" "),_c('li',[_vm._v("Leadership Opportunities")]),_vm._v(" "),_c('li',[_vm._v("Networking with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and to mentor others")]),_vm._v(" "),_c('li',[_vm._v("Access to Science News")]),_vm._v(" "),_c('li',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('li',[_vm._v("Quarterly AHA Connections Newsletter")]),_vm._v(" "),_c('li',[_vm._v("Inclusion/ access to the online AHA/ASA Professional Membership Directory")]),_vm._v(" "),_c('li',[_vm._v("Achieve Golden and Silver Heart Membership")]),_vm._v(" "),_c('li',[_vm._v("Be a part of the Emeritus Membership program")])]),_vm._v(" "),_c('div',{staticClass:"btn-wrapper"},[_c('a',{staticClass:"btn btn-primary btn-round btn-block btn--signup",attrs:{"href":"#"}},[_vm._v("Sign Up")])])])],1)])])])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('aha-modal',{staticClass:"table-comparison__modal",attrs:{"id":"table-comparison-modal","hide-footer":"","centered":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h2',{staticClass:"text-center"},[_vm._v("Pick a Membership that's right for you")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-muted"},[_vm._v("\n                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur possimus ex incidunt quod eius delectus atque iste, saepe repellat impedit iusto, non repudiandae nemo accusamus alias magnam dolore maxime soluta.\n              ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"l-comparison--desktop"},[_c('table',{staticClass:"table table-hover table-comparison"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v(" ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Premier")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Professional")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Limited")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Signature")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Journals")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Council Affiliations")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Discount")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("FAHA")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Funding opportunities "),_c('em',[_vm._v("members only")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Leadership opportunities")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Network with like-minded professionals")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Get involved in the AHA mission and mentor others")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Access to Science News")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Quarterly AHA Connections Newsleter")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])])])])]),_vm._v(" "),_c('div',{staticClass:"l-comparison--mobile"},[_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-premier",modifiers:{"collapse-tier-premier":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Premier")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-premier"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")]),_vm._v(" "),_c('li',[_vm._v("Funding opportunities members only")]),_vm._v(" "),_c('li',[_vm._v("Leadership opportunities")]),_vm._v(" "),_c('li',[_vm._v("Network with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and mentor others")]),_vm._v(" "),_c('li',[_vm._v("Access to Science News")]),_vm._v(" "),_c('li',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('li',[_vm._v("Quarterly AHA Connections Newsleter")])])])],1),_vm._v(" "),_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-professional",modifiers:{"collapse-tier-professional":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Professional")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-professional"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")]),_vm._v(" "),_c('li',[_vm._v("Funding opportunities members only")]),_vm._v(" "),_c('li',[_vm._v("Leadership opportunities")]),_vm._v(" "),_c('li',[_vm._v("Network with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and mentor others")])])])],1),_vm._v(" "),_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-limited",modifiers:{"collapse-tier-limited":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Limited")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-limited"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")])])])],1),_vm._v(" "),_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-signature",modifiers:{"collapse-tier-signature":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Signature")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-signature"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")])])])],1)])])])]),_vm._v(" "),_c('aha-modal',{staticClass:"limited-membership__modal",attrs:{"id":"limited-membership-modal","hide-footer":"","centered":""}},[_c('h2',{staticClass:"text-center"},[_vm._v("Limited Membership")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio commodi vero similique amet eos, voluptas dolores rerum modi quasi nesciunt placeat odio incidunt sint animi eum earum vel consectetur soluta!")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-link-plain",on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'limited-membership-modal', $event.target)}}},[_vm._v("Go Back")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'limited-membership-modal', $event.target)}}},[_vm._v("Continue")])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Institutional Tier Component")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading institutional-tier__heading"},[_vm._v("Tier 1")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading institutional-tier__heading"},[_vm._v("Tier 2")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading institutional-tier__heading"},[_vm._v("Tier 3")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading institutional-tier__heading"},[_vm._v("Tier 4")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('div',{staticClass:"c-tier-promo-card"},[_c('div',{staticClass:"card__img"}),_vm._v(" "),_c('div',{staticClass:"card__content"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Tier 1")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Tier 2")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Tier 3")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Tier 4")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"linkbox"},[_c('div',{staticClass:"container linkbox-container"},[_c('div',{staticClass:"linkbox__wrapper phd-shadow-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v("Linkbox Title")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_vm._v("Optional "),_c('em',[_vm._v("descriptive")]),_vm._v(" statement/paragraph")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Lorem, ipsum dolor sit amet consectetur adipisicing elit")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Alias aperiam quas in ratione repellat quidem corporis eligendi! Est")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Rerum quidem debitis laudantium, consectetur eligendi veniam nobis rem sint")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Quasi, sunt cum aperiam quasi natus")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Quasi quo repellendus corrupti omnis maxime perferendis molestias iure nam")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"linkbox linkbox--5050"},[_c('div',{staticClass:"container linkbox-container"},[_c('div',{staticClass:"linkbox__wrapper phd-shadow-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v("Linkbox Title")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit.")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Ipsam dolor facere quae doloribus provident accusantium, repellendus cum dicta labore! Ducimus enim architecto in dolore.")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Eos tempora provident ad reprehenderit aperiam quam quibusdam doloribus aliquam, necessitatibus earum laudantium aliquid, iste explicabo atque sed harum officiis architecto. Exercitationem autem laboriosam incidunt iste dignissimos! A, dolorum quaerat!")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Cum tenetur fugiat voluptatum modi vel, ipsam saepe praesentium, iste perferendis repellat sint at nostrum consequuntur. Dignissimos, eos doloribus possimus quos, sapiente architecto voluptas molestias et dolore sit unde modi.")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Magnam pariatur praesentium quisquam rem obcaecati voluptas amet aliquid molestiae labore! Earum odit, illum quis animi repellendus corrupti exercitationem minus aliquid neque. Nemo maxime deleniti libero nihil rem a in?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Fugiat deleniti ratione quis sit, atque esse quas iusto, repellendus, debitis rerum cupiditate quod. Nesciunt fugit qui quod inventore ullam obcaecati quasi, corrupti a, mollitia culpa sed perspiciatis dignissimos nostrum!")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd7971a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_main_nav_vue__ = __webpack_require__(1311);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd7971a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_main_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"c-main-nav",attrs:{"aria-label":"Site Navigation"}},[_c('ul',{staticClass:"w-100 c-main-nav__item-container"},[_c('li',{staticClass:"c-main-nav__item c-mega-nav",attrs:{"data-aha-nav":"healthy-living"}},[_c('aha-nav-dropdown',{attrs:{"role":"menu","position":"none","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Communities")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('div',{staticClass:"container container-fluid container-wide"},[_c('a',{staticClass:"c-mega-nav__dropdown-header",attrs:{"href":"#"}},[_vm._v("Communities")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav__container"},[_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Bilateral Trade")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Cognitive Psychology")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Deferential Treatment")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Elimination Round")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Fragmented Financing")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])])])])])],2)],1),_vm._v(" "),_c('li',{staticClass:"c-main-nav__item c-mega-nav",attrs:{"data-aha-nav":"healthy-living"}},[_c('aha-nav-dropdown',{attrs:{"role":"menu","position":"none","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Guidelines & Statements")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('div',{staticClass:"container container-fluid container-wide"},[_c('a',{staticClass:"c-mega-nav__dropdown-header",attrs:{"href":"#"}},[_vm._v("Guidelines & Statements")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav__container"},[_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Bilateral Trade")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Cognitive Psychology")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Deferential Treatment")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Elimination Round")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Fragmented Financing")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])])])])])],2)],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('li',{staticClass:"c-main-nav__item c-mega-nav",attrs:{"data-aha-nav":"healthy-living"}},[_c('aha-nav-dropdown',{attrs:{"role":"menu","position":"none","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Membership / Councils")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('div',{staticClass:"container container-fluid container-wide"},[_c('a',{staticClass:"c-mega-nav__dropdown-header",attrs:{"href":"#"}},[_vm._v("Membership / Councils")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav__container"},[_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Bilateral Trade")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Cognitive Psychology")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Deferential Treatment")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Elimination Round")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Fragmented Financing")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])])])])])],2)],1),_vm._v(" "),_c('li',{staticClass:"c-main-nav__item c-mega-nav"},[_c('aha-nav-dropdown',{attrs:{"role":"menu","position":"none","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Research Programs")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('div',{staticClass:"container container-fluid container-wide"},[_c('a',{staticClass:"c-mega-nav__dropdown-header",attrs:{"href":"#"}},[_vm._v("Research Programs")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav__container"},[_c('li',[_c('a',{staticClass:"c-mega-nav__header",attrs:{"href":"#"}},[_vm._v("Research Programs")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav__links"},[_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Arrythmia")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Atrial Fibrilation")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Cardiac Arrest")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Cardiac Rehab")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Cardiomyopathy")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Cholesterol")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Congenital Heart Defects")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Cardiovascular Conditions of Childhood")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Heart Attack")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Heart Failure")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Heart Valve & Disease")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("High Blood Pressure")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Metabolic Syndrome")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Peripheral Artery Disease")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Stroke")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Vascular Health")])])])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__header",attrs:{"href":"#"}},[_vm._v("Conditions")]),_vm._v(" "),_c('ul',{staticClass:"c-mega-nav__links"},[_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Link 1")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Link 2")])])])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Another Link")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Another Link 2")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Another Link 3")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Elimination Round")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Fragmented Financing")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Accute Coronary Syndromes")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mega-nav__link",attrs:{"href":"#"}},[_vm._v("Support")])])])])])],2)],1)]),_vm._v(" "),_vm._m(3)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-main-nav__item"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon dropdown-toggle",attrs:{"href":"#"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Journals")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-main-nav__item"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon dropdown-toggle",attrs:{"href":"#"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Meetings")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-main-nav__item"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon dropdown-toggle",attrs:{"href":"#"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("Education")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-member-button"},[_c('a',{staticClass:"btn btn-round active",attrs:{"href":""}},[_vm._v("Become a Member")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"c-listing-header c-cta"},[_c('h2',{staticClass:"c-listing-header__heading pb-2"},[_vm._v("Hypertension Scientific Sessions 2020")]),_vm._v(" "),_c('div',{staticClass:"c-listing-header__cta-container"},[_c('div',{staticClass:"links-to-details__description"},[_vm._v("September 10–13, 2020 "),_c('br'),_vm._v("\n          Sponsored by: Councils on Hypertension and Kidney in Cardiovascular Disease\n        ")]),_vm._v(" "),_c('div',{staticClass:"links-to-details__actions"},[_c('a',{staticClass:"btn btn-sm btn-outline mt-2 ml-lg-2",attrs:{"href":"/en/news/coronavirus-news"}},[_vm._v(" \n            Purchase OnDemand\n          ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm mt-2 ml-lg-2",attrs:{"href":"/en/news/coronavirus-news"}},[_vm._v(" \n            Watch OnDemand Now!\n          ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43db15e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_need_to_know_vue__ = __webpack_require__(1314);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43db15e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_need_to_know_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"c-promo c-promo--events c-promo--shadow c-promo--row"},[_c('div',{staticClass:"c-need-to-know"},[_c('div',{staticClass:"col-md-8 text-center m-auto"},[_c('h2',{staticClass:"c-need-to-know__heading mb-2"},[_vm._v("Make a Commitment")]),_vm._v(" "),_c('p',{staticClass:"mb-5"},[_vm._v("\n                    Join a friend or family member and make a Go Red Commitment to take action in the fight against heart disease.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut nisi animi quis aperiam quia, fugiat, impedit voluptate, temporibus recusandae voluptatem placeat aspernatur! Voluptates ipsa est quos assumenda expedita molestias officia?")]),_vm._v(" "),_c('div',{staticClass:"c-need-to-know__wrap"},[_c('div',{staticClass:"col c-need-to-know__item c-need-to-know__bg c-need-to-know__border align-items-center h-theme--red",staticStyle:{"background-image":"url('https://picsum.photos/300/600?image=674')"}},[_c('a',{staticClass:"h-100 w-100 c-need-to-know__link",attrs:{"href":"#"}},[_c('div',{staticClass:"position-relative w-100 h-100"},[_c('div',{staticClass:"c-need-to-know__text position-absolute w-100 p-2"},[_c('div',{staticClass:"p-1 m-2 text-center"},[_vm._v("Healthy Living")])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-end mask h-100"},[_c('div',{staticClass:"hover-msg"},[_vm._v("Join a friend or family member and make a Go Red Commitment to take action in the fight against heart disease.")])])]),_vm._v(" "),_c('span',{staticClass:"check-box"})])]),_vm._v(" "),_c('div',{staticClass:"col c-need-to-know__item c-need-to-know__bg c-need-to-know__border align-items-center h-theme--red",staticStyle:{"background-image":"url('https://picsum.photos/300/600?image=694')"}},[_c('a',{staticClass:"h-100 w-100 c-need-to-know__link",attrs:{"href":"#"}},[_c('div',{staticClass:"position-relative w-100 h-100"},[_c('div',{staticClass:"c-need-to-know__text position-absolute w-100 p-2"},[_c('div',{staticClass:"p-1 m-2 text-center"},[_vm._v("Monitor Blood Pressure")])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-end mask h-100"},[_c('div',{staticClass:"hover-msg"},[_vm._v("A cool description of some sort between these tags. I am so cool and awesomely awesome.")])])]),_vm._v(" "),_c('span',{staticClass:"check-box"})])]),_vm._v(" "),_c('div',{staticClass:"col c-need-to-know__item c-need-to-know__bg c-need-to-know__border align-items-center h-theme--red",staticStyle:{"background-image":"url('https://picsum.photos/300/600?image=784')"}},[_c('a',{staticClass:"h-100 w-100 c-need-to-know__link",attrs:{"href":"#"}},[_c('div',{staticClass:"position-relative w-100 h-100"},[_c('div',{staticClass:"c-need-to-know__text position-absolute w-100 p-2"},[_c('div',{staticClass:"p-1 m-2 text-center"},[_vm._v("Get Active")])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-end mask h-100"},[_c('div',{staticClass:"hover-msg"},[_vm._v("A cool description of some sort between these tags. I am so cool and awesomely awesome.")])])]),_vm._v(" "),_c('span',{staticClass:"check-box"})])]),_vm._v(" "),_c('div',{staticClass:"col c-need-to-know__item c-need-to-know__bg c-need-to-know__border align-items-center h-theme--red",staticStyle:{"background-image":"url('https://picsum.photos/300/600?image=874')"}},[_c('a',{staticClass:"h-100 w-100 c-need-to-know__link",attrs:{"href":"#"}},[_c('div',{staticClass:"position-relative w-100 h-100"},[_c('div',{staticClass:"c-need-to-know__text position-absolute w-100 p-2"},[_c('div',{staticClass:"p-1 m-2 text-center"},[_vm._v("Research")])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-end mask h-100"},[_c('div',{staticClass:"hover-msg"},[_vm._v("A cool description of some sort between these tags. I am so cool and awesomely awesome.")])])]),_vm._v(" "),_c('span',{staticClass:"check-box"})])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-link"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("View the full news Lorem ipsum dolor sit amet consectetur")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e78468_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_window_hyperlink_vue__ = __webpack_require__(1317);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e78468_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_window_hyperlink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-window-hyperlink",attrs:{"id":"UniqueID123"}},[_c('div',{staticClass:"new-window-hyperlink__container new-window-hyperlink__container--shadow"},[_c('div',{staticClass:"font-italic new-window-hyperlink__title",attrs:{"id":"TableTitleID"}},[_vm._v("\n            Table 1: 2015 - Applying Class of Recommendations and Level of Evidence to Clinical Strategies, Interventions, Treatments, or Diagnostic Testing in Patient Care*\n        ")]),_vm._v(" "),_c('div',{staticClass:"new-window-hyperlink__link"},[_c('p',[_vm._v("Open table in a "),_c('a',{attrs:{"href":"#","target":"_blank","aria-describedby":"TableTitleID"}},[_vm._v("new window")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f1d390_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_non_partner_connections_vue__ = __webpack_require__(1319);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f1d390_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_non_partner_connections_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"non-partner-connections"},[_c('div',{staticClass:"container non-partner-connections__container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 non-partner-connections__header-container"},[_c('h2',[_vm._v("Connections")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-3 d-flex d-md-block justify-content-center non-partner-connections__image-content-container"},[_c('img',{staticClass:"img-fluid",attrs:{"src":"//placehold.it/173x222/333333/666666?text=FPO"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-9 non-partner-connections__text-content-container"},[_c('p',[_vm._v("Connections is the AHA’s most comprehensive communication vehicle for all active Professional Members. Each issue features the latest AHA news and reports from all sixteen Scientific Councils.")]),_vm._v(" "),_c('p',[_vm._v("LConnections is printed and mailed four times a year to domestic members and concurrently posted online as a members-only benefit for international members. Archives are also available online. "),_c('a',{attrs:{"href":"#"}},[_vm._v("Become a Partner Today »")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f0fec96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partner_benefits_vue__ = __webpack_require__(1321);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f0fec96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partner_benefits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-partner-benefits"},[_c('div',{staticClass:"container c-partner-benefits__container"},[_c('div',{staticClass:"row mx-0"},[_c('div',{staticClass:"col-12 c-partner-benefits__header text-center py-4"},[_c('h1',{staticClass:"h3"},[_vm._v("A few benefits of being an AHA Partner:")])])]),_vm._v(" "),_c('div',{staticClass:"row mx-2 c-partner-benefits__content-row"},[_c('a',{staticClass:"py-4 py-sm-0 py-md-4 py-lg-0 my-sm-4 my-md-0 my-lg-4 col-12 col-sm-6 col-md-12 col-lg-6 c-partner-benefits__content-col",attrs:{"href":"https://professional.heart.org/professional/MembershipCouncils/FellowofAHAFAHA/UCM_475326_Fellow-of-AHA-FAHA.jsp"}},[_c('div',{staticClass:"row justify-content-center h-100"},[_c('div',{staticClass:"col-12 col-xl-6 order-2 order-xl-1 text-center text-sm-center text-xl-left c-partner-benefits__text-content"},[_c('h2',{staticClass:"h4"},[_vm._v("FAHA:")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-partner-benefits__emphasis-text"},[_vm._v("Eary your")]),_vm._v(" Fellow of the American Heart Association "),_c('span',{staticClass:"c-partner-benefits__emphasis-text"},[_vm._v("(FAHA) Credentials.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 order-1 order-xl-2 text-center c-partner-benefits__image-content"},[_c('img',{attrs:{"src":"/assets/icons/heart.png","alt":""}})])])]),_vm._v(" "),_c('a',{staticClass:"py-4 py-sm-0 py-md-4 py-lg-0 my-sm-4 my-md-0 my-lg-4 col-12 col-sm-6 col-md-12 col-lg-6 c-partner-benefits__content-col",attrs:{"href":"https://professional.heart.org/professional/ResearchPrograms/UCM_316889_Research.jsp"}},[_c('div',{staticClass:"row justify-content-center h-100"},[_c('div',{staticClass:"col-12 col-xl-6 order-2 text-center text-sm-center text-xl-left c-partner-benefits__text-content"},[_c('h2',{staticClass:"h4"},[_vm._v("Grants/Research:")]),_vm._v(" "),_c('p',[_vm._v("Funding over "),_c('span',{staticClass:"c-partner-benefits__emphasis-text"},[_vm._v("$4.3 Billion")]),_vm._v(" in cutting-edge science research.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 order-1 text-center c-partner-benefits__image-content"},[_c('img',{attrs:{"src":"/assets/icons/book-2.png","alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"row mx-2 c-partner-benefits__content-row"},[_c('a',{staticClass:"py-4 py-sm-0 py-md-4 py-lg-0 my-sm-4 my-md-0 my-lg-4 col-12 col-sm-6 col-md-12 col-lg-6 c-partner-benefits__content-col",attrs:{"href":"https://professional.heart.org/professional/EducationMeetings/MeetingsLiveCME/UCM_475321_Meetings.jsp"}},[_c('div',{staticClass:"row justify-content-center h-100"},[_c('div',{staticClass:"col-12 col-xl-6 order-2 text-center text-sm-center text-xl-left c-partner-benefits__text-content"},[_c('h2',{staticClass:"h4"},[_vm._v("Attending meetings:")]),_vm._v(" "),_c('p',[_vm._v("Deep discounts on all "),_c('span',{staticClass:"c-partner-benefits__emphasis-text"},[_vm._v("AHA Scientific Meetings.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 order-1 text-center c-partner-benefits__image-content"},[_c('img',{attrs:{"src":"/assets/icons/conference.png","alt":""}})])])]),_vm._v(" "),_c('a',{staticClass:"py-4 py-sm-0 py-md-4 py-lg-0 my-sm-4 my-md-0 my-lg-4 col-12 col-sm-6 col-md-12 col-lg-6 c-partner-benefits__content-col",attrs:{"href":"https://professional.heart.org/professional/Journals/UCM_316898_Journals.jsp"}},[_c('div',{staticClass:"row justify-content-center h-100"},[_c('div',{staticClass:"col-12 col-xl-6 order-2 order-xl-1 text-center text-sm-center text-xl-left c-partner-benefits__text-content"},[_c('h2',{staticClass:"h4"},[_vm._v("Study journals:")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-partner-benefits__emphasis-text"},[_vm._v("Journals")]),_vm._v(" What's new and now in science.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 order-1 order-xl-2 text-center c-partner-benefits__image-content"},[_c('img',{attrs:{"src":"/assets/icons/book.png","alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"row mx-2 c-partner-benefits__content-row"},[_c('a',{staticClass:"py-4 py-sm-0 py-md-4 py-lg-0 my-sm-4 my-md-0 my-lg-4 col-12 col-sm-6 col-md-12 col-lg-6 c-partner-benefits__content-col",attrs:{"href":"https://professional.heart.org/professional/EducationMeetings/OnlineLearning/UCM_477872_Webinars.jsp"}},[_c('div',{staticClass:"row justify-content-center h-100"},[_c('div',{staticClass:"col-12 col-xl-6 order-2 order-xl-1 text-center text-sm-center text-xl-left c-partner-benefits__text-content"},[_c('h2',{staticClass:"h4"},[_vm._v("Learn online:")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-partner-benefits__emphasis-text"},[_vm._v("Lifelong learning")]),_vm._v(" Earn CME/CE credits through our online and in person learning opportunities.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 order-1 order-xl-2 text-center c-partner-benefits__image-content"},[_c('img',{attrs:{"src":"/assets/icons/laptop.png","alt":""}})])])]),_vm._v(" "),_c('a',{staticClass:"py-4 py-sm-0 py-md-4 py-lg-0 my-sm-4 my-md-0 my-lg-4 col-12 col-sm-6 col-md-12 col-lg-6 c-partner-benefits__content-col",attrs:{"href":"https://professional.heart.org/professional/MembershipCouncils/MentoringforProfessionals/UCM_494611_Professional-Mentoring.jsp"}},[_c('div',{staticClass:"row justify-content-center h-100"},[_c('div',{staticClass:"col-12 col-xl-6 order-2 order-xl-1 text-center text-sm-center text-xl-left c-partner-benefits__text-content"},[_c('h2',{staticClass:"h4"},[_vm._v("Mentor:")]),_vm._v(" "),_c('p',[_vm._v("Engage in our "),_c('span',{staticClass:"c-partner-benefits__emphasis-text"},[_vm._v("mentoring program")]),_vm._v(" Experience + Knowledge = Enrichment.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 order-1 order-xl-2 text-center c-partner-benefits__image-content"},[_c('img',{attrs:{"src":"/assets/icons/people.png","alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"row mx-2 c-partner-benefits__content-row"},[_c('a',{staticClass:"py-4 py-sm-0 py-md-4 py-lg-0 my-sm-4 my-md-0 my-lg-4 col-12 col-sm-6 col-md-12 col-lg-6 c-partner-benefits__content-col",attrs:{"href":"https://professional.heart.org/professional/ProfessionalMembership/ScientificCouncils/UCM_316913_Connections.jsp"}},[_c('div',{staticClass:"row justify-content-center h-100"},[_c('div',{staticClass:"col-12 col-xl-6 order-2 text-center text-sm-center text-xl-left c-partner-benefits__text-content"},[_c('h2',{staticClass:"h4"},[_vm._v("Connect:")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-partner-benefits__emphasis-text"},[_vm._v("Connections")]),_vm._v(" AHA updates serving our Scientific Councils.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 order-1 text-center c-partner-benefits__image-content"},[_c('img',{attrs:{"src":"/assets/icons/news.png","alt":""}})])])]),_vm._v(" "),_c('a',{staticClass:"py-4 py-sm-0 py-md-4 py-lg-0 my-sm-4 my-md-0 my-lg-4 col-12 col-sm-6 col-md-12 col-lg-6 c-partner-benefits__content-col",attrs:{"href":"https://professionaljobs.heart.org/"}},[_c('div',{staticClass:"row justify-content-center h-100"},[_c('div',{staticClass:"col-12 col-xl-6 order-2 text-center text-sm-center text-xl-left c-partner-benefits__text-content"},[_c('h2',{staticClass:"h4"},[_vm._v("Find jobs:")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-partner-benefits__emphasis-text"},[_vm._v("Job resources")]),_vm._v(" Your #1 source for cardiovascular jobs.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 order-1 text-center c-partner-benefits__image-content"},[_c('img',{attrs:{"src":"/assets/icons/search.png","alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"row mx-0 c-partner-benefits__footer"},[_c('div',{staticClass:"col-12 col-sm-6 col-md-12 col-lg-6 mb-3 m-sm-0 text-center text-sm-center text-xl-left text-md-center text-lg-left"},[_c('a',{staticClass:"c-partner-benefits__emphasis-text",attrs:{"href":"https://professional.heart.org/"}},[_vm._v("professional.heart.org")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 col-md-12 col-lg-6 mt-3 m-sm-0 text-center text-sm-right text-md-center text-lg-right"},[_c('span',{staticClass:"c-partner-benefits__hash-tag"},[_vm._v("#AHAMembership")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c6244e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_article_link_vue__ = __webpack_require__(1323);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c6244e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_article_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("Published Nov 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link PHD__article-link--large",attrs:{"href":"#"}},[_vm._v("Cryptogenic Stroke: Evaluation and Management")]),_vm._v(" "),_c('p',{staticClass:"PHD__article-summary"},[_vm._v("This webinar series covers evaluation of patients with cryptogenic stroke, cardiac monitoring and the role of atrial cardiopathy; and the management Strategies for patients with cryptogenic stroke. Descriptions and accreditations are shown under Activity Information. Accreditation is claimed separately on each activity. Click the Register button to purchase the bundle.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5824c84e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_card_vue__ = __webpack_require__(1325);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5824c84e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-phd-card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"c-phd-card__content"},[_c('p',{attrs:{"slot":"content"},slot:"content"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam interdum maximus turpis, nec malesuada augue interdum at. Ut sed elit mollis, sollicitudin nisi sed, congue diam. ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-phd-card__header"},[_c('a',{attrs:{"href":"#"}},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"//placehold.it/750x563/ddd/ccc?text=FPO","alt":"alt text"}})]),_vm._v(" "),_c('h3',{staticClass:"c-phd-card__heading"},[_c('abbr',{attrs:{"title":"National Aeronautics and Space Administration","aria-label":"National Aeronautics and Space Administration"}},[_vm._v("NASA")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-phd-card__actions"},[_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("Scientific Sessions")])]),_vm._v(" "),_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("Resuscitation Science Symposium")])]),_vm._v(" "),_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("CVRI Council Awards")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD__citations"},[_c('div',{staticClass:"container PHD__citations-container"},[_c('div',{staticClass:"phd-shadow-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 PHD__citations-title"},[_c('h2',[_vm._v("Citation")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 PHD__citations-divider"},[_c('hr',{staticClass:"divider"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 PHD__citations-content"},[_c('p',[_vm._v("Oiri J Sista AK, Weinberg I, Kearon C, Kumbhani DJ, Desal NQ, Plazza G, Gladwin MT, Chatterjee S, Kobayhoshi T, Kabrhel C, Dornes OO; on behalf of American HEart Association Council on Peripheral Vascular Disease, Council on Arterosclercsis, Thrombosis and Vascular Biology, Council on Cardiopulmonary Critical Care, Percipitive and Resuscitation, and Council on Cardiovascular Surgery and Anesthesia. "),_c('a',{attrs:{"href":"#"}},[_vm._v("Interventional therapies for acute pulmonary embolism, current status and principles for the development of novel evidence: a scientific statement from the American Heart Association")]),_vm._v(" (published online ahead of print Octoboer 4, 2019. Circulation dot: 10.116VCIR0000000000707).")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('div',{staticClass:"l-main"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',{staticClass:"page-heading mb-3"},[_vm._v("PHD Media Block / Profile Card component examples")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',{staticClass:"h2 mb-3"},[_vm._v("Media Block - All fields present")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6 mb-4"},[_c('div',{staticClass:"media-block phd-shadow-box"},[_c('div',{staticClass:"row media-block__first-row"},[_c('div',{staticClass:"col-12 media-block__top"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 media-block__title"},[_c('h2',{staticClass:"h2"},[_vm._v("Example title for this specific block")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 media-block__media-container"},[_c('img',{staticClass:"img-fluid",attrs:{"src":"https://via.placeholder.com/180/440066/eeeeee","alt":"placeholder image"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 media-block__rich-container"},[_c('p',[_vm._v("Rich text goes here.")]),_vm._v(" "),_c('p',[_vm._v("Deserunt est, repellat, debitis excepturi corrupti velit laudantium eveniet at, obcaecati amet neque ad doloremque quod et facilis eius? Esse, beatae voluptatem ab delectus eaque consequuntur commodi id reiciendis adipisci?")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"#"}},[_vm._v("example link below first paragraph, still in rich text")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 media-block__bottom"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Example bottom of block link")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 mb-4"},[_c('div',{staticClass:"media-block phd-shadow-box"},[_c('div',{staticClass:"row media-block__first-row"},[_c('div',{staticClass:"col-12 media-block__top"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 media-block__title"},[_c('h2',{staticClass:"h2"},[_vm._v("Example title for this specific block")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 media-block__media-container"},[_c('img',{staticClass:"img-fluid",attrs:{"src":"https://via.placeholder.com/180/440066/eeeeee","alt":"placeholder image"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 media-block__rich-container"},[_c('p',[_vm._v("Rich text goes here.")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus deleniti id quisquam, minima eligendi asperiores recusandae laboriosam reiciendis necessitatibus magni doloremque numquam ipsum iusto ea non nemo facere cum laborum.")]),_vm._v(" "),_c('p',[_vm._v("Fugiat harum voluptates sequi id temporibus reiciendis mollitia officia? Error excepturi quidem pariatur earum dolor distinctio assumenda facilis, unde iure officia sint reprehenderit nulla qui quo voluptas atque molestias architecto.")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"#"}},[_vm._v("example link below first paragraph, still in rich text")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 media-block__bottom"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Example bottom of block link")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',{staticClass:"h2 mt-5 mb-3"},[_vm._v("Media Block(s) - no optional fields present")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-8 mb-4"},[_c('div',{staticClass:"phd-shadow-box"},[_c('h2',{staticClass:"mb-3"},[_vm._v("Stacked example of minimal content media items")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 my-2"},[_c('div',{staticClass:"media-block"},[_c('div',{staticClass:"row media-block__first-row"},[_c('div',{staticClass:"col-12 media-block__top"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 media-block__media-container"},[_c('img',{attrs:{"src":"https://via.placeholder.com/180/440066/eeeeee","alt":"placeholder image"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 media-block__rich-container"},[_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae perferendis non necessitatibus. Voluptatibus adipisci iure, hic velit qui a sed est nesciunt laborum inventore cupiditate porro aliquid. Vel, voluptatibus nihil.")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 my-2"},[_c('div',{staticClass:"media-block"},[_c('div',{staticClass:"row media-block__first-row"},[_c('div',{staticClass:"col-12 media-block__top"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 media-block__media-container"},[_c('img',{attrs:{"src":"https://via.placeholder.com/180/440066/eeeeee","alt":"placeholder image"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 media-block__rich-container"},[_c('p',[_vm._v("Sed quam, esse in delectus consequatur, ullam enim ipsa sunt corrupti odio, ducimus facilis amet ea eveniet voluptates fuga corporis nemo totam perspiciatis unde tempora! Distinctio vero ad sapiente placeat.")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 my-2"},[_c('div',{staticClass:"media-block"},[_c('div',{staticClass:"row media-block__first-row"},[_c('div',{staticClass:"col-12 media-block__top"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 media-block__media-container"},[_c('img',{attrs:{"src":"https://via.placeholder.com/180/440066/eeeeee","alt":"placeholder image"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 media-block__rich-container"},[_c('p',[_vm._v("Iusto inventore, id possimus iste modi nihil provident ullam adipisci minus sequi architecto consectetur commodi dignissimos, molestiae distinctio quibusdam ipsum reiciendis vel accusamus ipsam cum alias, dolores minima veritatis. Ratione!")])])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4 mb-4"},[_c('div',{staticClass:"phd-shadow-box"},[_c('p',[_vm._v("Ignore me, as I am only a placeholder to simulate the right-side-content.  I like lemon & strawberry cupcakes best.")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aspernatur reprehenderit eligendi inventore quos dignissimos labore cum ut voluptate aut qui distinctio, similique quibusdam! Unde, cumque a magni odio numquam fugiat.")]),_vm._v(" "),_c('p',[_vm._v("Quia veniam, numquam fugiat consequuntur nobis voluptas blanditiis obcaecati architecto sapiente ipsa. Necessitatibus nisi ratione blanditiis laborum alias, doloremque, maiores ipsum non magnam sunt eum ut aliquid incidunt sapiente tempora!")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bfb594b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_meeting_vue__ = __webpack_require__(1329);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bfb594b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_meeting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"c-phd-meeting"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md c-phd-meeting__image-container"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('img',{attrs:{"src":"https://placekitten.com/1398/858","alt":"alt text"}}),_vm._v(" "),_c('span',{staticClass:"c-phd-meeting__image-title"},[_vm._v("Featured Session")])])]),_vm._v(" "),_c('div',{staticClass:"col-md c-phd-meeting__metadata-container"},[_c('h3',[_vm._v("International Stroke Conference")]),_vm._v(" "),_c('p',{staticClass:"date"},[_vm._v("Precon & Nursing: Feb. 18 | Sessions: Feb. 19–21, 2020")]),_vm._v(" "),_c('p',{staticClass:"location"},[_vm._v("Los Angeles, Calif.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"c-phd-meeting__registration c-phd-meeting__registration--status"},[_vm._v("Registration now open")]),_vm._v(" "),_c('p',{staticClass:"c-phd-meeting__registration c-phd-meeting__registration--message"},[_vm._v("Get EARLY pricing through Dec. 31!")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 order-2 order-md-1 c-phd-meeting__content-container"},[_c('p',[_vm._v("Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nemo eveniet exercitationem esse architecto consequatur consequuntur sapiente, modi accusamus amet porro deserunt perferendis soluta sunt quisquam autem dolorem dolore! Vitae, natus.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ad ut nisi quia assumenda, voluptas incidunt quasi dolor. Neque, corporis a dolorum facilis facere qui quidem expedita ex id, aliquid exercitationem?")]),_vm._v(" "),_c('li',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus laboriosam culpa vitae! Optio possimus perspiciatis accusamus laborum odio quisquam reprehenderit vitae maiores quas est. Beatae incidunt blanditiis sit ut distinctio.")])]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga, labore aperiam. Minus hic ipsa ullam, consequatur doloribus rem distinctio aut adipisci facere! Fugiat, consequatur accusantium necessitatibus fuga sit consequuntur iste.")])]),_vm._v(" "),_c('ul',{staticClass:"col-12 order-1 order-lg-2 c-phd-meeting__buttons-list"},[_c('li',{staticClass:"c-phd-meeting__buttons-list-item"},[_c('a',{staticClass:"btn btn-outline",attrs:{"href":"#"}},[_vm._v("Housing & Transportation")])]),_vm._v(" "),_c('li',{staticClass:"c-phd-meeting__buttons-list-item"},[_c('a',{staticClass:"btn btn-outline",attrs:{"href":"#"}},[_vm._v("Submit Abstract")])]),_vm._v(" "),_c('li',{staticClass:"c-phd-meeting__buttons-list-item"},[_c('a',{staticClass:"btn btn-outline",attrs:{"href":"#"}},[_vm._v("View Programming")])]),_vm._v(" "),_c('li',{staticClass:"c-phd-meeting__buttons-list-item"},[_c('a',{staticClass:"btn",attrs:{"href":"#"}},[_vm._v("Register Now")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD__references"},[_c('div',{staticClass:"container PHD__references-container"},[_c('div',{staticClass:"phd-shadow-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 PHD__references-title"},[_c('h2',[_vm._v("References")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 PHD__references-divider"},[_c('hr',{staticClass:"divider"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 PHD__references-content"},[_c('p',{attrs:{"id":"reference-1"}},[_vm._v("1. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Eos, in quidem eum magnam quas nulla facere dolorem provident voluptas tempore sunt, suscipit asperiores? Dolor laudantium esse iure consequuntur, recusandae asperiores.")]),_vm._v(" "),_c('p',{attrs:{"id":"reference-2"}},[_vm._v("2. Molestiae pariatur, soluta nobis autem totam obcaecati dolorum iure. Ipsa, voluptatem debitis. Quae vel odio corporis reiciendis, officia quam fugit ab, mollitia officiis necessitatibus asperiores repellat omnis nisi optio tempore.")]),_vm._v(" "),_c('p',{attrs:{"id":"reference-3"}},[_vm._v("3. Quam laborum vel possimus corporis vero dolorem voluptatum. Corrupti reiciendis sapiente ab necessitatibus a incidunt consectetur sed dicta alias totam, voluptatem dolorem unde sit nesciunt eligendi vel, praesentium blanditiis ratione.")]),_vm._v(" "),_c('p',{attrs:{"id":"reference-4"}},[_vm._v("4. Architecto numquam sunt quam delectus ipsa placeat ex aliquam deleniti distinctio minus aut unde, nam cumque aspernatur exercitationem inventore ratione dignissimos nihil! Perferendis reprehenderit dicta libero similique doloribus delectus nam.")]),_vm._v(" "),_c('p',{attrs:{"id":"reference-5"}},[_vm._v("5. Veritatis, unde. Voluptates fugit quas quisquam aut quis? Dolores facilis non quaerat natus voluptatum minus modi, pariatur dicta repellendus consequatur amet, inventore nemo officiis ducimus, perspiciatis sequi quos! Ex, quisquam!")]),_vm._v(" "),_c('p',{attrs:{"id":"reference-6"}},[_vm._v("6. Voluptates aperiam magni officiis rem porro, repellendus quaerat dicta assumenda ipsam voluptate veniam sunt eos. Rerum earum sint ea veritatis, iste consequuntur nostrum et laborum quibusdam! Facere aperiam quae debitis.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phd-video"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId0'),expression:"'uniqueModalId0'"}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?0'),expression:"'//placeimg.com/1200/600/any?0'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId0","video-id":"M7lc1UVf-VE"}}),_vm._v(" "),_c('p',{staticClass:"c-video__title h5"},[_vm._v("Video Caption")])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23776c67_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_volunteer_search_vue__ = __webpack_require__(1333);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23776c67_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_volunteer_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-ce-search l-promo--shadow"},[_c('div',{staticClass:"c-ce-search__top"},[_vm._m(0),_vm._v(" "),_c('aha-search-results-form',{attrs:{"action":"search","query-delimeter":"#","role":"search"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('label',{staticClass:"c-ce-search__top-label"},[_c('div',{staticClass:"pb-2",attrs:{"id":"ahaRegionHeading"}},[_vm._v("AHA Region")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"ahaRegionHeading","input-name":"ahaRegion","input-directive":true,"default-value":"option-3","toggle-class":"c-search-group__dropdown btn btn-white btn--select"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Select AHA Region")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Select AHA Region","value":"","item-class":"c-select-dropdown__item"}},[_vm._v("Select AHA Region")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 1","value":"option-1","item-class":"c-select-dropdown__item"}},[_vm._v("Option 1")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 2","value":"option-2","item-class":"c-select-dropdown__item"}},[_vm._v("Option 2")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 3","value":"option-3","item-class":"c-select-dropdown__item"}},[_vm._v("Option 3")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 4","value":"option-4","item-class":"c-select-dropdown__item"}},[_vm._v("Option 4")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 5","value":"option-5","item-class":"c-select-dropdown__item"}},[_vm._v("Option 5")])],1)],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{staticClass:"c-ce-search__top-label"},[_c('div',{staticClass:"pb-2",attrs:{"id":"specialitiesHeading"}},[_vm._v("Specialities")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"specialitiesHeading","input-name":"specialities","input-directive":true,"default-value":"","toggle-class":"c-search-group__dropdown btn btn-white btn--select"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Select Specialities")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Select Specialities","value":"","item-class":"c-select-dropdown__item","selected":""}},[_vm._v("Select Specialities")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 1","value":"option-1","item-class":"c-select-dropdown__item"}},[_vm._v("Option 1")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 2","value":"option-2","item-class":"c-select-dropdown__item"}},[_vm._v("Option 2")])],1)],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{staticClass:"c-ce-search__top-label"},[_c('div',{staticClass:"pb-2",attrs:{"id":"classificationsHeading"}},[_vm._v("Classifications")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"classificationsHeading","input-name":"classifications","input-directive":true,"default-value":"","toggle-class":"c-search-group__dropdown btn btn-white btn--select"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Select Classifications")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Select Classifications","value":"","item-class":"c-select-dropdown__item","selected":""}},[_vm._v("Select Classifications")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 1","value":"option-1","item-class":"c-select-dropdown__item"}},[_vm._v("Option 1")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 2","value":"option-2","item-class":"c-select-dropdown__item"}},[_vm._v("Option 2")])],1)],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{staticClass:"c-ce-search__top-label"},[_c('div',{staticClass:"pb-2",attrs:{"id":"genderHeading"}},[_vm._v("Gender")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"genderHeading","input-name":"gender","input-directive":true,"default-value":"","toggle-class":"c-search-group__dropdown btn btn-white btn--select"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Select Gender")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Select Gender","value":"","item-class":"c-select-dropdown__item","selected":""}},[_vm._v("Select Gender")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 1","value":"option-1","item-class":"c-select-dropdown__item"}},[_vm._v("Option 1")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 2","value":"option-2","item-class":"c-select-dropdown__item"}},[_vm._v("Option 2")])],1)],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{staticClass:"c-ce-search__top-label"},[_c('div',{staticClass:"pb-2",attrs:{"id":"ethnicityHeading"}},[_vm._v("Ethnicity")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"ethnicityHeading","input-name":"ethnicity","input-directive":true,"default-value":"","toggle-class":"c-search-group__dropdown btn btn-white btn--select"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Select Ethnicity")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Select Ethnicity","value":"","item-class":"c-select-dropdown__item","selected":""}},[_vm._v("Select Ethnicity")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 1","value":"option-1","item-class":"c-select-dropdown__item"}},[_vm._v("Option 1")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 2","value":"option-2","item-class":"c-select-dropdown__item"}},[_vm._v("Option 2")])],1)],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('label',{staticClass:"c-ce-search__top-label"},[_c('div',{staticClass:"pb-2",attrs:{"id":"careerStageHeading"}},[_vm._v("Community Career Stage")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"careerStageHeading","input-name":"careerStage","input-directive":true,"default-value":"","toggle-class":"c-search-group__dropdown btn btn-white btn--select"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Select Career Stage")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Select Community Type","value":"","item-class":"c-select-dropdown__item","selected":""}},[_vm._v("Select Community Type")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 1","value":"option-1","item-class":"c-select-dropdown__item"}},[_vm._v("Option 1")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 2","value":"option-2","item-class":"c-select-dropdown__item"}},[_vm._v("Option 2")])],1)],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-4"},[_c('button',{staticClass:"btn btn-round btn-primary c-ce-search__search-btn",attrs:{"disabled":!slotProps.isValid()},on:{"click":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}},[_vm._v("Search")])])])]}}])})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-ce-search__top-title"},[_c('h3',{staticClass:"c-ce-search__top-header"},[_vm._v("Professional Volunteer Search")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d059be4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__ = __webpack_require__(1335);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d059be4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-phd-profile js-mobile-nav-positioning"},[_c('div',{staticClass:"c-phd-profile__container d-flex d-lg-block justify-content-between align-items-center"},[_c('aha-mobile-nav',{attrs:{"nav-id":"profile-navigation","nav-ref":"profileNav","modal-title":"Profile Navigation","modal-tag":"nav","show-on-desktop":true}},[[_c('div',{staticClass:"c-phd-profile__profile d-flex flex-column align-items-center"},[_c('div',{staticClass:"position-relative mb-3"},[_c('img',{staticClass:"thumbnail rounded-circle",attrs:{"src":"//placehold.it/100x100/ddd/ccc?text=FPO"}}),_vm._v(" "),_c('span',{staticClass:"position-absolute d-flex justify-content-center align-items-center text-uppercase c-phd-profile__badge c-phd-profile__badge--silver"},[_vm._v("Silver")]),_vm._v(" "),_c('span',{staticClass:"position-absolute d-flex justify-content-center align-items-center text-uppercase c-phd-profile__badge c-phd-profile__badge--gold"},[_vm._v("Gold")])]),_vm._v(" "),_c('span',{staticClass:"c-phd-profile__name mb-3"},[_vm._v("Gina Von der Kret")]),_vm._v(" "),_c('div',{staticClass:"c-phd-profile__member c-phd-profile__member--current d-flex align-items-center"},[_c('span',{staticClass:"d-inline-block c-phd-profile__member-status text-uppercase"},[_vm._v("Premier Member")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block c-phd-profile__member-number"},[_vm._v("12345678")])]),_vm._v(" "),_c('div',{staticClass:"c-phd-profile__faha-status"},[_c('p',{staticClass:"mt-2 c-phd-profile__faha-label"},[_vm._v("Faha")]),_vm._v(" "),_c('span',{staticClass:"mt-2 c-phd-profile__expiry-date"},[_vm._v("Exp. 6/30/2020")])])]),_vm._v(" "),_c('ul',{staticClass:"c-phd-profile__nav-list"},[_c('li',{staticClass:"nav-item active"},[_c('a',{staticClass:"d-flex justify-content-start align-items-center",attrs:{"href":""}},[_c('img',{staticClass:"c-phd-profile__icon-default",attrs:{"src":"assets/icons/icon_dashboard-default.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"c-phd-profile__icon-active",attrs:{"src":"assets/icons/icon_dashboard-hover.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("My Dashboard")])])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"d-flex justify-content-start align-items-center",attrs:{"href":""}},[_c('img',{staticClass:"c-phd-profile__icon-default",attrs:{"src":"assets/icons/icon-account-summary-default.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"c-phd-profile__icon-active",attrs:{"src":"assets/icons/icon-accountsummary-hover.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("Account Summary")])])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"d-flex justify-content-start align-items-center",attrs:{"href":""}},[_c('img',{staticClass:"c-phd-profile__icon-default",attrs:{"src":"assets/icons/icon-partner-directory-default.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"c-phd-profile__icon-active",attrs:{"src":"assets/icons/icon-partner-directory-hover.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("Partner Directory")])])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"d-flex justify-content-start align-items-center",attrs:{"href":""}},[_c('img',{staticClass:"c-phd-profile__icon-default",attrs:{"src":"assets/icons/icon-council-resources-default.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"c-phd-profile__icon-active",attrs:{"src":"assets/icons/icon-council-resources-hover.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("Council Resource Manual")])])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"d-flex justify-content-start align-items-center",attrs:{"href":""}},[_c('img',{staticClass:"c-phd-profile__icon-default",attrs:{"src":"assets/icons/icon-partner-benefitts-default.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"c-phd-profile__icon-active",attrs:{"src":"assets/icons/icon-partner-benefitts-hover.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("Partner Benefits")])])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"d-flex justify-content-start align-items-center",attrs:{"href":""}},[_c('img',{staticClass:"c-phd-profile__icon-default",attrs:{"src":"assets/icons/icon-pincert-default.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"c-phd-profile__icon-active",attrs:{"src":"assets/icons/icon-pincert-hover.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("Pin & Certifcate")])])])]),_vm._v(" "),_c('div',{staticClass:"px-4 px-lg-0 mb-3"},[_c('div',{staticClass:"c-phd-profile__councils-container col-12"},[_c('span',{staticClass:"section__label d-block"},[_vm._v("My Scientific Councils")]),_vm._v(" "),_c('div',{staticClass:"c-phd-profile__councils-container--content"},[_c('div',{staticClass:"c-phd-profile__councils-container--text-block"},[_c('div',{staticClass:"c-phd-profile__councils-container--text-item"},[_c('a',{staticClass:"c-phd-profile__councils-container--text-link",attrs:{"href":"#"}},[_vm._v("ATVB")])]),_vm._v(" "),_c('div',{staticClass:"c-phd-profile__councils-container--text-item"},[_c('a',{staticClass:"c-phd-profile__councils-container--text-link",attrs:{"href":"#"}},[_vm._v("Electrophysiology and Arrhythmias")])])])])])]),_vm._v(" "),_c('div',{staticClass:"p-4 d-lg-none phd-bg--gray-light"},[_c('nav',{staticClass:"profile-navigation",attrs:{"role":"Profile Control Navigation","aria-label":"Profile Control Navigation"}},[_c('a',{staticClass:"profile-navigation__link",attrs:{"href":"#"}},[_c('img',{staticClass:"profile-navigation__icon profile-navigation__icon--default",attrs:{"src":"/assets/icons/icon-profile-default.svg","alt":"Edit Profile"}}),_vm._v(" "),_c('img',{staticClass:"profile-navigation__icon profile-navigation__icon--hover",attrs:{"src":"/assets/icons/icon-profile-hover.svg","alt":"Edit Profile"}}),_vm._v(" "),_c('img',{staticClass:"profile-navigation__icon profile-navigation__icon--active",attrs:{"src":"/assets/icons/icon-profile-active.svg","alt":"Edit Profile"}}),_vm._v("\n                            Edit Profile\n                        ")])])])]],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('img',{staticClass:"thumbnail rounded-circle d-lg-none",attrs:{"src":"//placehold.it/100x100/ddd/ccc?text=FPO"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-lg-none"},[_c('span',{staticClass:"c-phd-profile__mobile-title"},[_vm._v("My Dashboard")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rich-text"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere blanditiis aliquam soluta fuga corporis ex atque inventore veniam quos qui vel illum distinctio iste non voluptate, tempore nemo sequi iure!")]),_vm._v(" "),_c('p',[_vm._v("Lorem, ipsum dolor sit amet consectetur adipisicing elit. Minima, itaque! Minus nemo consectetur dicta distinctio, necessitatibus exercitationem nobis maiores eligendi eaque aliquid inventore sit? Saepe, quidem molestias! Sunt eligendi voluptatum, accusamus eveniet dolore quo! Cum distinctio modi quisquam in harum dolore, excepturi laudantium soluta eius incidunt, inventore libero facere perspiciatis!")]),_vm._v(" "),_c('p',[_vm._v("Lorem, ipsum dolor sit amet consectetur adipisicing elit. Eos, ipsam veritatis perspiciatis voluptas quisquam nihil enim necessitatibus, voluptate, alias in debitis saepe delectus commodi similique at dignissimos corrupti voluptatum laboriosam omnis a placeat magnam! Eum blanditiis, pariatur at corrupti nesciunt deleniti commodi, ea unde nostrum impedit mollitia vero voluptatum rerum, repellat dolor repudiandae facere? Perspiciatis maiores, vel quis vero delectus eaque, assumenda magni maxime dolore magnam recusandae reprehenderit inventore voluptatibus placeat, cupiditate enim consectetur. Recusandae illo officiis, rem repellat eaque eligendi earum placeat corrupti ipsum maxime quaerat, excepturi adipisci mollitia?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quidem magni dolores ipsam vitae neque sit laudantium at sequi soluta consequatur voluptatibus eius vero, illum aspernatur praesentium animi, quo fugit ipsum.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_secondary_tertiary_nav_vue__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_secondary_tertiary_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_secondary_tertiary_nav_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_secondary_tertiary_nav_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_secondary_tertiary_nav_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_193b2b76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_secondary_tertiary_nav_vue__ = __webpack_require__(1338);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_secondary_tertiary_nav_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_193b2b76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_secondary_tertiary_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('div',{staticClass:"l-main"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"secondary-tertiary-nav"},[_vm._v("SECONDARY TERTIARY NAV")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eum mollitia nam eaque architecto aut voluptatum totam harum! Dolor, placeat dolorem natus optio facilis quasi laboriosam, aliquid corporis, reprehenderit sapiente iusto!")]),_vm._v(" "),_c('p',[_vm._v("Corrupti consequuntur animi officia eaque, voluptas laudantium, pariatur omnis praesentium eum perferendis voluptatibus soluta nulla temporibus! Enim repudiandae natus quidem ad aspernatur, fugit, quibusdam quasi, fugiat asperiores pariatur ipsam magni.")]),_vm._v(" "),_c('phd-nav-secondary-tertiary',{attrs:{"nav-data":_vm.demoData}}),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus, ad? Ullam ipsum voluptatem perferendis mollitia rem voluptatibus nesciunt dolores perspiciatis? Necessitatibus nobis tenetur consequatur delectus nemo ab reprehenderit itaque qui.")]),_vm._v(" "),_c('p',[_vm._v("Quis aspernatur illum neque! Soluta pariatur reiciendis ipsam beatae mollitia in dolore illum non, quia quas quidem. Quos sequi incidunt similique aspernatur amet recusandae quasi rem, maiores porro! Placeat, ipsum.")]),_vm._v(" "),_c('p',[_vm._v("Voluptatum error sapiente ab unde labore quisquam sequi ullam voluptate mollitia, consequatur eligendi saepe perspiciatis delectus hic ratione optio ut aperiam fuga totam cupiditate veniam! Consequatur facilis accusantium perferendis nesciunt.")]),_vm._v(" "),_c('p',[_vm._v("Beatae, dignissimos cumque deleniti quia, excepturi nulla aut possimus deserunt ad distinctio obcaecati consectetur facilis tenetur. Pariatur saepe, sunt distinctio, incidunt odio accusantium culpa laboriosam corrupti libero quos temporibus a.")]),_vm._v(" "),_c('p',[_vm._v("Quisquam id mollitia eveniet hic officiis maiores asperiores iste minus suscipit nesciunt modi ducimus necessitatibus est tempore, quam doloribus! Molestiae distinctio tenetur voluptatibus et sequi, consequatur vel numquam quibusdam cupiditate.")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-heading"},[_c('div',{staticClass:"container section-heading__container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 section-heading__title"},[_c('h2',[_vm._v("Top Things to Know")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 section-heading__by-line"},[_c('p',[_c('strong',[_vm._v("By Jah Chri, MD, MPH, Professor of Radiology, Mayo Clinic College of Medicine, Assistant Professor of Medicine, Hospital of the University of Pennsylvania")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recent-science-news"},[_c('div',{staticClass:"container recent-science-news__container"},[_c('div',{staticClass:"recent-science-news__wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"recent-science-news__featured"},[_c('figure',{staticClass:"recent-science-news__featured-media"},[_c('a',{staticClass:"recent-science-news__featured-media-link",staticStyle:{"background-image":"url('https://via.placeholder.com/800x600/990000/eeeeee?text=Placeholder')"},attrs:{"href":"#"}},[_c('img',{staticClass:"d-md-none",attrs:{"src":"https://via.placeholder.com/800x600/990000/eeeeee?text=Placeholder","alt":"placholder featured image"}}),_vm._v(" "),_c('div',{staticClass:"recent-science-news__featured-card"},[_c('span',{staticClass:"recent-science-news__featured-category"},[_vm._v("Featured News")]),_vm._v(" "),_c('div',{staticClass:"h4 recent-science-news__featured-title d-none d-md-block"},[_vm._v("Identification of Racial Inequities in Access to Specialized Inpatient Heart")]),_vm._v(" "),_c('p',{staticClass:"recent-science-news__featured-byline d-none d-md-block"},[_c('span',{staticClass:"byline-date"},[_vm._v("Oct. 29, 2019")]),_vm._v(" "),_c('a',{staticClass:"byline-link",attrs:{"href":"#"}},[_vm._v("Circulation: Heart Failure")]),_vm._v(" "),_c('a',{staticClass:"byline-link",attrs:{"href":"#"}},[_vm._v("Optional 2nd link")]),_vm._v(" "),_c('a',{staticClass:"byline-link",attrs:{"href":"#"}},[_vm._v("3rd link y not")])])])])]),_vm._v(" "),_c('div',{staticClass:"recent-science-news__featured-titles d-md-none"},[_c('h3',{staticClass:"recent-science-news__featured-title"},[_c('a',{staticClass:"title-link",attrs:{"href":"#"}},[_vm._v("Identification of Racial Inequities in Access to Specialized Inpatient Heart Failure Care at an Academic Medical Center")])]),_vm._v(" "),_c('p',{staticClass:"recent-science-news__featured-byline"},[_c('span',{staticClass:"byline-date"},[_vm._v("Oct. 29, 2019")]),_vm._v(" "),_c('a',{staticClass:"byline-link",attrs:{"href":"#"}},[_vm._v("Circulation: Heart Failure")]),_vm._v(" "),_c('a',{staticClass:"byline-link",attrs:{"href":"#"}},[_vm._v("Optional 2nd link")]),_vm._v(" "),_c('a',{staticClass:"byline-link",attrs:{"href":"#"}},[_vm._v("3rd link y not")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6",attrs:{"aria-label":"Article Sidebar"}},[_c('div',{staticClass:"recent-science-news__list"},[_c('div',{staticClass:"recent-science-news__list-heading"},[_vm._v("Recent News")]),_vm._v(" "),_c('div',{staticClass:"recent-science-news__list-item"},[_c('a',{staticClass:"recent-science-news__list-item-title",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('div',{staticClass:"recent-science-news__list-item-byline"},[_c('a',{staticClass:"byline-link",attrs:{"href":"#"}},[_vm._v("Hypertension")]),_vm._v(" "),_c('span',{staticClass:"byline-date"},[_vm._v("Oct. 28, 2019")])])]),_vm._v(" "),_c('div',{staticClass:"recent-science-news__list-item"},[_c('a',{staticClass:"recent-science-news__list-item-title",attrs:{"href":"#"}},[_vm._v("Hypertrophic Cardiomyopathy-Related Sudden Cardiac Death in Young People in Ontario")]),_vm._v(" "),_c('div',{staticClass:"recent-science-news__list-item-byline"},[_c('a',{staticClass:"byline-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" "),_c('span',{staticClass:"byline-date"},[_vm._v("October 21, 2019")])])]),_vm._v(" "),_c('div',{staticClass:"recent-science-news__list-item"},[_c('a',{staticClass:"recent-science-news__list-item-title",attrs:{"href":"#"}},[_vm._v("Circulation: Arrhythmia and Electrophysiology | REMINDER: Call for Papers")]),_vm._v(" "),_c('div',{staticClass:"recent-science-news__list-item-byline"},[_c('a',{staticClass:"byline-link",attrs:{"href":"#"}},[_vm._v("Circulation: Arrhythmia and Electrophysiology")]),_vm._v(" "),_c('a',{staticClass:"byline-link",attrs:{"href":"#"}},[_vm._v("Second")]),_vm._v(" "),_c('a',{staticClass:"byline-link",attrs:{"href":"#"}},[_vm._v("Third Link")]),_vm._v(" "),_c('span',{staticClass:"byline-date"},[_vm._v("October 2, 2019")])])]),_vm._v(" "),_c('div',{staticClass:"recent-science-news__list-item"},[_c('a',{staticClass:"recent-science-news__list-item-title",attrs:{"href":"#"}},[_vm._v("Retired? Hardly - at 99, this pioneering heart doctor is still leading the way")]),_vm._v(" "),_c('div',{staticClass:"recent-science-news__list-item-byline"},[_c('a',{staticClass:"byline-link",attrs:{"href":"#"}},[_vm._v("AHA News")]),_vm._v(" "),_c('span',{staticClass:"byline-date"},[_vm._v("Oct. 18, 2019")])])]),_vm._v(" "),_c('div',{staticClass:"recent-science-news__list-item"},[_c('a',{staticClass:"recent-science-news__list-item-title",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('div',{staticClass:"recent-science-news__list-item-byline"},[_c('a',{staticClass:"byline-link",attrs:{"href":"#"}},[_vm._v("Hypertension")]),_vm._v(" "),_c('span',{staticClass:"byline-date"},[_vm._v("Oct. 28, 2019")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('header',{staticClass:"science-news__heading"},[_c('div',{staticClass:"container science-news__heading-container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 science-news__heading-social"},[_c('aha-share-gigya')],1)]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 science-news__heading-title"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Science News Page Header Here...")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 science-news__heading-date"},[_vm._v("\n                    Published: November 20, 2019\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 science-news__heading-divider"},[_c('hr',{staticClass:"divider"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"science-news__promo"},[_c('div',{staticClass:"container science-news__promo-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 order-md-2 science-news__promo-media"},[_c('img',{attrs:{"src":"http://placehold.it/960x540/220066/dddddd?text=Placeholder","alt":"Placeholder image"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 order-md-1"},[_c('div',{staticClass:"science-news__promo-content"},[_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia, eaque, labore autem fuga velit architecto explicabo ad hic impedit earum nulla, error sit excepturi. Temporibus accusamus doloribus corporis nemo sunt?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eaque suscipit error id eius cupiditate aperiam illo amet? Reiciendis quas consequuntur voluptatibus, dolore odit accusantium at nam nihil ducimus corrupti omnis.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda, magni commodi! Ducimus dolor quisquam impedit consequatur soluta facere, nulla inventore eligendi quis nisi natus ullam tenetur similique molestiae accusantium ipsa?")])]),_vm._v(" "),_c('div',{staticClass:"science-news__promo-link"},[_c('a',{staticClass:"c-cta c-cta--secondary",attrs:{"href":"#"}},[_vm._v("Read the full article in Circulation »")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('div',{staticClass:"l-main"},[_c('div',{staticClass:"signup-promo"},[_c('div',{staticClass:"container"},[_c('a',{staticClass:"signup-promo__wrapper",attrs:{"href":"#"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-9 signup-promo__titles"},[_c('div',{staticClass:"signup-promo__pre-title"},[_c('p',[_vm._v("Get Involved")])]),_vm._v(" "),_c('div',{staticClass:"signup-promo__main-title"},[_vm._v("Submit the Science Volunteer Form")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 col-lg-3 signup-promo__buttons"},[_c('span',{staticClass:"btn btn-outline"},[_vm._v("Sign-up Today long text to test how text is wrapping in the button")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_twitter_feed_vue__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_twitter_feed_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_twitter_feed_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_twitter_feed_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_twitter_feed_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d206a6f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_twitter_feed_vue__ = __webpack_require__(1345);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_twitter_feed_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d206a6f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_twitter_feed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-twitter-feed"},[_c('a',{staticClass:"twitter-timeline",attrs:{"data-widget-id":"265841979852718080","href":"https://twitter.com/AHAScience"}},[_vm._v("Tweets by @AHAScience")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-promo"},[_c('div',{staticClass:"container video-promo__container"},[_c('div',{staticClass:"video-promo__wrapper phd-shadow-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 order-md-2 video-promo__media"},[_c('phd-video')],1),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-6 order-md-1"},[_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col-12 video-promo__content"},[_c('div',{staticClass:"row"},[_c('h2',{staticClass:"col-12 video-promo__content-title"},[_vm._v("Related Resources")]),_vm._v(" "),_c('div',{staticClass:"col-12 video-promo__content-text"},[_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Illo voluptatum nihil neque earum ratione inventore, quos voluptate, nobis autem laudantium quasi possimus. Odio, magnam architecto laborum laudantium maxime provident explicabo?")])])]),_vm._v(" "),_c('div',{staticClass:"row video-promo__content-links"},[_c('div',{staticClass:"col video-promo__link-item"},[_c('a',{staticClass:"video-promo__link c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("link(s) here")])]),_vm._v(" "),_c('div',{staticClass:"col video-promo__link-item"},[_c('a',{staticClass:"video-promo__link c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("link(s) here")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ecb8792_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_top_nav_vue__ = __webpack_require__(1348);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ecb8792_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_top_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"c-top-nav c-phd-top-nav js-mobile-nav-positioning",attrs:{"aria-label":"Top Navigation With Logo"}},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"c-top-nav__nav nav"},[_c('li',{staticClass:"c-top-nav__item c-expand-search"},[_c('div',[_c('div',{attrs:{"id":"_2C06CF83-6699-42FF-83F9-D3052227B325","data-search-interface-id":"coveoC606340E"}},[_c('div',{staticClass:"coveo-search-section"},[_c('div',{staticClass:"CoveoSearchInterface Coveostate CoveoComponentState CoveoComponentOptions CoveoQueryController CoveoDebug coveo-after-initialization",staticStyle:{"display":"block"},attrs:{"id":"_185F67BF-1D73-4AEE-9564-FDE5B0EB24D9_container","data-prebind-maximum-age":"currentMaximumAge","data-applied-prebind":"true","data-maximum-age":"0","data-coveo-for-sitecore-event-registered":"true"}},[_c('div',{staticClass:"CoveoSearchbox",attrs:{"id":"_185F67BF-1D73-4AEE-9564-FDE5B0EB24D9","data-enable-omnibox":"true","data-prebind-maximum-age":"currentMaximumAge","data-placeholder":"ex: Heart Attack Symptoms","data-applied-prebind":"true","data-maximum-age":"0"}},[_c('div',{staticClass:"CoveoForSitecoreExpressions"}),_vm._v(" "),_c('div',{staticClass:"CoveoForSitecoreConfigureSearchHub",attrs:{"data-sc-search-hub":"Search"}}),_c('div',{staticClass:"CoveoOmnibox coveo-query-syntax-disabled magic-box",attrs:{"role":"combobox","aria-expanded":"false","aria-haspopup":"listbox"}},[_c('div',{staticClass:"magic-box-input"},[_vm._m(1),_vm._v(" "),_c('input',{attrs:{"id":"c-expand-search__input","spellcheck":"false","form":"coveo-dummy-form","role":"combobox","autocomplete":"off","aria-autocomplete":"list","title":"Insert a query. Press enter to send","aria-label":"Search","placeholder":"Search"}}),_vm._v(" "),_c('label',{staticClass:"c-expand-search__label",attrs:{"for":"c-expand-search__input"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"magic-box-clear coveo-accessible-button",attrs:{"role":"button","aria-label":"Clear","tabindex":"-1"}},[_c('div',{staticClass:"magic-box-icon"},[_c('svg',{staticClass:"magic-box-clear-svg",attrs:{"enable-background":"new 0 0 13 13","viewBox":"0 0 13 13","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m7.881 6.501 4.834-4.834c.38-.38.38-1.001 0-1.381s-1.001-.38-1.381 0l-4.834 4.834-4.834-4.835c-.38-.38-1.001-.38-1.381 0s-.38 1.001 0 1.381l4.834 4.834-4.834 4.834c-.38.38-.38 1.001 0 1.381s1.001.38 1.381 0l4.834-4.834 4.834 4.834c.38.38 1.001.38 1.381 0s .38-1.001 0-1.381z"}})])])])])]),_c('div',{staticClass:"magic-box-suggestions"})]),_c('a',{staticClass:"CoveoSearchButton coveo-accessible-button",attrs:{"role":"button","aria-label":"Search","tabindex":"0"}},[_c('span',{staticClass:"coveo-search-button"},[_c('svg',{staticClass:"coveo-search-button-svg",attrs:{"enable-background":"new 0 0 20 20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{staticClass:"coveo-magnifier-circle-svg",attrs:{"d":"m8.368 16.736c-4.614 0-8.368-3.754-8.368-8.368s3.754-8.368 8.368-8.368 8.368 3.754 8.368 8.368-3.754 8.368-8.368 8.368m0-14.161c-3.195 0-5.793 2.599-5.793 5.793s2.599 5.793 5.793 5.793 5.793-2.599 5.793-5.793-2.599-5.793-5.793-5.793"}}),_c('path',{attrs:{"d":"m18.713 20c-.329 0-.659-.126-.91-.377l-4.552-4.551c-.503-.503-.503-1.318 0-1.82.503-.503 1.318-.503 1.82 0l4.552 4.551c.503.503.503 1.318 0 1.82-.252.251-.581.377-.91.377"}})])])]),_c('span',{staticClass:"coveo-search-button-loading"},[_c('svg',{staticClass:"coveo-search-button-loading-svg",attrs:{"enable-background":"new 0 0 18 18","viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m16.76 8.051c-.448 0-.855-.303-.969-.757-.78-3.117-3.573-5.294-6.791-5.294s-6.01 2.177-6.79 5.294c-.134.537-.679.861-1.213.727-.536-.134-.861-.677-.728-1.212 1.004-4.009 4.594-6.809 8.731-6.809 4.138 0 7.728 2.8 8.73 6.809.135.536-.191 1.079-.727 1.213-.081.02-.162.029-.243.029z"}}),_c('path',{attrs:{"d":"m9 18c-4.238 0-7.943-3.007-8.809-7.149-.113-.541.234-1.071.774-1.184.541-.112 1.071.232 1.184.773.674 3.222 3.555 5.56 6.851 5.56s6.178-2.338 6.852-5.56c.113-.539.634-.892 1.184-.773.54.112.887.643.773 1.184-.866 4.142-4.57 7.149-8.809 7.149z"}})])])])])]),_c('div',{staticClass:"CoveoForSitecoreContext",attrs:{"data-sc-should-have-analytics-component":"true","data-sc-analytics-enabled":"false","data-sc-current-language":"en","data-prebind-sc-language-field-name":"fieldTranslator","data-sc-language-field-name":"z95xlanguage","data-sc-labels":"{\"Created\" : \"Created\" , \"Created by\" : \"Created by\" , \"Creation time.\" : \"Creation time.\" , \"Language\" : \"Language\" , \"Last time modified.\" : \"Last time modified.\" , \"Template\" : \"Template\" , \"Uniform resource identifier\" : \"URI\" , \"Updated by\" : \"Updated by\" , \"Directions\" : \"Directions\" , \"Miles\" : \"miles\" , \"Website\" : \"Website\" , \"If the problem persists contact the administrator.\" : \"If the problem persists contact the administrator.\" , \"Search is currently unavailable\" : \"Oops! Something went wrong on the server.\"}","data-sc-maximum-age":"0","data-sc-page-name":"Membership","data-sc-page-name-full-path":"/sitecore/content/PHD/Home/Membership","data-sc-index-source-name":"Coveo_master_index - azre1vsitecmdw1-sitecoredevcm.heart.org","data-sc-is-in-experience-editor":"false","data-sc-is-user-anonymous":"true","data-sc-item-uri":"sitecore://master/{8A400D3B-2DEC-4058-A7F7-E9149BD71E38}?lang=en&ver=1","data-sc-item-id":"8a400d3b-2dec-4058-a7f7-e9149bd71e38","data-prebind-sc-latest-version-field-name":"fieldTranslator","data-sc-latest-version-field-name":"z95xlatestversion","data-sc-rest-endpoint-uri":"/coveo/rest","data-sc-site-name":"PHD","data-sc-field-prefix":"f","data-sc-field-suffix":"72644","data-sc-prefer-source-specific-fields":"false","data-sc-external-fields":"[{\"fieldName\":\"permanentid\",\"shouldEscape\":false}]","data-sc-source-specific-fields":"[{\"fieldName\":\"attachmentparentid\"},{\"fieldName\":\"author\"},{\"fieldName\":\"clickableuri\"},{\"fieldName\":\"collection\"},{\"fieldName\":\"concepts\"},{\"fieldName\":\"date\"},{\"fieldName\":\"filetype\"},{\"fieldName\":\"indexeddate\"},{\"fieldName\":\"isattachment\"},{\"fieldName\":\"language\"},{\"fieldName\":\"printableuri\"},{\"fieldName\":\"rowid\"},{\"fieldName\":\"size\"},{\"fieldName\":\"source\"},{\"fieldName\":\"title\"},{\"fieldName\":\"topparent\"},{\"fieldName\":\"topparentid\"},{\"fieldName\":\"transactionid\"},{\"fieldName\":\"uri\"},{\"fieldName\":\"urihash\"}]","data-applied-prebind":"true"}}),_c('div',{staticClass:"coveo-visible-to-screen-reader-only",attrs:{"aria-live":"polite"}})]),_vm._v(" "),_c('div',{staticClass:"coveo-hide-until-settings-added"})])])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('li',{staticClass:"c-top-nav__item phd-login-dropdown"},[_c('aha-nav-dropdown',{attrs:{"position":"right","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle"}},[_c('div',{staticClass:"c-underline-link phd-login-dropdown__logged-in"},[_vm._v("\n                        Leon Truong\n                    ")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('ul',{staticClass:"c-nav-dropdown__list phd-login-dropdown__list",attrs:{"role":"menu"}},[_c('li',{},[_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_c('div',{staticClass:"alert-text"},[_vm._v("Partner account is being processed")])])]),_vm._v(" "),_c('li',{staticClass:"phd-login-dropdown__item",attrs:{"role":"none"}},[_c('a',{staticClass:"phd-login-dropdown__link",attrs:{"role":"menuitem","href":"#"}},[_vm._v("Login")])]),_vm._v(" "),_c('li',{staticClass:"phd-login-dropdown__item",attrs:{"role":"none"}},[_c('a',{staticClass:"phd-login-dropdown__link",attrs:{"role":"menuitem","href":"#"}},[_vm._v("Sign-up")])]),_vm._v(" "),_c('li',{staticClass:"phd-login-dropdown__item",attrs:{"role":"none"}},[_c('a',{staticClass:"phd-login-dropdown__link",attrs:{"role":"menuitem","href":"#"}},[_vm._v("View Dashboard")])]),_vm._v(" "),_c('li',{staticClass:"phd-login-dropdown__item",attrs:{"role":"none"}},[_c('a',{staticClass:"phd-login-dropdown__link",attrs:{"role":"menuitem","href":"#"}},[_vm._v("Sign-out")])]),_vm._v(" "),_c('li',{staticClass:"phd-login-dropdown__item border-0",attrs:{"role":"none"}},[_c('a',{staticClass:"phd-login-dropdown__link text-bold",attrs:{"role":"menuitem","href":"#"}},[_vm._v("Find My Account »")])])])])],2)],1)]),_vm._v(" "),_c('aha-mobile-nav',{attrs:{"modal-role":"dialog","modal-content-role":"document"}},[[_c('ul',{staticClass:"c-mobile-nav__list"},[_c('li',{staticClass:"c-mobile-nav__side-search"},[_c('aha-search-results-form',{staticClass:"c-side-search c-side-search--phd-mobile",attrs:{"action":"/en/search","query-delimeter":"#","role":"search"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('input',{directives:[{name:"input",rawName:"v-input.flagged",value:('q'),expression:"'q'",modifiers:{"flagged":true}}],staticClass:"c-side-search__input",attrs:{"type":"text","id":"phdGlobalMobileSearch","placeholder":"Search","title":"Insert a query. Press enter to send","aria-label":"Insert a query. Press enter to send","name":"q"},on:{"enter":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}}),_vm._v(" "),_c('label',{staticClass:"c-side-search__label mr-0",attrs:{"for":"phdGlobalMobileSearch"}},[_vm._v("\n                                            Search\n                                        ")]),_vm._v(" "),_c('button',{staticClass:"btn c-side-search__btn",attrs:{"label":"Search button."},on:{"click":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18px","height":"18px","viewBox":"0 0 23.414101 23.414062"}},[_c('g',{attrs:{"transform":"translate(-1358,-18)"}},[_c('path',{attrs:{"d":"m 1374.4004,32.986328 -1.4141,1.414063 0.7071,0.707031 5.5996,5.599609 0.707,0.707031 1.4141,-1.414062 -0.7071,-0.707031 -5.5996,-5.59961 z"}}),_vm._v(" "),_c('path',{attrs:{"d":"m 1368,18 c -5.511,0 -10,4.488997 -10,10 0,5.511003 4.489,10 10,10 5.511,0 10,-4.488997 10,-10 0,-5.511003 -4.489,-10 -10,-10 z m 0,2 c 4.4301,0 8,3.569877 8,8 0,4.430123 -3.5699,8 -8,8 -4.4301,0 -8,-3.569877 -8,-8 0,-4.430123 3.5699,-8 8,-8 z"}})])])])])])]}}])})],1),_vm._v(" "),_c('li',{staticClass:"c-mobile-nav__login phd-login-dropdown"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.mobilenavcollapse0",modifiers:{"mobilenavcollapse0":true}}],staticClass:"c-mobile-nav__list-item btn btn-link-plain btn--select phd-login-dropdown__logged-in"},[_c('span',[_vm._v("Gina")])]),_vm._v(" "),_c('b-collapse',{attrs:{"role":"","id":"mobilenavcollapse0","visible":false}},[_c('ul',{staticClass:"c-nav-dropdown__list phd-login-dropdown__list",attrs:{"role":"menu"}},[_c('li',{},[_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_c('div',{staticClass:"alert-text"},[_vm._v("Partner account is being processed")])])]),_vm._v(" "),_c('li',{staticClass:"phd-login-dropdown__item",attrs:{"role":"none"}},[_c('a',{staticClass:"phd-login-dropdown__link",attrs:{"role":"menuitem","href":"#"}},[_vm._v("Login")])]),_vm._v(" "),_c('li',{staticClass:"phd-login-dropdown__item",attrs:{"role":"none"}},[_c('a',{staticClass:"phd-login-dropdown__link",attrs:{"role":"menuitem","href":"#"}},[_vm._v("Sign-up")])]),_vm._v(" "),_c('li',{staticClass:"phd-login-dropdown__item",attrs:{"role":"none"}},[_c('a',{staticClass:"phd-login-dropdown__link",attrs:{"role":"menuitem","href":"#"}},[_vm._v("View Dashboard")])]),_vm._v(" "),_c('li',{staticClass:"phd-login-dropdown__item",attrs:{"role":"none"}},[_c('a',{staticClass:"phd-login-dropdown__link",attrs:{"role":"menuitem","href":"#"}},[_vm._v("Sign-out")])]),_vm._v(" "),_c('li',{staticClass:"phd-login-dropdown__item border-0",attrs:{"role":"none"}},[_c('a',{staticClass:"phd-login-dropdown__link text-bold",attrs:{"role":"menuitem","href":"#"}},[_vm._v("Find My Account »")])])])])],1),_vm._v(" "),_c('li',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.mobileNavCollapse1",modifiers:{"mobileNavCollapse1":true}}],staticClass:"c-mobile-nav__list-item btn btn-link-plain btn--select"},[_vm._v("\n                           Communities\n                        ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"mobileNavCollapse1","visible":false}},[_c('a',{staticClass:"c-mobile-nav__dropdown-header",attrs:{"href":"#"}},[_vm._v("Communities")]),_vm._v(" "),_c('ul',{staticClass:"c-mobile-nav__sub-list nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 1")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 2")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 3")])])])])],1),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle.mobileNavCollapse2",modifiers:{"mobileNavCollapse2":true}}],staticClass:"c-mobile-nav__list-item btn btn-link-plain",attrs:{"href":"#"}},[_vm._v("\n                            Guidelines & Statements\n                        ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"mobileNavCollapse2","visible":false}},[_c('a',{staticClass:"c-mobile-nav__dropdown-header",attrs:{"href":"#"}},[_vm._v("Communities")]),_vm._v(" "),_c('ul',{staticClass:"c-mobile-nav__sub-list nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 1")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 2")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 3")])])])])],1),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mobile-nav__list-item btn btn-link-plain",attrs:{"href":"#"}},[_vm._v("\n                            Journals\n                        ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mobile-nav__list-item btn btn-link-plain",attrs:{"href":"#"}},[_vm._v("\n                            Education\n                        ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mobile-nav__list-item btn btn-link-plain",attrs:{"href":"#"}},[_vm._v("\n                            Meetings\n                        ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-mobile-nav__list-item btn btn-link-plain",attrs:{"href":"#"}},[_vm._v("\n                            Membership/Councils\n                        ")])]),_vm._v(" "),_c('li',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.mobileNavCollapse7",modifiers:{"mobileNavCollapse7":true}}],staticClass:"c-mobile-nav__list-item btn btn-link-plain btn--select"},[_vm._v("\n                            Research Programs\n                        ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"mobileNavCollapse7","visible":false}},[_c('a',{staticClass:"c-mobile-nav__dropdown-header",attrs:{"href":"#"}},[_vm._v("Research Programs")]),_vm._v(" "),_c('ul',{staticClass:"c-mobile-nav__sub-list nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-item-heading",attrs:{"href":"#"}},[_vm._v("Research Programs")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"sub-nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 1")])]),_vm._v(" "),_c('li',{staticClass:"sub-nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 2")])]),_vm._v(" "),_c('li',{staticClass:"sub-nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 3")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-item-heading",attrs:{"href":"#"}},[_vm._v("Strategically Focused Research")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"sub-nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 1")])]),_vm._v(" "),_c('li',{staticClass:"sub-nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 2")])]),_vm._v(" "),_c('li',{staticClass:"sub-nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 3")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-item-heading",attrs:{"href":"#"}},[_vm._v("Menu Item 2")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-item-heading",attrs:{"href":"#"}},[_vm._v("Menu Item 3")])])])])],1),_vm._v(" "),_c('li',{staticClass:"c-mobile-nav__utility"},[_c('phd-top-utility-nav')],1),_vm._v(" "),_c('li',{staticClass:"c-mobile-nav__social"},[_c('ul',{staticClass:"c-mobile-nav__sub-list nav l-icon-nav"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/twitter-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/facebook-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/google-plus-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/instagram-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/youtube-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/linkedin-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/share/pinterest-gray.svg"}})])])])])])]],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"c-top-nav__logo",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"https://sitecoretestphdcm.heart.org/-/media/project/phd/logos/750x150_phdlogo_2019.png?h=150&w=751&hash=BB0AF3042362FC4F1469AF4F9F58FD3DA7921D43","alt":""}}),_c('span',{staticClass:"sr-only"},[_vm._v("Logo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"magic-box-underlay"},[_c('span',{staticClass:"magic-box-highlight-container"},[_c('span',{attrs:{"data-id":"start","data-success":"true"}},[_c('span',{attrs:{"data-id":"Any","data-success":"true","data-value":""}})])]),_c('span',{staticClass:"magic-box-ghost-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-top-nav__item px-4",attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("|")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1654995e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_top_utility_nav_vue__ = __webpack_require__(1350);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1654995e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_top_utility_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"c-top-utility-nav",attrs:{"aria-label":"Utility Navigation"}},[_c('ul',{staticClass:"w-100 d-none d-lg-flex c-top-utility-nav__desktop-container"},[_c('li',{staticClass:"c-top-nav__item",attrs:{"data-aha-nav":"healthy-living"}},[_c('aha-nav-dropdown',{attrs:{"position":"center","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle pr-0"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("GET INVOLVED")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('ul',{staticClass:"c-nav-dropdown__list"},[_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Donate")])]),_vm._v(" "),_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Link 1")])]),_vm._v(" "),_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Link 2")])]),_vm._v(" "),_c('li',{staticClass:"c-nav-dropdown__item"},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#"}},[_vm._v("Link 3")])])])])],2)],1),_vm._v(" "),_c('li',{staticClass:"c-top-nav__item"},[_c('button',{staticClass:"c-top-nav__link c-cta c-cta--icon pr-0",on:{"click":function($event){return _vm.$root.$emit('bv::show::modal', 'jobResourcesModal', $event.target)}}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("JOB RESOURCES")])]),_vm._v(" "),_c('aha-modal',{ref:"jobResourcesModal",staticClass:"c-location-modal c-job-resources-modal",attrs:{"id":"jobResourcesModal","hide-footer":"","centered":"","lazy":""}},[_c('template',{slot:"modal-header"},[_c('h2',{staticClass:"c-location-modal__heading h4"},[_vm._v("Professional Job Board")])]),_vm._v(" "),_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'jobResourcesModal', $event.target)}}},[_vm._v("×")]),_vm._v(" "),_c('aha-external-script',{attrs:{"id":"jobsListDesktopModal","src":"//professionaljobs.heart.org/distrib/jobs/javascript.cfm?code=o8y2CsjrEtJ5rFfsGZy7cHHMzhLEeeQQ"}})],2)],1),_vm._v(" "),_c('li',{staticClass:"c-top-nav__item",attrs:{"data-aha-nav":"healthy-living"}},[_c('aha-nav-dropdown',{attrs:{"position":"center","extra-classes":"c-top-nav__link c-cta c-cta--icon dropdown-toggle pr-0"}},[_c('span',{staticClass:"c-underline-link"},[_vm._v("TOOLS & RESOURCES")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('ul',{staticClass:"c-nav-dropdown__list",attrs:{"role":"menu"}},[_c('li',{attrs:{"role":"none"}},[_c('a',{staticClass:"c-nav-dropdown__link",attrs:{"href":"#","role":"menuitem"}},[_vm._v("Accute Coronary Syndromes")])])])])],2)],1)]),_vm._v(" "),_c('ul',{staticClass:"d-lg-none c-top-utility-nav__mobile-container c-mobile-nav__list"},[_c('li',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.mobileNavCollapseGetInvolved",modifiers:{"mobileNavCollapseGetInvolved":true}}],staticClass:"c-mobile-nav__list-item btn btn-link-plain btn--select"},[_vm._v("\n                GET INVOLVED\n            ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"mobileNavCollapseGetInvolved","visible":false}},[_c('ul',{staticClass:"c-mobile-nav__sub-list nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 1")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 2")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 3")])])])])],1),_vm._v(" "),_c('li',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.mobileNavCollapseJobResources",modifiers:{"mobileNavCollapseJobResources":true}}],staticClass:"c-mobile-nav__list-item btn btn-link-plain btn--select"},[_vm._v("\n                JOB RESOURCES\n            ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"mobileNavCollapseJobResources"}},[_c('aha-external-script',{attrs:{"id":"jobsListMobileView","src":"//professionaljobs.heart.org/distrib/jobs/javascript.cfm?code=o8y2CsjrEtJ5rFfsGZy7cHHMzhLEeeQQ"}})],1)],1),_vm._v(" "),_c('li',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.mobileNavCollapseTools",modifiers:{"mobileNavCollapseTools":true}}],staticClass:"c-mobile-nav__list-item btn btn-link-plain btn--select"},[_vm._v("\n                TOOLS & RESOURCES\n            ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"mobileNavCollapseTools","visible":false}},[_c('ul',{staticClass:"c-mobile-nav__sub-list nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 1")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 2")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 3")])])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('div',{staticClass:"l-main"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-8"},[_c('div',{staticClass:"phd-shadow-box"},[_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias exercitationem expedita optio asperiores quisquam quia vitae perferendis iusto excepturi id vel, rem provident deleniti natus unde fugit ipsum, temporibus nihil?")]),_vm._v(" "),_c('p',[_vm._v("Saepe nisi, rerum consequatur recusandae at tempora facere vel, mollitia magnam ad, consectetur animi. Eligendi eius repellat, modi sequi recusandae doloremque consequuntur, et distinctio ipsam aspernatur fuga, sint temporibus perferendis!")]),_vm._v(" "),_c('p',[_vm._v("Voluptas consectetur eaque fuga dolores id aperiam rerum quisquam alias nesciunt. Tempore hic fugit totam tenetur odit esse est quisquam? Blanditiis, nihil maiores minima assumenda aperiam qui corrupti quisquam quas?")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4"},[_c('div',{staticClass:"upcoming-meetings phd-shadow-box"},[_c('h2',{staticClass:"section__label upcoming-meetings__header"},[_vm._v("Upcoming AHA Conferences")]),_vm._v(" "),_c('ul',{staticClass:"upcoming-meetings__list"},[_c('li',{staticClass:"upcoming-meetings__item"},[_c('p',{staticClass:"upcoming-meetings__item-title"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Meeting 1")])]),_vm._v(" "),_c('div',{staticClass:"date upcoming-meetings__item-date"},[_vm._v("DateRange")]),_vm._v(" "),_c('div',{staticClass:"location upcoming-meetings__item-location"},[_vm._v("Location")])]),_vm._v(" "),_c('li',{staticClass:"upcoming-meetings__item"},[_c('p',{staticClass:"upcoming-meetings__item-title"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Meeting 2")])]),_vm._v(" "),_c('div',{staticClass:"date upcoming-meetings__item-date"},[_vm._v("DateRange")]),_vm._v(" "),_c('div',{staticClass:"location upcoming-meetings__item-location"},[_vm._v("Location")])]),_vm._v(" "),_c('li',{staticClass:"upcoming-meetings__item"},[_c('p',{staticClass:"upcoming-meetings__item-title"},[_c('a',{attrs:{"href":"#"}},[_vm._v("EPI|Lifestyle")])]),_vm._v(" "),_c('div',{staticClass:"date upcoming-meetings__item-date"},[_vm._v("March 3–6, 2020")]),_vm._v(" "),_c('div',{staticClass:"location upcoming-meetings__item-location"},[_vm._v("Phoenix, AZ")])]),_vm._v(" "),_c('li',{staticClass:"upcoming-meetings__item"},[_c('p',{staticClass:"upcoming-meetings__item-title"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Vascular Discovery: From Genes to Medicine (formerly ATVB|PVD)")])]),_vm._v(" "),_c('div',{staticClass:"date upcoming-meetings__item-date"},[_vm._v("May 5–7, 2020")]),_vm._v(" "),_c('div',{staticClass:"location upcoming-meetings__item-location"},[_vm._v("Chicago, Ill.")])]),_vm._v(" "),_c('li',{staticClass:"upcoming-meetings__item"},[_c('p',{staticClass:"upcoming-meetings__item-title"},[_c('a',{attrs:{"href":"#"}},[_vm._v("QCORE")])]),_vm._v(" "),_c('div',{staticClass:"date upcoming-meetings__item-date"},[_vm._v("May 15–16, 2020")]),_vm._v(" "),_c('div',{staticClass:"location upcoming-meetings__item-location"},[_vm._v("Reston, Va")])])]),_vm._v(" "),_c('footer',{staticClass:"upcoming-meetings__footer"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--black text-uppercase",attrs:{"href":"#"}},[_vm._v("View All")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d489fd1c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sessions_meetings_vue__ = __webpack_require__(1353);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d489fd1c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sessions_meetings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('div',{staticClass:"container container-fluid"},[_c('h2',[_vm._v("Using the Science News Box Component as Wrapper")]),_vm._v(" "),_c('science-news-box',{attrs:{"heading":"New Basic Heading With Link","description":"Subtitle","link":{
                    text: 'View All',
                    url: 'https://sitecoredevcm.heart.org:443/en'
                }}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"section__label mb-3"},[_vm._v("\n                                    Video Highlights\n                                ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('a',{staticClass:"c-image__link",attrs:{"href":""}},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--5-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://sitecoredevphdcm.heart.org/-/media/images/health-topics/congenital-heart-defects/grandfather-and-grandson-reading-book-at-home-pnjbsbs.jpg?h=540&la=en&mw=960&w=960&hash=0B8FD5B0EC4B88350D399BF1FE6B741440FB3B61","alt":"Quit vaping"}})]),_vm._v(" "),_c('div',{staticClass:"c-video__media-caption"},[_vm._v("\n                                                Title Image 2\n                                            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('a',{staticClass:"science-news-box",attrs:{"href":""}},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--5-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://sitecoredevphdcm.heart.org/-/media/images/health-topics/congenital-heart-defects/kids-taking-red-hearts-pdpwaml.jpg?h=540&la=en&mw=960&w=960&hash=96A7B578C4A2E30060FBFC3DC1150FDB4C71DDA3","alt":"Quit vaping"}})]),_vm._v(" "),_c('div',{staticClass:"c-video__media-caption"},[_vm._v("\n                                                Title Image 2\n                                            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('Modal-CCF255F044E440CE8369121157AC7C68'),expression:"'Modal-CCF255F044E440CE8369121157AC7C68'"}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://sitecoredevphdcm.heart.org/-/media/images/health-topics/congenital-heart-defects/istock-894463832-girl-with-doctor.jpg?h=1125&w=2000&hash=452EF86F74C7BF8B2BF3ABA2F759782B8502639F","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"Modal-CCF255F044E440CE8369121157AC7C68","video-id":"8Q7KswkJP7I"}}),_vm._v(" "),_c('div',{staticClass:"c-video__media-caption"},[_c('a',{staticClass:"h-color--black",attrs:{"href":"/en"}},[_vm._v("Hypertension 2019 Early Career Oral Recipients")])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('Modal-CCF255F044E440CE8369121157AC7C68'),expression:"'Modal-CCF255F044E440CE8369121157AC7C68'"}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://sitecoredevphdcm.heart.org/-/media/images/health-topics/congenital-heart-defects/istock-894463832-girl-with-doctor.jpg?h=1125&w=2000&hash=452EF86F74C7BF8B2BF3ABA2F759782B8502639F","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"Modal-CCF255F044E440CE8369121157AC7C68","video-id":"8Q7KswkJP7I"}}),_vm._v(" "),_c('div',{staticClass:"c-video__media-caption"},[_c('a',{staticClass:"h-color--black",attrs:{"href":"/en"}},[_vm._v("Hypertension 2019 Early Career Oral Recipients")])])],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"c-sessions-news-list",attrs:{"aria-label":"Article Sidebar"}},[_c('div',{staticClass:"section__label mb-2"},[_vm._v("\n                                News Highlights\n                            ")]),_vm._v(" "),_c('div',{staticClass:"c-sessions-news-list__item mb-4"},[_c('a',{staticClass:"d-block news-list__title mb-2 h-color--black",attrs:{"href":"/en"}},[_vm._v("News Highlights Component")]),_vm._v(" "),_vm._v("\n                                Lorem ipsum dolor sit amet, consectetur\n                                adipiscing elit. Duis venenatis nibh quis\n                                neque faucibus, vel scelerisque enim\n                                aliquam. Fusce ac sodales sem. Morbi\n                                convallis ullamcorper leo ut viverra.\n                                "),_c('p')]),_vm._v(" "),_c('div',{staticClass:"c-sessions-news-list__item mb-4"},[_c('a',{staticClass:"d-block news-list__title mb-2 h-color--black",attrs:{"href":"https://sitecoredevcprcm.heart.org:443/en"}},[_vm._v("News Highlights Component 2")]),_vm._v(" "),_vm._v("\n                                Lorem ipsum dolor sit amet, consectetur\n                                adipiscing elit. Duis venenatis nibh quis\n                                neque faucibus, vel scelerisque enim\n                                aliquam. Fusce ac sodales sem. Morbi\n                                convallis ullamcorper leo ut viverra.\n                                "),_c('p')]),_vm._v(" "),_c('div',{staticClass:"c-sessions-news-list__item mb-4"},[_c('a',{staticClass:"d-block news-list__title mb-2 h-color--black",attrs:{"href":"https://sitecoredevcm.heart.org:443/en"}},[_vm._v("News Highlights Component 3")]),_vm._v(" "),_vm._v("\n                                Lorem ipsum dolor sit amet, consectetur\n                                adipiscing elit. Duis venenatis nibh quis\n                                neque faucibus, vel scelerisque enim\n                                aliquam. \n                                "),_c('p')]),_vm._v(" "),_c('div',{staticClass:"c-sessions-news-list__item mb-4"},[_c('a',{staticClass:"d-block news-list__title mb-2 h-color--black",attrs:{"href":"/en"}},[_vm._v("News Highlights Component 4")]),_vm._v(" "),_vm._v("\n                                Lorem ipsum dolor sit amet. Duis venenatis\n                                nibh quis neque faucibus, vel scelerisque\n                                enim aliquam. Fusce ac sodales sem. Morbi\n                                convallis ullamcorper leo ut viverra.\n                                "),_c('p')])])])])]),_vm._v(" "),_c('H2',{staticClass:"mt-5"},[_vm._v("Generic Component Wrapper")]),_vm._v(" "),_c('div',{staticClass:"l-promo l-promo--sessions-meetings l-promo--shadow"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"section__label mb-3"},[_vm._v("\n                                            Video Highlights\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(
                                                                'uniqueModalId23'
                                                            ),expression:"\n                                                                'uniqueModalId23'\n                                                            "}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://www.heart.org/-/media/images/healthy-living/made-you-move/binge_break_torso_twists_video_2.jpg","alt":""}})]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId23","video-id":"M7lc1UVf-VE"}}),_vm._v(" "),_vm._m(4)],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(
                                                                'uniqueModalId33'
                                                            ),expression:"\n                                                                'uniqueModalId33'\n                                                            "}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://www.heart.org/-/media/images/healthy-living/made-you-move/binge_break_lunges.jpg","alt":""}})]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId33","video-id":"M7lc1UVf-VE"}}),_vm._v(" "),_c('div',{staticClass:"c-video__media-caption"},[_vm._v("\n                                                        Study hints at hot\n                                                        yoga benefit for\n                                                        blood pressure\n                                                    ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(
                                                                'uniqueModalId43'
                                                            ),expression:"\n                                                                'uniqueModalId43'\n                                                            "}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://www.heart.org/-/media/images/healthy-living/made-you-move/binge_break_dips_video.jpg","alt":""}})]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId43","video-id":"M7lc1UVf-VE"}}),_vm._v(" "),_c('div',{staticClass:"c-video__media-caption"},[_vm._v("\n                                                        Study hints at hot\n                                                        yoga benefit for\n                                                        blood pressure\n                                                    ")])],1)])])])])]),_vm._v(" "),_vm._m(7)])])])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Meetings Scientific Sessions")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-listing-header c-listing-header--medium pt-sm-4"},[_c('div',{staticClass:"c-listing-header__cta-container border-0"},[_c('div',{staticClass:"h2 c-listing-header__heading"},[_vm._v("\n                                    Hypertension 2019 Scientific Sessions\n                                ")]),_vm._v(" "),_c('span',{staticClass:"h-flex"}),_vm._v(" "),_c('a',{staticClass:"c-listing-header__cta c-cta c-cta--arrow h-theme--black",attrs:{"href":"#"}},[_vm._v("VIEW ALL CONTENT")])]),_vm._v(" "),_c('div',{staticClass:"h5 h-color--gray-mid"},[_vm._v("\n                                What was there to learn at Hypertension\n                                2019?\n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('a',{staticClass:"c-image__link",attrs:{"href":"#"}},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--5-3",attrs:{"href":"#"}},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://www.heart.org/-/media/images/healthy-living/made-you-move/binge_break_torso_twists_video_2.jpg"}})]),_vm._v(" "),_c('div',{staticClass:"c-video__media-caption"},[_vm._v("\n                                                        Study hints at hot\n                                                        yoga benefit for\n                                                        blood pressure\n                                                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-video__video-meta"},[_c('span',{staticClass:"c-video__vide-time"},[_vm._v("1:15")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-video__media-caption"},[_c('a',{staticClass:"h-color--black",attrs:{"href":"#"}},[_vm._v("Study hints at\n                                                            hot yoga benefit\n                                                            for blood\n                                                            pressure")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-video__video-meta"},[_c('span',{staticClass:"c-video__vide-time"},[_vm._v("2:15")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-video__video-meta"},[_c('span',{staticClass:"c-video__vide-time"},[_vm._v("3:15")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"c-sessions-news-list",attrs:{"aria-label":"Article Sidebar"}},[_c('div',{staticClass:"section__label mb-2"},[_vm._v("\n                                        News Highlights\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"c-sessions-news-list__item mb-4"},[_c('a',{staticClass:"d-block news-list__title mb-2 h-color--black",attrs:{"href":"#"}},[_vm._v("Study hints at hot yoga benefit\n                                            for blood pressure")]),_vm._v(" "),_c('div',{staticClass:"news-list__desc mb-1"},[_c('strong',[_vm._v("Abstract:")]),_vm._v(" Hot\n                                            Yoga and Hypertension:\n                                            Exploration of a Novel Lifestyle\n                                            Intervention\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"news-list__byline mb-2"},[_vm._v("\n                                            Bruce R. Stevens | University of\n                                            Florida Gainesville, FL | AHA\n                                            News Release\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"c-sessions-news__item mb-4"},[_c('a',{staticClass:"news-list__title mb-1",attrs:{"href":"#"}},[_vm._v("Eating probiotics regularly may\n                                            improve your blood pressure")]),_vm._v(" "),_c('div',{staticClass:"news-list__desc mb-1"},[_c('strong',[_vm._v("Abstract:")]),_vm._v("Effects of Smoking Cessation on\n                                            the Intestinal Microbiota\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"news-list__byline mb-2"},[_vm._v("\n                                            Bruce R. Stevens | University of\n                                            Florida Gainesville, FL | AHA\n                                            News Release\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"c-sessions-news__item mb-4"},[_c('a',{staticClass:"d-block news-list__title mb-2 h-color--black",attrs:{"href":"#"}},[_vm._v("Study hints at hot yoga benefit\n                                            for blood pressure")]),_vm._v(" "),_c('div',{staticClass:"news-list__desc mb-1"},[_c('strong',[_vm._v("Abstract:")]),_vm._v(" Hot\n                                            Yoga and Hypertension:\n                                            Exploration of a Novel Lifestyle\n                                            Intervention\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"news-list__byline"},[_vm._v("\n                                            Bruce R. Stevens | University of\n                                            Florida Gainesville, FL | AHA\n                                            News Release\n                                        ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('div',{staticClass:"l-main"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"phd-shadow-box phd-shadow-box--no-padding"},[_c('div',{staticClass:"row my-4"},[_c('div',{staticClass:"col-12 col-md-6 p-5 d-flex flex-column justify-content-center"},[_c('h2',[_vm._v("Professional memberships")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Enjoy instant benefits!")])]),_vm._v(" "),_c('p',[_vm._v("Free Online Access to AHA Scientific Journals")]),_vm._v(" "),_c('p',[_vm._v("Affiliate with our 16 Scientific Councils.")]),_vm._v(" "),_c('p',[_vm._v("Discounts on Scientific Conference, Registration and Online Courses")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"cta-hero h-text-contrast h-theme--black"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://placekitten.com/600/450","alt":"Family around a computer","width":"800","height":"533","disablewebedit":"False"}})]),_vm._v(" "),_c('span',{staticClass:"h-mask-dark"}),_vm._v(" "),_c('div',{staticClass:"cta-hero__item"},[_c('a',{staticClass:"btn btn-round",attrs:{"href":"#"}},[_vm._v("Learn about Hypertension 2020 and Register")]),_vm._v(" "),_c('div',{staticClass:"news-list__desc cta-hero__desc"},[_vm._v("Become a Partner")])]),_vm._v(" "),_c('div',{staticClass:"cta-hero__item"},[_c('a',{staticClass:"btn btn-round btn-outline",attrs:{"href":"#"}},[_vm._v("See updated VIRTUAL conference prices")]),_vm._v(" "),_c('div',{staticClass:"news-list__desc cta-hero__desc"},[_vm._v("Current members renew today")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"linked-list mb-5"},[_c('div',{staticClass:"container"},[_c('header',{staticClass:"row justify-content-between"},[_c('h2',{staticClass:"col-12 col-md"},[_vm._v("In the News")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-auto d-flex align-items-center"},[_c('a',{staticClass:"c-cta c-cta--secondary c-cta--arrow h-theme--red text-uppercase",attrs:{"href":"#"}},[_vm._v("View All")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 linkbox"},[_c('ul',[_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Teen vaping on the rise in U.S., Canada")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Lorem, ipsum dolor sit amet consectetur adipisicing elit. Beatae quidem praesentium soluta qui doloremque deleniti.")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore esse pariatur aperiam iusto velit quaerat. Voluptate possimus eius voluptates amet.")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Vapers inhale lower levels of toxins than smokers")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Vitamin vapes are now a thing — but that doesn't mean they're good for you")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('div',{staticClass:"l-main"},[_c('div',{staticClass:"phd-hero",staticStyle:{"background-image":"url('https://via.placeholder.com/2560x800/cc0000/aa0000')"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col text-center"},[_c('img',{staticClass:"img-fluid phd-hero__media",attrs:{"src":"https://via.placeholder.com/400x100/0000cc/ffffff","alt":"image alt text is required"}})])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center mt-3"},[_c('div',{staticClass:"col text-center"},[_c('span',{staticClass:"phd-hero__date"},[_vm._v("NOVEMBER 16-18, 2020")]),_vm._v(" "),_c('span',{staticClass:"phd-hero__location"},[_vm._v("Philadelphia, Pennsylvania")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f2360ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_things_to_know_vue__ = __webpack_require__(1358);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f2360ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_things_to_know_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('aha-breadcrumb'),_vm._v(" "),_c('science-news-heading'),_vm._v(" "),_c('section-heading'),_vm._v(" "),_c('rich-text'),_vm._v(" "),_c('news-link'),_vm._v(" "),_c('phd-citations')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-4 phd-shadow-box"},[_c('phd-profile')],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-8 phd-shadow-box"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('community-science-news'),_vm._v(" "),_c('non-partner-connections')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row d-none d-lg-block"},[_c('div',{staticClass:"col-12"},[_c('nav',{staticClass:"profile-navigation",attrs:{"role":"Profile Control Navigation","aria-label":"Profile Control Navigation"}},[_c('a',{staticClass:"profile-navigation__link",attrs:{"href":"#"}},[_c('img',{staticClass:"profile-navigation__icon profile-navigation__icon--default",attrs:{"src":"/assets/icons/icon-profile-default.svg","alt":"Edit Profile"}}),_vm._v(" "),_c('img',{staticClass:"profile-navigation__icon profile-navigation__icon--hover",attrs:{"src":"/assets/icons/icon-profile-hover.svg","alt":"Edit Profile"}}),_vm._v(" "),_c('img',{staticClass:"profile-navigation__icon profile-navigation__icon--active",attrs:{"src":"/assets/icons/icon-profile-active.svg","alt":"Edit Profile"}}),_vm._v("\n                        Edit Profile\n                    ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member-dashboard-panel account-summary"},[_c('h2',[_vm._v("Account Summary")]),_vm._v(" "),_c('div',{staticClass:"account-summary__description"},[_c('div',{staticClass:"warning"},[_c('p',[_vm._v("This is a warning message to notify you of important information about your account.")])])]),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-12 col-lg-9 member-dashboard-panel__content account-summary__content"},[_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-12 col-lg-4 account-summary__content-title"},[_vm._v("Partnership Tier")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-8 account-summary__content-value"},[_vm._v("Premium Professional")])]),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-12 col-lg-4 account-summary__content-title"},[_vm._v("Partnership ID")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-8 account-summary__content-value"},[_vm._v("190774063")])]),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-12 col-lg-4 account-summary__content-title"},[_vm._v("Current Status")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-8 account-summary__content-value"},[_vm._v("Active")])]),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-12 col-lg-4 account-summary__content-title"},[_vm._v("Expires")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-8 account-summary__content-value"},[_vm._v("12/31/2020")])]),_vm._v(" "),_c('div',{staticClass:"mb-4 d-none d-md-block"},[_c('div',{staticClass:"col-sm-12 d-md-flex phd-bg--gray-light p-3"},[_c('div',{staticClass:"d-md-inline pr-3"},[_c('img',{staticClass:"d-md-block",attrs:{"aria-hidden":"true","aria-describedby":"qr-info","src":"http://static.heart.org/ahaanywhere/sitecore/dist/images/qr-code-sample.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"d-md-inline"},[_c('div',{staticClass:"d-none d-md-block h4 font-weight-bold"},[_vm._v("SCAN ME")]),_vm._v(" "),_c('p',{attrs:{"id":"qr-info"}},[_vm._v("\n                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Laudantium officia necessitatibus a.\n                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"mb-4 d-none",attrs:{"id":"phd-apple-wallet"}},[_c('div',{staticClass:"col-sm-12 d-md-flex phd-bg--gray-light p-3"},[_c('div',{staticClass:"d-block pr-3"},[_c('a',{attrs:{"href":"link/to/download/wallet"}},[_c('img',{staticClass:"d-block my-3 w-75",attrs:{"aria-describedby":"wallet-info","aria-hidden":"true","src":"http://static.heart.org/ahaanywhere/sitecore/dist/images/apple-wallet-500px.png","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"d-block"},[_c('div',{staticClass:"d-block h4 font-weight-bold"},[_vm._v("Take this Card with you")]),_vm._v(" "),_c('p',{attrs:{"id":"wallet-info"}},[_vm._v("\n                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Laudantium officia necessitatibus a.\n                                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3 member-dashboard-panel__buttons"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-auto col-lg-12 mb-lg-3"},[_c('button',{staticClass:"btn text-uppercase"},[_vm._v("Renew")])]),_vm._v(" "),_c('div',{staticClass:"col-auto col-lg-12"},[_c('button',{staticClass:"btn btn-outline"},[_vm._v("Upgrade")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member-dashboard-panel council-list"},[_c('div',{staticClass:"row mb-1"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"section__label--thin"},[_vm._v("Councils")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-9 member-dashboard-panel__content"},[_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-12 mb-1"},[_c('span',{staticClass:"c-cta h-theme--red"},[_vm._v("Primary")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"news-list__desc"},[_c('p',[_vm._v("Arteriosclerosis, Thrombosis, and Vascular Biology")])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-12 mb-1"},[_c('span',{staticClass:"c-cta h-theme--red"},[_vm._v("Secondary")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"news-list__desc"},[_c('p',[_vm._v("Genomic and Precision Medicine")])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"news-list__desc"},[_c('p',[_c('strong',[_vm._v("Want a third council?  Add one today.")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3 member-dashboard-panel__buttons"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-auto col-lg-12"},[_c('button',{staticClass:"btn btn-outline"},[_vm._v("Add")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member-dashboard-panel journals-lists"},[_c('div',{staticClass:"row mb-1"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"section__label--thin"},[_vm._v("Journals")])])]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12 col-lg-9 member-dashboard-panel__content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-1"},[_c('span',{staticClass:"c-cta h-theme--red"},[_vm._v("Online")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('ul',{staticClass:"list-unstyled news-list__desc"},[_c('li',[_vm._v("Arteriosclerosis, Thrombosis, and Vascular Biology - Online")]),_vm._v(" "),_c('li',[_vm._v("Circulation: Arrhythmia and Electrophysiology - Online")]),_vm._v(" "),_c('li',[_vm._v("Circulation: Cardiovascular Imaging - Online")]),_vm._v(" "),_c('li',[_vm._v("Circulation: Cardiovascular Interventions - Online")]),_vm._v(" "),_c('li',[_vm._v("Circulation: Cardiovascular Quality and Outcomes - Online")]),_vm._v(" "),_c('li',[_vm._v("Circulation: Genomic and Precision Medicine - Online")]),_vm._v(" "),_c('li',[_vm._v("Circulation: Heart Failure - Online")]),_vm._v(" "),_c('li',[_vm._v("Circulation - Online")]),_vm._v(" "),_c('li',[_vm._v("Circulation Research - Online")]),_vm._v(" "),_c('li',[_vm._v("Circulation Research - Online")]),_vm._v(" "),_c('li',[_vm._v("Hypertension - Online")]),_vm._v(" "),_c('li',[_vm._v("Stroke - Online")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3 member-dashboard-panel__buttons"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-auto col-lg-12"},[_c('button',{staticClass:"btn btn-outline"},[_vm._v("Add")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-9 member-dashboard-panel__content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-1"},[_c('span',{staticClass:"c-cta h-theme--red"},[_vm._v("Print")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('ul',{staticClass:"list-unstyled news-list__desc"},[_c('li',[_vm._v("Circulation Research")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3 member-dashboard-panel__buttons"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-auto col-lg-12"},[_c('button',{staticClass:"btn btn-outline"},[_vm._v("Purchase")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('div',{staticClass:"l-main"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('linked-list')],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"phd-shadow-box"},[_c('linked-list')],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"phd-shadow-box"},[_c('linked-list')],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"linked-list mb-5"},[_c('div',{staticClass:"container"},[_c('header',{staticClass:"row justify-content-between"},[_c('h1',{staticClass:"col-12 col-md"},[_vm._v("In the News")])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12 linkbox"},[_c('ul',[_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Teen vaping on the rise in U.S., Canada")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Lorem, ipsum dolor sit amet consectetur adipisicing elit. Beatae quidem praesentium soluta qui doloremque deleniti.")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore esse pariatur aperiam iusto velit quaerat. Voluptate possimus eius voluptates amet.")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Vapers inhale lower levels of toxins than smokers")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Vitamin vapes are now a thing — but that doesn't mean they're good for you")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Delectus, quisquam?")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Nulla nostrum iste distinctio, facilis odit maxime incidunt mollitia quia.")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Sit, libero commodi! Iste, quibusdam? Obcaecati numquam error debitis cupiditate!")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Itaque quo ad odit perferendis, adipisci fuga quas reprehenderit tempora.")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Totam voluptatum commodi reprehenderit libero error? Possimus reiciendis non aut?")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Sit tenetur, iste aut pariatur harum voluptatum necessitatibus. Facilis, blanditiis?")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Dolores tenetur blanditiis cumque? Rem ut est doloremque totam tenetur.")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Iusto vero accusamus odit repellat sunt dignissimos suscipit voluptates facilis.")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Quae ad rem doloremque eius optio at, amet voluptates sapiente!")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"phd-link-color--red",attrs:{"href":"#"}},[_vm._v("Possimus minima tempore fuga ipsum iste inventore placeat similique eaque?")])])])])]),_vm._v(" "),_c('footer',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('nav',[_c('div',{staticClass:"pagination-container"},[_c('ul',{staticClass:"pagination pagination-lg pagination--page-count pagination--right"},[_c('li',{staticClass:"page-item page-link disabled PagedList-skipToPrevious"},[_c('a',{attrs:{"href":"#","rel":"prev"}},[_vm._v("<")])]),_vm._v(" "),_c('li',{staticClass:"page-item disabled PagedList-pageCountAndLocation"},[_c('a',[_vm._v("Page 1 of 3.")])]),_vm._v(" "),_c('li',{staticClass:"page-item page-link PagedList-skipToNext"},[_c('a',{attrs:{"href":"#","rel":"next"}},[_vm._v(">")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _home = __webpack_require__(1363);

var _home2 = _interopRequireDefault(_home);

var _components = __webpack_require__(1369);

var _components2 = _interopRequireDefault(_components);

var _layouts = __webpack_require__(1599);

var _layouts2 = _interopRequireDefault(_layouts);

var _snackables = __webpack_require__(1672);

var _snackables2 = _interopRequireDefault(_snackables);

var _uiKit = __webpack_require__(1697);

var _uiKit2 = _interopRequireDefault(_uiKit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var routes = [].concat(_home2['default'], _uiKit2['default'], _layouts2['default'], _components2['default'], _snackables2['default']); // Import all demo navigation
// import Page from './page';

exports['default'] = routes;

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _page = __webpack_require__(81);

var _page2 = _interopRequireDefault(_page);

var _homeNavigation = __webpack_require__(1365);

var _homeNavigation2 = _interopRequireDefault(_homeNavigation);

var _home = __webpack_require__(1367);

var _home2 = _interopRequireDefault(_home);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var HomePages = [{
    path: '/',
    components: {
        'default': _page2['default'],
        'sidebar-nav': _homeNavigation2['default']
    },
    children: [{
        path: '',
        component: _home2['default']
    }]
}];

exports['default'] = HomePages;

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ad748d2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_navigation_vue__ = __webpack_require__(1366);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ad748d2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-light"},[_c('b-navbar-toggle',{staticClass:"float-right d-md-none",attrs:{"target":"sidebar-collapse"}}),_vm._v(" "),_c('span',{staticClass:"c-sidebar-nav__header"},[_vm._v("Home")]),_vm._v(" "),_c('b-collapse',{staticClass:"c-sidebar-nav",attrs:{"visible":"","id":"sidebar-collapse"}},[_c('ul',{staticClass:"c-sidebar-nav__links"},[_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#getting-started'),expression:"'#getting-started'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Getting Started")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#prerequisites'),expression:"'#prerequisites'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Prerequisites")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#build-tasks'),expression:"'#build-tasks'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Build Tasks")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#build-errors'),expression:"'#build-errors'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Common Build Errors")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a485cbd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__(1368);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a485cbd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-3"},[_vm._v("AHA Component Library")]),_vm._v(" "),_c('p',[_vm._v("Documentation for the AHA Component Library")]),_vm._v(" "),_c('span',{staticClass:"anchor",attrs:{"id":"getting-started"}}),_vm._v(" "),_c('h2',{staticClass:"h4 mt-5"},[_vm._v("Getting Started")]),_vm._v(" "),_c('p',[_vm._v("The AHA Component Library is built from the Heart.org Front-end repository.")]),_vm._v(" "),_c('p',[_vm._v("To build and run this project locally, clone the repository from: "),_c('code',[_c('a',{attrs:{"href":"https://aha-bt.visualstudio.com/Sitecore/Heart.org/_git/Heart.org%20Front-End"}},[_vm._v("https://aha-bt.visualstudio.com/Sitecore/Heart.org/_git/Heart.org%20Front-End")])])]),_vm._v(" "),_c('p',[_vm._v("In the main project directory, run "),_c('code',[_vm._v("npm install")]),_vm._v(" to install all dependencies")]),_vm._v(" "),_c('span',{staticClass:"anchor",attrs:{"id":"prerequisites"}}),_vm._v(" "),_c('h2',{staticClass:"h4 mt-5"},[_vm._v("Prerequisites")]),_vm._v(" "),_c('ul',{staticClass:"nav flex-column"},[_c('li',[_vm._v("NodeJS")])]),_vm._v(" "),_c('span',{staticClass:"anchor",attrs:{"id":"build-tasks"}}),_vm._v(" "),_c('h2',{staticClass:"h4 mt-5"},[_vm._v("Build Tasks")]),_vm._v(" "),_c('ul',{staticClass:"nav flex-column"},[_c('li',[_c('code',[_vm._v("gulp dev")]),_vm._v(" "),_c('p',[_vm._v("Runs the development server and allows you to develop locally")])]),_vm._v(" "),_c('li',[_c('code',[_vm._v("gulp demo-prod")]),_vm._v(" "),_c('p',[_vm._v("Builds the distribution assets for use on digitaldocs.heart.org")])]),_vm._v(" "),_c('li',[_c('code',[_vm._v("gulp prod")]),_vm._v(" "),_c('p',[_vm._v("Builds the distribution assets for use on heart.org")])])]),_vm._v(" "),_c('span',{staticClass:"anchor",attrs:{"id":"build-errors"}}),_vm._v(" "),_c('h2',{staticClass:"h4 mt-5"},[_vm._v("Common Build Errors")]),_vm._v(" "),_c('p',[_vm._v("If you receive the build error "),_c('code',[_vm._v("Expected indentation of 0 spaces")]),_vm._v(" when building for the first time, you can fix with the following methods")]),_vm._v(" "),_c('ul',{staticClass:"nav flex-column"},[_c('li',[_c('strong',[_vm._v("VS Code")]),_vm._v(" "),_c('p',[_vm._v("In the bottom-right corner of the editor, click on CRLF and change to LF")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Visual Studio")]),_vm._v(" "),_c('p',[_vm._v("File > Save As > Click the dropdown arrow > Save with encoding.")]),_vm._v(" "),_c('p',[_vm._v("Change the line endings from CRLF to LF")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Notepad++")]),_vm._v(" "),_c('p',[_vm._v("Do a find & replace of "),_c('code',[_vm._v("\\r\\n")]),_vm._v(" to "),_c('code',[_vm._v("\\n")]),_vm._v(" in the offending files. ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _page = __webpack_require__(81);

var _page2 = _interopRequireDefault(_page);

var _componentNavigation = __webpack_require__(1370);

var _componentNavigation2 = _interopRequireDefault(_componentNavigation);

var _alert = __webpack_require__(1372);

var _alert2 = _interopRequireDefault(_alert);

var _personalizationSignup = __webpack_require__(1374);

var _personalizationSignup2 = _interopRequireDefault(_personalizationSignup);

var _imageCredit = __webpack_require__(1376);

var _imageCredit2 = _interopRequireDefault(_imageCredit);

var _articles = __webpack_require__(1378);

var _articles2 = _interopRequireDefault(_articles);

var _breadcrumb = __webpack_require__(1380);

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

var _dafWidget = __webpack_require__(1382);

var _dafWidget2 = _interopRequireDefault(_dafWidget);

var _genericModal = __webpack_require__(1384);

var _genericModal2 = _interopRequireDefault(_genericModal);

var _mainNav = __webpack_require__(1386);

var _mainNav2 = _interopRequireDefault(_mainNav);

var _utilityBar = __webpack_require__(1388);

var _utilityBar2 = _interopRequireDefault(_utilityBar);

var _topNav = __webpack_require__(1390);

var _topNav2 = _interopRequireDefault(_topNav);

var _loginSignup = __webpack_require__(1392);

var _loginSignup2 = _interopRequireDefault(_loginSignup);

var _listingHeader = __webpack_require__(1394);

var _listingHeader2 = _interopRequireDefault(_listingHeader);

var _heroCard = __webpack_require__(1396);

var _heroCard2 = _interopRequireDefault(_heroCard);

var _donationHeroCard = __webpack_require__(1398);

var _donationHeroCard2 = _interopRequireDefault(_donationHeroCard);

var _heroFullWidth = __webpack_require__(1400);

var _heroFullWidth2 = _interopRequireDefault(_heroFullWidth);

var _eventList = __webpack_require__(1402);

var _eventList2 = _interopRequireDefault(_eventList);

var _fullWidthVideoImage = __webpack_require__(1404);

var _fullWidthVideoImage2 = _interopRequireDefault(_fullWidthVideoImage);

var _fullWidthEvent = __webpack_require__(1406);

var _fullWidthEvent2 = _interopRequireDefault(_fullWidthEvent);

var _inquiriesSupport = __webpack_require__(1408);

var _inquiriesSupport2 = _interopRequireDefault(_inquiriesSupport);

var _fullWidthTestimonial = __webpack_require__(1410);

var _fullWidthTestimonial2 = _interopRequireDefault(_fullWidthTestimonial);

var _fullWidthHighlightCopy = __webpack_require__(1412);

var _fullWidthHighlightCopy2 = _interopRequireDefault(_fullWidthHighlightCopy);

var _inlineSearch = __webpack_require__(1414);

var _inlineSearch2 = _interopRequireDefault(_inlineSearch);

var _ceSearch = __webpack_require__(1416);

var _ceSearch2 = _interopRequireDefault(_ceSearch);

var _courseSearch = __webpack_require__(1418);

var _courseSearch2 = _interopRequireDefault(_courseSearch);

var _cprCourseSearch = __webpack_require__(1420);

var _cprCourseSearch2 = _interopRequireDefault(_cprCourseSearch);

var _qualityResearchPublications = __webpack_require__(1422);

var _qualityResearchPublications2 = _interopRequireDefault(_qualityResearchPublications);

var _ratingWidget = __webpack_require__(1424);

var _ratingWidget2 = _interopRequireDefault(_ratingWidget);

var _iconNavigation = __webpack_require__(1426);

var _iconNavigation2 = _interopRequireDefault(_iconNavigation);

var _imageVideoCarousel = __webpack_require__(1428);

var _imageVideoCarousel2 = _interopRequireDefault(_imageVideoCarousel);

var _groceryList = __webpack_require__(1430);

var _groceryList2 = _interopRequireDefault(_groceryList);

var _courseInformation = __webpack_require__(1432);

var _courseInformation2 = _interopRequireDefault(_courseInformation);

var _videoGallery = __webpack_require__(1436);

var _videoGallery2 = _interopRequireDefault(_videoGallery);

var _video = __webpack_require__(1438);

var _video2 = _interopRequireDefault(_video);

var _tvPages = __webpack_require__(1442);

var _tvPages2 = _interopRequireDefault(_tvPages);

var _thingsToKnow = __webpack_require__(366);

var _thingsToKnow2 = _interopRequireDefault(_thingsToKnow);

var _externalScript = __webpack_require__(1445);

var _externalScript2 = _interopRequireDefault(_externalScript);

var _magicGridDemoExamples = __webpack_require__(1447);

var _magicGridDemoExamples2 = _interopRequireDefault(_magicGridDemoExamples);

var _ahaNewsletterAjaxComponent = __webpack_require__(1451);

var _ahaNewsletterAjaxComponent2 = _interopRequireDefault(_ahaNewsletterAjaxComponent);

var _modalFormSubmitToEmail = __webpack_require__(1453);

var _modalFormSubmitToEmail2 = _interopRequireDefault(_modalFormSubmitToEmail);

var _liwIntroBanner = __webpack_require__(1455);

var _liwIntroBanner2 = _interopRequireDefault(_liwIntroBanner);

var _liwCounterComponent = __webpack_require__(1457);

var _liwCounterComponent2 = _interopRequireDefault(_liwCounterComponent);

var _liwMultiLogoComponent = __webpack_require__(1459);

var _liwMultiLogoComponent2 = _interopRequireDefault(_liwMultiLogoComponent);

var _liwFlipCardComponent = __webpack_require__(1461);

var _liwFlipCardComponent2 = _interopRequireDefault(_liwFlipCardComponent);

var _eccColorCodedTable = __webpack_require__(1463);

var _eccColorCodedTable2 = _interopRequireDefault(_eccColorCodedTable);

var _eccReferences = __webpack_require__(1465);

var _eccReferences2 = _interopRequireDefault(_eccReferences);

var _eccSearch = __webpack_require__(1467);

var _eccSearch2 = _interopRequireDefault(_eccSearch);

var _eccNestedAccordion = __webpack_require__(1469);

var _eccNestedAccordion2 = _interopRequireDefault(_eccNestedAccordion);

var _svgMap = __webpack_require__(1471);

var _svgMap2 = _interopRequireDefault(_svgMap);

var _twoColumnContentWidthPromo = __webpack_require__(1473);

var _twoColumnContentWidthPromo2 = _interopRequireDefault(_twoColumnContentWidthPromo);

var _twoColumnFullWidthPromo = __webpack_require__(1475);

var _twoColumnFullWidthPromo2 = _interopRequireDefault(_twoColumnFullWidthPromo);

var _twoColumnFullBleedPromo = __webpack_require__(1477);

var _twoColumnFullBleedPromo2 = _interopRequireDefault(_twoColumnFullBleedPromo);

var _threeColumnContentWidthPromo = __webpack_require__(1479);

var _threeColumnContentWidthPromo2 = _interopRequireDefault(_threeColumnContentWidthPromo);

var _threeColumnContentWidthPromoEnhanced = __webpack_require__(1481);

var _threeColumnContentWidthPromoEnhanced2 = _interopRequireDefault(_threeColumnContentWidthPromoEnhanced);

var _fourColumnContentWidthIconPromo = __webpack_require__(1483);

var _fourColumnContentWidthIconPromo2 = _interopRequireDefault(_fourColumnContentWidthIconPromo);

var _fourColumnContentWidthImagePromo = __webpack_require__(1485);

var _fourColumnContentWidthImagePromo2 = _interopRequireDefault(_fourColumnContentWidthImagePromo);

var _fourColumnFullWidthImagePromo = __webpack_require__(1487);

var _fourColumnFullWidthImagePromo2 = _interopRequireDefault(_fourColumnFullWidthImagePromo);

var _threeColumnFullWidthPromo = __webpack_require__(1489);

var _threeColumnFullWidthPromo2 = _interopRequireDefault(_threeColumnFullWidthPromo);

var _twoThirdLinkComponent = __webpack_require__(1491);

var _twoThirdLinkComponent2 = _interopRequireDefault(_twoThirdLinkComponent);

var _fullWidthEmailPromo = __webpack_require__(1493);

var _fullWidthEmailPromo2 = _interopRequireDefault(_fullWidthEmailPromo);

var _halfImageHalfCopyPromo = __webpack_require__(1495);

var _halfImageHalfCopyPromo2 = _interopRequireDefault(_halfImageHalfCopyPromo);

var _halfImageHalfCopyCollapse = __webpack_require__(1497);

var _halfImageHalfCopyCollapse2 = _interopRequireDefault(_halfImageHalfCopyCollapse);

var _oneColumnContentWidthPromo = __webpack_require__(1499);

var _oneColumnContentWidthPromo2 = _interopRequireDefault(_oneColumnContentWidthPromo);

var _recipeInstructions = __webpack_require__(1501);

var _recipeInstructions2 = _interopRequireDefault(_recipeInstructions);

var _impactedData = __webpack_require__(1503);

var _impactedData2 = _interopRequireDefault(_impactedData);

var _recipeNutritionalFacts = __webpack_require__(1505);

var _recipeNutritionalFacts2 = _interopRequireDefault(_recipeNutritionalFacts);

var _recipeQuickTips = __webpack_require__(1507);

var _recipeQuickTips2 = _interopRequireDefault(_recipeQuickTips);

var _recipeSocial = __webpack_require__(1509);

var _recipeSocial2 = _interopRequireDefault(_recipeSocial);

var _StudentCode = __webpack_require__(1511);

var _StudentCode2 = _interopRequireDefault(_StudentCode);

var _speedBump = __webpack_require__(1513);

var _speedBump2 = _interopRequireDefault(_speedBump);

var _ssoIntercept = __webpack_require__(1515);

var _ssoIntercept2 = _interopRequireDefault(_ssoIntercept);

var _affiliateNav = __webpack_require__(1517);

var _affiliateNav2 = _interopRequireDefault(_affiliateNav);

var _sitecoreForms = __webpack_require__(1519);

var _sitecoreForms2 = _interopRequireDefault(_sitecoreForms);

var _strokeSymptoms = __webpack_require__(1521);

var _strokeSymptoms2 = _interopRequireDefault(_strokeSymptoms);

var _promoModal = __webpack_require__(1523);

var _promoModal2 = _interopRequireDefault(_promoModal);

var _sessionTimeout = __webpack_require__(1525);

var _sessionTimeout2 = _interopRequireDefault(_sessionTimeout);

var _twoColumnParagraph = __webpack_require__(1527);

var _twoColumnParagraph2 = _interopRequireDefault(_twoColumnParagraph);

var _cardSelector = __webpack_require__(1529);

var _cardSelector2 = _interopRequireDefault(_cardSelector);

var _switchInput = __webpack_require__(1531);

var _switchInput2 = _interopRequireDefault(_switchInput);

var _buttonCta = __webpack_require__(1533);

var _buttonCta2 = _interopRequireDefault(_buttonCta);

var _adHorizontal = __webpack_require__(330);

var _adHorizontal2 = _interopRequireDefault(_adHorizontal);

var _phdAccordion = __webpack_require__(1535);

var _phdAccordion2 = _interopRequireDefault(_phdAccordion);

var _articleListbox = __webpack_require__(328);

var _articleListbox2 = _interopRequireDefault(_articleListbox);

var _articleListComponent = __webpack_require__(329);

var _articleListComponent2 = _interopRequireDefault(_articleListComponent);

var _phdCommunityScienceNews = __webpack_require__(1537);

var _phdCommunityScienceNews2 = _interopRequireDefault(_phdCommunityScienceNews);

var _phdCtaBar = __webpack_require__(1539);

var _phdCtaBar2 = _interopRequireDefault(_phdCtaBar);

var _phdCtaBarFlexible = __webpack_require__(1541);

var _phdCtaBarFlexible2 = _interopRequireDefault(_phdCtaBarFlexible);

var _phdImagePdfAccessibleLinks = __webpack_require__(1543);

var _phdImagePdfAccessibleLinks2 = _interopRequireDefault(_phdImagePdfAccessibleLinks);

var _linkbox = __webpack_require__(332);

var _linkbox2 = _interopRequireDefault(_linkbox);

var _linkbox3 = __webpack_require__(333);

var _linkbox4 = _interopRequireDefault(_linkbox3);

var _linkedList = __webpack_require__(352);

var _linkedList2 = _interopRequireDefault(_linkedList);

var _linksToDetails = __webpack_require__(334);

var _linksToDetails2 = _interopRequireDefault(_linksToDetails);

var _phdCard = __webpack_require__(1545);

var _phdCard2 = _interopRequireDefault(_phdCard);

var _phdCouncil = __webpack_require__(1547);

var _phdCouncil2 = _interopRequireDefault(_phdCouncil);

var _phdMainNav = __webpack_require__(1549);

var _phdMainNav2 = _interopRequireDefault(_phdMainNav);

var _phdMeeting = __webpack_require__(1551);

var _phdMeeting2 = _interopRequireDefault(_phdMeeting);

var _needToKnow = __webpack_require__(1553);

var _needToKnow2 = _interopRequireDefault(_needToKnow);

var _newsLink = __webpack_require__(335);

var _newsLink2 = _interopRequireDefault(_newsLink);

var _phdNewWindowHyperlink = __webpack_require__(1555);

var _phdNewWindowHyperlink2 = _interopRequireDefault(_phdNewWindowHyperlink);

var _phdNonPartnerConnections = __webpack_require__(1557);

var _phdNonPartnerConnections2 = _interopRequireDefault(_phdNonPartnerConnections);

var _partnerBenefits = __webpack_require__(1559);

var _partnerBenefits2 = _interopRequireDefault(_partnerBenefits);

var _phdArticleLink = __webpack_require__(1561);

var _phdArticleLink2 = _interopRequireDefault(_phdArticleLink);

var _phdCitations = __webpack_require__(336);

var _phdCitations2 = _interopRequireDefault(_phdCitations);

var _phdClinicalTrialComponent = __webpack_require__(1563);

var _phdClinicalTrialComponent2 = _interopRequireDefault(_phdClinicalTrialComponent);

var _phdCommunitiesEducation = __webpack_require__(1565);

var _phdCommunitiesEducation2 = _interopRequireDefault(_phdCommunitiesEducation);

var _phdDeviceDrugAlerts = __webpack_require__(1567);

var _phdDeviceDrugAlerts2 = _interopRequireDefault(_phdDeviceDrugAlerts);

var _phdDailyRateComparison = __webpack_require__(1569);

var _phdDailyRateComparison2 = _interopRequireDefault(_phdDailyRateComparison);

var _phdInstitutionalTier = __webpack_require__(1571);

var _phdInstitutionalTier2 = _interopRequireDefault(_phdInstitutionalTier);

var _phdLeftNavDemo = __webpack_require__(1573);

var _phdLeftNavDemo2 = _interopRequireDefault(_phdLeftNavDemo);

var _phdLinkedListDemo = __webpack_require__(355);

var _phdLinkedListDemo2 = _interopRequireDefault(_phdLinkedListDemo);

var _phdMediaBlock = __webpack_require__(337);

var _phdMediaBlock2 = _interopRequireDefault(_phdMediaBlock);

var _phdMembershipRateComparison = __webpack_require__(1575);

var _phdMembershipRateComparison2 = _interopRequireDefault(_phdMembershipRateComparison);

var _phdOverallJournal = __webpack_require__(1577);

var _phdOverallJournal2 = _interopRequireDefault(_phdOverallJournal);

var _phdReferences = __webpack_require__(339);

var _phdReferences2 = _interopRequireDefault(_phdReferences);

var _phdVideo = __webpack_require__(340);

var _phdVideo2 = _interopRequireDefault(_phdVideo);

var _phdProVolSearch = __webpack_require__(1579);

var _phdProVolSearch2 = _interopRequireDefault(_phdProVolSearch);

var _phdVolunteerSearch = __webpack_require__(1581);

var _phdVolunteerSearch2 = _interopRequireDefault(_phdVolunteerSearch);

var _phdTopNav = __webpack_require__(1583);

var _phdTopNav2 = _interopRequireDefault(_phdTopNav);

var _phdTopUtilityNav = __webpack_require__(1585);

var _phdTopUtilityNav2 = _interopRequireDefault(_phdTopUtilityNav);

var _upcomingMeetings = __webpack_require__(350);

var _upcomingMeetings2 = _interopRequireDefault(_upcomingMeetings);

var _phdProfile = __webpack_require__(1587);

var _phdProfile2 = _interopRequireDefault(_phdProfile);

var _richText = __webpack_require__(341);

var _richText2 = _interopRequireDefault(_richText);

var _phdRiskCalculator = __webpack_require__(1589);

var _phdRiskCalculator2 = _interopRequireDefault(_phdRiskCalculator);

var _phdScienceVolunteerModal = __webpack_require__(1591);

var _phdScienceVolunteerModal2 = _interopRequireDefault(_phdScienceVolunteerModal);

var _phdSecondaryTertiaryNav = __webpack_require__(1593);

var _phdSecondaryTertiaryNav2 = _interopRequireDefault(_phdSecondaryTertiaryNav);

var _sectionHeading = __webpack_require__(343);

var _sectionHeading2 = _interopRequireDefault(_sectionHeading);

var _signUpPromo = __webpack_require__(347);

var _signUpPromo2 = _interopRequireDefault(_signUpPromo);

var _phdTwitterFeed = __webpack_require__(1595);

var _phdTwitterFeed2 = _interopRequireDefault(_phdTwitterFeed);

var _twoCtaComponent = __webpack_require__(351);

var _twoCtaComponent2 = _interopRequireDefault(_twoCtaComponent);

var _videoPromo = __webpack_require__(349);

var _videoPromo2 = _interopRequireDefault(_videoPromo);

var _phdHero = __webpack_require__(353);

var _phdHero2 = _interopRequireDefault(_phdHero);

var _demoScienceNewsBox = __webpack_require__(1597);

var _demoScienceNewsBox2 = _interopRequireDefault(_demoScienceNewsBox);

var _scienceNewsHeading = __webpack_require__(345);

var _scienceNewsHeading2 = _interopRequireDefault(_scienceNewsHeading);

var _scienceNewsPromo = __webpack_require__(346);

var _scienceNewsPromo2 = _interopRequireDefault(_scienceNewsPromo);

var _scienceNewsRecentList = __webpack_require__(344);

var _scienceNewsRecentList2 = _interopRequireDefault(_scienceNewsRecentList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Science News:


// Promos
var ComponentPages = [{
    path: '/components',
    // You could also have named views at the top
    components: {
        'default': _page2['default'],
        'sidebar-nav': _componentNavigation2['default']
    },
    children: [{
        path: '',
        redirect: 'alert'
    }, {
        path: 'alert',
        component: _alert2['default']
    }, {
        path: 'personalization-signup',
        component: _personalizationSignup2['default']
    }, {
        path: 'icon-navigation',
        component: _iconNavigation2['default']
    }, {
        path: 'image-credit',
        component: _imageCredit2['default']
    }, {
        path: 'newsletter-ajax',
        component: _ahaNewsletterAjaxComponent2['default']
    }, {
        path: '/components/articles',
        component: _articles2['default']
    }, {
        path: '/components/breadcrumb',
        component: _breadcrumb2['default']
    }, {
        path: '/components/daf-widget',
        component: _dafWidget2['default']
    }, {
        path: '/components/generic-modal',
        component: _genericModal2['default']
    }, {
        path: '/components/main-nav',
        component: _mainNav2['default']
    }, {
        path: '/components/utility-bar',
        component: _utilityBar2['default']
    }, {
        path: '/components/listing-header',
        component: _listingHeader2['default']
    }, {
        path: '/components/hero-card',
        component: _heroCard2['default']
    }, {
        path: '/components/donation-hero-card',
        component: _donationHeroCard2['default']
    }, {
        path: '/components/hero-full-width',
        component: _heroFullWidth2['default']
    }, {
        path: '/components/event-list',
        component: _eventList2['default']
    }, {
        path: '/components/full-width-video-image',
        component: _fullWidthVideoImage2['default']
    }, {
        path: '/components/full-width-event',
        component: _fullWidthEvent2['default']
    }, {
        path: '/components/top-nav',
        component: _topNav2['default']
    }, {
        path: '/components/login-signup',
        component: _loginSignup2['default']
    }, {
        path: '/components/inquiries-support',
        component: _inquiriesSupport2['default']
    }, {
        path: '/components/testimonial',
        component: _fullWidthTestimonial2['default']
    }, {
        path: '/components/full-width-highlight-copy',
        component: _fullWidthHighlightCopy2['default']
    }, {
        path: '/components/video-gallery',
        component: _videoGallery2['default']
    }, {
        path: '/components/two-column-content-width-promo',
        component: _twoColumnContentWidthPromo2['default']
    }, {
        path: '/components/two-column-full-width-promo',
        component: _twoColumnFullWidthPromo2['default']
    }, {
        path: '/components/two-column-full-bleed-promo',
        component: _twoColumnFullBleedPromo2['default']
    }, {
        path: '/components/three-column-content-width-promo',
        component: _threeColumnContentWidthPromo2['default']
    }, {
        path: '/components/three-column-content-width-promo-enhanced',
        component: _threeColumnContentWidthPromoEnhanced2['default']
    }, {
        path: '/components/four-column-content-width-icon-promo',
        component: _fourColumnContentWidthIconPromo2['default']
    }, {
        path: '/components/four-column-content-width-image-promo',
        component: _fourColumnContentWidthImagePromo2['default']
    }, {
        path: '/components/four-column-full-width-image-promo',
        component: _fourColumnFullWidthImagePromo2['default']
    }, {
        path: '/components/three-column-full-width-promo',
        component: _threeColumnFullWidthPromo2['default']
    }, {
        path: '/components/two-third-link-component',
        component: _twoThirdLinkComponent2['default']
    }, {
        path: '/components/full-width-email-promo',

        component: _fullWidthEmailPromo2['default']
    }, {
        path: '/components/half-image-half-copy-promo',
        component: _halfImageHalfCopyPromo2['default']
    }, {
        path: '/components/half-image-half-copy-collapse',
        component: _halfImageHalfCopyCollapse2['default']
    }, {
        path: '/components/one-column-content-width-promo',
        component: _oneColumnContentWidthPromo2['default']
    }, {
        path: '/components/recipe-instructions',
        component: _recipeInstructions2['default']
    }, {
        path: '/components/impacted-data',
        component: _impactedData2['default']
    }, {
        path: '/components/grocery-list',
        component: _groceryList2['default']
    }, {
        path: '/components/recipe-nutritional-facts',
        component: _recipeNutritionalFacts2['default']
    }, {
        path: '/components/recipe-quick-tips',
        component: _recipeQuickTips2['default']
    }, {
        path: '/components/recipe-social',
        component: _recipeSocial2['default']
    }, {
        path: '/components/inline-search',
        component: _inlineSearch2['default']
    }, {
        path: '/components/ce-search',
        component: _ceSearch2['default']
    }, {
        path: 'course-search',
        component: _courseSearch2['default']
    }, {
        path: '/components/cpr-course-search',
        component: _cprCourseSearch2['default']
    }, {
        path: '/components/quality-research-publications',
        component: _qualityResearchPublications2['default']
    }, {
        path: 'rating-widget',
        component: _ratingWidget2['default']
    }, {
        path: 'image-carousel',
        component: _imageVideoCarousel2['default']
    }, {
        path: '/components/stroke-symptoms',
        component: _strokeSymptoms2['default']
    }, {
        path: '/components/promo-modal',
        component: _promoModal2['default']
    }, {
        path: 'speed-bump',
        component: _speedBump2['default']
    }, {
        path: 'sso-intercept',
        component: _ssoIntercept2['default']
    }, {
        path: 'affiliate-nav',
        component: _affiliateNav2['default']
    }, {
        path: 'sitecore-forms',
        component: _sitecoreForms2['default']
    }, {
        path: 'video',
        component: _video2['default']
    }, {
        path: 'external-script',
        component: _externalScript2['default']
    }, {
        path: 'magic-grid',
        component: _magicGridDemoExamples2['default']
    }, {
        path: 'liw-intro-banner',
        component: _liwIntroBanner2['default']
    }, {
        path: 'liw-counter-component',
        component: _liwCounterComponent2['default']
    }, {
        path: 'liw-multi-logo-component',
        component: _liwMultiLogoComponent2['default']
    }, {
        path: 'liw-flip-card-component',
        component: _liwFlipCardComponent2['default']
    }, {
        path: 'color-coded-table',
        component: _eccColorCodedTable2['default']
    }, {
        path: 'ecc-references',
        component: _eccReferences2['default']
    }, {
        path: 'ecc-search',
        component: _eccSearch2['default']
    }, {
        path: 'nested-accordion',
        component: _eccNestedAccordion2['default']
    }, {
        path: 'svg-map',
        component: _svgMap2['default']
    }, {
        path: '/components/course-information',
        component: _courseInformation2['default']
    }, {
        path: '/components/student-code',
        component: _StudentCode2['default']
    }, {
        path: 'rating-widget',
        component: _ratingWidget2['default']
    }, {
        path: 'session-timeout',
        component: _sessionTimeout2['default']
    }, {
        path: 'two-column-paragraph',
        component: _twoColumnParagraph2['default']
    }, {
        path: 'tv-pages',
        component: _tvPages2['default']
    }, {
        path: 'things-to-know',
        component: _thingsToKnow2['default']
    }, {
        path: 'phd-institutional-tier',
        component: _phdInstitutionalTier2['default']
    }, {
        path: 'phd-left-nav-demo',
        component: _phdLeftNavDemo2['default']
    }, {
        path: 'phd-linked-list-demo',
        component: _phdLinkedListDemo2['default']
    }, {
        path: 'phd-membership-rate-comparison',
        component: _phdMembershipRateComparison2['default']
    }, {
        path: 'phd-media-block',
        component: _phdMediaBlock2['default']
    }, {
        path: 'phd-daily-rate-comparison',
        component: _phdDailyRateComparison2['default']
    }, {
        path: 'card-selector',
        component: _cardSelector2['default']
    }, {
        path: 'ad-horizontal',
        component: _adHorizontal2['default']
    }, {
        path: 'phd-accordion',
        component: _phdAccordion2['default']
    }, {
        path: 'article-listbox',
        component: _articleListbox2['default']
    }, {
        path: 'phd-article-link',
        component: _phdArticleLink2['default']
    }, {
        path: 'article-list-component',
        component: _articleListComponent2['default']
    }, {
        path: 'phd-article-link',
        component: _phdArticleLink2['default']
    }, {
        path: 'phd-citations',
        component: _phdCitations2['default']
    }, {
        path: 'community-science-news',
        component: _phdCommunityScienceNews2['default']
    }, {
        path: 'phd-cta-bar',
        component: _phdCtaBar2['default']
    }, {
        path: 'phd-cta-bar-flexible',
        component: _phdCtaBarFlexible2['default']
    }, {
        path: 'image-pdf-accessible-links',
        component: _phdImagePdfAccessibleLinks2['default']
    }, {
        path: 'phd-clinical-trial-component',
        component: _phdClinicalTrialComponent2['default']
    }, {
        path: 'phd-council',
        component: _phdCouncil2['default']
    }, {
        path: 'phd-communities-education',
        component: _phdCommunitiesEducation2['default']
    }, {
        path: 'phd-device-drug-alerts',
        component: _phdDeviceDrugAlerts2['default']
    }, {
        path: 'link-box',
        component: _linkbox2['default']
    }, {
        path: 'link-box-50-50',
        component: _linkbox4['default']
    }, {
        path: 'linked-list',
        component: _linkedList2['default']
    }, {
        path: 'links-to-details',
        component: _linksToDetails2['default']
    }, {
        path: 'phd-card',
        component: _phdCard2['default']
    }, {
        path: 'phd-main-nav',
        component: _phdMainNav2['default']
    }, {
        path: 'phd-meeting',
        component: _phdMeeting2['default']
    }, {
        path: 'phd-overall-journal',
        component: _phdOverallJournal2['default']
    },
    // {
    //     path: 'phd-membership-rate-comparison',
    //     component: PhdMembershipRateComparison
    // },
    {
        path: 'need-to-know',
        component: _needToKnow2['default']
    }, {
        path: 'phd-news-link',
        component: _newsLink2['default']
    }, {
        path: 'new-window-hyperlink',
        component: _phdNewWindowHyperlink2['default']
    }, {
        path: 'non-partner-connections',
        component: _phdNonPartnerConnections2['default']
    }, {
        path: 'partner-benefits',
        component: _partnerBenefits2['default']
    }, {
        path: 'phd-references',
        component: _phdReferences2['default']
    }, {
        path: 'phd-video',
        component: _phdVideo2['default']
    }, {
        path: 'phd-volunteer-search',
        component: _phdVolunteerSearch2['default']
    }, {
        path: 'phd-pro-vol-search',
        component: _phdProVolSearch2['default']
    }, {
        path: 'phd-top-nav',
        component: _phdTopNav2['default']
    }, {
        path: 'phd-top-utility-nav',
        component: _phdTopUtilityNav2['default']
    }, {
        path: 'phd-upcoming-meetings',
        component: _upcomingMeetings2['default']
    }, {
        path: 'phd-profile',
        component: _phdProfile2['default']
    }, {
        path: 'phd-risk-calculator',
        component: _phdRiskCalculator2['default']
    }, {
        path: 'rich-text',
        component: _richText2['default']
    }, {
        path: 'phd-science-volunteer-modal',
        component: _phdScienceVolunteerModal2['default']
    }, {
        path: 'science-news-box',
        component: _demoScienceNewsBox2['default']
    }, {
        path: 'science-news-heading',
        component: _scienceNewsHeading2['default']
    }, {
        path: 'science-news-promo',
        component: _scienceNewsPromo2['default']
    }, {
        path: 'science-news-recent-list',
        component: _scienceNewsRecentList2['default']
    }, {
        path: 'secondary-tertiary-nav',
        component: _phdSecondaryTertiaryNav2['default']
    }, {
        path: 'section-heading',
        component: _sectionHeading2['default']
    }, {
        path: 'sign-up-promo',
        component: _signUpPromo2['default']
    }, {
        path: 'video-promo',
        component: _videoPromo2['default']
    }, {
        path: 'twitter-feed',
        component: _phdTwitterFeed2['default']
    }, {
        path: 'two-cta-component',
        component: _twoCtaComponent2['default']
    }, {
        path: 'switch-input',
        component: _switchInput2['default']
    }, {
        path: 'button-cta',
        component: _buttonCta2['default']
    }, {
        path: 'phd-hero',
        component: _phdHero2['default']
    }, {
        path: 'modal-form-submit-to-email',
        component: _modalFormSubmitToEmail2['default']
    }]
}];

// PHD:


// ECC


// LIW
exports['default'] = ComponentPages;

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41e37d61_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_navigation_vue__ = __webpack_require__(1371);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41e37d61_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-light"},[_c('b-navbar-toggle',{staticClass:"float-right d-md-none",attrs:{"target":"sidebar-collapse"}}),_vm._v(" "),_c('span',{staticClass:"c-sidebar-nav__header"},[_vm._v("Components")]),_vm._v(" "),_c('b-collapse',{staticClass:"c-sidebar-nav",attrs:{"visible":"","id":"sidebar-collapse"}},[_c('ul',{staticClass:"c-sidebar-nav__links"},[_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/alert'}},[_vm._v("Alert")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/articles'}},[_vm._v("Article")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/breadcrumb'}},[_vm._v("Breadcrumb")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/daf-widget'}},[_vm._v("DAF Donation Widget")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/generic-modal'}},[_vm._v("Generic Modal")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/top-nav'}},[_vm._v("Top Nav")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/login-signup'}},[_vm._v("Login/Signup")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/main-nav'}},[_vm._v("Main Nav")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/utility-bar'}},[_vm._v("Utility Bar")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/listing-header'}},[_vm._v("Listing Header")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/hero-card'}},[_vm._v("Hero Card")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/donation-hero-card'}},[_vm._v("Donation Hero Card")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/hero-full-width'}},[_vm._v("Hero Full-Width")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/event-list'}},[_vm._v("Event List")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/full-width-video-image'}},[_vm._v("Full-Width Video/Image")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/inquiries-support'}},[_vm._v("Inquiries & Support Bar")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/testimonial'}},[_vm._v("Full-Width Testimonial")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/full-width-event'}},[_vm._v("Full-Width Event")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/two-third-link-component'}},[_vm._v("Two-Third Link")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/full-width-highlight-copy'}},[_vm._v("Full-Width Highlight Copy")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/inline-search'}},[_vm._v("Inline Search")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/impacted-data'}},[_vm._v("Impacted Data")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/magic-grid'}},[_vm._v("Magic Grid examples")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/ce-search'}},[_vm._v("Ce Search")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/cpr-course-search'}},[_vm._v("CPR Topic Search")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/quality-research-publications'}},[_vm._v("Quality Research Publications")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/video-gallery'}},[_vm._v("Video Gallery")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/speed-bump'}},[_vm._v("Speed Bump")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/sso-intercept'}},[_vm._v("SSO Intercept")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/affiliate-nav'}},[_vm._v("Affiliate Nav")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/sitecore-forms'}},[_vm._v("Sitecore Forms")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/video'}},[_vm._v("Video")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/external-script'}},[_vm._v("JotForm")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/course-information'}},[_vm._v("Course Information")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/rating-widget'}},[_vm._v("Rating Widget")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/student-code'}},[_vm._v("Student Info")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/session-timeout'}},[_vm._v("Session Timeout Modal")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/two-column-paragraph'}},[_vm._v("Two Column Paragraph")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/tv-pages'}},[_vm._v("TV Pages")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/things-to-know'}},[_vm._v("Things to Know")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/card-selector'}},[_vm._v("Card Selector")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/switch-input'}},[_vm._v("Switch Input")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/button-cta'}},[_vm._v("Button CTA")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/newsletter-ajax'}},[_vm._v("Newsletter AJAX")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/icon-navigation'}},[_vm._v("Icon Navigation")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/personalization-signup'}},[_vm._v("Personalization Signup Form")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/image-carousel'}},[_vm._v("Image & Video Carousel")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/image-credit'}},[_vm._v("Image Credit")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/grocery-list'}},[_vm._v("Grocery List")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'modal-form-submit-to-email'}},[_vm._v("Form Submit To Email")])],1)]),_vm._v(" "),_c('span',{staticClass:"c-sidebar-nav__header"},[_vm._v("LIW")]),_vm._v(" "),_c('ul',{staticClass:"c-sidebar-nav__links"},[_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/liw-intro-banner'}},[_vm._v("Intro Banner Component")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/liw-counter-component'}},[_vm._v("Counter Component")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/liw-multi-logo-component'}},[_vm._v("Multi Logo Component")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/liw-flip-card-component'}},[_vm._v("Flip Card Component")])],1)]),_vm._v(" "),_c('span',{staticClass:"c-sidebar-nav__header"},[_vm._v("ECC")]),_vm._v(" "),_c('ul',{staticClass:"c-sidebar-nav__links"},[_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/color-coded-table'}},[_vm._v("Color Coded Table")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/course-search'}},[_vm._v("Course Search")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/ecc-references'}},[_vm._v("ECC References")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/ecc-search'}},[_vm._v("ECC Search")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/nested-accordion'}},[_vm._v("Nested Accordion")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/svg-map'}},[_vm._v("SVG Map")])],1)]),_vm._v(" "),_c('span',{staticClass:"c-sidebar-nav__header"},[_vm._v("PHD")]),_vm._v(" "),_c('ul',{staticClass:"c-sidebar-nav__links"},[_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/ad-horizontal'}},[_vm._v("Ad - Horizontal")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-accordion'}},[_vm._v("Accordion")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/article-listbox'}},[_vm._v("Article Listbox")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/article-list-component'}},[_vm._v("Article List Component")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-citations'}},[_vm._v("Citations")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/community-science-news'}},[_vm._v("Community Science News")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-cta-bar'}},[_vm._v("CTA Bar")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-cta-bar-flexible'}},[_vm._v("CTA Bar - Flexible")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/image-pdf-accessible-links'}},[_vm._v("Image PDF Accessible Links")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/link-box'}},[_vm._v("Link Box")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/link-box-50-50'}},[_vm._v("Link Box 50/50")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/linked-list'}},[_vm._v("Linked List")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/links-to-details'}},[_vm._v("Links To Details")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-card'}},[_vm._v("PHD Card\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'phd-clinical-trial-component'}},[_vm._v("PHD Clinical Trial Component")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'phd-communities-education'}},[_vm._v("PHD Communities Education")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-council'}},[_vm._v("PHD Council\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'phd-device-drug-alerts'}},[_vm._v("PHD Device Drug Alerts")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-daily-rate-comparison'}},[_vm._v("PHD Daily Rate Comparison\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-institutional-tier'}},[_vm._v("PHD Institutional Tier\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-media-block'}},[_vm._v("PHD Media Block\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-meeting'}},[_vm._v("PHD Meeting\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-overall-journal'}},[_vm._v("PHD Overall Journal\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-article-link'}},[_vm._v("PHD Article Link\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-hero'}},[_vm._v("PHD Hero")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'phd-left-nav-demo'}},[_vm._v("PHD Left Navigation")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'phd-linked-list-demo'}},[_vm._v("PHD Linked List Demo")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-membership-rate-comparison'}},[_vm._v("PHD Membership Rate Comparison\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-main-nav'}},[_vm._v("Main Nav")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/need-to-know'}},[_vm._v("Need To Know\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-news-link'}},[_vm._v("News Link")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/new-window-hyperlink'}},[_vm._v("New Window Hyperlink")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/non-partner-connections'}},[_vm._v("Non-Partner Connections")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/partner-benefits'}},[_vm._v("Partner Benefits")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-references'}},[_vm._v("References")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/rich-text'}},[_vm._v("Rich Text")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-risk-calculator'}},[_vm._v("Risk Calculator")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-top-nav'}},[_vm._v("Top Nav")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-top-utility-nav'}},[_vm._v("Top Utility Nav")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-upcoming-meetings'}},[_vm._v("PHD Upcoming Meetings List")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-science-volunteer-modal'}},[_vm._v("Science Volunteer Modal")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/section-heading'}},[_vm._v("Section Heading")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/secondary-tertiary-nav'}},[_vm._v("Secondary Tertiary Nav")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/sign-up-promo'}},[_vm._v("Sign-Up Promo")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/twitter-feed'}},[_vm._v("Twitter Feed")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/two-cta-component'}},[_vm._v("Two CTA Component")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-video'}},[_vm._v("Video")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/video-promo'}},[_vm._v("Video Promo")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/phd-volunteer-search'}},[_vm._v("Volunteer Search")])],1)]),_vm._v(" "),_c('span',{staticClass:"c-sidebar-nav__header"},[_vm._v("PHD: Science News")]),_vm._v(" "),_c('ul',{staticClass:"c-sidebar-nav__links"},[_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/science-news-box'}},[_vm._v("\n          Science News Box\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/science-news-heading'}},[_vm._v("\n          Science News Heading\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/science-news-promo'}},[_vm._v("\n          Science News Promo\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'science-news-recent-list'}},[_vm._v("\n          Science News Recent List\n        ")])],1)]),_vm._v(" "),_c('span',{staticClass:"c-sidebar-nav__header"},[_vm._v("Promos")]),_vm._v(" "),_c('ul',{staticClass:"c-sidebar-nav__links"},[_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/two-column-content-width-promo'}},[_vm._v("Two-Column Content-Width")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/two-column-full-width-promo'}},[_vm._v("Two-Column Full-Width")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/two-column-full-bleed-promo'}},[_vm._v("Two-Column Full-Bleed")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/three-column-content-width-promo'}},[_vm._v("Three-Column Content-Width")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/three-column-content-width-promo-enhanced'}},[_vm._v("Three-Column Content-Width Enhanced")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/four-column-content-width-icon-promo'}},[_vm._v("Four-Column Content-Width Icon")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/four-column-content-width-image-promo'}},[_vm._v("Four-Column Content-Width Image")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/four-column-full-width-image-promo'}},[_vm._v("Four-Column Full-Width Image")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/three-column-full-width-promo'}},[_vm._v("Three-Column Full-Width")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/full-width-email-promo'}},[_vm._v("Full-Width Email")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/half-image-half-copy-promo'}},[_vm._v("Half-Image Half-Copy")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/half-image-half-copy-collapse'}},[_vm._v("Half-Image Half-Copy Collapse")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/one-column-content-width-promo'}},[_vm._v("One-Column Content-Width")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/stroke-symptoms'}},[_vm._v("Stroke Symptoms")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/promo-modal'}},[_vm._v("Donation Promo Modal")])],1)]),_vm._v(" "),_c('span',{staticClass:"c-sidebar-nav__header"},[_vm._v("Recipes")]),_vm._v(" "),_c('ul',{staticClass:"c-sidebar-nav__links"},[_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/recipe-instructions'}},[_vm._v("Instructions")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/recipe-quick-tips'}},[_vm._v("Quick Tips")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/recipe-nutritional-facts'}},[_vm._v("Nutritional Facts")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/components/recipe-social'}},[_vm._v("Social")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alert_vue__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alert_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alert_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alert_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ac02b04_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_vue__ = __webpack_require__(1373);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alert_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ac02b04_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Alert")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('aha-alert')],1),_vm._v(" "),_c('b-btn',{on:{"click":_vm.click}},[_vm._v("Clear Cookies")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e849080e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_personalization_signup_vue__ = __webpack_require__(1375);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e849080e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_personalization_signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Personalization Signup Component")]),_vm._v(" "),_c('section',{staticClass:"component"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"l-promo row"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo--full-width c-promo--border c-promo--shadow h-theme--red"},[_c('div',{staticClass:"row d-flex flex-wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col flex-child--250"},[_c('aha-sitecore-form-wrapper',{staticClass:"c-aha-form"},[_c('form',{attrs:{"action":"/formbuilder?fxb.FormItemId=a8541879-870a-4d0c-bdf9-2bdeb4924051&fxb.HtmlPrefix=fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837","data-ajax":"true","data-ajax-method":"Post","data-ajax-mode":"replace-with","data-ajax-success":"$.validator.unobtrusive.parse('#fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_a8541879-870a-4d0c-bdf9-2bdeb4924051');$.fxbFormTracker.parse('#fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_a8541879-870a-4d0c-bdf9-2bdeb4924051');","data-ajax-update":"#fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_a8541879-870a-4d0c-bdf9-2bdeb4924051","data-sc-fxb":"a8541879-870a-4d0c-bdf9-2bdeb4924051","enctype":"multipart/form-data","id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_a8541879-870a-4d0c-bdf9-2bdeb4924051","method":"post"}},[_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_FormSessionId","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.FormSessionId","type":"hidden","value":"d562dc3e-9cde-43f2-86b4-5d53b19a8b85"}}),_c('input',{attrs:{"name":"__RequestVerificationToken","type":"hidden","value":"YclzKO0MenAyYtLA38RSLg50l05FaKmp56kG1HwIjjWoPkiRs9l8Y8t0sSEreFc2PPdpAMMtPudGh1q4u5x4YtJ5r7T3YmGb3eRV-aJhs8MjzRSeJkY2gJqSMS0ZqfBuVJlVOddZCUOXtMoIkRDh3w2"}}),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_FormItemId","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.FormItemId","type":"hidden","value":"a8541879-870a-4d0c-bdf9-2bdeb4924051"}}),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_PageItemId","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.PageItemId","type":"hidden","value":"cf929f81-600a-41a2-bfb5-f1b61ec74650"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_Fields_Index_5b86534b-00c3-4c5b-b8e4-f66df86734e9","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.Fields.Index","type":"hidden","value":"5b86534b-00c3-4c5b-b8e4-f66df86734e9"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_Fields_5b86534b-00c3-4c5b-b8e4-f66df86734e9__ItemId","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.Fields[5b86534b-00c3-4c5b-b8e4-f66df86734e9].ItemId","type":"hidden","value":"5b86534b-00c3-4c5b-b8e4-f66df86734e9"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_911a6bee-2697-1b88-9ccd-be68cd8ed07c__Value"}},[_vm._v("First Name (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_911a6bee-2697-1b88-9ccd-be68cd8ed07c__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[911a6bee-2697-1b88-9ccd-be68cd8ed07c].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"firstName","data-val-required":"First Name is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[911a6bee-2697-1b88-9ccd-be68cd8ed07c].Value","data-valmsg-replace":"true"}},[_vm._v("First Name is required.")]),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_05ef8956-6476-caf2-7bc3-18ff28ab334b__Value"}},[_vm._v("Last Name (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_05ef8956-6476-caf2-7bc3-18ff28ab334b__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[05ef8956-6476-caf2-7bc3-18ff28ab334b].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"lastName","data-val-required":"Last Name (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[05ef8956-6476-caf2-7bc3-18ff28ab334b].Value","data-valmsg-replace":"true"}},[_vm._v("Last Name is required.")]),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_281ade3a-7744-6c71-04e1-61c1e876df55__Value"}},[_vm._v("E-mail (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_281ade3a-7744-6c71-04e1-61c1e876df55__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[281ade3a-7744-6c71-04e1-61c1e876df55].Value","type":"email","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"emailrequired","data-val-required":"E-mail (required) is required.","data-val-regex":"E-mail (required) contains an invalid email address.","data-val-regex-pattern":"^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,17}$","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[281ade3a-7744-6c71-04e1-61c1e876df55].Value","data-valmsg-replace":"true"}},[_vm._v("E-mail is required.")]),_vm._v(" "),_c('p',{staticClass:"small pt-4"},[_vm._v("By clicking the sign up button you agree to the "),_c('a',{staticClass:"h-color--blue",attrs:{"href":"/en/healthy-living/hfg-user-agreement"}},[_vm._v("Terms and Conditions")]),_vm._v(" and "),_c('a',{staticClass:"h-color--blue",attrs:{"href":"/en/about-us/statements-and-policies/privacy-statement"}},[_vm._v("Privacy Policy")]),_vm._v(".")]),_vm._v(" "),_c('div',{staticClass:"form-group custom-control custom-checkbox",attrs:{"data-sc-field-key":"2AD3A4F9A22149BD82D0A46DA8184F16"}},[_c('input',{attrs:{"id":"fxb_50e616a4-6a71-48e9-acac-20800324ad8a_Fields_Index_92a2ad27-aecd-43d5-971e-77ba9c3fc08a","name":"fxb.50e616a4-6a71-48e9-acac-20800324ad8a.Fields.Index","type":"hidden","value":"92a2ad27-aecd-43d5-971e-77ba9c3fc08a"}}),_c('input',{attrs:{"id":"fxb_50e616a4-6a71-48e9-acac-20800324ad8a_Fields_92a2ad27-aecd-43d5-971e-77ba9c3fc08a__ItemId","name":"fxb.50e616a4-6a71-48e9-acac-20800324ad8a.Fields[92a2ad27-aecd-43d5-971e-77ba9c3fc08a].ItemId","type":"hidden","value":"92a2ad27-aecd-43d5-971e-77ba9c3fc08a"}}),_vm._v(" "),_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"fxb_50e616a4-6a71-48e9-acac-20800324ad8a_Fields_92a2ad27-aecd-43d5-971e-77ba9c3fc08a__Value","name":"fxb.50e616a4-6a71-48e9-acac-20800324ad8a.Fields[92a2ad27-aecd-43d5-971e-77ba9c3fc08a].Value","value":"true","data-sc-tracking":"True","data-sc-field-name":"TermsCheckbox","data-sc-field-key":"BC32242F4CD74F6D8745C98BDB12077D","data-val-ischecked":"TermsCheckbox is required.","data-val-ischecked-value":"False","data-val-required":"The Value field is required.","data-val":"true"}}),_vm._v("\n                                                    I have read and understand the "),_c('a',{attrs:{"href":"/en/about-us/statements-and-policies/terms-of-service"}},[_vm._v("Terms and Conditions")]),_vm._v(" and "),_c('a',{staticClass:"h-color--white",attrs:{"href":"/en/about-us/statements-and-policies/privacy-statement"}},[_vm._v("Privacy Policy")]),_vm._v(".\n                                                    "),_c('input',{attrs:{"type":"hidden","name":"fxb.50e616a4-6a71-48e9-acac-20800324ad8a.Fields[92a2ad27-aecd-43d5-971e-77ba9c3fc08a].Value","value":"false"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"fxb_50e616a4-6a71-48e9-acac-20800324ad8a_Fields_92a2ad27-aecd-43d5-971e-77ba9c3fc08a__Value"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid",attrs:{"data-valmsg-for":"fxb.50e616a4-6a71-48e9-acac-20800324ad8a.Fields[92a2ad27-aecd-43d5-971e-77ba9c3fc08a].Value","data-valmsg-replace":"true"}})]),_vm._v(" "),_c('input',{attrs:{"value":"Sign Up","type":"submit","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.7bf433be-c7cb-435f-93d9-54dfc0a30a68"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_NavigationButtons","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.NavigationButtons","type":"hidden","value":"7bf433be-c7cb-435f-93d9-54dfc0a30a68"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_7bf433be-c7cb-435f-93d9-54dfc0a30a68","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.7bf433be-c7cb-435f-93d9-54dfc0a30a68","type":"hidden","value":"1"}})])])],1)])])])])])])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"l-promo row"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo--full-width c-promo--border c-promo--shadow h-theme--green-light"},[_c('div',{staticClass:"row d-flex flex-wrap"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col flex-child--250"},[_c('aha-sitecore-form-wrapper',{staticClass:"c-aha-form"},[_c('form',{attrs:{"action":"/formbuilder?fxb.FormItemId=a8541879-870a-4d0c-bdf9-2bdeb4924051&fxb.HtmlPrefix=fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837","data-ajax":"true","data-ajax-method":"Post","data-ajax-mode":"replace-with","data-ajax-success":"$.validator.unobtrusive.parse('#fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_a8541879-870a-4d0c-bdf9-2bdeb4924051');$.fxbFormTracker.parse('#fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_a8541879-870a-4d0c-bdf9-2bdeb4924051');","data-ajax-update":"#fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_a8541879-870a-4d0c-bdf9-2bdeb4924051","data-sc-fxb":"a8541879-870a-4d0c-bdf9-2bdeb4924051","enctype":"multipart/form-data","id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_a8541879-870a-4d0c-bdf9-2bdeb4924051","method":"post"}},[_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_FormSessionId","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.FormSessionId","type":"hidden","value":"d562dc3e-9cde-43f2-86b4-5d53b19a8b85"}}),_c('input',{attrs:{"name":"__RequestVerificationToken","type":"hidden","value":"YclzKO0MenAyYtLA38RSLg50l05FaKmp56kG1HwIjjWoPkiRs9l8Y8t0sSEreFc2PPdpAMMtPudGh1q4u5x4YtJ5r7T3YmGb3eRV-aJhs8MjzRSeJkY2gJqSMS0ZqfBuVJlVOddZCUOXtMoIkRDh3w2"}}),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_FormItemId","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.FormItemId","type":"hidden","value":"a8541879-870a-4d0c-bdf9-2bdeb4924051"}}),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_PageItemId","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.PageItemId","type":"hidden","value":"cf929f81-600a-41a2-bfb5-f1b61ec74650"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_Fields_Index_5b86534b-00c3-4c5b-b8e4-f66df86734e9","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.Fields.Index","type":"hidden","value":"5b86534b-00c3-4c5b-b8e4-f66df86734e9"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_Fields_5b86534b-00c3-4c5b-b8e4-f66df86734e9__ItemId","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.Fields[5b86534b-00c3-4c5b-b8e4-f66df86734e9].ItemId","type":"hidden","value":"5b86534b-00c3-4c5b-b8e4-f66df86734e9"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_911a6bee-2697-1b88-9ccd-be68cd8ed07c__Value"}},[_vm._v("First Name (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_911a6bee-2697-1b88-9ccd-be68cd8ed07c__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[911a6bee-2697-1b88-9ccd-be68cd8ed07c].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"firstName","data-val-required":"First Name is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[911a6bee-2697-1b88-9ccd-be68cd8ed07c].Value","data-valmsg-replace":"true"}},[_vm._v("First Name is required.")]),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_05ef8956-6476-caf2-7bc3-18ff28ab334b__Value"}},[_vm._v("Last Name (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_05ef8956-6476-caf2-7bc3-18ff28ab334b__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[05ef8956-6476-caf2-7bc3-18ff28ab334b].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"lastName","data-val-required":"Last Name (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[05ef8956-6476-caf2-7bc3-18ff28ab334b].Value","data-valmsg-replace":"true"}},[_vm._v("Last Name is required.")]),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_281ade3a-7744-6c71-04e1-61c1e876df55__Value"}},[_vm._v("E-mail (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_281ade3a-7744-6c71-04e1-61c1e876df55__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[281ade3a-7744-6c71-04e1-61c1e876df55].Value","type":"email","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"emailrequired","data-val-required":"E-mail (required) is required.","data-val-regex":"E-mail (required) contains an invalid email address.","data-val-regex-pattern":"^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,17}$","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[281ade3a-7744-6c71-04e1-61c1e876df55].Value","data-valmsg-replace":"true"}},[_vm._v("E-mail is required.")]),_vm._v(" "),_c('p',{staticClass:"small pt-4"},[_vm._v("By clicking the sign up button you agree to the "),_c('a',{staticClass:"h-color--blue",attrs:{"href":"/en/healthy-living/hfg-user-agreement"}},[_vm._v("Terms and Conditions")]),_vm._v(" and "),_c('a',{staticClass:"h-color--blue",attrs:{"href":"/en/about-us/statements-and-policies/privacy-statement"}},[_vm._v("Privacy Policy")]),_vm._v(".")]),_vm._v(" "),_c('input',{attrs:{"value":"Sign Up","type":"submit","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.7bf433be-c7cb-435f-93d9-54dfc0a30a68"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_NavigationButtons","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.NavigationButtons","type":"hidden","value":"7bf433be-c7cb-435f-93d9-54dfc0a30a68"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_7bf433be-c7cb-435f-93d9-54dfc0a30a68","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.7bf433be-c7cb-435f-93d9-54dfc0a30a68","type":"hidden","value":"1"}})])])],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 p-5"},[_c('h2',[_vm._v("Signup Inside a Modal")]),_vm._v(" "),_c('p',[_vm._v("\n                    Example of personalization signup inside a modal.\n                ")]),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('GenericModal'),expression:"'GenericModal'"}],staticClass:"text-primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("\n                    Open Signup Form\n                ")])])])]),_vm._v(" "),_c('aha-modal',{ref:"GenericModal",staticClass:"c-modal--aha",attrs:{"id":"GenericModal","hide-footer":"","hide-header":"","centered":"","lazy":""}},[_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'GenericModal', $event.target)}}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticClass:"l-promo row"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo--full-width c-promo--border c-promo--shadow h-theme--green-light"},[_c('div',{staticClass:"row d-flex flex-wrap"},[_c('div',{staticClass:"col flex-child--250"},[_c('div',{staticClass:"c-promo__content pr-0"},[_c('h2',{staticClass:"h2 h-color--red"},[_vm._v("Unite with AHA")]),_vm._v(" "),_c('p',{staticClass:"h4 mb-4"},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic nostrum laboriosam veniam voluptatibus harum blanditiis dolorum sed facere quibusdam, minus esse quo, vero porro omnis fugiat iusto aliquid eveniet unde.")])])]),_vm._v(" "),_c('div',{staticClass:"col flex-child--250"},[_c('aha-sitecore-form-wrapper',{staticClass:"c-aha-form"},[_c('form',{attrs:{"action":"/formbuilder?fxb.FormItemId=a8541879-870a-4d0c-bdf9-2bdeb4924051&fxb.HtmlPrefix=fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837","data-ajax":"true","data-ajax-method":"Post","data-ajax-mode":"replace-with","data-ajax-success":"$.validator.unobtrusive.parse('#fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_a8541879-870a-4d0c-bdf9-2bdeb4924051');$.fxbFormTracker.parse('#fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_a8541879-870a-4d0c-bdf9-2bdeb4924051');","data-ajax-update":"#fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_a8541879-870a-4d0c-bdf9-2bdeb4924051","data-sc-fxb":"a8541879-870a-4d0c-bdf9-2bdeb4924051","enctype":"multipart/form-data","id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_a8541879-870a-4d0c-bdf9-2bdeb4924051","method":"post"}},[_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_FormSessionId","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.FormSessionId","type":"hidden","value":"d562dc3e-9cde-43f2-86b4-5d53b19a8b85"}}),_c('input',{attrs:{"name":"__RequestVerificationToken","type":"hidden","value":"YclzKO0MenAyYtLA38RSLg50l05FaKmp56kG1HwIjjWoPkiRs9l8Y8t0sSEreFc2PPdpAMMtPudGh1q4u5x4YtJ5r7T3YmGb3eRV-aJhs8MjzRSeJkY2gJqSMS0ZqfBuVJlVOddZCUOXtMoIkRDh3w2"}}),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_FormItemId","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.FormItemId","type":"hidden","value":"a8541879-870a-4d0c-bdf9-2bdeb4924051"}}),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_PageItemId","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.PageItemId","type":"hidden","value":"cf929f81-600a-41a2-bfb5-f1b61ec74650"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_Fields_Index_5b86534b-00c3-4c5b-b8e4-f66df86734e9","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.Fields.Index","type":"hidden","value":"5b86534b-00c3-4c5b-b8e4-f66df86734e9"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_Fields_5b86534b-00c3-4c5b-b8e4-f66df86734e9__ItemId","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.Fields[5b86534b-00c3-4c5b-b8e4-f66df86734e9].ItemId","type":"hidden","value":"5b86534b-00c3-4c5b-b8e4-f66df86734e9"}}),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_911a6bee-2697-1b88-9ccd-be68cd8ed07c__Value"}},[_vm._v("First Name (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_911a6bee-2697-1b88-9ccd-be68cd8ed07c__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[911a6bee-2697-1b88-9ccd-be68cd8ed07c].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"firstName","data-val-required":"First Name is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[911a6bee-2697-1b88-9ccd-be68cd8ed07c].Value","data-valmsg-replace":"true"}},[_vm._v("First Name is required.")]),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_05ef8956-6476-caf2-7bc3-18ff28ab334b__Value"}},[_vm._v("Last Name (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_05ef8956-6476-caf2-7bc3-18ff28ab334b__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[05ef8956-6476-caf2-7bc3-18ff28ab334b].Value","type":"text","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"lastName","data-val-required":"Last Name (required) is required.","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[05ef8956-6476-caf2-7bc3-18ff28ab334b].Value","data-valmsg-replace":"true"}},[_vm._v("Last Name is required.")]),_vm._v(" "),_c('label',{attrs:{"for":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_281ade3a-7744-6c71-04e1-61c1e876df55__Value"}},[_vm._v("E-mail (required)")]),_vm._v(" "),_c('input',{attrs:{"id":"fxb_a0a4dfca-c319-4944-833d-5b3610c9ee9b_Fields_281ade3a-7744-6c71-04e1-61c1e876df55__Value","name":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[281ade3a-7744-6c71-04e1-61c1e876df55].Value","type":"email","maxlength":"255","placeholder":"","data-sc-tracking":"True","data-sc-field-name":"emailrequired","data-val-required":"E-mail (required) is required.","data-val-regex":"E-mail (required) contains an invalid email address.","data-val-regex-pattern":"^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,17}$","data-val":"true"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-error",attrs:{"data-valmsg-for":"fxb.a0a4dfca-c319-4944-833d-5b3610c9ee9b.Fields[281ade3a-7744-6c71-04e1-61c1e876df55].Value","data-valmsg-replace":"true"}},[_vm._v("E-mail is required.")]),_vm._v(" "),_c('p',{staticClass:"small pt-4"},[_vm._v("By clicking the sign up button you agree to the "),_c('a',{staticClass:"h-color--blue",attrs:{"href":"/en/healthy-living/hfg-user-agreement"}},[_vm._v("Terms and Conditions")]),_vm._v(" and "),_c('a',{staticClass:"h-color--blue",attrs:{"href":"/en/about-us/statements-and-policies/privacy-statement"}},[_vm._v("Privacy Policy")]),_vm._v(".")]),_vm._v(" "),_c('input',{attrs:{"value":"Sign Up","type":"submit","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.7bf433be-c7cb-435f-93d9-54dfc0a30a68"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_NavigationButtons","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.NavigationButtons","type":"hidden","value":"7bf433be-c7cb-435f-93d9-54dfc0a30a68"}}),_vm._v(" "),_c('input',{attrs:{"id":"fxb_36152ce9-7501-48d0-bd9d-9b1b144c1837_7bf433be-c7cb-435f-93d9-54dfc0a30a68","name":"fxb.36152ce9-7501-48d0-bd9d-9b1b144c1837.7bf433be-c7cb-435f-93d9-54dfc0a30a68","type":"hidden","value":"1"}})])])],1)])])])])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col flex-child--250"},[_c('div',{staticClass:"c-promo__content pr-0"},[_c('h2',{staticClass:"h2 h-color--red"},[_vm._v("Unite with AHA")]),_vm._v(" "),_c('p',{staticClass:"h4 mb-4"},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic nostrum laboriosam veniam voluptatibus harum blanditiis dolorum sed facere quibusdam, minus esse quo, vero porro omnis fugiat iusto aliquid eveniet unde.")]),_vm._v(" "),_c('p',{staticClass:"h4 mb-4"},[_vm._v("Sitecore form will tranisition to a 'Thank You' panel after submission.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col flex-child--250"},[_c('div',{staticClass:"c-promo__content pr-0"},[_c('h2',{staticClass:"h2 h-color--green-light"},[_vm._v("Unite with AHA")]),_vm._v(" "),_c('p',{staticClass:"h4 mb-5"},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic nostrum laboriosam veniam voluptatibus harum blanditiis dolorum sed facere quibusdam, minus esse quo, vero porro omnis fugiat iusto aliquid eveniet unde.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d11dfd64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_credit_vue__ = __webpack_require__(1377);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d11dfd64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_credit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg h-placeholder-image--bg-sm has-credit-image"},[_c('figure',{staticClass:"c-credit-image__figure"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://placeimg.com/600/600/nature","loading":"lazy","alt":"grandfather and child on bench","title":"grandfather and child on bench"}}),_vm._v(" "),_c('span',{staticClass:"h-mask-half-dark"}),_vm._v(" "),_c('figcaption',{staticClass:"c-credit-image__figcaption"},[_c('a',{directives:[{name:"toggle-credit-image",rawName:"v-toggle-credit-image"}],staticClass:"c-credit-image__toggle toggle",attrs:{"href":"#photoCaption","role":"button","aria-label":"image caption and credit"}}),_vm._v(" "),_vm._m(3)])])])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"c-hero-card h-theme--red"},[_c('div',{staticClass:"c-hero-card__container"},[_c('div',{directives:[{name:"vertical-align",rawName:"v-vertical-align"}],staticClass:"c-hero-card__content-container"},[_c('h1',{staticClass:"c-hero-card__heading"},[_c('fit-text',{attrs:{"max":4.8,"targetLineCount":1}},[_vm._v("Health Topics")])],1),_vm._v(" "),_c('p',{staticClass:"c-hero-card__subheading h4"},[_vm._v("Learn the facts about heart conditions and stroke so you can increase your confidence in making changes to improve and maintain your health.")])]),_vm._v(" "),_c('div',{staticClass:"c-hero-card__media h-placeholder-image h-placeholder-image--43-20 d-none d-sm-block has-credit-image"},[_c('figure',{staticClass:"c-credit-image__figure"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://placeimg.com/600/600/nature","alt":"","width":"900","height":"544","loading":"lazy","DisableWebEdit":"False"}}),_vm._v(" "),_c('span',{staticClass:"h-mask-half-dark"}),_vm._v(" "),_c('figcaption',{staticClass:"c-credit-image__figcaption"},[_c('a',{directives:[{name:"toggle-credit-image",rawName:"v-toggle-credit-image"}],staticClass:"c-credit-image__toggle toggle",attrs:{"href":"#photoCaption","role":"button","aria-label":"image caption and credit"}}),_vm._v(" "),_vm._m(5)])])])])])]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo row"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo--full-width h-theme--aqua c-promo--border"},[_c('div',{staticClass:"row"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg-sm has-credit-image"},[_c('figure',{staticClass:"c-credit-image__figure"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://placeimg.com/600/600/nature","alt":"","width":"900","height":"544","loading":"lazy","DisableWebEdit":"False"}}),_vm._v(" "),_c('figcaption',{staticClass:"c-credit-image__figcaption"},[_c('a',{directives:[{name:"toggle-credit-image",rawName:"v-toggle-credit-image"}],staticClass:"c-credit-image__toggle toggle",attrs:{"href":"#photoCaption","role":"button","aria-label":"image caption and credit"}}),_vm._v(" "),_vm._m(8)])])])])])])])])]),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Image Credit")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h2',[_vm._v("Half Image Half Copy Promo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-promo c-promo--half"},[_c('div',{staticClass:"c-promo__content"},[_c('span',{staticClass:"c-promo__label c-label c-label--orange"},[_vm._v("Featured")]),_vm._v(" "),_c('h2',{staticClass:"h3"},[_vm._v("Veggie Migas")]),_vm._v(" "),_c('p',[_vm._v("A Tex-Mex dish, migas are corn tortilla strips gently fried and incorporated into scrambled eggs. This spin on the classic uses very little oil while also adding an array of veggies into the mix.")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--icon h-theme--yellow-orange-alt",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg"}}),_vm._v("View Recipe\n                        ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-credit-image__content toggle-content",attrs:{"id":"photoCaption","role":"doc-credit"}},[_c('div',{staticClass:"c-credit-image__container"},[_vm._v("\n                                    Sitting in the bioswale garden she created at Masjid An-Nur mosque in Minneapolis, Kenya soaks in the sunshine.\n                                    © ™ ®\n                                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h2',{staticClass:"my-4"},[_vm._v("Overlap Card")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-credit-image__content toggle-content",attrs:{"id":"photoCaption","role":"doc-credit"}},[_c('div',{staticClass:"c-credit-image__container"},[_vm._v("\n                                            Sitting in the bioswale garden she created at Masjid An-Nur mosque in Minneapolis, Kenya soaks in the sunshine.\n                                            © ™ ®\n                                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h2',{staticClass:"my-4"},[_vm._v("Promo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 c-promo--last-sm"},[_c('div',{staticClass:"c-promo c-promo--match-height"},[_c('div',{staticClass:"c-promo__content"},[_c('div',{staticClass:"c-promo__icon"}),_vm._v(" "),_c('h2',{staticClass:"h3"},[_vm._v("Support That Empowers")]),_vm._v(" "),_c('p',[_vm._v("\nRecovery becomes so much more manageable when you have the right kind of emotional support. Our online community of patients, survivors and caregivers is here to keep you going no matter the obstacles. We’ve been there, and we won’t let you go it alone.                                    ")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider"},[_c('a',{staticClass:"c-cta c-cta--icon h-theme--red c-cta--arrow",attrs:{"href":"https://supportnetwork.heart.org/","Title":"Find encouragement"}},[_vm._v(" Find encouragement")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-credit-image__content toggle-content",attrs:{"id":"photoCaption","role":"doc-credit"}},[_c('div',{staticClass:"c-credit-image__container"},[_vm._v("\n                                                Sitting in the bioswale garden she created at Masjid An-Nur mosque in Minneapolis, Kenya soaks in the sunshine.\n                                                © ™ ®\n                                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h2',{staticClass:"my-4"},[_vm._v("Three Columns")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('article',{staticClass:"c-article-card c-article-card--small"},[_c('div',{staticClass:"c-article-card__content"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/aortic-aneurysm/types-of-aneurysms"}},[_c('div',{staticClass:"c-article-card__background h-placeholder-image h-placeholder-image--3-2 has-credit-image",attrs:{"href":"#"}},[_c('figure',{staticClass:"c-credit-image__figure"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://placeimg.com/600/600/people","alt":"medical illustration of an aneurysm","width":"440","height":"339","loading":"lazy","title":"medical illustration of an aneurysm","DisableWebEdit":"True"}}),_vm._v(" "),_c('figcaption',[_vm._v("Image Credit: Getty Images")])])]),_vm._v(" "),_c('h2',{staticClass:"c-article-card__title h4"},[_vm._v("Types of Aneurysms")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('article',{staticClass:"c-article-card c-article-card--small"},[_c('div',{staticClass:"c-article-card__content"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"/en/health-topics/aortic-aneurysm/your-aorta-the-pulse-of-life"}},[_c('div',{staticClass:"c-article-card__background h-placeholder-image h-placeholder-image--3-2 has-credit-image",attrs:{"href":"#"}},[_c('figure',{staticClass:"c-credit-image__figure"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://placeimg.com/600/600/arch","alt":"medical illustration of an aneurysm","width":"440","height":"339","loading":"lazy","title":"medical illustration of an aneurysm","DisableWebEdit":"True"}}),_vm._v(" "),_c('figcaption',[_vm._v("Image Credit: Getty Images")])])]),_vm._v(" "),_c('h2',{staticClass:"c-article-card__title h4"},[_vm._v("Your Aorta: The Pulse of Life")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('article',{staticClass:"c-article-card c-article-card--small"},[_c('div',{staticClass:"c-article-card__content"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"http://watchlearnlive.heart.org/CVML_Player.php","target":"","title":"Watch Videos"}},[_c('div',{staticClass:"c-article-card__background h-placeholder-image h-placeholder-image--3-2 has-credit-image",attrs:{"href":"#"}},[_c('figure',{staticClass:"c-credit-image__figure"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://placeimg.com/600/600/nature","alt":"medical illustration of an aneurysm","width":"440","height":"339","loading":"lazy","title":"medical illustration of an aneurysm","DisableWebEdit":"True"}}),_vm._v(" "),_c('figcaption',[_vm._v("Image Credit: Getty Images")])])]),_vm._v(" "),_c('h2',{staticClass:"c-article-card__title h4"},[_vm._v("Watch, Learn and Live")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7429605a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_articles_vue__ = __webpack_require__(1379);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7429605a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_articles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Articles")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('aha-component',{attrs:{"title":"Large Article"}},[_c('aha-article-large')],1),_vm._v(" "),_c('aha-component',{attrs:{"title":"Medium Article"}},[_c('aha-article-medium')],1),_vm._v(" "),_c('aha-component',{attrs:{"title":"Small Article"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('aha-article-small')],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('aha-article-small')],1)])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('aha-component',{attrs:{"title":"X-Small Article"}},[_c('ul',{staticClass:"l-article-list"},[_c('li',{staticClass:"l-article-list__item"},[_c('aha-article-xsmall')],1),_vm._v(" "),_c('li',{staticClass:"l-article-list__item"},[_c('aha-article-xsmall')],1)])])],1)]),_vm._v(" "),_c('around-aha-news'),_vm._v(" "),_c('around-aha-news'),_vm._v(" "),_c('around-aha-news')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae99a382_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__ = __webpack_require__(1381);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae99a382_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Breadcrumb")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('aha-breadcrumb')],1),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default - w/ Back to Search Link"}},[_c('aha-breadcrumb-with-link')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dacd420_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daf_widget_vue__ = __webpack_require__(1383);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dacd420_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daf_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("DAF Widget")]),_vm._v(" "),_c('p',[_vm._v("Donor Advised Form")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('aha-daf-widget',{attrs:{"dafdirect_settings":""}})],1),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('p',[_vm._v("The DAF Widget is a Donation Advised Form recommend grants to nonprofit directly. The widget needs a daddirect settings string that is generated when signed up from their site.")]),_vm._v(" "),_c('h6',[_vm._v("Example of dafdirect settings string: XXXXXXXXX_XXXX_XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX.")]),_vm._v(" "),_c('p',[_vm._v("The number generates a special token string that will be passed to the financial institute from the dropdown.")]),_vm._v(" "),_c('p',[_vm._v("If no dafdirect setting string is passed into the component then it will default to the one stored in the component.")]),_vm._v(" "),_c('code',[_vm._v("\"135613797_1111_88885361-4ceb-423f-bde6-xxxxxxxxxxxx\"")]),_vm._v(" "),_c('h3',{staticClass:"mt-4"},[_vm._v("USAGE")]),_vm._v(" "),_c('h5',[_vm._v("Default")]),_vm._v(" "),_c('code',[_vm._v("<aha-daf-widget></aha-daf-widget>")]),_vm._v(" "),_c('h5',{staticClass:"mt-3"},[_vm._v("With your own dafdirect settings string")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("<aha-daf-widget \ndafdirect_settings=\n\"135613797_1111_88885361-4ceb-423f-bde6-xxxxxxxxxxxx\"\n>\n</aha-daf-widget>")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_modal_vue__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_modal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_modal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_modal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_244f54b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_modal_vue__ = __webpack_require__(1385);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_modal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_244f54b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Generic Modal")]),_vm._v(" "),_c('h4',{staticClass:"mt-4"},[_vm._v("Triggers")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Page load - add prop visible")]),_vm._v(" "),_c('li',[_vm._v("Interval - :interval=\"5\" (5 seconds)")]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('PersonalizedQuizModal'),expression:"'PersonalizedQuizModal'"}],staticClass:"text-primary",attrs:{"href":"#"}},[_vm._v("Open Personalized Quiz Modal")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('QuizModal'),expression:"'QuizModal'"}],staticClass:"text-primary",attrs:{"href":"#"}},[_vm._v("Open Quiz Modal")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('GenericModal'),expression:"'GenericModal'"}],staticClass:"text-primary",attrs:{"href":"#"}},[_vm._v("Open Generic Modal With Component")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"text-primary",attrs:{"href":"#"},on:{"click":function($event){return _vm.$root.$emit('bv::show::modal', 'PersonalizedQuizModal')}}},[_vm._v("Open Personalized Quiz Modal with Emit")])])]),_vm._v(" "),_c('aha-modal',{ref:"GenericModal",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"GenericModal","title":"Quiz","hide-footer":"","centered":""}},[_c('article',{staticClass:"c-article-card c-article-card--large h-text-contrast"},[_c('p',{staticClass:"c-article-card__label"},[_c('span',{staticClass:"c-label c-label--green"},[_vm._v("In The News")])]),_vm._v(" "),_c('a',{staticClass:"c-article-card__link",attrs:{"href":"#"}},[_c('div',{staticClass:"c-article-card__background h-placeholder-image h-placeholder-image--4-3",attrs:{"href":"#"}},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/750x563/ddd/ccc?text=FPO'),expression:"'//placehold.it/750x563/ddd/ccc?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_c('div',{staticClass:"c-article-card__content"},[_c('p',{staticClass:"c-article-card__metadata"},[_c('time',{attrs:{"datetime":"2017-10-03"}},[_vm._v("Oct. 3,\n                               2017")]),_vm._v(" / By American Heart Association News")]),_vm._v(" "),_c('h2',{staticClass:"c-article-card__title h3"},[_vm._v("Meditation May Decrease The Risk Of Heart\n                           Disease")]),_vm._v(" "),_c('p',{staticClass:"c-article-card__subtitle"},[_vm._v("Live a long and healthy life, The American\n                           Heart Association has your back.")])])])])]),_vm._v(" "),_c('aha-modal',{ref:"PersonalizedQuizModal",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"PersonalizedQuizModal","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('aha-transition-group',{ref:"QuizModal",staticClass:"c-hero-card-snackable"},[_c('div',{staticClass:"c-hero-card-snackable__container"},[_c('div',{staticClass:"c-hero-card-snackable__content",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Cholesterol high? Let Us Help You\n                               Find The Perfect Meal. ")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis\n                               elementum felis, a pretium felis. ")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number mt-3"},[_vm._v("1 of 3")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                                   Next\n                               ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Choose a Protein")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2 mb-0"},[_c('fieldset',[_c('div',{attrs:{"data-v-546c2c52":""}},[_c('div',{staticClass:"c-quiz-personalized__selects"},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio1","name":"customRadioGroup","checked":""}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio1"}},[_vm._v("Bisquit")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio2","name":"customRadioGroup"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio2"}},[_vm._v("Toast")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio3","name":"customRadioGroup"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio3"}},[_vm._v("Waffle")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio4","name":"customRadioGroup","checked":""}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio4"}},[_vm._v("Turkey")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio5","name":"customRadioGroup"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio5"}},[_vm._v("Salmon")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":"customRadio6","name":"customRadioGroup"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customRadio6"}},[_vm._v("Lean Beef")])])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number mt-3"},[_vm._v("2 of 3")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"1","event-item-id":"12345","event-text":"eventText"}},[_vm._v("\n                                   Back\n                               ")]),_vm._v(" "),_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","event-item-id":"123456","event-text":"eventText"}},[_vm._v("\n                                   Next\n                               ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('aha-transition-trigger',{directives:[{name:"register-event",rawName:"v-register-event"}],staticClass:"p-0 m-0 bg-white border-0",attrs:{"type":"button","step-index":"1","event-item-id":"123456","event-text":"eventText"}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake Quiz\n                               ")])],1),_vm._v(" "),_c('div',{staticClass:"c-daily-journey"},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Try This: Salmon With Sauted\n                                   Greens And Veggies")]),_vm._v(" "),_c('a',{staticClass:"btn btn-secondary-link ml-0 pl-0",attrs:{"href":"/en"}},[_vm._v("Get the Recipe\n                                   Here!")]),_vm._v(" "),_c('a',{staticClass:"btn btn-secondary-link ml-0 pl-0",attrs:{"href":"/en"}},[_vm._v("Show Me Something\n                                   Else!")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number mt-3"},[_vm._v("3 of 3")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share--quiz"},[_c('p',{staticClass:"h3 mr-3"},[_vm._v("Share:")]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"/assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"/assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('img',{attrs:{"src":"/assets/share/mail.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#0"}},[_c('img',{attrs:{"src":"/assets/share/copy-link.svg"}})])])])])],1)])])],1),_vm._v(" "),_c('aha-modal',{ref:"QuizModal",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"QuizModal","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('aha-transition-group',{staticClass:"c-hero-card-snackable-full-quiz"},[_c('aha-transition-group-form',{attrs:{"error-step-key":7,"url":"/aha-service/grfw/Quiz","name":"Strip Down"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable-full-quiz"},[_c('div',{attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Which Breakfast Item Are\n                                       You?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam\n                                       mollis elementum felis, a pretium felis. Maecenas tempor blandit\n                                       libero, ut tempor augue posuere non. Donec sed auctor arcu.\n                                       Vivamus consectetur eros id mauris egestas semper. Phasellus et\n                                       diam ac justo tempus vulputate. ")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("1 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                                           Next\n                                       ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"whichBreakfastHeading"}},[_vm._v("\n                                       Which One Would You Choose")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"whichBreakfastHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"bisquit","name":"whichBreakfast","value":"Bisquit"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"bisquit"}},[_vm._v("Bisquit")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"toast","name":"whichBreakfast","value":"Toast"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"toast"}},[_vm._v("Toast")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('whichBreakfast'),expression:"'whichBreakfast'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"waffle","name":"whichBreakfast","value":"Waffle"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"waffle"}},[_vm._v("Waffle")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("2 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"1","type":"button"}},[_vm._v("\n                                           Back\n                                       ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                           Next\n                                       ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v(_vm._s(formCtrl.ResponseTitle)+"\n                                   ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.ResponseText))]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("3 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"2","type":"button"}},[_vm._v("\n                                           Back\n                                       ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                           Next\n                                       ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":4}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"healthyDietHeading"}},[_vm._v("The\n                                       simplest way to enjoy a healthy diet is with:")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"healthyDietHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"candy","name":"healthyDiet","value":"Candy"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"candy"}},[_vm._v("Candy")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"butter","name":"healthyDiet","value":"Butter"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"butter"}},[_vm._v("Butter")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('healthyDiet'),expression:"'healthyDiet'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"burger","name":"healthyDiet","value":"Burger"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"burger"}},[_vm._v("Burger")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("4 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"3","type":"button"}},[_vm._v("\n                                           Back\n                                       ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                           Next\n                                       ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":5}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v(_vm._s(formCtrl.ResponseTitle)+"\n                                   ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.ResponseText))]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("5 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"4"}},[_vm._v("\n                                           Back\n                                       ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.whichBreakfast},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                           Next\n                                       ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":6}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-4"},[_c('button',{staticClass:"c-cta btn btn-link h-theme--red",attrs:{"type":"button","step-index":"1"},on:{"click":formCtrl.resetForm}},[_c('img',{staticClass:"mr-2",attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Retake Quiz\n                                       ")])]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey"},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("You Got: Avocado Toast\n                                       ")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed\n                                           do eiusmod tempor incididunt ut labore et dolore magna\n                                           aliqua. Ut enim ad minim veniam, quis nostrud exercitation\n                                           ullamco laboris nisi ut.")]),_vm._v(" "),_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("Get the Recipe Here!")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number mt-3"},[_vm._v("6 of 6")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share--quiz"},[_c('p',{staticClass:"h3 mr-3"},[_vm._v("Share:")]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('img',{attrs:{"src":"assets/share/mail.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#0"}},[_c('img',{attrs:{"src":"assets/share/copy-link.svg"}})])])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable-full-width__transition",attrs:{"step-key":7}},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                                       Uh oh, it appears that there was a network issue.\n                                   ")]),_vm._v(" "),_c('div',{staticClass:"c-make-commitment__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"2","type":"button"}},[_vm._v("\n                                           Back\n                                       ")])],1)])],1)])]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_nav_vue__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_nav_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_nav_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_nav_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd96d2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_nav_vue__ = __webpack_require__(1387);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_nav_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd96d2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Main Nav")]),_vm._v(" "),_c('aha-main-nav')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_utility_bar_vue__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_utility_bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_utility_bar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_utility_bar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_utility_bar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_116ee085_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_utility_bar_vue__ = __webpack_require__(1389);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_utility_bar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_116ee085_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_utility_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Utility Bar")]),_vm._v(" "),_c('aha-utility-bar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_top_nav_vue__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_top_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_top_nav_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_top_nav_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_top_nav_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80f7b708_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_nav_vue__ = __webpack_require__(1391);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_top_nav_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80f7b708_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container container-fluid container-wide"},[_c('aha-top-nav')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Top Nav")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_signup_vue__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_signup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_signup_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_signup_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_signup_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a344879_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_signup_vue__ = __webpack_require__(1393);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_signup_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a344879_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container container-fluid container-wide"},[_c('aha-login-signup')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Login/Signup")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5326db1a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listing_header_vue__ = __webpack_require__(1395);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5326db1a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listing_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid h-theme--red"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Listing Header")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Listing Header Large"}},[_c('aha-listing-header')],1),_vm._v(" "),_c('aha-component',{attrs:{"title":"Listing Header Medium"}},[_c('aha-listing-header-medium')],1),_vm._v(" "),_c('aha-component',{attrs:{"title":"Listing Header Small"}},[_c('aha-listing-header-small')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348f424b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_card_vue__ = __webpack_require__(1397);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348f424b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-hero-card'),_vm._v(" "),_c('a',{staticStyle:{"opacity":"0"},attrs:{"href":"#"}},[_vm._v("This is hidden on purpose")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid h-theme--red"},[_c('h1',{staticClass:"page-heading mb-5"},[_vm._v("Hero Card")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52d6e8dd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_donation_hero_card_vue__ = __webpack_require__(1399);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52d6e8dd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_donation_hero_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"c-hero-card h-theme--red"},[_c('div',{staticClass:"c-hero-card__container"},[_c('div',{directives:[{name:"vertical-align",rawName:"v-vertical-align"}],staticClass:"c-hero-card__content-container"},[_c('h1',{staticClass:"c-hero-card__heading h1"},[_vm._v("Ways to Give")]),_vm._v(" "),_c('p',{staticClass:"c-hero-card__subheading h4"},[_vm._v("Your support means the work to us.")]),_vm._v(" "),_c('form',{directives:[{name:"luminate-donate-form",rawName:"v-luminate-donate-form"}],attrs:{"method":"post","action":"https://www2.heart.org/site/SPageNavigator/donatenow_heart.html?s_src=20U2W1UEMG&s_subsrc=ways_to_give_hero_donate_btn","name":"donationForm"}},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"c-hero-card__media h-placeholder-image h-placeholder-image--43-20"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://www.heart.org/-/media/direct-response-images/november-2020/mom_and_young_son_making_thanksigiving_dinner.jpg'),expression:"'https://www.heart.org/-/media/direct-response-images/november-2020/mom_and_young_son_making_thanksigiving_dinner.jpg'"}],attrs:{"src":"//placehold.it/1200x600?text=loading","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId","video-id":"M7lc1UVf-VE"}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid h-theme--red"},[_c('h1',{staticClass:"page-heading mb-5"},[_vm._v("Donation Hero Card")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group row c-hero-card__duration ml-0"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{staticClass:"form-check-input",attrs:{"checked":"","type":"radio","name":"frequency","id":"timeFrameOne","value":"onetime"}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"timeFrameOne"}},[_vm._v("One-Time Gift")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"frequency","id":"timeFrameMonthly","value":"monthly"}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"timeFrameMonthly"}},[_vm._v("Monthly Gift")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group row c-hero-card__monetary ml-0",attrs:{"id":"donation"}},[_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{staticClass:"form-check-input",attrs:{"checked":"","type":"radio","name":"amount_select","id":"inlineRadio1","value":"40"}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"inlineRadio1"}},[_vm._v("$40")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"amount_select","id":"inlineRadio2","value":"60"}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"inlineRadio2"}},[_vm._v("$60")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"amount_select","id":"inlineRadio3","value":"100"}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"inlineRadio3"}},[_vm._v("$100")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"amount_select","id":"inlineRadio4","value":"250"}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"inlineRadio4"}},[_vm._v("$250")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{staticClass:"form-check-input mt-3 mt-md-0",attrs:{"type":"number","name":"amount_other","id":"otherAmount","value":"","placeholder":"$ Other","aria-label":"Enter an amount between $10 and $50,000 to donate.","min":"10","max":"50000"}}),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"otherAmount"}},[_vm._v("Other Amount")])]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"amount","value":""}}),_vm._v(" "),_c('div',{staticClass:"clearfix mt-4 error-message"},[_c('p',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                            Please choose an amount presented or enter an amount between\n                            $10 and $50,000 to donate.\n                            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-round btn-primary mt-4",attrs:{"type":"submit","id":"submit"}},[_vm._v("\n                            Donate Now\n                            ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d67978_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_full_width_vue__ = __webpack_require__(1401);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d67978_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_full_width_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-hero-full-width')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-5"},[_vm._v("Hero Full-Width")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f775d532_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_event_list_vue__ = __webpack_require__(1403);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f775d532_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_event_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-event-list'),_vm._v(" "),_c('a',{staticStyle:{"opacity":"0"},attrs:{"href":"#"}},[_vm._v("This is hidden on purpose")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid h-theme--red"},[_c('h1',{staticClass:"page-heading mb-5"},[_vm._v("Event List")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_737483f9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_video_image_vue__ = __webpack_require__(1405);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_737483f9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_video_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-component',{attrs:{"title":""}},[_c('aha-full-width-video-image')],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Full-Width Video/Image")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43ffb335_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_event_vue__ = __webpack_require__(1407);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43ffb335_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_event_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-full-width-event')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Full-Width Event")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_866dbd5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inquiries_support_vue__ = __webpack_require__(1409);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_866dbd5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inquiries_support_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-inquiries-support')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Inquiries & Support Bar")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_134e2cbf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_testimonial_vue__ = __webpack_require__(1411);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_134e2cbf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_testimonial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-testimonial')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Full-Width Testimonial")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449695d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_highlight_copy_vue__ = __webpack_require__(1413);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449695d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_highlight_copy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-full-width-highlight-copy')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Full-Width Highlight Copy")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e9fb70a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inline_search_vue__ = __webpack_require__(1415);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e9fb70a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inline_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Inline Search")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('aha-inline-search')],1),_vm._v(" "),_c('aha-component',{attrs:{"title":"Dropdown"}},[_c('aha-inline-search-dropdown')],1),_vm._v(" "),_c('aha-component',{attrs:{"title":"Redirect"}},[_c('aha-inline-search-redirect')],1),_vm._v(" "),_c('aha-component',{attrs:{"title":"Icon"}},[_c('aha-inline-search-icon')],1),_vm._v(" "),_c('aha-component',{attrs:{"title":"Simple"}},[_c('aha-inline-search-simple')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68c25846_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ce_search_vue__ = __webpack_require__(1417);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68c25846_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ce_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Ce Search")]),_vm._v(" "),_c('aha-component',[_c('aha-ce-search')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d5d13dd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_course_search_vue__ = __webpack_require__(1419);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d5d13dd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_course_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Course Search")]),_vm._v(" "),_c('aha-component',[_c('aha-course-search')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_763e4c78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cpr_course_search_vue__ = __webpack_require__(1421);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_763e4c78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cpr_course_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("CPR Course Search")]),_vm._v(" "),_c('aha-component',[_c('aha-cpr-course-search')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74545656_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quality_research_publications_vue__ = __webpack_require__(1423);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74545656_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quality_research_publications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("QI GWTG Quality Research Publications")]),_vm._v(" "),_c('aha-component',[_c('aha-quality-research-publications')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61f251db_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rating_widget_vue__ = __webpack_require__(1425);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61f251db_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rating_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-rating-widget'),_vm._v(" "),_c('a',{staticStyle:{"opacity":"0"},attrs:{"href":"#"}},[_vm._v("This is hidden on purpose")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid h-theme--red"},[_c('h1',{staticClass:"page-heading mb-5"},[_vm._v("Rating Widget")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80cc5990_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_icon_navigation_vue__ = __webpack_require__(1427);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80cc5990_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_icon_navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Icon Navigation")])]),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo l-promo--icon-nav"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo c-promo--full-width c-promo--border c-promo--border-bottom-only c-promo--shadow h-theme--red"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"c-icon-nav__content d-flex align-items-center h-100"},[_c('div',{staticClass:"h3"},[_vm._v("In a hurry? Select a topic to navigate to that section")])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-8"},[_c('div',{staticClass:"c-icon-nav__icons h-theme--red"},[_c('div',{staticClass:"c-icon-nav__icon text-center"},[_c('a',{staticClass:"c-cta h-theme--black c-icon-nav__action",attrs:{"href":"https://www.heart.org/en/coronavirus","title":"Go to article"}},[_c('div',{staticClass:"c-icon-nav__icon-block"},[_c('img',{attrs:{"src":"assets/glyphs/donate-heart.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-nav__icon-title"},[_vm._v("What is COVID-19?")])])]),_vm._v(" "),_c('div',{staticClass:"c-icon-nav__icon text-center"},[_c('a',{staticClass:"c-cta h-theme--black c-icon-nav__action",attrs:{"href":"#AdditionalResources","title":"Jump to section"}},[_c('div',{staticClass:"c-icon-nav__icon-block"},[_c('img',{attrs:{"src":"assets/glyphs/cross.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-nav__icon-title"},[_vm._v("Additional Resources")])])]),_vm._v(" "),_c('div',{staticClass:"c-icon-nav__icon text-center"},[_c('a',{staticClass:"c-cta h-theme--black c-icon-nav__action twoClick",attrs:{"href":"http://www.cnn.com","title":"Go To CNN"}},[_c('div',{staticClass:"c-icon-nav__icon-block"},[_c('img',{attrs:{"src":"assets/glyphs/volunteer.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-nav__icon-title"},[_vm._v("Volunteer")])])]),_vm._v(" "),_c('div',{staticClass:"c-icon-nav__icon text-center"},[_c('a',{staticClass:"c-cta h-theme--black c-icon-nav__action",attrs:{"href":"https://www.heart.org/en/coronavirus","title":"Go to article"}},[_c('div',{staticClass:"c-icon-nav__icon-block"},[_c('img',{attrs:{"src":"assets/glyphs/donate-heart.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-nav__icon-title"},[_vm._v("What is COVID-19?")])])]),_vm._v(" "),_c('div',{staticClass:"c-icon-nav__icon text-center"},[_c('a',{staticClass:"c-cta h-theme--black c-icon-nav__action",attrs:{"href":"#AdditionalResources","title":"Jump to section"}},[_c('div',{staticClass:"c-icon-nav__icon-block"},[_c('img',{attrs:{"src":"assets/glyphs/cross.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"c-icon-nav__icon-title"},[_vm._v("Additional Resources")])])])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_765c69fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_video_carousel_vue__ = __webpack_require__(1429);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_765c69fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_video_carousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-carousel')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Image & Video Carousel")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grocery_list_vue__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grocery_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grocery_list_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grocery_list_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grocery_list_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d5fa340_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grocery_list_vue__ = __webpack_require__(1431);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grocery_list_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d5fa340_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grocery_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Grocery List")]),_vm._v(" "),_c('div',{staticClass:"my-4"}),_vm._v(" "),_c('aha-grocery-list',{attrs:{"title":"Awesome List","count":5}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-center"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"my-4"},[_vm._v("\n        To see preset list for testing, use the console to clear localstorage.\n        "),_c('pre',[_vm._v("localStorage.clear()")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_information_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_information_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_information_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_information_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_information_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e767c91a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_course_information_vue__ = __webpack_require__(1435);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_information_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e767c91a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_course_information_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61c633c5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_course_information_vue__ = __webpack_require__(1434);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61c633c5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_course_information_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"c-table c-table--hidden-mobile",attrs:{"role":"table","aria-describedby":"courseOptionsHeading"}},[_c('caption',{staticClass:"c-table__caption h3",attrs:{"id":"courseOptionsHeading"}},[_vm._v("Course Options")]),_vm._v(" "),_c('tbody',{staticClass:"c-table__body",attrs:{"role":"rowgroup"}},[_c('tr',{staticClass:"c-table__row",attrs:{"role":"row"}},[_c('td'),_vm._v(" "),_c('th',{staticClass:"c-table__heading c-table__heading--col",attrs:{"scope":"col","role":"columnheader","title":"Heartsaver&reg; First Aid CPR AEDClassroom"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--col"},[_c('div',{staticClass:"c-table__heading-icon c-table__heading-icon--lg"},[_c('img',{attrs:{"src":"assets/images/course-icons/instructors.png"}})])]),_vm._v(" "),_c('p',{staticClass:"h3 h-color--black"},[_vm._v("Classroom")])]),_vm._v(" "),_c('th',{staticClass:"c-table__heading c-table__heading--col",attrs:{"scope":"col","role":"columnheader","title":"Heartsaver&reg; First Aid CPR AED Blended Learning"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--col"},[_c('div',{staticClass:"c-table__heading-icon c-table__heading-icon--lg"},[_c('img',{attrs:{"src":"assets/images/course-icons/instructors.png"}})]),_vm._v(" "),_c('div',{staticClass:"c-table__heading-icon c-table__heading-icon--lg"},[_c('img',{attrs:{"src":"assets/glyphs/cross.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-table__heading-icon c-table__heading-icon--lg"},[_c('img',{attrs:{"src":"assets/images/course-icons/classroom.png"}})])]),_vm._v(" "),_c('p',{staticClass:"h3 h-color--black"},[_vm._v("Blended Learning")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"scope":"row","role":"rowheader","title":"What to Expect"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("What to Expect")])])]),_vm._v(" "),_c('td',{staticClass:"c-table__data",attrs:{"role":"cell"}},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"/"}},[_vm._v("Learn More")])])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"/"}},[_vm._v("Lorem Ipsum Dolor site Amet")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"scope":"row","role":"rowheader","title":"Format"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Format")])])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',[_vm._v("Classroom-based Instructor and Video, with Skills Conducted Throughout")])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',[_vm._v("Online, followed by a hand-on session with an AHA BLS or Heartsaver Instructor")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"scope":"row","role":"rowheader","title":"Time"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Time")])])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',[_vm._v("Varies")])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',[_vm._v("Hands-On Session: varies"),_c('br'),_vm._v("\n                    Online: approximately 1 hour, 45 minutes")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"scope":"row","role":"rowheader","title":"Completion Card"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Completion Card")])])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',[_vm._v("US English Only")])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',[_vm._v("US English Only")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"scope":"row","role":"rowheader","title":"Accessibility"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Accessibility")])])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',[_vm._v("Something Brief if Relevant")])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',[_vm._v("Audio & Transcripts, Text Size controls")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"scope":"row","role":"rowheader","title":"CE / CME"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("CE / CME")])])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',[_vm._v("Not Eligible")])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',[_vm._v("IACET Accredited: 0.3 CEUs")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"scope":"row","role":"rowheader","title":"FAQ"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("FAQ")])])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"/"}},[_vm._v("Classroom FAQ")])])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"/"}},[_vm._v("Blended Learning FAQ")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"scope":"row","role":"rowheader","title":"Features"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Features")])])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('ul',[_c('li',[_vm._v("\n                            Video Based course ensures consistency Instructor-led, hands-on class format reinforces skills proficiency\n                        ")]),_vm._v(" "),_c('li',[_vm._v("\n                            Student Workbook comes with Heartsaver First Aid Quick Reference Guide that summarizes first aid actions for many injuries and illnesses\n                        ")]),_vm._v(" "),_c('li',[_vm._v("\n                            Course is updated with the new science from the 2015 AHA Guildelines Update for Cardiopulmonary Resuscitation and Emergency Cardiovascular\n                        ")])])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('ul',[_c('li',[_vm._v("\n                            Video Based course ensures consistency Instructor-led, hands-on class format reinforces skills proficiency\n                        ")]),_vm._v(" "),_c('li',[_vm._v("\n                            Student Workbook comes with Heartsaver First Aid Quick Reference Guide that summarizes first aid actions for many injuries and illnesses\n                        ")]),_vm._v(" "),_c('li',[_vm._v("\n                            Course is updated with the new science from the 2015 AHA Guildelines Update for Cardiopulmonary Resuscitation and Emergency Cardiovascular\n                        ")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"scope":"row","role":"rowheader","title":"Student Materials"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Student Materials")])])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',{staticClass:"text-left"},[_c('strong',[_vm._v("15-1020")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("Student Workbook")]),_vm._v(" with Adult Reminder Card and Child & Infant Reminder Card\n                    ")])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',{staticClass:"text-left"},[_c('strong',[_vm._v("15-1401")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("Online Course")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"scope":"row","role":"rowheader","title":"Instructor Materials"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Instructor Materials")])])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',{staticClass:"text-left"},[_c('strong',[_vm._v("15-1019")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("DVD Set")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v("15-1023")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("Manual")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v("15-3114")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("Instructor Manual eBook")]),_c('br')])]),_vm._v(" "),_c('td',{staticClass:"c-table__data c-table__data--striped",attrs:{"role":"cell"}},[_c('p',{staticClass:"text-left"},[_c('strong',[_vm._v("15-1019")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("DVD Set")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v("15-1023")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("Manual")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v("15-3114")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("Instructor Manual eBook")]),_c('br')])])])])]),_vm._v(" "),_c('table',{staticClass:"c-table c-table--condensed c-table--hidden-desktop",attrs:{"role":"presentation"}},[_c('caption',{staticClass:"c-table__caption h3"},[_vm._v("Course Options")]),_vm._v(" "),_c('tbody',{staticClass:"c-table__body"},[_c('tr',{staticClass:"c-table__condensed-row"},[_c('td',{staticClass:"c-table__condensed-data"},[_c('table',{staticClass:"c-table",attrs:{"role":"table"}},[_c('caption',{staticClass:"c-table__caption c-table__caption--sr-only",attrs:{"id":"courseOptionsClassroom"}},[_vm._v("\n                            Course Options - Heartsaver® First Aid CPR AED - Classroom\n                        ")]),_vm._v(" "),_c('tbody',{attrs:{"role":"rowgroup"}},[_c('tr',{staticClass:"c-table__row",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--col",attrs:{"id":"classroom","title":"Heartsaver&reg; First Aid CPR AEDClassroom"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--col"},[_c('div',{staticClass:"c-table__heading-icon c-table__heading-icon--lg"},[_c('img',{attrs:{"src":"assets/images/course-icons/instructors.png"}})])]),_vm._v(" "),_c('p',{staticClass:"h3 h-color--black"},[_vm._v("Classroom")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"whatToExpect","title":"What to Expect"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("What to Expect")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"classroom whatToExpect"}},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"/"}},[_vm._v("Learn More")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"format","title":"Format"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Format")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"classroom format"}},[_c('p',[_vm._v("Classroom-based Instructor and Video, with Skills Conducted Throughout")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"time","title":"Time"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Time")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"classroom time"}},[_c('p',[_vm._v("Varies")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"completionCard","title":"Completion Card"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Completion Card")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"classroom completionCard"}},[_c('p',[_vm._v("US English Only")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"accessibility","title":"Accessibility"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Accessibility")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"classroom accessibility"}},[_c('p',[_vm._v("Something Brief if Relevant")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"ceCme","title":"CE / CME"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("CE / CME")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"classroom ceCme"}},[_c('p',[_vm._v("Not Eligible")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"faq","title":"FAQ"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("FAQ")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"classroom faq"}},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"/"}},[_vm._v("Classroom FAQ")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"features","title":"Features"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Features")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"classroom features"}},[_c('ul',[_c('li',[_vm._v("\n                                            Video Based course ensures consistency Instructor-led, hands-on class format reinforces skills proficiency\n                                        ")]),_vm._v(" "),_c('li',[_vm._v("\n                                            Student Workbook comes with Heartsaver First Aid Quick Reference Guide that summarizes first aid actions for many injuries and illnesses\n                                        ")]),_vm._v(" "),_c('li',[_vm._v("\n                                            Course is updated with the new science from the 2015 AHA Guildelines Update for Cardiopulmonary Resuscitation and Emergency Cardiovascular\n                                        ")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"studentMaterials","title":"Student Materials"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Student Materials")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"classroom studentMaterials"}},[_c('p',{staticClass:"text-left"},[_c('strong',[_vm._v("15-1020")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("Student Workbook")]),_vm._v(" with Adult Reminder Card and Child & Infant Reminder Card\n                                    ")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"instructorMaterials","title":"Instructor Materials"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Instructor Materials")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"classroom instructorMaterials"}},[_c('p',{staticClass:"text-left"},[_c('strong',[_vm._v("15-1019")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("DVD Set")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v("15-1023")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("Manual")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v("15-3114")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("Instructor Manual eBook")]),_c('br')])])])])])]),_vm._v(" "),_c('td',{staticClass:"c-table__condensed-data"},[_c('table',{staticClass:"c-table",attrs:{"role":"table"}},[_c('caption',{staticClass:"c-table__caption c-table__caption--sr-only",attrs:{"id":"courseOptionsHeadingBlendedLearning"}},[_vm._v("\n                            Course Options - Heartsaver® First Aid CPR AED - Blended Learning\n                        ")]),_vm._v(" "),_c('tbody',{attrs:{"role":"rowgroup"}},[_c('tr',{staticClass:"c-table__row",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--col",attrs:{"id":"blendedLearning","title":"Heartsaver&reg; First Aid CPR AED Blended Learning"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--col"},[_c('div',{staticClass:"c-table__heading-icon c-table__heading-icon--lg"},[_c('img',{attrs:{"src":"assets/images/course-icons/instructors.png"}})]),_vm._v(" "),_c('div',{staticClass:"c-table__heading-icon c-table__heading-icon--lg"},[_c('img',{attrs:{"src":"assets/glyphs/cross.svg"}})]),_vm._v(" "),_c('div',{staticClass:"c-table__heading-icon c-table__heading-icon--lg"},[_c('img',{attrs:{"src":"assets/images/course-icons/classroom.png"}})])]),_vm._v(" "),_c('p',{staticClass:"h3 h-color--black"},[_vm._v("Blended Learning")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"whatToExpectCol2","title":"What to Expect"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("What to Expect")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"blendedLearning whatToExpectCol2"}},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"/"}},[_vm._v("Lorem Ipsum Dolor site Amet")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"formatCol2","title":"Format"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Format")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"blendedLearning formatCol2"}},[_c('p',[_vm._v("Online, followed by a hand-on session with an AHA BLS or Heartsaver Instructor")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"timeCol2","title":"Time"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Time")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"blendedLearning timeCol2"}},[_c('p',[_vm._v("Hands-On Session: varies"),_c('br'),_vm._v("\n                                    Online: approximately 1 hour, 45 minutes")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"completionCardCol2","title":"Completion Card"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Completion Card")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"blendedLearning completionCardCol2"}},[_c('p',[_vm._v("US English Only")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"accessibilityCol2","title":"Accessibility"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Accessibility")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"blendedLearning accessibilityCol2"}},[_c('p',[_vm._v("Audio & Transcripts, Text Size controls")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"ceCmeCol2","title":"CE / CME"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("CE / CME")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"blendedLearning ceCmeCol2"}},[_c('p',[_vm._v("IACET Accredited: 0.3 CEUs")])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"faqCol2","title":"FAQ"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("FAQ")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"blendedLearning faqCol2"}},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"/"}},[_vm._v("Blended Learning FAQ")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"featuresCol2","title":"Features"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Features")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"blendedLearning featuresCol2"}},[_c('ul',[_c('li',[_vm._v("\n                                            Video Based course ensures consistency Instructor-led, hands-on class format reinforces skills proficiency\n                                        ")]),_vm._v(" "),_c('li',[_vm._v("\n                                            Student Workbook comes with Heartsaver First Aid Quick Reference Guide that summarizes first aid actions for many injuries and illnesses\n                                        ")]),_vm._v(" "),_c('li',[_vm._v("\n                                            Course is updated with the new science from the 2015 AHA Guildelines Update for Cardiopulmonary Resuscitation and Emergency Cardiovascular\n                                        ")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"studentMaterialsCol2","title":"Student Materials"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Student Materials")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"blendedLearning studentMaterialsCol2"}},[_c('p',{staticClass:"text-left"},[_c('strong',[_vm._v("15-1401")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("Online Course")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('th',{staticClass:"c-table__heading c-table__heading--row",attrs:{"id":"instructorMaterialsCol2","title":"Instructor Materials"}},[_c('div',{staticClass:"c-table__heading-wrap c-table__heading-wrap--row"},[_c('div',{staticClass:"c-table__heading-icon"},[_c('img',{attrs:{"aria-hidden":"true","src":"assets/icons/info.svg"}})]),_vm._v(" "),_c('p',[_vm._v("Instructor Materials")])])])]),_vm._v(" "),_c('tr',{staticClass:"c-table__row c-table__row--striped",attrs:{"role":"row"}},[_c('td',{staticClass:"c-table__data",attrs:{"role":"cell","headers":"blendedLearning instructorMaterialsCol2"}},[_c('p',{staticClass:"text-left"},[_c('strong',[_vm._v("15-1019")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("DVD Set")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v("15-1023")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("Manual")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v("15-3114")]),_vm._v(" - "),_c('a',{attrs:{"href":"/"}},[_vm._v("Instructor Manual eBook")]),_c('br')])])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Course Information")]),_vm._v(" "),_c('aha-component',[_c('aha-course-information')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb3a786_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_gallery_vue__ = __webpack_require__(1437);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb3a786_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-video-gallery')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Video Gallery")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b73eed0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_vue__ = __webpack_require__(1441);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b73eed0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01b228ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_vue__ = __webpack_require__(1440);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01b228ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-section"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId0'),expression:"'uniqueModalId0'"}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?0'),expression:"'//placeimg.com/1200/600/any?0'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId0","video-id":"M7lc1UVf-VE"}}),_vm._v(" "),_c('p',{staticClass:"c-video__title h5"},[_vm._v("Video Caption")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"l-section"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId1'),expression:"'uniqueModalId1'"}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?1'),expression:"'//placeimg.com/1200/600/any?1'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId1","video-id":"M7lc1UVf-VE"}}),_vm._v(" "),_c('p',{staticClass:"c-video__title h5"},[_vm._v("Video Caption")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId2'),expression:"'uniqueModalId2'"}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?2'),expression:"'//placeimg.com/1200/600/any?2'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId2","video-id":"M7lc1UVf-VE"}}),_vm._v(" "),_c('p',{staticClass:"c-video__title h5"},[_vm._v("Video Caption")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"l-section"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId3'),expression:"'uniqueModalId3'"}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?3'),expression:"'//placeimg.com/1200/600/any?3'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId3","video-id":"M7lc1UVf-VE"}}),_vm._v(" "),_c('p',{staticClass:"c-video__title h5"},[_vm._v("Video Caption")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId3'),expression:"'uniqueModalId3'"}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?4'),expression:"'//placeimg.com/1200/600/any?4'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId4","video-id":"M7lc1UVf-VE"}}),_vm._v(" "),_c('p',{staticClass:"c-video__title h5"},[_vm._v("Video Caption")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId3'),expression:"'uniqueModalId3'"}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?5'),expression:"'//placeimg.com/1200/600/any?5'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId5","video-id":"M7lc1UVf-VE"}}),_vm._v(" "),_c('p',{staticClass:"c-video__title h5"},[_vm._v("Video Caption")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"l-section"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId3'),expression:"'uniqueModalId3'"}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?6'),expression:"'//placeimg.com/1200/600/any?6'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId6","video-id":"M7lc1UVf-VE"}}),_vm._v(" "),_c('p',{staticClass:"c-video__title h5"},[_vm._v("Video Caption test")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId3'),expression:"'uniqueModalId3'"}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?7'),expression:"'//placeimg.com/1200/600/any?7'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId7","video-id":"M7lc1UVf-VE"}}),_vm._v(" "),_c('p',{staticClass:"c-video__title h5"},[_vm._v("Video Caption")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId3'),expression:"'uniqueModalId3'"}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?8'),expression:"'//placeimg.com/1200/600/any?8'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId8","video-id":"M7lc1UVf-VE"}}),_vm._v(" "),_c('p',{staticClass:"c-video__title h5"},[_vm._v("Video Caption")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId3'),expression:"'uniqueModalId3'"}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?9'),expression:"'//placeimg.com/1200/600/any?9'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId9","video-id":"M7lc1UVf-VE"}}),_vm._v(" "),_c('p',{staticClass:"c-video__title h5"},[_vm._v("Video Caption")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"c-video"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-1",modifiers:{"modal-1":true}}],staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any?8'),expression:"'//placeimg.com/1200/600/any?8'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-modal',{ref:"loadingModal",staticClass:"c-loadingModal",attrs:{"size":"md","id":"modal-1","hide-footer":"","centered":"","lazy":"","video-modal":""}},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":"https://www.youtube.com/embed/zpOULjyy-n8?rel=0","allowfullscreen":""}})],1),_vm._v(" "),_c('p',{staticClass:"c-video__title h5"},[_vm._v("Bembed Model")])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-video')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Video")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1469d793_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tv_pages_vue__ = __webpack_require__(1443);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1469d793_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tv_pages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-tv-pages'),_vm._v(" "),_c('a',{staticStyle:{"opacity":"0"},attrs:{"href":"#"}},[_vm._v("This is hidden on purpose")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid h-theme--red"},[_c('h1',{staticClass:"page-heading mb-5"},[_vm._v("Hero Card")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('aha-things-to-know')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49407abc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_external_script_vue__ = __webpack_require__(1446);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49407abc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_external_script_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Daily Journey")]),_vm._v(" "),_c('h1',[_vm._v("JotForm External Script")]),_vm._v(" "),_c('aha-external-script',{attrs:{"id":"jt2","src":"https://form.jotform.com/jsform/83334336746158"}}),_vm._v(" "),_c('div',[_c('aha-external-script',{attrs:{"id":"jt12","src":"https://form.jotform.com/jsform/202796431116049"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0afb4602_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_magic_grid_demo_examples_vue__ = __webpack_require__(1450);
function injectStyle (ssrContext) {
  __webpack_require__(1448)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0afb4602"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0afb4602_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_magic_grid_demo_examples_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1449);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("3dba1b89", content, true, {});

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".col-lg[data-v-0afb4602]:first-child,.col[data-v-0afb4602]:first-child{background-color:rgba(255,0,255,.15)}.col-lg[data-v-0afb4602]:nth-child(2){background-color:rgba(125,0,125,.15)}.col-lg[data-v-0afb4602]:nth-child(3){background-color:rgba(50,0,50,.15)}", ""]);

// exports


/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("3, 2, and 1 column 'magic' grid examples:")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"magic-grid"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v("3 Column 'Magic Grid' with level 2 Heading")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg"},[_c('p',[_vm._v("Column 1")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil ab minus repellat, deleniti, inventore voluptatibus vero quam, quae adipisci necessitatibus neque. Eligendi eos, sit libero exercitationem voluptates unde voluptatem voluptatum?")]),_vm._v(" "),_c('p',[_vm._v("Corporis, dolores eveniet. Sequi vero esse ab illum commodi facilis ducimus nostrum maiores totam. Quae, deserunt cum! Assumenda minus accusantium, cum error, facere vitae deleniti dolorum eos soluta ratione voluptate!")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg"},[_c('p',[_vm._v("Column 2")]),_vm._v(" "),_c('p',[_vm._v("Sapiente eveniet aliquid illum. Neque corrupti, sit distinctio consequatur enim esse vero autem atque temporibus quasi quos reprehenderit? Quos obcaecati quod ipsum beatae nesciunt dolore doloremque iste est eos voluptatibus?")]),_vm._v(" "),_c('p',[_vm._v("Quam aperiam, similique ipsum numquam aliquid rem quo odit ducimus laudantium animi. Soluta atque ratione a aspernatur molestiae magnam cum, voluptates, sapiente tempora iure molestias consequuntur odio veritatis error minima.")]),_vm._v(" "),_c('p',[_vm._v("Maxime earum nostrum porro, omnis est blanditiis totam vel sit velit voluptate vitae debitis aperiam dolor ipsum hic dicta quaerat facere aliquid exercitationem error placeat modi ut reiciendis. Nemo, non.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg"},[_c('p',[_vm._v("Column 3")]),_vm._v(" "),_c('p',[_vm._v("Facilis autem praesentium saepe, exercitationem, incidunt inventore, corrupti laborum expedita dolores vero sint voluptatibus officia nesciunt reiciendis voluptates eos. Quo, maiores! Quas accusantium velit a cupiditate, quidem laborum quibusdam in.")])])])])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"magic-grid"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("2 Column 'Magic Grid' with level 3 Heading")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg"},[_c('p',[_vm._v("Column 1")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil ab minus repellat, deleniti, inventore voluptatibus vero quam, quae adipisci necessitatibus neque. Eligendi eos, sit libero exercitationem voluptates unde voluptatem voluptatum?")]),_vm._v(" "),_c('p',[_vm._v("Corporis, dolores eveniet. Sequi vero esse ab illum commodi facilis ducimus nostrum maiores totam. Quae, deserunt cum! Assumenda minus accusantium, cum error, facere vitae deleniti dolorum eos soluta ratione voluptate!")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg"},[_c('p',[_vm._v("Column 2")]),_vm._v(" "),_c('p',[_vm._v("Sapiente eveniet aliquid illum. Neque corrupti, sit distinctio consequatur enim esse vero autem atque temporibus quasi quos reprehenderit? Quos obcaecati quod ipsum beatae nesciunt dolore doloremque iste est eos voluptatibus?")]),_vm._v(" "),_c('p',[_vm._v("Quam aperiam, similique ipsum numquam aliquid rem quo odit ducimus laudantium animi. Soluta atque ratione a aspernatur molestiae magnam cum, voluptates, sapiente tempora iure molestias consequuntur odio veritatis error minima.")]),_vm._v(" "),_c('p',[_vm._v("Maxime earum nostrum porro, omnis est blanditiis totam vel sit velit voluptate vitae debitis aperiam dolor ipsum hic dicta quaerat facere aliquid exercitationem error placeat modi ut reiciendis. Nemo, non.")])])])])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"magic-grid"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',[_vm._v("1 Column 'Magic Grid' with level 4 Heading")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg"},[_c('p',[_vm._v("Column 1")]),_vm._v(" "),_c('p',[_vm._v("Sapiente eveniet aliquid illum. Neque corrupti, sit distinctio consequatur enim esse vero autem atque temporibus quasi quos reprehenderit? Quos obcaecati quod ipsum beatae nesciunt dolore doloremque iste est eos voluptatibus?")]),_vm._v(" "),_c('p',[_vm._v("Quam aperiam, similique ipsum numquam aliquid rem quo odit ducimus laudantium animi. Soluta atque ratione a aspernatur molestiae magnam cum, voluptates, sapiente tempora iure molestias consequuntur odio veritatis error minima.")]),_vm._v(" "),_c('p',[_vm._v("Maxime earum nostrum porro, omnis est blanditiis totam vel sit velit voluptate vitae debitis aperiam dolor ipsum hic dicta quaerat facere aliquid exercitationem error placeat modi ut reiciendis. Nemo, non.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eca001ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_newsletter_ajax_component_vue__ = __webpack_require__(1452);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eca001ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_newsletter_ajax_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',[_vm._v("Newsletter AJAX Component")]),_vm._v(" "),_c('div',{staticClass:"c-email-promo c-email-promo--bg c-email-promo--center h-theme--black h-text-contrast",attrs:{"id":"emailform"}},[_c('div',{staticClass:"c-email-promo__media h-placeholder-image h-placeholder-image--bg"}),_vm._v(" "),_c('span'),_vm._v(" "),_c('div',{staticClass:"c-email-promo__container container container-fluid"},[_c('div',{staticClass:"c-email-promo__content h-theme--black h-text-contrast"},[_c('aha-newsletter-ajax-thank-you',{attrs:{"url":"https://run.mocky.io/v3/04887c52-0fc4-4891-8c19-9bbdb798a0a4"},scopedSlots:_vm._u([{key:"newsletter",fn:function(props){return _c('div',{},[_c('div',{staticClass:"text-center"},[_c('h2',{staticClass:"c-email-promo__heading h2"},[_vm._v("\n                                        Stay up to date on how your support makes an impact on\n                                        your community.\n                                    ")]),_vm._v(" "),_c('p',{staticClass:"c-email-promo__subheading"},[_c('strong',[_vm._v("Note:")]),_vm._v(" "),_c('em',[_vm._v("All fields required unless indicated as optional.")])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('form',{directives:[{name:"form-submit",rawName:"v-form-submit"}],ref:"newsletterform",staticClass:"col-md-8 text-left",attrs:{"name":"newsletter","method":"post","action":""}},[_c('div',{attrs:{"aria-atomic":"true","aria-live":"polite"}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"firstname"}},[_vm._v("First Name (required)\n                                            ")]),_vm._v(" "),_c('p',{staticClass:"invalid-feedback"},[_vm._v("\n                                                First Name Required\n                                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.formData.firstname),expression:"props.formData.firstname"}],staticClass:"form-control",attrs:{"type":"text","id":"firstname","required":"required","name":"firstname","aria-required":"true","aria-invalid":"false"},domProps:{"value":(props.formData.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.formData, "firstname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"lastname"}},[_vm._v("Last Name (required)\n                                            ")]),_vm._v(" "),_c('p',{staticClass:"invalid-feedback"},[_vm._v("\n                                                Last Name Required\n                                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.formData.lastname),expression:"props.formData.lastname"}],staticClass:"form-control",attrs:{"type":"text","id":"lastname","required":"required","name":"lastname","aria-required":"true","aria-invalid":"false"},domProps:{"value":(props.formData.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.formData, "lastname", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email (required)\n                                            ")]),_vm._v(" "),_c('p',{staticClass:"invalid-feedback"},[_vm._v("\n                                                Email Required\n                                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.formData.email),expression:"props.formData.email"}],staticClass:"form-control",attrs:{"type":"email","id":"email","required":"required","name":"email","aria-required":"true","aria-invalid":"false","placeholder":"youremail@domain.com"},domProps:{"value":(props.formData.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.formData, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"zipcode"}},[_vm._v("Zip Code (required)\n                                            ")]),_vm._v(" "),_c('p',{staticClass:"invalid-feedback"},[_vm._v("\n                                                Zip Code Required\n                                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.formData.zipcode),expression:"props.formData.zipcode"}],staticClass:"form-control",attrs:{"type":"text","id":"zipcode","required":"required","name":"zipcode","aria-required":"true","aria-invalid":"false"},domProps:{"value":(props.formData.zipcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.formData, "zipcode", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 d-flex justify-content-center mt-4"},[_c('button',{staticClass:"btn btn-primary btn-round",attrs:{"type":"submit","name":"submit"},on:{"click":props.submitForm}},[_vm._v("\n                                            Sign me up!\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-center mt-4"},[_vm._v("\n                                        By clicking the sign up button you agree to\n                                        the "),_c('a',{attrs:{"href":"/en/about-us/statements-and-policies/terms-of-service"}},[_vm._v("Terms and Conditions")]),_vm._v(" and "),_c('a',{staticClass:"h-color--white",attrs:{"href":"/en/about-us/statements-and-policies/privacy-statement"}},[_vm._v("Privacy Policy")]),_vm._v(".\n                                    ")])])])])}},{key:"thankyou",fn:function(props){return _c('div',{staticClass:"thankyou",attrs:{"role":"alert","aria-atomic":"true"}},[_c('h2',{staticClass:"h3"},[_vm._v("Thanks for signing up!")]),_vm._v(" "),_c('p',[_vm._v("We look forward to keeping you up to date on how, together, we're making an impact on your community.")])])}}])})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09e7d5b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_form_submit_to_email_vue__ = __webpack_require__(1454);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09e7d5b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_form_submit_to_email_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Modal Form Submit To Email")]),_vm._v(" "),_c('button',{staticClass:"btn btn-round btn-outline-primary",on:{"click":function($event){return _vm.$root.$emit('bv::show::modal', 'GroceryListModal', $event.target)}}},[_vm._v("Open Modal")]),_vm._v(" "),_c('b-modal',{ref:"GroceryListModal",staticClass:"c-location-modal c-job-resources-modal",attrs:{"id":"GroceryListModal","scrollable":"","hide-footer":"","centered":"","lazy":""}},[_c('div',{staticClass:"loader-container",attrs:{"id":"GroceryListSpinner","role":"alert","aria-live":"assertive"}},[_c('div',{staticClass:"loader"},[_vm._v("Loading...")])]),_vm._v(" "),_c('div',{attrs:{"id":"grocery-list-print-section"}},[_c('aha-grocery-list',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h2',[_vm._v("Super Awesome Grocery List")])]},proxy:true},{key:"error",fn:function(){return [_c('h4',{staticClass:"text-primary"},[_vm._v("No items listed. Please add item from search results.")])]},proxy:true}])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("\n                Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam sapiente magni aliquid dicta pariatur! Quae facilis repellendus doloribus. Veniam dolores natus cupiditate eum expedita provident voluptatum officiis fugit reprehenderit ad.\n            ")]),_vm._v(" "),_c('div',{staticClass:"message small mb-3 d-print-none d-print-none"},[_vm._v("\n                By sending this email you agree to our "),_c('a',{attrs:{"href":"https://www.heart.org/en/about-us/statements-and-policies/privacy-statement","title":"Privacy Policy"}},[_vm._v("Privacy Policy")]),_vm._v(".\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row justify-content-between d-print-none"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"small text-danger mt-2 width-100"},[_vm._v("Please provide a valid email please.")]),_vm._v(" "),_c('form',{directives:[{name:"form-submit-grocery-email",rawName:"v-form-submit-grocery-email",value:('aha-service/HeartCheckGroceryList/Email'),expression:"'aha-service/HeartCheckGroceryList/Email'"}],staticClass:"form-inline d-print-none",attrs:{"action":""}},[_c('div',{staticClass:"form-group mr-3 d-print-none"},[_c('label',{staticClass:"mr-2",attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control d-print-none",attrs:{"type":"email","id":"email","name":"email","required":"","data-vv-delay":"100","placeholder":"username@example.com","pattern":"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"}})])]),_vm._v(" "),_c('button',{staticClass:"btn btn-round btn-primary d-print-none",attrs:{"type":"submit","disabled":_vm.fields.email && _vm.fields.email.invalid}},[_vm._v("Email My List")])]),_vm._v(" "),_c('button',{directives:[{name:"print-element",rawName:"v-print-element",value:('grocery-list-print-section'),expression:"'grocery-list-print-section'"}],staticClass:"btn btn-outline-primary btn-round mr-3 d-print-none"},[_vm._v("Print Grocery List")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a788a60_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liw_intro_banner_vue__ = __webpack_require__(1456);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a788a60_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liw_intro_banner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('liw-intro-banner')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Sponsor Banner")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8663e3ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liw_counter_component_vue__ = __webpack_require__(1458);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8663e3ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liw_counter_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('liw-counter-component')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("LIW - Counter Component")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2725e28_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liw_multi_logo_component_vue__ = __webpack_require__(1460);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2725e28_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liw_multi_logo_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('liw-multi-logo-component')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("LIW - Multi Logo Component")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6637fa16_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liw_flip_card_component_vue__ = __webpack_require__(1462);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6637fa16_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liw_flip_card_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('liw-flip-card-component')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("LIW - Flip Card Component")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d51844cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ecc_color_coded_table_vue__ = __webpack_require__(1464);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d51844cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ecc_color_coded_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Color Coded Table")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('color-coded-table')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23e2c18c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ecc_references_vue__ = __webpack_require__(1466);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23e2c18c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ecc_references_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("ECC References")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('ecc-references',{attrs:{"references":[
            {
                id: 'uniqueID1',
                content: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est voluptatibus nobis nulla? Est, architecto quidem modi voluptatem magnam vitae perferendis expedita corrupti accusantium numquam nostrum illo quisquam perspiciatis, tempore provident!',
                refnum: '1'
            },
            {
                id: 'uniqueID2',
                content: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est voluptatibus nobis nulla? Est, architecto quidem modi voluptatem magnam vitae perferendis expedita corrupti accusantium numquam nostrum illo quisquam perspiciatis, tempore provident!',
                refnum: '2'
            },
            {
                id: 'uniqueID3',
                content: "<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. <a href='#'>quam nostrum</a> illo quisquam perspiciatis",
                refnum: '2a'
            },
            {
                id: 'uniqueID4',
                content: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est voluptatibus nobis nulla? Est, architecto quidem modi voluptatem magnam vitae perferendis expedita corrupti accusantium numquam nostrum illo quisquam perspiciatis, tempore provident!',
                refnum: '3'
            },
            {
                id: 'uniqueID5',
                content: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est voluptatibus nobis nulla? Est, architecto quidem modi voluptatem magnam vitae perferendis expedita corrupti accusantium numquam nostrum illo quisquam perspiciatis, tempore provident!',
                refnum: '4'
            },
            {
                id: 'uniqueID6',
                content: "<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. <a href='#'>quam nostrum</a> illo quisquam perspiciatis",
                refnum: '11a'
            } ]}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? "),_c('a',{staticClass:"text-bold",attrs:{"href":"#uniqueID1"}},[_vm._v("Tempore minus")]),_vm._v(" quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! "),_c('a',{staticClass:"text-bold",attrs:{"href":"#uniqueID2"}},[_vm._v("Lorem, ipsum")]),_vm._v(" dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? "),_c('a',{staticClass:"text-bold",attrs:{"href":"#uniqueID1"}},[_vm._v("Tempore minus")]),_vm._v(" quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit officiis?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat ad sapiente accusantium culpa totam exercitationem. Doloremque ducimus debitis pariatur molestias consequuntur nulla quia earum reiciendis numquam? Tempore minus quod eveniet! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero est beatae rerum maxime esse architecto soluta ipsam magnam laboriosam, facere velit totam labore nesciunt ab perspiciatis! Corrupti nam impedit "),_c('a',{staticClass:"text-bold",attrs:{"href":"#uniqueID3"}},[_vm._v("officiis")]),_vm._v("?")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35370d71_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ecc_search_vue__ = __webpack_require__(1468);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35370d71_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ecc_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("ECC Search")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('ecc-search')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd0bf1aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ecc_nested_accordion_vue__ = __webpack_require__(1470);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd0bf1aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ecc_nested_accordion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Nested Accordion")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('nested-accordion')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd2f9326_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_svg_map_vue__ = __webpack_require__(1472);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd2f9326_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_svg_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("SVG Map")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('svg-map',{attrs:{"map-settings":{
                mapHeight: '500px', 
                activeStateColor: '#ce2a23', 
                inactiveStateColor: '#6f859a', 
                hiddenStateAbbrev: ['MD', 'RI', 'CT', 'MA', 'NH', 'DC', 'DE', 'NJ', 'VT'], 
                showAccessibleStateSelector: true, 
                screenReaderMapTitle: 'CPR In Schools Legislation Map', 
                selectorButtonLabel: 'Select',
                blankSelectorOptionLabel: 'Select A State'},"map-data":[
                {
                    id: 'US-AL',
                    value: '1',
                    line1: 'CPR training required for high school graduation.',
                    line2: 'Began in 2017-2018 school year.',
                    line3: 'Click on state to read law in full. ',
                    url: 'https://www.alabama.gov/'
                },
                {
                    id: 'US-AK',
                    value: '0',
                    line1: 'ALASKA CPR training required for high school graduation.',
                    line2: 'Began in 2017-2018 school year.',
                    line3: 'Click on state to read law in full. ',
                    url: 'https://www.alaska.gov/'
                },
                {
                    id: 'US-AZ',
                    value: '1',
                    line1: 'This is line 1',
                    line2: 'This is line 2',
                    line3: 'This is line 3',
                    url: 'https://az.gov/'
                },
                {
                    id: 'US-AR',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-CA',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-CO',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-CT',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-DC',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-DE',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-FL',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-GA',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-HI',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-ID',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-IL',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-IN',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-IA',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-KS',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-KY',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-LA',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-ME',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-MD',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-MA',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-MI',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-MN',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-MS',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-MO',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-MT',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-NE',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-NV',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-NH',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-NJ',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-NM',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-NY',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-NC',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-ND',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-OH',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-OK',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-OR',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-PA',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-RI',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-SC',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-SD',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-TN',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-TX',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-UT',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-VT',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-VA',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-WA',
                    value: '1',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-WV',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-WI',
                    value: '0',
                    url: 'http://www.google.com'
                },
                {
                    id: 'US-WY',
                    value: '0',
                    url: 'http://www.google.com'
                }
            ]}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db0444bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_column_content_width_promo_vue__ = __webpack_require__(1474);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db0444bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_column_content_width_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-two-column-content-width-promo')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Two-Column Content-Width Promo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57764c0a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_column_full_width_promo_vue__ = __webpack_require__(1476);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57764c0a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_column_full_width_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-two-column-full-width-promo')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Two-Column Full-Width Promo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d296a060_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_column_full_bleed_promo_vue__ = __webpack_require__(1478);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d296a060_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_column_full_bleed_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-two-column-full-bleed-promo')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Two-Column Full-Bleed Promo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00882ca2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_column_content_width_promo_vue__ = __webpack_require__(1480);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00882ca2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_column_content_width_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-three-column-content-width-promo')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Three-Column Content-Width Promo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5e06c42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_column_content_width_promo_enhanced_vue__ = __webpack_require__(1482);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5e06c42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_column_content_width_promo_enhanced_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("PHD Three-Column Content-Width Promo Enhanced")])]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo l-promo--enhanced-three-column-content-width l-promo--shadow"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo-enhanced br-1"},[_c('div',{staticClass:"c-promo-enhanced__content"},[_c('div',{staticClass:"c-promo-enhanced__label"},[_vm._v("FEATURED ARTICLE")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__image h-placeholder-image h-placeholder-image--3-2",attrs:{"href":"#"}},[_c('img',{staticClass:"is-loaded",attrs:{"src":"//placehold.it/750x563/ddd/ccc?text=FPO"}})]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__image-cta"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Association Between Neighborhood Walkability and Predicted 10-Year CVD Risk")])])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo-enhanced"},[_c('div',{staticClass:"c-promo-enhanced__content"},[_c('div',{staticClass:"c-promo-enhanced__label"},[_vm._v("ONLINE MEETING")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__title"},[_vm._v("Hypertension Live Twitter Chat")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__subtext"},[_vm._v("\n                                    October 30, 2019 "),_c('br'),_vm._v("\n                                    10am - 11am CT\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__actions"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("\n                                Learn More\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo-enhanced"},[_c('div',{staticClass:"c-promo-enhanced__content"},[_c('div',{staticClass:"c-promo-enhanced__label"},[_vm._v("ONLINE MEETING")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__title"},[_vm._v("Hypertension Live Twitter Chat")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__subtext"},[_vm._v("\n                                    October 30, 2019 "),_c('br'),_vm._v("\n                                    10am - 11am CT\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__actions"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("\n                                Learn More\n                                ")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_561d903b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_four_column_content_width_icon_promo_vue__ = __webpack_require__(1484);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_561d903b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_four_column_content_width_icon_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-four-column-content-width-icon-promo')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Four-Column Content-Width Icon Promo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aa1ce4f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_four_column_content_width_image_promo_vue__ = __webpack_require__(1486);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aa1ce4f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_four_column_content_width_image_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-four-column-content-width-image-promo')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Four-Column Content-Width Image Promo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_250bd175_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_four_column_full_width_image_promo_vue__ = __webpack_require__(1488);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_250bd175_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_four_column_full_width_image_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-four-column-full-width-image-promo')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Four-Column Full-Width Image Promo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_616e03c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_column_full_width_promo_vue__ = __webpack_require__(1490);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_616e03c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_column_full_width_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-three-column-full-width-promo')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Three-Column Full-Width Promo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0a56512_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_third_link_component_vue__ = __webpack_require__(1492);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0a56512_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_third_link_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Two-Third Link Component")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('aha-two-third-link-component')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_382e1912_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_email_promo_vue__ = __webpack_require__(1494);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_382e1912_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_width_email_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-full-width-email-promo')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Full-Width Email")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e80503c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_half_image_half_copy_promo_vue__ = __webpack_require__(1496);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e80503c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_half_image_half_copy_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-half-image-half-copy-promo')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Half-Image Half-Copy Promo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7f692bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_half_image_half_copy_collapse_vue__ = __webpack_require__(1498);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7f692bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_half_image_half_copy_collapse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('aha-half-image-half-copy-collapse')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Half-Image Half-Copy Collapse")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e2843c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_one_column_content_width_promo_vue__ = __webpack_require__(1500);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e2843c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_one_column_content_width_promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"l-promo__row"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"container container-fluid"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('aha-one-column-content-width-promo')],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"l-promo__row"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"container container-fluid"},[_c('aha-component',{attrs:{"title":"Event"}},[_c('aha-event-promo')],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("One-Column Content-Width Promo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e993c910_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_instructions_vue__ = __webpack_require__(1502);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e993c910_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_instructions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Recipe Instructions")]),_vm._v(" "),_c('aha-recipe-instructions')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9743dc5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_impacted_data_vue__ = __webpack_require__(1504);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9743dc5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_impacted_data_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Impacted Data")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('impacted-data')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27e6886d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_nutritional_facts_vue__ = __webpack_require__(1506);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27e6886d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_nutritional_facts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Nutritional Facts")]),_vm._v(" "),_c('aha-nutritional-facts')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd162642_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_quick_tips_vue__ = __webpack_require__(1508);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd162642_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_quick_tips_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Recipe Quick Tips")]),_vm._v(" "),_c('aha-quick-tips')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_413a610c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_social_vue__ = __webpack_require__(1510);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_413a610c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_social_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Recipe Social")]),_vm._v(" "),_c('div',{staticClass:"c-recipe"},[_c('aha-recipe-gigya-addthis')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c54d8942_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Student_code_vue__ = __webpack_require__(1512);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c54d8942_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Student_code_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Student Code")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('aha-student-code')],1),_vm._v(" "),_c('aha-component',{attrs:{"title":"Invalid"}},[_c('aha-student-code-invalid')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_590cd92e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_speed_bump_vue__ = __webpack_require__(1514);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_590cd92e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_speed_bump_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Speed Bump")]),_vm._v(" "),_c('ul',{staticClass:"nav flex-column"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.promotion",modifiers:{"promotion":true}}],attrs:{"variant":"primary"}},[_vm._v("Open Promotion Modal")]),_vm._v(" "),_c('b-modal',{attrs:{"id":"promotion","centered":"","size":"lg","hide-footer":"","hide-header":"","title":"Large Modal"}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"l-generic__col col-md-12 p-0"},[_c('div',{staticClass:"c-promotion__card d-none d-md-block h-theme--black h-text-contrast"},[_c('div',{staticClass:"c-article-card__background h-placeholder-image h-placeholder-image--16-9"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://picsum.photos/700/250/?random'),expression:"'https://picsum.photos/700/250/?random'"}],attrs:{"src":"https://picsum.photos/700/250/?random"}}),_vm._v(" "),_c('b-btn-close',{staticClass:"c-modal--promotion__close btn btn-dark",on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'promotion', $event.target)}}},[_vm._v("×")])],1),_vm._v(" "),_c('div',{staticClass:"d-block"},[_c('h2',{staticClass:"c-promotion__title w-100 text-center m-0"},[_vm._v("\n                                        DON'T MISS A BEAT:   \n                                        ")])])])])]),_vm._v(" "),_c('b-row',{attrs:{"align-v":"center"}},[_c('div',{staticClass:"col-sm-8"},[_c('p',{staticClass:"h4"},[_vm._v("Donate now to help more families impacted by heart disease and stroke enjoy more of the holiday season TOGETHER.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('b-btn',{attrs:{"variant":"primary btn-round btn-lg float-right"}},[_vm._v("Donate Now")])],1)])],1)],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link twoClick",attrs:{"href":"http://google.com"}},[_vm._v("Google link with speedbump")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link twoClick",attrs:{"href":"http://google.com","data-tracking":"{'name':'Testing Event Name','data':'Testing Event Data','text':'Testing Event Text',  'goalId':'{2E8E29CC-9817-4D35-B894-0CCA5A9A37FD}'}"}},[_vm._v("Google link with speedbump + Goal")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"http://google.com"}},[_vm._v("Google link without speedbump")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"https://sitecore93dev.heart.org/en/healthy-living","target":"_blank","data-tracking":"{'name':'Testing Event Name','data':'Testing Event Data','text':'Testing Event Text',  'goalId':'{2E8E29CC-9817-4D35-B894-0CCA5A9A37FD}'}","title":"Healthy For Good"}},[_vm._v(" Google link without speedbump + Goal")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48698481_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sso_intercept_vue__ = __webpack_require__(1516);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48698481_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sso_intercept_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("SSO Intercept")]),_vm._v(" "),_c('ul',{staticClass:"nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"http://google.com"}},[_vm._v("Standard link")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"https://sso.heart.org"}},[_vm._v("Link to SSO")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41a4957c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_affiliate_nav_vue__ = __webpack_require__(1518);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41a4957c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_affiliate_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Affiliate Nav")]),_vm._v(" "),_c('aha-affiliate-nav')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6763f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sitecore_forms_vue__ = __webpack_require__(1520);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6763f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sitecore_forms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Sitecore Forms")]),_vm._v(" "),_c('aha-sitecore-forms')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c4a7909_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_symptoms_vue__ = __webpack_require__(1522);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c4a7909_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_symptoms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('asa-stroke-symptoms')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Stroke Symptoms")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6466c7c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_promo_modal_vue__ = __webpack_require__(1524);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6466c7c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_promo_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('p',[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('ahaDonationPromoModal'),expression:"'ahaDonationPromoModal'"}],attrs:{"href":"#"}},[_vm._v(" Open Modal")])]),_vm._v(" "),_c('aha-donation-modal',{ref:"DonationModal",attrs:{"name":"donation-modal","show-modal":true,"interval":0,"endpoint":"/aha-service/promo/PromotionalModalClosed","data-tracking":"{'name':'test','data':'test','text':'test', 'goalId':'{3705F960-B289-478A-81F5-62E612C60C99}'}","translations":{
      btn: 'Donate Now',
      title: 'DON\'T MISS A BEAT HERE IS A SECOND LINE OF TEXT',
      description:
        'Donate now to help more families impacted by heart disease and stroke enjoy more of the holiday season TOGETHER.',
      image: '',
      video: 'https://www.youtube.com/embed/zpOULjyy-n8?rel=0',
      url: 'url_to_make_donation',
      btn2: 'Donate Monthly',
      url2: 'url_to_make_monthly_donation',
      btnTheme: 'red',
      btnTheme2: 'white'
    }}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Promo Modal")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_session_timeout_vue__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_session_timeout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_session_timeout_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_session_timeout_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_session_timeout_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7ec7c56_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_session_timeout_vue__ = __webpack_require__(1526);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_session_timeout_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7ec7c56_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_session_timeout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.ahaTimeoutModal",modifiers:{"ahaTimeoutModal":true}}],staticClass:"btn btn-lg btn-danger btn-round"},[_vm._v("\n        Trigger\n        Session Timeout Modal\n      ")]),_vm._v(" "),_c('div',[_vm._v(" ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Session expires in "+_vm._s(_vm.value))]),_vm._v(" "),_c('aha-session-timeout-modal',{ref:"session-modal",attrs:{"name":"session-modal","endpoint":"http://www.mocky.io/v2/5d3a10e22f00005b006ebfa1","redirect":"http://localhost:3000/#/","session-time":0.25,"translations":{
              'btnyeslabel': 'Continue',
              'btnnolabel': 'No',
              'heading': 'Session Timed Out', 
              'subheading': 'Your session is about to time out. Do you wish to continue?',
          }}}),_vm._v(" "),_vm._m(2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-listing-header"},[_c('div',{staticClass:"c-listing-header__cta-container"},[_c('h2',{staticClass:"c-listing-header__heading"},[_vm._v("Session Timeout Modal")]),_vm._v(" "),_c('span',{staticClass:"h-flex"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Notify user of session timeout before actual session timeout with a modal")]),_vm._v(" "),_c('li',[_vm._v("Buttons continue cancel")]),_vm._v(" "),_c('li',[_vm._v("Extend session by pinging the server")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_vm._v("      "),_vm._v("\n    <aha-session-timeout-modal\n      @update = \"timerUpdate\" // udpate is for local testing, updating the timer visually\n      ref=\"session-modal\"\n      name=\"session-modal\"\n      endpoint = \"some url to ping to\"\n      redirect = \"redirect url when user click on No\"\n      :sessionTime = 18 //in minutes\n      :translations=\"{\n              'btnyeslabel': 'Yes',\n              'btnnolabel': 'No',\n              'heading': 'Session Timed Out', \n              'subheading': 'Your session is about to time out. Do you wish to continue?',\n          }\"\n    ></aha-session-timeout-modal>\n    "),_vm._v("\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_785bc500_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_column_paragraph_vue__ = __webpack_require__(1528);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_785bc500_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_two_column_paragraph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Two Column Paragraph")])]),_vm._v(" "),_c('div',{staticClass:"container contaier-fluid"},[_c('div',{staticClass:"h-columns--two"},[_c('p',[_vm._v("The six cardiologists who founded the American Heart Association in 1924 would be amazed.")]),_vm._v(" "),_c('p',[_vm._v("From humble beginnings, the AHA has grown into the nation’s oldest and largest voluntary organization dedicated to fighting heart disease and stroke. A shared focus on cardiovascular health unites our more than 33 million volunteers and\n      supporters as well as our more than 3,400 employees. "),_c('a',{attrs:{"href":"/en/about-us/history-of-the-american-heart-association"}},[_vm._v("Learn more about our impact over time")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Heart disease is the No. 1 killer worldwide, and stroke ranks second globally. Even when those conditions don’t result in death, they cause disability and diminish quality of life. We want to see a world free of cardiovascular diseases\n      and stroke.")]),_vm._v(" "),_c('p',[_vm._v("Our size and scope let us have real impact. We have invested more than $4.1 billion in research, more than any U.S. nonprofit organization. "),_c('a',{attrs:{"href":"/en/about-us/funded-research-breakthroughs"}},[_vm._v("Learn more about our life-changing funded\n      research breakthroughs")]),_vm._v(".")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_selector_vue__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_selector_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_selector_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_selector_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc1a1fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_selector_vue__ = __webpack_require__(1530);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_selector_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc1a1fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Card")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('aha-card-selector',{attrs:{"title":"Ready to volunteer?","data":"","buttonText":"","buttonRemoveText":"","description":"Take a look at these opportunities and make your selections."},scopedSlots:_vm._u([{key:"filters",fn:function(){return [_c('aha-card-selector-filter',{attrs:{"title":"Interested in Youth Volunteer?","description":"Made for ages 18 & under","name":"youth"}})]},proxy:true},{key:"actions",fn:function(props){return [_c('a',{staticClass:"btn btn-round btn-outline-dark mr-3",attrs:{"src":"link","target":"_blank","href":"https://sitecoredev.heart.org/en/help-me-choose"}},[_vm._v("\n                    Help Me Choose\n                ")]),_vm._v(" "),(props.isFiltered('youth'))?_c('a',{staticClass:"btn btn-primary btn-round",class:{ 'disabled': !props.valid },attrs:{"href":"/en/demos/volunteer-form/consent"},on:{"click":function($event){$event.preventDefault();return props.submit($event)}}},[_vm._v("\n                    Next\n                ")]):_c('a',{staticClass:"btn btn-primary btn-round",class:{ 'disabled': !props.valid },attrs:{"href":"/en/demos/volunteer-form/your-info"},on:{"click":function($event){$event.preventDefault();return props.submit($event)}}},[_vm._v("\n                    Next\n                ")])]}}])},[_vm._v(" "),_c('aha-selection-card',{attrs:{"id":"{27822E14-B366-43C3-A3CB-EC442AEC22F7}","title":"Advocate for Healthcare","img":"https://sitecoredev.heart.org/-/media/images/volunteer-opportunities/voting.png?h=200&w=266&hash=3C626A776B12C6D65AF2C6B47A1DB480A5F0BE83","description":"Description","flags":"adults","categoryTitle":"Hands only CPR","mediaLink":"","downloadLink":""}}),_vm._v(" "),_c('aha-selection-card',{attrs:{"id":"{DD4B4F54-F12E-489B-95FE-2EBCBC1ABB29}","title":"Advocate for Change","img":"https://sitecoredev.heart.org/-/media/images/volunteer-opportunities/voting.png?h=200&w=266&hash=3C626A776B12C6D65AF2C6B47A1DB480A5F0BE83","description":"Description","flags":"adults","categoryTitle":"Workplace Health Solutions","mediaLink":"","downloadLink":""}}),_vm._v(" "),_c('aha-selection-card',{attrs:{"id":"{5EBE375B-9E65-42F3-A035-BFCB07A12466}","title":"Become a Heart Walk Hero","img":"https://sitecoredev.heart.org/-/media/images/volunteer-opportunities/imagination.png?h=200&w=250&hash=E24C1F60810D8C6E0A31E73E8A239723272BE3A7","description":"Description","flags":"adults","categoryTitle":"Heart Walk","mediaLink":"","downloadLink":""}}),_vm._v(" "),_c('aha-selection-card',{attrs:{"id":"{802DF99C-4A49-4740-985D-5B67F110CEF7}","title":"Host a fundraiser","img":"https://sitecoredev.heart.org/-/media/images/volunteer-opportunities/wall_post.png?h=200&w=274&hash=5A2988A77F04B10FC26CB128B9A14CD02F3F4571","description":"Description","flags":"adults","categoryTitle":"Fundraiser","mediaLink":"","downloadLink":""}}),_vm._v(" "),_c('aha-selection-card',{attrs:{"id":"{560173C2-053D-40D6-848B-63F55578A0CE}","title":"Help Women in Your Community Live Healthier Lives","img":"https://sitecoredev.heart.org/-/media/images/health-topics/congenital-heart-defects/happy-young-father-looking-with-tenderness-at-his-pjbdgt2.jpg?h=1125&w=2000&hash=31FD8EDB57796AC461BD6AF9BCA56A85DF4E54B0","description":"Description","flags":"adults","categoryTitle":"Workplace Health Solutions","mediaLink":"","downloadLink":""}}),_vm._v(" "),_c('aha-selection-card',{attrs:{"id":"{F3892D66-5889-47AD-91B9-E1B80BBC1E9E}","title":"Join the GRFW health","img":"https://sitecoredev.heart.org/-/media/images/professional/quality-improvement/black-female-doctor-leading-medical-team-pv89ysg-copy.jpg?h=1272&w=2000&hash=FD652FDAF85F3331AB6278666B154EEA96A54505","description":"Description","flags":"adults","categoryTitle":"Workplace Health Solutions","mediaLink":"","downloadLink":""}}),_vm._v(" "),_c('aha-selection-card',{attrs:{"id":"{35771D0F-8FCA-42FA-9940-BEAE581D6E9D}","title":"Teach Healthy Eating Habits to Your Community","img":"https://sitecoredev.heart.org/-/media/images/istock_000014401432_full.jpg?h=2799&w=4201&hash=4AB06532757A888F056BF1D0D63B9FC02BA4BA11","description":"Description","flags":"adults","categoryTitle":"Hands only CPR","mediaLink":"","downloadLink":""}}),_vm._v(" "),_c('aha-selection-card',{attrs:{"id":"{0DEB1773-24BA-4674-B1F3-ADC03951237F}","title":"Start a High School Service Hub ML","img":"https://sitecoredev.heart.org/-/media/images/professional/quality-improvement/doctorwithstethoscopep3h5abz.jpg?h=1125&w=2000&hash=85374FA1F8549FACF42BB23FBAEBE92FCB935F2C","description":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid ut expedita quas voluptas praesentium tenetur eligendi et accusamus, at similique? Neque quidem accusamus voluptatem commodi ea inventore repellat culpa soluta.","flags":"youth","categoryTitle":"Heart Walk","mediaLink":"https://sitecoredev.heart.org/en/help-me-choose","mediaLinkDescription":"How to Hands-Only CPR <br> 1:23 min","mediaTitle":"Media Title","mediaText":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid ut expedita quas voluptas praesentium tenetur eligendi et accusamus, at similique? Neque quidem accusamus voluptatem commodi ea inventore repellat culpa soluta.","downloadLink":"","downloadButtonText":""}}),_vm._v(" "),_c('aha-selection-card',{attrs:{"id":"{C70DB700-CD08-4282-B08D-5FD892E2F60E}","title":"Learn to save lives DL","img":"https://sitecoredev.heart.org/-/media/images/volunteer-opportunities/super_woman.png?h=201&w=224&hash=F371DE7C2E494960F76232ECACE65B7C56FE7E91","description":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid ut expedita quas voluptas praesentium tenetur eligendi et accusamus, at similique? Neque quidem accusamus voluptatem commodi ea inventore repellat culpa soluta.","flags":"youth","categoryTitle":"Fundraiser","mediaTitle":"Media Title","mediaText":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid ut expedita quas voluptas praesentium tenetur eligendi et accusamus, at similique? Neque quidem accusamus voluptatem commodi ea inventore repellat culpa soluta.","mediaLink":"","mediaLinkDescription":"","downloadLink":"https://sitecoredev.heart.org/en/help-me-choose","downloadButtonText":"Download Your Toolkit"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('form',[_c('input',{directives:[{name:"from-store",rawName:"v-from-store:card-selector",value:('selectedIds'),expression:"'selectedIds'",arg:"card-selector"}],attrs:{"type":"hidden","name":"selectedOpps"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('aha-card-viewer-text',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var count = ref.count;
return [_c('h1',[_vm._v("GREAT! You choose "+_vm._s(count)+" "+_vm._s(_vm._f("pluralize")('Opportunity',count)))])]}}])})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('aha-switch-input',{attrs:{"aria-describedby":"hello","name":"democollapse","toggle-for":"democollapse"}}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fieldset',[_c('legend',{staticClass:"c-switch-input-legend",attrs:{"id":"hello"}},[_vm._v("\n                    Are you active military or a military veteran?\n                ")]),_vm._v(" "),_c('br',{staticClass:"d-lg-none"}),_vm._v(" "),_c('aha-switch-input',{attrs:{"name":"ActiveMilitary","aria-describedby":"hello","toggle-for":"ActiveMilitaryNarrative","on-text":"Yes","off-text":"No"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fieldset',[_c('legend',{staticClass:"input-switch-legend",attrs:{"id":"hello"}},[_vm._v("\n                    Are you active military or a military veteran?\n                ")]),_vm._v(" "),_c('br',{staticClass:"d-lg-none"}),_vm._v(" "),_c('aha-switch-input',{attrs:{"name":"ActiveMilitary","aria-describedby":"hello","toggle-for":"ActiveMilitaryNarrative","on-text":"Yes","off-text":"No"}})],1)]),_vm._v(" "),_c('aha-collapsable-view',{attrs:{"show":false,"name":"democollapse"}},[_c('aha-card-viewer-text',[_c('h1',[_vm._v("GREAT! You choose {count} Opportunities")])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-5",attrs:{"styles":"background: 'green'; height: 685px;"}},[_c('aha-card-viewer',{attrs:{"mode":"stack"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",attrs:{"styles":"background: 'yellow';"}},[_c('aha-card-viewer',{attrs:{"mode":"list"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',[_vm._v("bottom")]),_vm._v(" "),_c('input',{directives:[{name:"aha-mask",rawName:"v-aha-mask",value:('phone'),expression:"'phone'"}],attrs:{"type":"text"}}),_vm._v(" "),_c('input',{directives:[{name:"aha-mask",rawName:"v-aha-mask",value:('date'),expression:"'date'"}],attrs:{"type":"text"}})])]),_vm._v(" "),_c('aha-modal',{ref:"loadingModal",staticClass:"c-loadingModal",attrs:{"size":"md","id":"loadingModal","hide-footer":"","hide-header-close":"","no-close-on-esc":"","no-close-on-backdrop":"","centered":"","lazy":""}},[_c('template',{slot:"modal-header"},[_c('div',{staticClass:"c-loadingModal__heading"},[_vm._v("Submitting Form")])]),_vm._v(" "),_c('div',{staticClass:"loader-container show",attrs:{"role":"alert","aria-live":"assertive"}},[_c('div',{staticClass:"loader"},[_vm._v("Loading...")])]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("\n            Please be patient while we are submitting your form.\n        ")])],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('span',{staticClass:"icon icon-error",attrs:{"aria-hidden":"true"}},[_vm._v("!")]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Error:")]),_vm._v("\n                Enter a valid email address\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32192e3e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_switch_input_vue__ = __webpack_require__(1532);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32192e3e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_switch_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Toggle Switch")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label',{attrs:{"id":"input1-label","for":"input1"}},[_vm._v("Toggle 1:")]),_vm._v(" "),_c('aha-switch-input',{attrs:{"name":"input1","aria-labelledby":"input1-label"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a54f64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_cta_vue__ = __webpack_require__(1534);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a54f64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_cta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Button CTA")]),_vm._v(" "),_c('h2',[_vm._v("Rounded")]),_vm._v(" "),_c('div',{staticClass:"bg-light p-4"},[_c('div',{staticClass:"m-4"},[_c('div',{staticClass:"d-flex justify-content-start"},[_c('a',{staticClass:"btn btn-round btn-primary",attrs:{"href":"#"}},[_vm._v("btn-primary")])]),_vm._v(" "),_c('br'),_vm._v("Default button\n            ")]),_vm._v(" "),_c('div',{staticClass:"m-4"},[_c('div',{staticClass:"d-flex justify-content-start"},[_c('a',{staticClass:"btn btn-round btn-outline-dark",attrs:{"href":"#"}},[_vm._v("btn-outline-dark")])]),_vm._v(" "),_c('br'),_vm._v("Change out "),_c('code',[_vm._v("btn-primary")]),_vm._v(" > "),_c('code',[_vm._v("btn-outline-dark")])])]),_vm._v(" "),_c('div',{staticClass:"bg-dark p-4 text-light"},[_c('div',{staticClass:"m-4"},[_c('div',{staticClass:"d-flex justify-content-start"},[_c('a',{staticClass:"btn btn-round btn-light",attrs:{"href":"#"}},[_vm._v("btn-light")])]),_vm._v(" "),_c('br'),_vm._v("Change out "),_c('code',[_vm._v("btn-primary")]),_vm._v(" > "),_c('code',[_vm._v("btn-light")])]),_vm._v(" "),_c('div',{staticClass:"m-4"},[_c('div',{staticClass:"d-flex justify-content-start"},[_c('a',{staticClass:"btn btn-round btn-outline-light",attrs:{"href":"#"}},[_vm._v("btn-outline-light")])]),_vm._v(" "),_c('br'),_vm._v("Change out "),_c('code',[_vm._v("btn-primary")]),_vm._v(" > "),_c('code',[_vm._v("btn-outline-light")])])]),_vm._v(" "),_c('h2',{staticClass:"mt-5"},[_vm._v("Square")]),_vm._v(" "),_c('p',[_vm._v("Square buttons mainly used on PHD")]),_vm._v(" "),_c('div',{staticClass:"bg-light p-4"},[_c('div',{staticClass:"d-flex justify-content-start"},[_c('a',{staticClass:"btn btn-primary",attrs:{"href":"#"}},[_vm._v("btn-default")])]),_vm._v("\n            For Square only remove the "),_c('code',[_vm._v("btn-round")]),_vm._v(" in class\n        ")]),_vm._v(" "),_c('h2',{staticClass:"mt-5"},[_vm._v("Button Alignments")]),_vm._v(" "),_c('h3',[_vm._v("Alignment Examples")]),_vm._v(" "),_c('div',{staticClass:"bg-light p-4"},[_c('div',{},[_c('a',{staticClass:"btn btn-primary btn-round",attrs:{"href":"#"}},[_vm._v("Left Button")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"btn btn-primary btn-round",attrs:{"href":"#"}},[_vm._v("Center Button")])]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('a',{staticClass:"btn btn-primary btn-round",attrs:{"href":"#"}},[_vm._v("Right Button")])]),_vm._v(" "),_c('p')]),_vm._v(" "),_c('h3',[_vm._v("Margin Examples")]),_vm._v(" "),_c('div',{staticClass:"bg-light p-4"},[_c('div',{staticClass:"text-center m-1"},[_c('a',{staticClass:"btn btn-primary btn-round",attrs:{"href":"#"}},[_vm._v("Margin 1")])]),_vm._v(" "),_c('div',{staticClass:"text-center m-2"},[_c('a',{staticClass:"btn btn-primary btn-round",attrs:{"href":"#"}},[_vm._v("Margin 2")])]),_vm._v(" "),_c('div',{staticClass:"text-center m-3"},[_c('a',{staticClass:"btn btn-primary btn-round",attrs:{"href":"#"}},[_vm._v("Margin 3")])]),_vm._v(" "),_c('div',{staticClass:"text-center m-4"},[_c('a',{staticClass:"btn btn-primary btn-round",attrs:{"href":"#"}},[_vm._v("Margin 4")])]),_vm._v(" "),_c('div',{staticClass:"text-center m-5"},[_c('a',{staticClass:"btn btn-primary btn-round",attrs:{"href":"#"}},[_vm._v("Margin 5")])]),_vm._v(" "),_c('p')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33ff0ce4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_accordion_vue__ = __webpack_require__(1536);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33ff0ce4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_accordion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('div',{staticClass:"container container-fluid"},[_c('aha-breadcrumb'),_vm._v(" "),_c('h1',{staticClass:"mb-5"},[_vm._v("Accordion")]),_vm._v(" "),_c('div',{staticClass:"l-phd"},[_c('div',{staticClass:"c-accordion"},[_c('div',{attrs:{"role":"tablist"}},[_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('accordion-1'),expression:"'accordion-1'"}],staticClass:"btn btn--select",attrs:{"block":"","variant":"plain"}},[_c('span',{staticClass:"section__label d-block"},[_vm._v("Section 1")]),_vm._v("\n                                Applicant\n                                ")])],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":"","id":"accordion-1","accordion":"group-1"}},[_c('b-card-body',[_c('ul',{},[_c('li',[_vm._v("Research Plan 8 Pages")]),_vm._v(" "),_c('li',[_vm._v("Biographical Sketch/Bibliography (5 pages)")]),_vm._v(" "),_c('li',[_vm._v("Resubmission Modifications (if applicable, 2 pages)")]),_vm._v(" "),_c('li',[_vm._v("Vertebrate Animal Subjects (if applicable, no page limit)")])])])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('accordion-2'),expression:"'accordion-2'"}],staticClass:"btn btn--select",attrs:{"block":"","variant":"plain"}},[_c('span',{staticClass:"section__label d-block"},[_vm._v("2018 Distinguished Scientist")]),_vm._v("\n                                Lawrence J. Appel, MD, MPH, FAHA\n                            ")])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-2","accordion":"group-1"}},[_c('b-card-body',[_c('p',[_vm._v("\n                            Dr. Appel is the C. David Molina Professor of Medicine and Director of the Welch Center for Prevention, Epidemiology and Clinical Research, a joint program of the Johns Hopkins University School of Medicine and the Bloomberg School of Public Health. Dr. Appel holds a primary faculty appointment in the Division of General Internal Medicine with joint appointments in Epidemiology, International Health, and Nursing. In addition, he directs the ProHealth Clinical Research Unit in West Baltimore. \n                            ")]),_vm._v(" "),_c('p',[_vm._v("\n                                The focus of Dr. Appel’s investigative career is the conduct of clinical, epidemiologic, and translational research pertaining to the prevention of high blood pressure, cardiovascular-kidney diseases, and other chronic conditions. He has conducted over 50 studies and published over 400 papers. Many of his research findings have had a substantial influence on health and health care policy. His principal lines of research are:\n                            ")]),_vm._v(" "),_c('p',[_vm._v("\n                                Dr. Appel has also been actively involved in shaping health care policy. He was a member of the 2005 and 2010 U.S. Dietary Guidelines Scientific Advisory Committees. For the American Heart Association, he has chaired its Nutrition Committee and its Council on Lifestyle and Cardiometabolic Health. He has served on several NIH and Institute of Medicine Committees and chaired the committee that set dietary reference intakes for sodium, potassium, and water. Among his awards are membership in the Association of American Physicians and the National Academy of Medicine (formerly Institute of Medicine).\n                            ")])])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('accordion-3'),expression:"'accordion-3'"}],staticClass:"btn btn--select",attrs:{"block":"","variant":"plain"}},[_c('span',{staticClass:"section__label d-block"},[_vm._v("Section 3")]),_vm._v("\n                                Accordion 3\n                            ")])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-3","accordion":"group-1"}},[_c('b-card-body',[_c('p',[_vm._v("Lorem ipsum dolor sit, amet consectetur adipisicing elit. Repudiandae obcaecati ducimus aliquam consequuntur qui vitae dolor quis, accusamus fugiat doloribus voluptate inventore quisquam itaque sint neque, temporibus rerum possimus ea.")])])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('accordion-4'),expression:"'accordion-4'"}],staticClass:"btn btn--select",attrs:{"block":"","variant":"plain"}},[_c('span',{staticClass:"section__label d-block"},[_vm._v("Section Header Title / Label")]),_vm._v("\n                                Accordion 4\n                            ")])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-4","accordion":"group-1"}},[_c('b-card-body',[_c('p',[_vm._v("Lorem ipsum dolor sit, amet consectetur adipisicing elit. Repudiandae obcaecati ducimus aliquam consequuntur qui vitae dolor quis, accusamus fugiat doloribus voluptate inventore quisquam itaque sint neque, temporibus rerum possimus ea.\n                            ")])])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('accordion-5'),expression:"'accordion-5'"}],staticClass:"btn btn--select",attrs:{"block":"","variant":"plain"}},[_vm._v("\n                                Unstyled List Example, no label\n                                ")])],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":"","id":"accordion-5","accordion":"group-1"}},[_c('b-card-body',[_c('ul',{staticClass:"list-unstyled"},[_c('li',{staticClass:"my-3"},[_c('strong',[_c('a',{attrs:{"href":"#"}},[_vm._v("Research Plan 8 Pages")])])]),_vm._v(" "),_c('li',{staticClass:"my-3"},[_c('strong',[_c('a',{attrs:{"href":"#"}},[_vm._v("Vertebrate Animal Subjects (if applicable, no page limit)")])])]),_vm._v(" "),_c('li',{staticClass:"my-3"},[_c('strong',[_c('a',{attrs:{"href":"#"}},[_vm._v("Resubmission Modifications (if applicable, 2 pages)")])])]),_vm._v(" "),_c('li',{staticClass:"my-3"},[_c('strong',[_c('a',{attrs:{"href":"#"}},[_vm._v("Biographical Sketch/Bibliography (5 pages)")])])])])])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('accordion-6'),expression:"'accordion-6'"}],staticClass:"btn btn--select",attrs:{"block":"","variant":"plain"}},[_vm._v("\n                                Unstyled List Example, no label #2\n                                ")])],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":"","id":"accordion-6","accordion":"group-1"}},[_c('b-card-body',[_c('ul',{staticClass:"list-unstyled"},[_c('li',{staticClass:"my-3"},[_c('strong',[_c('a',{attrs:{"href":"#"}},[_vm._v("Research Plan 8 Pages")])])]),_vm._v(" "),_c('li',{staticClass:"my-3"},[_c('strong',[_c('a',{attrs:{"href":"#"}},[_vm._v("Vertebrate Animal Subjects (if applicable, no page limit)")])])]),_vm._v(" "),_c('li',{staticClass:"my-3"},[_c('strong',[_c('a',{attrs:{"href":"#"}},[_vm._v("Resubmission Modifications (if applicable, 2 pages)")])])]),_vm._v(" "),_c('li',{staticClass:"my-3"},[_c('strong',[_c('a',{attrs:{"href":"#"}},[_vm._v("Biographical Sketch/Bibliography (5 pages)")])])])])])],1)],1)],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3362d5bf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_community_science_news_vue__ = __webpack_require__(1538);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3362d5bf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_community_science_news_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Community Science News")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('community-science-news')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aebc95c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_cta_bar_vue__ = __webpack_require__(1540);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aebc95c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_cta_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("PHD Bar")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('cta-bar')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44940bc4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_cta_bar_flexible_vue__ = __webpack_require__(1542);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44940bc4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_cta_bar_flexible_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Flexible CTA Bar")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('aha-component',{attrs:{"title":"Flexible CTA Bar"}},[_c('cta-bar-flexible')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24750e7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_image_pdf_accessible_links_vue__ = __webpack_require__(1544);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24750e7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_image_pdf_accessible_links_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Image with PDF and Accessible Links")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('image-pdf-accessible-links')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b4ec8ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_card_vue__ = __webpack_require__(1546);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b4ec8ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("PHD Card")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('div',{staticClass:"l-generic row mb-5"},[_c('div',{staticClass:"l-generic__col col-12 col-md-4"},[_c('phd-card')],1),_vm._v(" "),_c('div',{staticClass:"l-generic__col col-12 col-md-4"},[_c('phd-card')],1),_vm._v(" "),_c('div',{staticClass:"l-generic__col col-12 col-md-4"},[_c('phd-card')],1)]),_vm._v(" "),_c('div',{staticClass:"l-generic row mb-5"},[_c('div',{staticClass:"l-generic__col col-12 col-md-4"},[_c('phd-card')],1),_vm._v(" "),_c('div',{staticClass:"l-generic__col col-12 col-md-4"},[_c('phd-card')],1),_vm._v(" "),_c('div',{staticClass:"l-generic__col col-12 col-md-4"},[_c('phd-card')],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07fc24b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_council_vue__ = __webpack_require__(1548);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07fc24b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_council_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("PHD Council")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('phd-council')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203958c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_main_nav_vue__ = __webpack_require__(1550);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203958c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_main_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Main Nav")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('phd-main-nav')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa9c7846_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_meeting_vue__ = __webpack_require__(1552);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa9c7846_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_meeting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("PHD Meeting")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('div',{staticClass:"l-main"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('phd-meeting')],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1df0735c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_need_to_know_vue__ = __webpack_require__(1554);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1df0735c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_need_to_know_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Need To Know")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('need-to-know')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a450bcc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_new_window_hyperlink_vue__ = __webpack_require__(1556);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a450bcc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_new_window_hyperlink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("New Window Hyperlink")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('new-window-hyperlink')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e78c464_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_non_partner_connections_vue__ = __webpack_require__(1558);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e78c464_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_non_partner_connections_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Non-Partner Connections")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('non-partner-connections')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76497151_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partner_benefits_vue__ = __webpack_require__(1560);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76497151_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partner_benefits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Partner Benefits")]),_vm._v(" "),_c('aha-component',[_c('partner-benefits')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d4c2e92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_article_link_vue__ = __webpack_require__(1562);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d4c2e92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_article_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("PHD Article Link")]),_vm._v("\ns\n        "),_c('aha-component',{attrs:{"title":"Default"}},[_c('phd-article-link')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_clinical_trial_component_vue__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_clinical_trial_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_clinical_trial_component_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_clinical_trial_component_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_clinical_trial_component_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cb302f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_clinical_trial_component_vue__ = __webpack_require__(1564);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_clinical_trial_component_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cb302f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_clinical_trial_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Clinical Trial Table/Component")]),_vm._v(" "),_c('clinical-trial-component',{attrs:{"trial-content":_vm.clinicalTrialDemoData1}},[_c('template',{slot:"results"},[_c('div',{staticClass:"clinical-trial__text-block px-md-2"},[_c('div',{staticClass:"row-description"},[_c('strong',[_vm._v("Results")])]),_vm._v(" "),_c('span',{staticClass:"row-description"},[_c('p',[_vm._v("\n                        Major CVD events and total invasive cancer were not\n                        significantly reduced by Omega-3 or vitamin D3.\n                        Omega-3 significantly reduced total MI, especially\n                        in African Americans and those with lower fish\n                        intake.\n                    ")]),_vm._v(" "),_c('br')])])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42bf834e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_communities_education_vue__ = __webpack_require__(1566);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42bf834e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_communities_education_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("PHD Communities Education - Tab")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('div',{staticClass:"l-main"},[_c('aha-component',{attrs:{"title":""}},[_c('communities-education')],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dad31d64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_device_drug_alerts_vue__ = __webpack_require__(1568);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dad31d64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_device_drug_alerts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Device & Drug Alerts")]),_vm._v(" "),_c('aha-component',{attrs:{"title":""}},[_c('device-drug-alerts')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_daily_rate_comparison_vue__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_daily_rate_comparison_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_daily_rate_comparison_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_daily_rate_comparison_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_daily_rate_comparison_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e368492_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_daily_rate_comparison_vue__ = __webpack_require__(1570);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_daily_rate_comparison_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e368492_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_daily_rate_comparison_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Membership Rate Comparison")]),_vm._v(" "),_c('aha-component',{attrs:{"title":""}},[_c('daily-rate-comparison',{attrs:{"tables":_vm.demoData}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55ccd25e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_institutional_tier_vue__ = __webpack_require__(1572);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55ccd25e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_institutional_tier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Institutional Tier Selector")]),_vm._v(" "),_c('institutional-tier')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_left_nav_demo_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_left_nav_demo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_left_nav_demo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_left_nav_demo_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_left_nav_demo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d1c2234_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_left_nav_demo_vue__ = __webpack_require__(1574);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_left_nav_demo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d1c2234_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_left_nav_demo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"page-heading mb-3"},[_vm._v("PHD Left Navigation Demo")]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12 col-md-4"},[_c('phd-left-nav',{attrs:{"sc-data":_vm.demoData}})],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4"},[_c('phd-left-nav',{attrs:{"sc-data":[{target: '_blank',text: 'I <3 Kittens',url: 'https://www.eyebleach.me/kittens/'},{active: true,target: '_blank',text: 'Cats!',url: 'https://www.eyebleach.me/cats/'},{target: '_blank',text: 'I like dogs Dogs',url: 'https://www.eyebleach.me/dogs/'},{target: '_blank',text: 'Show me some nature and I shall tell you how pretty it is',url: 'https://www.eyebleach.me/nature/'},{target: '_blank',text: 'I wanna go fast!',url: 'https://www.eyebleach.me/faster/'},{text: 'No target on this one',url: 'https://giantbomb.com'}
                ]}})],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-8"},[_c('h2',[_vm._v("Fake content simulating rich text")]),_vm._v(" "),_c('p',[_vm._v("Navigation on the left is an example using variable assigned data.")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Temporibus fugit quaerat facere sapiente vel, alias enim dolor reiciendis cupiditate est non nostrum asperiores provident labore voluptatum voluptatem dolorum. Sint, sed.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-8"},[_c('h2',[_vm._v("Fake content simulating rich text")]),_vm._v(" "),_c('p',[_vm._v("Navigation on the left is an example using inline assigned data.")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Temporibus fugit quaerat facere sapiente vel, alias enim dolor reiciendis cupiditate est non nostrum asperiores provident labore voluptatum voluptatem dolorum. Sint, sed.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_membership_rate_comparison_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_membership_rate_comparison_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_membership_rate_comparison_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_membership_rate_comparison_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_membership_rate_comparison_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_153540a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_membership_rate_comparison_vue__ = __webpack_require__(1576);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_membership_rate_comparison_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_153540a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_membership_rate_comparison_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Membership Rate Comparison")]),_vm._v(" "),_c('aha-component',{attrs:{"title":""}},[_c('membership-rate-comparison',{attrs:{"table-data":_vm.demoData}},[_c('template',{slot:"postTableContent"},[_c('div',{staticClass:"flex-table__content-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"rate-comparison__disclaimer-title"},[_vm._v("Title here is optional")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 rate-comparison__disclaimer-content"},[_c('p',[_vm._v("*Verification of Student/Trainee status is required. Please see \"Membership Discounts\" below for details."),_c('br'),_c('strong',[_vm._v("Gold Package")]),_vm._v(" includes online access to Stroke OnDemand™ – slides with synchronized audio from any computer, tablet or smartphone. (Hard Drive purchase available for additional $60)")])])])])])],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c6e7a70_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_overall_journal_vue__ = __webpack_require__(1578);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c6e7a70_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_overall_journal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Overall Journal")]),_vm._v(" "),_c('aha-component',{attrs:{"title":""}},[_c('overall-journal')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a1834d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_pro_vol_search_vue__ = __webpack_require__(1580);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a1834d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_pro_vol_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',[_vm._v("Hello")]),_vm._v(" "),_c('pro-vol-search')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f2a114_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_volunteer_search_vue__ = __webpack_require__(1582);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f2a114_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_volunteer_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Volunteer Search")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('div',{staticClass:"l-main"},[_c('aha-component',[_c('phd-volunteer-search')],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_386a96ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_top_nav_vue__ = __webpack_require__(1584);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_386a96ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_top_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Top Nav")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('phd-top-nav')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c39337_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_top_utility_nav_vue__ = __webpack_require__(1586);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c39337_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_top_utility_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Top Utility Nav")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('phd-top-utility-nav')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fd763c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_profile_vue__ = __webpack_require__(1588);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fd763c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("PHD Profile")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('phd-profile')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5bf4e4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_risk_calculator_vue__ = __webpack_require__(1590);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5bf4e4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_risk_calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phd"},[_c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("HCM Risk Calculator")]),_vm._v(" "),_c('risk-calculator')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9a350d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_science_volunteer_modal_vue__ = __webpack_require__(1592);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9a350d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_science_volunteer_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Science Volunteer Modal")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('phd-science-volunteer-modal',{attrs:{"modal-data":{
                isVolunteer: true,
                yesRedirect:'http://www.heart.org',
                title: 'Science Volunteer',
                message:'Are you interested in becoming a science volunteer?',
                yesLabel: 'Yes',
                noLabel: 'No'
            }}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e4da336_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_secondary_tertiary_nav_vue__ = __webpack_require__(1594);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e4da336_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_secondary_tertiary_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Secondary Tertiary Nav")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('secondary-tertiary-nav')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d71248_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_twitter_feed_vue__ = __webpack_require__(1596);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d71248_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_twitter_feed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Twitter Feed")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('twitter-feed')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_demo_science_news_box_vue__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_demo_science_news_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_demo_science_news_box_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_demo_science_news_box_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_demo_science_news_box_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdcdfb5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_demo_science_news_box_vue__ = __webpack_require__(1598);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_demo_science_news_box_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdcdfb5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_demo_science_news_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Science News Box - Default Example")]),_c('br'),_vm._v(" "),_c('science-news-box',{attrs:{"heading":_vm.demoHeading,"description":_vm.demoDescription,"link":_vm.demoLink}},[_c('p',[_vm._v("Any single component or content gets slid into a slot here, instead of this paragraph.  Perhaps a placehodler on the Sitecore/.Net side of things?")])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Science News Box - Science News Example")]),_c('br'),_vm._v(" "),_c('science-news-box',{attrs:{"heading":_vm.demoHeading2,"description":_vm.demoDescription2,"link":_vm.demoLink2}},[_c('science-news-recent-list')],1),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Science News Box - Science News Example with inline data")]),_c('br'),_vm._v(" "),_c('science-news-box',{attrs:{"heading":"inline title","heading-level":"1","description":"inline description","link":{text: 'inline text', url: 'https://google.com'}}},[_c('science-news-recent-list')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _page = __webpack_require__(81);

var _page2 = _interopRequireDefault(_page);

var _layoutNavigation = __webpack_require__(1600);

var _layoutNavigation2 = _interopRequireDefault(_layoutNavigation);

var _header = __webpack_require__(1602);

var _header2 = _interopRequireDefault(_header);

var _header3 = __webpack_require__(1604);

var _header4 = _interopRequireDefault(_header3);

var _footer = __webpack_require__(1606);

var _footer2 = _interopRequireDefault(_footer);

var _article = __webpack_require__(1608);

var _article2 = _interopRequireDefault(_article);

var _articleMobileNav = __webpack_require__(1610);

var _articleMobileNav2 = _interopRequireDefault(_articleMobileNav);

var _latestNews = __webpack_require__(1612);

var _latestNews2 = _interopRequireDefault(_latestNews);

var _newsListing = __webpack_require__(1614);

var _newsListing2 = _interopRequireDefault(_newsListing);

var _recipe = __webpack_require__(1616);

var _recipe2 = _interopRequireDefault(_recipe);

var _search = __webpack_require__(1618);

var _search2 = _interopRequireDefault(_search);

var _hospitalListLayout = __webpack_require__(1620);

var _hospitalListLayout2 = _interopRequireDefault(_hospitalListLayout);

var _hospitalMapLayout = __webpack_require__(1622);

var _hospitalMapLayout2 = _interopRequireDefault(_hospitalMapLayout);

var _impactMapLayout = __webpack_require__(1624);

var _impactMapLayout2 = _interopRequireDefault(_impactMapLayout);

var _searchResults = __webpack_require__(1626);

var _searchResults2 = _interopRequireDefault(_searchResults);

var _searchResultsCoveo = __webpack_require__(1628);

var _searchResultsCoveo2 = _interopRequireDefault(_searchResultsCoveo);

var _searchResultsCoveoError = __webpack_require__(1630);

var _searchResultsCoveoError2 = _interopRequireDefault(_searchResultsCoveoError);

var _recipeBox = __webpack_require__(1632);

var _recipeBox2 = _interopRequireDefault(_recipeBox);

var _recipePreferences = __webpack_require__(1634);

var _recipePreferences2 = _interopRequireDefault(_recipePreferences);

var _recipeCategories = __webpack_require__(1636);

var _recipeCategories2 = _interopRequireDefault(_recipeCategories);

var _survivorStory = __webpack_require__(1638);

var _survivorStory2 = _interopRequireDefault(_survivorStory);

var _ = __webpack_require__(1640);

var _2 = _interopRequireDefault(_);

var _3 = __webpack_require__(1642);

var _4 = _interopRequireDefault(_3);

var _strokeGroupFinder = __webpack_require__(1644);

var _strokeGroupFinder2 = _interopRequireDefault(_strokeGroupFinder);

var _strokeGroupDetail = __webpack_require__(1646);

var _strokeGroupDetail2 = _interopRequireDefault(_strokeGroupDetail);

var _hospitalmaps = __webpack_require__(1648);

var _hospitalmaps2 = _interopRequireDefault(_hospitalmaps);

var _thingsToKnow = __webpack_require__(366);

var _thingsToKnow2 = _interopRequireDefault(_thingsToKnow);

var _scienceNewsCommentary = __webpack_require__(1652);

var _scienceNewsCommentary2 = _interopRequireDefault(_scienceNewsCommentary);

var _scienceNewsArticleSummaryWildcard = __webpack_require__(1654);

var _scienceNewsArticleSummaryWildcard2 = _interopRequireDefault(_scienceNewsArticleSummaryWildcard);

var _linkedListViewAllPage = __webpack_require__(356);

var _linkedListViewAllPage2 = _interopRequireDefault(_linkedListViewAllPage);

var _phdHeader = __webpack_require__(1656);

var _phdHeader2 = _interopRequireDefault(_phdHeader);

var _phdMemberDashboardAccountSummary = __webpack_require__(354);

var _phdMemberDashboardAccountSummary2 = _interopRequireDefault(_phdMemberDashboardAccountSummary);

var _phdMembershipTablesExample = __webpack_require__(1658);

var _phdMembershipTablesExample2 = _interopRequireDefault(_phdMembershipTablesExample);

var _phdCommunityTabs = __webpack_require__(1660);

var _phdCommunityTabs2 = _interopRequireDefault(_phdCommunityTabs);

var _tierSelector = __webpack_require__(1662);

var _tierSelector2 = _interopRequireDefault(_tierSelector);

var _tierSelectorApi = __webpack_require__(1664);

var _tierSelectorApi2 = _interopRequireDefault(_tierSelectorApi);

var _institutionMembershipApi = __webpack_require__(1666);

var _institutionMembershipApi2 = _interopRequireDefault(_institutionMembershipApi);

var _programmingTable = __webpack_require__(1668);

var _programmingTable2 = _interopRequireDefault(_programmingTable);

var _phdMeetingsSciSessions = __webpack_require__(1670);

var _phdMeetingsSciSessions2 = _interopRequireDefault(_phdMeetingsSciSessions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var LayoutPages = [{
    path: '/pages',
    // You could also have named views at the top
    components: {
        'default': _page2['default'],
        'sidebar-nav': _layoutNavigation2['default']
    },
    children: [{
        path: '',
        redirect: 'header'
    }, {
        path: 'header-2023',
        component: _header2['default']
    }, {
        path: 'header',
        component: _header4['default']
    }, {
        path: 'footer',
        component: _footer2['default']
    }, {
        path: 'article',
        component: _article2['default']
    }, {
        path: 'article-mobile-nav',
        component: _articleMobileNav2['default']
    }, {
        path: 'latest-news',
        component: _latestNews2['default']
    }, {
        path: 'news-listing',
        component: _newsListing2['default']
    }, {
        path: 'recipe',
        component: _recipe2['default']
    }, {
        path: 'search',
        component: _search2['default']
    }, {
        path: 'hospital-list-layout',
        component: _hospitalListLayout2['default']
    }, {
        path: 'hospital-map-layout',
        component: _hospitalMapLayout2['default']
    }, {
        path: 'Impact-map-layout',
        component: _impactMapLayout2['default']
    }, {
        path: 'search-results',
        component: _searchResults2['default']
    }, {
        path: 'search-results-coveo',
        component: _searchResultsCoveo2['default']
    }, {
        path: 'search-results-coveo-error',
        component: _searchResultsCoveoError2['default']
    }, {
        path: 'recipe-box',
        component: _recipeBox2['default']
    }, {
        path: 'recipe-preferences',
        component: _recipePreferences2['default']
    }, {
        path: 'recipe-categories',
        component: _recipeCategories2['default']
    }, {
        path: 'survivor-story',
        component: _survivorStory2['default']
    }, {
        path: 'not-found',
        component: _2['default']
    }, {
        path: 'error',
        component: _4['default']
    }, {
        path: 'stroke-group-finder',
        component: _strokeGroupFinder2['default']
    }, {
        path: 'stroke-group-detail',
        component: _strokeGroupDetail2['default']
    }, {
        path: 'hospitalmaps',
        component: _hospitalmaps2['default']
    }, {
        path: 'phd-member-dashboard-account-summary',
        component: _phdMemberDashboardAccountSummary2['default']
    }, {
        path: 'phd-membership-tables',
        component: _phdMembershipTablesExample2['default']
    }, {
        path: 'things-to-know',
        component: _thingsToKnow2['default']
    }, {
        path: 'science-news-commentary',
        component: _scienceNewsCommentary2['default']
    }, {
        path: 'science-news-article-wildcard',
        component: _scienceNewsArticleSummaryWildcard2['default']
    }, {
        path: 'phd-linked-list-view-all-page',
        component: _linkedListViewAllPage2['default']
    }, {
        path: 'phd-header',
        component: _phdHeader2['default']
    }, {
        path: 'tier-selector',
        component: _tierSelector2['default']
    }, {
        path: 'tier-selector-api',
        component: _tierSelectorApi2['default']
    }, {
        path: 'institution-membership-api',
        component: _institutionMembershipApi2['default']
    }, {
        path: 'programming-table',
        component: _programmingTable2['default']
    }, {
        path: 'phd-community-tabs',
        component: _phdCommunityTabs2['default']
    }, {
        path: 'phd-meetings-sci-sessions',
        component: _phdMeetingsSciSessions2['default']
    }]
}];

exports['default'] = LayoutPages;

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45897ef0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_navigation_vue__ = __webpack_require__(1601);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45897ef0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-light"},[_c('b-navbar-toggle',{staticClass:"float-right",attrs:{"target":"sidebar-collapse"}}),_vm._v(" "),_c('span',{staticClass:"c-sidebar-nav__header"},[_vm._v("Layouts")]),_vm._v(" "),_c('b-collapse',{staticClass:"c-sidebar-nav",attrs:{"visible":"","id":"sidebar-collapse"}},[_c('ul',{staticClass:"c-sidebar-nav__links"},[_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/header-2023'}},[_vm._v("Header 2023")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/header'}},[_vm._v("Header")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/footer'}},[_vm._v("Footer")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/article'}},[_vm._v("Article")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/article-mobile-nav'}},[_vm._v("Article Mobile Nav")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/latest-news'}},[_vm._v("Latest News")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/news-listing'}},[_vm._v("News Listing")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/recipe'}},[_vm._v("Recipe")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/search'}},[_vm._v("Search")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/hospital-list-layout'}},[_vm._v("Hospital List Layout")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/hospital-map-layout'}},[_vm._v("Hospital Map Layout")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/impact-map-layout'}},[_vm._v("Impact Map Layout")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/search-results'}},[_vm._v("Search Results")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/search-results-coveo'}},[_vm._v("Coveo Search Results")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/search-results-coveo-error'}},[_vm._v("Coveo Search Results w/Error")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/recipe-box'}},[_vm._v("Recipe Box")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/recipe-preferences'}},[_vm._v("Recipe Preferences")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/recipe-categories'}},[_vm._v("Recipe Categories")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/survivor-story'}},[_vm._v("Survivor Story")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/not-found'}},[_vm._v("404")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/error'}},[_vm._v("500")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/stroke-group-finder'}},[_vm._v("Stroke Group Search")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/stroke-group-detail'}},[_vm._v("Stroke Group Detail")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/hospitalmaps'}},[_vm._v("Hospital Maps Development")])],1)]),_vm._v(" "),_c('span',{staticClass:"c-sidebar-nav__header"},[_vm._v("PHD")]),_vm._v(" "),_c('ul',{staticClass:"c-sidebar-nav__links"},[_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/phd-community-tabs'}},[_vm._v("PHD Community Tabs")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/phd-header'}},[_vm._v("Header")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/phd-member-dashboard-account-summary'}},[_vm._v("PHD Membership Dashboard - Account Summary")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/phd-membership-tables'}},[_vm._v("Membership Tables Examples")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'phd-linked-list-view-all-page'}},[_vm._v("PHD Linked List View All Page")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/science-news-article-wildcard'}},[_vm._v("Science News: Article Wildcard")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/science-news-commentary'}},[_vm._v("Science News: Commentary")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/things-to-know'}},[_vm._v("Science News: Things To Know")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/tier-selector'}},[_vm._v("Membership Tier Landing")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/tier-selector-api'}},[_vm._v("Membership Tier Landing API")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/institution-membership-api'}},[_vm._v("Institution Membership API")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/programming-table'}},[_vm._v("Programming Date/Time Table")])],1)]),_vm._v(" "),_c('span',{staticClass:"c-sidebar-nav__header border-0"},[_vm._v("PHD Scientific Sessions")]),_vm._v(" "),_c('ul',{staticClass:"c-sidebar-nav__links"},[_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/pages/phd-meetings-sci-sessions'}},[_vm._v("Meetings Scientific Sessions")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bc6c485_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_2023_vue__ = __webpack_require__(1603);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bc6c485_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_2023_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('header',{staticClass:"l-header"},[_c('div',{directives:[{name:"sticky-header",rawName:"v-sticky-header"}],staticClass:"l-header__top"},[_c('div',{staticClass:"container container-fluid container-wide"})]),_vm._v(" "),_c('div',{staticClass:"l-header__main"},[_c('div',{staticClass:"container container-fluid container-wide"},[_c('div',{staticClass:"d-none d-md-block"},[_c('aha-main-nav-2023')],1)])]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Header 2023")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-header__utility"},[_c('nav',{staticClass:"container container-fluid"},[_c('ul',{staticClass:"c-utility-nav nav"},[_c('li',[_c('a',{staticClass:"c-cta c-cta--icon h-theme--black",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/login-signup.svg","alt":""}}),_vm._v("Login")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta h-theme--black",attrs:{"href":"#"}},[_vm._v("Signup")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dded4cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__(1605);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dded4cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('header',{staticClass:"l-header"},[_vm._m(1),_vm._v(" "),_c('div',{directives:[{name:"sticky-header",rawName:"v-sticky-header"}],staticClass:"l-header__top"},[_c('div',{staticClass:"container container-fluid container-wide"},[_c('aha-top-nav')],1)]),_vm._v(" "),_c('div',{staticClass:"l-header__main"},[_c('div',{staticClass:"container container-fluid container-wide"},[_c('div',{staticClass:"d-none d-md-block"},[_c('aha-main-nav')],1)])]),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Header")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-header__utility"},[_c('nav',{staticClass:"container container-fluid"},[_c('ul',{staticClass:"c-utility-nav nav"},[_c('li',[_c('a',{staticClass:"c-cta h-theme--black",attrs:{"href":"#"}},[_vm._v("Warning Signs")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta h-theme--black",attrs:{"href":"#"}},[_vm._v("Volunteer")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta c-cta--icon h-theme--red",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/donate-heart.svg","alt":""}}),_vm._v("Donate")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-header__utility"},[_c('nav',{staticClass:"container container-fluid"},[_c('ul',{staticClass:"c-utility-nav nav"},[_c('li',[_c('a',{staticClass:"c-cta c-cta--icon h-theme--black",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/login-signup.svg","alt":""}}),_vm._v("Login")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-cta h-theme--black",attrs:{"href":"#"}},[_vm._v("Signup")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6954664_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__(1607);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6954664_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('footer',{staticClass:"l-footer"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"c-support-bar"},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row row-cols-1 row-cols-md-4"},[_c('div',{staticClass:"col c-support-bar__section"},[_c('div',{staticClass:"c-support-bar__content"},[_c('div',{staticClass:"h6 c-support-bar__content-title"},[_vm._v("Password/Login Help")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.supportcollapse1",modifiers:{"supportcollapse1":true}}],staticClass:"btn btn-link-plain btn--select"},[_c('div',{staticClass:"h6"},[_vm._v("Password/Login Help")])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"supportcollapse1","visible":false}},[_c('ul',{staticClass:"nav flex-column"},[_c('li',{staticClass:"nav-item"},[_vm._v("(888) 242-2453 (Inside U.S.)")]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_vm._v("(214) 570-5935 (Outside U.S.)")]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Contact Us")])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col c-support-bar__section"},[_c('div',{staticClass:"c-support-bar__content"},[_c('div',{staticClass:"h6 c-support-bar__content-title"},[_vm._v("Membership & Subscription")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.supportcollapse2",modifiers:{"supportcollapse2":true}}],staticClass:"btn btn-link-plain btn--select"},[_c('div',{staticClass:"h6"},[_vm._v("Membership & Subscription")])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"supportcollapse2","visible":false}},[_c('ul',{staticClass:"nav flex-column"},[_c('li',{staticClass:"nav-item"},[_vm._v("(800) 787-8984 (Inside U.S.)")]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_vm._v("(301) 223-2307 (Outside U.S.)")]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"mailto:ahacustomerservice@lww.com"}},[_vm._v("ahacustomerservice@lww.com")])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col c-support-bar__section"},[_c('div',{staticClass:"c-support-bar__content"},[_c('div',{staticClass:"h6 c-support-bar__content-title"},[_vm._v("Membership & Subscription")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.supportcollapse3",modifiers:{"supportcollapse3":true}}],staticClass:"btn btn-link-plain btn--select"},[_c('div',{staticClass:"h6"},[_vm._v("Membership & Subscription")])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"supportcollapse3","visible":false}},[_c('ul',{staticClass:"nav flex-column"},[_c('li',{staticClass:"nav-item"},[_vm._v("(800) 787-8984 (Inside U.S.)")]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_vm._v("(301) 223-2307 (Outside U.S.)")]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"mailto:ahacustomerservice@lww.com"}},[_vm._v("ahacustomerservice@lww.com")])])])])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"l-footer__section"},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-3 l-footer__nav"},[_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('contact-footer-collapse'),expression:"'contact-footer-collapse'"}],staticClass:"btn btn-link-plain btn--select"},[_c('div',{staticClass:"h6"},[_vm._v("Contact Us")])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"contact-footer-collapse","visible":false}},[_c('p',[_vm._v("7272 Greenville Ave."),_c('br'),_vm._v("\n                            Dallas, TX 75231"),_c('br'),_c('br'),_vm._v("\n\n                            Customer Service"),_c('br'),_vm._v("\n                            1-800-AHA-USA-1"),_c('br'),_vm._v("\n                            1-800-242-8721"),_c('br'),_vm._v("\n                            1-888-474-VIVE"),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Give Us Your Feedback")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3 l-footer__nav"},[_c('div',{staticClass:"h6 l-footer__nav-title"},[_vm._v("About Us")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse2",modifiers:{"collapse2":true}}],staticClass:"btn btn-link-plain btn--select"},[_c('div',{staticClass:"h6"},[_vm._v("About Us")])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse2","visible":false}},[_c('ul',{staticClass:"nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("About the AHA/ASA")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("2015-16 Annual Report")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("2015-16 Diversity & Inclusion Report")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("AHA Financial Information")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Careers")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("SHOP")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Latest Heart and Stroke News")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("AHA/ASA Media Newsroom")])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3 l-footer__nav"},[_c('div',{staticClass:"h6 l-footer__nav-title"},[_vm._v("Our Causes")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse3",modifiers:{"collapse3":true}}],staticClass:"btn btn-link-plain btn--select"},[_c('div',{staticClass:"h6"},[_vm._v("Our Causes")])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse3","visible":false}},[_c('ul',{staticClass:"nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Go Red For Women")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("2Ro Red Por Tu Curazon")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Healthy Living")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("EmPOWERED to Serve")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("The Warning Signs")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Online Communities")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Heart & Stroke Encyclopedia")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Volunteer")])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3 l-footer__nav"},[_c('div',{staticClass:"h6 l-footer__nav-title"},[_vm._v("Our Sites")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse4",modifiers:{"collapse4":true}}],staticClass:"btn btn-link-plain btn--select"},[_c('div',{staticClass:"h6"},[_vm._v("Our Sites")])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse4","visible":false}},[_c('ul',{staticClass:"nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("American Heart Association")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("American Stroke Association")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("My Life Check")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Professional Heart Daily")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Scientific Sessions")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Stroke Conference")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("You're The Cure")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Global Programs")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("eBooks")])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3 l-footer__nav"},[_c('div',{staticClass:"h6 l-footer__nav-title"},[_vm._v("Our Sites 2")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse5",modifiers:{"collapse5":true}}],staticClass:"btn btn-link-plain btn--select"},[_c('div',{staticClass:"h6"},[_vm._v("Our Sites 2")])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse5","visible":false}},[_c('ul',{staticClass:"nav flex-column"},[_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("American Heart Association")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("American Stroke Association")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("My Life Check")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Professional Heart Daily")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Scientific Sessions")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Stroke Conference")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("You're The Cure")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Global Programs")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("eBooks")])])])])],1)])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Footer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-disclaimer-bar"},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"c-disclaimer__content"},[_vm._v("\n                    Disclaimer: Statements, opinions, and study results published on Professional Heart Daily are those of the contributors and may not reflect the policy or position of the American Heart Association, which provides no warranty as to their accuracy or reliability, unless otherwise noted.\n               ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-footer__logo"},[_c('img',{attrs:{"src":"//placehold.it/200x80","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-footer__section"},[_c('div',{staticClass:"container container-fluid l-footer__social"},[_c('ul',{staticClass:"nav l-icon-nav"},[_c('li',[_c('a',{attrs:{"href":"http://www.twitter.com/American_Heart"}},[_c('img',{attrs:{"src":"assets/share/twitter-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.facebook.com/AmericanHeart"}},[_c('img',{attrs:{"src":"assets/share/facebook-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://plus.google.com/+AmericanHeart"}},[_c('img',{attrs:{"src":"assets/share/google-plus-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://instagram.com/american_heart"}},[_c('img',{attrs:{"src":"assets/share/instagram-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.youtube.com/user/americanheartassoc"}},[_c('img',{attrs:{"src":"assets/share/youtube-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.linkedin.com/company/american-heart-association"}},[_c('img',{attrs:{"src":"assets/share/linkedin-gray.svg"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://www.pinterest.com/americanheart/"}},[_c('img',{attrs:{"src":"assets/share/pinterest-gray.svg"}})])])]),_vm._v(" "),_c('div',{staticClass:"l-footer__logos"},[_c('ul',{staticClass:"nav l-icon-nav"},[_c('li',[_c('img',{attrs:{"src":"//placehold.it/71x61"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"//placehold.it/61x63"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"//placehold.it/36x63"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-footer__section"},[_c('div',{staticClass:"container container-fluid"},[_c('ul',{staticClass:"nav l-divider-link-nav l-footer__supplemental-nav"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Privacy Policy")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Copyright")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Ethics Policy")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Conflit of Interest Policy")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Linking Policy")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Diversity")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Careers")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Suppliers & Providers")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Accessibility Statement")])])]),_vm._v(" "),_c('div',{staticClass:"l-footer__copyright"},[_c('p',[_vm._v("©2017 American Heart Association, Inc. All rights reserved. Unauthorized use prohibited."),_c('br'),_vm._v("\n                        The American Heart Association is a qualified 501(c)(3) tax-exempt organization. "),_c('br'),_vm._v("\n                        *Red Dress ™ DHHS, Go Red ™ AHA ; National Wear Red Day® is a registered trademark.\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"l-footer__compliance"},[_c('img',{attrs:{"src":"//placehold.it/40x60"}}),_vm._v(" "),_c('div',{staticClass:"l-footer__compliance-text"},[_c('p',[_vm._v("This site complies with the HONcode standard for trustworthy health information: verify here.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c75113b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_vue__ = __webpack_require__(1609);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c75113b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('article',{staticClass:"l-article mb-5"},[_c('header',{staticClass:"container container-wide"},[_c('div',{staticClass:"c-hero-card h-theme--red"},[_c('div',{staticClass:"c-hero-card__container"},[_c('div',{directives:[{name:"vertical-align",rawName:"v-vertical-align"}],staticClass:"c-hero-card__content-container"},[_c('p',{staticClass:"c-hero-card__kicker"},[_vm._v("Conditions")]),_vm._v(" "),_c('h1',{staticClass:"c-hero-card__heading h1"},[_vm._v("About Arrythmia")]),_vm._v(" "),_c('p',{staticClass:"c-hero-card__subheading h4"},[_vm._v("Updated: Oct 26, 2017")]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('uniqueModalId'),expression:"'uniqueModalId'"}],staticClass:"c-hero-card__media h-placeholder-image h-placeholder-image--43-20 h-video-play"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/1200x600?text=loaded'),expression:"'//placehold.it/1200x600?text=loaded'"}],attrs:{"src":"//placehold.it/1200x600?text=loading","alt":""}})])]),_vm._v(" "),_c('aha-youtube',{attrs:{"trigger":"uniqueModalId","video-id":"M7lc1UVf-VE"}})],1)]),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"l-article__main"},[_c('p',[_vm._v("The term \"arrhythmia\" refers to any change from the normal sequence of electrical impulses. The electrical impulses may happen too fast, too slowly, or erratically – causing the heart to beat too fast, too slowly, or erratically. When the heart doesn't beat properly, it can't pump blood effectively. When the heart doesn't pump blood effectively, the lungs, brain and all other organs can't work properly and may shut down or be damaged.")]),_vm._v(" "),_c('p',[_vm._v("The normal heart is a strong, muscular pump a little larger than a fist. It pumps blood continuously through the circulatory system.")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('aha-single-field-prompt-component'),_vm._v(" "),_c('aha-quiz-scoring-component'),_vm._v(" "),_c('aha-quiz-personalised-component'),_vm._v(" "),_c('h3',[_vm._v("Understand how the heart pumps")]),_vm._v(" "),_c('h4',{staticClass:"h4 h-color--gray"},[_vm._v("Structure of the heart: Four Chambers, Four Valves")]),_vm._v(" "),_c('p',[_vm._v("The heart has four chambers, two on the right and two on the left:")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',[_vm._v("The heart also has four valves that open and close to let blood flow in only one direction when the heart contracts (beats). The four heart valves are:")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',[_vm._v("Each valve has a set of flaps (also called leaflets or cusps). The mitral valve has two flaps; the others have three. Blood flow occurs only when there's a difference in pressure across the valves, which causes them to open. Under normal conditions, the valves permit blood to flow in only one direction.")]),_vm._v(" "),_c('p',[_vm._v("The heart pumps blood to the lungs and to all the body's tissues by a sequence of highly organized contractions of the four chambers. For the heart to function properly, the four chambers must beat in an organized way.")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"l-article__meta"},[_c('aha-share-gigya')],1)]),_vm._v(" "),_c('aside',{staticClass:"l-article__col col-md-4 desktop-l-article-sidebar",attrs:{"aria-label":"Article Sidebar"}},[_c('nav',{staticClass:"l-article__widget"},[_c('aha-article-toc')],1),_vm._v(" "),_c('div',{staticClass:"l-article__widget"},[_c('h3',{staticClass:"l-article__widget-heading c-label c-label--green c-label--wide"},[_vm._v("Popular Articles")]),_vm._v(" "),_c('aha-article-listing')],1),_vm._v(" "),_c('div',{staticClass:"l-article__widget"},[_c('h3',{staticClass:"l-article__widget-heading c-label c-label--green c-label--wide"},[_vm._v("Article Listing with icons")]),_vm._v(" "),_c('aha-article-list-with-icons')],1)])])])]),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('aha-article-medium')],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('aha-article-medium')],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('aha-article-medium')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Article Layout")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"c-hero-card__cta c-cta c-cta--icon",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg","alt":""}}),_vm._v("Watch An Animation of Arrythima\n                        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-article__header"},[_c('h2',{staticClass:"h2"},[_vm._v("Arrythmia")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Each day the average heart beats (expands and contracts) 100,000 times and pumps about 2,000 gallons of blood through the body.")]),_vm._v(" "),_c('li',[_vm._v("In a 70-year lifetime, an average human heart beats more than 2.5 billion times.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Two upper chambers are called atria (one is called an atrium).")]),_vm._v(" "),_c('li',[_vm._v("Two lower chambers are called ventricles.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Tricuspid valve, located between the right atrium and right ventricle")]),_vm._v(" "),_c('li',[_vm._v("Pulmonary or pulmonic valve, between the right ventricle and the pulmonary artery")]),_vm._v(" "),_c('li',[_vm._v("Mitral valve, between the left atrium and left ventricle")]),_vm._v(" "),_c('li',[_vm._v("Aortic valve, between the left ventricle and the aorta")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"float-right col-md-6"},[_c('figcaption',{staticClass:"h4"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Watch an animation of heart valve anatomy")])]),_vm._v(" "),_c('img',{attrs:{"src":"//placehold.it/400x300","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-article__byline"},[_c('p',{staticClass:"l-article__byline-copy"},[_vm._v("Written by "),_c('a',{attrs:{"href":"#"}},[_vm._v("American Heart Association editorial staff")]),_vm._v(" and reviewed by science and medicine advisers.")]),_vm._v(" "),_c('p',{staticClass:"l-article__byline-reviewed"},[_vm._v("Last Reviewed: October 2017")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208d6b83_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_mobile_nav_vue__ = __webpack_require__(1611);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208d6b83_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_article_mobile_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('article',{staticClass:"l-article mb-5"},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('aside',{staticClass:"l-article__col col-md-4 mobile-l-article-sidebar",attrs:{"aria-label":"Article Sidebar"}},[_c('nav',{staticClass:"l-article__widget"},[_c('ul',{staticClass:"l-article-list"},[_c('li',{staticClass:"l-article-list__item"},[_c('aha-article-toc')],1),_vm._v(" "),_c('li',{staticClass:"l-article-list__item"},[_c('aha-article-toc')],1)])]),_vm._v(" "),_c('div',{staticClass:"l-article__widget"},[_c('h3',{staticClass:"l-article__widget-heading c-label c-label--green c-label--wide"},[_vm._v("Popular Articles")]),_vm._v(" "),_c('aha-article-medium')],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Article Layout")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07561ba7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_latest_news_vue__ = __webpack_require__(1613);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07561ba7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_latest_news_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"container container-fluid",attrs:{"aria-labelledby":"section-latest-news"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('aha-article-large',{staticClass:"d-none d-md-block"}),_vm._v(" "),_c('aha-article-medium',{staticClass:"d-md-none"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('aha-article-small')],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('aha-article-small')],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('ul',{staticClass:"l-article-list"},[_c('li',{staticClass:"l-article-list__item"},[_c('aha-article-xsmall')],1),_vm._v(" "),_c('li',{staticClass:"l-article-list__item"},[_c('aha-article-xsmall')],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-4"},[_vm._v("Latest News")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-listing-header"},[_c('h1',{staticClass:"c-listing-header__heading",attrs:{"id":"section-latest-news"}},[_vm._v("Latest News")]),_vm._v(" "),_c('div',{staticClass:"c-listing-header__cta-container"},[_c('p',{staticClass:"c-listing-header__subheading"},[_vm._v("Lorem Ipsum dolor sit amet, consectetur adipiscing elit.")]),_vm._v(" "),_c('a',{staticClass:"c-listing-header__cta c-cta c-cta--arrow h-theme--black",attrs:{"href":"#"}},[_vm._v("Read All News Stories")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93c17694_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_listing_vue__ = __webpack_require__(1615);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93c17694_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_listing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('aha-article-listing')],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('aha-article-listing')],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('aha-article-listing')],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('aha-article-listing')],1)]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("News Listing")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',{staticClass:"pagination pagination-lg pagination--page-count pagination--right"},[_c('li',{staticClass:"page-item disabled"},[_c('span',{staticClass:"page-link"},[_c('i',{staticClass:"icon-left-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item page-item--page-count"},[_vm._v("\n                    1 of 10\n                ")]),_vm._v(" "),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"}},[_c('i',{staticClass:"icon-right-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d80f1e3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_vue__ = __webpack_require__(1617);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d80f1e3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('article',[_c('div',{staticClass:"container container-fluid container-wide"},[_c('div',{staticClass:"c-hero-card h-theme--yellow-orange-alt"},[_c('div',{staticClass:"c-hero-card__container"},[_c('div',{directives:[{name:"vertical-align",rawName:"v-vertical-align"}],staticClass:"c-hero-card__content-container"},[_c('h1',{staticClass:"c-hero-card__heading h2"},[_vm._v("Veggie Pizza With Cauliflower Crust")]),_vm._v(" "),_c('div',{staticClass:"c-hero-card__action"},[_c('aha-recipe-social',{staticClass:"c-recipe__social--ratings-card",attrs:{"write-review-label":"Rate This Recipe","ratings-category-id":"Recipe","ratings-stream-id":"2163","comments-category-id":"Recipe","comments-stream-id":"2074","comments-stream-tags":"globalRecipe, 1002/4021, 1003/4031, 1004/4033, 1002/4023, 1001/4017, 1001/4018, 1002/4025, 1002/4024, 1002/4028, 1000/4011"}})],1)]),_vm._v(" "),_c('div',{staticClass:"c-hero-card__media h-placeholder-image h-placeholder-image--43-20"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/1200x600?text=loaded'),expression:"'//placehold.it/1200x600?text=loaded'"}],attrs:{"src":"//placehold.it/1200x600?text=loading","alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-article row"},[_c('div',{staticClass:"l-article__col col-md-8"},[_c('div',{staticClass:"c-recipe"},[_c('div',{staticClass:"c-recipe__social c-recipe__social--print-container"},[_c('aha-share-gigya'),_vm._v(" "),_c('aha-print-button')],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('aha-nutritional-facts'),_vm._v(" "),_c('aha-recipe-instructions'),_vm._v(" "),_c('aha-quick-tips')],1)]),_vm._v(" "),_c('aside',{staticClass:"l-article__col col-md-4"},[_c('h2',{staticClass:"l-article__widget-heading c-label c-label--orange c-label--wide"},[_vm._v("Related Recipes")]),_vm._v(" "),_c('article',{staticClass:"c-article-card c-article-card--small"},[_c('div',{staticClass:"c-article-card__content"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"#"}},[_c('div',{staticClass:"c-article-card__background h-placeholder-image h-placeholder-image--3-2",attrs:{"href":"#"}},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/750x563/ddd/ccc?text=FPO'),expression:"'//placehold.it/750x563/ddd/ccc?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_c('h3',{staticClass:"c-article-card__title h4"},[_vm._v("Meditation May Decrease The Risk Of Heart Disease")])]),_vm._v(" "),_c('p',{staticClass:"c-article-card__metadata"},[_vm._v("Oct. 3, 2017")])])])])])])]),_vm._v(" "),_c('aha-modal',{staticClass:"c-modal c-modal--aha",attrs:{"id":"recipe-add-to-box","hide-footer":"","centered":"","lazy":""}},[_c('template',{slot:"modal-header"},[_c('h2',{staticClass:"h3",attrs:{"id":"section-add-to-recipe-box"}},[_vm._v("Add to Recipe Box")])]),_vm._v(" "),_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'recipe-add-to-box', $event.target)}}},[_vm._v("×")]),_vm._v(" "),_c('p',[_vm._v("Recipe box folders:")]),_vm._v(" "),_c('aha-add-to-recipe-box',{attrs:{"recipe-id":"20"}})],2),_vm._v(" "),_c('aha-modal',{staticClass:"c-modal c-modal--aha c-modal--wide",attrs:{"id":"recipe-print","hide-footer":"","centered":""}},[_c('template',{slot:"modal-header"},[_c('h2',{staticClass:"sr-only"},[_vm._v("Print Recipe")])]),_vm._v(" "),_c('button',{directives:[{name:"print-element",rawName:"v-print-element",value:('recipe-print-section'),expression:"'recipe-print-section'"}],staticClass:"c-print-button btn btn-danger btn-round"},[_vm._v("Print Recipe")]),_vm._v(" "),_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'recipe-print', $event.target)}}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticClass:"c-recipe__print-container",attrs:{"id":"recipe-print-section"}},[_c('h2',{staticClass:"c-recipe__print-heading h3"},[_vm._v("Summer Veggie Pizza With Cauliflower Crust")]),_vm._v(" "),_c('div',{staticClass:"c-recipe__intro"},[_c('p',[_vm._v("Cauliflower will become your new favorite vegetable as it is used to create a pizza crust brimming with more fiber and nutrients than dough. With this creation or any of the other ideas in the tips, pizza is turned from an indulgence into a healthy option.")])]),_vm._v(" "),_c('div',{staticClass:"c-quick-nutrition"},[_c('h3',{staticClass:"c-quick-nutrition__heading h4"},[_vm._v("Summer Veggie Pizza With Cauliflower Crust")]),_vm._v(" "),_c('div',{staticClass:"c-quick-nutrition__content"},[_c('div',{staticClass:"c-quick-nutrition__col"},[_c('h4',{staticClass:"c-quick-nutrition__category h4"},[_c('img',{attrs:{"src":"assets/glyphs/graph.svg","alt":""}}),_vm._v("Calories\n            ")]),_vm._v(" "),_c('span',{staticClass:"c-quick-nutrition__value h4"},[_vm._v("190 Per Serving")])]),_vm._v(" "),_c('div',{staticClass:"c-quick-nutrition__col"},[_c('h4',{staticClass:"c-quick-nutrition__category h4"},[_c('img',{attrs:{"src":"assets/glyphs/strong.svg","alt":""}}),_vm._v("Protein\n            ")]),_vm._v(" "),_c('span',{staticClass:"c-quick-nutrition__value h4"},[_vm._v("15g Per Serving")])]),_vm._v(" "),_c('div',{staticClass:"c-quick-nutrition__col"},[_c('h4',{staticClass:"c-quick-nutrition__category h4"},[_c('img',{attrs:{"src":"assets/glyphs/leaf.svg","alt":""}}),_vm._v("Fiber\n            ")]),_vm._v(" "),_c('span',{staticClass:"c-quick-nutrition__value h4"},[_vm._v("17g Per Serving")])])])]),_vm._v(" "),_c('div',{staticClass:"nutrition-facts nutrition-facts--print"},[_c('h2',{staticClass:"nutrition-facts__heading"},[_vm._v("Nutrition Facts")]),_vm._v(" "),_c('div',{staticClass:"nutrition-facts"},[_c('table',{staticClass:"nutrition-facts__table"},[_c('tbody',[_c('tr',[_c('th',{staticClass:"nutrition-facts__category",attrs:{"colspan":"2"}},[_vm._v("Calories")]),_vm._v(" "),_c('td',[_vm._v("218")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"nutrition-facts__category",attrs:{"colspan":"2"}},[_vm._v("Total Fat")]),_vm._v(" "),_c('td',[_vm._v("12.0 g")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"blank-cell"}),_vm._v(" "),_c('th',[_vm._v("Saturated Fat")]),_vm._v(" "),_c('td',[_vm._v("2.0 g")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"blank-cell"}),_vm._v(" "),_c('th',[_vm._v("Trans Fat")]),_vm._v(" "),_c('td',[_vm._v("0.0 g")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"blank-cell"}),_vm._v(" "),_c('th',[_vm._v("Polyunsaturated Fat")]),_vm._v(" "),_c('td',[_vm._v("1.5 g")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"blank-cell"}),_vm._v(" "),_c('th',[_vm._v("Monounsaturated Fat")]),_vm._v(" "),_c('td',[_vm._v("8.0 g")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"nutrition-facts__category",attrs:{"colspan":"2"}},[_vm._v("Cholesterol")]),_vm._v(" "),_c('td',[_vm._v("0 mg")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"nutrition-facts__category",attrs:{"colspan":"2"}},[_vm._v("Sodium")]),_vm._v(" "),_c('td',[_vm._v("154 mg")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"nutrition-facts__category",attrs:{"colspan":"2"}},[_vm._v("Total Carbohydrate")]),_vm._v(" "),_c('td',[_vm._v("25 g")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"blank-cell"}),_vm._v(" "),_c('th',[_vm._v("Dietary Fiber")]),_vm._v(" "),_c('td',[_vm._v("8 g")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"blank-cell"}),_vm._v(" "),_c('th',[_vm._v("Sugars")]),_vm._v(" "),_c('td',[_vm._v("8 g")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"nutrition-facts__category",attrs:{"colspan":"2"}},[_vm._v("Protein")]),_vm._v(" "),_c('td',[_vm._v("6 g")])])])])]),_vm._v(" "),_c('p',{staticClass:"nutrition-facts__exchange"},[_c('strong',[_vm._v("Dietary Exchanges")]),_vm._v(" "),_c('br'),_vm._v("1 starch, 1/2 fruit, 1 vegetable, 2 fat\n        ")])]),_vm._v(" "),_c('aha-recipe-instructions'),_vm._v(" "),_c('aha-quick-tips')],1)],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('p',{staticClass:"page-heading"},[_vm._v("Recipe")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-recipe__intro"},[_c('p',[_vm._v("Cauliflower will become your new favorite vegetable as it is used to create a pizza crust brimming with more fiber and nutrients than dough. With this creation or any of the other ideas in the tips, pizza is turned from an indulgence into a healthy option.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03cc18d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__ = __webpack_require__(1619);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03cc18d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Search Layout")]),_vm._v(" "),_c('div',{staticClass:"l-search"},[_c('aha-inline-search'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('header',{staticClass:"l-search__header"},[_vm._m(1),_vm._v(" "),_c('aha-search-results-form',{attrs:{"action":""},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('input',{attrs:{"type":"hidden","name":"query","value":"lorem"}}),_vm._v(" "),_c('div',{staticClass:"l-search__options"},[_c('div',{staticClass:"l-search__filters"},[_c('div',{staticClass:"c-search-group form-group form-group--horizontal"},[_c('span',{staticClass:"c-search-group__label col-form-label",attrs:{"id":"most-relevant"}},[_vm._v("Sort by:")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"most-relevant","input-name":"sort-by","default-value":"Most Relevant","toggle-class":"c-search-group__dropdown btn btn-white btn--select"},model:{value:(slotProps.sortBy),callback:function ($$v) {_vm.$set(slotProps, "sortBy", $$v)},expression:"slotProps.sortBy"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Most Relevant")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Most Relevant","value":"most-relevant-1","item-class":"c-select-dropdown__item"}},[_vm._v("Most Relevant")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Option 2","value":"option-2","item-class":"c-select-dropdown__item"}},[_vm._v("Option 2")])],1)],2)],1),_vm._v(" "),_c('div',{staticClass:"form-group form-group--horizontal"},[_c('span',{staticClass:"c-search-group__label col-form-label",attrs:{"id":"num-results"}},[_vm._v("Results per page")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"num-results","input-name":"num-results","default-value":"20","position":"right","toggle-class":"c-search-group__dropdown btn btn-white btn--select"},model:{value:(slotProps.numResults),callback:function ($$v) {_vm.$set(slotProps, "numResults", $$v)},expression:"slotProps.numResults"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("20")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"10","item-class":"c-select-dropdown__item"}},[_vm._v("10")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"20","item-class":"c-select-dropdown__item"}},[_vm._v("20")])],1)],2)],1)]),_vm._v(" "),_c('div',{staticClass:"l-search__paging"},[_c('nav',{attrs:{"aria-label":"Search Results Pagination"}},[_c('ul',{staticClass:"pagination pagination-lg pagination--page-count"},[_c('li',{staticClass:"page-item disabled"},[_c('span',{staticClass:"page-link"},[_c('i',{staticClass:"icon-left-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item page-item--page-count"},[_vm._v("\n                                        1 of 10\n                                    ")]),_vm._v(" "),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"}},[_c('i',{staticClass:"icon-right-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])])])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"content"},[_c('ol',{staticClass:"c-search-results__list",staticStyle:{"counter-reset":"search-counter 9"}},[_c('li',{staticClass:"c-search-results__item"},[_c('div',{staticClass:"c-search-results__media"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/100x100?text=FPO'),expression:"'//placehold.it/100x100?text=FPO'"}],attrs:{"src":"//placehold.it/100x100?text=FPO","alt":""}})])]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('li',{staticClass:"c-search-results__item"},[_c('div',{staticClass:"c-search-results__media"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/100x100?text=FPO'),expression:"'//placehold.it/100x100?text=FPO'"}],attrs:{"src":"//placehold.it/100x100?text=FPO","alt":""}})])]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('li',{staticClass:"c-search-results__item"},[_c('div',{staticClass:"c-search-results__media"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/100x100?text=FPO'),expression:"'//placehold.it/100x100?text=FPO'"}],attrs:{"src":"//placehold.it/100x100?text=FPO","alt":""}})])]),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_vm._m(5)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"l-search__nav nav nav-tabs nav-tabs--centered"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#"}},[_vm._v("Tab")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_vm._v("Tab")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_vm._v("Tab")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_vm._v("Tab")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-search__heading"},[_c('h2',{staticClass:"h4"},[_vm._v("Search results for: "),_c('i',[_vm._v("\"lorem\"")])]),_vm._v(" "),_c('p',{staticClass:"h4 h-color--gray"},[_c('i',[_vm._v("120 results")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-search-results__content"},[_c('a',{staticClass:"c-search-results__link",attrs:{"href":"#"}},[_c('span',{staticClass:"c-search-results__counter"}),_vm._v(" American "),_c('strong',{staticClass:"h-color--red"},[_vm._v("Stroke")]),_vm._v(" Association…\n                        ")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac orci bibendum, tincidunt justo vel, finibus dolor. Integer non ullamcorper ante. Nam feugiat turpis laoreet neque lobortis congue. Nunc feugiat lacinia tortor, et rutrum enim placerat et. Vestibulum ornare sem nibh, vel finibus ipsum ornare a.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-search-results__content"},[_c('a',{staticClass:"c-search-results__link",attrs:{"href":"#"}},[_c('span',{staticClass:"c-search-results__counter"}),_vm._v(" American "),_c('strong',{staticClass:"h-color--red"},[_vm._v("Stroke")]),_vm._v(" Association…\n                        ")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, "),_c('br'),_vm._v("consectetur adipiscing elit. Sed ac orci bibendum, tincidunt justo vel, finibus dolor. Integer non ullamcorper ante. Nam feugiat turpis laoreet neque lobortis congue. Nunc feugiat lacinia tortor, et rutrum enim placerat et. Vestibulum ornare sem nibh, vel finibus ipsum ornare a.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-search-results__content"},[_c('a',{staticClass:"c-search-results__link",attrs:{"href":"#"}},[_c('span',{staticClass:"c-search-results__counter"}),_vm._v(" American "),_c('strong',{staticClass:"h-color--red"},[_vm._v("Stroke")]),_vm._v(" Association…\n                        ")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac orci bibendum, tincidunt justo vel, finibus dolor. Integer non ullamcorper ante. Nam feugiat turpis laoreet neque lobortis congue. Nunc feugiat lacinia tortor, et rutrum enim placerat et. Vestibulum ornare sem nibh, vel finibus ipsum ornare a.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{attrs:{"aria-label":"Search Results Pagination"}},[_c('ul',{staticClass:"pagination pagination-lg pagination--page-count pagination--right"},[_c('li',{staticClass:"page-item disabled"},[_c('span',{staticClass:"page-link"},[_c('i',{staticClass:"icon-left-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item page-item--page-count"},[_vm._v("\n                        1 of 10\n                    ")]),_vm._v(" "),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"}},[_c('i',{staticClass:"icon-right-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45b38c36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hospital_list_layout_vue__ = __webpack_require__(1621);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45b38c36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hospital_list_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-article-list-view"},[_c('div',{staticClass:"container"},[_c('aha-listing-header')],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"coveo-main-section c-map"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"coveo-search-section"},[_c('div',{staticClass:"container c-map-search",attrs:{"id":"search"}},[_c('aha-map-search',{attrs:{"name":"location-selector","search-endpoint":"//jsonplaceholder.typicode.com/posts","translations":{ "search": "Search", "searchResults": "Search results for", "clearResults": "Clear Results", "offices": "Offices", "address": "Address", "city": "City", "distance": "Distance", "searchLabel": "Hospital Name", "searchAddressLabel": "Hospital Address", "searchLabelPlaceholder": "i.e. Presbyterian", "addressLabelPlaceholder": "i.e. Address", "distancePlaceholder": "Distance" },"distances":[{ "code": "5", "title": "5 Miles" }, { "code": "10", "title": "10 Miles" }, { "code": "20", "title": "20 Miles" }]}})],1)]),_vm._v(" "),_c('div',{staticClass:"container",attrs:{"id":"map-search-results"}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"l-article__col mt-md-4 coveo-facet-column",attrs:{"cols":"12","lg":"4"}},[_c('aside',{attrs:{"aria-label":"Facet Sidebar"}},[_c('a',{staticClass:"map-btn btn btn-round btn-lg btn-outline-primary c-cta--icon mb-3",attrs:{"href":"#/pages/hospital-map-layout/"}},[_c('span',{staticClass:"map-icon"},[_c('svg',{staticStyle:{"enable-background":"new 0 0 32 30"},attrs:{"version":"1.1","id":"Location","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 32 30","xml:space":"preserve"}},[_c('g',[_c('path',{attrs:{"d":"M30,5v22.78l-8-1.6V22h-2v4.18l-8,1.6V9h-2v18.78l-8-1.6V4.22l8.804,1.761l0.393-1.961l-10-2\n                                        C0.9,1.958,0.598,2.036,0.366,2.227C0.134,2.417,0,2.7,0,3v24c0,0.477,0.336,0.887,0.804,0.98l10,2c0.13,0.026,0.263,0.026,0.393,0\n                                        L21,28.02l9.804,1.96C30.869,29.994,30.935,30,31,30c0.229,0,0.454-0.079,0.634-0.227C31.866,29.583,32,29.3,32,29V5H30z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M21,20c0.256,0,0.512-0.098,0.707-0.293C21.964,19.45,28,13.341,28,7c0-3.86-3.14-7-7-7s-7,3.14-7,7\n                                        c0,6.341,6.036,12.45,6.293,12.707C20.488,19.902,20.744,20,21,20z M21,2c2.757,0,5,2.243,5,5c0,4.317-3.472,8.77-5,10.521\n                                        C19.472,15.77,16,11.317,16,7C16,4.243,18.243,2,21,2z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M24,7c0-1.654-1.346-3-3-3s-3,1.346-3,3s1.346,3,3,3S24,8.654,24,7z M20,7c0-0.551,0.449-1,1-1s1,0.449,1,1s-0.449,1-1,1\n                                        S20,7.551,20,7z"}})])])]),_vm._v(" "),_c('span',[_vm._v("Map View")])]),_vm._v(" "),_c('form',{attrs:{"action":""}},[_c('div',{staticClass:"c-search-results__filter"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse1",modifiers:{"collapse1":true}}],staticClass:"facets__button",attrs:{"variant":"btn btn--select c-search-results__filter-btn"}},[_vm._v("Social Determinant")]),_vm._v(" "),_c('b-collapse',{staticClass:"facets__options",attrs:{"id":"collapse1"}},[_c('ul',{staticClass:"c-search-results__filter-content"},[_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox1","name":"customCheckbox1"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox1"}},[_c('strong',[_vm._v("Neighborhood & Environments")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"c-search-results__filter-helper"},[_vm._v("(This is helper text for this category)")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("12")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox2","name":"customCheckbox2"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox2"}},[_c('strong',[_vm._v("Health & Healthcare")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"c-search-results__filter-helper"},[_vm._v("(This is helper text for this category)")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("8")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox3","name":"customCheckbox3"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox3"}},[_c('strong',[_vm._v("Social & Community Context")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"c-search-results__filter-helper"},[_vm._v("(This is helper text for this category)")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("4")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox4","name":"customCheckbox4"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox4"}},[_c('strong',[_vm._v("Education")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"c-search-results__filter-helper"},[_vm._v("(This is helper text for this category)")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("5")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox5","name":"customCheckbox5"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox5"}},[_c('strong',[_vm._v("Economics & Stability")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"c-search-results__filter-helper"},[_vm._v("(This is helper text for this category)")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("3")])])])])])],1)])])]),_vm._v(" "),_c('b-col',{staticClass:"l-article__col mt-md-4 coveo-results-column",attrs:{"cols":"12","lg":"8"}},[_c('div',{staticClass:"l-map-search-results__heading coveo-results-header"},[_c('div',{staticClass:"coveo-summary-section"},[_c('span',{staticClass:"CoveoQuerySummary"},[_c('span',[_vm._v("Results "),_c('span',{staticClass:"coveo-highlight"},[_vm._v("1")]),_vm._v("-"),_c('span',{staticClass:"coveo-highlight"},[_vm._v("10")]),_vm._v(" of "),_c('span',{staticClass:"coveo-highlight"},[_vm._v("37")])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-result-layout-section coveo-result-layout-hidden"},[_c('div',{staticClass:"CoveoResultLayout CoveoResultLayoutSelector"},[_c('span',{staticClass:"coveo-result-layout-selector coveo-accessible-button coveo-selected",attrs:{"role":"button","aria-label":"Display results as List","tabindex":"0"}},[_c('span',{staticClass:"coveo-icon coveo-list-layout-icon"},[_c('svg',{staticClass:"coveo-list-svg",attrs:{"enable-background":"new 0 0 19 14","viewBox":"0 0 19 14","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m19 12c0 .552-.397 1-.813 1h-11.375c-.416 0-.813-.448-.813-1s .397-1 .813-1h11.375c.416 0 .813.448.813 1"}}),_c('path',{attrs:{"d":"m19 7c0 .552-.397 1-.813 1h-11.375c-.416 0-.813-.448-.813-1s .397-1 .813-1h11.375c.416 0 .813.448.813 1"}}),_c('path',{attrs:{"d":"m19 2c0 .552-.397 1-.813 1h-11.375c-.416 0-.813-.448-.813-1s .397-1 .813-1h11.375c.416 0 .813.448.813 1"}}),_c('path',{attrs:{"d":"m2 10c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2"}}),_c('path',{attrs:{"d":"m2 5c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2"}}),_c('path',{attrs:{"d":"m2 0c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2"}})])])]),_c('span',{staticClass:"coveo-result-layout-selector-caption"},[_vm._v("List")])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-sort-section"},[_c('button',{staticClass:"coveo-sort-section__print-btn btn btn-link"},[_c('img',{staticClass:"l-map-search-results__print-btn-img",attrs:{"src":"assets/share/print.svg","alt":"Print this list"}})])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__list CoveoResultList",attrs:{"id":"coveoD983BA32","data-layout":"list","data-wait-animation":"fade","data-auto-select-fields-to-include":"false"}},[_c('div',{staticClass:"coveo-result-list-container coveo-list-layout-container"},[_c('div',{staticClass:"CoveoResult"},[_c('div',{staticClass:"c-search-results__item coveo-result-frame coveoforsitecore-template"},[_c('div',{staticClass:"c-search-results-map__content coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell coveoforsitecore-information-section"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('div',{staticClass:"c-search-results-map__title coveo-title"},[_c('strong',[_vm._v("\n                                                            The "),_c('span',{staticClass:"highlight"},[_vm._v("Medical")]),_vm._v(" Center of Plano\n                                                        ")]),_vm._v(" "),_c('span',{staticClass:"c-search-results-map__meta"},[_vm._v("\n                                                            1.25 mi\n                                                        ")])]),_vm._v(" "),_c('div',{staticClass:"map-street-address"},[_vm._v("\n                                                        3345 Street Address Ln."),_c('br'),_vm._v("\n                                                        City, State 54000-4444"),_c('br')]),_vm._v(" "),_c('ul',{staticClass:"nav flex-row"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Website")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Direction")])])]),_vm._v(" "),_c('div',{staticClass:"map-phone"},[_vm._v("555-555-5555")]),_vm._v(" "),_c('div',{staticClass:"map-award"},[_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_GoldP_30x30.png","alt":"Stroke Gold"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_SilverP_30x30.png","alt":"Stroke Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Mission_Lifeline_STEMI_SilverP_Receiving_30x30.png","alt":"Mission Lifeline Stemi Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Target_Stroke_Honor_Roll_30x30.png","alt":"Target Stroke Honor Roll"}})])])])])])])])])])]),_vm._v(" "),_c('aha-search-results-form',{attrs:{"action":""}},[[_c('input',{attrs:{"type":"hidden","name":"query","role":"submit","value":"lorem"}}),_vm._v(" "),_c('div',{staticClass:"CoveoPager",attrs:{"data-number-of-pages":"3","aria-hidden":"false"}},[_c('ul',{staticClass:"coveo-pager-list"},[_c('li',{staticClass:"coveo-pager-list-item coveo-active coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Page 1"}},[_c('a',{staticClass:"coveo-pager-list-item-text coveo-pager-anchor"},[_vm._v("1")])]),_c('li',{staticClass:"coveo-pager-list-item coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Page 2"}},[_c('a',{staticClass:"coveo-pager-list-item-text coveo-pager-anchor"},[_vm._v("2")])]),_c('li',{staticClass:"coveo-pager-list-item coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Page 3"}},[_c('a',{staticClass:"coveo-pager-list-item-text coveo-pager-anchor"},[_vm._v("3")])]),_c('li',{staticClass:"coveo-pager-next coveo-pager-anchor coveo-pager-list-item coveo-accessible-button",attrs:{"role":"button","aria-label":"Next","tabindex":"0"}},[_c('a',{attrs:{"title":"Next"}},[_c('span',{staticClass:"coveo-pager-next-icon"},[_c('svg',{staticClass:"coveo-pager-next-icon-svg",attrs:{"enable-background":"new 0 0 11 20","viewBox":"0 0 11 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m .308 18.189c-.412.413-.411 1.086 0 1.5.2.201.465.311.746.311.282 0 .547-.11.747-.31l8.891-8.939c.199-.2.307-.466.307-.75 0-.286-.109-.551-.305-.748l-8.893-8.942c-.199-.2-.465-.311-.747-.311-.001 0-.001 0-.001 0-.281 0-.546.11-.745.309-.198.201-.308.468-.308.753 0 .284.11.548.306.745l8.145 8.193z"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"CoveoResultsPerPage",attrs:{"aria-hidden":"false"}},[_c('span',{staticClass:"coveo-results-per-page-text"},[_vm._v("Results per page")]),_c('ul',{staticClass:"coveo-results-per-page-list"},[_c('li',{staticClass:"coveo-results-per-page-list-item coveo-active coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Display 10 results per page"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("10")])]),_c('li',{staticClass:"coveo-results-per-page-list-item coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Display 25 results per page"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("25")])]),_c('li',{staticClass:"coveo-results-per-page-list-item coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Display 50 results per page"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("50")])]),_c('li',{staticClass:"coveo-results-per-page-list-item coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Display 100 results per page"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("100")])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-footer"},[_c('small',{staticClass:"l-map-search-results__date form-text text-muted"},[_vm._v("Hospital listing updated:: Sep 23, 2019")])])]],2)],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-article l-article--survivor row"},[_c('div',{staticClass:"col-md-8 align-self-center"},[_c('div',{staticClass:"l-article__main"},[_c('p',[_vm._v("Still, it didn't seem possible when Woodward arrived at Tufts Medical Center in Boston with 45 pounds of fluid weight. During the procedure to have his aorta repaired and another valve replaced with a mechanical heart valve, Woodward also had a clot on the left side of his heart that required additional repairs.")]),_vm._v(" "),_c('p',[_vm._v("\"When we were in the hospital for weeks leading up to Jeremy's surgery, my biggest fear was leaving the hospital alone,\" said his wife, Brook. \"Being there for weeks takes your mind to places you don't want to think about. We hadn't even been married two years, so dreams of having a family and a home just seemed liked they weren't going to be in the cards for us.\"")]),_vm._v(" "),_c('p',[_vm._v("But after six weeks in the hospital, Woodward returned home.")]),_vm._v(" "),_c('p',[_vm._v("\"I believe that his ability to keep positive is what kept him alive – along with the incredible team of doctors and nurses that literally put his heart back together,\" Brook said.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"l-article__widget"},[_c('blockquote',{staticClass:"c-blockquote c-blockquote--3"},[_vm._v("\n                        \"…Ability to Keep Positive Is What Kept Him Alive…\"\n                    ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coveo-header"},[_c('div',{staticClass:"CoveoForSitecoreAnalytics"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"CoveoAnalytics",attrs:{"data-prebind-endpoint":"coveoForSitecoreAnalyticsEndpoint","data-prebind-anonymous":"isAnonymous","data-prebind-search-hub":"currentPageName","data-prebind-send-to-cloud":"analyticsEnabled","data-applied-prebind":"true","data-endpoint":"/coveo/rest/coveoanalytics","data-anonymous":"true","data-search-hub":"Maps","data-send-to-cloud":"true"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1647f016_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hospital_map_layout_vue__ = __webpack_require__(1623);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1647f016_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hospital_map_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-view"},[_c('div',{staticClass:"container"},[_c('aha-listing-header')],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"coveo-main-section c-map"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"coveo-search-section"},[_c('div',{staticClass:"container c-map-search",attrs:{"id":"search"}},[_c('aha-map-search',{attrs:{"name":"location-selector","search-endpoint":"//jsonplaceholder.typicode.com/posts","translations":{ "search": "Search", "searchResults": "Search results for", "clearResults": "Clear Results", "offices": "Offices", "address": "Address", "city": "City", "distance": "Distance", "searchLabel": "Hospital Name", "searchAddressLabel": "Hospital Address", "searchLabelPlaceholder": "i.e. Presbyterian", "addressLabelPlaceholder": "i.e. Address", "distancePlaceholder": "Distance" },"distances":[{ "code": "5", "title": "5 Miles" }, { "code": "10", "title": "10 Miles" }, { "code": "20", "title": "20 Miles" }]}})],1)]),_vm._v(" "),_c('div',{staticClass:"container",attrs:{"id":"map-search-results"}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"l-article__col mt-md-4 coveo-facet-column",attrs:{"cols":"12","md":"4"}},[_c('aside',{attrs:{"aria-label":"List Sidebar"}},[_c('a',{staticClass:"map-btn btn btn-round btn-lg btn-outline-primary c-cta--icon mb-3",attrs:{"href":"#/pages/hospital-list-layout/"}},[_c('span',{staticClass:"map-icon"},[_c('svg',{staticStyle:{"enable-background":"new 0 0 32 32"},attrs:{"version":"1.1","id":"List","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 32 32","xml:space":"preserve"}},[_c('g',[_c('path',{attrs:{"d":"M7,0H1C0.448,0,0,0.448,0,1v6c0,0.552,0.448,1,1,1h6c0.552,0,1-0.448,1-1V1C8,0.448,7.552,0,7,0z M6,6H2V2h4V6z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7,12H1c-0.552,0-1,0.448-1,1v6c0,0.552,0.448,1,1,1h6c0.552,0,1-0.448,1-1v-6C8,12.448,7.552,12,7,12z M6,18H2v-4h4V18z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7,24H1c-0.552,0-1,0.448-1,1v6c0,0.552,0.448,1,1,1h6c0.552,0,1-0.448,1-1v-6C8,24.448,7.552,24,7,24z M6,30H2v-4h4V30z"}}),_vm._v(" "),_c('rect',{attrs:{"x":"12","y":"1","width":"20","height":"2"}}),_vm._v(" "),_c('rect',{attrs:{"x":"12","y":"5","width":"20","height":"2"}}),_vm._v(" "),_c('rect',{attrs:{"x":"12","y":"13","width":"20","height":"2"}}),_vm._v(" "),_c('rect',{attrs:{"x":"12","y":"17","width":"20","height":"2"}}),_vm._v(" "),_c('rect',{attrs:{"x":"12","y":"25","width":"20","height":"2"}}),_vm._v(" "),_c('rect',{attrs:{"x":"12","y":"29","width":"20","height":"2"}})])])]),_vm._v(" "),_c('span',[_vm._v("List View")])]),_vm._v(" "),_c('div',{staticClass:"l-map-search-results__heading coveo-results-header"},[_c('div',{staticClass:"coveo-summary-section"},[_c('span',{staticClass:"CoveoQuerySummary"},[_c('span',[_vm._v("Results "),_c('span',{staticClass:"coveo-highlight"},[_vm._v("1")]),_vm._v("-"),_c('span',{staticClass:"coveo-highlight"},[_vm._v("10")]),_vm._v(" of "),_c('span',{staticClass:"coveo-highlight"},[_vm._v("37")])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-result-layout-section coveo-result-layout-hidden"},[_c('div',{staticClass:"CoveoResultLayout CoveoResultLayoutSelector"},[_c('span',{staticClass:"coveo-result-layout-selector coveo-accessible-button coveo-selected",attrs:{"role":"button","aria-label":"Display results as List","tabindex":"0"}},[_c('span',{staticClass:"coveo-icon coveo-list-layout-icon"},[_c('svg',{staticClass:"coveo-list-svg",attrs:{"enable-background":"new 0 0 19 14","viewBox":"0 0 19 14","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m19 12c0 .552-.397 1-.813 1h-11.375c-.416 0-.813-.448-.813-1s .397-1 .813-1h11.375c.416 0 .813.448.813 1"}}),_c('path',{attrs:{"d":"m19 7c0 .552-.397 1-.813 1h-11.375c-.416 0-.813-.448-.813-1s .397-1 .813-1h11.375c.416 0 .813.448.813 1"}}),_c('path',{attrs:{"d":"m19 2c0 .552-.397 1-.813 1h-11.375c-.416 0-.813-.448-.813-1s .397-1 .813-1h11.375c.416 0 .813.448.813 1"}}),_c('path',{attrs:{"d":"m2 10c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2"}}),_c('path',{attrs:{"d":"m2 5c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2"}}),_c('path',{attrs:{"d":"m2 0c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2"}})])])]),_c('span',{staticClass:"coveo-result-layout-selector-caption"},[_vm._v("List")])])])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__list CoveoResultList mb-3",attrs:{"id":"coveoD983BA32","data-layout":"list","data-wait-animation":"fade","data-auto-select-fields-to-include":"false"}},[_c('div',{staticClass:"coveo-result-list-container coveo-list-layout-container"},[_c('div',{staticClass:"coveo-list-layout CoveoResult"},[_c('div',{staticClass:"c-search-results__item coveo-result-frame coveoforsitecore-template"},[_c('div',{staticClass:"coveo-result-cell coveoforsitecore-information-section"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('div',{staticClass:"c-search-results-map__title coveo-title"},[_c('strong',[_vm._v("\n                                                            The "),_c('span',{staticClass:"highlight"},[_vm._v("Medical")]),_vm._v(" Center of Plano\n                                                        ")])]),_vm._v(" "),_c('div',{staticClass:"c-search-results-map__meta"},[_c('span',{staticClass:"c-search-results-map__meta-distance"},[_vm._v("1.25 mi")])]),_vm._v(" "),_c('div',{staticClass:"map-street-address"},[_vm._v("\n                                                        3345 Street Address Ln."),_c('br'),_vm._v("\n                                                        City, State 54000-4444"),_c('br')]),_vm._v(" "),_c('ul',{staticClass:"nav flex-row"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Website")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Direction")])])]),_vm._v(" "),_c('div',{staticClass:"map-phone"},[_vm._v("555-555-5555")]),_vm._v(" "),_c('div',{staticClass:"map-award"},[_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_GoldP_30x30.png","alt":"Stroke Gold"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_SilverP_30x30.png","alt":"Stroke Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Mission_Lifeline_STEMI_SilverP_Receiving_30x30.png","alt":"Mission Lifeline Stemi Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Target_Stroke_Honor_Roll_30x30.png","alt":"Target Stroke Honor Roll"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__item coveo-result-frame coveoforsitecore-template"},[_c('div',{staticClass:"c-search-results-map__content coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell coveoforsitecore-information-section"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('div',{staticClass:"c-search-results-map__title coveo-title"},[_c('strong',[_vm._v("\n                                                            The "),_c('span',{staticClass:"highlight"},[_vm._v("Medical")]),_vm._v(" Center of Plano\n                                                        ")])]),_vm._v(" "),_c('div',{staticClass:"c-search-results-map__meta"},[_c('span',{staticClass:"c-search-results-map__meta-distance"},[_vm._v("1.25 mi")])]),_vm._v(" "),_c('div',{staticClass:"map-street-address"},[_vm._v("\n                                                        3345 Street Address Ln."),_c('br'),_vm._v("\n                                                        City, State 54000-4444"),_c('br')]),_vm._v(" "),_c('ul',{staticClass:"nav flex-row"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Website")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Direction")])])]),_vm._v(" "),_c('div',{staticClass:"map-phone"},[_vm._v("555-555-5555")]),_vm._v(" "),_c('div',{staticClass:"map-award"},[_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_GoldP_30x30.png","alt":"Stroke Gold"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_SilverP_30x30.png","alt":"Stroke Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Mission_Lifeline_STEMI_SilverP_Receiving_30x30.png","alt":"Mission Lifeline Stemi Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Target_Stroke_Honor_Roll_30x30.png","alt":"Target Stroke Honor Roll"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__item coveo-result-frame coveoforsitecore-template"},[_c('div',{staticClass:"c-search-results-map__content coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell coveoforsitecore-information-section"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('div',{staticClass:"c-search-results-map__title coveo-title"},[_c('strong',[_vm._v("\n                                                            The "),_c('span',{staticClass:"highlight"},[_vm._v("Medical")]),_vm._v(" Center of Plano\n                                                        ")])]),_vm._v(" "),_c('div',{staticClass:"c-search-results-map__meta"},[_c('span',{staticClass:"c-search-results-map__meta-distance"},[_vm._v("1.25 mi")])]),_vm._v(" "),_c('div',{staticClass:"map-street-address"},[_vm._v("\n                                                        3345 Street Address Ln."),_c('br'),_vm._v("\n                                                        City, State 54000-4444"),_c('br')]),_vm._v(" "),_c('ul',{staticClass:"nav flex-row"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Website")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Direction")])])]),_vm._v(" "),_c('div',{staticClass:"map-phone"},[_vm._v("555-555-5555")]),_vm._v(" "),_c('div',{staticClass:"map-award"},[_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_GoldP_30x30.png","alt":"Stroke Gold"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_SilverP_30x30.png","alt":"Stroke Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Mission_Lifeline_STEMI_SilverP_Receiving_30x30.png","alt":"Mission Lifeline Stemi Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Target_Stroke_Honor_Roll_30x30.png","alt":"Target Stroke Honor Roll"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__item coveo-result-frame coveoforsitecore-template"},[_c('div',{staticClass:"c-search-results-map__content coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell coveoforsitecore-information-section"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('div',{staticClass:"c-search-results-map__title coveo-title"},[_c('strong',[_vm._v("\n                                                            The "),_c('span',{staticClass:"highlight"},[_vm._v("Medical")]),_vm._v(" Center of Plano\n                                                        ")])]),_vm._v(" "),_c('div',{staticClass:"c-search-results-map__meta"},[_c('span',{staticClass:"c-search-results-map__meta-distance"},[_vm._v("1.25 mi")])]),_vm._v(" "),_c('div',{staticClass:"map-street-address"},[_vm._v("\n                                                        3345 Street Address Ln."),_c('br'),_vm._v("\n                                                        City, State 54000-4444"),_c('br')]),_vm._v(" "),_c('ul',{staticClass:"nav flex-row"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Website")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Direction")])])]),_vm._v(" "),_c('div',{staticClass:"map-phone"},[_vm._v("555-555-5555")]),_vm._v(" "),_c('div',{staticClass:"map-award"},[_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_GoldP_30x30.png","alt":"Stroke Gold"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_SilverP_30x30.png","alt":"Stroke Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Mission_Lifeline_STEMI_SilverP_Receiving_30x30.png","alt":"Mission Lifeline Stemi Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Target_Stroke_Honor_Roll_30x30.png","alt":"Target Stroke Honor Roll"}})])])])])])])])])]),_vm._v(" "),_c('aha-search-results-form',{attrs:{"action":""}},[[_c('input',{attrs:{"type":"hidden","name":"query","role":"submit","value":"lorem"}}),_vm._v(" "),_c('div',{staticClass:"l-search__options mb-md-0"},[_c('div',{staticClass:"l-search__filters"},[_c('div',{attrs:{"aria-label":"Search Results Pagination"}},[_c('ul',{staticClass:"pagination pagination-lg pagination--page-count"},[_c('li',{staticClass:"page-item disabled"},[_c('span',{staticClass:"page-link"},[_c('i',{staticClass:"icon-left-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item page-item--page-count"},[_vm._v("\n                                                    1 of 10\n                                                ")]),_vm._v(" "),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"}},[_c('i',{staticClass:"icon-right-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-group--horizontal mb-md-0"},[_c('div',{staticClass:"CoveoResultsPerPage",attrs:{"aria-hidden":"false"}},[_c('span',{staticClass:"coveo-results-per-page-text"},[_vm._v("Results per page")]),_c('ul',{staticClass:"coveo-results-per-page-list"},[_c('li',{staticClass:"coveo-results-per-page-list-item coveo-active coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Display 10 results per page"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("10")])]),_c('li',{staticClass:"coveo-results-per-page-list-item coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Display 25 results per page"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("25")])]),_c('li',{staticClass:"coveo-results-per-page-list-item coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Display 50 results per page"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("50")])]),_c('li',{staticClass:"coveo-results-per-page-list-item coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Display 100 results per page"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("100")])])])])])])])]],2)],1)]),_vm._v(" "),_c('b-col',{staticClass:"l-article__col mt-md-4",attrs:{"cols":"12","md":"8"}},[_c('div',{staticClass:"g-map"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3465.5528220173564!2d-95.55557038429563!3d29.703741882007684!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c2cf1ee90193%3A0x9bec9ab4b77e67fd!2sKung+Fu+Tea!5e0!3m2!1sen!2sus!4v1564081316415!5m2!1sen!2sus","width":"100%","height":"800","frameborder":"0","allowfullscreen":""}})]),_vm._v(" "),_c('div',{staticClass:"coveo-footer"},[_c('small',{staticClass:"l-map-search-results__date form-text text-muted"},[_vm._v("Hospital listing updated: April 9, 2019")])])])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-article l-article--survivor row"},[_c('div',{staticClass:"col-md-8 align-self-center"},[_c('div',{staticClass:"l-article__main"},[_c('p',[_vm._v("Still, it didn't seem possible when Woodward arrived at Tufts Medical Center in Boston with 45 pounds of fluid weight. During the procedure to have his aorta repaired and another valve replaced with a mechanical heart valve, Woodward also had a clot on the left side of his heart that required additional repairs.")]),_vm._v(" "),_c('p',[_vm._v("\"When we were in the hospital for weeks leading up to Jeremy's surgery, my biggest fear was leaving the hospital alone,\" said his wife, Brook. \"Being there for weeks takes your mind to places you don't want to think about. We hadn't even been married two years, so dreams of having a family and a home just seemed liked they weren't going to be in the cards for us.\"")]),_vm._v(" "),_c('p',[_vm._v("But after six weeks in the hospital, Woodward returned home.")]),_vm._v(" "),_c('p',[_vm._v("\"I believe that his ability to keep positive is what kept him alive – along with the incredible team of doctors and nurses that literally put his heart back together,\" Brook said.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"l-article__widget"},[_c('blockquote',{staticClass:"c-blockquote c-blockquote--3"},[_vm._v("\n                        \"…Ability to Keep Positive Is What Kept Him Alive…\"\n                    ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coveo-header"},[_c('div',{staticClass:"CoveoForSitecoreAnalytics"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"CoveoAnalytics",attrs:{"data-prebind-endpoint":"coveoForSitecoreAnalyticsEndpoint","data-prebind-anonymous":"isAnonymous","data-prebind-search-hub":"currentPageName","data-prebind-send-to-cloud":"analyticsEnabled","data-applied-prebind":"true","data-endpoint":"/coveo/rest/coveoanalytics","data-anonymous":"true","data-search-hub":"Maps","data-send-to-cloud":"true"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dde398ca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_impact_map_layout_vue__ = __webpack_require__(1625);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dde398ca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_impact_map_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-view"},[_c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Impact Map Layout")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('impacted-data')],1)],1),_vm._v(" "),_c('div',{staticClass:"coveo-main-section c-map impact-map"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('b-col',{staticClass:"impact-map-search-error",attrs:{"cols":"12"}},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                    Form error message\n                ")])])],1),_vm._v(" "),_c('div',{staticClass:"container-fluid",attrs:{"id":"map-results"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"l-article__col mt-lg-0",attrs:{"cols":"12","md":"4"}},[_c('aside',{attrs:{"aria-label":"List Sidebar"}},[_c('div',{staticClass:"c-map-search input-group impact-map-state-select"},[_c('select',{staticClass:"custom-select btn btn-white btn--select",attrs:{"id":"state","name":"state","autofocus":"autofocus"}},[_c('option',{staticClass:"dropdown-item",attrs:{"value":""}},[_vm._v("Select your State")]),_vm._v(" "),_c('option',{staticClass:"dropdown-item",attrs:{"data-latitude":"32.318231","data-longitude":"-86.902298","value":"AL"}},[_vm._v("Alabama")]),_vm._v(" "),_c('option',{staticClass:"dropdown-item",attrs:{"data-latitude":"63.588753","data-longitude":"-154.493062","value":"AK"}},[_vm._v("Alaska")]),_vm._v(" "),_c('option',{staticClass:"dropdown-item",attrs:{"data-latitude":"34.048928","data-longitude":"-111.093731","value":"AZ"}},[_vm._v("Arizona")]),_vm._v(" "),_c('option',{staticClass:"dropdown-item",attrs:{"data-latitude":"35.20105","data-longitude":"-91.831833","value":"AR"}},[_vm._v("Arkansas")])]),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"c-map-search__search-btn btn btn-lg btn-danger btn-round impact-map-searc-btn",attrs:{"id":"submit","onclick":"smoothScroll(document.getElementById('map-results'))"}},[_c('img',{attrs:{"src":"assets/search-icon.svg"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Search")])])])]),_vm._v(" "),_c('button',{staticClass:"btn impact-map-full-map-btn",attrs:{"aria-label":"Hide List Sidebar"}},[_c('i',{staticClass:"icon-times",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"l-map-search-results__heading coveo-results-header"},[_c('div',{staticClass:"coveo-summary-section"},[_c('span',{staticClass:"CoveoQuerySummary"},[_c('span',[_vm._v("Results "),_c('span',{staticClass:"coveo-highlight"},[_vm._v("1")]),_vm._v("-"),_c('span',{staticClass:"coveo-highlight"},[_vm._v("10")]),_vm._v(" of "),_c('span',{staticClass:"coveo-highlight"},[_vm._v("37")])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-result-layout-section coveo-result-layout-hidden"},[_c('div',{staticClass:"CoveoResultLayout CoveoResultLayoutSelector"},[_c('span',{staticClass:"coveo-result-layout-selector coveo-accessible-button coveo-selected",attrs:{"role":"button","aria-label":"Display results as List","tabindex":"0"}},[_c('span',{staticClass:"coveo-icon coveo-list-layout-icon"},[_c('svg',{staticClass:"coveo-list-svg",attrs:{"enable-background":"new 0 0 19 14","viewBox":"0 0 19 14","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m19 12c0 .552-.397 1-.813 1h-11.375c-.416 0-.813-.448-.813-1s .397-1 .813-1h11.375c.416 0 .813.448.813 1"}}),_c('path',{attrs:{"d":"m19 7c0 .552-.397 1-.813 1h-11.375c-.416 0-.813-.448-.813-1s .397-1 .813-1h11.375c.416 0 .813.448.813 1"}}),_c('path',{attrs:{"d":"m19 2c0 .552-.397 1-.813 1h-11.375c-.416 0-.813-.448-.813-1s .397-1 .813-1h11.375c.416 0 .813.448.813 1"}}),_c('path',{attrs:{"d":"m2 10c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2"}}),_c('path',{attrs:{"d":"m2 5c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2"}}),_c('path',{attrs:{"d":"m2 0c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2"}})])])]),_c('span',{staticClass:"coveo-result-layout-selector-caption"},[_vm._v("List")])])])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__list CoveoResultList mb-3",attrs:{"id":"coveoD983BA32","data-layout":"list","data-wait-animation":"fade","data-auto-select-fields-to-include":"false"}},[_c('div',{staticClass:"coveo-result-list-container coveo-list-layout-container"},[_c('div',{staticClass:"coveo-list-layout CoveoResult"},[_c('div',{staticClass:"c-search-results__item coveo-result-frame coveoforsitecore-template"},[_c('div',{staticClass:"coveo-result-cell coveoforsitecore-information-section"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('div',{staticClass:"c-search-results-map__title coveo-title"},[_c('strong',[_vm._v("\n                                                            The "),_c('span',{staticClass:"highlight"},[_vm._v("Medical")]),_vm._v(" Center of Plano\n                                                        ")])]),_vm._v(" "),_c('div',{staticClass:"c-search-results-map__meta"},[_c('span',{staticClass:"c-search-results-map__meta-distance"},[_vm._v("1.25 mi")])]),_vm._v(" "),_c('div',{staticClass:"map-street-address"},[_vm._v("\n                                                        3345 Street Address Ln."),_c('br'),_vm._v("\n                                                        City, State 54000-4444"),_c('br')]),_vm._v(" "),_c('ul',{staticClass:"nav flex-row"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Website")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Direction")])])]),_vm._v(" "),_c('div',{staticClass:"map-phone"},[_vm._v("555-555-5555")]),_vm._v(" "),_c('div',{staticClass:"map-award"},[_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_GoldP_30x30.png","alt":"Stroke Gold"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_SilverP_30x30.png","alt":"Stroke Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Mission_Lifeline_STEMI_SilverP_Receiving_30x30.png","alt":"Mission Lifeline Stemi Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Target_Stroke_Honor_Roll_30x30.png","alt":"Target Stroke Honor Roll"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__item coveo-result-frame coveoforsitecore-template"},[_c('div',{staticClass:"c-search-results-map__content coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell coveoforsitecore-information-section"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('div',{staticClass:"c-search-results-map__title coveo-title"},[_c('strong',[_vm._v("\n                                                            The "),_c('span',{staticClass:"highlight"},[_vm._v("Medical")]),_vm._v(" Center of Plano\n                                                        ")])]),_vm._v(" "),_c('div',{staticClass:"c-search-results-map__meta"},[_c('span',{staticClass:"c-search-results-map__meta-distance"},[_vm._v("1.25 mi")])]),_vm._v(" "),_c('div',{staticClass:"map-street-address"},[_vm._v("\n                                                        3345 Street Address Ln."),_c('br'),_vm._v("\n                                                        City, State 54000-4444"),_c('br')]),_vm._v(" "),_c('ul',{staticClass:"nav flex-row"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Website")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Direction")])])]),_vm._v(" "),_c('div',{staticClass:"map-phone"},[_vm._v("555-555-5555")]),_vm._v(" "),_c('div',{staticClass:"map-award"},[_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_GoldP_30x30.png","alt":"Stroke Gold"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_SilverP_30x30.png","alt":"Stroke Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Mission_Lifeline_STEMI_SilverP_Receiving_30x30.png","alt":"Mission Lifeline Stemi Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Target_Stroke_Honor_Roll_30x30.png","alt":"Target Stroke Honor Roll"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__item coveo-result-frame coveoforsitecore-template"},[_c('div',{staticClass:"c-search-results-map__content coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell coveoforsitecore-information-section"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('div',{staticClass:"c-search-results-map__title coveo-title"},[_c('strong',[_vm._v("\n                                                            The "),_c('span',{staticClass:"highlight"},[_vm._v("Medical")]),_vm._v(" Center of Plano\n                                                        ")])]),_vm._v(" "),_c('div',{staticClass:"c-search-results-map__meta"},[_c('span',{staticClass:"c-search-results-map__meta-distance"},[_vm._v("1.25 mi")])]),_vm._v(" "),_c('div',{staticClass:"map-street-address"},[_vm._v("\n                                                        3345 Street Address Ln."),_c('br'),_vm._v("\n                                                        City, State 54000-4444"),_c('br')]),_vm._v(" "),_c('ul',{staticClass:"nav flex-row"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Website")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Direction")])])]),_vm._v(" "),_c('div',{staticClass:"map-phone"},[_vm._v("555-555-5555")]),_vm._v(" "),_c('div',{staticClass:"map-award"},[_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_GoldP_30x30.png","alt":"Stroke Gold"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_SilverP_30x30.png","alt":"Stroke Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Mission_Lifeline_STEMI_SilverP_Receiving_30x30.png","alt":"Mission Lifeline Stemi Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Target_Stroke_Honor_Roll_30x30.png","alt":"Target Stroke Honor Roll"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__item coveo-result-frame coveoforsitecore-template"},[_c('div',{staticClass:"c-search-results-map__content coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell coveoforsitecore-information-section"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('div',{staticClass:"c-search-results-map__title coveo-title"},[_c('strong',[_vm._v("\n                                                            The "),_c('span',{staticClass:"highlight"},[_vm._v("Medical")]),_vm._v(" Center of Plano\n                                                        ")])]),_vm._v(" "),_c('div',{staticClass:"c-search-results-map__meta"},[_c('span',{staticClass:"c-search-results-map__meta-distance"},[_vm._v("1.25 mi")])]),_vm._v(" "),_c('div',{staticClass:"map-street-address"},[_vm._v("\n                                                        3345 Street Address Ln."),_c('br'),_vm._v("\n                                                        City, State 54000-4444"),_c('br')]),_vm._v(" "),_c('ul',{staticClass:"nav flex-row"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Website")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Direction")])])]),_vm._v(" "),_c('div',{staticClass:"map-phone"},[_vm._v("555-555-5555")]),_vm._v(" "),_c('div',{staticClass:"map-award"},[_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_GoldP_30x30.png","alt":"Stroke Gold"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/GWTG_Stroke_SilverP_30x30.png","alt":"Stroke Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Mission_Lifeline_STEMI_SilverP_Receiving_30x30.png","alt":"Mission Lifeline Stemi Silver"}})]),_vm._v(" "),_c('span',{staticClass:"c-search-results__map-content--icon"},[_c('img',{attrs:{"src":"assets/icons/hospital_map_icons/Target_Stroke_Honor_Roll_30x30.png","alt":"Target Stroke Honor Roll"}})])])])])])])])])]),_vm._v(" "),_c('aha-search-results-form',{attrs:{"action":""}},[[_c('input',{attrs:{"type":"hidden","name":"query","role":"submit","value":"lorem"}}),_vm._v(" "),_c('div',{staticClass:"l-search__options mb-md-0"},[_c('div',{staticClass:"l-search__filters"},[_c('div',{attrs:{"aria-label":"Search Results Pagination"}},[_c('ul',{staticClass:"pagination pagination-lg pagination--page-count"},[_c('li',{staticClass:"page-item disabled"},[_c('span',{staticClass:"page-link"},[_c('i',{staticClass:"icon-left-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item page-item--page-count"},[_vm._v("\n                                                    1 of 10\n                                                ")]),_vm._v(" "),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"}},[_c('i',{staticClass:"icon-right-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-group--horizontal mb-md-0"},[_c('div',{staticClass:"CoveoResultsPerPage",attrs:{"aria-hidden":"false"}},[_c('span',{staticClass:"coveo-results-per-page-text"},[_vm._v("Results per page")]),_c('ul',{staticClass:"coveo-results-per-page-list"},[_c('li',{staticClass:"coveo-results-per-page-list-item coveo-active coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Display 10 results per page"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("10")])]),_c('li',{staticClass:"coveo-results-per-page-list-item coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Display 25 results per page"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("25")])]),_c('li',{staticClass:"coveo-results-per-page-list-item coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Display 50 results per page"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("50")])]),_c('li',{staticClass:"coveo-results-per-page-list-item coveo-accessible-button",attrs:{"tabindex":"0","role":"button","aria-label":"Display 100 results per page"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("100")])])])])])])])]],2)],1)]),_vm._v(" "),_c('b-col',{staticClass:"l-article__col mt-lg-0",attrs:{"cols":"12","md":"8"}},[_c('div',{staticClass:"g-map"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3465.5528220173564!2d-95.55557038429563!3d29.703741882007684!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c2cf1ee90193%3A0x9bec9ab4b77e67fd!2sKung+Fu+Tea!5e0!3m2!1sen!2sus!4v1564081316415!5m2!1sen!2sus","width":"100%","height":"800","frameborder":"0","allowfullscreen":""}})]),_vm._v(" "),_c('div',{staticClass:"coveo-footer"},[_c('small',{staticClass:"l-map-search-results__date form-text text-muted"},[_vm._v("Hospital listing updated: April 9, 2019")])])])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coveo-header"},[_c('div',{staticClass:"CoveoForSitecoreAnalytics"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"CoveoAnalytics",attrs:{"data-prebind-endpoint":"coveoForSitecoreAnalyticsEndpoint","data-prebind-anonymous":"isAnonymous","data-prebind-search-hub":"currentPageName","data-prebind-send-to-cloud":"analyticsEnabled","data-applied-prebind":"true","data-endpoint":"/coveo/rest/coveoanalytics","data-anonymous":"true","data-search-hub":"Maps","data-send-to-cloud":"true"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"l-article__col col-lg-12"},[_c('div',{staticClass:"impact-map__map-instructions"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"impact-map__map-instructions-content text-center text-lg-left offset-1 offset-lg-2 offset-xl-3 col-10 col-lg-6 col-xl-5"},[_c('p',{attrs:{"id":"linkMapAriaDescribedByToThisId"}},[_vm._v("Lorem ipsum dolor sit, amet consectetur adipisicing elit. Impedit aspernatur distinctio eum rerum, ab alias harum expedita officiis dolores porro molestias voluptatibus, delectus nostrum vero odio illo sit exercitationem dolore?")])]),_vm._v(" "),_c('div',{staticClass:"coveo-tab-section text-center text-lg-left col-12 col-lg-4 col-xl-4 d-flex justify-content-center justify-content-lg-start align-items-center"},[_c('div',{attrs:{"aria-label":"Tabs"}},[_c('a',{staticClass:"btn btn-round btn-outline-primary",attrs:{"id":"_E7DC8845-F875-4630-9B6B-69EE0FA4BA45","href":"/en/test_pages/impact-map/list-view"}},[_c('span',[_vm._v("List View")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ccfa5fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_results_vue__ = __webpack_require__(1627);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ccfa5fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_results_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"l-search"},[_c('header',{staticClass:"l-search-results__header l-search-results__header--md-horizontal nav-tabs mt-5 pb-4 mb-5"},[_vm._m(0),_vm._v(" "),_c('aha-search-results-form',{attrs:{"action":""},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('input',{attrs:{"type":"hidden","name":"query","value":"lorem"}}),_vm._v(" "),_c('div',{staticClass:"l-search__options mb-md-0"},[_c('div',{staticClass:"l-search__filters"},[_c('div',{staticClass:"c-search-group form-group form-group--horizontal mb-md-0"},[_c('span',{staticClass:"c-search-group__label col-form-label",attrs:{"id":"sortByLabel"}},[_vm._v("Sort by:")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"sortByLabel","input-name":"sort-by","default-value":"Relevancy","toggle-class":"c-search-group__dropdown btn btn-white btn--select"},model:{value:(slotProps.sortBy),callback:function ($$v) {_vm.$set(slotProps, "sortBy", $$v)},expression:"slotProps.sortBy"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("Relevancy")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Relevancy","value":"relevancy","item-class":"c-select-dropdown__item"}},[_vm._v("Most Relevant")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"Date","value":"date","item-class":"c-select-dropdown__item"}},[_vm._v("Date")])],1)],2)],1),_vm._v(" "),_c('div',{staticClass:"form-group form-group--horizontal mb-md-0"},[_c('span',{staticClass:"c-search-group__label col-form-label",attrs:{"id":"numResultsLabel"}},[_vm._v("Results per page")]),_vm._v(" "),_c('aha-listbox',{attrs:{"dropdown-tag":"ul","role":"listbox","labelledby":"numResultsLabel","input-name":"num-results","default-value":"20","position":"right","toggle-class":"c-search-group__dropdown btn btn-white btn--select mr-0"},model:{value:(slotProps.numResults),callback:function ($$v) {_vm.$set(slotProps, "numResults", $$v)},expression:"slotProps.numResults"}},[_c('span',{staticClass:"c-search-group__dropdown btn btn-lg btn-white btn--select"},[_vm._v("20")]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"10","item-class":"c-select-dropdown__item"}},[_vm._v("10")]),_vm._v(" "),_c('aha-select-dropdown-item',{attrs:{"tag":"li","role":"option","text":"20","item-class":"c-select-dropdown__item"}},[_vm._v("20")])],1)],2)],1)])])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"content"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"3"}},[_c('form',{attrs:{"action":""}},[_c('div',{staticClass:"c-search-results__filter"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse1",modifiers:{"collapse1":true}}],staticClass:"facets__button",attrs:{"variant":"btn btn--select c-search-results__filter-btn"}},[_vm._v("Social Determinant")]),_vm._v(" "),_c('b-collapse',{staticClass:"facets__options",attrs:{"id":"collapse1"}},[_c('ul',{staticClass:"c-search-results__filter-content"},[_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox1","name":"customCheckbox1"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox1"}},[_c('strong',[_vm._v("Neighborhood & Environments")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"c-search-results__filter-helper"},[_vm._v("(This is helper text for this category)")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("12")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox2","name":"customCheckbox2"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox2"}},[_c('strong',[_vm._v("Health & Healthcare")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"c-search-results__filter-helper"},[_vm._v("(This is helper text for this category)")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("8")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox3","name":"customCheckbox3"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox3"}},[_c('strong',[_vm._v("Social & Community Context")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"c-search-results__filter-helper"},[_vm._v("(This is helper text for this category)")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("4")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox4","name":"customCheckbox4"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox4"}},[_c('strong',[_vm._v("Education")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"c-search-results__filter-helper"},[_vm._v("(This is helper text for this category)")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("5")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox5","name":"customCheckbox5"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox5"}},[_c('strong',[_vm._v("Economics & Stability")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"c-search-results__filter-helper"},[_vm._v("(This is helper text for this category)")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("3")])])])])])],1),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse2",modifiers:{"collapse2":true}}],staticClass:"facets__button",attrs:{"variant":"btn btn--select c-search-results__filter-btn"}},[_vm._v("Size of Population")]),_vm._v(" "),_c('b-collapse',{staticClass:"facets__options",attrs:{"id":"collapse2"}},[_c('ul',{staticClass:"c-search-results__filter-content"},[_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox6","name":"customCheckbox6"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox6"}},[_c('strong',[_vm._v("0-5,000")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("4")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox7","name":"customCheckbox7"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox7"}},[_c('strong',[_vm._v("5,000-25,000")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("6")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox8","name":"customCheckbox8"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox8"}},[_c('strong',[_vm._v("25,000-100,000")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("3")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox9","name":"customCheckbox9"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox9"}},[_c('strong',[_vm._v("100,000-500,000")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("2")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox10","name":"customCheckbox10"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox10"}},[_c('strong',[_vm._v("500,000-1 million")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("1")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox11","name":"customCheckbox11"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox11"}},[_c('strong',[_vm._v("1 million +")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("1")])])])])])],1),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse3",modifiers:{"collapse3":true}}],staticClass:"facets__button",attrs:{"variant":"btn btn--select c-search-results__filter-btn"}},[_vm._v("Community Type")]),_vm._v(" "),_c('b-collapse',{staticClass:"facets__options",attrs:{"id":"collapse3"}},[_c('ul',{staticClass:"c-search-results__filter-content"},[_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox12","name":"customCheckbox12"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox12"}},[_c('strong',[_vm._v("Rural")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("4")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox13","name":"customCheckbox13"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox13"}},[_c('strong',[_vm._v("Urban")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("6")])])])])])],1),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse4",modifiers:{"collapse4":true}}],staticClass:"facets__button",attrs:{"variant":"btn btn--select c-search-results__filter-btn"}},[_vm._v("Race")]),_vm._v(" "),_c('b-collapse',{staticClass:"facets__options",attrs:{"id":"collapse4"}},[_c('ul',{staticClass:"c-search-results__filter-content"},[_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox14","name":"customCheckbox14"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox14"}},[_c('strong',[_vm._v("All Races")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("8")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox15","name":"customCheckbox15"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox15"}},[_c('strong',[_vm._v("Caucasian")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("3")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox16","name":"customCheckbox16"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox16"}},[_c('strong',[_vm._v("African American")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("3")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox17","name":"customCheckbox17"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox17"}},[_c('strong',[_vm._v("Latino")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("2")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox18","name":"customCheckbox18"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox18"}},[_c('strong',[_vm._v("American Indian")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("1")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox19","name":"customCheckbox19"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox19"}},[_c('strong',[_vm._v("Native Alaskan")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("1")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox20","name":"customCheckbox20"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox20"}},[_c('strong',[_vm._v("Asian")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("2")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox21","name":"customCheckbox21"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox21"}},[_c('strong',[_vm._v("Other")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("3")])])])])])],1),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse5",modifiers:{"collapse5":true}}],staticClass:"facets__button",attrs:{"variant":"btn btn--select c-search-results__filter-btn"}},[_vm._v("Ethnicity")]),_vm._v(" "),_c('b-collapse',{staticClass:"facets__options",attrs:{"id":"collapse5"}},[_c('ul',{staticClass:"c-search-results__filter-content"},[_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox22","name":"customCheckbox22"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox22"}},[_c('strong',[_vm._v("All Ethnicities")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("8")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox23","name":"customCheckbox23"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox23"}},[_c('strong',[_vm._v("Caucasian")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("3")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox24","name":"customCheckbox24"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox24"}},[_c('strong',[_vm._v("African American")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("3")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox25","name":"customCheckbox25"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox25"}},[_c('strong',[_vm._v("Latino")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("2")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox26","name":"customCheckbox26"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox26"}},[_c('strong',[_vm._v("American Indian")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("1")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox27","name":"customCheckbox27"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox27"}},[_c('strong',[_vm._v("Native Alaskan")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("1")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox28","name":"customCheckbox28"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox28"}},[_c('strong',[_vm._v("Asian")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("2")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox29","name":"customCheckbox29"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox29"}},[_c('strong',[_vm._v("Other")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("3")])])])])])],1),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse6",modifiers:{"collapse6":true}}],staticClass:"facets__button",attrs:{"variant":"btn btn--select c-search-results__filter-btn"}},[_vm._v("Special Populations")]),_vm._v(" "),_c('b-collapse',{staticClass:"facets__options",attrs:{"id":"collapse6"}},[_c('ul',{staticClass:"c-search-results__filter-content"},[_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox30","name":"customCheckbox30"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox30"}},[_c('strong',[_vm._v("LGBTQ")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("8")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox31","name":"customCheckbox31"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox31"}},[_c('strong',[_vm._v("Veterans")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("3")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox32","name":"customCheckbox32"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox32"}},[_c('strong',[_vm._v("People Living w/ Disabilities")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("3")])])])])])],1),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse7",modifiers:{"collapse7":true}}],staticClass:"facets__button",attrs:{"variant":"btn btn--select c-search-results__filter-btn"}},[_vm._v("Gender")]),_vm._v(" "),_c('b-collapse',{staticClass:"facets__options",attrs:{"id":"collapse7"}},[_c('ul',{staticClass:"c-search-results__filter-content"},[_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox33","name":"customCheckbox33"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox33"}},[_c('strong',[_vm._v("All Genders")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("8")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox34","name":"customCheckbox34"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox34"}},[_c('strong',[_vm._v("Male")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("3")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox35","name":"customCheckbox35"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox35"}},[_c('strong',[_vm._v("Female")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("3")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox36","name":"customCheckbox36"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox36"}},[_c('strong',[_vm._v("Trangender")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("1")])])])])])],1),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse8",modifiers:{"collapse8":true}}],staticClass:"facets__button",attrs:{"variant":"btn btn--select c-search-results__filter-btn"}},[_vm._v("Age of Target Audience")]),_vm._v(" "),_c('b-collapse',{staticClass:"facets__options",attrs:{"id":"collapse8"}},[_c('ul',{staticClass:"c-search-results__filter-content"},[_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox37","name":"customCheckbox37"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox37"}},[_c('strong',[_vm._v("Youth")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("1")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox38","name":"customCheckbox38"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox38"}},[_c('strong',[_vm._v("Teen")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("6")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox39","name":"customCheckbox39"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox39"}},[_c('strong',[_vm._v("Adult")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("8")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__filter-item"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheckbox40","name":"customCheckbox40"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label c-search-results__filter-label",attrs:{"for":"customCheckbox40"}},[_c('strong',[_vm._v("Senior")])])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__filter-count"},[_c('p',[_vm._v("3")])])])])])],1),_vm._v(" "),_c('input',{staticClass:"my-3 btn btn-lg btn-danger btn-round w-100",attrs:{"type":"submit","value":"Update Search"}})])]),_vm._v(" "),_c('b-col',{staticClass:"d-lg-none",attrs:{"cols":"12"}},[_c('div',{staticClass:"nav-tabs w-100 mt-2 mb-4"})]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","lg":"9"}},[_c('ol',{staticClass:"c-search-results__list",staticStyle:{"counter-reset":"search-counter 9"}},[_c('li',{staticClass:"c-search-results__item"},[_c('div',{staticClass:"c-search-results__media"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/100x100?text=FPO'),expression:"'//placehold.it/100x100?text=FPO'"}],attrs:{"src":"//placehold.it/100x100?text=FPO","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__content"},[_c('a',{staticClass:"c-search-results__link",attrs:{"href":"#"}},[_c('span',{staticClass:"c-search-results__counter"}),_vm._v(" American "),_c('strong',{staticClass:"h-color--red"},[_vm._v("Stroke")]),_vm._v(" Association…\n                                ")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac orci bibendum, tincidunt justo vel, finibus dolor. Integer non ullamcorper ante. Nam feugiat turpis laoreet neque lobortis congue. Nunc feugiat lacinia tortor, et rutrum enim placerat et. Vestibulum ornare sem nibh, vel finibus ipsum ornare a.")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"/"}},[_vm._v("www.412foodrescue.com")])]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.viewmore1",modifiers:{"viewmore1":true}}],staticClass:"pl-0 pr-3",attrs:{"variant":"link btn-link--cta-toggle"}},[_c('span',{staticClass:"closed"},[_vm._v("View")]),_vm._v(" "),_c('span',{staticClass:"opened"},[_vm._v("Hide")]),_vm._v(" Details\n                                    ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"viewmore1"}},[_c('p',{staticClass:"pt-3"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac orci bibendum, tincidunt justo vel, finibus dolor. Integer non ullamcorper ante. Nam feugiat turpis laoreet neque lobortis congue. Nunc feugiat lacinia tortor, et rutrum enim placerat et. Vestibulum ornare sem nibh, vel finibus ipsum ornare a.")])])],1)]),_vm._v(" "),_c('li',{staticClass:"c-search-results__item"},[_c('div',{staticClass:"c-search-results__media"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/100x100?text=FPO'),expression:"'//placehold.it/100x100?text=FPO'"}],attrs:{"src":"//placehold.it/100x100?text=FPO","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__content"},[_c('a',{staticClass:"c-search-results__link",attrs:{"href":"#"}},[_c('span',{staticClass:"c-search-results__counter"}),_vm._v(" American "),_c('strong',{staticClass:"h-color--red"},[_vm._v("Stroke")]),_vm._v(" Association…\n                                ")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, "),_c('br'),_vm._v("consectetur adipiscing elit. Sed ac orci bibendum, tincidunt justo vel, finibus dolor. Integer non ullamcorper ante. Nam feugiat turpis laoreet neque lobortis congue. Nunc feugiat lacinia tortor, et rutrum enim placerat et. Vestibulum ornare sem nibh, vel finibus ipsum ornare a.")])])]),_vm._v(" "),_c('li',{staticClass:"c-search-results__item"},[_c('div',{staticClass:"c-search-results__media"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/100x100?text=FPO'),expression:"'//placehold.it/100x100?text=FPO'"}],attrs:{"src":"//placehold.it/100x100?text=FPO","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"c-search-results__content"},[_c('a',{staticClass:"c-search-results__link",attrs:{"href":"#"}},[_c('span',{staticClass:"c-search-results__counter"}),_vm._v(" American "),_c('strong',{staticClass:"h-color--red"},[_vm._v("Stroke")]),_vm._v(" Association…\n                                ")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac orci bibendum, tincidunt justo vel, finibus dolor. Integer non ullamcorper ante. Nam feugiat turpis laoreet neque lobortis congue. Nunc feugiat lacinia tortor, et rutrum enim placerat et. Vestibulum ornare sem nibh, vel finibus ipsum ornare a.")])])])]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Search Results Pagination"}},[_c('ul',{staticClass:"pagination pagination-lg pagination--page-count justify-content-center justify-content-lg-end"},[_c('li',{staticClass:"page-item disabled"},[_c('span',{staticClass:"page-link"},[_c('i',{staticClass:"icon-left-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_c('li',{staticClass:"page-item page-item--page-count"},[_vm._v("\n                                1 of 10\n                            ")]),_vm._v(" "),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"}},[_c('i',{staticClass:"icon-right-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-search-results__heading"},[_c('p',{staticClass:"h4 h-color--gray mb-4 mb-md-0"},[_c('i',[_vm._v("Results 1-10 of 24")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e695316_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_results_coveo_vue__ = __webpack_require__(1629);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e695316_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_results_coveo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"CoveoSearchInterface Coveostate CoveoComponentState CoveoComponentOptions CoveoQueryController CoveoHistoryController CoveoDebug coveo-after-initialization",staticStyle:{"display":"block"},attrs:{"id":"coveoC606340E"}},[_c('div',[_c('div',{staticClass:"coveo-main-section"},[_c('div',{staticClass:"coveo-search-section"},[_c('div',{attrs:{"id":"coveoBD1BA194_container"}},[_c('div',{staticClass:"CoveoSearchbox",attrs:{"id":"coveoBD1BA194"}},[_c('a',{staticClass:"CoveoSearchButton",attrs:{"aria-label":"Search"}},[_c('span',{staticClass:"coveo-search-button"},[_c('svg',{staticClass:"coveo-search-button-svg",attrs:{"enable-background":"new 0 0 20 20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{staticClass:"coveo-magnifier-circle-svg",attrs:{"d":"m8.368 16.736c-4.614 0-8.368-3.754-8.368-8.368s3.754-8.368 8.368-8.368 8.368 3.754 8.368 8.368-3.754 8.368-8.368 8.368m0-14.161c-3.195 0-5.793 2.599-5.793 5.793s2.599 5.793 5.793 5.793 5.793-2.599 5.793-5.793-2.599-5.793-5.793-5.793"}}),_vm._v(" "),_c('path',{attrs:{"d":"m18.713 20c-.329 0-.659-.126-.91-.377l-4.552-4.551c-.503-.503-.503-1.318 0-1.82.503-.503 1.318-.503 1.82 0l4.552 4.551c.503.503.503 1.318 0 1.82-.252.251-.581.377-.91.377"}})])])]),_vm._v(" "),_c('span',{staticClass:"coveo-search-button-loading"},[_c('svg',{staticClass:"coveo-search-button-loading-svg",attrs:{"enable-background":"new 0 0 18 18","viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m16.76 8.051c-.448 0-.855-.303-.969-.757-.78-3.117-3.573-5.294-6.791-5.294s-6.01 2.177-6.79 5.294c-.134.537-.679.861-1.213.727-.536-.134-.861-.677-.728-1.212 1.004-4.009 4.594-6.809 8.731-6.809 4.138 0 7.728 2.8 8.73 6.809.135.536-.191 1.079-.727 1.213-.081.02-.162.029-.243.029z"}}),_vm._v(" "),_c('path',{attrs:{"d":"m9 18c-4.238 0-7.943-3.007-8.809-7.149-.113-.541.234-1.071.774-1.184.541-.112 1.071.232 1.184.773.674 3.222 3.555 5.56 6.851 5.56s6.178-2.338 6.852-5.56c.113-.539.634-.892 1.184-.773.54.112.887.643.773 1.184-.866 4.142-4.57 7.149-8.809 7.149z"}})])])])]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"coveo-facet-column"},[_c('div',[_c('div',{staticClass:"CoveoFacet",attrs:{"id":"coveo5fe858c0"}},[_c('div',{staticClass:"coveo-facet-header"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"coveo-facet-header-settings-section"},[_c('div',{staticClass:"coveo-facet-header-eraser",attrs:{"title":"Clear Social Determinant"}},[_c('svg',{staticClass:"coveo-facet-header-eraser-svg",attrs:{"enable-background":"new 0 0 13 13","viewBox":"0 0 13 13","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m7.881 6.501 4.834-4.834c.38-.38.38-1.001 0-1.381s-1.001-.38-1.381 0l-4.834 4.834-4.834-4.835c-.38-.38-1.001-.38-1.381 0s-.38 1.001 0 1.381l4.834 4.834-4.834 4.834c-.38.38-.38 1.001 0 1.381s1.001.38 1.381 0l4.834-4.834 4.834 4.834c.38.38 1.001.38 1.381 0s .38-1.001 0-1.381z"}})])])]),_vm._v(" "),_c('div',{staticClass:"coveo-facet-header-settings",attrs:{"title":"Settings"}},[_c('svg',{staticClass:"coveo-facet-settings-more-svg",attrs:{"enable-background":"new 0 0 16 16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{staticClass:"coveo-more-background-svg",attrs:{"fill-opacity":"0","d":"m8.03.819c3.987 0 7.227 3.222 7.227 7.181s-3.239 7.181-7.227 7.181c-3.976 0-7.209-3.222-7.209-7.181s3.237-7.181 7.209-7.181"}}),_vm._v(" "),_c('path',{attrs:{"d":"m0 8c0 4.416 3.572 8 7.991 8 4.425 0 8.009-3.581 8.009-8 0-4.416-3.581-8-8.009-8-4.416 0-7.991 3.581-7.991 8m8.031-6.4c3.553 0 6.441 2.872 6.441 6.4s-2.887 6.4-6.441 6.4c-3.544 0-6.425-2.872-6.425-6.4s2.885-6.4 6.425-6.4"}}),_vm._v(" "),_c('path',{attrs:{"d":"m10.988 9.024c.551 0 1-.449 1-1s-.449-1-1-1-1 .449-1 1 .449 1 1 1"}}),_vm._v(" "),_c('path',{attrs:{"d":"m7.991 9c .551 0 1-.449 1-1s-.449-1-1-1-1 .449-1 1 .449 1 1 1"}}),_vm._v(" "),_c('path',{attrs:{"d":"m4.994 9c .551 0 1-.449 1-1s-.449-1-1-1-1 .449-1 1 .449 1 1 1"}})])])])])]),_vm._v(" "),_c('ul',{staticClass:"coveo-facet-values"},[_c('li',{staticClass:"coveo-facet-value coveo-facet-selectable"},[_c('label',{staticClass:"coveo-facet-value-label"},[_c('div',{staticClass:"coveo-facet-value-label-wrapper"},[_c('input',{attrs:{"type":"checkbox","form":"coveo-dummy-form"}}),_vm._v(" "),_c('div',{staticClass:"coveo-facet-value-checkbox",attrs:{"tabindex":"0"}},[_c('svg',{staticClass:"coveo-facet-value-checkbox-svg",attrs:{"enable-background":"new 0 0 11 11","viewBox":"0 0 11 11","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{staticClass:"coveo-more-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.083 4.583h-3.666v-3.666c0-.524-.393-.917-.917-.917s-.917.393-.917.917v3.667h-3.666c-.524-.001-.917.392-.917.916s.393.917.917.917h3.667v3.667c-.001.523.392.916.916.916s.917-.393.917-.917v-3.666h3.667c.523 0 .916-.393.916-.917-.001-.524-.394-.917-.917-.917z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-line-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10 6.5h-9c-.552 0-1-.448-1-1 0-.552.448-1 1-1h9c .552 0 1 .448 1 1 0 .552-.448 1-1 1z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-exclusion-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m9.233 7.989-2.489-2.489 2.489-2.489c.356-.356.356-.889 0-1.244-.356-.356-.889-.356-1.244 0l-2.489 2.489-2.489-2.489c-.356-.356-.889-.356-1.244 0-.356.356-.356.889 0 1.244l2.489 2.489-2.489 2.489c-.356.356-.356.889 0 1.244.356.356.889.356 1.244 0l2.489-2.489 2.489 2.489c.356.356.889.356 1.244 0 .356-.355.356-.889 0-1.244z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-hook-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.252 2.213c-.155-.142-.354-.211-.573-.213-.215.005-.414.091-.561.24l-4.873 4.932-2.39-2.19c-.154-.144-.385-.214-.57-.214-.214.004-.415.09-.563.24-.148.147-.227.343-.222.549.005.207.093.4.249.542l2.905 2.662c.168.154.388.239.618.239h.022.003c.237-.007.457-.101.618-.266l5.362-5.428c.148-.148.228-.344.223-.551s-.093-.399-.248-.542z"}})])])]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-count"},[_vm._v("4")]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-caption",attrs:{"title":"Health and Healthcare"}},[_vm._v("Health and Healthcare")])])])]),_vm._v(" "),_c('li',{staticClass:"coveo-facet-value coveo-facet-selectable"},[_c('label',{staticClass:"coveo-facet-value-label"},[_c('div',{staticClass:"coveo-facet-value-label-wrapper"},[_c('input',{attrs:{"type":"checkbox","form":"coveo-dummy-form"}}),_vm._v(" "),_c('div',{staticClass:"coveo-facet-value-checkbox",attrs:{"tabindex":"0"}},[_c('svg',{staticClass:"coveo-facet-value-checkbox-svg",attrs:{"enable-background":"new 0 0 11 11","viewBox":"0 0 11 11","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{staticClass:"coveo-more-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.083 4.583h-3.666v-3.666c0-.524-.393-.917-.917-.917s-.917.393-.917.917v3.667h-3.666c-.524-.001-.917.392-.917.916s.393.917.917.917h3.667v3.667c-.001.523.392.916.916.916s.917-.393.917-.917v-3.666h3.667c.523 0 .916-.393.916-.917-.001-.524-.394-.917-.917-.917z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-line-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10 6.5h-9c-.552 0-1-.448-1-1 0-.552.448-1 1-1h9c .552 0 1 .448 1 1 0 .552-.448 1-1 1z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-exclusion-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m9.233 7.989-2.489-2.489 2.489-2.489c.356-.356.356-.889 0-1.244-.356-.356-.889-.356-1.244 0l-2.489 2.489-2.489-2.489c-.356-.356-.889-.356-1.244 0-.356.356-.356.889 0 1.244l2.489 2.489-2.489 2.489c-.356.356-.356.889 0 1.244.356.356.889.356 1.244 0l2.489-2.489 2.489 2.489c.356.356.889.356 1.244 0 .356-.355.356-.889 0-1.244z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-hook-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.252 2.213c-.155-.142-.354-.211-.573-.213-.215.005-.414.091-.561.24l-4.873 4.932-2.39-2.19c-.154-.144-.385-.214-.57-.214-.214.004-.415.09-.563.24-.148.147-.227.343-.222.549.005.207.093.4.249.542l2.905 2.662c.168.154.388.239.618.239h.022.003c.237-.007.457-.101.618-.266l5.362-5.428c.148-.148.228-.344.223-.551s-.093-.399-.248-.542z"}})])])]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-count"},[_vm._v("3")]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-caption",attrs:{"title":"Economic Stability"}},[_vm._v("Economic Stability")])])])]),_vm._v(" "),_c('li',{staticClass:"coveo-facet-value coveo-facet-selectable"},[_c('label',{staticClass:"coveo-facet-value-label"},[_c('div',{staticClass:"coveo-facet-value-label-wrapper"},[_c('input',{attrs:{"type":"checkbox","form":"coveo-dummy-form"}}),_vm._v(" "),_c('div',{staticClass:"coveo-facet-value-checkbox",attrs:{"tabindex":"0"}},[_c('svg',{staticClass:"coveo-facet-value-checkbox-svg",attrs:{"enable-background":"new 0 0 11 11","viewBox":"0 0 11 11","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{staticClass:"coveo-more-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.083 4.583h-3.666v-3.666c0-.524-.393-.917-.917-.917s-.917.393-.917.917v3.667h-3.666c-.524-.001-.917.392-.917.916s.393.917.917.917h3.667v3.667c-.001.523.392.916.916.916s.917-.393.917-.917v-3.666h3.667c.523 0 .916-.393.916-.917-.001-.524-.394-.917-.917-.917z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-line-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10 6.5h-9c-.552 0-1-.448-1-1 0-.552.448-1 1-1h9c .552 0 1 .448 1 1 0 .552-.448 1-1 1z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-exclusion-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m9.233 7.989-2.489-2.489 2.489-2.489c.356-.356.356-.889 0-1.244-.356-.356-.889-.356-1.244 0l-2.489 2.489-2.489-2.489c-.356-.356-.889-.356-1.244 0-.356.356-.356.889 0 1.244l2.489 2.489-2.489 2.489c-.356.356-.356.889 0 1.244.356.356.889.356 1.244 0l2.489-2.489 2.489 2.489c.356.356.889.356 1.244 0 .356-.355.356-.889 0-1.244z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-hook-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.252 2.213c-.155-.142-.354-.211-.573-.213-.215.005-.414.091-.561.24l-4.873 4.932-2.39-2.19c-.154-.144-.385-.214-.57-.214-.214.004-.415.09-.563.24-.148.147-.227.343-.222.549.005.207.093.4.249.542l2.905 2.662c.168.154.388.239.618.239h.022.003c.237-.007.457-.101.618-.266l5.362-5.428c.148-.148.228-.344.223-.551s-.093-.399-.248-.542z"}})])])]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-count"},[_vm._v("3")]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-caption",attrs:{"title":"Education"}},[_vm._v("Education")])])])]),_vm._v(" "),_c('li',{staticClass:"coveo-facet-value coveo-facet-selectable"},[_c('label',{staticClass:"coveo-facet-value-label"},[_c('div',{staticClass:"coveo-facet-value-label-wrapper"},[_c('input',{attrs:{"type":"checkbox","form":"coveo-dummy-form"}}),_vm._v(" "),_c('div',{staticClass:"coveo-facet-value-checkbox",attrs:{"tabindex":"0"}},[_c('svg',{staticClass:"coveo-facet-value-checkbox-svg",attrs:{"enable-background":"new 0 0 11 11","viewBox":"0 0 11 11","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{staticClass:"coveo-more-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.083 4.583h-3.666v-3.666c0-.524-.393-.917-.917-.917s-.917.393-.917.917v3.667h-3.666c-.524-.001-.917.392-.917.916s.393.917.917.917h3.667v3.667c-.001.523.392.916.916.916s.917-.393.917-.917v-3.666h3.667c.523 0 .916-.393.916-.917-.001-.524-.394-.917-.917-.917z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-line-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10 6.5h-9c-.552 0-1-.448-1-1 0-.552.448-1 1-1h9c .552 0 1 .448 1 1 0 .552-.448 1-1 1z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-exclusion-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m9.233 7.989-2.489-2.489 2.489-2.489c.356-.356.356-.889 0-1.244-.356-.356-.889-.356-1.244 0l-2.489 2.489-2.489-2.489c-.356-.356-.889-.356-1.244 0-.356.356-.356.889 0 1.244l2.489 2.489-2.489 2.489c-.356.356-.356.889 0 1.244.356.356.889.356 1.244 0l2.489-2.489 2.489 2.489c.356.356.889.356 1.244 0 .356-.355.356-.889 0-1.244z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-hook-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.252 2.213c-.155-.142-.354-.211-.573-.213-.215.005-.414.091-.561.24l-4.873 4.932-2.39-2.19c-.154-.144-.385-.214-.57-.214-.214.004-.415.09-.563.24-.148.147-.227.343-.222.549.005.207.093.4.249.542l2.905 2.662c.168.154.388.239.618.239h.022.003c.237-.007.457-.101.618-.266l5.362-5.428c.148-.148.228-.344.223-.551s-.093-.399-.248-.542z"}})])])]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-count"},[_vm._v("2")]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-caption",attrs:{"title":"Neighborhood and Built Environment"}},[_vm._v("Neighborhood and Built Environment")])])])]),_vm._v(" "),_c('li',{staticClass:"coveo-facet-value coveo-facet-selectable"},[_c('label',{staticClass:"coveo-facet-value-label"},[_c('div',{staticClass:"coveo-facet-value-label-wrapper"},[_c('input',{attrs:{"type":"checkbox","form":"coveo-dummy-form"}}),_vm._v(" "),_c('div',{staticClass:"coveo-facet-value-checkbox",attrs:{"tabindex":"0"}},[_c('svg',{staticClass:"coveo-facet-value-checkbox-svg",attrs:{"enable-background":"new 0 0 11 11","viewBox":"0 0 11 11","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{staticClass:"coveo-more-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.083 4.583h-3.666v-3.666c0-.524-.393-.917-.917-.917s-.917.393-.917.917v3.667h-3.666c-.524-.001-.917.392-.917.916s.393.917.917.917h3.667v3.667c-.001.523.392.916.916.916s.917-.393.917-.917v-3.666h3.667c.523 0 .916-.393.916-.917-.001-.524-.394-.917-.917-.917z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-line-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10 6.5h-9c-.552 0-1-.448-1-1 0-.552.448-1 1-1h9c .552 0 1 .448 1 1 0 .552-.448 1-1 1z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-exclusion-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m9.233 7.989-2.489-2.489 2.489-2.489c.356-.356.356-.889 0-1.244-.356-.356-.889-.356-1.244 0l-2.489 2.489-2.489-2.489c-.356-.356-.889-.356-1.244 0-.356.356-.356.889 0 1.244l2.489 2.489-2.489 2.489c-.356.356-.356.889 0 1.244.356.356.889.356 1.244 0l2.489-2.489 2.489 2.489c.356.356.889.356 1.244 0 .356-.355.356-.889 0-1.244z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-hook-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.252 2.213c-.155-.142-.354-.211-.573-.213-.215.005-.414.091-.561.24l-4.873 4.932-2.39-2.19c-.154-.144-.385-.214-.57-.214-.214.004-.415.09-.563.24-.148.147-.227.343-.222.549.005.207.093.4.249.542l2.905 2.662c.168.154.388.239.618.239h.022.003c.237-.007.457-.101.618-.266l5.362-5.428c.148-.148.228-.344.223-.551s-.093-.399-.248-.542z"}})])])]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-count"},[_vm._v("2")]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-caption",attrs:{"title":"Social and Community Context"}},[_vm._v("Social and Community Context")])])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-facet-footer coveo-facet-empty"},[_c('div',{staticClass:"coveo-facet-less",attrs:{"tab-index":"0"}},[_c('span',{staticClass:"coveo-facet-less-icon"},[_c('svg',{staticClass:"coveo-facet-less-icon-svg",attrs:{"enable-background":"new 0 0 10 6","viewBox":"0 0 10 6","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m5 .068c.222 0 .443.084.612.253l4.134 4.134c.338.338.338.886 0 1.224s-.886.338-1.224 0l-3.522-3.521-3.523 3.521c-.336.338-.886.338-1.224 0s-.337-.886.001-1.224l4.134-4.134c.168-.169.39-.253.612-.253z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-facet-more",attrs:{"tabindex":"0"}},[_c('span',{staticClass:"coveo-facet-more-icon"},[_c('svg',{staticClass:"coveo-facet-more-icon-svg",attrs:{"enable-background":"new 0 0 10 6","viewBox":"0 0 10 6","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m5 5.932c-.222 0-.443-.084-.612-.253l-4.134-4.134c-.338-.338-.338-.886 0-1.224s.886-.338 1.224 0l3.522 3.521 3.523-3.521c.336-.338.886-.338 1.224 0s .337.886-.001 1.224l-4.135 4.134c-.168.169-.39.253-.611.253z"}})])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-results-column"},[_c('div',{staticClass:"coveo-results-header"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"coveo-sort-section"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"coveo-sort-container"},[_c('span',{staticClass:"CoveoSort",attrs:{"id":"coveo8BF15155","d":"","tabindex":"0"}},[_vm._v("Date\n                                    "),_c('span',{staticClass:"coveo-icon"},[_c('span',{staticClass:"coveo-sort-icon-ascending"},[_c('svg',{staticClass:"coveo-sort-icon-ascending-svg",attrs:{"enable-background":"new 0 0 10 6","viewBox":"0 0 10 6","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m5 .068c.222 0 .443.084.612.253l4.134 4.134c.338.338.338.886 0 1.224s-.886.338-1.224 0l-3.522-3.521-3.523 3.521c-.336.338-.886.338-1.224 0s-.337-.886.001-1.224l4.134-4.134c.168-.169.39-.253.612-.253z"}})])])]),_c('span',{staticClass:"coveo-sort-icon-descending"},[_c('svg',{staticClass:"coveo-sort-icon-descending-svg",attrs:{"enable-background":"new 0 0 10 6","viewBox":"0 0 10 6","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m5 5.932c-.222 0-.443-.084-.612-.253l-4.134-4.134c-.338-.338-.338-.886 0-1.224s.886-.338 1.224 0l3.522 3.521 3.523-3.521c.336-.338.886-.338 1.224 0s .337.886-.001 1.224l-4.135 4.134c-.168.169-.39.253-.611.253z"}})])])])])])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"CoveoPager"},[_c('ul',{staticClass:"coveo-pager-list"},[_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('li',{staticClass:"coveo-pager-next coveo-pager-anchor coveo-pager-list-item"},[_c('a',{attrs:{"title":"Next"}},[_c('span',{staticClass:"coveo-pager-next-icon"},[_c('svg',{staticClass:"coveo-pager-next-icon-svg",attrs:{"enable-background":"new 0 0 11 20","viewBox":"0 0 11 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m .308 18.189c-.412.413-.411 1.086 0 1.5.2.201.465.311.746.311.282 0 .547-.11.747-.31l8.891-8.939c.199-.2.307-.466.307-.75 0-.286-.109-.551-.305-.748l-8.893-8.942c-.199-.2-.465-.311-.747-.311-.001 0-.001 0-.001 0-.281 0-.546.11-.745.309-.198.201-.308.468-.308.753 0 .284.11.548.306.745l8.145 8.193z"}})])])])])])])]),_vm._v(" "),_vm._m(7)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CoveoOmnibox coveo-query-syntax-disabled magic-box"},[_c('div',{staticClass:"magic-box-input"},[_c('div',{staticClass:"magic-box-underlay"},[_c('span',{staticClass:"magic-box-highlight-container"},[_c('span',[_c('span')])]),_vm._v(" "),_c('span',{staticClass:"magic-box-ghost-text"})]),_vm._v(" "),_c('input',{attrs:{"spellcheck":"false","form":"coveo-dummy-form","autocomplete":"off"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coveo-facet-header-title-section"},[_c('div',{staticClass:"coveo-facet-header-title",attrs:{"title":"Social Determinant"}},[_vm._v("Social Determinant")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coveo-summary-section"},[_c('span',{staticClass:"CoveoQuerySummary"},[_c('span',[_vm._v("Results \n                                    "),_c('span',{staticClass:"coveo-highlight"},[_vm._v("1")]),_vm._v("-"),_c('span',{staticClass:"coveo-highlight"},[_vm._v("10")]),_vm._v(" of "),_c('span',{staticClass:"coveo-highlight"},[_vm._v("20")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coveo-sort-container"},[_c('span',{staticClass:"CoveoSort coveo-selected",attrs:{"id":"coveo62DF1983","tabindex":"0"}},[_vm._v("Relevancy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"CoveoResultList"},[_c('div',{staticClass:"coveo-result-list-container coveo-list-layout-container"},[_c('div',{staticClass:"coveo-list-layout CoveoResult"},[_c('div',{staticClass:"coveo-result-frame coveoforsitecore-template"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell coveo-quick-view-container"},[_c('span',{},[_c('img',{attrs:{"src":"assets/aha_heart.svg","alt":"American Heart Association - badge","width":"200","height":"256"}})])]),_vm._v(" "),_c('div',{staticClass:"coveo-result-cell coveoforsitecore-information-section"},[_c('div',{staticClass:"d-md-flex"},[_c('div',{staticClass:"col-md-9 col-lg-8 col-xl-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('div',{staticClass:"coveo-title"},[_c('a',{staticClass:"CoveoResultLink",attrs:{"tabindex":"0","href":"https://sitecoretest.empoweredtoserve.org:443/en/community-innovation-exchange/purchase-options"}},[_vm._v("\n                                                                            Purchase Options | American Heart Association\n                                                                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('span',{staticClass:"CoveoExcerpt"},[_vm._v("\n                                                                        1 ... Lorem ipsum dolor sit amet, consectetur adipiscing elit ... Text Promo 1 ... Text Promo 2... Text Promo 3 ... Find a Training Center Near You ... US Training Centers\n                                                                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-lg-4 col-xl-3 mt-3"},[_c('div',{staticClass:"row justify-content-md-end"},[_c('a',{staticClass:"btn btn-primary btn-round ml-md-3 px-3",attrs:{"href":"#"}},[_vm._v("Buy Now")])])])]),_vm._v(" "),_c('div',{staticClass:"mt-3 mt-3-icon-container"},[_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/classroom.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("Classroom")])]),_vm._v(" "),_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/cme.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("CME/CE")])]),_vm._v(" "),_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/course-completion-card.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("Course Completion")])]),_vm._v(" "),_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/instructors.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("Healthcore Professionals")])]),_vm._v(" "),_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/country/german-flag.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("German")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-list-layout CoveoResult"},[_c('div',{staticClass:"coveo-result-frame coveoforsitecore-template"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell coveo-quick-view-container"},[_c('span',{},[_c('img',{attrs:{"src":"assets/aha_heart.svg","alt":"American Heart Association - badge","width":"200","height":"256"}})])]),_vm._v(" "),_c('div',{staticClass:"coveo-result-cell coveoforsitecore-information-section"},[_c('div',{staticClass:"d-md-flex"},[_c('div',{staticClass:"col-md-9 col-lg-8 col-xl-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('div',{staticClass:"coveo-title"},[_c('a',{staticClass:"CoveoResultLink",attrs:{"tabindex":"0","href":"https://sitecoretest.empoweredtoserve.org:443/en/community-innovation-exchange/purchase-options"}},[_vm._v("\n                                                                            Purchase Options | American Heart Association\n                                                                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('span',{staticClass:"CoveoExcerpt"},[_vm._v("\n                                                                        1 ... Lorem ipsum dolor sit amet, consectetur adipiscing elit ... Text Promo 1 ... Text Promo 2... Text Promo 3 ... Find a Training Center Near You ... US Training Centers\n                                                                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-lg-4 col-xl-3 mt-3"},[_c('div',{staticClass:"row justify-content-md-end"},[_c('div',{staticClass:"btn-group dropdown"},[_c('button',{staticClass:"btn btn-primary btn-round px-3 dropdown-toggle",attrs:{"type":"button","vjs-dropdown":"ddown1"}},[_vm._v("See All Buying Options")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"id":"ddown1"}},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#","role":"menuitem"}},[_c('span',{staticClass:"c-cta c-cta--arrow"},[_vm._v("Option A")])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_c('span',{staticClass:"c-cta c-cta--arrow"},[_vm._v("Long B Option is Really Long")])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_c('span',{staticClass:"c-cta c-cta--arrow"},[_vm._v("Option C")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/online-classroom.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("Online + Classroom")])]),_vm._v(" "),_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/cme.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("CME/CE")])]),_vm._v(" "),_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/course-completion-card.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("Course Completion")])]),_vm._v(" "),_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/healthcare-professionals.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("Healthcare Professionals")])]),_vm._v(" "),_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/country/us-flag.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("English")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-list-layout CoveoResult"},[_c('div',{staticClass:"coveo-result-frame coveoforsitecore-template"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell coveo-quick-view-container"},[_c('span',{},[_c('img',{attrs:{"src":"assets/aha_heart.svg","alt":"American Heart Association - badge","width":"200","height":"256"}})])]),_vm._v(" "),_c('div',{staticClass:"coveo-result-cell coveoforsitecore-information-section"},[_c('div',{staticClass:"d-md-flex"},[_c('div',{staticClass:"col-md-9 col-lg-8 col-xl-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('div',{staticClass:"coveo-title"},[_c('a',{staticClass:"CoveoResultLink",attrs:{"tabindex":"0","href":"https://sitecoretest.empoweredtoserve.org:443/en/community-innovation-exchange/purchase-options"}},[_vm._v("\n                                                                            Purchase Options | American Heart Association\n                                                                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-result-row"},[_c('div',{staticClass:"coveo-result-cell"},[_c('span',{staticClass:"CoveoExcerpt"},[_vm._v("\n                                                                        1 ... Lorem ipsum dolor sit amet, consectetur adipiscing elit ... Text Promo 1 ... Text Promo 2... Text Promo 3 ... Find a Training Center Near You ... US Training Centers\n                                                                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-lg-4 col-xl-3 mt-3"},[_c('div',{staticClass:"row justify-content-md-end"},[_c('div',{staticClass:"btn-group dropdown"},[_c('button',{staticClass:"btn btn-primary btn-round px-3 dropdown-toggle",attrs:{"type":"button","vjs-dropdown":"ddown2"}},[_vm._v("See All Buying Options")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"id":"ddown2"}},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#","role":"menuitem"}},[_c('span',{staticClass:"c-cta c-cta--arrow"},[_vm._v("Option A")])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_c('span',{staticClass:"c-cta c-cta--arrow"},[_vm._v("Option B")])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_c('span',{staticClass:"c-cta c-cta--arrow"},[_vm._v("Option C")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/online-classroom.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("Online + Classroom")])]),_vm._v(" "),_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/cme.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("CME/CE")])]),_vm._v(" "),_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/course-completion-card.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("Course Completion")])]),_vm._v(" "),_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/healthcare-professionals.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("Healthcare Professionals")])]),_vm._v(" "),_c('div',{staticClass:"c-label c-label--inline-tag"},[_c('div',{staticClass:"c-label__icon"},[_c('img',{attrs:{"src":"assets/images/course-icons/country/us-flag.png"}})]),_vm._v(" "),_c('p',{staticClass:"m-0 d-inline"},[_vm._v("English")])])])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"coveo-pager-list-item coveo-active",attrs:{"tabindex":"0"}},[_c('a',{staticClass:"coveo-pager-list-item-text coveo-pager-anchor"},[_vm._v("1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"coveo-pager-list-item",attrs:{"tabindex":"0"}},[_c('a',{staticClass:"coveo-pager-list-item-text coveo-pager-anchor"},[_vm._v("2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CoveoResultsPerPage"},[_c('span',{staticClass:"coveo-results-per-page-text"},[_vm._v("Results per page")]),_vm._v(" "),_c('ul',{staticClass:"coveo-results-per-page-list"},[_c('li',{staticClass:"coveo-results-per-page-list-item coveo-active",attrs:{"tabindex":"0"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("10")])]),_vm._v(" "),_c('li',{staticClass:"coveo-results-per-page-list-item",attrs:{"tabindex":"0"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("25")])]),_vm._v(" "),_c('li',{staticClass:"coveo-results-per-page-list-item",attrs:{"tabindex":"0"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("50")])]),_vm._v(" "),_c('li',{staticClass:"coveo-results-per-page-list-item",attrs:{"tabindex":"0"}},[_c('a',{staticClass:"coveo-results-per-page-list-item-text"},[_vm._v("100")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b00266e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_results_coveo_error_vue__ = __webpack_require__(1631);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b00266e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_results_coveo_error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"CoveoSearchInterface Coveostate CoveoComponentState CoveoComponentOptions CoveoQueryController CoveoHistoryController CoveoDebug coveo-after-initialization",staticStyle:{"display":"block"},attrs:{"id":"coveoC606340E"}},[_c('div',[_c('div',{staticClass:"coveo-main-section"},[_c('div',{staticClass:"coveo-search-section"},[_c('div',{attrs:{"id":"coveoBD1BA194_container"}},[_c('div',{staticClass:"CoveoSearchbox",attrs:{"id":"coveoBD1BA194"}},[_c('a',{staticClass:"CoveoSearchButton",attrs:{"aria-label":"Search"}},[_c('span',{staticClass:"coveo-search-button"},[_c('svg',{staticClass:"coveo-search-button-svg",attrs:{"enable-background":"new 0 0 20 20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{staticClass:"coveo-magnifier-circle-svg",attrs:{"d":"m8.368 16.736c-4.614 0-8.368-3.754-8.368-8.368s3.754-8.368 8.368-8.368 8.368 3.754 8.368 8.368-3.754 8.368-8.368 8.368m0-14.161c-3.195 0-5.793 2.599-5.793 5.793s2.599 5.793 5.793 5.793 5.793-2.599 5.793-5.793-2.599-5.793-5.793-5.793"}}),_vm._v(" "),_c('path',{attrs:{"d":"m18.713 20c-.329 0-.659-.126-.91-.377l-4.552-4.551c-.503-.503-.503-1.318 0-1.82.503-.503 1.318-.503 1.82 0l4.552 4.551c.503.503.503 1.318 0 1.82-.252.251-.581.377-.91.377"}})])])]),_vm._v(" "),_c('span',{staticClass:"coveo-search-button-loading"},[_c('svg',{staticClass:"coveo-search-button-loading-svg",attrs:{"enable-background":"new 0 0 18 18","viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m16.76 8.051c-.448 0-.855-.303-.969-.757-.78-3.117-3.573-5.294-6.791-5.294s-6.01 2.177-6.79 5.294c-.134.537-.679.861-1.213.727-.536-.134-.861-.677-.728-1.212 1.004-4.009 4.594-6.809 8.731-6.809 4.138 0 7.728 2.8 8.73 6.809.135.536-.191 1.079-.727 1.213-.081.02-.162.029-.243.029z"}}),_vm._v(" "),_c('path',{attrs:{"d":"m9 18c-4.238 0-7.943-3.007-8.809-7.149-.113-.541.234-1.071.774-1.184.541-.112 1.071.232 1.184.773.674 3.222 3.555 5.56 6.851 5.56s6.178-2.338 6.852-5.56c.113-.539.634-.892 1.184-.773.54.112.887.643.773 1.184-.866 4.142-4.57 7.149-8.809 7.149z"}})])])])]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"coveo-facet-column"},[_c('div',[_c('div',{staticClass:"CoveoFacet",attrs:{"id":"coveo5fe858c0"}},[_c('div',{staticClass:"coveo-facet-header"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"coveo-facet-header-settings-section"},[_c('div',{staticClass:"coveo-facet-header-eraser",attrs:{"title":"Clear Social Determinant"}},[_c('svg',{staticClass:"coveo-facet-header-eraser-svg",attrs:{"enable-background":"new 0 0 13 13","viewBox":"0 0 13 13","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m7.881 6.501 4.834-4.834c.38-.38.38-1.001 0-1.381s-1.001-.38-1.381 0l-4.834 4.834-4.834-4.835c-.38-.38-1.001-.38-1.381 0s-.38 1.001 0 1.381l4.834 4.834-4.834 4.834c-.38.38-.38 1.001 0 1.381s1.001.38 1.381 0l4.834-4.834 4.834 4.834c.38.38 1.001.38 1.381 0s .38-1.001 0-1.381z"}})])])]),_vm._v(" "),_c('div',{staticClass:"coveo-facet-header-settings",attrs:{"title":"Settings"}},[_c('svg',{staticClass:"coveo-facet-settings-more-svg",attrs:{"enable-background":"new 0 0 16 16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{staticClass:"coveo-more-background-svg",attrs:{"fill-opacity":"0","d":"m8.03.819c3.987 0 7.227 3.222 7.227 7.181s-3.239 7.181-7.227 7.181c-3.976 0-7.209-3.222-7.209-7.181s3.237-7.181 7.209-7.181"}}),_vm._v(" "),_c('path',{attrs:{"d":"m0 8c0 4.416 3.572 8 7.991 8 4.425 0 8.009-3.581 8.009-8 0-4.416-3.581-8-8.009-8-4.416 0-7.991 3.581-7.991 8m8.031-6.4c3.553 0 6.441 2.872 6.441 6.4s-2.887 6.4-6.441 6.4c-3.544 0-6.425-2.872-6.425-6.4s2.885-6.4 6.425-6.4"}}),_vm._v(" "),_c('path',{attrs:{"d":"m10.988 9.024c.551 0 1-.449 1-1s-.449-1-1-1-1 .449-1 1 .449 1 1 1"}}),_vm._v(" "),_c('path',{attrs:{"d":"m7.991 9c .551 0 1-.449 1-1s-.449-1-1-1-1 .449-1 1 .449 1 1 1"}}),_vm._v(" "),_c('path',{attrs:{"d":"m4.994 9c .551 0 1-.449 1-1s-.449-1-1-1-1 .449-1 1 .449 1 1 1"}})])])])])]),_vm._v(" "),_c('ul',{staticClass:"coveo-facet-values"},[_c('li',{staticClass:"coveo-facet-value coveo-facet-selectable"},[_c('label',{staticClass:"coveo-facet-value-label"},[_c('div',{staticClass:"coveo-facet-value-label-wrapper"},[_c('input',{attrs:{"type":"checkbox","form":"coveo-dummy-form"}}),_vm._v(" "),_c('div',{staticClass:"coveo-facet-value-checkbox",attrs:{"tabindex":"0"}},[_c('svg',{staticClass:"coveo-facet-value-checkbox-svg",attrs:{"enable-background":"new 0 0 11 11","viewBox":"0 0 11 11","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{staticClass:"coveo-more-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.083 4.583h-3.666v-3.666c0-.524-.393-.917-.917-.917s-.917.393-.917.917v3.667h-3.666c-.524-.001-.917.392-.917.916s.393.917.917.917h3.667v3.667c-.001.523.392.916.916.916s.917-.393.917-.917v-3.666h3.667c.523 0 .916-.393.916-.917-.001-.524-.394-.917-.917-.917z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-line-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10 6.5h-9c-.552 0-1-.448-1-1 0-.552.448-1 1-1h9c .552 0 1 .448 1 1 0 .552-.448 1-1 1z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-exclusion-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m9.233 7.989-2.489-2.489 2.489-2.489c.356-.356.356-.889 0-1.244-.356-.356-.889-.356-1.244 0l-2.489 2.489-2.489-2.489c-.356-.356-.889-.356-1.244 0-.356.356-.356.889 0 1.244l2.489 2.489-2.489 2.489c-.356.356-.356.889 0 1.244.356.356.889.356 1.244 0l2.489-2.489 2.489 2.489c.356.356.889.356 1.244 0 .356-.355.356-.889 0-1.244z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-hook-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.252 2.213c-.155-.142-.354-.211-.573-.213-.215.005-.414.091-.561.24l-4.873 4.932-2.39-2.19c-.154-.144-.385-.214-.57-.214-.214.004-.415.09-.563.24-.148.147-.227.343-.222.549.005.207.093.4.249.542l2.905 2.662c.168.154.388.239.618.239h.022.003c.237-.007.457-.101.618-.266l5.362-5.428c.148-.148.228-.344.223-.551s-.093-.399-.248-.542z"}})])])]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-count"},[_vm._v("4")]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-caption",attrs:{"title":"Health and Healthcare"}},[_vm._v("Health and Healthcare")])])])]),_vm._v(" "),_c('li',{staticClass:"coveo-facet-value coveo-facet-selectable"},[_c('label',{staticClass:"coveo-facet-value-label"},[_c('div',{staticClass:"coveo-facet-value-label-wrapper"},[_c('input',{attrs:{"type":"checkbox","form":"coveo-dummy-form"}}),_vm._v(" "),_c('div',{staticClass:"coveo-facet-value-checkbox",attrs:{"tabindex":"0"}},[_c('svg',{staticClass:"coveo-facet-value-checkbox-svg",attrs:{"enable-background":"new 0 0 11 11","viewBox":"0 0 11 11","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{staticClass:"coveo-more-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.083 4.583h-3.666v-3.666c0-.524-.393-.917-.917-.917s-.917.393-.917.917v3.667h-3.666c-.524-.001-.917.392-.917.916s.393.917.917.917h3.667v3.667c-.001.523.392.916.916.916s.917-.393.917-.917v-3.666h3.667c.523 0 .916-.393.916-.917-.001-.524-.394-.917-.917-.917z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-line-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10 6.5h-9c-.552 0-1-.448-1-1 0-.552.448-1 1-1h9c .552 0 1 .448 1 1 0 .552-.448 1-1 1z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-exclusion-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m9.233 7.989-2.489-2.489 2.489-2.489c.356-.356.356-.889 0-1.244-.356-.356-.889-.356-1.244 0l-2.489 2.489-2.489-2.489c-.356-.356-.889-.356-1.244 0-.356.356-.356.889 0 1.244l2.489 2.489-2.489 2.489c-.356.356-.356.889 0 1.244.356.356.889.356 1.244 0l2.489-2.489 2.489 2.489c.356.356.889.356 1.244 0 .356-.355.356-.889 0-1.244z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-hook-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.252 2.213c-.155-.142-.354-.211-.573-.213-.215.005-.414.091-.561.24l-4.873 4.932-2.39-2.19c-.154-.144-.385-.214-.57-.214-.214.004-.415.09-.563.24-.148.147-.227.343-.222.549.005.207.093.4.249.542l2.905 2.662c.168.154.388.239.618.239h.022.003c.237-.007.457-.101.618-.266l5.362-5.428c.148-.148.228-.344.223-.551s-.093-.399-.248-.542z"}})])])]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-count"},[_vm._v("3")]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-caption",attrs:{"title":"Economic Stability"}},[_vm._v("Economic Stability")])])])]),_vm._v(" "),_c('li',{staticClass:"coveo-facet-value coveo-facet-selectable"},[_c('label',{staticClass:"coveo-facet-value-label"},[_c('div',{staticClass:"coveo-facet-value-label-wrapper"},[_c('input',{attrs:{"type":"checkbox","form":"coveo-dummy-form"}}),_vm._v(" "),_c('div',{staticClass:"coveo-facet-value-checkbox",attrs:{"tabindex":"0"}},[_c('svg',{staticClass:"coveo-facet-value-checkbox-svg",attrs:{"enable-background":"new 0 0 11 11","viewBox":"0 0 11 11","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{staticClass:"coveo-more-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.083 4.583h-3.666v-3.666c0-.524-.393-.917-.917-.917s-.917.393-.917.917v3.667h-3.666c-.524-.001-.917.392-.917.916s.393.917.917.917h3.667v3.667c-.001.523.392.916.916.916s.917-.393.917-.917v-3.666h3.667c.523 0 .916-.393.916-.917-.001-.524-.394-.917-.917-.917z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-line-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10 6.5h-9c-.552 0-1-.448-1-1 0-.552.448-1 1-1h9c .552 0 1 .448 1 1 0 .552-.448 1-1 1z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-exclusion-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m9.233 7.989-2.489-2.489 2.489-2.489c.356-.356.356-.889 0-1.244-.356-.356-.889-.356-1.244 0l-2.489 2.489-2.489-2.489c-.356-.356-.889-.356-1.244 0-.356.356-.356.889 0 1.244l2.489 2.489-2.489 2.489c-.356.356-.356.889 0 1.244.356.356.889.356 1.244 0l2.489-2.489 2.489 2.489c.356.356.889.356 1.244 0 .356-.355.356-.889 0-1.244z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-hook-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.252 2.213c-.155-.142-.354-.211-.573-.213-.215.005-.414.091-.561.24l-4.873 4.932-2.39-2.19c-.154-.144-.385-.214-.57-.214-.214.004-.415.09-.563.24-.148.147-.227.343-.222.549.005.207.093.4.249.542l2.905 2.662c.168.154.388.239.618.239h.022.003c.237-.007.457-.101.618-.266l5.362-5.428c.148-.148.228-.344.223-.551s-.093-.399-.248-.542z"}})])])]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-count"},[_vm._v("3")]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-caption",attrs:{"title":"Education"}},[_vm._v("Education")])])])]),_vm._v(" "),_c('li',{staticClass:"coveo-facet-value coveo-facet-selectable"},[_c('label',{staticClass:"coveo-facet-value-label"},[_c('div',{staticClass:"coveo-facet-value-label-wrapper"},[_c('input',{attrs:{"type":"checkbox","form":"coveo-dummy-form"}}),_vm._v(" "),_c('div',{staticClass:"coveo-facet-value-checkbox",attrs:{"tabindex":"0"}},[_c('svg',{staticClass:"coveo-facet-value-checkbox-svg",attrs:{"enable-background":"new 0 0 11 11","viewBox":"0 0 11 11","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{staticClass:"coveo-more-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.083 4.583h-3.666v-3.666c0-.524-.393-.917-.917-.917s-.917.393-.917.917v3.667h-3.666c-.524-.001-.917.392-.917.916s.393.917.917.917h3.667v3.667c-.001.523.392.916.916.916s.917-.393.917-.917v-3.666h3.667c.523 0 .916-.393.916-.917-.001-.524-.394-.917-.917-.917z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-line-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10 6.5h-9c-.552 0-1-.448-1-1 0-.552.448-1 1-1h9c .552 0 1 .448 1 1 0 .552-.448 1-1 1z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-exclusion-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m9.233 7.989-2.489-2.489 2.489-2.489c.356-.356.356-.889 0-1.244-.356-.356-.889-.356-1.244 0l-2.489 2.489-2.489-2.489c-.356-.356-.889-.356-1.244 0-.356.356-.356.889 0 1.244l2.489 2.489-2.489 2.489c-.356.356-.356.889 0 1.244.356.356.889.356 1.244 0l2.489-2.489 2.489 2.489c.356.356.889.356 1.244 0 .356-.355.356-.889 0-1.244z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-hook-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.252 2.213c-.155-.142-.354-.211-.573-.213-.215.005-.414.091-.561.24l-4.873 4.932-2.39-2.19c-.154-.144-.385-.214-.57-.214-.214.004-.415.09-.563.24-.148.147-.227.343-.222.549.005.207.093.4.249.542l2.905 2.662c.168.154.388.239.618.239h.022.003c.237-.007.457-.101.618-.266l5.362-5.428c.148-.148.228-.344.223-.551s-.093-.399-.248-.542z"}})])])]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-count"},[_vm._v("2")]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-caption",attrs:{"title":"Neighborhood and Built Environment"}},[_vm._v("Neighborhood and Built Environment")])])])]),_vm._v(" "),_c('li',{staticClass:"coveo-facet-value coveo-facet-selectable"},[_c('label',{staticClass:"coveo-facet-value-label"},[_c('div',{staticClass:"coveo-facet-value-label-wrapper"},[_c('input',{attrs:{"type":"checkbox","form":"coveo-dummy-form"}}),_vm._v(" "),_c('div',{staticClass:"coveo-facet-value-checkbox",attrs:{"tabindex":"0"}},[_c('svg',{staticClass:"coveo-facet-value-checkbox-svg",attrs:{"enable-background":"new 0 0 11 11","viewBox":"0 0 11 11","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{staticClass:"coveo-more-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.083 4.583h-3.666v-3.666c0-.524-.393-.917-.917-.917s-.917.393-.917.917v3.667h-3.666c-.524-.001-.917.392-.917.916s.393.917.917.917h3.667v3.667c-.001.523.392.916.916.916s.917-.393.917-.917v-3.666h3.667c.523 0 .916-.393.916-.917-.001-.524-.394-.917-.917-.917z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-line-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10 6.5h-9c-.552 0-1-.448-1-1 0-.552.448-1 1-1h9c .552 0 1 .448 1 1 0 .552-.448 1-1 1z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-exclusion-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m9.233 7.989-2.489-2.489 2.489-2.489c.356-.356.356-.889 0-1.244-.356-.356-.889-.356-1.244 0l-2.489 2.489-2.489-2.489c-.356-.356-.889-.356-1.244 0-.356.356-.356.889 0 1.244l2.489 2.489-2.489 2.489c-.356.356-.356.889 0 1.244.356.356.889.356 1.244 0l2.489-2.489 2.489 2.489c.356.356.889.356 1.244 0 .356-.355.356-.889 0-1.244z"}})]),_vm._v(" "),_c('g',{staticClass:"coveo-hook-svg",attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"m10.252 2.213c-.155-.142-.354-.211-.573-.213-.215.005-.414.091-.561.24l-4.873 4.932-2.39-2.19c-.154-.144-.385-.214-.57-.214-.214.004-.415.09-.563.24-.148.147-.227.343-.222.549.005.207.093.4.249.542l2.905 2.662c.168.154.388.239.618.239h.022.003c.237-.007.457-.101.618-.266l5.362-5.428c.148-.148.228-.344.223-.551s-.093-.399-.248-.542z"}})])])]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-count"},[_vm._v("2")]),_vm._v(" "),_c('span',{staticClass:"coveo-facet-value-caption",attrs:{"title":"Social and Community Context"}},[_vm._v("Social and Community Context")])])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-facet-footer coveo-facet-empty"},[_c('div',{staticClass:"coveo-facet-less",attrs:{"tab-index":"0"}},[_c('span',{staticClass:"coveo-facet-less-icon"},[_c('svg',{staticClass:"coveo-facet-less-icon-svg",attrs:{"enable-background":"new 0 0 10 6","viewBox":"0 0 10 6","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m5 .068c.222 0 .443.084.612.253l4.134 4.134c.338.338.338.886 0 1.224s-.886.338-1.224 0l-3.522-3.521-3.523 3.521c-.336.338-.886.338-1.224 0s-.337-.886.001-1.224l4.134-4.134c.168-.169.39-.253.612-.253z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-facet-more",attrs:{"tabindex":"0"}},[_c('span',{staticClass:"coveo-facet-more-icon"},[_c('svg',{staticClass:"coveo-facet-more-icon-svg",attrs:{"enable-background":"new 0 0 10 6","viewBox":"0 0 10 6","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m5 5.932c-.222 0-.443-.084-.612-.253l-4.134-4.134c-.338-.338-.338-.886 0-1.224s.886-.338 1.224 0l3.522 3.521 3.523-3.521c.336-.338.886-.338 1.224 0s .337.886-.001 1.224l-4.135 4.134c-.168.169-.39.253-.611.253z"}})])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-results-column coveo-no-results"},[_c('div',{staticClass:"coveo-results-header coveo-no-results"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"coveo-result-layout-section coveo-result-layout-hidden"},[_c('div',{staticClass:"CoveoResultLayout CoveoResultLayoutSelector"},[_c('span',{staticClass:"coveo-result-layout-selector coveo-selected",attrs:{"tabindex":"0"}},[_c('span',{staticClass:"coveo-icon coveo-list-layout-icon"},[_c('svg',{staticClass:"coveo-list-svg",attrs:{"enable-background":"new 0 0 19 14","viewBox":"0 0 19 14","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m19 12c0 .552-.397 1-.813 1h-11.375c-.416 0-.813-.448-.813-1s .397-1 .813-1h11.375c.416 0 .813.448.813 1"}}),_vm._v(" "),_c('path',{attrs:{"d":"m19 7c0 .552-.397 1-.813 1h-11.375c-.416 0-.813-.448-.813-1s .397-1 .813-1h11.375c.416 0 .813.448.813 1"}}),_vm._v(" "),_c('path',{attrs:{"d":"m19 2c0 .552-.397 1-.813 1h-11.375c-.416 0-.813-.448-.813-1s .397-1 .813-1h11.375c.416 0 .813.448.813 1"}}),_vm._v(" "),_c('path',{attrs:{"d":"m2 10c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2"}}),_vm._v(" "),_c('path',{attrs:{"d":"m2 5c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2"}}),_vm._v(" "),_c('path',{attrs:{"d":"m2 0c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2"}})])])]),_vm._v(" "),_c('span',{staticClass:"coveo-result-layout-selector-caption"},[_vm._v("List")])])])]),_vm._v(" "),_c('div',{staticClass:"coveo-sort-section"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"coveo-sort-container"},[_c('span',{staticClass:"CoveoSort coveo-sort-hidden",attrs:{"id":"coveo8BF15155","data-caption":"Date","data-prebind-sort-criteria":"sortCriteriaResolver","data-sort-criteria":"date descending, date ascending","data-sc-enable-direction-toggle":"true","data-applied-prebind":"true","tabindex":"0"}},[_vm._v("\n                                    Date\n                                    "),_c('span',{staticClass:"coveo-icon"},[_c('span',{staticClass:"coveo-sort-icon-ascending"},[_c('svg',{staticClass:"coveo-sort-icon-ascending-svg",attrs:{"enable-background":"new 0 0 10 6","viewBox":"0 0 10 6","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m5 .068c.222 0 .443.084.612.253l4.134 4.134c.338.338.338.886 0 1.224s-.886.338-1.224 0l-3.522-3.521-3.523 3.521c-.336.338-.886.338-1.224 0s-.337-.886.001-1.224l4.134-4.134c.168-.169.39-.253.612-.253z"}})])])]),_vm._v(" "),_c('span',{staticClass:"coveo-sort-icon-descending"},[_c('svg',{staticClass:"coveo-sort-icon-descending-svg",attrs:{"enable-background":"new 0 0 10 6","viewBox":"0 0 10 6","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m5 5.932c-.222 0-.443-.084-.612-.253l-4.134-4.134c-.338-.338-.338-.886 0-1.224s.886-.338 1.224 0l3.522 3.521 3.523-3.521c.336-.338.886-.338 1.224 0s .337.886-.001 1.224l-4.135 4.134c-.168.169-.39.253-.611.253z"}})])])])])])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)])]),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CoveoOmnibox coveo-query-syntax-disabled magic-box"},[_c('div',{staticClass:"magic-box-input"},[_c('div',{staticClass:"magic-box-underlay"},[_c('span',{staticClass:"magic-box-highlight-container"},[_c('span',[_c('span')])]),_vm._v(" "),_c('span',{staticClass:"magic-box-ghost-text"})]),_vm._v(" "),_c('input',{attrs:{"spellcheck":"false","form":"coveo-dummy-form","autocomplete":"off"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coveo-facet-header-title-section"},[_c('div',{staticClass:"coveo-facet-header-title",attrs:{"title":"Social Determinant"}},[_vm._v("Social Determinant")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coveo-summary-section"},[_c('span',{staticClass:"CoveoQuerySummary",attrs:{"data-query-summary-enable-search-tips":"false","data-query-summary-only-display-search-tips":"false"}},[_c('span',[_c('div',{staticClass:"coveo-query-summary-no-results-string"},[_vm._v("No results for "),_c('span',{staticClass:"coveo-highlight"},[_vm._v("gggg")])]),_vm._v(" "),_c('div',{staticClass:"coveo-query-summary-cancel-last"},[_vm._v("Cancel last action")]),_vm._v(" "),_c('div',{staticClass:"coveo-query-summary-search-tips-info"},[_vm._v("Search tips")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Check the spelling of your keywords.")]),_vm._v(" "),_c('li',[_vm._v("Try using fewer, different or more general keywords.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coveo-sort-container"},[_c('span',{staticClass:"CoveoSort coveo-selected coveo-sort-hidden",attrs:{"id":"coveo62DF1983","data-caption":"Relevancy","data-prebind-sort-criteria":"sortCriteriaResolver","data-sort-criteria":"relevancy","data-sc-enable-direction-toggle":"false","data-applied-prebind":"true","tabindex":"0"}},[_vm._v("Relevancy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"CoveoDidYouMean",staticStyle:{"display":"none"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"CoveoErrorReport",staticStyle:{"display":"none"}},[_c('div',{staticClass:"coveo-error-report-container"},[_c('div',{staticClass:"coveo-error-report-title"},[_c('h1'),_vm._v(" "),_c('h3')]),_vm._v(" "),_c('div',{staticClass:"coveo-error-report-message"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"CoveoResultList",attrs:{"data-layout":"list","data-wait-animation":"fade","data-auto-select-fields-to-include":"false"}},[_c('div',[_c('script',{staticClass:"result-template",attrs:{"id":"coveod7a75012","type":"text/x-underscore-template"}},[_vm._v("\n                                    <div class=\"coveo-result-frame coveoforsitecore-template\">\n                                    <div class=\"coveo-result-row\">\n                                    <div class=\"coveo-result-cell coveoforsitecore-information-section\">\n                                    <div class=\"coveo-result-row\">\n                                        <div class=\"coveo-result-cell\">\n                                            <% if (coveoFieldValue(\"templateid\") ===\"4d3eff2f-8488-44f4-80bb-adff3b340847\") { %>\n                                            <div class='coveo-title'>\n                                                <% if (coveoFieldValue(\"linkurl\") != null) { %>\n                                                <a href=\"<%= coveoFieldValue('linkurl')%>\" class=\"\" style=\"color:#c10e21!important\"><%= coveoFieldValue(\"title\") %></a>\n                                                <% } else { %>\n                                                <span class='CoveoResultTitle'><%= coveoFieldValue(\"title\") %></span>\n                                                <% } %>\n                                            </div>\n                                    \n                                            <div class=\"location\">\n                                                <% if (coveoFieldValue(\"location name\") != null) { %>\n                                                <span class=''><strong> Location:</strong>   <%= coveoFieldValue(\"location name\")  %></span>\n                                                <% } %>\n                                            </div>\n                                            <div class=\"event-date\">\n                                                <% if (coveoFieldValue(\"start date\") != null) { %>\n                                                <span class=''>\n                                                    <strong> Date: </strong>\n                                                    <%= coveoFieldValue(\"eventstartdate\") %>\n                                                </span>\n                                                <% } %>\n                                            </div>\n                                            <% } else { %>\n                                            <div class='coveo-title'>\n                                                <% if (coveoFieldValue(\"HasLayout\") === \"1\" || raw.syssource !== currentSourceName()) { %>\n                                                <a class='CoveoResultLink'><%= title ? highlight(title, titleHighlights) : coveoFieldValue(\"title\") %></a>\n                                                <% } else { %>\n                                                <span class='CoveoResultTitle'><%= title ? highlight(title, titleHighlights) : '' %></span>\n                                                <% } %>\n                                            </div>\n                                            <% } %>\n                                        </div>\n                                    </div>\n                                    <div class=\"coveo-result-row\">\n                                        <div class=\"coveo-result-cell\">\n                                            <span class=\"CoveoExcerpt\"></span>\n                                        </div>\n                                    </div>\n                                    </div>\n                                    </div>\n                                    </div>        \n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"coveo-result-list-container coveo-list-layout-container"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CoveoPager"},[_c('ul',{staticClass:"coveo-pager-list"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CoveoResultsPerPage"},[_c('span',{staticClass:"coveo-results-per-page-text coveo-results-per-page-no-results"},[_vm._v("Results per page")]),_vm._v(" "),_c('ul',{staticClass:"coveo-results-per-page-list"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"CoveoResultList",attrs:{"data-layout":"list","data-wait-animation":"fade","data-auto-select-fields-to-include":"false"}},[_c('div',[_c('script',{staticClass:"result-template",attrs:{"id":"coveod7a75012","type":"text/x-underscore-template"}},[_vm._v("\n                                <div class=\"coveo-result-frame coveoforsitecore-template\">\n                                    <div class=\"coveo-result-row\">\n                                        <div class=\"coveo-result-cell coveoforsitecore-information-section\">\n                                            <div class=\"coveo-result-row\">\n                                                <div class=\"coveo-result-cell\">\n                                                    <% if (coveoFieldValue(\"templateid\") ===\"4d3eff2f-8488-44f4-80bb-adff3b340847\") { %>\n                                                    <div class='coveo-title'>\n                                                        <% if (coveoFieldValue(\"linkurl\") != null) { %>\n                                                        <a href=\"<%= coveoFieldValue('linkurl')%>\" class=\"\" style=\"color:#c10e21!important\"><%= coveoFieldValue(\"title\") %></a>\n                                                        <% } else { %>\n                                                        <span class='CoveoResultTitle'><%= coveoFieldValue(\"title\") %></span>\n                                                        <% } %>\n                                                    </div>\n\n                                                    <div class=\"location\">\n                                                        <% if (coveoFieldValue(\"location name\") != null) { %>\n                                                        <span class=''><strong> Location:</strong>   <%= coveoFieldValue(\"location name\")  %></span>\n                                                        <% } %>\n                                                    </div>\n                                                    <div class=\"event-date\">\n                                                        <% if (coveoFieldValue(\"start date\") != null) { %>\n                                                        <span class=''>\n                                                            <strong> Date: </strong>\n                                                            <%= coveoFieldValue(\"eventstartdate\") %>\n                                                        </span>\n                                                        <% } %>\n                                                    </div>\n                                                    <% } else { %>\n                                                    <div class='coveo-title'>\n                                                        <% if (coveoFieldValue(\"HasLayout\") === \"1\" || raw.syssource !== currentSourceName()) { %>\n                                                        <a class='CoveoResultLink'><%= title ? highlight(title, titleHighlights) : coveoFieldValue(\"title\") %></a>\n                                                        <% } else { %>\n                                                        <span class='CoveoResultTitle'><%= title ? highlight(title, titleHighlights) : '' %></span>\n                                                        <% } %>\n                                                    </div>\n                                                    <% } %>\n                                                </div>\n                                            </div>\n                                            <div class=\"coveo-result-row\">\n                                                <div class=\"coveo-result-cell\">\n                                                    <span class=\"CoveoExcerpt\"></span>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>        \n                            ")])]),_vm._v(" "),_c('div',{staticClass:"coveo-result-list-container coveo-list-layout-container"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CoveoPager"},[_c('ul',{staticClass:"coveo-pager-list"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CoveoResultsPerPage"},[_c('span',{staticClass:"coveo-results-per-page-text coveo-results-per-page-no-results"},[_vm._v("Results per page")]),_vm._v(" "),_c('ul',{staticClass:"coveo-results-per-page-list"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81266104_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_box_vue__ = __webpack_require__(1633);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81266104_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"l-recipe-box container container-fluid"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-lg-9"},[_c('h1',{staticClass:"c-recipe-box__heading h3"},[_vm._v("Appetizers")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-lg-4"},[_c('article',{staticClass:"c-article-card c-article-card--small"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"#"}},[_c('div',{staticClass:"c-article-card__background h-placeholder-image h-placeholder-image--3-2"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/360x240/ddd/ccc?text=FPO'),expression:"'//placehold.it/360x240/ddd/ccc?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"c-article-card__actions"},[_c('aha-recipe-box-favorite',{attrs:{"recipe-id":"20","name":"recipeName","folder-name":"folderName","modal-id":"uniqueModalId1","saved-date":"uniqueDate"}})],1),_vm._v(" "),_c('aha-modal',{staticClass:"c-modal c-modal--aha",attrs:{"id":"uniqueModalId1","hide-footer":"","centered":"","lazy":""}},[_c('template',{staticClass:"nutrition-facts__header",slot:"modal-header"},[_c('h2',{staticClass:"h3"},[_vm._v("Add to Recipe Box")])]),_vm._v(" "),_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'uniqueModalId1', $event.target)}}},[_vm._v("×")]),_vm._v(" "),_c('p',[_vm._v("Recipe box folders:")]),_vm._v(" "),_c('aha-add-to-recipe-box',{attrs:{"recipe-id":"20"}})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4"},[_c('article',{staticClass:"c-article-card c-article-card--small"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"#"}},[_c('div',{staticClass:"c-article-card__background h-placeholder-image h-placeholder-image--3-2"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/360x240/ddd/ccc?text=FPO'),expression:"'//placehold.it/360x240/ddd/ccc?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-4"},[_c('article',{staticClass:"c-article-card c-article-card--small"},[_c('a',{staticClass:"c-article-card__link",attrs:{"href":"#"}},[_c('div',{staticClass:"c-article-card__background h-placeholder-image h-placeholder-image--3-2"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/360x240/ddd/ccc?text=FPO'),expression:"'//placehold.it/360x240/ddd/ccc?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_vm._m(6)])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-lg-3"},[_c('aha-modify-recipe-box',{attrs:{"translations":{ label: ' All (10)', firstSectionTitle: 'Recipe Box Folder', editText: 'Edit', createNewFolder: 'Create New Folder',createButtonText: 'Create', saveButtonText:'Save', currentItemLink:'', newFolderName:'i.e. Dinner' },"items":[{text:'Side Dishes'}, {text:'folder 2'}, {text:'folder 3'}],"folderitems":[{text:'Appetizers', count:'3'}, {text:'Side Dishes', count:'5'}, {text:'Side Dishesff', count:'8'}]}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Recipe")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"l-recipe-box__nav nav nav-tabs"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_vm._v("Profile")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#"}},[_vm._v("Recipe Box")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-article-card__content"},[_c('h3',{staticClass:"c-article-card__title h5"},[_vm._v("Guacamole Deviled Eggs")]),_vm._v(" "),_c('div',{staticClass:"c-article-card__metadata"},[_c('ul',{staticClass:"c-macro-list"},[_c('li',[_vm._v("226 Calories")]),_vm._v(" "),_c('li',[_vm._v("227g Sodium")]),_vm._v(" "),_c('li',[_vm._v("14g Fat")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-arctile-card__content"},[_c('h3',{staticClass:"c-article-card__title h5"},[_vm._v("Guacamole Deviled Eggs")]),_vm._v(" "),_c('div',{staticClass:"c-article-card__metadata"},[_c('ul',{staticClass:"c-macro-list"},[_c('li',[_vm._v("226 Calories")]),_vm._v(" "),_c('li',[_vm._v("227g Sodium")]),_vm._v(" "),_c('li',[_vm._v("14g Fat")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-article-card__actions"},[_c('a',{attrs:{"href":"#","title":"Remove Guacamole Deviled Eggs from Appetizers"}},[_c('span',{staticClass:"icon-solid-heart h-color--red"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-arctile-card__content"},[_c('h3',{staticClass:"c-article-card__title h5"},[_vm._v("Guacamole Deviled Eggs")]),_vm._v(" "),_c('div',{staticClass:"c-article-card__metadata"},[_c('ul',{staticClass:"c-macro-list"},[_c('li',[_vm._v("226 Calories")]),_vm._v(" "),_c('li',[_vm._v("227g Sodium")]),_vm._v(" "),_c('li',[_vm._v("14g Fat")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-article-card__actions"},[_c('a',{attrs:{"href":"#","title":"Remove Guacamole Deviled Eggs from Appetizers"}},[_c('span',{staticClass:"icon-solid-heart h-color--red"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fdba893_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_preferences_vue__ = __webpack_require__(1635);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fdba893_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_preferences_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Recipe")])]),_vm._v(" "),_c('section',{staticClass:"l-recipe-box container container-fluid",attrs:{"aria-labelledby":"section-recipe-preferences"}},[_c('ul',{staticClass:"l-recipe-box__nav nav nav-tabs"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#"}},[_vm._v("Profile")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_vm._v("Recipe Box")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"c-recipe-preferences"},[_c('h1',{staticClass:"c-recipe-preferences__heading h3 h-color--red",attrs:{"id":"section-location-selector"}},[_vm._v("Preferences")]),_vm._v(" "),_c('form',[_c('h2',{staticClass:"c-recipe-preferences__subheading h4"},[_vm._v("1. Tell Us About Yourself")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"zip-code"}},[_vm._v("Zip Code")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"zip-code","placeholder":"Zip Code"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"gender"}},[_vm._v("Gender")]),_vm._v(" "),_c('select',{staticClass:"custom-select btn--select",attrs:{"id":"gender"}},[_c('option',{attrs:{"selected":""}},[_vm._v("Choose a Gender")]),_vm._v(" "),_c('option',{attrs:{"value":"male"}},[_vm._v("Male")]),_vm._v(" "),_c('option',{attrs:{"value":"female"}},[_vm._v("Female")]),_vm._v(" "),_c('option',{attrs:{"value":"other"}},[_vm._v("Other")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"ethnicity"}},[_vm._v("Ethnicity")]),_vm._v(" "),_c('select',{staticClass:"custom-select btn--select",attrs:{"id":"ethnicity"}},[_c('option',{attrs:{"selected":""}},[_vm._v("Choose an Ethnicity")]),_vm._v(" "),_c('option',{attrs:{"value":"option1"}},[_vm._v("Option 1")]),_vm._v(" "),_c('option',{attrs:{"value":"option2"}},[_vm._v("Option 2")]),_vm._v(" "),_c('option',{attrs:{"value":"option3"}},[_vm._v("Option 3")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"age-range"}},[_vm._v("Age Range")]),_vm._v(" "),_c('select',{staticClass:"custom-select btn--select",attrs:{"id":"age-range"}},[_c('option',{attrs:{"selected":""}},[_vm._v("Choose an Age Range")]),_vm._v(" "),_c('option',{attrs:{"value":"option1"}},[_vm._v("Option 1")]),_vm._v(" "),_c('option',{attrs:{"value":"option2"}},[_vm._v("Option 2")]),_vm._v(" "),_c('option',{attrs:{"value":"option3"}},[_vm._v("Option 3")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('fieldset',{attrs:{"id":"recipes-search-type"}},[_c('legend',{staticClass:"c-recipe-preferences__legend",attrs:{"id":"legend-recipes-search-type"}},[_vm._v("2. Tell Us About Your Cooking A")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('ul',{staticClass:"c-recipe-preferences__checkboxes"},[_c('li',[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck1","aria-describedby":"recipes-search-type"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck1"}},[_vm._v("Lower fat/cholesterol")])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck2","aria-describedby":"recipes-search-type"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck2"}},[_vm._v("Vegetarian")])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck3","aria-describedby":"recipes-search-type"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck3"}},[_vm._v("Quick & Easy")])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck4","aria-describedby":"recipes-search-type"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck4"}},[_vm._v("Budget Friendly")])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck5","aria-describedby":"recipes-search-type"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck5"}},[_vm._v("Slow Cooker")])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck6","select-all":"#recipes-search-type","aria-describedby":"recipes-search-type"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck6"}},[_vm._v("Select All")])])])])])]),_vm._v(" "),_c('fieldset',{attrs:{"id":"recipes-search-type2"}},[_c('legend',{staticClass:"c-recipe-preferences__legend",attrs:{"id":"legend-recipes-search-type2"}},[_vm._v("2. Tell Us About Your Cooking")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('ul',{staticClass:"c-recipe-preferences__checkboxes"},[_c('li',[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck22","aria-describedby":"recipes-search-type2"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck22"}},[_vm._v("Vegetarian")])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck32","aria-describedby":"recipes-search-type2"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck32"}},[_vm._v("Quick & Easy")])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck62","select-all":"#recipes-search-type2","aria-describedby":"recipes-search-type2"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck62"}},[_vm._v("Select All")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"sr-only",attrs:{"for":"ethnicity"}},[_vm._v("How freqently do you cook at home")]),_vm._v(" "),_c('select',{staticClass:"custom-select btn--select",attrs:{"id":"ethnicity"}},[_c('option',{attrs:{"selected":""}},[_vm._v("How freqently do you cook at home")]),_vm._v(" "),_c('option',{attrs:{"value":"option1"}},[_vm._v("Option 1")]),_vm._v(" "),_c('option',{attrs:{"value":"option2"}},[_vm._v("Option 2")]),_vm._v(" "),_c('option',{attrs:{"value":"option3"}},[_vm._v("Option 3")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"sr-only",attrs:{"for":"ethnicity"}},[_vm._v("How frequently do you search online for healthy recipes")]),_vm._v(" "),_c('select',{staticClass:"custom-select btn--select",attrs:{"id":"ethnicity"}},[_c('option',{attrs:{"selected":""}},[_vm._v("How frequently do you search online for healthy recipes")]),_vm._v(" "),_c('option',{attrs:{"value":"option1"}},[_vm._v("Option 1")]),_vm._v(" "),_c('option',{attrs:{"value":"option2"}},[_vm._v("Option 2")]),_vm._v(" "),_c('option',{attrs:{"value":"option3"}},[_vm._v("Option 3")])])]),_vm._v(" "),_c('input',{staticClass:"btn btn-lg btn-danger btn-round",attrs:{"type":"submit","value":"Save"}})])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0025e096_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_categories_vue__ = __webpack_require__(1637);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0025e096_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recipe_categories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"l-recipe-category__list"},[_c('li',[_c('div',{staticClass:"c-recipe-category"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('collapse1'),expression:"'collapse1'"}],staticClass:"c-recipe-category__trigger"},[_c('h3',{staticClass:"h3"},[_vm._v("Category")])]),_vm._v(" "),_c('b-collapse',{staticClass:"c-recipe-category__content",attrs:{"id":"collapse1"}},[_c('ul',{staticClass:"c-recipe-category__links"},[_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])])])])],1)]),_vm._v(" "),_c('li',[_c('div',{staticClass:"c-recipe-category"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('collapse2'),expression:"'collapse2'"}],staticClass:"c-recipe-category__trigger"},[_c('h3',{staticClass:"h3"},[_vm._v("Category")])]),_vm._v(" "),_c('b-collapse',{staticClass:"c-recipe-category__content",attrs:{"id":"collapse2"}},[_c('ul',{staticClass:"c-recipe-category__links"},[_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"c-recipe-category__link h4",attrs:{"href":"#"}},[_vm._v("Sub Category")])])])])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Recipe Categories")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-recipe-category__header"},[_c('h1',{staticClass:"h2"},[_vm._v("Recipe Collections")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_640084e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_survivor_story_vue__ = __webpack_require__(1639);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_640084e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_survivor_story_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('article',{staticClass:"l-survivor"},[_c('header',{staticClass:"l-survivor__header container-extra-wide"},[_c('div',{staticClass:"c-hero-survivor"},[_c('div',{staticClass:"c-hero-survivor__media h-placeholder-image h-placeholder-image--bg"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/600/any'),expression:"'//placeimg.com/1200/600/any'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"c-hero-survivor__content-container container container-wide"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"c-hero-survivor__nav"},[_c('div',{staticClass:"c-hero-survivor__prev"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_c('span',{staticClass:"c-hero-survivor__thumb h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/80/60/any'),expression:"'//placeimg.com/80/60/any'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})]),_vm._v(" "),_c('span',{staticClass:"c-hero-survivor__thumb-text"},[_vm._v("Prev")])])]),_vm._v(" "),_c('div',{staticClass:"c-hero-survivor__next"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_c('span',{staticClass:"c-hero-survivor__thumb h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/80/60/any?a'),expression:"'//placeimg.com/80/60/any?a'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})]),_vm._v(" "),_c('span',{staticClass:"c-hero-survivor__thumb-text"},[_vm._v("Next")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"l-survivor__body"},[_c('div',{staticClass:"container container-fluid"},[_c('aha-share-gigya'),_vm._v(" "),_vm._m(2)],1),_vm._v(" "),_c('div',{staticClass:"container-extra-wide"},[_c('div',{staticClass:"l-promo l-promo--survivor-grid"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"container container-extra-wide"},[_c('div',{staticClass:"c-hero-full c-hero-full--scaled"},[_c('a',{staticClass:"c-hero-full__media h-placeholder-image",attrs:{"href":"#"}},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/1200x600?text=FPO'),expression:"'//placehold.it/1200x600?text=FPO'"}],attrs:{"src":"//placehold.it/1200x600?text=loading","alt":""}})])])]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"container-extra-wide"},[_c('div',{staticClass:"l-promo l-promo--survivor-grid"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--1-1"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placehold.it/300x600/333333/666666?text=FPO'),expression:"'//placehold.it/300x600/333333/666666?text=FPO'"}],attrs:{"src":"assets/images/placeholder.gif"}})])])])]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('aha-full-width-highlight-copy')],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-5"},[_vm._v("Survivor Story Layout")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-hero-survivor__content"},[_c('div',{staticClass:"c-hero-survivor__kicker"},[_c('img',{staticClass:"c-hero-card__kicker-icon",attrs:{"src":"assets/aha_heart.svg","alt":""}}),_vm._v("American Heart Association\n                        ")]),_vm._v(" "),_c('h1',{staticClass:"c-hero-survivor__heading h2"},[_vm._v("Mom Becomes Caregiver After Daughter's Stroke")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-article l-article--survivor row"},[_c('div',{staticClass:"col-md-8 align-self-center"},[_c('div',{staticClass:"l-article__main no-cap"},[_c('p',[_vm._v("Jeremy Woodward will participate in the Arizona Ironman competition on Nov. 19 – a decade after doctors told him he would never compete at that level again. \"This is going to be a really special day,\" said Woodward, who lives in Concord, New Hampshire. \"Celebrating that I can do it – that I'm healthy enough to do it – and having my family there at the finish line will be an emotional moment.\"")]),_vm._v(" "),_c('p',[_vm._v("The moment seemed unlikely on Aug. 4, 2007, when Woodward, who was 28 at the time, was in class four heart failure and nearly died. His heart failure developed after an aortic valve replaced in 2000 stopped working.")]),_vm._v(" "),_c('p',[_vm._v("\"They all thought I was crazy, but from that point on, it became my ultimate goal.\" The triathlon in November, which included a 2.4 mile swim, 112-mile bike ride and 26.2 mile run within a 17-hour time limit, will be Woodward's second.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"l-article__widget"},[_c('blockquote',{staticClass:"c-blockquote"},[_vm._v("\n                                \"The day before my surgery, I was reading about the "),_c('strong',{staticClass:"h-color--red"},[_vm._v("Ironman triathlon")]),_vm._v(" in a magazine and I told the doctors and nurses that if I got out of this surgery and could do it, I would,\" Woodward said.\n                            ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-survivor-promo"},[_c('p',[_vm._v("Jeremy Woodward with his wife, Brook, and older daughter, Elliana, after he completed his first Ironman triathlon in 2010. (Photo courtesy of Jeremy Woodward)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-extra-wide"},[_c('div',{staticClass:"l-article row justify-content-end"},[_c('div',{staticClass:"l-article__main col-md-8 col-push-md-4"},[_c('blockquote',{staticClass:"c-blockquote c-blockquote--2"},[_vm._v("\n                            \"Training for an Ironman competition takes a lot of time, effort and sacrifice, and my family has been extremely supportive and truly understands how much this means to me,\" Woodward said. \"Knowing that 10 years after my last open-heart surgery I am doing this a second time proves that anything is possible.\"\n                        ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-article l-article--survivor row"},[_c('div',{staticClass:"col-md-8 align-self-center"},[_c('div',{staticClass:"l-article__main"},[_c('p',[_vm._v("Still, it didn't seem possible when Woodward arrived at Tufts Medical Center in Boston with 45 pounds of fluid weight. During the procedure to have his aorta repaired and another valve replaced with a mechanical heart valve, Woodward also had a clot on the left side of his heart that required additional repairs.")]),_vm._v(" "),_c('p',[_vm._v("\"When we were in the hospital for weeks leading up to Jeremy's surgery, my biggest fear was leaving the hospital alone,\" said his wife, Brook. \"Being there for weeks takes your mind to places you don't want to think about. We hadn't even been married two years, so dreams of having a family and a home just seemed liked they weren't going to be in the cards for us.\"")]),_vm._v(" "),_c('p',[_vm._v("But after six weeks in the hospital, Woodward returned home.")]),_vm._v(" "),_c('p',[_vm._v("\"I believe that his ability to keep positive is what kept him alive – along with the incredible team of doctors and nurses that literally put his heart back together,\" Brook said.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"l-article__widget"},[_c('blockquote',{staticClass:"c-blockquote c-blockquote--3"},[_vm._v("\n                                \"…Ability to Keep Positive Is What Kept Him Alive…\"\n                            ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-survivor-promo c-survivor-promo--alt"},[_c('h4',{staticClass:"h4"},[_vm._v("…Participated in "),_c('span',{staticClass:"h-color--red"},[_vm._v("his fourth")]),_vm._v(" Boston Marathon")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"h-columns--two col-md-8"},[_c('p',[_vm._v("\"Now, 10 years later, we have three beautiful daughters and a brand new home that we've worked so hard for. Going through this experience has made us appreciate everything that we have so much more,\" she said.")]),_vm._v(" "),_c('p',[_vm._v("This past August, when Woodward walked into the CardioVascular Center at Tufts, he was elated to see Noreen A. Dolan, one of the head nurses who took care of him.")]),_vm._v(" "),_c('p',[_vm._v("\"Jeremy was one of hte sickest patients I cared for in my career,\" Dolan said. \"I thought his chances of recovery were slim to none. Althoug we would be able to fix his heart values, we thought he would always be limited due to his major heart condition.\"")]),_vm._v(" "),_c('p',[_vm._v("Just one day shy of his three-year anniversary of being admitted to the hospital, Woodward completed his first Ironman in July 2010.")]),_vm._v(" "),_c('p',[_vm._v("Through these races, Woodward has raised more than $37,000 for heart and stroke research and education.")]),_vm._v(" "),_c('p',[_vm._v("Then in 2013, he ran the Boston Marathon as part of Tedy's Team, a running group created by the American Stroke Association and former New England Patriots linebacker and stroke survivor Tedy Bruschi.")]),_vm._v(" "),_c('p',[_vm._v("This year, he ran the Falmouth Road Race in Massachusetts, participated in his fourth Boston Marathon, and ran the Marine Corps Marathon with Tedy's Team.")]),_vm._v(" "),_c('p',[_vm._v("\"Being able to do my part to fight heart disease and combat stroke is, I think, what I'm supposed to be doing,\" Woodward said. \"I was given a tough situation and I wanted to make sure I turned it around into something really positive.\"")]),_vm._v(" "),_c('p',[_vm._v("If you have questions or comments about this story, please email "),_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":"#"}},[_vm._v("editor@heart.org")]),_vm._v(".")]),_vm._v(" "),_c('div',{staticClass:"c-article-end"},[_c('p',{staticClass:"c-article-end__categories"},[_vm._v("Blog, Healthy Living, Heart Disease, Heart Failure, Patients, Stories from the Heart")]),_vm._v(" "),_c('p',{staticClass:"c-article-end__comments"},[_vm._v("Comments Off on Two-time open-heart sugery survivor to compete in Ironman competition")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('img',{attrs:{"src":"//placehold.it/400x600"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd96c8e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__(1641);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd96c8e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-generic row"},[_c('div',{staticClass:"l-generic__col col-md-12"},[_vm._m(0),_vm._v(" "),_c('aha-search-results-form',{attrs:{"action":"en/search","query-delimeter":"?#","role":"search"}},[_c('div',{staticClass:"container container-fluid",scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"c-inline-search"},[_c('div',{staticClass:"c-inline-search__form"},[_c('div',{staticClass:"c-inline-search__search form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label-lg",attrs:{"for":""}},[_vm._v("Search")]),_vm._v(" "),_c('input',{directives:[{name:"input",rawName:"v-input.flagged",value:('q'),expression:"'q'",modifiers:{"flagged":true}}],staticClass:"c-inline-search__input form-control form-control-lg",attrs:{"type":"text","id":"","placeholder":"ex: avocado","name":"q"}})]),_vm._v(" "),_c('button',{staticClass:"c-inline-search__submit btn btn-lg btn-danger btn-round",attrs:{"disabled":!slotProps.isValid()},on:{"click":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}},[_vm._v("Search")])])])]}}])})])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-error"},[_vm._v("\n         \n        "),_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"height":"404px","width":"404px"},attrs:{"height":"404","alt":"Defibrillator","width":"404","src":"/assets/images/fpo-defibrillator-icon.svg"}})]),_vm._v(" "),_c('h1',{staticClass:"text-center h-color--red font-weight-light mt-3 mb-3",staticStyle:{"font-size":"5.375rem"}},[_vm._v("404 - Page Not Found")]),_vm._v(" "),_c('h2',{staticClass:"text-center"},[_vm._v("Oh no! Something went wrong.")]),_vm._v(" "),_c('p',{staticClass:"text-center mb-5"},[_vm._v("\n          Please try a new search and if you still don't find\n          what you're looking for,\n          "),_c('br'),_vm._v("visit our\n          "),_c('a',{attrs:{"href":"/en/about-us/contact-us"}},[_vm._v("Contact Us page")]),_vm._v(" for helpful links and contact information.\n          "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"/en"}},[_vm._v("Back to American Heart Association Homepage")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf5b4aec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_500_vue__ = __webpack_require__(1643);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf5b4aec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_500_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-generic row"},[_c('div',{staticClass:"l-generic__col col-md-12"},[_vm._m(0),_vm._v(" "),_c('aha-search-results-form',{attrs:{"action":"en/search","query-delimeter":"?#","role":"search"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"c-inline-search"},[_c('div',{staticClass:"c-inline-search__form"},[_c('div',{staticClass:"c-inline-search__search form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label-lg",attrs:{"for":""}},[_vm._v("Search")]),_vm._v(" "),_c('input',{directives:[{name:"input",rawName:"v-input.flagged",value:('q'),expression:"'q'",modifiers:{"flagged":true}}],staticClass:"c-inline-search__input form-control form-control-lg",attrs:{"type":"text","id":"","placeholder":"ex: avocado","name":"q"}})]),_vm._v(" "),_c('button',{staticClass:"c-inline-search__submit btn btn-lg btn-danger btn-round",attrs:{"disabled":!slotProps.isValid()},on:{"click":function($event){$event.preventDefault();return slotProps.manualSubmitSearch()}}},[_vm._v("Search")])])])]}}])})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-error"},[_vm._v("\n         \n        "),_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"height":"404px","width":"404px"},attrs:{"height":"404","alt":"Defibrillator","width":"404","src":"/assets/images/defibrillator_icon.svg"}})]),_vm._v(" "),_c('h1',{staticClass:"text-center h-color--red font-weight-light mt-3 mb-3",staticStyle:{"font-size":"5.375rem"}},[_vm._v("Internal Server Error")]),_vm._v(" "),_c('h2',{staticClass:"text-center h3"},[_vm._v("This error occurs when something is wrong with our hard working servers. "),_c('br'),_vm._v("Because of your generous donor dollars, we have dispatched the best engineers (with caffeine in hand) to look at the issue.")]),_vm._v(" "),_c('p',{staticClass:"text-center mb-5"},[_vm._v("\n          Please try a new search and if you still don't find\n          what you're looking for,\n          "),_c('br'),_vm._v("visit our\n          "),_c('a',{attrs:{"href":"/en/about-us/contact-us"}},[_vm._v("Contact Us page")]),_vm._v(" for helpful links and contact information.\n          "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"/en"}},[_vm._v("Back to American Heart Association Homepage")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80ea9e80_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_finder_vue__ = __webpack_require__(1645);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80ea9e80_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_finder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('aha-stroke-group-selector',{attrs:{"name":"stroke-group-selector","search-endpoint":"plug_api_endpoint_here","translations":{ 
            "title": "Find a Stroke Support Group Nearby",
            "search": "Search",
            "searchResults": "Search results for",
            "clearResults": "Clear Results",
            "name": "Group Name",
            "city": "City",
            "state": "State",
            "radius": "Radius",
            "zipCode": "Zip Code", 
            "zipCodePlaceholder": "Enter zip code",
            "increaseRadius": "If your initial search does not pull up any groups, try increasing your mile radius.",
            "noResultsFound": "No results found.",
            "requiredFields": "All fields are required."
            },"radius":[{ "code": "5", "title": "5 miles" }, { "code": "10", "title": "10 miles" }, { "code": "20", "title": "20 miles" }, { "code": "50", "title": "50 miles" }, { "code": "100", "title": "100 miles" }, { "code": "200", "title": "200 miles" }, { "code": "300", "title": "300 miles" }],"image":"https://picsum.photos/700/250/?random","locations":[
            {"name":"Texas Rehab Arlington Stroke Support Group","city":"Arlington","state":"TX","zip":"76015","audience":"Survivors,Caregivers","url":"?zipcode=84101&radius=300"},
            {"name":"Rehabilitaion Hospital of Dallas","city":"Dallas","state":"TX","zip":"75230","audience":"Survivors,Medical Professionals","url":"?zipcode=84101&radius=300"},
            {"name":"Frisco Support Group","city":"Frisco","state":"MA","zip":"74060","audience":"caregivers","url":"?zipcode=84101&radius=300"},
            {"name":"Collin County Stroke Support","city":"McKinney","state":"CA","zip":"75070","audience":"Survivors,Caregivers","url":"?zipcode=84101&radius=300"},
            {"name":"Irving Stroke Support Group","city":"Irving","state":"CA","zip":"75061","audience":"Medical Professionals","url":"?zipcode=84101&radius=300"}
        ],"previous-searched-params":{
            zipcode:"06149", 
            radius:"5", 
            audience: ["Caregivers", "Survivors"]
        }}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-5"},[_vm._v("Stroke Group Finder")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('h2',[_vm._v("Welcome to our national stroke support group registry.")]),_vm._v(" "),_c('p',[_vm._v("Testing 2click, "),_c('a',{staticClass:"btn btn-secondary-link ml-0 pl-0 mt-3 twoClick",attrs:{"href":"http://www.cnn.com"}},[_vm._v("CNN")])]),_vm._v(" "),_c('p',[_vm._v("Once a group, or list of groups appear, you may click on any group for more details about them. To find a group near you, simply enter your ZIP code and a mile radius.")]),_vm._v(" "),_c('p',[_vm._v("If you're a group leader and would like to update your information or register your group, visit our "),_c('a',{attrs:{"href":"http://www.strokeassociation.org/STROKEORG/LifeAfterStroke/ForSupportGroupLeaders/For-Support-Group-Leaders_UCM_308564_SubHomePage.jsp"}},[_vm._v("Support Group Leaders")]),_vm._v(" section.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_detail_vue__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_detail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_detail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_detail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_detail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f96af05_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_detail_vue__ = __webpack_require__(1647);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_detail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f96af05_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"c-card c-card--horizontal"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('aha-google-map',{attrs:{"address":'1901 N MacArthur Blvd, Irving, TX, 75061',"zoom":14}})],1),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',{staticClass:"h-color--green mt-5 text-right"},[_vm._v("Last Reviewed: Jun 27, 2018")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-5"},[_vm._v("Stroke Group Detail")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-listing-header c-cta"},[_c('div',{staticClass:"c-label c-label--grey"},[_vm._v("Inactive")]),_vm._v(" "),_c('h1',{staticClass:"h2"},[_vm._v("Texas Rehab Arlington Stroke Support Group")]),_vm._v(" "),_c('div',{staticClass:"c-listing-header__cta-container"},[_c('p',{staticClass:"c-listing-header__subheading"},[_vm._v("Medical Professionals")]),_vm._v(" "),_c('a',{staticClass:"c-listing-header__cta c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("Back to Search")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"c-card__content"},[_c('h2',{staticClass:"c-card__heading h3 text-primary"},[_vm._v("Address")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',{staticClass:"h4 mb-1"},[_vm._v("1901 N MacArthur Blvd")]),_vm._v(" "),_c('li',[_vm._v("Baylor Scott & White Health")]),_vm._v(" "),_c('li',[_vm._v("Irving, TX, 75061")])]),_vm._v(" "),_c('div',{staticClass:"c-card__actions"},[_c('div',{staticClass:"c-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"http://www.google.com/maps/dir/1901+N+MacArthur+Blvd%2CIrving%2CTX%2C75061","target":"_blank"}},[_vm._v("Directions")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo row no-gutters"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-text-promo"},[_c('div',{staticClass:"c-text-promo__content"},[_c('h2',{staticClass:"h3 text-primary"},[_vm._v("Contact")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',{staticClass:"h4 mb-1"},[_vm._v("Renee Vickers")]),_vm._v(" "),_c('li',[_vm._v("972-579-8511")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"mailto:renee.vickers@bswealth.org","type":"email"}},[_vm._v("renee.vickers@bswealth.org")])])])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-text-promo"},[_c('div',{staticClass:"c-text-promo__content"},[_c('h2',{staticClass:"h3 text-primary"},[_vm._v("Meeting")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',{staticClass:"h4 mb-1"},[_vm._v("2nd Wednesday")]),_vm._v(" "),_c('li',[_vm._v("3:00-4:00PM")]),_vm._v(" "),_c('li',[_vm._v("Baylor Medical Hospital, 5th Floor Rehab Unit")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"c-promo c-promo--shadow"},[_c('div',{staticClass:"c-promo__content-container"},[_c('div',{staticClass:"agenda"},[_c('h2',{staticClass:"h3"},[_vm._v("Agenda")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Meetings include a guest speaker with time for discussion afterwards.")])]),_vm._v(" "),_c('div',{staticClass:"notes"},[_c('h2',{staticClass:"h3"},[_vm._v("Notes")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("No charge for attendance. No advance notice required to attend.")])]),_vm._v(" "),_c('div',{staticClass:"type"},[_c('h2',{staticClass:"h3"},[_vm._v("Type")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Support/Social/Edu/Therapeutic")])]),_vm._v(" "),_c('div',{staticClass:"specialty"},[_c('h2',{staticClass:"h3"},[_vm._v("Specialty")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("SURVIVORS, CAREGIVERS, PROS")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hospitalmaps_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hospitalmaps_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hospitalmaps_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hospitalmaps_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hospitalmaps_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5ecb754_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hospitalmaps_vue__ = __webpack_require__(1651);
function injectStyle (ssrContext) {
  __webpack_require__(1649)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5ecb754"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hospitalmaps_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5ecb754_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hospitalmaps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1650);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("ae28eb14", content, true, {});

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "pre[data-v-d5ecb754]{background-color:#eaeaea;font-size:.5rem}", ""]);

// exports


/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"c-listing-header__subheading"},[_vm._v("Front End")]),_vm._v(" "),_c('p',[_vm._v("Cookie Name: \"EventManualZipcodeEntry\"")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.ahaZipCodeModal",modifiers:{"ahaZipCodeModal":true}}],staticClass:"btn btn-lg btn-danger btn-round"},[_vm._v("\n        Trigger\n        Zip Code Modal\n      ")]),_vm._v(" "),_c('div',[_vm._v(" ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-lg btn-danger btn-round text-white",on:{"click":function($event){$event.preventDefault();return _vm.clearCookie.apply(null, arguments)}}},[_vm._v("Clear Cookie")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('aha-hospital-zipcode-modal',{ref:"zipcode-modal",attrs:{"name":"zipcode-modal","zip-code-selector":"address_42","translations":{
              'cookie': 'EventManualZipcodeEntry',
              'btn': 'Share', 
              'heading': 'Share Your Location', 
              'subheading': 'We cannot determine your location, please share your Zip Code to view accredited hospitals in your area.',
          }}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',{staticClass:"c-listing-header__subheading"},[_vm._v("Coveo Search Box")]),_vm._v(" "),_c('div',{staticClass:"container c-map-search"},[_c('aha-map-search',{attrs:{"name":"location-selector","endpoint":"//jsonplaceholder.typicode.com/posts","translations":{ "search": "Search", "searchResults": "Search results for", "clearResults": "Clear Results", "offices": "Offices", "address": "Address", "city": "City", "distance": "Distance", "searchLabel": "Hospital Name", "searchAddressLabel": "Hospital Address", "searchLabelPlaceholder": "i.e. Presbyterian", "addressLabelPlaceholder": "i.e. Address", "distancePlaceholder": "Distance" },"distances":[{ "code": "5", "title": "5 Miles" }, { "code": "10", "title": "10 Miles" }, { "code": "20", "title": "20 Miles" }]}})],1),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-listing-header"},[_c('div',{staticClass:"c-listing-header__cta-container"},[_c('h2',{staticClass:"c-listing-header__heading"},[_vm._v("Hospital Maps Development")]),_vm._v(" "),_c('span',{staticClass:"h-flex"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Created a utility js script, src/app/utils/aha-cookie.js.")]),_vm._v(" "),_c('li',[_vm._v("Vue component: aha-hospital-zipcode-modal will detect if cookie exist on mounted.")]),_vm._v(" "),_c('li',[_vm._v("If no cookie, or zipcode is null then have modal pop up asking for zipcode then store zipcode in the cookie.")]),_vm._v(" "),_c('li',[_vm._v("Cookie API to get, set cookie with cookie name and zipcode as parameters, delete cookie.")]),_vm._v(" "),_c('li',[_vm._v("Demo page: demo/pages/layouts/hospitalmaps.vue")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_vm._v("      "),_vm._v("\n      <aha-hospital-zipcode-modal\n        ref=\"zipcode-modal\"\n        name=\"zipcode-modal\"\n        zip-code-selector=\"zipcode\" // the id of the zip code input box for Coveo search\n        :translations=\"{ \n              'cookie': 'EventManualZipcodeEntry',\n              'btn': 'Share', \n              'heading': 'Share Your Location', \n              'subheading': 'We cannot determine your location, please share your Zip Code to view accredited hospitals in your area.',\n          }\"\n      ></aha-hospital-zipcode-modal>\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container c-map-search"},[_c('div',{staticClass:"c-map-search__content"},[_c('form',{staticClass:"map-location-search",attrs:{"novalidate":"novalidate","name":"location-selector","search-endpoint":"//jsonplaceholder.typicode.com/posts"}},[_c('div',{staticClass:"map-search__fields row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{attrs:{"for":"zipcode"}},[_vm._v("Search Hospital Name or Address")]),_vm._v(" "),_c('input',{staticClass:"form-control form-control-lg",attrs:{"name":"hospital","type":"text","placeholder":"i.e. Presbyterian","id":"zipcode"}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{attrs:{"for":"distance_147"}},[_vm._v("Distance")]),_vm._v(" "),_c('select',{staticClass:"custom-select btn--select form-control form-control-lg",attrs:{"name":"distance","id":"distance_147"}},[_c('option',{attrs:{"value":""}},[_vm._v("Select a Distance")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5 Miles")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10 Miles")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20 Miles")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"c-map-search__search-btn btn btn-lg btn-danger btn-round",attrs:{"type":"submit"}},[_vm._v("Search")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1492e0b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_science_news_commentary_vue__ = __webpack_require__(1653);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1492e0b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_science_news_commentary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('aha-breadcrumb'),_vm._v(" "),_c('science-news-heading'),_vm._v(" "),_c('rich-text'),_vm._v(" "),_c('news-link'),_vm._v(" "),_c('ad-horizontal'),_vm._v(" "),_c('phd-citations'),_vm._v(" "),_c('phd-references'),_vm._v(" "),_c('article-listbox')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4acc3f4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_science_news_article_summary_wildcard_vue__ = __webpack_require__(1655);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4acc3f4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_science_news_article_summary_wildcard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('aha-breadcrumb'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"phd-shadow-box"},[_c('science-news-heading'),_vm._v(" "),_c('science-news-promo')],1)]),_vm._v(" "),_c('video-promo'),_vm._v(" "),_c('link-box'),_vm._v(" "),_c('ad-horizontal'),_vm._v(" "),_c('link-box'),_vm._v(" "),_c('link-box')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_447a6aae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_header_vue__ = __webpack_require__(1657);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_447a6aae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('header',{staticClass:"l-header"},[_c('div',{staticClass:"l-header__top l-mobile-nav-box-shadow"},[_c('div',{staticClass:"d-none d-lg-block container container-fluid container-wide"},[_c('phd-top-utility-nav')],1),_vm._v(" "),_c('div',{staticClass:"container container-fluid container-wide"},[_c('phd-top-nav')],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"l-header__main"},[_c('div',{staticClass:"container container-fluid container-wide"},[_c('div',{staticClass:"d-none d-md-block"},[_c('phd-main-nav')],1)])]),_vm._v(" "),_c('div',{staticClass:"l-header__cta"},[_c('cta-bar')],1),_vm._v(" "),_c('phd-science-volunteer-modal',{attrs:{"modalData":{
                isVolunteer: true,
                yesRedirect:'http://heart.org',
                noRedirect: 'http://professional.heart.org/',
                title: 'Science Volunteer',
                message:'Are you interested in becoming a science volunteer?'
            }}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("PHD Header")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-member-button"},[_c('a',{staticClass:"btn btn-round active",attrs:{"href":""}},[_vm._v("Become a Member")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_membership_tables_example_vue__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_membership_tables_example_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_membership_tables_example_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_membership_tables_example_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_membership_tables_example_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9027f1fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_membership_tables_example_vue__ = __webpack_require__(1659);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_membership_tables_example_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9027f1fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_membership_tables_example_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Membership Rate Comparison (default: 3 data columns)")]),_vm._v(" "),_c('aha-component',{attrs:{"title":""}},[_c('membership-rate-comparison',{attrs:{"table-data":_vm.demoDataMembershipRateComparison}},[_c('template',{slot:"postTableContent"},[_c('div',{staticClass:"flex-table__content-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"rate-comparison__disclaimer-title"},[_vm._v("1Title here is optional")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 rate-comparison__disclaimer-content"},[_c('p',[_vm._v("*Verification of Student/Trainee status is required. Please see \"Membership Discounts\" below for details."),_c('br'),_c('strong',[_vm._v("Gold Package")]),_vm._v(" includes online access to Stroke OnDemand™ – slides with synchronized audio from any computer, tablet or smartphone. (Hard Drive purchase available for additional $60)")])])])])])],2)],1),_vm._v(" "),_c('h1',{staticClass:"page-heading mb-0 mt-5"},[_vm._v("Membership Rate Comparison (2 data columns)")]),_vm._v(" "),_c('aha-component',{attrs:{"title":""}},[_c('membership-rate-comparison',{attrs:{"table-data":_vm.demoDataMembershipRateComparison2datacolumns}},[_c('template',{slot:"postTableContent"},[_c('div',{staticClass:"flex-table__content-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"rate-comparison__disclaimer-title"},[_vm._v("2Title here is optional")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 rate-comparison__disclaimer-content"},[_c('p',[_vm._v("*Verification of Student/Trainee status is required. Please see \"Membership Discounts\" below for details."),_c('br'),_c('strong',[_vm._v("Gold Package")]),_vm._v(" includes online access to Stroke OnDemand™ – slides with synchronized audio from any computer, tablet or smartphone. (Hard Drive purchase available for additional $60)")])])])])])],2)],1),_vm._v(" "),_c('h1',{staticClass:"page-heading mb-0 mt-5"},[_vm._v("Membership Rate Comparison (1 data columns)")]),_vm._v(" "),_c('aha-component',{attrs:{"title":""}},[_c('membership-rate-comparison',{attrs:{"table-data":_vm.demoDataMembershipRateComparison1datacolumn}},[_c('template',{slot:"postTableContent"},[_c('div',{staticClass:"flex-table__content-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"rate-comparison__disclaimer-title"},[_vm._v("3Title here is optional")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 rate-comparison__disclaimer-content"},[_c('p',[_vm._v("*Verification of Student/Trainee status is required. Please see \"Membership Discounts\" below for details."),_c('br'),_c('strong',[_vm._v("Gold Package")]),_vm._v(" includes online access to Stroke OnDemand™ – slides with synchronized audio from any computer, tablet or smartphone. (Hard Drive purchase available for additional $60)")])])])])])],2)],1),_vm._v(" "),_c('h1',{staticClass:"page-heading mb-0 mt-5"},[_vm._v("Membership Rate Comparison (1 data columns, no gold data)")]),_vm._v(" "),_c('aha-component',{attrs:{"title":""}},[_c('membership-rate-comparison',{attrs:{"table-data":_vm.demoDataMembershipRateComparison1datacolumnNoGold}},[_c('template',{slot:"postTableContent"},[_c('div',{staticClass:"flex-table__content-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"rate-comparison__disclaimer-title"},[_vm._v("4Title here is optional")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 rate-comparison__disclaimer-content"},[_c('p',[_vm._v("*Verification of Student/Trainee status is required. Please see \"Membership Discounts\" below for details."),_c('br'),_c('strong',[_vm._v("Gold Package")]),_vm._v(" includes online access to Stroke OnDemand™ – slides with synchronized audio from any computer, tablet or smartphone. (Hard Drive purchase available for additional $60)")])])])])])],2)],1),_vm._v(" "),_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Membership Rate Comparison")]),_vm._v(" "),_c('aha-component',{attrs:{"title":""}},[_c('daily-rate-comparison',{attrs:{"tables":_vm.demoDataDailyRateComparison}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_community_tabs_vue__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_community_tabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_community_tabs_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_community_tabs_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_community_tabs_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f53e50c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_community_tabs_vue__ = __webpack_require__(1661);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_community_tabs_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f53e50c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_community_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('div',{staticClass:"l-main"},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-phd l-phd--phd-community"},[_c('div',[_c('div',{staticClass:"d-flex c-simple-tabs c-simple-tabs--border-top"},[_c('div',{staticClass:"col-sm-12"},[_c('b-tabs',{directives:[{name:"tabs-custom-tabbing",rawName:"v-tabs-custom-tabbing"}],attrs:{"vertical":"","nav-wrapper-class":"col-md-4 tabs__nav tabs__nav--phd-community","content-class":"tab-content--phd-community"}},[_c('b-tab',{attrs:{"title":"Journals","active":""}},[_c('simple-accordion',{attrs:{"title":"Journals","variant":"phd-community"}},[_c('h2',{staticClass:"phd-h2 c-programming__heading"},[_vm._v("Related Journal Content")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"news-link news-link--phd-community"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("VIEW ALL Related Journals Content")])])])])])])])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Science News"}},[_c('simple-accordion',{attrs:{"title":"Science News","variant":"phd-community"}},[_c('h2',{staticClass:"phd-h2 c-programming__heading"},[_vm._v("Related Science News")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"news-link news-link--phd-community"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("VIEW ALL Related Science News Content")])])])])])])])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Guidelines & Statements"}},[_c('simple-accordion',{attrs:{"title":"Guidelines & Statements","variant":"phd-community"}},[_c('h2',{staticClass:"phd-h2 c-programming__heading"},[_vm._v("Related Guidelines & Statements")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("Published Nov 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("Published Nov 2019")])]),_vm._v(" "),_c('div',{staticClass:"news-link news-link--phd-community"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("VIEW ALL Related Guidelines & Statements Content")])])])])])])])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Meetings"}},[_c('simple-accordion',{attrs:{"title":"Meetings","variant":"phd-community"}},[_c('h2',{staticClass:"phd-h2 c-programming__heading"},[_vm._v("Related Meetings")]),_vm._v(" "),_c('phd-meeting'),_vm._v(" "),_c('phd-meeting'),_vm._v(" "),_c('div',{staticClass:"news-link news-link--phd-community"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("VIEW ALL Meetings")])])])])])])],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Education"}},[_c('simple-accordion',{attrs:{"title":"Continuing Education","variant":"phd-community"}},[_c('h2',{staticClass:"phd-h2 c-programming__heading"},[_vm._v("Continuing Education")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link PHD__article-link--large",attrs:{"href":"#"}},[_vm._v("Cryptogenic Stroke: Evaluation and Management")]),_vm._v(" "),_c('p',{staticClass:"PHD__article-summary"},[_vm._v("This webinar series covers evaluation of patients with cryptogenic stroke, cardiac monitoring and the role of atrial cardiopathy; and the management Strategies for patients with cryptogenic stroke. Descriptions and accreditations are shown under Activity Information. Accreditation is claimed separately on each activity. Click the Register button to purchase the bundle.")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link PHD__article-link--large",attrs:{"href":"#"}},[_vm._v("Cryptogenic Stroke: Evaluation and Management")]),_vm._v(" "),_c('p',{staticClass:"PHD__article-summary"},[_vm._v("This webinar series covers evaluation of patients with cryptogenic stroke, cardiac monitoring and the role of atrial cardiopathy; and the management Strategies for patients with cryptogenic stroke. Descriptions and accreditations are shown under Activity Information. Accreditation is claimed separately on each activity. Click the Register button to purchase the bundle.")])]),_vm._v(" "),_c('div',{staticClass:"news-link news-link--phd-community"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("VIEW MORE EDUCATION ON LIFE LONG LEARNING")])])])])])])])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Council"}},[_c('simple-accordion',{attrs:{"title":"Scientific Councils","variant":"phd-community"}},[_c('h2',{staticClass:"phd-h2 c-programming__heading"},[_vm._v("Related Scientific Councils")]),_vm._v(" "),_c('phd-card'),_vm._v(" "),_c('phd-card'),_vm._v(" "),_c('phd-card'),_vm._v(" "),_c('phd-card'),_vm._v(" "),_c('div',{staticClass:"news-link news-link--phd-community"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("VIEW ALL Related Councils Content")])])])])])])],1)],1)],1)],1)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Community Tabs")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tier_selector_vue__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tier_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tier_selector_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tier_selector_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tier_selector_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd3e8f10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tier_selector_vue__ = __webpack_require__(1663);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tier_selector_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd3e8f10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tier_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD tier-selector"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-4 l-promo-code"},[_c('div',{staticClass:"c-promo-code"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-promo-code",modifiers:{"collapse-promo-code":true}}],staticClass:"c-promo-code__btn btn--select w-100"},[_vm._v("Have a promo code?")]),_vm._v(" "),_c('b-collapse',{staticClass:"c-promo-code__content",attrs:{"id":"collapse-promo-code"}},[_c('div',{},[_vm._v(" ")]),_vm._v(" "),_c('form',{staticClass:"form-inline",attrs:{"action":""}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"sr-only",attrs:{"for":"inputPromoCode"}},[_vm._v("Promo Code")]),_vm._v(" "),_c('input',{staticClass:"form-control input--small",attrs:{"type":"text","id":"inputPromoCode","placeholder":"Enter promo code"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("Add")])])])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row l-tier-selector"},[_c('div',{staticClass:"c-tier-selector__tabs"},[_c('div',{staticClass:"nav nav-pills nav-justified",attrs:{"id":"pills-tab","role":"tablist"}},[_c('a',{staticClass:"nav-item nav-link",class:{ active: _vm.isActive('premier') },attrs:{"id":"v-pills-premier-tab","data-toggle":"pill","href":"#v-pills-premier","role":"tab","aria-controls":"v-pills-premier","aria-selected":[_vm.isActive('premier') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('premier')}}},[_vm._m(2)]),_vm._v(" "),_c('a',{staticClass:"nav-item nav-link",class:{ active: _vm.isActive('professional') },attrs:{"id":"v-pills-professional-tab","data-toggle":"pill","href":"#v-pills-professional","role":"tab","aria-controls":"v-pills-professional","aria-selected":[_vm.isActive('professional') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('professional')}}},[_vm._m(3)]),_vm._v(" "),_c('a',{staticClass:"nav-item nav-link",class:{ active: _vm.isActive('student') },attrs:{"id":"v-pills-student-tab","data-toggle":"pill","href":"#v-pills-student","role":"tab","aria-controls":"v-pills-student","aria-selected":[_vm.isActive('student') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('student')}}},[_vm._m(4)]),_vm._v(" "),_c('a',{staticClass:"nav-item nav-link",class:{ active: _vm.isActive('early') },attrs:{"id":"v-pills-early-tab","data-toggle":"pill","href":"#v-pills-early","role":"tab","aria-controls":"v-pills-early","aria-selected":[_vm.isActive('early') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('early')}}},[_vm._m(5)]),_vm._v(" "),_c('a',{staticClass:"nav-item nav-link",class:{ active: _vm.isActive('general') },attrs:{"id":"v-pills-general-tab","data-toggle":"pill","href":"#v-pills-general","role":"tab","aria-controls":"v-pills-general","aria-selected":[_vm.isActive('general') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('general')}}},[_vm._m(6)])])]),_vm._v(" "),_c('div',{staticClass:"c-tier-selector__tab-panels"},[_c('div',{staticClass:"tab-content",attrs:{"id":"pills-tabContent"}},[_c('div',{staticClass:"tab-pane",class:{ 'active show': _vm.isActive('premier') },attrs:{"id":"v-pills-premier","role":"tabpanel","aria-labelledby":"v-pills-premier-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-premier'),expression:"'panel-collapse-premier'"}],staticClass:"btn btn--select",class:{ active: _vm.isActive('premier') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('premier')}}},[_c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__icon"},[_c('svg',{attrs:{"width":"80px","height":"80px","viewBox":"0 0 80 80","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"id":"AHA_UI_Kit_Page2","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","transform":"translate(-355.000000, -4354.000000)"}},[_c('g',{attrs:{"id":"laugh-Icon","transform":"translate(355.000000, 4354.000000)","fill":"#6D6E71","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M40,0 C17.9442188,0 0,17.9442188 0,40 C0,62.0557813 17.9442188,80 40,80 C62.0557812,80 80,62.0557812 80,40 C80,17.9442188 62.0557812,0 40,0 Z M40,77.0370312 C19.5775,77.0370312 2.96296875,60.4225 2.96296875,40 C2.96296875,19.5775 19.5775,2.96296875 40,2.96296875 C60.4225,2.96296875 77.0370312,19.5775 77.0370312,40 C77.0370312,60.4225 60.4225,77.0370312 40,77.0370312 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M65.1851562,38.5115625 L14.8148437,38.5115625 C13.9967187,38.5115625 13.3332812,39.1782812 13.3332812,39.9967187 C13.3332812,54.7007812 25.2957812,66.665 40,66.665 C54.7042187,66.665 66.6667188,54.7 66.6667188,39.9957812 C66.6667187,39.1775 66.0032812,38.5115625 65.1851562,38.5115625 Z M40,63.70375 C33.913125,63.70375 28.3590625,61.3928125 24.156875,57.6079687 C26.1046875,55.0878125 32.0932812,48.8164062 40.8189062,53.1771875 C41.3354687,53.4346875 41.9567187,53.3703125 42.4067187,53.0085938 C42.6620312,52.80625 48.6864062,48.1704688 56.4553125,57.0390625 C52.1884375,61.1610937 46.386875,63.70375 40,63.70375 Z M58.4673437,54.839375 C50.68125,46.14875 43.7117187,48.849375 41.3809375,50.163125 C31.6215625,45.7882812 24.6779687,52.3714062 22.0857812,55.4954687 C18.7851562,51.6857812 16.6732812,46.6595312 16.3417187,41.474375 L63.6579687,41.474375 C63.3454687,46.6596875 61.4510937,51.134375 58.4673437,54.839375 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M31.1110938,22.2151562 L22.2221875,22.2151562 C21.4040625,22.2151562 20.740625,22.8784375 20.740625,23.6967187 C20.740625,24.515 21.4039063,25.178125 22.2221875,25.178125 L31.1110938,25.178125 C31.9292188,25.178125 32.5926563,24.5148437 32.5926563,23.6967187 C32.5926563,22.8785938 31.9292188,22.2151562 31.1110938,22.2151562 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M56.29625,22.2151562 L47.4073437,22.2151562 C46.5892188,22.2151562 45.9257812,22.8784375 45.9257812,23.6967187 C45.9257812,24.515 46.5890625,25.178125 47.4073437,25.178125 L56.29625,25.178125 C57.114375,25.178125 57.7776562,24.5148437 57.7776562,23.6967187 C57.7776562,22.8785938 57.114375,22.2151562 56.29625,22.2151562 Z","id":"Shape"}})])])])]),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-premier","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4"},[_vm._v("Premier")]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Council Affilitions")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Affiliate with up to two of our "),_c('strong',[_c('a',{attrs:{"href":"/professional/MembershipCouncils/ScientificCouncils/UCM_475327_Scientific-Councils.jsp","target":"_blank"}},[_vm._v("16 Scientific Councils")])]),_vm._v(".")]),_vm._v(" "),_c('li',[_vm._v("(Optional) Affiliate with a third council for an additional $65/year.")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("AHA Scientific Journals")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Access to all "),_c('strong',[_vm._v("11 online")]),_vm._v(" "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/","target":"_blank"}},[_vm._v("AHA scientific journals")])]),_vm._v(" (full text)")]),_vm._v(" "),_c('li',[_vm._v("Yearly print subscriptions only $225 per journal ("),_c('em',[_vm._v("ATVB, Circulation, Circulation Research, Hypertension, Stroke")]),_vm._v(")")]),_vm._v(" "),_c('li',[_vm._v("Access to CME credits through the "),_c('strong',[_c('a',{attrs:{"href":"https://cme.ahajournals.org/s/catalog","target":"_blank"}},[_vm._v("AHA Journals CME")]),_vm._v(" ")]),_vm._v("program")]),_vm._v(" "),_c('li',[_c('strong',[_c('a',{attrs:{"href":"/professional/Journals/UCM_491607_JAHA-Discount-for-AHA-Professional-Members.jsp","target":"_blank"}},[_vm._v("Discounted article publication charges")])]),_vm._v(" for accepted articles in "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/journal/jaha","target":"_blank"}},[_c('em',[_vm._v("JAHA")])])]),_vm._v(" (the AHA/ASA’s Open Access journal that’s freely accessible). Members save $700 with discount code")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Conferences and Education")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Save on AHA/ASA "),_c('strong',[_c('a',{attrs:{"href":"/professional/EducationMeetings/MeetingsLiveCME/UCM_475321_Meetings.jsp","target":"_blank"}},[_vm._v("Scientific Conferences")]),_vm._v(" ")]),_vm._v("registration")]),_vm._v(" "),_c('li',[_vm._v("Savings on Science OnDemand® products,")]),_vm._v(" "),_c('li',[_vm._v("Priority Registration and Housing for Scientific Sessions and the International Stroke Conference")]),_vm._v(" "),_c('li',[_vm._v("Complimentary and/or discounted courses through the "),_c('strong',[_c('a',{attrs:{"href":"https://learn.heart.org/","target":"_blank"}},[_vm._v("Lifelong Learning Center")])])])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Opportunities")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Funding opportunities for members only")]),_vm._v(" "),_c('li',[_vm._v("Become a "),_c('strong',[_c('a',{attrs:{"href":"/professional/ProfessionalMembership/FellowofAHAFAHA/UCM_475326_Fellow-of-AHA-FAHA.jsp","target":"_blank"}},[_vm._v("Fellow of the American Heart Association (FAHA)")])])]),_vm._v(" "),_c('li',[_vm._v("Leadership Opportunities")]),_vm._v(" "),_c('li',[_vm._v("Networking with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and to mentor others")]),_vm._v(" "),_c('li',[_vm._v("Access to Science News")]),_vm._v(" "),_c('li',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('li',[_vm._v("Quarterly AHA Connections Newsletter")]),_vm._v(" "),_c('li',[_vm._v("Inclusion/ access to the online AHA/ASA Professional Membership Directory")]),_vm._v(" "),_c('li',[_vm._v("Achieve Golden and Silver Heart Membership")]),_vm._v(" "),_c('li',[_vm._v("Be a part of the Emeritus Membership program")])]),_vm._v(" "),_c('div',{staticClass:"btn-wrapper"},[_c('a',{staticClass:"btn btn-primary btn-round btn-block btn--signup",attrs:{"href":"#"}},[_vm._v("Sign Up")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane",class:{ 'show active': _vm.isActive('professional') },attrs:{"id":"v-pills-professional","role":"tabpanel","aria-labelledby":"v-pills-professional-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-professional'),expression:"'panel-collapse-professional'"}],staticClass:"btn btn--select",class:{ active: _vm.isActive('professional') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('professional')}}},[_c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__icon"},[_c('svg',{attrs:{"width":"80px","height":"80px","viewBox":"0 0 80 80","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"id":"AHA_UI_Kit_Page2","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","transform":"translate(-355.000000, -4354.000000)"}},[_c('g',{attrs:{"id":"laugh-Icon","transform":"translate(355.000000, 4354.000000)","fill":"#6D6E71","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M40,0 C17.9442188,0 0,17.9442188 0,40 C0,62.0557813 17.9442188,80 40,80 C62.0557812,80 80,62.0557812 80,40 C80,17.9442188 62.0557812,0 40,0 Z M40,77.0370312 C19.5775,77.0370312 2.96296875,60.4225 2.96296875,40 C2.96296875,19.5775 19.5775,2.96296875 40,2.96296875 C60.4225,2.96296875 77.0370312,19.5775 77.0370312,40 C77.0370312,60.4225 60.4225,77.0370312 40,77.0370312 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M65.1851562,38.5115625 L14.8148437,38.5115625 C13.9967187,38.5115625 13.3332812,39.1782812 13.3332812,39.9967187 C13.3332812,54.7007812 25.2957812,66.665 40,66.665 C54.7042187,66.665 66.6667188,54.7 66.6667188,39.9957812 C66.6667187,39.1775 66.0032812,38.5115625 65.1851562,38.5115625 Z M40,63.70375 C33.913125,63.70375 28.3590625,61.3928125 24.156875,57.6079687 C26.1046875,55.0878125 32.0932812,48.8164062 40.8189062,53.1771875 C41.3354687,53.4346875 41.9567187,53.3703125 42.4067187,53.0085938 C42.6620312,52.80625 48.6864062,48.1704688 56.4553125,57.0390625 C52.1884375,61.1610937 46.386875,63.70375 40,63.70375 Z M58.4673437,54.839375 C50.68125,46.14875 43.7117187,48.849375 41.3809375,50.163125 C31.6215625,45.7882812 24.6779687,52.3714062 22.0857812,55.4954687 C18.7851562,51.6857812 16.6732812,46.6595312 16.3417187,41.474375 L63.6579687,41.474375 C63.3454687,46.6596875 61.4510937,51.134375 58.4673437,54.839375 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M31.1110938,22.2151562 L22.2221875,22.2151562 C21.4040625,22.2151562 20.740625,22.8784375 20.740625,23.6967187 C20.740625,24.515 21.4039063,25.178125 22.2221875,25.178125 L31.1110938,25.178125 C31.9292188,25.178125 32.5926563,24.5148437 32.5926563,23.6967187 C32.5926563,22.8785938 31.9292188,22.2151562 31.1110938,22.2151562 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M56.29625,22.2151562 L47.4073437,22.2151562 C46.5892188,22.2151562 45.9257812,22.8784375 45.9257812,23.6967187 C45.9257812,24.515 46.5890625,25.178125 47.4073437,25.178125 L56.29625,25.178125 C57.114375,25.178125 57.7776562,24.5148437 57.7776562,23.6967187 C57.7776562,22.8785938 57.114375,22.2151562 56.29625,22.2151562 Z","id":"Shape"}})])])])]),_vm._v(" "),_vm._m(8)])]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-professional","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4"},[_vm._v("Professional")]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Council Affilitions")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Affiliate with up to two of our "),_c('strong',[_c('a',{attrs:{"href":"/professional/MembershipCouncils/ScientificCouncils/UCM_475327_Scientific-Councils.jsp","target":"_blank"}},[_vm._v("16 Scientific Councils")])]),_vm._v(".")]),_vm._v(" "),_c('li',[_vm._v("(Optional) Affiliate with a third council for an additional $65/year.")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("AHA Scientific Journals")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Access to all "),_c('strong',[_vm._v("11 online")]),_vm._v(" "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/","target":"_blank"}},[_vm._v("AHA scientific journals")])]),_vm._v(" (full text)")]),_vm._v(" "),_c('li',[_vm._v("Yearly print subscriptions only $225 per journal ("),_c('em',[_vm._v("ATVB, Circulation, Circulation Research, Hypertension, Stroke")]),_vm._v(")")]),_vm._v(" "),_c('li',[_vm._v("Access to CME credits through the "),_c('strong',[_c('a',{attrs:{"href":"https://cme.ahajournals.org/s/catalog","target":"_blank"}},[_vm._v("AHA Journals CME")]),_vm._v(" ")]),_vm._v("program")]),_vm._v(" "),_c('li',[_c('strong',[_c('a',{attrs:{"href":"/professional/Journals/UCM_491607_JAHA-Discount-for-AHA-Professional-Members.jsp","target":"_blank"}},[_vm._v("Discounted article publication charges")])]),_vm._v(" for accepted articles in "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/journal/jaha","target":"_blank"}},[_c('em',[_vm._v("JAHA")])])]),_vm._v(" (the AHA/ASA’s Open Access journal that’s freely accessible). Members save $700 with discount code")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Conferences and Education")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Save on AHA/ASA "),_c('strong',[_c('a',{attrs:{"href":"/professional/EducationMeetings/MeetingsLiveCME/UCM_475321_Meetings.jsp","target":"_blank"}},[_vm._v("Scientific Conferences")]),_vm._v(" ")]),_vm._v("registration")]),_vm._v(" "),_c('li',[_vm._v("Savings on Science OnDemand® products,")]),_vm._v(" "),_c('li',[_vm._v("Priority Registration and Housing for Scientific Sessions and the International Stroke Conference")]),_vm._v(" "),_c('li',[_vm._v("Complimentary and/or discounted courses through the "),_c('strong',[_c('a',{attrs:{"href":"https://learn.heart.org/","target":"_blank"}},[_vm._v("Lifelong Learning Center")])])])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Opportunities")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Funding opportunities for members only")]),_vm._v(" "),_c('li',[_vm._v("Become a "),_c('strong',[_c('a',{attrs:{"href":"/professional/ProfessionalMembership/FellowofAHAFAHA/UCM_475326_Fellow-of-AHA-FAHA.jsp","target":"_blank"}},[_vm._v("Fellow of the American Heart Association (FAHA)")])])]),_vm._v(" "),_c('li',[_vm._v("Leadership Opportunities")]),_vm._v(" "),_c('li',[_vm._v("Networking with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and to mentor others")]),_vm._v(" "),_c('li',[_vm._v("Access to Science News")]),_vm._v(" "),_c('li',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('li',[_vm._v("Quarterly AHA Connections Newsletter")]),_vm._v(" "),_c('li',[_vm._v("Inclusion/ access to the online AHA/ASA Professional Membership Directory")]),_vm._v(" "),_c('li',[_vm._v("Achieve Golden and Silver Heart Membership")]),_vm._v(" "),_c('li',[_vm._v("Be a part of the Emeritus Membership program")])]),_vm._v(" "),_c('div',{staticClass:"btn-wrapper"},[_c('a',{staticClass:"btn btn-primary btn-round btn-block btn--signup",attrs:{"href":"#"}},[_vm._v("Sign Up")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane",class:{ 'show active': _vm.isActive('student') },attrs:{"id":"v-pills-student","role":"tabpanel","aria-labelledby":"v-pills-student-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-student'),expression:"'panel-collapse-student'"}],staticClass:"btn btn--select",class:{ active: _vm.isActive('student') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('student')}}},[_c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__icon"},[_c('svg',{attrs:{"width":"80px","height":"80px","viewBox":"0 0 80 80","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"id":"AHA_UI_Kit_Page2","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","transform":"translate(-355.000000, -4354.000000)"}},[_c('g',{attrs:{"id":"laugh-Icon","transform":"translate(355.000000, 4354.000000)","fill":"#6D6E71","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M40,0 C17.9442188,0 0,17.9442188 0,40 C0,62.0557813 17.9442188,80 40,80 C62.0557812,80 80,62.0557812 80,40 C80,17.9442188 62.0557812,0 40,0 Z M40,77.0370312 C19.5775,77.0370312 2.96296875,60.4225 2.96296875,40 C2.96296875,19.5775 19.5775,2.96296875 40,2.96296875 C60.4225,2.96296875 77.0370312,19.5775 77.0370312,40 C77.0370312,60.4225 60.4225,77.0370312 40,77.0370312 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M65.1851562,38.5115625 L14.8148437,38.5115625 C13.9967187,38.5115625 13.3332812,39.1782812 13.3332812,39.9967187 C13.3332812,54.7007812 25.2957812,66.665 40,66.665 C54.7042187,66.665 66.6667188,54.7 66.6667188,39.9957812 C66.6667187,39.1775 66.0032812,38.5115625 65.1851562,38.5115625 Z M40,63.70375 C33.913125,63.70375 28.3590625,61.3928125 24.156875,57.6079687 C26.1046875,55.0878125 32.0932812,48.8164062 40.8189062,53.1771875 C41.3354687,53.4346875 41.9567187,53.3703125 42.4067187,53.0085938 C42.6620312,52.80625 48.6864062,48.1704688 56.4553125,57.0390625 C52.1884375,61.1610937 46.386875,63.70375 40,63.70375 Z M58.4673437,54.839375 C50.68125,46.14875 43.7117187,48.849375 41.3809375,50.163125 C31.6215625,45.7882812 24.6779687,52.3714062 22.0857812,55.4954687 C18.7851562,51.6857812 16.6732812,46.6595312 16.3417187,41.474375 L63.6579687,41.474375 C63.3454687,46.6596875 61.4510937,51.134375 58.4673437,54.839375 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M31.1110938,22.2151562 L22.2221875,22.2151562 C21.4040625,22.2151562 20.740625,22.8784375 20.740625,23.6967187 C20.740625,24.515 21.4039063,25.178125 22.2221875,25.178125 L31.1110938,25.178125 C31.9292188,25.178125 32.5926563,24.5148437 32.5926563,23.6967187 C32.5926563,22.8785938 31.9292188,22.2151562 31.1110938,22.2151562 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M56.29625,22.2151562 L47.4073437,22.2151562 C46.5892188,22.2151562 45.9257812,22.8784375 45.9257812,23.6967187 C45.9257812,24.515 46.5890625,25.178125 47.4073437,25.178125 L56.29625,25.178125 C57.114375,25.178125 57.7776562,24.5148437 57.7776562,23.6967187 C57.7776562,22.8785938 57.114375,22.2151562 56.29625,22.2151562 Z","id":"Shape"}})])])])]),_vm._v(" "),_vm._m(9)])]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-student","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4"},[_vm._v("Student/Trainee")]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Council Affilitions")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Affiliate with up to two of our "),_c('strong',[_c('a',{attrs:{"href":"/professional/MembershipCouncils/ScientificCouncils/UCM_475327_Scientific-Councils.jsp","target":"_blank"}},[_vm._v("16 Scientific Councils")])]),_vm._v(".")]),_vm._v(" "),_c('li',[_vm._v("(Optional) Affiliate with a third council for an additional $65/year.")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("AHA Scientific Journals")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Access to all "),_c('strong',[_vm._v("11 online")]),_vm._v(" "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/","target":"_blank"}},[_vm._v("AHA scientific journals")])]),_vm._v(" (full text)")]),_vm._v(" "),_c('li',[_vm._v("Yearly print subscriptions only $225 per journal ("),_c('em',[_vm._v("ATVB, Circulation, Circulation Research, Hypertension, Stroke")]),_vm._v(")")]),_vm._v(" "),_c('li',[_vm._v("Access to CME credits through the "),_c('strong',[_c('a',{attrs:{"href":"https://cme.ahajournals.org/s/catalog","target":"_blank"}},[_vm._v("AHA Journals CME")]),_vm._v(" ")]),_vm._v("program")]),_vm._v(" "),_c('li',[_c('strong',[_c('a',{attrs:{"href":"/professional/Journals/UCM_491607_JAHA-Discount-for-AHA-Professional-Members.jsp","target":"_blank"}},[_vm._v("Discounted article publication charges")])]),_vm._v(" for accepted articles in "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/journal/jaha","target":"_blank"}},[_c('em',[_vm._v("JAHA")])])]),_vm._v(" (the AHA/ASA’s Open Access journal that’s freely accessible). Members save $700 with discount code")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Conferences and Education")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Save on AHA/ASA "),_c('strong',[_c('a',{attrs:{"href":"/professional/EducationMeetings/MeetingsLiveCME/UCM_475321_Meetings.jsp","target":"_blank"}},[_vm._v("Scientific Conferences")]),_vm._v(" ")]),_vm._v("registration")]),_vm._v(" "),_c('li',[_vm._v("Savings on Science OnDemand® products,")]),_vm._v(" "),_c('li',[_vm._v("Priority Registration and Housing for Scientific Sessions and the International Stroke Conference")]),_vm._v(" "),_c('li',[_vm._v("Complimentary and/or discounted courses through the "),_c('strong',[_c('a',{attrs:{"href":"https://learn.heart.org/","target":"_blank"}},[_vm._v("Lifelong Learning Center")])])])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Opportunities")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Funding opportunities for members only")]),_vm._v(" "),_c('li',[_vm._v("Become a "),_c('strong',[_c('a',{attrs:{"href":"/professional/ProfessionalMembership/FellowofAHAFAHA/UCM_475326_Fellow-of-AHA-FAHA.jsp","target":"_blank"}},[_vm._v("Fellow of the American Heart Association (FAHA)")])])]),_vm._v(" "),_c('li',[_vm._v("Leadership Opportunities")]),_vm._v(" "),_c('li',[_vm._v("Networking with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and to mentor others")]),_vm._v(" "),_c('li',[_vm._v("Access to Science News")]),_vm._v(" "),_c('li',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('li',[_vm._v("Quarterly AHA Connections Newsletter")]),_vm._v(" "),_c('li',[_vm._v("Inclusion/ access to the online AHA/ASA Professional Membership Directory")]),_vm._v(" "),_c('li',[_vm._v("Achieve Golden and Silver Heart Membership")]),_vm._v(" "),_c('li',[_vm._v("Be a part of the Emeritus Membership program")])]),_vm._v(" "),_c('div',{staticClass:"btn-wrapper"},[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('limited-membership-modal'),expression:"'limited-membership-modal'"}],staticClass:"btn btn-primary btn-round btn-block btn--signup",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Sign Up")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane",class:{ 'show active': _vm.isActive('early') },attrs:{"id":"v-pills-early","role":"tabpanel","aria-labelledby":"v-pills-early-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-early'),expression:"'panel-collapse-early'"}],staticClass:"btn btn--select",class:{ active: _vm.isActive('early') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('early')}}},[_c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__icon"},[_c('svg',{attrs:{"width":"80px","height":"80px","viewBox":"0 0 80 80","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"id":"AHA_UI_Kit_Page2","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","transform":"translate(-355.000000, -4354.000000)"}},[_c('g',{attrs:{"id":"laugh-Icon","transform":"translate(355.000000, 4354.000000)","fill":"#6D6E71","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M40,0 C17.9442188,0 0,17.9442188 0,40 C0,62.0557813 17.9442188,80 40,80 C62.0557812,80 80,62.0557812 80,40 C80,17.9442188 62.0557812,0 40,0 Z M40,77.0370312 C19.5775,77.0370312 2.96296875,60.4225 2.96296875,40 C2.96296875,19.5775 19.5775,2.96296875 40,2.96296875 C60.4225,2.96296875 77.0370312,19.5775 77.0370312,40 C77.0370312,60.4225 60.4225,77.0370312 40,77.0370312 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M65.1851562,38.5115625 L14.8148437,38.5115625 C13.9967187,38.5115625 13.3332812,39.1782812 13.3332812,39.9967187 C13.3332812,54.7007812 25.2957812,66.665 40,66.665 C54.7042187,66.665 66.6667188,54.7 66.6667188,39.9957812 C66.6667187,39.1775 66.0032812,38.5115625 65.1851562,38.5115625 Z M40,63.70375 C33.913125,63.70375 28.3590625,61.3928125 24.156875,57.6079687 C26.1046875,55.0878125 32.0932812,48.8164062 40.8189062,53.1771875 C41.3354687,53.4346875 41.9567187,53.3703125 42.4067187,53.0085938 C42.6620312,52.80625 48.6864062,48.1704688 56.4553125,57.0390625 C52.1884375,61.1610937 46.386875,63.70375 40,63.70375 Z M58.4673437,54.839375 C50.68125,46.14875 43.7117187,48.849375 41.3809375,50.163125 C31.6215625,45.7882812 24.6779687,52.3714062 22.0857812,55.4954687 C18.7851562,51.6857812 16.6732812,46.6595312 16.3417187,41.474375 L63.6579687,41.474375 C63.3454687,46.6596875 61.4510937,51.134375 58.4673437,54.839375 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M31.1110938,22.2151562 L22.2221875,22.2151562 C21.4040625,22.2151562 20.740625,22.8784375 20.740625,23.6967187 C20.740625,24.515 21.4039063,25.178125 22.2221875,25.178125 L31.1110938,25.178125 C31.9292188,25.178125 32.5926563,24.5148437 32.5926563,23.6967187 C32.5926563,22.8785938 31.9292188,22.2151562 31.1110938,22.2151562 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M56.29625,22.2151562 L47.4073437,22.2151562 C46.5892188,22.2151562 45.9257812,22.8784375 45.9257812,23.6967187 C45.9257812,24.515 46.5890625,25.178125 47.4073437,25.178125 L56.29625,25.178125 C57.114375,25.178125 57.7776562,24.5148437 57.7776562,23.6967187 C57.7776562,22.8785938 57.114375,22.2151562 56.29625,22.2151562 Z","id":"Shape"}})])])])]),_vm._v(" "),_vm._m(10)])]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-early","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4"},[_vm._v("Early Career")]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Council Affilitions")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Affiliate with up to two of our "),_c('strong',[_c('a',{attrs:{"href":"/professional/MembershipCouncils/ScientificCouncils/UCM_475327_Scientific-Councils.jsp","target":"_blank"}},[_vm._v("16 Scientific Councils")])]),_vm._v(".")]),_vm._v(" "),_c('li',[_vm._v("(Optional) Affiliate with a third council for an additional $65/year.")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("AHA Scientific Journals")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Access to all "),_c('strong',[_vm._v("11 online")]),_vm._v(" "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/","target":"_blank"}},[_vm._v("AHA scientific journals")])]),_vm._v(" (full text)")]),_vm._v(" "),_c('li',[_vm._v("Yearly print subscriptions only $225 per journal ("),_c('em',[_vm._v("ATVB, Circulation, Circulation Research, Hypertension, Stroke")]),_vm._v(")")]),_vm._v(" "),_c('li',[_vm._v("Access to CME credits through the "),_c('strong',[_c('a',{attrs:{"href":"https://cme.ahajournals.org/s/catalog","target":"_blank"}},[_vm._v("AHA Journals CME")]),_vm._v(" ")]),_vm._v("program")]),_vm._v(" "),_c('li',[_c('strong',[_c('a',{attrs:{"href":"/professional/Journals/UCM_491607_JAHA-Discount-for-AHA-Professional-Members.jsp","target":"_blank"}},[_vm._v("Discounted article publication charges")])]),_vm._v(" for accepted articles in "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/journal/jaha","target":"_blank"}},[_c('em',[_vm._v("JAHA")])])]),_vm._v(" (the AHA/ASA’s Open Access journal that’s freely accessible). Members save $700 with discount code")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Conferences and Education")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Save on AHA/ASA "),_c('strong',[_c('a',{attrs:{"href":"/professional/EducationMeetings/MeetingsLiveCME/UCM_475321_Meetings.jsp","target":"_blank"}},[_vm._v("Scientific Conferences")]),_vm._v(" ")]),_vm._v("registration")]),_vm._v(" "),_c('li',[_vm._v("Savings on Science OnDemand® products,")]),_vm._v(" "),_c('li',[_vm._v("Priority Registration and Housing for Scientific Sessions and the International Stroke Conference")]),_vm._v(" "),_c('li',[_vm._v("Complimentary and/or discounted courses through the "),_c('strong',[_c('a',{attrs:{"href":"https://learn.heart.org/","target":"_blank"}},[_vm._v("Lifelong Learning Center")])])])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Opportunities")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Funding opportunities for members only")]),_vm._v(" "),_c('li',[_vm._v("Become a "),_c('strong',[_c('a',{attrs:{"href":"/professional/ProfessionalMembership/FellowofAHAFAHA/UCM_475326_Fellow-of-AHA-FAHA.jsp","target":"_blank"}},[_vm._v("Fellow of the American Heart Association (FAHA)")])])]),_vm._v(" "),_c('li',[_vm._v("Leadership Opportunities")]),_vm._v(" "),_c('li',[_vm._v("Networking with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and to mentor others")]),_vm._v(" "),_c('li',[_vm._v("Access to Science News")]),_vm._v(" "),_c('li',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('li',[_vm._v("Quarterly AHA Connections Newsletter")]),_vm._v(" "),_c('li',[_vm._v("Inclusion/ access to the online AHA/ASA Professional Membership Directory")]),_vm._v(" "),_c('li',[_vm._v("Achieve Golden and Silver Heart Membership")]),_vm._v(" "),_c('li',[_vm._v("Be a part of the Emeritus Membership program")])]),_vm._v(" "),_c('div',{staticClass:"btn-wrapper"},[_c('a',{staticClass:"btn btn-primary btn-round btn-block btn--signup",attrs:{"href":"#"}},[_vm._v("Sign Up")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane",class:{ 'show active': _vm.isActive('general') },attrs:{"id":"v-pills-general","role":"tabpanel","aria-labelledby":"v-pills-general-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-general'),expression:"'panel-collapse-general'"}],staticClass:"btn btn--select",class:{ active: _vm.isActive('general') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('general')}}},[_c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__icon"},[_c('svg',{attrs:{"width":"80px","height":"80px","viewBox":"0 0 80 80","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"id":"AHA_UI_Kit_Page2","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","transform":"translate(-355.000000, -4354.000000)"}},[_c('g',{attrs:{"id":"laugh-Icon","transform":"translate(355.000000, 4354.000000)","fill":"#6D6E71","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M40,0 C17.9442188,0 0,17.9442188 0,40 C0,62.0557813 17.9442188,80 40,80 C62.0557812,80 80,62.0557812 80,40 C80,17.9442188 62.0557812,0 40,0 Z M40,77.0370312 C19.5775,77.0370312 2.96296875,60.4225 2.96296875,40 C2.96296875,19.5775 19.5775,2.96296875 40,2.96296875 C60.4225,2.96296875 77.0370312,19.5775 77.0370312,40 C77.0370312,60.4225 60.4225,77.0370312 40,77.0370312 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M65.1851562,38.5115625 L14.8148437,38.5115625 C13.9967187,38.5115625 13.3332812,39.1782812 13.3332812,39.9967187 C13.3332812,54.7007812 25.2957812,66.665 40,66.665 C54.7042187,66.665 66.6667188,54.7 66.6667188,39.9957812 C66.6667187,39.1775 66.0032812,38.5115625 65.1851562,38.5115625 Z M40,63.70375 C33.913125,63.70375 28.3590625,61.3928125 24.156875,57.6079687 C26.1046875,55.0878125 32.0932812,48.8164062 40.8189062,53.1771875 C41.3354687,53.4346875 41.9567187,53.3703125 42.4067187,53.0085938 C42.6620312,52.80625 48.6864062,48.1704688 56.4553125,57.0390625 C52.1884375,61.1610937 46.386875,63.70375 40,63.70375 Z M58.4673437,54.839375 C50.68125,46.14875 43.7117187,48.849375 41.3809375,50.163125 C31.6215625,45.7882812 24.6779687,52.3714062 22.0857812,55.4954687 C18.7851562,51.6857812 16.6732812,46.6595312 16.3417187,41.474375 L63.6579687,41.474375 C63.3454687,46.6596875 61.4510937,51.134375 58.4673437,54.839375 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M31.1110938,22.2151562 L22.2221875,22.2151562 C21.4040625,22.2151562 20.740625,22.8784375 20.740625,23.6967187 C20.740625,24.515 21.4039063,25.178125 22.2221875,25.178125 L31.1110938,25.178125 C31.9292188,25.178125 32.5926563,24.5148437 32.5926563,23.6967187 C32.5926563,22.8785938 31.9292188,22.2151562 31.1110938,22.2151562 Z","id":"Shape"}}),_vm._v(" "),_c('path',{attrs:{"d":"M56.29625,22.2151562 L47.4073437,22.2151562 C46.5892188,22.2151562 45.9257812,22.8784375 45.9257812,23.6967187 C45.9257812,24.515 46.5890625,25.178125 47.4073437,25.178125 L56.29625,25.178125 C57.114375,25.178125 57.7776562,24.5148437 57.7776562,23.6967187 C57.7776562,22.8785938 57.114375,22.2151562 56.29625,22.2151562 Z","id":"Shape"}})])])])]),_vm._v(" "),_vm._m(11)])]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-general","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4"},[_vm._v("General")]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Council Affilitions")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Affiliate with up to two of our "),_c('strong',[_c('a',{attrs:{"href":"/professional/MembershipCouncils/ScientificCouncils/UCM_475327_Scientific-Councils.jsp","target":"_blank"}},[_vm._v("16 Scientific Councils")])]),_vm._v(".")]),_vm._v(" "),_c('li',[_vm._v("(Optional) Affiliate with a third council for an additional $65/year.")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("AHA Scientific Journals")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Access to all "),_c('strong',[_vm._v("11 online")]),_vm._v(" "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/","target":"_blank"}},[_vm._v("AHA scientific journals")])]),_vm._v(" (full text)")]),_vm._v(" "),_c('li',[_vm._v("Yearly print subscriptions only $225 per journal ("),_c('em',[_vm._v("ATVB, Circulation, Circulation Research, Hypertension, Stroke")]),_vm._v(")")]),_vm._v(" "),_c('li',[_vm._v("Access to CME credits through the "),_c('strong',[_c('a',{attrs:{"href":"https://cme.ahajournals.org/s/catalog","target":"_blank"}},[_vm._v("AHA Journals CME")]),_vm._v(" ")]),_vm._v("program")]),_vm._v(" "),_c('li',[_c('strong',[_c('a',{attrs:{"href":"/professional/Journals/UCM_491607_JAHA-Discount-for-AHA-Professional-Members.jsp","target":"_blank"}},[_vm._v("Discounted article publication charges")])]),_vm._v(" for accepted articles in "),_c('strong',[_c('a',{attrs:{"href":"https://www.ahajournals.org/journal/jaha","target":"_blank"}},[_c('em',[_vm._v("JAHA")])])]),_vm._v(" (the AHA/ASA’s Open Access journal that’s freely accessible). Members save $700 with discount code")])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Conferences and Education")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Save on AHA/ASA "),_c('strong',[_c('a',{attrs:{"href":"/professional/EducationMeetings/MeetingsLiveCME/UCM_475321_Meetings.jsp","target":"_blank"}},[_vm._v("Scientific Conferences")]),_vm._v(" ")]),_vm._v("registration")]),_vm._v(" "),_c('li',[_vm._v("Savings on Science OnDemand® products,")]),_vm._v(" "),_c('li',[_vm._v("Priority Registration and Housing for Scientific Sessions and the International Stroke Conference")]),_vm._v(" "),_c('li',[_vm._v("Complimentary and/or discounted courses through the "),_c('strong',[_c('a',{attrs:{"href":"https://learn.heart.org/","target":"_blank"}},[_vm._v("Lifelong Learning Center")])])])]),_vm._v(" "),_c('div',{staticClass:"h3"},[_vm._v("Opportunities")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Funding opportunities for members only")]),_vm._v(" "),_c('li',[_vm._v("Become a "),_c('strong',[_c('a',{attrs:{"href":"/professional/ProfessionalMembership/FellowofAHAFAHA/UCM_475326_Fellow-of-AHA-FAHA.jsp","target":"_blank"}},[_vm._v("Fellow of the American Heart Association (FAHA)")])])]),_vm._v(" "),_c('li',[_vm._v("Leadership Opportunities")]),_vm._v(" "),_c('li',[_vm._v("Networking with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and to mentor others")]),_vm._v(" "),_c('li',[_vm._v("Access to Science News")]),_vm._v(" "),_c('li',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('li',[_vm._v("Quarterly AHA Connections Newsletter")]),_vm._v(" "),_c('li',[_vm._v("Inclusion/ access to the online AHA/ASA Professional Membership Directory")]),_vm._v(" "),_c('li',[_vm._v("Achieve Golden and Silver Heart Membership")]),_vm._v(" "),_c('li',[_vm._v("Be a part of the Emeritus Membership program")])]),_vm._v(" "),_c('div',{staticClass:"btn-wrapper"},[_c('a',{staticClass:"btn btn-primary btn-round btn-block btn--signup",attrs:{"href":"#"}},[_vm._v("Sign Up")])])])],1)])])])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('aha-modal',{staticClass:"table-comparison__modal",attrs:{"id":"table-comparison-modal","hide-footer":"","centered":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h2',{staticClass:"text-center"},[_vm._v("Pick a Membership that's right for you")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-muted"},[_vm._v("\n                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur possimus ex incidunt quod eius delectus atque iste, saepe repellat impedit iusto, non repudiandae nemo accusamus alias magnam dolore maxime soluta.\n              ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"l-comparison--desktop"},[_c('table',{staticClass:"table table-hover table-comparison"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v(" ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Premier")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Professional")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Limited")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Signature")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Journals")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Council Affiliations")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Discount")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("FAHA")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Funding opportunities "),_c('em',[_vm._v("members only")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Leadership opportunities")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Network with like-minded professionals")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Get involved in the AHA mission and mentor others")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Access to Science News")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Quarterly AHA Connections Newsleter")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_c('span',{attrs:{"aria-label":"check"}},[_vm._v("•")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])])])])]),_vm._v(" "),_c('div',{staticClass:"l-comparison--mobile"},[_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-premier",modifiers:{"collapse-tier-premier":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Premier")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-premier"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")]),_vm._v(" "),_c('li',[_vm._v("Funding opportunities members only")]),_vm._v(" "),_c('li',[_vm._v("Leadership opportunities")]),_vm._v(" "),_c('li',[_vm._v("Network with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and mentor others")]),_vm._v(" "),_c('li',[_vm._v("Access to Science News")]),_vm._v(" "),_c('li',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('li',[_vm._v("Quarterly AHA Connections Newsleter")])])])],1),_vm._v(" "),_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-professional",modifiers:{"collapse-tier-professional":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Professional")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-professional"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")]),_vm._v(" "),_c('li',[_vm._v("Funding opportunities members only")]),_vm._v(" "),_c('li',[_vm._v("Leadership opportunities")]),_vm._v(" "),_c('li',[_vm._v("Network with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and mentor others")])])])],1),_vm._v(" "),_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-student",modifiers:{"collapse-tier-student":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Student/Trainee")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-student"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")])])])],1),_vm._v(" "),_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-signature",modifiers:{"collapse-tier-signature":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Signature")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-signature"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")])])])],1)])])])]),_vm._v(" "),_c('aha-modal',{staticClass:"limited-membership__modal",attrs:{"id":"limited-membership-modal","hide-footer":"","centered":""}},[_c('h2',{staticClass:"text-center"},[_vm._v("Limited Membership")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio commodi vero similique amet eos, voluptas dolores rerum modi quasi nesciunt placeat odio incidunt sint animi eum earum vel consectetur soluta!")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-link-plain",on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'limited-membership-modal', $event.target)}}},[_vm._v("Go Back")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'limited-membership-modal', $event.target)}}},[_vm._v("Continue")])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-5"},[_vm._v("PHD Tier Selecton Page")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8"},[_c('h1',[_vm._v("Professional Membership")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Premium Professional")]),_vm._v(" "),_c('div',{staticClass:"tier-price"},[_c('span',{staticClass:"font-italic"},[_vm._v("$50/YR")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Premium Professional Plus")]),_vm._v(" "),_c('div',{staticClass:"tier-price"},[_c('span',{staticClass:"font-italic"},[_vm._v("$50/YR")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Student/  "),_c('br'),_vm._v("Trainee")]),_vm._v(" "),_c('div',{staticClass:"tier-price"},[_c('span',{staticClass:"font-italic"},[_vm._v("$50/YR")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Early "),_c('br'),_vm._v("Career")]),_vm._v(" "),_c('div',{staticClass:"tier-price"},[_c('span',{staticClass:"font-italic"},[_vm._v("$50/YR")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("General Professional")]),_vm._v(" "),_c('div',{staticClass:"tier-price"},[_c('span',{staticClass:"font-italic"},[_vm._v("$50/YR")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Premier")]),_vm._v(" "),_c('div',{staticClass:"tier-price"},[_c('span',{staticClass:"full-price strikethrough"},[_vm._v("$85/YR")]),_vm._v(" "),_c('span',{staticClass:"discounted-price"},[_vm._v("$50/YR")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Professional")]),_vm._v(" "),_c('div',{staticClass:"tier-price"},[_c('span',{staticClass:"full-price strikethrough"},[_vm._v("$85/YR")]),_vm._v(" "),_c('span',{staticClass:"discounted-price"},[_vm._v("$50/YR")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Student/Trainee")]),_vm._v(" "),_c('div',{staticClass:"tier-price"},[_c('span',{staticClass:"full-price strikethrough"},[_vm._v("$85/YR")]),_vm._v(" "),_c('span',{staticClass:"discounted-price"},[_vm._v("$50/YR")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Early Career")]),_vm._v(" "),_c('div',{staticClass:"tier-price"},[_c('span',{staticClass:"full-price strikethrough"},[_vm._v("$85/YR")]),_vm._v(" "),_c('span',{staticClass:"discounted-price"},[_vm._v("$50/YR")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("General")]),_vm._v(" "),_c('div',{staticClass:"tier-price"},[_c('span',{staticClass:"full-price strikethrough"},[_vm._v("$85/YR")]),_vm._v(" "),_c('span',{staticClass:"discounted-price"},[_vm._v("$50/YR")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tier_selector_api_vue__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tier_selector_api_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tier_selector_api_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tier_selector_api_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tier_selector_api_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcc811a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tier_selector_api_vue__ = __webpack_require__(1665);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tier_selector_api_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcc811a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tier_selector_api_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tier-selector PHD"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('h2',[_vm._v("Professional Partnership")]),_vm._v(" "),_c('p',{staticClass:"mb-5"},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur cumque sequi, veritatis animi aspernatur, nobis perferendis, necessitatibus corporis adipisci maxime ut. Deleniti voluptatum non quisquam doloremque nemo consectetur eaque! Pariatur. "),_c('br'),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('table-comparison-modal'),expression:"'table-comparison-modal'"}],staticClass:"text-primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Click here to Compare Partnership »")])]),_vm._v(" "),_c('h3',[_vm._v("Testing - Trigger Early Career Modal")]),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('ec-membership-modal'),expression:"'ec-membership-modal'"}],staticClass:"text-primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Early Career Modal Trigger")]),_vm._v(" "),_c('h3',{staticClass:"my-4"},[_vm._v("Content Author can change icons")]),_vm._v(" "),_c('member-tier-selector',{staticClass:"mb-5",attrs:{"component-title":" Professional Membership","icons":_vm.membershipIcons,"uri":"/PhpApiProxy/GetMemberTierAsync","flow-type":"new","disable-signup":false,"promomsg":"Have a promo code?","promo-modal-header":"Processing Request","promo-modal-message":"Associating promo code to order."}}),_vm._v(" "),_c('aha-modal',{staticClass:"table-comparison__modal",attrs:{"id":"table-comparison-modal","hide-footer":"","centered":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h2',{staticClass:"text-center"},[_vm._v("Pick a Membership that's right for you")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-muted"},[_vm._v("\n                      Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur possimus ex incidunt quod eius delectus atque iste, saepe repellat impedit iusto, non repudiandae nemo accusamus alias magnam dolore maxime soluta.\n                  ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"l-comparison--desktop"},[_c('table',{staticClass:"table table-hover table-comparison"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v(" ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Premier")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Professional")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Limited")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Signature")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Journals")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Council Affiliations")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Discount")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("FAHA")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Funding opportunities "),_c('em',[_vm._v("members only")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Leadership opportunities")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Network with like-minded professionals")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Get involved in the AHA mission and mentor others")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Access to Science News")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Quarterly AHA Connections Newsleter")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])])])])]),_vm._v(" "),_c('div',{staticClass:"l-comparison--mobile"},[_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-premier",modifiers:{"collapse-tier-premier":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Premier")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-premier"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")]),_vm._v(" "),_c('li',[_vm._v("Funding opportunities members only")]),_vm._v(" "),_c('li',[_vm._v("Leadership opportunities")]),_vm._v(" "),_c('li',[_vm._v("Network with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and mentor others")]),_vm._v(" "),_c('li',[_vm._v("Access to Science News")]),_vm._v(" "),_c('li',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('li',[_vm._v("Quarterly AHA Connections Newsleter")])])])],1),_vm._v(" "),_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-professional",modifiers:{"collapse-tier-professional":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Professional")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-professional"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")]),_vm._v(" "),_c('li',[_vm._v("Funding opportunities members only")]),_vm._v(" "),_c('li',[_vm._v("Leadership opportunities")]),_vm._v(" "),_c('li',[_vm._v("Network with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and mentor others")])])])],1),_vm._v(" "),_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-limited",modifiers:{"collapse-tier-limited":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Limited")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-limited"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")])])])],1),_vm._v(" "),_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-signature",modifiers:{"collapse-tier-signature":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Signature")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-signature"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")])])])],1)])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Membership Tier API Data DEMO")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_499845e5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_institution_membership_api_vue__ = __webpack_require__(1667);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_499845e5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_institution_membership_api_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tier-selector PHD"},[_c('div',{staticClass:"container container-fluid"},[_c('h2',[_vm._v("Institutional Partnerships")]),_vm._v(" "),_c('p',{staticClass:"mb-5"},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur cumque sequi, veritatis animi aspernatur, nobis perferendis, necessitatibus corporis adipisci maxime ut. Deleniti voluptatum non quisquam doloremque nemo consectetur eaque! Pariatur. "),_c('br'),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('table-comparison-modal'),expression:"'table-comparison-modal'"}],staticClass:"text-primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Click here to Compare Partnership »")])]),_vm._v(" "),_c('member-tier-selector',{staticClass:"mb-5",attrs:{"uri":"/PhpApiProxy/GetMemberTierAsync","flowtype":"new"},scopedSlots:_vm._u([{key:"modals",fn:function(props){return [_c('aha-modal',{staticClass:"ec-membership__modal",attrs:{"id":"ec-membership-modal","hide-footer":"","centered":""}},[_c('h2',{staticClass:"text-center"},[_vm._v("Early Career")]),_vm._v(" "),_c('phd-display-checkbox',{staticClass:"c-phd-display-checkbox__item",attrs:{"check-class":"c-phd-display-checkbox__check"}},[_c('p',{},[_vm._v("\n                          I certify I am eligible for this category because I am still in training as an undergraduate, graduate, or postdoctoral/clinical fellow.\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mt-4"},[_c('button',{staticClass:"btn btn-outline mr-2 w-100",on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'ec-membership-modal', $event.target)}}},[_vm._v("Go Back")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary w-100 ec-continue disabled",attrs:{"href":props.uri}},[_vm._v("Continue")])])],1),_vm._v(" "),_c('aha-modal',{staticClass:"gp-upgrade-modal",attrs:{"id":"gp-upgrade-modal","hide-footer":"","centered":""}},[_c('h2',{staticClass:"text-center"},[_vm._v("Did You Know?")]),_vm._v(" "),_c('p',{},[_vm._v("\n                      Upgrade to Premium Professional and receive even more benefits!\n                      (For example: Science OnDemand and an additional council!)\n                  ")]),_vm._v(" "),_c('div',{staticClass:"alert alert-dark"},[_c('p',[_vm._v("\n                          When the user clicks the ACCEPT button, PHD updates the selection to Premium Professional and navigates the user to the “Select Your Councils” page.\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mt-4"},[_c('button',{staticClass:"btn btn-outline mr-2 w-100",on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'gp-upgrade-modal', $event.target)}}},[_vm._v("No Thanks")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary w-100",attrs:{"href":props.uri}},[_vm._v("Accept")])])])]}}])},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo my-0 pb-1"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg","alt":"Quit vaping"}})])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md d-none d-sm-block"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg","alt":"Quit vaping"}})])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md d-none d-sm-block"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg","alt":"Quit vaping"}})])])])])])]),_vm._v(" "),_c('aha-modal',{staticClass:"table-comparison__modal",attrs:{"id":"table-comparison-modal","hide-footer":"","centered":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h2',{staticClass:"text-center"},[_vm._v("Pick a Membership that's right for you")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-muted"},[_vm._v("\n                      Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur possimus ex incidunt quod eius delectus atque iste, saepe repellat impedit iusto, non repudiandae nemo accusamus alias magnam dolore maxime soluta.\n                  ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"l-comparison--desktop"},[_c('table',{staticClass:"table table-hover table-comparison"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v(" ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Premier")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Professional")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Limited")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("Signature")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Journals")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Council Affiliations")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Discount")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("FAHA")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Funding opportunities "),_c('em',[_vm._v("members only")])]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Leadership opportunities")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Network with like-minded professionals")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Get involved in the AHA mission and mentor others")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Access to Science News")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Quarterly AHA Connections Newsleter")]),_vm._v(" "),_c('td',{staticClass:"text-center dot dot--active"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")]),_vm._v(" "),_c('td',{staticClass:"text-center dot"},[_vm._v("•")])])])])]),_vm._v(" "),_c('div',{staticClass:"l-comparison--mobile"},[_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-premier",modifiers:{"collapse-tier-premier":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Premier")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-premier"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")]),_vm._v(" "),_c('li',[_vm._v("Funding opportunities members only")]),_vm._v(" "),_c('li',[_vm._v("Leadership opportunities")]),_vm._v(" "),_c('li',[_vm._v("Network with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and mentor others")]),_vm._v(" "),_c('li',[_vm._v("Access to Science News")]),_vm._v(" "),_c('li',[_vm._v("Eligible for AHA council grants and awards")]),_vm._v(" "),_c('li',[_vm._v("Quarterly AHA Connections Newsleter")])])])],1),_vm._v(" "),_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-professional",modifiers:{"collapse-tier-professional":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Professional")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-professional"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")]),_vm._v(" "),_c('li',[_vm._v("Funding opportunities members only")]),_vm._v(" "),_c('li',[_vm._v("Leadership opportunities")]),_vm._v(" "),_c('li',[_vm._v("Network with like-minded professionals")]),_vm._v(" "),_c('li',[_vm._v("Get involved in the AHA mission and mentor others")])])])],1),_vm._v(" "),_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-limited",modifiers:{"collapse-tier-limited":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Limited")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-limited"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")])])])],1),_vm._v(" "),_c('div',{staticClass:"l-comparison__wrapper"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-tier-signature",modifiers:{"collapse-tier-signature":true}}],staticClass:"btn--select btn-block text-left"},[_vm._v("Signature")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-tier-signature"}},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Journals")]),_vm._v(" "),_c('li',[_vm._v("Councils Affiliations")]),_vm._v(" "),_c('li',[_vm._v("Discount")]),_vm._v(" "),_c('li',[_vm._v("FAHA")])])])],1)])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a8c69b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_programming_table_vue__ = __webpack_require__(1669);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a8c69b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_programming_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('h5',[_vm._v("Standalone Generic Promo Component for PHD")]),_vm._v(" "),_c('div',{staticClass:"l-promo l-promo--shadow"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg'),expression:"'https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg'"}],attrs:{"src":"assets/images/placeholder.gif","alt":"Quit vaping"}})])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg'),expression:"'https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg'"}],attrs:{"src":"assets/images/placeholder.gif","alt":"Quit vaping"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('h5',[_vm._v("Promo Inside Tab Component")]),_vm._v(" "),_c('div',{staticClass:"l-phd"},[_c('div',{staticClass:"c-programming-table"},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo l-promo--shadow"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg'),expression:"'https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg'"}],attrs:{"src":"assets/images/placeholder.gif","alt":"Quit vaping"}})])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg'),expression:"'https://www.heart.org/-/media/images/around-the-aha/quit-lying-spokesperson.jpg'"}],attrs:{"src":"assets/images/placeholder.gif","alt":"Quit vaping"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex c-simple-tabs c-simple-tabs--border-top"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.print-modal",modifiers:{"print-modal":true}}],staticClass:"btn btn-plain btn-print",attrs:{"type":"button"}},[_vm._m(3),_vm._v(" "),_c('span',{staticClass:"btn-print__link c-cta h-theme--gray"},[_vm._v("Print")])]),_vm._v(" "),_c('b-tabs',{directives:[{name:"set-tabindex-zero",rawName:"v-set-tabindex-zero"}],attrs:{"vertical":"","nav-wrapper-class":"col-md-4 tabs__nav"}},[_c('b-tab',{attrs:{"title":"Thursday"}},[_c('simple-accordion',{attrs:{"title":"Thursday","variant":"icon-plus"}},[_c('h2',{staticClass:"phd-h2 c-programming__heading"},[_vm._v("Thursday - Sept. 5")]),_vm._v(" "),_c('dl',{staticClass:"c-programming__list"},[_c('dt',{staticClass:"col-sm-3 c-programming__label c-programming__label--red"},[_vm._v("Time")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__label c-programming__label--red"},[_vm._v("Event")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                                                Session 1.2: Recent Advances: Keynote Lectures\n                                            ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                                                Session 1.2: Recent Advances: Keynote Lectures\n                                            ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                                                Session 1.2: Recent Advances: Keynote Lectures\n                                            ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                                                Session 1.2: Recent Advances: Keynote Lectures\n                                            ")])])])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Saturday"}},[_c('simple-accordion',{attrs:{"title":"Saturday","variant":"icon-plus"}},[_c('h2',{staticClass:"phd-h2 c-programming__heading"},[_vm._v("Saturday - Sept. 6")]),_vm._v(" "),_c('dl',{staticClass:"c-programming__list"},[_c('dt',{staticClass:"col-sm-3 c-programming__label c-programming__label--red"},[_vm._v("Time")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__label c-programming__label--red"},[_vm._v("Event")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                                            Session 1.2: Recent Advances: Keynote Lectures\n                                        ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                                            Session 1.2: Recent Advances: Keynote Lectures\n                                        ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("12:30 a.m - 12:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                                            Session 1.2: Recent Advances: Keynote Lectures\n                                        ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                                            Session 1.2: Recent Advances: Keynote Lectures\n                                        ")])])])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Sunday"}},[_c('simple-accordion',{attrs:{"title":"Sunday","variant":"icon-plus"}},[_c('h2',{staticClass:"phd-h2 c-programming__heading"},[_vm._v("Sunday - Sept. 6")]),_vm._v(" "),_c('dl',{staticClass:"c-programming__list"},[_c('dt',{staticClass:"col-sm-3 c-programming__label c-programming__label--red"},[_vm._v("Time")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__label c-programming__label--red"},[_vm._v("Event")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                                            Session 1.2: Recent Advances: Keynote Lectures\n                                        ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                                            Session 1.2: Recent Advances: Keynote Lectures\n                                        ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                                            Session 1.2: Recent Advances: Keynote Lectures\n                                        ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                                            Session 1.2: Recent Advances: Keynote Lectures\n                                        ")])])])],1)],1)],1)])])])]),_vm._v(" "),_c('aha-modal',{staticClass:"c-print__modal",attrs:{"id":"print-modal","hide-footer":"","centered":""}},[_c('button',{directives:[{name:"print-element",rawName:"v-print-element",value:('schedule-print-section'),expression:"'schedule-print-section'"}],staticClass:"btn btn-primary btn-round mb-5 btn--excute-print",attrs:{"type":"button"}},[_c('span',{staticClass:"icon mr-1"},[_c('img',{attrs:{"src":"assets/share/print-icon-white.svg","alt":""}})]),_vm._v(" "),_c('span',[_vm._v("Print Full Schedule")])]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"schedule-print-section"}},[_c('div',{staticClass:"col print-modal--print-region"},[_c('div',{staticClass:"print-modal--heading"},[_vm._v("Scientific Sessions 2020")]),_vm._v(" "),_c('div',{staticClass:"print-modal--date"},[_vm._v("Novemeber 16 - 18, 2020")]),_vm._v(" "),_c('div',{staticClass:"print-modal--location"},[_vm._v("Philadelphia, Pennsylvania")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',{staticClass:"c-programming__heading"},[_vm._v("Thursday - Sept. 5")]),_vm._v(" "),_c('dl',{staticClass:"c-programming__list"},[_c('dt',{staticClass:"col-sm-4 c-programming__label c-programming__label--red"},[_vm._v("Time")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__label c-programming__label--red"},[_vm._v("Event")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                    Session 1.2: Recent Advances: Keynote Lectures\n                ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                    Session 1.2: Recent Advances: Keynote Lectures\n                ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                    Session 1.2: Recent Advances: Keynote Lectures\n                ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                    Session 1.2: Recent Advances: Keynote Lectures\n                ")])]),_vm._v(" "),_c('h3',{staticClass:"c-programming__heading"},[_vm._v("Friday - Sept. 6")]),_vm._v(" "),_c('dl',{staticClass:"c-programming__list"},[_c('dt',{staticClass:"col-sm-4 c-programming__label c-programming__label--red"},[_vm._v("Time")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__label c-programming__label--red"},[_vm._v("Event")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                    Session 1.2: Recent Advances: Keynote Lectures\n                ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                    Session 1.2: Recent Advances: Keynote Lectures\n                ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                    Session 1.2: Recent Advances: Keynote Lectures\n                ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                    Session 1.2: Recent Advances: Keynote Lectures\n                ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("7:30 a.m - 8:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("Session 1.1: Welcome and Opening Remarks")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-4 c-programming__list-item c-programming__list-item--time"},[_vm._v("8:00 a.m - 9:00 a.m")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-8 c-programming__list-item c-programming__list-item--event"},[_vm._v("\n                    Session 1.2: Recent Advances: Keynote Lectures\n                ")])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',[_vm._v("Programming Table")]),_vm._v(" "),_c('h2',[_vm._v("Scientific Session 2020")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aliquam aspernatur, eaque saepe eum autem ullam, facere soluta, accusantium natus illo vitae deserunt quo perspiciatis molestiae ea laudantium. Provident, tempore? Neque tenetur rerum necessitatibus totam veniam provident vitae, sed, iste, ratione dicta aliquid sapiente quis praesentium? Molestias voluptas maiores labore corporis?")]),_vm._v(" "),_c('p',[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"section__label mb-1"},[_vm._v("Programming")]),_vm._v(" "),_c('div',{staticClass:"h3 mb-3"},[_vm._v("What To Expect From This Year's Event")]),_vm._v(" "),_c('div',{staticClass:"h6 mb-0"},[_vm._v("New 3-Day Meeting. New Experience. New Sessions.")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis eum quia accusamus harum accusantium?")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo"},[_c('div',{staticClass:"section__label mb-1"},[_vm._v("Programming")]),_vm._v(" "),_c('div',{staticClass:"h3 mb-3"},[_vm._v("What To Expect From This Year's Event")]),_vm._v(" "),_c('div',{staticClass:"h6 mb-0"},[_vm._v("New 3-Day Meeting. New Experience. New Sessions.")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis eum quia accusamus harum accusantium?")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-print__icon"},[_c('img',{attrs:{"src":"/assets/share/print-gray.svg","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dfb5e13_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_meetings_sci_sessions_vue__ = __webpack_require__(1671);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dfb5e13_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_meetings_sci_sessions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"PHD"},[_c('div',{staticClass:"container container-fluid"},[_c('sessions-meetings')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _page = __webpack_require__(81);

var _page2 = _interopRequireDefault(_page);

var _snackableNavigation = __webpack_require__(1673);

var _snackableNavigation2 = _interopRequireDefault(_snackableNavigation);

var _dailyJourney = __webpack_require__(1675);

var _dailyJourney2 = _interopRequireDefault(_dailyJourney);

var _yesNoQuestion = __webpack_require__(1677);

var _yesNoQuestion2 = _interopRequireDefault(_yesNoQuestion);

var _singleFieldPrompt = __webpack_require__(1679);

var _singleFieldPrompt2 = _interopRequireDefault(_singleFieldPrompt);

var _makeCommitment = __webpack_require__(1681);

var _makeCommitment2 = _interopRequireDefault(_makeCommitment);

var _quiz = __webpack_require__(1683);

var _quiz2 = _interopRequireDefault(_quiz);

var _quizScoring = __webpack_require__(1685);

var _quizScoring2 = _interopRequireDefault(_quizScoring);

var _quizPersonalised = __webpack_require__(1687);

var _quizPersonalised2 = _interopRequireDefault(_quizPersonalised);

var _quizDiscussionGuide = __webpack_require__(1689);

var _quizDiscussionGuide2 = _interopRequireDefault(_quizDiscussionGuide);

var _symptomChecker = __webpack_require__(1691);

var _symptomChecker2 = _interopRequireDefault(_symptomChecker);

var _listicle = __webpack_require__(1693);

var _listicle2 = _interopRequireDefault(_listicle);

var _poll = __webpack_require__(1695);

var _poll2 = _interopRequireDefault(_poll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SnackablePages = [{
    path: '/snackable',
    // You could also have named views at the top
    components: {
        'default': _page2['default'],
        'sidebar-nav': _snackableNavigation2['default']
    },
    children: [{
        path: '',
        redirect: 'daily-journey'
    }, {
        path: 'daily-journey',
        component: _dailyJourney2['default']
    }, {
        path: 'yes-no-question',
        component: _yesNoQuestion2['default']
    }, {
        path: 'single-field-prompt',
        component: _singleFieldPrompt2['default']
    }, {
        path: 'make-commitment',
        component: _makeCommitment2['default']
    }, {
        path: 'quiz',
        component: _quiz2['default']
    }, {
        path: 'quiz-scoring',
        component: _quizScoring2['default']
    }, {
        path: 'quiz-personalised',
        component: _quizPersonalised2['default']
    }, {
        path: 'quiz-discussion-guide',
        component: _quizDiscussionGuide2['default']
    }, {
        path: 'symptom-checker',
        component: _symptomChecker2['default']
    }, {
        path: 'listicle',
        component: _listicle2['default']
    }, {
        path: 'poll',
        component: _poll2['default']
    }]
}];

exports['default'] = SnackablePages;

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5079d248_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_snackable_navigation_vue__ = __webpack_require__(1674);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5079d248_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_snackable_navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-light"},[_c('b-navbar-toggle',{staticClass:"float-right d-md-none",attrs:{"target":"sidebar-collapse"}}),_vm._v(" "),_c('span',{staticClass:"c-sidebar-nav__header"},[_vm._v("Snackables")]),_vm._v(" "),_c('b-collapse',{staticClass:"c-sidebar-nav",attrs:{"visible":"","id":"sidebar-collapse"}},[_c('ul',{staticClass:"c-sidebar-nav__links"},[_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/snackable/daily-journey'}},[_vm._v("Daily Journey")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/snackable/yes-no-question'}},[_vm._v("Yes/No Question")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/snackable/single-field-prompt'}},[_vm._v("Single Field Prompt")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/snackable/make-commitment'}},[_vm._v("Make Commitment")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/snackable/quiz'}},[_vm._v("Quiz")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/snackable/quiz-scoring'}},[_vm._v("Quiz Scoring")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/snackable/quiz-personalised'}},[_vm._v("Quiz Personalised")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/snackable/quiz-discussion-guide'}},[_vm._v("Quiz Doctor Discussion Guide")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/snackable/symptom-checker'}},[_vm._v("HF Symptom Checker")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/snackable/listicle'}},[_vm._v("Listicles")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"c-sidebar-nav__link",attrs:{"to":'/snackable/poll'}},[_vm._v("Poll")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_375f4676_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_journey_vue__ = __webpack_require__(1676);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_375f4676_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_journey_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Daily Journey")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('aha-daily-journey-component')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2a48e3e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_yes_no_question_vue__ = __webpack_require__(1678);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2a48e3e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_yes_no_question_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Yes/No Question")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('aha-yes-no-question-component')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca4db528_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_single_field_prompt_vue__ = __webpack_require__(1680);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca4db528_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_single_field_prompt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Single Field Prompt")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('aha-single-field-prompt-component')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a8798f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_make_commitment_vue__ = __webpack_require__(1682);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a8798f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_make_commitment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Make Commitment")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('aha-make-commitment-component')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52146282_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_vue__ = __webpack_require__(1684);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52146282_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Quiz")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('aha-quiz-component')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d14cd20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_scoring_vue__ = __webpack_require__(1686);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d14cd20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_scoring_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Quiz - Scoring")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('aha-quiz-scoring-component')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a363e7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_personalised_vue__ = __webpack_require__(1688);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a363e7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_personalised_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Quiz Personalised")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('aha-quiz-personalised-component')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c522814_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_discussion_guide_vue__ = __webpack_require__(1690);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c522814_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quiz_discussion_guide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-transition-group',{staticClass:"c-hero-card-snackable-full-quiz"},[_c('aha-transition-group-form',{attrs:{"error-step-key":9,"url":"http://www.mocky.io/v2/5ed93185310000f5dec4ec0f","email-url":"/aha-service/promo/EmailQuiz"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable__container"},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__content",attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Doctor Discussion Guide")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis elementum felis, a pretium felis. Maecenas tempor blandit libero, ut tempor augue posuere non. Donec sed auctor arcu. Vivamus consectetur eros id mauris egestas semper. Phasellus et diam ac justo tempus vulputate. ")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("1 of 7")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                                    Next  \n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"checkBloodPressureHeading"}},[_vm._v("How often do you check your blood pressure?")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.formData))]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"checkBloodPressureHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"step2Radio1","name":"checkBloodPressure","value":"Daily"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step2Radio1"}},[_vm._v("Every Day")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"step2Radio2","name":"checkBloodPressure","value":"Weekly"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step2Radio2"}},[_vm._v("About once a week")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"step2Radio3","name":"checkBloodPressure","value":"Monthly"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step2Radio3"}},[_vm._v("About once a month")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"step2Radio4","name":"checkBloodPressure","value":"Rarely"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step2Radio4"}},[_vm._v("Rarely")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"step2Radio5","name":"checkBloodPressure","value":"Never"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step2Radio5"}},[_vm._v("Never")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("2 of 7")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"3","type":"button"}},[_vm._v("\n                                    Next Temp\n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.AnswerId},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"logBloodPressureHeading"}},[_vm._v("If you measure your blood pressure, do you keep a log?")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"logBloodPressureHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"step3Radio1","name":"logBloodPressure","value":"Yes"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step3Radio1"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"step3Radio2","name":"logBloodPressure","value":"No"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step3Radio2"}},[_vm._v("No")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("3 of 7")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"4","type":"button"}},[_vm._v("\n                                    Next Temp\n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.AnswerId},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":4}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"takingMedicationsHeading"}},[_vm._v("Are you taking your medications as prescribed?")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"takingMedicationsHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"step4Radio1","name":"takingMedications","value":"Yes"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step4Radio1"}},[_vm._v("Yes")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"step4Radio2","name":"takingMedications","value":"Usually"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step4Radio2"}},[_vm._v("Usually")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"step4Radio3","name":"takingMedications","value":"Sometimes"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step4Radio3"}},[_vm._v("Sometimes")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"step4Radio5","name":"takingMedications","value":"No"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step4Radio5"}},[_vm._v("No")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("4 of 7")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"5","type":"button"}},[_vm._v("\n                                    Next Temp\n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.AnswerId},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":5}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"reduceSaltHeading"}},[_vm._v("To get less salt in my diet, I'd like to (choose all that apply):")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.formData))]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2",attrs:{"id":"checkboxCheck1"}},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"reduceSaltHeading"}},[_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{directives:[{name:"input",rawName:"v-input.checkbox",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"checkbox":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"step5Check1","name":"step5Check","value":"Buy low sodium foods"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step5Check1"}},[_vm._v("Buy low sodium foods")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{directives:[{name:"input",rawName:"v-input.checkbox",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"checkbox":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"step5Check2","name":"step5Check","value":"Taste before adding salt"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step5Check2"}},[_vm._v("Taste before adding salt")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("5 of 7")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"6"}},[_vm._v("\n                                Next Temp\n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.AnswerId},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next test\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":6}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"manageBPHeading"}},[_vm._v("It's hard to manage my blood pressure because (choose all that apply):")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"manageBPHeading"}},[_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{directives:[{name:"input",rawName:"v-input.checkbox",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"checkbox":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"step6Check1","name":"step6Check","value":"I don't like the way the medication makes me feel"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step6Check1"}},[_vm._v("I don't like the way the medication makes me feel")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{directives:[{name:"input",rawName:"v-input.checkbox",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"checkbox":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"step6Check2","name":"step6Check","value":"I'm having trouble changing my diet"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step6Check2"}},[_vm._v("I'm having trouble changing my diet")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{directives:[{name:"input",rawName:"v-input.checkbox",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"checkbox":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"step6Check3","name":"step6Check","value":"I can't easily exercise"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step6Check3"}},[_vm._v("I can't easily exercise")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{directives:[{name:"input",rawName:"v-input.checkbox",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"checkbox":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"step6Check4","name":"step6Check","value":"It's expensive"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step6Check4"}},[_vm._v("It's expensive")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{directives:[{name:"input",rawName:"v-input.checkbox",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"checkbox":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"step6Check5","name":"step6Check","value":"I'm stressed/I don't feel well"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step6Check5"}},[_vm._v("I'm stressed/I don't feel well")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{directives:[{name:"input",rawName:"v-input.checkbox",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"checkbox":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"step6Check6","name":"step6Check","value":"I forgot what I need to do"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step6Check6"}},[_vm._v("I forgot what I need to do")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("6 of 7")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"5"}},[_vm._v("\n                                Back\n                            ")]),_vm._v(" "),_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"7"}},[_vm._v("\n                                Next temp\n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.AnswerId},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Next\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":7}},[_c('h2',{staticClass:"c-daily-journey__heading h3",attrs:{"id":"appointmentDiscussHeading"}},[_vm._v("At my appointment, I'd like to talk about (choose all that apply):")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"appointmentDiscussHeading"}},[_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{directives:[{name:"input",rawName:"v-input.checkbox",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"checkbox":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"step7Check1","name":"step7check","value":"My medications"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step7Check1"}},[_vm._v("My medications")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{directives:[{name:"input",rawName:"v-input.checkbox",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"checkbox":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"step7Check2","name":"step7check","value":"Checking my blood pressure at home"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step7Check2"}},[_vm._v("Checking my blood pressure at home")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{directives:[{name:"input",rawName:"v-input.checkbox",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"checkbox":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"step7Check3","name":"step7check","value":"Reducing salt in my diet"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step7Check3"}},[_vm._v("Reducing salt in my diet")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{directives:[{name:"input",rawName:"v-input.checkbox",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"checkbox":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"step7Check4","name":"step7check","value":"Getting more exercise"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step7Check4"}},[_vm._v("Getting more exercise")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{directives:[{name:"input",rawName:"v-input.checkbox",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"checkbox":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"step7Check5","name":"step7check","value":"Managing my weight"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step7Check5"}},[_vm._v("Managing my weight")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2"},[_c('input',{directives:[{name:"input",rawName:"v-input.checkbox",value:('AnswerId'),expression:"'AnswerId'",modifiers:{"checkbox":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"step7Check6","name":"step7check","value":"Quitting smoking"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"step7Check6"}},[_vm._v("Quitting smoking")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("7 of 7")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"6"}},[_vm._v("\n                                Back\n                            ")]),_vm._v(" "),_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","step-index":"8"}},[_vm._v("\n                                Finish temp\n                            ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.AnswerId},on:{"click":formCtrl.quizSubmitForm}},[_vm._v("\n                                Finish\n                            ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":8}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__retake pb-2"},[_c('button',{staticClass:"p-0 m-0 bg-white border-0",attrs:{"type":"button","step-index":"1"},on:{"click":formCtrl.resetForm}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" Restart Guide\n                            ")]),_vm._v(" "),_c('div',{staticClass:"py-4"},[_c('a',{directives:[{name:"print-element",rawName:"v-print-element",value:('print-section'),expression:"'print-section'"}],staticClass:"c-cta h-theme--red mr-1",attrs:{"href":"#","target":"self","data-tracking":"{'name':'content promo image event name','data':'content promo image event data','text':'content promo image event text',  'goalId':'{E020A002-55A2-4495-9D06-EF6B0B1F2E71}'}"}},[_vm._v("Print Results")]),_vm._v(" | \n                               "),_c('a',{staticClass:"c-cta h-theme--red ml-1 btn-plain-text",attrs:{"href":"#","target":"self","data-tracking":"{'name':'content promo image event name','data':'content promo image event data','text':'content promo image event text',  'goalId':'{E020A002-55A2-4495-9D06-EF6B0B1F2E71}'}"},on:{"click":function($event){return _vm.$root.$emit('bv::show::modal', 'email-results-modal', $event.target)}}},[_vm._v("Email Results")])])]),_vm._v(" "),_c('aha-modal',{ref:"email-results-modal",staticClass:"c-location-modal discussion-email-modal",attrs:{"id":"email-results-modal","size":"md","hide-footer":"","centered":"","lazy":""}},[_c('template',{slot:"modal-header"},[_c('div',{staticClass:"c-discussion-email-modal__heading h2"},[_vm._v("Email Results")])]),_vm._v(" "),_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'email-results-modal', $event.target)}}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticClass:"slide-wrapper"},[_c('div',{staticClass:"slide-inline"},[_c('div',{staticClass:"slide slide-1"},[_c('form',{directives:[{name:"form-submit",rawName:"v-form-submit"}],attrs:{"name":"form-email-results","action":""},on:{"submit":function($event){$event.preventDefault();return formCtrl.sendEmail.apply(null, arguments)}}},[_c('div',{staticClass:"form-group my-4"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email Address")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"type":"email","id":"email","name":"email","required":"","data-vv-delay":"100","placeholder":"username@example.com","pattern":"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"small text-danger mt-2"},[_vm._v("Please provide a valid email.")])]),_vm._v(" "),_c('div',{staticClass:"message small mb-3"},[_vm._v("\n                                                    By sending this email you agree to our "),_c('a',{attrs:{"href":"https://www.heart.org/en/about-us/statements-and-policies/privacy-statement","title":"Privacy Policy"}},[_vm._v("Privacy Policy")]),_vm._v(".\n                                                ")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-round btn-primary",attrs:{"type":"submit","data-tracking":"{'name':'Email Quiz','data':'Email Quiz','text':'Email Quiz',  'goalId':'{921FC546-F58D-4687-91EF-DB12F8B10234}'}","disabled":""}},[_vm._v("Send Email")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-dark",attrs:{"href":"#","role":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$root.$emit('bv::hide::modal', 'email-results-modal', $event.target)}}},[_vm._v("Cancel")])])])]),_vm._v(" "),_c('div',{staticClass:"slide slide-2 text-center"},[_c('div',[_c('svg',{attrs:{"width":"66px","height":"72px","viewBox":"0 0 66 72","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("paper-airplane")]),_vm._v(" "),_c('desc',[_vm._v("Created with Sketch.")]),_vm._v(" "),_c('defs'),_vm._v(" "),_c('g',{attrs:{"id":"Page-1","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"paper-airplane","fill":"#D0021B","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M66,0 L52.5,49.5 L34.209,33.21 L51.765,14.685 L28.233,30.948 L12,27 L66,0 Z M33,37.503 L33,54 L39.579,44.031 L33,37.503 Z M6.906,57.978 L2.589,56.457 L19.692,40.812 L24,42 L6.906,57.978 Z M16.692,70.839 L12.723,69.144 L26.04,55.635 L30,57 L16.692,70.839 Z M4.443,72 L-2.22044605e-16,70.479 L24,46.809 L28.311,48 L4.443,72 Z","id":"Shape"}})])])])]),_vm._v(" "),_c('div',{staticClass:"h2 slide__title"},[_vm._v("Thank You!")]),_vm._v(" "),_c('div',{staticClass:"h3 mb-5 slide__subtitle"},[_vm._v("Your summary is on it's way.")])])])])],2),_vm._v(" "),_c('div',{staticClass:"c-daily-journey p-4"},[_c('div',{staticClass:"summary-section"},[_c('div',{staticClass:"summary"},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Instruction Copy")]),_vm._v(" "),_c('p',[_vm._v("Above YOUR RESULTS there should be instructional copy for what the patient needs to do. Included in the documentation provided. Please confirm this is possible and that the content manager can edit this")]),_vm._v(" "),_c('h2',{staticClass:"c-daily-journey__heading h2 mb-5 text-center"},[_vm._v("Your Summary")]),_vm._v(" "),_c('ul',{staticClass:"quiz__items"},_vm._l((formCtrl.response.QuizData),function(item,index){return _c('li',{key:index,staticClass:"quiz__items--question"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"quiz__items--question"},[_c('div',[_c('span',{staticClass:"badge badge-light"},[_vm._v("Question")])]),_vm._v("\n                                                    "+_vm._s(item.Question)+"\n                                                ")]),_vm._v(" "),_c('div',{staticClass:"quiz__items--answers"},[_c('div',[_c('span',{staticClass:"badge badge-light"},[_vm._v("Your Answers")])]),_vm._v(" "),_vm._l((item.Answers),function(answer){return _c('div',[(item.Answers.length > 1)?_c('span',{staticClass:"bullet"},[_vm._v("•")]):_vm._e(),_vm._v(_vm._s(answer)+"\n                                                    ")])})],2),_vm._v(" "),(item.Tip)?_c('div',{staticClass:"quiz__items--tip"},[_c('div',[_c('span',{staticClass:"badge badge-dark quiz__items--tip-icon"},[_c('img',{attrs:{"src":"https://www.heart.org/en/-/media/images/Icons/Light/tiplightbulbwhite","alt":"Tip"}})])]),_vm._v(" "),_c('span',[_vm._v("\n\n                                                    "+_vm._s(item.Tip)+"\n                                                    ")])]):_vm._e()])}),0)])]),_vm._v(" "),_c('div',{attrs:{"id":"print-section"}},[_c('div',{staticStyle:{"min-width":"100%","width":"100%","background-color":"#ffffff"}},[_c('table',{staticStyle:{"border-spacing":"0","color":"rgba(0,0,0,0.9)","font-family":"Arial,sans-serif","letter-spacing":"0em","line-height":"1.4","margin-top":"0","margin-right":"auto","margin-bottom":"0","margin-left":"auto","padding-left":"24px","padding-right":"24px","width":"100%","max-width":"500px","padding-bottom":"0px"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"min-width":"100%","width":"100%","padding-top":"0px","padding-right":"0px","padding-bottom":"0px","padding-left":"0px","text-align":"center"}},[_c('div',[_c('img',{staticStyle:{"padding-bottom":"5px"},attrs:{"src":"https://static.heart.org/ahaanywhere/images/AHALogo_full_red_black@2x.png","width":"133","alt":"American Heart Association"}})])])])])])]),_vm._v(" "),_c('div',{staticStyle:{"min-width":"100%","width":"100%","background-color":"#ffffff"}},[_c('table',{staticStyle:{"border-spacing":"0","color":"rgba(0,0,0,0.9)","font-family":"'Montserrat',Arial,sans-serif","letter-spacing":"0em","line-height":"1.4","margin-top":"0","margin-right":"auto","margin-bottom":"0","margin-left":"auto","padding-left":"24px","padding-right":"24px","width":"100%","max-width":"500px","padding-bottom":"0px"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"min-width":"100%","width":"100%","padding-top":"0px","padding-right":"0px","padding-bottom":"0px","padding-left":"0px","text-align":"center"}},[_c('div',{staticStyle:{"font-size":"36px","margin-bottom":"36px","color":"#000000","font-weight":"400","letter-spacing":"1px"}},[_vm._v("Your Summary")])])])])])]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","background-color":"#f8f8f8","max-width":"600px","margin-left":"auto","margin-right":"auto","padding-top":"40px","padding-bottom":"20px"}},[_c('table',{staticStyle:{"border-spacing":"0","color":"rgba(0,0,0,0.9)","font-family":"'Montserrat',Arial,sans-serif","letter-spacing":"0em","line-height":"1.4","margin-top":"0","margin-right":"auto","margin-bottom":"0","margin-left":"auto","padding-left":"50px","padding-top":"50px","padding-bottom":"0px","padding-right":"50px","width":"100%","max-width":"500px"}},[_c('tbody',_vm._l((formCtrl.response.QuizData),function(item,index){return _c('tr',{key:index},[_c('td',{staticStyle:{"min-width":"100%","width":"100%","padding-top":"0px","padding-right":"0px","padding-bottom":"0px","padding-left":"0px","text-align":"left"}},[_c('div',{staticStyle:{"font-size":"16px","margin-bottom":"0px","color":"#000000","font-weight":"500","letter-spacing":"0px"}},[_vm._v("\n                                                        "+_vm._s(++index)+". "+_vm._s(item.Question)+"\n                                                    ")]),_vm._v(" "),_c('div',[_c('table',{staticStyle:{"border-spacing":"0","margin":"0","padding":"0","width":"100%"}},[_c('tbody',[_c('tbody',_vm._l((item.Answers),function(answer,index){return _c('tr',{key:index},[_c('td',[_c('div',{staticStyle:{"font-size":"18px"}},[(item.Answers.length > 1)?_c('span',{staticStyle:{"font-size":"30px","line-height":"22px","margin-right":"5px"}},[_vm._v("•")]):_vm._e(),_vm._v(_vm._s(answer)+"\n                                                                            ")])])])}),0)])])]),_vm._v(" "),(item.Tip)?_c('div',{staticStyle:{"margin-bottom":"40px","margin-top":"10px","width":"100%"}},[_c('table',{staticStyle:{"border-spacing":"0","margin":"0","padding":"0"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"vertical-align":"top","font-size":"12px","font-weight":"500","letter-spacing":"1px"}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Tip: ")])]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"top","font-size":"12px","padding-left":"5px"}},[_vm._v("\n                                                                        "+_vm._s(item.Tip)+"\n                                                                    ")])])])])]):_vm._e()])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"py-4 text-center"},[_c('a',{directives:[{name:"print-element",rawName:"v-print-element",value:('print-section'),expression:"'print-section'"}],staticClass:"btn btn-round btn-danger mx-2",attrs:{"href":"#"}},[_vm._v("Print Results")]),_vm._v(" "),_c('a',{staticClass:"btn btn-round btn-danger mx-2",attrs:{"href":"#"},on:{"click":function($event){return _vm.$root.$emit('bv::show::modal', 'email-results-modal', $event.target)}}},[_vm._v("Email Results")])]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__share--quiz"},[_c('p',{staticClass:"h3 mr-3"},[_vm._v("Share:")]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"}},[_c('img',{attrs:{"src":"assets/share/facebook.svg"}})]),_vm._v(" "),_c('a',{directives:[{name:"share-button",rawName:"v-share-button"}],attrs:{"href":"http://www.twitter.com/intent/tweet?url=http://test.com&text=description"}},[_c('img',{attrs:{"src":"assets/share/twitter.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:?subject=Big%20News&body=Body-goes-here"}},[_c('img',{attrs:{"src":"assets/share/mail.svg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#0"}},[_c('img',{attrs:{"src":"assets/share/copy-link.svg"}})])])])],1),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable-full-width__transition",attrs:{"step-key":9}},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                            Uh oh, it appears that there was a network issue.\n                        ")]),_vm._v(" "),_c('div',{staticClass:"c-make-commitment__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"2","type":"button"}},[_vm._v("\n                                    Back  \n                            ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media"},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?1'),expression:"'//placeimg.com/1200/400/any?1'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?2'),expression:"'//placeimg.com/1200/400/any?2'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?3'),expression:"'//placeimg.com/1200/400/any?3'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":4}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?4'),expression:"'//placeimg.com/1200/400/any?4'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":5}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?5'),expression:"'//placeimg.com/1200/400/any?5'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":6}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?6'),expression:"'//placeimg.com/1200/400/any?6'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":7}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media-container h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('//placeimg.com/1200/400/any?7'),expression:"'//placeimg.com/1200/400/any?7'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])])],1)])]}}])}),_vm._v("Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quia, porro!\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bfafd86_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_symptom_checker_vue__ = __webpack_require__(1692);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bfafd86_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_symptom_checker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"my-5"},[_vm._v("Heart Failure Symptom Checker")]),_vm._v(" "),_c('aha-transition-group',{staticClass:"c-hero-card-snackable-full-quiz"},[_c('aha-transition-group-form',{attrs:{"error-step-key":99,"url":"https://run.mocky.io/v3/d95949a0-83be-41c2-b28b-7ae955c77450?mocky-delay=60000ms","data-quiz-type":"symptom-checker","quiz-id":"1234567890","quiz-name":"Name of Quiz"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('p',[_vm._v("\n                    "+_vm._s(formCtrl.formData)+"\n                ")]),_vm._v(" "),_c('h3',[_vm._v("Red List")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.redList))]),_vm._v(" "),_c('h3',[_vm._v("Yellow List")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.yellowList))]),_vm._v(" "),_c('h3',[_vm._v("Green List")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(formCtrl.greenList))]),_vm._v(" "),_c('div',{staticClass:"c-hero-card-snackable__container"},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__content",class:{'no-box-shadow': formCtrl.activeStep == 5},attrs:{"aria-live":"polite"}},[_c('div',{staticClass:"loader-container",class:{'show': formCtrl.loading},attrs:{"role":"alert","aria-live":"assertive"}},[_c('div',{staticClass:"loader"},[_vm._v("Loading...")])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('h2',{staticClass:"c-daily-journey__heading h3"},[_vm._v("Self-Check Plan for Heart Failure Management")]),_vm._v(" "),_c('p',[_vm._v("If you have been diagnosed with heart failure, it's important for you to manage and keep track of symptoms and report any sudden changes to your health care team.")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button"}},[_vm._v("\n                                        Get Started  \n                                ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":2}},[_c('h2',{staticClass:"c-daily-journey__heading h3 mb-0",attrs:{"id":"shortnessHeading"}},[_vm._v("Shortness of Breath")]),_vm._v(" "),_c('div',{staticClass:"subheading"},[_vm._v("Please select the most accurate symptom")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-4"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"shortnessHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('Shortness'),expression:"'Shortness'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"normal","name":"shortness","data-category":"green","data-icon":"assets/glyphs/check.svg","data-question":"Shortness of Breath","value":"No new or worsening; Physical activity level is normal"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"normal"}},[_vm._v("No new or worsening; Physical activity level is normal")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('Shortness'),expression:"'Shortness'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"worsening","name":"shortness","data-category":"yellow","data-icon":"assets/glyphs/solid-heart.svg","data-question":"Shortness of Breath","value":"Worsening"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"worsening"}},[_vm._v("Worsening")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('Shortness'),expression:"'Shortness'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"shortness","name":"shortness","data-category":"red","data-icon":"assets/glyphs/solid-heart.svg","data-question":"Shortness of Breath","value":"Shortness of breath at rest"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"shortness"}},[_vm._v("Shortness of breath at rest")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('Shortness'),expression:"'Shortness'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"na","name":"shortness","data-category":"","value":"NA"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"na"}},[_vm._v("N/A")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("1 of 3")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple pt-0"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"1","type":"button"}},[_vm._v("\n                                        Back\n                                ")]),_vm._v(" "),_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","disabled":!formCtrl.formData['symptoms'].some(function (element) { return element.id === 'Shortness'; })}},[_vm._v("\n                                        Next\n                                ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":3}},[_c('h2',{staticClass:"c-daily-journey__heading h3 mb-0",attrs:{"id":"logBloodPressureHeading"}},[_vm._v("Cough")]),_vm._v(" "),_c('div',{staticClass:"subheading"},[_vm._v("Please select the most accurate symptom")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-4"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"logBloodPressureHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('Cough'),expression:"'Cough'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"dry","name":"cough","data-category":"yellow","data-icon":"assets/glyphs/check.svg","data-question":"Cough","value":"Dry, hacking cough"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"dry"}},[_vm._v("Dry, hacking cough")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('Cough'),expression:"'Cough'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"frequent","name":"cough","data-category":"red","data-icon":"assets/glyphs/cross.svg","data-question":"Cough","value":"Frequent dry, hacking cough"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"frequent"}},[_vm._v("Frequent dry, hacking cough")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("2 of 3")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple pt-0"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"2","type":"button"}},[_vm._v("\n                                        Back\n                                ")]),_vm._v(" "),_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"type":"button","disabled":!formCtrl.formData.symptoms.some(function (element) { return element.id === 'Cough'; })}},[_vm._v("\n                                        Next\n                                ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":4}},[_c('h2',{staticClass:"c-daily-journey__heading h3 mb-0",attrs:{"id":"takingMedicationsHeading"}},[_vm._v("Swelling")]),_vm._v(" "),_c('div',{staticClass:"subheading"},[_vm._v("Please select the most accurate symptom")]),_vm._v(" "),_c('div',{staticClass:"form-group mt-4"},[_c('div',{staticClass:"c-daily-journey__selects"},[_c('fieldset',{attrs:{"aria-required":"true","aria-labelledby":"takingMedicationsHeading"}},[_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('Swelling'),expression:"'Swelling'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"noNewSwelling","data-category":"green","data-icon":"assets/glyphs/solid-heart.svg","data-question":"Swelling","name":"swelling","value":"No new swelling, feet and legs look normal"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"noNewSwelling"}},[_vm._v("No new swelling, feet and legs look normal")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('Swelling'),expression:"'Swelling'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"legsAbdomen","data-category":"yellow","data-icon":"assets/glyphs/check.svg","data-question":"Swelling","name":"swelling","value":"Increased swelling of legs, feet, and ankles or discomfort or swelling in abdomen"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"legsAbdomen"}},[_vm._v("Increased swelling of legs, feet, and ankles or discomfort or swelling in abdomen")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"input",rawName:"v-input.radio",value:('Swelling'),expression:"'Swelling'",modifiers:{"radio":true}}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"lowerbody","name":"swelling","data-category":"red","data-icon":"assets/glyphs/cross.svg","data-question":"Swelling","value":"Increased discomfort or swelling in the lower body"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"lowerbody"}},[_vm._v("Increased discomfort or swelling in the lower body")])])])])]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number"},[_vm._v("3 of 3")]),_vm._v(" "),_c('div',{staticClass:"c-daily-journey__actions--multiple pt-0"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"3","type":"button"}},[_vm._v("\n                                        Back\n                                ")]),_vm._v(" "),_c('button',{staticClass:"buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger",attrs:{"type":"button","disabled":!formCtrl.formData.symptoms.some(function (element) { return element.id === 'Swelling'; })},on:{"click":formCtrl.submitForm}},[_vm._v("\n                                    See Summary\n                                ")])],1)]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"id":"summary","step-key":5}},[_c('div',{staticClass:"summary-cards__title-container"},[_c('div',{staticClass:"text-center mb-4"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"http://digitaldocs.heart.org/aha-redesign/assets/symptom-checker/hf-logo.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"lead text-muted"},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit.")]),_vm._v(" "),_c('button',{staticClass:"p-0 my-4 bg-white border-0",attrs:{"type":"button","step-index":"1"},on:{"click":formCtrl.resetForm}},[_c('img',{attrs:{"src":"assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" "),_c('span',{staticClass:"text-primary"},[_vm._v("Start Over")])])])]),_vm._v(" "),_c('div',{staticClass:"summary-cards"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(formCtrl.redList.length),expression:"formCtrl.redList.length"}],staticClass:"summary-card summary-card--red"},[_c('h3',[_vm._v("Severe")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled list-items"},_vm._l((formCtrl.redList),function(item){return _c('li',{key:item.id,staticClass:"list-item list-item--grid"},[_c('div',{staticClass:"summary-card__icon-container summary-card__icon-container--red"},[_c('div',{staticClass:"summary-card__icon--center"},[_c('img',{staticClass:"summary-card__icon summary-card__icon--white",attrs:{"src":item.icon,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"list-item--condensed"},[_vm._v(_vm._s(item.value))])])}),0),_vm._v(" "),_c('p',[_vm._v("\n                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor repudiandae debitis iusto non placeat, ducimus aliquid repellat magnam fugiat voluptatibus eligendi veniam, necessitatibus vel! Earum repellendus nisi illo blanditiis error!\n                                        ")]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"summary-card__cta-container"},[_c('a',{staticClass:"btn btn-round btn-primary btn-lg",attrs:{"href":"https://heart.org"}},[_vm._v("\n                                                Default\n                                            ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(formCtrl.yellowList.length),expression:"formCtrl.yellowList.length"}],staticClass:"summary-card summary-card--yellow"},[_c('h3',[_vm._v("Moderate")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled list-items"},_vm._l((formCtrl.yellowList),function(item){return _c('li',{key:item.id,staticClass:"list-item list-item--grid"},[_c('div',{staticClass:"summary-card__icon-container summary-card__icon-container--yellow"},[_c('div',{staticClass:"summary-card__icon--center"},[_c('img',{staticClass:"summary-card__icon summary-card__icon--white",attrs:{"src":item.icon,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"list-item--condensed"},[_vm._v(_vm._s(item.value))])])}),0),_vm._v(" "),_c('p',[_vm._v("\n                                            Lorem ipsum dolor sit amet consectetur adipisicing elit.\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"summary-card__cta-container"},[_c('a',{staticClass:"btn btn-round btn-outline-primary btn-lg",attrs:{"href":"https://heart.org"}},[_vm._v("\n                                                Default\n                                            ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(formCtrl.greenList.length),expression:"formCtrl.greenList.length"}],staticClass:"summary-card summary-card--green"},[_c('h3',[_vm._v("Good")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled list-items"},_vm._l((formCtrl.greenList),function(item){return _c('li',{key:item.id,staticClass:"list-item list-item--grid"},[_c('div',{staticClass:"summary-card__icon-container summary-card__icon-container--green"},[_c('div',{staticClass:"summary-card__icon--center"},[_c('img',{staticClass:"summary-card__icon summary-card__icon--white",attrs:{"src":item.icon,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"list-item--condensed"},[_vm._v(_vm._s(item.value))])])}),0),_vm._v(" "),_c('p',[_vm._v("\n                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor repudiandae debitis iusto non placeat, ducimus aliquid repellat magnam fugiat voluptatibus eligendi veniam, necessitatibus vel! Earum repellendus nisi illo blanditiis error!\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"summary-card__cta-container"},[_c('a',{staticClass:"c-hero-card__cta c-cta c-cta--icon h-theme--red c-cta--arrow",attrs:{"href":"https://heart.org"}},[_vm._v(" First CTA Link Only Stack")])])])])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable-full-width__transition",attrs:{"step-key":99}},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                                Uh oh, it appears that there was a network issue.\n                            ")]),_vm._v(" "),_c('div',{staticClass:"c-make-commitment__actions"},[_c('aha-transition-trigger',{staticClass:"c-daily-journey__button btn btn-round btn-lg btn-danger mb-2",attrs:{"step-index":"1","type":"button"}},[_vm._v("\n                                        Back  \n                                ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media",class:{'d-none': formCtrl.activeStep == 5}},[_c('div',{staticClass:"d-flex",attrs:{"id":"quiz-logo"}},[_c('img',{staticClass:"is-loaded",attrs:{"src":"http://digitaldocs.heart.org/aha-redesign/assets/symptom-checker/hf-logo.png","alt":""}})]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition position-relative",attrs:{"step-key":1}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media c-hero-card-snackable-full-quiz__media-bg--transparent h-placeholder-image"},[_c('img',{staticClass:"object-fit is-loaded",attrs:{"src":"http://digitaldocs.heart.org/aha-redesign/assets/symptom-checker/hf-00.png","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition position-relative",attrs:{"step-key":2}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media c-hero-card-snackable-full-quiz__media-bg--transparent h-placeholder-image"},[_c('img',{staticClass:"object-fit is-loaded",attrs:{"src":"http://digitaldocs.heart.org/aha-redesign/assets/symptom-checker/hf-02.png","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition position-relative",attrs:{"step-key":3}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media c-hero-card-snackable-full-quiz__media-bg--transparent h-placeholder-image"},[_c('img',{staticClass:"object-fit is-loaded",attrs:{"src":"http://digitaldocs.heart.org/aha-redesign/assets/symptom-checker/hf-03.png","alt":""}})])]),_vm._v(" "),_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition position-relative",attrs:{"step-key":4}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz__media c-hero-card-snackable-full-quiz__media-bg--transparent h-placeholder-image"},[_c('img',{staticClass:"object-fit is-loaded",attrs:{"src":"http://digitaldocs.heart.org/aha-redesign/assets/symptom-checker/hf-04.png","alt":""}})])])],1)])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb3243e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listicle_vue__ = __webpack_require__(1694);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb3243e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listicle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Listicles")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('aha-listicle-component')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b58306_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_poll_vue__ = __webpack_require__(1696);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b58306_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_poll_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Poll")]),_vm._v(" "),_c('aha-component',{attrs:{"title":"Default"}},[_c('aha-poll-component')],1),_vm._v(" "),_c('div',{staticClass:"l-promo row"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('aha-poll-component')],1),_vm._v(" "),_vm._m(0)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo--match-height h-text-contrast h-theme--gray-dark"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"//placeimg.com/1200/400/any?1","alt":"group of people posing for photo at a heart walk","width":"640","height":"398","disablewebedit":"False"}})]),_vm._v(" "),_c('span',{staticClass:"h-mask-dark"}),_vm._v(" "),_c('div',{staticClass:"c-promo__content"},[_c('h2',{staticClass:"h2"},[_vm._v("\n                        Join Us For A Heart Walk In Your Area\n                    ")]),_vm._v(" "),_c('p',{staticClass:"h4"},[_vm._v(" Heart Walk is the American Heart Association's premiere event for raising funds to save lives from this country's No. 1 and No. 5 killers — heart disease and stroke.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _page = __webpack_require__(81);

var _page2 = _interopRequireDefault(_page);

var _uiKitNavigation = __webpack_require__(1698);

var _uiKitNavigation2 = _interopRequireDefault(_uiKitNavigation);

var _uiKit = __webpack_require__(1700);

var _uiKit2 = _interopRequireDefault(_uiKit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var UiKitPages = [{
    path: '/ui-kit',
    // You could also have named views at the top
    components: {
        'default': _page2['default'],
        'sidebar-nav': _uiKitNavigation2['default']
    },
    children: [{
        path: '',
        component: _uiKit2['default']
    }]
}];

exports['default'] = UiKitPages;

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45eca671_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ui_kit_navigation_vue__ = __webpack_require__(1699);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45eca671_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ui_kit_navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-light"},[_c('b-navbar-toggle',{staticClass:"float-right d-md-none",attrs:{"target":"sidebar-collapse"}}),_vm._v(" "),_c('span',{staticClass:"c-sidebar-nav__header"},[_vm._v("UI Kit")]),_vm._v(" "),_c('b-collapse',{staticClass:"c-sidebar-nav",attrs:{"visible":"","id":"sidebar-collapse"}},[_c('ul',{staticClass:"c-sidebar-nav__links"},[_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#typography'),expression:"'#typography'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Typography")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#color-palette'),expression:"'#color-palette'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Color Palette")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#buttons'),expression:"'#buttons'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Buttons")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#inputs'),expression:"'#inputs'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Inputs")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#large-inputs'),expression:"'#large-inputs'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Large Inputs")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#textboxes'),expression:"'#textboxes'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Textboxes")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#dropdowns'),expression:"'#dropdowns'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Dropdowns")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#facets'),expression:"'#facets'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Facets")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#tags'),expression:"'#tags'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Tags")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#radio'),expression:"'#radio'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Radio")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#tabs'),expression:"'#tabs'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Tabs")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#pagination'),expression:"'#pagination'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Pagination")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#tooltip'),expression:"'#tooltip'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("tooltip")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#scrollbar'),expression:"'#scrollbar'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Scollbar")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#alphabet-filter'),expression:"'#alphabet-filter'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Alphabet Filter")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#labels'),expression:"'#labels'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Lables")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#icons'),expression:"'#icons'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Icons")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#glyphs'),expression:"'#glyphs'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Glyphs")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#social-icons'),expression:"'#social-icons'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Social Icons")])])])]),_vm._v(" "),_c('span',{staticClass:"c-sidebar-nav__header mt-4"},[_vm._v("PHD")]),_vm._v(" "),_c('b-collapse',{staticClass:"c-sidebar-nav",attrs:{"visible":"","id":"sidebar-collapse"}},[_c('ul',{staticClass:"c-sidebar-nav__links"},[_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#phd-typography'),expression:"'#phd-typography'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Typography")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#phd-color-palette'),expression:"'#phd-color-palette'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Color Palette")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#phd-buttons'),expression:"'#phd-buttons'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Buttons")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#phd-links'),expression:"'#phd-links'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Links")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#phd-dropdowns'),expression:"'#phd-dropdowns'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Dropdowns")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#phd-inputs'),expression:"'#phd-inputs'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Inputs")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#phd-icons'),expression:"'#phd-icons'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Icons")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#phd-component-skeleton'),expression:"'#phd-component-skeleton'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Component Skeleton")])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#phd-default-tables'),expression:"'#phd-default-tables'"}],staticClass:"c-sidebar-nav__link"},[_vm._v("Default Tables")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f0e53fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ui_kit_vue__ = __webpack_require__(1703);
function injectStyle (ssrContext) {
  __webpack_require__(1701)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f0e53fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ui_kit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1702);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("5682085a", content, true, {});

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "h1.phd-uikit-title{font-size:7rem!important;font-weight:700!important;line-height:8rem!important}.button-table{table-layout:fixed;text-align:center}.table tbody th{text-align:left;vertical-align:middle}.table .form-group{margin-bottom:0}.table td,.table th{border:none}", ""]);

// exports


/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("UI Kit")]),_vm._v(" "),_c('span',{attrs:{"id":"typography"}}),_vm._v(" "),_c('aha-component',{attrs:{"title":"Typography"}},[_c('aha-ui-typography')],1),_vm._v(" "),_c('hr',{attrs:{"id":"color-palette"}}),_vm._v(" "),_c('aha-component',{attrs:{"title":"Color Palette"}},[_c('aha-ui-color-palette')],1),_vm._v(" "),_c('hr',{attrs:{"id":"buttons"}}),_vm._v(" "),_c('aha-component',{attrs:{"title":"Buttons"}},[_c('aha-ui-buttons')],1),_vm._v(" "),_c('hr',{attrs:{"id":"inputs"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('aha-component',{attrs:{"title":"Inputs"}},[_c('aha-ui-inputs')],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('aha-component',{attrs:{"title":"Inputs Feedback"}},[_c('aha-ui-inputs-feedback')],1)],1)]),_vm._v(" "),_c('hr',{attrs:{"id":"large-inputs"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('aha-component',{attrs:{"title":"Large Inputs"}},[_c('aha-ui-large-inputs')],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('aha-component',{attrs:{"title":"Large Input Feedback"}},[_c('aha-ui-large-inputs-feedback')],1)],1)]),_vm._v(" "),_c('hr',{attrs:{"id":"textboxes"}}),_vm._v(" "),_c('aha-component',{attrs:{"title":"Textboxes"}},[_c('aha-ui-textboxes')],1),_vm._v(" "),_c('hr',{attrs:{"id":"dropdowns"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('aha-component',{attrs:{"title":"Dropdown"}},[_c('aha-ui-dropdown')],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('aha-component',{attrs:{"title":"Large Dropdown"}},[_c('aha-ui-dropdown',{attrs:{"size":"lg"}})],1)],1)]),_vm._v(" "),_c('hr',{attrs:{"id":"facets"}}),_vm._v(" "),_c('aha-component',{attrs:{"title":"Facets"}},[_c('aha-ui-facets')],1),_vm._v(" "),_c('hr',{attrs:{"id":"tags"}}),_vm._v(" "),_c('aha-component',{attrs:{"title":"Tags"}},[_c('aha-ui-tags')],1),_vm._v(" "),_c('hr',{attrs:{"id":"radio"}}),_vm._v(" "),_c('aha-component',{attrs:{"title":"Radio"}},[_c('aha-ui-radio-buttons')],1),_vm._v(" "),_c('hr',{attrs:{"id":"tabs"}}),_vm._v(" "),_c('aha-component',{attrs:{"title":"Tabs"}},[_c('aha-ui-tabs')],1),_vm._v(" "),_c('hr',{attrs:{"id":"pagination"}}),_vm._v(" "),_c('aha-component',{attrs:{"title":"Pagination"}},[_c('aha-ui-pagination')],1),_vm._v(" "),_c('hr',{attrs:{"id":"alphabet-filter"}}),_vm._v(" "),_c('aha-component',{attrs:{"title":"Alphabet Filter"}},[_c('div',{staticClass:"alphabet-filter"},[_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("A")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("B")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("C")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("D")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("E")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("F")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("G")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("H")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("I")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("J")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("K")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("L")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("M")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("N")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("O")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("P")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("Q")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("R")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("S")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("T")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("U")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("V")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("W")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("X")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("Y")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("Z")])])]),_vm._v(" "),_c('hr',{attrs:{"id":"labels"}}),_vm._v(" "),_c('aha-component',{attrs:{"title":"Labels"}},[_c('aha-ui-labels')],1),_vm._v(" "),_c('hr',{attrs:{"id":"icons"}}),_vm._v(" "),_c('aha-component',{attrs:{"title":"Icons"}},[_c('aha-ui-icons')],1),_vm._v(" "),_c('hr',{attrs:{"id":"glyphs"}}),_vm._v(" "),_c('aha-component',{attrs:{"title":"Glyphs"}},[_c('aha-ui-glyphs')],1),_vm._v(" "),_c('hr',{attrs:{"id":"social-icons"}}),_vm._v(" "),_c('aha-component',{attrs:{"title":"Social Icons"}},[_c('aha-ui-social-icons')],1),_vm._v(" "),_c('div',{staticClass:"PHD"},[_vm._m(0),_vm._v(" "),_c('code',{staticClass:"small text-danger"},[_vm._v("<body class=\"PHD\">...</body>\n\n        ")]),_vm._v(" "),_c('phd-typography',{attrs:{"id":"phd-typography"}}),_vm._v(" "),_c('phd-ui-color-palette',{attrs:{"id":"phd-color-palette"}}),_vm._v(" "),_c('phd-ui-color-palette-membership'),_vm._v(" "),_c('phd-buttons',{attrs:{"id":"phd-buttons"}}),_vm._v(" "),_c('phd-links',{attrs:{"id":"phd-links"}}),_vm._v(" "),_c('phd-dropdowns',{attrs:{"id":"phd-dropdowns"}}),_vm._v(" "),_c('div',{attrs:{"id":"phd-inputs"}},[_c('h2',{staticClass:"text-uppercase mt-5 mb-5"},[_vm._v("Inputs")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("Inputs")]),_vm._v(" "),_c('phd-inputs')],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("Feedback")]),_vm._v(" "),_c('phd-inputs-feedback')],1)])]),_vm._v(" "),_c('phd-radios',{attrs:{"id":"phd-radios"}}),_vm._v(" "),_c('h2',{staticClass:"text-uppercase mt-5 mb-3"},[_vm._v("Alphabet Filter")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"phd-icons"}},[_c('h2',{staticClass:"h2 text-uppercase mt-5 mb-3"},[_vm._v("Icons")]),_vm._v(" "),_c('phd-icons')],1),_vm._v(" "),_c('div',{attrs:{"title":"","id":"phd-component-skeleton"}},[_c('h2',{staticClass:"h2 text-uppercase mt-5 mb-3"},[_vm._v("Component Skeleton")]),_vm._v(" "),_c('phd-skeleton-component')],1),_vm._v(" "),_c('div',{attrs:{"title":"","id":"phd-default-tables"}},[_c('h2',{staticClass:"h2 text-uppercase mt-5 mb-3"},[_vm._v("PHD Default Tables")]),_vm._v(" "),_c('phd-default-tables')],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"phd-uikit-title"},[_c('img',{staticStyle:{"width":"90px","margin-top":"-30px","margin-right":"20px"},attrs:{"src":"assets/aha_heart.svg"}}),_vm._v("PHD "),_c('span',{staticClass:"text-danger"},[_vm._v("UI KIT")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"alphabet-filter"},[_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("A")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("B")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("C")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("D")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("E")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("F")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("G")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("H")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("I")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("J")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("K")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("L")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("M")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("N")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("O")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("P")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("Q")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("R")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("S")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("T")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("U")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("V")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("W")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("X")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("Y")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item",attrs:{"href":"#"}},[_vm._v("Z")])]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_vm._v("Active")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item active",attrs:{"href":"#"}},[_vm._v("A")]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_vm._v("Focus")]),_vm._v(" "),_c('a',{staticClass:"alphabet-filter__item focus",attrs:{"href":"#"}},[_vm._v("A")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[380]);


// WEBPACK FOOTER //
// app.bundle.js